"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[71565],{

/***/ 885776:
/***/ (function(module) {

module.exports="data:image/jpeg;base64,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";


/***/ }),

/***/ 780406:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(623537),t=__webpack_require__(610314),o=__webpack_require__(47248),l=__webpack_require__(407229),i=__webpack_require__(891987),n=__webpack_require__(85097),s=__webpack_require__(736451),a=__webpack_require__(452669),d=__webpack_require__(555254),u=__webpack_require__(212951),c=__webpack_require__(610796),p=__webpack_require__(400406),x=__webpack_require__(458460),h=__webpack_require__(739646),f=__webpack_require__(96179);function g(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var m=g(o),j=g(l),b=g(u);const y=b.default.div`
  font-size: 12px;
  font-weight: 500;
  margin: 8px 0 4px;
`,C=b.default(t.Modal)`
  &.ant-modal {
    top: 80px;
  }

  .ant-modal {
    &-header,
    &-footer {
      padding: 8px;
    }

    &-title {
      font-size: 14px;
    }

    &-close-x {
      width: 32px;
      height: 32px;
      line-height: 32px;
      font-size: 14px;
    }
  }
`,v=b.default(s.RgbaStringColorPicker)`
  width: 100% !important;
  margin-bottom: 16px;

  .react-colorful {
    &__pointer {
      width: 16px;
      height: 16px;
    }

    &__alpha,
    &__hue {
      height: 12px;
      margin-top: 12px;
      border-radius: 8px;
    }
  }
`,q=b.default(s.HexColorInput)(d.inputCss),O=b.default.label(d.labelCss),R=b.default.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
  column-gap: 8px;
`,k=b.default.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  transform: scale(1);
  transition: all 100ms ease 0s;
  cursor: pointer;
  border: 1px solid #d9d9d9;

  &.active {
    border: 2px solid #000;
    transform: scale(1.1);
  }

  &:hover {
    transform: scale(1.2);
  }
`,w=b.default.div`
  display: flex;
  justify-content: space-between;
`,_=b.default(t.Button)`
  padding-left: 0;
  padding-right: 0;
`,P=b.default(a.RgbaField)`
  flex: 2;
`;exports.ColorPickerModal=({color:o="rgba(0, 0, 0, 1)",visible:l,setVisible:s,onChange:a})=>{var d;const{actions:{history:u},myColors:g}=x.useEditor((e=>{var r;const t=e.nodes[n.ROOT];return{myColors:m.default(null==(r=t.data)?void 0:r.props,f.PROP_KEY.MyColors,[])}})),{document:b}=c.useFrame(),[M,B]=i.useState(),S=M||"";i.useEffect((()=>{if(l){const e=h.getRGBAColor(o);B(e)}}),[l]);const E=(r,t)=>(null==t?void 0:t.length)?e.jsxs(e.Fragment,{children:[e.jsx(y,{children:r}),e.jsx(R,{children:t.map(((r,t)=>{var o;const l=h.getRGBAColor(r),i=null==(o=h.rgbaStringToObject(l))?void 0:o.hex;return e.jsx(k,{title:i,style:{backgroundColor:r},className:l===M?"active":"",onClick:()=>{B(l)}},t)}))})]}):null,F=()=>s(!1);return e.jsxs(C,{open:l,title:r.t("Chọn màu"),onCancel:F,width:300,bodyStyle:{padding:"16px 8px"},zIndex:9999,destroyOnClose:!0,getContainer:()=>(null==b?void 0:b.body)||(null==document?void 0:document.body),footer:e.jsxs(w,{children:[e.jsx(_,{type:"link",onClick:()=>{a(),F()},children:r.t("Đặt lại")}),e.jsxs("div",{style:{display:"flex"},children:[e.jsx(t.Button,{onClick:F,children:r.t("common.cancel")}),e.jsx(t.Button,{type:"primary",onClick:()=>{var e;const r=null==(e=h.rgbaStringToObject(M))?void 0:e.hex;a(r);let t=[...g],o=!1;for(const e of g)if(h.getRGBAColor(e)===M){o=!0;break}o||(10===g.length?t=[...g.slice(1),r]:t.push(r),u.ignore().setProp(n.ROOT,(e=>{j.default(e,f.PROP_KEY.MyColors,t)}))),F()},children:"OK"})]})]}),children:[e.jsx(v,{color:S,onChange:B}),e.jsxs("div",{style:{display:"flex",columnGap:16},children:[e.jsxs("div",{style:{flex:1},children:[e.jsx(q,{alpha:!0,prefixed:!0,color:null==(d=h.rgbaStringToObject(M))?void 0:d.hex,onChange:e=>{B(n.getRgbaFromHex(e))}}),e.jsx(O,{children:"hex"})]}),e.jsx(P,{color:S,onChange:B})]}),E(r.t("Màu của tôi"),g),E(r.t("Màu mẫu"),p.sampleColors)]})};


/***/ }),

/***/ 476756:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(623537),r=__webpack_require__(610314),l=__webpack_require__(47248),t=__webpack_require__(407229),i=__webpack_require__(891987),n=__webpack_require__(85097),a=__webpack_require__(736451),d=__webpack_require__(212951),s=__webpack_require__(610796),p=__webpack_require__(400406),u=__webpack_require__(273202),c=__webpack_require__(739646),g=__webpack_require__(301930),x=__webpack_require__(505765),f=__webpack_require__(458460),h=__webpack_require__(96179);function y(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var v=y(l),C=y(t),b=y(d),m=Object.defineProperty,j=Object.defineProperties,T=Object.getOwnPropertyDescriptors,w=Object.getOwnPropertySymbols,O=Object.prototype.hasOwnProperty,P=Object.prototype.propertyIsEnumerable,q=(e,o,r)=>o in e?m(e,o,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[o]=r;const S=[{label:"Linear",value:n.GradientType.linear},{label:"Radial",value:n.GradientType.radial}],k=[{label:"Solid",value:n.ColorType.solid},{label:"Gradient",value:n.ColorType.gradient}],G=b.default.div`
  font-size: 12px;
  font-weight: 500;
  margin: 8px 0 4px;
`,H=b.default(r.Modal)`
  &.ant-modal {
    top: 80px;
  }

  .ant-modal {
    &-header,
    &-footer {
      padding: 8px;
      border-radius: 8px;
    }

    &-title {
      font-size: 14px;
    }

    &-close-x {
      width: 32px;
      height: 32px;
      line-height: 32px;
      font-size: 14px;
    }
    &-content {
      border-radius: 8px;
      padding: 8px;
    }
  }
`,I=b.default(a.HexAlphaColorPicker)`
  width: 100% !important;
  margin-bottom: 16px;

  .react-colorful {
    &__pointer {
      width: 16px;
      height: 16px;
    }

    &__alpha,
    &__hue {
      height: 12px;
      margin-top: 12px;
      border-radius: 8px;
    }
  }
`,R=b.default(a.HexColorInput)`
  width: 100%;
  padding: 4px;
  text-align: center;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  &:focus {
    outline: none;
  }
`,_=b.default.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
  column-gap: 8px;
`,M=b.default.div`
  width: 25px;
  height: 25px;
  border-radius: 6px;
  transform: scale(1);
  transition: all 100ms ease 0s;
  cursor: pointer;

  &:hover {
    transform: scale(1.2);
    border: 2px solid #d9d9d9;
  }
`,z=b.default.div`
  display: flex;
  justify-content: space-between;
`,A=b.default(r.Button)`
  color: var(--text-color);
  padding-left: 0;
  padding-right: 0;
`,E=b.default.div`
  height: 32px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`,N=b.default.div`
  border-radius: 4px;
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>');
`,B=b.default.div((({colorConfig:e})=>`\n    width: 32px;\n    height: 32px;\n    border-radius: 4px;\n    margin-left: auto;\n    background: ${n.stringifyColor(e)};\n    border: 1px solid rgba(0, 0, 0, 0.05);\n`)),V=b.default(x.InputNumberConfig)`
  .ant-input-number-handler-wrap {
    display: none;
  }
`,F=b.default.div`
  font-size: 24px;
  position: absolute;
  top: -18px;
  right: -8px;
`,K=b.default(r.Row)`
  margin-top: 16px;
`,J=b.default(r.Button)`
  border-radius: 6px;
`;exports.ColorPickerModalV2=({color:l=n.stringifyColor({colorType:n.ColorType.solid,colorValue:"rgba(255,255,255,1)"}),visible:t,setVisible:a,onChange:d,hasGradientColor:x})=>{const{actions:{history:y},myColors:b}=f.useEditor((e=>{var o;const r=e.nodes[n.ROOT];return{myColors:v.default(null==(o=null==r?void 0:r.data)?void 0:o.props,h.PROP_KEY.MyColors,[])}})),{document:m}=s.useFrame(),[Y,$]=i.useState(),[D,L]=i.useState(),[Q,U]=i.useState(),[W,X]=i.useState(),Z=Y===n.ColorType.gradient?Q:W?n.getRgbaFromHex(W).replaceAll(" ",""):"";i.useEffect((()=>{var e,o,r;if(t){const t=n.parseColor(l),i=(null==t?void 0:t.colorType)||n.ColorType.solid,a=(null==t?void 0:t.colorValue)||"rgba(255,255,255,1)",d=0,s=i===n.ColorType.gradient,p=s?a:void 0;$(i),U(p),L(d);const u=(null==(r=s?null==(o=null==(e=null==a?void 0:a.colors)?void 0:e[d])?void 0:o.color:a)?void 0:r.toString())||"";X(c.getHexColor(u))}}),[t]),i.useEffect((()=>{var e,o;Y===n.ColorType.gradient&&void 0!==D&&X(c.getHexColor(null==(o=null==(e=null==Q?void 0:Q.colors)?void 0:e[D])?void 0:o.color))}),[D]);const ee=e=>{if(X(e),Y===n.ColorType.gradient&&Q&&e){const o=JSON.parse(JSON.stringify(Q.colors));o[D].color=n.getRgbaFromHex(e).replaceAll(" ",""),le("colors",o)}},oe=(o,r)=>(null==r?void 0:r.length)?e.jsxs(e.Fragment,{children:[e.jsx(G,{children:o}),e.jsx(_,{children:r.map(((o,r)=>{var l;const t=c.getRGBAColor(o),i=null==(l=c.rgbaStringToObject(t))?void 0:l.hex;return e.jsx(M,{title:i,style:{backgroundColor:o},onClick:()=>{ee(i)},"data-testid":`color-${i}`},r)}))})]}):null,re=()=>a(!1),le=(e,o)=>{U((r=>{return l=((e,o)=>{for(var r in o||(o={}))O.call(o,r)&&q(e,r,o[r]);if(w)for(var r of w(o))P.call(o,r)&&q(e,r,o[r]);return e})({},r),t={[e]:Array.isArray(o)?[...o]:o},j(l,T(t));var l,t}))};return e.jsxs(H,{"data-testid":"color-picker-modal",open:t,title:o.t("Chọn màu"),onCancel:re,width:300,bodyStyle:{padding:"8px 8px"},zIndex:9999,destroyOnClose:!0,getContainer:()=>(null==m?void 0:m.body)||(null==document?void 0:document.body),footer:e.jsxs(z,{children:[e.jsx(A,{type:"link",onClick:()=>{d(void 0),re()},children:o.t("Đặt lại")}),e.jsxs("div",{style:{display:"flex"},children:[e.jsx(J,{onClick:re,"data-testid":"color-picker-cancel",children:o.t("common.cancel")}),e.jsx(J,{type:"primary",onClick:()=>{const e={colorType:Y,colorValue:Z};if(d(n.stringifyColor(e)),Y===n.ColorType.solid){let e=[...b];b.some((e=>c.getRGBAColor(e)===Z))||(10===b.length?e=[...b.slice(1),Z]:e.push(Z),y.ignore().setProp(n.ROOT,(o=>{C.default(o,h.PROP_KEY.MyColors,e)})))}re()},"data-testid":"color-picker-ok",children:"OK"})]})]}),children:[e.jsxs(E,{children:[x&&e.jsx(g.SelectConfig,{selectProps:{allowClear:!1,value:Y,options:k,onChange:e=>{var o,r;if(e===n.ColorType.solid)U(void 0),X(c.getHexColor("rgba(255,255,255,1)"));else{const e={colors:[{color:"rgb(254,214,227)",stop:0},{color:"rgba(168,237,234)",stop:100}],radius:90,gradientType:n.GradientType.linear};U(e),X(c.getHexColor(null==(r=null==(o=null==e?void 0:e.colors)?void 0:o[0])?void 0:r.color))}$(e),L(0)},getPopupContainer:e=>e}}),e.jsx(N,{children:e.jsx(B,{colorConfig:{colorType:Y,colorValue:Z}})})]}),e.jsx(I,{color:W,onChange:ee}),Y===n.ColorType.gradient&&e.jsx(u.GradientBar,{gradientColor:Q,selectedGradientItem:D,setSelectedGradientItem:L,onChange:le}),e.jsxs(K,{gutter:[8,8],className:"mt-base",children:[e.jsx(r.Col,{span:11,children:e.jsx(R,{alpha:!0,prefixed:!0,color:W,onChange:ee})}),Y===n.ColorType.gradient&&e.jsxs(e.Fragment,{children:[e.jsx(r.Col,{span:8,children:e.jsx(g.SelectConfig,{selectProps:{allowClear:!1,value:null==Q?void 0:Q.gradientType,options:S,onChange:e=>{e===n.GradientType.linear&&le("radius",90),le("gradientType",e)},getPopupContainer:e=>e}})}),e.jsxs(r.Col,{span:5,children:[e.jsx(V,{formItemProps:{onChange:e=>{const o=e.target.value?parseInt(e.target.value):0;le("radius",o)},value:null==Q?void 0:Q.radius},inputNumberProps:{disabled:(null==Q?void 0:Q.gradientType)===n.GradientType.radial,min:0,max:360,value:null==Q?void 0:Q.radius}}),(null==Q?void 0:Q.gradientType)===n.GradientType.linear&&e.jsx(F,{children:"°"})]})]})]}),Y===n.ColorType.solid&&oe(o.t("Màu của tôi"),b),oe(o.t("Màu mẫu"),p.sampleColors)]})};


/***/ }),

/***/ 379072:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(212951),r=__webpack_require__(85097),l=__webpack_require__(610314),t=__webpack_require__(891987),n=__webpack_require__(736451),i=__webpack_require__(610796),a=__webpack_require__(623537),d=__webpack_require__(400406),s=__webpack_require__(273202),p=__webpack_require__(146532),u=__webpack_require__(423269),c=__webpack_require__(739646),f=__webpack_require__(301930),g=__webpack_require__(505765);function x(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var C=x(o),y=Object.defineProperty,h=Object.defineProperties,v=Object.getOwnPropertyDescriptors,m=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,j=Object.prototype.propertyIsEnumerable,T=(e,o,r)=>o in e?y(e,o,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[o]=r;const S=[{label:"Solid",value:r.ColorType.solid},{label:"Gradient",value:r.ColorType.gradient}],O=[{label:"Linear",value:r.GradientType.linear},{label:"Radial",value:r.GradientType.radial}],w=C.default(l.Modal)`
  &.ant-modal {
    top: 200px;
    left: calc(50% + 210px);
    margin: 0;
  }

  .ant-modal {
    &-header,
    &-footer {
      padding: 8px;
      border-radius: 8px;
    }

    &-title {
      font-size: 14px;
    }

    &-close-x {
      width: 32px;
      height: 32px;
      line-height: 32px;
      font-size: 14px;
    }
    &-content {
      border-radius: 8px;
      padding: 8px;
    }
  }
`,q=C.default(l.Button)`
  border-radius: 6px;
`,P=C.default.div`
  height: 32px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`,I=C.default(n.HexAlphaColorPicker)`
  width: 100% !important;
  margin-bottom: 16px;

  .react-colorful {
    &__pointer {
      width: 16px;
      height: 16px;
    }

    &__alpha,
    &__hue {
      height: 12px;
      margin-top: 12px;
      border-radius: 8px;
    }
  }
`,_=C.default(l.Row)`
  margin-top: 16px;
`,G=C.default(n.HexColorInput)`
  width: 100%;
  padding: 4px;
  text-align: center;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  &:focus {
    outline: none;
  }
`,N=C.default(g.InputNumberConfig)`
  .ant-input-number-handler-wrap {
    display: none;
  }
`,H=C.default.div`
  font-size: 24px;
  position: absolute;
  top: -18px;
  right: -8px;
`;exports.AddColorModal=({myColors:o,hasGradientColor:n,visible:g,onClose:x,setSelectedColor:C,initColor:y,isUpdate:A=!1})=>{const{updateThemeConfig:R}=u.useThemeStore(),{document:E}=i.useFrame(),[F,M]=t.useState(r.ColorType.solid),[k,z]=t.useState(),[B,V]=t.useState("#ffffff"),[J,L]=t.useState(0),U=()=>F===r.ColorType.gradient?k:B?r.getRgbaFromHex(B).replaceAll(" ",""):"",D=(e,o)=>{z((r=>{return l=((e,o)=>{for(var r in o||(o={}))b.call(o,r)&&T(e,r,o[r]);if(m)for(var r of m(o))j.call(o,r)&&T(e,r,o[r]);return e})({},r),t={[e]:Array.isArray(o)?[...o]:o},h(l,v(t));var l,t}))},X=e=>{if(V(e),F===r.ColorType.gradient&&k&&e){const o=JSON.parse(JSON.stringify(k.colors));o[J].color=r.getRgbaFromHex(e).replaceAll(" ",""),D("colors",o)}};return t.useEffect((()=>{if(!g)return;const{colorType:e,gradientColor:o,hexInput:l}=(e=>{var o,l,t;if(!e||e.includes("var(--tempi-global-color"))return{colorType:r.ColorType.solid,hexInput:"#ffffff",gradientColor:void 0};const{colorType:n,colorValue:i}=r.parseColor(e),a=(null==(t=n===r.ColorType.gradient?null==(l=null==(o=null==i?void 0:i.colors)?void 0:o[J])?void 0:l.color:i)?void 0:t.toString())||"#ffffff";return{colorType:n,hexInput:c.getHexColor(a),gradientColor:n===r.ColorType.gradient?i:void 0}})(y);M(e),z(o),V(l)}),[g,y]),t.useEffect((()=>{var e,o;const r=null==(o=null==(e=null==k?void 0:k.colors)?void 0:e[J])?void 0:o.color;r&&V(c.getHexColor(r))}),[J]),e.jsxs(w,{open:g,onCancel:x,title:a.t("color_config.add_color"),bodyStyle:{padding:10},width:320,mask:!1,zIndex:1e4,getContainer:()=>(null==E?void 0:E.body)||(null==document?void 0:document.body),footer:e.jsxs("div",{style:{display:"flex",justifyContent:"flex-end",gap:8},children:[e.jsx(q,{onClick:x,children:a.t("common.cancel")}),e.jsx(q,{type:"primary",onClick:()=>{const e={colorType:F,colorValue:U()},l=r.stringifyColor(e);let t=[...o];const n=o.includes(l);if(A){const e=o.indexOf(y);if(e<0||l===y)return void x();t[e]=l;const r=null==o?void 0:o.indexOf(l);-1!==r&&t.splice(r,1)}else n||(o.length>=d.MAX_NUMBER_OF_RECENT_COLORS?t=[l,...o.slice(0,-1)]:t.unshift(l));R({recentColors:t}),null==C||C(l),x()},children:a.t("common.save")})]}),children:[e.jsxs(P,{children:[n&&e.jsx(f.SelectConfig,{selectProps:{allowClear:!1,value:F,options:S,onChange:e=>{var o,l;if(e===r.ColorType.solid)z(void 0),V(c.getHexColor("rgba(255,255,255,1)"));else{const e={colors:[{color:"rgb(254,214,227)",stop:0},{color:"rgba(168,237,234)",stop:100}],radius:90,gradientType:r.GradientType.linear};z(e),V(c.getHexColor(null==(l=null==(o=null==e?void 0:e.colors)?void 0:o[0])?void 0:l.color))}M(e),L(0)},getPopupContainer:e=>e}}),e.jsx(p.ColorPreview,{currentColorValue:U(),hexInput:B,onChangeColor:X,colorType:F})]}),e.jsx(I,{color:B,onChange:X}),F===r.ColorType.gradient&&e.jsx(s.GradientBar,{gradientColor:k,selectedGradientItem:J,setSelectedGradientItem:L,onChange:D}),F===r.ColorType.gradient&&e.jsxs(_,{gutter:[8,8],className:"mt-base",children:[e.jsx(l.Col,{span:11,children:e.jsx(G,{alpha:!0,prefixed:!0,color:B,onChange:X})}),e.jsxs(e.Fragment,{children:[e.jsx(l.Col,{span:8,children:e.jsx(f.SelectConfig,{selectProps:{allowClear:!1,value:null==k?void 0:k.gradientType,options:O,onChange:e=>{e===r.GradientType.linear&&D("radius",90),D("gradientType",e)},getPopupContainer:e=>e}})}),e.jsxs(l.Col,{span:5,children:[e.jsx(N,{formItemProps:{onChange:e=>{const o=e.target.value?parseInt(e.target.value):0;D("radius",o)},value:null==k?void 0:k.radius},inputNumberProps:{disabled:(null==k?void 0:k.gradientType)===r.GradientType.radial,min:0,max:360,value:null==k?void 0:k.radius}}),(null==k?void 0:k.gradientType)===r.GradientType.linear&&e.jsx(H,{children:"°"})]})]})]})]})};


/***/ }),

/***/ 313900:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(212951),r=__webpack_require__(85097),l=__webpack_require__(547929),t=__webpack_require__(610314),n=__webpack_require__(891987),i=__webpack_require__(736451),a=__webpack_require__(623537),s=__webpack_require__(273202),d=__webpack_require__(146532),u=__webpack_require__(400406),p=__webpack_require__(641962),c=__webpack_require__(793882),f=__webpack_require__(423269),g=__webpack_require__(739646),C=__webpack_require__(301930),y=__webpack_require__(505765);function x(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var v=x(o),h=Object.defineProperty,b=Object.defineProperties,m=Object.getOwnPropertyDescriptors,j=Object.getOwnPropertySymbols,T=Object.prototype.hasOwnProperty,P=Object.prototype.propertyIsEnumerable,S=(e,o,r)=>o in e?h(e,o,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[o]=r;const O=[{label:"Solid",value:r.ColorType.solid},{label:"Gradient",value:r.ColorType.gradient}],q=[{label:"Linear",value:r.GradientType.linear},{label:"Radial",value:r.GradientType.radial}],w=v.default(t.Button)`
  border-radius: 6px;
`,_=v.default.div`
  height: 32px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`,I=v.default(i.HexAlphaColorPicker)`
  width: 100% !important;
  margin-bottom: 16px;

  .react-colorful {
    &__pointer {
      width: 16px;
      height: 16px;
    }

    &__alpha,
    &__hue {
      height: 12px;
      margin-top: 12px;
      border-radius: 8px;
    }
  }
`,D=v.default(t.Row)`
  margin-top: 16px;
`,G=v.default(i.HexColorInput)`
  width: 100%;
  padding: 4px;
  text-align: center;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  &:focus {
    outline: none;
  }
`,E=v.default(y.InputNumberConfig)`
  .ant-input-number-handler-wrap {
    display: none;
  }
`,N=v.default.div`
  font-size: 24px;
  position: absolute;
  top: -18px;
  right: -8px;
`;exports.AddColorModalDraggable=({myColors:o,hasGradientColor:i,visible:y,onClose:x,setSelectedColor:v,initColor:h,isUpdate:M=!1,width:H=320,setModalPosition:R,propKey:A,modalPosition:k={x:0,y:0},onChangeColor:V,onEditingColor:B,onCancelEditingColor:F})=>{const{id:J}=l.useNode(),L=c.useDraftStore((e=>e.updateDraftThrottled)),U=c.useDraftStore((e=>e.clearDraft)),{updateThemeConfig:z}=f.useThemeStore(),[K,X]=n.useState(r.ColorType.solid),[Q,W]=n.useState(),[Y,Z]=n.useState("#ffffff"),[$,ee]=n.useState(0),oe=n.useRef(h),re=n.useCallback((()=>K===r.ColorType.gradient?Q:Y?r.getRgbaFromHex(Y).replaceAll(" ",""):""),[K,Q,Y]),le=(e,o)=>{W((r=>{return l=((e,o)=>{for(var r in o||(o={}))T.call(o,r)&&S(e,r,o[r]);if(j)for(var r of j(o))P.call(o,r)&&S(e,r,o[r]);return e})({},r),t={[e]:Array.isArray(o)?[...o]:o},b(l,m(t));var l,t}))},te=e=>{if(Z(e),K===r.ColorType.gradient&&Q&&e){const o=JSON.parse(JSON.stringify(Q.colors));o[$].color=r.getRgbaFromHex(e).replaceAll(" ",""),le("colors",o)}},ne=e=>{null==e||e.preventDefault(),null==e||e.stopPropagation(),x((()=>{U(J),null==F||F(oe.current)}))},ie=()=>{x((()=>{const e={colorType:K,colorValue:re()},o=r.stringifyColor(e);v(o),V(o),U(J)}))};return n.useEffect((()=>{if(!y)return;const{colorType:e,gradientColor:o,hexInput:l}=(e=>{var o,l,t;if(!e)return{colorType:r.ColorType.solid,hexInput:"#ffffff",gradientColor:void 0};const{colorType:n,colorValue:i}=r.parseColor(e),a=(null==(t=n===r.ColorType.gradient?null==(l=null==(o=null==i?void 0:i.colors)?void 0:o[$])?void 0:l.color:i)?void 0:t.toString())||"#ffffff";return{colorType:n!==r.ColorType.theme&&n?n:r.ColorType.solid,hexInput:g.getHexColor(a),gradientColor:n===r.ColorType.gradient?i:void 0}})(h);X(e),W(o),Z(l),oe.current=h}),[y]),n.useEffect((()=>{var e,o;const r=null==(o=null==(e=null==Q?void 0:Q.colors)?void 0:e[$])?void 0:o.color;r&&Z(g.getHexColor(r))}),[$]),n.useEffect((()=>{(()=>{const e={colorType:K,colorValue:re()},o=r.stringifyColor(e);y&&o&&(A&&L(J,A,o),null==B||B(o))})()}),[K,re]),n.useEffect((()=>()=>{x((()=>{U(J)}))}),[]),e.jsxs(p.DraggableModal,{open:y,onCancel:ne,title:a.t("color_config.add_color"),width:H,footer:e.jsxs("div",{style:{display:"flex",justifyContent:"flex-end",gap:8},children:[e.jsx(w,{onClick:ne,children:a.t("common.cancel")}),e.jsx(w,{type:"primary",onClick:e=>{e.preventDefault(),e.stopPropagation();const l={colorType:K,colorValue:re()},t=r.stringifyColor(l);let n=[...o];const i=o.includes(t);if(M){const e=o.indexOf(oe.current||"");if(e<0||t===oe.current)return void ie();n[e]=t;const r=null==o?void 0:o.indexOf(t);-1!==r&&n.splice(r,1)}else i||(o.length>=u.MAX_NUMBER_OF_RECENT_COLORS?n=[t,...o.slice(0,-1)]:n.unshift(t));z({recentColors:n}),ie()},children:a.t("common.save")})]}),modalPosition:k,setModalPosition:R,destroyOnClose:!0,onClickOutside:ne,children:[e.jsxs(_,{children:[i&&e.jsx(C.SelectConfig,{selectProps:{allowClear:!1,value:K,options:O,onChange:e=>{var o,l;if(e===r.ColorType.solid)W(void 0),Z(g.getHexColor("rgba(255,255,255,1)"));else{const e={colors:[{color:"rgb(254,214,227)",stop:0},{color:"rgba(168,237,234)",stop:100}],radius:90,gradientType:r.GradientType.linear};W(e),Z(g.getHexColor(null==(l=null==(o=null==e?void 0:e.colors)?void 0:o[0])?void 0:l.color))}X(e),ee(0)},getPopupContainer:e=>e}}),e.jsx(d.ColorPreview,{currentColorValue:re(),hexInput:Y,onChangeColor:te,colorType:K})]}),e.jsx(I,{color:Y||"#ffffff",onChange:te}),K===r.ColorType.gradient&&e.jsx(s.GradientBar,{gradientColor:Q,selectedGradientItem:$,setSelectedGradientItem:ee,onChange:le}),K===r.ColorType.gradient&&e.jsxs(D,{gutter:[8,8],className:"mt-base",children:[e.jsx(t.Col,{span:11,children:e.jsx(G,{alpha:!0,prefixed:!0,color:Y,onChange:te})}),e.jsx(t.Col,{span:8,children:e.jsx(C.SelectConfig,{selectProps:{allowClear:!1,value:null==Q?void 0:Q.gradientType,options:q,onChange:e=>{e===r.GradientType.linear&&le("radius",90),le("gradientType",e)},getPopupContainer:e=>e}})}),e.jsxs(t.Col,{span:5,children:[e.jsx(E,{formItemProps:{onChange:e=>{const o=e.target.value?parseInt(e.target.value):0;le("radius",o)},value:null==Q?void 0:Q.radius},inputNumberProps:{disabled:(null==Q?void 0:Q.gradientType)===r.GradientType.radial,min:0,max:360,value:null==Q?void 0:Q.radius}}),(null==Q?void 0:Q.gradientType)===r.GradientType.linear&&e.jsx(N,{children:"°"})]})]})]})};


/***/ }),

/***/ 643784:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(112373),r=__webpack_require__(212951),t=__webpack_require__(959211),i=__webpack_require__(85097),l=__webpack_require__(610314),n=__webpack_require__(891987),s=__webpack_require__(610796),c=__webpack_require__(623537),d=__webpack_require__(313900),a=__webpack_require__(392244),u=__webpack_require__(189997),h=__webpack_require__(423269),p=__webpack_require__(852989),x=__webpack_require__(641962),g=__webpack_require__(739646);function C(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var f=C(r);const m=f.default(l.Button)`
  color: var(--text-color);
  padding-left: 0;
  padding-right: 0;
`,j=f.default.div`
  font-size: 14px;
  font-weight: 600;
`,y=f.default.div`
  color: #7367f0;
  font-size: 14px;
  cursor: pointer;
  margin-right: 10px;
`,v=f.default(o.QuestionCircleOutlined)`
  font-size: 1.2em;
  color: #82869e;
  margin-left: 4px;

  &:hover {
    color: var(--text-color);
  }
`,k=f.default.div`
  display: flex;
  flex-wrap: wrap;
`,b=f.default.div`
  position: relative;
  width: ${({isStretch:e})=>e?"100%":"130px"};
  height: 32px;
  display: flex;
  align-items: center;
  border: 1px solid ${e=>e.theme.colorBorder};
  border-radius: 4px;
  &:hover {
    cursor: pointer;
  }
`;exports.ColorPickerDraggable=({color:o,visible:r,setVisible:C,onChange:f,hasGradientColor:S,width:q=350,colorConfig:w,propKey:_,onEditingColor:M,onCancelEditingColor:T,isStretch:D,showSelectedThemeColor:P=!0})=>{const{window:z}=s.useFrame(),{recentColors:I,updateThemeConfig:O}=h.useThemeStore(),[E,B]=n.useState(o),[A,V]=n.useState(!1),[F,Q]=n.useState(!1),[R,G]=n.useState({x:0,y:0}),[H,K]=n.useState({x:0,y:0}),{setOpenThemeConfig:N}=p.useBuilder(),W=()=>C(!1);n.useEffect((()=>{B(o)}),[o]);const $=(e,o,r,t,i)=>{const l=e.currentTarget.getBoundingClientRect(),n=l.left,s=l.right-t,c=l.left+t>z.innerWidth?s:n,d=l.top+l.height,a=l.top-i,u=l.top+i>z.innerHeight?a:d,h=z.innerWidth-t,p=z.innerHeight-i;o({x:Math.max(0,Math.min(c,h)),y:Math.max(0,Math.min(u,p))}),r(!0)},U=e=>{const{colorType:o}=E?i.parseColor(E):{colorType:"solid"};let r=370;"gradient"===o&&(r=440),$(e,K,V,320,r)},J=n.useCallback((()=>{A||W()}),[A]);return e.jsxs(e.Fragment,{children:[e.jsx(b,{onClick:e=>{const o=(null==I?void 0:I.length)?36*Math.ceil(I.length/8)+290:290;$(e,G,C,q,o)},"data-testid":"color-picker-select",isStretch:D,children:w}),e.jsxs(x.DraggableModal,{onClickOutside:J,modalPosition:R,setModalPosition:G,"data-testid":"color-picker-modal",open:r,width:q,title:c.t("Chọn màu"),onCancel:W,destroyOnClose:!0,footer:null,children:[P&&e.jsxs(e.Fragment,{children:[e.jsxs("div",{style:{marginTop:20,display:"flex",justifyContent:"space-between"},children:[e.jsxs("div",{style:{display:"flex",alignItems:"center"},children:[e.jsx(j,{children:c.t("color_picker.from_theme")}),e.jsx(l.Popover,{content:e.jsx("div",{style:{color:"#fff",width:200},children:c.t("color_picker.from_theme.tooltip")}),zIndex:1e4,color:"#000",overlayInnerStyle:{backgroundColor:"#000"},children:e.jsx(v,{name:"AntdQuestionCircleOutlined"})})]}),e.jsx(y,{onClick:()=>{N("color"),W()},children:c.t("color_picker.edit_theme")})]}),e.jsx(u.ThemeColorSelect,{selectedColor:E,onSelect:e=>{B(e),f(e)}}),e.jsx(l.Divider,{})]}),e.jsxs("div",{style:{marginTop:20,display:"flex",justifyContent:"space-between"},children:[e.jsxs("div",{style:{display:"flex",alignItems:"center"},children:[e.jsx(j,{children:c.t("color_picker.from_my_colors")}),e.jsx(l.Popover,{content:e.jsx("div",{style:{color:"#fff"},children:c.t("color_picker.from_my_colors.tooltip")}),zIndex:1e4,color:"#000",overlayInnerStyle:{backgroundColor:"#000"},children:e.jsx(v,{name:"AntdQuestionCircleOutlined"})})]}),e.jsxs(y,{onClick:U,children:["+ ",c.t("add_color")]}),e.jsx(d.AddColorModalDraggable,{myColors:I||[],hasGradientColor:S,visible:A,onClose:e=>{V(!1),Q(!1),null==e||e()},setSelectedColor:B,initColor:E,isUpdate:F,setVisible:V,modalPosition:H,setModalPosition:K,propKey:_,onChangeColor:f,onEditingColor:M,onCancelEditingColor:T})]}),e.jsx(k,{style:{marginTop:5},children:null==I?void 0:I.map(((o,r)=>(S||!o.includes("-gradient"))&&e.jsxs(a.ColorDiv,{onDoubleClick:U,color:o,onClick:()=>{B(o),f(o)},children:[E===o&&e.jsx(a.SelectedColor,{}),e.jsx("div",{className:"icon-wrapper edit-icon",onClick:e=>{U(e),Q(!0)},children:e.jsx(t.EditRegular,{fontSize:14})}),e.jsx("div",{className:"icon-wrapper delete-icon",onClick:e=>{((e,o)=>{e.stopPropagation();const r=I.filter(((e,r)=>r!==o));O({recentColors:r})})(e,r)},children:e.jsx(t.DismissRegular,{fontSize:14})})]},r)))}),e.jsxs("div",{style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:20},children:[e.jsx(m,{type:"link",onClick:()=>{f(void 0),B(void 0),W()},children:c.t("Đặt lại")}),e.jsx("div",{style:{fontSize:16},children:g.getColorValue(E,!1)})]})]})]})};


/***/ }),

/***/ 392244:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(212951),r=__webpack_require__(112373),t=__webpack_require__(610314),n=__webpack_require__(891987),i=__webpack_require__(610796),l=__webpack_require__(623537),s=__webpack_require__(379072),d=__webpack_require__(189997),c=__webpack_require__(959211),a=__webpack_require__(739646),p=__webpack_require__(423269),u=__webpack_require__(852989);function x(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var f=x(o);const h=f.default(t.Modal)`
  &.ant-modal {
    top: 80px;
  }

  .ant-modal {
    &-header,
    &-footer {
      padding: 8px;
      border-radius: 8px;
    }

    &-title {
      font-size: 14px;
    }

    &-close-x {
      width: 32px;
      height: 32px;
      line-height: 32px;
      font-size: 14px;
    }
    &-content {
      border-radius: 8px;
      padding: 8px;
    }
  }
`,m=f.default.div`
  display: flex;
  justify-content: space-between;
`,g=f.default(t.Button)`
  color: var(--text-color);
  padding-left: 0;
  padding-right: 0;
`,j=f.default(t.Button)`
  border-radius: 6px;
`,C=f.default.div`
  font-size: 14px;
  font-weight: 600;
`,y=f.default.div`
  color: #7367f0;
  font-size: 14px;
  cursor: pointer;
  margin-right: 10px;
`,v=f.default(r.QuestionCircleOutlined)`
  font-size: 1.2em;
  color: #82869e;
  margin-left: 4px;

  &:hover {
    color: var(--text-color);
  }
`,b=f.default.div`
  display: flex;
  flex-wrap: wrap;
`,k=f.default.div`
  font-size: 16px;
  margin-top: 20px;
`,w=f.default.div((({color:e})=>`\n    position: relative;\n    width: 30px;\n    height: 30px;\n    border-radius: 2px;\n    margin-right: 7px;\n    margin-top: 5px;\n    background: ${e};\n    border: 1px solid rgba(0, 0, 0, 0.05);\n    cursor: pointer;\n    transition: scale 0.2s ease-in-out;\n    &:hover {\n      z-index: 1;\n      scale: 1.15;\n      .icon-wrapper {\n        display: flex\n      }\n    }\n    .icon-wrapper {\n      position: absolute;\n      border-radius: 50%;\n      padding: 4px;\n      top: 0;\n      align-items: center;\n      justify-content: center;\n      display: none;\n      color: #ffffff;\n      &:hover {\n        filter: brightness(1.1);\n      }\n    }\n    .icon-wrapper.edit-icon {\n      background: #7367f0;\n      left: 0;\n      transform: translate(-50%, -50%);\n    }\n    .icon-wrapper.delete-icon {\n      background: red;\n      right: 0;\n      transform: translate(50%, -50%);\n    }\n`)),S=f.default.div`
  position: absolute;
  top: -5px;
  left: -5px;
  width: calc(100% + 10px);
  height: calc(100% + 10px);
  border-radius: 5px;
  border: 2px solid #7367f0;
`;exports.ColorDiv=w,exports.ColorPickerModalV3=({color:o,visible:r,setVisible:x,onChange:f,hasGradientColor:_})=>{const{recentColors:q,updateThemeConfig:z}=p.useThemeStore(),{document:T}=i.useFrame(),[I,O]=n.useState(o),[M,P]=n.useState(!1),[A,B]=n.useState(!1),{setOpenThemeConfig:D}=u.useBuilder(),Q=()=>x(!1);return n.useEffect((()=>{O(o)}),[o]),e.jsxs(e.Fragment,{children:[e.jsxs(h,{"data-testid":"color-picker-modal",open:r,title:l.t("Chọn màu"),onCancel:Q,width:410,bodyStyle:{padding:10},zIndex:9999,destroyOnClose:!0,getContainer:()=>(null==T?void 0:T.body)||(null==document?void 0:document.body),footer:e.jsxs(m,{children:[e.jsx(g,{type:"link",onClick:()=>{f(void 0),O(void 0),Q()},children:l.t("Đặt lại")}),e.jsxs("div",{style:{display:"flex"},children:[e.jsx(j,{onClick:Q,"data-testid":"color-picker-cancel",children:l.t("common.cancel")}),e.jsx(j,{type:"primary",onClick:()=>{f(I),Q()},"data-testid":"color-picker-ok",children:l.t("common.save")})]})]}),children:[e.jsxs("div",{style:{marginTop:20,display:"flex",justifyContent:"space-between"},children:[e.jsxs("div",{style:{display:"flex",alignItems:"center"},children:[e.jsx(C,{children:l.t("color_picker.from_theme")}),e.jsx(t.Popover,{content:e.jsx("div",{style:{color:"#fff",width:200},children:l.t("color_picker.from_theme.tooltip")}),zIndex:1e4,color:"#000",overlayInnerStyle:{backgroundColor:"#000"},children:e.jsx(v,{name:"AntdQuestionCircleOutlined"})})]}),e.jsx(y,{onClick:()=>{D("color"),Q()},children:l.t("color_picker.edit_theme")})]}),e.jsx(d.ThemeColorSelect,{selectedColor:I,onSelect:O}),e.jsxs("div",{style:{marginTop:20,display:"flex",justifyContent:"space-between"},children:[e.jsxs("div",{style:{display:"flex",alignItems:"center"},children:[e.jsx(C,{children:l.t("color_picker.from_my_colors")}),e.jsx(t.Popover,{content:e.jsx("div",{style:{color:"#fff"},children:l.t("color_picker.from_my_colors.tooltip")}),zIndex:1e4,color:"#000",overlayInnerStyle:{backgroundColor:"#000"},children:e.jsx(v,{name:"AntdQuestionCircleOutlined"})})]}),e.jsxs(y,{onClick:()=>{P(!0)},children:["+ ",l.t("add_color")]})]}),e.jsx(b,{style:{marginTop:5},children:null==q?void 0:q.map(((o,r)=>(_||!o.includes("-gradient"))&&e.jsxs(w,{onDoubleClick:()=>{P(!0)},color:o,onClick:()=>{O(o)},children:[I===o&&e.jsx(S,{}),e.jsx("div",{className:"icon-wrapper edit-icon",onClick:()=>{P(!0),B(!0)},children:e.jsx(c.EditRegular,{fontSize:14})}),e.jsx("div",{className:"icon-wrapper delete-icon",onClick:e=>{((e,o)=>{e.stopPropagation();const r=q.filter(((e,r)=>r!==o));z({recentColors:r})})(e,r)},children:e.jsx(c.DismissRegular,{fontSize:14})})]},r)))}),e.jsx(k,{children:a.getColorValue(I,!1)})]}),M&&e.jsx(s.AddColorModal,{myColors:q||[],hasGradientColor:_,visible:M,onClose:()=>{P(!1),B(!1)},setSelectedColor:O,initColor:I,isUpdate:A})]})},exports.SelectedColor=S;


/***/ }),

/***/ 146532:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),o=__webpack_require__(85097),i=__webpack_require__(736451);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=l(r);const n=t.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-color);
  padding-left: 4px;
  border-radius: 4px;
`,d=t.default(i.HexColorInput)`
  width: 80px;
  padding: 4px 4px 4px 8px;
  text-align: left;
  vertical-align: middle;
  border: none;
  &:focus {
    outline: none;
  }
`,a=t.default.div`
  border-radius: 4px;
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>');
`,s=t.default.div((({colorConfig:e,size:r})=>`\n    width: ${r}px;\n    height: ${r}px;\n    border-radius: 4px;\n    margin-left: auto;\n    background: ${o.stringifyColor(e)};\n    border: 1px solid rgba(0, 0, 0, 0.05);\n`));exports.ColorPreview=({hexInput:r,onChangeColor:i,colorType:l,currentColorValue:t})=>e.jsx(e.Fragment,{children:l===o.ColorType.solid?e.jsxs(n,{children:[e.jsx(a,{children:e.jsx(s,{colorConfig:{colorType:l,colorValue:t},size:20})}),e.jsx(d,{alpha:!0,prefixed:!0,color:r,onChange:i})]}):e.jsx(a,{children:e.jsx(s,{colorConfig:{colorType:l,colorValue:t},size:32})})});


/***/ }),

/***/ 189997:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),o=__webpack_require__(392244),t=__webpack_require__(959211),l=__webpack_require__(610314),i=__webpack_require__(623537),s=__webpack_require__(739646),n=__webpack_require__(423269),c=__webpack_require__(852989);function u(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const d=u(r).default.div`
  display: flex;
  margin-top: 10px;
  align-items: center;
`;exports.ThemeColorSelect=({selectedColor:r,onSelect:u,closeColorPickerModal:a})=>{const{currentColorPalette:j}=n.useThemeStore(),{setOpenThemeConfig:p}=c.useBuilder();return e.jsxs(d,{children:[null==j?void 0:j.map((t=>{const l=s.getColorThemeCssVarFromId(t.id);return e.jsx(o.ColorDiv,{color:t.color,onClick:()=>u(l),children:r===l&&e.jsx(o.SelectedColor,{})},t.id)})),a&&e.jsx(l.Tooltip,{zIndex:9999,color:"#000",title:i.t("color_picker.edit_color_palette"),children:e.jsx(t.SettingsFilled,{style:{fontSize:20,marginLeft:8,color:"#7B61FF",cursor:"pointer"},onClick:()=>{p("color"),a()}})})]})};


/***/ }),

/***/ 765446:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(891987),n=__webpack_require__(555254);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const u=/^\d(\.\d+)*$/,i=s(t).default.input(n.inputCss);exports.EditableInput=({value:t,onChange:n,min:s,max:o,precision:a})=>{const[l,c]=r.useState(),p=Number(t).toString(),d=()=>void 0!==a;return r.useEffect((()=>{const e=d()?parseFloat(l):parseInt(l);t!==e&&c(p)}),[t]),e.jsx(i,{value:l||"",onChange:e=>{var r;let u=e.target.value;if(!u)return void c(u);let i=parseInt(u);const l=u.split(/(\.|,)/);if(l.length>1)if(d()){const e=(null==(r=l[2])?void 0:r.substr(0,a))||"";u=`${l[0]}.${e}`,i=parseFloat(u)}else u=l[0];i>=s&&i<=o&&(c(u),t!==i&&n(i))},onBlur:()=>{u.test(l)||c(p)}})};


/***/ }),

/***/ 273202:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),o=__webpack_require__(85097),n=__webpack_require__(891987);function t(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=t(r);const l=i.default.div`
  border-radius: 8px;
  background-color: var(--background-color);
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>');
`,u=i.default.div((({gradientColor:e})=>`\n      height: 12px;\n      border-radius: 8px;\n      margin-top: 12px;\n      margin-bottom: 12px;\n      position: relative;\n      background: ${o.stringifyColor({colorType:o.ColorType.gradient,colorValue:e})};\n      `)),a=i.default.div((({gColor:e})=>`\n    height: 16px;\n    width: 16px;\n    padding-left: 2px;\n    padding-right: 2px;\n    position: absolute;\n    z-index: 10000;\n    background: ${e.color};\n    left: min(max(${e.stop}%, 0%), 100%);\n    top: 50%;\n    transform: translate(-50%,-50%);\n    border: 2px solid #fff;\n    border-radius: 50%;\n    box-shadow: 0 2px 4px rgb(0 0 0 / 20%);\n    &:hover {\n      cursor: pointer;\n    }\n  `));exports.GradientBar=({gradientColor:r,setSelectedGradientItem:o,onChange:t})=>{var i,d;const s=n.useRef(null);return e.jsx(l,{children:e.jsx(u,{gradientColor:r,ref:s,children:null==(d=null==(i=null==r?void 0:r.colors)?void 0:i.map)?void 0:d.call(i,((n,i)=>e.jsx(a,{gColor:n,onMouseDown:e=>{o(i),((e,o)=>{if(!(null==s?void 0:s.current))return;const n=s.current.clientWidth;let i=o.clientX;s.current.onmousemove=o=>{const l=Math.round(100*(o.clientX-i)/n),u=[...r.colors],a=u[e].stop+l;u[e].stop+=l,Math.abs(l)>=1&&a>=0&&a<=100&&(i=o.clientX,u[e].stop=a,t("colors",u))},s.current.onmouseup=()=>{s.current.onmousemove&&(s.current.onmousemove=null)},s.current.onmouseleave=()=>{s.current.onmousemove&&(s.current.onmousemove=null)}})(i,e)}},i)))})})};


/***/ }),

/***/ 452669:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(765446),l=__webpack_require__(555254),a=__webpack_require__(739646);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=o(r),n=Object.defineProperty,s=Object.defineProperties,u=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,d=(e,r,t)=>r in e?n(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;const j=i.default.label(l.labelCss);exports.RgbaField=({color:r,onChange:l,className:o})=>{var i;const n=null==(i=a.rgbaStringToObject(r))?void 0:i.rgba;return e.jsx("div",{className:o,style:{display:"flex",columnGap:4},children:["r","g","b","a"].map((r=>e.jsxs("div",{children:[e.jsx(t.EditableInput,{value:(null==n?void 0:n[r])||null,onChange:e=>{var t;l(a.rgbaToString((t=((e,r)=>{for(var t in r||(r={}))b.call(r,t)&&d(e,t,r[t]);if(c)for(var t of c(r))p.call(r,t)&&d(e,t,r[t]);return e})({},n),s(t,u({[r]:e})))))},min:0,max:"a"===r?1:255,precision:"a"===r?2:void 0}),e.jsx(j,{children:r})]},r)))})};


/***/ }),

/***/ 400406:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.MAX_NUMBER_OF_RECENT_COLORS=40,exports.sampleColors=["#f44336ff","#e91e63ff","#9c27b0ff","#673ab7ff","#3f51b5ff","#2196f3ff","#03a9f4ff","#00bcd4ff","#009688ff","#4caf50ff","#8bc34aff","#cddc39ff","#ffeb3bff","#ffc107ff","#ff9800ff","#ff5722ff"];


/***/ }),

/***/ 555254:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(75537);const t=e.css`
  width: 100%;
  padding: 5px;
  border-radius: 5px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  text-align: center;
`,r=e.css`
  width: 100%;
  margin-top: 4px;
  font-weight: 500;
  text-align: center;
  text-transform: uppercase;
`;exports.inputCss=t,exports.labelCss=r;


/***/ }),

/***/ 500613:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(623537),o=__webpack_require__(212951),i=__webpack_require__(112373),l=__webpack_require__(85097),t=__webpack_require__(739646),d=__webpack_require__(476756);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=n(o);const a=s.default.div`
  position: relative;
`,c=s.default.div((({color:e})=>`\n    width: 24px;\n    height: 24px;\n    border-radius: 4px;\n    margin-left: 4px;\n    background: ${e};\n    margin-right: 8px;\n`)),p=s.default.div`
  position: relative;
  width: 130px;
  height: 32px;
  display: flex;
  align-items: center;
  border: 1px solid ${e=>e.theme.colorBorder};
  border-radius: 4px;
  &:hover {
    cursor: pointer;
  }
`,u=s.default.div`
  font-size: 13px;
  line-height: 20px;
`,h=s.default.div`
  font-size: 13px;
  line-height: 18px;
  color: var(--placeholder-color);
  padding: 12px;
`,x=s.default.div`
  display: flex;
  align-items: center;
  width: 100%;
`,g=s.default.div`
  margin: auto 4px;
  right: 0;
  position: absolute;
`;exports.ColorPickerV2=({color:o,showModal:n,setShowModal:s,onChangeColor:v,placeholder:f,hasGradientColor:j})=>{const C=l.parseColor(o),m=(null==C?void 0:C.colorType)===l.ColorType.solid?t.getHexColor(o):void 0;return e.jsxs(a,{children:[e.jsx(p,{onClick:()=>{s(!n)},"data-testid":"color-picker-select",children:o?e.jsxs(e.Fragment,{children:[e.jsxs(x,{children:[e.jsx(c,{color:o}),e.jsx(u,{children:m||""})]}),e.jsx(g,{onClick:e=>{v(void 0),e.stopPropagation()},children:e.jsx(i.CloseOutlined,{})})]}):e.jsx(h,{children:f||r.t("Chọn màu")})}),e.jsx(d.ColorPickerModalV2,{visible:n,setVisible:s,color:o,onChange:v,hasGradientColor:j})]})};


/***/ }),

/***/ 535745:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(112373),r=__webpack_require__(212951),i=__webpack_require__(85097),l=__webpack_require__(623537),t=__webpack_require__(891987),n=__webpack_require__(736451),d=__webpack_require__(476756),s=__webpack_require__(739646);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=a(r);const p=c.default.div`
  position: relative;
`,u=c.default.div((({color:e,theme:o})=>`\n    width: 24px;\n    height: 24px;\n    border-radius: 4px;\n    margin-left: 4px;\n    background: ${e};\n    margin-right: 8px;\n    border: 1px solid ${null==o?void 0:o.colorBorder};\n`)),x=c.default.div`
  position: relative;
  width: 130px;
  height: 32px;
  display: flex;
  align-items: center;
  border: 1px solid ${e=>e.theme.colorBorder};
  border-radius: 4px;
  &:hover {
    cursor: pointer;
  }
`,h=c.default(n.HexColorInput)`
  width: 85px;
  height: 28px;
  font-size: 13px;
  border: none;
  outline: none;
`,f=c.default.div`
  font-size: 13px;
  line-height: 18px;
  color: var(--placeholder-color);
  padding: 12px;
`,g=c.default.div`
  display: flex;
  align-items: center;
  width: 100%;
`,v=c.default.div`
  margin: auto 4px;
  right: 0;
  position: absolute;
`;exports.ColorPickerV3=({color:r,showModal:n,setShowModal:a,onChangeColor:c,placeholder:C,hasGradientColor:j})=>{const[b,m]=t.useState(),k=i.parseColor(r),q=(null==k?void 0:k.colorType)===i.ColorType.solid?s.getHexColor(r):void 0,y=()=>{a(!n)};return t.useEffect((()=>{m(q)}),[q]),e.jsxs(p,{children:[r?e.jsxs(x,{children:[e.jsxs(g,{children:[e.jsx(u,{color:r,onClick:y,"data-testid":"color-picker-select"}),e.jsx(h,{alpha:!0,prefixed:!0,color:b,onChange:c,"data-testid":"color-picker-input"})]}),e.jsx(v,{onClick:e=>{c(void 0),m(void 0),e.stopPropagation()},children:e.jsx(o.CloseOutlined,{})})]}):e.jsx(x,{onClick:y,children:e.jsx(f,{children:C||l.t("Chọn màu")})}),e.jsx(d.ColorPickerModalV2,{visible:n,setVisible:a,color:r,onChange:c,hasGradientColor:j})]})};


/***/ }),

/***/ 276467:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(623537),r=__webpack_require__(212951),i=__webpack_require__(112373),l=__webpack_require__(643784),t=__webpack_require__(739646);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=n(r);const d=a.default.div((({color:e})=>`\n    width: 24px;\n    height: 24px;\n    border-radius: 4px;\n    margin-left: 4px;\n    background: ${e};\n    margin-right: 8px;\n`)),s=a.default.div`
  font-size: 13px;
  line-height: 20px;
`,c=a.default.div`
  font-size: 13px;
  line-height: 18px;
  color: var(--placeholder-color);
  padding: 12px;
`,h=a.default.div`
  display: flex;
  align-items: center;
  width: 100%;
`,p=a.default.div`
  margin: auto 4px;
  right: 0;
  position: absolute;
`;exports.ColorPickerV4=({color:r,showModal:n,setShowModal:a,onChangeColor:u,placeholder:g,hasGradientColor:x,propKey:C,onCancelEditingColor:f,onEditingColor:j,isStretch:v,showSelectedThemeColor:m=!0,allowClear:b=!0,displayText:y})=>e.jsx("div",{style:{position:"relative",flex:v?1:void 0},children:e.jsx(l.ColorPickerDraggable,{propKey:C,visible:n,setVisible:a,color:r,onChange:u,hasGradientColor:x,onCancelEditingColor:f,onEditingColor:j,isStretch:v,showSelectedThemeColor:m,colorConfig:r?e.jsxs(e.Fragment,{children:[e.jsxs(h,{children:[e.jsx(d,{color:r}),e.jsx(s,{children:y||t.getColorValue(r)||""})]}),b&&e.jsx(p,{onClick:e=>{u(null),e.stopPropagation()},children:e.jsx(i.CloseOutlined,{})})]}):e.jsx(c,{children:g||o.t("Chọn màu")})})});


/***/ }),

/***/ 254686:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=i(__webpack_require__(212951));const r=t.default.div`
  font-weight: 700;
  color: rgba(0, 0, 0, 0.88);
  line-height: 1.5;
  font-size: 14px;
  margin-inline-end: auto;
  flex: auto;
  box-sizing: border-box;
  padding: 8px 0px;
`,o=t.default.div`
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
`;exports.ConfigWrapper=({title:i,children:t})=>e.jsxs("div",{children:[i&&e.jsx(r,{children:i}),e.jsx(o,{children:t})]});


/***/ }),

/***/ 147446:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(623537),t=__webpack_require__(212951),s=__webpack_require__(610314),i=__webpack_require__(458460),o=__webpack_require__(852989);function r(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const a=r(t).default.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;exports.ContextMenu=t=>{const{children:r}=t,{actions:d,duplicateNode:l,query:c,getSiblings:u,onCopy:p,onPaste:x}=i.useEditor(),{frame:h,setShowSettingDialog:j,editorConfig:y}=o.useBuilder(),C=e=>"windows"===(()=>{const e=window.navigator.userAgent.toLowerCase();return[{os:"macos",pattern:/(macintosh|macintel|macppc|mac68k|macos)/i},{os:"windows",pattern:/(win32|win64|windows|wince)/i},{os:"ios",pattern:/(iphone|ipad|ipod)/i},{os:"android",pattern:/android/},{os:"linux",pattern:/linux/}].find((n=>n.pattern.test(e))).os})()?`Ctrl + ${e}`:`⌘ ${e}`,g=[{label:e.jsxs(a,{children:[e.jsx("span",{children:n.t("Cài đặt")}),e.jsx("span",{children:C("E")})]}),key:"1",onClick:()=>{j(!0)}},{label:e.jsxs(a,{children:[e.jsx("span",{children:n.t("Sao chép")}),e.jsx("span",{children:C("C")})]}),key:"2",onClick:()=>(()=>{const e=c.getState().events.selected,n=e.values().next().value;y.canCopyPaste(e,c.node)&&p(n)})()},{label:e.jsxs(a,{children:[e.jsx("span",{children:n.t("Dán")}),e.jsx("span",{children:C("V")})]}),key:"3",onClick:()=>{const e=c.getState().events.selected,n=e.values().next().value;y.canCopyPaste(e,c.node)&&x(n)}},{label:e.jsxs(a,{children:[e.jsx("span",{children:n.t("Nhân bản")}),e.jsx("span",{children:C("D")})]}),key:"4",onClick:()=>{const e=c.getState().events.selected,n=e.values().next().value;if(!y.canCopyPaste(e,c.node))return;const t=u(n).findIndex((e=>e===n)),s=c.node(n).get();l(s,s.data.parent,{index:t+1})}},{label:e.jsxs(a,{children:[e.jsx("span",{children:n.t("Xoá")}),e.jsx("span",{children:C("⌫")})]}),key:"5",onClick:()=>{const e=c.getState().events.selected;y.canDeleteNode(e,c.node)&&d.delete(Array.from(e))}}];return e.jsx(s.Dropdown,{getPopupContainer:()=>null==h?void 0:h.body,destroyPopupOnHide:!0,menu:{items:g,style:{width:160}},trigger:["contextMenu"],children:r})};


/***/ }),

/***/ 250227:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),o=__webpack_require__(959211),r=__webpack_require__(610314),n=__webpack_require__(891987);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const s=a(t).default.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
  .action-group {
    display: flex;
    gap: 2px;
  }
`;exports.DropdownOption=({label:t,changeItem:a,index:i,value:u,deleteItem:l})=>{const[c,p]=n.useState(t),[d,g]=n.useState(!1),x=n.useRef(null);return e.jsxs(s,{onClick:e=>{d&&e.stopPropagation()},children:[d?e.jsx(r.Input,{ref:x,value:c,onPressEnter:e=>{var t;t=e.currentTarget.value,a(t,u,i),g(!1)},onChange:e=>p(e.target.value),onMouseDown:e=>e.stopPropagation(),onBlur:()=>(g(!1),void p(t))}):t,e.jsxs("div",{className:"action-group",children:[!d&&e.jsx(r.Button,{size:"small",ghost:!0,icon:e.jsx(o.EditRegular,{color:"#7367f0"}),onClick:e=>{e.stopPropagation(),g(!0),setTimeout((()=>{var e;null==(e=x.current)||e.focus()}),0)}}),e.jsx(r.Button,{size:"small",ghost:!0,icon:e.jsx(o.DeleteRegular,{color:"red"}),onClick:e=>{e.stopPropagation(),l(i)}})]})]})};


/***/ }),

/***/ 321501:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(610314),l=__webpack_require__(891987),n=__webpack_require__(875839),i=__webpack_require__(434472);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=o(t),s=Object.defineProperty,d=Object.defineProperties,u=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,b=(e,t,r)=>t in e?s(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,x=(e,t)=>{for(var r in t||(t={}))p.call(t,r)&&b(e,r,t[r]);if(c)for(var r of c(t))f.call(t,r)&&b(e,r,t[r]);return e};const y=a.default.div`
  padding: 5px 12px;
  cursor: pointer;
  min-height: 31px;
  overflow: hidden;
  text-overflow: ellipsis;
`;exports.EditableCell=t=>{var o=t,{title:a,editable:s,children:b,dataIndex:h,rowIndex:v,style:w,record:j,onChange:m}=o,O=((e,t)=>{var r={};for(var l in e)p.call(e,l)&&t.indexOf(l)<0&&(r[l]=e[l]);if(null!=e&&c)for(var l of c(e))t.indexOf(l)<0&&f.call(e,l)&&(r[l]=e[l]);return r})(o,["title","editable","children","dataIndex","rowIndex","style","record","onChange"]);const[g,C]=l.useState(!1),I=l.useRef(null),E=l.useContext(i.EditableContext),P=async()=>{try{await E.validateFields([h]),m(E.getFieldValue(h)),q()}catch(e){}};l.useEffect((()=>{var e;g&&(null==(e=I.current)||e.focus())}),[g]);const q=()=>{C(!g),E.setFieldValue(h,j[h])};let S=b;return s&&(S=g?e.jsx(r.Form.Item,{style:{margin:0,whiteSpace:"normal"},name:h,rules:null==s?void 0:s.rules,children:(()=>{const{options:t,setOptions:l,inputType:i,cbDeleteOption:o}=s;switch(i){case"number":return e.jsx(r.InputNumber,{ref:I,onPressEnter:P,onBlur:P,style:{width:"100%"}});case"select":return e.jsx(n.Select,{onChange:P,ref:I,items:t,setItems:l,allowClear:!0,cbDeleteItem:e=>{E.setFieldValue(h,""),o(e)},onDropdownVisibleChange:e=>{!e&&C(!g)}});default:return e.jsx(r.Input,{ref:I,onPressEnter:P,onBlur:P,style:{width:"100%"}})}})()}):e.jsx(y,{className:"editable-cell",onClick:q,children:b})),e.jsx("td",(F=x({},O),D={style:x({overflow:"hidden",textOverflow:"ellipsis"},w),children:S},d(F,u(D))));var F,D},exports.StyledEditableCell=y;


/***/ }),

/***/ 875839:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(112373),r=__webpack_require__(610314),n=__webpack_require__(891987),l=__webpack_require__(623537),a=__webpack_require__(493959),o=__webpack_require__(250227);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=i(n),u=Object.defineProperty,d=Object.defineProperties,c=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,v=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,b=(e,t,r)=>t in e?u(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,m=(e,t)=>{for(var r in t||(t={}))v.call(t,r)&&b(e,r,t[r]);if(p)for(var r of p(t))f.call(t,r)&&b(e,r,t[r]);return e};const j=s.default.forwardRef(((i,s)=>{var u=i,{items:b,setItems:j,onChange:x,cbDeleteItem:g}=u,y=((e,t)=>{var r={};for(var n in e)v.call(e,n)&&t.indexOf(n)<0&&(r[n]=e[n]);if(null!=e&&p)for(var n of p(e))t.indexOf(n)<0&&f.call(e,n)&&(r[n]=e[n]);return r})(u,["items","setItems","onChange","cbDeleteItem"]);const[O,h]=n.useState(""),P=n.useRef(null),w=e=>{h(e.target.value)},I=()=>{const e=null==O?void 0:O.trim();if(!e)return;const t=a.v4();j([...b,{label:e,value:t}]),h(""),x(t,{value:t,label:e}),setTimeout((()=>{var e;null==(e=P.current)||e.focus()}),0)},q=(e,t,r)=>{const n=[...b];n[r]={label:e,value:t},j(n)},D=e=>{var t;const r=[...b],n=null==(t=r.splice(e,1))?void 0:t[0];j(r),null==g||g(n.value)};return e.jsx(e.Fragment,{children:e.jsx(r.Select,(S=m({dropdownStyle:{zIndex:1080}},y),C={onChange:(e,t)=>{x(e,null==t?void 0:t.dataLabel)},ref:s,style:{width:"100%"},dropdownRender:n=>e.jsxs(e.Fragment,{children:[(null==b?void 0:b.length)?n:e.jsx(r.Empty,{description:l.t("common.no_data")}),e.jsx(r.Divider,{style:{margin:"8px 0"}}),e.jsxs(r.Space,{style:{padding:"0 4px 2px"},children:[e.jsx(r.Input,{placeholder:l.t("select_config.add.placeholder"),ref:P,value:O,onChange:w,onKeyDown:e=>{e.stopPropagation()},onPressEnter:e=>{e.stopPropagation(),I()}}),e.jsx(r.Button,{type:"primary",size:"middle",icon:e.jsx(t.PlusOutlined,{}),onClick:e=>{e.stopPropagation(),I()},children:l.t("common.add")})]})]}),options:b.map(((t,r)=>({key:t.value,value:t.value,label:e.jsx(o.DropdownOption,{label:t.label,changeItem:q,index:r,value:t.value,deleteItem:D}),dataLabel:t.label}))),optionLabelProp:"dataLabel"},d(S,c(C))))});var S,C}));exports.Select=j;


/***/ }),

/***/ 434472:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(610314),t=__webpack_require__(891987),n=__webpack_require__(104437),o=__webpack_require__(944200),i=__webpack_require__(112373),l=__webpack_require__(212951);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=a(t),s=a(l),u=Object.defineProperty,c=Object.defineProperties,f=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,x=Object.prototype.propertyIsEnumerable,v=(e,r,t)=>r in e?u(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,y=(e,r)=>{for(var t in r||(r={}))b.call(r,t)&&v(e,t,r[t]);if(p)for(var t of p(r))x.call(r,t)&&v(e,t,r[t]);return e},m=(e,r)=>c(e,f(r));const j=d.default.createContext(null),O=s.default.tr`
  &:hover .editable-cell {
    padding: 4px 11px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
  }
`;exports.EditableContext=j,exports.EditableRow=t=>{var l,a=t,{index:s,children:u,style:c}=a,f=((e,r)=>{var t={};for(var n in e)b.call(e,n)&&r.indexOf(n)<0&&(t[n]=e[n]);if(null!=e&&p)for(var n of p(e))r.indexOf(n)<0&&x.call(e,n)&&(t[n]=e[n]);return t})(a,["index","children","style"]);const[v]=r.Form.useForm(),{attributes:h,listeners:g,setNodeRef:q,setActivatorNodeRef:P,transform:w,transition:S,isDragging:k}=o.useSortable({id:f["data-row-key"]}),C=y(m(y({},c),{transform:null==(l=n.CSS.Transform.toString(w&&m(y({},w),{scaleY:1})))?void 0:l.replace(/translate3d\(([^,]+),/,"translate3d(0,"),transition:S}),k?{position:"relative",zIndex:9999}:{});return e.jsx(O,m(y(y({ref:q},h),f),{style:C,children:e.jsx(r.Form,{form:v,component:!1,children:e.jsx(j.Provider,{value:v,children:d.default.Children.map(u,(r=>"sort"===r.key?d.default.cloneElement(r,{children:e.jsx(i.MenuOutlined,y({ref:P,style:{touchAction:"none",cursor:"move"}},g))}):r))})})}))};


/***/ }),

/***/ 691171:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(891987),t=__webpack_require__(212951),l=__webpack_require__(610314),i=__webpack_require__(112373);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var o=n(t),a=Object.defineProperty,s=Object.defineProperties,c=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,u=(e,r,t)=>r in e?a(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,x=(e,r)=>{for(var t in r||(r={}))p.call(r,t)&&u(e,t,r[t]);if(d)for(var t of d(r))f.call(r,t)&&u(e,t,r[t]);return e};const m=o.default.div`
  margin-bottom: 8px;

  &.horizontal {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 8px;
  }
`,y=o.default.div((({layout:e="horizontal"})=>`\n  flex: 1;\n  ${"vertical"===e?"margin-bottom: 4px;":""}\n`)),h=o.default.div`
  margin-bottom: 8px;
  color: #d5dadf;
  font-size: 13px;
`,b=o.default.div`
  margin-top: 4px;
  color: #ffb307;
`,g=o.default.div`
  margin-top: 4px;
  color: #d32f2f;
`,j=o.default(i.QuestionCircleOutlined)`
  margin: inherit;
  margin-left: 0.5rem;
`;exports.FormItem=t=>{var i=t,{className:n,layout:o="horizontal",label:a,children:u,warning:v,tip:O,error:z,tooltip:w,description:T,styleTextElement:P}=i,q=((e,r)=>{var t={};for(var l in e)p.call(e,l)&&r.indexOf(l)<0&&(t[l]=e[l]);if(null!=e&&d)for(var l of d(e))r.indexOf(l)<0&&f.call(e,l)&&(t[l]=e[l]);return t})(i,["className","layout","label","children","warning","tip","error","tooltip","description","styleTextElement"]);const[N,$]=r.useState();return e.jsxs(m,(E=x({className:(()=>{let e=`${o}`;return n&&(e+=` ${n}`),e})()},q),I={children:[!!a&&e.jsxs(y,{className:"label",ref:e=>{e&&"horizontal"===o&&$(e.clientWidth)},layout:o,children:[e.jsx(l.Typography.Title,{level:5,style:{fontSize:14,fontWeight:500,marginBottom:0,display:w?"inline":"block"},children:a}),!!T&&e.jsx(l.Typography.Text,{type:"secondary",children:T}),w&&e.jsx(l.Tooltip,{title:w,zIndex:1090,children:e.jsx(j,{className:"cursor-pointer"})})]}),O&&"vertical"===o&&e.jsx(h,{children:O}),u,(()=>{if(!(v||z||O&&"horizontal"===o))return null;const r=e.jsxs(e.Fragment,{children:[O&&"horizontal"===o&&e.jsx(h,{children:O}),!!v&&e.jsx(b,{children:v}),z&&e.jsx(g,{children:z})]});return"vertical"===o?r:e.jsx("div",{style:x({marginLeft:`${N}px`,flexBasis:"100%"},P),children:r})})()]},s(E,c(I))));var E,I};


/***/ }),

/***/ 776777:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(623537),r=__webpack_require__(891987),i=__webpack_require__(212951),n=__webpack_require__(610314);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=o(i),a=Object.defineProperty,l=Object.defineProperties,c=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,u=Object.prototype.hasOwnProperty,d=Object.prototype.propertyIsEnumerable,y=(e,t,r)=>t in e?a(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,f=(e,t)=>{for(var r in t||(t={}))u.call(t,r)&&y(e,r,t[r]);if(p)for(var r of p(t))d.call(t,r)&&y(e,r,t[r]);return e};const b=s.default.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
`,j=s.default(n.Button)`
  padding: 0 !important;
  height: unset !important;
`;exports.ModalConfigWrapper=({title:i=t.t("Cấu hình sự kiện"),actionText:o=t.t("Cấu hình"),customModal:s,subTitle:a,customModalProps:p})=>{const[u,d]=r.useState(!1);return e.jsxs(e.Fragment,{children:[e.jsxs(b,{children:[e.jsxs("div",{children:[e.jsx(n.Typography.Title,{level:5,style:{fontSize:14,fontWeight:500},children:i}),!!a&&e.jsx(n.Typography.Paragraph,{type:"secondary",className:"mb-0",children:a})]}),e.jsx(j,{type:"link",onClick:()=>d((e=>!e)),children:o})]}),e.jsx(s,f({},(y=f({},p),h={visible:u,setVisible:d},l(y,c(h)))))]});var y,h};


/***/ }),

/***/ 569059:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(891987),n=__webpack_require__(212951),o=__webpack_require__(437321),r=__webpack_require__(85097);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const s=i(n).default.div((({height:e,isDragging:t,isHovering:n,isAllowDrag:o,position:r})=>`\n  height: ${e}px;\n  transition: ${t?"none":"all 0.3s ease-in-out"};\n  opacity: ${n||t?1:0};\n  cursor: ${o?"ns-resize":"default"};\n  width: 100%;\n  pointer-events: ${o?"auto":"none"};\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #7367f0;\n  background-color: #7267f052;\n  user-select: none;\n  position: absolute;\n  font-weight: 600;\n  left: 0;\n  right: 0;\n  ${"top"===r?"top: 0;":"bottom: 0;"}\n`));exports.HorizontalPaddingDragHandler=({value:n,position:i,targetRef:u,onUpdate:a,onFinish:l})=>{const c=null==u?void 0:u.current,[d,p]=t.useState(n),[f,g]=t.useState(!1),[m,v]=t.useState(!1),[h,M]=t.useState(0),[D,y]=t.useState(0),x="number"==typeof n&&n>=o.MIN_PADDING;return t.useEffect((()=>{p(n)}),[n]),t.useEffect((()=>{if(c&&c.style)switch(i){case"top":c.style.paddingTop=`${d}px`;break;case"bottom":c.style.paddingBottom=`${d}px`}}),[d]),t.useEffect((()=>{var e;const t=e=>{if(f){const t=e.clientY-h,n=D+t,r=2*Math.round(n/2),i=Math.min(o.MAX_PADDING,Math.max(o.MIN_PADDING,r));p(i),null==a||a(i)}},n=()=>{f&&(g(!1),null==l||l(d))},i=(null==(e=null==document?void 0:document.querySelector(`#${r.TEMPI_MAIN_IFRAME}`))?void 0:e.contentWindow)||window;return f&&(i.addEventListener("mousemove",t),i.addEventListener("mouseup",n)),()=>{i.removeEventListener("mousemove",t),i.removeEventListener("mouseup",n)}}),[f,h,D,d,l]),"number"!=typeof n?null:e.jsxs(s,{height:d,isDragging:f,isHovering:m,isAllowDrag:x,position:i,onMouseDown:e=>{e.preventDefault(),g(!0),M(e.clientY),y(d)},onMouseEnter:()=>{v(!0)},onMouseLeave:()=>{f||v(!1)},children:[Math.round(d),"px"]})};


/***/ }),

/***/ 437321:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.MAX_PADDING=600,exports.MIN_PADDING=16;


/***/ }),

/***/ 626240:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(959211),o=__webpack_require__(610314),n=__webpack_require__(852989),i=__webpack_require__(458460);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=a(t),s=Object.defineProperty,d=Object.defineProperties,l=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,x=Object.prototype.propertyIsEnumerable,y=(e,t,r)=>t in e?s(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,b=(e,t)=>{for(var r in t||(t={}))p.call(t,r)&&y(e,r,t[r]);if(u)for(var r of u(t))x.call(t,r)&&y(e,r,t[r]);return e},f=(e,t)=>d(e,l(t));const g=c.default(o.Button)`
  display: flex;
  align-items: center;
  width: fit-content;
  padding: 0;
  background: transparent !important;

  &:not([disabled]):hover {
    path,
    stroke {
      fill: var(--text-color);
    }
  }
`;exports.PrevNext=({disabled:t})=>{const{getAttrTracking:a,isEditingText:c}=n.useBuilder(),{canUndo:s,canRedo:d,actions:{history:l}}=i.useEditor(((e,r)=>({canUndo:!c&&r.history.canUndo()&&!t,canRedo:!c&&r.history.canRedo()&&!t})));return e.jsxs(o.Space,{children:[e.jsx(g,f(b({},a({regionName:"pageEditor",contentName:"undoBtn"})),{onClick:()=>{s&&l.undo()},type:"text",disabled:!s,icon:e.jsx(r.ArrowHookUpLeft20Regular,{color:s?"var(--text-color)":"var(--text-secondary-color)"})})),e.jsx(g,f(b({},a({regionName:"pageEditor",contentName:"redoBtn"})),{onClick:()=>{s&&l.redo()},type:"text",disabled:!d,icon:e.jsx(r.ArrowHookUpRight20Regular,{color:d?"var(--text-color)":"var(--text-secondary-color)"})}))]})};


/***/ }),

/***/ 896121:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097),o=__webpack_require__(547929),i=__webpack_require__(610314),a=__webpack_require__(891987),l=__webpack_require__(852989);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=n(t),s=n(a),p=Object.defineProperty,u=Object.getOwnPropertySymbols,f=Object.prototype.hasOwnProperty,d=Object.prototype.propertyIsEnumerable,m=(e,t,r)=>t in e?p(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,g=(e,t)=>{for(var r in t||(t={}))f.call(t,r)&&m(e,r,t[r]);if(u)for(var r of u(t))d.call(t,r)&&m(e,r,t[r]);return e};const v=s.default.forwardRef(((t,a)=>{const n=t,{tooltip:c,isActive:s,className:p}=n,m=((e,t)=>{var r={};for(var o in e)f.call(e,o)&&t.indexOf(o)<0&&(r[o]=e[o]);if(null!=e&&u)for(var o of u(e))t.indexOf(o)<0&&d.call(e,o)&&(r[o]=e[o]);return r})(n,["tooltip","isActive","className"]),v=[p,s?"active":""].filter(Boolean).join(" "),{tag:j}=o.useNode((e=>({tag:e.data.custom.tag}))),{device:b}=l.useBuilder(),x=j===r.COMPONENT_TAG.SECTION&&"desktop"!==b;return e.jsx(i.Tooltip,{title:c,getPopupContainer:e=>e,getTooltipContainer:e=>e,placement:x?"right":"top",children:e.jsx(y,g({ref:a,className:v},m))})})),y=c.default.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  height: 40px;
  padding-left: 12px;
  padding-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #444444;
  white-space: nowrap;

  &:hover,
  &.active {
    color: ${e=>e.theme.colorPrimary};
  }
`;exports.QuickSettingButton=v;


/***/ }),

/***/ 43730:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(610314),r=__webpack_require__(212951),n=__webpack_require__(547929),o=__webpack_require__(852989);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=i(r),d=Object.defineProperty,l=Object.defineProperties,c=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,s=Object.prototype.propertyIsEnumerable,f=(e,t,r)=>t in e?d(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r;const g=a.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 12px;
  padding-right: 12px;
`;exports.RenderQuickSetting=r=>{var i=r,{children:a,content:d,open:v}=i,y=((e,t)=>{var r={};for(var n in e)p.call(e,n)&&t.indexOf(n)<0&&(r[n]=e[n]);if(null!=e&&u)for(var n of u(e))t.indexOf(n)<0&&s.call(e,n)&&(r[n]=e[n]);return r})(i,["children","content","open"]);const{dragging:b,tag:j}=n.useNode((e=>({dragging:e.events.dragged,tag:e.data.custom.tag}))),{frame:x}=o.useBuilder();return e.jsx(t.Popover,(O=((e,t)=>{for(var r in t||(t={}))p.call(t,r)&&f(e,r,t[r]);if(u)for(var r of u(t))s.call(t,r)&&f(e,r,t[r]);return e})({placement:"top",open:v&&!b,overlayInnerStyle:{width:"max-content",borderRadius:8,padding:0},zIndex:1050,content:e.jsx(g,{"data-testid":`${j}-popover-quick-setting`,children:d}),autoAdjustOverflow:!0,destroyTooltipOnHide:!0,getPopupContainer:()=>null==x?void 0:x.body,getTooltipContainer:()=>null==x?void 0:x.body},y),l(O,c({children:a}))));var O};


/***/ }),

/***/ 587877:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(112373),i=__webpack_require__(212951),n=__webpack_require__(891987);function r(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=r(i);const o=l.default.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
`,s=l.default.span`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`,d=l.default.div`
  display: flex;
  align-items: center;
  padding: 8px 0;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1080;
`,c=l.default(t.LeftOutlined)`
  margin-right: 8px;
`,a=l.default.div`
  min-height: 38px;
  padding: 8px 12px 8px 0;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  font-weight: 500;
`,p=l.default.div`
  color: #000000cc;
  font-weight: bold;
`;exports.SettingWrapper=({children:i,settings:r})=>{const[l,u]=n.useState(null);if(null!==l){const t=r[l];return e.jsxs(e.Fragment,{children:[e.jsxs(d,{onClick:()=>u(null),children:[e.jsx(c,{}),e.jsx(s,{children:t.label})]}),t.children]})}return e.jsxs(e.Fragment,{children:[i,r.map(((i,n)=>e.jsxs(a,{onClick:()=>{u(n)},children:[e.jsx(o,{children:i.label}),e.jsx(p,{children:e.jsx(t.RightOutlined,{})})]},n)))]})};


/***/ }),

/***/ 143299:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(610314),t=Object.defineProperty,n=Object.defineProperties,o=Object.getOwnPropertyDescriptors,i=Object.getOwnPropertySymbols,l=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable,c=(e,r,n)=>r in e?t(e,r,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[r]=n,p=(e,r)=>{for(var t in r||(r={}))l.call(r,t)&&c(e,t,r[t]);if(i)for(var t of i(r))a.call(r,t)&&c(e,t,r[t]);return e};exports.SubQuickSetting=t=>{var c,u=t,{children:d,overlayInnerStyle:b}=u,y=((e,r)=>{var t={};for(var n in e)l.call(e,n)&&r.indexOf(n)<0&&(t[n]=e[n]);if(null!=e&&i)for(var n of i(e))r.indexOf(n)<0&&a.call(e,n)&&(t[n]=e[n]);return t})(u,["children","overlayInnerStyle"]);return e.jsx(r.Popover,(c=p({trigger:"click",placement:"bottom",overlayInnerStyle:p({padding:12,borderRadius:8,width:310},b),zIndex:1065,getPopupContainer:e=>e},y),n(c,o({children:d}))))};


/***/ }),

/***/ 440178:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(610314),t=__webpack_require__(691171),o=Object.defineProperty,s=Object.defineProperties,c=Object.getOwnPropertyDescriptors,n=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable,p=(e,r,t)=>r in e?o(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,l=(e,r)=>{for(var t in r||(r={}))i.call(r,t)&&p(e,t,r[t]);if(n)for(var t of n(r))a.call(r,t)&&p(e,t,r[t]);return e};exports.SwitchToShow=o=>{const{show:n,setShow:i,formItemProps:a,children:p,switchProps:m}=o;return e.jsxs(e.Fragment,{children:[e.jsx(t.FormItem,(u=l({},a),b={children:e.jsx(r.Switch,l({checked:n,onChange:i},m))},s(u,c(b)))),n&&p]});var u,b};


/***/ }),

/***/ 584491:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),i=__webpack_require__(623537),t=__webpack_require__(610314),r=__webpack_require__(891987),n=__webpack_require__(493959),a=__webpack_require__(852989);const l=(e,i)=>URL.createObjectURL(e);exports.UploadImageButton=({acceptedFiles:o=["image/jpg","image/jpeg","image/png","image/gif","image/webp"],handlerAfterUpload:u})=>{const[s,c]=r.useState(!1),d=r.useRef(),{uploadFileHandler:p=l,maxSizeImageUpload:g=20}=a.useBuilder(),[m,f]=r.useState(n.v4()),h=()=>{if(!d)return;const e=d.current.parentNode;e.focus(),e.querySelector("button").blur(),d.current.click()};return e.jsxs("div",{onKeyDown:h,onClick:h,children:[e.jsx("input",{ref:d,disabled:s,id:"image-file",type:"file",hidden:!0,multiple:!0,onClick:e=>e.stopPropagation(),onChange:e=>(e=>{try{const{files:r}=e.target,n=[...r];if((null==r?void 0:r.length)>5)return void t.notification.error({message:i.t("Vui lòng chỉ tải lên tối đa {{MAX_IMAGE_UPLOAD}} ảnh 1 lần!",{MAX_IMAGE_UPLOAD:5})});if(n.some((e=>!o.includes(e.type))))return void t.notification.error({message:i.t("Chỉ upload các định dạng file: {{acceptedFiles}}",{acceptedFiles:o})});(e=>{c(!0);const i=e.map((e=>p(e,"image")));Promise.all(i).then((e=>{null==u||u(e)})).finally((()=>c(!1)))})(n)}finally{f(n.v4())}})(e)},m),e.jsx(t.Button,{loading:s,shape:"round",children:i.t("upload_image_product",{maxSize:`${g}MB`})})]})};


/***/ }),

/***/ 164181:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),i=__webpack_require__(623537),t=__webpack_require__(623906),r=__webpack_require__(11575),n=__webpack_require__(900193),s=__webpack_require__(610314),o=__webpack_require__(215921),a=__webpack_require__(151033),d=__webpack_require__(117480),l=__webpack_require__(852989),c=__webpack_require__(96179);const{Panel:p}=s.Collapse;exports.AdvanceAttributes=({propKey:g=c.PROP_KEY.CommonStyle,separateDevice:u=!1,readOnlyElementId:h,allowConfigSchema:j,allowConfigVisibility:x=!0,allowConfigResponsive:v})=>{const{allowConfigResponsive:y}=l.useBuilder(),m=void 0!==v?v:y;return e.jsxs(e.Fragment,{children:[e.jsx(n.AttributeId,{readOnlyElementId:h}),e.jsx(s.Divider,{style:{margin:"12px 0"}}),e.jsxs(s.Collapse,{defaultActiveKey:["Spacing","ResponsiveVisibility","TimingVisibility"],expandIconPosition:"end",bordered:!1,children:[e.jsx(p,{header:i.t("Khoảng cách"),children:e.jsxs(s.Space,{direction:"vertical",children:[e.jsx(s.Typography.Text,{style:{marginBottom:8},type:"warning",children:i.t("Chú ý: Margin và Padding quá cao có thể làm vỡ thiết kế trên điện thoại")}),e.jsx(t.SpacingAttribute,{title:"Margin",separateDevice:u,propKey:c.PROP_KEY.joinKey(g,c.PROP_KEY.Margin)}),e.jsx(t.SpacingAttribute,{title:"Padding",separateDevice:u,propKey:c.PROP_KEY.joinKey(g,c.PROP_KEY.Padding)})]})},"Spacing"),g===c.PROP_KEY.CommonStyle&&x&&e.jsxs(e.Fragment,{children:[m&&e.jsx(p,{header:i.t("Ẩn/Hiển thị trên thiết bị"),children:e.jsx(r.ResponsiveAttribute,{})},"ResponsiveVisibility"),e.jsx(p,{header:i.t("Đặt giờ hiển thị"),children:e.jsx(o.TimingAttributes,{})},"TimingVisibility")]}),e.jsx(p,{header:i.t("Hiệu ứng khi di chuột vào"),children:e.jsx(a.HoverConfig,{propKey:g,separateDevice:u})},"HoverEffect"),j&&e.jsx(p,{header:i.t("Schema"),children:e.jsx(d.CodeEditorConfig,{propKey:c.PROP_KEY.Schema})},"Schema")]})]})};


/***/ }),

/***/ 900193:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(623537),t=__webpack_require__(547929),i=__webpack_require__(891987),n=__webpack_require__(458460),s=__webpack_require__(2723),o=__webpack_require__(781883);exports.AttributeId=({readOnlyElementId:u=!1})=>{const d={label:r.t("Mã thành phần"),existed:r.t("Mã đã tồn tại")},{id:l}=t.useNode(),{query:a}=n.useEditor(),[p,h]=s.useProp("id"),[c,g]=i.useState("");return e.jsx(o.InputConfig,{formItemProps:{label:r.t("Mã thành phần"),warning:c,style:{margin:"0.5rem"}},inputProps:{value:p,onChange:e=>{const r=e.target.value.trim()||void 0;(e=>{let r="";if(e){const t=a.getSerializedNodes();Object.keys(t).filter((r=>{var i;return e===(null==(i=t[r].props)?void 0:i.id)&&r!==l})).length&&(r=d.existed)}g(r)})(r),h(r)},placeholder:r.t("Nhập mã"),readOnly:u}})};


/***/ }),

/***/ 620214:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(547929),n=__webpack_require__(78922),o=__webpack_require__(96179),i=__webpack_require__(505765);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var u=a(t),p=Object.defineProperty,s=Object.defineProperties,l=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,b=Object.prototype.propertyIsEnumerable,f=(e,t,r)=>t in e?p(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,m=(e,t)=>{for(var r in t||(t={}))c.call(t,r)&&f(e,r,t[r]);if(d)for(var r of d(t))b.call(t,r)&&f(e,r,t[r]);return e},v=(e,t)=>s(e,l(t)),j=(e=>(e.top="top",e.right="right",e.bottom="bottom",e.left="left",e.main="main",e))(j||{});const y=u.default.div`
  position: relative;
  height: 90px;
  width: 60%;
  margin: 24px auto;
  border: 1px solid var(--border-color);
  border-radius: 10px;
`,h=u.default(i.InputNumber)((({position:e})=>`\n    width: 50px;\n    position: absolute;\n    border-radius: 4px;\n    ${(()=>{switch(e){case"top":return" \n          left: 50%;\n        ";case"right":return"\n          left: 100%;\n          top: 50%;\n        ";case"bottom":return"\n          top: 100%;\n          left: 50%;\n        ";case"left":return"\n          top: 50%;\n        ";default:return"\n          top: 50%;\n          left: 50%;\n        "}})()}\n    transform: translateX(-50%) translateY(-50%);\n\n    .ant-input-number {\n      &-handler-wrap {\n        visibility: hidden;\n      }\n\n      &-input {\n        border-radius: 4px;\n        padding: 0 8px;\n        text-align: center;\n      }\n    } \n  `));exports.FourCornerInputGroup=({propKey:t,separateDevice:i})=>{const{defaultValues:a}=r.useNode((({data:e})=>{var r;return{defaultValues:null==(r=e.custom.defaultValues)?void 0:r[t]}})),[u,p]=n.usePropSeparateDevice(t,i);return e.jsx(y,{children:Object.values(j).map((r=>e.jsx(h,{position:r,separateDevice:i,propKey:o.PROP_KEY.joinKey(t,r),placeholder:(null==a?void 0:a[r])||0,onChange:e=>((e,t)=>{const r=null!==e?e:void 0;let n=u;n="main"===t?m(m({},n),Object.values(j).reduce(((e,t)=>v(m({},e),{[t]:r})),{})):v(m({},n),{[t]:r,main:void 0}),p(n)})(e,r)},r)))})};


/***/ }),

/***/ 11575:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(623537),i=__webpack_require__(407229),n=__webpack_require__(547929),r=__webpack_require__(955448),o=__webpack_require__(96179);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=s(i);exports.ResponsiveAttribute=()=>{const{responsive:i,actions:{setProp:s}}=n.useNode((e=>({responsive:e.data.props.responsive}))),c=(null==i?void 0:i.hiddenXs)||!1,h=(null==i?void 0:i.hiddenMd)||!1,l=e=>{"mobile"===e&&s((e=>{d.default(e,o.PROP_KEY.HiddenXs,!c)}),500),"desktop"===e&&s((e=>{d.default(e,o.PROP_KEY.HiddenMd,!h)}),500)};return e.jsxs(e.Fragment,{children:[e.jsx(r.SwitchConfig,{formItemProps:{label:t.t("Máy tính")},switchProps:{checkedChildren:t.t("Hiện"),unCheckedChildren:t.t("Ẩn"),checked:!h,onChange:()=>l("desktop")}}),e.jsx(r.SwitchConfig,{formItemProps:{label:t.t("Điện thoại"),style:{marginBottom:0}},switchProps:{checkedChildren:t.t("Hiện"),unCheckedChildren:t.t("Ẩn"),checked:!c,onChange:()=>l("mobile")}})]})};


/***/ }),

/***/ 623906:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var r=__webpack_require__(561261),e=__webpack_require__(620214),t=__webpack_require__(691171),o=Object.defineProperty,n=Object.getOwnPropertySymbols,u=Object.prototype.hasOwnProperty,l=Object.prototype.propertyIsEnumerable,a=(r,e,t)=>e in r?o(r,e,{enumerable:!0,configurable:!0,writable:!0,value:t}):r[e]=t,i=(r,e)=>{for(var t in e||(e={}))u.call(e,t)&&a(r,t,e[t]);if(n)for(var t of n(e))l.call(e,t)&&a(r,t,e[t]);return r};exports.SpacingAttribute=o=>{var a=o,{title:p}=a,c=((r,e)=>{var t={};for(var o in r)u.call(r,o)&&e.indexOf(o)<0&&(t[o]=r[o]);if(null!=r&&n)for(var o of n(r))e.indexOf(o)<0&&l.call(r,o)&&(t[o]=r[o]);return t})(a,["title"]);return r.jsx(t.FormItem,{layout:"vertical",label:p,children:r.jsx(e.FourCornerInputGroup,i({},c))})};


/***/ }),

/***/ 215921:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(547929),r=__webpack_require__(228831),i=Object.defineProperty,o=Object.getOwnPropertySymbols,n=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,a=(e,t,r)=>t in e?i(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r;exports.TimingAttributes=()=>{const{startTime:i,endTime:l,ruleRepeat:d,date:s,duration:m,actions:{setCustom:p}}=t.useNode((({data:e})=>{var t,r,i,o,n;return{startTime:null==(t=null==e?void 0:e.custom)?void 0:t.startTime,endTime:null==(r=null==e?void 0:e.custom)?void 0:r.endTime,ruleRepeat:null==(i=null==e?void 0:e.custom)?void 0:i.ruleRepeat,date:null==(o=null==e?void 0:e.custom)?void 0:o.date,duration:null==(n=null==e?void 0:e.custom)?void 0:n.duration}}));return e.jsx(r.TimingConfig,((e,t)=>{for(var r in t||(t={}))n.call(t,r)&&a(e,r,t[r]);if(o)for(var r of o(t))u.call(t,r)&&a(e,r,t[r]);return e})({},{startTime:i,endTime:l,ruleRepeat:d,date:s,duration:m,setDate:e=>{p((t=>{t.date=e}))},setStartTime:e=>{p((t=>{t.startTime=e}))},setEndTime:e=>{p((t=>{t.endTime=e}))},setRuleRepeat:e=>{p((t=>{t.ruleRepeat=e}))},setDuration:e=>{p((t=>{t.duration=e}))}}))};


/***/ }),

/***/ 78180:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(959211),r=__webpack_require__(610314),i=__webpack_require__(78922),n=__webpack_require__(691171),o=Object.defineProperty,l=Object.defineProperties,s=Object.getOwnPropertyDescriptors,a=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,p=(e,t,r)=>t in e?o(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r;exports.AlignmentConfig=o=>{const{propKey:f,buttonGroupProps:d,formItemProps:j,separateDevice:g,alignmentType:m="horizontal"}=o,{listAlignment:b=["left","center","right"],defaultValue:x}=d||{},[y=x,v]=i.usePropSeparateDevice(f,g),h=r=>{if("vertical"===m)switch(r){case"top":return e.jsx(t.AlignTopFilled,{fontSize:16});case"bottom":return e.jsx(t.AlignBottomFilled,{fontSize:16});case"center":return e.jsx(t.AlignCenterHorizontalFilled,{fontSize:16});case"justify":return e.jsx(t.TextAlignJustifyFilled,{style:{fontWeight:"bold"},fontSize:16})}switch(r){case"left":case"flex-start":return e.jsx(t.AlignLeftFilled,{fontSize:16});case"center":return e.jsx(t.AlignCenterVerticalFilled,{fontSize:16});case"right":case"flex-end":return e.jsx(t.AlignRightFilled,{fontSize:16});case"justify":case"space-between":return e.jsx(t.TextAlignJustifyRotate90Filled,{fontSize:16})}};return e.jsx(n.FormItem,(S=((e,t)=>{for(var r in t||(t={}))c.call(t,r)&&p(e,r,t[r]);if(a)for(var r of a(t))u.call(t,r)&&p(e,r,t[r]);return e})({},j),F={children:e.jsx(r.Radio.Group,{value:y,optionType:"button",buttonStyle:"solid",children:b.map(((t,i)=>e.jsx(r.Radio,{onClick:()=>(e=>{v(e!==y?e:void 0)})(t),value:t,children:h(t)},i)))})},l(S,s(F))));var S,F};


/***/ }),

/***/ 904039:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(623537),t=__webpack_require__(610314),i=__webpack_require__(87395),o=__webpack_require__(78922),a=__webpack_require__(96179),r=__webpack_require__(2723),s=__webpack_require__(301930),l=__webpack_require__(955448);const p=[{label:"Fading entrances",options:["fadeIn","fadeInUp","fadeInUpBig","fadeInDown","fadeInLeft","fadeInRight","fadeInTopLeft","fadeInTopRight","fadeInBottomLeft","fadeInBottomRight"]},{label:"Sliding entrances",options:["slideInUp","slideInDown","slideInLeft","slideInRight"]},{label:"Rotating entrances",options:["rotateIn","rotateInUpLeft","rotateInUpRight","rotateInDownLeft","rotateInDownRight"]},{label:"Bouncing entrances",options:["bounceIn","bounceInUp","bounceInDown","bounceInLeft","bounceInRight"]},{label:"Zooming entrances",options:["zoomIn","zoomInUp","zoomInDown","zoomInLeft","zoomInRight"]},{label:"Lightspeed",options:["lightSpeedInRight","lightSpeedInLeft","lightSpeedOutRight","lightSpeedOutLeft"]},{label:"Attention seekers",options:["bounce","flash","pulse","rubberBand","shakeX","shakeY","headShake","swing","tada","wobble","jello","heartBeat"]},{label:"Specials",options:["hinge","jackInTheBox","rollIn"]}];exports.AnimationConfig=({propKey:g=a.PROP_KEY.CommonStyle,separateDevice:u})=>{const{Option:d,OptGroup:h}=t.Select,[c,f]=o.usePropSeparateDevice(a.PROP_KEY.joinKey(g,a.PROP_KEY.AnimationRepeatType),u),[I,P]=r.useProp(a.PROP_KEY.joinKey(g,a.PROP_KEY.AnimationName));return e.jsxs(e.Fragment,{children:[e.jsx(s.SelectConfig,{separateDevice:u,propKey:a.PROP_KEY.joinKey(g,a.PROP_KEY.AnimationName),formItemProps:{label:n.t("Loại hiệu ứng"),placeholder:n.t("Chọn hiệu ứng"),layout:"vertical"},selectProps:{style:{width:"100%"},children:e.jsx(e.Fragment,{children:p.map((n=>e.jsx(h,{label:n.label,children:n.options.map((n=>e.jsx(d,{value:n,children:n[0].toUpperCase()+n.slice(1).split(/(?=[A-Z])/).join(" ")},n)))},n.label)))})}}),I&&e.jsxs(e.Fragment,{children:[e.jsx(i.RangeSliderConfig,{separateDevice:u,propKey:a.PROP_KEY.joinKey(g,a.PROP_KEY.AnimationDuration),formItemProps:{label:n.t("Khoảng thời gian diễn ra hiệu ứng (s)")},sliderProps:{defaultValue:1,min:0,max:5},unitProps:{defaultValue:"s"}}),e.jsx(i.RangeSliderConfig,{separateDevice:u,propKey:a.PROP_KEY.joinKey(g,a.PROP_KEY.AnimationDelay),formItemProps:{label:n.t("Độ trễ xuất hiện hiệu ứng (s)")},sliderProps:{defaultValue:1,min:0,max:5},unitProps:{defaultValue:"s"}}),e.jsx(l.SwitchConfig,{formItemProps:{label:n.t("Lặp lại hiệu ứng")},switchProps:{checked:"infinite"===c,onChange:e=>{f(e?"infinite":void 0)}}})]})]})};


/***/ }),

/***/ 573595:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(112373),r=__webpack_require__(212951),i=__webpack_require__(610314),o=__webpack_require__(891987),a=__webpack_require__(623537),n=__webpack_require__(340530),l=__webpack_require__(78922),s=__webpack_require__(852989),u=__webpack_require__(691171);function c(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=c(r),p=Object.defineProperty,m=Object.defineProperties,f=Object.getOwnPropertyDescriptors,j=Object.getOwnPropertySymbols,h=Object.prototype.hasOwnProperty,y=Object.prototype.propertyIsEnumerable,v=(e,t,r)=>t in e?p(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,x=(e,t)=>{for(var r in t||(t={}))h.call(t,r)&&v(e,r,t[r]);if(j)for(var r of j(t))y.call(t,r)&&v(e,r,t[r]);return e};const b=["wav","mp3"],g=d.default(i.Upload)`
  .ant-upload-select,
  .ant-upload-list-item-container {
    width: 100% !important;
  }

  a {
    color: rgba(0, 0, 0, 0.88);
  }
`,_=d.default(i.Divider)`
  justify-content: center;
  &::before,
  &::after {
    width: 25% !important;
  }
`;exports.AudioUploadConfig=({propKey:r,separateDevice:c})=>{const[d,p]=o.useState(!1),[j,h]=o.useState(!1),[y,v]=o.useState([]),[w,F]=l.usePropSeparateDevice(r,c),[O]=i.Form.useForm();o.useEffect((()=>{v(w?[{url:w,uid:w,name:n.getFileName(w)}]:[])}),[w]);const q=(e,t)=>URL.createObjectURL(e),{uploadFileHandler:S=q}=s.useBuilder(),P={beforeUpload:n.beforeUploadAudio,customRequest:async e=>{const{file:t,onSuccess:r,onError:i}=e;try{p(!0);const e=await S(t,"audio");F(e),r(t)}catch(e){i(e,t)}finally{p(!1)}},listType:w?"picture":"picture-card",maxCount:1,multiple:!1,fileList:y,onRemove:()=>{F("")},accept:b.map((e=>`.${e}`)).join(", ")};return e.jsx(u.FormItem,{layout:"vertical",label:a.t("audio.audio_file"),children:e.jsxs(i.Spin,{spinning:d,children:[e.jsx("div",{style:{position:"relative",width:"100%"},children:e.jsx("div",{style:{position:"relative"},children:e.jsx(g,(U=x({},P),I={children:w?null:e.jsx("div",{style:{width:"100%"},children:d?e.jsx(t.LoadingOutlined,{}):e.jsxs(e.Fragment,{children:[e.jsx(t.UploadOutlined,{}),e.jsx("div",{style:{marginTop:4},children:a.t("audio_config.upload")})]})})},m(U,f(I))))})}),!w&&e.jsxs(e.Fragment,{children:[e.jsx(_,{plain:!0,children:a.t("hoặc")}),e.jsx(i.Form,{form:O,onFinish:async e=>{var t;const{url:r}=e;try{h(!0);const e=await S(r,"audioUrl");if(!(null==(t=new RegExp(`\\.(${b.join("|")})$`,"i"))?void 0:t.test(r)))throw i.notification.error({message:a.t("upload.invalid_file_format")}),Error(a.t("upload.invalid_file_format"));F(e)}catch(e){}finally{O.resetFields(),h(!1)}},children:e.jsx(i.Form.Item,{name:"url",rules:[{required:!0,message:a.t("common.url_can_not_be_empty")},{type:"url",message:a.t("common.invalid_url")},{pattern:/^[a-zA-Z0-9-._~:/?#@!$&'()*+,;=%]*$/,message:a.t("url_not_support_special_characters")}],children:e.jsx(i.Input.Search,{placeholder:a.t("common.use_url"),enterButton:a.t("use"),loading:j,onSearch:()=>O.submit()})})})]})]})});var U,I};


/***/ }),

/***/ 340530:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(623537),i=__webpack_require__(610314);const o=["audio/mpeg","audio/wav"];exports.beforeUploadAudio=t=>o.includes(t.type)?!!(t.size<20971520)||(i.notification.error({message:e.t("audio.upload.file_size_limit")}),!1):(i.notification.error({message:e.t("audio.upload.invalid_file_format")}),!1),exports.getFileName=e=>e.substring(e.lastIndexOf("/")+1);


/***/ }),

/***/ 34271:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(623537),r=__webpack_require__(891987),a=__webpack_require__(920375),i=__webpack_require__(39979),t=__webpack_require__(96179),n=__webpack_require__(78922),u=__webpack_require__(852989),s=__webpack_require__(924216);const c=[{label:"common.color",value:"color"},{label:"common.image",value:"image"}];exports.BackgroundConfig=({title:g=o.t("Nền"),propKey:l,separateDevice:p})=>{const d=t.PROP_KEY.joinKey(l,t.PROP_KEY.BackgroundColor),m=t.PROP_KEY.joinKey(l,t.PROP_KEY.BackgroundImage),[P,v]=r.useState(""),[C,f]=r.useState(void 0),[j,k]=n.usePropSeparateDevice(m,p),[b,B]=n.usePropSeparateDevice(d,p),[K,q]=r.useState(j?"image":"color"),{track:x}=u.useBuilder();return r.useEffect((()=>{"image"===K?(f(b),B(void 0),""!==P&&k(P)):(v(j),k(""),void 0!==C&&B(C))}),[K]),e.jsxs(e.Fragment,{children:[e.jsx(a.RadioConfig,{formItemProps:{label:g},radioGroupProps:{options:o.getOptionsI18n(o.t,c,"label"),value:K,onChange:e=>{q(e.target.value),x({contentName:"color"===e.target.value?"colorBackground":"imageBackground",regionName:"backgroundTab"})},optionType:"button",buttonStyle:"solid"}}),"image"===K?e.jsx(i.BackgroundImageConfig,{propKey:l,separateDevice:p}):e.jsx(s.ColorPickerConfigV3,{propKey:d,gradientPicker:!0,separateDevice:p,formItemProps:{label:o.t("Màu nền")}})]})};


/***/ }),

/***/ 39979:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(623537),o=__webpack_require__(85097),i=__webpack_require__(891987),a=__webpack_require__(185789),t=__webpack_require__(110691),n=__webpack_require__(702571),u=__webpack_require__(525192),p=__webpack_require__(96179),s=__webpack_require__(78922),P=__webpack_require__(281471),c=__webpack_require__(432257),l=__webpack_require__(301930);exports.BackgroundImageConfig=({propKey:g=p.PROP_KEY.CommonStyle,separateDevice:K,allowConfingMarqueeBgImage:y=!1})=>{const m=p.PROP_KEY.joinKey(g,p.PROP_KEY.BackgroundImage),d=p.PROP_KEY.joinKey(g,p.PROP_KEY.BackgroundImageWidth),[f]=s.usePropSeparateDevice(p.PROP_KEY.joinKey(g,p.PROP_KEY.BackgroundImage),K),[j,v]=s.usePropSeparateDevice(p.PROP_KEY.joinKey(g,p.PROP_KEY.BackgroundSize),K),[O,E]=s.usePropSeparateDevice(p.PROP_KEY.joinKey(g,p.PROP_KEY.BackgroundRepeat),K),h=p.PROP_KEY.joinKey(g,p.PROP_KEY.DefaultOverlay),[C]=s.usePropSeparateDevice(p.PROP_KEY.joinKey(g,p.PROP_KEY.BackgroundOverlay),K),[_]=s.usePropSeparateDevice(m,K),[R,Y]=s.usePropSeparateDevice(h,K);return i.useEffect((()=>{j||v("cover"),O||E("no-repeat")}),[]),i.useEffect((()=>{!_&&R&&Y(void 0)}),[_]),e.jsxs(e.Fragment,{children:[e.jsx(P.ImageConfig,{clearValue:null,propKey:m,widthPropKey:d,separateDevice:K,layout:"vertical"}),!!C&&e.jsx(a.OverlayConfig,{separateDevice:K}),f&&e.jsxs(e.Fragment,{children:[e.jsx(t.BackgroundPositionConfig,{propKey:p.PROP_KEY.joinKey(g,p.PROP_KEY.BackgroundPosition),separateDevice:K}),e.jsx(c.InputNumberConfigV2,{propKey:h,separateDevice:K,unitProps:{defaultValue:o.UnitEnum.percent},inputNumberProps:{min:0,max:100,defaultValue:0,style:{width:90}},formItemProps:{label:r.t("Độ mờ lớp phủ nền")},usePropOptions:{formatter:n.percentPropFormatter,parser:u.percentPropParser}}),y&&e.jsx(l.SelectConfig,{separateDevice:K,formItemProps:{label:r.t("Hiệu ứng di chuyển"),layout:"vertical"},selectProps:{placeholder:r.t("Chọn hiệu ứng di chuyển ảnh nền"),style:{width:"100%"}},options:[{label:r.t("Chạy theo chiều ngang"),value:"horizontal"},{label:r.t("Chạy theo chiều dọc"),value:"vertical"}],propKey:p.PROP_KEY.joinKey(g,p.PROP_KEY.BackgroundMarqueeDirection)})]})]})};


/***/ }),

/***/ 110691:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(623537),r=__webpack_require__(610314),a=__webpack_require__(891987),l=__webpack_require__(78922),o=__webpack_require__(691171),i=Object.defineProperty,n=Object.defineProperties,c=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,s=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,b=(e,t,r)=>t in e?i(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r;const y=[{key:"1",label:t.t("Trái trên"),value:"left top"},{key:"2",label:t.t("Giữa trên"),value:"center top"},{key:"3",label:t.t("Phải trên"),value:"right top"},{key:"4",label:t.t("Trái giữa"),value:"left center"},{key:"5",label:t.t("Giữa"),value:"center center"},{key:"6",label:t.t("Phải giữa"),value:"right center"},{key:"7",label:t.t("Trái dưới"),value:"left bottom"},{key:"8",label:t.t("Trái giữa"),value:"center bottom"},{key:"9",label:t.t("Phải dưới"),value:"right bottom"}];exports.BackgroundPositionConfig=i=>{const{formItemProps:v,propKey:d,separateDevice:h}=i,[j,m]=l.usePropSeparateDevice(d,h);return a.useEffect((()=>{j||m("center center")}),[]),e.jsx(o.FormItem,(g=((e,t)=>{for(var r in t||(t={}))s.call(t,r)&&b(e,r,t[r]);if(u)for(var r of u(t))p.call(t,r)&&b(e,r,t[r]);return e})({label:t.t("Vị trí ảnh nền"),layout:"vertical"},v),f={children:e.jsx(r.Radio.Group,{style:{width:"100%"},onChange:e=>{m(e.target.value)},value:j,children:e.jsx(r.Card,{style:{width:"100%"},bodyStyle:{padding:16},children:e.jsx(r.Row,{gutter:[16,16],children:y.map((t=>e.jsx(r.Col,{style:{textAlign:"center"},span:8,children:e.jsx(r.Radio,{value:t.value})},t.key)))})})})},n(g,c(f))));var g,f};


/***/ }),

/***/ 851921:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(623537),o=__webpack_require__(85097),t=__webpack_require__(891987),i=__webpack_require__(993594),a=__webpack_require__(96179),l=__webpack_require__(78922),n=__webpack_require__(432257),u=__webpack_require__(702571),p=__webpack_require__(525192),s=__webpack_require__(301930);exports.BackgroundVideoConfig=({propKey:P=a.PROP_KEY.CommonStyle,separateDevice:c})=>{const d=a.PROP_KEY.joinKey(P,a.PROP_KEY.BackgroundVideo,a.PROP_KEY.Platform),K=a.PROP_KEY.joinKey(P,a.PROP_KEY.BackgroundVideo,a.PROP_KEY.Src),f=a.PROP_KEY.joinKey(P,a.PROP_KEY.BackgroundVideo,a.PROP_KEY.UploadSrc),m=a.PROP_KEY.joinKey(P,a.PROP_KEY.BackgroundVideo,a.PROP_KEY.DefaultOverlay),j=a.PROP_KEY.joinKey(P,a.PROP_KEY.BackgroundVideo,a.PROP_KEY.ObjectFit),[y]=l.usePropSeparateDevice(f,c),[O]=l.usePropSeparateDevice(K,c),[v,g]=l.usePropSeparateDevice(m,c);return t.useEffect((()=>{y||O||!v||g(void 0)}),[y,O]),e.jsxs(e.Fragment,{children:[e.jsx(i.VideoConfig,{youtubeVideoPropKey:K,uploadVideoPropKey:f,platformPropKey:d}),e.jsx("div",{style:{height:"1rem",display:"block"}}),e.jsx(n.InputNumberConfigV2,{propKey:m,separateDevice:c,formItemProps:{label:r.t("Độ mờ lớp phủ nền")},inputNumberProps:{max:100,min:0,defaultValue:0,style:{width:90}},usePropOptions:{formatter:u.percentPropFormatter,parser:p.percentPropParser},unitProps:{defaultValue:o.UnitEnum.percent}}),e.jsx("div",{style:{height:"1rem",display:"block"}}),!!y&&e.jsx(s.SelectConfig,{separateDevice:c,propKey:j,formItemProps:{label:r.t("Object-fit"),layout:"horizontal"},selectProps:{defaultValue:"fill",allowClear:!1},options:[{label:r.t("Cover"),value:"cover"},{label:r.t("Fill"),value:"fill"},{label:r.t("Contain"),value:"contain"},{label:r.t("Scale down"),value:"scale-down"},{label:r.t("Unset"),value:"unset"}]})]})};


/***/ }),

/***/ 322293:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(623537),o=__webpack_require__(112373),t=__webpack_require__(689043),i=__webpack_require__(989279),n=__webpack_require__(123604),s=__webpack_require__(78922),u=__webpack_require__(96179),l=__webpack_require__(691171),c=__webpack_require__(924216);exports.BorderConfig=({propKey:d,separateDevice:p})=>{const[j,a]=s.usePropSeparateDevice(u.PROP_KEY.joinKey(d,u.PROP_KEY.BorderStyle),p),[m,x]=s.usePropSeparateDevice(u.PROP_KEY.joinKey(d,u.PROP_KEY.BorderWidth),p),C=e=>{if(e===j)return a(void 0),void x(void 0);a(e),x(1)};return e.jsxs(e.Fragment,{children:[e.jsx(t.CornerConfigV2,{propKey:d,separateDevice:p}),e.jsx(l.FormItem,{label:r.t("Kiểu viền"),children:e.jsxs(i.ButtonGroup,{children:[e.jsx(n.ButtonGroupItem,{onClick:()=>C("solid"),isActive:"solid"===j,children:e.jsx(o.LineOutlined,{style:{fontSize:18}})}),e.jsx(n.ButtonGroupItem,{onClick:()=>C("dashed"),isActive:"dashed"===j,children:e.jsx(o.DashOutlined,{style:{fontSize:18}})}),e.jsx(n.ButtonGroupItem,{onClick:()=>C("dotted"),isActive:"dotted"===j,children:e.jsx(o.SmallDashOutlined,{style:{fontSize:18}})})]})}),j&&e.jsxs(e.Fragment,{children:[e.jsx(l.FormItem,{label:r.t("Độ rộng (px)"),children:e.jsxs(i.ButtonGroup,{children:[e.jsx(n.ButtonGroupItem,{onClick:()=>x(1),isActive:1===m,children:"1"}),e.jsx(n.ButtonGroupItem,{onClick:()=>x(2),isActive:2===m,children:"2"}),e.jsx(n.ButtonGroupItem,{onClick:()=>x(3),isActive:3===m,children:"3"})]})}),e.jsx(c.ColorPickerConfigV3,{propKey:u.PROP_KEY.joinKey(d,u.PROP_KEY.BorderColor),formItemProps:{label:r.t("Màu viền")},separateDevice:p})]})]})};


/***/ }),

/***/ 989279:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261);function r(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const t=r(__webpack_require__(212951)).default.div`
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  border: 1px solid ${e=>e.theme.colorBorder};
  min-width: 130px;
  justify-content: center;
`;exports.ButtonGroup=({children:r,className:o})=>e.jsx(t,{className:o,children:r});


/***/ }),

/***/ 123604:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(610314);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const o=i(t).default(r.Button)`
  border: none;
  height: 32px;
  min-width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  path,
  rect {
    fill: ${e=>e.theme.colorText};
  }
  border-radius: 0;
  cursor: pointer;
  padding: 6px 8px;
  &.is-active {
    color: ${e=>e.theme.colorPrimary} !important;
    path,
    rect {
      fill: ${e=>e.theme.colorPrimary} !important;
    }
  }
`;exports.ButtonGroupItem=({isActive:t=!1,children:r,onClick:i,className:n})=>e.jsx(o,{type:"text",onClick:i,className:`${t?"is-active":""} ${n}`,children:r});


/***/ }),

/***/ 117480:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(891987),t=__webpack_require__(2723),o=__webpack_require__(691171);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}function i(e){if(e&&e.__esModule)return e;var r=Object.create(null);return e&&Object.keys(e).forEach((function(t){if("default"!==t){var o=Object.getOwnPropertyDescriptor(e,t);Object.defineProperty(r,t,o.get?o:{enumerable:!0,get:function(){return e[t]}})}})),r.default=e,Object.freeze(r)}var c=n(r),u=Object.defineProperty,s=Object.defineProperties,a=Object.getOwnPropertyDescriptors,l=Object.getOwnPropertySymbols,f=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,b=(e,r,t)=>r in e?u(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,d=(e,r)=>{for(var t in r||(r={}))f.call(r,t)&&b(e,t,r[t]);if(l)for(var t of l(r))p.call(r,t)&&b(e,t,r[t]);return e};const m=c.default.lazy((()=>Promise.resolve().then((function(){return i(__webpack_require__(680300))}))));exports.CodeEditorConfig=({propKey:n,formItemProps:u})=>{const[l,f]=t.useProp(n);return r.useEffect((()=>{(async()=>{await Promise.resolve().then((function(){return i(__webpack_require__(717431))})),await Promise.resolve().then((function(){return i(__webpack_require__(936097))}))})()}),[]),e.jsx(c.default.Suspense,{fallback:e.jsx("div",{}),children:e.jsx(o.FormItem,(p=d({},u),b={children:e.jsx(m,{value:l,onChange:e=>f(e),mode:"html",fontSize:14,height:"300px",width:"100%",setOptions:{showLineNumbers:!0,tabSize:2},highlightActiveLine:!0})},s(p,a(b))))});var p,b};


/***/ }),

/***/ 797920:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(623537),o=__webpack_require__(891987),t=__webpack_require__(500613),l=__webpack_require__(78922),a=__webpack_require__(96179),c=__webpack_require__(691171),i=Object.defineProperty,n=Object.defineProperties,s=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,u=Object.prototype.hasOwnProperty,P=Object.prototype.propertyIsEnumerable,d=(e,r,o)=>r in e?i(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,m=(e,r)=>{for(var o in r||(r={}))u.call(r,o)&&d(e,o,r[o]);if(p)for(var o of p(r))P.call(r,o)&&d(e,o,r[o]);return e};exports.ColorPickerConfig=({propKey:i,placeholder:p,formItemProps:u,colorPickerProps:P={},gradientPicker:d=!1,separateDevice:v})=>{var j,b;const[O,f]=l.usePropSeparateDevice(i,v),C=null==(j=null==i?void 0:i.replace)?void 0:j.call(i,a.PROP_KEY.BackgroundColor,a.PROP_KEY.Background),[h,y]=l.usePropSeparateDevice(C,v),[k,g]=o.useState(!1),q=(null==(b=null==i?void 0:i.includes)?void 0:b.call(i,a.PROP_KEY.BackgroundColor))&&(!!h||d);return o.useEffect((()=>{q&&O&&(f(void 0),h||y(O))}),[]),e.jsx(c.FormItem,(w=m({label:r.t("Chọn màu")},u),S={children:e.jsx(t.ColorPickerV2,m({color:q?h:O,onChangeColor:q?y:f,showModal:k,setShowModal:g,placeholder:p||r.t("Chọn màu"),hasGradientColor:d},P))},n(w,s(S))));var w,S};


/***/ }),

/***/ 578211:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(623537),o=__webpack_require__(891987),t=__webpack_require__(535745),l=__webpack_require__(78922),c=__webpack_require__(96179),a=__webpack_require__(691171),i=Object.defineProperty,n=Object.defineProperties,s=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,u=Object.prototype.hasOwnProperty,P=Object.prototype.propertyIsEnumerable,d=(e,r,o)=>r in e?i(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,m=(e,r)=>{for(var o in r||(r={}))u.call(r,o)&&d(e,o,r[o]);if(p)for(var o of p(r))P.call(r,o)&&d(e,o,r[o]);return e};exports.ColorPickerConfigV2=({propKey:i,placeholder:p,formItemProps:u,colorPickerProps:P={},gradientPicker:d=!1,separateDevice:v})=>{var j,b;const[f,O]=l.usePropSeparateDevice(i,v),C=null==(j=null==i?void 0:i.replace)?void 0:j.call(i,c.PROP_KEY.BackgroundColor,c.PROP_KEY.Background),[h,k]=l.usePropSeparateDevice(C,v),[y,g]=o.useState(!1),q=(null==(b=null==i?void 0:i.includes)?void 0:b.call(i,c.PROP_KEY.BackgroundColor))&&(!!h||d);return o.useEffect((()=>{q&&f&&(O(void 0),h||k(f))}),[]),e.jsx(a.FormItem,(w=m({label:r.t("Chọn màu")},u),S={"data-testid":"color-picker-config",children:e.jsx(t.ColorPickerV3,m({color:q?h:f,onChangeColor:q?k:O,showModal:y,setShowModal:g,placeholder:p||r.t("Chọn màu"),hasGradientColor:d},P))},n(w,s(S))));var w,S};


/***/ }),

/***/ 924216:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(623537),o=__webpack_require__(891987),t=__webpack_require__(578211),i=__webpack_require__(276467),l=__webpack_require__(852989),c=__webpack_require__(78922),n=__webpack_require__(96179),a=__webpack_require__(691171),s=Object.defineProperty,u=Object.defineProperties,p=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,P=Object.prototype.hasOwnProperty,C=Object.prototype.propertyIsEnumerable,j=(e,r,o)=>r in e?s(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,v=(e,r)=>{for(var o in r||(r={}))P.call(r,o)&&j(e,o,r[o]);if(d)for(var o of d(r))C.call(r,o)&&j(e,o,r[o]);return e};exports.ColorPickerConfigV3=s=>{var d,P;const{propKey:C,placeholder:j,formItemProps:f,colorPickerProps:m={},gradientPicker:b=!1,separateDevice:g,defaultColor:O}=s,{realDevice:k,editorConfig:y}=l.useBuilder(),h=!!(null==y?void 0:y.enableThemeConfig),[q,x]=c.usePropSeparateDevice(C,g),K=null==(d=null==C?void 0:C.replace)?void 0:d.call(C,n.PROP_KEY.BackgroundColor,n.PROP_KEY.Background),[w,D]=c.usePropSeparateDevice(K,g),[E,S]=o.useState(!1),V=(null==(P=null==C?void 0:C.includes)?void 0:P.call(C,n.PROP_KEY.BackgroundColor))&&(!!w||b);return o.useEffect((()=>{V&&q&&(x(void 0),w||D(q))}),[]),h?e.jsx(a.FormItem,(_=v({label:r.t("Chọn màu")},f),B={"data-testid":"color-picker-config",children:e.jsx(i.ColorPickerV4,v({color:void 0!==O?O:V?w:q,onChangeColor:V?D:x,showModal:E,setShowModal:S,placeholder:j||r.t("Chọn màu"),hasGradientColor:b,propKey:n.PROP_KEY.joinKey(g?k:"",V?K:C)},m))},u(_,p(B)))):e.jsx(t.ColorPickerConfigV2,v({},s));var _,B};


/***/ }),

/***/ 290938:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),i=__webpack_require__(623537),n=__webpack_require__(85097),t=__webpack_require__(212951),r=__webpack_require__(982206),o=__webpack_require__(96179),p=__webpack_require__(78922),u=__webpack_require__(432257),a=__webpack_require__(955448),P=__webpack_require__(87395);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const l=s(t).default.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;exports.SizeAttribute=({propKey:t=o.PROP_KEY.CommonStyle,configs:s={},separateDevice:K})=>{const{allowConfigWidth:c=!0,allowConfigHeight:x=!0,allowConfigMinMax:d=!1}=s,g=o.PROP_KEY.joinKey(t,o.PROP_KEY.WidthUnit),E=o.PROP_KEY.joinKey(t,o.PROP_KEY.HeightUnit),f=o.PROP_KEY.joinKey(t,o.PROP_KEY.MinWidthUnit),m=o.PROP_KEY.joinKey(t,o.PROP_KEY.MaxWidthUnit),h=o.PROP_KEY.joinKey(t,o.PROP_KEY.MinHeightUnit),j=o.PROP_KEY.joinKey(t,o.PROP_KEY.MaxHeightUnit),[y,R]=p.usePropSeparateDevice(g,K),[_=null,O]=p.usePropSeparateDevice(o.PROP_KEY.joinKey(t,o.PROP_KEY.Height),K),[Y,M]=p.usePropSeparateDevice(o.PROP_KEY.joinKey(t,o.PROP_KEY.Width),K);return e.jsxs(e.Fragment,{children:[c&&e.jsxs(e.Fragment,{children:[e.jsx(u.InputNumberConfigV2,{inputNumberProps:{controls:!1,min:0,max:y===n.UnitEnum.percent?100:1e3,style:{width:70}},propKey:o.PROP_KEY.joinKey(t,o.PROP_KEY.Width),unitProps:{propKey:g,defaultValue:n.UnitEnum.pixel,options:[n.UnitEnum.percent,n.UnitEnum.pixel],onChange:e=>{R(e),e===n.UnitEnum.percent&&Y>100&&M(100)}},formItemProps:{label:i.t("common.width")},separateDevice:K}),d&&e.jsxs(l,{children:[e.jsx(r.MinMaxInputConfig,{propKey:o.PROP_KEY.joinKey(t,o.PROP_KEY.MinWidth),separateDevice:K,inputNumberProps:{prefix:"Min",placeholder:"Auto"},unitProps:{propKey:f,defaultValue:n.UnitEnum.pixel}}),e.jsx(r.MinMaxInputConfig,{inputNumberProps:{prefix:"Max",placeholder:"Auto"},propKey:o.PROP_KEY.joinKey(t,o.PROP_KEY.MaxWidth),separateDevice:K,unitProps:{propKey:m,defaultValue:n.UnitEnum.pixel}})]})]}),x&&e.jsxs(e.Fragment,{children:[e.jsx(a.SwitchConfig,{formItemProps:{label:i.t("Chiều cao tự động")},switchProps:{checked:null===_,onChange:e=>{O(e?null:350)}}}),null!=_&&e.jsxs(e.Fragment,{children:[e.jsx(P.RangeSliderConfig,{sliderProps:{min:1,max:1e3},propKey:o.PROP_KEY.joinKey(t,o.PROP_KEY.Height),unitProps:{propKey:E,defaultValue:n.UnitEnum.pixel},separateDevice:K}),d&&e.jsxs(l,{children:[e.jsx(r.MinMaxInputConfig,{inputNumberProps:{prefix:"Min",placeholder:"Auto"},propKey:o.PROP_KEY.joinKey(t,o.PROP_KEY.MinHeight),separateDevice:K,unitProps:{propKey:h,defaultValue:n.UnitEnum.pixel}}),e.jsx(r.MinMaxInputConfig,{inputNumberProps:{prefix:"Max",placeholder:"Auto"},propKey:o.PROP_KEY.joinKey(t,o.PROP_KEY.MaxHeight),separateDevice:K,unitProps:{propKey:j,defaultValue:n.UnitEnum.pixel}})]})]})]})]})};


/***/ }),

/***/ 712405:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(623537),r=__webpack_require__(212951),i=__webpack_require__(959211),t=__webpack_require__(85097),n=__webpack_require__(610314),a=__webpack_require__(78922),P=__webpack_require__(96179),u=__webpack_require__(691171),p=__webpack_require__(87395);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const d=["common","detail"],l=100,R=s(r).default.div`
  padding: 0px 8px 8px 8px;
  .ant-row {
    width: 83% !important;
  }
`;exports.CornerConfig=({propKey:r,separateDevice:s})=>{const[K,m]=a.usePropSeparateDevice(P.PROP_KEY.joinKey(r,P.PROP_KEY.CornerType),s),[E,c]=a.usePropSeparateDevice(P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderTopLeftRadius),s),[y,O]=a.usePropSeparateDevice(P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderTopRightRadius),s),[_,Y]=a.usePropSeparateDevice(P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderBottomLeftRadius),s),[j,f]=a.usePropSeparateDevice(P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderBottomRightRadius),s),[g]=a.usePropSeparateDevice(P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderRadius),s),[,B]=a.usePropSeparateDevice(P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderRadiusUnit),s),[,x]=a.usePropSeparateDevice(P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderTopRightRadiusUnit),s),[,h]=a.usePropSeparateDevice(P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderTopLeftRadiusUnit),s),[,U]=a.usePropSeparateDevice(P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderBottomLeftRadiusUnit),s),[,S]=a.usePropSeparateDevice(P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderBottomRightRadiusUnit),s),v=o=>{switch(o){case"common":return e.jsx(i.BorderOutsideRegular,{fontSize:16});case"detail":return e.jsx(i.BorderTopBottomRegular,{fontSize:16})}},C=(e,o)=>{o(e)};return e.jsxs(e.Fragment,{children:[e.jsx(u.FormItem,{label:o.t("Bo góc"),layout:"horizontal",children:e.jsx(n.Radio.Group,{value:K,optionType:"button",buttonStyle:"solid",defaultValue:K||"common",children:d.map(((o,r)=>e.jsx(n.Radio,{onClick:()=>(e=>{"detail"!==e||E||y||_||j||(c(g),O(g),Y(g),f(g)),m(e)})(o),value:o,children:v(o)},r)))})}),"detail"===K?e.jsxs(R,{children:[e.jsx(p.RangeSliderConfig,{propKey:P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderTopLeftRadius),formItemProps:{label:o.t("Trái trên"),layout:"horizontal"},sliderProps:{min:0,max:l,defaultValue:0},unitProps:{defaultValue:t.UnitEnum.percent,propKey:P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderTopLeftRadiusUnit),options:[t.UnitEnum.percent,t.UnitEnum.pixel],onChange:e=>C(e,h)}}),e.jsx(p.RangeSliderConfig,{propKey:P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderTopRightRadius),formItemProps:{label:o.t("Phải trên"),layout:"horizontal"},sliderProps:{min:0,max:l,defaultValue:0},unitProps:{defaultValue:t.UnitEnum.percent,propKey:P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderTopRightRadiusUnit),options:[t.UnitEnum.percent,t.UnitEnum.pixel],onChange:e=>C(e,x)}}),e.jsx(p.RangeSliderConfig,{propKey:P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderBottomLeftRadius),formItemProps:{label:o.t("Trái dưới"),layout:"horizontal"},sliderProps:{min:0,max:l,defaultValue:0},unitProps:{defaultValue:t.UnitEnum.percent,propKey:P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderBottomLeftRadiusUnit),options:[t.UnitEnum.percent,t.UnitEnum.pixel],onChange:e=>C(e,U)}}),e.jsx(p.RangeSliderConfig,{propKey:P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderBottomRightRadius),formItemProps:{label:o.t("Phải dưới"),layout:"horizontal"},sliderProps:{min:0,max:l,defaultValue:0},unitProps:{defaultValue:t.UnitEnum.percent,propKey:P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderBottomRightRadiusUnit),options:[t.UnitEnum.percent,t.UnitEnum.pixel],onChange:e=>C(e,S)}})]}):e.jsx(p.RangeSliderConfig,{propKey:P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderRadius),sliderProps:{min:0,max:l,defaultValue:0},unitProps:{defaultValue:t.UnitEnum.percent,propKey:P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderRadiusUnit),options:[t.UnitEnum.percent,t.UnitEnum.pixel],onChange:e=>C(e,B)}})]})};


/***/ }),

/***/ 689043:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),i=__webpack_require__(623537),r=__webpack_require__(212951),t=__webpack_require__(959211),n=__webpack_require__(85097),o=__webpack_require__(610314),a=__webpack_require__(143599),p=__webpack_require__(78922),u=__webpack_require__(96179),s=__webpack_require__(691171),d=__webpack_require__(87395),P=__webpack_require__(432257);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var m=l(r);const R=["common","detail"],K=m.default.div`
  padding: 0px 8px 8px 8px;
  display: grid;
  grid-template-columns: repeat(2, calc((100% - 8px) / 2));
  gap: 8px;
  .ant-row {
    width: 100% !important;
  }
  .ant-input-number {
    background-color: #f5f5f5;
  }
  .ant-input-number-affix-wrapper {
    border: none !important;
  }
  .ant-input-number-handler-wrap {
    display: none !important;
  }
`,c=m.default(a.Icon)`
  font-size: 12px;
  margin-right: 6px;
`,x=m.default(P.InputNumberConfigV2)`
  background-color: #f5f5f5;
  width: 100%;
`;exports.CornerConfigV2=({propKey:r,separateDevice:a})=>{const[P,l]=p.usePropSeparateDevice(u.PROP_KEY.joinKey(r,u.PROP_KEY.CornerType),a),[m,E]=p.usePropSeparateDevice(u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderTopLeftRadius),a),[f,j]=p.usePropSeparateDevice(u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderTopRightRadius),a),[O,y]=p.usePropSeparateDevice(u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderBottomLeftRadius),a),[_,Y]=p.usePropSeparateDevice(u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderBottomRightRadius),a),[g]=p.usePropSeparateDevice(u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderRadius),a),[U,B]=p.usePropSeparateDevice(u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderRadiusUnit),a),[v,h]=p.usePropSeparateDevice(u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderTopRightRadiusUnit),a),[b,D]=p.usePropSeparateDevice(u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderTopLeftRadiusUnit),a),[S,q]=p.usePropSeparateDevice(u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderBottomLeftRadiusUnit),a),[C,V]=p.usePropSeparateDevice(u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderBottomRightRadiusUnit),a),T=i=>{switch(i){case"common":return e.jsx(t.BorderOutsideRegular,{fontSize:16});case"detail":return e.jsx(t.BorderTopBottomRegular,{fontSize:16})}};return e.jsxs(e.Fragment,{children:[e.jsx(s.FormItem,{label:i.t("Bo góc"),layout:"horizontal",children:e.jsx(o.Radio.Group,{value:P,optionType:"button",buttonStyle:"solid",defaultValue:P||"common",children:R.map(((i,r)=>e.jsx(o.Radio,{onClick:()=>(e=>{"detail"!==e||m||f||O||_||(E(g),j(g),y(g),Y(g)),(b!==n.UnitEnum.pixel||v!==n.UnitEnum.pixel&&S!==n.UnitEnum.pixel||C!==n.UnitEnum.pixel)&&(D(n.UnitEnum.pixel),h(n.UnitEnum.pixel),q(n.UnitEnum.pixel),V(n.UnitEnum.pixel)),l(e)})(i),value:i,children:T(i)},r)))})}),"detail"===P?e.jsxs(K,{children:[e.jsx(x,{propKey:u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderTopLeftRadius),inputNumberProps:{prefix:e.jsx(c,{name:"RadiusUpLeftOutlined"}),min:0,max:999},unitProps:{defaultValue:n.UnitEnum.pixel},displayUnit:!1,separateDevice:a}),e.jsx(x,{propKey:u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderTopRightRadius),inputNumberProps:{prefix:e.jsx(c,{name:"RadiusUpRightOutlined"}),min:0,max:999},unitProps:{defaultValue:n.UnitEnum.pixel},displayUnit:!1,separateDevice:a}),e.jsx(x,{propKey:u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderBottomLeftRadius),inputNumberProps:{prefix:e.jsx(c,{name:"RadiusBottomLeftOutlined"}),min:0,max:999},unitProps:{defaultValue:n.UnitEnum.pixel},displayUnit:!1,separateDevice:a}),e.jsx(x,{propKey:u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderBottomRightRadius),inputNumberProps:{prefix:e.jsx(c,{name:"RadiusBottomRightOutlined"}),min:0,max:999},unitProps:{defaultValue:n.UnitEnum.pixel},displayUnit:!1,separateDevice:a})]}):e.jsx(d.RangeSliderConfig,{propKey:u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderRadius),sliderProps:{min:0,max:999,defaultValue:0},unitProps:{defaultValue:n.UnitEnum.pixel,propKey:u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderRadiusUnit),options:U===n.UnitEnum.percent?[n.UnitEnum.percent,n.UnitEnum.pixel]:[n.UnitEnum.pixel],onChange:e=>B(e)},separateDevice:a})]})};


/***/ }),

/***/ 75272:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(610314),o=__webpack_require__(78922),i=__webpack_require__(691171);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var n=a(r),l=Object.defineProperty,p=Object.defineProperties,u=Object.getOwnPropertyDescriptors,s=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,d=Object.prototype.propertyIsEnumerable,m=(e,r,t)=>r in e?l(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;const b=n.default(t.Radio)`
  span {
    vertical-align: middle;
  }
`;exports.CustomRadioButtonConfig=r=>{const{propKey:a,options:n,formItemProps:l,separateDevice:v,allowClear:f}=r,[j,y]=o.usePropSeparateDevice(a,v);return e.jsx(i.FormItem,(O=((e,r)=>{for(var t in r||(r={}))c.call(r,t)&&m(e,t,r[t]);if(s)for(var t of s(r))d.call(r,t)&&m(e,t,r[t]);return e})({},l),P={children:e.jsx(t.Radio.Group,{value:j,optionType:"button",buttonStyle:"solid",children:null==n?void 0:n.map((({value:r,label:t},o)=>e.jsx(b,{onClick:()=>(e=>{y(e===j&&f?void 0:e)})(r),value:r,children:t},o)))})},p(O,u(P))));var O,P};


/***/ }),

/***/ 297476:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(610314),l=__webpack_require__(78922),o=__webpack_require__(691171);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const i=n(t).default(r.Button)((({type:e})=>`\n    height: unset;\n    margin-bottom: 0.5em;\n    padding-top: 1em;\n    padding-bottom: 1em;\n  \n    ${"default"===e?"color: #82868B;":""}\n  `));exports.CustomRadioConfig=({propKey:t,seperateDevice:n,formItemProps:a,options:u,defaultValue:s,handleAfterSelect:d})=>{const[c=s,p]=l.usePropSeparateDevice(t,n);return e.jsx(o.FormItem,{layout:"vertical",label:null==a?void 0:a.label,children:e.jsx(r.Row,{gutter:16,children:u.map(((t,l)=>e.jsxs(r.Col,{span:Math.round(24/u.length),children:[e.jsx(i,{block:!0,type:c===t.value?"primary":"default",onClick:()=>{p(t.value),null==d||d(t.value)},children:t.children}),!!(null==t?void 0:t.label)&&e.jsx("div",{style:{textAlign:"center"},children:null==t?void 0:t.label})]},l)))})})};


/***/ }),

/***/ 515676:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(772139),t=__webpack_require__(610314),o=__webpack_require__(2723),a=__webpack_require__(691171);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=n(r),s=Object.defineProperty,p=Object.defineProperties,u=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,l=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,j=(e,r,t)=>r in e?s(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,m=(e,r)=>{for(var t in r||(r={}))l.call(r,t)&&j(e,t,r[t]);if(c)for(var t of c(r))f.call(r,t)&&j(e,t,r[t]);return e};exports.DatePickerConfig=({propKey:r,dateTimePickerProps:n,formItemProps:s})=>{const[c,l]=o.useProp(r);return e.jsx(a.FormItem,(f=m({},s),j={children:e.jsx(t.DatePicker,m({allowClear:!1,value:i.default(c),onChange:e=>{l(e.toISOString())}},n))},p(f,u(j))));var f,j};


/***/ }),

/***/ 610168:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(959211),o=__webpack_require__(610314),i=__webpack_require__(78922),n=__webpack_require__(691171);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=a(r),s=Object.defineProperty,c=Object.defineProperties,u=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,b=(e,r,t)=>r in e?s(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;const j=l.default(o.Radio)`
  span {
    vertical-align: middle;
  }
`;exports.DirectionConfig=r=>{const{propKey:a,buttonGroupProps:l,formItemProps:s,separateDevice:m,allowClear:v=!1}=r,{listDirections:y=["vertical","horizontal"]}=l||{},[O,P]=i.usePropSeparateDevice(a,m),h=r=>{switch(r){case"horizontal":return e.jsx(t.CenterVerticalFilled,{fontSize:16});case"vertical":return e.jsx(t.CenterHorizontalFilled,{fontSize:16})}};return e.jsx(n.FormItem,(x=((e,r)=>{for(var t in r||(r={}))d.call(r,t)&&b(e,t,r[t]);if(p)for(var t of p(r))f.call(r,t)&&b(e,t,r[t]);return e})({},s),q={children:e.jsx(o.Radio.Group,{value:O,optionType:"button",buttonStyle:"solid",children:y.map(((r,t)=>e.jsx(j,{onClick:()=>(e=>{P(e===O&&v?void 0:e)})(r),value:r,children:h(r)},t)))})},c(x,u(q))));var x,q};


/***/ }),

/***/ 635416:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(112373),r=__webpack_require__(212951),i=__webpack_require__(610314),o=__webpack_require__(891987),n=__webpack_require__(623537),a=__webpack_require__(85097),l=__webpack_require__(705930),s=__webpack_require__(78922),c=__webpack_require__(852989),u=__webpack_require__(691171);function d(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var p=d(r),m=Object.defineProperty,f=Object.defineProperties,j=Object.getOwnPropertyDescriptors,h=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,v=Object.prototype.propertyIsEnumerable,_=(e,t,r)=>t in e?m(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,b=(e,t)=>{for(var r in t||(t={}))y.call(t,r)&&_(e,r,t[r]);if(h)for(var r of h(t))v.call(t,r)&&_(e,r,t[r]);return e};const x=p.default(i.Upload)`
  .ant-upload-select,
  .ant-upload-list-item-container {
    width: 100% !important;
  }

  a {
    color: rgba(0, 0, 0, 0.88);
  }
`,g=p.default(i.Divider)`
  justify-content: center;
  &::before,
  &::after {
    width: 25% !important;
  }
`;exports.DocumentConfig=({propKey:r,separateDevice:d,layout:p="vertical",placeholder:m=n.t("document_viewer.upload_file"),acceptTypes:h=Object.values(a.DOCUMENT_TYPE)})=>{const[y,v]=o.useState([]),[_,O]=o.useState(!1),[w,F]=o.useState(!1),[q,P]=s.usePropSeparateDevice(r,d),[E]=i.Form.useForm();o.useEffect((()=>{v(q?[{url:q,uid:q,name:l.getFileName(q)}]:[])}),[q]);const S=(e,t)=>URL.createObjectURL(e),{uploadFileHandler:I=S}=c.useBuilder(),D={beforeUpload:l.beforeUploadDocument(h),customRequest:async e=>{const{file:t,onSuccess:r,onError:i}=e;try{O(!0);const e=await I(t,"doc");P(e),r(t)}catch(e){i(e,t)}finally{O(!1)}},listType:q?"picture":"picture-card",maxCount:1,multiple:!1,fileList:y,onRemove:()=>{P("")},accept:Object.keys(a.MAPPING_EXTENSION_MIME_TYPE).filter((e=>!h||(null==h?void 0:h.includes(e)))).map((e=>`.${e}`)).join(", ")};return e.jsx(e.Fragment,{children:e.jsx(u.FormItem,{layout:p,label:n.t("document_viewer.file"),children:e.jsxs(i.Spin,{spinning:_,children:[e.jsx("div",{style:{position:"relative",width:"vertical"===p?"100%":"auto"},children:e.jsx("div",{style:{position:"relative"},children:e.jsx(x,(U=b({},D),T={children:q?null:e.jsx("div",{style:{width:"100%"},children:_?e.jsx(t.LoadingOutlined,{}):e.jsxs(e.Fragment,{children:[e.jsx(t.UploadOutlined,{}),e.jsx("div",{style:{marginTop:4},children:m})]})})},f(U,j(T))))})}),!q&&e.jsxs(e.Fragment,{children:[e.jsx(g,{plain:!0,children:n.t("hoặc")}),e.jsx(i.Form,{form:E,onFinish:async e=>{var t;const{url:r}=e;try{F(!0);const e=await I(r,"docUrl");if(!(null==(t=new RegExp(`\\.(${h.join("|")})$`,"i"))?void 0:t.test(r)))throw i.notification.error({message:n.t("upload.invalid_file_format")}),Error(n.t("upload.invalid_file_format"));P(e)}catch(e){}finally{E.resetFields(),F(!1)}},children:e.jsx(i.Form.Item,{name:"url",rules:[{required:!0,message:n.t("common.url_can_not_be_empty")},{type:"url",message:n.t("common.invalid_url")},{pattern:/^[a-zA-Z0-9-._~:/?#@!$&'()*+,;=%]*$/,message:n.t("url_not_support_special_characters")}],children:e.jsx(i.Input.Search,{placeholder:n.t("common.use_url"),enterButton:n.t("use"),loading:w,onSearch:()=>E.submit()})})})]})]})})});var U,T};


/***/ }),

/***/ 705930:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(610314),r=__webpack_require__(623537),i=__webpack_require__(85097);exports.beforeUploadDocument=t=>o=>{var n;return(null==t?void 0:t.map((e=>i.MAPPING_EXTENSION_MIME_TYPE[e]))).includes(o.type)?!!(o.size<20971520)||(e.notification.error({message:r.t("upload.file_size_limit")}),!1):(e.notification.error({message:`${r.t("document_viewer.file_format_restriction")} ${null==(n=null==t?void 0:t.map((e=>null==e?void 0:e.toUpperCase())))?void 0:n.join(", ")}!`}),!1)},exports.getFileName=e=>e.substring(e.lastIndexOf("/")+1);


/***/ }),

/***/ 641962:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(891987),n=__webpack_require__(610314),r=__webpack_require__(212951),o=__webpack_require__(959211),a=__webpack_require__(610796),l=__webpack_require__(85097);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=i(r),c=Object.defineProperty,u=Object.defineProperties,d=Object.getOwnPropertyDescriptors,m=Object.getOwnPropertySymbols,f=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,y=(e,t,n)=>t in e?c(e,t,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[t]=n;const b=s.default(n.Modal)("  \n  .ant-modal-header {\n    cursor: grab;\n    user-select: none;\n  }\n\n  .ant-modal-header:active {\n    cursor: grabbing;\n  }\n");exports.DraggableModal=n=>{var r=n,{width:i=500,children:s,footer:c,setModalPosition:v,modalPosition:p={x:0,y:0},title:x="Draggable Modal",offset:h={x:4,y:4},onCancel:C,onClickOutside:O}=r,M=((e,t)=>{var n={};for(var r in e)f.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&m)for(var r of m(e))t.indexOf(r)<0&&g.call(e,r)&&(n[r]=e[r]);return n})(r,["width","children","footer","setModalPosition","modalPosition","title","offset","onCancel","onClickOutside"]);const{document:k,window:E}=a.useFrame(),j=t.useRef(null),[w,P]=t.useState({x:0,y:0}),[D,R]=t.useState(!1),q=t.useRef(null),L=t.useCallback((e=>{if(!e.target.closest(".ant-modal-header"))return;e.preventDefault(),e.stopPropagation();const t=j.current;if(!t)return;const n=t.getBoundingClientRect();P({x:e.clientX-n.left,y:e.clientY-n.top}),R(!0)}),[]),S=t.useCallback((e=>{const t=j.current;D&&t&&(e.preventDefault(),e.stopPropagation(),requestAnimationFrame((()=>{const n=t.getBoundingClientRect(),r=e.clientX-w.x,o=e.clientY-w.y,a=E.innerWidth-n.width,l=E.innerHeight-n.height;v((e=>{const t=Math.max(0,Math.min(r,a-h.x)),n=Math.max(0,Math.min(o,l-h.y));return e.x===t&&e.y===n?e:{x:t,y:n}}))})))}),[D,w.x,w.y,E.innerWidth,E.innerHeight,v,h.x,h.y]),I=t.useCallback((()=>{R(!1)}),[]),B=t.useCallback((e=>{if(D)return;const t=j.current;t&&!t.contains(e.target)&&O&&O(e)}),[D,O]);t.useEffect((()=>{var e;const t=null==(e=null==document?void 0:document.getElementById(l.TEMPI_MAIN_IFRAME))?void 0:e.contentDocument;return null==t||t.addEventListener("click",B),null==document||document.addEventListener("click",B),()=>{null==t||t.removeEventListener("click",B),null==document||document.removeEventListener("click",B)}}),[B]),t.useEffect((()=>{if(D)return k.addEventListener("mousemove",S),k.addEventListener("mouseup",I),k.body.style.userSelect="none",k.body.style.cursor="grabbing",()=>{k.removeEventListener("mousemove",S),k.removeEventListener("mouseup",I),k.body.style.userSelect="",k.body.style.cursor=""}}),[D,k,S,I]);const _={top:p.y,left:p.x,paddingBottom:0,margin:0},z=e.jsxs("div",{ref:q,onMouseDown:L,className:"cursor-grab active:cursor-grabbing select-none flex items-center",style:{padding:"0",margin:"0",userSelect:"none"},children:[e.jsx(o.ReOrderDotsVerticalRegular,{style:{transform:"rotate(90deg)",marginRight:4},fontSize:24}),x]});return e.jsx(b,(A=((e,t)=>{for(var n in t||(t={}))f.call(t,n)&&y(e,n,t[n]);if(m)for(var n of m(t))g.call(t,n)&&y(e,n,t[n]);return e})({zIndex:1080,onCancel:C,title:z,style:_,width:i,centered:!1,mask:!0,maskClosable:!0,destroyOnClose:!0,maskStyle:{backgroundColor:"transparent",zIndex:-1},modalRender:t=>e.jsx("div",{ref:j,onMouseDown:L,style:{cursor:"default"},children:t}),getContainer:()=>k.body,footer:c},M),u(A,d({wrapClassName:D?"":"draggable-modal",children:s}))));var A};


/***/ }),

/***/ 909602:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),i=__webpack_require__(623537),r=__webpack_require__(610314),t=__webpack_require__(904039),n=__webpack_require__(151033),o=__webpack_require__(96179);const{Panel:s}=r.Collapse;exports.EffectAttributes=({propKey:a=o.PROP_KEY.CommonStyle,separateDevice:c=!1})=>e.jsxs(r.Collapse,{defaultActiveKey:"AnimationEffect",expandIconPosition:"end",bordered:!1,children:[e.jsx(s,{header:i.t("Hiệu ứng khi cuộn tới"),children:e.jsx(t.AnimationConfig,{propKey:a,separateDevice:c})},"AnimationEffect"),e.jsx(s,{header:i.t("Hiệu ứng khi trỏ chuột"),children:e.jsx(n.HoverConfig,{propKey:a,separateDevice:c})},"HoverEffect")]});


/***/ }),

/***/ 766933:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(623537),o=__webpack_require__(891987),i=__webpack_require__(610314),n=__webpack_require__(85097),r=__webpack_require__(610796),s=__webpack_require__(981982),a=__webpack_require__(397155),l=__webpack_require__(373409),p=__webpack_require__(8474),c=__webpack_require__(799194),P=__webpack_require__(955448),u=__webpack_require__(852989),m=__webpack_require__(96179),g=__webpack_require__(78922),y=__webpack_require__(458460),f=__webpack_require__(301930),K=__webpack_require__(781883),d=__webpack_require__(505765),h=Object.defineProperty,E=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,O=Object.prototype.propertyIsEnumerable,j=(e,t,o)=>t in e?h(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o,v=(e,t)=>{for(var o in t||(t={}))b.call(t,o)&&j(e,o,t[o]);if(E)for(var o of E(t))O.call(t,o)&&j(e,o,t[o]);return e};const _=({propKey:i,separateDevice:r,listOptions:a,label:l,selectProps:h})=>{const{featureFlags:E}=n.useStore(),b=null==E?void 0:E.flagPB6119,{popupListSelection:O}=p.usePopupList(),{pageListInWebsiteSelection:j}=u.useBuilder(),[_,C]=o.useState(""),R=m.PROP_KEY.joinKey(i,m.PROP_KEY.Event,m.PROP_KEY.EventType),Y=m.PROP_KEY.joinKey(i,m.PROP_KEY.Event,m.PROP_KEY.Link),x=m.PROP_KEY.joinKey(i,m.PROP_KEY.Event,m.PROP_KEY.Email),I=m.PROP_KEY.joinKey(i,m.PROP_KEY.Event,m.PROP_KEY.Phone),w=m.PROP_KEY.joinKey(i,m.PROP_KEY.Event,m.PROP_KEY.InPage),S=m.PROP_KEY.joinKey(i,m.PROP_KEY.Event,m.PROP_KEY.TogglePopup),T=m.PROP_KEY.joinKey(i,m.PROP_KEY.Event,m.PROP_KEY.TogglePopupList),k=m.PROP_KEY.joinKey(i,m.PROP_KEY.Event,m.PROP_KEY.OpenPageOfWebsite),D=m.PROP_KEY.joinKey(i,m.PROP_KEY.Event,m.PROP_KEY.OpenArticleOfWebsite),q=m.PROP_KEY.joinKey(i,m.PROP_KEY.Event,m.PROP_KEY.CopyToClipboard),[N,B]=g.usePropSeparateDevice(R,r),[M]=g.usePropSeparateDevice(I,r),[L]=g.usePropSeparateDevice(x,r),[A,W]=g.usePropSeparateDevice(m.PROP_KEY.joinKey(i,m.PROP_KEY.Event,m.PROP_KEY.CopyToClipboard),r),{nodes:F}=y.useEditor((e=>({nodes:e.nodes}))),z=o.useMemo((()=>[...new Set(Object.keys(F).map((e=>F[e].data.props.id)))].filter((e=>e)).map((e=>({label:e,value:e})))),[N]);return o.useEffect((()=>{var e,o;"phone"===N&&(e=M)&&(n.PATTERN_VALIDATION.phone.test(e)?C(""):C(t.t("Số điện thoại chưa đúng định dạng"))),"email"===N&&(o=L)&&(n.PATTERN_VALIDATION.email.test(o)?C(""):C(t.t("Nhập email định dạng abc@gmai.com")))}),[N,M,L]),o.useEffect((()=>{"copyToClipboard"===N&&W(v({textCopy:t.t("text_to_copy"),notificationMessage:t.t("notification_message")},A))}),[N]),e.jsxs(e.Fragment,{children:[e.jsx(f.SelectConfig,v({options:(()=>{const e=[{label:t.t("Mở liên kết"),value:"link"},...b?[{label:t.t("open_article_in_website"),value:"openArticleOfWebsite"}]:[],{label:t.t("Cuộn trong trang"),value:"inPage"},{label:"Email",value:"email"},{label:t.t("Số điện thoại"),value:"phone"},{label:t.t("Mở popup"),value:"openPopup"},{label:t.t("Đóng popup"),value:"closePopupList"},{label:t.t("copy_to_clipboard"),value:"copyToClipboard"}];return(null==j?void 0:j.length)&&e.unshift({label:t.t("Mở trang trong website"),value:"openPageOfWebsite"}),a?e.filter((({value:e})=>a.includes(e))):e})(),formItemProps:{label:l||t.t("Loại sự kiện"),style:{marginBottom:"0.5rem"}},selectProps:{listHeight:350,placeholder:t.t("Chọn sự kiện"),style:{width:"100%"},onChange:e=>{B(e),C("")},value:N}},h)),(o=>{switch(o){case"link":return e.jsxs(e.Fragment,{children:[e.jsx(K.InputConfig,{separateDevice:r,formItemProps:{label:t.t("Nhập URL"),style:{marginBottom:"0.5rem"}},inputProps:{placeholder:t.t("Nhập URL"),style:{width:"100%"}},propKey:Y+".href"}),e.jsx(P.SwitchConfig,{separateDevice:r,formItemProps:{label:t.t("Mở trong thẻ mới"),layout:"horizontal",style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"0.5rem"}},propKey:Y+".openNewTab"}),e.jsx(P.SwitchConfig,{separateDevice:r,formItemProps:{label:t.t("Liên kết nofollow"),layout:"horizontal",style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"0.5rem"}},propKey:Y+".nofollow"})]});case"inPage":return e.jsxs(e.Fragment,{children:[e.jsx(f.SelectConfig,v({separateDevice:r,formItemProps:{label:t.t("Phần tử"),style:{marginBottom:"0.5rem"}},selectProps:{placeholder:t.t("Mặc định"),style:{width:"100%"},popupMatchSelectWidth:!1},options:z,propKey:w},h)),e.jsx(d.InputNumberConfig,{separateDevice:r,propKey:m.PROP_KEY.joinKey(m.PROP_KEY.Event,m.PROP_KEY.SectionMarginTop),formItemProps:{label:"Section margin-top",style:{marginBottom:"0.5rem"}},unitProps:{defaultValue:n.UnitEnum.pixel},inputNumberProps:{style:{width:"100%"}}})]});case"email":return e.jsx(K.InputConfig,{separateDevice:r,formItemProps:{label:"Email",warning:_,layout:"vertical",style:{marginBottom:"0.5rem"}},inputProps:{style:{width:"100%"},placeholder:t.t("Nhập email")},propKey:x});case"phone":return e.jsx(K.InputConfig,{separateDevice:r,formItemProps:{label:t.t("Số điện thoại"),warning:_,layout:"vertical",style:{marginBottom:"0.5rem"}},inputProps:{placeholder:t.t("Nhập số điện thoại có 10 chữ số"),style:{width:"100%"}},propKey:I});case"openPopup":return e.jsx(s.SelectPopupConfig,{separateDevice:r,label:t.t("Mở popup"),options:O,propKey:S});case"closePopupList":return e.jsx(s.SelectPopupConfig,{separateDevice:r,label:t.t("Đóng popup"),options:O,propKey:T});case"openPageOfWebsite":return e.jsxs(e.Fragment,{children:[e.jsx(f.SelectConfig,v({separateDevice:r,formItemProps:{style:{marginBottom:"0.5rem"}},selectProps:{placeholder:t.t("Mặc định"),style:{width:"100%"},popupMatchSelectWidth:!1,fieldNames:{value:"id"}},options:j,propKey:m.PROP_KEY.joinKey(k,m.PROP_KEY.PageId)},h)),e.jsx(P.SwitchConfig,{separateDevice:r,formItemProps:{label:t.t("Mở trong thẻ mới"),layout:"horizontal",style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"0.5rem"}},propKey:m.PROP_KEY.joinKey(k,m.PROP_KEY.OpenNewTab)})]});case"openArticleOfWebsite":return e.jsxs(e.Fragment,{children:[e.jsx(c.SelectArticleWebsite,{propKey:i}),e.jsx(P.SwitchConfig,{separateDevice:r,formItemProps:{label:t.t("Mở trong thẻ mới"),layout:"horizontal",style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"0.5rem"}},propKey:m.PROP_KEY.joinKey(D,m.PROP_KEY.OpenNewTab)})]});case"copyToClipboard":return e.jsxs(e.Fragment,{children:[e.jsx(K.InputConfig,{separateDevice:r,formItemProps:{label:t.t("text_to_copy"),warning:_,layout:"vertical",style:{marginBottom:"0.5rem"}},inputProps:{style:{width:"100%"},placeholder:t.t("text_to_copy")},propKey:m.PROP_KEY.joinKey(q,m.PROP_KEY.TextCopy)}),e.jsx(K.InputConfig,{separateDevice:r,formItemProps:{label:t.t("notification_message"),warning:_,layout:"vertical",style:{marginBottom:"0.5rem"}},inputProps:{style:{width:"100%"},placeholder:t.t("notification_message")},propKey:m.PROP_KEY.joinKey(q,m.PROP_KEY.NotificationMessage)})]})}})(N)]})};exports.EventClickConfig=_,exports.EventConfig=({propKey:n,visible:s,setVisible:p,separateDevice:c,listOptions:P,zIndex:g=1080,selectProps:y})=>{const{relatedNodeId:f,enableTekoTracking:K}=u.useBuilder(),{document:d}=r.useFrame();o.useEffect((()=>{(null==f?void 0:f.popupId)&&p(!0)}),[]);const h=()=>{p(!1)};return e.jsx(i.Modal,{closable:!1,zIndex:g,open:s,onCancel:h,title:t.t("Cài đặt sự kiện nhấp chuột"),destroyOnClose:!0,width:450,footer:[e.jsx(i.Button,{type:"primary",shape:"round",onClick:h,children:t.t("Đóng")})],getContainer:()=>(null==d?void 0:d.body)||(null==document?void 0:document.body),children:e.jsx(i.Tabs,{items:[{label:t.t("Sự kiện"),key:"1",children:e.jsx(_,{propKey:n,separateDevice:c,listOptions:P,selectProps:y})},{label:t.t("Chuyển đổi (Tracking)"),key:"2",children:e.jsx(a.TrackingConfig,{separateDevice:c,config:"event",propKey:m.PROP_KEY.joinKey(n,m.PROP_KEY.Event)})},K&&{label:"Teko tracking",key:"3",children:e.jsx(l.TekoTrackingConfig,{propKey:m.PROP_KEY.joinKey(n,m.PROP_KEY.Event)})}]})})};


/***/ }),

/***/ 981982:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(623537),t=__webpack_require__(610314),o=__webpack_require__(212951),p=__webpack_require__(547929),i=__webpack_require__(891987),l=__webpack_require__(78922),n=__webpack_require__(852989),d=__webpack_require__(301930);function c(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=c(o),a=Object.defineProperty,u=Object.defineProperties,f=Object.getOwnPropertyDescriptors,m=Object.getOwnPropertySymbols,v=Object.prototype.hasOwnProperty,y=Object.prototype.propertyIsEnumerable,j=(e,r,t)=>r in e?a(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,P=(e,r)=>{for(var t in r||(r={}))v.call(r,t)&&j(e,t,r[t]);if(m)for(var t of m(r))y.call(r,t)&&j(e,t,r[t]);return e};const b=s.default.div`
  color: #7367f0;
  padding: 5px;
  width: 100%;
  cursor: pointer;
`;exports.SelectPopupConfig=o=>{const c=o,{label:s,placeholder:a,itemIndex:j,device:h,selectProps:x}=c,I=((e,r)=>{var t={};for(var o in e)v.call(e,o)&&r.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&m)for(var o of m(e))r.indexOf(o)<0&&y.call(e,o)&&(t[o]=e[o]);return t})(c,["label","placeholder","itemIndex","device","selectProps"]),[,g]=l.usePropSeparateDevice(I.propKey,I.separateDevice,I.usePropOptions),{setShowModalSelectPopup:O,relatedNodeId:S,setRelatedNodeId:q}=n.useBuilder(),{id:w}=p.useNode(),E=()=>{O(!0),q({componentId:w,propKey:I.propKey,itemIndex:j,device:h})};return i.useEffect((()=>{(null==S?void 0:S.popupId)&&(null==S?void 0:S.propKey)===I.propKey&&(g(S.popupId),q((e=>{return(null==e?void 0:e.componentId)&&(r=P({},e),u(r,f({popupId:void 0})));var r})))}),[null==S?void 0:S.popupId]),e.jsx(d.SelectConfig,P({selectProps:P({placeholder:a||r.t("Mặc định"),style:{width:"100%"},popupMatchSelectWidth:!1,showSearch:!0,optionFilterProp:"label",notFoundContent:I.options.length?e.jsx(t.Empty,{style:{margin:8},image:t.Empty.PRESENTED_IMAGE_SIMPLE}):e.jsx(e.Fragment,{}),dropdownRender:t=>e.jsxs(e.Fragment,{children:[t,e.jsxs(b,{onClick:E,children:["+"," ",r.t("Thêm mới popup")]})]})},x),formItemProps:{label:s,style:{marginBottom:"0.5rem"}}},I))};


/***/ }),

/***/ 151033:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(623537),o=__webpack_require__(85097),i=__webpack_require__(924216),n=__webpack_require__(432257),t=__webpack_require__(96179);exports.HoverConfig=({propKey:p=t.PROP_KEY.CommonStyle,separateDevice:P})=>e.jsxs(e.Fragment,{children:[e.jsx(i.ColorPickerConfigV3,{separateDevice:P,propKey:t.PROP_KEY.joinKey(p,t.PROP_KEY.HoverBorderColor),formItemProps:{label:r.t("Màu viền")}}),e.jsx(i.ColorPickerConfigV3,{separateDevice:P,propKey:t.PROP_KEY.joinKey(p,t.PROP_KEY.HoverBackgroundColor),formItemProps:{label:r.t("Màu nền")},gradientPicker:!0}),e.jsx(i.ColorPickerConfigV3,{separateDevice:P,propKey:t.PROP_KEY.joinKey(p,t.PROP_KEY.HoverColor),formItemProps:{label:r.t("Màu chữ")}}),e.jsx(n.InputNumberConfigV2,{separateDevice:P,propKey:t.PROP_KEY.joinKey(p,t.PROP_KEY.HoverTransparent),formItemProps:{label:r.t("Trong suốt")},inputNumberProps:{min:0,max:100,placeholder:"100"},unitProps:{defaultValue:o.UnitEnum.percent}}),e.jsx(n.InputNumberConfigV2,{separateDevice:P,propKey:t.PROP_KEY.joinKey(p,t.PROP_KEY.HoverZoom),formItemProps:{label:r.t("Phóng to")},inputNumberProps:{min:0,placeholder:"100"},unitProps:{defaultValue:o.UnitEnum.percent}})]});


/***/ }),

/***/ 281471:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(623537),t=__webpack_require__(212951),o=__webpack_require__(85097),i=__webpack_require__(610314),a=__webpack_require__(891987),n=__webpack_require__(906068),l=__webpack_require__(170517),s=__webpack_require__(827247),p=__webpack_require__(781883),u=__webpack_require__(675452),c=__webpack_require__(78922),d=__webpack_require__(852989),g=__webpack_require__(691171);function m(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const h=m(t).default(i.Divider)`
  justify-content: center;
  &::before,
  &::after {
    width: 25% !important;
  }
`;exports.ImageConfig=({propKey:t,widthPropKey:m,heightPropKey:f,layout:j="horizontal",placeholderImage:y,altPropKey:x,labels:I={},separateDevice:v,allowUploadImageByUrl:w=!0,allowCropImage:C,cropProps:P,additionalConfig:q,clearValue:F})=>{var S;const[b]=i.Form.useForm(),[U,D]=a.useState(!1),B=(e,r)=>e,[_,K]=c.usePropSeparateDevice(t,v),[,z]=c.usePropSeparateDevice(m,v),[,k]=c.usePropSeparateDevice(f,v),{uploadFileHandler:O=B,maxSizeImageUpload:$=20}=d.useBuilder();a.useEffect((()=>{const e=(r=_,u.isPrefixUrl(r)?r.slice(4,r.lastIndexOf("=")):r);var r;_!==e&&K(e)}),[]);const[L,M]=a.useState(!1),R=null==(S=null==window?void 0:window.config)?void 0:S.flagPB6243;return e.jsxs(e.Fragment,{children:[e.jsx(g.FormItem,{"data-testid":"upload-image-config",layout:j,label:e.jsxs("div",{style:{display:"flex",flexDirection:"row",justifyContent:"space-between",alignItems:"center"},children:[(null==I?void 0:I.image)||r.t("common.image"),_&&R&&e.jsx(i.Button,{type:"link",style:{padding:0},onClick:()=>M(!L),children:r.t("Chỉnh sửa ảnh")})]}),children:e.jsxs(i.Spin,{spinning:U,children:[e.jsx("div",{style:{position:"relative",width:"vertical"===j?"100%":"auto"},children:e.jsx(l.ImageUploadButton,{accept:"image/jpg, image/jpeg, image/png, image/gif, image/webp",beforeUpload:n.beforeUploadImage,imagePropKey:t,widthPropKey:m,heightPropKey:f,placeholder:y||e.jsx(e.Fragment,{children:r.t("upload_image",{maxSize:`${$}MB`})}),deleteImage:()=>K(F),separateDevice:v,layout:j,allowCropImage:C,cropProps:P})}),_&&R&&e.jsx(s.ImageCropConfig,{imgSrc:_,setImgSrc:K,open:L,setOpen:M}),!_&&w&&e.jsxs(e.Fragment,{children:[e.jsx(h,{plain:!0,children:r.t("hoặc")}),e.jsx(i.Form,{form:b,onFinish:async e=>{const{url:r}=e;try{D(!0);const e=await O(r,"url");if(K(e),m||f){const r=new Image;r.src=o.getImageUrlFromGoogleUserContent(e,{width:0}),r.onload=()=>{r.complete&&(m&&z(r.width),f&&k(r.height))}}}finally{b.resetFields(),D(!1)}},children:e.jsx(i.Form.Item,{name:"url",rules:[{required:!0,message:r.t("URL không được để trống")},{type:"url",message:r.t("URL sai định dạng")},{pattern:/^[a-zA-Z0-9-._~:/?#@!$&'()*+,;=%]*$/,message:r.t("url_not_support_special_characters")}],children:e.jsx(i.Input.Search,{placeholder:r.t("Dùng đường dẫn ảnh"),enterButton:r.t("Dùng ảnh"),loading:U,onSearch:()=>b.submit()})})})]})]})}),!!x&&e.jsx(p.InputConfig,{propKey:x,formItemProps:{label:(null==I?void 0:I.alt)||r.t("image_config.alt"),layout:j},inputProps:{style:{width:"horizontal"===j?140:"100%"},placeholder:r.t("Nhập văn bản thay thế")},separateDevice:v}),q]})};


/***/ }),

/***/ 75085:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(623537),i=__webpack_require__(212951),r=__webpack_require__(891987),a=__webpack_require__(885776),l=__webpack_require__(906068),o=__webpack_require__(61079),n=__webpack_require__(610314),s=__webpack_require__(112373),u=__webpack_require__(691171),d=__webpack_require__(781883),p=__webpack_require__(675452),c=__webpack_require__(852989);function m(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var g=m(i),f=Object.defineProperty,j=Object.defineProperties,x=Object.getOwnPropertyDescriptors,h=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,y=Object.prototype.propertyIsEnumerable,v=(e,t,i)=>t in e?f(e,t,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[t]=i,I=(e,t)=>{for(var i in t||(t={}))b.call(t,i)&&v(e,i,t[i]);if(h)for(var i of h(t))y.call(t,i)&&v(e,i,t[i]);return e};const O=g.default((i=>{var a=i,{multiple:l=!1,image:u,setImage:d,listType:p="picture-card"}=a,m=((e,t)=>{var i={};for(var r in e)b.call(e,r)&&t.indexOf(r)<0&&(i[r]=e[r]);if(null!=e&&h)for(var r of h(e))t.indexOf(r)<0&&y.call(e,r)&&(i[r]=e[r]);return i})(a,["multiple","image","setImage","listType"]);const{maxSizeImageUpload:g=20}=c.useBuilder(),[f,v]=r.useState(!1);return e.jsx(n.Spin,{indicator:e.jsx(s.LoadingOutlined,{style:{fontSize:20}}),spinning:f,children:e.jsx(o.ImageUpload,(O=I({multiple:l,showUploadList:!1,disabled:f,listType:p,onUpdateImageUrl:l?e=>{if(!e)return;const t=e.imageUrl;t&&d(t),v(e.uploading)}:e=>{if(!e)return;const t=e.imageUrl;t&&d(t),v(e.uploading)}},m),q={children:l?e.jsx(n.Button,{block:!0,type:"primary",icon:e.jsx(s.UploadOutlined,{}),loading:f,children:t.t("upload_image",{maxSize:`${g}MB`})}):u?e.jsx(U,{src:u,alt:"uploaded img"}):e.jsxs("div",{children:[e.jsx(s.CloudUploadOutlined,{style:{fontSize:20}}),e.jsx("div",{style:{marginTop:8},children:t.t("upload_image",{maxSize:`${g}MB`})})]})},j(O,x(q))))});var O,q}))`
  width: 130px;
  height: 130px;
`,U=g.default.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;exports.ImageFormItem=({onChange:i,defaultValue:o})=>{const[n,c]=r.useState(o);r.useEffect((()=>{const e=(t=n,p.isPrefixUrl(t)?t.slice(4,t.lastIndexOf("=")):t);var t;n!==e&&c(e)}),[]);const m=[void 0,"",a];return r.useEffect((()=>{i(n)}),[n]),e.jsxs(e.Fragment,{children:[e.jsx(u.FormItem,{label:t.t("common.image"),children:e.jsxs("div",{style:{position:"relative"},children:[e.jsx(O,{accept:"image/jpg, image/jpeg, image/png, image/gif, image/webp",beforeUpload:l.beforeUploadImage,image:n,setImage:c}),!m.includes(n)&&e.jsx(s.CloseCircleFilled,{onClick:()=>{c(void 0)},style:{position:"absolute",top:-6,right:-6,fontSize:16,borderRadius:8}})]})}),e.jsx(d.InputConfig,{formItemProps:{label:t.t("Đường dẫn ảnh")},inputProps:{style:{width:130},placeholder:t.t("Nhập URL"),value:n===a?null:n,onChange:e=>{const t=e.target.value;c(t)}}})]})};


/***/ }),

/***/ 185085:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(623537),r=__webpack_require__(212951),i=__webpack_require__(891987),o=__webpack_require__(610314),a=__webpack_require__(112373),n=__webpack_require__(906068),l=__webpack_require__(885776),s=__webpack_require__(852989),c=__webpack_require__(691171),d=__webpack_require__(675452);function p(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var u=p(r),m=Object.defineProperty,g=Object.defineProperties,f=Object.getOwnPropertyDescriptors,h=Object.getOwnPropertySymbols,x=Object.prototype.hasOwnProperty,j=Object.prototype.propertyIsEnumerable,y=(e,t,r)=>t in e?m(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,b=(e,t)=>{for(var r in t||(t={}))x.call(t,r)&&y(e,r,t[r]);if(h)for(var r of h(t))j.call(t,r)&&y(e,r,t[r]);return e};const v=u.default.div`
  width: ${e=>"vertical"===e.layout?"100%":"130px"};
  height: 130px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  transition: border-color 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
  background-color: #fafafa;
  box-sizing: border-box;

  &:hover {
    border-color: ${e=>e.themeToken.colorPrimary};
  }

  .ant-upload {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    width: 100% !important;
    height: 100% !important;
    padding: 4px;
    position: relative;
    overflow: hidden;
  }
`,w=u.default.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
  margin: auto;
  pointer-events: none; /* Prevent image from intercepting click events */
`,F=u.default(a.CloseCircleFilled)`
  cursor: pointer;
  color: rgba(0, 0, 0, 0.88);
  position: absolute;
  top: -6px;
  right: -6px;
  font-size: 16px;
  border-radius: 8px;
`,O=u.default(o.Divider)`
  justify-content: center;
  &::before,
  &::after {
    width: 25% !important;
  }
`;exports.ImageFormItemV2=({onChange:r,defaultValue:p,layout:u="vertical",placeholder:m,allowUploadImageByUrl:h=!0,formItemProps:x})=>{const[j]=o.Form.useForm(),[y,I]=i.useState(p),[U,q]=i.useState(!1),{token:P}=o.theme.useToken(),k=(e,t)=>e,{uploadFileHandler:S=k,maxSizeImageUpload:_=20}=s.useBuilder();i.useEffect((()=>{const e=(t=y,d.isPrefixUrl(t)?t.slice(4,t.lastIndexOf("=")):t);var t;y!==e&&I(e)}),[]),i.useEffect((()=>{r(y)}),[y]);const z={name:"file",accept:"image/jpg, image/jpeg, image/png, image/gif, image/webp",showUploadList:!1,disabled:U,beforeUpload:(e,t)=>(n.beforeUploadImage(e)&&(async e=>{try{q(!0);const t=URL.createObjectURL(e),r=S;let i;try{i=await r(e,"image")}catch(e){i=t}I(i)}catch(e){}finally{q(!1)}})(e),!1)};return e.jsx(c.FormItem,{label:(null==x?void 0:x.label)||t.t("common.image"),layout:u,children:e.jsxs("div",{style:{position:"relative",width:"vertical"===u?"100%":"auto"},children:[e.jsx(v,{layout:u,themeToken:P,children:e.jsx(o.Upload,(L=b({},z),B={children:y&&y!==l?e.jsx(w,{src:y,alt:"uploaded img"}):e.jsx("div",{style:{width:"100%",textAlign:"center"},children:U?e.jsx(a.LoadingOutlined,{style:{fontSize:24}}):e.jsxs(e.Fragment,{children:[e.jsx(a.UploadOutlined,{style:{fontSize:20}}),e.jsx("div",{style:{marginTop:8},children:m||t.t("upload_image",{maxSize:`${_}MB`})})]})})},g(L,f(B))))}),y&&e.jsx(F,{onClick:e=>{e.stopPropagation(),I(void 0)},style:{color:P.colorText}}),!y&&h&&e.jsxs(e.Fragment,{children:[e.jsx(O,{plain:!0,children:t.t("hoặc")}),e.jsx(o.Form,{form:j,onFinish:async e=>{const{url:t}=e;try{q(!0);const e=await S(t,"url");I(e)}finally{j.resetFields(),q(!1)}},children:e.jsx(o.Form.Item,{name:"url",rules:[{required:!0,message:t.t("URL không được để trống")},{type:"url",message:t.t("URL sai định dạng")},{pattern:/^[a-zA-Z0-9-._~:/?#@!$&'()*+,;=%]*$/,message:t.t("url_not_support_special_characters")}],children:e.jsx(o.Input.Search,{placeholder:t.t("Dùng đường dẫn ảnh"),enterButton:t.t("Dùng ảnh"),loading:U,onSearch:()=>j.submit()})})})]})]})});var L,B};


/***/ }),

/***/ 61079:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(623537),r=__webpack_require__(891987),a=__webpack_require__(610314),o=__webpack_require__(212951),l=__webpack_require__(877084),i=__webpack_require__(636574),n=__webpack_require__(852989);function c(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=c(o),p=c(l),u=c(i),d=Object.defineProperty,m=Object.defineProperties,f=Object.getOwnPropertyDescriptors,g=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,h=Object.prototype.propertyIsEnumerable,j=(e,t,r)=>t in e?d(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,O=(e,t)=>{for(var r in t||(t={}))b.call(t,r)&&j(e,r,t[r]);if(g)for(var r of g(t))h.call(t,r)&&j(e,r,t[r]);return e},v=(e,t)=>m(e,f(t)),x=(e,t)=>{var r={};for(var a in e)b.call(e,a)&&t.indexOf(a)<0&&(r[a]=e[a]);if(null!=e&&g)for(var a of g(e))t.indexOf(a)<0&&h.call(e,a)&&(r[a]=e[a]);return r};const y=s.default(a.Upload)`
  &.vertical {
    .ant-upload-select {
      width: 100% !important;
    }
  }

  .ant-upload-select {
    margin-bottom: 0 !important;
    margin-inline-end: 0 !important;
  }
`;exports.ImageUpload=o=>{var l=o,{accept:i="image/jpg, image/jpeg, image/png, image/webp",onUpdateImageUrl:c,multiple:s,children:d,layout:m="horizontal",allowCropImage:f=!1,cropProps:g={},maxSize:b=20}=l,h=x(l,["accept","onUpdateImageUrl","multiple","children","layout","allowCropImage","cropProps","maxSize"]);const[j,U]=r.useState(1),w=(e,t)=>URL.createObjectURL(e),{uploadFileHandler:q=w}=n.useBuilder(),P=()=>U(1),C=async e=>{const{onSuccess:t,onError:r,file:a}=e;if(S(a))try{await c({uploading:!0},a);const e=await q(a,"image");a.thumbUrl=e,t(a)}catch(e){r()}},I=async({file:e})=>{if(c){const{status:t,thumbUrl:r}=e;"error"!==t&&"done"!==t||await c({imageUrl:r,uploading:!1},e.originFileObj)}},S=e=>{var r;return!(e.size>1024*b*1024&&(null==(r=a.notification)||r.error({message:t.t("max_size_upload_error",{MAX_SIZE_UPLOAD:b})}),1))},R=h,{beforeUpload:_}=R,z=x(R,["beforeUpload"]);return f?e.jsx(u.default,v(O({rotationSlider:!0,modalProps:{zIndex:2e3},aspectSlider:!0,aspect:j,showReset:!0,beforeCrop:(e,t)=>((e=>{const t=new Image;t.src=e,t.onload=()=>{t.complete&&t.width>0&&t.height>0&&U(t.width/t.height)}})(URL.createObjectURL(e)),_(e,t)),onModalOk:P,onModalCancel:P,modalTitle:t.t("Chỉnh sửa ảnh"),modalOk:"Xong",modalCancel:t.t("common.cancel"),resetText:t.t("Đặt lại")},g),{children:e.jsx(y,v(O({className:p.default({vertical:"vertical"===m}),multiple:s,accept:i,customRequest:C,onChange:I},z),{children:d}))})):e.jsx(y,v(O({className:p.default({vertical:"vertical"===m}),multiple:s,customRequest:C,accept:i,onChange:I},h),{children:d}))};


/***/ }),

/***/ 170517:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(623537),i=__webpack_require__(891987),r=__webpack_require__(61079),a=__webpack_require__(212951),o=__webpack_require__(610314),l=__webpack_require__(112373),s=__webpack_require__(885776),n=__webpack_require__(493959),d=__webpack_require__(452281),u=__webpack_require__(852989),p=__webpack_require__(78922);function c(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var g=c(a),h=Object.defineProperty,m=Object.defineProperties,j=Object.getOwnPropertyDescriptors,f=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,x=Object.prototype.propertyIsEnumerable,v=(e,t,i)=>t in e?h(e,t,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[t]=i,b=(e,t)=>{for(var i in t||(t={}))y.call(t,i)&&v(e,i,t[i]);if(f)for(var i of f(t))x.call(t,i)&&v(e,i,t[i]);return e};const w=g.default.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;exports.ImageUploadButton=a=>{var c=a,{multiple:g=!1,imagePropKey:h,widthPropKey:v,heightPropKey:P,listType:I="picture-card",placeholder:O,deleteImage:U,separateDevice:q,layout:S="horizontal",defaultNewImage:B,showButtonUpload:D,stateImageUpload:C,onLoadingChange:K}=c,T=((e,t)=>{var i={};for(var r in e)y.call(e,r)&&t.indexOf(r)<0&&(i[r]=e[r]);if(null!=e&&f)for(var r of f(e))t.indexOf(r)<0&&x.call(e,r)&&(i[r]=e[r]);return i})(c,["multiple","imagePropKey","widthPropKey","heightPropKey","listType","placeholder","deleteImage","separateDevice","layout","defaultNewImage","showButtonUpload","stateImageUpload","onLoadingChange"]);const{maxSizeImageUpload:k=20}=u.useBuilder(),[z,F]=p.usePropSeparateDevice(h,q),[,L]=p.usePropSeparateDevice(v,q),[,_]=p.usePropSeparateDevice(P,q),[E,H]=i.useState(!1),{token:M}=o.theme.useToken(),N=C?C.image:z,R=C?C.setImage:F,W=C?C.setWidth:L,$=(null==C?void 0:C.setHeight)?C.setHeight:_,A=O||e.jsx(e.Fragment,{children:t.t("upload_image",{maxSize:`${k}MB`})});return i.useEffect((()=>{K&&K(E)}),[E,K]),e.jsxs("div",{style:{position:"relative"},children:[e.jsx(r.ImageUpload,(G=b({multiple:g,showUploadList:!1,disabled:E,listType:I,onUpdateImageUrl:g?async(e,t)=>{if(!e)return;const i=e.imageUrl;if(i&&h){const e=b({src:i,googleImageParams:{width:0,height:0}},B);e.id&&(e.id=n.v4());const r=await d.getImageObject(t);e.googleImageParams.width=r.width,e.googleImageParams.height=r.height;const a=[...z||[]];a.push(e),R(a)}H(e.uploading)}:async(e,t)=>{if(!e)return;const i=e.imageUrl;if(i&&h){const e=await d.getImageObject(t);v&&W(e.width),P&&$(e.height),R(i)}H(e.uploading)},layout:S},T),J={children:g?e.jsx(o.Button,{block:!0,type:"primary",icon:e.jsx(l.UploadOutlined,{}),loading:E,children:A}):N&&N!=s&&!E?e.jsx(w,{src:N,alt:"uploaded img"}):e.jsx("div",{style:{width:"100%"},children:E?e.jsx(l.LoadingOutlined,{}):e.jsx(e.Fragment,{children:D?e.jsx(o.Button,{icon:e.jsx(l.UploadOutlined,{}),loading:E,children:A}):e.jsxs(e.Fragment,{children:[e.jsx(l.UploadOutlined,{}),e.jsx("div",{style:{marginTop:4},children:A})]})})})},m(G,j(J)))),!g&&!!N&&e.jsx(l.CloseCircleFilled,{onClick:()=>{U?U():R(void 0)},style:{cursor:"pointer",color:M.colorText,position:"absolute",top:-6,right:-6,fontSize:16,borderRadius:8}})]});var G,J};


/***/ }),

/***/ 906068:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(623537),i=__webpack_require__(610314);const r=["image/jpeg","image/png","image/jpg","image/gif","image/webp"];exports.beforeUploadImage=t=>!!r.includes(t.type)||(i.notification.error({message:e.t("Bạn chỉ có thể tải lên ảnh dạng JPG/JPEG/PNG/GIF/WEBP!")}),!1);


/***/ }),

/***/ 827247:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(610314),t=__webpack_require__(891987),o=__webpack_require__(190899),a=__webpack_require__(85097),i=__webpack_require__(8359),n=__webpack_require__(623537),p=__webpack_require__(212951),s=__webpack_require__(926854),c=__webpack_require__(75537),d=__webpack_require__(852989);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var u=l(o),f=l(p);const h=l(s).default({key:"image-crop",prepend:!0}),g=({label:r,min:t,max:o,step:a,value:i,onChange:n})=>{const p=(i-t)/(o-t)*100;return e.jsxs(m,{children:[e.jsx(_,{children:r}),e.jsxs(C,{children:[e.jsx(R,{percent:p}),e.jsx(v,{percent:p}),e.jsx(w,{type:"range",min:t,max:o,step:a,value:i,onChange:e=>n(Number(e.target.value))})]})]})},x=({value:r,onChange:o,options:a})=>{const[i,n]=t.useState(!1),p=t.useRef(null);t.useEffect((()=>{const e=e=>{p.current&&!p.current.contains(e.target)&&n(!1)};return document.addEventListener("mousedown",e),()=>document.removeEventListener("mousedown",e)}),[]);const s=a.find((e=>e.value===r));return e.jsxs(k,{ref:p,children:[e.jsxs(j,{isOpen:i,onClick:()=>n(!i),type:"button",children:[e.jsx("span",{children:(null==s?void 0:s.label)||""}),e.jsx(z,{isOpen:i})]}),e.jsx(O,{isOpen:i,children:a.map((t=>e.jsx(S,{isSelected:t.value===r,onClick:()=>{o(t.value),n(!1)},children:t.label},t.value)))})]})},b=f.default.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 16px;
`,m=f.default.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`,_=f.default.div`
  font-size: 14px;
  color: #333;
`,C=f.default.div`
  position: relative;
  width: 100%;
  height: 6px;
  background: #e8e8e8;
  border-radius: 3px;
`,R=f.default.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background: #7b61ff;
  border-radius: 3px;
  width: ${e=>e.percent}%;
  pointer-events: none;
`,v=f.default.div`
  position: absolute;
  top: 50%;
  left: ${e=>e.percent}%;
  transform: translate(-50%, -50%);
  width: 16px;
  height: 16px;
  background: #7b61ff;
  border: 2px solid #fff;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  transition: transform 0.1s ease;

  &:hover {
    transform: translate(-50%, -50%) scale(1.1);
  }

  &:active {
    transform: translate(-50%, -50%) scale(0.95);
  }
`,w=f.default.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  margin: 0;
  padding: 0;

  &::-webkit-slider-thumb {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  &::-moz-range-thumb {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
`,y=f.default.div`
  display: flex;
  align-items: center;
  gap: 12px;
`,k=f.default.div`
  position: relative;
  width: 160px;
`,j=f.default.button`
  width: 100%;
  height: 32px;
  padding: 4px 11px;
  background: #fff;
  border: 1px solid ${e=>e.isOpen?"#7B61FF":"#d9d9d9"};
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: all 0.2s;

  &:hover {
    border-color: #7b61ff;
  }

  &:focus {
    outline: none;
    border-color: #7b61ff;
    box-shadow: 0 0 0 2px rgba(91, 124, 250, 0.1);
  }
`,z=f.default.span`
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid #999;
  transition: transform 0.2s;
  transform: ${e=>e.isOpen?"rotate(180deg)":"rotate(0)"};
`,O=f.default.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  display: ${e=>e.isOpen?"block":"none"};
`,S=f.default.div`
  padding: 5px 12px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  background: ${e=>e.isSelected?"#f3f0fe":"#fff"};
  transition: background 0.2s;

  &:hover {
    background: #f5f5f5;
  }

  &:first-of-type {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }

  &:last-of-type {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }
`,q=f.default.div`
  @keyframes marching-ants {
    0% {
      background-position: 0 0, 0 100%, 0 0, 100% 0;
    }
    to {
      background-position: 20px 0, -20px 100%, 0 -20px, 100% 20px;
    }
  }
  .ReactCrop {
    position: relative;
    display: inline-block;
    cursor: crosshair;
    max-width: 100%;
  }
  .ReactCrop *,
  .ReactCrop *:before,
  .ReactCrop *:after {
    box-sizing: border-box;
  }
  .ReactCrop--disabled,
  .ReactCrop--locked {
    cursor: inherit;
  }
  .ReactCrop__child-wrapper {
    overflow: hidden;
    max-height: inherit;
  }
  .ReactCrop__child-wrapper > img,
  .ReactCrop__child-wrapper > video {
    display: block;
    max-width: 100%;
    max-height: inherit;
  }
  .ReactCrop:not(.ReactCrop--disabled) .ReactCrop__child-wrapper > img,
  .ReactCrop:not(.ReactCrop--disabled) .ReactCrop__child-wrapper > video {
    touch-action: none;
  }
  .ReactCrop:not(.ReactCrop--disabled) .ReactCrop__crop-selection {
    touch-action: none;
  }
  .ReactCrop__crop-mask {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    pointer-events: none;
    width: calc(100% + 0.5px);
    height: calc(100% + 0.5px);
  }
  .ReactCrop__crop-selection {
    position: absolute;
    top: 0;
    left: 0;
    transform: translateZ(0);
    cursor: move;
  }
  .ReactCrop--disabled .ReactCrop__crop-selection {
    cursor: inherit;
  }
  .ReactCrop--circular-crop .ReactCrop__crop-selection {
    border-radius: 50%;
  }
  .ReactCrop--circular-crop .ReactCrop__crop-selection:after {
    pointer-events: none;
    content: '';
    position: absolute;
    top: -1px;
    right: -1px;
    bottom: -1px;
    left: -1px;
    border: 1px solid rgba(255, 255, 255, 0.7);
    opacity: 0.3;
  }
  .ReactCrop--no-animate .ReactCrop__crop-selection {
    outline: 1px dashed white;
  }
  .ReactCrop__crop-selection:not(.ReactCrop--no-animate
      .ReactCrop__crop-selection) {
    animation: marching-ants 1s;
    background-image: linear-gradient(to right, #fff 50%, #444 50%),
      linear-gradient(to right, #fff 50%, #444 50%),
      linear-gradient(to bottom, #fff 50%, #444 50%),
      linear-gradient(to bottom, #fff 50%, #444 50%);
    background-size: 10px 1px, 10px 1px, 1px 10px, 1px 10px;
    background-position: 0 0, 0 100%, 0 0, 100% 0;
    background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
    color: #fff;
    animation-play-state: running;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
  }
  .ReactCrop__crop-selection:focus {
    outline: 2px solid #0088ff;
    outline-offset: -1px;
  }
  .ReactCrop--invisible-crop .ReactCrop__crop-mask,
  .ReactCrop--invisible-crop .ReactCrop__crop-selection {
    display: none;
  }
  .ReactCrop__rule-of-thirds-vt:before,
  .ReactCrop__rule-of-thirds-vt:after,
  .ReactCrop__rule-of-thirds-hz:before,
  .ReactCrop__rule-of-thirds-hz:after {
    content: '';
    display: block;
    position: absolute;
    background-color: #fff6;
  }
  .ReactCrop__rule-of-thirds-vt:before,
  .ReactCrop__rule-of-thirds-vt:after {
    width: 1px;
    height: 100%;
  }
  .ReactCrop__rule-of-thirds-vt:before {
    left: 33.3333333333%;
  }
  .ReactCrop__rule-of-thirds-vt:after {
    left: 66.6666666667%;
  }
  .ReactCrop__rule-of-thirds-hz:before,
  .ReactCrop__rule-of-thirds-hz:after {
    width: 100%;
    height: 1px;
  }
  .ReactCrop__rule-of-thirds-hz:before {
    top: 33.3333333333%;
  }
  .ReactCrop__rule-of-thirds-hz:after {
    top: 66.6666666667%;
  }
  .ReactCrop__drag-handle {
    position: absolute;
    width: 12px;
    height: 12px;
    background-color: rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.7);
  }
  .ReactCrop__drag-handle:focus {
    background: #0088ff;
  }
  .ReactCrop .ord-nw {
    top: 0;
    left: 0;
    transform: translate(-50%, -50%);
    cursor: nw-resize;
  }
  .ReactCrop .ord-n {
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: n-resize;
  }
  .ReactCrop .ord-ne {
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    cursor: ne-resize;
  }
  .ReactCrop .ord-e {
    top: 50%;
    right: 0;
    transform: translate(50%, -50%);
    cursor: e-resize;
  }
  .ReactCrop .ord-se {
    bottom: 0;
    right: 0;
    transform: translate(50%, 50%);
    cursor: se-resize;
  }
  .ReactCrop .ord-s {
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%);
    cursor: s-resize;
  }
  .ReactCrop .ord-sw {
    bottom: 0;
    left: 0;
    transform: translate(-50%, 50%);
    cursor: sw-resize;
  }
  .ReactCrop .ord-w {
    top: 50%;
    left: 0;
    transform: translate(-50%, -50%);
    cursor: w-resize;
  }
  .ReactCrop__disabled .ReactCrop__drag-handle {
    cursor: inherit;
  }
  .ReactCrop__drag-bar {
    position: absolute;
  }
  .ReactCrop__drag-bar.ord-n {
    top: 0;
    left: 0;
    width: 100%;
    height: 6px;
    transform: translateY(-50%);
  }
  .ReactCrop__drag-bar.ord-e {
    right: 0;
    top: 0;
    width: 6px;
    height: 100%;
    transform: translate(50%);
  }
  .ReactCrop__drag-bar.ord-s {
    bottom: 0;
    left: 0;
    width: 100%;
    height: 6px;
    transform: translateY(50%);
  }
  .ReactCrop__drag-bar.ord-w {
    top: 0;
    left: 0;
    width: 6px;
    height: 100%;
    transform: translate(-50%);
  }
  .ReactCrop--new-crop .ReactCrop__drag-bar,
  .ReactCrop--new-crop .ReactCrop__drag-handle,
  .ReactCrop--fixed-aspect .ReactCrop__drag-bar,
  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-n,
  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-e,
  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-s,
  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-w {
    display: none;
  }
  @media (pointer: coarse) {
    .ReactCrop .ord-n,
    .ReactCrop .ord-e,
    .ReactCrop .ord-s,
    .ReactCrop .ord-w {
      display: none;
    }
    .ReactCrop__drag-handle {
      width: 24px;
      height: 24px;
    }
  }
`;exports.ImageCropConfig=({imgSrc:p,setImgSrc:s,open:l,setOpen:f})=>{const[m,_]=t.useState(),[C,R]=t.useState(),[v,w]=t.useState(1),[k,j]=t.useState(0),[z,O]=t.useState(1),[S,L]=t.useState(!1),$=t.useRef(null),E=t.useRef(""),{uploadFileHandler:P}=d.useBuilder();t.useEffect((()=>{if(l&&p){const e=a.getImageUrlFromGoogleUserContent(p,{width:0});s(e)}}),[l,p,s]),t.useEffect((()=>{if($.current&&z){const{width:e,height:r}=$.current,t=i.centerAspectCrop(e,r,z);_(t),R(o.convertToPixelCrop(t,e,r))}}),[z]);const T=t.useCallback((async()=>{var e;if(C&&$.current)try{L(!0);const t=document.createElement("canvas");i.canvasPreview($.current,t,C,v,k);const o=await(e=t,new Promise((r=>{e.toBlob((e=>{r(e)}),"image/png")})));if(!o)return r.notification.error({message:n.t("Lỗi"),description:n.t("image_crop_config.crop.cannot_create_crop")}),void f(!1);const a=new File([o],`cropped-image-${Date.now()}.png`,{type:"image/png"});if(!P)return r.notification.error({message:n.t("Lỗi"),description:n.t("image_crop_config.upload.no_handler")}),void f(!1);const p=await P(a,"image");if(!p)throw new Error("Upload failed: No URL returned");E.current&&(URL.revokeObjectURL(E.current),E.current=""),s(p),r.notification.success({message:n.t("Thành công"),description:n.t("image_crop_config.upload.image_update_successful")}),f(!1)}catch(e){r.notification.error({message:n.t("Lỗi"),description:n.t("image_crop_config.upload.image_update_failed")})}finally{L(!1)}else f(!1)}),[C,v,k,s,f,P]);return e.jsx(c.CacheProvider,{value:h,children:e.jsx(r.Modal,{title:n.t("Chỉnh sửa ảnh"),open:l,onCancel:()=>f(!1),onOk:T,okText:n.t("Áp dụng"),cancelText:n.t("Hủy"),width:900,destroyOnClose:!0,confirmLoading:S,maskClosable:!1,getContainer:()=>null==document?void 0:document.body,zIndex:2e3,children:!!p&&e.jsxs(q,{children:[e.jsx(u.default,{crop:m,onChange:(e,r)=>_(r),onComplete:e=>R(e),aspect:z,minHeight:60,keepSelection:!1,children:e.jsx("img",{ref:$,alt:"Crop me",src:p,crossOrigin:"anonymous",style:{transform:`scale(${v}) rotate(${k}deg)`},onLoad:e=>{if(z){const{width:r,height:t}=e.currentTarget,a=i.centerAspectCrop(r,t,z);_(a),R(o.convertToPixelCrop(a,r,t))}}})}),e.jsxs(b,{children:[e.jsxs(y,{children:[n.t("Tỉ lệ"),e.jsx(x,{value:null!=z?z:0,onChange:e=>O(e||void 0),options:[{label:n.t("image_crop_config.aspect.free"),value:0},{label:"1:1",value:1},{label:"4:3",value:4/3},{label:"16:9",value:16/9},{label:"3:4",value:3/4}]})]}),e.jsx(g,{label:n.t("Phóng to"),min:.5,max:3,step:.01,value:v,onChange:w}),e.jsx(g,{label:n.t("Xoay (độ)"),min:-180,max:180,step:1,value:k,onChange:j})]})]})})})};


/***/ }),

/***/ 8359:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(190899);exports.canvasPreview=function(t,e,r,a=1,h=0){const i=e.getContext("2d");if(!i)return;const n=t.naturalWidth/t.width,o=t.naturalHeight/t.height;e.width=Math.floor(r.width*n),e.height=Math.floor(r.height*o),i.save(),i.clearRect(0,0,e.width,e.height),i.translate(-r.x*n,-r.y*o),i.translate(t.width*n/2,t.height*o/2),i.rotate(h*Math.PI/180),i.scale(a,a),i.translate(-t.width*n/2,-t.height*o/2),i.drawImage(t,0,0,t.naturalWidth,t.naturalHeight,0,0,t.naturalWidth,t.naturalHeight),i.restore()},exports.centerAspectCrop=function(e,r,a){return t.centerCrop(t.makeAspectCrop({unit:"%",width:90},a,e,r),e,r)};


/***/ }),

/***/ 970388:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(623537),r=__webpack_require__(983642),n=__webpack_require__(944200),i=__webpack_require__(212951),a=__webpack_require__(610314),o=__webpack_require__(891987),l=__webpack_require__(610796),d=__webpack_require__(534179),s=__webpack_require__(482574),u=__webpack_require__(170517);function p(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=p(i),m=Object.defineProperty,g=Object.defineProperties,y=Object.getOwnPropertyDescriptors,b=Object.getOwnPropertySymbols,f=Object.prototype.hasOwnProperty,h=Object.prototype.propertyIsEnumerable,x=(e,t,r)=>t in e?m(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r;const j=c.default.ul`
  display: grid;
  gap: 0.75rem;
  padding: 0;

  transition: all 2s;

  /* Desktop */
  grid-template-columns: repeat(4, 1fr);
  /* Tablet */
  @media only screen and (max-width: 800px) {
    grid-template-columns: repeat(2, 1fr);
  }
  /* Mobile */
  @media only screen and (max-width: 460px) {
    grid-template-columns: repeat(1, 1fr);
  }
`,v=c.default.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;exports.ImageListConfig=({propKey:i="items",separateDevice:p,visible:c,setVisible:m,imageHeight:I,actions:C,defaultNewImage:q,imageSettingCustom:w,title:O})=>{var S;const[D,k]=s.useSortable(i,p),[P,T]=o.useState(null),B=P?D.findIndex((e=>e.id===P)):-1,{document:K}=l.useFrame(),M=()=>m(!1),E=e.jsxs(e.Fragment,{children:[e.jsxs(v,{children:[e.jsx(a.Typography.Text,{type:"secondary",children:t.t("Click 2 lần vào ảnh để thay ảnh mới")}),e.jsx(u.ImageUploadButton,{separateDevice:p,imagePropKey:i,multiple:!0,listType:"picture",defaultNewImage:q})]}),e.jsx(r.DndContext,{onDragStart:({active:e})=>{e&&T(e.id)},onDragEnd:({over:e})=>{if(T(null),e){const t=D.findIndex((t=>t.id===e.id));B!==t&&k((e=>n.arrayMove(e,B,t)))}},onDragCancel:()=>T(null),children:e.jsx(n.SortableContext,{items:D,children:e.jsx(j,{children:null==(S=null==D?void 0:D.map)?void 0:S.call(D,((t,r)=>{return e.jsx(d.SortableImage,(n=((e,t)=>{for(var r in t||(t={}))f.call(t,r)&&x(e,r,t[r]);if(b)for(var r of b(t))h.call(t,r)&&x(e,r,t[r]);return e})({actions:C,propKey:i,onRemove:()=>(e=>{k((t=>(null==t||t.splice(e,1),t)))})(r),index:r,id:t.id},t.item),g(n,y({imageHeight:I,separateDevice:p,imageSettingCustom:w}))),r);var n}))})})})]});return e.jsxs(a.Modal,{width:"70%",bodyStyle:{minHeight:500},zIndex:1080,title:O||t.t("Quản lý ảnh"),okText:t.t("Đóng"),destroyOnClose:!0,onCancel:M,open:c,footer:e.jsx(e.Fragment,{children:e.jsx(a.Button,{type:"primary",onClick:M,children:t.t("Đóng")})}),getContainer:(null==K?void 0:K.body)||(null==document?void 0:document.body),children:[(null==D?void 0:D.length)?E:null,e.jsx(a.Empty,{description:t.t("Chưa có hình ảnh nào"),style:{paddingTop:"10%",display:(null==D?void 0:D.length)?"none":"block"},children:e.jsx(u.ImageUploadButton,{separateDevice:p,imagePropKey:i,multiple:!0,listType:"picture",defaultNewImage:q})})]})};


/***/ }),

/***/ 32951:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(281471),o=__webpack_require__(96179),t=Object.defineProperty,a=Object.getOwnPropertySymbols,P=Object.prototype.hasOwnProperty,i=Object.prototype.propertyIsEnumerable,p=(e,r,o)=>r in e?t(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o;exports.ImageSetting=t=>{var l=t,{altPropKey:n=o.PROP_KEY.Alt,srcPropKey:y=o.PROP_KEY.Src,widthPropKey:K=o.PROP_KEY.joinKey(o.PROP_KEY.GoogleImageParams,o.PROP_KEY.Width),heightPropKey:g=o.PROP_KEY.joinKey(o.PROP_KEY.GoogleImageParams,o.PROP_KEY.Height)}=l,s=((e,r)=>{var o={};for(var t in e)P.call(e,t)&&r.indexOf(t)<0&&(o[t]=e[t]);if(null!=e&&a)for(var t of a(e))r.indexOf(t)<0&&i.call(e,t)&&(o[t]=e[t]);return o})(l,["altPropKey","srcPropKey","widthPropKey","heightPropKey"]);return e.jsx(r.ImageConfig,((e,r)=>{for(var o in r||(r={}))P.call(r,o)&&p(e,o,r[o]);if(a)for(var o of a(r))i.call(r,o)&&p(e,o,r[o]);return e})({propKey:y,widthPropKey:K,heightPropKey:g,layout:"vertical",altPropKey:n},s))};


/***/ }),

/***/ 534179:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(623537),i=__webpack_require__(891987),o=__webpack_require__(104437),r=__webpack_require__(610314),n=__webpack_require__(944200),s=__webpack_require__(212951),a=__webpack_require__(32951),l=__webpack_require__(610796),c=__webpack_require__(959211),u=__webpack_require__(885776),d=__webpack_require__(766933),p=__webpack_require__(746917),g=__webpack_require__(170517),y=__webpack_require__(96179);function f(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var P=f(i),j=f(s),b=Object.defineProperty,m=Object.defineProperties,x=Object.getOwnPropertyDescriptors,K=Object.getOwnPropertySymbols,v=Object.prototype.hasOwnProperty,h=Object.prototype.propertyIsEnumerable,O=(e,t,i)=>t in e?b(e,t,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[t]=i,R=(e,t)=>{for(var i in t||(t={}))v.call(t,i)&&O(e,i,t[i]);if(K)for(var i of K(t))h.call(t,i)&&O(e,i,t[i]);return e};const E=j.default.li`
  position: relative;
  list-style: none;
  cursor: grabbing;
  box-shadow: 0px 0px 4px rgba(68, 68, 68, 0.2);
  border-radius: 4px;

  .action-button {
    display: none;
  }

  :hover {
    .action-button {
      display: block;
    }
  }
`;exports.SortableImage=({id:s,src:f,index:j,onRemove:b,propKey:K,imageHeight:v=150,actions:h=["editInfo","editEvent","timingConfig"],separateDevice:O,imageSettingCustom:S})=>{const{attributes:C,listeners:_,setNodeRef:Y,transform:q,transition:I}=n.useSortable({id:s}),[k,w]=i.useState(!1),[D,$]=i.useState(!1),[z,B]=i.useState(!1),{document:T}=l.useFrame(),V=P.default.useRef(null),F=S;return e.jsxs(e.Fragment,{children:[e.jsxs(E,{style:{transform:o.CSS.Transform.toString(q),transition:I},ref:Y,children:[e.jsx(r.Tag,{color:"#fff",style:{color:"#333",borderRadius:999,position:"absolute",top:10,left:10,zIndex:1,boxShadow:"0px 0px 4px rgba(68, 68, 68, 0.1)"},children:j+1}),e.jsxs(r.Space,{style:{position:"absolute",top:10,right:10,zIndex:1},children:[h.map((t=>e.jsxs("div",{className:"action-button",children:["editInfo"===t&&e.jsx(r.Button,{shape:"circle",type:"default",onClick:()=>w(!0),icon:e.jsx(c.SettingsRegular,{style:{fontSize:14}})}),"editEvent"===t&&e.jsx(r.Button,{shape:"circle",type:"default",onClick:()=>$(!0),icon:e.jsx(c.LinkRegular,{style:{fontSize:14}})}),"timingConfig"===t&&e.jsx(r.Button,{shape:"circle",type:"default",onClick:()=>B(!0),icon:e.jsx(c.ClockRegular,{style:{fontSize:14}})}),"function"==typeof t&&e.jsx(t,{propKey:K,index:j,separateDevice:O})]}))),e.jsx("div",{className:"action-button",children:e.jsx(r.Button,{shape:"circle",type:"default",onClick:b,icon:e.jsx(c.DeleteRegular,{style:{fontSize:14}})})})]}),e.jsx(r.Image,(G=R(R({},_),C),N={src:f,height:v,width:"100%",style:{objectFit:"cover",borderRadius:4},fallback:u,preview:!1,onDoubleClick:()=>{var e,t;return null==(t=null==(e=null==V?void 0:V.current)?void 0:e.querySelector("input"))?void 0:t.click()}},m(G,x(N))))]}),e.jsx(r.Modal,{zIndex:1080,open:k,onCancel:()=>w(!1),cancelButtonProps:{style:{display:"none"}},destroyOnClose:!0,onOk:()=>w(!1),closable:!1,okText:t.t("Đóng"),title:t.t("Chỉnh sửa thông tin ảnh"),getContainer:()=>(null==T?void 0:T.body)||(null==document?void 0:document.body),children:S?e.jsx(F,{index:j}):e.jsx(a.ImageSetting,{separateDevice:O,srcPropKey:y.PROP_KEY.joinKey(K,`[${j}]`,y.PROP_KEY.Src),widthPropKey:y.PROP_KEY.joinKey(K,`[${j}]`,y.PROP_KEY.GoogleImageParams,y.PROP_KEY.Width),altPropKey:y.PROP_KEY.joinKey(K,`[${j}]`,y.PROP_KEY.Alt)})}),e.jsx(d.EventConfig,{separateDevice:O,propKey:y.PROP_KEY.joinKey(K,`[${j}]`),visible:D,setVisible:$}),e.jsx(p.TimeVisibilityConfig,{visible:z,setVisible:B,propKey:y.PROP_KEY.joinKey(K,`[${j}]`),separateDevice:O}),e.jsx("div",{ref:V,style:{display:"none"},children:e.jsx(g.ImageUploadButton,{imagePropKey:y.PROP_KEY.joinKey(K,`[${j}]`,y.PROP_KEY.Src),widthPropKey:y.PROP_KEY.joinKey(K,`[${j}]`,y.PROP_KEY.GoogleImageParams,y.PROP_KEY.Width),heightPropKey:y.PROP_KEY.joinKey(K,`[${j}]`,y.PROP_KEY.GoogleImageParams,y.PROP_KEY.Height)})})]});var G,N};


/***/ }),

/***/ 741817:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(411156),i=__webpack_require__(78922),o=__webpack_require__(96179);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=s(r);const n=a.default.div`
  flex: 1;
  color: ${({isActive:e})=>e?"#7367F0":"#747474"};
  cursor: pointer;
`,c=a.default.div`
  display: flex;
  gap: 8px;
  margin-top: 8px;
`;exports.ImageRatioConfig=({propKey:r,separateDevice:s})=>{const[a,p]=i.usePropSeparateDevice(o.PROP_KEY.joinKey(r,o.PROP_KEY.AspectRatio),s);return e.jsx(c,{children:Object.entries(t.ICON_ASPECT_RATIO).map((([r,t])=>e.jsx(n,{isActive:a==r,onClick:()=>p(r),children:t},r)))})};


/***/ }),

/***/ 411156:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var C=__webpack_require__(561261);const t={"2/1":C.jsxs("svg",{width:"36",height:"18",viewBox:"0 0 36 18",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[C.jsx("rect",{width:"36",height:"18",transform:"translate(0 0.00195312)",fill:"currentColor"}),C.jsx("path",{d:"M15.3936 12.2832V13.502H9.19824V12.4546L12.207 9.17285C12.5371 8.80046 12.7974 8.47884 12.9878 8.20801C13.1782 7.93717 13.3115 7.69385 13.3877 7.47803C13.4681 7.25798 13.5083 7.04427 13.5083 6.83691C13.5083 6.54492 13.4533 6.2889 13.3433 6.06885C13.2375 5.84456 13.0809 5.66895 12.8735 5.54199C12.6662 5.41081 12.4144 5.34521 12.1182 5.34521C11.7754 5.34521 11.4876 5.41927 11.2549 5.56738C11.0221 5.71549 10.8465 5.92074 10.728 6.18311C10.6095 6.44124 10.5503 6.73747 10.5503 7.07178H9.02051C9.02051 6.53434 9.14323 6.04346 9.38867 5.59912C9.63411 5.15055 9.98958 4.79508 10.4551 4.53271C10.9206 4.26611 11.4813 4.13281 12.1372 4.13281C12.755 4.13281 13.2798 4.23649 13.7114 4.44385C14.1431 4.6512 14.471 4.94531 14.6953 5.32617C14.9238 5.70703 15.0381 6.15771 15.0381 6.67822C15.0381 6.96598 14.9915 7.25163 14.8984 7.53516C14.8053 7.81868 14.672 8.10221 14.4985 8.38574C14.3293 8.66504 14.1283 8.94645 13.8955 9.22998C13.6628 9.50928 13.4067 9.79281 13.1274 10.0806L11.1279 12.2832H15.3936ZM16.6948 12.7402C16.6948 12.5033 16.7752 12.3044 16.936 12.1436C17.0968 11.9785 17.3148 11.896 17.5898 11.896C17.8691 11.896 18.0871 11.9785 18.2437 12.1436C18.4045 12.3044 18.4849 12.5033 18.4849 12.7402C18.4849 12.9772 18.4045 13.1761 18.2437 13.3369C18.0871 13.4977 17.8691 13.5781 17.5898 13.5781C17.3148 13.5781 17.0968 13.4977 16.936 13.3369C16.7752 13.1761 16.6948 12.9772 16.6948 12.7402ZM16.7012 7.33203C16.7012 7.09505 16.7816 6.89616 16.9424 6.73535C17.1032 6.57031 17.3211 6.48779 17.5962 6.48779C17.8755 6.48779 18.0934 6.57031 18.25 6.73535C18.4108 6.89616 18.4912 7.09505 18.4912 7.33203C18.4912 7.56901 18.4108 7.7679 18.25 7.92871C18.0934 8.08952 17.8755 8.16992 17.5962 8.16992C17.3211 8.16992 17.1032 8.08952 16.9424 7.92871C16.7816 7.7679 16.7012 7.56901 16.7012 7.33203ZM24.1914 4.22803V13.502H22.6616V6.04346L20.3955 6.81152V5.54834L24.0073 4.22803H24.1914Z",fill:"white"})]}),"3/2":C.jsxs("svg",{width:"36",height:"24",viewBox:"0 0 36 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[C.jsx("path",{d:"M36 0.00195312H0V24.002H36V0.00195312Z",fill:"currentColor"}),C.jsx("path",{d:"M10.9946 11.189H11.9087C12.2642 11.189 12.5583 11.1276 12.791 11.0049C13.028 10.8822 13.2036 10.7129 13.3179 10.4971C13.4321 10.2812 13.4893 10.0337 13.4893 9.7544C13.4893 9.4624 13.4364 9.2127 13.3306 9.0054C13.229 8.7938 13.0724 8.6309 12.8608 8.5166C12.6535 8.4023 12.389 8.3452 12.0674 8.3452C11.7965 8.3452 11.5511 8.4002 11.3311 8.5103C11.1152 8.616 10.9438 8.7684 10.8169 8.9673C10.6899 9.1619 10.6265 9.3947 10.6265 9.6655H9.09031C9.09031 9.1746 9.2194 8.7388 9.4775 8.3579C9.7357 7.9771 10.0869 7.6787 10.5312 7.4629C10.9798 7.2428 11.4834 7.1328 12.042 7.1328C12.6387 7.1328 13.1592 7.2323 13.6035 7.4312C14.0521 7.6258 14.4012 7.9178 14.6509 8.3071C14.9006 8.6965 15.0254 9.1789 15.0254 9.7544C15.0254 10.0168 14.964 10.2834 14.8413 10.5542C14.7186 10.825 14.5366 11.0726 14.2954 11.2969C14.0542 11.5169 13.7537 11.6968 13.394 11.8364C13.0343 11.9718 12.6175 12.0396 12.1436 12.0396H10.9946V11.189ZM10.9946 12.3823V11.5444H12.1436C12.6852 11.5444 13.1465 11.6079 13.5273 11.7349C13.9124 11.8618 14.2256 12.0374 14.4668 12.2617C14.708 12.4818 14.8836 12.7336 14.9937 13.0171C15.1079 13.3006 15.165 13.6011 15.165 13.9185C15.165 14.3501 15.0868 14.7352 14.9302 15.0737C14.7778 15.408 14.5599 15.6916 14.2764 15.9243C13.9928 16.1571 13.6606 16.3327 13.2798 16.4512C12.9032 16.5697 12.4927 16.6289 12.0483 16.6289C11.6506 16.6289 11.2697 16.5739 10.9058 16.4639C10.5418 16.3538 10.216 16.1909 9.9282 15.9751C9.6405 15.755 9.4119 15.4821 9.2427 15.1562C9.0776 14.8262 8.9951 14.4453 8.9951 14.0137H10.5249C10.5249 14.2887 10.5884 14.5321 10.7153 14.7437C10.8465 14.951 11.0285 15.1139 11.2612 15.2324C11.4982 15.3509 11.769 15.4102 12.0737 15.4102C12.3953 15.4102 12.6725 15.353 12.9053 15.2388C13.138 15.1245 13.3158 14.9552 13.4385 14.731C13.5654 14.5067 13.6289 14.2358 13.6289 13.9185C13.6289 13.5588 13.5591 13.2668 13.4194 13.0425C13.2798 12.8182 13.0809 12.6532 12.8228 12.5474C12.5646 12.4373 12.2599 12.3823 11.9087 12.3823H10.9946ZM16.6948 15.7402C16.6948 15.5033 16.7752 15.3044 16.936 15.1436C17.0968 14.9785 17.3148 14.896 17.5898 14.896C17.8691 14.896 18.0871 14.9785 18.2437 15.1436C18.4045 15.3044 18.4849 15.5033 18.4849 15.7402C18.4849 15.9772 18.4045 16.1761 18.2437 16.3369C18.0871 16.4977 17.8691 16.5781 17.5898 16.5781C17.3148 16.5781 17.0968 16.4977 16.936 16.3369C16.7752 16.1761 16.6948 15.9772 16.6948 15.7402ZM16.7012 10.332C16.7012 10.0951 16.7816 9.8962 16.9424 9.7354C17.1032 9.5703 17.3211 9.4878 17.5962 9.4878C17.8755 9.4878 18.0934 9.5703 18.25 9.7354C18.4108 9.8962 18.4912 10.0951 18.4912 10.332C18.4912 10.569 18.4108 10.7679 18.25 10.9287C18.0934 11.0895 17.8755 11.1699 17.5962 11.1699C17.3211 11.1699 17.1032 11.0895 16.9424 10.9287C16.7816 10.7679 16.7012 10.569 16.7012 10.332ZM26.21 15.2832V16.502H20.0146V15.4546L23.0234 12.1729C23.3535 11.8005 23.6138 11.4788 23.8042 11.208C23.9946 10.9372 24.1279 10.6938 24.2041 10.478C24.2845 10.258 24.3247 10.0443 24.3247 9.8369C24.3247 9.5449 24.2697 9.2889 24.1597 9.0688C24.0539 8.8446 23.8973 8.6689 23.6899 8.542C23.4826 8.4108 23.2308 8.3452 22.9346 8.3452C22.5918 8.3452 22.304 8.4193 22.0713 8.5674C21.8385 8.7155 21.6629 8.9207 21.5444 9.1831C21.4259 9.4412 21.3667 9.7375 21.3667 10.0718H19.8369C19.8369 9.5343 19.9596 9.0435 20.2051 8.5991C20.4505 8.1506 20.806 7.7951 21.2715 7.5327C21.737 7.2661 22.2977 7.1328 22.9536 7.1328C23.5715 7.1328 24.0962 7.2365 24.5278 7.4438C24.9595 7.6512 25.2874 7.9453 25.5117 8.3262C25.7402 8.707 25.8545 9.1577 25.8545 9.6782C25.8545 9.966 25.8079 10.2516 25.7148 10.5352C25.6217 10.8187 25.4884 11.1022 25.3149 11.3857C25.1457 11.665 24.9447 11.9465 24.7119 12.23C24.4792 12.5093 24.2231 12.7928 23.9438 13.0806L21.9443 15.2832H26.21Z",fill:"white"})]}),"4/3":C.jsxs("svg",{width:"36",height:"27",viewBox:"0 0 36 27",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[C.jsx("rect",{width:"36",height:"27",transform:"translate(0 0.00195312)",fill:"currentColor"}),C.jsx("path",{d:"M15.5649 14.7075V15.9263H8.8999L8.84912 15.0059L12.8354 8.75977H14.0605L12.7339 11.0322L10.4424 14.7075H15.5649ZM14.4097 8.75977V18.002H12.8799V8.75977H14.4097ZM16.6948 17.2402C16.6948 17.0033 16.7752 16.8044 16.936 16.6436C17.0968 16.4785 17.3148 16.396 17.5898 16.396C17.8691 16.396 18.0871 16.4785 18.2437 16.6436C18.4045 16.8044 18.4849 17.0033 18.4849 17.2402C18.4849 17.4772 18.4045 17.6761 18.2437 17.8369C18.0871 17.9977 17.8691 18.0781 17.5898 18.0781C17.3148 18.0781 17.0968 17.9977 16.936 17.8369C16.7752 17.6761 16.6948 17.4772 16.6948 17.2402ZM16.7012 11.832C16.7012 11.5951 16.7816 11.3962 16.9424 11.2354C17.1032 11.0703 17.3211 10.9878 17.5962 10.9878C17.8755 10.9878 18.0934 11.0703 18.25 11.2354C18.4108 11.3962 18.4912 11.5951 18.4912 11.832C18.4912 12.069 18.4108 12.2679 18.25 12.4287C18.0934 12.5895 17.8755 12.6699 17.5962 12.6699C17.3211 12.6699 17.1032 12.5895 16.9424 12.4287C16.7816 12.2679 16.7012 12.069 16.7012 11.832ZM21.811 12.689H22.7251C23.0806 12.689 23.3747 12.6276 23.6074 12.5049C23.8444 12.3822 24.02 12.2129 24.1343 11.9971C24.2485 11.7812 24.3057 11.5337 24.3057 11.2544C24.3057 10.9624 24.2528 10.7127 24.147 10.5054C24.0454 10.2938 23.8888 10.1309 23.6772 10.0166C23.4699 9.90234 23.2054 9.84521 22.8838 9.84521C22.613 9.84521 22.3675 9.90023 22.1475 10.0103C21.9316 10.116 21.7603 10.2684 21.6333 10.4673C21.5063 10.6619 21.4429 10.8947 21.4429 11.1655H19.9067C19.9067 10.6746 20.0358 10.2388 20.2939 9.85791C20.5521 9.47705 20.9033 9.17871 21.3477 8.96289C21.7962 8.74284 22.2998 8.63281 22.8584 8.63281C23.4551 8.63281 23.9756 8.73226 24.4199 8.93115C24.8685 9.12581 25.2176 9.41781 25.4673 9.80713C25.717 10.1965 25.8418 10.6789 25.8418 11.2544C25.8418 11.5168 25.7804 11.7834 25.6577 12.0542C25.535 12.325 25.353 12.5726 25.1118 12.7969C24.8706 13.0169 24.5701 13.1968 24.2104 13.3364C23.8507 13.4718 23.4339 13.5396 22.96 13.5396H21.811V12.689ZM21.811 13.8823V13.0444H22.96C23.5016 13.0444 23.9629 13.1079 24.3438 13.2349C24.7288 13.3618 25.042 13.5374 25.2832 13.7617C25.5244 13.9818 25.7 14.2336 25.8101 14.5171C25.9243 14.8006 25.9814 15.1011 25.9814 15.4185C25.9814 15.8501 25.9032 16.2352 25.7466 16.5737C25.5942 16.908 25.3763 17.1916 25.0928 17.4243C24.8092 17.6571 24.4771 17.8327 24.0962 17.9512C23.7196 18.0697 23.3091 18.1289 22.8647 18.1289C22.467 18.1289 22.0861 18.0739 21.7222 17.9639C21.3582 17.8538 21.0324 17.6909 20.7446 17.4751C20.4569 17.255 20.2284 16.9821 20.0591 16.6562C19.894 16.3262 19.8115 15.9453 19.8115 15.5137H21.3413C21.3413 15.7887 21.4048 16.0321 21.5317 16.2437C21.6629 16.451 21.8449 16.6139 22.0776 16.7324C22.3146 16.8509 22.5854 16.9102 22.8901 16.9102C23.2118 16.9102 23.4889 16.853 23.7217 16.7388C23.9544 16.6245 24.1322 16.4552 24.2549 16.231C24.3818 16.0067 24.4453 15.7358 24.4453 15.4185C24.4453 15.0588 24.3755 14.7668 24.2358 14.5425C24.0962 14.3182 23.8973 14.1532 23.6392 14.0474C23.381 13.9373 23.0763 13.8823 22.7251 13.8823H21.811Z",fill:"white"})]}),"1/1":C.jsxs("svg",{width:"36",height:"36",viewBox:"0 0 36 36",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[C.jsx("rect",{width:"36",height:"36",transform:"translate(0 0.00195312)",fill:"currentColor"}),C.jsx("path",{d:"M13.375 13.228V22.502H11.8452V15.0435L9.5791 15.8115V14.5483L13.1909 13.228H13.375ZM16.6948 21.7402C16.6948 21.5033 16.7752 21.3044 16.936 21.1436C17.0968 20.9785 17.3148 20.896 17.5898 20.896C17.8691 20.896 18.0871 20.9785 18.2437 21.1436C18.4045 21.3044 18.4849 21.5033 18.4849 21.7402C18.4849 21.9772 18.4045 22.1761 18.2437 22.3369C18.0871 22.4977 17.8691 22.5781 17.5898 22.5781C17.3148 22.5781 17.0968 22.4977 16.936 22.3369C16.7752 22.1761 16.6948 21.9772 16.6948 21.7402ZM16.7012 16.332C16.7012 16.0951 16.7816 15.8962 16.9424 15.7354C17.1032 15.5703 17.3211 15.4878 17.5962 15.4878C17.8755 15.4878 18.0934 15.5703 18.25 15.7354C18.4108 15.8962 18.4912 16.0951 18.4912 16.332C18.4912 16.569 18.4108 16.7679 18.25 16.9287C18.0934 17.0895 17.8755 17.1699 17.5962 17.1699C17.3211 17.1699 17.1032 17.0895 16.9424 16.9287C16.7816 16.7679 16.7012 16.569 16.7012 16.332ZM24.1914 13.228V22.502H22.6616V15.0435L20.3955 15.8115V14.5483L24.0073 13.228H24.1914Z",fill:"white"})]}),"3/4":C.jsxs("svg",{width:"36",height:"48",viewBox:"0 0 36 48",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[C.jsx("rect",{width:"36",height:"48",transform:"translate(0 0.00195312)",fill:"currentColor"}),C.jsx("path",{d:"M10.9946 23.189H11.9087C12.2642 23.189 12.5583 23.1276 12.791 23.0049C13.028 22.8822 13.2036 22.7129 13.3179 22.4971C13.4321 22.2812 13.4893 22.0337 13.4893 21.7544C13.4893 21.4624 13.4364 21.2127 13.3306 21.0054C13.229 20.7938 13.0724 20.6309 12.8608 20.5166C12.6535 20.4023 12.389 20.3452 12.0674 20.3452C11.7965 20.3452 11.5511 20.4002 11.3311 20.5103C11.1152 20.616 10.9438 20.7684 10.8169 20.9673C10.6899 21.1619 10.6265 21.3947 10.6265 21.6655H9.09033C9.09033 21.1746 9.2194 20.7388 9.47754 20.3579C9.73568 19.9771 10.0869 19.6787 10.5312 19.4629C10.9798 19.2428 11.4834 19.1328 12.042 19.1328C12.6387 19.1328 13.1592 19.2323 13.6035 19.4312C14.0521 19.6258 14.4012 19.9178 14.6509 20.3071C14.9006 20.6965 15.0254 21.1789 15.0254 21.7544C15.0254 22.0168 14.964 22.2834 14.8413 22.5542C14.7186 22.825 14.5366 23.0726 14.2954 23.2969C14.0542 23.5169 13.7537 23.6968 13.394 23.8364C13.0343 23.9718 12.6175 24.0396 12.1436 24.0396H10.9946V23.189ZM10.9946 24.3823V23.5444H12.1436C12.6852 23.5444 13.1465 23.6079 13.5273 23.7349C13.9124 23.8618 14.2256 24.0374 14.4668 24.2617C14.708 24.4818 14.8836 24.7336 14.9937 25.0171C15.1079 25.3006 15.165 25.6011 15.165 25.9185C15.165 26.3501 15.0868 26.7352 14.9302 27.0737C14.7778 27.408 14.5599 27.6916 14.2764 27.9243C13.9928 28.1571 13.6606 28.3327 13.2798 28.4512C12.9032 28.5697 12.4927 28.6289 12.0483 28.6289C11.6506 28.6289 11.2697 28.5739 10.9058 28.4639C10.5418 28.3538 10.216 28.1909 9.92822 27.9751C9.64046 27.755 9.41195 27.4821 9.24268 27.1562C9.07764 26.8262 8.99512 26.4453 8.99512 26.0137H10.5249C10.5249 26.2887 10.5884 26.5321 10.7153 26.7437C10.8465 26.951 11.0285 27.1139 11.2612 27.2324C11.4982 27.3509 11.769 27.4102 12.0737 27.4102C12.3953 27.4102 12.6725 27.353 12.9053 27.2388C13.138 27.1245 13.3158 26.9552 13.4385 26.731C13.5654 26.5067 13.6289 26.2358 13.6289 25.9185C13.6289 25.5588 13.5591 25.2668 13.4194 25.0425C13.2798 24.8182 13.0809 24.6532 12.8228 24.5474C12.5646 24.4373 12.2599 24.3823 11.9087 24.3823H10.9946ZM16.6948 27.7402C16.6948 27.5033 16.7752 27.3044 16.936 27.1436C17.0968 26.9785 17.3148 26.896 17.5898 26.896C17.8691 26.896 18.0871 26.9785 18.2437 27.1436C18.4045 27.3044 18.4849 27.5033 18.4849 27.7402C18.4849 27.9772 18.4045 28.1761 18.2437 28.3369C18.0871 28.4977 17.8691 28.5781 17.5898 28.5781C17.3148 28.5781 17.0968 28.4977 16.936 28.3369C16.7752 28.1761 16.6948 27.9772 16.6948 27.7402ZM16.7012 22.332C16.7012 22.0951 16.7816 21.8962 16.9424 21.7354C17.1032 21.5703 17.3211 21.4878 17.5962 21.4878C17.8755 21.4878 18.0934 21.5703 18.25 21.7354C18.4108 21.8962 18.4912 22.0951 18.4912 22.332C18.4912 22.569 18.4108 22.7679 18.25 22.9287C18.0934 23.0895 17.8755 23.1699 17.5962 23.1699C17.3211 23.1699 17.1032 23.0895 16.9424 22.9287C16.7816 22.7679 16.7012 22.569 16.7012 22.332ZM26.3813 25.2075V26.4263H19.7163L19.6655 25.5059L23.6519 19.2598H24.877L23.5503 21.5322L21.2588 25.2075H26.3813ZM25.2261 19.2598V28.502H23.6963V19.2598H25.2261Z",fill:"white"})]}),"2/3":C.jsxs("svg",{width:"36",height:"54",viewBox:"0 0 36 54",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[C.jsx("rect",{width:"36",height:"54",transform:"translate(0 0.00195312)",fill:"currentColor"}),C.jsx("path",{d:"M15.3936 30.2832V31.502H9.19824V30.4546L12.207 27.1729C12.5371 26.8005 12.7974 26.4788 12.9878 26.208C13.1782 25.9372 13.3115 25.6938 13.3877 25.478C13.4681 25.258 13.5083 25.0443 13.5083 24.8369C13.5083 24.5449 13.4533 24.2889 13.3433 24.0688C13.2375 23.8446 13.0809 23.6689 12.8735 23.542C12.6662 23.4108 12.4144 23.3452 12.1182 23.3452C11.7754 23.3452 11.4876 23.4193 11.2549 23.5674C11.0221 23.7155 10.8465 23.9207 10.728 24.1831C10.6095 24.4412 10.5503 24.7375 10.5503 25.0718H9.02051C9.02051 24.5343 9.14323 24.0435 9.38867 23.5991C9.63411 23.1506 9.98958 22.7951 10.4551 22.5327C10.9206 22.2661 11.4813 22.1328 12.1372 22.1328C12.755 22.1328 13.2798 22.2365 13.7114 22.4438C14.1431 22.6512 14.471 22.9453 14.6953 23.3262C14.9238 23.707 15.0381 24.1577 15.0381 24.6782C15.0381 24.966 14.9915 25.2516 14.8984 25.5352C14.8053 25.8187 14.672 26.1022 14.4985 26.3857C14.3293 26.665 14.1283 26.9465 13.8955 27.23C13.6628 27.5093 13.4067 27.7928 13.1274 28.0806L11.1279 30.2832H15.3936ZM16.6948 30.7402C16.6948 30.5033 16.7752 30.3044 16.936 30.1436C17.0968 29.9785 17.3148 29.896 17.5898 29.896C17.8691 29.896 18.0871 29.9785 18.2437 30.1436C18.4045 30.3044 18.4849 30.5033 18.4849 30.7402C18.4849 30.9772 18.4045 31.1761 18.2437 31.3369C18.0871 31.4977 17.8691 31.5781 17.5898 31.5781C17.3148 31.5781 17.0968 31.4977 16.936 31.3369C16.7752 31.1761 16.6948 30.9772 16.6948 30.7402ZM16.7012 25.332C16.7012 25.0951 16.7816 24.8962 16.9424 24.7354C17.1032 24.5703 17.3211 24.4878 17.5962 24.4878C17.8755 24.4878 18.0934 24.5703 18.25 24.7354C18.4108 24.8962 18.4912 25.0951 18.4912 25.332C18.4912 25.569 18.4108 25.7679 18.25 25.9287C18.0934 26.0895 17.8755 26.1699 17.5962 26.1699C17.3211 26.1699 17.1032 26.0895 16.9424 25.9287C16.7816 25.7679 16.7012 25.569 16.7012 25.332ZM21.811 26.189H22.7251C23.0806 26.189 23.3747 26.1276 23.6074 26.0049C23.8444 25.8822 24.02 25.7129 24.1343 25.4971C24.2485 25.2812 24.3057 25.0337 24.3057 24.7544C24.3057 24.4624 24.2528 24.2127 24.147 24.0054C24.0454 23.7938 23.8888 23.6309 23.6772 23.5166C23.4699 23.4023 23.2054 23.3452 22.8838 23.3452C22.613 23.3452 22.3675 23.4002 22.1475 23.5103C21.9316 23.616 21.7603 23.7684 21.6333 23.9673C21.5063 24.1619 21.4429 24.3947 21.4429 24.6655H19.9067C19.9067 24.1746 20.0358 23.7388 20.2939 23.3579C20.5521 22.9771 20.9033 22.6787 21.3477 22.4629C21.7962 22.2428 22.2998 22.1328 22.8584 22.1328C23.4551 22.1328 23.9756 22.2323 24.4199 22.4312C24.8685 22.6258 25.2176 22.9178 25.4673 23.3071C25.717 23.6965 25.8418 24.1789 25.8418 24.7544C25.8418 25.0168 25.7804 25.2834 25.6577 25.5542C25.535 25.825 25.353 26.0726 25.1118 26.2969C24.8706 26.5169 24.5701 26.6968 24.2104 26.8364C23.8507 26.9718 23.4339 27.0396 22.96 27.0396H21.811V26.189ZM21.811 27.3823V26.5444H22.96C23.5016 26.5444 23.9629 26.6079 24.3438 26.7349C24.7288 26.8618 25.042 27.0374 25.2832 27.2617C25.5244 27.4818 25.7 27.7336 25.8101 28.0171C25.9243 28.3006 25.9814 28.6011 25.9814 28.9185C25.9814 29.3501 25.9032 29.7352 25.7466 30.0737C25.5942 30.408 25.3763 30.6916 25.0928 30.9243C24.8092 31.1571 24.4771 31.3327 24.0962 31.4512C23.7196 31.5697 23.3091 31.6289 22.8647 31.6289C22.467 31.6289 22.0861 31.5739 21.7222 31.4639C21.3582 31.3538 21.0324 31.1909 20.7446 30.9751C20.4569 30.755 20.2284 30.4821 20.0591 30.1562C19.894 29.8262 19.8115 29.4453 19.8115 29.0137H21.3413C21.3413 29.2887 21.4048 29.5321 21.5317 29.7437C21.6629 29.951 21.8449 30.1139 22.0776 30.2324C22.3146 30.3509 22.5854 30.4102 22.8901 30.4102C23.2118 30.4102 23.4889 30.353 23.7217 30.2388C23.9544 30.1245 24.1322 29.9552 24.2549 29.731C24.3818 29.5067 24.4453 29.2358 24.4453 28.9185C24.4453 28.5588 24.3755 28.2668 24.2358 28.0425C24.0962 27.8182 23.8973 27.6532 23.6392 27.5474C23.381 27.4373 23.0763 27.3823 22.7251 27.3823H21.811Z",fill:"white"})]})};exports.ICON_ASPECT_RATIO=t;


/***/ }),

/***/ 300910:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(610314),t=__webpack_require__(78922),o=__webpack_require__(691171),p=Object.defineProperty,i=Object.defineProperties,s=Object.getOwnPropertyDescriptors,n=Object.getOwnPropertySymbols,a=Object.prototype.hasOwnProperty,l=Object.prototype.propertyIsEnumerable,u=(e,r,t)=>r in e?p(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,c=(e,r)=>{for(var t in r||(r={}))a.call(r,t)&&u(e,t,r[t]);if(n)for(var t of n(r))l.call(r,t)&&u(e,t,r[t]);return e},j=(e,r)=>i(e,s(r));const m=t=>e.jsx(r.Input,c({},t));exports.Input=m,exports.InputConfigV1=p=>{const{propKey:i,formItemProps:s,inputProps:n,separateDevice:a,showTooltip:l,tooltipProps:u={}}=p,[y,b]=t.usePropSeparateDevice(i,a),{layout:v="horizontal"}=s||{},P=()=>e.jsx(o.FormItem,j(c({layout:v},s),{children:e.jsx(m,c({value:y||"",onChange:e=>{b(e.target.value||void 0)},style:{width:"horizontal"===v?130:"100%"}},n))}));return l?e.jsx(r.Tooltip,j(c({title:y},u),{children:P()})):P()};


/***/ }),

/***/ 781883:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(891987),r=__webpack_require__(610314),o=__webpack_require__(212951),n=__webpack_require__(85097),i=__webpack_require__(300910),s=__webpack_require__(78922),a=__webpack_require__(691171);function u(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=u(o),p=Object.defineProperty,c=Object.defineProperties,f=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,j=Object.prototype.hasOwnProperty,v=Object.prototype.propertyIsEnumerable,m=(e,t,r)=>t in e?p(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,x=(e,t)=>{for(var r in t||(t={}))j.call(t,r)&&m(e,r,t[r]);if(d)for(var r of d(t))v.call(t,r)&&m(e,r,t[r]);return e},b=(e,t)=>c(e,f(t));const g=o=>{const{propKey:i,formItemProps:u,inputProps:l,separateDevice:p,showTooltip:c,tooltipProps:f={},validateRegex:d,validateMessage:j="Invalid input format"}=o,[v,m]=s.usePropSeparateDevice(i,p),[g,P]=t.useState(v||""),[h,O]=t.useState(),{layout:q="horizontal"}=u||{},[C,S]=t.useState(!1),w=t.useCallback(n.debounce((e=>{d&&e?d.test(e)&&m(e):m(e||void 0)}),300),[d,j,m]);t.useEffect((()=>{C||(P(v||""),O(void 0))}),[v,C]);const F=e=>{const t=e.target.value;if(S(!0),P(t),d&&t){const e=d.test(t);O(e?void 0:j)}else O(void 0);w(t)},D=()=>{S(!1)},V=()=>e.jsxs(e.Fragment,{children:[e.jsx(a.FormItem,b(x({layout:q},u),{children:e.jsx(y,x({value:g,onChange:F,onBlur:D,style:x({width:"horizontal"===q?130:"100%"},h?{borderColor:"#ff4d4f"}:{})},l))})),h&&e.jsx(I,{children:h})]});return c?e.jsx(r.Tooltip,b(x({title:v},f),{children:V()})):V()},y=t=>e.jsx(r.Input,x({},t)),I=l.default.div`
  margin: 8px 4px;
  color: #ff4d4f;
  font-size: 11px;
`;exports.InputConfig=t=>{const{featureFlags:r}=n.useStore();return(null==r?void 0:r.flagPB5729)?e.jsx(g,x({},t)):e.jsx(i.InputConfigV1,x({},t))},exports.InputConfigV2=g,exports.InputV2=y;


/***/ }),

/***/ 625861:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),n=__webpack_require__(253857);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const t=o(r).default.div`
  position: relative;

  &::before {
    z-index: 999;
    content: '';
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0px;
    left: 0px;
    display: none;
  }

  .fake-cursor {
    position: fixed;
    top: -12px;
    left: -12px;
    border-radius: 50%;
    pointer-events: none;
    z-index: 9999;
    will-change: transform;
    transform: translate3d(0, 0, 0);
    width: 10px;
    height: 10px;
    display: none;
  }

  &.drag-resizing::before,
  &.drag-resizing .fake-cursor {
    display: block;
  }
`;exports.AddonBeforeDragNumberConfig=({min:r,max:o,value:i,onChange:s,label:a,step:u=1})=>{const{handleMouseDown:l,wrapperRef:d}=n.useDragNumber({min:r,max:o,value:i,onChange:s,label:a,step:u});return e.jsx(t,{ref:d,onMouseDown:l,style:{cursor:"ew-resize",userSelect:"none"},children:a})};


/***/ }),

/***/ 505765:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(610314),n=__webpack_require__(891987),o=__webpack_require__(734957),i=__webpack_require__(691171),u=__webpack_require__(78922);function p(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=p(r),s=Object.defineProperty,l=Object.defineProperties,c=Object.getOwnPropertyDescriptors,f=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,v=(e,r,t)=>r in e?s(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,b=(e,r)=>{for(var t in r||(r={}))d.call(r,t)&&v(e,t,r[t]);if(f)for(var t of f(r))m.call(r,t)&&v(e,t,r[t]);return e},j=(e,r)=>l(e,c(r)),x=(e,r)=>{var t={};for(var n in e)d.call(e,n)&&r.indexOf(n)<0&&(t[n]=e[n]);if(null!=e&&f)for(var n of f(e))r.indexOf(n)<0&&m.call(e,n)&&(t[n]=e[n]);return t};const y=r=>{var i=r,{propKey:p,placeholder:a,unitProps:s={},usePropOptions:l,onChange:c,separateDevice:f,displayUnit:d=!0}=i,m=x(i,["propKey","placeholder","unitProps","usePropOptions","onChange","separateDevice","displayUnit"]);const{defaultValue:v,options:y}=s,[h,O]=u.usePropSeparateDevice(p,f,l),g=n.useRef();n.useEffect((()=>{(null==m?void 0:m.defaultValue)&&!h&&O(m.defaultValue)}),[]);const I=b({ref:g,value:h,onChange:e=>{c?c(e):O(null===e?void 0:e)},placeholder:a||"0"},m);return(null==y?void 0:y.length)?e.jsxs(t.Input.Group,{style:{width:"unset"},className:"d-flex align-items-center",children:[e.jsx(P,b({style:{width:100}},I)),e.jsx(o.UnitConfig,j(b({},s),{separateDevice:f}))]}):e.jsx(P,b(b({},I),v&&d&&{addonAfter:v}))},P=a.default(t.InputNumber)("\n  width: 130px;\n  border-radius: 4px 0px 0px 4px !important;\n  .ant-input-number-input {\n    &:hover {\n      //cursor: ew-resize;\n    }\n  }\n");exports.InputNumber=y,exports.InputNumberConfig=r=>{var t=r,{formItemProps:n,inputNumberProps:o}=t,u=x(t,["formItemProps","inputNumberProps"]);return e.jsx(i.FormItem,j(b({},n),{children:e.jsx(y,b(b({},u),o))}))};


/***/ }),

/***/ 432257:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),n=__webpack_require__(610314),o=__webpack_require__(891987),t=__webpack_require__(625861),i=__webpack_require__(959211),a=__webpack_require__(253857),l=__webpack_require__(691171),u=__webpack_require__(78922),s=__webpack_require__(734957);function p(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=p(r),c=Object.defineProperty,f=Object.defineProperties,m=Object.getOwnPropertyDescriptors,v=Object.getOwnPropertySymbols,g=Object.prototype.hasOwnProperty,b=Object.prototype.propertyIsEnumerable,x=(e,r,n)=>r in e?c(e,r,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[r]=n,j=(e,r)=>{for(var n in r||(r={}))g.call(r,n)&&x(e,n,r[n]);if(v)for(var n of v(r))b.call(r,n)&&x(e,n,r[n]);return e},h=(e,r)=>f(e,m(r)),y=(e,r)=>{var n={};for(var o in e)g.call(e,o)&&r.indexOf(o)<0&&(n[o]=e[o]);if(null!=e&&v)for(var o of v(e))r.indexOf(o)<0&&b.call(e,o)&&(n[o]=e[o]);return n};const D=r=>{var l=r,{propKey:p,placeholder:d,unitProps:c={},usePropOptions:f,onChange:m,separateDevice:v,displayUnit:g=!0,isDraggable:b=!0,iconBeforeAddon:x}=l,D=y(l,["propKey","placeholder","unitProps","usePropOptions","onChange","separateDevice","displayUnit","isDraggable","iconBeforeAddon"]);const{defaultValue:O,options:C}=c,[q,I]=u.usePropSeparateDevice(p,v,f),N=o.useRef(),A=e=>{m?m(e):I(null===e?void 0:e)},B={min:null==D?void 0:D.min,max:null==D?void 0:D.max,value:p?q:null==D?void 0:D.value,onChange:A,label:x||e.jsx(i.ArrowsBidirectional20Regular,{}),step:null==D?void 0:D.step},{handleMouseDown:U,wrapperRef:V}=a.useDragNumber(B);o.useEffect((()=>{(null==D?void 0:D.defaultValue)&&!q&&I(D.defaultValue)}),[]);const z=j({ref:N,value:p?q:null==D?void 0:D.value,onChange:A,placeholder:d||"0",addonBefore:b&&x&&e.jsx(t.AddonBeforeDragNumberConfig,{min:null==D?void 0:D.min,max:null==D?void 0:D.max,value:p?q:null==D?void 0:D.value,onChange:A,label:x,step:null==D?void 0:D.step}),controls:!1},D),F=b?{ref:V,onMouseDown:U}:{};return(null==C?void 0:C.length)?e.jsx(n.Input.Group,{style:{width:"unset"},className:"d-flex align-items-center",children:e.jsxs(P,h(j({},F),{children:[e.jsx(w,h(j({style:{width:100}},z),{isDraggable:b})),g&&e.jsx(s.UnitConfig,j({separateDevice:v},c))]}))}):e.jsx(P,h(j({},F),{children:e.jsx(w,j(j({isDraggable:b},z),O&&g&&{addonAfter:O}))}))},P=d.default.div`
  &.drag-resizing input {
    caret-color: transparent;
  }

  &.drag-resizing::before {
    z-index: 999;
    content: '';
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0px;
    left: 0px;
  }
  caret-color: unset;
`,w=d.default(n.InputNumber)((({isDraggable:e})=>`\n    width: 130px;\n    border-radius: 4px !important;\n    .ant-input-number-input {\n      ${e?"cursor: ew-resize;":""}\n    }\n  `));exports.InputNumberConfigV2=r=>{var n=r,{formItemProps:o,inputNumberProps:t}=n,i=y(n,["formItemProps","inputNumberProps"]);return e.jsx(l.FormItem,h(j({},o),{children:e.jsx(D,j(j({},i),t))}))},exports.InputNumberV2=D;


/***/ }),

/***/ 253857:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(891987);exports.useDragNumber=({min:r,max:n,value:t,onChange:u,step:l=1})=>{const o=e.useRef(null),s=e.useRef(u),i=e.useRef(null),c=e.useRef({x:0,y:0}),d=e.useRef(!1),a=e.useRef();return e.useEffect((()=>{s.current=u}),[u]),e.useEffect((()=>{var e;if(!o.current)return;const t=e=>{var t,u,m,v;const f=e.movementX,p=e.movementY;if(void 0===a.current||0===f||Math.abs(f)>100)return;d.current||(i.current.style.display="block",null==(t=null==o?void 0:o.current)||t.requestPointerLock(),null==(m=null==(u=null==o?void 0:o.current)?void 0:u.classList)||m.add("drag-resizing"),d.current=!0),((e,r)=>{c.current.x+=e,c.current.y+=r,c.current.x<0&&(c.current.x=window.innerWidth),c.current.x>window.innerWidth&&(c.current.x=0),i.current&&(i.current.style.transform=`translate3d(${c.current.x}px, ${c.current.y}px, 0)`)})(f,p);const x=f*Number(l);let w=(a.current||0)+x;a.current=w,void 0!==r&&"number"==typeof Number(r)&&(w=Math.max(Number(r),w)),void 0!==n&&"number"==typeof Number(n)&&(w=Math.min(Number(n),w)),null==(v=s.current)||v.call(s,w)},u=()=>{var e,r;a.current=void 0,d.current=!1,document.exitPointerLock(),null==(r=null==(e=null==o?void 0:o.current)?void 0:e.classList)||r.remove("drag-resizing"),i.current.style.display="none"};return null==(e=null==o?void 0:o.current)||e.addEventListener("mousemove",t),window.addEventListener("mouseup",u),()=>{var e;null==(e=null==o?void 0:o.current)||e.removeEventListener("mousemove",t),window.removeEventListener("mouseup",u)}}),[n,r,l]),e.useEffect((()=>{let e=document.getElementById("fake-cursor");return e||(e=document.createElement("div"),e.id="fake-cursor",e.innerHTML='\n        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"\n          xmlns="http://www.w3.org/2000/svg">\n          <path\n            d="M7.45 7.04999L2.5 12L7.447 16.947L7.448 13H16.55V16.95L21.5 12L16.55 7.04999V11H7.45V7.04999Z"\n            fill="#4B4B4B"\n          />\n        </svg>\n      ',Object.assign(e.style,{position:"fixed",top:"-12px",left:"-12px",borderRadius:"50%",pointerEvents:"none",zIndex:"9999",willChange:"transform",transform:"translate3d(0, 0, 0)",width:"10px",height:"10px",display:"none"}),document.body.appendChild(e)),i.current=e,()=>{e.remove()}}),[]),{handleMouseDown:e=>{e.currentTarget===o.current&&(a.current=t||0,c.current={x:e.clientX,y:e.clientY},i.current&&(i.current.style.transform=`translate3d(${e.clientX}px, ${e.clientY}px, 0)`))},wrapperRef:o}};


/***/ }),

/***/ 589375:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(959211),n=__webpack_require__(610314),o=__webpack_require__(891987),i=__webpack_require__(78922),u=__webpack_require__(691171);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=l(t),s=Object.defineProperty,p=Object.defineProperties,c=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,f=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,v=(e,t,r)=>t in e?s(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,b=(e,t)=>{for(var r in t||(t={}))f.call(t,r)&&v(e,r,t[r]);if(d)for(var r of d(t))m.call(t,r)&&v(e,r,t[r]);return e},y=(e,t)=>p(e,c(t));const h=a.default.div`
  position: relative;
  width: 100%;

  &:hover {
    cursor: pointer;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      border-radius: 4px;
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }
`,j=a.default(n.Dropdown)`
  min-width: unset !important;
`;exports.InputSelectConfig=({propKey:t,formItemProps:l,options:a,value:s,onChange:p,inputProps:c})=>{const[d,f]=i.usePropSeparateDevice(t),[m,v]=o.useState(s),[x,g]=o.useState(s),w=e=>{const t=(e=>{if(null==e||""===e)return m||(null==c?void 0:c.min)||"";if(void 0!==(null==c?void 0:c.min)||void 0!==(null==c?void 0:c.max)){const t=Number(e);if(isNaN(t))return m||(null==c?void 0:c.min)||"";const r=null==c?void 0:c.min,n=null==c?void 0:c.max;return Math.min(Math.max(t,null!=r?r:-1/0),null!=n?n:1/0)}return e})(e);""!==e&&null!=e?t!==(s||d||m)&&(v(t),g(t),"function"!=typeof p?f(t):p(t)):g(m)};return o.useEffect((()=>{const e=void 0!==s?s:d;v(e),g(e)}),[s,d]),e.jsx(u.FormItem,y(b({},l),{children:e.jsx(j,{menu:{items:a,selectedKeys:[null==m?void 0:m.toString()],onClick:({key:e})=>w(e)},trigger:["click"],overlayStyle:{zIndex:1080},arrow:!0,children:e.jsx(h,{children:e.jsx(n.Input,y(b({value:x,bordered:!1,suffix:e.jsx(r.ChevronDown16Regular,{}),onChange:e=>g(e.target.value),onPressEnter:()=>w(x),onBlur:()=>w(x)},c),{"data-testid":"font-size-input"}))})})}))};


/***/ }),

/***/ 754914:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(610314),t=__webpack_require__(78922),o=__webpack_require__(691171),a=Object.defineProperty,n=Object.defineProperties,p=Object.getOwnPropertyDescriptors,s=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,l=(e,r,t)=>r in e?a(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,c=(e,r)=>{for(var t in r||(r={}))i.call(r,t)&&l(e,t,r[t]);if(s)for(var t of s(r))u.call(r,t)&&l(e,t,r[t]);return e};exports.InputTextAreaConfig=a=>{const{propKey:s,formItemProps:i,textareaProps:u,separateDevice:l}=a,[m,j]=t.usePropSeparateDevice(s,l),{layout:y="horizontal"}=i||{};return e.jsx(e.Fragment,{children:e.jsx(o.FormItem,(b=c({layout:y},i),v={children:e.jsx(r.Input.TextArea,c({value:m,onChange:e=>j(e.target.value),style:{width:"horizontal"===y?130:"100%"}},u))},n(b,p(v))))});var b,v};


/***/ }),

/***/ 987359:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(112373),r=__webpack_require__(983642),i=__webpack_require__(477560),o=__webpack_require__(944200),n=__webpack_require__(104437),l=__webpack_require__(212951),a=__webpack_require__(959211),s=__webpack_require__(610314),d=__webpack_require__(891987),c=__webpack_require__(493959),u=__webpack_require__(623537),m=__webpack_require__(78922);function p(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var v=p(l),f=Object.defineProperty,g=Object.defineProperties,x=Object.getOwnPropertyDescriptors,j=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,b=Object.prototype.propertyIsEnumerable,I=(e,t,r)=>t in e?f(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,h=(e,t)=>{for(var r in t||(t={}))y.call(t,r)&&I(e,r,t[r]);if(j)for(var r of j(t))b.call(t,r)&&I(e,r,t[r]);return e},D=(e,t)=>g(e,x(t));const w=({index:r,item:i,onDuplicate:l,onRemove:d,activeItem:c,setActiveItem:u,activeItemConfig:m,activeItemConfigProps:p,allowRemove:v=!0,allowDuplicate:f=!0,separateDevice:g,allowDrag:x=!0,titleKey:j,customTitle:y})=>{const{setNodeRef:b,attributes:I,listeners:w,transform:O}=o.useSortable({id:null==i?void 0:i.dndId}),q=m;return e.jsx(e.Fragment,{children:e.jsxs(C,{ref:b,style:{transform:n.CSS.Transform.toString(O)},className:c===r?"active":null,children:[e.jsxs(P,{onClick:()=>{u(c===r?void 0:r)},children:[e.jsxs("div",{className:"flex",children:[x&&e.jsx(S,D(h(h({},w),I),{style:{cursor:"move",marginRight:8},children:e.jsx(t.HolderOutlined,{style:{fontSize:20}})})),e.jsx("div",{children:y?y(i):(k=i[j],((null==k?void 0:k.length)>30?k.substring(0,30)+"...":k)||r+1)})]}),e.jsxs("div",{className:"flex",children:[f&&e.jsx(S,{style:{marginRight:8},onClick:e=>{e.stopPropagation(),l()},children:e.jsx(a.CopyRegular,{fontSize:20})}),v&&e.jsx(S,{onClick:e=>{e.stopPropagation(),d()},children:e.jsx(a.DeleteRegular,{fontSize:20})})]})]}),c===r&&!!m&&e.jsxs(e.Fragment,{children:[e.jsx(s.Divider,{className:"my-half mb-0"}),e.jsx(q,h({index:r,separateDevice:g},p))]})]},r)});var k},C=v.default.div`
  justify-content: space-between;
  padding: 0.5rem;
  border-radius: 4px;
  border: 1px solid var(--border-color);
  margin-bottom: 8px;
  &.active {
    border-color: ${e=>e.theme.colorPrimary};
  }
`,P=v.default.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`,S=v.default.div`
  background-color: transparent;
  cursor: pointer;
`;exports.ItemConfig=w,exports.ItemListConfig=({activeItemConfig:n,activeItemConfigProps:l,defaultActiveItem:a,defaultItem:p,propKey:v,maxItem:f,allowDuplicate:g=!0,allowRemove:x=!0,allowInsert:I=!0,allowDrag:C=!0,addItemText:P=u.t("Thêm phần tử"),separateDevice:S=!1,customDuplicate:O,customInsert:q,customRemove:k,titleKey:R="title",customTitle:T,emptyDescription:A,handleChangeActiveIndex:N,addItemButtonProps:E})=>{var F,K;const[z,B]=m.usePropSeparateDevice(v,S,{formatter:e=>(e||[]).map((e=>D(h({},e),{dndId:e.dndId?e.dndId:c.v4()}))),parser:e=>(e||[]).map((e=>((e,t)=>{var r={};for(var i in e)y.call(e,i)&&t.indexOf(i)<0&&(r[i]=e[i]);if(null!=e&&j)for(var i of j(e))t.indexOf(i)<0&&b.call(e,i)&&(r[i]=e[i]);return r})(e,["dndId"])))}),[$,L]=d.useState(a||0),M=e=>{L(e),null==N||N(e)},_=q||(()=>{const e=h({},p);e.id&&(e.id=c.v4()),B([...z,h({},e)])}),H=k||(e=>{const t=[...z];t.splice(e,1),B(t)}),V=O||(e=>{if(z.length>=f)return;const t=h({},z[e]);t.id&&(t.id=c.v4());const r=[...z];r.splice(e+1,0,t),B(r)});return e.jsxs(e.Fragment,{children:[e.jsx(r.DndContext,{modifiers:[i.restrictToVerticalAxis,i.restrictToWindowEdges,i.restrictToFirstScrollableAncestor],onDragEnd:({active:e,over:t})=>{if((null==e?void 0:e.id)!==(null==t?void 0:t.id)){const r=[...z],i=r.findIndex((t=>t.dndId===(null==e?void 0:e.id))),n=r.findIndex((e=>e.dndId===(null==t?void 0:t.id)));B(o.arrayMove(r,i,n)),M(void 0)}},children:0===z.length?e.jsx(s.Empty,{description:A}):e.jsx(o.SortableContext,{items:null==(F=z.map)?void 0:F.call(z,(e=>e.dndId)),strategy:o.verticalListSortingStrategy,disabled:!C,children:null==(K=z.map)?void 0:K.call(z,((t,r)=>e.jsx(w,{activeItem:$,setActiveItem:M,item:t,index:r,onDuplicate:()=>V(r),onRemove:()=>H(r),activeItemConfig:n,activeItemConfigProps:l,allowDuplicate:g,allowRemove:x,separateDevice:S,allowDrag:C,titleKey:R,customTitle:T},r)))})}),I&&e.jsx(s.Button,D(h({style:{marginTop:8,marginBottom:8},disabled:f&&z.length>=f,type:"primary",block:!0,icon:e.jsx(t.PlusOutlined,{}),onClick:()=>_()},E),{children:P+(f?` (${z.length}/${f})`:"")}))]})};


/***/ }),

/***/ 767330:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(610314),i=__webpack_require__(112373),n=__webpack_require__(891987),o=__webpack_require__(212951),r=__webpack_require__(85097),a=__webpack_require__(623537),s=__webpack_require__(96179),l=__webpack_require__(78922),p=__webpack_require__(852989),u=__webpack_require__(505765);function c(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=c(o),m=Object.defineProperty,f=Object.defineProperties,P=Object.getOwnPropertyDescriptors,j=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,y=(e,t,i)=>t in e?m(e,t,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[t]=i,_=(e,t)=>{for(var i in t||(t={}))b.call(t,i)&&y(e,i,t[i]);if(j)for(var i of j(t))g.call(t,i)&&y(e,i,t[i]);return e};const O=d.default.div`
  position: relative;
  ${({spinning:e})=>e?"\n    &::after {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: rgba(255, 255, 255, 0.8);\n      z-index: 1;\n    }\n  ":""}
`,K=d.default(t.Upload)`
  .ant-upload-select,
  .ant-upload-list-item-container {
    width: 100% !important;
  }

  a {
    color: rgba(0, 0, 0, 0.88);
  }
`;exports.AnimationLottieConfig=({separateDevice:o=!1})=>{const c=s.PROP_KEY.joinKey(s.PROP_KEY.AnimationConfig,s.PROP_KEY.Url),d=s.PROP_KEY.joinKey(s.PROP_KEY.AnimationConfig,s.PROP_KEY.TotalFrame),m=s.PROP_KEY.joinKey(s.PROP_KEY.AnimationConfig,s.PROP_KEY.FrameShowPopup),j=s.PROP_KEY.joinKey(s.PROP_KEY.AnimationConfig,s.PROP_KEY.WrapperStyle),b=s.PROP_KEY.joinKey(j,s.PROP_KEY.Width),g=s.PROP_KEY.joinKey(j,s.PROP_KEY.Height),y=s.PROP_KEY.joinKey(j,s.PROP_KEY.Top),[h,v]=l.usePropSeparateDevice(c,o),[,x]=l.usePropSeparateDevice(d,o),[E,R]=l.usePropSeparateDevice(m,o),[Y,C]=n.useState(!1),[q,w]=n.useState([]),I=e=>URL.createObjectURL(e),{uploadFileHandler:D=I}=p.useBuilder();n.useEffect((()=>{w(h?[{url:h,uid:h,name:h.substring(h.lastIndexOf("/")+1)}]:[])}),[h]),n.useEffect((()=>{h&&(async e=>{var t,i;try{const n=await fetch(e),o=await n.json(),r=Number(null!=(t=null==o?void 0:o.ip)?t:0),a=Number(null!=(i=null==o?void 0:o.op)?i:0),s=Math.max(0,Math.ceil(a-r));s>0&&(x(s),(!E||E<=0)&&R(Math.ceil(.95*s)))}catch(e){}})(h)}),[h]);const S={beforeUpload:e=>"application/json"===e.type||e.name.toLowerCase().endsWith(".json")?!!(e.size<20971520)||(t.notification.error({message:a.t("upload.file_size_limit")}),!1):(t.notification.error({message:a.t("upload.invalid_file_format")}),!1),customRequest:async e=>{const{file:i,onSuccess:n,onError:o}=e;try{C(!0);const e=await D(i,"json");v(e),n(i)}catch(e){t.notification.error({message:a.t("upload.cannot_upload_file")}),o(e,i)}finally{C(!1)}},listType:h?"picture":"picture-card",maxCount:1,multiple:!1,fileList:q,onRemove:()=>{v(""),x(void 0),R(void 0)},accept:".json,application/json"};return e.jsxs(e.Fragment,{children:[e.jsxs("div",{style:{marginBottom:16},children:[e.jsx("label",{style:{display:"block",marginBottom:8,fontWeight:"bold"},children:a.t("config_lottie_animation")}),e.jsx(O,{spinning:Y,children:e.jsx(K,(U=_({},S),N={children:h?null:e.jsx("div",{style:{width:"100%"},children:Y?e.jsx(i.LoadingOutlined,{}):e.jsxs(e.Fragment,{children:[e.jsx(i.UploadOutlined,{}),e.jsx("div",{style:{marginTop:4},children:a.t("upload_lottie_animation")})]})})},f(U,P(N))))})]}),e.jsx(u.InputNumberConfig,{propKey:m,separateDevice:o,formItemProps:{label:a.t("frame_to_show_popup")}}),e.jsx(u.InputNumberConfig,{propKey:b,separateDevice:o,formItemProps:{label:a.t("Chiều rộng")},unitProps:{defaultValue:r.UnitEnum.pixel}}),e.jsx(u.InputNumberConfig,{propKey:g,separateDevice:o,formItemProps:{label:a.t("Chiều cao")},unitProps:{defaultValue:r.UnitEnum.pixel}}),e.jsx(u.InputNumberConfig,{propKey:y,separateDevice:o,formItemProps:{label:a.t("Khoảng cách trên")},unitProps:{defaultValue:r.UnitEnum.pixel}})]});var U,N};


/***/ }),

/***/ 982206:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(610314),o=__webpack_require__(891987),n=__webpack_require__(691171),a=__webpack_require__(78922);function p(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var u=p(r),i=Object.defineProperty,l=Object.defineProperties,s=Object.getOwnPropertyDescriptors,f=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,d=Object.prototype.propertyIsEnumerable,b=(e,r,t)=>r in e?i(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,m=(e,r)=>{for(var t in r||(r={}))c.call(r,t)&&b(e,t,r[t]);if(f)for(var t of f(r))d.call(r,t)&&b(e,t,r[t]);return e},v=(e,r)=>{var t={};for(var o in e)c.call(e,o)&&r.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&f)for(var o of f(e))r.indexOf(o)<0&&d.call(e,o)&&(t[o]=e[o]);return t};const P=r=>{var t=r,{propKey:n,placeholder:p,unitProps:u={},usePropOptions:i,onChange:l,separateDevice:s,label:f,isDisabled:c}=t,d=v(t,["propKey","placeholder","unitProps","usePropOptions","onChange","separateDevice","label","isDisabled"]);const{defaultValue:b}=u,[P,x]=a.usePropSeparateDevice(n,s,i),y=o.useRef();o.useEffect((()=>{(null==d?void 0:d.defaultValue)&&!P&&x(d.defaultValue)}),[]);const O=m({ref:y,value:P,onChange:e=>{l?l(e):x(null===e?void 0:e)},placeholder:p||""},d);return e.jsx(j,m(m({},O),b&&{addonAfter:b}))},j=u.default(t.InputNumber)`
  border-radius: 4px !important;

  .ant-input-number {
    background-color: #f5f5f5;
    padding-left: 10px !important;
  }
  .ant-input-number-affix-wrapper {
    background-color: #f5f5f5;
    border: none !important;
  }
  .ant-input-number-group-addon {
    background-color: #f5f5f5;
    color: #00000080;
    border: none !important;
  }
  .ant-input-number-handler-wrap {
    display: none !important;
  }
`;exports.MinMaxInput=P,exports.MinMaxInputConfig=r=>{var t,o,a=r,{formItemProps:p,inputNumberProps:u}=a,i=v(a,["formItemProps","inputNumberProps"]);return e.jsx(n.FormItem,(t=m({},p),o={children:e.jsx(P,m(m({},i),u))},l(t,s(o))))};


/***/ }),

/***/ 185789:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(623537),o=__webpack_require__(891987),i=__webpack_require__(85097),t=__webpack_require__(440178),s=__webpack_require__(96179),c=__webpack_require__(78922),a=__webpack_require__(924216);exports.OverlayConfig=({propKey:p=s.PROP_KEY.CommonStyle,separateDevice:n})=>{const[u,P]=o.useState(!1),l=s.PROP_KEY.joinKey(p,s.PROP_KEY.BackgroundOverlayType),v=s.PROP_KEY.joinKey(p,s.PROP_KEY.BackgroundOverlay),[y,S]=c.usePropSeparateDevice(l,n),[h,j]=c.usePropSeparateDevice(v,n);return o.useEffect((()=>{(y||h)&&P(!0)}),[]),e.jsx(t.SwitchToShow,{show:u,setShow:e=>{e?(P(!0),S(i.OverlayType.color)):(P(!1),S(void 0),j(void 0))},formItemProps:{label:r.t("Lớp phủ nền")},children:e.jsx(a.ColorPickerConfigV3,{propKey:v,gradientPicker:!0,separateDevice:n})})};


/***/ }),

/***/ 920375:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(610314),o=__webpack_require__(78922),t=__webpack_require__(691171),a=Object.defineProperty,p=Object.defineProperties,i=Object.getOwnPropertyDescriptors,n=Object.getOwnPropertySymbols,s=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,c=(e,r,o)=>r in e?a(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,l=(e,r)=>{for(var o in r||(r={}))s.call(r,o)&&c(e,o,r[o]);if(n)for(var o of n(r))u.call(r,o)&&c(e,o,r[o]);return e};exports.RadioConfig=a=>{const c=a,{formItemProps:f,radioGroupProps:m,propKey:v,separateDevice:b}=c,d=((e,r)=>{var o={};for(var t in e)s.call(e,t)&&r.indexOf(t)<0&&(o[t]=e[t]);if(null!=e&&n)for(var t of n(e))r.indexOf(t)<0&&u.call(e,t)&&(o[t]=e[t]);return o})(c,["formItemProps","radioGroupProps","propKey","separateDevice"]),[j,O]=o.usePropSeparateDevice(v,b);return e.jsx(t.FormItem,(P=l({},f),y={children:e.jsx(r.Radio.Group,l(l({value:j,onChange:e=>O(e.target.value)},m),d))},p(P,i(y))));var P,y};


/***/ }),

/***/ 71678:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(772139),o=__webpack_require__(891987),t=__webpack_require__(610314),n=__webpack_require__(2723),i=__webpack_require__(691171);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=a(r),u=Object.defineProperty,l=Object.defineProperties,c=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,f=(e,r,o)=>r in e?u(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,v=(e,r)=>{for(var o in r||(r={}))d.call(r,o)&&f(e,o,r[o]);if(p)for(var o of p(r))m.call(r,o)&&f(e,o,r[o]);return e};const{RangePicker:P}=t.DatePicker;exports.RangePickerConfig=({propKeyStart:r,propKeyEnd:t,rangePickerProps:a,formItemProps:u})=>{const[p,d]=n.useProp(r),[m,f]=n.useProp(t),j=o.useMemo((()=>p&&m?[s.default(p),s.default(m)]:[void 0,void 0]),[p,m]);return e.jsx(i.FormItem,(b=v({},u),y={children:e.jsx(P,v({allowClear:!1,value:j,onChange:e=>{if(!e)return d(void 0),void f(void 0);let[r,o]=e;"DD-MM-YYYY HH:mm"===(null==a?void 0:a.format)&&(r=null==r?void 0:r.second(0),o=null==o?void 0:o.second(0)),d(r.toISOString()),f(o.toISOString())},format:"DD-MM-YYYY HH:mm:ss"},a))},l(b,c(y))));var b,y};


/***/ }),

/***/ 87395:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(610314),o=__webpack_require__(891987),l=__webpack_require__(505765),t=__webpack_require__(78922),n=__webpack_require__(2723),u=__webpack_require__(691171),i=Object.defineProperty,s=Object.defineProperties,a=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,d=Object.prototype.propertyIsEnumerable,v=(e,r,o)=>r in e?i(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,f=(e,r)=>{for(var o in r||(r={}))c.call(r,o)&&v(e,o,r[o]);if(p)for(var o of p(r))d.call(r,o)&&v(e,o,r[o]);return e},m=(e,r)=>s(e,a(r));exports.RangeSliderConfig=i=>{const{propKey:s,separateDevice:a,usePropOptions:v,formItemProps:j,inputNumberProps:b,showInput:y=!0,unitProps:P,className:g,sliderProps:h}=i,x=h||{},{defaultValue:O}=x,I=((e,r)=>{var o={};for(var l in e)c.call(e,l)&&r.indexOf(l)<0&&(o[l]=e[l]);if(null!=e&&p)for(var l of p(e))r.indexOf(l)<0&&d.call(e,l)&&(o[l]=e[l]);return o})(x,["defaultValue"]),[w,q]=t.usePropSeparateDevice(s,a,v),[C,N]=n.useProp(null==P?void 0:P.propKey);o.useEffect((()=>{void 0!==O&&void 0===w&&q(O),(null==P?void 0:P.propKey)&&(null==P?void 0:P.defaultValue)&&!C&&N&&N(null==P?void 0:P.defaultValue)}),[]);const D=e=>{q(null===e?null!=O?O:void 0:e)};return e.jsx(u.FormItem,m(f({},j),{layout:"vertical",children:e.jsxs(r.Row,{gutter:16,style:{alignItems:"center"},children:[e.jsx(r.Col,{style:{flexGrow:1},children:e.jsx(r.Slider,f({className:g,value:w,onChange:D},I))}),e.jsx(r.Col,{children:y?e.jsx(l.InputNumber,m(f(f({value:w,unitProps:P,onChange:D,controls:!1},b),I),{style:{width:(null==P?void 0:P.options)&&(null==P?void 0:P.options.length)>0?60:P?95:60},separateDevice:a})):e.jsxs(e.Fragment,{children:[null!=w?w:null==I?void 0:I.value,null==P?void 0:P.defaultValue]})})]})}))};


/***/ }),

/***/ 2161:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),i=__webpack_require__(610314),r=__webpack_require__(891987),l=__webpack_require__(623537),s=__webpack_require__(568052),a=__webpack_require__(945315),n=__webpack_require__(2723);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=o(t);const p=({aspectRatio:t,isActive:i,onClick:r,label:l})=>e.jsx(u,{onClick:r,style:{aspectRatio:t,backgroundColor:i?"#7367F0":"#747474"},children:a.displayRatio(l)||a.displayRatio(t)}),c=d.default.div`
  max-width: 100%;
  padding-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`,u=d.default.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #747474;
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
`,x=d.default.div`
  max-width: 250px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  > div {
    height: 35px;
  }
`,h=d.default.div`
  display: grid;
  grid-template-columns: repeat(4, 35px);
  gap: 8px;
`;exports.RatioConfig=({propKey:t,label:o})=>{const[d,u]=n.useProp(t),[f,y]=r.useState(""),[g,j]=r.useState(""),v=e=>{u(e)};return e.jsxs(c,{children:[e.jsxs("div",{style:{display:"flex",justifyContent:"space-between",alignItems:"center"},children:[e.jsx(i.Typography.Title,{level:4,style:{fontSize:14,fontWeight:500,marginBottom:0},children:o||l.t("ratio_setting.ratio")}),e.jsx("span",{style:{fontWeight:600},children:d})]}),e.jsx("div",{children:e.jsx(x,{children:s.ASPECT_RATIO_HORIZONTAL_OPTIONS.map((t=>e.jsx(p,{aspectRatio:t,isActive:t===d,onClick:()=>{v(t)}})))})}),e.jsx("div",{children:e.jsx(h,{children:s.ASPECT_RATIO_VERTICAL_OPTIONS.map((t=>e.jsx(p,{aspectRatio:t,isActive:t===d,onClick:()=>{v(t)}})))})}),e.jsx("div",{style:{marginTop:12},children:e.jsxs(i.Space,{children:[e.jsx(i.InputNumber,{placeholder:l.t("ratio_setting.width"),type:"number",value:f,onChange:e=>y(e),style:{width:70},controls:!1}),"/",e.jsx(i.InputNumber,{placeholder:l.t("ratio_setting.height"),type:"number",value:g,onChange:e=>j(e),style:{width:70},controls:!1}),e.jsx(i.Button,{onClick:()=>{var e;const t=`${f} / ${g}`,i=null==(e=null==t?void 0:t.replace(/\s*/g,""))?void 0:e.replace("/"," / ");i&&a.validateRatio(i)&&(y(""),j(""),u(i))},disabled:!g||!f,type:"primary",children:l.t("ratio_setting.apply")})]})})]})};


/***/ }),

/***/ 568052:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.ASPECT_RATIO_HORIZONTAL_OPTIONS=["16 / 9","4 / 3","3 / 2","5 / 4"],exports.ASPECT_RATIO_VERTICAL_OPTIONS=["9 / 16","2 / 3","3 / 4","1 / 1"];


/***/ }),

/***/ 945315:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.displayRatio=e=>{var t;return null==(t=null==e?void 0:e.replace(/\s*/g,""))?void 0:t.replace("/",":")},exports.validateRatio=e=>/^\d+\s{0,1}\/\s{0,1}\d+$/.test(e.trim());


/***/ }),

/***/ 799194:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097),l=__webpack_require__(610314),i=__webpack_require__(891987),o=__webpack_require__(623537),n=__webpack_require__(11279),s=__webpack_require__(388798),a=__webpack_require__(96179),c=__webpack_require__(2723),u=__webpack_require__(301930);function d(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var p=d(t),f=Object.defineProperty,h=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,j=Object.prototype.propertyIsEnumerable,y=(e,t,r)=>t in e?f(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,g=(e,t)=>{for(var r in t||(t={}))b.call(t,r)&&y(e,r,t[r]);if(h)for(var r of h(t))j.call(t,r)&&y(e,r,t[r]);return e};const{Option:v}=l.Select,x=p.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
`,P=p.default(l.Tag)`
  border-radius: 16px;
`,O=p.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
`,m=p.default.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 250px;
`;exports.SelectArticleWebsite=({propKey:t,selectProps:d})=>{const p=a.PROP_KEY.joinKey(t,a.PROP_KEY.Event,a.PROP_KEY.OpenArticleOfWebsite,a.PROP_KEY.PageId),[f]=c.useProp(p),h=f||(null==d?void 0:d.value),{globalData:b={}}=r.useStore(),{websiteId:j,currentLanguage:y}=b||{},{debounceFetchArticleOptions:w,fetchArticleOptions:S,options:A,loading:C,loadMore:q,loadingMore:E,hasMore:K,fetchArticleById:_,loadingLabelArticle:I,searchQuery:R}=s.useArticleOptions({websiteId:j,websiteTranslationId:null==y?void 0:y.id}),M=i.useRef(!1);i.useEffect((()=>{h&&_(h)}),[]);const Y=i.useCallback((e=>{const t=e.target;!C&&(null==t?void 0:t.scrollTop)+(null==t?void 0:t.offsetHeight)>=(null==t?void 0:t.scrollHeight)-10&&K&&q()}),[C,K,q]),k=i.useCallback((t=>e.jsxs(e.Fragment,{children:[t,E&&e.jsx(O,{children:e.jsx(l.Spin,{size:"small"})})]})),[E]);return e.jsx(u.SelectConfig,{formItemProps:{style:{marginBottom:"0.5rem"}},selectProps:g({placeholder:o.t("article"),style:{width:"100%"},popupMatchSelectWidth:!1,showSearch:!0,filterOption:!1,onSearch:w,notFoundContent:e.jsx(x,{children:C?e.jsx(l.Spin,{}):o.t("not_found_article")}),loading:C||I,onDropdownVisibleChange:async e=>{e&&(M.current&&!R.current||(await S(""),M.current=!0))},onPopupScroll:Y,dropdownRender:k,getPopupContainer:e=>e.parentElement,disabled:I},d),propKey:p,children:A.map(((t,r)=>{return e.jsx(v,{value:t.value,children:e.jsxs("div",{style:{display:"flex",justifyContent:"space-between"},children:[e.jsx(m,{title:null==t?void 0:t.label,children:t.label}),e.jsx("span",{children:(l=null==t?void 0:t.status,l===n.ArticleStatus.Published?e.jsx(P,{style:{borderRadius:16},color:"#29CC6A",children:o.t("published")}):e.jsx(P,{color:"#A7ABC3",children:o.t("draft")}))})]})},`${t.value}${r}`);var l}))})};


/***/ }),

/***/ 11279:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=(e=>(e.Draft="draft",e.Published="published",e))(e||{});exports.ArticleStatus=e;


/***/ }),

/***/ 388798:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(891987),t=__webpack_require__(852989);exports.useArticleOptions=r=>{const[l,n]=e.useState([]),{websiteId:i,websiteTranslationId:a}=r,{getPages:u}=t.useBuilder(),[s,o]=e.useState(!1),[c,d]=e.useState(!1),[v,p]=e.useState(!1),[g,b]=e.useState(!1),f=e.useRef(0),h=e.useRef(1),y=e.useRef(""),A=e=>({label:null==e?void 0:e.name,value:null==e?void 0:e.id,status:null==e?void 0:e.status}),I=e=>{o(!0),1===h.current&&n([]),y.current=e,f.current+=1;const t=f.current;return u({websiteId:i,searchQuery:e||void 0,page:h.current,pageSize:20,isArticle:!0,websiteTranslationId:a}).then((e=>{var r,l,i,a;if(t!==f.current)return;const u=null==(i=null==(l=null==(r=null==e?void 0:e.data)?void 0:r.pages)?void 0:l.map)?void 0:i.call(l,(e=>A(e))),s=(null==(a=null==e?void 0:e.pagination)?void 0:a.totalItems)||0;return n((e=>1===h.current?u:[...e,...u])),p(s>20*h.current),u})).catch((e=>{n([])})).finally((()=>{o(!1)}))};return{loadMore:e.useCallback((async()=>{try{d(!0),h.current+=1,await I(y.current)}finally{d(!1)}d(!1)}),[]),debounceFetchArticleOptions:e.useMemo((()=>{let e;return t=>{e&&clearTimeout(e),e=setTimeout((()=>{h.current=1,I(t)}),500)}}),[]),loading:s,hasMore:v,options:l,setOptions:n,setLoading:o,fetchArticleOptions:I,loadingMore:c,convertArticleOption:A,fetchArticleById:e=>(b(!0),u({websiteId:i,page:1,pageSize:20,isArticle:!0,websiteTranslationId:a,ids:e}).then((e=>{var t,r,l;const i=null==(l=null==(r=null==(t=null==e?void 0:e.data)?void 0:t.pages)?void 0:r.map)?void 0:l.call(r,(e=>A(e)));n(i)})).catch((e=>{})).finally((()=>{b(!1)}))),loadingLabelArticle:g,searchQuery:y}};


/***/ }),

/***/ 301930:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(623537),t=__webpack_require__(610314),o=__webpack_require__(212951),n=__webpack_require__(891987),l=__webpack_require__(691171),i=__webpack_require__(78922);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=s(o),u=Object.defineProperty,p=Object.defineProperties,c=Object.getOwnPropertyDescriptors,f=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,v=Object.prototype.propertyIsEnumerable,y=(e,r,t)=>r in e?u(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,m=(e,r)=>{for(var t in r||(r={}))d.call(r,t)&&y(e,t,r[t]);if(f)for(var t of f(r))v.call(r,t)&&y(e,t,r[t]);return e},j=(e,r)=>p(e,c(r)),O=(e,r)=>{var t={};for(var o in e)d.call(e,o)&&r.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&f)for(var o of f(e))r.indexOf(o)<0&&v.call(e,o)&&(t[o]=e[o]);return t};const b=t=>{var o=t,{propKey:l,options:s,separateDevice:a,usePropOptions:u,requireExistedValue:p,value:c}=o,f=O(o,["propKey","options","separateDevice","usePropOptions","requireExistedValue","value"]);const[d,v]=i.usePropSeparateDevice(l,a,u),y=n.useRef(!1);return n.useEffect((()=>{y.current=!1}),[JSON.stringify(s)]),e.jsx(x,j(m({style:{width:130},dropdownStyle:{zIndex:1080},value:(()=>{let e=null!=c?c:d;return p&&!y.current&&-1===(null==s?void 0:s.findIndex((({value:r})=>r===e)))&&(e=null),e})(),onChange:v,options:s,placeholder:r.t("Chọn giá trị")},f),{onSelect:()=>y.current=!0}))},x=a.default(t.Select)`
  .ant-select-selector {
    border-radius: 4px !important;
  }
`;exports.Select=b,exports.SelectConfig=r=>{const t=r,{formItemProps:o,selectProps:n}=t,i=O(t,["formItemProps","selectProps"]),{layout:s="horizontal"}=o||{};return e.jsx(l.FormItem,j(m({layout:s},o),{children:e.jsx(b,m(m({allowClear:!0,style:{width:"vertical"===s?"100%":130}},n),i))}))};


/***/ }),

/***/ 88190:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(623537),o=__webpack_require__(212951),i=__webpack_require__(2723),t=__webpack_require__(96179),n=__webpack_require__(955448),p=__webpack_require__(432257),s=__webpack_require__(87395);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=a(o);const m={x:{min:-125,max:125},y:{min:-125,max:125},blur:{min:0,max:120},spread:{min:-125,max:125}},u=l.default.div`
  display: flex;
  max-width: 100%;
  height: 32px;
  margin-bottom: 28px;
  box-shadow: 0 2px 5px var(--box-shadow-color);
`,d=l.default.div`
  flex: 1;
  min-width: 0;
`,x=l.default.div`
  text-transform: capitalize;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  padding: 4px 4px 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;exports.ShadowConfig=({propKey:o=t.PROP_KEY.joinKey(t.PROP_KEY.CommonStyle,t.PROP_KEY.Shadow),shadowProps:a=["x","y","blur","spread"]})=>{const[l]=i.useProp(t.PROP_KEY.joinKey(o,"on")),f=a.map((e=>({label:e,inputNumberProps:m[e],propKey:t.PROP_KEY.joinKey(o,e)})));return e.jsxs(e.Fragment,{children:[e.jsx(n.SwitchConfig,{formItemProps:{label:r.t("Đổ bóng")},propKey:`${o}.on`}),l&&e.jsxs(e.Fragment,{children:[e.jsx(u,{children:f.map((({label:r,propKey:o,inputNumberProps:i})=>e.jsxs(d,{children:[e.jsx(p.InputNumberConfigV2,{propKey:o,formItemProps:{style:{marginBottom:0}},inputNumberProps:i,style:{width:"100%"}}),e.jsx(x,{children:r})]},o)))}),e.jsx(s.RangeSliderConfig,{formItemProps:{label:r.t("Độ đậm")},propKey:`${o}.opacity`,sliderProps:{min:0,max:1,defaultValue:.25,step:.25}})]})]})};


/***/ }),

/***/ 149716:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),o=__webpack_require__(78922),t=__webpack_require__(432257);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=n(r),u=Object.defineProperty,l=Object.defineProperties,p=Object.getOwnPropertyDescriptors,a=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,s=Object.prototype.propertyIsEnumerable,d=(e,r,o)=>r in e?u(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,b=(e,r)=>{for(var o in r||(r={}))c.call(r,o)&&d(e,o,r[o]);if(a)for(var o of a(r))s.call(r,o)&&d(e,o,r[o]);return e},f=(e=>(e.top="top",e.right="right",e.bottom="bottom",e.left="left",e.main="main",e))(f||{});const m=i.default.div`
  display: inline-block;
  width: 100%;

  .ant-input-number {
    background-color: #f1f2f6;
    width: 100%;
    border: none !important;
  }

  .ant-input-number-group-addon {
    background-color: #f1f2f6;
    border: none !important;
  }
`;exports.PositionEnum=f,exports.SpacingConfigItemConfig=({propKey:r,positions:n,icon:i,placeholder:u,separateDevice:a=!0})=>{const[c,s]=o.usePropSeparateDevice(r,a),d=1===(null==n?void 0:n.length)?null==c?void 0:c[n[0]]:n.map((e=>null==c?void 0:c[e]))[0];return e.jsx(m,{children:e.jsx(t.InputNumberConfigV2,{propKey:void 0,displayUnit:!1,style:{backgroundColor:"#F1F2F6"},iconBeforeAddon:i,inputNumberProps:{value:d,onChange:e=>{const r=null!==e?e:void 0;let o=c;o=b(b({},o),Object.values(n).reduce(((e,o)=>{return t=b({},e),l(t,p({[o]:r}));var t}),{})),s(o)},placeholder:u,style:{width:"100%"},controls:!1}})})};


/***/ }),

/***/ 654986:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var i=__webpack_require__(561261),e=__webpack_require__(212951),o=__webpack_require__(143599),t=__webpack_require__(610314),n=__webpack_require__(891987),s=__webpack_require__(623537),r=__webpack_require__(149716),p=__webpack_require__(2723),a=__webpack_require__(96179),l=__webpack_require__(78922);function c(i){return i&&"object"==typeof i&&"default"in i?i:{default:i}}var u=c(e),f=Object.defineProperty,d=Object.getOwnPropertySymbols,m=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,v=(i,e,o)=>e in i?f(i,e,{enumerable:!0,configurable:!0,writable:!0,value:o}):i[e]=o;const x=u.default.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
`,P=u.default.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
`,j=u.default.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
`,y=u.default(o.Icon)`
  cursor: pointer;
  flex-shrink: 0;
  margin-top: 4px;
  font-size: 20px;
  color: ${i=>(null==i?void 0:i.isActive)?"#7367f0":"inherit"};

  &:hover {
    opacity: 0.7;
  }
`;exports.SpacingConfig=({propKey:e,title:c,separateDevice:u=!0})=>{const[f,E]=p.useProp(a.PROP_KEY.joinKey(e,a.PROP_KEY.OpenFourPosition)),[h,S]=l.usePropSeparateDevice(e,u);return n.useEffect((()=>{if(h&&void 0===f){const i=h[r.PositionEnum.top],e=h[r.PositionEnum.bottom],o=h[r.PositionEnum.left],t=h[r.PositionEnum.right];if(void 0!==i&&void 0!==e&&void 0!==o&&void 0!==t&&(i!==e||o!==t))return void E(!0)}}),[h]),n.useEffect((()=>{if(!1===f&&h){const i=h[r.PositionEnum.top],e=h[r.PositionEnum.bottom],o=h[r.PositionEnum.left],t=h[r.PositionEnum.right],n=((i,e)=>{for(var o in e||(e={}))m.call(e,o)&&v(i,o,e[o]);if(d)for(var o of d(e))g.call(e,o)&&v(i,o,e[o]);return i})({},h);void 0!==i&&void 0!==e&&i!==e?n[r.PositionEnum.bottom]=i:void 0===i&&void 0!==e?n[r.PositionEnum.top]=e:void 0!==i&&void 0===e&&(n[r.PositionEnum.bottom]=i),void 0!==o&&void 0!==t&&o!==t?n[r.PositionEnum.right]=o:void 0===o&&void 0!==t?n[r.PositionEnum.left]=t:void 0!==o&&void 0===t&&(n[r.PositionEnum.right]=o),S(n)}}),[f]),i.jsxs(x,{children:[i.jsx("label",{children:c}),i.jsxs(P,{children:[i.jsx(j,{children:f?i.jsxs(i.Fragment,{children:[i.jsx(r.SpacingConfigItemConfig,{icon:i.jsx(o.Icon,{name:"AlignTopSpaceOutlined",style:{fontSize:16}}),propKey:e,positions:[r.PositionEnum.top],separateDevice:u}),i.jsx(r.SpacingConfigItemConfig,{icon:i.jsx(o.Icon,{name:"AlignLeftSpaceOutlined",style:{fontSize:16}}),propKey:e,positions:[r.PositionEnum.left],separateDevice:u}),i.jsx(r.SpacingConfigItemConfig,{icon:i.jsx(o.Icon,{name:"AlignBottomSpaceOutlined",style:{fontSize:16}}),propKey:e,positions:[r.PositionEnum.bottom],separateDevice:u}),i.jsx(r.SpacingConfigItemConfig,{icon:i.jsx(o.Icon,{name:"AlignRightSpaceOutlined",style:{fontSize:16}}),propKey:e,positions:[r.PositionEnum.right],separateDevice:u})]}):i.jsxs(i.Fragment,{children:[i.jsx(r.SpacingConfigItemConfig,{icon:i.jsx(o.Icon,{name:"AlignVerticalSpaceOutlined",style:{fontSize:16}}),propKey:e,positions:[r.PositionEnum.top,r.PositionEnum.bottom],separateDevice:u}),i.jsx(r.SpacingConfigItemConfig,{icon:i.jsx(o.Icon,{name:"AlignHorizontalSpaceOutlined",style:{fontSize:16}}),propKey:e,positions:[r.PositionEnum.left,r.PositionEnum.right],separateDevice:u})]})}),i.jsx(t.Tooltip,{zIndex:2e3,placement:"topRight",title:f?s.t("spacing_config.pooling_value.tool_tip"):s.t("spacing_config.separate_value.tool_tip"),children:i.jsx("span",{style:{display:"inline-flex"},children:i.jsx(y,{name:"FourPointSpacingOutlined",isActive:f,onClick:()=>{E(!f)}})})})]})]})};


/***/ }),

/***/ 955448:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(623537),t=__webpack_require__(610314),o=__webpack_require__(78922),i=__webpack_require__(691171),c=Object.defineProperty,n=Object.defineProperties,s=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,a=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,l=(e,r,t)=>r in e?c(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,j=(e,r)=>{for(var t in r||(r={}))a.call(r,t)&&l(e,t,r[t]);if(p)for(var t of p(r))u.call(r,t)&&l(e,t,r[t]);return e};exports.SwitchConfig=c=>{const{propKey:p,switchProps:a,formItemProps:u,separateDevice:l=!1}=c,[m,b]=o.usePropSeparateDevice(p,l);return e.jsx(i.FormItem,(h=j({},u),d={children:e.jsx(t.Switch,j({checkedChildren:r.t("Bật"),unCheckedChildren:r.t("Tắt"),checked:m,onChange:e=>b(e)},a))},n(h,s(d))));var h,d};


/***/ }),

/***/ 373409:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(96179),n=__webpack_require__(781883);exports.TekoTrackingConfig=({propKey:o=t.PROP_KEY.Event,separateDevice:r})=>{const a=t.PROP_KEY.joinKey(o,t.PROP_KEY.TekoTrackingEvent,t.PROP_KEY.RegionName),i=t.PROP_KEY.joinKey(o,t.PROP_KEY.TekoTrackingEvent,t.PROP_KEY.ContentName),p=t.PROP_KEY.joinKey(o,t.PROP_KEY.TekoTrackingEvent,t.PROP_KEY.Target),s=t.PROP_KEY.joinKey(o,t.PROP_KEY.TekoTrackingEvent,t.PROP_KEY.Payload);return e.jsxs(e.Fragment,{children:[e.jsx(n.InputConfig,{separateDevice:r,propKey:a,formItemProps:{label:"Region name",style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"0.5rem"}},inputProps:{placeholder:"Region name",style:{width:"180px"}}}),e.jsx(n.InputConfig,{separateDevice:r,propKey:i,formItemProps:{label:"Content name",style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"0.5rem"}},inputProps:{placeholder:"Content name",style:{width:"180px"}}}),e.jsx(n.InputConfig,{separateDevice:r,propKey:p,formItemProps:{label:"Target",style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"0.5rem"}},inputProps:{placeholder:"Target",style:{width:"180px"}}}),e.jsx(n.InputConfig,{separateDevice:r,propKey:s,formItemProps:{label:"Payload",style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"0.5rem"}},inputProps:{placeholder:"Payload",style:{width:"180px"}}})]})};


/***/ }),

/***/ 226061:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(959211),t=__webpack_require__(610314),o=__webpack_require__(78922),i=__webpack_require__(96179),n=__webpack_require__(691171),s=Object.defineProperty,c=Object.defineProperties,a=Object.getOwnPropertyDescriptors,l=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,P=(e,r,t)=>r in e?s(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;exports.TextConfig=s=>{const{propKey:j,separateDevice:y,formItemProps:x}=s,{token:{colorPrimary:d}}=t.theme.useToken(),[v,O]=o.usePropSeparateDevice(i.PROP_KEY.joinKey(j,i.PROP_KEY.FontWeight),y),[m,b]=o.usePropSeparateDevice(i.PROP_KEY.joinKey(j,i.PROP_KEY.FontStyle),y),[f,K]=o.usePropSeparateDevice(i.PROP_KEY.joinKey(j,i.PROP_KEY.TextDecoration),y);return e.jsx(n.FormItem,(R=((e,r)=>{for(var t in r||(r={}))p.call(r,t)&&P(e,t,r[t]);if(l)for(var t of l(r))u.call(r,t)&&P(e,t,r[t]);return e})({},x),g={children:e.jsxs(t.Space,{children:[e.jsx(t.Button,{style:{color:v?d:void 0},type:"text",icon:e.jsx(r.TextBold16Regular,{}),onClick:()=>{O(v?void 0:"bold")}}),e.jsx(t.Button,{style:{color:m?d:void 0},type:"text",icon:e.jsx(r.TextItalic16Regular,{}),onClick:()=>{b(m?void 0:"italic")}}),e.jsx(t.Button,{style:{color:f?d:void 0},type:"text",icon:e.jsx(r.TextUnderline16Regular,{}),onClick:()=>{K(f?void 0:"underline")}})]})},c(R,a(g))));var R,g};


/***/ }),

/***/ 349567:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(610314),t=__webpack_require__(891987),o=__webpack_require__(2723),a=__webpack_require__(691171),l=Object.defineProperty,s=Object.defineProperties,i=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,n=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,c=(e,r,t)=>r in e?l(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,m=(e,r)=>{for(var t in r||(r={}))n.call(r,t)&&c(e,t,r[t]);if(u)for(var t of u(r))p.call(r,t)&&c(e,t,r[t]);return e},b=(e,r)=>s(e,i(r));exports.TextareaToOptionConfig=({textareaProps:l,formItemProps:s,propKey:i})=>{const[u,n]=t.useState(""),[p,c]=o.useProp(i);return t.useEffect((()=>{n((p||[]).reduce(((e,r)=>r.label===r.value?`${e}${r.label}\n`:`${e}${r.label} | ${r.value}\n`),""))}),[]),e.jsx(a.FormItem,b(m({},s),{children:e.jsx(r.Input.TextArea,b(m({},l),{value:u,onChange:e=>{n(e.target.value),(e=>{const r=[];e.trim().split("\n").map((e=>e.trim())).filter(Boolean).forEach((e=>{e.includes("|")?r.push({label:e.split("|")[0].trim(),value:e.split("|")[1].trim()}):r.push({label:e.trim(),value:e.trim()})})),c(r)})(e.target.value)}}))}))};


/***/ }),

/***/ 839000:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=l(__webpack_require__(212951));const t=[{label:"CN",value:0},{label:"T2",value:1},{label:"T3",value:2},{label:"T4",value:3},{label:"T5",value:4},{label:"T6",value:5},{label:"T7",value:6}],r=a.default.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  border: 1px solid #d8d6de;
  border-radius: 4px;
  max-width: 320px;
`,u=a.default.div`
  &.active,
  &:hover {
    color: #7367f0;
  }
  padding: 4px 8px;
  cursor: pointer;
`;exports.SelectSegment=({arrSelected:l=[1],onchange:a})=>e.jsx(r,{children:t.map((t=>e.jsx(u,{className:l.includes(t.value)?"active":"",onClick:()=>{const e=!l.includes(t.value);(e||!e&&(null==l?void 0:l.length)>1)&&a(t.value)},children:t.label},t.value)))});


/***/ }),

/***/ 746917:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),i=__webpack_require__(623537),t=__webpack_require__(610314),r=__webpack_require__(610796),o=__webpack_require__(228831),n=__webpack_require__(78922),a=__webpack_require__(96179),s=Object.defineProperty,P=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,l=Object.prototype.propertyIsEnumerable,u=(e,i,t)=>i in e?s(e,i,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[i]=t,c=(e,i)=>{for(var t in i||(i={}))p.call(i,t)&&u(e,t,i[t]);if(P)for(var t of P(i))l.call(i,t)&&u(e,t,i[t]);return e};exports.TimeVisibilityConfig=({propKey:s,separateDevice:P=!1,visible:p,setVisible:l})=>{const[u,y]=n.usePropSeparateDevice(a.PROP_KEY.joinKey(s,a.PROP_KEY.TimeVisibility,a.PROP_KEY.StartTime),P),[d,m]=n.usePropSeparateDevice(a.PROP_KEY.joinKey(s,a.PROP_KEY.TimeVisibility,a.PROP_KEY.EndTime),P),[O,b]=n.usePropSeparateDevice(a.PROP_KEY.joinKey(s,a.PROP_KEY.TimeVisibility,a.PROP_KEY.RuleRepeat),P),[K,R]=n.usePropSeparateDevice(a.PROP_KEY.joinKey(s,a.PROP_KEY.TimeVisibility,a.PROP_KEY.Date),P),[j,E]=n.usePropSeparateDevice(a.PROP_KEY.joinKey(s,a.PROP_KEY.TimeVisibility,a.PROP_KEY.Duration),P),{document:_}=r.useFrame();return e.jsx(e.Fragment,{children:e.jsx(t.Modal,{title:i.t("Đặt giờ hiển thị"),onCancel:()=>l(!1),open:p,destroyOnClose:!0,bodyStyle:{paddingTop:0},getContainer:()=>(null==_?void 0:_.body)||(null==document?void 0:document.body),closable:!1,footer:[e.jsx(t.Button,{type:"primary",shape:"round",onClick:()=>l(!1),children:i.t("Đóng")})],zIndex:1080,children:e.jsx(o.TimingConfig,c({},{startTime:u,endTime:d,ruleRepeat:O,date:K,duration:j,setDate:R,setStartTime:y,setEndTime:m,setRuleRepeat:b,setDuration:E}))})})};


/***/ }),

/***/ 228831:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),n=__webpack_require__(772139),a=__webpack_require__(891987),i=__webpack_require__(85097),l=__webpack_require__(610314),u=__webpack_require__(839000),r=__webpack_require__(623537),o=__webpack_require__(301930),s=__webpack_require__(691171),m=__webpack_require__(505765);function p(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=p(t),c=p(n);const R=e=>{if(c.default.isDayjs(e))return c.default(e).toISOString()},h=d.default(l.DatePicker)`
  width: 100%;
`,E=d.default.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`,v=d.default(l.DatePicker.RangePicker)`
  width: 100%;
`;exports.TimingConfig=({startTime:t,endTime:n,ruleRepeat:l,date:p,duration:d,setStartTime:f,setEndTime:g,setRuleRepeat:y,setDate:T,setDuration:j})=>{var D;const[b,x]=a.useState(),[C,Y]=a.useState(""),[I,A]=a.useState(),[U,S]=a.useState(),[N,$]=a.useState(""),[O,M]=a.useState(),[F,L]=a.useState(),q="DD/MM/YYYY HH:mm:ss";a.useEffect((()=>{if(d){const[e,t]=d;M(e),L(t)}w()}),[]);const w=()=>{var e;if(!l)return void((t||n)&&$(i.RepeatTypeEnum.NO_REPEAT));const a=i.parseRuleRepeat(i.RuleRepeatEnum.FREQ,l),u=i.parseRuleRepeat(i.RuleRepeatEnum.INTERVAL,l)||"1",r=i.parseRuleRepeat(i.RuleRepeatEnum.UNTIL,l),o=i.parseRuleRepeat(i.RuleRepeatEnum.BYDAY,l);S(parseInt(u)),a&&x(a),r&&Y(r),o&&A(null==(e=o.split(","))?void 0:e.map((e=>parseInt(e)))),(a===i.UnitRepeatEnum.DURATION||t||n)&&$(i.RepeatTypeEnum.NO_REPEAT),1==+u&&a===i.UnitRepeatEnum.DAY&&$(i.RepeatTypeEnum.DAILY),(+u>1||a!==i.UnitRepeatEnum.DAY&&a!==i.UnitRepeatEnum.DURATION)&&$(i.RepeatTypeEnum.CUSTOM)},P=e=>{if(void 0===e)return;const t=p?c.default(p):c.default(),n=Math.floor(e/60),a=e-60*n;return t.hour(n).minute(a)},k=(e,t)=>{e&&t&&c.default(e).isAfter(t)?(f(t),g(e)):(f(e),g(t))};a.useEffect((()=>{H({freq:b,byDay:null==I?void 0:I.join(","),until:C,interval:U})}),[b,I,C,N,U]);const H=({freq:e,byDay:t,until:n,interval:a})=>{const u=`${e?`${i.RuleRepeatEnum.FREQ}:${e};`:""}${a?`${i.RuleRepeatEnum.INTERVAL}:${a};`:""}${t?`${i.RuleRepeatEnum.BYDAY}:${t};`:""}${n?`${i.RuleRepeatEnum.UNTIL}:${n};`:""}`;(l||u)&&y(u)},B=e=>{const[t,n]=e||[void 0,void 0],a=t?60*t.hour()+t.minute():void 0,i=n?60*n.hour()+n.minute():void 0;M(a),L(i),j(void 0!==a&&void 0!==i?[a,i]:void 0)},K=(e,t,n)=>{if(!n||t!==i.UnitRepeatEnum.YEAR&&t!==i.UnitRepeatEnum.MONTH)return"";const a={month:r.t("tháng"),year:r.t("năm")},l=t==i.UnitRepeatEnum.YEAR?"DD/MM":"DD";return`${e>1?`${e} ${a[t.toLowerCase()]} ${r.t("một lần")}`:`${r.t("Hàng")} ${a[t.toLowerCase()]}`} ${r.t("vào ngày")} ${c.default(n).format(l)}`},_=a.useRef(null);return e.jsxs(e.Fragment,{children:[e.jsx("div",{ref:_,style:{display:"none"}}),e.jsx(o.SelectConfig,{options:[{label:r.t("Luôn hiển thị"),value:""},{label:r.t("Khoảng thời gian"),value:i.RepeatTypeEnum.NO_REPEAT},{label:r.t("Lặp lại hàng ngày"),value:i.RepeatTypeEnum.DAILY},{label:r.t("Tùy chỉnh"),value:i.RepeatTypeEnum.CUSTOM}],formItemProps:{label:r.t("Kiểu hiển thị"),layout:"vertical"},selectProps:{style:{width:"100%"},value:N,onChange:e=>{switch(f(void 0),g(void 0),T(void 0),B(void 0),S(void 0),x(void 0),A(void 0),Y(void 0),$(e),e){case i.RepeatTypeEnum.CUSTOM:x(i.UnitRepeatEnum.WEEK),A([1]),S(1);break;case i.RepeatTypeEnum.DAILY:x(i.UnitRepeatEnum.DAY),S(1);break;case i.RepeatTypeEnum.NO_REPEAT:x(i.UnitRepeatEnum.DURATION)}},allowClear:!1}}),N===i.RepeatTypeEnum.NO_REPEAT&&e.jsxs(e.Fragment,{children:[e.jsx(s.FormItem,{label:r.t("Thời gian bắt đầu"),layout:"vertical",children:e.jsx(h,{showTime:!0,placeholder:r.t("Chọn thời gian bắt đầu"),disabledDate:e=>!!n&&(null==e?void 0:e.isAfter(n,"day")),format:q,value:t?c.default(t):void 0,onChange:e=>k(R(e),n)})}),e.jsx(s.FormItem,{label:r.t("Thời gian kết thúc"),layout:"vertical",children:e.jsx(h,{showTime:!0,placeholder:r.t("Chọn thời gian kết thúc"),disabledDate:e=>!!t&&(null==e?void 0:e.isBefore(t,"day")),format:q,value:n?c.default(n):void 0,onChange:e=>k(t,R(e))})})]}),(N===i.RepeatTypeEnum.CUSTOM||N===i.RepeatTypeEnum.DAILY)&&e.jsxs(e.Fragment,{children:[(!!(U&&U>1)||b!==i.UnitRepeatEnum.WEEK&&b!==i.UnitRepeatEnum.DAY)&&e.jsxs(e.Fragment,{children:[e.jsx(s.FormItem,{label:r.t("Lặp lại mỗi"),style:{marginBottom:0},children:e.jsxs(E,{children:[e.jsx(m.InputNumberConfig,{inputNumberProps:{min:1,value:U,onChange:e=>S(e)}}),e.jsx(o.SelectConfig,{options:[{label:r.t("Ngày"),value:i.UnitRepeatEnum.DAY},{label:r.t("Tuần"),value:i.UnitRepeatEnum.WEEK},{label:r.t("Tháng"),value:i.UnitRepeatEnum.MONTH},{label:r.t("Năm"),value:i.UnitRepeatEnum.YEAR}],selectProps:{value:b,onChange:e=>{x(e)}}})]})}),!!U&&!!b&&!!K(U,b,p)&&e.jsx("div",{style:{marginBottom:16,color:"#82869E"},children:K(U,b,p)})]}),b===i.UnitRepeatEnum.WEEK&&e.jsx(s.FormItem,{label:r.t("Lặp lại vào"),layout:"vertical",children:e.jsx(u.SelectSegment,{arrSelected:I,onchange:e=>{A((t=>{const n=null==t?void 0:t.indexOf(e);if(void 0!==n){if(n<0)return[...t||[],e];{const e=[...t||[]];return e.splice(n,1),e}}}))}})}),e.jsx(s.FormItem,{label:r.t("Hiển thị trong khung giờ"),layout:"vertical",children:e.jsx(v,{placeholder:[r.t("Bắt đầu"),r.t("Kết thúc")],format:"HH:mm",picker:"time",value:[P(O),P(F)],changeOnBlur:(null==(D=null==_?void 0:_.current)?void 0:D.ownerDocument)!==document,allowClear:!0,onChange:B})}),e.jsx(s.FormItem,{label:r.t("Ngày bắt đầu"),layout:"vertical",children:e.jsx(h,{placeholder:r.t("Chọn thời gian bắt đầu"),value:p?c.default(p):void 0,format:"DD/MM/YYYY",onChange:e=>T(R(e))})}),e.jsx(s.FormItem,{label:r.t("Ngày kết thúc"),layout:"vertical",children:e.jsx(h,{placeholder:r.t("Chọn thời gian kết thúc"),format:"DD/MM/YYYY",value:C?c.default(C):void 0,onChange:e=>Y(R(e))})})]})]})};


/***/ }),

/***/ 397155:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(623537),r=__webpack_require__(891987),n=__webpack_require__(85097),o=__webpack_require__(96179),i=__webpack_require__(78922),a=__webpack_require__(781883),s=__webpack_require__(301930),l=__webpack_require__(505765),u=__webpack_require__(691171);function p(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}function c(e){if(e&&e.__esModule)return e;var t=Object.create(null);return e&&Object.keys(e).forEach((function(r){if("default"!==r){var n=Object.getOwnPropertyDescriptor(e,r);Object.defineProperty(t,r,n.get?n:{enumerable:!0,get:function(){return e[r]}})}})),t.default=e,Object.freeze(t)}var f=p(r);const d=f.default.lazy((()=>Promise.resolve().then((function(){return c(__webpack_require__(680300))})))),h=[{label:"CompleteRegistration",value:"CompleteRegistration"},{label:"Purchase",value:"Purchase"},{label:"Lead",value:"Lead"}];exports.TrackingConfig=({propKey:p=o.PROP_KEY.Event,config:c="event",separateDevice:m})=>{const P=o.PROP_KEY.joinKey(p,o.PROP_KEY.TrackingEventName),y=o.PROP_KEY.joinKey(p,o.PROP_KEY.ConversionValue),g=o.PROP_KEY.joinKey(p,o.PROP_KEY.ConversionGGAdsId),j=o.PROP_KEY.joinKey(p,o.PROP_KEY.ConversionGGAdsLabel),v=o.PROP_KEY.joinKey(p,o.PROP_KEY.ScriptCustom),[b,C]=i.usePropSeparateDevice(v,m),[K,x]=r.useState(null);return r.useEffect((()=>{var e,t;return null==(t=null==(e=null==K?void 0:K.editor)?void 0:e.renderer)||t.attachToShadowRoot(),()=>{var e,t;null==(t=null==(e=null==K?void 0:K.editor)?void 0:e.renderer)||t.attachToShadowRoot()}})),e.jsxs(e.Fragment,{children:["event"===c&&e.jsx(a.InputConfig,{separateDevice:m,propKey:P,formItemProps:{label:t.t("Tên sự kiện FB/GA"),style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"0.5rem"}},inputProps:{placeholder:t.t("Nhập tên sự kiện"),style:{width:"180px"}}}),"form"===c&&e.jsxs(e.Fragment,{children:[e.jsx(s.SelectConfig,{separateDevice:m,propKey:P,options:h,formItemProps:{label:t.t("Mã chuyển đổi FB/GA")},selectProps:{placeholder:t.t("Chọn mã chuyển đổi"),allowClear:!0}}),e.jsx(l.InputNumberConfig,{separateDevice:m,propKey:y,formItemProps:{label:t.t("Giá trị chuyển đổi")},inputNumberProps:{placeholder:"0",min:0,style:{width:"180px"}}})]}),e.jsx(a.InputConfig,{separateDevice:m,propKey:g,formItemProps:{label:t.t("ID chuyển đổi Google Ads"),style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"0.5rem"}},inputProps:{placeholder:t.t("ID chuyển đổi"),style:{width:"180px"}}}),e.jsx(a.InputConfig,{separateDevice:m,propKey:j,formItemProps:{label:t.t("Nhãn chuyển đổi Google Ads"),style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"0.5rem"}},inputProps:{placeholder:t.t("Nhãn chuyển đổi"),style:{width:"180px"}}}),e.jsx(f.default.Suspense,{fallback:e.jsx("div",{}),children:e.jsx(u.FormItem,{label:t.t("Mã tùy chỉnh nâng cao (không bắt buộc)"),children:e.jsx(d,{ref:e=>x(e),placeholder:"VD: fbq('track', 'Purchase', {currency: 'VND', value: 300000})",mode:"javascript",fontSize:14,height:"200px",width:"100%",setOptions:{showLineNumbers:!0,tabSize:2},highlightActiveLine:!0,value:n.unescapeString(b),onChange:e=>C(n.escapeString(e)),showPrintMargin:!0,showGutter:!0})})})]})};


/***/ }),

/***/ 734957:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(85097),r=__webpack_require__(212951),o=__webpack_require__(301930);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var n=a(r),l=Object.defineProperty,i=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,s=(e,t,r)=>t in e?l(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,c=(e,t)=>{for(var r in t||(t={}))p.call(t,r)&&s(e,r,t[r]);if(i)for(var r of i(t))u.call(t,r)&&s(e,r,t[r]);return e};const f=n.default(o.Select)`
  .ant-select-selector {
    border-radius: 0 4px 4px 0px !important;
  }
`;exports.UnitConfig=({propKey:r,options:o=[],defaultValue:a=t.UnitEnum.pixel,separateDevice:n,onChange:l,style:i})=>e.jsx(f,{style:c({width:60},i),propKey:r,defaultValue:a,options:o.map((e=>({value:e,label:e}))),separateDevice:n,onChange:l});


/***/ }),

/***/ 247309:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(959211),o=__webpack_require__(610314),i=__webpack_require__(85097),n=__webpack_require__(78922),l=__webpack_require__(691171);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=a(r),u=Object.defineProperty,c=Object.defineProperties,p=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,j=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,b=(e,r,t)=>r in e?u(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;const x=s.default.span`
  vertical-align: -webkit-baseline-middle;
`;exports.VerticalAlignmentConfig=({propKey:r,formItemProps:a,separateDevice:s=!1})=>{const[u,f]=n.usePropSeparateDevice(r,s);return e.jsx(l.FormItem,(g=((e,r)=>{for(var t in r||(r={}))j.call(r,t)&&b(e,t,r[t]);if(d)for(var t of d(r))m.call(r,t)&&b(e,t,r[t]);return e})({},a),v={children:e.jsxs(o.Radio.Group,{onChange:e=>{f(e.target.value)},value:u,buttonStyle:"solid",children:[e.jsx(o.Radio.Button,{value:i.VerticalAlignment.top,children:e.jsx(x,{children:e.jsx(t.TextboxAlignTopRegular,{fontSize:20})})}),e.jsx(o.Radio.Button,{value:i.VerticalAlignment.center,children:e.jsx(x,{children:e.jsx(t.TextboxAlignMiddleRegular,{fontSize:20})})}),e.jsx(o.Radio.Button,{value:i.VerticalAlignment.bottom,children:e.jsx(x,{children:e.jsx(t.TextboxAlignBottomRegular,{fontSize:20})})})]})},c(g,p(v))));var g,v};


/***/ }),

/***/ 347619:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(623537),o=__webpack_require__(610314),i=__webpack_require__(781883),t=__webpack_require__(96179),n=__webpack_require__(955448);exports.FacebookConfig=({facebookPropKey:c,separateDevice:s})=>e.jsx(e.Fragment,{children:e.jsxs(o.Space,{direction:"vertical",size:5,style:{width:"100%",marginTop:"10px"},children:[e.jsx(i.InputConfig,{propKey:t.PROP_KEY.joinKey(c,t.PROP_KEY.Src),separateDevice:s,formItemProps:{label:r.t("video_config.facebook.src"),layout:"vertical"},inputProps:{placeholder:r.t("video_config.facebook.enter_link")}}),e.jsx(n.SwitchConfig,{propKey:t.PROP_KEY.joinKey(c,t.PROP_KEY.Fullscreen),formItemProps:{label:r.t("video_config.allow_fullscreen")}})]})});


/***/ }),

/***/ 101736:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var o=__webpack_require__(561261),e=__webpack_require__(623537),i=__webpack_require__(610314),t=__webpack_require__(2161),r=__webpack_require__(781883),n=__webpack_require__(96179),p=__webpack_require__(955448);exports.TikTokConfig=({tiktokPropKey:s,separateDevice:c})=>o.jsx(o.Fragment,{children:o.jsxs(i.Space,{direction:"vertical",size:5,style:{width:"100%",marginTop:"10px"},children:[o.jsx(r.InputConfig,{propKey:n.PROP_KEY.joinKey(s,n.PROP_KEY.Src),separateDevice:c,formItemProps:{label:e.t("video_config.tiktok.src"),layout:"vertical"},inputProps:{placeholder:e.t("video_config.tiktok.enter_link")}}),o.jsx(p.SwitchConfig,{propKey:n.PROP_KEY.joinKey(s,n.PROP_KEY.Autoplay),formItemProps:{label:e.t("video_config.autoplay")}}),o.jsx(p.SwitchConfig,{propKey:n.PROP_KEY.joinKey(s,n.PROP_KEY.Loop),formItemProps:{label:e.t("video_config.loop")}}),o.jsx(p.SwitchConfig,{propKey:n.PROP_KEY.joinKey(s,n.PROP_KEY.Controls),formItemProps:{label:e.t("video_config.controls")}}),o.jsx(p.SwitchConfig,{propKey:n.PROP_KEY.joinKey(s,n.PROP_KEY.Description),formItemProps:{label:e.t("video_config.video_description")}}),o.jsx(p.SwitchConfig,{propKey:n.PROP_KEY.joinKey(s,n.PROP_KEY.MusicDescription),formItemProps:{label:e.t("video_config.music_description")}}),o.jsx(t.RatioConfig,{propKey:n.PROP_KEY.joinKey(s,n.PROP_KEY.AspectRatio)})]})});


/***/ }),

/***/ 569433:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(610314),r=__webpack_require__(623537),t=__webpack_require__(212951),i=__webpack_require__(112373),n=__webpack_require__(838058),a=__webpack_require__(891987),s=__webpack_require__(78922),c=__webpack_require__(96179),l=__webpack_require__(852989),p=__webpack_require__(955448),u=__webpack_require__(2161);function d(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var f=d(t),P=Object.defineProperty,j=Object.defineProperties,y=Object.getOwnPropertyDescriptors,K=Object.getOwnPropertySymbols,O=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,v=(e,o,r)=>o in e?P(e,o,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[o]=r,b=(e,o)=>{for(var r in o||(o={}))O.call(o,r)&&v(e,r,o[r]);if(K)for(var r of K(o))g.call(o,r)&&v(e,r,o[r]);return e};const m=f.default(o.Upload)`
  div.ant-upload {
    width: 100%;
  }
`;exports.UploadConfig=({uploadPropKey:t,uploadSrcPropKey:d,separateDevice:f})=>{const[P,K]=a.useState(!1),[O,g]=a.useState([]),[v,R]=s.usePropSeparateDevice(c.PROP_KEY.joinKey(t,c.PROP_KEY.Src),f),[x,_]=s.usePropSeparateDevice(c.PROP_KEY.joinKey(d),f);a.useEffect((()=>{g(v?[{url:v,uid:v,name:n.getFileName(v)}]:[])}),[v]);const h=(e,o)=>URL.createObjectURL(e),{uploadFileHandler:S=h}=l.useBuilder(),E={beforeUpload:n.beforeUploadVideo,customRequest:async e=>{const{file:o,onSuccess:r,onError:t}=e;try{K(!0);const e=await S(o,"video");R(e),x&&_(void 0),r(o)}catch(e){t(e,o)}finally{K(!1)}},listType:"picture",maxCount:1,multiple:!1,fileList:O,onRemove:()=>{R("")}};return e.jsx(e.Fragment,{children:e.jsxs(o.Space,{direction:"vertical",size:5,style:{width:"100%",marginTop:"10px"},children:[e.jsx(m,(q=b({},E),w={children:e.jsx(o.Button,{block:!0,icon:e.jsx(i.UploadOutlined,{}),loading:P,children:r.t("video_config.upload.src")})},j(q,y(w)))),e.jsxs("div",{style:{marginTop:"56px"},children:[e.jsx(p.SwitchConfig,{propKey:c.PROP_KEY.joinKey(t,c.PROP_KEY.Autoplay),formItemProps:{label:r.t("video_config.autoplay")}}),e.jsx(p.SwitchConfig,{propKey:c.PROP_KEY.joinKey(t,c.PROP_KEY.Loop),formItemProps:{label:r.t("video_config.loop")}}),e.jsx(p.SwitchConfig,{propKey:c.PROP_KEY.joinKey(t,c.PROP_KEY.Controls),formItemProps:{label:r.t("video_config.controls")}}),e.jsx(u.RatioConfig,{propKey:c.PROP_KEY.joinKey(t,c.PROP_KEY.AspectRatio)})]})]})});var q,w};


/***/ }),

/***/ 993594:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(623537),r=__webpack_require__(112373),o=__webpack_require__(212951),i=__webpack_require__(610314),u=__webpack_require__(891987),a=__webpack_require__(838058),n=__webpack_require__(78922),l=__webpack_require__(852989),s=__webpack_require__(781883);function p(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=p(o),d=Object.defineProperty,b=Object.defineProperties,f=Object.getOwnPropertyDescriptors,j=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,v=(e,t,r)=>t in e?d(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,g=(e,t)=>{for(var r in t||(t={}))y.call(t,r)&&v(e,r,t[r]);if(j)for(var r of j(t))m.call(t,r)&&v(e,r,t[r]);return e},P=(e=>(e.YouTube="YouTube",e.Upload="Upload",e))(P||{});const O=c.default(i.Upload)`
  div.ant-upload {
    width: 100%;
  }
`;exports.VideoConfig=({platformPropKey:o,youtubeVideoPropKey:p,uploadVideoPropKey:c,separateDevice:d})=>{const[j,y]=u.useState([]),[m,v]=u.useState(!1),[h,x]=n.usePropSeparateDevice(c,d),[q,U]=n.usePropSeparateDevice(o,d),S=q||(h?"Upload":"YouTube");u.useEffect((()=>{y(h?[{url:h,uid:h,name:a.getFileName(h)}]:[])}),[h]);const w=(e,t)=>URL.createObjectURL(e),{uploadFileHandler:C=w}=l.useBuilder(),V={beforeUpload:a.beforeUploadVideo,customRequest:async e=>{const{file:t,onSuccess:r,onError:o}=e;try{v(!0);const e=await C(t,"video");x(e),r(t)}catch(e){o(e,t)}finally{v(!1)}},listType:"picture",maxCount:1,multiple:!1,fileList:j,onRemove:()=>{x("")}};return e.jsxs(e.Fragment,{children:[e.jsx(i.Segmented,{options:Object.values(P),onChange:e=>{U(e)},defaultValue:S,style:{width:"100%",marginBottom:20},block:!0}),"YouTube"===S&&e.jsx(s.InputConfig,{propKey:p,separateDevice:d,formItemProps:{label:t.t("Đường dẫn Youtube"),layout:"vertical"},inputProps:{placeholder:t.t("Nhập đường dẫn Youtube")}}),"Upload"===S&&e.jsx(O,(D=g({},V),T={children:e.jsx(i.Button,{block:!0,icon:e.jsx(r.UploadOutlined,{}),loading:m,children:t.t("Tải lên video (MP4, WebM, OGV)")})},b(D,f(T))))]});var D,T};


/***/ }),

/***/ 642955:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(623537),i=__webpack_require__(610314),r=__webpack_require__(781883),t=__webpack_require__(96179),n=__webpack_require__(955448),p=__webpack_require__(2161);exports.YouTubeConfig=({youtubePropKey:s,separateDevice:a})=>e.jsx(e.Fragment,{children:e.jsxs(i.Space,{direction:"vertical",size:5,style:{width:"100%",marginTop:"10px"},children:[e.jsx(r.InputConfig,{propKey:t.PROP_KEY.joinKey(s,t.PROP_KEY.Src),separateDevice:a,formItemProps:{label:o.t("video_config.youtube.src"),layout:"vertical"},inputProps:{placeholder:o.t("video_config.youtube.enter_link")}}),e.jsx(n.SwitchConfig,{propKey:t.PROP_KEY.joinKey(s,t.PROP_KEY.Autoplay),formItemProps:{label:o.t("video_config.autoplay")}}),e.jsx(n.SwitchConfig,{propKey:t.PROP_KEY.joinKey(s,t.PROP_KEY.Loop),formItemProps:{label:o.t("video_config.loop")}}),e.jsx(n.SwitchConfig,{propKey:t.PROP_KEY.joinKey(s,t.PROP_KEY.Controls),formItemProps:{label:o.t("video_config.controls")}}),e.jsx(p.RatioConfig,{propKey:t.PROP_KEY.joinKey(s,t.PROP_KEY.AspectRatio)})]})});


/***/ }),

/***/ 838058:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(623537),i=__webpack_require__(610314);const t=["video/mp4","video/webm","video/ogg"];exports.beforeUploadVideo=o=>t.includes(o.type)?!!(o.size<20971520)||(i.notification.error({message:e.t("Bạn chỉ có thể tải lên video nhỏ hơn hoặc bằng 20MB!")}),!1):(i.notification.error({message:e.t("Bạn chỉ có thể tải lên video dạng MP4/WEBM/OGV!")}),!1),exports.getFileName=e=>e.substring(e.lastIndexOf("/")+1);


/***/ }),

/***/ 828741:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=Object.defineProperty,p=Object.defineProperties,t=Object.getOwnPropertyDescriptors,o=Object.getOwnPropertySymbols,s=Object.prototype.hasOwnProperty,r=Object.prototype.propertyIsEnumerable,i=(p,t,o)=>t in p?e(p,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):p[t]=o,a=(e,p)=>{for(var t in p||(p={}))s.call(p,t)&&i(e,t,p[t]);if(o)for(var t of o(p))r.call(p,t)&&i(e,t,p[t]);return e},d=(e,o)=>p(e,t(o));const l=[{tags:["luckymoney","potsmashing","treasurehunting","luckydrawv2"],resetFields:["data.props.gameId","data.props.configStorage"],mappingFields:{"data.props.response":(e,p)=>{var t;return{emptyPrize:p[e.emptyPrize],outOfTurn:p[e.outOfTurn],prize:p[e.prize],outOfPrize:p[e.outOfPrize],custom:null==(t=e.custom)?void 0:t.map((e=>d(a({},e),{popup:p[e.popup]})))}}}},{tags:["tempiproductlistv2","websiteheader"],resetFields:[],mappingFields:{"data.props.orderPopupId":(e,p)=>p[e]}},{tags:["formv4","checkoutform","orderpopupv2"],resetFields:["data.props.configStorage"],mappingFields:{"data.props.response":(e,p)=>{var t;return d(a({},e),{success:p[e.success]||e.success,failed:p[e.failed]||e.failed,custom:null==(t=e.custom)?void 0:t.map((e=>d(a({},e),{popup:p[e.popup]||e.popup})))})}}},{tags:["buttonv2","col","image","icon","socialicon"],resetFields:[],mappingFields:{"data.props.event":(e,p)=>{var t;return d(a({},e),{togglePopup:p[e.togglePopup]||e.togglePopup,togglePopupList:"string"==typeof e.togglePopupList?p[e.togglePopupList]||e.togglePopupList:null==(t=e.togglePopupList)?void 0:t.map((e=>p[e]||e))})}}},{tags:["tab"],resetFields:[],mappingFields:{"data.props.tabs":(e,p)=>null==e?void 0:e.map((e=>d(a({},e),{id:p[e.id]||e.id})))}},{tags:["advancedslider"],resetFields:[],mappingFields:{"data.props.sliders":(e,p)=>null==e?void 0:e.map((e=>d(a({},e),{id:p[e.id]||e.id})))}},{tags:["timeline"],resetFields:[],mappingFields:{"data.props.timelines":(e,p)=>null==e?void 0:e.map((e=>d(a({},e),{nodeId:p[e.nodeId]||e.nodeId})))}},{tags:["omni_voucherlist"],resetFields:["data.props.endpointConfig"]}];exports.DEFAULT_RESTRICTED_ELEMENT_CONFIG=l;


/***/ }),

/***/ 731051:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.DEFAULT_WIDTH=1232,exports.GRID_COLUMNS=12,exports.MAX_WIDTH=2e3;


/***/ }),

/***/ 124449:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=(e=>(e.USER="user",e.ASSISTANT="assistant",e))(e||{}),_=(e=>(e.FRIENDLY="friendly",e.PROFESSIONAL="professional",e.CONVINCING="convincing",e.CREATIVE="creative",e.HUMOROUS="humorous",e))(_||{}),E=(e=>(e.GENERATE_TEXT="generate_text",e.SHORTEN_TEXT="shorten_text",e.REWRITE_TEXT="rewrite_text",e.CHANGE_TONE_FRIENDLY="change_tone_friendly",e.CHANGE_TONE_PROFESSIONAL="change_tone_professional",e.CHANGE_TONE_CONVINCING="change_tone_convincing",e.CHANGE_TONE_CREATIVE="change_tone_creative",e.CHANGE_TONE_HUMOROUS="change_tone_humorous",e.SET_PARAGRAPH_NODE_ID="set_paragraph_node_id",e))(E||{});exports.LLM_ACTION_TYPE=E,exports.LLM_EVENT_NAME="llm-event",exports.MESSAGE_ROLE=e,exports.TONE=_;


/***/ }),

/***/ 96179:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));const e={Action:"action",ActionButton:"actionButton",ActiveName:"activeName",ActiveTabStyle:"activeTabStyle",Address:"address",Align:"align",AlignItems:"alignItems",Alignment:"alignment",AlignThumbnail:"alignThumbnail",AllowSetupThumbnail:"allowSetupThumbnail",Alt:"alt",AltStyle:"altStyle",AnimationDelay:"animation.delay",AnimationDuration:"animation.duration",AnimationName:"animation.name",AnimationRepeatNumber:"animation.repeatNumber",AnimationRepeatType:"animation.repeatType",ApiResponsePopup:"responsePopup",AppliedDomains:"appliedDomains",ArrowStyle:"arrowStyle",AutoPassParams:"autoPassParams",Autoplay:"autoplay",AutoSwipeTimeMilliseconds:"autoSwipeTimeMilliseconds",AspectRatio:"aspectRatio",AnimationConfig:"animationConfig",BackgroundType:"backgroundType",Background:"background",BackgroundColor:"backgroundColor",BackgroundColorHover:"hover.backgroundColor",BackgroundImage:"backgroundImage",BackgroundImagePercent:"bgImagePercent",BackgroundImageWidth:"bgImageWidth",BackgroundMarqueeDirection:"backgroundMarqueeDirection",BackgroundMarqueeSpeed:"backgroundMarqueeSpeed",BackgroundOverlay:"backgroundOverlay",BackgroundOverlayType:"backgroundOverlayType",BackgroundPosition:"backgroundPosition",BackgroundRepeat:"backgroundRepeat",BackgroundSize:"backgroundSize",BackgroundVideo:"backgroundVideo",BackgroundBlur:"backgroundBlur",BarStyle:"barStyle",BlockType:"blockType",Border:"border",BorderBottomLeftRadius:"borderBottomLeftRadius",BorderBottomLeftRadiusUnit:"borderBottomLeftRadiusUnit",BorderBottomRightRadius:"borderBottomRightRadius",BorderBottomRightRadiusUnit:"borderBottomRightRadiusUnit",BorderColor:"borderColor",BorderColorHover:"hover.borderColor",BorderRadius:"borderRadius",BorderRadiusUnit:"borderRadiusUnit",BorderStyle:"borderStyle",BorderTopLeftRadius:"borderTopLeftRadius",BorderTopLeftRadiusUnit:"borderTopLeftRadiusUnit",BorderTopRightRadius:"borderTopRightRadius",BorderTopRightRadiusUnit:"borderTopRightRadiusUnit",BorderWidth:"borderWidth",BorderBottomWidth:"borderBottomWidth",BorderTopWidth:"borderTopWidth",BorderLeftWidth:"borderLeftWidth",BorderRightWidth:"borderRightWidth",Bottom:"bottom",BottomBanners:"bottomBanners",BubbleStyle:"bubbleStyle",Button:"button",ButtonStyle:"buttonStyle",CanvasConfig:"canvasConfig",Captcha:"captcha",CarouselSettings:"carouselSettings",CategoryMenuItems:"categoryMenuItems",CircleStyle:"circleStyle",CityId:"cityId",CloseIcon:"closeIcon",Code:"code",CollectionSlug:"collectionSlug",Color:"color",ColorHover:"hover.color",ColumnCount:"columnCount",ColumnGap:"columnGap",CommonStyle:"commonStyle",Config:"config",ConfigStorage:"configStorage",Content:"content",ContentAlign:"contentAlign",ContentMaxWidthKey:"row.commonStyle.maxWidth",ContentName:"contentName",ContentStyle:"contentStyle",ContentType:"contentType",ContentWidthType:"contentWidthType",ConversionGGAdsId:"conversionGGAdsId",ConversionGGAdsLabel:"conversionGGAdsLabel",ConversionValue:"conversionValue",CornerOption:"cornerOption",CornerType:"cornerType",CountdownStyle:"countdownStyle",CopyToClipboard:"copyToClipboard",Crop:"crop",Custom:"custom",Controls:"controls",Data:"data",Date:"date",DefaultOverlay:"defaultOverlay",Delay:"delay",Description:"description",Desktop:"desktop",Device:"device",DigitStyle:"digitStyle",DisplayCloseButton:"displayCloseButton",DisplayOnClickElement:"displayOnClickElement",DisplayOnExitPage:"displayOnExitPage",DisplayOnScrollTo:"displayOnScrollTo",DisplayOnVisitPage:"displayOnVisitPage",DistrictId:"districtId",Divider:"divider",DividerStyle:"dividerStyle",Duration:"duration",ElementGap:"elementGap",Email:"email",EndTime:"endTime",ErrorStyle:"errorStyle",Event:"event",EventType:"eventType",Failed:"failed",FlexDirection:"flexDirection",FlexWrap:"flexWrap",FontFamily:"fontFamily",FontSize:"fontSize",FontStyle:"fontStyle",FontVariant:"fontVariant",FontWeight:"fontWeight",ForegroundColor:"foregroundColor",FormAccountId:"formAccountId",FormConfigId:"formConfigId",FormStyle:"formStyle",Facebook:"facebook",Fullscreen:"fullscreen",FrameShowPopup:"frameShowPopup",Gap:"gap",GoogleImageParams:"googleImageParams",GradientColor:"gradientColor",GridCols:"gridCols",GridRows:"gridRows",Gutter:"gutter",Headers:"headers",HeaderStyle:"headerStyle",HeadingEditor:"headingEditor",Height:"height",HeightUnit:"heightUnit",HiddenFields:"hiddenFields",HiddenMd:"responsive.hiddenMd",HiddenXs:"responsive.hiddenXs",HideAfterClick:"hideAfterClick",HoverBackgroundColor:"hover.backgroundColor",HoverBorderColor:"hover.borderColor",HoverColor:"hover.color",HoverEffect:"hoverEffect",HoverTransparent:"hover.transparent",HoverZoom:"hover.zoom",Href:"href",HtmlTag:"htmlTag",Icon:"icon",IconConfig:"iconConfig",IconStyle:"iconStyle",Id:"id",Image:"image",ImageAlt:"imageAlt",ImageConfig:"imageConfig",Images:"images",ImageStyle:"imageStyle",ImageUrl:"imageUrl",InPage:"inPage",Inputs:"inputs",InputStyle:"inputStyle",Interval:"interval",IsMainPopup:"isMainPopup",ItemData:"itemData",ItemKey:"itemKey",Items:"items",ItemSettings:"itemSettings",ItemsPerRow:"itemsPerRow",ItemStyle:"itemStyle",JustifyContent:"justifyContent",Key:"key",Label:"label",LabelGap:"labelGap",LabelPosition:"labelPosition",LabelStyle:"labelStyle",Layout:"layout",Left:"left",LetterSpacing:"letterSpacing",Limit:"limit",LineHeight:"lineHeight",Link:"link",Logo:"logo",LogoConfig:"logoConfig",LogoDesktop:"logoDesktop",LogoMobile:"logoMobile",Loop:"loop",MainBanner:"mainBanner",MainColor:"mainColor",MainConnection:"mainConnection",Map:"map",Margin:"margin",MaskClosable:"maskClosable",MaskStyle:"maskStyle",MaxHeight:"maxHeight",MaxWidth:"maxWidth",Md:"md.flex",Menu:"menu",MenuConfig:"menuConfig",MenuItemConfig:"menuItemConfig",MenuItemId:"menuItemId",MenuZone:"menuZone",Method:"method",MinHeight:"minHeight",MinHeightUnit:"minHeightUnit",MinWidth:"minWidth",Mobile:"mobile",Multiple:"multiple",MyColors:"colors",MusicDescription:"musicDescription",Name:"name",NameStyle:"nameStyle",NavigationColor:"navigationColor",NavigationStyle:"navigationStyle",Number:"number",NumberItemPerRow:"numberItemPerRow",NumberPosition:"numberPosition",NumberStyle:"numberStyle",NumberType:"numberType",NotificationMessage:"notificationMessage",ObjectFit:"objectFit",OpenNewTab:"openNewTab",OpenPageOfWebsite:"openPageOfWebsite",OpenArticleOfWebsite:"openArticleOfWebsite",Options:"options",OptionStyle:"optionStyle",OrderBy:"orderBy",Origin:"origin",OutOfMove:"outOfMove",OutOfPrize:"outOfPrize",OutOfTurn:"outOfTurn",Padding:"padding",PageMaxWidth:"pageMaxWidth",PageWidthType:"pageWidthType",PaginationColor:"paginationColor",PaginationPosition:"paginationPosition",PaginationStyle:"paginationStyle",ParagraphEditor:"paragraphEditor",PauseOnHover:"pauseOnHover",PauseOnMouseEnter:"pauseOnMouseEnter",Payload:"payload",Percent:"percent",Percentage:"percentage",PerpendicularPrize:"perpendicularPrize",Phone:"phone",Placeholder:"placeholder",Popup:"popup",PopupButton:"popupButton",Position:"position",PositionType:"positionType",PrefixNumber:"prefixNumber",PriceColor:"priceColor",PrimaryColor:"primaryColor",Prize:"prize",PrizeAngle:"prizeAngle",Platform:"platform",Radius:"radius",RedirectUrl:"redirectUrl",RegionName:"regionName",Request:"request",RequestKey:"requestKey",Required:"required",Response:"response",ResponseType:"responseType",ResponsiveSettings:"responsiveSettings",Rewind:"rewind",Right:"right",RightBanners:"rightBanners",RightItems:"rightItems",Rotate:"rotate",Roulette:"roulette",Row:"row",RowGap:"rowGap",RuleRepeat:"ruleRepeat",ScriptCustom:"scriptCustom",SectionMarginTop:"sectionMarginTop",Shadow:"shadow",SheetResponsePopup:"sheetResponsePopup",Show:"show",ShowAlt:"showAlt",ShowCloseBtn:"showCloseBtn",ShowCloseIcon:"showCloseIcon",ShowLabel:"showLabel",ShowMegaMenu:"showMegaMenu",ShowThumbnail:"showThumbnail",ShowTurn:"showTurn",SiteKey:"siteKey",Size:"size",Skin:"skin",SlidePerColumn:"slidesPerColumn",SlidePerView:"slidesPerView",SlidePerViewMobile:"slidesPerViewMobile",Slug:"slug",SortBy:"sortBy",Spacing:"spacing",SpacingWithMenu:"spacingWithMenu",Speed:"speed",SpinTrigger:"spinTrigger",SpinTurn:"spinTurn",Src:"src",StartTime:"startTime",StickyTop:"stickyTop",Stores:"stores",StrokeSize:"strokeSize",Style:"style",SubmitButton:"submitButton",Submits:"submits",SubmitTime:"submitTime",Success:"success",SuffixNumber:"suffixNumber",SyncDeviceStyle:"syncDeviceStyle",Tabs:"tabs",TagId:"tagId",Target:"target",TekoTrackingEvent:"tekoTrackingEvent",TerminalCode:"terminalCode",Text:"text",TextAfter:"textAfter",TextAlign:"textAlign",TextBefore:"textBefore",TextConfig:"textConfig",TextDecoration:"textDecoration",TextShadow:"textShadow",TextStyle:"textStyle",TextTransform:"textTransform",TimeUnitStyle:"timeUnitStyle",TimeVisibility:"timeVisibility",Title:"title",TitleStyle:"titleStyle",Toggle:"toggle",TogglePopup:"togglePopup",TogglePopupList:"togglePopupList",TextCopy:"textCopy",Top:"top",TopBanner:"topBanner",TopBarMenu:"topBarMenu",Total:"total",TrackingEventName:"trackingEventName",TriggerUpdate:"triggerUpdate",Type:"type",Tiktok:"tiktok",TotalFrame:"totalFrame",Unit:"unit",UploadSrc:"uploadSrc",Url:"url",Upload:"upload",Valid:"valid",Value:"value",Version:"version",VerticalAlignment:"verticalAlignment",ViewMoreStyle:"viewMoreStyle",ViewMoreUrl:"viewMoreUrl",Weight:"weight",Width:"width",WidthType:"widthType",WidthUnit:"widthUnit",MinWidthUnit:"minWidthUnit",MaxWidthUnit:"maxWidthUnit",MaxHeightUnit:"maxHeightUnit",WorkHours:"workHours",WrapperStyle:"wrapperStyle",Xs:"xs.flex",Youtube:"youtube",ZIndex:"zIndex",Zoom:"zoom",ZoomPreview:"zoomPreview",EmptyPrize:"emptyPrize",PageId:"pageId",Schema:"schema",DisplayType:"displayType",CursorWidth:"cursorWidth",BarWidth:"barWidth",BarGap:"barGap",BarRadius:"barRadius",WaveColor:"waveColor",CursorColor:"cursorColor",ProgressColor:"progressColor",OpenFourPosition:"openFourPosition",SubMenuBackgroundColor:"subMenuBackgroundColor",joinKey:(...e)=>e.filter(Boolean).join(".")};exports.PROP_KEY=e;


/***/ }),

/***/ 98322:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.resolvedNameMapping={Root:"RootEditor",Row:"RowEditor",Col:"ColEditor",GallerySlideshowEditor:"SliderEditor",CheckoutFormEditor:"CheckoutFormEditor",ImageEditor:"ImageEditor",ParagraphEditor:"ParagraphEditor",OrderPopupEditor:"OrderPopupEditor",ProductDetailPopupEditor:"ProductDetailPopupEditor",ButtonSubmitV3Editor:"ButtonSubmitV3Editor",AccordionContentEditor:"AccordionContentEditor",TabItemEditor:"TabItemEditor",ArticleHeaderEditor:"ArticleHeaderEditor",WebsiteHeaderEditor:"WebsiteHeaderEditor",TopBannerEditor:"TopBannerEditor",WebsiteFooterEditor:"WebsiteFooterEditor",TempiProductListEditorV2:"TempiProductListEditorV2",TempiProductListEditorV3:"TempiProductListEditorV3",TimelineEditor:"TimelineEditor",ContactBubbleEditor:"ContactBubbleEditor",OrderPopupV2Editor:"OrderPopupV2Editor",PopupEditorV1:"PopupEditorV1"};


/***/ }),

/***/ 852989:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(891987),r=__webpack_require__(85097),n=__webpack_require__(12893),o=__webpack_require__(828741),i=__webpack_require__(948185);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=a(t),l=Object.defineProperty,u=Object.defineProperties,d=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,g=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,S=(e,t,r)=>t in e?l(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,f=(e,t)=>{for(var r in t||(t={}))g.call(t,r)&&S(e,r,t[r]);if(c)for(var r of c(t))p.call(t,r)&&S(e,r,t[r]);return e},v=(e,t)=>u(e,d(t)),m=(e,t)=>{var r={};for(var n in e)g.call(e,n)&&t.indexOf(n)<0&&(r[n]=e[n]);if(null!=e&&c)for(var n of c(e))t.indexOf(n)<0&&p.call(e,n)&&(r[n]=e[n]);return r};const b="is-setting-pin",x=s.default.createContext({});exports.BuilderProvider=a=>{var s=a,{children:l,trackHelper:u,initialDevice:d="desktop",storeState:c,extraBuilderState:g,editorConfig:p}=s,S=m(s,["children","trackHelper","initialDevice","storeState","extraBuilderState","editorConfig"]);const{enable:C=!1,target:h="pageBuilder",screenName:E="PageBuilder"}=u||{},O=localStorage.getItem(b),[y,N]=t.useState(),[P,w]=t.useState(),[T,I]=t.useState(),[j,k]=t.useState(!1),[D,B]=t.useState("false"!==O),[M,q]=t.useState(),{trackManual:H,trackCustomEvent:F}=i.useTracking(E),[R,_]=t.useState(d),[A,G]=t.useState(!0),[L,U]=t.useState(!0),[J,z]=t.useState(!1),[K,Q]=t.useState(!1),[V,W]=t.useState(void 0),[X,Y]=t.useState(!1),[Z,$]=t.useState(!1),[ee,te]=t.useState(null),[re,ne]=t.useState(),[oe,ie]=t.useState(!1),[ae,se]=t.useState(!1),[le,ue]=t.useState(void 0),de=t.useMemo((()=>"mobile"===R?"mobile":"desktop"),[R]);return t.useEffect((()=>{localStorage.setItem(b,D.toString())}),[D]),e.jsx(x.Provider,{value:f(f({draggingNode:y,setDraggingNode:N,insertIndex:P,setInsertIndex:w,showSettingDialog:T,setShowSettingDialog:I,getAttrTracking:({regionName:e,contentName:t,payload:n={}})=>{let o={};return C&&(o=r.getTrackingData({isTrackContent:!0,regionName:e,contentName:t,index:null,target:h,payload:JSON.stringify(f({screenName:E},n))})),o},track:e=>{var t=m(e,[]);C&&H(f({target:h},t))},trackCustomEvent:F,setFrame:q,frame:M,device:R,realDevice:de,setDevice:_,showHiddenElements:A,setShowHiddenElements:G,allowConfigResponsive:L,setAllowConfigResponsive:U,hideBubbleOnEditor:J,setHideBubbleOnEditor:z,isEditingText:Z,setIsEditingText:$,showModalSelectPopup:K,setShowModalSelectPopup:Q,pinSetting:D,setPinSetting:B,relatedNodeId:V,setRelatedNodeId:W,showBubbleSetting:X,setShowBubbleSetting:Y,pageFonts:ee,setPageFonts:te,textEditor:re,setTextEditor:ne,openStyledMenu:oe,setOpenStyledMenu:ie,openPopupMenu:ae,setOpenPopupMenu:se,openThemeConfig:le,setOpenThemeConfig:ue,isOpenFloatingTextGenerator:j,setIsOpenFloatingTextGenerator:k,editorConfig:v(f({},p),{restrictedElementConfig:(null==p?void 0:p.restrictedElementConfig)||o.DEFAULT_RESTRICTED_ELEMENT_CONFIG,canCopyPaste:(null==p?void 0:p.canCopyPaste)||n.defaultCanCopyPaste,canDeleteNode:(null==p?void 0:p.canDeleteNode)||n.defaultCanDeleteNode,shortcutHandler:(null==p?void 0:p.shortcutHandler)||n.defaultShortcutHandler,type:null==p?void 0:p.type,uniqueNodeIds:(null==p?void 0:p.uniqueNodeIds)||n.defaultUniqueNodeIds})},g),S),children:e.jsx(r.StoreProvider,v(f({},c),{device:de,children:l}))})},exports.BuilderStateContext=x,exports.useBuilder=function(){const e=t.useContext(x);if(!e)throw new Error("useBuilder must be inside a BuilderStateContext with a state value");return e};


/***/ }),

/***/ 262411:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(547929),t=__webpack_require__(844383),o=__webpack_require__(678010),i=Object.defineProperty,s=Object.defineProperties,n=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable,u=(e,r,t)=>r in e?i(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,f=(e,r)=>{for(var t in r||(r={}))d.call(r,t)&&u(e,t,r[t]);if(c)for(var t of c(r))a.call(r,t)&&u(e,t,r[t]);return e};exports.withSelector=(i,c,d)=>{const a=t=>{const{connectors:{connect:c,drag:a}}=r.useNode(),u=o.useDraftNode(t);return e.jsx("div",(l=f({ref:e=>c(a(e))},d),p={children:e.jsx(i,f({isEditingMode:!0,isEditor:!0,isEditorMode:!0},u))},s(l,n(p))));var l,p};return a.craft=t.crafting(c),a},exports.withSelectorDirectElement=(i,s,n)=>{const c=t=>{const{connectors:{connect:s,drag:c}}=r.useNode(),d=o.useDraftNode(t);return e.jsx(i,f(f({ref:e=>s(c(e)),isEditingMode:!0,isEditor:!0,isEditorMode:!0},d),n))};return c.craft=t.crafting(s),c};


/***/ }),

/***/ 678010:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(891987),r=__webpack_require__(547929),t=__webpack_require__(12893),s=__webpack_require__(793882);exports.useDraftNode=u=>{const{id:a}=r.useNode(),o=s.useDraftStore((e=>e.drafts[a])),n=e.useRef({props:null,draftData:null,result:null});return e.useMemo((()=>{if(!o||0===Object.keys(o).length)return u;const e=n.current;if(e.props===u&&e.draftData===o)return e.result;const r=t.selectiveMergeBatch(u,o);return n.current={props:u,draftData:o,result:r},r}),[o,u])};


/***/ }),

/***/ 458460:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(623537),o=__webpack_require__(547929),t=__webpack_require__(85097),n=__webpack_require__(12893),d=__webpack_require__(407229),r=__webpack_require__(610314),a=__webpack_require__(852989),i=__webpack_require__(817314);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=s(d),c=Object.defineProperty,u=Object.defineProperties,p=Object.getOwnPropertyDescriptors,f=Object.getOwnPropertySymbols,g=Object.prototype.hasOwnProperty,N=Object.prototype.propertyIsEnumerable,v=(e,o,t)=>o in e?c(e,o,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[o]=t,h=(e,o)=>{for(var t in o||(o={}))g.call(o,t)&&v(e,t,o[t]);if(f)for(var t of f(o))N.call(o,t)&&v(e,t,o[t]);return e},m=(e,o)=>u(e,p(o));exports.useEditor=function(d){const{editorConfig:s}=a.useBuilder(),c=i.useBuilderStore((e=>e.setShowModalSelectBlock)),{message:u}=r.App.useApp(),p=o.useEditor(d),{actions:v,query:y}=p,O=((e,o)=>{var t={};for(var n in e)g.call(e,n)&&o.indexOf(n)<0&&(t[n]=e[n]);if(null!=e&&f)for(var n of f(e))o.indexOf(n)<0&&N.call(e,n)&&(t[n]=e[n]);return t})(p,["actions","query"]),b=(e,o)=>{var t;const n=m(h({},e),{id:o,events:{dragged:!1,hovered:!1,selected:!1},data:m(h({},null==e?void 0:e.data),{props:m(h({},null==(t=null==e?void 0:e.data)?void 0:t.props),{originNodeId:null==e?void 0:e.id})})});return y.parseFreshNode(n).toNode()},I=e=>{const o={},d=Object.keys(e.nodes).reduce(((o,n)=>s.uniqueNodeIds.has(n)?(o[n]=n,o):(o[n]=(e=>{var o,n;try{const d="popupv1"===(null==(n=null==(o=null==e?void 0:e.data)?void 0:o.custom)?void 0:n.tag);let r=t.generateRandomId(10);const a=y.node("ROOT").childNodes().find((e=>{var o,t,n;return null==(n=null==(t=null==(o=y.node(e))?void 0:o.get().data)?void 0:t.props)?void 0:n.isMainPopup}));if(!d||!a)return r;if(a.length>=r.length&&a>=r){const e=Object.keys(JSON.parse(y.serialize())).map((e=>parseInt(e.replaceAll(".",""),36)));r="."+(Math.max(...e)+1).toString(36)}return r}catch(e){return t.generateRandomId(10)}})(e.nodes[n]),o)),{}),r=(t,a)=>{var i,l;const c=d[t.id];s.restrictedElementConfig&&(t=n.transformNodeByConfig({tag:null==(l=null==(i=null==t?void 0:t.data)?void 0:i.custom)?void 0:l.tag,node:t,mappingKey:d,transformElementConfig:s.restrictedElementConfig}));const u=t.data.nodes.map((o=>r(e.nodes[o],c))),p=Object.keys(t.data.linkedNodes).reduce(((o,n)=>{const d=r(e.nodes[t.data.linkedNodes[n]],c);return m(h({},o),{[n]:d})}),{}),f=m(h({},t),{id:c,data:m(h({},t.data),{parent:a||t.data.parent,nodes:u,linkedNodes:p})}),g=y.parseFreshNode(f).toNode();return o[c]=g,c};return{rootNodeId:r(e.nodes[e.rootNodeId]),nodes:o}},x=e=>{const o=y.node(e).get();if(o)return o.data.parent&&y.node(o.data.parent).get()},T=e=>{const o=x(e);return o&&y.node(o.id).descendants()||[]};return h({actions:v,query:y,duplicateNode:async(e,o,t={})=>{const d=s.uniqueNodeIds.has(e.id);if(!e||!o||d)return;const{index:r}=t,a=y.node(e.id).descendants(!0),i={rootNodeId:e.id,nodes:{[e.id]:b(e,e.id)}};null==a||a.forEach((e=>{const o=y.node(e).get();i.nodes[o.id]=b(o,o.id)}));const l=I(i);return n.updateProductDetailIdForProductList(l.nodes),v.history.throttle().addNodeTree(l,o,r),null==l?void 0:l.rootNodeId},addBlock:async(e,o={})=>{const{index:n,parentId:d=t.ROOT,rootNodeId:r}=o,a=Object.entries(e).map((([e,o])=>y.parseSerializedNode(o).toNode((o=>o.id=e)))),i={rootNodeId:r,nodes:a.reduce(((e,o)=>(e[o.id]=o,e)),{})};if(!r){const e=a.find((e=>e.data.parent===t.ROOT));i.rootNodeId=null==e?void 0:e.id}const s=r?i:I(i);return void 0!==n?v.addNodeTree(s,d,n):v.addNodeTree(s,d),s},getSiblings:T,getNextNode:e=>{const o=T(e),t=o.findIndex((o=>o===e));return o[t+1]&&y.node(o[t+1]).get()},getPrevNode:e=>{const o=T(e),t=o.findIndex((o=>o===e));return o[t-1]&&y.node(o[t-1]).get()},getParent:x,resizeColumns:(e,o)=>{y.node(e).childNodes().forEach((e=>v.history.throttle().setProp(e,(e=>{l.default(e,"md.flex",`${n.floorPercentage(100/o)}%`)}))))},getLastSection:(e=t.ROOT)=>{const o=y.node(e).childNodes().filter((e=>{var o,t,n,d;return"RowEditor"===(null==(d=null==(n=null==(t=(o=y.node(e)).get)?void 0:t.call(o))?void 0:n.data)?void 0:d.name)}));return o[o.length-1]},onCopy:async o=>{try{const t=y.node(o).descendants(!0),n={rootNodeId:o,nodes:{[o]:y.node(o).toSerializedNode()}};null==t||t.forEach((e=>{const o=y.node(e).toSerializedNode();n.nodes[e]=o})),await navigator.clipboard.writeText(JSON.stringify(n)),u.success({content:e.t("Sao chép thành công")})}catch(e){u.error({content:`${e.name}: ${e.message}.`})}},onPaste:async o=>{try{const n=await navigator.clipboard.readText(),d=JSON.parse(n);for(const e in null==d?void 0:d.nodes)d.nodes[e]=y.parseSerializedNode(d.nodes[e]).toNode((o=>o.id=e));const a=I(d),i=y.node(o).get();if(!i)return;const l=s.shortcutHandler(a,i,y.node);if(!l)return;const{nodes:u}=y.node(t.ROOT).get().data,p=null==d?void 0:d.rootNodeId;s.uniqueNodeIds.has(p)&&u.includes(p)?(o=>{const t=o.toLowerCase();r.Modal.confirm({centered:!0,zIndex:2002,closable:!0,maskClosable:!0,icon:null,title:e.t("add_something",{nameOfSomething:t}),content:e.t("confirm_replace_global_block_by_the_new_one",{globalBlockName:t}),okText:e.t("Đồng ý"),cancelText:e.t("common.cancel"),onOk:()=>{v.history.throttle().delete(p),v.addNodeTree(a,l.parentIdToPaste,l.indexToPaste||0),c(!1)}})})(p):v.addNodeTree(a,l.parentIdToPaste,l.indexToPaste||0)}catch(e){}},cloneNodeTree:I},O)};


/***/ }),

/***/ 8474:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(891987),r=__webpack_require__(458460);exports.usePopupList=()=>{const{nodes:t}=r.useEditor((e=>({nodes:e.nodes})));return{popupListSelection:e.useMemo((()=>Object.keys(t).filter((e=>{var r,o;return"PopupEditorV1"===(null==(o=null==(r=t[e])?void 0:r.data)?void 0:o.name)})).map((e=>({label:t[e].data.props.name,value:e})))),[t])}};


/***/ }),

/***/ 2723:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(547929),t=__webpack_require__(47248),r=__webpack_require__(407229);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var u=o(t),a=o(r);exports.useProp=(t,r)=>{const{actions:{setProp:o},props:s}=e.useNode((e=>({props:e.data.props})));return["function"==typeof(null==r?void 0:r.formatter)?r.formatter(u.default(s,t)):u.default(s,t),e=>{o((o=>{"function"==typeof(null==r?void 0:r.parser)?a.default(o,t,null==r?void 0:r.parser(e)):a.default(o,t,e)}),500)}]};


/***/ }),

/***/ 40575:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(2723),o=__webpack_require__(96179);exports.usePropDeviceSpecific=function(r,s){const p=o.PROP_KEY.joinKey(o.PROP_KEY.Desktop,r),P=o.PROP_KEY.joinKey(o.PROP_KEY.Mobile,r),[t,i]=e.useProp(r,s),[u,n]=e.useProp(p,s),[c,K]=e.useProp(P,s);return{commonProp:t,desktopProp:u,mobileProp:c,setCommonProp:i,setDesktopProp:n,setMobileProp:K}};


/***/ }),

/***/ 78922:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(2723),o=__webpack_require__(96179),r=__webpack_require__(852989);exports.usePropSeparateDevice=function(s,i=!1,P){const{realDevice:t}=r.useBuilder(),u=o.PROP_KEY.joinKey(i&&t,s),p=o.PROP_KEY.joinKey(o.PROP_KEY.Desktop,s),n=o.PROP_KEY.joinKey(o.PROP_KEY.Mobile,s),[c]=e.useProp(o.PROP_KEY.SyncDeviceStyle),[d,v]=e.useProp(u,P),[K,l]=e.useProp(p,P),[,_]=e.useProp(n,P),[j,y]=e.useProp(s,P);return[i&&void 0===d?void 0===c&&void 0!==K?K:j:d,e=>{v(e),i&&(c&&("desktop"===t?_(e):l(e)),!c&&"mobile"===t||void 0!==e||void 0===j||y(e))}]};


/***/ }),

/***/ 482574:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(891987),r=__webpack_require__(85097),t=__webpack_require__(78922);exports.useSortable=(i,o=!1)=>{const[s,u]=t.usePropSeparateDevice(i,o);return[e.useMemo((()=>{var e;return null==(e=null==s?void 0:s.map)?void 0:e.call(s,((e,t)=>({id:e.id||`${JSON.stringify(e)}_${t}}`||`slider-item-${r.generateRandomId()}`,item:e})))}),[s]),e=>{const r=e([...s||[]]);u(r)}]};


/***/ }),

/***/ 948185:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=Object.defineProperty,e=Object.getOwnPropertySymbols,a=Object.prototype.hasOwnProperty,n=Object.prototype.propertyIsEnumerable,r=(e,a,n)=>a in e?t(e,a,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[a]=n,o=(t,o)=>{for(var c in o||(o={}))a.call(o,c)&&r(t,c,o[c]);if(e)for(var c of e(o))n.call(o,c)&&r(t,c,o[c]);return t};exports.useTracking=t=>({trackngScreenName:t,getAttrTracking:({regionName:e,contentName:a,target:n,payload:r={}})=>({"data-track-content":!0,"data-content-region-name":e,"data-content-name":a,"data-content-target":n,"data-content-payload":JSON.stringify(o({screenName:t},r))}),trackManual:({regionName:e,contentName:a,target:n,payload:r={},interaction:c="click"})=>{"function"==typeof track&&track("manualTrackInteractionContent",{interaction:c,contentName:a,regionName:e,target:n,payload:JSON.stringify(o({screenName:t},r))})},trackCustomEvent:(t,e)=>{"function"==typeof track&&track("customEvent",t,e)}});


/***/ }),

/***/ 623537:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}Object.defineProperty(exports, "__esModule", ({value:!0}));var t=e(__webpack_require__(396556)),r=Object.defineProperty,o=Object.defineProperties,n=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,a=Object.prototype.hasOwnProperty,i=Object.prototype.propertyIsEnumerable,u=(e,t,o)=>t in e?r(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o,c=(e,t)=>{for(var r in t||(t={}))a.call(t,r)&&u(e,r,t[r]);if(p)for(var r of p(t))i.call(t,r)&&u(e,r,t[r]);return e};exports.getOptionsI18n=(e,t,r)=>{const o="string"==typeof r?[r]:r;return t.map((t=>c(c({},t),o.reduce(((r,o)=>(r[o]=e(t[o]),r)),{}))))},exports.t=(e,r)=>{var p;return t.default.t(e,(p=c({},r),o(p,n({interpolation:{escapeValue:!1}}))))||e};


/***/ }),

/***/ 66811:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(547929),o=__webpack_require__(731051),r=__webpack_require__(12893),i=__webpack_require__(817314),t=__webpack_require__(423269),n=__webpack_require__(913494),s=__webpack_require__(208906),g=__webpack_require__(793882),u=__webpack_require__(691171),p=__webpack_require__(43730),a=__webpack_require__(500613),f=__webpack_require__(276467),C=__webpack_require__(780406),c=__webpack_require__(476756),l=__webpack_require__(392244),d=__webpack_require__(643784),x=__webpack_require__(273202),m=__webpack_require__(440178),S=__webpack_require__(776777),j=__webpack_require__(896121),q=__webpack_require__(626240),I=__webpack_require__(143299),P=__webpack_require__(321501),k=__webpack_require__(434472),b=__webpack_require__(147446),T=__webpack_require__(584491),A=__webpack_require__(587877),E=__webpack_require__(254686),V=__webpack_require__(569059),D=__webpack_require__(300910),B=__webpack_require__(781883),N=__webpack_require__(505765),M=__webpack_require__(432257),v=__webpack_require__(301930),R=__webpack_require__(955448),h=__webpack_require__(734957),U=__webpack_require__(920375),L=__webpack_require__(515676),F=__webpack_require__(117480),O=__webpack_require__(228831),G=__webpack_require__(746917),_=__webpack_require__(987359),w=__webpack_require__(87395),y=__webpack_require__(906068),H=__webpack_require__(281471),Q=__webpack_require__(61079),W=__webpack_require__(170517),z=__webpack_require__(75085),Y=__webpack_require__(185085),K=__webpack_require__(397155),X=__webpack_require__(766933),J=__webpack_require__(981982),Z=__webpack_require__(970388),$=__webpack_require__(151033),ee=__webpack_require__(904039),oe=__webpack_require__(164181),re=__webpack_require__(11575),ie=__webpack_require__(623906),te=__webpack_require__(215921),ne=__webpack_require__(797920),se=__webpack_require__(578211),ge=__webpack_require__(924216),ue=__webpack_require__(247309),pe=__webpack_require__(297476),ae=__webpack_require__(71678),fe=__webpack_require__(110691),Ce=__webpack_require__(909602),ce=__webpack_require__(88190),le=__webpack_require__(78180),de=__webpack_require__(34271),xe=__webpack_require__(39979),me=__webpack_require__(851921),Se=__webpack_require__(322293),je=__webpack_require__(989279),qe=__webpack_require__(123604),Ie=__webpack_require__(349567),Pe=__webpack_require__(290938),ke=__webpack_require__(993594),be=__webpack_require__(347619),Te=__webpack_require__(101736),Ae=__webpack_require__(642955),Ee=__webpack_require__(569433),Ve=__webpack_require__(838058),De=__webpack_require__(226061),Be=__webpack_require__(589375),Ne=__webpack_require__(373409),Me=__webpack_require__(712405),ve=__webpack_require__(689043),Re=__webpack_require__(635416),he=__webpack_require__(610168),Ue=__webpack_require__(75272),Le=__webpack_require__(982206),Fe=__webpack_require__(741817),Oe=__webpack_require__(573595),Ge=__webpack_require__(799194),_e=__webpack_require__(654986),we=__webpack_require__(827247),ye=__webpack_require__(641962),He=__webpack_require__(754914),Qe=__webpack_require__(767330),We=__webpack_require__(96179),ze=__webpack_require__(98322),Ye=__webpack_require__(828741),Ke=__webpack_require__(124449),Xe=__webpack_require__(852989),Je=__webpack_require__(262411),Ze=__webpack_require__(2723),$e=__webpack_require__(458460),eo=__webpack_require__(948185),oo=__webpack_require__(78922),ro=__webpack_require__(482574),io=__webpack_require__(8474),to=__webpack_require__(678010),no=__webpack_require__(40575),so=__webpack_require__(642180),go=__webpack_require__(366883),uo=__webpack_require__(446354),po=__webpack_require__(715859),ao=__webpack_require__(931722),fo=__webpack_require__(619691),Co=__webpack_require__(739646),co=__webpack_require__(844383),lo=__webpack_require__(675452),xo=__webpack_require__(702571),mo=__webpack_require__(525192),So=__webpack_require__(452281),jo=__webpack_require__(112739);Object.defineProperty(exports, "Editor", ({enumerable:!0,get:function(){return e.Editor}})),Object.defineProperty(exports, "Element", ({enumerable:!0,get:function(){return e.Element}})),Object.defineProperty(exports, "Events", ({enumerable:!0,get:function(){return e.Events}})),Object.defineProperty(exports, "Frame", ({enumerable:!0,get:function(){return e.Frame}})),Object.defineProperty(exports, "useNode", ({enumerable:!0,get:function(){return e.useNode}})),exports.DEFAULT_WIDTH=o.DEFAULT_WIDTH,exports.GRID_COLUMNS=o.GRID_COLUMNS,exports.MAX_WIDTH=o.MAX_WIDTH,exports.clonePageContent=r.clonePageContent,exports.defaultCanCopyPaste=r.defaultCanCopyPaste,exports.defaultCanDeleteNode=r.defaultCanDeleteNode,exports.defaultShortcutHandler=r.defaultShortcutHandler,exports.defaultUniqueNodeIds=r.defaultUniqueNodeIds,exports.deserializePB=r.deserializePB,exports.floorPercentage=r.floorPercentage,exports.gachaGameAndFormPaths=r.gachaGameAndFormPaths,exports.percentage=r.percentage,exports.resetGachaGameAndFormConfig=r.resetGachaGameAndFormConfig,exports.selectiveMerge=r.selectiveMerge,exports.selectiveMergeBatch=r.selectiveMergeBatch,exports.serializePB=r.serializePB,exports.setPbConfigProperties=r.setPbConfigProperties,exports.transformNodeByConfig=r.transformNodeByConfig,exports.updateProductDetailIdForProductList=r.updateProductDetailIdForProductList,exports.useBuilderStore=i.useBuilderStore,exports.useThemeStore=t.useThemeStore,exports.useHistoryStore=n.useHistoryStore,exports.PROVISION_STATUS=s.PROVISION_STATUS,exports.usePinposIntegrationStore=s.usePinposIntegrationStore,exports.useDraftStore=g.useDraftStore,exports.FormItem=u.FormItem,exports.RenderQuickSetting=p.RenderQuickSetting,exports.ColorPickerV2=a.ColorPickerV2,exports.ColorPickerV4=f.ColorPickerV4,exports.ColorPickerModal=C.ColorPickerModal,exports.ColorPickerModalV2=c.ColorPickerModalV2,exports.ColorDiv=l.ColorDiv,exports.ColorPickerModalV3=l.ColorPickerModalV3,exports.SelectedColor=l.SelectedColor,exports.ColorPickerDraggable=d.ColorPickerDraggable,exports.GradientBar=x.GradientBar,exports.SwitchToShow=m.SwitchToShow,exports.ModalConfigWrapper=S.ModalConfigWrapper,exports.QuickSettingButton=j.QuickSettingButton,exports.PrevNext=q.PrevNext,exports.SubQuickSetting=I.SubQuickSetting,exports.EditableCell=P.EditableCell,exports.StyledEditableCell=P.StyledEditableCell,exports.EditableContext=k.EditableContext,exports.EditableRow=k.EditableRow,exports.ContextMenu=b.ContextMenu,exports.UploadImageButton=T.UploadImageButton,exports.SettingWrapper=A.SettingWrapper,exports.ConfigWrapper=E.ConfigWrapper,exports.HorizontalPaddingDragHandler=V.HorizontalPaddingDragHandler,exports.Input=D.Input,exports.InputConfigV1=D.InputConfigV1,exports.InputConfig=B.InputConfig,exports.InputConfigV2=B.InputConfigV2,exports.InputV2=B.InputV2,exports.InputNumber=N.InputNumber,exports.InputNumberConfig=N.InputNumberConfig,exports.InputNumberConfigV2=M.InputNumberConfigV2,exports.InputNumberV2=M.InputNumberV2,exports.Select=v.Select,exports.SelectConfig=v.SelectConfig,exports.SwitchConfig=R.SwitchConfig,exports.UnitConfig=h.UnitConfig,exports.RadioConfig=U.RadioConfig,exports.DatePickerConfig=L.DatePickerConfig,exports.CodeEditorConfig=F.CodeEditorConfig,exports.TimingConfig=O.TimingConfig,exports.TimeVisibilityConfig=G.TimeVisibilityConfig,exports.ItemConfig=_.ItemConfig,exports.ItemListConfig=_.ItemListConfig,exports.RangeSliderConfig=w.RangeSliderConfig,exports.beforeUploadImage=y.beforeUploadImage,exports.ImageConfig=H.ImageConfig,exports.ImageUpload=Q.ImageUpload,exports.ImageUploadButton=W.ImageUploadButton,exports.ImageFormItem=z.ImageFormItem,exports.ImageFormItemV2=Y.ImageFormItemV2,exports.TrackingConfig=K.TrackingConfig,exports.EventClickConfig=X.EventClickConfig,exports.EventConfig=X.EventConfig,exports.SelectPopupConfig=J.SelectPopupConfig,exports.ImageListConfig=Z.ImageListConfig,exports.HoverConfig=$.HoverConfig,exports.AnimationConfig=ee.AnimationConfig,exports.AdvanceAttributes=oe.AdvanceAttributes,exports.ResponsiveAttribute=re.ResponsiveAttribute,exports.SpacingAttribute=ie.SpacingAttribute,exports.TimingAttributes=te.TimingAttributes,exports.ColorPickerConfig=ne.ColorPickerConfig,exports.ColorPickerConfigV2=se.ColorPickerConfigV2,exports.ColorPickerConfigV3=ge.ColorPickerConfigV3,exports.VerticalAlignmentConfig=ue.VerticalAlignmentConfig,exports.CustomRadioConfig=pe.CustomRadioConfig,exports.RangePickerConfig=ae.RangePickerConfig,exports.BackgroundPositionConfig=fe.BackgroundPositionConfig,exports.EffectAttributes=Ce.EffectAttributes,exports.ShadowConfig=ce.ShadowConfig,exports.AlignmentConfig=le.AlignmentConfig,exports.BackgroundConfig=de.BackgroundConfig,exports.BackgroundImageConfig=xe.BackgroundImageConfig,exports.BackgroundVideoConfig=me.BackgroundVideoConfig,exports.BorderConfig=Se.BorderConfig,exports.ButtonGroup=je.ButtonGroup,exports.ButtonGroupItem=qe.ButtonGroupItem,exports.TextareaToOptionConfig=Ie.TextareaToOptionConfig,exports.SizeAttribute=Pe.SizeAttribute,exports.VideoConfig=ke.VideoConfig,exports.FacebookConfig=be.FacebookConfig,exports.TikTokConfig=Te.TikTokConfig,exports.YouTubeConfig=Ae.YouTubeConfig,exports.UploadConfig=Ee.UploadConfig,exports.beforeUploadVideo=Ve.beforeUploadVideo,exports.getFileName=Ve.getFileName,exports.TextConfig=De.TextConfig,exports.InputSelectConfig=Be.InputSelectConfig,exports.TekoTrackingConfig=Ne.TekoTrackingConfig,exports.CornerConfig=Me.CornerConfig,exports.CornerConfigV2=ve.CornerConfigV2,exports.DocumentConfig=Re.DocumentConfig,exports.DirectionConfig=he.DirectionConfig,exports.CustomRadioButtonConfig=Ue.CustomRadioButtonConfig,exports.MinMaxInput=Le.MinMaxInput,exports.MinMaxInputConfig=Le.MinMaxInputConfig,exports.ImageRatioConfig=Fe.ImageRatioConfig,exports.AudioUploadConfig=Oe.AudioUploadConfig,exports.SelectArticleWebsite=Ge.SelectArticleWebsite,exports.SpacingConfig=_e.SpacingConfig,exports.ImageCropConfig=we.ImageCropConfig,exports.DraggableModal=ye.DraggableModal,exports.InputTextAreaConfig=He.InputTextAreaConfig,exports.AnimationLottieConfig=Qe.AnimationLottieConfig,exports.PROP_KEY=We.PROP_KEY,exports.resolvedNameMapping=ze.resolvedNameMapping,exports.DEFAULT_RESTRICTED_ELEMENT_CONFIG=Ye.DEFAULT_RESTRICTED_ELEMENT_CONFIG,exports.LLM_ACTION_TYPE=Ke.LLM_ACTION_TYPE,exports.LLM_EVENT_NAME=Ke.LLM_EVENT_NAME,exports.MESSAGE_ROLE=Ke.MESSAGE_ROLE,exports.TONE=Ke.TONE,exports.BuilderProvider=Xe.BuilderProvider,exports.BuilderStateContext=Xe.BuilderStateContext,exports.useBuilder=Xe.useBuilder,exports.withSelector=Je.withSelector,exports.withSelectorDirectElement=Je.withSelectorDirectElement,exports.useProp=Ze.useProp,exports.useEditor=$e.useEditor,exports.useTracking=eo.useTracking,exports.usePropSeparateDevice=oo.usePropSeparateDevice,exports.useSortable=ro.useSortable,exports.usePopupList=io.usePopupList,exports.useDraftNode=to.useDraftNode,exports.usePropDeviceSpecific=no.usePropDeviceSpecific,exports.OpenSettingDialog=so.OpenSettingDialog,exports.DeleteNode=go.DeleteNode,exports.DuplicateNode=uo.DuplicateNode,exports.EventQuickSetting=po.EventQuickSetting,exports.ImageListQuickSetting=ao.ImageListQuickSetting,exports.GuidelineNode=fo.GuidelineNode,exports.getColorThemeCssVarFromId=Co.getColorThemeCssVarFromId,exports.getColorValue=Co.getColorValue,exports.getHexColor=Co.getHexColor,exports.getRGBAColor=Co.getRGBAColor,exports.rgbaStringToObject=Co.rgbaStringToObject,exports.rgbaToString=Co.rgbaToString,exports.crafting=co.crafting,exports.getEditorName=co.getEditorName,exports.combineSize=lo.combineSize,exports.extractSize=lo.extractSize,exports.extractUrlFromCssUrl=lo.extractUrlFromCssUrl,exports.isNumeric=lo.isNumeric,exports.isPrefixUrl=lo.isPrefixUrl,exports.nomalizeText=lo.nomalizeText,exports.removeUnit=lo.removeUnit,exports.usePropOptionsUnitPercent=lo.usePropOptionsUnitPercent,exports.percentPropFormatter=xo.percentPropFormatter,exports.percentPropParser=mo.percentPropParser,exports.getImageObject=So.getImageObject,exports.editorRegistry=jo.editorRegistry;


/***/ }),

/***/ 366883:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(959211),r=__webpack_require__(547929),i=__webpack_require__(458460),n=__webpack_require__(896121);exports.DeleteNode=({customDelete:o})=>{const{actions:u,query:s}=i.useEditor(),{id:a,isDeletable:l}=r.useNode((e=>({isDeletable:s.node(e.id).isDeletable(),name:e.data.name,parent:e.data.parent})));return l?e.jsx(n.QuickSettingButton,{onClick:e=>{e.stopPropagation(),"function"==typeof o?o(a):u.delete(a)},children:e.jsx(t.Delete16Regular,{})}):null};


/***/ }),

/***/ 446354:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(547929),r=__webpack_require__(959211),i=__webpack_require__(458460),n=__webpack_require__(896121);exports.DuplicateNode=({track:u})=>{const{duplicateNode:o,getSiblings:d}=i.useEditor(),{id:s,node:c,parentId:a}=t.useNode((e=>({node:e,parentId:e.data.parent})));return e.jsx(n.QuickSettingButton,{onClick:()=>{const e=d(s).findIndex((e=>e===s));o(c,a,{index:e+1}),null==u||u()},children:e.jsx(r.Copy16Regular,{})})};


/***/ }),

/***/ 715859:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(623537),r=__webpack_require__(891987),i=__webpack_require__(959211),n=__webpack_require__(896121),o=__webpack_require__(766933),s=Object.defineProperty,u=Object.defineProperties,c=Object.getOwnPropertyDescriptors,l=Object.getOwnPropertySymbols,a=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,j=(e,t,r)=>t in e?s(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,b=(e,t)=>{for(var r in t||(t={}))a.call(t,r)&&j(e,r,t[r]);if(l)for(var r of l(t))p.call(t,r)&&j(e,r,t[r]);return e};exports.EventQuickSetting=s=>{const[l,a]=r.useState(!1);return e.jsxs(e.Fragment,{children:[e.jsx(n.QuickSettingButton,{tooltip:t.t("Gắn link"),onClick:()=>a(!0),children:e.jsx(i.Link16Regular,{})}),e.jsx(o.EventConfig,(p=b({},s),j={visible:l,setVisible:a},u(p,c(j))))]});var p,j};


/***/ }),

/***/ 619691:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(959211),i=__webpack_require__(547929),r=__webpack_require__(623537),t=__webpack_require__(896121);exports.GuidelineNode=()=>{const{name:o}=i.useNode((e=>({name:e.data.name}))),{guidelineUrls:u}=(null==window?void 0:window.config)||{},d=u&&u[o];return d&&e.jsx(t.QuickSettingButton,{onClick:()=>{window.open(d,"_blank","noopener,noreferrer")},tooltip:r.t("Video hướng dẫn"),children:e.jsx(n.QuestionCircle16Regular,{})})};


/***/ }),

/***/ 931722:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(623537),r=__webpack_require__(891987),i=__webpack_require__(959211),n=__webpack_require__(970388),o=__webpack_require__(896121),s=Object.defineProperty,u=Object.defineProperties,c=Object.getOwnPropertyDescriptors,a=Object.getOwnPropertySymbols,l=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,p=(e,t,r)=>t in e?s(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,j=(e,t)=>{for(var r in t||(t={}))l.call(t,r)&&p(e,r,t[r]);if(a)for(var r of a(t))g.call(t,r)&&p(e,r,t[r]);return e};exports.ImageListQuickSetting=s=>{const[a,l]=r.useState(!1);return e.jsxs(e.Fragment,{children:[e.jsx(o.QuickSettingButton,{tooltip:t.t("Quản lý ảnh"),onClick:()=>l(!0),children:e.jsx(i.ImageAddRegular,{style:{fontSize:16}})}),e.jsx(n.ImageListConfig,(g=j({},s),p={visible:a,setVisible:l},u(g,c(p))))]});var g,p};


/***/ }),

/***/ 642180:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(959211),i=__webpack_require__(547929),r=__webpack_require__(896121),n=__webpack_require__(852989),o=__webpack_require__(458460);exports.OpenSettingDialog=({children:s})=>{const{setShowSettingDialog:u}=n.useBuilder(),{actions:c}=o.useEditor(),{id:d}=i.useNode();return e.jsx(r.QuickSettingButton,{onClick:()=>{c.selectNode(d),u(!0)},children:s||e.jsx(t.Settings16Regular,{"data-testid":"btn-open-setting-dialog"})})};


/***/ }),

/***/ 817314:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));const e=(__webpack_require__(420851).create)((e=>({showModalSelectBlock:!1,setShowModalSelectBlock:t=>e({showModalSelectBlock:t}),openElementMenu:!1,setOpenElementMenu:t=>e({openElementMenu:t})})));exports.useBuilderStore=e;


/***/ }),

/***/ 793882:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(420851),t=__webpack_require__(410953),r=Object.defineProperty,a=Object.defineProperties,o=Object.getOwnPropertyDescriptors,n=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,i=Object.prototype.propertyIsEnumerable,s=(e,t,a)=>t in e?r(e,t,{enumerable:!0,configurable:!0,writable:!0,value:a}):e[t]=a,f=(e,t)=>{for(var r in t||(t={}))d.call(t,r)&&s(e,r,t[r]);if(n)for(var r of n(t))i.call(t,r)&&s(e,r,t[r]);return e},u=(e,t)=>a(e,o(t));const c=(e,t,r)=>{const a=t.split(".");if(1===a.length)return e[a[0]]===r?e:u(f({},e),{[a[0]]:r});const[o,...n]=a,d=e[o]||{},i=c(d,n.join("."),r);return i===d?e:u(f({},e),{[o]:i})},l=new Map,p=e=>{const t=l.get(e);t&&(t.rafId&&cancelAnimationFrame(t.rafId),t.timeoutId&&clearTimeout(t.timeoutId),l.delete(e))},m=e.create()(t.subscribeWithSelector(((e,t)=>({drafts:{},updateDraft:(t,r,a)=>{e((e=>{const o=e.drafts[t]||{},n=c(o,r,a);return n===o?e:{drafts:u(f({},e.drafts),{[t]:n})}}))},updateDraftThrottled:(e,r,a)=>{const o=`${e}:${r}`,n=Date.now();let d=l.get(o);d||(d={lastUpdate:0},l.set(o,d));const i=n-d.lastUpdate;if(d.rafId&&(cancelAnimationFrame(d.rafId),d.rafId=void 0),d.timeoutId&&(clearTimeout(d.timeoutId),d.timeoutId=void 0),i>=16)d.lastUpdate=n,d.pendingValue=void 0,t().updateDraft(e,r,a);else{d.pendingValue=a;const n=16-i;d.rafId=requestAnimationFrame((()=>{const a=l.get(o);a&&(a.rafId=void 0,a.timeoutId=window.setTimeout((()=>{const a=l.get(o);a&&(void 0!==a.pendingValue&&(a.lastUpdate=Date.now(),t().updateDraft(e,r,a.pendingValue),a.pendingValue=void 0),a.timeoutId=void 0)}),Math.max(0,n-1)))}))}},clearDraft:t=>{for(const[e]of l)e.startsWith(`${t}:`)&&p(e);e((e=>{if(!e.drafts[t])return e;const r=f({},e.drafts);return delete r[t],{drafts:r}}))},commitDraft:(e,r)=>{for(const[r,a]of l)if(r.startsWith(`${e}:`)){if(a.rafId&&cancelAnimationFrame(a.rafId),a.timeoutId&&clearTimeout(a.timeoutId),void 0!==a.pendingValue){const o=r.substring(e.length+1);t().updateDraft(e,o,a.pendingValue)}l.delete(r)}const a=t().drafts[e];return!!a&&(r(a),t().clearDraft(e),!0)}}))));if("undefined"!=typeof window){const e=()=>{for(const[e]of l)p(e)};window.addEventListener("beforeunload",e)}exports.useDraftStore=m;


/***/ }),

/***/ 913494:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(420851),e=__webpack_require__(410953);const s=(t,e)=>s=>{t("function"==typeof s?t=>({[e]:s(t[e])}):{[e]:s})},r=t.create()(e.devtools((t=>({pastColorPaletteList:[],futureColorPaletteList:[],pastTextStyleList:[],futureTextStyleList:[],setPastColorPaletteList:s(t,"pastColorPaletteList"),setFutureColorPaletteList:s(t,"futureColorPaletteList"),setPastTextStyleList:s(t,"pastTextStyleList"),setFutureTextStyleList:s(t,"futureTextStyleList")}))));exports.useHistoryStore=r;


/***/ }),

/***/ 208906:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var i=__webpack_require__(610314),t=__webpack_require__(420851),e=__webpack_require__(410953),n=__webpack_require__(623537);const r="current_mapping_terminals";var o=(i=>(i.IDLE="idle",i.PROVISIONING="provisioning",i.PROVISIONED="provisioned",i.FAILED="failed",i.TIMEOUT="timeout",i))(o||{});const s=t.create()(e.subscribeWithSelector(e.devtools(((t,e)=>({startProvisioning:!1,terminalId:"",loadingIntegration:!1,provisionStatus:"idle",pinposAppId:null,initializedMerchantId:null,pinposApiService:null,mmApiService:null,pollingInterval:null,startTime:null,retryCount:0,autoProvisionTriggered:!1,setStartProvisioning:i=>{t({startProvisioning:i}),i||t({autoProvisionTriggered:!1})},setTerminalId:i=>t({terminalId:i}),setLoadingIntegration:i=>t({loadingIntegration:i}),setProvisionStatus:i=>t({provisionStatus:i}),setPinposAppId:i=>t({pinposAppId:i}),initializeProvisioning:(i,e,n)=>{t({pinposAppId:i,mmApiService:e,initializedMerchant:n})},initializeTerminalMapping:(i,e,n)=>{t({pinposApiService:i,website:e,flagPB4900:n})},createTerminal:async i=>{const{pinposApiService:t,provisionStatus:n}=e();if(!t||"provisioned"!==n)return null;const r=i=>new Promise((t=>setTimeout(t,i)));for(let e=1;e<=3;e++)try{const e=await t.createTerminal(i);return(null==e?void 0:e.terminalId)||null}catch(i){e<3&&await r(5e3)}return null},fetchTerminalIdByWebsite:async i=>{const{pinposApiService:t}=e();if(!t)return null;try{return e().getTerminalIdFromLocalStorage(i)||await t.getTerminalId(i)}catch(i){return null}},initPinposTerminal:async()=>{var i;const{pinposAppId:t,setTerminalId:n,fetchTerminalIdByWebsite:r,createTerminal:o,saveTerminalIdToLocalStorage:s,provisionStatus:a,flagPB4900:l,website:p,initializedMerchant:c}=e();try{if(!l||!p||(null==(i=p.extraInfo)?void 0:i.sellingPartnerId)!==t||"provisioned"!==a)return;let e=await r(p.id);e||"provisioned"!==a||(e=await o({websiteId:p.id,websiteName:p.name||"",merchantId:c.marketMerchantId})),e&&(n(e),s(e,p.id))}catch(i){}},getTerminalIdFromLocalStorage:i=>{if("undefined"==typeof window||!window.localStorage)return null;try{const t=JSON.parse(localStorage.getItem(r)||"null");return(null==t?void 0:t.websiteId)===i&&(null==t?void 0:t.terminalId)||null}catch(i){return null}},saveTerminalIdToLocalStorage:(i,t)=>{if("undefined"!=typeof window&&window.localStorage)try{localStorage.setItem(r,JSON.stringify({websiteId:t,terminalId:i}))}catch(i){}},clearPolling:()=>{const{pollingInterval:i}=e();i&&clearInterval(i),t({pollingInterval:null,startTime:null})},resetProvisioning:()=>{const{clearPolling:i}=e();i(),t({provisionStatus:"idle",retryCount:0})},checkPinposProvision:i=>{const{pinposAppId:n}=e();if(!i||!i.length||!n)return!1;const r=i.some((i=>i.appId===n&&i.isActive&&i.isNotified));return r&&t({provisionStatus:"provisioned"}),r},checkPinposStatus:async()=>{const{pinposAppId:t,clearPolling:r,setProvisionStatus:o,checkPinposProvision:s,mmApiService:a,initPinposTerminal:l,terminalId:p,setLoadingIntegration:c}=e();if(!t||!a)return!1;try{const t=await a.getOwnedLBMerchant();if((null==t?void 0:t.length)>0){if(s(t[0].subscriptions))return r(),p||(await l(),c(!1),i.notification.success({message:n.t("pinpos_integration.success_provision")})),!0;{const{startTime:t}=e();null!==t&&Date.now()-t>9e5&&(i.notification.error({message:n.t("pinpos_integration.error_provision_timeout")}),o("timeout"),r(),c(!1))}}}catch(i){}return!1},callProvisionApi:async()=>{const{pinposAppId:i,mmApiService:t}=e();if(!i||!t)return!1;try{return await t.provisionApp({appIds:[i]}),!0}catch(i){return!1}},retryProvision:async()=>{const{retryCount:i,setProvisionStatus:n,callProvisionApi:r}=e();return i>=3?(n("failed"),!1):(t({retryCount:i+1}),new Promise((i=>{setTimeout((async()=>{const t=await r();i(t)}),5e3)})))},provisionPinpos:async()=>{const{pinposAppId:r,clearPolling:o,setProvisionStatus:s,checkPinposProvision:a,checkPinposStatus:l,callProvisionApi:p,retryProvision:c,resetAutoProvisionFlag:u,setLoadingIntegration:d,initializedMerchant:v}=e();if(!r||!v)return{success:!1,error:new Error("Pinpos App ID not initialized")};try{d(!0),t({retryCount:0});let i=!1;if(i=(null==v?void 0:v.subscriptions)?a(v.subscriptions):await l(),i)return t({provisionStatus:"provisioned"}),o(),{success:!0};const{pollingInterval:n}=e();if(n)return{success:!1,error:new Error("Provision already in progress")};s("provisioning");let r=await p();for(;!r&&e().retryCount<3;)r=await c();if(!r)return s("failed"),{success:!1,error:new Error("Failed to provision Pinpos after multiple attempts")};if(await l())return t({provisionStatus:"provisioned"}),{success:!0};t({startTime:Date.now()});const u=setInterval((async()=>{await l()}),3e4);return t({pollingInterval:u}),{success:!0,message:"Provision process started"}}catch(t){return i.notification.error({message:n.t("pinpos_integration.error_provision")}),d(!1),{success:!1,error:new Error("Failed to provision Pinpos")}}finally{u()}},cancelProvision:()=>{const{pollingInterval:i,clearPolling:t,setProvisionStatus:n}=e();return!!i&&(t(),n("idle"),!0)},getStartProvisioning:()=>e().startProvisioning,getTerminalId:()=>e().terminalId,getLoadingIntegration:()=>e().loadingIntegration,getProvisionStatus:()=>e().provisionStatus,resetAutoProvisionFlag:()=>t({autoProvisionTriggered:!1})})))));s.subscribe((i=>({startProvisioning:i.startProvisioning,loadingIntegration:i.loadingIntegration,provisionStatus:i.provisionStatus,pinposAppId:i.pinposAppId,mmApiService:i.mmApiService,autoProvisionTriggered:i.autoProvisionTriggered})),((i,t)=>{i.startProvisioning&&!t.startProvisioning&&!i.loadingIntegration&&"idle"===i.provisionStatus&&i.pinposAppId&&i.mmApiService&&!i.autoProvisionTriggered&&(s.setState({autoProvisionTriggered:!0}),setTimeout((()=>{const{provisionPinpos:i}=s.getState();i()}),0))})),exports.PROVISION_STATUS=o,exports.usePinposIntegrationStore=s;


/***/ }),

/***/ 423269:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(420851),t=__webpack_require__(410953),o=__webpack_require__(85097),a=Object.defineProperty,r=Object.defineProperties,n=Object.getOwnPropertyDescriptors,i=Object.getOwnPropertySymbols,l=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,f=(e,t,o)=>t in e?a(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o,s=(e,t)=>{for(var o in t||(t={}))l.call(t,o)&&f(e,o,t[o]);if(i)for(var o of i(t))g.call(t,o)&&f(e,o,t[o]);return e},d=(e,t)=>r(e,n(t));const c=e.create()(t.devtools(((e,t)=>({theme:void 0,fontFamilyHeading:void 0,fontFamilyParagraph:void 0,headingsConfig:[],paragraphsConfig:[],currentColorPalette:void 0,recentColors:[],loadingUpdateTheme:[],setFontFamilyHeading:t=>e({fontFamilyHeading:t}),setFontFamilyParagraph:t=>e({fontFamilyParagraph:t}),setHeadingsConfig:t=>e({headingsConfig:t}),setParagraphsConfig:t=>e({paragraphsConfig:t}),setCurrentColorPalette:t=>e({currentColorPalette:t}),setTheme:t=>e({theme:t}),setRecentColors:t=>e({recentColors:t}),initThemeData:async t=>{const a=((null==t?void 0:t.fontStyles)||[]).reduce(((e,t)=>{const a=t,{fontFamily:r}=a,n=((e,t)=>{var o={};for(var a in e)l.call(e,a)&&t.indexOf(a)<0&&(o[a]=e[a]);if(null!=e&&i)for(var a of i(e))t.indexOf(a)<0&&g.call(e,a)&&(o[a]=e[a]);return o})(a,["fontFamily"]);return o.isHeadingFontStyle(t.id)&&(e.headingsConfig.push(n),e.fontFamilyHeading=r,e.fontFamilyHeadingSource=t.fontSource),o.isParagraphFontStyle(t.id)&&(e.paragraphsConfig.push(n),e.fontFamilyParagraph=r,e.fontFamilyParagraphSource=t.fontSource),e}),{headingsConfig:[],paragraphsConfig:[],fontFamilyHeading:"",fontFamilyParagraph:"",fontFamilyHeadingSource:o.FontSource.GOOGLE,fontFamilyParagraphSource:o.FontSource.GOOGLE});e({fontFamilyHeading:{value:a.fontFamilyHeading,source:a.fontFamilyHeadingSource},fontFamilyParagraph:{value:a.fontFamilyParagraph,source:a.fontFamilyParagraphSource},headingsConfig:a.headingsConfig,paragraphsConfig:a.paragraphsConfig,currentColorPalette:(null==t?void 0:t.colorPalette)||[],recentColors:null==t?void 0:t.recentColors,initialized:!0,theme:t})},updateThemeConfig:(o,a)=>{if(!o)return;const r=t(),{paragraphStyles:n=r.paragraphsConfig,headingStyles:i=r.headingsConfig,ffHeading:l=r.fontFamilyHeading,ffParagraph:g=r.fontFamilyParagraph,recentColors:f=r.recentColors}=o,c=n.map((e=>d(s({},e),{fontFamily:g.value,fontSource:g.source}))),p=i.map((e=>d(s({},e),{fontFamily:l.value,fontSource:l.source})));e(d(s(s(s(s(s({},o.headingStyles?{headingsConfig:p}:{}),o.paragraphStyles?{paragraphsConfig:c}:{}),o.ffHeading?{fontFamilyHeading:l}:{}),o.ffParagraph?{fontFamilyParagraph:g}:{}),o.recentColors?{recentColors:f}:{}),{theme:{colorPalette:r.currentColorPalette,fontStyles:[...p,...c],recentColors:f}})),null==a||a({colorPalette:r.currentColorPalette,fontStyles:[...p,...c],recentColors:f})},getCurrentTheme:()=>t().theme,getCurrentColor:()=>t().currentColorPalette,loadFont:()=>{const e=t();e.initialized&&(e.fontFamilyHeading.source===o.FontSource.GOOGLE&&o.loadNewGGFont(e.fontFamilyHeading.value,[document]),e.fontFamilyParagraph.source===o.FontSource.GOOGLE&&o.loadNewGGFont(e.fontFamilyParagraph.value,[document]))},getThemeMapping:()=>{var e,o;const a=t(),r=null==(e=a.theme.colorPalette)?void 0:e.reduce(((e,t)=>(e[t.id]=t.color,e)),{}),n=null==(o=a.theme.fontStyles)?void 0:o.reduce(((e,t)=>{const o=t.fontSizeUnit||"px",a=t.mobileFontSize||t.fontSize,r=t.mobileFontSizeUnit||o,n=t.mobileLetterSpacing||t.letterSpacing,i=t.mobileLineHeight||t.lineHeight;return e[`${t.id}fontfamily`]=t.fontFamily,e[`${t.id}fontsize`]=`${t.fontSize}${o}`,e[`${t.id}fontweight`]=t.fontWeight,e[`${t.id}letterspacing`]=void 0!==t.letterSpacing?`${t.letterSpacing}px`:"unset",e[`${t.id}lineheight`]=void 0!==t.lineHeight?`${t.lineHeight}px`:"unset",e[`${t.id}mobilefontsize`]=`${a}${r}`,e[`${t.id}mobilefontweight`]=t.mobileFontWeight||t.fontWeight,e[`${t.id}mobileletterspacing`]=void 0!==n?`${n}px`:"unset",e[`${t.id}mobilelineheight`]=void 0!==i?`${i}px`:"unset",e}),{});return s(s({},r),n)}}))));exports.useThemeStore=c;


/***/ }),

/***/ 739646:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var r=__webpack_require__(85097),t=__webpack_require__(623537);const e=r=>{if(!r)return null;const t=/rgb\(/.test(r),e=r.indexOf(",")>-1?",":" ",o=r.substr(t?4:5).split(")")[0].split(e);let l=(+o[0]).toString(16),n=(+o[1]).toString(16),i=(+o[2]).toString(16),s=1,a="ff";return o.length>=4&&(s=parseFloat(o[3]),a=0===s?"00":Math.round(255*s).toString(16)),1===l.length&&(l="0"+l),1===n.length&&(n="0"+n),1===i.length&&(i="0"+i),1===a.length&&(a="0"+a),{hex:"#"+l+n+i+a,rgba:{r:parseInt(o[0]),g:parseInt(o[1]),b:parseInt(o[2]),a:s}}},o=r=>`rgba(${r.r},${r.g},${r.b},${null!=r.a?r.a:1})`,l=r=>r.startsWith("#")?r:r.startsWith("rgb")?e(r).hex:void 0;exports.getColorThemeCssVarFromId=r=>`var(--tempi-global-${r})`,exports.getColorValue=(e,o=!0)=>{if(!e)return;const n=r.parseColor(e);if((null==n?void 0:n.colorType)===r.ColorType.gradient)return;if((null==n?void 0:n.colorType)===r.ColorType.solid)return l(e);const i=e.match(/var\(--tempi-global-color(\d+)\)/),s=null==i?void 0:i[1];return s?o?`${t.t("Màu")} ${s}`:t.t("color_picker.color_in_theme",{indexColor:s}):i?t.t("common.theme_color"):void 0},exports.getHexColor=l,exports.getRGBAColor=t=>{var l;if(!t)return null;let n=t;/^#.+$/.test(t)&&(n=r.getRgbaFromHex(t));const i=null==(l=e(n))?void 0:l.rgba;return o(i)},exports.rgbaStringToObject=e,exports.rgbaToString=o;


/***/ }),

/***/ 844383:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=Object.defineProperty,e=Object.defineProperties,o=Object.getOwnPropertyDescriptors,r=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,n=Object.prototype.propertyIsEnumerable,a=(e,o,r)=>o in e?t(e,o,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[o]=r,d=(t,e)=>{for(var o in e||(e={}))i.call(e,o)&&a(t,o,e[o]);if(r)for(var o of r(e))n.call(e,o)&&a(t,o,e[o]);return t};const c={commonStyle:{margin:{top:void 0,bottom:void 0,left:void 0,right:void 0},padding:{top:void 0,bottom:void 0,left:void 0,right:void 0},backgroundColor:void 0,backgroundRepeat:void 0,backgroundPosition:void 0,backgroundSize:void 0,width:void 0,maxWidth:void 0,minWidth:void 0,height:void 0,maxHeight:void 0,minHeight:void 0}},s={responsive:{hiddenXs:!1,hiddenMd:!1}};exports.crafting=t=>{var a=t,{props:u={},related:v={},customAttributes:b,commonAttributes:l,advanceAttributes:p,advanceAttributesApp:m,effectAttributes:f,rules:g,custom:A={},tag:y,commonStyle:O={},quickSetting:h}=a,S=((t,e)=>{var o={};for(var a in t)i.call(t,a)&&e.indexOf(a)<0&&(o[a]=t[a]);if(null!=t&&r)for(var a of r(t))e.indexOf(a)<0&&n.call(t,a)&&(o[a]=t[a]);return o})(a,["props","related","customAttributes","commonAttributes","advanceAttributes","advanceAttributesApp","effectAttributes","rules","custom","tag","commonStyle","quickSetting"]);const j=d({},v);return b&&(j.customAttributes=b),l&&(j.commonAttributes=l),p&&(j.advanceAttributes=p),m&&(j.advanceAttributesApp=m),h&&(j.quickSetting=h),f&&(j.effectAttributes=f),d({props:d(d((k=d({},c),x={commonStyle:O},e(k,o(x))),s),u),related:j,rules:g,custom:d(d({},A),{tag:y})},S);var k,x},exports.getEditorName=t=>{var e;return null==(e=Object.keys(t))?void 0:e[0]};


/***/ }),

/***/ 112739:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));const e=new class{constructor(){this.editors=new Map}register(e,t){this.editors.set(e,t)}unregister(e){this.editors.delete(e)}get(e){return this.editors.get(e)}};exports.editorRegistry=e;


/***/ }),

/***/ 452281:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.getImageObject=async e=>new Promise((async(o,r)=>{const t=await(e=>new Promise(((o,r)=>{const t=new FileReader;t.readAsDataURL(e),t.onloadend=()=>o(t.result.toString()),t.onerror=e=>r(e)})))(e),n=new Image;n.src=t,n.onload=()=>{n.complete&&o(n)},n.onerror=e=>r(e)}));


/***/ }),

/***/ 12893:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097),t=__webpack_require__(630839),o=__webpack_require__(731051),r=__webpack_require__(407229),n=__webpack_require__(47248),a=__webpack_require__(327879),i=__webpack_require__(98322);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=l(t),s=l(r),p=l(n),u=Object.defineProperty,c=Object.defineProperties,m=Object.getOwnPropertyDescriptors,g=Object.getOwnPropertySymbols,v=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,y=(e,t,o)=>t in e?u(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o,h=(e,t)=>{for(var o in t||(t={}))v.call(t,o)&&y(e,o,t[o]);if(g)for(var o of g(t))f.call(t,o)&&y(e,o,t[o]);return e},b=(e,t)=>c(e,m(t));const O=e=>Math.floor(100*e)/100,N=(e,t)=>O(e/t*100)+"%",E=[{path:["customAttributes","luckydrawv2","configStorage","formConfigId"],tag:"luckydrawv2"},{path:["elementId"],tag:"luckydrawv2"},{path:["customAttributes","luckymoney","gameId"],tag:"luckymoney"},{path:["customAttributes","luckymoney","configStorage","formConfigId"],tag:"luckymoney"},{path:["customAttributes","potsmashing","configStorage","formConfigId"],tag:"potsmashing"},{path:["customAttributes","potsmashing","gameId"],tag:"potsmashing"},{path:["customAttributes","treasurehunting","configStorage","formConfigId"],tag:"treasurehunting"},{path:["customAttributes","treasurehunting","gameId"],tag:"treasurehunting"},{path:["customAttributes","formv4","configStorage","formConfigId"],tag:"formv4"},{path:["customAttributes","formcheckout","configStorage","formConfigId"],tag:"formcheckout"},{path:["customAttributes","leadform","configStorage","formConfigId"],tag:"leadform"},{path:["customAttributes","tempiproductlistv3","productDisplay","categoryId"],tag:"tempiproductlistv3"},{path:["customAttributes","tempiproductlistv3","productDisplay","skus"],tag:"tempiproductlistv3"},{path:["customAttributes","orderpopupv2","configStorage","formConfigId"],tag:"orderpopupv2"}],P=["tempiproductlistv2","tempiproductlist"],k=["tempiproductlistv3"],j=(e,t,o=null)=>{for(const r in e)t.forEach((t=>{e[r].tag===t.tag&&s.default(e[r],t.path,o)}))},M=new Set([e.HEADER,e.FOOTER,e.TOP_BANNER]),I=({node:e,transformElementConfig:t,tag:o,mappingKey:r})=>{const n=t.filter((e=>e.tags.includes(o)));return(null==n?void 0:n.length)?(n.forEach((t=>{(t.resetFields||[]).forEach((t=>{s.default(e,t,void 0)})),Object.entries(t.mappingFields||{}).forEach((([t,o])=>{const n=p.default(e,t);n&&s.default(e,t,o(n,r))}))})),e):e},C=(e,t)=>{const o=t(e).get();if(o)return o.data.parent&&t(o.data.parent).get()},A=(e,t)=>{var o;t&&e[t]&&(((null==(o=e[t].data)?void 0:o.nodes)||[]).forEach((t=>A(e,t))),delete e[t])},S=e=>{Object.values(e).forEach((t=>{if(t.data.name===i.resolvedNameMapping.TempiProductListEditorV3){let o;t.data.nodes.forEach((t=>{const r=e[t];r.data.name===i.resolvedNameMapping.ProductDetailPopupEditor&&(o=r.id,r.data.props.id=r.id)})),t.data.props.productDetailPopup=o}}))},x=e=>"object"==typeof e&&null!==e&&!Array.isArray(e),R=Array.isArray,D=e=>e!==Object(e),w=(e,t)=>{const o=e.length,r=t.length,n=o>r?o:r;let a,i=!1;for(let l=0;l<n;l++){const n=t[l],d=e[l];if(l>=o){null!=n&&(i||(a=e.slice(),i=!0),a.push(n));continue}if(l>=r||null==n){i&&a.push(d);continue}const s=T(d,n);s!==d?(i||(a=e.slice(0,l),i=!0),a.push(s)):i&&a.push(d)}return i?a:e},T=(e,t)=>{if(D(e)||D(t))return e===t?e:t;const o=R(e),r=R(t);return o&&r?w(e,t):o||r?((e,t)=>{if(e===t)return!0;if("object"!=typeof e||null===e||null===t)return!1;const o=Object.keys(e),r=o.length;if(r!==Object.keys(t).length)return!1;for(let n=0;n<r;n++){const r=o[n];if(e[r]!==t[r])return!1}return!0})(e,t)?e:t:B(e,t)},B=(e,t)=>{const o=Object.keys(t);if(0===o.length)return e;let r=e,n=!1;for(let a=0;a<o.length;a++){const i=o[a],l=t[i];if(void 0===l)continue;const d=e[i];if(l===d)continue;let s;s=R(l)?R(d)?w(d,l):l:x(l)?x(d)||R(d)?B(d,l):l:d===l?d:l,s!==d&&(n||(r=R(e)?e.slice():h({},e),n=!0),r[i]=s)}return r};exports.clonePageContent=(t,o,r=!1)=>{if(!t)return t;const n={},a=Object.keys(t).filter((o=>t[o].parentId===e.ROOT)),i=parseInt(e.generateRandomId(10).replaceAll(".",""),36);for(let e=0;e<a.length;e++)n[a[e]]="."+(i+e).toString(36);for(const o in t)o===e.ROOT?n[o]=o:n[o]||(n[o]=e.generateRandomId(10));const l={};return Object.entries(t).forEach((([e,t])=>{t.id=n[t.id]||t.id,t.children=(t.children||[]).map((e=>n[e]||e)),t.parentId=n[t.parentId]||t.parentId;const r=n[e];l[r]=I({tag:t.tag,node:t,mappingKey:n,transformElementConfig:o})})),r?[l,n]:l},exports.defaultCanCopyPaste=(e,t)=>!Array.from(e).some((e=>{var o,r,n,a,l,d;const s=t(e).get(),p=null==(o=null==s?void 0:s.data)?void 0:o.name;return p===i.resolvedNameMapping.Row?[i.resolvedNameMapping.OrderPopupEditor,i.resolvedNameMapping.ProductDetailPopupEditor].includes(null==(n=null==(r=C(e,t))?void 0:r.data)?void 0:n.name):p===i.resolvedNameMapping.Col?[i.resolvedNameMapping.OrderPopupEditor,i.resolvedNameMapping.ProductDetailPopupEditor].includes(null==(d=null==(l=C(null==(a=null==s?void 0:s.data)?void 0:a.parent,t))?void 0:l.data)?void 0:d.name):[i.resolvedNameMapping.CheckoutFormEditor,i.resolvedNameMapping.OrderPopupEditor,i.resolvedNameMapping.ProductDetailPopupEditor,i.resolvedNameMapping.ButtonSubmitV3Editor].includes(p)})),exports.defaultCanDeleteNode=(t,o)=>!Array.from(t).some((e=>{var t,r,n,a,l,d;const s=o(e).get(),p=null==(t=null==s?void 0:s.data)?void 0:t.name;return p===i.resolvedNameMapping.Row?[i.resolvedNameMapping.OrderPopupEditor,i.resolvedNameMapping.ProductDetailPopupEditor].includes(null==(n=null==(r=C(e,o))?void 0:r.data)?void 0:n.name):p===i.resolvedNameMapping.Col?[i.resolvedNameMapping.OrderPopupEditor,i.resolvedNameMapping.ProductDetailPopupEditor].includes(null==(d=null==(l=C(null==(a=null==s?void 0:s.data)?void 0:a.parent,o))?void 0:l.data)?void 0:d.name):[i.resolvedNameMapping.CheckoutFormEditor,i.resolvedNameMapping.OrderPopupEditor,i.resolvedNameMapping.ProductDetailPopupEditor,i.resolvedNameMapping.ButtonSubmitV3Editor].includes(p)}))||t.has(e.ARTICLE_HEADER),exports.defaultShortcutHandler=(e,t,o)=>{var r;let n;const l=(()=>{var e;const t=window.location.pathname.split("/").filter(Boolean)[0],o=localStorage.getItem("current_mapping_terminals");return o&&(null==(e=JSON.parse(o))?void 0:e.websiteId)===+t})(),d=((e,t)=>(Object.values(e).forEach((o=>{var r,n,a,i,l;if(!t.includes(null==(n=null==(r=null==o?void 0:o.data)?void 0:r.custom)?void 0:n.tag))return;A(e,null==o?void 0:o.id);const d=null==(l=null==(i=e[null==(a=null==o?void 0:o.data)?void 0:a.parent])?void 0:i.data)?void 0:l.nodes;if(!d)return;const s=d.indexOf(o.id);-1!==s&&(d.splice(s,1),e[o.data.parent].data.nodes=d)})),e))(e.nodes,l?P:k);l&&S(d);const s=d[e.rootNodeId];switch(null==(r=null==s?void 0:s.data)?void 0:r.name){case void 0:break;case i.resolvedNameMapping.Col:n=a.getPositionDropCol(t.id,d,o);break;case i.resolvedNameMapping.Row:n=a.getPositionDropRow(t.id,d,o);break;case i.resolvedNameMapping.WebsiteHeaderEditor:case i.resolvedNameMapping.TopBannerEditor:case i.resolvedNameMapping.WebsiteFooterEditor:n=a.getPositionDropGlobalBlock(s.id,o);break;default:n=a.getPositionDropElement(t.id,o)}return n},exports.defaultUniqueNodeIds=M,exports.deserializePB=(t,r,n)=>{if(!t||0===Object.keys(t).length)return"";const a=Object.assign({},d.default(t)),l=[];return Object.keys(a).forEach((e=>{var t,d;const s=a[e],p=(null==s?void 0:s.children)||[];let u={},c=s.tag;if(null==(t=s.customAttributes)?void 0:t[c]){const e=null==(d=s.customAttributes)?void 0:d[c];"galleryslideshow"===c&&(c="slider"),u=h(h({},u),"col"===c?(e=>{const{md:t,xs:r}=e;return"number"==typeof t&&(e.md={flex:N(t,o.GRID_COLUMNS)}),"number"==typeof r&&(e.xs={flex:N(r,o.GRID_COLUMNS)}),e})(e):e)}s.style&&Object.keys(s.style).length&&(u.commonStyle=s.style,s.style.desktop&&Object.keys(s.style.desktop).length&&u.desktop&&(u.desktop.commonStyle=s.style.desktop,delete u.commonStyle.desktop),s.style.mobile&&Object.keys(s.style.mobile).length&&u.mobile&&(u.mobile.commonStyle=s.style.mobile,delete u.commonStyle.mobile)),a[e]={type:{resolvedName:i.resolvedNameMapping[s.resolvedName]||s.resolvedName},displayName:s.resolvedName,isCanvas:void 0===s.isCanvas?"root"===c||"col"===c||"menucol"===c:s.isCanvas,nodes:p,parent:s.parentId,custom:{tag:c,displayName:s.displayName,startTime:s.startTime,endTime:s.endTime,ruleRepeat:s.ruleRepeat,date:s.date,duration:s.duration},props:b(h({},u),{id:s.elementId})},(r&&("section"===s.tag||"globalblock"===s.tag)||n&&["popupv1","inlinebanner"].includes(s.tag))&&l.push(e)})),(r||n)&&(a[e.ROOT]={type:{resolvedName:"RootEditor"},displayName:e.ROOT,isCanvas:!0,nodes:l,parent:null,custom:{tag:e.ROOT.toLowerCase(),isEditingBlock:r},props:{}}),a},exports.floorPercentage=O,exports.gachaGameAndFormPaths=E,exports.percentage=N,exports.resetGachaGameAndFormConfig=e=>j(e,E),exports.selectiveMerge=B,exports.selectiveMergeBatch=(e,t)=>{const o=Object.keys(t);if(0===o.length)return e;const r={};let n=!1;for(let a=0;a<o.length;a++){const i=o[a],l=t[i];if(void 0===l||l===e[i])continue;const d=e[i];let s;s=R(l)?R(d)?w(d,l):l:x(l)?x(d)||R(d)?B(d,l):l:d===l?d:l,s!==d&&(r[i]=s,n=!0)}return n?R(e)?[...e,...Object.values(r)]:h(h({},e),r):e},exports.serializePB=(t,o)=>{const{serializedNodeIds:r,isEditingBlock:n,isEditingPopup:a}=o||{},i=Object.assign({},t);return Object.keys(i).forEach((t=>{var o,l,d,s,p,u,c,m;if(m=t,(null==r?void 0:r.length)?r.includes(m):!n&&!a||m!==e.ROOT){const r=i[t];let n=null==(o=null==r?void 0:r.custom)?void 0:o.tag,a=[];"galleryslideshow"===n&&r.parent===e.ROOT&&(n="slider"),a="section"===n||"row"===n?r.nodes.length?r.nodes:Object.values(r.linkedNodes):r.nodes;const m=r.props||{},{commonStyle:y,hidden:O,id:N}=m,E=((e,t)=>{var o={};for(var r in e)v.call(e,r)&&t.indexOf(r)<0&&(o[r]=e[r]);if(null!=e&&g)for(var r of g(e))t.indexOf(r)<0&&f.call(e,r)&&(o[r]=e[r]);return o})(m,["commonStyle","hidden","id"]),{startTime:P,endTime:k,date:j,duration:M,ruleRepeat:I}=r.custom;(null==y?void 0:y.margin)&&delete y.margin.main,(null==y?void 0:y.padding)&&delete y.padding.main;const C=(null==(l=null==E?void 0:E.desktop)?void 0:l.commonStyle)||{},A=(null==(d=null==E?void 0:E.mobile)?void 0:d.commonStyle)||{};null==(s=null==E?void 0:E.desktop)||delete s.commonStyle,null==(p=null==E?void 0:E.mobile)||delete p.commonStyle,(null==C?void 0:C.margin)&&delete C.margin.main,(null==C?void 0:C.padding)&&delete C.padding.main,(null==A?void 0:A.margin)&&delete A.margin.main,(null==A?void 0:A.padding)&&delete A.padding.main,i[t]={id:t,elementId:N,parentId:r.parent||null,tag:n,displayName:null==(u=null==r?void 0:r.custom)?void 0:u.displayName,resolvedName:null==(c=null==r?void 0:r.type)?void 0:c.resolvedName,style:b(h({},y||{}),{desktop:Object.keys(C).length?C:void 0,mobile:Object.keys(A).length?A:void 0}),isCanvas:r.isCanvas,customAttributes:{[n]:E},children:a,startTime:P,endTime:k,date:j,duration:M,ruleRepeat:I}}else delete i[t]})),i},exports.setPbConfigProperties=j,exports.transformNodeByConfig=I,exports.updateProductDetailIdForProductList=S;


/***/ }),

/***/ 702571:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.percentPropFormatter=e=>{if("number"==typeof e)return Math.floor(100*e)};


/***/ }),

/***/ 525192:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.percentPropParser=e=>{if("number"==typeof e)return e/100};


/***/ }),

/***/ 327879:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097),a=__webpack_require__(98322);const t=(e,a)=>{const t=((e,a)=>{const t=a(e).get();if(t)return t.data.parent&&a(t.data.parent).get()})(e,a);return t&&a(t.id).descendants()||[]},n=(e,a,t)=>{const n=t(a).ancestors(),o=new Set(e);return n.some((e=>{var a,n;return o.has(null==(n=null==(a=t(e).get())?void 0:a.data)?void 0:n.name)}))},o=[a.resolvedNameMapping.TopBannerEditor,a.resolvedNameMapping.Root,a.resolvedNameMapping.WebsiteFooterEditor],d=(e,a,n,o)=>{const{callbackConditionSibling:r,callbackConditionParent:i}=e,s=n(a).get();return s?r(s)?{parentIdToPaste:s.data.parent,indexToPaste:t(s.id,n).findIndex((e=>e===s.id))+1}:(null==i?void 0:i(s))?{parentIdToPaste:s.id,indexToPaste:o?t(o,n).findIndex((e=>e===o))+1:s.data.nodes.length||0}:s.data.parent?d(e,s.data.parent,n,a):null:null};exports.findPosition=d,exports.getPositionDropCol=(e,t,r)=>{if(!r(e).get())return null;const i=Object.values(t).some((e=>e.data.name===a.resolvedNameMapping.Row));return d({callbackConditionSibling:e=>e.data.name===a.resolvedNameMapping.Col&&(!i||n(o,e.id,r)),callbackConditionParent:e=>{const t=r(e.data.parent).get();return e.data.name===a.resolvedNameMapping.Row&&(!i||o.includes(t.data.name))}},e,r)},exports.getPositionDropElement=(e,n)=>{var o,d,r;const i=n(e).get();if(!i)return null;switch(i.data.name){case a.resolvedNameMapping.Row:return{parentIdToPaste:i.data.nodes[0],indexToPaste:(null==(r=null==(d=null==(o=n(i.data.nodes[0]).get())?void 0:o.data)?void 0:d.nodes)?void 0:r.length)||0};case a.resolvedNameMapping.Col:return{parentIdToPaste:i.id,indexToPaste:i.data.nodes.length||0};default:return{indexToPaste:t(i.id,n).findIndex((e=>e===i.id))+1,parentIdToPaste:i.data.parent}}},exports.getPositionDropGlobalBlock=(a,t)=>{const n=t(e.ROOT).get().data.nodes;let o=n.indexOf(a);if(-1===o)switch(a){case e.HEADER:o=n.includes(e.TOP_BANNER)?1:0;break;case e.TOP_BANNER:o=0;break;case e.FOOTER:o=n.length}return{parentIdToPaste:e.ROOT,indexToPaste:o}},exports.getPositionDropRow=(e,t,r)=>{if(!r(e).get())return null;const i=1===Object.values(t).filter((e=>e.data.name===a.resolvedNameMapping.Row)).length;return d({callbackConditionSibling:e=>{if(e.data.name!==a.resolvedNameMapping.Row)return!1;const t=r(e.data.parent).get();return!!t&&(o.includes(t.data.name)||i&&t.data.name===a.resolvedNameMapping.Col&&n(o,t.id,r))},callbackConditionParent:e=>o.includes(e.data.name)||i&&e.data.name===a.resolvedNameMapping.Col&&n(o,e.id,r)},e,r)};


/***/ }),

/***/ 675452:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097);const r={parser:e=>"number"==typeof e?`${e}%`:e,formatter:e=>isNaN(+(null==e?void 0:e.replace("%","")))?e:+e.replace("%","")};exports.combineSize=(r,t=e.UnitEnum.pixel)=>{if(r)return`${r}${t}`},exports.extractSize=(r,t=e.UnitEnum.pixel)=>{if(null==r?void 0:r.includes(e.UnitEnum.pixel)){const t=Number(r.replace(e.UnitEnum.pixel,""));return isNaN(t)?[void 0,e.UnitEnum.pixel]:[t,e.UnitEnum.pixel]}if(null==r?void 0:r.includes(e.UnitEnum.percent)){const t=Number(r.replace(e.UnitEnum.percent,""));return isNaN(t)?[void 0,e.UnitEnum.percent]:[t,e.UnitEnum.percent]}return[void 0,t]},exports.extractUrlFromCssUrl=e=>{const r=e.match(/^url\((.*)\)$/);return r?r[1]:""},exports.isNumeric=e=>"number"==typeof e||"string"==typeof e&&!isNaN(e)&&!isNaN(parseFloat(e)),exports.isPrefixUrl=e=>/^url\((.*)\)$/.test(e),exports.nomalizeText=e=>{let r=e.toLowerCase().trim();return r=r.replace(/\s+/g," "),r=r.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g,"a"),r=r.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g,"e"),r=r.replace(/ì|í|ị|ỉ|ĩ/g,"i"),r=r.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g,"o"),r=r.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g,"u"),r=r.replace(/ỳ|ý|ỵ|ỷ|ỹ/g,"y"),r=r.replace(/đ/g,"d"),r},exports.removeUnit=(r,t=e.UnitEnum.pixel)=>{var n,i;return null!=r?parseInt(null==(i=null==(n=`${r}`)?void 0:n.replace)?void 0:i.call(n,t,"")):r},exports.usePropOptionsUnitPercent=r;


/***/ }),

/***/ 164662:
/***/ (function(module) {

module.exports="data:image/jpeg;base64,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";


/***/ }),

/***/ 871496:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(429830),t=__webpack_require__(610314),o=__webpack_require__(47248),l=__webpack_require__(407229),i=__webpack_require__(891987),n=__webpack_require__(85097),s=__webpack_require__(736451),a=__webpack_require__(739271),d=__webpack_require__(518421),u=__webpack_require__(212951),c=__webpack_require__(610796),p=__webpack_require__(994040),x=__webpack_require__(552884),h=__webpack_require__(805116),f=__webpack_require__(234741);function g(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var m=g(o),j=g(l),b=g(u);const y=b.default.div`
  font-size: 12px;
  font-weight: 500;
  margin: 8px 0 4px;
`,C=b.default(t.Modal)`
  &.ant-modal {
    top: 80px;
  }

  .ant-modal {
    &-header,
    &-footer {
      padding: 8px;
    }

    &-title {
      font-size: 14px;
    }

    &-close-x {
      width: 32px;
      height: 32px;
      line-height: 32px;
      font-size: 14px;
    }
  }
`,v=b.default(s.RgbaStringColorPicker)`
  width: 100% !important;
  margin-bottom: 16px;

  .react-colorful {
    &__pointer {
      width: 16px;
      height: 16px;
    }

    &__alpha,
    &__hue {
      height: 12px;
      margin-top: 12px;
      border-radius: 8px;
    }
  }
`,q=b.default(s.HexColorInput)(d.inputCss),O=b.default.label(d.labelCss),R=b.default.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
  column-gap: 8px;
`,k=b.default.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  transform: scale(1);
  transition: all 100ms ease 0s;
  cursor: pointer;
  border: 1px solid #d9d9d9;

  &.active {
    border: 2px solid #000;
    transform: scale(1.1);
  }

  &:hover {
    transform: scale(1.2);
  }
`,w=b.default.div`
  display: flex;
  justify-content: space-between;
`,_=b.default(t.Button)`
  padding-left: 0;
  padding-right: 0;
`,P=b.default(a.RgbaField)`
  flex: 2;
`;exports.ColorPickerModal=({color:o="rgba(0, 0, 0, 1)",visible:l,setVisible:s,onChange:a})=>{var d;const{actions:{history:u},myColors:g}=x.useEditor((e=>{var r;const t=e.nodes[n.ROOT];return{myColors:m.default(null==(r=t.data)?void 0:r.props,f.PROP_KEY.MyColors,[])}})),{document:b}=c.useFrame(),[M,B]=i.useState(),S=M||"";i.useEffect((()=>{if(l){const e=h.getRGBAColor(o);B(e)}}),[l]);const E=(r,t)=>(null==t?void 0:t.length)?e.jsxs(e.Fragment,{children:[e.jsx(y,{children:r}),e.jsx(R,{children:t.map(((r,t)=>{var o;const l=h.getRGBAColor(r),i=null==(o=h.rgbaStringToObject(l))?void 0:o.hex;return e.jsx(k,{title:i,style:{backgroundColor:r},className:l===M?"active":"",onClick:()=>{B(l)}},t)}))})]}):null,F=()=>s(!1);return e.jsxs(C,{open:l,title:r.t("Chọn màu"),onCancel:F,width:300,bodyStyle:{padding:"16px 8px"},zIndex:9999,destroyOnClose:!0,getContainer:()=>(null==b?void 0:b.body)||(null==document?void 0:document.body),footer:e.jsxs(w,{children:[e.jsx(_,{type:"link",onClick:()=>{a(),F()},children:r.t("Đặt lại")}),e.jsxs("div",{style:{display:"flex"},children:[e.jsx(t.Button,{onClick:F,children:r.t("common.cancel")}),e.jsx(t.Button,{type:"primary",onClick:()=>{var e;const r=null==(e=h.rgbaStringToObject(M))?void 0:e.hex;a(r);let t=[...g],o=!1;for(const e of g)if(h.getRGBAColor(e)===M){o=!0;break}o||(10===g.length?t=[...g.slice(1),r]:t.push(r),u.ignore().setProp(n.ROOT,(e=>{j.default(e,f.PROP_KEY.MyColors,t)}))),F()},children:"OK"})]})]}),children:[e.jsx(v,{color:S,onChange:B}),e.jsxs("div",{style:{display:"flex",columnGap:16},children:[e.jsxs("div",{style:{flex:1},children:[e.jsx(q,{alpha:!0,prefixed:!0,color:null==(d=h.rgbaStringToObject(M))?void 0:d.hex,onChange:e=>{B(n.getRgbaFromHex(e))}}),e.jsx(O,{children:"hex"})]}),e.jsx(P,{color:S,onChange:B})]}),E(r.t("Màu của tôi"),g),E(r.t("Màu mẫu"),p.sampleColors)]})};


/***/ }),

/***/ 312995:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(429830),r=__webpack_require__(610314),l=__webpack_require__(47248),t=__webpack_require__(407229),i=__webpack_require__(891987),n=__webpack_require__(85097),a=__webpack_require__(736451),d=__webpack_require__(212951),s=__webpack_require__(610796),p=__webpack_require__(994040),u=__webpack_require__(24005),c=__webpack_require__(805116),g=__webpack_require__(828426),x=__webpack_require__(514824),f=__webpack_require__(552884),h=__webpack_require__(234741);function y(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var v=y(l),C=y(t),b=y(d),m=Object.defineProperty,j=Object.defineProperties,T=Object.getOwnPropertyDescriptors,w=Object.getOwnPropertySymbols,O=Object.prototype.hasOwnProperty,P=Object.prototype.propertyIsEnumerable,q=(e,o,r)=>o in e?m(e,o,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[o]=r;const S=[{label:"Linear",value:n.GradientType.linear},{label:"Radial",value:n.GradientType.radial}],k=[{label:"Solid",value:n.ColorType.solid},{label:"Gradient",value:n.ColorType.gradient}],G=b.default.div`
  font-size: 12px;
  font-weight: 500;
  margin: 8px 0 4px;
`,H=b.default(r.Modal)`
  &.ant-modal {
    top: 80px;
  }

  .ant-modal {
    &-header,
    &-footer {
      padding: 8px;
      border-radius: 8px;
    }

    &-title {
      font-size: 14px;
    }

    &-close-x {
      width: 32px;
      height: 32px;
      line-height: 32px;
      font-size: 14px;
    }
    &-content {
      border-radius: 8px;
      padding: 8px;
    }
  }
`,I=b.default(a.HexAlphaColorPicker)`
  width: 100% !important;
  margin-bottom: 16px;

  .react-colorful {
    &__pointer {
      width: 16px;
      height: 16px;
    }

    &__alpha,
    &__hue {
      height: 12px;
      margin-top: 12px;
      border-radius: 8px;
    }
  }
`,R=b.default(a.HexColorInput)`
  width: 100%;
  padding: 4px;
  text-align: center;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  &:focus {
    outline: none;
  }
`,_=b.default.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
  column-gap: 8px;
`,M=b.default.div`
  width: 25px;
  height: 25px;
  border-radius: 6px;
  transform: scale(1);
  transition: all 100ms ease 0s;
  cursor: pointer;

  &:hover {
    transform: scale(1.2);
    border: 2px solid #d9d9d9;
  }
`,z=b.default.div`
  display: flex;
  justify-content: space-between;
`,A=b.default(r.Button)`
  color: var(--text-color);
  padding-left: 0;
  padding-right: 0;
`,E=b.default.div`
  height: 32px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`,N=b.default.div`
  border-radius: 4px;
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>');
`,B=b.default.div((({colorConfig:e})=>`\n    width: 32px;\n    height: 32px;\n    border-radius: 4px;\n    margin-left: auto;\n    background: ${n.stringifyColor(e)};\n    border: 1px solid rgba(0, 0, 0, 0.05);\n`)),V=b.default(x.InputNumberConfig)`
  .ant-input-number-handler-wrap {
    display: none;
  }
`,F=b.default.div`
  font-size: 24px;
  position: absolute;
  top: -18px;
  right: -8px;
`,K=b.default(r.Row)`
  margin-top: 16px;
`,J=b.default(r.Button)`
  border-radius: 6px;
`;exports.ColorPickerModalV2=({color:l=n.stringifyColor({colorType:n.ColorType.solid,colorValue:"rgba(255,255,255,1)"}),visible:t,setVisible:a,onChange:d,hasGradientColor:x})=>{const{actions:{history:y},myColors:b}=f.useEditor((e=>{var o;const r=e.nodes[n.ROOT];return{myColors:v.default(null==(o=null==r?void 0:r.data)?void 0:o.props,h.PROP_KEY.MyColors,[])}})),{document:m}=s.useFrame(),[Y,$]=i.useState(),[D,L]=i.useState(),[Q,U]=i.useState(),[W,X]=i.useState(),Z=Y===n.ColorType.gradient?Q:W?n.getRgbaFromHex(W).replaceAll(" ",""):"";i.useEffect((()=>{var e,o,r;if(t){const t=n.parseColor(l),i=(null==t?void 0:t.colorType)||n.ColorType.solid,a=(null==t?void 0:t.colorValue)||"rgba(255,255,255,1)",d=0,s=i===n.ColorType.gradient,p=s?a:void 0;$(i),U(p),L(d);const u=(null==(r=s?null==(o=null==(e=null==a?void 0:a.colors)?void 0:e[d])?void 0:o.color:a)?void 0:r.toString())||"";X(c.getHexColor(u))}}),[t]),i.useEffect((()=>{var e,o;Y===n.ColorType.gradient&&void 0!==D&&X(c.getHexColor(null==(o=null==(e=null==Q?void 0:Q.colors)?void 0:e[D])?void 0:o.color))}),[D]);const ee=e=>{if(X(e),Y===n.ColorType.gradient&&Q&&e){const o=JSON.parse(JSON.stringify(Q.colors));o[D].color=n.getRgbaFromHex(e).replaceAll(" ",""),le("colors",o)}},oe=(o,r)=>(null==r?void 0:r.length)?e.jsxs(e.Fragment,{children:[e.jsx(G,{children:o}),e.jsx(_,{children:r.map(((o,r)=>{var l;const t=c.getRGBAColor(o),i=null==(l=c.rgbaStringToObject(t))?void 0:l.hex;return e.jsx(M,{title:i,style:{backgroundColor:o},onClick:()=>{ee(i)},"data-testid":`color-${i}`},r)}))})]}):null,re=()=>a(!1),le=(e,o)=>{U((r=>{return l=((e,o)=>{for(var r in o||(o={}))O.call(o,r)&&q(e,r,o[r]);if(w)for(var r of w(o))P.call(o,r)&&q(e,r,o[r]);return e})({},r),t={[e]:Array.isArray(o)?[...o]:o},j(l,T(t));var l,t}))};return e.jsxs(H,{"data-testid":"color-picker-modal",open:t,title:o.t("Chọn màu"),onCancel:re,width:300,bodyStyle:{padding:"8px 8px"},zIndex:9999,destroyOnClose:!0,getContainer:()=>(null==m?void 0:m.body)||(null==document?void 0:document.body),footer:e.jsxs(z,{children:[e.jsx(A,{type:"link",onClick:()=>{d(void 0),re()},children:o.t("Đặt lại")}),e.jsxs("div",{style:{display:"flex"},children:[e.jsx(J,{onClick:re,"data-testid":"color-picker-cancel",children:o.t("common.cancel")}),e.jsx(J,{type:"primary",onClick:()=>{const e={colorType:Y,colorValue:Z};if(d(n.stringifyColor(e)),Y===n.ColorType.solid){let e=[...b];b.some((e=>c.getRGBAColor(e)===Z))||(10===b.length?e=[...b.slice(1),Z]:e.push(Z),y.ignore().setProp(n.ROOT,(o=>{C.default(o,h.PROP_KEY.MyColors,e)})))}re()},"data-testid":"color-picker-ok",children:"OK"})]})]}),children:[e.jsxs(E,{children:[x&&e.jsx(g.SelectConfig,{selectProps:{allowClear:!1,value:Y,options:k,onChange:e=>{var o,r;if(e===n.ColorType.solid)U(void 0),X(c.getHexColor("rgba(255,255,255,1)"));else{const e={colors:[{color:"rgb(254,214,227)",stop:0},{color:"rgba(168,237,234)",stop:100}],radius:90,gradientType:n.GradientType.linear};U(e),X(c.getHexColor(null==(r=null==(o=null==e?void 0:e.colors)?void 0:o[0])?void 0:r.color))}$(e),L(0)},getPopupContainer:e=>e}}),e.jsx(N,{children:e.jsx(B,{colorConfig:{colorType:Y,colorValue:Z}})})]}),e.jsx(I,{color:W,onChange:ee}),Y===n.ColorType.gradient&&e.jsx(u.GradientBar,{gradientColor:Q,selectedGradientItem:D,setSelectedGradientItem:L,onChange:le}),e.jsxs(K,{gutter:[8,8],className:"mt-base",children:[e.jsx(r.Col,{span:11,children:e.jsx(R,{alpha:!0,prefixed:!0,color:W,onChange:ee})}),Y===n.ColorType.gradient&&e.jsxs(e.Fragment,{children:[e.jsx(r.Col,{span:8,children:e.jsx(g.SelectConfig,{selectProps:{allowClear:!1,value:null==Q?void 0:Q.gradientType,options:S,onChange:e=>{e===n.GradientType.linear&&le("radius",90),le("gradientType",e)},getPopupContainer:e=>e}})}),e.jsxs(r.Col,{span:5,children:[e.jsx(V,{formItemProps:{onChange:e=>{const o=e.target.value?parseInt(e.target.value):0;le("radius",o)},value:null==Q?void 0:Q.radius},inputNumberProps:{disabled:(null==Q?void 0:Q.gradientType)===n.GradientType.radial,min:0,max:360,value:null==Q?void 0:Q.radius}}),(null==Q?void 0:Q.gradientType)===n.GradientType.linear&&e.jsx(F,{children:"°"})]})]})]}),Y===n.ColorType.solid&&oe(o.t("Màu của tôi"),b),oe(o.t("Màu mẫu"),p.sampleColors)]})};


/***/ }),

/***/ 526415:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(212951),r=__webpack_require__(85097),l=__webpack_require__(610314),t=__webpack_require__(891987),n=__webpack_require__(736451),i=__webpack_require__(610796),a=__webpack_require__(429830),d=__webpack_require__(994040),s=__webpack_require__(24005),p=__webpack_require__(352172),u=__webpack_require__(10619),c=__webpack_require__(805116),f=__webpack_require__(828426),g=__webpack_require__(514824);function x(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var C=x(o),y=Object.defineProperty,h=Object.defineProperties,v=Object.getOwnPropertyDescriptors,m=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,j=Object.prototype.propertyIsEnumerable,T=(e,o,r)=>o in e?y(e,o,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[o]=r;const S=[{label:"Solid",value:r.ColorType.solid},{label:"Gradient",value:r.ColorType.gradient}],O=[{label:"Linear",value:r.GradientType.linear},{label:"Radial",value:r.GradientType.radial}],w=C.default(l.Modal)`
  &.ant-modal {
    top: 200px;
    left: calc(50% + 210px);
    margin: 0;
  }

  .ant-modal {
    &-header,
    &-footer {
      padding: 8px;
      border-radius: 8px;
    }

    &-title {
      font-size: 14px;
    }

    &-close-x {
      width: 32px;
      height: 32px;
      line-height: 32px;
      font-size: 14px;
    }
    &-content {
      border-radius: 8px;
      padding: 8px;
    }
  }
`,q=C.default(l.Button)`
  border-radius: 6px;
`,P=C.default.div`
  height: 32px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`,I=C.default(n.HexAlphaColorPicker)`
  width: 100% !important;
  margin-bottom: 16px;

  .react-colorful {
    &__pointer {
      width: 16px;
      height: 16px;
    }

    &__alpha,
    &__hue {
      height: 12px;
      margin-top: 12px;
      border-radius: 8px;
    }
  }
`,_=C.default(l.Row)`
  margin-top: 16px;
`,G=C.default(n.HexColorInput)`
  width: 100%;
  padding: 4px;
  text-align: center;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  &:focus {
    outline: none;
  }
`,N=C.default(g.InputNumberConfig)`
  .ant-input-number-handler-wrap {
    display: none;
  }
`,H=C.default.div`
  font-size: 24px;
  position: absolute;
  top: -18px;
  right: -8px;
`;exports.AddColorModal=({myColors:o,hasGradientColor:n,visible:g,onClose:x,setSelectedColor:C,initColor:y,isUpdate:A=!1})=>{const{updateThemeConfig:R}=u.useThemeStore(),{document:E}=i.useFrame(),[F,M]=t.useState(r.ColorType.solid),[k,z]=t.useState(),[B,V]=t.useState("#ffffff"),[J,L]=t.useState(0),U=()=>F===r.ColorType.gradient?k:B?r.getRgbaFromHex(B).replaceAll(" ",""):"",D=(e,o)=>{z((r=>{return l=((e,o)=>{for(var r in o||(o={}))b.call(o,r)&&T(e,r,o[r]);if(m)for(var r of m(o))j.call(o,r)&&T(e,r,o[r]);return e})({},r),t={[e]:Array.isArray(o)?[...o]:o},h(l,v(t));var l,t}))},X=e=>{if(V(e),F===r.ColorType.gradient&&k&&e){const o=JSON.parse(JSON.stringify(k.colors));o[J].color=r.getRgbaFromHex(e).replaceAll(" ",""),D("colors",o)}};return t.useEffect((()=>{if(!g)return;const{colorType:e,gradientColor:o,hexInput:l}=(e=>{var o,l,t;if(!e||e.includes("var(--tempi-global-color"))return{colorType:r.ColorType.solid,hexInput:"#ffffff",gradientColor:void 0};const{colorType:n,colorValue:i}=r.parseColor(e),a=(null==(t=n===r.ColorType.gradient?null==(l=null==(o=null==i?void 0:i.colors)?void 0:o[J])?void 0:l.color:i)?void 0:t.toString())||"#ffffff";return{colorType:n,hexInput:c.getHexColor(a),gradientColor:n===r.ColorType.gradient?i:void 0}})(y);M(e),z(o),V(l)}),[g,y]),t.useEffect((()=>{var e,o;const r=null==(o=null==(e=null==k?void 0:k.colors)?void 0:e[J])?void 0:o.color;r&&V(c.getHexColor(r))}),[J]),e.jsxs(w,{open:g,onCancel:x,title:a.t("color_config.add_color"),bodyStyle:{padding:10},width:320,mask:!1,zIndex:1e4,getContainer:()=>(null==E?void 0:E.body)||(null==document?void 0:document.body),footer:e.jsxs("div",{style:{display:"flex",justifyContent:"flex-end",gap:8},children:[e.jsx(q,{onClick:x,children:a.t("common.cancel")}),e.jsx(q,{type:"primary",onClick:()=>{const e={colorType:F,colorValue:U()},l=r.stringifyColor(e);let t=[...o];const n=o.includes(l);if(A){const e=o.indexOf(y);if(e<0||l===y)return void x();t[e]=l;const r=null==o?void 0:o.indexOf(l);-1!==r&&t.splice(r,1)}else n||(o.length>=d.MAX_NUMBER_OF_RECENT_COLORS?t=[l,...o.slice(0,-1)]:t.unshift(l));R({recentColors:t}),null==C||C(l),x()},children:a.t("common.save")})]}),children:[e.jsxs(P,{children:[n&&e.jsx(f.SelectConfig,{selectProps:{allowClear:!1,value:F,options:S,onChange:e=>{var o,l;if(e===r.ColorType.solid)z(void 0),V(c.getHexColor("rgba(255,255,255,1)"));else{const e={colors:[{color:"rgb(254,214,227)",stop:0},{color:"rgba(168,237,234)",stop:100}],radius:90,gradientType:r.GradientType.linear};z(e),V(c.getHexColor(null==(l=null==(o=null==e?void 0:e.colors)?void 0:o[0])?void 0:l.color))}M(e),L(0)},getPopupContainer:e=>e}}),e.jsx(p.ColorPreview,{currentColorValue:U(),hexInput:B,onChangeColor:X,colorType:F})]}),e.jsx(I,{color:B,onChange:X}),F===r.ColorType.gradient&&e.jsx(s.GradientBar,{gradientColor:k,selectedGradientItem:J,setSelectedGradientItem:L,onChange:D}),F===r.ColorType.gradient&&e.jsxs(_,{gutter:[8,8],className:"mt-base",children:[e.jsx(l.Col,{span:11,children:e.jsx(G,{alpha:!0,prefixed:!0,color:B,onChange:X})}),e.jsxs(e.Fragment,{children:[e.jsx(l.Col,{span:8,children:e.jsx(f.SelectConfig,{selectProps:{allowClear:!1,value:null==k?void 0:k.gradientType,options:O,onChange:e=>{e===r.GradientType.linear&&D("radius",90),D("gradientType",e)},getPopupContainer:e=>e}})}),e.jsxs(l.Col,{span:5,children:[e.jsx(N,{formItemProps:{onChange:e=>{const o=e.target.value?parseInt(e.target.value):0;D("radius",o)},value:null==k?void 0:k.radius},inputNumberProps:{disabled:(null==k?void 0:k.gradientType)===r.GradientType.radial,min:0,max:360,value:null==k?void 0:k.radius}}),(null==k?void 0:k.gradientType)===r.GradientType.linear&&e.jsx(H,{children:"°"})]})]})]})]})};


/***/ }),

/***/ 475356:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(212951),r=__webpack_require__(85097),l=__webpack_require__(547929),t=__webpack_require__(610314),n=__webpack_require__(891987),i=__webpack_require__(736451),a=__webpack_require__(429830),s=__webpack_require__(24005),d=__webpack_require__(352172),u=__webpack_require__(994040),p=__webpack_require__(921890),c=__webpack_require__(516965),f=__webpack_require__(10619),g=__webpack_require__(805116),C=__webpack_require__(828426),y=__webpack_require__(514824);function x(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var v=x(o),h=Object.defineProperty,b=Object.defineProperties,m=Object.getOwnPropertyDescriptors,j=Object.getOwnPropertySymbols,T=Object.prototype.hasOwnProperty,P=Object.prototype.propertyIsEnumerable,S=(e,o,r)=>o in e?h(e,o,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[o]=r;const O=[{label:"Solid",value:r.ColorType.solid},{label:"Gradient",value:r.ColorType.gradient}],q=[{label:"Linear",value:r.GradientType.linear},{label:"Radial",value:r.GradientType.radial}],w=v.default(t.Button)`
  border-radius: 6px;
`,_=v.default.div`
  height: 32px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`,I=v.default(i.HexAlphaColorPicker)`
  width: 100% !important;
  margin-bottom: 16px;

  .react-colorful {
    &__pointer {
      width: 16px;
      height: 16px;
    }

    &__alpha,
    &__hue {
      height: 12px;
      margin-top: 12px;
      border-radius: 8px;
    }
  }
`,D=v.default(t.Row)`
  margin-top: 16px;
`,G=v.default(i.HexColorInput)`
  width: 100%;
  padding: 4px;
  text-align: center;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  &:focus {
    outline: none;
  }
`,E=v.default(y.InputNumberConfig)`
  .ant-input-number-handler-wrap {
    display: none;
  }
`,N=v.default.div`
  font-size: 24px;
  position: absolute;
  top: -18px;
  right: -8px;
`;exports.AddColorModalDraggable=({myColors:o,hasGradientColor:i,visible:y,onClose:x,setSelectedColor:v,initColor:h,isUpdate:M=!1,width:H=320,setModalPosition:R,propKey:A,modalPosition:k={x:0,y:0},onChangeColor:V,onEditingColor:B,onCancelEditingColor:F})=>{const{id:J}=l.useNode(),L=c.useDraftStore((e=>e.updateDraftThrottled)),U=c.useDraftStore((e=>e.clearDraft)),{updateThemeConfig:z}=f.useThemeStore(),[K,X]=n.useState(r.ColorType.solid),[Q,W]=n.useState(),[Y,Z]=n.useState("#ffffff"),[$,ee]=n.useState(0),oe=n.useRef(h),re=n.useCallback((()=>K===r.ColorType.gradient?Q:Y?r.getRgbaFromHex(Y).replaceAll(" ",""):""),[K,Q,Y]),le=(e,o)=>{W((r=>{return l=((e,o)=>{for(var r in o||(o={}))T.call(o,r)&&S(e,r,o[r]);if(j)for(var r of j(o))P.call(o,r)&&S(e,r,o[r]);return e})({},r),t={[e]:Array.isArray(o)?[...o]:o},b(l,m(t));var l,t}))},te=e=>{if(Z(e),K===r.ColorType.gradient&&Q&&e){const o=JSON.parse(JSON.stringify(Q.colors));o[$].color=r.getRgbaFromHex(e).replaceAll(" ",""),le("colors",o)}},ne=e=>{null==e||e.preventDefault(),null==e||e.stopPropagation(),x((()=>{U(J),null==F||F(oe.current)}))},ie=()=>{x((()=>{const e={colorType:K,colorValue:re()},o=r.stringifyColor(e);v(o),V(o),U(J)}))};return n.useEffect((()=>{if(!y)return;const{colorType:e,gradientColor:o,hexInput:l}=(e=>{var o,l,t;if(!e)return{colorType:r.ColorType.solid,hexInput:"#ffffff",gradientColor:void 0};const{colorType:n,colorValue:i}=r.parseColor(e),a=(null==(t=n===r.ColorType.gradient?null==(l=null==(o=null==i?void 0:i.colors)?void 0:o[$])?void 0:l.color:i)?void 0:t.toString())||"#ffffff";return{colorType:n!==r.ColorType.theme&&n?n:r.ColorType.solid,hexInput:g.getHexColor(a),gradientColor:n===r.ColorType.gradient?i:void 0}})(h);X(e),W(o),Z(l),oe.current=h}),[y]),n.useEffect((()=>{var e,o;const r=null==(o=null==(e=null==Q?void 0:Q.colors)?void 0:e[$])?void 0:o.color;r&&Z(g.getHexColor(r))}),[$]),n.useEffect((()=>{(()=>{const e={colorType:K,colorValue:re()},o=r.stringifyColor(e);y&&o&&(A&&L(J,A,o),null==B||B(o))})()}),[K,re]),n.useEffect((()=>()=>{x((()=>{U(J)}))}),[]),e.jsxs(p.DraggableModal,{open:y,onCancel:ne,title:a.t("color_config.add_color"),width:H,footer:e.jsxs("div",{style:{display:"flex",justifyContent:"flex-end",gap:8},children:[e.jsx(w,{onClick:ne,children:a.t("common.cancel")}),e.jsx(w,{type:"primary",onClick:e=>{e.preventDefault(),e.stopPropagation();const l={colorType:K,colorValue:re()},t=r.stringifyColor(l);let n=[...o];const i=o.includes(t);if(M){const e=o.indexOf(oe.current||"");if(e<0||t===oe.current)return void ie();n[e]=t;const r=null==o?void 0:o.indexOf(t);-1!==r&&n.splice(r,1)}else i||(o.length>=u.MAX_NUMBER_OF_RECENT_COLORS?n=[t,...o.slice(0,-1)]:n.unshift(t));z({recentColors:n}),ie()},children:a.t("common.save")})]}),modalPosition:k,setModalPosition:R,destroyOnClose:!0,onClickOutside:ne,children:[e.jsxs(_,{children:[i&&e.jsx(C.SelectConfig,{selectProps:{allowClear:!1,value:K,options:O,onChange:e=>{var o,l;if(e===r.ColorType.solid)W(void 0),Z(g.getHexColor("rgba(255,255,255,1)"));else{const e={colors:[{color:"rgb(254,214,227)",stop:0},{color:"rgba(168,237,234)",stop:100}],radius:90,gradientType:r.GradientType.linear};W(e),Z(g.getHexColor(null==(l=null==(o=null==e?void 0:e.colors)?void 0:o[0])?void 0:l.color))}X(e),ee(0)},getPopupContainer:e=>e}}),e.jsx(d.ColorPreview,{currentColorValue:re(),hexInput:Y,onChangeColor:te,colorType:K})]}),e.jsx(I,{color:Y||"#ffffff",onChange:te}),K===r.ColorType.gradient&&e.jsx(s.GradientBar,{gradientColor:Q,selectedGradientItem:$,setSelectedGradientItem:ee,onChange:le}),K===r.ColorType.gradient&&e.jsxs(D,{gutter:[8,8],className:"mt-base",children:[e.jsx(t.Col,{span:11,children:e.jsx(G,{alpha:!0,prefixed:!0,color:Y,onChange:te})}),e.jsx(t.Col,{span:8,children:e.jsx(C.SelectConfig,{selectProps:{allowClear:!1,value:null==Q?void 0:Q.gradientType,options:q,onChange:e=>{e===r.GradientType.linear&&le("radius",90),le("gradientType",e)},getPopupContainer:e=>e}})}),e.jsxs(t.Col,{span:5,children:[e.jsx(E,{formItemProps:{onChange:e=>{const o=e.target.value?parseInt(e.target.value):0;le("radius",o)},value:null==Q?void 0:Q.radius},inputNumberProps:{disabled:(null==Q?void 0:Q.gradientType)===r.GradientType.radial,min:0,max:360,value:null==Q?void 0:Q.radius}}),(null==Q?void 0:Q.gradientType)===r.GradientType.linear&&e.jsx(N,{children:"°"})]})]})]})};


/***/ }),

/***/ 131417:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(112373),r=__webpack_require__(212951),t=__webpack_require__(959211),i=__webpack_require__(85097),l=__webpack_require__(610314),n=__webpack_require__(891987),s=__webpack_require__(610796),c=__webpack_require__(429830),d=__webpack_require__(475356),a=__webpack_require__(851734),u=__webpack_require__(639911),h=__webpack_require__(10619),p=__webpack_require__(313247),x=__webpack_require__(921890),g=__webpack_require__(805116);function C(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var f=C(r);const m=f.default(l.Button)`
  color: var(--text-color);
  padding-left: 0;
  padding-right: 0;
`,j=f.default.div`
  font-size: 14px;
  font-weight: 600;
`,y=f.default.div`
  color: #7367f0;
  font-size: 14px;
  cursor: pointer;
  margin-right: 10px;
`,v=f.default(o.QuestionCircleOutlined)`
  font-size: 1.2em;
  color: #82869e;
  margin-left: 4px;

  &:hover {
    color: var(--text-color);
  }
`,k=f.default.div`
  display: flex;
  flex-wrap: wrap;
`,b=f.default.div`
  position: relative;
  width: ${({isStretch:e})=>e?"100%":"130px"};
  height: 32px;
  display: flex;
  align-items: center;
  border: 1px solid ${e=>e.theme.colorBorder};
  border-radius: 4px;
  &:hover {
    cursor: pointer;
  }
`;exports.ColorPickerDraggable=({color:o,visible:r,setVisible:C,onChange:f,hasGradientColor:S,width:q=350,colorConfig:w,propKey:_,onEditingColor:M,onCancelEditingColor:T,isStretch:D,showSelectedThemeColor:P=!0})=>{const{window:z}=s.useFrame(),{recentColors:I,updateThemeConfig:O}=h.useThemeStore(),[E,B]=n.useState(o),[A,V]=n.useState(!1),[F,Q]=n.useState(!1),[R,G]=n.useState({x:0,y:0}),[H,K]=n.useState({x:0,y:0}),{setOpenThemeConfig:N}=p.useBuilder(),W=()=>C(!1);n.useEffect((()=>{B(o)}),[o]);const $=(e,o,r,t,i)=>{const l=e.currentTarget.getBoundingClientRect(),n=l.left,s=l.right-t,c=l.left+t>z.innerWidth?s:n,d=l.top+l.height,a=l.top-i,u=l.top+i>z.innerHeight?a:d,h=z.innerWidth-t,p=z.innerHeight-i;o({x:Math.max(0,Math.min(c,h)),y:Math.max(0,Math.min(u,p))}),r(!0)},U=e=>{const{colorType:o}=E?i.parseColor(E):{colorType:"solid"};let r=370;"gradient"===o&&(r=440),$(e,K,V,320,r)},J=n.useCallback((()=>{A||W()}),[A]);return e.jsxs(e.Fragment,{children:[e.jsx(b,{onClick:e=>{const o=(null==I?void 0:I.length)?36*Math.ceil(I.length/8)+290:290;$(e,G,C,q,o)},"data-testid":"color-picker-select",isStretch:D,children:w}),e.jsxs(x.DraggableModal,{onClickOutside:J,modalPosition:R,setModalPosition:G,"data-testid":"color-picker-modal",open:r,width:q,title:c.t("Chọn màu"),onCancel:W,destroyOnClose:!0,footer:null,children:[P&&e.jsxs(e.Fragment,{children:[e.jsxs("div",{style:{marginTop:20,display:"flex",justifyContent:"space-between"},children:[e.jsxs("div",{style:{display:"flex",alignItems:"center"},children:[e.jsx(j,{children:c.t("color_picker.from_theme")}),e.jsx(l.Popover,{content:e.jsx("div",{style:{color:"#fff",width:200},children:c.t("color_picker.from_theme.tooltip")}),zIndex:1e4,color:"#000",overlayInnerStyle:{backgroundColor:"#000"},children:e.jsx(v,{name:"AntdQuestionCircleOutlined"})})]}),e.jsx(y,{onClick:()=>{N("color"),W()},children:c.t("color_picker.edit_theme")})]}),e.jsx(u.ThemeColorSelect,{selectedColor:E,onSelect:e=>{B(e),f(e)}}),e.jsx(l.Divider,{})]}),e.jsxs("div",{style:{marginTop:20,display:"flex",justifyContent:"space-between"},children:[e.jsxs("div",{style:{display:"flex",alignItems:"center"},children:[e.jsx(j,{children:c.t("color_picker.from_my_colors")}),e.jsx(l.Popover,{content:e.jsx("div",{style:{color:"#fff"},children:c.t("color_picker.from_my_colors.tooltip")}),zIndex:1e4,color:"#000",overlayInnerStyle:{backgroundColor:"#000"},children:e.jsx(v,{name:"AntdQuestionCircleOutlined"})})]}),e.jsxs(y,{onClick:U,children:["+ ",c.t("add_color")]}),e.jsx(d.AddColorModalDraggable,{myColors:I||[],hasGradientColor:S,visible:A,onClose:e=>{V(!1),Q(!1),null==e||e()},setSelectedColor:B,initColor:E,isUpdate:F,setVisible:V,modalPosition:H,setModalPosition:K,propKey:_,onChangeColor:f,onEditingColor:M,onCancelEditingColor:T})]}),e.jsx(k,{style:{marginTop:5},children:null==I?void 0:I.map(((o,r)=>(S||!o.includes("-gradient"))&&e.jsxs(a.ColorDiv,{onDoubleClick:U,color:o,onClick:()=>{B(o),f(o)},children:[E===o&&e.jsx(a.SelectedColor,{}),e.jsx("div",{className:"icon-wrapper edit-icon",onClick:e=>{U(e),Q(!0)},children:e.jsx(t.EditRegular,{fontSize:14})}),e.jsx("div",{className:"icon-wrapper delete-icon",onClick:e=>{((e,o)=>{e.stopPropagation();const r=I.filter(((e,r)=>r!==o));O({recentColors:r})})(e,r)},children:e.jsx(t.DismissRegular,{fontSize:14})})]},r)))}),e.jsxs("div",{style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:20},children:[e.jsx(m,{type:"link",onClick:()=>{f(void 0),B(void 0),W()},children:c.t("Đặt lại")}),e.jsx("div",{style:{fontSize:16},children:g.getColorValue(E,!1)})]})]})]})};


/***/ }),

/***/ 851734:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(212951),r=__webpack_require__(112373),t=__webpack_require__(610314),n=__webpack_require__(891987),i=__webpack_require__(610796),l=__webpack_require__(429830),s=__webpack_require__(526415),d=__webpack_require__(639911),c=__webpack_require__(959211),a=__webpack_require__(805116),p=__webpack_require__(10619),u=__webpack_require__(313247);function x(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var f=x(o);const h=f.default(t.Modal)`
  &.ant-modal {
    top: 80px;
  }

  .ant-modal {
    &-header,
    &-footer {
      padding: 8px;
      border-radius: 8px;
    }

    &-title {
      font-size: 14px;
    }

    &-close-x {
      width: 32px;
      height: 32px;
      line-height: 32px;
      font-size: 14px;
    }
    &-content {
      border-radius: 8px;
      padding: 8px;
    }
  }
`,m=f.default.div`
  display: flex;
  justify-content: space-between;
`,g=f.default(t.Button)`
  color: var(--text-color);
  padding-left: 0;
  padding-right: 0;
`,j=f.default(t.Button)`
  border-radius: 6px;
`,C=f.default.div`
  font-size: 14px;
  font-weight: 600;
`,y=f.default.div`
  color: #7367f0;
  font-size: 14px;
  cursor: pointer;
  margin-right: 10px;
`,v=f.default(r.QuestionCircleOutlined)`
  font-size: 1.2em;
  color: #82869e;
  margin-left: 4px;

  &:hover {
    color: var(--text-color);
  }
`,b=f.default.div`
  display: flex;
  flex-wrap: wrap;
`,k=f.default.div`
  font-size: 16px;
  margin-top: 20px;
`,w=f.default.div((({color:e})=>`\n    position: relative;\n    width: 30px;\n    height: 30px;\n    border-radius: 2px;\n    margin-right: 7px;\n    margin-top: 5px;\n    background: ${e};\n    border: 1px solid rgba(0, 0, 0, 0.05);\n    cursor: pointer;\n    transition: scale 0.2s ease-in-out;\n    &:hover {\n      z-index: 1;\n      scale: 1.15;\n      .icon-wrapper {\n        display: flex\n      }\n    }\n    .icon-wrapper {\n      position: absolute;\n      border-radius: 50%;\n      padding: 4px;\n      top: 0;\n      align-items: center;\n      justify-content: center;\n      display: none;\n      color: #ffffff;\n      &:hover {\n        filter: brightness(1.1);\n      }\n    }\n    .icon-wrapper.edit-icon {\n      background: #7367f0;\n      left: 0;\n      transform: translate(-50%, -50%);\n    }\n    .icon-wrapper.delete-icon {\n      background: red;\n      right: 0;\n      transform: translate(50%, -50%);\n    }\n`)),S=f.default.div`
  position: absolute;
  top: -5px;
  left: -5px;
  width: calc(100% + 10px);
  height: calc(100% + 10px);
  border-radius: 5px;
  border: 2px solid #7367f0;
`;exports.ColorDiv=w,exports.ColorPickerModalV3=({color:o,visible:r,setVisible:x,onChange:f,hasGradientColor:_})=>{const{recentColors:q,updateThemeConfig:z}=p.useThemeStore(),{document:T}=i.useFrame(),[I,O]=n.useState(o),[M,P]=n.useState(!1),[A,B]=n.useState(!1),{setOpenThemeConfig:D}=u.useBuilder(),Q=()=>x(!1);return n.useEffect((()=>{O(o)}),[o]),e.jsxs(e.Fragment,{children:[e.jsxs(h,{"data-testid":"color-picker-modal",open:r,title:l.t("Chọn màu"),onCancel:Q,width:410,bodyStyle:{padding:10},zIndex:9999,destroyOnClose:!0,getContainer:()=>(null==T?void 0:T.body)||(null==document?void 0:document.body),footer:e.jsxs(m,{children:[e.jsx(g,{type:"link",onClick:()=>{f(void 0),O(void 0),Q()},children:l.t("Đặt lại")}),e.jsxs("div",{style:{display:"flex"},children:[e.jsx(j,{onClick:Q,"data-testid":"color-picker-cancel",children:l.t("common.cancel")}),e.jsx(j,{type:"primary",onClick:()=>{f(I),Q()},"data-testid":"color-picker-ok",children:l.t("common.save")})]})]}),children:[e.jsxs("div",{style:{marginTop:20,display:"flex",justifyContent:"space-between"},children:[e.jsxs("div",{style:{display:"flex",alignItems:"center"},children:[e.jsx(C,{children:l.t("color_picker.from_theme")}),e.jsx(t.Popover,{content:e.jsx("div",{style:{color:"#fff",width:200},children:l.t("color_picker.from_theme.tooltip")}),zIndex:1e4,color:"#000",overlayInnerStyle:{backgroundColor:"#000"},children:e.jsx(v,{name:"AntdQuestionCircleOutlined"})})]}),e.jsx(y,{onClick:()=>{D("color"),Q()},children:l.t("color_picker.edit_theme")})]}),e.jsx(d.ThemeColorSelect,{selectedColor:I,onSelect:O}),e.jsxs("div",{style:{marginTop:20,display:"flex",justifyContent:"space-between"},children:[e.jsxs("div",{style:{display:"flex",alignItems:"center"},children:[e.jsx(C,{children:l.t("color_picker.from_my_colors")}),e.jsx(t.Popover,{content:e.jsx("div",{style:{color:"#fff"},children:l.t("color_picker.from_my_colors.tooltip")}),zIndex:1e4,color:"#000",overlayInnerStyle:{backgroundColor:"#000"},children:e.jsx(v,{name:"AntdQuestionCircleOutlined"})})]}),e.jsxs(y,{onClick:()=>{P(!0)},children:["+ ",l.t("add_color")]})]}),e.jsx(b,{style:{marginTop:5},children:null==q?void 0:q.map(((o,r)=>(_||!o.includes("-gradient"))&&e.jsxs(w,{onDoubleClick:()=>{P(!0)},color:o,onClick:()=>{O(o)},children:[I===o&&e.jsx(S,{}),e.jsx("div",{className:"icon-wrapper edit-icon",onClick:()=>{P(!0),B(!0)},children:e.jsx(c.EditRegular,{fontSize:14})}),e.jsx("div",{className:"icon-wrapper delete-icon",onClick:e=>{((e,o)=>{e.stopPropagation();const r=q.filter(((e,r)=>r!==o));z({recentColors:r})})(e,r)},children:e.jsx(c.DismissRegular,{fontSize:14})})]},r)))}),e.jsx(k,{children:a.getColorValue(I,!1)})]}),M&&e.jsx(s.AddColorModal,{myColors:q||[],hasGradientColor:_,visible:M,onClose:()=>{P(!1),B(!1)},setSelectedColor:O,initColor:I,isUpdate:A})]})},exports.SelectedColor=S;


/***/ }),

/***/ 352172:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),o=__webpack_require__(85097),i=__webpack_require__(736451);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=l(r);const n=t.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-color);
  padding-left: 4px;
  border-radius: 4px;
`,d=t.default(i.HexColorInput)`
  width: 80px;
  padding: 4px 4px 4px 8px;
  text-align: left;
  vertical-align: middle;
  border: none;
  &:focus {
    outline: none;
  }
`,a=t.default.div`
  border-radius: 4px;
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>');
`,s=t.default.div((({colorConfig:e,size:r})=>`\n    width: ${r}px;\n    height: ${r}px;\n    border-radius: 4px;\n    margin-left: auto;\n    background: ${o.stringifyColor(e)};\n    border: 1px solid rgba(0, 0, 0, 0.05);\n`));exports.ColorPreview=({hexInput:r,onChangeColor:i,colorType:l,currentColorValue:t})=>e.jsx(e.Fragment,{children:l===o.ColorType.solid?e.jsxs(n,{children:[e.jsx(a,{children:e.jsx(s,{colorConfig:{colorType:l,colorValue:t},size:20})}),e.jsx(d,{alpha:!0,prefixed:!0,color:r,onChange:i})]}):e.jsx(a,{children:e.jsx(s,{colorConfig:{colorType:l,colorValue:t},size:32})})});


/***/ }),

/***/ 639911:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),o=__webpack_require__(851734),t=__webpack_require__(959211),l=__webpack_require__(610314),i=__webpack_require__(429830),s=__webpack_require__(805116),n=__webpack_require__(10619),c=__webpack_require__(313247);function u(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const d=u(r).default.div`
  display: flex;
  margin-top: 10px;
  align-items: center;
`;exports.ThemeColorSelect=({selectedColor:r,onSelect:u,closeColorPickerModal:a})=>{const{currentColorPalette:j}=n.useThemeStore(),{setOpenThemeConfig:p}=c.useBuilder();return e.jsxs(d,{children:[null==j?void 0:j.map((t=>{const l=s.getColorThemeCssVarFromId(t.id);return e.jsx(o.ColorDiv,{color:t.color,onClick:()=>u(l),children:r===l&&e.jsx(o.SelectedColor,{})},t.id)})),a&&e.jsx(l.Tooltip,{zIndex:9999,color:"#000",title:i.t("color_picker.edit_color_palette"),children:e.jsx(t.SettingsFilled,{style:{fontSize:20,marginLeft:8,color:"#7B61FF",cursor:"pointer"},onClick:()=>{p("color"),a()}})})]})};


/***/ }),

/***/ 382231:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(891987),n=__webpack_require__(518421);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const u=/^\d(\.\d+)*$/,i=s(t).default.input(n.inputCss);exports.EditableInput=({value:t,onChange:n,min:s,max:o,precision:a})=>{const[l,c]=r.useState(),p=Number(t).toString(),d=()=>void 0!==a;return r.useEffect((()=>{const e=d()?parseFloat(l):parseInt(l);t!==e&&c(p)}),[t]),e.jsx(i,{value:l||"",onChange:e=>{var r;let u=e.target.value;if(!u)return void c(u);let i=parseInt(u);const l=u.split(/(\.|,)/);if(l.length>1)if(d()){const e=(null==(r=l[2])?void 0:r.substr(0,a))||"";u=`${l[0]}.${e}`,i=parseFloat(u)}else u=l[0];i>=s&&i<=o&&(c(u),t!==i&&n(i))},onBlur:()=>{u.test(l)||c(p)}})};


/***/ }),

/***/ 24005:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),o=__webpack_require__(85097),n=__webpack_require__(891987);function t(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=t(r);const l=i.default.div`
  border-radius: 8px;
  background-color: var(--background-color);
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>');
`,u=i.default.div((({gradientColor:e})=>`\n      height: 12px;\n      border-radius: 8px;\n      margin-top: 12px;\n      margin-bottom: 12px;\n      position: relative;\n      background: ${o.stringifyColor({colorType:o.ColorType.gradient,colorValue:e})};\n      `)),a=i.default.div((({gColor:e})=>`\n    height: 16px;\n    width: 16px;\n    padding-left: 2px;\n    padding-right: 2px;\n    position: absolute;\n    z-index: 10000;\n    background: ${e.color};\n    left: min(max(${e.stop}%, 0%), 100%);\n    top: 50%;\n    transform: translate(-50%,-50%);\n    border: 2px solid #fff;\n    border-radius: 50%;\n    box-shadow: 0 2px 4px rgb(0 0 0 / 20%);\n    &:hover {\n      cursor: pointer;\n    }\n  `));exports.GradientBar=({gradientColor:r,setSelectedGradientItem:o,onChange:t})=>{var i,d;const s=n.useRef(null);return e.jsx(l,{children:e.jsx(u,{gradientColor:r,ref:s,children:null==(d=null==(i=null==r?void 0:r.colors)?void 0:i.map)?void 0:d.call(i,((n,i)=>e.jsx(a,{gColor:n,onMouseDown:e=>{o(i),((e,o)=>{if(!(null==s?void 0:s.current))return;const n=s.current.clientWidth;let i=o.clientX;s.current.onmousemove=o=>{const l=Math.round(100*(o.clientX-i)/n),u=[...r.colors],a=u[e].stop+l;u[e].stop+=l,Math.abs(l)>=1&&a>=0&&a<=100&&(i=o.clientX,u[e].stop=a,t("colors",u))},s.current.onmouseup=()=>{s.current.onmousemove&&(s.current.onmousemove=null)},s.current.onmouseleave=()=>{s.current.onmousemove&&(s.current.onmousemove=null)}})(i,e)}},i)))})})};


/***/ }),

/***/ 739271:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(382231),l=__webpack_require__(518421),a=__webpack_require__(805116);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=o(r),n=Object.defineProperty,s=Object.defineProperties,u=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,d=(e,r,t)=>r in e?n(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;const j=i.default.label(l.labelCss);exports.RgbaField=({color:r,onChange:l,className:o})=>{var i;const n=null==(i=a.rgbaStringToObject(r))?void 0:i.rgba;return e.jsx("div",{className:o,style:{display:"flex",columnGap:4},children:["r","g","b","a"].map((r=>e.jsxs("div",{children:[e.jsx(t.EditableInput,{value:(null==n?void 0:n[r])||null,onChange:e=>{var t;l(a.rgbaToString((t=((e,r)=>{for(var t in r||(r={}))b.call(r,t)&&d(e,t,r[t]);if(c)for(var t of c(r))p.call(r,t)&&d(e,t,r[t]);return e})({},n),s(t,u({[r]:e})))))},min:0,max:"a"===r?1:255,precision:"a"===r?2:void 0}),e.jsx(j,{children:r})]},r)))})};


/***/ }),

/***/ 994040:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.MAX_NUMBER_OF_RECENT_COLORS=40,exports.sampleColors=["#f44336ff","#e91e63ff","#9c27b0ff","#673ab7ff","#3f51b5ff","#2196f3ff","#03a9f4ff","#00bcd4ff","#009688ff","#4caf50ff","#8bc34aff","#cddc39ff","#ffeb3bff","#ffc107ff","#ff9800ff","#ff5722ff"];


/***/ }),

/***/ 518421:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(75537);const t=e.css`
  width: 100%;
  padding: 5px;
  border-radius: 5px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  text-align: center;
`,r=e.css`
  width: 100%;
  margin-top: 4px;
  font-weight: 500;
  text-align: center;
  text-transform: uppercase;
`;exports.inputCss=t,exports.labelCss=r;


/***/ }),

/***/ 899278:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(429830),o=__webpack_require__(212951),i=__webpack_require__(112373),l=__webpack_require__(85097),t=__webpack_require__(805116),d=__webpack_require__(312995);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=n(o);const a=s.default.div`
  position: relative;
`,c=s.default.div((({color:e})=>`\n    width: 24px;\n    height: 24px;\n    border-radius: 4px;\n    margin-left: 4px;\n    background: ${e};\n    margin-right: 8px;\n`)),p=s.default.div`
  position: relative;
  width: 130px;
  height: 32px;
  display: flex;
  align-items: center;
  border: 1px solid ${e=>e.theme.colorBorder};
  border-radius: 4px;
  &:hover {
    cursor: pointer;
  }
`,u=s.default.div`
  font-size: 13px;
  line-height: 20px;
`,h=s.default.div`
  font-size: 13px;
  line-height: 18px;
  color: var(--placeholder-color);
  padding: 12px;
`,x=s.default.div`
  display: flex;
  align-items: center;
  width: 100%;
`,g=s.default.div`
  margin: auto 4px;
  right: 0;
  position: absolute;
`;exports.ColorPickerV2=({color:o,showModal:n,setShowModal:s,onChangeColor:v,placeholder:f,hasGradientColor:j})=>{const C=l.parseColor(o),m=(null==C?void 0:C.colorType)===l.ColorType.solid?t.getHexColor(o):void 0;return e.jsxs(a,{children:[e.jsx(p,{onClick:()=>{s(!n)},"data-testid":"color-picker-select",children:o?e.jsxs(e.Fragment,{children:[e.jsxs(x,{children:[e.jsx(c,{color:o}),e.jsx(u,{children:m||""})]}),e.jsx(g,{onClick:e=>{v(void 0),e.stopPropagation()},children:e.jsx(i.CloseOutlined,{})})]}):e.jsx(h,{children:f||r.t("Chọn màu")})}),e.jsx(d.ColorPickerModalV2,{visible:n,setVisible:s,color:o,onChange:v,hasGradientColor:j})]})};


/***/ }),

/***/ 201747:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(112373),r=__webpack_require__(212951),i=__webpack_require__(85097),l=__webpack_require__(429830),t=__webpack_require__(891987),n=__webpack_require__(736451),d=__webpack_require__(312995),s=__webpack_require__(805116);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=a(r);const p=c.default.div`
  position: relative;
`,u=c.default.div((({color:e,theme:o})=>`\n    width: 24px;\n    height: 24px;\n    border-radius: 4px;\n    margin-left: 4px;\n    background: ${e};\n    margin-right: 8px;\n    border: 1px solid ${null==o?void 0:o.colorBorder};\n`)),x=c.default.div`
  position: relative;
  width: 130px;
  height: 32px;
  display: flex;
  align-items: center;
  border: 1px solid ${e=>e.theme.colorBorder};
  border-radius: 4px;
  &:hover {
    cursor: pointer;
  }
`,h=c.default(n.HexColorInput)`
  width: 85px;
  height: 28px;
  font-size: 13px;
  border: none;
  outline: none;
`,f=c.default.div`
  font-size: 13px;
  line-height: 18px;
  color: var(--placeholder-color);
  padding: 12px;
`,g=c.default.div`
  display: flex;
  align-items: center;
  width: 100%;
`,v=c.default.div`
  margin: auto 4px;
  right: 0;
  position: absolute;
`;exports.ColorPickerV3=({color:r,showModal:n,setShowModal:a,onChangeColor:c,placeholder:C,hasGradientColor:j})=>{const[b,m]=t.useState(),k=i.parseColor(r),q=(null==k?void 0:k.colorType)===i.ColorType.solid?s.getHexColor(r):void 0,y=()=>{a(!n)};return t.useEffect((()=>{m(q)}),[q]),e.jsxs(p,{children:[r?e.jsxs(x,{children:[e.jsxs(g,{children:[e.jsx(u,{color:r,onClick:y,"data-testid":"color-picker-select"}),e.jsx(h,{alpha:!0,prefixed:!0,color:b,onChange:c,"data-testid":"color-picker-input"})]}),e.jsx(v,{onClick:e=>{c(void 0),m(void 0),e.stopPropagation()},children:e.jsx(o.CloseOutlined,{})})]}):e.jsx(x,{onClick:y,children:e.jsx(f,{children:C||l.t("Chọn màu")})}),e.jsx(d.ColorPickerModalV2,{visible:n,setVisible:a,color:r,onChange:c,hasGradientColor:j})]})};


/***/ }),

/***/ 114800:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(429830),r=__webpack_require__(212951),i=__webpack_require__(112373),l=__webpack_require__(131417),t=__webpack_require__(805116);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=n(r);const d=a.default.div((({color:e})=>`\n    width: 24px;\n    height: 24px;\n    border-radius: 4px;\n    margin-left: 4px;\n    background: ${e};\n    margin-right: 8px;\n`)),s=a.default.div`
  font-size: 13px;
  line-height: 20px;
`,c=a.default.div`
  font-size: 13px;
  line-height: 18px;
  color: var(--placeholder-color);
  padding: 12px;
`,h=a.default.div`
  display: flex;
  align-items: center;
  width: 100%;
`,p=a.default.div`
  margin: auto 4px;
  right: 0;
  position: absolute;
`;exports.ColorPickerV4=({color:r,showModal:n,setShowModal:a,onChangeColor:u,placeholder:g,hasGradientColor:x,propKey:C,onCancelEditingColor:f,onEditingColor:j,isStretch:v,showSelectedThemeColor:m=!0,allowClear:b=!0,displayText:y})=>e.jsx("div",{style:{position:"relative",flex:v?1:void 0},children:e.jsx(l.ColorPickerDraggable,{propKey:C,visible:n,setVisible:a,color:r,onChange:u,hasGradientColor:x,onCancelEditingColor:f,onEditingColor:j,isStretch:v,showSelectedThemeColor:m,colorConfig:r?e.jsxs(e.Fragment,{children:[e.jsxs(h,{children:[e.jsx(d,{color:r}),e.jsx(s,{children:y||t.getColorValue(r)||""})]}),b&&e.jsx(p,{onClick:e=>{u(null),e.stopPropagation()},children:e.jsx(i.CloseOutlined,{})})]}):e.jsx(c,{children:g||o.t("Chọn màu")})})});


/***/ }),

/***/ 225439:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=i(__webpack_require__(212951));const r=t.default.div`
  font-weight: 700;
  color: rgba(0, 0, 0, 0.88);
  line-height: 1.5;
  font-size: 14px;
  margin-inline-end: auto;
  flex: auto;
  box-sizing: border-box;
  padding: 8px 0px;
`,o=t.default.div`
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
`;exports.ConfigWrapper=({title:i,children:t})=>e.jsxs("div",{children:[i&&e.jsx(r,{children:i}),e.jsx(o,{children:t})]});


/***/ }),

/***/ 923766:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(429830),t=__webpack_require__(212951),s=__webpack_require__(610314),i=__webpack_require__(552884),o=__webpack_require__(313247);function r(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const a=r(t).default.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;exports.ContextMenu=t=>{const{children:r}=t,{actions:d,duplicateNode:l,query:c,getSiblings:u,onCopy:p,onPaste:x}=i.useEditor(),{frame:h,setShowSettingDialog:j,editorConfig:y}=o.useBuilder(),C=e=>"windows"===(()=>{const e=window.navigator.userAgent.toLowerCase();return[{os:"macos",pattern:/(macintosh|macintel|macppc|mac68k|macos)/i},{os:"windows",pattern:/(win32|win64|windows|wince)/i},{os:"ios",pattern:/(iphone|ipad|ipod)/i},{os:"android",pattern:/android/},{os:"linux",pattern:/linux/}].find((n=>n.pattern.test(e))).os})()?`Ctrl + ${e}`:`⌘ ${e}`,g=[{label:e.jsxs(a,{children:[e.jsx("span",{children:n.t("Cài đặt")}),e.jsx("span",{children:C("E")})]}),key:"1",onClick:()=>{j(!0)}},{label:e.jsxs(a,{children:[e.jsx("span",{children:n.t("Sao chép")}),e.jsx("span",{children:C("C")})]}),key:"2",onClick:()=>(()=>{const e=c.getState().events.selected,n=e.values().next().value;y.canCopyPaste(e,c.node)&&p(n)})()},{label:e.jsxs(a,{children:[e.jsx("span",{children:n.t("Dán")}),e.jsx("span",{children:C("V")})]}),key:"3",onClick:()=>{const e=c.getState().events.selected,n=e.values().next().value;y.canCopyPaste(e,c.node)&&x(n)}},{label:e.jsxs(a,{children:[e.jsx("span",{children:n.t("Nhân bản")}),e.jsx("span",{children:C("D")})]}),key:"4",onClick:()=>{const e=c.getState().events.selected,n=e.values().next().value;if(!y.canCopyPaste(e,c.node))return;const t=u(n).findIndex((e=>e===n)),s=c.node(n).get();l(s,s.data.parent,{index:t+1})}},{label:e.jsxs(a,{children:[e.jsx("span",{children:n.t("Xoá")}),e.jsx("span",{children:C("⌫")})]}),key:"5",onClick:()=>{const e=c.getState().events.selected;y.canDeleteNode(e,c.node)&&d.delete(Array.from(e))}}];return e.jsx(s.Dropdown,{getPopupContainer:()=>null==h?void 0:h.body,destroyPopupOnHide:!0,menu:{items:g,style:{width:160}},trigger:["contextMenu"],children:r})};


/***/ }),

/***/ 958992:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),o=__webpack_require__(959211),r=__webpack_require__(610314),n=__webpack_require__(891987);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const s=a(t).default.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
  .action-group {
    display: flex;
    gap: 2px;
  }
`;exports.DropdownOption=({label:t,changeItem:a,index:i,value:u,deleteItem:l})=>{const[c,p]=n.useState(t),[d,g]=n.useState(!1),x=n.useRef(null);return e.jsxs(s,{onClick:e=>{d&&e.stopPropagation()},children:[d?e.jsx(r.Input,{ref:x,value:c,onPressEnter:e=>{var t;t=e.currentTarget.value,a(t,u,i),g(!1)},onChange:e=>p(e.target.value),onMouseDown:e=>e.stopPropagation(),onBlur:()=>(g(!1),void p(t))}):t,e.jsxs("div",{className:"action-group",children:[!d&&e.jsx(r.Button,{size:"small",ghost:!0,icon:e.jsx(o.EditRegular,{color:"#7367f0"}),onClick:e=>{e.stopPropagation(),g(!0),setTimeout((()=>{var e;null==(e=x.current)||e.focus()}),0)}}),e.jsx(r.Button,{size:"small",ghost:!0,icon:e.jsx(o.DeleteRegular,{color:"red"}),onClick:e=>{e.stopPropagation(),l(i)}})]})]})};


/***/ }),

/***/ 252187:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(610314),l=__webpack_require__(891987),n=__webpack_require__(336984),i=__webpack_require__(833175);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=o(t),s=Object.defineProperty,d=Object.defineProperties,u=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,b=(e,t,r)=>t in e?s(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,x=(e,t)=>{for(var r in t||(t={}))p.call(t,r)&&b(e,r,t[r]);if(c)for(var r of c(t))f.call(t,r)&&b(e,r,t[r]);return e};const y=a.default.div`
  padding: 5px 12px;
  cursor: pointer;
  min-height: 31px;
  overflow: hidden;
  text-overflow: ellipsis;
`;exports.EditableCell=t=>{var o=t,{title:a,editable:s,children:b,dataIndex:h,rowIndex:v,style:w,record:j,onChange:m}=o,O=((e,t)=>{var r={};for(var l in e)p.call(e,l)&&t.indexOf(l)<0&&(r[l]=e[l]);if(null!=e&&c)for(var l of c(e))t.indexOf(l)<0&&f.call(e,l)&&(r[l]=e[l]);return r})(o,["title","editable","children","dataIndex","rowIndex","style","record","onChange"]);const[g,C]=l.useState(!1),I=l.useRef(null),E=l.useContext(i.EditableContext),P=async()=>{try{await E.validateFields([h]),m(E.getFieldValue(h)),q()}catch(e){}};l.useEffect((()=>{var e;g&&(null==(e=I.current)||e.focus())}),[g]);const q=()=>{C(!g),E.setFieldValue(h,j[h])};let S=b;return s&&(S=g?e.jsx(r.Form.Item,{style:{margin:0,whiteSpace:"normal"},name:h,rules:null==s?void 0:s.rules,children:(()=>{const{options:t,setOptions:l,inputType:i,cbDeleteOption:o}=s;switch(i){case"number":return e.jsx(r.InputNumber,{ref:I,onPressEnter:P,onBlur:P,style:{width:"100%"}});case"select":return e.jsx(n.Select,{onChange:P,ref:I,items:t,setItems:l,allowClear:!0,cbDeleteItem:e=>{E.setFieldValue(h,""),o(e)},onDropdownVisibleChange:e=>{!e&&C(!g)}});default:return e.jsx(r.Input,{ref:I,onPressEnter:P,onBlur:P,style:{width:"100%"}})}})()}):e.jsx(y,{className:"editable-cell",onClick:q,children:b})),e.jsx("td",(F=x({},O),D={style:x({overflow:"hidden",textOverflow:"ellipsis"},w),children:S},d(F,u(D))));var F,D},exports.StyledEditableCell=y;


/***/ }),

/***/ 336984:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(112373),r=__webpack_require__(610314),n=__webpack_require__(891987),l=__webpack_require__(429830),a=__webpack_require__(493959),o=__webpack_require__(958992);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=i(n),u=Object.defineProperty,d=Object.defineProperties,c=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,v=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,b=(e,t,r)=>t in e?u(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,m=(e,t)=>{for(var r in t||(t={}))v.call(t,r)&&b(e,r,t[r]);if(p)for(var r of p(t))f.call(t,r)&&b(e,r,t[r]);return e};const j=s.default.forwardRef(((i,s)=>{var u=i,{items:b,setItems:j,onChange:x,cbDeleteItem:g}=u,y=((e,t)=>{var r={};for(var n in e)v.call(e,n)&&t.indexOf(n)<0&&(r[n]=e[n]);if(null!=e&&p)for(var n of p(e))t.indexOf(n)<0&&f.call(e,n)&&(r[n]=e[n]);return r})(u,["items","setItems","onChange","cbDeleteItem"]);const[O,h]=n.useState(""),P=n.useRef(null),w=e=>{h(e.target.value)},I=()=>{const e=null==O?void 0:O.trim();if(!e)return;const t=a.v4();j([...b,{label:e,value:t}]),h(""),x(t,{value:t,label:e}),setTimeout((()=>{var e;null==(e=P.current)||e.focus()}),0)},q=(e,t,r)=>{const n=[...b];n[r]={label:e,value:t},j(n)},D=e=>{var t;const r=[...b],n=null==(t=r.splice(e,1))?void 0:t[0];j(r),null==g||g(n.value)};return e.jsx(e.Fragment,{children:e.jsx(r.Select,(S=m({dropdownStyle:{zIndex:1080}},y),C={onChange:(e,t)=>{x(e,null==t?void 0:t.dataLabel)},ref:s,style:{width:"100%"},dropdownRender:n=>e.jsxs(e.Fragment,{children:[(null==b?void 0:b.length)?n:e.jsx(r.Empty,{description:l.t("common.no_data")}),e.jsx(r.Divider,{style:{margin:"8px 0"}}),e.jsxs(r.Space,{style:{padding:"0 4px 2px"},children:[e.jsx(r.Input,{placeholder:l.t("select_config.add.placeholder"),ref:P,value:O,onChange:w,onKeyDown:e=>{e.stopPropagation()},onPressEnter:e=>{e.stopPropagation(),I()}}),e.jsx(r.Button,{type:"primary",size:"middle",icon:e.jsx(t.PlusOutlined,{}),onClick:e=>{e.stopPropagation(),I()},children:l.t("common.add")})]})]}),options:b.map(((t,r)=>({key:t.value,value:t.value,label:e.jsx(o.DropdownOption,{label:t.label,changeItem:q,index:r,value:t.value,deleteItem:D}),dataLabel:t.label}))),optionLabelProp:"dataLabel"},d(S,c(C))))});var S,C}));exports.Select=j;


/***/ }),

/***/ 833175:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(610314),t=__webpack_require__(891987),n=__webpack_require__(104437),o=__webpack_require__(944200),i=__webpack_require__(112373),l=__webpack_require__(212951);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=a(t),s=a(l),u=Object.defineProperty,c=Object.defineProperties,f=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,x=Object.prototype.propertyIsEnumerable,v=(e,r,t)=>r in e?u(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,y=(e,r)=>{for(var t in r||(r={}))b.call(r,t)&&v(e,t,r[t]);if(p)for(var t of p(r))x.call(r,t)&&v(e,t,r[t]);return e},m=(e,r)=>c(e,f(r));const j=d.default.createContext(null),O=s.default.tr`
  &:hover .editable-cell {
    padding: 4px 11px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
  }
`;exports.EditableContext=j,exports.EditableRow=t=>{var l,a=t,{index:s,children:u,style:c}=a,f=((e,r)=>{var t={};for(var n in e)b.call(e,n)&&r.indexOf(n)<0&&(t[n]=e[n]);if(null!=e&&p)for(var n of p(e))r.indexOf(n)<0&&x.call(e,n)&&(t[n]=e[n]);return t})(a,["index","children","style"]);const[v]=r.Form.useForm(),{attributes:h,listeners:g,setNodeRef:q,setActivatorNodeRef:P,transform:w,transition:S,isDragging:k}=o.useSortable({id:f["data-row-key"]}),C=y(m(y({},c),{transform:null==(l=n.CSS.Transform.toString(w&&m(y({},w),{scaleY:1})))?void 0:l.replace(/translate3d\(([^,]+),/,"translate3d(0,"),transition:S}),k?{position:"relative",zIndex:9999}:{});return e.jsx(O,m(y(y({ref:q},h),f),{style:C,children:e.jsx(r.Form,{form:v,component:!1,children:e.jsx(j.Provider,{value:v,children:d.default.Children.map(u,(r=>"sort"===r.key?d.default.cloneElement(r,{children:e.jsx(i.MenuOutlined,y({ref:P,style:{touchAction:"none",cursor:"move"}},g))}):r))})})}))};


/***/ }),

/***/ 800302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(891987),t=__webpack_require__(212951),l=__webpack_require__(610314),i=__webpack_require__(112373);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var o=n(t),a=Object.defineProperty,s=Object.defineProperties,c=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,u=(e,r,t)=>r in e?a(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,x=(e,r)=>{for(var t in r||(r={}))p.call(r,t)&&u(e,t,r[t]);if(d)for(var t of d(r))f.call(r,t)&&u(e,t,r[t]);return e};const m=o.default.div`
  margin-bottom: 8px;

  &.horizontal {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 8px;
  }
`,y=o.default.div((({layout:e="horizontal"})=>`\n  flex: 1;\n  ${"vertical"===e?"margin-bottom: 4px;":""}\n`)),h=o.default.div`
  margin-bottom: 8px;
  color: #d5dadf;
  font-size: 13px;
`,b=o.default.div`
  margin-top: 4px;
  color: #ffb307;
`,g=o.default.div`
  margin-top: 4px;
  color: #d32f2f;
`,j=o.default(i.QuestionCircleOutlined)`
  margin: inherit;
  margin-left: 0.5rem;
`;exports.FormItem=t=>{var i=t,{className:n,layout:o="horizontal",label:a,children:u,warning:v,tip:O,error:z,tooltip:w,description:T,styleTextElement:P}=i,q=((e,r)=>{var t={};for(var l in e)p.call(e,l)&&r.indexOf(l)<0&&(t[l]=e[l]);if(null!=e&&d)for(var l of d(e))r.indexOf(l)<0&&f.call(e,l)&&(t[l]=e[l]);return t})(i,["className","layout","label","children","warning","tip","error","tooltip","description","styleTextElement"]);const[N,$]=r.useState();return e.jsxs(m,(E=x({className:(()=>{let e=`${o}`;return n&&(e+=` ${n}`),e})()},q),I={children:[!!a&&e.jsxs(y,{className:"label",ref:e=>{e&&"horizontal"===o&&$(e.clientWidth)},layout:o,children:[e.jsx(l.Typography.Title,{level:5,style:{fontSize:14,fontWeight:500,marginBottom:0,display:w?"inline":"block"},children:a}),!!T&&e.jsx(l.Typography.Text,{type:"secondary",children:T}),w&&e.jsx(l.Tooltip,{title:w,zIndex:1090,children:e.jsx(j,{className:"cursor-pointer"})})]}),O&&"vertical"===o&&e.jsx(h,{children:O}),u,(()=>{if(!(v||z||O&&"horizontal"===o))return null;const r=e.jsxs(e.Fragment,{children:[O&&"horizontal"===o&&e.jsx(h,{children:O}),!!v&&e.jsx(b,{children:v}),z&&e.jsx(g,{children:z})]});return"vertical"===o?r:e.jsx("div",{style:x({marginLeft:`${N}px`,flexBasis:"100%"},P),children:r})})()]},s(E,c(I))));var E,I};


/***/ }),

/***/ 826688:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(429830),r=__webpack_require__(891987),i=__webpack_require__(212951),n=__webpack_require__(610314);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=o(i),a=Object.defineProperty,l=Object.defineProperties,c=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,u=Object.prototype.hasOwnProperty,d=Object.prototype.propertyIsEnumerable,y=(e,t,r)=>t in e?a(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,f=(e,t)=>{for(var r in t||(t={}))u.call(t,r)&&y(e,r,t[r]);if(p)for(var r of p(t))d.call(t,r)&&y(e,r,t[r]);return e};const b=s.default.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
`,j=s.default(n.Button)`
  padding: 0 !important;
  height: unset !important;
`;exports.ModalConfigWrapper=({title:i=t.t("Cấu hình sự kiện"),actionText:o=t.t("Cấu hình"),customModal:s,subTitle:a,customModalProps:p})=>{const[u,d]=r.useState(!1);return e.jsxs(e.Fragment,{children:[e.jsxs(b,{children:[e.jsxs("div",{children:[e.jsx(n.Typography.Title,{level:5,style:{fontSize:14,fontWeight:500},children:i}),!!a&&e.jsx(n.Typography.Paragraph,{type:"secondary",className:"mb-0",children:a})]}),e.jsx(j,{type:"link",onClick:()=>d((e=>!e)),children:o})]}),e.jsx(s,f({},(y=f({},p),h={visible:u,setVisible:d},l(y,c(h)))))]});var y,h};


/***/ }),

/***/ 939414:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(891987),n=__webpack_require__(212951),o=__webpack_require__(36655),r=__webpack_require__(85097);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const s=i(n).default.div((({height:e,isDragging:t,isHovering:n,isAllowDrag:o,position:r})=>`\n  height: ${e}px;\n  transition: ${t?"none":"all 0.3s ease-in-out"};\n  opacity: ${n||t?1:0};\n  cursor: ${o?"ns-resize":"default"};\n  width: 100%;\n  pointer-events: ${o?"auto":"none"};\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #7367f0;\n  background-color: #7267f052;\n  user-select: none;\n  position: absolute;\n  font-weight: 600;\n  left: 0;\n  right: 0;\n  ${"top"===r?"top: 0;":"bottom: 0;"}\n`));exports.HorizontalPaddingDragHandler=({value:n,position:i,targetRef:u,onUpdate:a,onFinish:l})=>{const c=null==u?void 0:u.current,[d,p]=t.useState(n),[f,g]=t.useState(!1),[m,v]=t.useState(!1),[h,M]=t.useState(0),[D,y]=t.useState(0),x="number"==typeof n&&n>=o.MIN_PADDING;return t.useEffect((()=>{p(n)}),[n]),t.useEffect((()=>{if(c&&c.style)switch(i){case"top":c.style.paddingTop=`${d}px`;break;case"bottom":c.style.paddingBottom=`${d}px`}}),[d]),t.useEffect((()=>{var e;const t=e=>{if(f){const t=e.clientY-h,n=D+t,r=2*Math.round(n/2),i=Math.min(o.MAX_PADDING,Math.max(o.MIN_PADDING,r));p(i),null==a||a(i)}},n=()=>{f&&(g(!1),null==l||l(d))},i=(null==(e=null==document?void 0:document.querySelector(`#${r.TEMPI_MAIN_IFRAME}`))?void 0:e.contentWindow)||window;return f&&(i.addEventListener("mousemove",t),i.addEventListener("mouseup",n)),()=>{i.removeEventListener("mousemove",t),i.removeEventListener("mouseup",n)}}),[f,h,D,d,l]),"number"!=typeof n?null:e.jsxs(s,{height:d,isDragging:f,isHovering:m,isAllowDrag:x,position:i,onMouseDown:e=>{e.preventDefault(),g(!0),M(e.clientY),y(d)},onMouseEnter:()=>{v(!0)},onMouseLeave:()=>{f||v(!1)},children:[Math.round(d),"px"]})};


/***/ }),

/***/ 36655:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.MAX_PADDING=600,exports.MIN_PADDING=16;


/***/ }),

/***/ 180336:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(959211),o=__webpack_require__(610314),n=__webpack_require__(313247),i=__webpack_require__(552884);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=a(t),s=Object.defineProperty,d=Object.defineProperties,l=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,x=Object.prototype.propertyIsEnumerable,y=(e,t,r)=>t in e?s(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,b=(e,t)=>{for(var r in t||(t={}))p.call(t,r)&&y(e,r,t[r]);if(u)for(var r of u(t))x.call(t,r)&&y(e,r,t[r]);return e},f=(e,t)=>d(e,l(t));const g=c.default(o.Button)`
  display: flex;
  align-items: center;
  width: fit-content;
  padding: 0;
  background: transparent !important;

  &:not([disabled]):hover {
    path,
    stroke {
      fill: var(--text-color);
    }
  }
`;exports.PrevNext=({disabled:t})=>{const{getAttrTracking:a,isEditingText:c}=n.useBuilder(),{canUndo:s,canRedo:d,actions:{history:l}}=i.useEditor(((e,r)=>({canUndo:!c&&r.history.canUndo()&&!t,canRedo:!c&&r.history.canRedo()&&!t})));return e.jsxs(o.Space,{children:[e.jsx(g,f(b({},a({regionName:"pageEditor",contentName:"undoBtn"})),{onClick:()=>{s&&l.undo()},type:"text",disabled:!s,icon:e.jsx(r.ArrowHookUpLeft20Regular,{color:s?"var(--text-color)":"var(--text-secondary-color)"})})),e.jsx(g,f(b({},a({regionName:"pageEditor",contentName:"redoBtn"})),{onClick:()=>{s&&l.redo()},type:"text",disabled:!d,icon:e.jsx(r.ArrowHookUpRight20Regular,{color:d?"var(--text-color)":"var(--text-secondary-color)"})}))]})};


/***/ }),

/***/ 887886:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097),o=__webpack_require__(547929),i=__webpack_require__(610314),a=__webpack_require__(891987),l=__webpack_require__(313247);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=n(t),s=n(a),p=Object.defineProperty,u=Object.getOwnPropertySymbols,f=Object.prototype.hasOwnProperty,d=Object.prototype.propertyIsEnumerable,m=(e,t,r)=>t in e?p(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,g=(e,t)=>{for(var r in t||(t={}))f.call(t,r)&&m(e,r,t[r]);if(u)for(var r of u(t))d.call(t,r)&&m(e,r,t[r]);return e};const v=s.default.forwardRef(((t,a)=>{const n=t,{tooltip:c,isActive:s,className:p}=n,m=((e,t)=>{var r={};for(var o in e)f.call(e,o)&&t.indexOf(o)<0&&(r[o]=e[o]);if(null!=e&&u)for(var o of u(e))t.indexOf(o)<0&&d.call(e,o)&&(r[o]=e[o]);return r})(n,["tooltip","isActive","className"]),v=[p,s?"active":""].filter(Boolean).join(" "),{tag:j}=o.useNode((e=>({tag:e.data.custom.tag}))),{device:b}=l.useBuilder(),x=j===r.COMPONENT_TAG.SECTION&&"desktop"!==b;return e.jsx(i.Tooltip,{title:c,getPopupContainer:e=>e,getTooltipContainer:e=>e,placement:x?"right":"top",children:e.jsx(y,g({ref:a,className:v},m))})})),y=c.default.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  height: 40px;
  padding-left: 12px;
  padding-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #444444;
  white-space: nowrap;

  &:hover,
  &.active {
    color: ${e=>e.theme.colorPrimary};
  }
`;exports.QuickSettingButton=v;


/***/ }),

/***/ 227244:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(610314),r=__webpack_require__(212951),n=__webpack_require__(547929),o=__webpack_require__(313247);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=i(r),d=Object.defineProperty,l=Object.defineProperties,c=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,s=Object.prototype.propertyIsEnumerable,f=(e,t,r)=>t in e?d(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r;const g=a.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 12px;
  padding-right: 12px;
`;exports.RenderQuickSetting=r=>{var i=r,{children:a,content:d,open:v}=i,y=((e,t)=>{var r={};for(var n in e)p.call(e,n)&&t.indexOf(n)<0&&(r[n]=e[n]);if(null!=e&&u)for(var n of u(e))t.indexOf(n)<0&&s.call(e,n)&&(r[n]=e[n]);return r})(i,["children","content","open"]);const{dragging:b,tag:j}=n.useNode((e=>({dragging:e.events.dragged,tag:e.data.custom.tag}))),{frame:x}=o.useBuilder();return e.jsx(t.Popover,(O=((e,t)=>{for(var r in t||(t={}))p.call(t,r)&&f(e,r,t[r]);if(u)for(var r of u(t))s.call(t,r)&&f(e,r,t[r]);return e})({placement:"top",open:v&&!b,overlayInnerStyle:{width:"max-content",borderRadius:8,padding:0},zIndex:1050,content:e.jsx(g,{"data-testid":`${j}-popover-quick-setting`,children:d}),autoAdjustOverflow:!0,destroyTooltipOnHide:!0,getPopupContainer:()=>null==x?void 0:x.body,getTooltipContainer:()=>null==x?void 0:x.body},y),l(O,c({children:a}))));var O};


/***/ }),

/***/ 944215:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(112373),i=__webpack_require__(212951),n=__webpack_require__(891987);function r(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=r(i);const o=l.default.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
`,s=l.default.span`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`,d=l.default.div`
  display: flex;
  align-items: center;
  padding: 8px 0;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1080;
`,c=l.default(t.LeftOutlined)`
  margin-right: 8px;
`,a=l.default.div`
  min-height: 38px;
  padding: 8px 12px 8px 0;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  font-weight: 500;
`,p=l.default.div`
  color: #000000cc;
  font-weight: bold;
`;exports.SettingWrapper=({children:i,settings:r})=>{const[l,u]=n.useState(null);if(null!==l){const t=r[l];return e.jsxs(e.Fragment,{children:[e.jsxs(d,{onClick:()=>u(null),children:[e.jsx(c,{}),e.jsx(s,{children:t.label})]}),t.children]})}return e.jsxs(e.Fragment,{children:[i,r.map(((i,n)=>e.jsxs(a,{onClick:()=>{u(n)},children:[e.jsx(o,{children:i.label}),e.jsx(p,{children:e.jsx(t.RightOutlined,{})})]},n)))]})};


/***/ }),

/***/ 953191:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(610314),t=Object.defineProperty,n=Object.defineProperties,o=Object.getOwnPropertyDescriptors,i=Object.getOwnPropertySymbols,l=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable,c=(e,r,n)=>r in e?t(e,r,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[r]=n,p=(e,r)=>{for(var t in r||(r={}))l.call(r,t)&&c(e,t,r[t]);if(i)for(var t of i(r))a.call(r,t)&&c(e,t,r[t]);return e};exports.SubQuickSetting=t=>{var c,u=t,{children:d,overlayInnerStyle:b}=u,y=((e,r)=>{var t={};for(var n in e)l.call(e,n)&&r.indexOf(n)<0&&(t[n]=e[n]);if(null!=e&&i)for(var n of i(e))r.indexOf(n)<0&&a.call(e,n)&&(t[n]=e[n]);return t})(u,["children","overlayInnerStyle"]);return e.jsx(r.Popover,(c=p({trigger:"click",placement:"bottom",overlayInnerStyle:p({padding:12,borderRadius:8,width:310},b),zIndex:1065,getPopupContainer:e=>e},y),n(c,o({children:d}))))};


/***/ }),

/***/ 964694:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(610314),t=__webpack_require__(800302),o=Object.defineProperty,s=Object.defineProperties,c=Object.getOwnPropertyDescriptors,n=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable,p=(e,r,t)=>r in e?o(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,l=(e,r)=>{for(var t in r||(r={}))i.call(r,t)&&p(e,t,r[t]);if(n)for(var t of n(r))a.call(r,t)&&p(e,t,r[t]);return e};exports.SwitchToShow=o=>{const{show:n,setShow:i,formItemProps:a,children:p,switchProps:m}=o;return e.jsxs(e.Fragment,{children:[e.jsx(t.FormItem,(u=l({},a),b={children:e.jsx(r.Switch,l({checked:n,onChange:i},m))},s(u,c(b)))),n&&p]});var u,b};


/***/ }),

/***/ 801115:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),i=__webpack_require__(429830),t=__webpack_require__(610314),r=__webpack_require__(891987),n=__webpack_require__(493959),a=__webpack_require__(313247);const l=(e,i)=>URL.createObjectURL(e);exports.UploadImageButton=({acceptedFiles:o=["image/jpg","image/jpeg","image/png","image/gif","image/webp"],handlerAfterUpload:u})=>{const[s,c]=r.useState(!1),d=r.useRef(),{uploadFileHandler:p=l,maxSizeImageUpload:g=20}=a.useBuilder(),[m,f]=r.useState(n.v4()),h=()=>{if(!d)return;const e=d.current.parentNode;e.focus(),e.querySelector("button").blur(),d.current.click()};return e.jsxs("div",{onKeyDown:h,onClick:h,children:[e.jsx("input",{ref:d,disabled:s,id:"image-file",type:"file",hidden:!0,multiple:!0,onClick:e=>e.stopPropagation(),onChange:e=>(e=>{try{const{files:r}=e.target,n=[...r];if((null==r?void 0:r.length)>5)return void t.notification.error({message:i.t("Vui lòng chỉ tải lên tối đa {{MAX_IMAGE_UPLOAD}} ảnh 1 lần!",{MAX_IMAGE_UPLOAD:5})});if(n.some((e=>!o.includes(e.type))))return void t.notification.error({message:i.t("Chỉ upload các định dạng file: {{acceptedFiles}}",{acceptedFiles:o})});(e=>{c(!0);const i=e.map((e=>p(e,"image")));Promise.all(i).then((e=>{null==u||u(e)})).finally((()=>c(!1)))})(n)}finally{f(n.v4())}})(e)},m),e.jsx(t.Button,{loading:s,shape:"round",children:i.t("upload_image_product",{maxSize:`${g}MB`})})]})};


/***/ }),

/***/ 788463:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),i=__webpack_require__(429830),t=__webpack_require__(106441),r=__webpack_require__(925687),n=__webpack_require__(81337),s=__webpack_require__(610314),o=__webpack_require__(326809),a=__webpack_require__(468569),d=__webpack_require__(105915),l=__webpack_require__(313247),c=__webpack_require__(234741);const{Panel:p}=s.Collapse;exports.AdvanceAttributes=({propKey:g=c.PROP_KEY.CommonStyle,separateDevice:u=!1,readOnlyElementId:h,allowConfigSchema:j,allowConfigVisibility:x=!0,allowConfigResponsive:v})=>{const{allowConfigResponsive:y}=l.useBuilder(),m=void 0!==v?v:y;return e.jsxs(e.Fragment,{children:[e.jsx(n.AttributeId,{readOnlyElementId:h}),e.jsx(s.Divider,{style:{margin:"12px 0"}}),e.jsxs(s.Collapse,{defaultActiveKey:["Spacing","ResponsiveVisibility","TimingVisibility"],expandIconPosition:"end",bordered:!1,children:[e.jsx(p,{header:i.t("Khoảng cách"),children:e.jsxs(s.Space,{direction:"vertical",children:[e.jsx(s.Typography.Text,{style:{marginBottom:8},type:"warning",children:i.t("Chú ý: Margin và Padding quá cao có thể làm vỡ thiết kế trên điện thoại")}),e.jsx(t.SpacingAttribute,{title:"Margin",separateDevice:u,propKey:c.PROP_KEY.joinKey(g,c.PROP_KEY.Margin)}),e.jsx(t.SpacingAttribute,{title:"Padding",separateDevice:u,propKey:c.PROP_KEY.joinKey(g,c.PROP_KEY.Padding)})]})},"Spacing"),g===c.PROP_KEY.CommonStyle&&x&&e.jsxs(e.Fragment,{children:[m&&e.jsx(p,{header:i.t("Ẩn/Hiển thị trên thiết bị"),children:e.jsx(r.ResponsiveAttribute,{})},"ResponsiveVisibility"),e.jsx(p,{header:i.t("Đặt giờ hiển thị"),children:e.jsx(o.TimingAttributes,{})},"TimingVisibility")]}),e.jsx(p,{header:i.t("Hiệu ứng khi di chuột vào"),children:e.jsx(a.HoverConfig,{propKey:g,separateDevice:u})},"HoverEffect"),j&&e.jsx(p,{header:i.t("Schema"),children:e.jsx(d.CodeEditorConfig,{propKey:c.PROP_KEY.Schema})},"Schema")]})]})};


/***/ }),

/***/ 81337:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(429830),t=__webpack_require__(547929),i=__webpack_require__(891987),n=__webpack_require__(552884),s=__webpack_require__(541054),o=__webpack_require__(728567);exports.AttributeId=({readOnlyElementId:u=!1})=>{const d={label:r.t("Mã thành phần"),existed:r.t("Mã đã tồn tại")},{id:l}=t.useNode(),{query:a}=n.useEditor(),[p,h]=s.useProp("id"),[c,g]=i.useState("");return e.jsx(o.InputConfig,{formItemProps:{label:r.t("Mã thành phần"),warning:c,style:{margin:"0.5rem"}},inputProps:{value:p,onChange:e=>{const r=e.target.value.trim()||void 0;(e=>{let r="";if(e){const t=a.getSerializedNodes();Object.keys(t).filter((r=>{var i;return e===(null==(i=t[r].props)?void 0:i.id)&&r!==l})).length&&(r=d.existed)}g(r)})(r),h(r)},placeholder:r.t("Nhập mã"),readOnly:u}})};


/***/ }),

/***/ 740231:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(547929),n=__webpack_require__(26308),o=__webpack_require__(234741),i=__webpack_require__(514824);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var u=a(t),p=Object.defineProperty,s=Object.defineProperties,l=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,b=Object.prototype.propertyIsEnumerable,f=(e,t,r)=>t in e?p(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,m=(e,t)=>{for(var r in t||(t={}))c.call(t,r)&&f(e,r,t[r]);if(d)for(var r of d(t))b.call(t,r)&&f(e,r,t[r]);return e},v=(e,t)=>s(e,l(t)),j=(e=>(e.top="top",e.right="right",e.bottom="bottom",e.left="left",e.main="main",e))(j||{});const y=u.default.div`
  position: relative;
  height: 90px;
  width: 60%;
  margin: 24px auto;
  border: 1px solid var(--border-color);
  border-radius: 10px;
`,h=u.default(i.InputNumber)((({position:e})=>`\n    width: 50px;\n    position: absolute;\n    border-radius: 4px;\n    ${(()=>{switch(e){case"top":return" \n          left: 50%;\n        ";case"right":return"\n          left: 100%;\n          top: 50%;\n        ";case"bottom":return"\n          top: 100%;\n          left: 50%;\n        ";case"left":return"\n          top: 50%;\n        ";default:return"\n          top: 50%;\n          left: 50%;\n        "}})()}\n    transform: translateX(-50%) translateY(-50%);\n\n    .ant-input-number {\n      &-handler-wrap {\n        visibility: hidden;\n      }\n\n      &-input {\n        border-radius: 4px;\n        padding: 0 8px;\n        text-align: center;\n      }\n    } \n  `));exports.FourCornerInputGroup=({propKey:t,separateDevice:i})=>{const{defaultValues:a}=r.useNode((({data:e})=>{var r;return{defaultValues:null==(r=e.custom.defaultValues)?void 0:r[t]}})),[u,p]=n.usePropSeparateDevice(t,i);return e.jsx(y,{children:Object.values(j).map((r=>e.jsx(h,{position:r,separateDevice:i,propKey:o.PROP_KEY.joinKey(t,r),placeholder:(null==a?void 0:a[r])||0,onChange:e=>((e,t)=>{const r=null!==e?e:void 0;let n=u;n="main"===t?m(m({},n),Object.values(j).reduce(((e,t)=>v(m({},e),{[t]:r})),{})):v(m({},n),{[t]:r,main:void 0}),p(n)})(e,r)},r)))})};


/***/ }),

/***/ 925687:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(429830),i=__webpack_require__(407229),n=__webpack_require__(547929),r=__webpack_require__(350461),o=__webpack_require__(234741);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=s(i);exports.ResponsiveAttribute=()=>{const{responsive:i,actions:{setProp:s}}=n.useNode((e=>({responsive:e.data.props.responsive}))),c=(null==i?void 0:i.hiddenXs)||!1,h=(null==i?void 0:i.hiddenMd)||!1,l=e=>{"mobile"===e&&s((e=>{d.default(e,o.PROP_KEY.HiddenXs,!c)}),500),"desktop"===e&&s((e=>{d.default(e,o.PROP_KEY.HiddenMd,!h)}),500)};return e.jsxs(e.Fragment,{children:[e.jsx(r.SwitchConfig,{formItemProps:{label:t.t("Máy tính")},switchProps:{checkedChildren:t.t("Hiện"),unCheckedChildren:t.t("Ẩn"),checked:!h,onChange:()=>l("desktop")}}),e.jsx(r.SwitchConfig,{formItemProps:{label:t.t("Điện thoại"),style:{marginBottom:0}},switchProps:{checkedChildren:t.t("Hiện"),unCheckedChildren:t.t("Ẩn"),checked:!c,onChange:()=>l("mobile")}})]})};


/***/ }),

/***/ 106441:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var r=__webpack_require__(561261),e=__webpack_require__(740231),t=__webpack_require__(800302),o=Object.defineProperty,n=Object.getOwnPropertySymbols,u=Object.prototype.hasOwnProperty,l=Object.prototype.propertyIsEnumerable,a=(r,e,t)=>e in r?o(r,e,{enumerable:!0,configurable:!0,writable:!0,value:t}):r[e]=t,i=(r,e)=>{for(var t in e||(e={}))u.call(e,t)&&a(r,t,e[t]);if(n)for(var t of n(e))l.call(e,t)&&a(r,t,e[t]);return r};exports.SpacingAttribute=o=>{var a=o,{title:p}=a,c=((r,e)=>{var t={};for(var o in r)u.call(r,o)&&e.indexOf(o)<0&&(t[o]=r[o]);if(null!=r&&n)for(var o of n(r))e.indexOf(o)<0&&l.call(r,o)&&(t[o]=r[o]);return t})(a,["title"]);return r.jsx(t.FormItem,{layout:"vertical",label:p,children:r.jsx(e.FourCornerInputGroup,i({},c))})};


/***/ }),

/***/ 326809:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(547929),r=__webpack_require__(731006),i=Object.defineProperty,o=Object.getOwnPropertySymbols,n=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,a=(e,t,r)=>t in e?i(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r;exports.TimingAttributes=()=>{const{startTime:i,endTime:l,ruleRepeat:d,date:s,duration:m,actions:{setCustom:p}}=t.useNode((({data:e})=>{var t,r,i,o,n;return{startTime:null==(t=null==e?void 0:e.custom)?void 0:t.startTime,endTime:null==(r=null==e?void 0:e.custom)?void 0:r.endTime,ruleRepeat:null==(i=null==e?void 0:e.custom)?void 0:i.ruleRepeat,date:null==(o=null==e?void 0:e.custom)?void 0:o.date,duration:null==(n=null==e?void 0:e.custom)?void 0:n.duration}}));return e.jsx(r.TimingConfig,((e,t)=>{for(var r in t||(t={}))n.call(t,r)&&a(e,r,t[r]);if(o)for(var r of o(t))u.call(t,r)&&a(e,r,t[r]);return e})({},{startTime:i,endTime:l,ruleRepeat:d,date:s,duration:m,setDate:e=>{p((t=>{t.date=e}))},setStartTime:e=>{p((t=>{t.startTime=e}))},setEndTime:e=>{p((t=>{t.endTime=e}))},setRuleRepeat:e=>{p((t=>{t.ruleRepeat=e}))},setDuration:e=>{p((t=>{t.duration=e}))}}))};


/***/ }),

/***/ 821544:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(959211),r=__webpack_require__(610314),i=__webpack_require__(26308),n=__webpack_require__(800302),o=Object.defineProperty,l=Object.defineProperties,s=Object.getOwnPropertyDescriptors,a=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,p=(e,t,r)=>t in e?o(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r;exports.AlignmentConfig=o=>{const{propKey:f,buttonGroupProps:d,formItemProps:j,separateDevice:g,alignmentType:m="horizontal"}=o,{listAlignment:b=["left","center","right"],defaultValue:x}=d||{},[y=x,v]=i.usePropSeparateDevice(f,g),h=r=>{if("vertical"===m)switch(r){case"top":return e.jsx(t.AlignTopFilled,{fontSize:16});case"bottom":return e.jsx(t.AlignBottomFilled,{fontSize:16});case"center":return e.jsx(t.AlignCenterHorizontalFilled,{fontSize:16});case"justify":return e.jsx(t.TextAlignJustifyFilled,{style:{fontWeight:"bold"},fontSize:16})}switch(r){case"left":case"flex-start":return e.jsx(t.AlignLeftFilled,{fontSize:16});case"center":return e.jsx(t.AlignCenterVerticalFilled,{fontSize:16});case"right":case"flex-end":return e.jsx(t.AlignRightFilled,{fontSize:16});case"justify":case"space-between":return e.jsx(t.TextAlignJustifyRotate90Filled,{fontSize:16})}};return e.jsx(n.FormItem,(S=((e,t)=>{for(var r in t||(t={}))c.call(t,r)&&p(e,r,t[r]);if(a)for(var r of a(t))u.call(t,r)&&p(e,r,t[r]);return e})({},j),F={children:e.jsx(r.Radio.Group,{value:y,optionType:"button",buttonStyle:"solid",children:b.map(((t,i)=>e.jsx(r.Radio,{onClick:()=>(e=>{v(e!==y?e:void 0)})(t),value:t,children:h(t)},i)))})},l(S,s(F))));var S,F};


/***/ }),

/***/ 714816:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(429830),t=__webpack_require__(610314),i=__webpack_require__(301842),o=__webpack_require__(26308),a=__webpack_require__(234741),r=__webpack_require__(541054),s=__webpack_require__(828426),l=__webpack_require__(350461);const p=[{label:"Fading entrances",options:["fadeIn","fadeInUp","fadeInUpBig","fadeInDown","fadeInLeft","fadeInRight","fadeInTopLeft","fadeInTopRight","fadeInBottomLeft","fadeInBottomRight"]},{label:"Sliding entrances",options:["slideInUp","slideInDown","slideInLeft","slideInRight"]},{label:"Rotating entrances",options:["rotateIn","rotateInUpLeft","rotateInUpRight","rotateInDownLeft","rotateInDownRight"]},{label:"Bouncing entrances",options:["bounceIn","bounceInUp","bounceInDown","bounceInLeft","bounceInRight"]},{label:"Zooming entrances",options:["zoomIn","zoomInUp","zoomInDown","zoomInLeft","zoomInRight"]},{label:"Lightspeed",options:["lightSpeedInRight","lightSpeedInLeft","lightSpeedOutRight","lightSpeedOutLeft"]},{label:"Attention seekers",options:["bounce","flash","pulse","rubberBand","shakeX","shakeY","headShake","swing","tada","wobble","jello","heartBeat"]},{label:"Specials",options:["hinge","jackInTheBox","rollIn"]}];exports.AnimationConfig=({propKey:g=a.PROP_KEY.CommonStyle,separateDevice:u})=>{const{Option:d,OptGroup:h}=t.Select,[c,f]=o.usePropSeparateDevice(a.PROP_KEY.joinKey(g,a.PROP_KEY.AnimationRepeatType),u),[I,P]=r.useProp(a.PROP_KEY.joinKey(g,a.PROP_KEY.AnimationName));return e.jsxs(e.Fragment,{children:[e.jsx(s.SelectConfig,{separateDevice:u,propKey:a.PROP_KEY.joinKey(g,a.PROP_KEY.AnimationName),formItemProps:{label:n.t("Loại hiệu ứng"),placeholder:n.t("Chọn hiệu ứng"),layout:"vertical"},selectProps:{style:{width:"100%"},children:e.jsx(e.Fragment,{children:p.map((n=>e.jsx(h,{label:n.label,children:n.options.map((n=>e.jsx(d,{value:n,children:n[0].toUpperCase()+n.slice(1).split(/(?=[A-Z])/).join(" ")},n)))},n.label)))})}}),I&&e.jsxs(e.Fragment,{children:[e.jsx(i.RangeSliderConfig,{separateDevice:u,propKey:a.PROP_KEY.joinKey(g,a.PROP_KEY.AnimationDuration),formItemProps:{label:n.t("Khoảng thời gian diễn ra hiệu ứng (s)")},sliderProps:{defaultValue:1,min:0,max:5},unitProps:{defaultValue:"s"}}),e.jsx(i.RangeSliderConfig,{separateDevice:u,propKey:a.PROP_KEY.joinKey(g,a.PROP_KEY.AnimationDelay),formItemProps:{label:n.t("Độ trễ xuất hiện hiệu ứng (s)")},sliderProps:{defaultValue:1,min:0,max:5},unitProps:{defaultValue:"s"}}),e.jsx(l.SwitchConfig,{formItemProps:{label:n.t("Lặp lại hiệu ứng")},switchProps:{checked:"infinite"===c,onChange:e=>{f(e?"infinite":void 0)}}})]})]})};


/***/ }),

/***/ 512571:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(112373),r=__webpack_require__(212951),i=__webpack_require__(610314),o=__webpack_require__(891987),a=__webpack_require__(429830),n=__webpack_require__(208647),l=__webpack_require__(26308),s=__webpack_require__(313247),u=__webpack_require__(800302);function c(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=c(r),p=Object.defineProperty,m=Object.defineProperties,f=Object.getOwnPropertyDescriptors,j=Object.getOwnPropertySymbols,h=Object.prototype.hasOwnProperty,y=Object.prototype.propertyIsEnumerable,v=(e,t,r)=>t in e?p(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,x=(e,t)=>{for(var r in t||(t={}))h.call(t,r)&&v(e,r,t[r]);if(j)for(var r of j(t))y.call(t,r)&&v(e,r,t[r]);return e};const b=["wav","mp3"],g=d.default(i.Upload)`
  .ant-upload-select,
  .ant-upload-list-item-container {
    width: 100% !important;
  }

  a {
    color: rgba(0, 0, 0, 0.88);
  }
`,_=d.default(i.Divider)`
  justify-content: center;
  &::before,
  &::after {
    width: 25% !important;
  }
`;exports.AudioUploadConfig=({propKey:r,separateDevice:c})=>{const[d,p]=o.useState(!1),[j,h]=o.useState(!1),[y,v]=o.useState([]),[w,F]=l.usePropSeparateDevice(r,c),[O]=i.Form.useForm();o.useEffect((()=>{v(w?[{url:w,uid:w,name:n.getFileName(w)}]:[])}),[w]);const q=(e,t)=>URL.createObjectURL(e),{uploadFileHandler:S=q}=s.useBuilder(),P={beforeUpload:n.beforeUploadAudio,customRequest:async e=>{const{file:t,onSuccess:r,onError:i}=e;try{p(!0);const e=await S(t,"audio");F(e),r(t)}catch(e){i(e,t)}finally{p(!1)}},listType:w?"picture":"picture-card",maxCount:1,multiple:!1,fileList:y,onRemove:()=>{F("")},accept:b.map((e=>`.${e}`)).join(", ")};return e.jsx(u.FormItem,{layout:"vertical",label:a.t("audio.audio_file"),children:e.jsxs(i.Spin,{spinning:d,children:[e.jsx("div",{style:{position:"relative",width:"100%"},children:e.jsx("div",{style:{position:"relative"},children:e.jsx(g,(U=x({},P),I={children:w?null:e.jsx("div",{style:{width:"100%"},children:d?e.jsx(t.LoadingOutlined,{}):e.jsxs(e.Fragment,{children:[e.jsx(t.UploadOutlined,{}),e.jsx("div",{style:{marginTop:4},children:a.t("audio_config.upload")})]})})},m(U,f(I))))})}),!w&&e.jsxs(e.Fragment,{children:[e.jsx(_,{plain:!0,children:a.t("hoặc")}),e.jsx(i.Form,{form:O,onFinish:async e=>{var t;const{url:r}=e;try{h(!0);const e=await S(r,"audioUrl");if(!(null==(t=new RegExp(`\\.(${b.join("|")})$`,"i"))?void 0:t.test(r)))throw i.notification.error({message:a.t("upload.invalid_file_format")}),Error(a.t("upload.invalid_file_format"));F(e)}catch(e){}finally{O.resetFields(),h(!1)}},children:e.jsx(i.Form.Item,{name:"url",rules:[{required:!0,message:a.t("common.url_can_not_be_empty")},{type:"url",message:a.t("common.invalid_url")},{pattern:/^[a-zA-Z0-9-._~:/?#@!$&'()*+,;=%]*$/,message:a.t("url_not_support_special_characters")}],children:e.jsx(i.Input.Search,{placeholder:a.t("common.use_url"),enterButton:a.t("use"),loading:j,onSearch:()=>O.submit()})})})]})]})});var U,I};


/***/ }),

/***/ 208647:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(429830),i=__webpack_require__(610314);const o=["audio/mpeg","audio/wav"];exports.beforeUploadAudio=t=>o.includes(t.type)?!!(t.size<20971520)||(i.notification.error({message:e.t("audio.upload.file_size_limit")}),!1):(i.notification.error({message:e.t("audio.upload.invalid_file_format")}),!1),exports.getFileName=e=>e.substring(e.lastIndexOf("/")+1);


/***/ }),

/***/ 268349:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(429830),r=__webpack_require__(891987),a=__webpack_require__(62424),i=__webpack_require__(509895),t=__webpack_require__(234741),n=__webpack_require__(26308),u=__webpack_require__(313247),s=__webpack_require__(451633);const c=[{label:"common.color",value:"color"},{label:"common.image",value:"image"}];exports.BackgroundConfig=({title:g=o.t("Nền"),propKey:l,separateDevice:p})=>{const d=t.PROP_KEY.joinKey(l,t.PROP_KEY.BackgroundColor),m=t.PROP_KEY.joinKey(l,t.PROP_KEY.BackgroundImage),[P,v]=r.useState(""),[C,f]=r.useState(void 0),[j,k]=n.usePropSeparateDevice(m,p),[b,B]=n.usePropSeparateDevice(d,p),[K,q]=r.useState(j?"image":"color"),{track:x}=u.useBuilder();return r.useEffect((()=>{"image"===K?(f(b),B(void 0),""!==P&&k(P)):(v(j),k(""),void 0!==C&&B(C))}),[K]),e.jsxs(e.Fragment,{children:[e.jsx(a.RadioConfig,{formItemProps:{label:g},radioGroupProps:{options:o.getOptionsI18n(o.t,c,"label"),value:K,onChange:e=>{q(e.target.value),x({contentName:"color"===e.target.value?"colorBackground":"imageBackground",regionName:"backgroundTab"})},optionType:"button",buttonStyle:"solid"}}),"image"===K?e.jsx(i.BackgroundImageConfig,{propKey:l,separateDevice:p}):e.jsx(s.ColorPickerConfigV3,{propKey:d,gradientPicker:!0,separateDevice:p,formItemProps:{label:o.t("Màu nền")}})]})};


/***/ }),

/***/ 509895:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(429830),o=__webpack_require__(85097),i=__webpack_require__(891987),a=__webpack_require__(272274),t=__webpack_require__(615554),n=__webpack_require__(116176),u=__webpack_require__(904511),p=__webpack_require__(234741),s=__webpack_require__(26308),P=__webpack_require__(770867),c=__webpack_require__(541055),l=__webpack_require__(828426);exports.BackgroundImageConfig=({propKey:g=p.PROP_KEY.CommonStyle,separateDevice:K,allowConfingMarqueeBgImage:y=!1})=>{const m=p.PROP_KEY.joinKey(g,p.PROP_KEY.BackgroundImage),d=p.PROP_KEY.joinKey(g,p.PROP_KEY.BackgroundImageWidth),[f]=s.usePropSeparateDevice(p.PROP_KEY.joinKey(g,p.PROP_KEY.BackgroundImage),K),[j,v]=s.usePropSeparateDevice(p.PROP_KEY.joinKey(g,p.PROP_KEY.BackgroundSize),K),[O,E]=s.usePropSeparateDevice(p.PROP_KEY.joinKey(g,p.PROP_KEY.BackgroundRepeat),K),h=p.PROP_KEY.joinKey(g,p.PROP_KEY.DefaultOverlay),[C]=s.usePropSeparateDevice(p.PROP_KEY.joinKey(g,p.PROP_KEY.BackgroundOverlay),K),[_]=s.usePropSeparateDevice(m,K),[R,Y]=s.usePropSeparateDevice(h,K);return i.useEffect((()=>{j||v("cover"),O||E("no-repeat")}),[]),i.useEffect((()=>{!_&&R&&Y(void 0)}),[_]),e.jsxs(e.Fragment,{children:[e.jsx(P.ImageConfig,{clearValue:null,propKey:m,widthPropKey:d,separateDevice:K,layout:"vertical"}),!!C&&e.jsx(a.OverlayConfig,{separateDevice:K}),f&&e.jsxs(e.Fragment,{children:[e.jsx(t.BackgroundPositionConfig,{propKey:p.PROP_KEY.joinKey(g,p.PROP_KEY.BackgroundPosition),separateDevice:K}),e.jsx(c.InputNumberConfigV2,{propKey:h,separateDevice:K,unitProps:{defaultValue:o.UnitEnum.percent},inputNumberProps:{min:0,max:100,defaultValue:0,style:{width:90}},formItemProps:{label:r.t("Độ mờ lớp phủ nền")},usePropOptions:{formatter:n.percentPropFormatter,parser:u.percentPropParser}}),y&&e.jsx(l.SelectConfig,{separateDevice:K,formItemProps:{label:r.t("Hiệu ứng di chuyển"),layout:"vertical"},selectProps:{placeholder:r.t("Chọn hiệu ứng di chuyển ảnh nền"),style:{width:"100%"}},options:[{label:r.t("Chạy theo chiều ngang"),value:"horizontal"},{label:r.t("Chạy theo chiều dọc"),value:"vertical"}],propKey:p.PROP_KEY.joinKey(g,p.PROP_KEY.BackgroundMarqueeDirection)})]})]})};


/***/ }),

/***/ 615554:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(429830),r=__webpack_require__(610314),a=__webpack_require__(891987),l=__webpack_require__(26308),o=__webpack_require__(800302),i=Object.defineProperty,n=Object.defineProperties,c=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,s=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,b=(e,t,r)=>t in e?i(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r;const y=[{key:"1",label:t.t("Trái trên"),value:"left top"},{key:"2",label:t.t("Giữa trên"),value:"center top"},{key:"3",label:t.t("Phải trên"),value:"right top"},{key:"4",label:t.t("Trái giữa"),value:"left center"},{key:"5",label:t.t("Giữa"),value:"center center"},{key:"6",label:t.t("Phải giữa"),value:"right center"},{key:"7",label:t.t("Trái dưới"),value:"left bottom"},{key:"8",label:t.t("Trái giữa"),value:"center bottom"},{key:"9",label:t.t("Phải dưới"),value:"right bottom"}];exports.BackgroundPositionConfig=i=>{const{formItemProps:v,propKey:d,separateDevice:h}=i,[j,m]=l.usePropSeparateDevice(d,h);return a.useEffect((()=>{j||m("center center")}),[]),e.jsx(o.FormItem,(g=((e,t)=>{for(var r in t||(t={}))s.call(t,r)&&b(e,r,t[r]);if(u)for(var r of u(t))p.call(t,r)&&b(e,r,t[r]);return e})({label:t.t("Vị trí ảnh nền"),layout:"vertical"},v),f={children:e.jsx(r.Radio.Group,{style:{width:"100%"},onChange:e=>{m(e.target.value)},value:j,children:e.jsx(r.Card,{style:{width:"100%"},bodyStyle:{padding:16},children:e.jsx(r.Row,{gutter:[16,16],children:y.map((t=>e.jsx(r.Col,{style:{textAlign:"center"},span:8,children:e.jsx(r.Radio,{value:t.value})},t.key)))})})})},n(g,c(f))));var g,f};


/***/ }),

/***/ 287167:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(429830),o=__webpack_require__(85097),t=__webpack_require__(891987),i=__webpack_require__(916757),a=__webpack_require__(234741),l=__webpack_require__(26308),n=__webpack_require__(541055),u=__webpack_require__(116176),p=__webpack_require__(904511),s=__webpack_require__(828426);exports.BackgroundVideoConfig=({propKey:P=a.PROP_KEY.CommonStyle,separateDevice:c})=>{const d=a.PROP_KEY.joinKey(P,a.PROP_KEY.BackgroundVideo,a.PROP_KEY.Platform),K=a.PROP_KEY.joinKey(P,a.PROP_KEY.BackgroundVideo,a.PROP_KEY.Src),f=a.PROP_KEY.joinKey(P,a.PROP_KEY.BackgroundVideo,a.PROP_KEY.UploadSrc),m=a.PROP_KEY.joinKey(P,a.PROP_KEY.BackgroundVideo,a.PROP_KEY.DefaultOverlay),j=a.PROP_KEY.joinKey(P,a.PROP_KEY.BackgroundVideo,a.PROP_KEY.ObjectFit),[y]=l.usePropSeparateDevice(f,c),[O]=l.usePropSeparateDevice(K,c),[v,g]=l.usePropSeparateDevice(m,c);return t.useEffect((()=>{y||O||!v||g(void 0)}),[y,O]),e.jsxs(e.Fragment,{children:[e.jsx(i.VideoConfig,{youtubeVideoPropKey:K,uploadVideoPropKey:f,platformPropKey:d}),e.jsx("div",{style:{height:"1rem",display:"block"}}),e.jsx(n.InputNumberConfigV2,{propKey:m,separateDevice:c,formItemProps:{label:r.t("Độ mờ lớp phủ nền")},inputNumberProps:{max:100,min:0,defaultValue:0,style:{width:90}},usePropOptions:{formatter:u.percentPropFormatter,parser:p.percentPropParser},unitProps:{defaultValue:o.UnitEnum.percent}}),e.jsx("div",{style:{height:"1rem",display:"block"}}),!!y&&e.jsx(s.SelectConfig,{separateDevice:c,propKey:j,formItemProps:{label:r.t("Object-fit"),layout:"horizontal"},selectProps:{defaultValue:"fill",allowClear:!1},options:[{label:r.t("Cover"),value:"cover"},{label:r.t("Fill"),value:"fill"},{label:r.t("Contain"),value:"contain"},{label:r.t("Scale down"),value:"scale-down"},{label:r.t("Unset"),value:"unset"}]})]})};


/***/ }),

/***/ 860936:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(429830),o=__webpack_require__(112373),t=__webpack_require__(661999),i=__webpack_require__(573466),n=__webpack_require__(551837),s=__webpack_require__(26308),u=__webpack_require__(234741),l=__webpack_require__(800302),c=__webpack_require__(451633);exports.BorderConfig=({propKey:d,separateDevice:p})=>{const[j,a]=s.usePropSeparateDevice(u.PROP_KEY.joinKey(d,u.PROP_KEY.BorderStyle),p),[m,x]=s.usePropSeparateDevice(u.PROP_KEY.joinKey(d,u.PROP_KEY.BorderWidth),p),C=e=>{if(e===j)return a(void 0),void x(void 0);a(e),x(1)};return e.jsxs(e.Fragment,{children:[e.jsx(t.CornerConfigV2,{propKey:d,separateDevice:p}),e.jsx(l.FormItem,{label:r.t("Kiểu viền"),children:e.jsxs(i.ButtonGroup,{children:[e.jsx(n.ButtonGroupItem,{onClick:()=>C("solid"),isActive:"solid"===j,children:e.jsx(o.LineOutlined,{style:{fontSize:18}})}),e.jsx(n.ButtonGroupItem,{onClick:()=>C("dashed"),isActive:"dashed"===j,children:e.jsx(o.DashOutlined,{style:{fontSize:18}})}),e.jsx(n.ButtonGroupItem,{onClick:()=>C("dotted"),isActive:"dotted"===j,children:e.jsx(o.SmallDashOutlined,{style:{fontSize:18}})})]})}),j&&e.jsxs(e.Fragment,{children:[e.jsx(l.FormItem,{label:r.t("Độ rộng (px)"),children:e.jsxs(i.ButtonGroup,{children:[e.jsx(n.ButtonGroupItem,{onClick:()=>x(1),isActive:1===m,children:"1"}),e.jsx(n.ButtonGroupItem,{onClick:()=>x(2),isActive:2===m,children:"2"}),e.jsx(n.ButtonGroupItem,{onClick:()=>x(3),isActive:3===m,children:"3"})]})}),e.jsx(c.ColorPickerConfigV3,{propKey:u.PROP_KEY.joinKey(d,u.PROP_KEY.BorderColor),formItemProps:{label:r.t("Màu viền")},separateDevice:p})]})]})};


/***/ }),

/***/ 573466:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261);function r(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const t=r(__webpack_require__(212951)).default.div`
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  border: 1px solid ${e=>e.theme.colorBorder};
  min-width: 130px;
  justify-content: center;
`;exports.ButtonGroup=({children:r,className:o})=>e.jsx(t,{className:o,children:r});


/***/ }),

/***/ 551837:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(610314);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const o=i(t).default(r.Button)`
  border: none;
  height: 32px;
  min-width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  path,
  rect {
    fill: ${e=>e.theme.colorText};
  }
  border-radius: 0;
  cursor: pointer;
  padding: 6px 8px;
  &.is-active {
    color: ${e=>e.theme.colorPrimary} !important;
    path,
    rect {
      fill: ${e=>e.theme.colorPrimary} !important;
    }
  }
`;exports.ButtonGroupItem=({isActive:t=!1,children:r,onClick:i,className:n})=>e.jsx(o,{type:"text",onClick:i,className:`${t?"is-active":""} ${n}`,children:r});


/***/ }),

/***/ 105915:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(891987),t=__webpack_require__(541054),o=__webpack_require__(800302);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}function i(e){if(e&&e.__esModule)return e;var r=Object.create(null);return e&&Object.keys(e).forEach((function(t){if("default"!==t){var o=Object.getOwnPropertyDescriptor(e,t);Object.defineProperty(r,t,o.get?o:{enumerable:!0,get:function(){return e[t]}})}})),r.default=e,Object.freeze(r)}var c=n(r),u=Object.defineProperty,s=Object.defineProperties,a=Object.getOwnPropertyDescriptors,l=Object.getOwnPropertySymbols,f=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,b=(e,r,t)=>r in e?u(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,d=(e,r)=>{for(var t in r||(r={}))f.call(r,t)&&b(e,t,r[t]);if(l)for(var t of l(r))p.call(r,t)&&b(e,t,r[t]);return e};const m=c.default.lazy((()=>Promise.resolve().then((function(){return i(__webpack_require__(680300))}))));exports.CodeEditorConfig=({propKey:n,formItemProps:u})=>{const[l,f]=t.useProp(n);return r.useEffect((()=>{(async()=>{await Promise.resolve().then((function(){return i(__webpack_require__(717431))})),await Promise.resolve().then((function(){return i(__webpack_require__(936097))}))})()}),[]),e.jsx(c.default.Suspense,{fallback:e.jsx("div",{}),children:e.jsx(o.FormItem,(p=d({},u),b={children:e.jsx(m,{value:l,onChange:e=>f(e),mode:"html",fontSize:14,height:"300px",width:"100%",setOptions:{showLineNumbers:!0,tabSize:2},highlightActiveLine:!0})},s(p,a(b))))});var p,b};


/***/ }),

/***/ 502253:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(429830),o=__webpack_require__(891987),t=__webpack_require__(899278),l=__webpack_require__(26308),a=__webpack_require__(234741),c=__webpack_require__(800302),i=Object.defineProperty,n=Object.defineProperties,s=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,u=Object.prototype.hasOwnProperty,P=Object.prototype.propertyIsEnumerable,d=(e,r,o)=>r in e?i(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,m=(e,r)=>{for(var o in r||(r={}))u.call(r,o)&&d(e,o,r[o]);if(p)for(var o of p(r))P.call(r,o)&&d(e,o,r[o]);return e};exports.ColorPickerConfig=({propKey:i,placeholder:p,formItemProps:u,colorPickerProps:P={},gradientPicker:d=!1,separateDevice:v})=>{var j,b;const[O,f]=l.usePropSeparateDevice(i,v),C=null==(j=null==i?void 0:i.replace)?void 0:j.call(i,a.PROP_KEY.BackgroundColor,a.PROP_KEY.Background),[h,y]=l.usePropSeparateDevice(C,v),[k,g]=o.useState(!1),q=(null==(b=null==i?void 0:i.includes)?void 0:b.call(i,a.PROP_KEY.BackgroundColor))&&(!!h||d);return o.useEffect((()=>{q&&O&&(f(void 0),h||y(O))}),[]),e.jsx(c.FormItem,(w=m({label:r.t("Chọn màu")},u),S={children:e.jsx(t.ColorPickerV2,m({color:q?h:O,onChangeColor:q?y:f,showModal:k,setShowModal:g,placeholder:p||r.t("Chọn màu"),hasGradientColor:d},P))},n(w,s(S))));var w,S};


/***/ }),

/***/ 387365:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(429830),o=__webpack_require__(891987),t=__webpack_require__(201747),l=__webpack_require__(26308),c=__webpack_require__(234741),a=__webpack_require__(800302),i=Object.defineProperty,n=Object.defineProperties,s=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,u=Object.prototype.hasOwnProperty,P=Object.prototype.propertyIsEnumerable,d=(e,r,o)=>r in e?i(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,m=(e,r)=>{for(var o in r||(r={}))u.call(r,o)&&d(e,o,r[o]);if(p)for(var o of p(r))P.call(r,o)&&d(e,o,r[o]);return e};exports.ColorPickerConfigV2=({propKey:i,placeholder:p,formItemProps:u,colorPickerProps:P={},gradientPicker:d=!1,separateDevice:v})=>{var j,b;const[f,O]=l.usePropSeparateDevice(i,v),C=null==(j=null==i?void 0:i.replace)?void 0:j.call(i,c.PROP_KEY.BackgroundColor,c.PROP_KEY.Background),[h,k]=l.usePropSeparateDevice(C,v),[y,g]=o.useState(!1),q=(null==(b=null==i?void 0:i.includes)?void 0:b.call(i,c.PROP_KEY.BackgroundColor))&&(!!h||d);return o.useEffect((()=>{q&&f&&(O(void 0),h||k(f))}),[]),e.jsx(a.FormItem,(w=m({label:r.t("Chọn màu")},u),S={"data-testid":"color-picker-config",children:e.jsx(t.ColorPickerV3,m({color:q?h:f,onChangeColor:q?k:O,showModal:y,setShowModal:g,placeholder:p||r.t("Chọn màu"),hasGradientColor:d},P))},n(w,s(S))));var w,S};


/***/ }),

/***/ 451633:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(429830),o=__webpack_require__(891987),t=__webpack_require__(387365),i=__webpack_require__(114800),l=__webpack_require__(313247),c=__webpack_require__(26308),n=__webpack_require__(234741),a=__webpack_require__(800302),s=Object.defineProperty,u=Object.defineProperties,p=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,P=Object.prototype.hasOwnProperty,C=Object.prototype.propertyIsEnumerable,j=(e,r,o)=>r in e?s(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,v=(e,r)=>{for(var o in r||(r={}))P.call(r,o)&&j(e,o,r[o]);if(d)for(var o of d(r))C.call(r,o)&&j(e,o,r[o]);return e};exports.ColorPickerConfigV3=s=>{var d,P;const{propKey:C,placeholder:j,formItemProps:f,colorPickerProps:m={},gradientPicker:b=!1,separateDevice:g,defaultColor:O}=s,{realDevice:k,editorConfig:y}=l.useBuilder(),h=!!(null==y?void 0:y.enableThemeConfig),[q,x]=c.usePropSeparateDevice(C,g),K=null==(d=null==C?void 0:C.replace)?void 0:d.call(C,n.PROP_KEY.BackgroundColor,n.PROP_KEY.Background),[w,D]=c.usePropSeparateDevice(K,g),[E,S]=o.useState(!1),V=(null==(P=null==C?void 0:C.includes)?void 0:P.call(C,n.PROP_KEY.BackgroundColor))&&(!!w||b);return o.useEffect((()=>{V&&q&&(x(void 0),w||D(q))}),[]),h?e.jsx(a.FormItem,(_=v({label:r.t("Chọn màu")},f),B={"data-testid":"color-picker-config",children:e.jsx(i.ColorPickerV4,v({color:void 0!==O?O:V?w:q,onChangeColor:V?D:x,showModal:E,setShowModal:S,placeholder:j||r.t("Chọn màu"),hasGradientColor:b,propKey:n.PROP_KEY.joinKey(g?k:"",V?K:C)},m))},u(_,p(B)))):e.jsx(t.ColorPickerConfigV2,v({},s));var _,B};


/***/ }),

/***/ 793698:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),i=__webpack_require__(429830),n=__webpack_require__(85097),t=__webpack_require__(212951),r=__webpack_require__(553226),o=__webpack_require__(234741),p=__webpack_require__(26308),u=__webpack_require__(541055),a=__webpack_require__(350461),P=__webpack_require__(301842);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const l=s(t).default.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;exports.SizeAttribute=({propKey:t=o.PROP_KEY.CommonStyle,configs:s={},separateDevice:K})=>{const{allowConfigWidth:c=!0,allowConfigHeight:x=!0,allowConfigMinMax:d=!1}=s,g=o.PROP_KEY.joinKey(t,o.PROP_KEY.WidthUnit),E=o.PROP_KEY.joinKey(t,o.PROP_KEY.HeightUnit),f=o.PROP_KEY.joinKey(t,o.PROP_KEY.MinWidthUnit),m=o.PROP_KEY.joinKey(t,o.PROP_KEY.MaxWidthUnit),h=o.PROP_KEY.joinKey(t,o.PROP_KEY.MinHeightUnit),j=o.PROP_KEY.joinKey(t,o.PROP_KEY.MaxHeightUnit),[y,R]=p.usePropSeparateDevice(g,K),[_=null,O]=p.usePropSeparateDevice(o.PROP_KEY.joinKey(t,o.PROP_KEY.Height),K),[Y,M]=p.usePropSeparateDevice(o.PROP_KEY.joinKey(t,o.PROP_KEY.Width),K);return e.jsxs(e.Fragment,{children:[c&&e.jsxs(e.Fragment,{children:[e.jsx(u.InputNumberConfigV2,{inputNumberProps:{controls:!1,min:0,max:y===n.UnitEnum.percent?100:1e3,style:{width:70}},propKey:o.PROP_KEY.joinKey(t,o.PROP_KEY.Width),unitProps:{propKey:g,defaultValue:n.UnitEnum.pixel,options:[n.UnitEnum.percent,n.UnitEnum.pixel],onChange:e=>{R(e),e===n.UnitEnum.percent&&Y>100&&M(100)}},formItemProps:{label:i.t("common.width")},separateDevice:K}),d&&e.jsxs(l,{children:[e.jsx(r.MinMaxInputConfig,{propKey:o.PROP_KEY.joinKey(t,o.PROP_KEY.MinWidth),separateDevice:K,inputNumberProps:{prefix:"Min",placeholder:"Auto"},unitProps:{propKey:f,defaultValue:n.UnitEnum.pixel}}),e.jsx(r.MinMaxInputConfig,{inputNumberProps:{prefix:"Max",placeholder:"Auto"},propKey:o.PROP_KEY.joinKey(t,o.PROP_KEY.MaxWidth),separateDevice:K,unitProps:{propKey:m,defaultValue:n.UnitEnum.pixel}})]})]}),x&&e.jsxs(e.Fragment,{children:[e.jsx(a.SwitchConfig,{formItemProps:{label:i.t("Chiều cao tự động")},switchProps:{checked:null===_,onChange:e=>{O(e?null:350)}}}),null!=_&&e.jsxs(e.Fragment,{children:[e.jsx(P.RangeSliderConfig,{sliderProps:{min:1,max:1e3},propKey:o.PROP_KEY.joinKey(t,o.PROP_KEY.Height),unitProps:{propKey:E,defaultValue:n.UnitEnum.pixel},separateDevice:K}),d&&e.jsxs(l,{children:[e.jsx(r.MinMaxInputConfig,{inputNumberProps:{prefix:"Min",placeholder:"Auto"},propKey:o.PROP_KEY.joinKey(t,o.PROP_KEY.MinHeight),separateDevice:K,unitProps:{propKey:h,defaultValue:n.UnitEnum.pixel}}),e.jsx(r.MinMaxInputConfig,{inputNumberProps:{prefix:"Max",placeholder:"Auto"},propKey:o.PROP_KEY.joinKey(t,o.PROP_KEY.MaxHeight),separateDevice:K,unitProps:{propKey:j,defaultValue:n.UnitEnum.pixel}})]})]})]})]})};


/***/ }),

/***/ 567522:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(429830),r=__webpack_require__(212951),i=__webpack_require__(959211),t=__webpack_require__(85097),n=__webpack_require__(610314),a=__webpack_require__(26308),P=__webpack_require__(234741),u=__webpack_require__(800302),p=__webpack_require__(301842);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const d=["common","detail"],l=100,R=s(r).default.div`
  padding: 0px 8px 8px 8px;
  .ant-row {
    width: 83% !important;
  }
`;exports.CornerConfig=({propKey:r,separateDevice:s})=>{const[K,m]=a.usePropSeparateDevice(P.PROP_KEY.joinKey(r,P.PROP_KEY.CornerType),s),[E,c]=a.usePropSeparateDevice(P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderTopLeftRadius),s),[y,O]=a.usePropSeparateDevice(P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderTopRightRadius),s),[_,Y]=a.usePropSeparateDevice(P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderBottomLeftRadius),s),[j,f]=a.usePropSeparateDevice(P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderBottomRightRadius),s),[g]=a.usePropSeparateDevice(P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderRadius),s),[,B]=a.usePropSeparateDevice(P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderRadiusUnit),s),[,x]=a.usePropSeparateDevice(P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderTopRightRadiusUnit),s),[,h]=a.usePropSeparateDevice(P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderTopLeftRadiusUnit),s),[,U]=a.usePropSeparateDevice(P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderBottomLeftRadiusUnit),s),[,S]=a.usePropSeparateDevice(P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderBottomRightRadiusUnit),s),v=o=>{switch(o){case"common":return e.jsx(i.BorderOutsideRegular,{fontSize:16});case"detail":return e.jsx(i.BorderTopBottomRegular,{fontSize:16})}},C=(e,o)=>{o(e)};return e.jsxs(e.Fragment,{children:[e.jsx(u.FormItem,{label:o.t("Bo góc"),layout:"horizontal",children:e.jsx(n.Radio.Group,{value:K,optionType:"button",buttonStyle:"solid",defaultValue:K||"common",children:d.map(((o,r)=>e.jsx(n.Radio,{onClick:()=>(e=>{"detail"!==e||E||y||_||j||(c(g),O(g),Y(g),f(g)),m(e)})(o),value:o,children:v(o)},r)))})}),"detail"===K?e.jsxs(R,{children:[e.jsx(p.RangeSliderConfig,{propKey:P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderTopLeftRadius),formItemProps:{label:o.t("Trái trên"),layout:"horizontal"},sliderProps:{min:0,max:l,defaultValue:0},unitProps:{defaultValue:t.UnitEnum.percent,propKey:P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderTopLeftRadiusUnit),options:[t.UnitEnum.percent,t.UnitEnum.pixel],onChange:e=>C(e,h)}}),e.jsx(p.RangeSliderConfig,{propKey:P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderTopRightRadius),formItemProps:{label:o.t("Phải trên"),layout:"horizontal"},sliderProps:{min:0,max:l,defaultValue:0},unitProps:{defaultValue:t.UnitEnum.percent,propKey:P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderTopRightRadiusUnit),options:[t.UnitEnum.percent,t.UnitEnum.pixel],onChange:e=>C(e,x)}}),e.jsx(p.RangeSliderConfig,{propKey:P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderBottomLeftRadius),formItemProps:{label:o.t("Trái dưới"),layout:"horizontal"},sliderProps:{min:0,max:l,defaultValue:0},unitProps:{defaultValue:t.UnitEnum.percent,propKey:P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderBottomLeftRadiusUnit),options:[t.UnitEnum.percent,t.UnitEnum.pixel],onChange:e=>C(e,U)}}),e.jsx(p.RangeSliderConfig,{propKey:P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderBottomRightRadius),formItemProps:{label:o.t("Phải dưới"),layout:"horizontal"},sliderProps:{min:0,max:l,defaultValue:0},unitProps:{defaultValue:t.UnitEnum.percent,propKey:P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderBottomRightRadiusUnit),options:[t.UnitEnum.percent,t.UnitEnum.pixel],onChange:e=>C(e,S)}})]}):e.jsx(p.RangeSliderConfig,{propKey:P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderRadius),sliderProps:{min:0,max:l,defaultValue:0},unitProps:{defaultValue:t.UnitEnum.percent,propKey:P.PROP_KEY.joinKey(r,P.PROP_KEY.BorderRadiusUnit),options:[t.UnitEnum.percent,t.UnitEnum.pixel],onChange:e=>C(e,B)}})]})};


/***/ }),

/***/ 661999:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),i=__webpack_require__(429830),r=__webpack_require__(212951),t=__webpack_require__(959211),n=__webpack_require__(85097),o=__webpack_require__(610314),a=__webpack_require__(143599),p=__webpack_require__(26308),u=__webpack_require__(234741),s=__webpack_require__(800302),d=__webpack_require__(301842),P=__webpack_require__(541055);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var m=l(r);const R=["common","detail"],K=m.default.div`
  padding: 0px 8px 8px 8px;
  display: grid;
  grid-template-columns: repeat(2, calc((100% - 8px) / 2));
  gap: 8px;
  .ant-row {
    width: 100% !important;
  }
  .ant-input-number {
    background-color: #f5f5f5;
  }
  .ant-input-number-affix-wrapper {
    border: none !important;
  }
  .ant-input-number-handler-wrap {
    display: none !important;
  }
`,c=m.default(a.Icon)`
  font-size: 12px;
  margin-right: 6px;
`,x=m.default(P.InputNumberConfigV2)`
  background-color: #f5f5f5;
  width: 100%;
`;exports.CornerConfigV2=({propKey:r,separateDevice:a})=>{const[P,l]=p.usePropSeparateDevice(u.PROP_KEY.joinKey(r,u.PROP_KEY.CornerType),a),[m,E]=p.usePropSeparateDevice(u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderTopLeftRadius),a),[f,j]=p.usePropSeparateDevice(u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderTopRightRadius),a),[O,y]=p.usePropSeparateDevice(u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderBottomLeftRadius),a),[_,Y]=p.usePropSeparateDevice(u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderBottomRightRadius),a),[g]=p.usePropSeparateDevice(u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderRadius),a),[U,B]=p.usePropSeparateDevice(u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderRadiusUnit),a),[v,h]=p.usePropSeparateDevice(u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderTopRightRadiusUnit),a),[b,D]=p.usePropSeparateDevice(u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderTopLeftRadiusUnit),a),[S,q]=p.usePropSeparateDevice(u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderBottomLeftRadiusUnit),a),[C,V]=p.usePropSeparateDevice(u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderBottomRightRadiusUnit),a),T=i=>{switch(i){case"common":return e.jsx(t.BorderOutsideRegular,{fontSize:16});case"detail":return e.jsx(t.BorderTopBottomRegular,{fontSize:16})}};return e.jsxs(e.Fragment,{children:[e.jsx(s.FormItem,{label:i.t("Bo góc"),layout:"horizontal",children:e.jsx(o.Radio.Group,{value:P,optionType:"button",buttonStyle:"solid",defaultValue:P||"common",children:R.map(((i,r)=>e.jsx(o.Radio,{onClick:()=>(e=>{"detail"!==e||m||f||O||_||(E(g),j(g),y(g),Y(g)),(b!==n.UnitEnum.pixel||v!==n.UnitEnum.pixel&&S!==n.UnitEnum.pixel||C!==n.UnitEnum.pixel)&&(D(n.UnitEnum.pixel),h(n.UnitEnum.pixel),q(n.UnitEnum.pixel),V(n.UnitEnum.pixel)),l(e)})(i),value:i,children:T(i)},r)))})}),"detail"===P?e.jsxs(K,{children:[e.jsx(x,{propKey:u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderTopLeftRadius),inputNumberProps:{prefix:e.jsx(c,{name:"RadiusUpLeftOutlined"}),min:0,max:999},unitProps:{defaultValue:n.UnitEnum.pixel},displayUnit:!1,separateDevice:a}),e.jsx(x,{propKey:u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderTopRightRadius),inputNumberProps:{prefix:e.jsx(c,{name:"RadiusUpRightOutlined"}),min:0,max:999},unitProps:{defaultValue:n.UnitEnum.pixel},displayUnit:!1,separateDevice:a}),e.jsx(x,{propKey:u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderBottomLeftRadius),inputNumberProps:{prefix:e.jsx(c,{name:"RadiusBottomLeftOutlined"}),min:0,max:999},unitProps:{defaultValue:n.UnitEnum.pixel},displayUnit:!1,separateDevice:a}),e.jsx(x,{propKey:u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderBottomRightRadius),inputNumberProps:{prefix:e.jsx(c,{name:"RadiusBottomRightOutlined"}),min:0,max:999},unitProps:{defaultValue:n.UnitEnum.pixel},displayUnit:!1,separateDevice:a})]}):e.jsx(d.RangeSliderConfig,{propKey:u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderRadius),sliderProps:{min:0,max:999,defaultValue:0},unitProps:{defaultValue:n.UnitEnum.pixel,propKey:u.PROP_KEY.joinKey(r,u.PROP_KEY.BorderRadiusUnit),options:U===n.UnitEnum.percent?[n.UnitEnum.percent,n.UnitEnum.pixel]:[n.UnitEnum.pixel],onChange:e=>B(e)},separateDevice:a})]})};


/***/ }),

/***/ 38680:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(610314),o=__webpack_require__(26308),i=__webpack_require__(800302);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var n=a(r),l=Object.defineProperty,p=Object.defineProperties,u=Object.getOwnPropertyDescriptors,s=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,d=Object.prototype.propertyIsEnumerable,m=(e,r,t)=>r in e?l(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;const b=n.default(t.Radio)`
  span {
    vertical-align: middle;
  }
`;exports.CustomRadioButtonConfig=r=>{const{propKey:a,options:n,formItemProps:l,separateDevice:v,allowClear:f}=r,[j,y]=o.usePropSeparateDevice(a,v);return e.jsx(i.FormItem,(O=((e,r)=>{for(var t in r||(r={}))c.call(r,t)&&m(e,t,r[t]);if(s)for(var t of s(r))d.call(r,t)&&m(e,t,r[t]);return e})({},l),P={children:e.jsx(t.Radio.Group,{value:j,optionType:"button",buttonStyle:"solid",children:null==n?void 0:n.map((({value:r,label:t},o)=>e.jsx(b,{onClick:()=>(e=>{y(e===j&&f?void 0:e)})(r),value:r,children:t},o)))})},p(O,u(P))));var O,P};


/***/ }),

/***/ 618063:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(610314),l=__webpack_require__(26308),o=__webpack_require__(800302);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const i=n(t).default(r.Button)((({type:e})=>`\n    height: unset;\n    margin-bottom: 0.5em;\n    padding-top: 1em;\n    padding-bottom: 1em;\n  \n    ${"default"===e?"color: #82868B;":""}\n  `));exports.CustomRadioConfig=({propKey:t,seperateDevice:n,formItemProps:a,options:u,defaultValue:s,handleAfterSelect:d})=>{const[c=s,p]=l.usePropSeparateDevice(t,n);return e.jsx(o.FormItem,{layout:"vertical",label:null==a?void 0:a.label,children:e.jsx(r.Row,{gutter:16,children:u.map(((t,l)=>e.jsxs(r.Col,{span:Math.round(24/u.length),children:[e.jsx(i,{block:!0,type:c===t.value?"primary":"default",onClick:()=>{p(t.value),null==d||d(t.value)},children:t.children}),!!(null==t?void 0:t.label)&&e.jsx("div",{style:{textAlign:"center"},children:null==t?void 0:t.label})]},l)))})})};


/***/ }),

/***/ 431115:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(772139),t=__webpack_require__(610314),o=__webpack_require__(541054),a=__webpack_require__(800302);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=n(r),s=Object.defineProperty,p=Object.defineProperties,u=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,l=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,j=(e,r,t)=>r in e?s(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,m=(e,r)=>{for(var t in r||(r={}))l.call(r,t)&&j(e,t,r[t]);if(c)for(var t of c(r))f.call(r,t)&&j(e,t,r[t]);return e};exports.DatePickerConfig=({propKey:r,dateTimePickerProps:n,formItemProps:s})=>{const[c,l]=o.useProp(r);return e.jsx(a.FormItem,(f=m({},s),j={children:e.jsx(t.DatePicker,m({allowClear:!1,value:i.default(c),onChange:e=>{l(e.toISOString())}},n))},p(f,u(j))));var f,j};


/***/ }),

/***/ 290223:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(959211),o=__webpack_require__(610314),i=__webpack_require__(26308),n=__webpack_require__(800302);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=a(r),s=Object.defineProperty,c=Object.defineProperties,u=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,b=(e,r,t)=>r in e?s(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;const j=l.default(o.Radio)`
  span {
    vertical-align: middle;
  }
`;exports.DirectionConfig=r=>{const{propKey:a,buttonGroupProps:l,formItemProps:s,separateDevice:m,allowClear:v=!1}=r,{listDirections:y=["vertical","horizontal"]}=l||{},[O,P]=i.usePropSeparateDevice(a,m),h=r=>{switch(r){case"horizontal":return e.jsx(t.CenterVerticalFilled,{fontSize:16});case"vertical":return e.jsx(t.CenterHorizontalFilled,{fontSize:16})}};return e.jsx(n.FormItem,(x=((e,r)=>{for(var t in r||(r={}))d.call(r,t)&&b(e,t,r[t]);if(p)for(var t of p(r))f.call(r,t)&&b(e,t,r[t]);return e})({},s),q={children:e.jsx(o.Radio.Group,{value:O,optionType:"button",buttonStyle:"solid",children:y.map(((r,t)=>e.jsx(j,{onClick:()=>(e=>{P(e===O&&v?void 0:e)})(r),value:r,children:h(r)},t)))})},c(x,u(q))));var x,q};


/***/ }),

/***/ 373654:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(112373),r=__webpack_require__(212951),i=__webpack_require__(610314),o=__webpack_require__(891987),n=__webpack_require__(429830),a=__webpack_require__(85097),l=__webpack_require__(449130),s=__webpack_require__(26308),c=__webpack_require__(313247),u=__webpack_require__(800302);function d(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var p=d(r),m=Object.defineProperty,f=Object.defineProperties,j=Object.getOwnPropertyDescriptors,h=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,v=Object.prototype.propertyIsEnumerable,_=(e,t,r)=>t in e?m(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,b=(e,t)=>{for(var r in t||(t={}))y.call(t,r)&&_(e,r,t[r]);if(h)for(var r of h(t))v.call(t,r)&&_(e,r,t[r]);return e};const x=p.default(i.Upload)`
  .ant-upload-select,
  .ant-upload-list-item-container {
    width: 100% !important;
  }

  a {
    color: rgba(0, 0, 0, 0.88);
  }
`,g=p.default(i.Divider)`
  justify-content: center;
  &::before,
  &::after {
    width: 25% !important;
  }
`;exports.DocumentConfig=({propKey:r,separateDevice:d,layout:p="vertical",placeholder:m=n.t("document_viewer.upload_file"),acceptTypes:h=Object.values(a.DOCUMENT_TYPE)})=>{const[y,v]=o.useState([]),[_,O]=o.useState(!1),[w,F]=o.useState(!1),[q,P]=s.usePropSeparateDevice(r,d),[E]=i.Form.useForm();o.useEffect((()=>{v(q?[{url:q,uid:q,name:l.getFileName(q)}]:[])}),[q]);const S=(e,t)=>URL.createObjectURL(e),{uploadFileHandler:I=S}=c.useBuilder(),D={beforeUpload:l.beforeUploadDocument(h),customRequest:async e=>{const{file:t,onSuccess:r,onError:i}=e;try{O(!0);const e=await I(t,"doc");P(e),r(t)}catch(e){i(e,t)}finally{O(!1)}},listType:q?"picture":"picture-card",maxCount:1,multiple:!1,fileList:y,onRemove:()=>{P("")},accept:Object.keys(a.MAPPING_EXTENSION_MIME_TYPE).filter((e=>!h||(null==h?void 0:h.includes(e)))).map((e=>`.${e}`)).join(", ")};return e.jsx(e.Fragment,{children:e.jsx(u.FormItem,{layout:p,label:n.t("document_viewer.file"),children:e.jsxs(i.Spin,{spinning:_,children:[e.jsx("div",{style:{position:"relative",width:"vertical"===p?"100%":"auto"},children:e.jsx("div",{style:{position:"relative"},children:e.jsx(x,(U=b({},D),T={children:q?null:e.jsx("div",{style:{width:"100%"},children:_?e.jsx(t.LoadingOutlined,{}):e.jsxs(e.Fragment,{children:[e.jsx(t.UploadOutlined,{}),e.jsx("div",{style:{marginTop:4},children:m})]})})},f(U,j(T))))})}),!q&&e.jsxs(e.Fragment,{children:[e.jsx(g,{plain:!0,children:n.t("hoặc")}),e.jsx(i.Form,{form:E,onFinish:async e=>{var t;const{url:r}=e;try{F(!0);const e=await I(r,"docUrl");if(!(null==(t=new RegExp(`\\.(${h.join("|")})$`,"i"))?void 0:t.test(r)))throw i.notification.error({message:n.t("upload.invalid_file_format")}),Error(n.t("upload.invalid_file_format"));P(e)}catch(e){}finally{E.resetFields(),F(!1)}},children:e.jsx(i.Form.Item,{name:"url",rules:[{required:!0,message:n.t("common.url_can_not_be_empty")},{type:"url",message:n.t("common.invalid_url")},{pattern:/^[a-zA-Z0-9-._~:/?#@!$&'()*+,;=%]*$/,message:n.t("url_not_support_special_characters")}],children:e.jsx(i.Input.Search,{placeholder:n.t("common.use_url"),enterButton:n.t("use"),loading:w,onSearch:()=>E.submit()})})})]})]})})});var U,T};


/***/ }),

/***/ 449130:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(610314),r=__webpack_require__(429830),i=__webpack_require__(85097);exports.beforeUploadDocument=t=>o=>{var n;return(null==t?void 0:t.map((e=>i.MAPPING_EXTENSION_MIME_TYPE[e]))).includes(o.type)?!!(o.size<20971520)||(e.notification.error({message:r.t("upload.file_size_limit")}),!1):(e.notification.error({message:`${r.t("document_viewer.file_format_restriction")} ${null==(n=null==t?void 0:t.map((e=>null==e?void 0:e.toUpperCase())))?void 0:n.join(", ")}!`}),!1)},exports.getFileName=e=>e.substring(e.lastIndexOf("/")+1);


/***/ }),

/***/ 921890:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(891987),n=__webpack_require__(610314),r=__webpack_require__(212951),o=__webpack_require__(959211),a=__webpack_require__(610796),l=__webpack_require__(85097);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=i(r),c=Object.defineProperty,u=Object.defineProperties,d=Object.getOwnPropertyDescriptors,m=Object.getOwnPropertySymbols,f=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,y=(e,t,n)=>t in e?c(e,t,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[t]=n;const b=s.default(n.Modal)("  \n  .ant-modal-header {\n    cursor: grab;\n    user-select: none;\n  }\n\n  .ant-modal-header:active {\n    cursor: grabbing;\n  }\n");exports.DraggableModal=n=>{var r=n,{width:i=500,children:s,footer:c,setModalPosition:v,modalPosition:p={x:0,y:0},title:x="Draggable Modal",offset:h={x:4,y:4},onCancel:C,onClickOutside:O}=r,M=((e,t)=>{var n={};for(var r in e)f.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&m)for(var r of m(e))t.indexOf(r)<0&&g.call(e,r)&&(n[r]=e[r]);return n})(r,["width","children","footer","setModalPosition","modalPosition","title","offset","onCancel","onClickOutside"]);const{document:k,window:E}=a.useFrame(),j=t.useRef(null),[w,P]=t.useState({x:0,y:0}),[D,R]=t.useState(!1),q=t.useRef(null),L=t.useCallback((e=>{if(!e.target.closest(".ant-modal-header"))return;e.preventDefault(),e.stopPropagation();const t=j.current;if(!t)return;const n=t.getBoundingClientRect();P({x:e.clientX-n.left,y:e.clientY-n.top}),R(!0)}),[]),S=t.useCallback((e=>{const t=j.current;D&&t&&(e.preventDefault(),e.stopPropagation(),requestAnimationFrame((()=>{const n=t.getBoundingClientRect(),r=e.clientX-w.x,o=e.clientY-w.y,a=E.innerWidth-n.width,l=E.innerHeight-n.height;v((e=>{const t=Math.max(0,Math.min(r,a-h.x)),n=Math.max(0,Math.min(o,l-h.y));return e.x===t&&e.y===n?e:{x:t,y:n}}))})))}),[D,w.x,w.y,E.innerWidth,E.innerHeight,v,h.x,h.y]),I=t.useCallback((()=>{R(!1)}),[]),B=t.useCallback((e=>{if(D)return;const t=j.current;t&&!t.contains(e.target)&&O&&O(e)}),[D,O]);t.useEffect((()=>{var e;const t=null==(e=null==document?void 0:document.getElementById(l.TEMPI_MAIN_IFRAME))?void 0:e.contentDocument;return null==t||t.addEventListener("click",B),null==document||document.addEventListener("click",B),()=>{null==t||t.removeEventListener("click",B),null==document||document.removeEventListener("click",B)}}),[B]),t.useEffect((()=>{if(D)return k.addEventListener("mousemove",S),k.addEventListener("mouseup",I),k.body.style.userSelect="none",k.body.style.cursor="grabbing",()=>{k.removeEventListener("mousemove",S),k.removeEventListener("mouseup",I),k.body.style.userSelect="",k.body.style.cursor=""}}),[D,k,S,I]);const _={top:p.y,left:p.x,paddingBottom:0,margin:0},z=e.jsxs("div",{ref:q,onMouseDown:L,className:"cursor-grab active:cursor-grabbing select-none flex items-center",style:{padding:"0",margin:"0",userSelect:"none"},children:[e.jsx(o.ReOrderDotsVerticalRegular,{style:{transform:"rotate(90deg)",marginRight:4},fontSize:24}),x]});return e.jsx(b,(A=((e,t)=>{for(var n in t||(t={}))f.call(t,n)&&y(e,n,t[n]);if(m)for(var n of m(t))g.call(t,n)&&y(e,n,t[n]);return e})({zIndex:1080,onCancel:C,title:z,style:_,width:i,centered:!1,mask:!0,maskClosable:!0,destroyOnClose:!0,maskStyle:{backgroundColor:"transparent",zIndex:-1},modalRender:t=>e.jsx("div",{ref:j,onMouseDown:L,style:{cursor:"default"},children:t}),getContainer:()=>k.body,footer:c},M),u(A,d({wrapClassName:D?"":"draggable-modal",children:s}))));var A};


/***/ }),

/***/ 246020:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),i=__webpack_require__(429830),r=__webpack_require__(610314),t=__webpack_require__(714816),n=__webpack_require__(468569),o=__webpack_require__(234741);const{Panel:s}=r.Collapse;exports.EffectAttributes=({propKey:a=o.PROP_KEY.CommonStyle,separateDevice:c=!1})=>e.jsxs(r.Collapse,{defaultActiveKey:"AnimationEffect",expandIconPosition:"end",bordered:!1,children:[e.jsx(s,{header:i.t("Hiệu ứng khi cuộn tới"),children:e.jsx(t.AnimationConfig,{propKey:a,separateDevice:c})},"AnimationEffect"),e.jsx(s,{header:i.t("Hiệu ứng khi trỏ chuột"),children:e.jsx(n.HoverConfig,{propKey:a,separateDevice:c})},"HoverEffect")]});


/***/ }),

/***/ 883906:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(429830),o=__webpack_require__(891987),i=__webpack_require__(610314),n=__webpack_require__(85097),r=__webpack_require__(610796),s=__webpack_require__(793709),a=__webpack_require__(246685),l=__webpack_require__(283311),p=__webpack_require__(327590),c=__webpack_require__(359607),P=__webpack_require__(350461),u=__webpack_require__(313247),m=__webpack_require__(234741),g=__webpack_require__(26308),y=__webpack_require__(552884),f=__webpack_require__(828426),K=__webpack_require__(728567),d=__webpack_require__(514824),h=Object.defineProperty,E=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,O=Object.prototype.propertyIsEnumerable,j=(e,t,o)=>t in e?h(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o,v=(e,t)=>{for(var o in t||(t={}))b.call(t,o)&&j(e,o,t[o]);if(E)for(var o of E(t))O.call(t,o)&&j(e,o,t[o]);return e};const _=({propKey:i,separateDevice:r,listOptions:a,label:l,selectProps:h})=>{const{featureFlags:E}=n.useStore(),b=null==E?void 0:E.flagPB6119,{popupListSelection:O}=p.usePopupList(),{pageListInWebsiteSelection:j}=u.useBuilder(),[_,C]=o.useState(""),R=m.PROP_KEY.joinKey(i,m.PROP_KEY.Event,m.PROP_KEY.EventType),Y=m.PROP_KEY.joinKey(i,m.PROP_KEY.Event,m.PROP_KEY.Link),x=m.PROP_KEY.joinKey(i,m.PROP_KEY.Event,m.PROP_KEY.Email),I=m.PROP_KEY.joinKey(i,m.PROP_KEY.Event,m.PROP_KEY.Phone),w=m.PROP_KEY.joinKey(i,m.PROP_KEY.Event,m.PROP_KEY.InPage),S=m.PROP_KEY.joinKey(i,m.PROP_KEY.Event,m.PROP_KEY.TogglePopup),T=m.PROP_KEY.joinKey(i,m.PROP_KEY.Event,m.PROP_KEY.TogglePopupList),k=m.PROP_KEY.joinKey(i,m.PROP_KEY.Event,m.PROP_KEY.OpenPageOfWebsite),D=m.PROP_KEY.joinKey(i,m.PROP_KEY.Event,m.PROP_KEY.OpenArticleOfWebsite),q=m.PROP_KEY.joinKey(i,m.PROP_KEY.Event,m.PROP_KEY.CopyToClipboard),[N,B]=g.usePropSeparateDevice(R,r),[M]=g.usePropSeparateDevice(I,r),[L]=g.usePropSeparateDevice(x,r),[A,W]=g.usePropSeparateDevice(m.PROP_KEY.joinKey(i,m.PROP_KEY.Event,m.PROP_KEY.CopyToClipboard),r),{nodes:F}=y.useEditor((e=>({nodes:e.nodes}))),z=o.useMemo((()=>[...new Set(Object.keys(F).map((e=>F[e].data.props.id)))].filter((e=>e)).map((e=>({label:e,value:e})))),[N]);return o.useEffect((()=>{var e,o;"phone"===N&&(e=M)&&(n.PATTERN_VALIDATION.phone.test(e)?C(""):C(t.t("Số điện thoại chưa đúng định dạng"))),"email"===N&&(o=L)&&(n.PATTERN_VALIDATION.email.test(o)?C(""):C(t.t("Nhập email định dạng abc@gmai.com")))}),[N,M,L]),o.useEffect((()=>{"copyToClipboard"===N&&W(v({textCopy:t.t("text_to_copy"),notificationMessage:t.t("notification_message")},A))}),[N]),e.jsxs(e.Fragment,{children:[e.jsx(f.SelectConfig,v({options:(()=>{const e=[{label:t.t("Mở liên kết"),value:"link"},...b?[{label:t.t("open_article_in_website"),value:"openArticleOfWebsite"}]:[],{label:t.t("Cuộn trong trang"),value:"inPage"},{label:"Email",value:"email"},{label:t.t("Số điện thoại"),value:"phone"},{label:t.t("Mở popup"),value:"openPopup"},{label:t.t("Đóng popup"),value:"closePopupList"},{label:t.t("copy_to_clipboard"),value:"copyToClipboard"}];return(null==j?void 0:j.length)&&e.unshift({label:t.t("Mở trang trong website"),value:"openPageOfWebsite"}),a?e.filter((({value:e})=>a.includes(e))):e})(),formItemProps:{label:l||t.t("Loại sự kiện"),style:{marginBottom:"0.5rem"}},selectProps:{listHeight:350,placeholder:t.t("Chọn sự kiện"),style:{width:"100%"},onChange:e=>{B(e),C("")},value:N}},h)),(o=>{switch(o){case"link":return e.jsxs(e.Fragment,{children:[e.jsx(K.InputConfig,{separateDevice:r,formItemProps:{label:t.t("Nhập URL"),style:{marginBottom:"0.5rem"}},inputProps:{placeholder:t.t("Nhập URL"),style:{width:"100%"}},propKey:Y+".href"}),e.jsx(P.SwitchConfig,{separateDevice:r,formItemProps:{label:t.t("Mở trong thẻ mới"),layout:"horizontal",style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"0.5rem"}},propKey:Y+".openNewTab"}),e.jsx(P.SwitchConfig,{separateDevice:r,formItemProps:{label:t.t("Liên kết nofollow"),layout:"horizontal",style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"0.5rem"}},propKey:Y+".nofollow"})]});case"inPage":return e.jsxs(e.Fragment,{children:[e.jsx(f.SelectConfig,v({separateDevice:r,formItemProps:{label:t.t("Phần tử"),style:{marginBottom:"0.5rem"}},selectProps:{placeholder:t.t("Mặc định"),style:{width:"100%"},popupMatchSelectWidth:!1},options:z,propKey:w},h)),e.jsx(d.InputNumberConfig,{separateDevice:r,propKey:m.PROP_KEY.joinKey(m.PROP_KEY.Event,m.PROP_KEY.SectionMarginTop),formItemProps:{label:"Section margin-top",style:{marginBottom:"0.5rem"}},unitProps:{defaultValue:n.UnitEnum.pixel},inputNumberProps:{style:{width:"100%"}}})]});case"email":return e.jsx(K.InputConfig,{separateDevice:r,formItemProps:{label:"Email",warning:_,layout:"vertical",style:{marginBottom:"0.5rem"}},inputProps:{style:{width:"100%"},placeholder:t.t("Nhập email")},propKey:x});case"phone":return e.jsx(K.InputConfig,{separateDevice:r,formItemProps:{label:t.t("Số điện thoại"),warning:_,layout:"vertical",style:{marginBottom:"0.5rem"}},inputProps:{placeholder:t.t("Nhập số điện thoại có 10 chữ số"),style:{width:"100%"}},propKey:I});case"openPopup":return e.jsx(s.SelectPopupConfig,{separateDevice:r,label:t.t("Mở popup"),options:O,propKey:S});case"closePopupList":return e.jsx(s.SelectPopupConfig,{separateDevice:r,label:t.t("Đóng popup"),options:O,propKey:T});case"openPageOfWebsite":return e.jsxs(e.Fragment,{children:[e.jsx(f.SelectConfig,v({separateDevice:r,formItemProps:{style:{marginBottom:"0.5rem"}},selectProps:{placeholder:t.t("Mặc định"),style:{width:"100%"},popupMatchSelectWidth:!1,fieldNames:{value:"id"}},options:j,propKey:m.PROP_KEY.joinKey(k,m.PROP_KEY.PageId)},h)),e.jsx(P.SwitchConfig,{separateDevice:r,formItemProps:{label:t.t("Mở trong thẻ mới"),layout:"horizontal",style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"0.5rem"}},propKey:m.PROP_KEY.joinKey(k,m.PROP_KEY.OpenNewTab)})]});case"openArticleOfWebsite":return e.jsxs(e.Fragment,{children:[e.jsx(c.SelectArticleWebsite,{propKey:i}),e.jsx(P.SwitchConfig,{separateDevice:r,formItemProps:{label:t.t("Mở trong thẻ mới"),layout:"horizontal",style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"0.5rem"}},propKey:m.PROP_KEY.joinKey(D,m.PROP_KEY.OpenNewTab)})]});case"copyToClipboard":return e.jsxs(e.Fragment,{children:[e.jsx(K.InputConfig,{separateDevice:r,formItemProps:{label:t.t("text_to_copy"),warning:_,layout:"vertical",style:{marginBottom:"0.5rem"}},inputProps:{style:{width:"100%"},placeholder:t.t("text_to_copy")},propKey:m.PROP_KEY.joinKey(q,m.PROP_KEY.TextCopy)}),e.jsx(K.InputConfig,{separateDevice:r,formItemProps:{label:t.t("notification_message"),warning:_,layout:"vertical",style:{marginBottom:"0.5rem"}},inputProps:{style:{width:"100%"},placeholder:t.t("notification_message")},propKey:m.PROP_KEY.joinKey(q,m.PROP_KEY.NotificationMessage)})]})}})(N)]})};exports.EventClickConfig=_,exports.EventConfig=({propKey:n,visible:s,setVisible:p,separateDevice:c,listOptions:P,zIndex:g=1080,selectProps:y})=>{const{relatedNodeId:f,enableTekoTracking:K}=u.useBuilder(),{document:d}=r.useFrame();o.useEffect((()=>{(null==f?void 0:f.popupId)&&p(!0)}),[]);const h=()=>{p(!1)};return e.jsx(i.Modal,{closable:!1,zIndex:g,open:s,onCancel:h,title:t.t("Cài đặt sự kiện nhấp chuột"),destroyOnClose:!0,width:450,footer:[e.jsx(i.Button,{type:"primary",shape:"round",onClick:h,children:t.t("Đóng")})],getContainer:()=>(null==d?void 0:d.body)||(null==document?void 0:document.body),children:e.jsx(i.Tabs,{items:[{label:t.t("Sự kiện"),key:"1",children:e.jsx(_,{propKey:n,separateDevice:c,listOptions:P,selectProps:y})},{label:t.t("Chuyển đổi (Tracking)"),key:"2",children:e.jsx(a.TrackingConfig,{separateDevice:c,config:"event",propKey:m.PROP_KEY.joinKey(n,m.PROP_KEY.Event)})},K&&{label:"Teko tracking",key:"3",children:e.jsx(l.TekoTrackingConfig,{propKey:m.PROP_KEY.joinKey(n,m.PROP_KEY.Event)})}]})})};


/***/ }),

/***/ 793709:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(429830),t=__webpack_require__(610314),o=__webpack_require__(212951),p=__webpack_require__(547929),i=__webpack_require__(891987),l=__webpack_require__(26308),n=__webpack_require__(313247),d=__webpack_require__(828426);function c(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=c(o),a=Object.defineProperty,u=Object.defineProperties,f=Object.getOwnPropertyDescriptors,m=Object.getOwnPropertySymbols,v=Object.prototype.hasOwnProperty,y=Object.prototype.propertyIsEnumerable,j=(e,r,t)=>r in e?a(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,P=(e,r)=>{for(var t in r||(r={}))v.call(r,t)&&j(e,t,r[t]);if(m)for(var t of m(r))y.call(r,t)&&j(e,t,r[t]);return e};const b=s.default.div`
  color: #7367f0;
  padding: 5px;
  width: 100%;
  cursor: pointer;
`;exports.SelectPopupConfig=o=>{const c=o,{label:s,placeholder:a,itemIndex:j,device:h,selectProps:x}=c,I=((e,r)=>{var t={};for(var o in e)v.call(e,o)&&r.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&m)for(var o of m(e))r.indexOf(o)<0&&y.call(e,o)&&(t[o]=e[o]);return t})(c,["label","placeholder","itemIndex","device","selectProps"]),[,g]=l.usePropSeparateDevice(I.propKey,I.separateDevice,I.usePropOptions),{setShowModalSelectPopup:O,relatedNodeId:S,setRelatedNodeId:q}=n.useBuilder(),{id:w}=p.useNode(),E=()=>{O(!0),q({componentId:w,propKey:I.propKey,itemIndex:j,device:h})};return i.useEffect((()=>{(null==S?void 0:S.popupId)&&(null==S?void 0:S.propKey)===I.propKey&&(g(S.popupId),q((e=>{return(null==e?void 0:e.componentId)&&(r=P({},e),u(r,f({popupId:void 0})));var r})))}),[null==S?void 0:S.popupId]),e.jsx(d.SelectConfig,P({selectProps:P({placeholder:a||r.t("Mặc định"),style:{width:"100%"},popupMatchSelectWidth:!1,showSearch:!0,optionFilterProp:"label",notFoundContent:I.options.length?e.jsx(t.Empty,{style:{margin:8},image:t.Empty.PRESENTED_IMAGE_SIMPLE}):e.jsx(e.Fragment,{}),dropdownRender:t=>e.jsxs(e.Fragment,{children:[t,e.jsxs(b,{onClick:E,children:["+"," ",r.t("Thêm mới popup")]})]})},x),formItemProps:{label:s,style:{marginBottom:"0.5rem"}}},I))};


/***/ }),

/***/ 468569:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(429830),o=__webpack_require__(85097),i=__webpack_require__(451633),n=__webpack_require__(541055),t=__webpack_require__(234741);exports.HoverConfig=({propKey:p=t.PROP_KEY.CommonStyle,separateDevice:P})=>e.jsxs(e.Fragment,{children:[e.jsx(i.ColorPickerConfigV3,{separateDevice:P,propKey:t.PROP_KEY.joinKey(p,t.PROP_KEY.HoverBorderColor),formItemProps:{label:r.t("Màu viền")}}),e.jsx(i.ColorPickerConfigV3,{separateDevice:P,propKey:t.PROP_KEY.joinKey(p,t.PROP_KEY.HoverBackgroundColor),formItemProps:{label:r.t("Màu nền")},gradientPicker:!0}),e.jsx(i.ColorPickerConfigV3,{separateDevice:P,propKey:t.PROP_KEY.joinKey(p,t.PROP_KEY.HoverColor),formItemProps:{label:r.t("Màu chữ")}}),e.jsx(n.InputNumberConfigV2,{separateDevice:P,propKey:t.PROP_KEY.joinKey(p,t.PROP_KEY.HoverTransparent),formItemProps:{label:r.t("Trong suốt")},inputNumberProps:{min:0,max:100,placeholder:"100"},unitProps:{defaultValue:o.UnitEnum.percent}}),e.jsx(n.InputNumberConfigV2,{separateDevice:P,propKey:t.PROP_KEY.joinKey(p,t.PROP_KEY.HoverZoom),formItemProps:{label:r.t("Phóng to")},inputNumberProps:{min:0,placeholder:"100"},unitProps:{defaultValue:o.UnitEnum.percent}})]});


/***/ }),

/***/ 770867:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(429830),t=__webpack_require__(212951),o=__webpack_require__(85097),i=__webpack_require__(610314),a=__webpack_require__(891987),n=__webpack_require__(342022),l=__webpack_require__(660512),s=__webpack_require__(495410),p=__webpack_require__(728567),u=__webpack_require__(726142),c=__webpack_require__(26308),d=__webpack_require__(313247),g=__webpack_require__(800302);function m(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const h=m(t).default(i.Divider)`
  justify-content: center;
  &::before,
  &::after {
    width: 25% !important;
  }
`;exports.ImageConfig=({propKey:t,widthPropKey:m,heightPropKey:f,layout:j="horizontal",placeholderImage:y,altPropKey:x,labels:I={},separateDevice:v,allowUploadImageByUrl:w=!0,allowCropImage:C,cropProps:P,additionalConfig:q,clearValue:F})=>{var S;const[b]=i.Form.useForm(),[U,D]=a.useState(!1),B=(e,r)=>e,[_,K]=c.usePropSeparateDevice(t,v),[,z]=c.usePropSeparateDevice(m,v),[,k]=c.usePropSeparateDevice(f,v),{uploadFileHandler:O=B,maxSizeImageUpload:$=20}=d.useBuilder();a.useEffect((()=>{const e=(r=_,u.isPrefixUrl(r)?r.slice(4,r.lastIndexOf("=")):r);var r;_!==e&&K(e)}),[]);const[L,M]=a.useState(!1),R=null==(S=null==window?void 0:window.config)?void 0:S.flagPB6243;return e.jsxs(e.Fragment,{children:[e.jsx(g.FormItem,{"data-testid":"upload-image-config",layout:j,label:e.jsxs("div",{style:{display:"flex",flexDirection:"row",justifyContent:"space-between",alignItems:"center"},children:[(null==I?void 0:I.image)||r.t("common.image"),_&&R&&e.jsx(i.Button,{type:"link",style:{padding:0},onClick:()=>M(!L),children:r.t("Chỉnh sửa ảnh")})]}),children:e.jsxs(i.Spin,{spinning:U,children:[e.jsx("div",{style:{position:"relative",width:"vertical"===j?"100%":"auto"},children:e.jsx(l.ImageUploadButton,{accept:"image/jpg, image/jpeg, image/png, image/gif, image/webp",beforeUpload:n.beforeUploadImage,imagePropKey:t,widthPropKey:m,heightPropKey:f,placeholder:y||e.jsx(e.Fragment,{children:r.t("upload_image",{maxSize:`${$}MB`})}),deleteImage:()=>K(F),separateDevice:v,layout:j,allowCropImage:C,cropProps:P})}),_&&R&&e.jsx(s.ImageCropConfig,{imgSrc:_,setImgSrc:K,open:L,setOpen:M}),!_&&w&&e.jsxs(e.Fragment,{children:[e.jsx(h,{plain:!0,children:r.t("hoặc")}),e.jsx(i.Form,{form:b,onFinish:async e=>{const{url:r}=e;try{D(!0);const e=await O(r,"url");if(K(e),m||f){const r=new Image;r.src=o.getImageUrlFromGoogleUserContent(e,{width:0}),r.onload=()=>{r.complete&&(m&&z(r.width),f&&k(r.height))}}}finally{b.resetFields(),D(!1)}},children:e.jsx(i.Form.Item,{name:"url",rules:[{required:!0,message:r.t("URL không được để trống")},{type:"url",message:r.t("URL sai định dạng")},{pattern:/^[a-zA-Z0-9-._~:/?#@!$&'()*+,;=%]*$/,message:r.t("url_not_support_special_characters")}],children:e.jsx(i.Input.Search,{placeholder:r.t("Dùng đường dẫn ảnh"),enterButton:r.t("Dùng ảnh"),loading:U,onSearch:()=>b.submit()})})})]})]})}),!!x&&e.jsx(p.InputConfig,{propKey:x,formItemProps:{label:(null==I?void 0:I.alt)||r.t("image_config.alt"),layout:j},inputProps:{style:{width:"horizontal"===j?140:"100%"},placeholder:r.t("Nhập văn bản thay thế")},separateDevice:v}),q]})};


/***/ }),

/***/ 142669:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(429830),i=__webpack_require__(212951),r=__webpack_require__(891987),a=__webpack_require__(164662),l=__webpack_require__(342022),o=__webpack_require__(537018),n=__webpack_require__(610314),s=__webpack_require__(112373),u=__webpack_require__(800302),d=__webpack_require__(728567),p=__webpack_require__(726142),c=__webpack_require__(313247);function m(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var g=m(i),f=Object.defineProperty,j=Object.defineProperties,x=Object.getOwnPropertyDescriptors,h=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,y=Object.prototype.propertyIsEnumerable,v=(e,t,i)=>t in e?f(e,t,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[t]=i,I=(e,t)=>{for(var i in t||(t={}))b.call(t,i)&&v(e,i,t[i]);if(h)for(var i of h(t))y.call(t,i)&&v(e,i,t[i]);return e};const O=g.default((i=>{var a=i,{multiple:l=!1,image:u,setImage:d,listType:p="picture-card"}=a,m=((e,t)=>{var i={};for(var r in e)b.call(e,r)&&t.indexOf(r)<0&&(i[r]=e[r]);if(null!=e&&h)for(var r of h(e))t.indexOf(r)<0&&y.call(e,r)&&(i[r]=e[r]);return i})(a,["multiple","image","setImage","listType"]);const{maxSizeImageUpload:g=20}=c.useBuilder(),[f,v]=r.useState(!1);return e.jsx(n.Spin,{indicator:e.jsx(s.LoadingOutlined,{style:{fontSize:20}}),spinning:f,children:e.jsx(o.ImageUpload,(O=I({multiple:l,showUploadList:!1,disabled:f,listType:p,onUpdateImageUrl:l?e=>{if(!e)return;const t=e.imageUrl;t&&d(t),v(e.uploading)}:e=>{if(!e)return;const t=e.imageUrl;t&&d(t),v(e.uploading)}},m),q={children:l?e.jsx(n.Button,{block:!0,type:"primary",icon:e.jsx(s.UploadOutlined,{}),loading:f,children:t.t("upload_image",{maxSize:`${g}MB`})}):u?e.jsx(U,{src:u,alt:"uploaded img"}):e.jsxs("div",{children:[e.jsx(s.CloudUploadOutlined,{style:{fontSize:20}}),e.jsx("div",{style:{marginTop:8},children:t.t("upload_image",{maxSize:`${g}MB`})})]})},j(O,x(q))))});var O,q}))`
  width: 130px;
  height: 130px;
`,U=g.default.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;exports.ImageFormItem=({onChange:i,defaultValue:o})=>{const[n,c]=r.useState(o);r.useEffect((()=>{const e=(t=n,p.isPrefixUrl(t)?t.slice(4,t.lastIndexOf("=")):t);var t;n!==e&&c(e)}),[]);const m=[void 0,"",a];return r.useEffect((()=>{i(n)}),[n]),e.jsxs(e.Fragment,{children:[e.jsx(u.FormItem,{label:t.t("common.image"),children:e.jsxs("div",{style:{position:"relative"},children:[e.jsx(O,{accept:"image/jpg, image/jpeg, image/png, image/gif, image/webp",beforeUpload:l.beforeUploadImage,image:n,setImage:c}),!m.includes(n)&&e.jsx(s.CloseCircleFilled,{onClick:()=>{c(void 0)},style:{position:"absolute",top:-6,right:-6,fontSize:16,borderRadius:8}})]})}),e.jsx(d.InputConfig,{formItemProps:{label:t.t("Đường dẫn ảnh")},inputProps:{style:{width:130},placeholder:t.t("Nhập URL"),value:n===a?null:n,onChange:e=>{const t=e.target.value;c(t)}}})]})};


/***/ }),

/***/ 277920:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(429830),r=__webpack_require__(212951),i=__webpack_require__(891987),o=__webpack_require__(610314),a=__webpack_require__(112373),n=__webpack_require__(342022),l=__webpack_require__(164662),s=__webpack_require__(313247),c=__webpack_require__(800302),d=__webpack_require__(726142);function p(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var u=p(r),m=Object.defineProperty,g=Object.defineProperties,f=Object.getOwnPropertyDescriptors,h=Object.getOwnPropertySymbols,x=Object.prototype.hasOwnProperty,j=Object.prototype.propertyIsEnumerable,y=(e,t,r)=>t in e?m(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,b=(e,t)=>{for(var r in t||(t={}))x.call(t,r)&&y(e,r,t[r]);if(h)for(var r of h(t))j.call(t,r)&&y(e,r,t[r]);return e};const v=u.default.div`
  width: ${e=>"vertical"===e.layout?"100%":"130px"};
  height: 130px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  transition: border-color 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
  background-color: #fafafa;
  box-sizing: border-box;

  &:hover {
    border-color: ${e=>e.themeToken.colorPrimary};
  }

  .ant-upload {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    width: 100% !important;
    height: 100% !important;
    padding: 4px;
    position: relative;
    overflow: hidden;
  }
`,w=u.default.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
  margin: auto;
  pointer-events: none; /* Prevent image from intercepting click events */
`,F=u.default(a.CloseCircleFilled)`
  cursor: pointer;
  color: rgba(0, 0, 0, 0.88);
  position: absolute;
  top: -6px;
  right: -6px;
  font-size: 16px;
  border-radius: 8px;
`,O=u.default(o.Divider)`
  justify-content: center;
  &::before,
  &::after {
    width: 25% !important;
  }
`;exports.ImageFormItemV2=({onChange:r,defaultValue:p,layout:u="vertical",placeholder:m,allowUploadImageByUrl:h=!0,formItemProps:x})=>{const[j]=o.Form.useForm(),[y,I]=i.useState(p),[U,q]=i.useState(!1),{token:P}=o.theme.useToken(),k=(e,t)=>e,{uploadFileHandler:S=k,maxSizeImageUpload:_=20}=s.useBuilder();i.useEffect((()=>{const e=(t=y,d.isPrefixUrl(t)?t.slice(4,t.lastIndexOf("=")):t);var t;y!==e&&I(e)}),[]),i.useEffect((()=>{r(y)}),[y]);const z={name:"file",accept:"image/jpg, image/jpeg, image/png, image/gif, image/webp",showUploadList:!1,disabled:U,beforeUpload:(e,t)=>(n.beforeUploadImage(e)&&(async e=>{try{q(!0);const t=URL.createObjectURL(e),r=S;let i;try{i=await r(e,"image")}catch(e){i=t}I(i)}catch(e){}finally{q(!1)}})(e),!1)};return e.jsx(c.FormItem,{label:(null==x?void 0:x.label)||t.t("common.image"),layout:u,children:e.jsxs("div",{style:{position:"relative",width:"vertical"===u?"100%":"auto"},children:[e.jsx(v,{layout:u,themeToken:P,children:e.jsx(o.Upload,(L=b({},z),B={children:y&&y!==l?e.jsx(w,{src:y,alt:"uploaded img"}):e.jsx("div",{style:{width:"100%",textAlign:"center"},children:U?e.jsx(a.LoadingOutlined,{style:{fontSize:24}}):e.jsxs(e.Fragment,{children:[e.jsx(a.UploadOutlined,{style:{fontSize:20}}),e.jsx("div",{style:{marginTop:8},children:m||t.t("upload_image",{maxSize:`${_}MB`})})]})})},g(L,f(B))))}),y&&e.jsx(F,{onClick:e=>{e.stopPropagation(),I(void 0)},style:{color:P.colorText}}),!y&&h&&e.jsxs(e.Fragment,{children:[e.jsx(O,{plain:!0,children:t.t("hoặc")}),e.jsx(o.Form,{form:j,onFinish:async e=>{const{url:t}=e;try{q(!0);const e=await S(t,"url");I(e)}finally{j.resetFields(),q(!1)}},children:e.jsx(o.Form.Item,{name:"url",rules:[{required:!0,message:t.t("URL không được để trống")},{type:"url",message:t.t("URL sai định dạng")},{pattern:/^[a-zA-Z0-9-._~:/?#@!$&'()*+,;=%]*$/,message:t.t("url_not_support_special_characters")}],children:e.jsx(o.Input.Search,{placeholder:t.t("Dùng đường dẫn ảnh"),enterButton:t.t("Dùng ảnh"),loading:U,onSearch:()=>j.submit()})})})]})]})});var L,B};


/***/ }),

/***/ 537018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(429830),r=__webpack_require__(891987),a=__webpack_require__(610314),o=__webpack_require__(212951),l=__webpack_require__(877084),i=__webpack_require__(636574),n=__webpack_require__(313247);function c(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=c(o),p=c(l),u=c(i),d=Object.defineProperty,m=Object.defineProperties,f=Object.getOwnPropertyDescriptors,g=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,h=Object.prototype.propertyIsEnumerable,j=(e,t,r)=>t in e?d(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,O=(e,t)=>{for(var r in t||(t={}))b.call(t,r)&&j(e,r,t[r]);if(g)for(var r of g(t))h.call(t,r)&&j(e,r,t[r]);return e},v=(e,t)=>m(e,f(t)),x=(e,t)=>{var r={};for(var a in e)b.call(e,a)&&t.indexOf(a)<0&&(r[a]=e[a]);if(null!=e&&g)for(var a of g(e))t.indexOf(a)<0&&h.call(e,a)&&(r[a]=e[a]);return r};const y=s.default(a.Upload)`
  &.vertical {
    .ant-upload-select {
      width: 100% !important;
    }
  }

  .ant-upload-select {
    margin-bottom: 0 !important;
    margin-inline-end: 0 !important;
  }
`;exports.ImageUpload=o=>{var l=o,{accept:i="image/jpg, image/jpeg, image/png, image/webp",onUpdateImageUrl:c,multiple:s,children:d,layout:m="horizontal",allowCropImage:f=!1,cropProps:g={},maxSize:b=20}=l,h=x(l,["accept","onUpdateImageUrl","multiple","children","layout","allowCropImage","cropProps","maxSize"]);const[j,U]=r.useState(1),w=(e,t)=>URL.createObjectURL(e),{uploadFileHandler:q=w}=n.useBuilder(),P=()=>U(1),C=async e=>{const{onSuccess:t,onError:r,file:a}=e;if(S(a))try{await c({uploading:!0},a);const e=await q(a,"image");a.thumbUrl=e,t(a)}catch(e){r()}},I=async({file:e})=>{if(c){const{status:t,thumbUrl:r}=e;"error"!==t&&"done"!==t||await c({imageUrl:r,uploading:!1},e.originFileObj)}},S=e=>{var r;return!(e.size>1024*b*1024&&(null==(r=a.notification)||r.error({message:t.t("max_size_upload_error",{MAX_SIZE_UPLOAD:b})}),1))},R=h,{beforeUpload:_}=R,z=x(R,["beforeUpload"]);return f?e.jsx(u.default,v(O({rotationSlider:!0,modalProps:{zIndex:2e3},aspectSlider:!0,aspect:j,showReset:!0,beforeCrop:(e,t)=>((e=>{const t=new Image;t.src=e,t.onload=()=>{t.complete&&t.width>0&&t.height>0&&U(t.width/t.height)}})(URL.createObjectURL(e)),_(e,t)),onModalOk:P,onModalCancel:P,modalTitle:t.t("Chỉnh sửa ảnh"),modalOk:"Xong",modalCancel:t.t("common.cancel"),resetText:t.t("Đặt lại")},g),{children:e.jsx(y,v(O({className:p.default({vertical:"vertical"===m}),multiple:s,accept:i,customRequest:C,onChange:I},z),{children:d}))})):e.jsx(y,v(O({className:p.default({vertical:"vertical"===m}),multiple:s,customRequest:C,accept:i,onChange:I},h),{children:d}))};


/***/ }),

/***/ 660512:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(429830),i=__webpack_require__(891987),r=__webpack_require__(537018),a=__webpack_require__(212951),o=__webpack_require__(610314),l=__webpack_require__(112373),s=__webpack_require__(164662),n=__webpack_require__(493959),d=__webpack_require__(737577),u=__webpack_require__(313247),p=__webpack_require__(26308);function c(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var g=c(a),h=Object.defineProperty,m=Object.defineProperties,j=Object.getOwnPropertyDescriptors,f=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,x=Object.prototype.propertyIsEnumerable,v=(e,t,i)=>t in e?h(e,t,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[t]=i,b=(e,t)=>{for(var i in t||(t={}))y.call(t,i)&&v(e,i,t[i]);if(f)for(var i of f(t))x.call(t,i)&&v(e,i,t[i]);return e};const w=g.default.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;exports.ImageUploadButton=a=>{var c=a,{multiple:g=!1,imagePropKey:h,widthPropKey:v,heightPropKey:P,listType:I="picture-card",placeholder:O,deleteImage:U,separateDevice:q,layout:S="horizontal",defaultNewImage:B,showButtonUpload:D,stateImageUpload:C,onLoadingChange:K}=c,T=((e,t)=>{var i={};for(var r in e)y.call(e,r)&&t.indexOf(r)<0&&(i[r]=e[r]);if(null!=e&&f)for(var r of f(e))t.indexOf(r)<0&&x.call(e,r)&&(i[r]=e[r]);return i})(c,["multiple","imagePropKey","widthPropKey","heightPropKey","listType","placeholder","deleteImage","separateDevice","layout","defaultNewImage","showButtonUpload","stateImageUpload","onLoadingChange"]);const{maxSizeImageUpload:k=20}=u.useBuilder(),[z,F]=p.usePropSeparateDevice(h,q),[,L]=p.usePropSeparateDevice(v,q),[,_]=p.usePropSeparateDevice(P,q),[E,H]=i.useState(!1),{token:M}=o.theme.useToken(),N=C?C.image:z,R=C?C.setImage:F,W=C?C.setWidth:L,$=(null==C?void 0:C.setHeight)?C.setHeight:_,A=O||e.jsx(e.Fragment,{children:t.t("upload_image",{maxSize:`${k}MB`})});return i.useEffect((()=>{K&&K(E)}),[E,K]),e.jsxs("div",{style:{position:"relative"},children:[e.jsx(r.ImageUpload,(G=b({multiple:g,showUploadList:!1,disabled:E,listType:I,onUpdateImageUrl:g?async(e,t)=>{if(!e)return;const i=e.imageUrl;if(i&&h){const e=b({src:i,googleImageParams:{width:0,height:0}},B);e.id&&(e.id=n.v4());const r=await d.getImageObject(t);e.googleImageParams.width=r.width,e.googleImageParams.height=r.height;const a=[...z||[]];a.push(e),R(a)}H(e.uploading)}:async(e,t)=>{if(!e)return;const i=e.imageUrl;if(i&&h){const e=await d.getImageObject(t);v&&W(e.width),P&&$(e.height),R(i)}H(e.uploading)},layout:S},T),J={children:g?e.jsx(o.Button,{block:!0,type:"primary",icon:e.jsx(l.UploadOutlined,{}),loading:E,children:A}):N&&N!=s&&!E?e.jsx(w,{src:N,alt:"uploaded img"}):e.jsx("div",{style:{width:"100%"},children:E?e.jsx(l.LoadingOutlined,{}):e.jsx(e.Fragment,{children:D?e.jsx(o.Button,{icon:e.jsx(l.UploadOutlined,{}),loading:E,children:A}):e.jsxs(e.Fragment,{children:[e.jsx(l.UploadOutlined,{}),e.jsx("div",{style:{marginTop:4},children:A})]})})})},m(G,j(J)))),!g&&!!N&&e.jsx(l.CloseCircleFilled,{onClick:()=>{U?U():R(void 0)},style:{cursor:"pointer",color:M.colorText,position:"absolute",top:-6,right:-6,fontSize:16,borderRadius:8}})]});var G,J};


/***/ }),

/***/ 342022:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(429830),i=__webpack_require__(610314);const r=["image/jpeg","image/png","image/jpg","image/gif","image/webp"];exports.beforeUploadImage=t=>!!r.includes(t.type)||(i.notification.error({message:e.t("Bạn chỉ có thể tải lên ảnh dạng JPG/JPEG/PNG/GIF/WEBP!")}),!1);


/***/ }),

/***/ 495410:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(610314),t=__webpack_require__(891987),o=__webpack_require__(190899),a=__webpack_require__(85097),i=__webpack_require__(358121),n=__webpack_require__(429830),p=__webpack_require__(212951),s=__webpack_require__(926854),c=__webpack_require__(75537),d=__webpack_require__(313247);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var u=l(o),f=l(p);const h=l(s).default({key:"image-crop",prepend:!0}),g=({label:r,min:t,max:o,step:a,value:i,onChange:n})=>{const p=(i-t)/(o-t)*100;return e.jsxs(m,{children:[e.jsx(_,{children:r}),e.jsxs(C,{children:[e.jsx(R,{percent:p}),e.jsx(v,{percent:p}),e.jsx(w,{type:"range",min:t,max:o,step:a,value:i,onChange:e=>n(Number(e.target.value))})]})]})},x=({value:r,onChange:o,options:a})=>{const[i,n]=t.useState(!1),p=t.useRef(null);t.useEffect((()=>{const e=e=>{p.current&&!p.current.contains(e.target)&&n(!1)};return document.addEventListener("mousedown",e),()=>document.removeEventListener("mousedown",e)}),[]);const s=a.find((e=>e.value===r));return e.jsxs(k,{ref:p,children:[e.jsxs(j,{isOpen:i,onClick:()=>n(!i),type:"button",children:[e.jsx("span",{children:(null==s?void 0:s.label)||""}),e.jsx(z,{isOpen:i})]}),e.jsx(O,{isOpen:i,children:a.map((t=>e.jsx(S,{isSelected:t.value===r,onClick:()=>{o(t.value),n(!1)},children:t.label},t.value)))})]})},b=f.default.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 16px;
`,m=f.default.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`,_=f.default.div`
  font-size: 14px;
  color: #333;
`,C=f.default.div`
  position: relative;
  width: 100%;
  height: 6px;
  background: #e8e8e8;
  border-radius: 3px;
`,R=f.default.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background: #7b61ff;
  border-radius: 3px;
  width: ${e=>e.percent}%;
  pointer-events: none;
`,v=f.default.div`
  position: absolute;
  top: 50%;
  left: ${e=>e.percent}%;
  transform: translate(-50%, -50%);
  width: 16px;
  height: 16px;
  background: #7b61ff;
  border: 2px solid #fff;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  transition: transform 0.1s ease;

  &:hover {
    transform: translate(-50%, -50%) scale(1.1);
  }

  &:active {
    transform: translate(-50%, -50%) scale(0.95);
  }
`,w=f.default.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  margin: 0;
  padding: 0;

  &::-webkit-slider-thumb {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  &::-moz-range-thumb {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
`,y=f.default.div`
  display: flex;
  align-items: center;
  gap: 12px;
`,k=f.default.div`
  position: relative;
  width: 160px;
`,j=f.default.button`
  width: 100%;
  height: 32px;
  padding: 4px 11px;
  background: #fff;
  border: 1px solid ${e=>e.isOpen?"#7B61FF":"#d9d9d9"};
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: all 0.2s;

  &:hover {
    border-color: #7b61ff;
  }

  &:focus {
    outline: none;
    border-color: #7b61ff;
    box-shadow: 0 0 0 2px rgba(91, 124, 250, 0.1);
  }
`,z=f.default.span`
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid #999;
  transition: transform 0.2s;
  transform: ${e=>e.isOpen?"rotate(180deg)":"rotate(0)"};
`,O=f.default.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  display: ${e=>e.isOpen?"block":"none"};
`,S=f.default.div`
  padding: 5px 12px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  background: ${e=>e.isSelected?"#f3f0fe":"#fff"};
  transition: background 0.2s;

  &:hover {
    background: #f5f5f5;
  }

  &:first-of-type {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }

  &:last-of-type {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }
`,q=f.default.div`
  @keyframes marching-ants {
    0% {
      background-position: 0 0, 0 100%, 0 0, 100% 0;
    }
    to {
      background-position: 20px 0, -20px 100%, 0 -20px, 100% 20px;
    }
  }
  .ReactCrop {
    position: relative;
    display: inline-block;
    cursor: crosshair;
    max-width: 100%;
  }
  .ReactCrop *,
  .ReactCrop *:before,
  .ReactCrop *:after {
    box-sizing: border-box;
  }
  .ReactCrop--disabled,
  .ReactCrop--locked {
    cursor: inherit;
  }
  .ReactCrop__child-wrapper {
    overflow: hidden;
    max-height: inherit;
  }
  .ReactCrop__child-wrapper > img,
  .ReactCrop__child-wrapper > video {
    display: block;
    max-width: 100%;
    max-height: inherit;
  }
  .ReactCrop:not(.ReactCrop--disabled) .ReactCrop__child-wrapper > img,
  .ReactCrop:not(.ReactCrop--disabled) .ReactCrop__child-wrapper > video {
    touch-action: none;
  }
  .ReactCrop:not(.ReactCrop--disabled) .ReactCrop__crop-selection {
    touch-action: none;
  }
  .ReactCrop__crop-mask {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    pointer-events: none;
    width: calc(100% + 0.5px);
    height: calc(100% + 0.5px);
  }
  .ReactCrop__crop-selection {
    position: absolute;
    top: 0;
    left: 0;
    transform: translateZ(0);
    cursor: move;
  }
  .ReactCrop--disabled .ReactCrop__crop-selection {
    cursor: inherit;
  }
  .ReactCrop--circular-crop .ReactCrop__crop-selection {
    border-radius: 50%;
  }
  .ReactCrop--circular-crop .ReactCrop__crop-selection:after {
    pointer-events: none;
    content: '';
    position: absolute;
    top: -1px;
    right: -1px;
    bottom: -1px;
    left: -1px;
    border: 1px solid rgba(255, 255, 255, 0.7);
    opacity: 0.3;
  }
  .ReactCrop--no-animate .ReactCrop__crop-selection {
    outline: 1px dashed white;
  }
  .ReactCrop__crop-selection:not(.ReactCrop--no-animate
      .ReactCrop__crop-selection) {
    animation: marching-ants 1s;
    background-image: linear-gradient(to right, #fff 50%, #444 50%),
      linear-gradient(to right, #fff 50%, #444 50%),
      linear-gradient(to bottom, #fff 50%, #444 50%),
      linear-gradient(to bottom, #fff 50%, #444 50%);
    background-size: 10px 1px, 10px 1px, 1px 10px, 1px 10px;
    background-position: 0 0, 0 100%, 0 0, 100% 0;
    background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
    color: #fff;
    animation-play-state: running;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
  }
  .ReactCrop__crop-selection:focus {
    outline: 2px solid #0088ff;
    outline-offset: -1px;
  }
  .ReactCrop--invisible-crop .ReactCrop__crop-mask,
  .ReactCrop--invisible-crop .ReactCrop__crop-selection {
    display: none;
  }
  .ReactCrop__rule-of-thirds-vt:before,
  .ReactCrop__rule-of-thirds-vt:after,
  .ReactCrop__rule-of-thirds-hz:before,
  .ReactCrop__rule-of-thirds-hz:after {
    content: '';
    display: block;
    position: absolute;
    background-color: #fff6;
  }
  .ReactCrop__rule-of-thirds-vt:before,
  .ReactCrop__rule-of-thirds-vt:after {
    width: 1px;
    height: 100%;
  }
  .ReactCrop__rule-of-thirds-vt:before {
    left: 33.3333333333%;
  }
  .ReactCrop__rule-of-thirds-vt:after {
    left: 66.6666666667%;
  }
  .ReactCrop__rule-of-thirds-hz:before,
  .ReactCrop__rule-of-thirds-hz:after {
    width: 100%;
    height: 1px;
  }
  .ReactCrop__rule-of-thirds-hz:before {
    top: 33.3333333333%;
  }
  .ReactCrop__rule-of-thirds-hz:after {
    top: 66.6666666667%;
  }
  .ReactCrop__drag-handle {
    position: absolute;
    width: 12px;
    height: 12px;
    background-color: rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.7);
  }
  .ReactCrop__drag-handle:focus {
    background: #0088ff;
  }
  .ReactCrop .ord-nw {
    top: 0;
    left: 0;
    transform: translate(-50%, -50%);
    cursor: nw-resize;
  }
  .ReactCrop .ord-n {
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: n-resize;
  }
  .ReactCrop .ord-ne {
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    cursor: ne-resize;
  }
  .ReactCrop .ord-e {
    top: 50%;
    right: 0;
    transform: translate(50%, -50%);
    cursor: e-resize;
  }
  .ReactCrop .ord-se {
    bottom: 0;
    right: 0;
    transform: translate(50%, 50%);
    cursor: se-resize;
  }
  .ReactCrop .ord-s {
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%);
    cursor: s-resize;
  }
  .ReactCrop .ord-sw {
    bottom: 0;
    left: 0;
    transform: translate(-50%, 50%);
    cursor: sw-resize;
  }
  .ReactCrop .ord-w {
    top: 50%;
    left: 0;
    transform: translate(-50%, -50%);
    cursor: w-resize;
  }
  .ReactCrop__disabled .ReactCrop__drag-handle {
    cursor: inherit;
  }
  .ReactCrop__drag-bar {
    position: absolute;
  }
  .ReactCrop__drag-bar.ord-n {
    top: 0;
    left: 0;
    width: 100%;
    height: 6px;
    transform: translateY(-50%);
  }
  .ReactCrop__drag-bar.ord-e {
    right: 0;
    top: 0;
    width: 6px;
    height: 100%;
    transform: translate(50%);
  }
  .ReactCrop__drag-bar.ord-s {
    bottom: 0;
    left: 0;
    width: 100%;
    height: 6px;
    transform: translateY(50%);
  }
  .ReactCrop__drag-bar.ord-w {
    top: 0;
    left: 0;
    width: 6px;
    height: 100%;
    transform: translate(-50%);
  }
  .ReactCrop--new-crop .ReactCrop__drag-bar,
  .ReactCrop--new-crop .ReactCrop__drag-handle,
  .ReactCrop--fixed-aspect .ReactCrop__drag-bar,
  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-n,
  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-e,
  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-s,
  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-w {
    display: none;
  }
  @media (pointer: coarse) {
    .ReactCrop .ord-n,
    .ReactCrop .ord-e,
    .ReactCrop .ord-s,
    .ReactCrop .ord-w {
      display: none;
    }
    .ReactCrop__drag-handle {
      width: 24px;
      height: 24px;
    }
  }
`;exports.ImageCropConfig=({imgSrc:p,setImgSrc:s,open:l,setOpen:f})=>{const[m,_]=t.useState(),[C,R]=t.useState(),[v,w]=t.useState(1),[k,j]=t.useState(0),[z,O]=t.useState(1),[S,L]=t.useState(!1),$=t.useRef(null),E=t.useRef(""),{uploadFileHandler:P}=d.useBuilder();t.useEffect((()=>{if(l&&p){const e=a.getImageUrlFromGoogleUserContent(p,{width:0});s(e)}}),[l,p,s]),t.useEffect((()=>{if($.current&&z){const{width:e,height:r}=$.current,t=i.centerAspectCrop(e,r,z);_(t),R(o.convertToPixelCrop(t,e,r))}}),[z]);const T=t.useCallback((async()=>{var e;if(C&&$.current)try{L(!0);const t=document.createElement("canvas");i.canvasPreview($.current,t,C,v,k);const o=await(e=t,new Promise((r=>{e.toBlob((e=>{r(e)}),"image/png")})));if(!o)return r.notification.error({message:n.t("Lỗi"),description:n.t("image_crop_config.crop.cannot_create_crop")}),void f(!1);const a=new File([o],`cropped-image-${Date.now()}.png`,{type:"image/png"});if(!P)return r.notification.error({message:n.t("Lỗi"),description:n.t("image_crop_config.upload.no_handler")}),void f(!1);const p=await P(a,"image");if(!p)throw new Error("Upload failed: No URL returned");E.current&&(URL.revokeObjectURL(E.current),E.current=""),s(p),r.notification.success({message:n.t("Thành công"),description:n.t("image_crop_config.upload.image_update_successful")}),f(!1)}catch(e){r.notification.error({message:n.t("Lỗi"),description:n.t("image_crop_config.upload.image_update_failed")})}finally{L(!1)}else f(!1)}),[C,v,k,s,f,P]);return e.jsx(c.CacheProvider,{value:h,children:e.jsx(r.Modal,{title:n.t("Chỉnh sửa ảnh"),open:l,onCancel:()=>f(!1),onOk:T,okText:n.t("Áp dụng"),cancelText:n.t("Hủy"),width:900,destroyOnClose:!0,confirmLoading:S,maskClosable:!1,getContainer:()=>null==document?void 0:document.body,zIndex:2e3,children:!!p&&e.jsxs(q,{children:[e.jsx(u.default,{crop:m,onChange:(e,r)=>_(r),onComplete:e=>R(e),aspect:z,minHeight:60,keepSelection:!1,children:e.jsx("img",{ref:$,alt:"Crop me",src:p,crossOrigin:"anonymous",style:{transform:`scale(${v}) rotate(${k}deg)`},onLoad:e=>{if(z){const{width:r,height:t}=e.currentTarget,a=i.centerAspectCrop(r,t,z);_(a),R(o.convertToPixelCrop(a,r,t))}}})}),e.jsxs(b,{children:[e.jsxs(y,{children:[n.t("Tỉ lệ"),e.jsx(x,{value:null!=z?z:0,onChange:e=>O(e||void 0),options:[{label:n.t("image_crop_config.aspect.free"),value:0},{label:"1:1",value:1},{label:"4:3",value:4/3},{label:"16:9",value:16/9},{label:"3:4",value:3/4}]})]}),e.jsx(g,{label:n.t("Phóng to"),min:.5,max:3,step:.01,value:v,onChange:w}),e.jsx(g,{label:n.t("Xoay (độ)"),min:-180,max:180,step:1,value:k,onChange:j})]})]})})})};


/***/ }),

/***/ 358121:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(190899);exports.canvasPreview=function(t,e,r,a=1,h=0){const i=e.getContext("2d");if(!i)return;const n=t.naturalWidth/t.width,o=t.naturalHeight/t.height;e.width=Math.floor(r.width*n),e.height=Math.floor(r.height*o),i.save(),i.clearRect(0,0,e.width,e.height),i.translate(-r.x*n,-r.y*o),i.translate(t.width*n/2,t.height*o/2),i.rotate(h*Math.PI/180),i.scale(a,a),i.translate(-t.width*n/2,-t.height*o/2),i.drawImage(t,0,0,t.naturalWidth,t.naturalHeight,0,0,t.naturalWidth,t.naturalHeight),i.restore()},exports.centerAspectCrop=function(e,r,a){return t.centerCrop(t.makeAspectCrop({unit:"%",width:90},a,e,r),e,r)};


/***/ }),

/***/ 112628:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(429830),r=__webpack_require__(983642),n=__webpack_require__(944200),i=__webpack_require__(212951),a=__webpack_require__(610314),o=__webpack_require__(891987),l=__webpack_require__(610796),d=__webpack_require__(763805),s=__webpack_require__(523169),u=__webpack_require__(660512);function p(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=p(i),m=Object.defineProperty,g=Object.defineProperties,y=Object.getOwnPropertyDescriptors,b=Object.getOwnPropertySymbols,f=Object.prototype.hasOwnProperty,h=Object.prototype.propertyIsEnumerable,x=(e,t,r)=>t in e?m(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r;const j=c.default.ul`
  display: grid;
  gap: 0.75rem;
  padding: 0;

  transition: all 2s;

  /* Desktop */
  grid-template-columns: repeat(4, 1fr);
  /* Tablet */
  @media only screen and (max-width: 800px) {
    grid-template-columns: repeat(2, 1fr);
  }
  /* Mobile */
  @media only screen and (max-width: 460px) {
    grid-template-columns: repeat(1, 1fr);
  }
`,v=c.default.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;exports.ImageListConfig=({propKey:i="items",separateDevice:p,visible:c,setVisible:m,imageHeight:I,actions:C,defaultNewImage:q,imageSettingCustom:w,title:O})=>{var S;const[D,k]=s.useSortable(i,p),[P,T]=o.useState(null),B=P?D.findIndex((e=>e.id===P)):-1,{document:K}=l.useFrame(),M=()=>m(!1),E=e.jsxs(e.Fragment,{children:[e.jsxs(v,{children:[e.jsx(a.Typography.Text,{type:"secondary",children:t.t("Click 2 lần vào ảnh để thay ảnh mới")}),e.jsx(u.ImageUploadButton,{separateDevice:p,imagePropKey:i,multiple:!0,listType:"picture",defaultNewImage:q})]}),e.jsx(r.DndContext,{onDragStart:({active:e})=>{e&&T(e.id)},onDragEnd:({over:e})=>{if(T(null),e){const t=D.findIndex((t=>t.id===e.id));B!==t&&k((e=>n.arrayMove(e,B,t)))}},onDragCancel:()=>T(null),children:e.jsx(n.SortableContext,{items:D,children:e.jsx(j,{children:null==(S=null==D?void 0:D.map)?void 0:S.call(D,((t,r)=>{return e.jsx(d.SortableImage,(n=((e,t)=>{for(var r in t||(t={}))f.call(t,r)&&x(e,r,t[r]);if(b)for(var r of b(t))h.call(t,r)&&x(e,r,t[r]);return e})({actions:C,propKey:i,onRemove:()=>(e=>{k((t=>(null==t||t.splice(e,1),t)))})(r),index:r,id:t.id},t.item),g(n,y({imageHeight:I,separateDevice:p,imageSettingCustom:w}))),r);var n}))})})})]});return e.jsxs(a.Modal,{width:"70%",bodyStyle:{minHeight:500},zIndex:1080,title:O||t.t("Quản lý ảnh"),okText:t.t("Đóng"),destroyOnClose:!0,onCancel:M,open:c,footer:e.jsx(e.Fragment,{children:e.jsx(a.Button,{type:"primary",onClick:M,children:t.t("Đóng")})}),getContainer:(null==K?void 0:K.body)||(null==document?void 0:document.body),children:[(null==D?void 0:D.length)?E:null,e.jsx(a.Empty,{description:t.t("Chưa có hình ảnh nào"),style:{paddingTop:"10%",display:(null==D?void 0:D.length)?"none":"block"},children:e.jsx(u.ImageUploadButton,{separateDevice:p,imagePropKey:i,multiple:!0,listType:"picture",defaultNewImage:q})})]})};


/***/ }),

/***/ 780724:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(770867),o=__webpack_require__(234741),t=Object.defineProperty,a=Object.getOwnPropertySymbols,P=Object.prototype.hasOwnProperty,i=Object.prototype.propertyIsEnumerable,p=(e,r,o)=>r in e?t(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o;exports.ImageSetting=t=>{var l=t,{altPropKey:n=o.PROP_KEY.Alt,srcPropKey:y=o.PROP_KEY.Src,widthPropKey:K=o.PROP_KEY.joinKey(o.PROP_KEY.GoogleImageParams,o.PROP_KEY.Width),heightPropKey:g=o.PROP_KEY.joinKey(o.PROP_KEY.GoogleImageParams,o.PROP_KEY.Height)}=l,s=((e,r)=>{var o={};for(var t in e)P.call(e,t)&&r.indexOf(t)<0&&(o[t]=e[t]);if(null!=e&&a)for(var t of a(e))r.indexOf(t)<0&&i.call(e,t)&&(o[t]=e[t]);return o})(l,["altPropKey","srcPropKey","widthPropKey","heightPropKey"]);return e.jsx(r.ImageConfig,((e,r)=>{for(var o in r||(r={}))P.call(r,o)&&p(e,o,r[o]);if(a)for(var o of a(r))i.call(r,o)&&p(e,o,r[o]);return e})({propKey:y,widthPropKey:K,heightPropKey:g,layout:"vertical",altPropKey:n},s))};


/***/ }),

/***/ 763805:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(429830),i=__webpack_require__(891987),o=__webpack_require__(104437),r=__webpack_require__(610314),n=__webpack_require__(944200),s=__webpack_require__(212951),a=__webpack_require__(780724),l=__webpack_require__(610796),c=__webpack_require__(959211),u=__webpack_require__(164662),d=__webpack_require__(883906),p=__webpack_require__(133501),g=__webpack_require__(660512),y=__webpack_require__(234741);function f(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var P=f(i),j=f(s),b=Object.defineProperty,m=Object.defineProperties,x=Object.getOwnPropertyDescriptors,K=Object.getOwnPropertySymbols,v=Object.prototype.hasOwnProperty,h=Object.prototype.propertyIsEnumerable,O=(e,t,i)=>t in e?b(e,t,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[t]=i,R=(e,t)=>{for(var i in t||(t={}))v.call(t,i)&&O(e,i,t[i]);if(K)for(var i of K(t))h.call(t,i)&&O(e,i,t[i]);return e};const E=j.default.li`
  position: relative;
  list-style: none;
  cursor: grabbing;
  box-shadow: 0px 0px 4px rgba(68, 68, 68, 0.2);
  border-radius: 4px;

  .action-button {
    display: none;
  }

  :hover {
    .action-button {
      display: block;
    }
  }
`;exports.SortableImage=({id:s,src:f,index:j,onRemove:b,propKey:K,imageHeight:v=150,actions:h=["editInfo","editEvent","timingConfig"],separateDevice:O,imageSettingCustom:S})=>{const{attributes:C,listeners:_,setNodeRef:Y,transform:q,transition:I}=n.useSortable({id:s}),[k,w]=i.useState(!1),[D,$]=i.useState(!1),[z,B]=i.useState(!1),{document:T}=l.useFrame(),V=P.default.useRef(null),F=S;return e.jsxs(e.Fragment,{children:[e.jsxs(E,{style:{transform:o.CSS.Transform.toString(q),transition:I},ref:Y,children:[e.jsx(r.Tag,{color:"#fff",style:{color:"#333",borderRadius:999,position:"absolute",top:10,left:10,zIndex:1,boxShadow:"0px 0px 4px rgba(68, 68, 68, 0.1)"},children:j+1}),e.jsxs(r.Space,{style:{position:"absolute",top:10,right:10,zIndex:1},children:[h.map((t=>e.jsxs("div",{className:"action-button",children:["editInfo"===t&&e.jsx(r.Button,{shape:"circle",type:"default",onClick:()=>w(!0),icon:e.jsx(c.SettingsRegular,{style:{fontSize:14}})}),"editEvent"===t&&e.jsx(r.Button,{shape:"circle",type:"default",onClick:()=>$(!0),icon:e.jsx(c.LinkRegular,{style:{fontSize:14}})}),"timingConfig"===t&&e.jsx(r.Button,{shape:"circle",type:"default",onClick:()=>B(!0),icon:e.jsx(c.ClockRegular,{style:{fontSize:14}})}),"function"==typeof t&&e.jsx(t,{propKey:K,index:j,separateDevice:O})]}))),e.jsx("div",{className:"action-button",children:e.jsx(r.Button,{shape:"circle",type:"default",onClick:b,icon:e.jsx(c.DeleteRegular,{style:{fontSize:14}})})})]}),e.jsx(r.Image,(G=R(R({},_),C),N={src:f,height:v,width:"100%",style:{objectFit:"cover",borderRadius:4},fallback:u,preview:!1,onDoubleClick:()=>{var e,t;return null==(t=null==(e=null==V?void 0:V.current)?void 0:e.querySelector("input"))?void 0:t.click()}},m(G,x(N))))]}),e.jsx(r.Modal,{zIndex:1080,open:k,onCancel:()=>w(!1),cancelButtonProps:{style:{display:"none"}},destroyOnClose:!0,onOk:()=>w(!1),closable:!1,okText:t.t("Đóng"),title:t.t("Chỉnh sửa thông tin ảnh"),getContainer:()=>(null==T?void 0:T.body)||(null==document?void 0:document.body),children:S?e.jsx(F,{index:j}):e.jsx(a.ImageSetting,{separateDevice:O,srcPropKey:y.PROP_KEY.joinKey(K,`[${j}]`,y.PROP_KEY.Src),widthPropKey:y.PROP_KEY.joinKey(K,`[${j}]`,y.PROP_KEY.GoogleImageParams,y.PROP_KEY.Width),altPropKey:y.PROP_KEY.joinKey(K,`[${j}]`,y.PROP_KEY.Alt)})}),e.jsx(d.EventConfig,{separateDevice:O,propKey:y.PROP_KEY.joinKey(K,`[${j}]`),visible:D,setVisible:$}),e.jsx(p.TimeVisibilityConfig,{visible:z,setVisible:B,propKey:y.PROP_KEY.joinKey(K,`[${j}]`),separateDevice:O}),e.jsx("div",{ref:V,style:{display:"none"},children:e.jsx(g.ImageUploadButton,{imagePropKey:y.PROP_KEY.joinKey(K,`[${j}]`,y.PROP_KEY.Src),widthPropKey:y.PROP_KEY.joinKey(K,`[${j}]`,y.PROP_KEY.GoogleImageParams,y.PROP_KEY.Width),heightPropKey:y.PROP_KEY.joinKey(K,`[${j}]`,y.PROP_KEY.GoogleImageParams,y.PROP_KEY.Height)})})]});var G,N};


/***/ }),

/***/ 62494:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(169589),i=__webpack_require__(26308),o=__webpack_require__(234741);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=s(r);const n=a.default.div`
  flex: 1;
  color: ${({isActive:e})=>e?"#7367F0":"#747474"};
  cursor: pointer;
`,c=a.default.div`
  display: flex;
  gap: 8px;
  margin-top: 8px;
`;exports.ImageRatioConfig=({propKey:r,separateDevice:s})=>{const[a,p]=i.usePropSeparateDevice(o.PROP_KEY.joinKey(r,o.PROP_KEY.AspectRatio),s);return e.jsx(c,{children:Object.entries(t.ICON_ASPECT_RATIO).map((([r,t])=>e.jsx(n,{isActive:a==r,onClick:()=>p(r),children:t},r)))})};


/***/ }),

/***/ 169589:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var C=__webpack_require__(561261);const t={"2/1":C.jsxs("svg",{width:"36",height:"18",viewBox:"0 0 36 18",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[C.jsx("rect",{width:"36",height:"18",transform:"translate(0 0.00195312)",fill:"currentColor"}),C.jsx("path",{d:"M15.3936 12.2832V13.502H9.19824V12.4546L12.207 9.17285C12.5371 8.80046 12.7974 8.47884 12.9878 8.20801C13.1782 7.93717 13.3115 7.69385 13.3877 7.47803C13.4681 7.25798 13.5083 7.04427 13.5083 6.83691C13.5083 6.54492 13.4533 6.2889 13.3433 6.06885C13.2375 5.84456 13.0809 5.66895 12.8735 5.54199C12.6662 5.41081 12.4144 5.34521 12.1182 5.34521C11.7754 5.34521 11.4876 5.41927 11.2549 5.56738C11.0221 5.71549 10.8465 5.92074 10.728 6.18311C10.6095 6.44124 10.5503 6.73747 10.5503 7.07178H9.02051C9.02051 6.53434 9.14323 6.04346 9.38867 5.59912C9.63411 5.15055 9.98958 4.79508 10.4551 4.53271C10.9206 4.26611 11.4813 4.13281 12.1372 4.13281C12.755 4.13281 13.2798 4.23649 13.7114 4.44385C14.1431 4.6512 14.471 4.94531 14.6953 5.32617C14.9238 5.70703 15.0381 6.15771 15.0381 6.67822C15.0381 6.96598 14.9915 7.25163 14.8984 7.53516C14.8053 7.81868 14.672 8.10221 14.4985 8.38574C14.3293 8.66504 14.1283 8.94645 13.8955 9.22998C13.6628 9.50928 13.4067 9.79281 13.1274 10.0806L11.1279 12.2832H15.3936ZM16.6948 12.7402C16.6948 12.5033 16.7752 12.3044 16.936 12.1436C17.0968 11.9785 17.3148 11.896 17.5898 11.896C17.8691 11.896 18.0871 11.9785 18.2437 12.1436C18.4045 12.3044 18.4849 12.5033 18.4849 12.7402C18.4849 12.9772 18.4045 13.1761 18.2437 13.3369C18.0871 13.4977 17.8691 13.5781 17.5898 13.5781C17.3148 13.5781 17.0968 13.4977 16.936 13.3369C16.7752 13.1761 16.6948 12.9772 16.6948 12.7402ZM16.7012 7.33203C16.7012 7.09505 16.7816 6.89616 16.9424 6.73535C17.1032 6.57031 17.3211 6.48779 17.5962 6.48779C17.8755 6.48779 18.0934 6.57031 18.25 6.73535C18.4108 6.89616 18.4912 7.09505 18.4912 7.33203C18.4912 7.56901 18.4108 7.7679 18.25 7.92871C18.0934 8.08952 17.8755 8.16992 17.5962 8.16992C17.3211 8.16992 17.1032 8.08952 16.9424 7.92871C16.7816 7.7679 16.7012 7.56901 16.7012 7.33203ZM24.1914 4.22803V13.502H22.6616V6.04346L20.3955 6.81152V5.54834L24.0073 4.22803H24.1914Z",fill:"white"})]}),"3/2":C.jsxs("svg",{width:"36",height:"24",viewBox:"0 0 36 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[C.jsx("path",{d:"M36 0.00195312H0V24.002H36V0.00195312Z",fill:"currentColor"}),C.jsx("path",{d:"M10.9946 11.189H11.9087C12.2642 11.189 12.5583 11.1276 12.791 11.0049C13.028 10.8822 13.2036 10.7129 13.3179 10.4971C13.4321 10.2812 13.4893 10.0337 13.4893 9.7544C13.4893 9.4624 13.4364 9.2127 13.3306 9.0054C13.229 8.7938 13.0724 8.6309 12.8608 8.5166C12.6535 8.4023 12.389 8.3452 12.0674 8.3452C11.7965 8.3452 11.5511 8.4002 11.3311 8.5103C11.1152 8.616 10.9438 8.7684 10.8169 8.9673C10.6899 9.1619 10.6265 9.3947 10.6265 9.6655H9.09031C9.09031 9.1746 9.2194 8.7388 9.4775 8.3579C9.7357 7.9771 10.0869 7.6787 10.5312 7.4629C10.9798 7.2428 11.4834 7.1328 12.042 7.1328C12.6387 7.1328 13.1592 7.2323 13.6035 7.4312C14.0521 7.6258 14.4012 7.9178 14.6509 8.3071C14.9006 8.6965 15.0254 9.1789 15.0254 9.7544C15.0254 10.0168 14.964 10.2834 14.8413 10.5542C14.7186 10.825 14.5366 11.0726 14.2954 11.2969C14.0542 11.5169 13.7537 11.6968 13.394 11.8364C13.0343 11.9718 12.6175 12.0396 12.1436 12.0396H10.9946V11.189ZM10.9946 12.3823V11.5444H12.1436C12.6852 11.5444 13.1465 11.6079 13.5273 11.7349C13.9124 11.8618 14.2256 12.0374 14.4668 12.2617C14.708 12.4818 14.8836 12.7336 14.9937 13.0171C15.1079 13.3006 15.165 13.6011 15.165 13.9185C15.165 14.3501 15.0868 14.7352 14.9302 15.0737C14.7778 15.408 14.5599 15.6916 14.2764 15.9243C13.9928 16.1571 13.6606 16.3327 13.2798 16.4512C12.9032 16.5697 12.4927 16.6289 12.0483 16.6289C11.6506 16.6289 11.2697 16.5739 10.9058 16.4639C10.5418 16.3538 10.216 16.1909 9.9282 15.9751C9.6405 15.755 9.4119 15.4821 9.2427 15.1562C9.0776 14.8262 8.9951 14.4453 8.9951 14.0137H10.5249C10.5249 14.2887 10.5884 14.5321 10.7153 14.7437C10.8465 14.951 11.0285 15.1139 11.2612 15.2324C11.4982 15.3509 11.769 15.4102 12.0737 15.4102C12.3953 15.4102 12.6725 15.353 12.9053 15.2388C13.138 15.1245 13.3158 14.9552 13.4385 14.731C13.5654 14.5067 13.6289 14.2358 13.6289 13.9185C13.6289 13.5588 13.5591 13.2668 13.4194 13.0425C13.2798 12.8182 13.0809 12.6532 12.8228 12.5474C12.5646 12.4373 12.2599 12.3823 11.9087 12.3823H10.9946ZM16.6948 15.7402C16.6948 15.5033 16.7752 15.3044 16.936 15.1436C17.0968 14.9785 17.3148 14.896 17.5898 14.896C17.8691 14.896 18.0871 14.9785 18.2437 15.1436C18.4045 15.3044 18.4849 15.5033 18.4849 15.7402C18.4849 15.9772 18.4045 16.1761 18.2437 16.3369C18.0871 16.4977 17.8691 16.5781 17.5898 16.5781C17.3148 16.5781 17.0968 16.4977 16.936 16.3369C16.7752 16.1761 16.6948 15.9772 16.6948 15.7402ZM16.7012 10.332C16.7012 10.0951 16.7816 9.8962 16.9424 9.7354C17.1032 9.5703 17.3211 9.4878 17.5962 9.4878C17.8755 9.4878 18.0934 9.5703 18.25 9.7354C18.4108 9.8962 18.4912 10.0951 18.4912 10.332C18.4912 10.569 18.4108 10.7679 18.25 10.9287C18.0934 11.0895 17.8755 11.1699 17.5962 11.1699C17.3211 11.1699 17.1032 11.0895 16.9424 10.9287C16.7816 10.7679 16.7012 10.569 16.7012 10.332ZM26.21 15.2832V16.502H20.0146V15.4546L23.0234 12.1729C23.3535 11.8005 23.6138 11.4788 23.8042 11.208C23.9946 10.9372 24.1279 10.6938 24.2041 10.478C24.2845 10.258 24.3247 10.0443 24.3247 9.8369C24.3247 9.5449 24.2697 9.2889 24.1597 9.0688C24.0539 8.8446 23.8973 8.6689 23.6899 8.542C23.4826 8.4108 23.2308 8.3452 22.9346 8.3452C22.5918 8.3452 22.304 8.4193 22.0713 8.5674C21.8385 8.7155 21.6629 8.9207 21.5444 9.1831C21.4259 9.4412 21.3667 9.7375 21.3667 10.0718H19.8369C19.8369 9.5343 19.9596 9.0435 20.2051 8.5991C20.4505 8.1506 20.806 7.7951 21.2715 7.5327C21.737 7.2661 22.2977 7.1328 22.9536 7.1328C23.5715 7.1328 24.0962 7.2365 24.5278 7.4438C24.9595 7.6512 25.2874 7.9453 25.5117 8.3262C25.7402 8.707 25.8545 9.1577 25.8545 9.6782C25.8545 9.966 25.8079 10.2516 25.7148 10.5352C25.6217 10.8187 25.4884 11.1022 25.3149 11.3857C25.1457 11.665 24.9447 11.9465 24.7119 12.23C24.4792 12.5093 24.2231 12.7928 23.9438 13.0806L21.9443 15.2832H26.21Z",fill:"white"})]}),"4/3":C.jsxs("svg",{width:"36",height:"27",viewBox:"0 0 36 27",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[C.jsx("rect",{width:"36",height:"27",transform:"translate(0 0.00195312)",fill:"currentColor"}),C.jsx("path",{d:"M15.5649 14.7075V15.9263H8.8999L8.84912 15.0059L12.8354 8.75977H14.0605L12.7339 11.0322L10.4424 14.7075H15.5649ZM14.4097 8.75977V18.002H12.8799V8.75977H14.4097ZM16.6948 17.2402C16.6948 17.0033 16.7752 16.8044 16.936 16.6436C17.0968 16.4785 17.3148 16.396 17.5898 16.396C17.8691 16.396 18.0871 16.4785 18.2437 16.6436C18.4045 16.8044 18.4849 17.0033 18.4849 17.2402C18.4849 17.4772 18.4045 17.6761 18.2437 17.8369C18.0871 17.9977 17.8691 18.0781 17.5898 18.0781C17.3148 18.0781 17.0968 17.9977 16.936 17.8369C16.7752 17.6761 16.6948 17.4772 16.6948 17.2402ZM16.7012 11.832C16.7012 11.5951 16.7816 11.3962 16.9424 11.2354C17.1032 11.0703 17.3211 10.9878 17.5962 10.9878C17.8755 10.9878 18.0934 11.0703 18.25 11.2354C18.4108 11.3962 18.4912 11.5951 18.4912 11.832C18.4912 12.069 18.4108 12.2679 18.25 12.4287C18.0934 12.5895 17.8755 12.6699 17.5962 12.6699C17.3211 12.6699 17.1032 12.5895 16.9424 12.4287C16.7816 12.2679 16.7012 12.069 16.7012 11.832ZM21.811 12.689H22.7251C23.0806 12.689 23.3747 12.6276 23.6074 12.5049C23.8444 12.3822 24.02 12.2129 24.1343 11.9971C24.2485 11.7812 24.3057 11.5337 24.3057 11.2544C24.3057 10.9624 24.2528 10.7127 24.147 10.5054C24.0454 10.2938 23.8888 10.1309 23.6772 10.0166C23.4699 9.90234 23.2054 9.84521 22.8838 9.84521C22.613 9.84521 22.3675 9.90023 22.1475 10.0103C21.9316 10.116 21.7603 10.2684 21.6333 10.4673C21.5063 10.6619 21.4429 10.8947 21.4429 11.1655H19.9067C19.9067 10.6746 20.0358 10.2388 20.2939 9.85791C20.5521 9.47705 20.9033 9.17871 21.3477 8.96289C21.7962 8.74284 22.2998 8.63281 22.8584 8.63281C23.4551 8.63281 23.9756 8.73226 24.4199 8.93115C24.8685 9.12581 25.2176 9.41781 25.4673 9.80713C25.717 10.1965 25.8418 10.6789 25.8418 11.2544C25.8418 11.5168 25.7804 11.7834 25.6577 12.0542C25.535 12.325 25.353 12.5726 25.1118 12.7969C24.8706 13.0169 24.5701 13.1968 24.2104 13.3364C23.8507 13.4718 23.4339 13.5396 22.96 13.5396H21.811V12.689ZM21.811 13.8823V13.0444H22.96C23.5016 13.0444 23.9629 13.1079 24.3438 13.2349C24.7288 13.3618 25.042 13.5374 25.2832 13.7617C25.5244 13.9818 25.7 14.2336 25.8101 14.5171C25.9243 14.8006 25.9814 15.1011 25.9814 15.4185C25.9814 15.8501 25.9032 16.2352 25.7466 16.5737C25.5942 16.908 25.3763 17.1916 25.0928 17.4243C24.8092 17.6571 24.4771 17.8327 24.0962 17.9512C23.7196 18.0697 23.3091 18.1289 22.8647 18.1289C22.467 18.1289 22.0861 18.0739 21.7222 17.9639C21.3582 17.8538 21.0324 17.6909 20.7446 17.4751C20.4569 17.255 20.2284 16.9821 20.0591 16.6562C19.894 16.3262 19.8115 15.9453 19.8115 15.5137H21.3413C21.3413 15.7887 21.4048 16.0321 21.5317 16.2437C21.6629 16.451 21.8449 16.6139 22.0776 16.7324C22.3146 16.8509 22.5854 16.9102 22.8901 16.9102C23.2118 16.9102 23.4889 16.853 23.7217 16.7388C23.9544 16.6245 24.1322 16.4552 24.2549 16.231C24.3818 16.0067 24.4453 15.7358 24.4453 15.4185C24.4453 15.0588 24.3755 14.7668 24.2358 14.5425C24.0962 14.3182 23.8973 14.1532 23.6392 14.0474C23.381 13.9373 23.0763 13.8823 22.7251 13.8823H21.811Z",fill:"white"})]}),"1/1":C.jsxs("svg",{width:"36",height:"36",viewBox:"0 0 36 36",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[C.jsx("rect",{width:"36",height:"36",transform:"translate(0 0.00195312)",fill:"currentColor"}),C.jsx("path",{d:"M13.375 13.228V22.502H11.8452V15.0435L9.5791 15.8115V14.5483L13.1909 13.228H13.375ZM16.6948 21.7402C16.6948 21.5033 16.7752 21.3044 16.936 21.1436C17.0968 20.9785 17.3148 20.896 17.5898 20.896C17.8691 20.896 18.0871 20.9785 18.2437 21.1436C18.4045 21.3044 18.4849 21.5033 18.4849 21.7402C18.4849 21.9772 18.4045 22.1761 18.2437 22.3369C18.0871 22.4977 17.8691 22.5781 17.5898 22.5781C17.3148 22.5781 17.0968 22.4977 16.936 22.3369C16.7752 22.1761 16.6948 21.9772 16.6948 21.7402ZM16.7012 16.332C16.7012 16.0951 16.7816 15.8962 16.9424 15.7354C17.1032 15.5703 17.3211 15.4878 17.5962 15.4878C17.8755 15.4878 18.0934 15.5703 18.25 15.7354C18.4108 15.8962 18.4912 16.0951 18.4912 16.332C18.4912 16.569 18.4108 16.7679 18.25 16.9287C18.0934 17.0895 17.8755 17.1699 17.5962 17.1699C17.3211 17.1699 17.1032 17.0895 16.9424 16.9287C16.7816 16.7679 16.7012 16.569 16.7012 16.332ZM24.1914 13.228V22.502H22.6616V15.0435L20.3955 15.8115V14.5483L24.0073 13.228H24.1914Z",fill:"white"})]}),"3/4":C.jsxs("svg",{width:"36",height:"48",viewBox:"0 0 36 48",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[C.jsx("rect",{width:"36",height:"48",transform:"translate(0 0.00195312)",fill:"currentColor"}),C.jsx("path",{d:"M10.9946 23.189H11.9087C12.2642 23.189 12.5583 23.1276 12.791 23.0049C13.028 22.8822 13.2036 22.7129 13.3179 22.4971C13.4321 22.2812 13.4893 22.0337 13.4893 21.7544C13.4893 21.4624 13.4364 21.2127 13.3306 21.0054C13.229 20.7938 13.0724 20.6309 12.8608 20.5166C12.6535 20.4023 12.389 20.3452 12.0674 20.3452C11.7965 20.3452 11.5511 20.4002 11.3311 20.5103C11.1152 20.616 10.9438 20.7684 10.8169 20.9673C10.6899 21.1619 10.6265 21.3947 10.6265 21.6655H9.09033C9.09033 21.1746 9.2194 20.7388 9.47754 20.3579C9.73568 19.9771 10.0869 19.6787 10.5312 19.4629C10.9798 19.2428 11.4834 19.1328 12.042 19.1328C12.6387 19.1328 13.1592 19.2323 13.6035 19.4312C14.0521 19.6258 14.4012 19.9178 14.6509 20.3071C14.9006 20.6965 15.0254 21.1789 15.0254 21.7544C15.0254 22.0168 14.964 22.2834 14.8413 22.5542C14.7186 22.825 14.5366 23.0726 14.2954 23.2969C14.0542 23.5169 13.7537 23.6968 13.394 23.8364C13.0343 23.9718 12.6175 24.0396 12.1436 24.0396H10.9946V23.189ZM10.9946 24.3823V23.5444H12.1436C12.6852 23.5444 13.1465 23.6079 13.5273 23.7349C13.9124 23.8618 14.2256 24.0374 14.4668 24.2617C14.708 24.4818 14.8836 24.7336 14.9937 25.0171C15.1079 25.3006 15.165 25.6011 15.165 25.9185C15.165 26.3501 15.0868 26.7352 14.9302 27.0737C14.7778 27.408 14.5599 27.6916 14.2764 27.9243C13.9928 28.1571 13.6606 28.3327 13.2798 28.4512C12.9032 28.5697 12.4927 28.6289 12.0483 28.6289C11.6506 28.6289 11.2697 28.5739 10.9058 28.4639C10.5418 28.3538 10.216 28.1909 9.92822 27.9751C9.64046 27.755 9.41195 27.4821 9.24268 27.1562C9.07764 26.8262 8.99512 26.4453 8.99512 26.0137H10.5249C10.5249 26.2887 10.5884 26.5321 10.7153 26.7437C10.8465 26.951 11.0285 27.1139 11.2612 27.2324C11.4982 27.3509 11.769 27.4102 12.0737 27.4102C12.3953 27.4102 12.6725 27.353 12.9053 27.2388C13.138 27.1245 13.3158 26.9552 13.4385 26.731C13.5654 26.5067 13.6289 26.2358 13.6289 25.9185C13.6289 25.5588 13.5591 25.2668 13.4194 25.0425C13.2798 24.8182 13.0809 24.6532 12.8228 24.5474C12.5646 24.4373 12.2599 24.3823 11.9087 24.3823H10.9946ZM16.6948 27.7402C16.6948 27.5033 16.7752 27.3044 16.936 27.1436C17.0968 26.9785 17.3148 26.896 17.5898 26.896C17.8691 26.896 18.0871 26.9785 18.2437 27.1436C18.4045 27.3044 18.4849 27.5033 18.4849 27.7402C18.4849 27.9772 18.4045 28.1761 18.2437 28.3369C18.0871 28.4977 17.8691 28.5781 17.5898 28.5781C17.3148 28.5781 17.0968 28.4977 16.936 28.3369C16.7752 28.1761 16.6948 27.9772 16.6948 27.7402ZM16.7012 22.332C16.7012 22.0951 16.7816 21.8962 16.9424 21.7354C17.1032 21.5703 17.3211 21.4878 17.5962 21.4878C17.8755 21.4878 18.0934 21.5703 18.25 21.7354C18.4108 21.8962 18.4912 22.0951 18.4912 22.332C18.4912 22.569 18.4108 22.7679 18.25 22.9287C18.0934 23.0895 17.8755 23.1699 17.5962 23.1699C17.3211 23.1699 17.1032 23.0895 16.9424 22.9287C16.7816 22.7679 16.7012 22.569 16.7012 22.332ZM26.3813 25.2075V26.4263H19.7163L19.6655 25.5059L23.6519 19.2598H24.877L23.5503 21.5322L21.2588 25.2075H26.3813ZM25.2261 19.2598V28.502H23.6963V19.2598H25.2261Z",fill:"white"})]}),"2/3":C.jsxs("svg",{width:"36",height:"54",viewBox:"0 0 36 54",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[C.jsx("rect",{width:"36",height:"54",transform:"translate(0 0.00195312)",fill:"currentColor"}),C.jsx("path",{d:"M15.3936 30.2832V31.502H9.19824V30.4546L12.207 27.1729C12.5371 26.8005 12.7974 26.4788 12.9878 26.208C13.1782 25.9372 13.3115 25.6938 13.3877 25.478C13.4681 25.258 13.5083 25.0443 13.5083 24.8369C13.5083 24.5449 13.4533 24.2889 13.3433 24.0688C13.2375 23.8446 13.0809 23.6689 12.8735 23.542C12.6662 23.4108 12.4144 23.3452 12.1182 23.3452C11.7754 23.3452 11.4876 23.4193 11.2549 23.5674C11.0221 23.7155 10.8465 23.9207 10.728 24.1831C10.6095 24.4412 10.5503 24.7375 10.5503 25.0718H9.02051C9.02051 24.5343 9.14323 24.0435 9.38867 23.5991C9.63411 23.1506 9.98958 22.7951 10.4551 22.5327C10.9206 22.2661 11.4813 22.1328 12.1372 22.1328C12.755 22.1328 13.2798 22.2365 13.7114 22.4438C14.1431 22.6512 14.471 22.9453 14.6953 23.3262C14.9238 23.707 15.0381 24.1577 15.0381 24.6782C15.0381 24.966 14.9915 25.2516 14.8984 25.5352C14.8053 25.8187 14.672 26.1022 14.4985 26.3857C14.3293 26.665 14.1283 26.9465 13.8955 27.23C13.6628 27.5093 13.4067 27.7928 13.1274 28.0806L11.1279 30.2832H15.3936ZM16.6948 30.7402C16.6948 30.5033 16.7752 30.3044 16.936 30.1436C17.0968 29.9785 17.3148 29.896 17.5898 29.896C17.8691 29.896 18.0871 29.9785 18.2437 30.1436C18.4045 30.3044 18.4849 30.5033 18.4849 30.7402C18.4849 30.9772 18.4045 31.1761 18.2437 31.3369C18.0871 31.4977 17.8691 31.5781 17.5898 31.5781C17.3148 31.5781 17.0968 31.4977 16.936 31.3369C16.7752 31.1761 16.6948 30.9772 16.6948 30.7402ZM16.7012 25.332C16.7012 25.0951 16.7816 24.8962 16.9424 24.7354C17.1032 24.5703 17.3211 24.4878 17.5962 24.4878C17.8755 24.4878 18.0934 24.5703 18.25 24.7354C18.4108 24.8962 18.4912 25.0951 18.4912 25.332C18.4912 25.569 18.4108 25.7679 18.25 25.9287C18.0934 26.0895 17.8755 26.1699 17.5962 26.1699C17.3211 26.1699 17.1032 26.0895 16.9424 25.9287C16.7816 25.7679 16.7012 25.569 16.7012 25.332ZM21.811 26.189H22.7251C23.0806 26.189 23.3747 26.1276 23.6074 26.0049C23.8444 25.8822 24.02 25.7129 24.1343 25.4971C24.2485 25.2812 24.3057 25.0337 24.3057 24.7544C24.3057 24.4624 24.2528 24.2127 24.147 24.0054C24.0454 23.7938 23.8888 23.6309 23.6772 23.5166C23.4699 23.4023 23.2054 23.3452 22.8838 23.3452C22.613 23.3452 22.3675 23.4002 22.1475 23.5103C21.9316 23.616 21.7603 23.7684 21.6333 23.9673C21.5063 24.1619 21.4429 24.3947 21.4429 24.6655H19.9067C19.9067 24.1746 20.0358 23.7388 20.2939 23.3579C20.5521 22.9771 20.9033 22.6787 21.3477 22.4629C21.7962 22.2428 22.2998 22.1328 22.8584 22.1328C23.4551 22.1328 23.9756 22.2323 24.4199 22.4312C24.8685 22.6258 25.2176 22.9178 25.4673 23.3071C25.717 23.6965 25.8418 24.1789 25.8418 24.7544C25.8418 25.0168 25.7804 25.2834 25.6577 25.5542C25.535 25.825 25.353 26.0726 25.1118 26.2969C24.8706 26.5169 24.5701 26.6968 24.2104 26.8364C23.8507 26.9718 23.4339 27.0396 22.96 27.0396H21.811V26.189ZM21.811 27.3823V26.5444H22.96C23.5016 26.5444 23.9629 26.6079 24.3438 26.7349C24.7288 26.8618 25.042 27.0374 25.2832 27.2617C25.5244 27.4818 25.7 27.7336 25.8101 28.0171C25.9243 28.3006 25.9814 28.6011 25.9814 28.9185C25.9814 29.3501 25.9032 29.7352 25.7466 30.0737C25.5942 30.408 25.3763 30.6916 25.0928 30.9243C24.8092 31.1571 24.4771 31.3327 24.0962 31.4512C23.7196 31.5697 23.3091 31.6289 22.8647 31.6289C22.467 31.6289 22.0861 31.5739 21.7222 31.4639C21.3582 31.3538 21.0324 31.1909 20.7446 30.9751C20.4569 30.755 20.2284 30.4821 20.0591 30.1562C19.894 29.8262 19.8115 29.4453 19.8115 29.0137H21.3413C21.3413 29.2887 21.4048 29.5321 21.5317 29.7437C21.6629 29.951 21.8449 30.1139 22.0776 30.2324C22.3146 30.3509 22.5854 30.4102 22.8901 30.4102C23.2118 30.4102 23.4889 30.353 23.7217 30.2388C23.9544 30.1245 24.1322 29.9552 24.2549 29.731C24.3818 29.5067 24.4453 29.2358 24.4453 28.9185C24.4453 28.5588 24.3755 28.2668 24.2358 28.0425C24.0962 27.8182 23.8973 27.6532 23.6392 27.5474C23.381 27.4373 23.0763 27.3823 22.7251 27.3823H21.811Z",fill:"white"})]})};exports.ICON_ASPECT_RATIO=t;


/***/ }),

/***/ 476662:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(610314),t=__webpack_require__(26308),o=__webpack_require__(800302),p=Object.defineProperty,i=Object.defineProperties,s=Object.getOwnPropertyDescriptors,n=Object.getOwnPropertySymbols,a=Object.prototype.hasOwnProperty,l=Object.prototype.propertyIsEnumerable,u=(e,r,t)=>r in e?p(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,c=(e,r)=>{for(var t in r||(r={}))a.call(r,t)&&u(e,t,r[t]);if(n)for(var t of n(r))l.call(r,t)&&u(e,t,r[t]);return e},j=(e,r)=>i(e,s(r));const m=t=>e.jsx(r.Input,c({},t));exports.Input=m,exports.InputConfigV1=p=>{const{propKey:i,formItemProps:s,inputProps:n,separateDevice:a,showTooltip:l,tooltipProps:u={}}=p,[y,b]=t.usePropSeparateDevice(i,a),{layout:v="horizontal"}=s||{},P=()=>e.jsx(o.FormItem,j(c({layout:v},s),{children:e.jsx(m,c({value:y||"",onChange:e=>{b(e.target.value||void 0)},style:{width:"horizontal"===v?130:"100%"}},n))}));return l?e.jsx(r.Tooltip,j(c({title:y},u),{children:P()})):P()};


/***/ }),

/***/ 728567:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(891987),r=__webpack_require__(610314),o=__webpack_require__(212951),n=__webpack_require__(85097),i=__webpack_require__(476662),s=__webpack_require__(26308),a=__webpack_require__(800302);function u(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=u(o),p=Object.defineProperty,c=Object.defineProperties,f=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,j=Object.prototype.hasOwnProperty,v=Object.prototype.propertyIsEnumerable,m=(e,t,r)=>t in e?p(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,x=(e,t)=>{for(var r in t||(t={}))j.call(t,r)&&m(e,r,t[r]);if(d)for(var r of d(t))v.call(t,r)&&m(e,r,t[r]);return e},b=(e,t)=>c(e,f(t));const g=o=>{const{propKey:i,formItemProps:u,inputProps:l,separateDevice:p,showTooltip:c,tooltipProps:f={},validateRegex:d,validateMessage:j="Invalid input format"}=o,[v,m]=s.usePropSeparateDevice(i,p),[g,P]=t.useState(v||""),[h,O]=t.useState(),{layout:q="horizontal"}=u||{},[C,S]=t.useState(!1),w=t.useCallback(n.debounce((e=>{d&&e?d.test(e)&&m(e):m(e||void 0)}),300),[d,j,m]);t.useEffect((()=>{C||(P(v||""),O(void 0))}),[v,C]);const F=e=>{const t=e.target.value;if(S(!0),P(t),d&&t){const e=d.test(t);O(e?void 0:j)}else O(void 0);w(t)},D=()=>{S(!1)},V=()=>e.jsxs(e.Fragment,{children:[e.jsx(a.FormItem,b(x({layout:q},u),{children:e.jsx(y,x({value:g,onChange:F,onBlur:D,style:x({width:"horizontal"===q?130:"100%"},h?{borderColor:"#ff4d4f"}:{})},l))})),h&&e.jsx(I,{children:h})]});return c?e.jsx(r.Tooltip,b(x({title:v},f),{children:V()})):V()},y=t=>e.jsx(r.Input,x({},t)),I=l.default.div`
  margin: 8px 4px;
  color: #ff4d4f;
  font-size: 11px;
`;exports.InputConfig=t=>{const{featureFlags:r}=n.useStore();return(null==r?void 0:r.flagPB5729)?e.jsx(g,x({},t)):e.jsx(i.InputConfigV1,x({},t))},exports.InputConfigV2=g,exports.InputV2=y;


/***/ }),

/***/ 689817:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),n=__webpack_require__(628734);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const t=o(r).default.div`
  position: relative;

  &::before {
    z-index: 999;
    content: '';
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0px;
    left: 0px;
    display: none;
  }

  .fake-cursor {
    position: fixed;
    top: -12px;
    left: -12px;
    border-radius: 50%;
    pointer-events: none;
    z-index: 9999;
    will-change: transform;
    transform: translate3d(0, 0, 0);
    width: 10px;
    height: 10px;
    display: none;
  }

  &.drag-resizing::before,
  &.drag-resizing .fake-cursor {
    display: block;
  }
`;exports.AddonBeforeDragNumberConfig=({min:r,max:o,value:i,onChange:s,label:a,step:u=1})=>{const{handleMouseDown:l,wrapperRef:d}=n.useDragNumber({min:r,max:o,value:i,onChange:s,label:a,step:u});return e.jsx(t,{ref:d,onMouseDown:l,style:{cursor:"ew-resize",userSelect:"none"},children:a})};


/***/ }),

/***/ 514824:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(610314),n=__webpack_require__(891987),o=__webpack_require__(187510),i=__webpack_require__(800302),u=__webpack_require__(26308);function p(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=p(r),s=Object.defineProperty,l=Object.defineProperties,c=Object.getOwnPropertyDescriptors,f=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,v=(e,r,t)=>r in e?s(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,b=(e,r)=>{for(var t in r||(r={}))d.call(r,t)&&v(e,t,r[t]);if(f)for(var t of f(r))m.call(r,t)&&v(e,t,r[t]);return e},j=(e,r)=>l(e,c(r)),x=(e,r)=>{var t={};for(var n in e)d.call(e,n)&&r.indexOf(n)<0&&(t[n]=e[n]);if(null!=e&&f)for(var n of f(e))r.indexOf(n)<0&&m.call(e,n)&&(t[n]=e[n]);return t};const y=r=>{var i=r,{propKey:p,placeholder:a,unitProps:s={},usePropOptions:l,onChange:c,separateDevice:f,displayUnit:d=!0}=i,m=x(i,["propKey","placeholder","unitProps","usePropOptions","onChange","separateDevice","displayUnit"]);const{defaultValue:v,options:y}=s,[h,O]=u.usePropSeparateDevice(p,f,l),g=n.useRef();n.useEffect((()=>{(null==m?void 0:m.defaultValue)&&!h&&O(m.defaultValue)}),[]);const I=b({ref:g,value:h,onChange:e=>{c?c(e):O(null===e?void 0:e)},placeholder:a||"0"},m);return(null==y?void 0:y.length)?e.jsxs(t.Input.Group,{style:{width:"unset"},className:"d-flex align-items-center",children:[e.jsx(P,b({style:{width:100}},I)),e.jsx(o.UnitConfig,j(b({},s),{separateDevice:f}))]}):e.jsx(P,b(b({},I),v&&d&&{addonAfter:v}))},P=a.default(t.InputNumber)("\n  width: 130px;\n  border-radius: 4px 0px 0px 4px !important;\n  .ant-input-number-input {\n    &:hover {\n      //cursor: ew-resize;\n    }\n  }\n");exports.InputNumber=y,exports.InputNumberConfig=r=>{var t=r,{formItemProps:n,inputNumberProps:o}=t,u=x(t,["formItemProps","inputNumberProps"]);return e.jsx(i.FormItem,j(b({},n),{children:e.jsx(y,b(b({},u),o))}))};


/***/ }),

/***/ 541055:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),n=__webpack_require__(610314),o=__webpack_require__(891987),t=__webpack_require__(689817),i=__webpack_require__(959211),a=__webpack_require__(628734),l=__webpack_require__(800302),u=__webpack_require__(26308),s=__webpack_require__(187510);function p(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=p(r),c=Object.defineProperty,f=Object.defineProperties,m=Object.getOwnPropertyDescriptors,v=Object.getOwnPropertySymbols,g=Object.prototype.hasOwnProperty,b=Object.prototype.propertyIsEnumerable,x=(e,r,n)=>r in e?c(e,r,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[r]=n,j=(e,r)=>{for(var n in r||(r={}))g.call(r,n)&&x(e,n,r[n]);if(v)for(var n of v(r))b.call(r,n)&&x(e,n,r[n]);return e},h=(e,r)=>f(e,m(r)),y=(e,r)=>{var n={};for(var o in e)g.call(e,o)&&r.indexOf(o)<0&&(n[o]=e[o]);if(null!=e&&v)for(var o of v(e))r.indexOf(o)<0&&b.call(e,o)&&(n[o]=e[o]);return n};const D=r=>{var l=r,{propKey:p,placeholder:d,unitProps:c={},usePropOptions:f,onChange:m,separateDevice:v,displayUnit:g=!0,isDraggable:b=!0,iconBeforeAddon:x}=l,D=y(l,["propKey","placeholder","unitProps","usePropOptions","onChange","separateDevice","displayUnit","isDraggable","iconBeforeAddon"]);const{defaultValue:O,options:C}=c,[q,I]=u.usePropSeparateDevice(p,v,f),N=o.useRef(),A=e=>{m?m(e):I(null===e?void 0:e)},B={min:null==D?void 0:D.min,max:null==D?void 0:D.max,value:p?q:null==D?void 0:D.value,onChange:A,label:x||e.jsx(i.ArrowsBidirectional20Regular,{}),step:null==D?void 0:D.step},{handleMouseDown:U,wrapperRef:V}=a.useDragNumber(B);o.useEffect((()=>{(null==D?void 0:D.defaultValue)&&!q&&I(D.defaultValue)}),[]);const z=j({ref:N,value:p?q:null==D?void 0:D.value,onChange:A,placeholder:d||"0",addonBefore:b&&x&&e.jsx(t.AddonBeforeDragNumberConfig,{min:null==D?void 0:D.min,max:null==D?void 0:D.max,value:p?q:null==D?void 0:D.value,onChange:A,label:x,step:null==D?void 0:D.step}),controls:!1},D),F=b?{ref:V,onMouseDown:U}:{};return(null==C?void 0:C.length)?e.jsx(n.Input.Group,{style:{width:"unset"},className:"d-flex align-items-center",children:e.jsxs(P,h(j({},F),{children:[e.jsx(w,h(j({style:{width:100}},z),{isDraggable:b})),g&&e.jsx(s.UnitConfig,j({separateDevice:v},c))]}))}):e.jsx(P,h(j({},F),{children:e.jsx(w,j(j({isDraggable:b},z),O&&g&&{addonAfter:O}))}))},P=d.default.div`
  &.drag-resizing input {
    caret-color: transparent;
  }

  &.drag-resizing::before {
    z-index: 999;
    content: '';
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0px;
    left: 0px;
  }
  caret-color: unset;
`,w=d.default(n.InputNumber)((({isDraggable:e})=>`\n    width: 130px;\n    border-radius: 4px !important;\n    .ant-input-number-input {\n      ${e?"cursor: ew-resize;":""}\n    }\n  `));exports.InputNumberConfigV2=r=>{var n=r,{formItemProps:o,inputNumberProps:t}=n,i=y(n,["formItemProps","inputNumberProps"]);return e.jsx(l.FormItem,h(j({},o),{children:e.jsx(D,j(j({},i),t))}))},exports.InputNumberV2=D;


/***/ }),

/***/ 628734:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(891987);exports.useDragNumber=({min:r,max:n,value:t,onChange:u,step:l=1})=>{const o=e.useRef(null),s=e.useRef(u),i=e.useRef(null),c=e.useRef({x:0,y:0}),d=e.useRef(!1),a=e.useRef();return e.useEffect((()=>{s.current=u}),[u]),e.useEffect((()=>{var e;if(!o.current)return;const t=e=>{var t,u,m,v;const f=e.movementX,p=e.movementY;if(void 0===a.current||0===f||Math.abs(f)>100)return;d.current||(i.current.style.display="block",null==(t=null==o?void 0:o.current)||t.requestPointerLock(),null==(m=null==(u=null==o?void 0:o.current)?void 0:u.classList)||m.add("drag-resizing"),d.current=!0),((e,r)=>{c.current.x+=e,c.current.y+=r,c.current.x<0&&(c.current.x=window.innerWidth),c.current.x>window.innerWidth&&(c.current.x=0),i.current&&(i.current.style.transform=`translate3d(${c.current.x}px, ${c.current.y}px, 0)`)})(f,p);const x=f*Number(l);let w=(a.current||0)+x;a.current=w,void 0!==r&&"number"==typeof Number(r)&&(w=Math.max(Number(r),w)),void 0!==n&&"number"==typeof Number(n)&&(w=Math.min(Number(n),w)),null==(v=s.current)||v.call(s,w)},u=()=>{var e,r;a.current=void 0,d.current=!1,document.exitPointerLock(),null==(r=null==(e=null==o?void 0:o.current)?void 0:e.classList)||r.remove("drag-resizing"),i.current.style.display="none"};return null==(e=null==o?void 0:o.current)||e.addEventListener("mousemove",t),window.addEventListener("mouseup",u),()=>{var e;null==(e=null==o?void 0:o.current)||e.removeEventListener("mousemove",t),window.removeEventListener("mouseup",u)}}),[n,r,l]),e.useEffect((()=>{let e=document.getElementById("fake-cursor");return e||(e=document.createElement("div"),e.id="fake-cursor",e.innerHTML='\n        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"\n          xmlns="http://www.w3.org/2000/svg">\n          <path\n            d="M7.45 7.04999L2.5 12L7.447 16.947L7.448 13H16.55V16.95L21.5 12L16.55 7.04999V11H7.45V7.04999Z"\n            fill="#4B4B4B"\n          />\n        </svg>\n      ',Object.assign(e.style,{position:"fixed",top:"-12px",left:"-12px",borderRadius:"50%",pointerEvents:"none",zIndex:"9999",willChange:"transform",transform:"translate3d(0, 0, 0)",width:"10px",height:"10px",display:"none"}),document.body.appendChild(e)),i.current=e,()=>{e.remove()}}),[]),{handleMouseDown:e=>{e.currentTarget===o.current&&(a.current=t||0,c.current={x:e.clientX,y:e.clientY},i.current&&(i.current.style.transform=`translate3d(${e.clientX}px, ${e.clientY}px, 0)`))},wrapperRef:o}};


/***/ }),

/***/ 17595:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(959211),n=__webpack_require__(610314),o=__webpack_require__(891987),i=__webpack_require__(26308),u=__webpack_require__(800302);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=l(t),s=Object.defineProperty,p=Object.defineProperties,c=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,f=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,v=(e,t,r)=>t in e?s(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,b=(e,t)=>{for(var r in t||(t={}))f.call(t,r)&&v(e,r,t[r]);if(d)for(var r of d(t))m.call(t,r)&&v(e,r,t[r]);return e},y=(e,t)=>p(e,c(t));const h=a.default.div`
  position: relative;
  width: 100%;

  &:hover {
    cursor: pointer;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      border-radius: 4px;
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }
`,j=a.default(n.Dropdown)`
  min-width: unset !important;
`;exports.InputSelectConfig=({propKey:t,formItemProps:l,options:a,value:s,onChange:p,inputProps:c})=>{const[d,f]=i.usePropSeparateDevice(t),[m,v]=o.useState(s),[x,g]=o.useState(s),w=e=>{const t=(e=>{if(null==e||""===e)return m||(null==c?void 0:c.min)||"";if(void 0!==(null==c?void 0:c.min)||void 0!==(null==c?void 0:c.max)){const t=Number(e);if(isNaN(t))return m||(null==c?void 0:c.min)||"";const r=null==c?void 0:c.min,n=null==c?void 0:c.max;return Math.min(Math.max(t,null!=r?r:-1/0),null!=n?n:1/0)}return e})(e);""!==e&&null!=e?t!==(s||d||m)&&(v(t),g(t),"function"!=typeof p?f(t):p(t)):g(m)};return o.useEffect((()=>{const e=void 0!==s?s:d;v(e),g(e)}),[s,d]),e.jsx(u.FormItem,y(b({},l),{children:e.jsx(j,{menu:{items:a,selectedKeys:[null==m?void 0:m.toString()],onClick:({key:e})=>w(e)},trigger:["click"],overlayStyle:{zIndex:1080},arrow:!0,children:e.jsx(h,{children:e.jsx(n.Input,y(b({value:x,bordered:!1,suffix:e.jsx(r.ChevronDown16Regular,{}),onChange:e=>g(e.target.value),onPressEnter:()=>w(x),onBlur:()=>w(x)},c),{"data-testid":"font-size-input"}))})})}))};


/***/ }),

/***/ 997245:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(610314),t=__webpack_require__(26308),o=__webpack_require__(800302),a=Object.defineProperty,n=Object.defineProperties,p=Object.getOwnPropertyDescriptors,s=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,l=(e,r,t)=>r in e?a(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,c=(e,r)=>{for(var t in r||(r={}))i.call(r,t)&&l(e,t,r[t]);if(s)for(var t of s(r))u.call(r,t)&&l(e,t,r[t]);return e};exports.InputTextAreaConfig=a=>{const{propKey:s,formItemProps:i,textareaProps:u,separateDevice:l}=a,[m,j]=t.usePropSeparateDevice(s,l),{layout:y="horizontal"}=i||{};return e.jsx(e.Fragment,{children:e.jsx(o.FormItem,(b=c({layout:y},i),v={children:e.jsx(r.Input.TextArea,c({value:m,onChange:e=>j(e.target.value),style:{width:"horizontal"===y?130:"100%"}},u))},n(b,p(v))))});var b,v};


/***/ }),

/***/ 100832:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(112373),r=__webpack_require__(983642),i=__webpack_require__(477560),o=__webpack_require__(944200),n=__webpack_require__(104437),l=__webpack_require__(212951),a=__webpack_require__(959211),s=__webpack_require__(610314),d=__webpack_require__(891987),c=__webpack_require__(493959),u=__webpack_require__(429830),m=__webpack_require__(26308);function p(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var v=p(l),f=Object.defineProperty,g=Object.defineProperties,x=Object.getOwnPropertyDescriptors,j=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,b=Object.prototype.propertyIsEnumerable,I=(e,t,r)=>t in e?f(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,h=(e,t)=>{for(var r in t||(t={}))y.call(t,r)&&I(e,r,t[r]);if(j)for(var r of j(t))b.call(t,r)&&I(e,r,t[r]);return e},D=(e,t)=>g(e,x(t));const w=({index:r,item:i,onDuplicate:l,onRemove:d,activeItem:c,setActiveItem:u,activeItemConfig:m,activeItemConfigProps:p,allowRemove:v=!0,allowDuplicate:f=!0,separateDevice:g,allowDrag:x=!0,titleKey:j,customTitle:y})=>{const{setNodeRef:b,attributes:I,listeners:w,transform:O}=o.useSortable({id:null==i?void 0:i.dndId}),q=m;return e.jsx(e.Fragment,{children:e.jsxs(C,{ref:b,style:{transform:n.CSS.Transform.toString(O)},className:c===r?"active":null,children:[e.jsxs(P,{onClick:()=>{u(c===r?void 0:r)},children:[e.jsxs("div",{className:"flex",children:[x&&e.jsx(S,D(h(h({},w),I),{style:{cursor:"move",marginRight:8},children:e.jsx(t.HolderOutlined,{style:{fontSize:20}})})),e.jsx("div",{children:y?y(i):(k=i[j],((null==k?void 0:k.length)>30?k.substring(0,30)+"...":k)||r+1)})]}),e.jsxs("div",{className:"flex",children:[f&&e.jsx(S,{style:{marginRight:8},onClick:e=>{e.stopPropagation(),l()},children:e.jsx(a.CopyRegular,{fontSize:20})}),v&&e.jsx(S,{onClick:e=>{e.stopPropagation(),d()},children:e.jsx(a.DeleteRegular,{fontSize:20})})]})]}),c===r&&!!m&&e.jsxs(e.Fragment,{children:[e.jsx(s.Divider,{className:"my-half mb-0"}),e.jsx(q,h({index:r,separateDevice:g},p))]})]},r)});var k},C=v.default.div`
  justify-content: space-between;
  padding: 0.5rem;
  border-radius: 4px;
  border: 1px solid var(--border-color);
  margin-bottom: 8px;
  &.active {
    border-color: ${e=>e.theme.colorPrimary};
  }
`,P=v.default.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`,S=v.default.div`
  background-color: transparent;
  cursor: pointer;
`;exports.ItemConfig=w,exports.ItemListConfig=({activeItemConfig:n,activeItemConfigProps:l,defaultActiveItem:a,defaultItem:p,propKey:v,maxItem:f,allowDuplicate:g=!0,allowRemove:x=!0,allowInsert:I=!0,allowDrag:C=!0,addItemText:P=u.t("Thêm phần tử"),separateDevice:S=!1,customDuplicate:O,customInsert:q,customRemove:k,titleKey:R="title",customTitle:T,emptyDescription:A,handleChangeActiveIndex:N,addItemButtonProps:E})=>{var F,K;const[z,B]=m.usePropSeparateDevice(v,S,{formatter:e=>(e||[]).map((e=>D(h({},e),{dndId:e.dndId?e.dndId:c.v4()}))),parser:e=>(e||[]).map((e=>((e,t)=>{var r={};for(var i in e)y.call(e,i)&&t.indexOf(i)<0&&(r[i]=e[i]);if(null!=e&&j)for(var i of j(e))t.indexOf(i)<0&&b.call(e,i)&&(r[i]=e[i]);return r})(e,["dndId"])))}),[$,L]=d.useState(a||0),M=e=>{L(e),null==N||N(e)},_=q||(()=>{const e=h({},p);e.id&&(e.id=c.v4()),B([...z,h({},e)])}),H=k||(e=>{const t=[...z];t.splice(e,1),B(t)}),V=O||(e=>{if(z.length>=f)return;const t=h({},z[e]);t.id&&(t.id=c.v4());const r=[...z];r.splice(e+1,0,t),B(r)});return e.jsxs(e.Fragment,{children:[e.jsx(r.DndContext,{modifiers:[i.restrictToVerticalAxis,i.restrictToWindowEdges,i.restrictToFirstScrollableAncestor],onDragEnd:({active:e,over:t})=>{if((null==e?void 0:e.id)!==(null==t?void 0:t.id)){const r=[...z],i=r.findIndex((t=>t.dndId===(null==e?void 0:e.id))),n=r.findIndex((e=>e.dndId===(null==t?void 0:t.id)));B(o.arrayMove(r,i,n)),M(void 0)}},children:0===z.length?e.jsx(s.Empty,{description:A}):e.jsx(o.SortableContext,{items:null==(F=z.map)?void 0:F.call(z,(e=>e.dndId)),strategy:o.verticalListSortingStrategy,disabled:!C,children:null==(K=z.map)?void 0:K.call(z,((t,r)=>e.jsx(w,{activeItem:$,setActiveItem:M,item:t,index:r,onDuplicate:()=>V(r),onRemove:()=>H(r),activeItemConfig:n,activeItemConfigProps:l,allowDuplicate:g,allowRemove:x,separateDevice:S,allowDrag:C,titleKey:R,customTitle:T},r)))})}),I&&e.jsx(s.Button,D(h({style:{marginTop:8,marginBottom:8},disabled:f&&z.length>=f,type:"primary",block:!0,icon:e.jsx(t.PlusOutlined,{}),onClick:()=>_()},E),{children:P+(f?` (${z.length}/${f})`:"")}))]})};


/***/ }),

/***/ 732125:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(610314),i=__webpack_require__(112373),n=__webpack_require__(891987),o=__webpack_require__(212951),r=__webpack_require__(85097),a=__webpack_require__(429830),s=__webpack_require__(234741),l=__webpack_require__(26308),p=__webpack_require__(313247),u=__webpack_require__(514824);function c(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=c(o),m=Object.defineProperty,f=Object.defineProperties,P=Object.getOwnPropertyDescriptors,j=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,y=(e,t,i)=>t in e?m(e,t,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[t]=i,_=(e,t)=>{for(var i in t||(t={}))b.call(t,i)&&y(e,i,t[i]);if(j)for(var i of j(t))g.call(t,i)&&y(e,i,t[i]);return e};const O=d.default.div`
  position: relative;
  ${({spinning:e})=>e?"\n    &::after {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: rgba(255, 255, 255, 0.8);\n      z-index: 1;\n    }\n  ":""}
`,K=d.default(t.Upload)`
  .ant-upload-select,
  .ant-upload-list-item-container {
    width: 100% !important;
  }

  a {
    color: rgba(0, 0, 0, 0.88);
  }
`;exports.AnimationLottieConfig=({separateDevice:o=!1})=>{const c=s.PROP_KEY.joinKey(s.PROP_KEY.AnimationConfig,s.PROP_KEY.Url),d=s.PROP_KEY.joinKey(s.PROP_KEY.AnimationConfig,s.PROP_KEY.TotalFrame),m=s.PROP_KEY.joinKey(s.PROP_KEY.AnimationConfig,s.PROP_KEY.FrameShowPopup),j=s.PROP_KEY.joinKey(s.PROP_KEY.AnimationConfig,s.PROP_KEY.WrapperStyle),b=s.PROP_KEY.joinKey(j,s.PROP_KEY.Width),g=s.PROP_KEY.joinKey(j,s.PROP_KEY.Height),y=s.PROP_KEY.joinKey(j,s.PROP_KEY.Top),[h,v]=l.usePropSeparateDevice(c,o),[,x]=l.usePropSeparateDevice(d,o),[E,R]=l.usePropSeparateDevice(m,o),[Y,C]=n.useState(!1),[q,w]=n.useState([]),I=e=>URL.createObjectURL(e),{uploadFileHandler:D=I}=p.useBuilder();n.useEffect((()=>{w(h?[{url:h,uid:h,name:h.substring(h.lastIndexOf("/")+1)}]:[])}),[h]),n.useEffect((()=>{h&&(async e=>{var t,i;try{const n=await fetch(e),o=await n.json(),r=Number(null!=(t=null==o?void 0:o.ip)?t:0),a=Number(null!=(i=null==o?void 0:o.op)?i:0),s=Math.max(0,Math.ceil(a-r));s>0&&(x(s),(!E||E<=0)&&R(Math.ceil(.95*s)))}catch(e){}})(h)}),[h]);const S={beforeUpload:e=>"application/json"===e.type||e.name.toLowerCase().endsWith(".json")?!!(e.size<20971520)||(t.notification.error({message:a.t("upload.file_size_limit")}),!1):(t.notification.error({message:a.t("upload.invalid_file_format")}),!1),customRequest:async e=>{const{file:i,onSuccess:n,onError:o}=e;try{C(!0);const e=await D(i,"json");v(e),n(i)}catch(e){t.notification.error({message:a.t("upload.cannot_upload_file")}),o(e,i)}finally{C(!1)}},listType:h?"picture":"picture-card",maxCount:1,multiple:!1,fileList:q,onRemove:()=>{v(""),x(void 0),R(void 0)},accept:".json,application/json"};return e.jsxs(e.Fragment,{children:[e.jsxs("div",{style:{marginBottom:16},children:[e.jsx("label",{style:{display:"block",marginBottom:8,fontWeight:"bold"},children:a.t("config_lottie_animation")}),e.jsx(O,{spinning:Y,children:e.jsx(K,(U=_({},S),N={children:h?null:e.jsx("div",{style:{width:"100%"},children:Y?e.jsx(i.LoadingOutlined,{}):e.jsxs(e.Fragment,{children:[e.jsx(i.UploadOutlined,{}),e.jsx("div",{style:{marginTop:4},children:a.t("upload_lottie_animation")})]})})},f(U,P(N))))})]}),e.jsx(u.InputNumberConfig,{propKey:m,separateDevice:o,formItemProps:{label:a.t("frame_to_show_popup")}}),e.jsx(u.InputNumberConfig,{propKey:b,separateDevice:o,formItemProps:{label:a.t("Chiều rộng")},unitProps:{defaultValue:r.UnitEnum.pixel}}),e.jsx(u.InputNumberConfig,{propKey:g,separateDevice:o,formItemProps:{label:a.t("Chiều cao")},unitProps:{defaultValue:r.UnitEnum.pixel}}),e.jsx(u.InputNumberConfig,{propKey:y,separateDevice:o,formItemProps:{label:a.t("Khoảng cách trên")},unitProps:{defaultValue:r.UnitEnum.pixel}})]});var U,N};


/***/ }),

/***/ 553226:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(610314),o=__webpack_require__(891987),n=__webpack_require__(800302),a=__webpack_require__(26308);function p(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var u=p(r),i=Object.defineProperty,l=Object.defineProperties,s=Object.getOwnPropertyDescriptors,f=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,d=Object.prototype.propertyIsEnumerable,b=(e,r,t)=>r in e?i(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,m=(e,r)=>{for(var t in r||(r={}))c.call(r,t)&&b(e,t,r[t]);if(f)for(var t of f(r))d.call(r,t)&&b(e,t,r[t]);return e},v=(e,r)=>{var t={};for(var o in e)c.call(e,o)&&r.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&f)for(var o of f(e))r.indexOf(o)<0&&d.call(e,o)&&(t[o]=e[o]);return t};const P=r=>{var t=r,{propKey:n,placeholder:p,unitProps:u={},usePropOptions:i,onChange:l,separateDevice:s,label:f,isDisabled:c}=t,d=v(t,["propKey","placeholder","unitProps","usePropOptions","onChange","separateDevice","label","isDisabled"]);const{defaultValue:b}=u,[P,x]=a.usePropSeparateDevice(n,s,i),y=o.useRef();o.useEffect((()=>{(null==d?void 0:d.defaultValue)&&!P&&x(d.defaultValue)}),[]);const O=m({ref:y,value:P,onChange:e=>{l?l(e):x(null===e?void 0:e)},placeholder:p||""},d);return e.jsx(j,m(m({},O),b&&{addonAfter:b}))},j=u.default(t.InputNumber)`
  border-radius: 4px !important;

  .ant-input-number {
    background-color: #f5f5f5;
    padding-left: 10px !important;
  }
  .ant-input-number-affix-wrapper {
    background-color: #f5f5f5;
    border: none !important;
  }
  .ant-input-number-group-addon {
    background-color: #f5f5f5;
    color: #00000080;
    border: none !important;
  }
  .ant-input-number-handler-wrap {
    display: none !important;
  }
`;exports.MinMaxInput=P,exports.MinMaxInputConfig=r=>{var t,o,a=r,{formItemProps:p,inputNumberProps:u}=a,i=v(a,["formItemProps","inputNumberProps"]);return e.jsx(n.FormItem,(t=m({},p),o={children:e.jsx(P,m(m({},i),u))},l(t,s(o))))};


/***/ }),

/***/ 272274:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(429830),o=__webpack_require__(891987),i=__webpack_require__(85097),t=__webpack_require__(964694),s=__webpack_require__(234741),c=__webpack_require__(26308),a=__webpack_require__(451633);exports.OverlayConfig=({propKey:p=s.PROP_KEY.CommonStyle,separateDevice:n})=>{const[u,P]=o.useState(!1),l=s.PROP_KEY.joinKey(p,s.PROP_KEY.BackgroundOverlayType),v=s.PROP_KEY.joinKey(p,s.PROP_KEY.BackgroundOverlay),[y,S]=c.usePropSeparateDevice(l,n),[h,j]=c.usePropSeparateDevice(v,n);return o.useEffect((()=>{(y||h)&&P(!0)}),[]),e.jsx(t.SwitchToShow,{show:u,setShow:e=>{e?(P(!0),S(i.OverlayType.color)):(P(!1),S(void 0),j(void 0))},formItemProps:{label:r.t("Lớp phủ nền")},children:e.jsx(a.ColorPickerConfigV3,{propKey:v,gradientPicker:!0,separateDevice:n})})};


/***/ }),

/***/ 62424:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(610314),o=__webpack_require__(26308),t=__webpack_require__(800302),a=Object.defineProperty,p=Object.defineProperties,i=Object.getOwnPropertyDescriptors,n=Object.getOwnPropertySymbols,s=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,c=(e,r,o)=>r in e?a(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,l=(e,r)=>{for(var o in r||(r={}))s.call(r,o)&&c(e,o,r[o]);if(n)for(var o of n(r))u.call(r,o)&&c(e,o,r[o]);return e};exports.RadioConfig=a=>{const c=a,{formItemProps:f,radioGroupProps:m,propKey:v,separateDevice:b}=c,d=((e,r)=>{var o={};for(var t in e)s.call(e,t)&&r.indexOf(t)<0&&(o[t]=e[t]);if(null!=e&&n)for(var t of n(e))r.indexOf(t)<0&&u.call(e,t)&&(o[t]=e[t]);return o})(c,["formItemProps","radioGroupProps","propKey","separateDevice"]),[j,O]=o.usePropSeparateDevice(v,b);return e.jsx(t.FormItem,(P=l({},f),y={children:e.jsx(r.Radio.Group,l(l({value:j,onChange:e=>O(e.target.value)},m),d))},p(P,i(y))));var P,y};


/***/ }),

/***/ 276879:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(772139),o=__webpack_require__(891987),t=__webpack_require__(610314),n=__webpack_require__(541054),i=__webpack_require__(800302);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=a(r),u=Object.defineProperty,l=Object.defineProperties,c=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,f=(e,r,o)=>r in e?u(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,v=(e,r)=>{for(var o in r||(r={}))d.call(r,o)&&f(e,o,r[o]);if(p)for(var o of p(r))m.call(r,o)&&f(e,o,r[o]);return e};const{RangePicker:P}=t.DatePicker;exports.RangePickerConfig=({propKeyStart:r,propKeyEnd:t,rangePickerProps:a,formItemProps:u})=>{const[p,d]=n.useProp(r),[m,f]=n.useProp(t),j=o.useMemo((()=>p&&m?[s.default(p),s.default(m)]:[void 0,void 0]),[p,m]);return e.jsx(i.FormItem,(b=v({},u),y={children:e.jsx(P,v({allowClear:!1,value:j,onChange:e=>{if(!e)return d(void 0),void f(void 0);let[r,o]=e;"DD-MM-YYYY HH:mm"===(null==a?void 0:a.format)&&(r=null==r?void 0:r.second(0),o=null==o?void 0:o.second(0)),d(r.toISOString()),f(o.toISOString())},format:"DD-MM-YYYY HH:mm:ss"},a))},l(b,c(y))));var b,y};


/***/ }),

/***/ 301842:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(610314),o=__webpack_require__(891987),l=__webpack_require__(514824),t=__webpack_require__(26308),n=__webpack_require__(541054),u=__webpack_require__(800302),i=Object.defineProperty,s=Object.defineProperties,a=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,d=Object.prototype.propertyIsEnumerable,v=(e,r,o)=>r in e?i(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,f=(e,r)=>{for(var o in r||(r={}))c.call(r,o)&&v(e,o,r[o]);if(p)for(var o of p(r))d.call(r,o)&&v(e,o,r[o]);return e},m=(e,r)=>s(e,a(r));exports.RangeSliderConfig=i=>{const{propKey:s,separateDevice:a,usePropOptions:v,formItemProps:j,inputNumberProps:b,showInput:y=!0,unitProps:P,className:g,sliderProps:h}=i,x=h||{},{defaultValue:O}=x,I=((e,r)=>{var o={};for(var l in e)c.call(e,l)&&r.indexOf(l)<0&&(o[l]=e[l]);if(null!=e&&p)for(var l of p(e))r.indexOf(l)<0&&d.call(e,l)&&(o[l]=e[l]);return o})(x,["defaultValue"]),[w,q]=t.usePropSeparateDevice(s,a,v),[C,N]=n.useProp(null==P?void 0:P.propKey);o.useEffect((()=>{void 0!==O&&void 0===w&&q(O),(null==P?void 0:P.propKey)&&(null==P?void 0:P.defaultValue)&&!C&&N&&N(null==P?void 0:P.defaultValue)}),[]);const D=e=>{q(null===e?null!=O?O:void 0:e)};return e.jsx(u.FormItem,m(f({},j),{layout:"vertical",children:e.jsxs(r.Row,{gutter:16,style:{alignItems:"center"},children:[e.jsx(r.Col,{style:{flexGrow:1},children:e.jsx(r.Slider,f({className:g,value:w,onChange:D},I))}),e.jsx(r.Col,{children:y?e.jsx(l.InputNumber,m(f(f({value:w,unitProps:P,onChange:D,controls:!1},b),I),{style:{width:(null==P?void 0:P.options)&&(null==P?void 0:P.options.length)>0?60:P?95:60},separateDevice:a})):e.jsxs(e.Fragment,{children:[null!=w?w:null==I?void 0:I.value,null==P?void 0:P.defaultValue]})})]})}))};


/***/ }),

/***/ 866196:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),i=__webpack_require__(610314),r=__webpack_require__(891987),l=__webpack_require__(429830),s=__webpack_require__(854680),a=__webpack_require__(191753),n=__webpack_require__(541054);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=o(t);const p=({aspectRatio:t,isActive:i,onClick:r,label:l})=>e.jsx(u,{onClick:r,style:{aspectRatio:t,backgroundColor:i?"#7367F0":"#747474"},children:a.displayRatio(l)||a.displayRatio(t)}),c=d.default.div`
  max-width: 100%;
  padding-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`,u=d.default.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #747474;
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
`,x=d.default.div`
  max-width: 250px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  > div {
    height: 35px;
  }
`,h=d.default.div`
  display: grid;
  grid-template-columns: repeat(4, 35px);
  gap: 8px;
`;exports.RatioConfig=({propKey:t,label:o})=>{const[d,u]=n.useProp(t),[f,y]=r.useState(""),[g,j]=r.useState(""),v=e=>{u(e)};return e.jsxs(c,{children:[e.jsxs("div",{style:{display:"flex",justifyContent:"space-between",alignItems:"center"},children:[e.jsx(i.Typography.Title,{level:4,style:{fontSize:14,fontWeight:500,marginBottom:0},children:o||l.t("ratio_setting.ratio")}),e.jsx("span",{style:{fontWeight:600},children:d})]}),e.jsx("div",{children:e.jsx(x,{children:s.ASPECT_RATIO_HORIZONTAL_OPTIONS.map((t=>e.jsx(p,{aspectRatio:t,isActive:t===d,onClick:()=>{v(t)}})))})}),e.jsx("div",{children:e.jsx(h,{children:s.ASPECT_RATIO_VERTICAL_OPTIONS.map((t=>e.jsx(p,{aspectRatio:t,isActive:t===d,onClick:()=>{v(t)}})))})}),e.jsx("div",{style:{marginTop:12},children:e.jsxs(i.Space,{children:[e.jsx(i.InputNumber,{placeholder:l.t("ratio_setting.width"),type:"number",value:f,onChange:e=>y(e),style:{width:70},controls:!1}),"/",e.jsx(i.InputNumber,{placeholder:l.t("ratio_setting.height"),type:"number",value:g,onChange:e=>j(e),style:{width:70},controls:!1}),e.jsx(i.Button,{onClick:()=>{var e;const t=`${f} / ${g}`,i=null==(e=null==t?void 0:t.replace(/\s*/g,""))?void 0:e.replace("/"," / ");i&&a.validateRatio(i)&&(y(""),j(""),u(i))},disabled:!g||!f,type:"primary",children:l.t("ratio_setting.apply")})]})})]})};


/***/ }),

/***/ 854680:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.ASPECT_RATIO_HORIZONTAL_OPTIONS=["16 / 9","4 / 3","3 / 2","5 / 4"],exports.ASPECT_RATIO_VERTICAL_OPTIONS=["9 / 16","2 / 3","3 / 4","1 / 1"];


/***/ }),

/***/ 191753:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.displayRatio=e=>{var t;return null==(t=null==e?void 0:e.replace(/\s*/g,""))?void 0:t.replace("/",":")},exports.validateRatio=e=>/^\d+\s{0,1}\/\s{0,1}\d+$/.test(e.trim());


/***/ }),

/***/ 359607:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097),l=__webpack_require__(610314),i=__webpack_require__(891987),o=__webpack_require__(429830),n=__webpack_require__(900109),s=__webpack_require__(2053),a=__webpack_require__(234741),c=__webpack_require__(541054),u=__webpack_require__(828426);function d(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var p=d(t),f=Object.defineProperty,h=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,j=Object.prototype.propertyIsEnumerable,y=(e,t,r)=>t in e?f(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,g=(e,t)=>{for(var r in t||(t={}))b.call(t,r)&&y(e,r,t[r]);if(h)for(var r of h(t))j.call(t,r)&&y(e,r,t[r]);return e};const{Option:v}=l.Select,x=p.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
`,P=p.default(l.Tag)`
  border-radius: 16px;
`,O=p.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
`,m=p.default.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 250px;
`;exports.SelectArticleWebsite=({propKey:t,selectProps:d})=>{const p=a.PROP_KEY.joinKey(t,a.PROP_KEY.Event,a.PROP_KEY.OpenArticleOfWebsite,a.PROP_KEY.PageId),[f]=c.useProp(p),h=f||(null==d?void 0:d.value),{globalData:b={}}=r.useStore(),{websiteId:j,currentLanguage:y}=b||{},{debounceFetchArticleOptions:w,fetchArticleOptions:S,options:A,loading:C,loadMore:q,loadingMore:E,hasMore:K,fetchArticleById:_,loadingLabelArticle:I,searchQuery:R}=s.useArticleOptions({websiteId:j,websiteTranslationId:null==y?void 0:y.id}),M=i.useRef(!1);i.useEffect((()=>{h&&_(h)}),[]);const Y=i.useCallback((e=>{const t=e.target;!C&&(null==t?void 0:t.scrollTop)+(null==t?void 0:t.offsetHeight)>=(null==t?void 0:t.scrollHeight)-10&&K&&q()}),[C,K,q]),k=i.useCallback((t=>e.jsxs(e.Fragment,{children:[t,E&&e.jsx(O,{children:e.jsx(l.Spin,{size:"small"})})]})),[E]);return e.jsx(u.SelectConfig,{formItemProps:{style:{marginBottom:"0.5rem"}},selectProps:g({placeholder:o.t("article"),style:{width:"100%"},popupMatchSelectWidth:!1,showSearch:!0,filterOption:!1,onSearch:w,notFoundContent:e.jsx(x,{children:C?e.jsx(l.Spin,{}):o.t("not_found_article")}),loading:C||I,onDropdownVisibleChange:async e=>{e&&(M.current&&!R.current||(await S(""),M.current=!0))},onPopupScroll:Y,dropdownRender:k,getPopupContainer:e=>e.parentElement,disabled:I},d),propKey:p,children:A.map(((t,r)=>{return e.jsx(v,{value:t.value,children:e.jsxs("div",{style:{display:"flex",justifyContent:"space-between"},children:[e.jsx(m,{title:null==t?void 0:t.label,children:t.label}),e.jsx("span",{children:(l=null==t?void 0:t.status,l===n.ArticleStatus.Published?e.jsx(P,{style:{borderRadius:16},color:"#29CC6A",children:o.t("published")}):e.jsx(P,{color:"#A7ABC3",children:o.t("draft")}))})]})},`${t.value}${r}`);var l}))})};


/***/ }),

/***/ 900109:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=(e=>(e.Draft="draft",e.Published="published",e))(e||{});exports.ArticleStatus=e;


/***/ }),

/***/ 2053:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(891987),t=__webpack_require__(313247);exports.useArticleOptions=r=>{const[l,n]=e.useState([]),{websiteId:i,websiteTranslationId:a}=r,{getPages:u}=t.useBuilder(),[s,o]=e.useState(!1),[c,d]=e.useState(!1),[v,p]=e.useState(!1),[g,b]=e.useState(!1),f=e.useRef(0),h=e.useRef(1),y=e.useRef(""),A=e=>({label:null==e?void 0:e.name,value:null==e?void 0:e.id,status:null==e?void 0:e.status}),I=e=>{o(!0),1===h.current&&n([]),y.current=e,f.current+=1;const t=f.current;return u({websiteId:i,searchQuery:e||void 0,page:h.current,pageSize:20,isArticle:!0,websiteTranslationId:a}).then((e=>{var r,l,i,a;if(t!==f.current)return;const u=null==(i=null==(l=null==(r=null==e?void 0:e.data)?void 0:r.pages)?void 0:l.map)?void 0:i.call(l,(e=>A(e))),s=(null==(a=null==e?void 0:e.pagination)?void 0:a.totalItems)||0;return n((e=>1===h.current?u:[...e,...u])),p(s>20*h.current),u})).catch((e=>{n([])})).finally((()=>{o(!1)}))};return{loadMore:e.useCallback((async()=>{try{d(!0),h.current+=1,await I(y.current)}finally{d(!1)}d(!1)}),[]),debounceFetchArticleOptions:e.useMemo((()=>{let e;return t=>{e&&clearTimeout(e),e=setTimeout((()=>{h.current=1,I(t)}),500)}}),[]),loading:s,hasMore:v,options:l,setOptions:n,setLoading:o,fetchArticleOptions:I,loadingMore:c,convertArticleOption:A,fetchArticleById:e=>(b(!0),u({websiteId:i,page:1,pageSize:20,isArticle:!0,websiteTranslationId:a,ids:e}).then((e=>{var t,r,l;const i=null==(l=null==(r=null==(t=null==e?void 0:e.data)?void 0:t.pages)?void 0:r.map)?void 0:l.call(r,(e=>A(e)));n(i)})).catch((e=>{})).finally((()=>{b(!1)}))),loadingLabelArticle:g,searchQuery:y}};


/***/ }),

/***/ 828426:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(429830),t=__webpack_require__(610314),o=__webpack_require__(212951),n=__webpack_require__(891987),l=__webpack_require__(800302),i=__webpack_require__(26308);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=s(o),u=Object.defineProperty,p=Object.defineProperties,c=Object.getOwnPropertyDescriptors,f=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,v=Object.prototype.propertyIsEnumerable,y=(e,r,t)=>r in e?u(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,m=(e,r)=>{for(var t in r||(r={}))d.call(r,t)&&y(e,t,r[t]);if(f)for(var t of f(r))v.call(r,t)&&y(e,t,r[t]);return e},j=(e,r)=>p(e,c(r)),O=(e,r)=>{var t={};for(var o in e)d.call(e,o)&&r.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&f)for(var o of f(e))r.indexOf(o)<0&&v.call(e,o)&&(t[o]=e[o]);return t};const b=t=>{var o=t,{propKey:l,options:s,separateDevice:a,usePropOptions:u,requireExistedValue:p,value:c}=o,f=O(o,["propKey","options","separateDevice","usePropOptions","requireExistedValue","value"]);const[d,v]=i.usePropSeparateDevice(l,a,u),y=n.useRef(!1);return n.useEffect((()=>{y.current=!1}),[JSON.stringify(s)]),e.jsx(x,j(m({style:{width:130},dropdownStyle:{zIndex:1080},value:(()=>{let e=null!=c?c:d;return p&&!y.current&&-1===(null==s?void 0:s.findIndex((({value:r})=>r===e)))&&(e=null),e})(),onChange:v,options:s,placeholder:r.t("Chọn giá trị")},f),{onSelect:()=>y.current=!0}))},x=a.default(t.Select)`
  .ant-select-selector {
    border-radius: 4px !important;
  }
`;exports.Select=b,exports.SelectConfig=r=>{const t=r,{formItemProps:o,selectProps:n}=t,i=O(t,["formItemProps","selectProps"]),{layout:s="horizontal"}=o||{};return e.jsx(l.FormItem,j(m({layout:s},o),{children:e.jsx(b,m(m({allowClear:!0,style:{width:"vertical"===s?"100%":130}},n),i))}))};


/***/ }),

/***/ 849041:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(429830),o=__webpack_require__(212951),i=__webpack_require__(541054),t=__webpack_require__(234741),n=__webpack_require__(350461),p=__webpack_require__(541055),s=__webpack_require__(301842);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=a(o);const m={x:{min:-125,max:125},y:{min:-125,max:125},blur:{min:0,max:120},spread:{min:-125,max:125}},u=l.default.div`
  display: flex;
  max-width: 100%;
  height: 32px;
  margin-bottom: 28px;
  box-shadow: 0 2px 5px var(--box-shadow-color);
`,d=l.default.div`
  flex: 1;
  min-width: 0;
`,x=l.default.div`
  text-transform: capitalize;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  padding: 4px 4px 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;exports.ShadowConfig=({propKey:o=t.PROP_KEY.joinKey(t.PROP_KEY.CommonStyle,t.PROP_KEY.Shadow),shadowProps:a=["x","y","blur","spread"]})=>{const[l]=i.useProp(t.PROP_KEY.joinKey(o,"on")),f=a.map((e=>({label:e,inputNumberProps:m[e],propKey:t.PROP_KEY.joinKey(o,e)})));return e.jsxs(e.Fragment,{children:[e.jsx(n.SwitchConfig,{formItemProps:{label:r.t("Đổ bóng")},propKey:`${o}.on`}),l&&e.jsxs(e.Fragment,{children:[e.jsx(u,{children:f.map((({label:r,propKey:o,inputNumberProps:i})=>e.jsxs(d,{children:[e.jsx(p.InputNumberConfigV2,{propKey:o,formItemProps:{style:{marginBottom:0}},inputNumberProps:i,style:{width:"100%"}}),e.jsx(x,{children:r})]},o)))}),e.jsx(s.RangeSliderConfig,{formItemProps:{label:r.t("Độ đậm")},propKey:`${o}.opacity`,sliderProps:{min:0,max:1,defaultValue:.25,step:.25}})]})]})};


/***/ }),

/***/ 148332:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),o=__webpack_require__(26308),t=__webpack_require__(541055);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=n(r),u=Object.defineProperty,l=Object.defineProperties,p=Object.getOwnPropertyDescriptors,a=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,s=Object.prototype.propertyIsEnumerable,d=(e,r,o)=>r in e?u(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,b=(e,r)=>{for(var o in r||(r={}))c.call(r,o)&&d(e,o,r[o]);if(a)for(var o of a(r))s.call(r,o)&&d(e,o,r[o]);return e},f=(e=>(e.top="top",e.right="right",e.bottom="bottom",e.left="left",e.main="main",e))(f||{});const m=i.default.div`
  display: inline-block;
  width: 100%;

  .ant-input-number {
    background-color: #f1f2f6;
    width: 100%;
    border: none !important;
  }

  .ant-input-number-group-addon {
    background-color: #f1f2f6;
    border: none !important;
  }
`;exports.PositionEnum=f,exports.SpacingConfigItemConfig=({propKey:r,positions:n,icon:i,placeholder:u,separateDevice:a=!0})=>{const[c,s]=o.usePropSeparateDevice(r,a),d=1===(null==n?void 0:n.length)?null==c?void 0:c[n[0]]:n.map((e=>null==c?void 0:c[e]))[0];return e.jsx(m,{children:e.jsx(t.InputNumberConfigV2,{propKey:void 0,displayUnit:!1,style:{backgroundColor:"#F1F2F6"},iconBeforeAddon:i,inputNumberProps:{value:d,onChange:e=>{const r=null!==e?e:void 0;let o=c;o=b(b({},o),Object.values(n).reduce(((e,o)=>{return t=b({},e),l(t,p({[o]:r}));var t}),{})),s(o)},placeholder:u,style:{width:"100%"},controls:!1}})})};


/***/ }),

/***/ 968965:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var i=__webpack_require__(561261),e=__webpack_require__(212951),o=__webpack_require__(143599),t=__webpack_require__(610314),n=__webpack_require__(891987),s=__webpack_require__(429830),r=__webpack_require__(148332),p=__webpack_require__(541054),a=__webpack_require__(234741),l=__webpack_require__(26308);function c(i){return i&&"object"==typeof i&&"default"in i?i:{default:i}}var u=c(e),f=Object.defineProperty,d=Object.getOwnPropertySymbols,m=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,v=(i,e,o)=>e in i?f(i,e,{enumerable:!0,configurable:!0,writable:!0,value:o}):i[e]=o;const x=u.default.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
`,P=u.default.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
`,j=u.default.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
`,y=u.default(o.Icon)`
  cursor: pointer;
  flex-shrink: 0;
  margin-top: 4px;
  font-size: 20px;
  color: ${i=>(null==i?void 0:i.isActive)?"#7367f0":"inherit"};

  &:hover {
    opacity: 0.7;
  }
`;exports.SpacingConfig=({propKey:e,title:c,separateDevice:u=!0})=>{const[f,E]=p.useProp(a.PROP_KEY.joinKey(e,a.PROP_KEY.OpenFourPosition)),[h,S]=l.usePropSeparateDevice(e,u);return n.useEffect((()=>{if(h&&void 0===f){const i=h[r.PositionEnum.top],e=h[r.PositionEnum.bottom],o=h[r.PositionEnum.left],t=h[r.PositionEnum.right];if(void 0!==i&&void 0!==e&&void 0!==o&&void 0!==t&&(i!==e||o!==t))return void E(!0)}}),[h]),n.useEffect((()=>{if(!1===f&&h){const i=h[r.PositionEnum.top],e=h[r.PositionEnum.bottom],o=h[r.PositionEnum.left],t=h[r.PositionEnum.right],n=((i,e)=>{for(var o in e||(e={}))m.call(e,o)&&v(i,o,e[o]);if(d)for(var o of d(e))g.call(e,o)&&v(i,o,e[o]);return i})({},h);void 0!==i&&void 0!==e&&i!==e?n[r.PositionEnum.bottom]=i:void 0===i&&void 0!==e?n[r.PositionEnum.top]=e:void 0!==i&&void 0===e&&(n[r.PositionEnum.bottom]=i),void 0!==o&&void 0!==t&&o!==t?n[r.PositionEnum.right]=o:void 0===o&&void 0!==t?n[r.PositionEnum.left]=t:void 0!==o&&void 0===t&&(n[r.PositionEnum.right]=o),S(n)}}),[f]),i.jsxs(x,{children:[i.jsx("label",{children:c}),i.jsxs(P,{children:[i.jsx(j,{children:f?i.jsxs(i.Fragment,{children:[i.jsx(r.SpacingConfigItemConfig,{icon:i.jsx(o.Icon,{name:"AlignTopSpaceOutlined",style:{fontSize:16}}),propKey:e,positions:[r.PositionEnum.top],separateDevice:u}),i.jsx(r.SpacingConfigItemConfig,{icon:i.jsx(o.Icon,{name:"AlignLeftSpaceOutlined",style:{fontSize:16}}),propKey:e,positions:[r.PositionEnum.left],separateDevice:u}),i.jsx(r.SpacingConfigItemConfig,{icon:i.jsx(o.Icon,{name:"AlignBottomSpaceOutlined",style:{fontSize:16}}),propKey:e,positions:[r.PositionEnum.bottom],separateDevice:u}),i.jsx(r.SpacingConfigItemConfig,{icon:i.jsx(o.Icon,{name:"AlignRightSpaceOutlined",style:{fontSize:16}}),propKey:e,positions:[r.PositionEnum.right],separateDevice:u})]}):i.jsxs(i.Fragment,{children:[i.jsx(r.SpacingConfigItemConfig,{icon:i.jsx(o.Icon,{name:"AlignVerticalSpaceOutlined",style:{fontSize:16}}),propKey:e,positions:[r.PositionEnum.top,r.PositionEnum.bottom],separateDevice:u}),i.jsx(r.SpacingConfigItemConfig,{icon:i.jsx(o.Icon,{name:"AlignHorizontalSpaceOutlined",style:{fontSize:16}}),propKey:e,positions:[r.PositionEnum.left,r.PositionEnum.right],separateDevice:u})]})}),i.jsx(t.Tooltip,{zIndex:2e3,placement:"topRight",title:f?s.t("spacing_config.pooling_value.tool_tip"):s.t("spacing_config.separate_value.tool_tip"),children:i.jsx("span",{style:{display:"inline-flex"},children:i.jsx(y,{name:"FourPointSpacingOutlined",isActive:f,onClick:()=>{E(!f)}})})})]})]})};


/***/ }),

/***/ 350461:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(429830),t=__webpack_require__(610314),o=__webpack_require__(26308),i=__webpack_require__(800302),c=Object.defineProperty,n=Object.defineProperties,s=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,a=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,l=(e,r,t)=>r in e?c(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,j=(e,r)=>{for(var t in r||(r={}))a.call(r,t)&&l(e,t,r[t]);if(p)for(var t of p(r))u.call(r,t)&&l(e,t,r[t]);return e};exports.SwitchConfig=c=>{const{propKey:p,switchProps:a,formItemProps:u,separateDevice:l=!1}=c,[m,b]=o.usePropSeparateDevice(p,l);return e.jsx(i.FormItem,(h=j({},u),d={children:e.jsx(t.Switch,j({checkedChildren:r.t("Bật"),unCheckedChildren:r.t("Tắt"),checked:m,onChange:e=>b(e)},a))},n(h,s(d))));var h,d};


/***/ }),

/***/ 283311:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(234741),n=__webpack_require__(728567);exports.TekoTrackingConfig=({propKey:o=t.PROP_KEY.Event,separateDevice:r})=>{const a=t.PROP_KEY.joinKey(o,t.PROP_KEY.TekoTrackingEvent,t.PROP_KEY.RegionName),i=t.PROP_KEY.joinKey(o,t.PROP_KEY.TekoTrackingEvent,t.PROP_KEY.ContentName),p=t.PROP_KEY.joinKey(o,t.PROP_KEY.TekoTrackingEvent,t.PROP_KEY.Target),s=t.PROP_KEY.joinKey(o,t.PROP_KEY.TekoTrackingEvent,t.PROP_KEY.Payload);return e.jsxs(e.Fragment,{children:[e.jsx(n.InputConfig,{separateDevice:r,propKey:a,formItemProps:{label:"Region name",style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"0.5rem"}},inputProps:{placeholder:"Region name",style:{width:"180px"}}}),e.jsx(n.InputConfig,{separateDevice:r,propKey:i,formItemProps:{label:"Content name",style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"0.5rem"}},inputProps:{placeholder:"Content name",style:{width:"180px"}}}),e.jsx(n.InputConfig,{separateDevice:r,propKey:p,formItemProps:{label:"Target",style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"0.5rem"}},inputProps:{placeholder:"Target",style:{width:"180px"}}}),e.jsx(n.InputConfig,{separateDevice:r,propKey:s,formItemProps:{label:"Payload",style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"0.5rem"}},inputProps:{placeholder:"Payload",style:{width:"180px"}}})]})};


/***/ }),

/***/ 991653:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(959211),t=__webpack_require__(610314),o=__webpack_require__(26308),i=__webpack_require__(234741),n=__webpack_require__(800302),s=Object.defineProperty,c=Object.defineProperties,a=Object.getOwnPropertyDescriptors,l=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,P=(e,r,t)=>r in e?s(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;exports.TextConfig=s=>{const{propKey:j,separateDevice:y,formItemProps:x}=s,{token:{colorPrimary:d}}=t.theme.useToken(),[v,O]=o.usePropSeparateDevice(i.PROP_KEY.joinKey(j,i.PROP_KEY.FontWeight),y),[m,b]=o.usePropSeparateDevice(i.PROP_KEY.joinKey(j,i.PROP_KEY.FontStyle),y),[f,K]=o.usePropSeparateDevice(i.PROP_KEY.joinKey(j,i.PROP_KEY.TextDecoration),y);return e.jsx(n.FormItem,(R=((e,r)=>{for(var t in r||(r={}))p.call(r,t)&&P(e,t,r[t]);if(l)for(var t of l(r))u.call(r,t)&&P(e,t,r[t]);return e})({},x),g={children:e.jsxs(t.Space,{children:[e.jsx(t.Button,{style:{color:v?d:void 0},type:"text",icon:e.jsx(r.TextBold16Regular,{}),onClick:()=>{O(v?void 0:"bold")}}),e.jsx(t.Button,{style:{color:m?d:void 0},type:"text",icon:e.jsx(r.TextItalic16Regular,{}),onClick:()=>{b(m?void 0:"italic")}}),e.jsx(t.Button,{style:{color:f?d:void 0},type:"text",icon:e.jsx(r.TextUnderline16Regular,{}),onClick:()=>{K(f?void 0:"underline")}})]})},c(R,a(g))));var R,g};


/***/ }),

/***/ 379386:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(610314),t=__webpack_require__(891987),o=__webpack_require__(541054),a=__webpack_require__(800302),l=Object.defineProperty,s=Object.defineProperties,i=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,n=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,c=(e,r,t)=>r in e?l(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,m=(e,r)=>{for(var t in r||(r={}))n.call(r,t)&&c(e,t,r[t]);if(u)for(var t of u(r))p.call(r,t)&&c(e,t,r[t]);return e},b=(e,r)=>s(e,i(r));exports.TextareaToOptionConfig=({textareaProps:l,formItemProps:s,propKey:i})=>{const[u,n]=t.useState(""),[p,c]=o.useProp(i);return t.useEffect((()=>{n((p||[]).reduce(((e,r)=>r.label===r.value?`${e}${r.label}\n`:`${e}${r.label} | ${r.value}\n`),""))}),[]),e.jsx(a.FormItem,b(m({},s),{children:e.jsx(r.Input.TextArea,b(m({},l),{value:u,onChange:e=>{n(e.target.value),(e=>{const r=[];e.trim().split("\n").map((e=>e.trim())).filter(Boolean).forEach((e=>{e.includes("|")?r.push({label:e.split("|")[0].trim(),value:e.split("|")[1].trim()}):r.push({label:e.trim(),value:e.trim()})})),c(r)})(e.target.value)}}))}))};


/***/ }),

/***/ 571765:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=l(__webpack_require__(212951));const t=[{label:"CN",value:0},{label:"T2",value:1},{label:"T3",value:2},{label:"T4",value:3},{label:"T5",value:4},{label:"T6",value:5},{label:"T7",value:6}],r=a.default.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  border: 1px solid #d8d6de;
  border-radius: 4px;
  max-width: 320px;
`,u=a.default.div`
  &.active,
  &:hover {
    color: #7367f0;
  }
  padding: 4px 8px;
  cursor: pointer;
`;exports.SelectSegment=({arrSelected:l=[1],onchange:a})=>e.jsx(r,{children:t.map((t=>e.jsx(u,{className:l.includes(t.value)?"active":"",onClick:()=>{const e=!l.includes(t.value);(e||!e&&(null==l?void 0:l.length)>1)&&a(t.value)},children:t.label},t.value)))});


/***/ }),

/***/ 133501:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),i=__webpack_require__(429830),t=__webpack_require__(610314),r=__webpack_require__(610796),o=__webpack_require__(731006),n=__webpack_require__(26308),a=__webpack_require__(234741),s=Object.defineProperty,P=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,l=Object.prototype.propertyIsEnumerable,u=(e,i,t)=>i in e?s(e,i,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[i]=t,c=(e,i)=>{for(var t in i||(i={}))p.call(i,t)&&u(e,t,i[t]);if(P)for(var t of P(i))l.call(i,t)&&u(e,t,i[t]);return e};exports.TimeVisibilityConfig=({propKey:s,separateDevice:P=!1,visible:p,setVisible:l})=>{const[u,y]=n.usePropSeparateDevice(a.PROP_KEY.joinKey(s,a.PROP_KEY.TimeVisibility,a.PROP_KEY.StartTime),P),[d,m]=n.usePropSeparateDevice(a.PROP_KEY.joinKey(s,a.PROP_KEY.TimeVisibility,a.PROP_KEY.EndTime),P),[O,b]=n.usePropSeparateDevice(a.PROP_KEY.joinKey(s,a.PROP_KEY.TimeVisibility,a.PROP_KEY.RuleRepeat),P),[K,R]=n.usePropSeparateDevice(a.PROP_KEY.joinKey(s,a.PROP_KEY.TimeVisibility,a.PROP_KEY.Date),P),[j,E]=n.usePropSeparateDevice(a.PROP_KEY.joinKey(s,a.PROP_KEY.TimeVisibility,a.PROP_KEY.Duration),P),{document:_}=r.useFrame();return e.jsx(e.Fragment,{children:e.jsx(t.Modal,{title:i.t("Đặt giờ hiển thị"),onCancel:()=>l(!1),open:p,destroyOnClose:!0,bodyStyle:{paddingTop:0},getContainer:()=>(null==_?void 0:_.body)||(null==document?void 0:document.body),closable:!1,footer:[e.jsx(t.Button,{type:"primary",shape:"round",onClick:()=>l(!1),children:i.t("Đóng")})],zIndex:1080,children:e.jsx(o.TimingConfig,c({},{startTime:u,endTime:d,ruleRepeat:O,date:K,duration:j,setDate:R,setStartTime:y,setEndTime:m,setRuleRepeat:b,setDuration:E}))})})};


/***/ }),

/***/ 731006:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),n=__webpack_require__(772139),a=__webpack_require__(891987),i=__webpack_require__(85097),l=__webpack_require__(610314),u=__webpack_require__(571765),r=__webpack_require__(429830),o=__webpack_require__(828426),s=__webpack_require__(800302),m=__webpack_require__(514824);function p(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=p(t),c=p(n);const R=e=>{if(c.default.isDayjs(e))return c.default(e).toISOString()},h=d.default(l.DatePicker)`
  width: 100%;
`,E=d.default.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`,v=d.default(l.DatePicker.RangePicker)`
  width: 100%;
`;exports.TimingConfig=({startTime:t,endTime:n,ruleRepeat:l,date:p,duration:d,setStartTime:f,setEndTime:g,setRuleRepeat:y,setDate:T,setDuration:j})=>{var D;const[b,x]=a.useState(),[C,Y]=a.useState(""),[I,A]=a.useState(),[U,S]=a.useState(),[N,$]=a.useState(""),[O,M]=a.useState(),[F,L]=a.useState(),q="DD/MM/YYYY HH:mm:ss";a.useEffect((()=>{if(d){const[e,t]=d;M(e),L(t)}w()}),[]);const w=()=>{var e;if(!l)return void((t||n)&&$(i.RepeatTypeEnum.NO_REPEAT));const a=i.parseRuleRepeat(i.RuleRepeatEnum.FREQ,l),u=i.parseRuleRepeat(i.RuleRepeatEnum.INTERVAL,l)||"1",r=i.parseRuleRepeat(i.RuleRepeatEnum.UNTIL,l),o=i.parseRuleRepeat(i.RuleRepeatEnum.BYDAY,l);S(parseInt(u)),a&&x(a),r&&Y(r),o&&A(null==(e=o.split(","))?void 0:e.map((e=>parseInt(e)))),(a===i.UnitRepeatEnum.DURATION||t||n)&&$(i.RepeatTypeEnum.NO_REPEAT),1==+u&&a===i.UnitRepeatEnum.DAY&&$(i.RepeatTypeEnum.DAILY),(+u>1||a!==i.UnitRepeatEnum.DAY&&a!==i.UnitRepeatEnum.DURATION)&&$(i.RepeatTypeEnum.CUSTOM)},P=e=>{if(void 0===e)return;const t=p?c.default(p):c.default(),n=Math.floor(e/60),a=e-60*n;return t.hour(n).minute(a)},k=(e,t)=>{e&&t&&c.default(e).isAfter(t)?(f(t),g(e)):(f(e),g(t))};a.useEffect((()=>{H({freq:b,byDay:null==I?void 0:I.join(","),until:C,interval:U})}),[b,I,C,N,U]);const H=({freq:e,byDay:t,until:n,interval:a})=>{const u=`${e?`${i.RuleRepeatEnum.FREQ}:${e};`:""}${a?`${i.RuleRepeatEnum.INTERVAL}:${a};`:""}${t?`${i.RuleRepeatEnum.BYDAY}:${t};`:""}${n?`${i.RuleRepeatEnum.UNTIL}:${n};`:""}`;(l||u)&&y(u)},B=e=>{const[t,n]=e||[void 0,void 0],a=t?60*t.hour()+t.minute():void 0,i=n?60*n.hour()+n.minute():void 0;M(a),L(i),j(void 0!==a&&void 0!==i?[a,i]:void 0)},K=(e,t,n)=>{if(!n||t!==i.UnitRepeatEnum.YEAR&&t!==i.UnitRepeatEnum.MONTH)return"";const a={month:r.t("tháng"),year:r.t("năm")},l=t==i.UnitRepeatEnum.YEAR?"DD/MM":"DD";return`${e>1?`${e} ${a[t.toLowerCase()]} ${r.t("một lần")}`:`${r.t("Hàng")} ${a[t.toLowerCase()]}`} ${r.t("vào ngày")} ${c.default(n).format(l)}`},_=a.useRef(null);return e.jsxs(e.Fragment,{children:[e.jsx("div",{ref:_,style:{display:"none"}}),e.jsx(o.SelectConfig,{options:[{label:r.t("Luôn hiển thị"),value:""},{label:r.t("Khoảng thời gian"),value:i.RepeatTypeEnum.NO_REPEAT},{label:r.t("Lặp lại hàng ngày"),value:i.RepeatTypeEnum.DAILY},{label:r.t("Tùy chỉnh"),value:i.RepeatTypeEnum.CUSTOM}],formItemProps:{label:r.t("Kiểu hiển thị"),layout:"vertical"},selectProps:{style:{width:"100%"},value:N,onChange:e=>{switch(f(void 0),g(void 0),T(void 0),B(void 0),S(void 0),x(void 0),A(void 0),Y(void 0),$(e),e){case i.RepeatTypeEnum.CUSTOM:x(i.UnitRepeatEnum.WEEK),A([1]),S(1);break;case i.RepeatTypeEnum.DAILY:x(i.UnitRepeatEnum.DAY),S(1);break;case i.RepeatTypeEnum.NO_REPEAT:x(i.UnitRepeatEnum.DURATION)}},allowClear:!1}}),N===i.RepeatTypeEnum.NO_REPEAT&&e.jsxs(e.Fragment,{children:[e.jsx(s.FormItem,{label:r.t("Thời gian bắt đầu"),layout:"vertical",children:e.jsx(h,{showTime:!0,placeholder:r.t("Chọn thời gian bắt đầu"),disabledDate:e=>!!n&&(null==e?void 0:e.isAfter(n,"day")),format:q,value:t?c.default(t):void 0,onChange:e=>k(R(e),n)})}),e.jsx(s.FormItem,{label:r.t("Thời gian kết thúc"),layout:"vertical",children:e.jsx(h,{showTime:!0,placeholder:r.t("Chọn thời gian kết thúc"),disabledDate:e=>!!t&&(null==e?void 0:e.isBefore(t,"day")),format:q,value:n?c.default(n):void 0,onChange:e=>k(t,R(e))})})]}),(N===i.RepeatTypeEnum.CUSTOM||N===i.RepeatTypeEnum.DAILY)&&e.jsxs(e.Fragment,{children:[(!!(U&&U>1)||b!==i.UnitRepeatEnum.WEEK&&b!==i.UnitRepeatEnum.DAY)&&e.jsxs(e.Fragment,{children:[e.jsx(s.FormItem,{label:r.t("Lặp lại mỗi"),style:{marginBottom:0},children:e.jsxs(E,{children:[e.jsx(m.InputNumberConfig,{inputNumberProps:{min:1,value:U,onChange:e=>S(e)}}),e.jsx(o.SelectConfig,{options:[{label:r.t("Ngày"),value:i.UnitRepeatEnum.DAY},{label:r.t("Tuần"),value:i.UnitRepeatEnum.WEEK},{label:r.t("Tháng"),value:i.UnitRepeatEnum.MONTH},{label:r.t("Năm"),value:i.UnitRepeatEnum.YEAR}],selectProps:{value:b,onChange:e=>{x(e)}}})]})}),!!U&&!!b&&!!K(U,b,p)&&e.jsx("div",{style:{marginBottom:16,color:"#82869E"},children:K(U,b,p)})]}),b===i.UnitRepeatEnum.WEEK&&e.jsx(s.FormItem,{label:r.t("Lặp lại vào"),layout:"vertical",children:e.jsx(u.SelectSegment,{arrSelected:I,onchange:e=>{A((t=>{const n=null==t?void 0:t.indexOf(e);if(void 0!==n){if(n<0)return[...t||[],e];{const e=[...t||[]];return e.splice(n,1),e}}}))}})}),e.jsx(s.FormItem,{label:r.t("Hiển thị trong khung giờ"),layout:"vertical",children:e.jsx(v,{placeholder:[r.t("Bắt đầu"),r.t("Kết thúc")],format:"HH:mm",picker:"time",value:[P(O),P(F)],changeOnBlur:(null==(D=null==_?void 0:_.current)?void 0:D.ownerDocument)!==document,allowClear:!0,onChange:B})}),e.jsx(s.FormItem,{label:r.t("Ngày bắt đầu"),layout:"vertical",children:e.jsx(h,{placeholder:r.t("Chọn thời gian bắt đầu"),value:p?c.default(p):void 0,format:"DD/MM/YYYY",onChange:e=>T(R(e))})}),e.jsx(s.FormItem,{label:r.t("Ngày kết thúc"),layout:"vertical",children:e.jsx(h,{placeholder:r.t("Chọn thời gian kết thúc"),format:"DD/MM/YYYY",value:C?c.default(C):void 0,onChange:e=>Y(R(e))})})]})]})};


/***/ }),

/***/ 246685:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(429830),r=__webpack_require__(891987),n=__webpack_require__(85097),o=__webpack_require__(234741),i=__webpack_require__(26308),a=__webpack_require__(728567),s=__webpack_require__(828426),l=__webpack_require__(514824),u=__webpack_require__(800302);function p(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}function c(e){if(e&&e.__esModule)return e;var t=Object.create(null);return e&&Object.keys(e).forEach((function(r){if("default"!==r){var n=Object.getOwnPropertyDescriptor(e,r);Object.defineProperty(t,r,n.get?n:{enumerable:!0,get:function(){return e[r]}})}})),t.default=e,Object.freeze(t)}var f=p(r);const d=f.default.lazy((()=>Promise.resolve().then((function(){return c(__webpack_require__(680300))})))),h=[{label:"CompleteRegistration",value:"CompleteRegistration"},{label:"Purchase",value:"Purchase"},{label:"Lead",value:"Lead"}];exports.TrackingConfig=({propKey:p=o.PROP_KEY.Event,config:c="event",separateDevice:m})=>{const P=o.PROP_KEY.joinKey(p,o.PROP_KEY.TrackingEventName),y=o.PROP_KEY.joinKey(p,o.PROP_KEY.ConversionValue),g=o.PROP_KEY.joinKey(p,o.PROP_KEY.ConversionGGAdsId),j=o.PROP_KEY.joinKey(p,o.PROP_KEY.ConversionGGAdsLabel),v=o.PROP_KEY.joinKey(p,o.PROP_KEY.ScriptCustom),[b,C]=i.usePropSeparateDevice(v,m),[K,x]=r.useState(null);return r.useEffect((()=>{var e,t;return null==(t=null==(e=null==K?void 0:K.editor)?void 0:e.renderer)||t.attachToShadowRoot(),()=>{var e,t;null==(t=null==(e=null==K?void 0:K.editor)?void 0:e.renderer)||t.attachToShadowRoot()}})),e.jsxs(e.Fragment,{children:["event"===c&&e.jsx(a.InputConfig,{separateDevice:m,propKey:P,formItemProps:{label:t.t("Tên sự kiện FB/GA"),style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"0.5rem"}},inputProps:{placeholder:t.t("Nhập tên sự kiện"),style:{width:"180px"}}}),"form"===c&&e.jsxs(e.Fragment,{children:[e.jsx(s.SelectConfig,{separateDevice:m,propKey:P,options:h,formItemProps:{label:t.t("Mã chuyển đổi FB/GA")},selectProps:{placeholder:t.t("Chọn mã chuyển đổi"),allowClear:!0}}),e.jsx(l.InputNumberConfig,{separateDevice:m,propKey:y,formItemProps:{label:t.t("Giá trị chuyển đổi")},inputNumberProps:{placeholder:"0",min:0,style:{width:"180px"}}})]}),e.jsx(a.InputConfig,{separateDevice:m,propKey:g,formItemProps:{label:t.t("ID chuyển đổi Google Ads"),style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"0.5rem"}},inputProps:{placeholder:t.t("ID chuyển đổi"),style:{width:"180px"}}}),e.jsx(a.InputConfig,{separateDevice:m,propKey:j,formItemProps:{label:t.t("Nhãn chuyển đổi Google Ads"),style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"0.5rem"}},inputProps:{placeholder:t.t("Nhãn chuyển đổi"),style:{width:"180px"}}}),e.jsx(f.default.Suspense,{fallback:e.jsx("div",{}),children:e.jsx(u.FormItem,{label:t.t("Mã tùy chỉnh nâng cao (không bắt buộc)"),children:e.jsx(d,{ref:e=>x(e),placeholder:"VD: fbq('track', 'Purchase', {currency: 'VND', value: 300000})",mode:"javascript",fontSize:14,height:"200px",width:"100%",setOptions:{showLineNumbers:!0,tabSize:2},highlightActiveLine:!0,value:n.unescapeString(b),onChange:e=>C(n.escapeString(e)),showPrintMargin:!0,showGutter:!0})})})]})};


/***/ }),

/***/ 187510:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(85097),r=__webpack_require__(212951),o=__webpack_require__(828426);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var n=a(r),l=Object.defineProperty,i=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,s=(e,t,r)=>t in e?l(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,c=(e,t)=>{for(var r in t||(t={}))p.call(t,r)&&s(e,r,t[r]);if(i)for(var r of i(t))u.call(t,r)&&s(e,r,t[r]);return e};const f=n.default(o.Select)`
  .ant-select-selector {
    border-radius: 0 4px 4px 0px !important;
  }
`;exports.UnitConfig=({propKey:r,options:o=[],defaultValue:a=t.UnitEnum.pixel,separateDevice:n,onChange:l,style:i})=>e.jsx(f,{style:c({width:60},i),propKey:r,defaultValue:a,options:o.map((e=>({value:e,label:e}))),separateDevice:n,onChange:l});


/***/ }),

/***/ 725721:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(959211),o=__webpack_require__(610314),i=__webpack_require__(85097),n=__webpack_require__(26308),l=__webpack_require__(800302);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=a(r),u=Object.defineProperty,c=Object.defineProperties,p=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,j=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,b=(e,r,t)=>r in e?u(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;const x=s.default.span`
  vertical-align: -webkit-baseline-middle;
`;exports.VerticalAlignmentConfig=({propKey:r,formItemProps:a,separateDevice:s=!1})=>{const[u,f]=n.usePropSeparateDevice(r,s);return e.jsx(l.FormItem,(g=((e,r)=>{for(var t in r||(r={}))j.call(r,t)&&b(e,t,r[t]);if(d)for(var t of d(r))m.call(r,t)&&b(e,t,r[t]);return e})({},a),v={children:e.jsxs(o.Radio.Group,{onChange:e=>{f(e.target.value)},value:u,buttonStyle:"solid",children:[e.jsx(o.Radio.Button,{value:i.VerticalAlignment.top,children:e.jsx(x,{children:e.jsx(t.TextboxAlignTopRegular,{fontSize:20})})}),e.jsx(o.Radio.Button,{value:i.VerticalAlignment.center,children:e.jsx(x,{children:e.jsx(t.TextboxAlignMiddleRegular,{fontSize:20})})}),e.jsx(o.Radio.Button,{value:i.VerticalAlignment.bottom,children:e.jsx(x,{children:e.jsx(t.TextboxAlignBottomRegular,{fontSize:20})})})]})},c(g,p(v))));var g,v};


/***/ }),

/***/ 538113:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(429830),o=__webpack_require__(610314),i=__webpack_require__(728567),t=__webpack_require__(234741),n=__webpack_require__(350461);exports.FacebookConfig=({facebookPropKey:c,separateDevice:s})=>e.jsx(e.Fragment,{children:e.jsxs(o.Space,{direction:"vertical",size:5,style:{width:"100%",marginTop:"10px"},children:[e.jsx(i.InputConfig,{propKey:t.PROP_KEY.joinKey(c,t.PROP_KEY.Src),separateDevice:s,formItemProps:{label:r.t("video_config.facebook.src"),layout:"vertical"},inputProps:{placeholder:r.t("video_config.facebook.enter_link")}}),e.jsx(n.SwitchConfig,{propKey:t.PROP_KEY.joinKey(c,t.PROP_KEY.Fullscreen),formItemProps:{label:r.t("video_config.allow_fullscreen")}})]})});


/***/ }),

/***/ 339692:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var o=__webpack_require__(561261),e=__webpack_require__(429830),i=__webpack_require__(610314),t=__webpack_require__(866196),r=__webpack_require__(728567),n=__webpack_require__(234741),p=__webpack_require__(350461);exports.TikTokConfig=({tiktokPropKey:s,separateDevice:c})=>o.jsx(o.Fragment,{children:o.jsxs(i.Space,{direction:"vertical",size:5,style:{width:"100%",marginTop:"10px"},children:[o.jsx(r.InputConfig,{propKey:n.PROP_KEY.joinKey(s,n.PROP_KEY.Src),separateDevice:c,formItemProps:{label:e.t("video_config.tiktok.src"),layout:"vertical"},inputProps:{placeholder:e.t("video_config.tiktok.enter_link")}}),o.jsx(p.SwitchConfig,{propKey:n.PROP_KEY.joinKey(s,n.PROP_KEY.Autoplay),formItemProps:{label:e.t("video_config.autoplay")}}),o.jsx(p.SwitchConfig,{propKey:n.PROP_KEY.joinKey(s,n.PROP_KEY.Loop),formItemProps:{label:e.t("video_config.loop")}}),o.jsx(p.SwitchConfig,{propKey:n.PROP_KEY.joinKey(s,n.PROP_KEY.Controls),formItemProps:{label:e.t("video_config.controls")}}),o.jsx(p.SwitchConfig,{propKey:n.PROP_KEY.joinKey(s,n.PROP_KEY.Description),formItemProps:{label:e.t("video_config.video_description")}}),o.jsx(p.SwitchConfig,{propKey:n.PROP_KEY.joinKey(s,n.PROP_KEY.MusicDescription),formItemProps:{label:e.t("video_config.music_description")}}),o.jsx(t.RatioConfig,{propKey:n.PROP_KEY.joinKey(s,n.PROP_KEY.AspectRatio)})]})});


/***/ }),

/***/ 818750:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(610314),r=__webpack_require__(429830),t=__webpack_require__(212951),i=__webpack_require__(112373),n=__webpack_require__(503104),a=__webpack_require__(891987),s=__webpack_require__(26308),c=__webpack_require__(234741),l=__webpack_require__(313247),p=__webpack_require__(350461),u=__webpack_require__(866196);function d(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var f=d(t),P=Object.defineProperty,j=Object.defineProperties,y=Object.getOwnPropertyDescriptors,K=Object.getOwnPropertySymbols,O=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,v=(e,o,r)=>o in e?P(e,o,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[o]=r,b=(e,o)=>{for(var r in o||(o={}))O.call(o,r)&&v(e,r,o[r]);if(K)for(var r of K(o))g.call(o,r)&&v(e,r,o[r]);return e};const m=f.default(o.Upload)`
  div.ant-upload {
    width: 100%;
  }
`;exports.UploadConfig=({uploadPropKey:t,uploadSrcPropKey:d,separateDevice:f})=>{const[P,K]=a.useState(!1),[O,g]=a.useState([]),[v,R]=s.usePropSeparateDevice(c.PROP_KEY.joinKey(t,c.PROP_KEY.Src),f),[x,_]=s.usePropSeparateDevice(c.PROP_KEY.joinKey(d),f);a.useEffect((()=>{g(v?[{url:v,uid:v,name:n.getFileName(v)}]:[])}),[v]);const h=(e,o)=>URL.createObjectURL(e),{uploadFileHandler:S=h}=l.useBuilder(),E={beforeUpload:n.beforeUploadVideo,customRequest:async e=>{const{file:o,onSuccess:r,onError:t}=e;try{K(!0);const e=await S(o,"video");R(e),x&&_(void 0),r(o)}catch(e){t(e,o)}finally{K(!1)}},listType:"picture",maxCount:1,multiple:!1,fileList:O,onRemove:()=>{R("")}};return e.jsx(e.Fragment,{children:e.jsxs(o.Space,{direction:"vertical",size:5,style:{width:"100%",marginTop:"10px"},children:[e.jsx(m,(q=b({},E),w={children:e.jsx(o.Button,{block:!0,icon:e.jsx(i.UploadOutlined,{}),loading:P,children:r.t("video_config.upload.src")})},j(q,y(w)))),e.jsxs("div",{style:{marginTop:"56px"},children:[e.jsx(p.SwitchConfig,{propKey:c.PROP_KEY.joinKey(t,c.PROP_KEY.Autoplay),formItemProps:{label:r.t("video_config.autoplay")}}),e.jsx(p.SwitchConfig,{propKey:c.PROP_KEY.joinKey(t,c.PROP_KEY.Loop),formItemProps:{label:r.t("video_config.loop")}}),e.jsx(p.SwitchConfig,{propKey:c.PROP_KEY.joinKey(t,c.PROP_KEY.Controls),formItemProps:{label:r.t("video_config.controls")}}),e.jsx(u.RatioConfig,{propKey:c.PROP_KEY.joinKey(t,c.PROP_KEY.AspectRatio)})]})]})});var q,w};


/***/ }),

/***/ 916757:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(429830),r=__webpack_require__(112373),o=__webpack_require__(212951),i=__webpack_require__(610314),u=__webpack_require__(891987),a=__webpack_require__(503104),n=__webpack_require__(26308),l=__webpack_require__(313247),s=__webpack_require__(728567);function p(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=p(o),d=Object.defineProperty,b=Object.defineProperties,f=Object.getOwnPropertyDescriptors,j=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,v=(e,t,r)=>t in e?d(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,g=(e,t)=>{for(var r in t||(t={}))y.call(t,r)&&v(e,r,t[r]);if(j)for(var r of j(t))m.call(t,r)&&v(e,r,t[r]);return e},P=(e=>(e.YouTube="YouTube",e.Upload="Upload",e))(P||{});const O=c.default(i.Upload)`
  div.ant-upload {
    width: 100%;
  }
`;exports.VideoConfig=({platformPropKey:o,youtubeVideoPropKey:p,uploadVideoPropKey:c,separateDevice:d})=>{const[j,y]=u.useState([]),[m,v]=u.useState(!1),[h,x]=n.usePropSeparateDevice(c,d),[q,U]=n.usePropSeparateDevice(o,d),S=q||(h?"Upload":"YouTube");u.useEffect((()=>{y(h?[{url:h,uid:h,name:a.getFileName(h)}]:[])}),[h]);const w=(e,t)=>URL.createObjectURL(e),{uploadFileHandler:C=w}=l.useBuilder(),V={beforeUpload:a.beforeUploadVideo,customRequest:async e=>{const{file:t,onSuccess:r,onError:o}=e;try{v(!0);const e=await C(t,"video");x(e),r(t)}catch(e){o(e,t)}finally{v(!1)}},listType:"picture",maxCount:1,multiple:!1,fileList:j,onRemove:()=>{x("")}};return e.jsxs(e.Fragment,{children:[e.jsx(i.Segmented,{options:Object.values(P),onChange:e=>{U(e)},defaultValue:S,style:{width:"100%",marginBottom:20},block:!0}),"YouTube"===S&&e.jsx(s.InputConfig,{propKey:p,separateDevice:d,formItemProps:{label:t.t("Đường dẫn Youtube"),layout:"vertical"},inputProps:{placeholder:t.t("Nhập đường dẫn Youtube")}}),"Upload"===S&&e.jsx(O,(D=g({},V),T={children:e.jsx(i.Button,{block:!0,icon:e.jsx(r.UploadOutlined,{}),loading:m,children:t.t("Tải lên video (MP4, WebM, OGV)")})},b(D,f(T))))]});var D,T};


/***/ }),

/***/ 165217:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(429830),i=__webpack_require__(610314),r=__webpack_require__(728567),t=__webpack_require__(234741),n=__webpack_require__(350461),p=__webpack_require__(866196);exports.YouTubeConfig=({youtubePropKey:s,separateDevice:a})=>e.jsx(e.Fragment,{children:e.jsxs(i.Space,{direction:"vertical",size:5,style:{width:"100%",marginTop:"10px"},children:[e.jsx(r.InputConfig,{propKey:t.PROP_KEY.joinKey(s,t.PROP_KEY.Src),separateDevice:a,formItemProps:{label:o.t("video_config.youtube.src"),layout:"vertical"},inputProps:{placeholder:o.t("video_config.youtube.enter_link")}}),e.jsx(n.SwitchConfig,{propKey:t.PROP_KEY.joinKey(s,t.PROP_KEY.Autoplay),formItemProps:{label:o.t("video_config.autoplay")}}),e.jsx(n.SwitchConfig,{propKey:t.PROP_KEY.joinKey(s,t.PROP_KEY.Loop),formItemProps:{label:o.t("video_config.loop")}}),e.jsx(n.SwitchConfig,{propKey:t.PROP_KEY.joinKey(s,t.PROP_KEY.Controls),formItemProps:{label:o.t("video_config.controls")}}),e.jsx(p.RatioConfig,{propKey:t.PROP_KEY.joinKey(s,t.PROP_KEY.AspectRatio)})]})});


/***/ }),

/***/ 503104:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(429830),i=__webpack_require__(610314);const t=["video/mp4","video/webm","video/ogg"];exports.beforeUploadVideo=o=>t.includes(o.type)?!!(o.size<20971520)||(i.notification.error({message:e.t("Bạn chỉ có thể tải lên video nhỏ hơn hoặc bằng 20MB!")}),!1):(i.notification.error({message:e.t("Bạn chỉ có thể tải lên video dạng MP4/WEBM/OGV!")}),!1),exports.getFileName=e=>e.substring(e.lastIndexOf("/")+1);


/***/ }),

/***/ 39134:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=Object.defineProperty,p=Object.defineProperties,t=Object.getOwnPropertyDescriptors,o=Object.getOwnPropertySymbols,s=Object.prototype.hasOwnProperty,r=Object.prototype.propertyIsEnumerable,i=(p,t,o)=>t in p?e(p,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):p[t]=o,a=(e,p)=>{for(var t in p||(p={}))s.call(p,t)&&i(e,t,p[t]);if(o)for(var t of o(p))r.call(p,t)&&i(e,t,p[t]);return e},d=(e,o)=>p(e,t(o));const l=[{tags:["luckymoney","potsmashing","treasurehunting","luckydrawv2"],resetFields:["data.props.gameId","data.props.configStorage"],mappingFields:{"data.props.response":(e,p)=>{var t;return{emptyPrize:p[e.emptyPrize],outOfTurn:p[e.outOfTurn],prize:p[e.prize],outOfPrize:p[e.outOfPrize],custom:null==(t=e.custom)?void 0:t.map((e=>d(a({},e),{popup:p[e.popup]})))}}}},{tags:["tempiproductlistv2","websiteheader"],resetFields:[],mappingFields:{"data.props.orderPopupId":(e,p)=>p[e]}},{tags:["formv4","checkoutform","orderpopupv2"],resetFields:["data.props.configStorage"],mappingFields:{"data.props.response":(e,p)=>{var t;return d(a({},e),{success:p[e.success]||e.success,failed:p[e.failed]||e.failed,custom:null==(t=e.custom)?void 0:t.map((e=>d(a({},e),{popup:p[e.popup]||e.popup})))})}}},{tags:["buttonv2","col","image","icon","socialicon"],resetFields:[],mappingFields:{"data.props.event":(e,p)=>{var t;return d(a({},e),{togglePopup:p[e.togglePopup]||e.togglePopup,togglePopupList:"string"==typeof e.togglePopupList?p[e.togglePopupList]||e.togglePopupList:null==(t=e.togglePopupList)?void 0:t.map((e=>p[e]||e))})}}},{tags:["tab"],resetFields:[],mappingFields:{"data.props.tabs":(e,p)=>null==e?void 0:e.map((e=>d(a({},e),{id:p[e.id]||e.id})))}},{tags:["advancedslider"],resetFields:[],mappingFields:{"data.props.sliders":(e,p)=>null==e?void 0:e.map((e=>d(a({},e),{id:p[e.id]||e.id})))}},{tags:["timeline"],resetFields:[],mappingFields:{"data.props.timelines":(e,p)=>null==e?void 0:e.map((e=>d(a({},e),{nodeId:p[e.nodeId]||e.nodeId})))}},{tags:["omni_voucherlist"],resetFields:["data.props.endpointConfig"]}];exports.DEFAULT_RESTRICTED_ELEMENT_CONFIG=l;


/***/ }),

/***/ 567669:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.DEFAULT_WIDTH=1232,exports.GRID_COLUMNS=12,exports.MAX_WIDTH=2e3;


/***/ }),

/***/ 755087:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=(e=>(e.USER="user",e.ASSISTANT="assistant",e))(e||{}),_=(e=>(e.FRIENDLY="friendly",e.PROFESSIONAL="professional",e.CONVINCING="convincing",e.CREATIVE="creative",e.HUMOROUS="humorous",e))(_||{}),E=(e=>(e.GENERATE_TEXT="generate_text",e.SHORTEN_TEXT="shorten_text",e.REWRITE_TEXT="rewrite_text",e.CHANGE_TONE_FRIENDLY="change_tone_friendly",e.CHANGE_TONE_PROFESSIONAL="change_tone_professional",e.CHANGE_TONE_CONVINCING="change_tone_convincing",e.CHANGE_TONE_CREATIVE="change_tone_creative",e.CHANGE_TONE_HUMOROUS="change_tone_humorous",e.SET_PARAGRAPH_NODE_ID="set_paragraph_node_id",e))(E||{});exports.LLM_ACTION_TYPE=E,exports.LLM_EVENT_NAME="llm-event",exports.MESSAGE_ROLE=e,exports.TONE=_;


/***/ }),

/***/ 234741:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));const e={Action:"action",ActionButton:"actionButton",ActiveName:"activeName",ActiveTabStyle:"activeTabStyle",Address:"address",Align:"align",AlignItems:"alignItems",Alignment:"alignment",AlignThumbnail:"alignThumbnail",AllowSetupThumbnail:"allowSetupThumbnail",Alt:"alt",AltStyle:"altStyle",AnimationDelay:"animation.delay",AnimationDuration:"animation.duration",AnimationName:"animation.name",AnimationRepeatNumber:"animation.repeatNumber",AnimationRepeatType:"animation.repeatType",ApiResponsePopup:"responsePopup",AppliedDomains:"appliedDomains",ArrowStyle:"arrowStyle",AutoPassParams:"autoPassParams",Autoplay:"autoplay",AutoSwipeTimeMilliseconds:"autoSwipeTimeMilliseconds",AspectRatio:"aspectRatio",AnimationConfig:"animationConfig",BackgroundType:"backgroundType",Background:"background",BackgroundColor:"backgroundColor",BackgroundColorHover:"hover.backgroundColor",BackgroundImage:"backgroundImage",BackgroundImagePercent:"bgImagePercent",BackgroundImageWidth:"bgImageWidth",BackgroundMarqueeDirection:"backgroundMarqueeDirection",BackgroundMarqueeSpeed:"backgroundMarqueeSpeed",BackgroundOverlay:"backgroundOverlay",BackgroundOverlayType:"backgroundOverlayType",BackgroundPosition:"backgroundPosition",BackgroundRepeat:"backgroundRepeat",BackgroundSize:"backgroundSize",BackgroundVideo:"backgroundVideo",BackgroundBlur:"backgroundBlur",BarStyle:"barStyle",BlockType:"blockType",Border:"border",BorderBottomLeftRadius:"borderBottomLeftRadius",BorderBottomLeftRadiusUnit:"borderBottomLeftRadiusUnit",BorderBottomRightRadius:"borderBottomRightRadius",BorderBottomRightRadiusUnit:"borderBottomRightRadiusUnit",BorderColor:"borderColor",BorderColorHover:"hover.borderColor",BorderRadius:"borderRadius",BorderRadiusUnit:"borderRadiusUnit",BorderStyle:"borderStyle",BorderTopLeftRadius:"borderTopLeftRadius",BorderTopLeftRadiusUnit:"borderTopLeftRadiusUnit",BorderTopRightRadius:"borderTopRightRadius",BorderTopRightRadiusUnit:"borderTopRightRadiusUnit",BorderWidth:"borderWidth",BorderBottomWidth:"borderBottomWidth",BorderTopWidth:"borderTopWidth",BorderLeftWidth:"borderLeftWidth",BorderRightWidth:"borderRightWidth",Bottom:"bottom",BottomBanners:"bottomBanners",BubbleStyle:"bubbleStyle",Button:"button",ButtonStyle:"buttonStyle",CanvasConfig:"canvasConfig",Captcha:"captcha",CarouselSettings:"carouselSettings",CategoryMenuItems:"categoryMenuItems",CircleStyle:"circleStyle",CityId:"cityId",CloseIcon:"closeIcon",Code:"code",CollectionSlug:"collectionSlug",Color:"color",ColorHover:"hover.color",ColumnCount:"columnCount",ColumnGap:"columnGap",CommonStyle:"commonStyle",Config:"config",ConfigStorage:"configStorage",Content:"content",ContentAlign:"contentAlign",ContentMaxWidthKey:"row.commonStyle.maxWidth",ContentName:"contentName",ContentStyle:"contentStyle",ContentType:"contentType",ContentWidthType:"contentWidthType",ConversionGGAdsId:"conversionGGAdsId",ConversionGGAdsLabel:"conversionGGAdsLabel",ConversionValue:"conversionValue",CornerOption:"cornerOption",CornerType:"cornerType",CountdownStyle:"countdownStyle",CopyToClipboard:"copyToClipboard",Crop:"crop",Custom:"custom",Controls:"controls",Data:"data",Date:"date",DefaultOverlay:"defaultOverlay",Delay:"delay",Description:"description",Desktop:"desktop",Device:"device",DigitStyle:"digitStyle",DisplayCloseButton:"displayCloseButton",DisplayOnClickElement:"displayOnClickElement",DisplayOnExitPage:"displayOnExitPage",DisplayOnScrollTo:"displayOnScrollTo",DisplayOnVisitPage:"displayOnVisitPage",DistrictId:"districtId",Divider:"divider",DividerStyle:"dividerStyle",Duration:"duration",ElementGap:"elementGap",Email:"email",EndTime:"endTime",ErrorStyle:"errorStyle",Event:"event",EventType:"eventType",Failed:"failed",FlexDirection:"flexDirection",FlexWrap:"flexWrap",FontFamily:"fontFamily",FontSize:"fontSize",FontStyle:"fontStyle",FontVariant:"fontVariant",FontWeight:"fontWeight",ForegroundColor:"foregroundColor",FormAccountId:"formAccountId",FormConfigId:"formConfigId",FormStyle:"formStyle",Facebook:"facebook",Fullscreen:"fullscreen",FrameShowPopup:"frameShowPopup",Gap:"gap",GoogleImageParams:"googleImageParams",GradientColor:"gradientColor",GridCols:"gridCols",GridRows:"gridRows",Gutter:"gutter",Headers:"headers",HeaderStyle:"headerStyle",HeadingEditor:"headingEditor",Height:"height",HeightUnit:"heightUnit",HiddenFields:"hiddenFields",HiddenMd:"responsive.hiddenMd",HiddenXs:"responsive.hiddenXs",HideAfterClick:"hideAfterClick",HoverBackgroundColor:"hover.backgroundColor",HoverBorderColor:"hover.borderColor",HoverColor:"hover.color",HoverEffect:"hoverEffect",HoverTransparent:"hover.transparent",HoverZoom:"hover.zoom",Href:"href",HtmlTag:"htmlTag",Icon:"icon",IconConfig:"iconConfig",IconStyle:"iconStyle",Id:"id",Image:"image",ImageAlt:"imageAlt",ImageConfig:"imageConfig",Images:"images",ImageStyle:"imageStyle",ImageUrl:"imageUrl",InPage:"inPage",Inputs:"inputs",InputStyle:"inputStyle",Interval:"interval",IsMainPopup:"isMainPopup",ItemData:"itemData",ItemKey:"itemKey",Items:"items",ItemSettings:"itemSettings",ItemsPerRow:"itemsPerRow",ItemStyle:"itemStyle",JustifyContent:"justifyContent",Key:"key",Label:"label",LabelGap:"labelGap",LabelPosition:"labelPosition",LabelStyle:"labelStyle",Layout:"layout",Left:"left",LetterSpacing:"letterSpacing",Limit:"limit",LineHeight:"lineHeight",Link:"link",Logo:"logo",LogoConfig:"logoConfig",LogoDesktop:"logoDesktop",LogoMobile:"logoMobile",Loop:"loop",MainBanner:"mainBanner",MainColor:"mainColor",MainConnection:"mainConnection",Map:"map",Margin:"margin",MaskClosable:"maskClosable",MaskStyle:"maskStyle",MaxHeight:"maxHeight",MaxWidth:"maxWidth",Md:"md.flex",Menu:"menu",MenuConfig:"menuConfig",MenuItemConfig:"menuItemConfig",MenuItemId:"menuItemId",MenuZone:"menuZone",Method:"method",MinHeight:"minHeight",MinHeightUnit:"minHeightUnit",MinWidth:"minWidth",Mobile:"mobile",Multiple:"multiple",MyColors:"colors",MusicDescription:"musicDescription",Name:"name",NameStyle:"nameStyle",NavigationColor:"navigationColor",NavigationStyle:"navigationStyle",Number:"number",NumberItemPerRow:"numberItemPerRow",NumberPosition:"numberPosition",NumberStyle:"numberStyle",NumberType:"numberType",NotificationMessage:"notificationMessage",ObjectFit:"objectFit",OpenNewTab:"openNewTab",OpenPageOfWebsite:"openPageOfWebsite",OpenArticleOfWebsite:"openArticleOfWebsite",Options:"options",OptionStyle:"optionStyle",OrderBy:"orderBy",Origin:"origin",OutOfMove:"outOfMove",OutOfPrize:"outOfPrize",OutOfTurn:"outOfTurn",Padding:"padding",PageMaxWidth:"pageMaxWidth",PageWidthType:"pageWidthType",PaginationColor:"paginationColor",PaginationPosition:"paginationPosition",PaginationStyle:"paginationStyle",ParagraphEditor:"paragraphEditor",PauseOnHover:"pauseOnHover",PauseOnMouseEnter:"pauseOnMouseEnter",Payload:"payload",Percent:"percent",Percentage:"percentage",PerpendicularPrize:"perpendicularPrize",Phone:"phone",Placeholder:"placeholder",Popup:"popup",PopupButton:"popupButton",Position:"position",PositionType:"positionType",PrefixNumber:"prefixNumber",PriceColor:"priceColor",PrimaryColor:"primaryColor",Prize:"prize",PrizeAngle:"prizeAngle",Platform:"platform",Radius:"radius",RedirectUrl:"redirectUrl",RegionName:"regionName",Request:"request",RequestKey:"requestKey",Required:"required",Response:"response",ResponseType:"responseType",ResponsiveSettings:"responsiveSettings",Rewind:"rewind",Right:"right",RightBanners:"rightBanners",RightItems:"rightItems",Rotate:"rotate",Roulette:"roulette",Row:"row",RowGap:"rowGap",RuleRepeat:"ruleRepeat",ScriptCustom:"scriptCustom",SectionMarginTop:"sectionMarginTop",Shadow:"shadow",SheetResponsePopup:"sheetResponsePopup",Show:"show",ShowAlt:"showAlt",ShowCloseBtn:"showCloseBtn",ShowCloseIcon:"showCloseIcon",ShowLabel:"showLabel",ShowMegaMenu:"showMegaMenu",ShowThumbnail:"showThumbnail",ShowTurn:"showTurn",SiteKey:"siteKey",Size:"size",Skin:"skin",SlidePerColumn:"slidesPerColumn",SlidePerView:"slidesPerView",SlidePerViewMobile:"slidesPerViewMobile",Slug:"slug",SortBy:"sortBy",Spacing:"spacing",SpacingWithMenu:"spacingWithMenu",Speed:"speed",SpinTrigger:"spinTrigger",SpinTurn:"spinTurn",Src:"src",StartTime:"startTime",StickyTop:"stickyTop",Stores:"stores",StrokeSize:"strokeSize",Style:"style",SubmitButton:"submitButton",Submits:"submits",SubmitTime:"submitTime",Success:"success",SuffixNumber:"suffixNumber",SyncDeviceStyle:"syncDeviceStyle",Tabs:"tabs",TagId:"tagId",Target:"target",TekoTrackingEvent:"tekoTrackingEvent",TerminalCode:"terminalCode",Text:"text",TextAfter:"textAfter",TextAlign:"textAlign",TextBefore:"textBefore",TextConfig:"textConfig",TextDecoration:"textDecoration",TextShadow:"textShadow",TextStyle:"textStyle",TextTransform:"textTransform",TimeUnitStyle:"timeUnitStyle",TimeVisibility:"timeVisibility",Title:"title",TitleStyle:"titleStyle",Toggle:"toggle",TogglePopup:"togglePopup",TogglePopupList:"togglePopupList",TextCopy:"textCopy",Top:"top",TopBanner:"topBanner",TopBarMenu:"topBarMenu",Total:"total",TrackingEventName:"trackingEventName",TriggerUpdate:"triggerUpdate",Type:"type",Tiktok:"tiktok",TotalFrame:"totalFrame",Unit:"unit",UploadSrc:"uploadSrc",Url:"url",Upload:"upload",Valid:"valid",Value:"value",Version:"version",VerticalAlignment:"verticalAlignment",ViewMoreStyle:"viewMoreStyle",ViewMoreUrl:"viewMoreUrl",Weight:"weight",Width:"width",WidthType:"widthType",WidthUnit:"widthUnit",MinWidthUnit:"minWidthUnit",MaxWidthUnit:"maxWidthUnit",MaxHeightUnit:"maxHeightUnit",WorkHours:"workHours",WrapperStyle:"wrapperStyle",Xs:"xs.flex",Youtube:"youtube",ZIndex:"zIndex",Zoom:"zoom",ZoomPreview:"zoomPreview",EmptyPrize:"emptyPrize",PageId:"pageId",Schema:"schema",DisplayType:"displayType",CursorWidth:"cursorWidth",BarWidth:"barWidth",BarGap:"barGap",BarRadius:"barRadius",WaveColor:"waveColor",CursorColor:"cursorColor",ProgressColor:"progressColor",OpenFourPosition:"openFourPosition",SubMenuBackgroundColor:"subMenuBackgroundColor",joinKey:(...e)=>e.filter(Boolean).join(".")};exports.PROP_KEY=e;


/***/ }),

/***/ 214220:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.resolvedNameMapping={Root:"RootEditor",Row:"RowEditor",Col:"ColEditor",GallerySlideshowEditor:"SliderEditor",CheckoutFormEditor:"CheckoutFormEditor",ImageEditor:"ImageEditor",ParagraphEditor:"ParagraphEditor",OrderPopupEditor:"OrderPopupEditor",ProductDetailPopupEditor:"ProductDetailPopupEditor",ButtonSubmitV3Editor:"ButtonSubmitV3Editor",AccordionContentEditor:"AccordionContentEditor",TabItemEditor:"TabItemEditor",ArticleHeaderEditor:"ArticleHeaderEditor",WebsiteHeaderEditor:"WebsiteHeaderEditor",TopBannerEditor:"TopBannerEditor",WebsiteFooterEditor:"WebsiteFooterEditor",TempiProductListEditorV2:"TempiProductListEditorV2",TempiProductListEditorV3:"TempiProductListEditorV3",TimelineEditor:"TimelineEditor",ContactBubbleEditor:"ContactBubbleEditor",OrderPopupV2Editor:"OrderPopupV2Editor",PopupEditorV1:"PopupEditorV1"};


/***/ }),

/***/ 313247:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(891987),r=__webpack_require__(85097),n=__webpack_require__(647199),o=__webpack_require__(39134),i=__webpack_require__(492176);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=a(t),l=Object.defineProperty,u=Object.defineProperties,d=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,g=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,S=(e,t,r)=>t in e?l(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,f=(e,t)=>{for(var r in t||(t={}))g.call(t,r)&&S(e,r,t[r]);if(c)for(var r of c(t))p.call(t,r)&&S(e,r,t[r]);return e},v=(e,t)=>u(e,d(t)),m=(e,t)=>{var r={};for(var n in e)g.call(e,n)&&t.indexOf(n)<0&&(r[n]=e[n]);if(null!=e&&c)for(var n of c(e))t.indexOf(n)<0&&p.call(e,n)&&(r[n]=e[n]);return r};const b="is-setting-pin",x=s.default.createContext({});exports.BuilderProvider=a=>{var s=a,{children:l,trackHelper:u,initialDevice:d="desktop",storeState:c,extraBuilderState:g,editorConfig:p}=s,S=m(s,["children","trackHelper","initialDevice","storeState","extraBuilderState","editorConfig"]);const{enable:C=!1,target:h="pageBuilder",screenName:E="PageBuilder"}=u||{},O=localStorage.getItem(b),[y,N]=t.useState(),[P,w]=t.useState(),[T,I]=t.useState(),[j,k]=t.useState(!1),[D,B]=t.useState("false"!==O),[M,q]=t.useState(),{trackManual:H,trackCustomEvent:F}=i.useTracking(E),[R,_]=t.useState(d),[A,G]=t.useState(!0),[L,U]=t.useState(!0),[J,z]=t.useState(!1),[K,Q]=t.useState(!1),[V,W]=t.useState(void 0),[X,Y]=t.useState(!1),[Z,$]=t.useState(!1),[ee,te]=t.useState(null),[re,ne]=t.useState(),[oe,ie]=t.useState(!1),[ae,se]=t.useState(!1),[le,ue]=t.useState(void 0),de=t.useMemo((()=>"mobile"===R?"mobile":"desktop"),[R]);return t.useEffect((()=>{localStorage.setItem(b,D.toString())}),[D]),e.jsx(x.Provider,{value:f(f({draggingNode:y,setDraggingNode:N,insertIndex:P,setInsertIndex:w,showSettingDialog:T,setShowSettingDialog:I,getAttrTracking:({regionName:e,contentName:t,payload:n={}})=>{let o={};return C&&(o=r.getTrackingData({isTrackContent:!0,regionName:e,contentName:t,index:null,target:h,payload:JSON.stringify(f({screenName:E},n))})),o},track:e=>{var t=m(e,[]);C&&H(f({target:h},t))},trackCustomEvent:F,setFrame:q,frame:M,device:R,realDevice:de,setDevice:_,showHiddenElements:A,setShowHiddenElements:G,allowConfigResponsive:L,setAllowConfigResponsive:U,hideBubbleOnEditor:J,setHideBubbleOnEditor:z,isEditingText:Z,setIsEditingText:$,showModalSelectPopup:K,setShowModalSelectPopup:Q,pinSetting:D,setPinSetting:B,relatedNodeId:V,setRelatedNodeId:W,showBubbleSetting:X,setShowBubbleSetting:Y,pageFonts:ee,setPageFonts:te,textEditor:re,setTextEditor:ne,openStyledMenu:oe,setOpenStyledMenu:ie,openPopupMenu:ae,setOpenPopupMenu:se,openThemeConfig:le,setOpenThemeConfig:ue,isOpenFloatingTextGenerator:j,setIsOpenFloatingTextGenerator:k,editorConfig:v(f({},p),{restrictedElementConfig:(null==p?void 0:p.restrictedElementConfig)||o.DEFAULT_RESTRICTED_ELEMENT_CONFIG,canCopyPaste:(null==p?void 0:p.canCopyPaste)||n.defaultCanCopyPaste,canDeleteNode:(null==p?void 0:p.canDeleteNode)||n.defaultCanDeleteNode,shortcutHandler:(null==p?void 0:p.shortcutHandler)||n.defaultShortcutHandler,type:null==p?void 0:p.type,uniqueNodeIds:(null==p?void 0:p.uniqueNodeIds)||n.defaultUniqueNodeIds})},g),S),children:e.jsx(r.StoreProvider,v(f({},c),{device:de,children:l}))})},exports.BuilderStateContext=x,exports.useBuilder=function(){const e=t.useContext(x);if(!e)throw new Error("useBuilder must be inside a BuilderStateContext with a state value");return e};


/***/ }),

/***/ 186284:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(547929),t=__webpack_require__(684319),o=__webpack_require__(461473),i=Object.defineProperty,s=Object.defineProperties,n=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable,u=(e,r,t)=>r in e?i(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,f=(e,r)=>{for(var t in r||(r={}))d.call(r,t)&&u(e,t,r[t]);if(c)for(var t of c(r))a.call(r,t)&&u(e,t,r[t]);return e};exports.withSelector=(i,c,d)=>{const a=t=>{const{connectors:{connect:c,drag:a}}=r.useNode(),u=o.useDraftNode(t);return e.jsx("div",(l=f({ref:e=>c(a(e))},d),p={children:e.jsx(i,f({isEditingMode:!0,isEditor:!0,isEditorMode:!0},u))},s(l,n(p))));var l,p};return a.craft=t.crafting(c),a},exports.withSelectorDirectElement=(i,s,n)=>{const c=t=>{const{connectors:{connect:s,drag:c}}=r.useNode(),d=o.useDraftNode(t);return e.jsx(i,f(f({ref:e=>s(c(e)),isEditingMode:!0,isEditor:!0,isEditorMode:!0},d),n))};return c.craft=t.crafting(s),c};


/***/ }),

/***/ 461473:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(891987),r=__webpack_require__(547929),t=__webpack_require__(647199),s=__webpack_require__(516965);exports.useDraftNode=u=>{const{id:a}=r.useNode(),o=s.useDraftStore((e=>e.drafts[a])),n=e.useRef({props:null,draftData:null,result:null});return e.useMemo((()=>{if(!o||0===Object.keys(o).length)return u;const e=n.current;if(e.props===u&&e.draftData===o)return e.result;const r=t.selectiveMergeBatch(u,o);return n.current={props:u,draftData:o,result:r},r}),[o,u])};


/***/ }),

/***/ 552884:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(429830),o=__webpack_require__(547929),t=__webpack_require__(85097),n=__webpack_require__(647199),d=__webpack_require__(407229),r=__webpack_require__(610314),a=__webpack_require__(313247),i=__webpack_require__(935266);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=s(d),c=Object.defineProperty,u=Object.defineProperties,p=Object.getOwnPropertyDescriptors,f=Object.getOwnPropertySymbols,g=Object.prototype.hasOwnProperty,N=Object.prototype.propertyIsEnumerable,v=(e,o,t)=>o in e?c(e,o,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[o]=t,h=(e,o)=>{for(var t in o||(o={}))g.call(o,t)&&v(e,t,o[t]);if(f)for(var t of f(o))N.call(o,t)&&v(e,t,o[t]);return e},m=(e,o)=>u(e,p(o));exports.useEditor=function(d){const{editorConfig:s}=a.useBuilder(),c=i.useBuilderStore((e=>e.setShowModalSelectBlock)),{message:u}=r.App.useApp(),p=o.useEditor(d),{actions:v,query:y}=p,O=((e,o)=>{var t={};for(var n in e)g.call(e,n)&&o.indexOf(n)<0&&(t[n]=e[n]);if(null!=e&&f)for(var n of f(e))o.indexOf(n)<0&&N.call(e,n)&&(t[n]=e[n]);return t})(p,["actions","query"]),b=(e,o)=>{var t;const n=m(h({},e),{id:o,events:{dragged:!1,hovered:!1,selected:!1},data:m(h({},null==e?void 0:e.data),{props:m(h({},null==(t=null==e?void 0:e.data)?void 0:t.props),{originNodeId:null==e?void 0:e.id})})});return y.parseFreshNode(n).toNode()},I=e=>{const o={},d=Object.keys(e.nodes).reduce(((o,n)=>s.uniqueNodeIds.has(n)?(o[n]=n,o):(o[n]=(e=>{var o,n;try{const d="popupv1"===(null==(n=null==(o=null==e?void 0:e.data)?void 0:o.custom)?void 0:n.tag);let r=t.generateRandomId(10);const a=y.node("ROOT").childNodes().find((e=>{var o,t,n;return null==(n=null==(t=null==(o=y.node(e))?void 0:o.get().data)?void 0:t.props)?void 0:n.isMainPopup}));if(!d||!a)return r;if(a.length>=r.length&&a>=r){const e=Object.keys(JSON.parse(y.serialize())).map((e=>parseInt(e.replaceAll(".",""),36)));r="."+(Math.max(...e)+1).toString(36)}return r}catch(e){return t.generateRandomId(10)}})(e.nodes[n]),o)),{}),r=(t,a)=>{var i,l;const c=d[t.id];s.restrictedElementConfig&&(t=n.transformNodeByConfig({tag:null==(l=null==(i=null==t?void 0:t.data)?void 0:i.custom)?void 0:l.tag,node:t,mappingKey:d,transformElementConfig:s.restrictedElementConfig}));const u=t.data.nodes.map((o=>r(e.nodes[o],c))),p=Object.keys(t.data.linkedNodes).reduce(((o,n)=>{const d=r(e.nodes[t.data.linkedNodes[n]],c);return m(h({},o),{[n]:d})}),{}),f=m(h({},t),{id:c,data:m(h({},t.data),{parent:a||t.data.parent,nodes:u,linkedNodes:p})}),g=y.parseFreshNode(f).toNode();return o[c]=g,c};return{rootNodeId:r(e.nodes[e.rootNodeId]),nodes:o}},x=e=>{const o=y.node(e).get();if(o)return o.data.parent&&y.node(o.data.parent).get()},T=e=>{const o=x(e);return o&&y.node(o.id).descendants()||[]};return h({actions:v,query:y,duplicateNode:async(e,o,t={})=>{const d=s.uniqueNodeIds.has(e.id);if(!e||!o||d)return;const{index:r}=t,a=y.node(e.id).descendants(!0),i={rootNodeId:e.id,nodes:{[e.id]:b(e,e.id)}};null==a||a.forEach((e=>{const o=y.node(e).get();i.nodes[o.id]=b(o,o.id)}));const l=I(i);return n.updateProductDetailIdForProductList(l.nodes),v.history.throttle().addNodeTree(l,o,r),null==l?void 0:l.rootNodeId},addBlock:async(e,o={})=>{const{index:n,parentId:d=t.ROOT,rootNodeId:r}=o,a=Object.entries(e).map((([e,o])=>y.parseSerializedNode(o).toNode((o=>o.id=e)))),i={rootNodeId:r,nodes:a.reduce(((e,o)=>(e[o.id]=o,e)),{})};if(!r){const e=a.find((e=>e.data.parent===t.ROOT));i.rootNodeId=null==e?void 0:e.id}const s=r?i:I(i);return void 0!==n?v.addNodeTree(s,d,n):v.addNodeTree(s,d),s},getSiblings:T,getNextNode:e=>{const o=T(e),t=o.findIndex((o=>o===e));return o[t+1]&&y.node(o[t+1]).get()},getPrevNode:e=>{const o=T(e),t=o.findIndex((o=>o===e));return o[t-1]&&y.node(o[t-1]).get()},getParent:x,resizeColumns:(e,o)=>{y.node(e).childNodes().forEach((e=>v.history.throttle().setProp(e,(e=>{l.default(e,"md.flex",`${n.floorPercentage(100/o)}%`)}))))},getLastSection:(e=t.ROOT)=>{const o=y.node(e).childNodes().filter((e=>{var o,t,n,d;return"RowEditor"===(null==(d=null==(n=null==(t=(o=y.node(e)).get)?void 0:t.call(o))?void 0:n.data)?void 0:d.name)}));return o[o.length-1]},onCopy:async o=>{try{const t=y.node(o).descendants(!0),n={rootNodeId:o,nodes:{[o]:y.node(o).toSerializedNode()}};null==t||t.forEach((e=>{const o=y.node(e).toSerializedNode();n.nodes[e]=o})),await navigator.clipboard.writeText(JSON.stringify(n)),u.success({content:e.t("Sao chép thành công")})}catch(e){u.error({content:`${e.name}: ${e.message}.`})}},onPaste:async o=>{try{const n=await navigator.clipboard.readText(),d=JSON.parse(n);for(const e in null==d?void 0:d.nodes)d.nodes[e]=y.parseSerializedNode(d.nodes[e]).toNode((o=>o.id=e));const a=I(d),i=y.node(o).get();if(!i)return;const l=s.shortcutHandler(a,i,y.node);if(!l)return;const{nodes:u}=y.node(t.ROOT).get().data,p=null==d?void 0:d.rootNodeId;s.uniqueNodeIds.has(p)&&u.includes(p)?(o=>{const t=o.toLowerCase();r.Modal.confirm({centered:!0,zIndex:2002,closable:!0,maskClosable:!0,icon:null,title:e.t("add_something",{nameOfSomething:t}),content:e.t("confirm_replace_global_block_by_the_new_one",{globalBlockName:t}),okText:e.t("Đồng ý"),cancelText:e.t("common.cancel"),onOk:()=>{v.history.throttle().delete(p),v.addNodeTree(a,l.parentIdToPaste,l.indexToPaste||0),c(!1)}})})(p):v.addNodeTree(a,l.parentIdToPaste,l.indexToPaste||0)}catch(e){}},cloneNodeTree:I},O)};


/***/ }),

/***/ 327590:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(891987),r=__webpack_require__(552884);exports.usePopupList=()=>{const{nodes:t}=r.useEditor((e=>({nodes:e.nodes})));return{popupListSelection:e.useMemo((()=>Object.keys(t).filter((e=>{var r,o;return"PopupEditorV1"===(null==(o=null==(r=t[e])?void 0:r.data)?void 0:o.name)})).map((e=>({label:t[e].data.props.name,value:e})))),[t])}};


/***/ }),

/***/ 541054:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(547929),t=__webpack_require__(47248),r=__webpack_require__(407229);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var u=o(t),a=o(r);exports.useProp=(t,r)=>{const{actions:{setProp:o},props:s}=e.useNode((e=>({props:e.data.props})));return["function"==typeof(null==r?void 0:r.formatter)?r.formatter(u.default(s,t)):u.default(s,t),e=>{o((o=>{"function"==typeof(null==r?void 0:r.parser)?a.default(o,t,null==r?void 0:r.parser(e)):a.default(o,t,e)}),500)}]};


/***/ }),

/***/ 288518:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(541054),o=__webpack_require__(234741);exports.usePropDeviceSpecific=function(r,s){const p=o.PROP_KEY.joinKey(o.PROP_KEY.Desktop,r),P=o.PROP_KEY.joinKey(o.PROP_KEY.Mobile,r),[t,i]=e.useProp(r,s),[u,n]=e.useProp(p,s),[c,K]=e.useProp(P,s);return{commonProp:t,desktopProp:u,mobileProp:c,setCommonProp:i,setDesktopProp:n,setMobileProp:K}};


/***/ }),

/***/ 26308:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(541054),o=__webpack_require__(234741),r=__webpack_require__(313247);exports.usePropSeparateDevice=function(s,i=!1,P){const{realDevice:t}=r.useBuilder(),u=o.PROP_KEY.joinKey(i&&t,s),p=o.PROP_KEY.joinKey(o.PROP_KEY.Desktop,s),n=o.PROP_KEY.joinKey(o.PROP_KEY.Mobile,s),[c]=e.useProp(o.PROP_KEY.SyncDeviceStyle),[d,v]=e.useProp(u,P),[K,l]=e.useProp(p,P),[,_]=e.useProp(n,P),[j,y]=e.useProp(s,P);return[i&&void 0===d?void 0===c&&void 0!==K?K:j:d,e=>{v(e),i&&(c&&("desktop"===t?_(e):l(e)),!c&&"mobile"===t||void 0!==e||void 0===j||y(e))}]};


/***/ }),

/***/ 523169:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(891987),r=__webpack_require__(85097),t=__webpack_require__(26308);exports.useSortable=(i,o=!1)=>{const[s,u]=t.usePropSeparateDevice(i,o);return[e.useMemo((()=>{var e;return null==(e=null==s?void 0:s.map)?void 0:e.call(s,((e,t)=>({id:e.id||`${JSON.stringify(e)}_${t}}`||`slider-item-${r.generateRandomId()}`,item:e})))}),[s]),e=>{const r=e([...s||[]]);u(r)}]};


/***/ }),

/***/ 492176:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=Object.defineProperty,e=Object.getOwnPropertySymbols,a=Object.prototype.hasOwnProperty,n=Object.prototype.propertyIsEnumerable,r=(e,a,n)=>a in e?t(e,a,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[a]=n,o=(t,o)=>{for(var c in o||(o={}))a.call(o,c)&&r(t,c,o[c]);if(e)for(var c of e(o))n.call(o,c)&&r(t,c,o[c]);return t};exports.useTracking=t=>({trackngScreenName:t,getAttrTracking:({regionName:e,contentName:a,target:n,payload:r={}})=>({"data-track-content":!0,"data-content-region-name":e,"data-content-name":a,"data-content-target":n,"data-content-payload":JSON.stringify(o({screenName:t},r))}),trackManual:({regionName:e,contentName:a,target:n,payload:r={},interaction:c="click"})=>{"function"==typeof track&&track("manualTrackInteractionContent",{interaction:c,contentName:a,regionName:e,target:n,payload:JSON.stringify(o({screenName:t},r))})},trackCustomEvent:(t,e)=>{"function"==typeof track&&track("customEvent",t,e)}});


/***/ }),

/***/ 429830:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}Object.defineProperty(exports, "__esModule", ({value:!0}));var t=e(__webpack_require__(396556)),r=Object.defineProperty,o=Object.defineProperties,n=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,a=Object.prototype.hasOwnProperty,i=Object.prototype.propertyIsEnumerable,u=(e,t,o)=>t in e?r(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o,c=(e,t)=>{for(var r in t||(t={}))a.call(t,r)&&u(e,r,t[r]);if(p)for(var r of p(t))i.call(t,r)&&u(e,r,t[r]);return e};exports.getOptionsI18n=(e,t,r)=>{const o="string"==typeof r?[r]:r;return t.map((t=>c(c({},t),o.reduce(((r,o)=>(r[o]=e(t[o]),r)),{}))))},exports.t=(e,r)=>{var p;return t.default.t(e,(p=c({},r),o(p,n({interpolation:{escapeValue:!1}}))))||e};


/***/ }),

/***/ 443410:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(547929),o=__webpack_require__(567669),r=__webpack_require__(647199),i=__webpack_require__(935266),t=__webpack_require__(10619),n=__webpack_require__(428263),s=__webpack_require__(446062),g=__webpack_require__(516965),u=__webpack_require__(800302),p=__webpack_require__(227244),a=__webpack_require__(899278),f=__webpack_require__(114800),C=__webpack_require__(871496),c=__webpack_require__(312995),l=__webpack_require__(851734),d=__webpack_require__(131417),x=__webpack_require__(24005),m=__webpack_require__(964694),S=__webpack_require__(826688),j=__webpack_require__(887886),q=__webpack_require__(180336),I=__webpack_require__(953191),P=__webpack_require__(252187),k=__webpack_require__(833175),b=__webpack_require__(923766),T=__webpack_require__(801115),A=__webpack_require__(944215),E=__webpack_require__(225439),V=__webpack_require__(939414),D=__webpack_require__(476662),B=__webpack_require__(728567),N=__webpack_require__(514824),M=__webpack_require__(541055),v=__webpack_require__(828426),R=__webpack_require__(350461),h=__webpack_require__(187510),U=__webpack_require__(62424),L=__webpack_require__(431115),F=__webpack_require__(105915),O=__webpack_require__(731006),G=__webpack_require__(133501),_=__webpack_require__(100832),w=__webpack_require__(301842),y=__webpack_require__(342022),H=__webpack_require__(770867),Q=__webpack_require__(537018),W=__webpack_require__(660512),z=__webpack_require__(142669),Y=__webpack_require__(277920),K=__webpack_require__(246685),X=__webpack_require__(883906),J=__webpack_require__(793709),Z=__webpack_require__(112628),$=__webpack_require__(468569),ee=__webpack_require__(714816),oe=__webpack_require__(788463),re=__webpack_require__(925687),ie=__webpack_require__(106441),te=__webpack_require__(326809),ne=__webpack_require__(502253),se=__webpack_require__(387365),ge=__webpack_require__(451633),ue=__webpack_require__(725721),pe=__webpack_require__(618063),ae=__webpack_require__(276879),fe=__webpack_require__(615554),Ce=__webpack_require__(246020),ce=__webpack_require__(849041),le=__webpack_require__(821544),de=__webpack_require__(268349),xe=__webpack_require__(509895),me=__webpack_require__(287167),Se=__webpack_require__(860936),je=__webpack_require__(573466),qe=__webpack_require__(551837),Ie=__webpack_require__(379386),Pe=__webpack_require__(793698),ke=__webpack_require__(916757),be=__webpack_require__(538113),Te=__webpack_require__(339692),Ae=__webpack_require__(165217),Ee=__webpack_require__(818750),Ve=__webpack_require__(503104),De=__webpack_require__(991653),Be=__webpack_require__(17595),Ne=__webpack_require__(283311),Me=__webpack_require__(567522),ve=__webpack_require__(661999),Re=__webpack_require__(373654),he=__webpack_require__(290223),Ue=__webpack_require__(38680),Le=__webpack_require__(553226),Fe=__webpack_require__(62494),Oe=__webpack_require__(512571),Ge=__webpack_require__(359607),_e=__webpack_require__(968965),we=__webpack_require__(495410),ye=__webpack_require__(921890),He=__webpack_require__(997245),Qe=__webpack_require__(732125),We=__webpack_require__(234741),ze=__webpack_require__(214220),Ye=__webpack_require__(39134),Ke=__webpack_require__(755087),Xe=__webpack_require__(313247),Je=__webpack_require__(186284),Ze=__webpack_require__(541054),$e=__webpack_require__(552884),eo=__webpack_require__(492176),oo=__webpack_require__(26308),ro=__webpack_require__(523169),io=__webpack_require__(327590),to=__webpack_require__(461473),no=__webpack_require__(288518),so=__webpack_require__(414030),go=__webpack_require__(342447),uo=__webpack_require__(664185),po=__webpack_require__(734777),ao=__webpack_require__(12961),fo=__webpack_require__(130664),Co=__webpack_require__(805116),co=__webpack_require__(684319),lo=__webpack_require__(726142),xo=__webpack_require__(116176),mo=__webpack_require__(904511),So=__webpack_require__(737577),jo=__webpack_require__(105084);Object.defineProperty(exports, "Editor", ({enumerable:!0,get:function(){return e.Editor}})),Object.defineProperty(exports, "Element", ({enumerable:!0,get:function(){return e.Element}})),Object.defineProperty(exports, "Events", ({enumerable:!0,get:function(){return e.Events}})),Object.defineProperty(exports, "Frame", ({enumerable:!0,get:function(){return e.Frame}})),Object.defineProperty(exports, "useNode", ({enumerable:!0,get:function(){return e.useNode}})),exports.DEFAULT_WIDTH=o.DEFAULT_WIDTH,exports.GRID_COLUMNS=o.GRID_COLUMNS,exports.MAX_WIDTH=o.MAX_WIDTH,exports.clonePageContent=r.clonePageContent,exports.defaultCanCopyPaste=r.defaultCanCopyPaste,exports.defaultCanDeleteNode=r.defaultCanDeleteNode,exports.defaultShortcutHandler=r.defaultShortcutHandler,exports.defaultUniqueNodeIds=r.defaultUniqueNodeIds,exports.deserializePB=r.deserializePB,exports.floorPercentage=r.floorPercentage,exports.gachaGameAndFormPaths=r.gachaGameAndFormPaths,exports.percentage=r.percentage,exports.resetGachaGameAndFormConfig=r.resetGachaGameAndFormConfig,exports.selectiveMerge=r.selectiveMerge,exports.selectiveMergeBatch=r.selectiveMergeBatch,exports.serializePB=r.serializePB,exports.setPbConfigProperties=r.setPbConfigProperties,exports.transformNodeByConfig=r.transformNodeByConfig,exports.updateProductDetailIdForProductList=r.updateProductDetailIdForProductList,exports.useBuilderStore=i.useBuilderStore,exports.useThemeStore=t.useThemeStore,exports.useHistoryStore=n.useHistoryStore,exports.PROVISION_STATUS=s.PROVISION_STATUS,exports.usePinposIntegrationStore=s.usePinposIntegrationStore,exports.useDraftStore=g.useDraftStore,exports.FormItem=u.FormItem,exports.RenderQuickSetting=p.RenderQuickSetting,exports.ColorPickerV2=a.ColorPickerV2,exports.ColorPickerV4=f.ColorPickerV4,exports.ColorPickerModal=C.ColorPickerModal,exports.ColorPickerModalV2=c.ColorPickerModalV2,exports.ColorDiv=l.ColorDiv,exports.ColorPickerModalV3=l.ColorPickerModalV3,exports.SelectedColor=l.SelectedColor,exports.ColorPickerDraggable=d.ColorPickerDraggable,exports.GradientBar=x.GradientBar,exports.SwitchToShow=m.SwitchToShow,exports.ModalConfigWrapper=S.ModalConfigWrapper,exports.QuickSettingButton=j.QuickSettingButton,exports.PrevNext=q.PrevNext,exports.SubQuickSetting=I.SubQuickSetting,exports.EditableCell=P.EditableCell,exports.StyledEditableCell=P.StyledEditableCell,exports.EditableContext=k.EditableContext,exports.EditableRow=k.EditableRow,exports.ContextMenu=b.ContextMenu,exports.UploadImageButton=T.UploadImageButton,exports.SettingWrapper=A.SettingWrapper,exports.ConfigWrapper=E.ConfigWrapper,exports.HorizontalPaddingDragHandler=V.HorizontalPaddingDragHandler,exports.Input=D.Input,exports.InputConfigV1=D.InputConfigV1,exports.InputConfig=B.InputConfig,exports.InputConfigV2=B.InputConfigV2,exports.InputV2=B.InputV2,exports.InputNumber=N.InputNumber,exports.InputNumberConfig=N.InputNumberConfig,exports.InputNumberConfigV2=M.InputNumberConfigV2,exports.InputNumberV2=M.InputNumberV2,exports.Select=v.Select,exports.SelectConfig=v.SelectConfig,exports.SwitchConfig=R.SwitchConfig,exports.UnitConfig=h.UnitConfig,exports.RadioConfig=U.RadioConfig,exports.DatePickerConfig=L.DatePickerConfig,exports.CodeEditorConfig=F.CodeEditorConfig,exports.TimingConfig=O.TimingConfig,exports.TimeVisibilityConfig=G.TimeVisibilityConfig,exports.ItemConfig=_.ItemConfig,exports.ItemListConfig=_.ItemListConfig,exports.RangeSliderConfig=w.RangeSliderConfig,exports.beforeUploadImage=y.beforeUploadImage,exports.ImageConfig=H.ImageConfig,exports.ImageUpload=Q.ImageUpload,exports.ImageUploadButton=W.ImageUploadButton,exports.ImageFormItem=z.ImageFormItem,exports.ImageFormItemV2=Y.ImageFormItemV2,exports.TrackingConfig=K.TrackingConfig,exports.EventClickConfig=X.EventClickConfig,exports.EventConfig=X.EventConfig,exports.SelectPopupConfig=J.SelectPopupConfig,exports.ImageListConfig=Z.ImageListConfig,exports.HoverConfig=$.HoverConfig,exports.AnimationConfig=ee.AnimationConfig,exports.AdvanceAttributes=oe.AdvanceAttributes,exports.ResponsiveAttribute=re.ResponsiveAttribute,exports.SpacingAttribute=ie.SpacingAttribute,exports.TimingAttributes=te.TimingAttributes,exports.ColorPickerConfig=ne.ColorPickerConfig,exports.ColorPickerConfigV2=se.ColorPickerConfigV2,exports.ColorPickerConfigV3=ge.ColorPickerConfigV3,exports.VerticalAlignmentConfig=ue.VerticalAlignmentConfig,exports.CustomRadioConfig=pe.CustomRadioConfig,exports.RangePickerConfig=ae.RangePickerConfig,exports.BackgroundPositionConfig=fe.BackgroundPositionConfig,exports.EffectAttributes=Ce.EffectAttributes,exports.ShadowConfig=ce.ShadowConfig,exports.AlignmentConfig=le.AlignmentConfig,exports.BackgroundConfig=de.BackgroundConfig,exports.BackgroundImageConfig=xe.BackgroundImageConfig,exports.BackgroundVideoConfig=me.BackgroundVideoConfig,exports.BorderConfig=Se.BorderConfig,exports.ButtonGroup=je.ButtonGroup,exports.ButtonGroupItem=qe.ButtonGroupItem,exports.TextareaToOptionConfig=Ie.TextareaToOptionConfig,exports.SizeAttribute=Pe.SizeAttribute,exports.VideoConfig=ke.VideoConfig,exports.FacebookConfig=be.FacebookConfig,exports.TikTokConfig=Te.TikTokConfig,exports.YouTubeConfig=Ae.YouTubeConfig,exports.UploadConfig=Ee.UploadConfig,exports.beforeUploadVideo=Ve.beforeUploadVideo,exports.getFileName=Ve.getFileName,exports.TextConfig=De.TextConfig,exports.InputSelectConfig=Be.InputSelectConfig,exports.TekoTrackingConfig=Ne.TekoTrackingConfig,exports.CornerConfig=Me.CornerConfig,exports.CornerConfigV2=ve.CornerConfigV2,exports.DocumentConfig=Re.DocumentConfig,exports.DirectionConfig=he.DirectionConfig,exports.CustomRadioButtonConfig=Ue.CustomRadioButtonConfig,exports.MinMaxInput=Le.MinMaxInput,exports.MinMaxInputConfig=Le.MinMaxInputConfig,exports.ImageRatioConfig=Fe.ImageRatioConfig,exports.AudioUploadConfig=Oe.AudioUploadConfig,exports.SelectArticleWebsite=Ge.SelectArticleWebsite,exports.SpacingConfig=_e.SpacingConfig,exports.ImageCropConfig=we.ImageCropConfig,exports.DraggableModal=ye.DraggableModal,exports.InputTextAreaConfig=He.InputTextAreaConfig,exports.AnimationLottieConfig=Qe.AnimationLottieConfig,exports.PROP_KEY=We.PROP_KEY,exports.resolvedNameMapping=ze.resolvedNameMapping,exports.DEFAULT_RESTRICTED_ELEMENT_CONFIG=Ye.DEFAULT_RESTRICTED_ELEMENT_CONFIG,exports.LLM_ACTION_TYPE=Ke.LLM_ACTION_TYPE,exports.LLM_EVENT_NAME=Ke.LLM_EVENT_NAME,exports.MESSAGE_ROLE=Ke.MESSAGE_ROLE,exports.TONE=Ke.TONE,exports.BuilderProvider=Xe.BuilderProvider,exports.BuilderStateContext=Xe.BuilderStateContext,exports.useBuilder=Xe.useBuilder,exports.withSelector=Je.withSelector,exports.withSelectorDirectElement=Je.withSelectorDirectElement,exports.useProp=Ze.useProp,exports.useEditor=$e.useEditor,exports.useTracking=eo.useTracking,exports.usePropSeparateDevice=oo.usePropSeparateDevice,exports.useSortable=ro.useSortable,exports.usePopupList=io.usePopupList,exports.useDraftNode=to.useDraftNode,exports.usePropDeviceSpecific=no.usePropDeviceSpecific,exports.OpenSettingDialog=so.OpenSettingDialog,exports.DeleteNode=go.DeleteNode,exports.DuplicateNode=uo.DuplicateNode,exports.EventQuickSetting=po.EventQuickSetting,exports.ImageListQuickSetting=ao.ImageListQuickSetting,exports.GuidelineNode=fo.GuidelineNode,exports.getColorThemeCssVarFromId=Co.getColorThemeCssVarFromId,exports.getColorValue=Co.getColorValue,exports.getHexColor=Co.getHexColor,exports.getRGBAColor=Co.getRGBAColor,exports.rgbaStringToObject=Co.rgbaStringToObject,exports.rgbaToString=Co.rgbaToString,exports.crafting=co.crafting,exports.getEditorName=co.getEditorName,exports.combineSize=lo.combineSize,exports.extractSize=lo.extractSize,exports.extractUrlFromCssUrl=lo.extractUrlFromCssUrl,exports.isNumeric=lo.isNumeric,exports.isPrefixUrl=lo.isPrefixUrl,exports.nomalizeText=lo.nomalizeText,exports.removeUnit=lo.removeUnit,exports.usePropOptionsUnitPercent=lo.usePropOptionsUnitPercent,exports.percentPropFormatter=xo.percentPropFormatter,exports.percentPropParser=mo.percentPropParser,exports.getImageObject=So.getImageObject,exports.editorRegistry=jo.editorRegistry;


/***/ }),

/***/ 342447:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(959211),r=__webpack_require__(547929),i=__webpack_require__(552884),n=__webpack_require__(887886);exports.DeleteNode=({customDelete:o})=>{const{actions:u,query:s}=i.useEditor(),{id:a,isDeletable:l}=r.useNode((e=>({isDeletable:s.node(e.id).isDeletable(),name:e.data.name,parent:e.data.parent})));return l?e.jsx(n.QuickSettingButton,{onClick:e=>{e.stopPropagation(),"function"==typeof o?o(a):u.delete(a)},children:e.jsx(t.Delete16Regular,{})}):null};


/***/ }),

/***/ 664185:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(547929),r=__webpack_require__(959211),i=__webpack_require__(552884),n=__webpack_require__(887886);exports.DuplicateNode=({track:u})=>{const{duplicateNode:o,getSiblings:d}=i.useEditor(),{id:s,node:c,parentId:a}=t.useNode((e=>({node:e,parentId:e.data.parent})));return e.jsx(n.QuickSettingButton,{onClick:()=>{const e=d(s).findIndex((e=>e===s));o(c,a,{index:e+1}),null==u||u()},children:e.jsx(r.Copy16Regular,{})})};


/***/ }),

/***/ 734777:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(429830),r=__webpack_require__(891987),i=__webpack_require__(959211),n=__webpack_require__(887886),o=__webpack_require__(883906),s=Object.defineProperty,u=Object.defineProperties,c=Object.getOwnPropertyDescriptors,l=Object.getOwnPropertySymbols,a=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,j=(e,t,r)=>t in e?s(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,b=(e,t)=>{for(var r in t||(t={}))a.call(t,r)&&j(e,r,t[r]);if(l)for(var r of l(t))p.call(t,r)&&j(e,r,t[r]);return e};exports.EventQuickSetting=s=>{const[l,a]=r.useState(!1);return e.jsxs(e.Fragment,{children:[e.jsx(n.QuickSettingButton,{tooltip:t.t("Gắn link"),onClick:()=>a(!0),children:e.jsx(i.Link16Regular,{})}),e.jsx(o.EventConfig,(p=b({},s),j={visible:l,setVisible:a},u(p,c(j))))]});var p,j};


/***/ }),

/***/ 130664:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(959211),i=__webpack_require__(547929),r=__webpack_require__(429830),t=__webpack_require__(887886);exports.GuidelineNode=()=>{const{name:o}=i.useNode((e=>({name:e.data.name}))),{guidelineUrls:u}=(null==window?void 0:window.config)||{},d=u&&u[o];return d&&e.jsx(t.QuickSettingButton,{onClick:()=>{window.open(d,"_blank","noopener,noreferrer")},tooltip:r.t("Video hướng dẫn"),children:e.jsx(n.QuestionCircle16Regular,{})})};


/***/ }),

/***/ 12961:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(429830),r=__webpack_require__(891987),i=__webpack_require__(959211),n=__webpack_require__(112628),o=__webpack_require__(887886),s=Object.defineProperty,u=Object.defineProperties,c=Object.getOwnPropertyDescriptors,a=Object.getOwnPropertySymbols,l=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,p=(e,t,r)=>t in e?s(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,j=(e,t)=>{for(var r in t||(t={}))l.call(t,r)&&p(e,r,t[r]);if(a)for(var r of a(t))g.call(t,r)&&p(e,r,t[r]);return e};exports.ImageListQuickSetting=s=>{const[a,l]=r.useState(!1);return e.jsxs(e.Fragment,{children:[e.jsx(o.QuickSettingButton,{tooltip:t.t("Quản lý ảnh"),onClick:()=>l(!0),children:e.jsx(i.ImageAddRegular,{style:{fontSize:16}})}),e.jsx(n.ImageListConfig,(g=j({},s),p={visible:a,setVisible:l},u(g,c(p))))]});var g,p};


/***/ }),

/***/ 414030:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(959211),i=__webpack_require__(547929),r=__webpack_require__(887886),n=__webpack_require__(313247),o=__webpack_require__(552884);exports.OpenSettingDialog=({children:s})=>{const{setShowSettingDialog:u}=n.useBuilder(),{actions:c}=o.useEditor(),{id:d}=i.useNode();return e.jsx(r.QuickSettingButton,{onClick:()=>{c.selectNode(d),u(!0)},children:s||e.jsx(t.Settings16Regular,{"data-testid":"btn-open-setting-dialog"})})};


/***/ }),

/***/ 935266:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));const e=(__webpack_require__(420851).create)((e=>({showModalSelectBlock:!1,setShowModalSelectBlock:t=>e({showModalSelectBlock:t}),openElementMenu:!1,setOpenElementMenu:t=>e({openElementMenu:t})})));exports.useBuilderStore=e;


/***/ }),

/***/ 516965:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(420851),t=__webpack_require__(410953),r=Object.defineProperty,a=Object.defineProperties,o=Object.getOwnPropertyDescriptors,n=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,i=Object.prototype.propertyIsEnumerable,s=(e,t,a)=>t in e?r(e,t,{enumerable:!0,configurable:!0,writable:!0,value:a}):e[t]=a,f=(e,t)=>{for(var r in t||(t={}))d.call(t,r)&&s(e,r,t[r]);if(n)for(var r of n(t))i.call(t,r)&&s(e,r,t[r]);return e},u=(e,t)=>a(e,o(t));const c=(e,t,r)=>{const a=t.split(".");if(1===a.length)return e[a[0]]===r?e:u(f({},e),{[a[0]]:r});const[o,...n]=a,d=e[o]||{},i=c(d,n.join("."),r);return i===d?e:u(f({},e),{[o]:i})},l=new Map,p=e=>{const t=l.get(e);t&&(t.rafId&&cancelAnimationFrame(t.rafId),t.timeoutId&&clearTimeout(t.timeoutId),l.delete(e))},m=e.create()(t.subscribeWithSelector(((e,t)=>({drafts:{},updateDraft:(t,r,a)=>{e((e=>{const o=e.drafts[t]||{},n=c(o,r,a);return n===o?e:{drafts:u(f({},e.drafts),{[t]:n})}}))},updateDraftThrottled:(e,r,a)=>{const o=`${e}:${r}`,n=Date.now();let d=l.get(o);d||(d={lastUpdate:0},l.set(o,d));const i=n-d.lastUpdate;if(d.rafId&&(cancelAnimationFrame(d.rafId),d.rafId=void 0),d.timeoutId&&(clearTimeout(d.timeoutId),d.timeoutId=void 0),i>=16)d.lastUpdate=n,d.pendingValue=void 0,t().updateDraft(e,r,a);else{d.pendingValue=a;const n=16-i;d.rafId=requestAnimationFrame((()=>{const a=l.get(o);a&&(a.rafId=void 0,a.timeoutId=window.setTimeout((()=>{const a=l.get(o);a&&(void 0!==a.pendingValue&&(a.lastUpdate=Date.now(),t().updateDraft(e,r,a.pendingValue),a.pendingValue=void 0),a.timeoutId=void 0)}),Math.max(0,n-1)))}))}},clearDraft:t=>{for(const[e]of l)e.startsWith(`${t}:`)&&p(e);e((e=>{if(!e.drafts[t])return e;const r=f({},e.drafts);return delete r[t],{drafts:r}}))},commitDraft:(e,r)=>{for(const[r,a]of l)if(r.startsWith(`${e}:`)){if(a.rafId&&cancelAnimationFrame(a.rafId),a.timeoutId&&clearTimeout(a.timeoutId),void 0!==a.pendingValue){const o=r.substring(e.length+1);t().updateDraft(e,o,a.pendingValue)}l.delete(r)}const a=t().drafts[e];return!!a&&(r(a),t().clearDraft(e),!0)}}))));if("undefined"!=typeof window){const e=()=>{for(const[e]of l)p(e)};window.addEventListener("beforeunload",e)}exports.useDraftStore=m;


/***/ }),

/***/ 428263:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(420851),e=__webpack_require__(410953);const s=(t,e)=>s=>{t("function"==typeof s?t=>({[e]:s(t[e])}):{[e]:s})},r=t.create()(e.devtools((t=>({pastColorPaletteList:[],futureColorPaletteList:[],pastTextStyleList:[],futureTextStyleList:[],setPastColorPaletteList:s(t,"pastColorPaletteList"),setFutureColorPaletteList:s(t,"futureColorPaletteList"),setPastTextStyleList:s(t,"pastTextStyleList"),setFutureTextStyleList:s(t,"futureTextStyleList")}))));exports.useHistoryStore=r;


/***/ }),

/***/ 446062:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var i=__webpack_require__(610314),t=__webpack_require__(420851),e=__webpack_require__(410953),n=__webpack_require__(429830);const r="current_mapping_terminals";var o=(i=>(i.IDLE="idle",i.PROVISIONING="provisioning",i.PROVISIONED="provisioned",i.FAILED="failed",i.TIMEOUT="timeout",i))(o||{});const s=t.create()(e.subscribeWithSelector(e.devtools(((t,e)=>({startProvisioning:!1,terminalId:"",loadingIntegration:!1,provisionStatus:"idle",pinposAppId:null,initializedMerchantId:null,pinposApiService:null,mmApiService:null,pollingInterval:null,startTime:null,retryCount:0,autoProvisionTriggered:!1,setStartProvisioning:i=>{t({startProvisioning:i}),i||t({autoProvisionTriggered:!1})},setTerminalId:i=>t({terminalId:i}),setLoadingIntegration:i=>t({loadingIntegration:i}),setProvisionStatus:i=>t({provisionStatus:i}),setPinposAppId:i=>t({pinposAppId:i}),initializeProvisioning:(i,e,n)=>{t({pinposAppId:i,mmApiService:e,initializedMerchant:n})},initializeTerminalMapping:(i,e,n)=>{t({pinposApiService:i,website:e,flagPB4900:n})},createTerminal:async i=>{const{pinposApiService:t,provisionStatus:n}=e();if(!t||"provisioned"!==n)return null;const r=i=>new Promise((t=>setTimeout(t,i)));for(let e=1;e<=3;e++)try{const e=await t.createTerminal(i);return(null==e?void 0:e.terminalId)||null}catch(i){e<3&&await r(5e3)}return null},fetchTerminalIdByWebsite:async i=>{const{pinposApiService:t}=e();if(!t)return null;try{return e().getTerminalIdFromLocalStorage(i)||await t.getTerminalId(i)}catch(i){return null}},initPinposTerminal:async()=>{var i;const{pinposAppId:t,setTerminalId:n,fetchTerminalIdByWebsite:r,createTerminal:o,saveTerminalIdToLocalStorage:s,provisionStatus:a,flagPB4900:l,website:p,initializedMerchant:c}=e();try{if(!l||!p||(null==(i=p.extraInfo)?void 0:i.sellingPartnerId)!==t||"provisioned"!==a)return;let e=await r(p.id);e||"provisioned"!==a||(e=await o({websiteId:p.id,websiteName:p.name||"",merchantId:c.marketMerchantId})),e&&(n(e),s(e,p.id))}catch(i){}},getTerminalIdFromLocalStorage:i=>{if("undefined"==typeof window||!window.localStorage)return null;try{const t=JSON.parse(localStorage.getItem(r)||"null");return(null==t?void 0:t.websiteId)===i&&(null==t?void 0:t.terminalId)||null}catch(i){return null}},saveTerminalIdToLocalStorage:(i,t)=>{if("undefined"!=typeof window&&window.localStorage)try{localStorage.setItem(r,JSON.stringify({websiteId:t,terminalId:i}))}catch(i){}},clearPolling:()=>{const{pollingInterval:i}=e();i&&clearInterval(i),t({pollingInterval:null,startTime:null})},resetProvisioning:()=>{const{clearPolling:i}=e();i(),t({provisionStatus:"idle",retryCount:0})},checkPinposProvision:i=>{const{pinposAppId:n}=e();if(!i||!i.length||!n)return!1;const r=i.some((i=>i.appId===n&&i.isActive&&i.isNotified));return r&&t({provisionStatus:"provisioned"}),r},checkPinposStatus:async()=>{const{pinposAppId:t,clearPolling:r,setProvisionStatus:o,checkPinposProvision:s,mmApiService:a,initPinposTerminal:l,terminalId:p,setLoadingIntegration:c}=e();if(!t||!a)return!1;try{const t=await a.getOwnedLBMerchant();if((null==t?void 0:t.length)>0){if(s(t[0].subscriptions))return r(),p||(await l(),c(!1),i.notification.success({message:n.t("pinpos_integration.success_provision")})),!0;{const{startTime:t}=e();null!==t&&Date.now()-t>9e5&&(i.notification.error({message:n.t("pinpos_integration.error_provision_timeout")}),o("timeout"),r(),c(!1))}}}catch(i){}return!1},callProvisionApi:async()=>{const{pinposAppId:i,mmApiService:t}=e();if(!i||!t)return!1;try{return await t.provisionApp({appIds:[i]}),!0}catch(i){return!1}},retryProvision:async()=>{const{retryCount:i,setProvisionStatus:n,callProvisionApi:r}=e();return i>=3?(n("failed"),!1):(t({retryCount:i+1}),new Promise((i=>{setTimeout((async()=>{const t=await r();i(t)}),5e3)})))},provisionPinpos:async()=>{const{pinposAppId:r,clearPolling:o,setProvisionStatus:s,checkPinposProvision:a,checkPinposStatus:l,callProvisionApi:p,retryProvision:c,resetAutoProvisionFlag:u,setLoadingIntegration:d,initializedMerchant:v}=e();if(!r||!v)return{success:!1,error:new Error("Pinpos App ID not initialized")};try{d(!0),t({retryCount:0});let i=!1;if(i=(null==v?void 0:v.subscriptions)?a(v.subscriptions):await l(),i)return t({provisionStatus:"provisioned"}),o(),{success:!0};const{pollingInterval:n}=e();if(n)return{success:!1,error:new Error("Provision already in progress")};s("provisioning");let r=await p();for(;!r&&e().retryCount<3;)r=await c();if(!r)return s("failed"),{success:!1,error:new Error("Failed to provision Pinpos after multiple attempts")};if(await l())return t({provisionStatus:"provisioned"}),{success:!0};t({startTime:Date.now()});const u=setInterval((async()=>{await l()}),3e4);return t({pollingInterval:u}),{success:!0,message:"Provision process started"}}catch(t){return i.notification.error({message:n.t("pinpos_integration.error_provision")}),d(!1),{success:!1,error:new Error("Failed to provision Pinpos")}}finally{u()}},cancelProvision:()=>{const{pollingInterval:i,clearPolling:t,setProvisionStatus:n}=e();return!!i&&(t(),n("idle"),!0)},getStartProvisioning:()=>e().startProvisioning,getTerminalId:()=>e().terminalId,getLoadingIntegration:()=>e().loadingIntegration,getProvisionStatus:()=>e().provisionStatus,resetAutoProvisionFlag:()=>t({autoProvisionTriggered:!1})})))));s.subscribe((i=>({startProvisioning:i.startProvisioning,loadingIntegration:i.loadingIntegration,provisionStatus:i.provisionStatus,pinposAppId:i.pinposAppId,mmApiService:i.mmApiService,autoProvisionTriggered:i.autoProvisionTriggered})),((i,t)=>{i.startProvisioning&&!t.startProvisioning&&!i.loadingIntegration&&"idle"===i.provisionStatus&&i.pinposAppId&&i.mmApiService&&!i.autoProvisionTriggered&&(s.setState({autoProvisionTriggered:!0}),setTimeout((()=>{const{provisionPinpos:i}=s.getState();i()}),0))})),exports.PROVISION_STATUS=o,exports.usePinposIntegrationStore=s;


/***/ }),

/***/ 10619:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(420851),t=__webpack_require__(410953),o=__webpack_require__(85097),a=Object.defineProperty,r=Object.defineProperties,n=Object.getOwnPropertyDescriptors,i=Object.getOwnPropertySymbols,l=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,f=(e,t,o)=>t in e?a(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o,s=(e,t)=>{for(var o in t||(t={}))l.call(t,o)&&f(e,o,t[o]);if(i)for(var o of i(t))g.call(t,o)&&f(e,o,t[o]);return e},d=(e,t)=>r(e,n(t));const c=e.create()(t.devtools(((e,t)=>({theme:void 0,fontFamilyHeading:void 0,fontFamilyParagraph:void 0,headingsConfig:[],paragraphsConfig:[],currentColorPalette:void 0,recentColors:[],loadingUpdateTheme:[],setFontFamilyHeading:t=>e({fontFamilyHeading:t}),setFontFamilyParagraph:t=>e({fontFamilyParagraph:t}),setHeadingsConfig:t=>e({headingsConfig:t}),setParagraphsConfig:t=>e({paragraphsConfig:t}),setCurrentColorPalette:t=>e({currentColorPalette:t}),setTheme:t=>e({theme:t}),setRecentColors:t=>e({recentColors:t}),initThemeData:async t=>{const a=((null==t?void 0:t.fontStyles)||[]).reduce(((e,t)=>{const a=t,{fontFamily:r}=a,n=((e,t)=>{var o={};for(var a in e)l.call(e,a)&&t.indexOf(a)<0&&(o[a]=e[a]);if(null!=e&&i)for(var a of i(e))t.indexOf(a)<0&&g.call(e,a)&&(o[a]=e[a]);return o})(a,["fontFamily"]);return o.isHeadingFontStyle(t.id)&&(e.headingsConfig.push(n),e.fontFamilyHeading=r,e.fontFamilyHeadingSource=t.fontSource),o.isParagraphFontStyle(t.id)&&(e.paragraphsConfig.push(n),e.fontFamilyParagraph=r,e.fontFamilyParagraphSource=t.fontSource),e}),{headingsConfig:[],paragraphsConfig:[],fontFamilyHeading:"",fontFamilyParagraph:"",fontFamilyHeadingSource:o.FontSource.GOOGLE,fontFamilyParagraphSource:o.FontSource.GOOGLE});e({fontFamilyHeading:{value:a.fontFamilyHeading,source:a.fontFamilyHeadingSource},fontFamilyParagraph:{value:a.fontFamilyParagraph,source:a.fontFamilyParagraphSource},headingsConfig:a.headingsConfig,paragraphsConfig:a.paragraphsConfig,currentColorPalette:(null==t?void 0:t.colorPalette)||[],recentColors:null==t?void 0:t.recentColors,initialized:!0,theme:t})},updateThemeConfig:(o,a)=>{if(!o)return;const r=t(),{paragraphStyles:n=r.paragraphsConfig,headingStyles:i=r.headingsConfig,ffHeading:l=r.fontFamilyHeading,ffParagraph:g=r.fontFamilyParagraph,recentColors:f=r.recentColors}=o,c=n.map((e=>d(s({},e),{fontFamily:g.value,fontSource:g.source}))),p=i.map((e=>d(s({},e),{fontFamily:l.value,fontSource:l.source})));e(d(s(s(s(s(s({},o.headingStyles?{headingsConfig:p}:{}),o.paragraphStyles?{paragraphsConfig:c}:{}),o.ffHeading?{fontFamilyHeading:l}:{}),o.ffParagraph?{fontFamilyParagraph:g}:{}),o.recentColors?{recentColors:f}:{}),{theme:{colorPalette:r.currentColorPalette,fontStyles:[...p,...c],recentColors:f}})),null==a||a({colorPalette:r.currentColorPalette,fontStyles:[...p,...c],recentColors:f})},getCurrentTheme:()=>t().theme,getCurrentColor:()=>t().currentColorPalette,loadFont:()=>{const e=t();e.initialized&&(e.fontFamilyHeading.source===o.FontSource.GOOGLE&&o.loadNewGGFont(e.fontFamilyHeading.value,[document]),e.fontFamilyParagraph.source===o.FontSource.GOOGLE&&o.loadNewGGFont(e.fontFamilyParagraph.value,[document]))},getThemeMapping:()=>{var e,o;const a=t(),r=null==(e=a.theme.colorPalette)?void 0:e.reduce(((e,t)=>(e[t.id]=t.color,e)),{}),n=null==(o=a.theme.fontStyles)?void 0:o.reduce(((e,t)=>{const o=t.fontSizeUnit||"px",a=t.mobileFontSize||t.fontSize,r=t.mobileFontSizeUnit||o,n=t.mobileLetterSpacing||t.letterSpacing,i=t.mobileLineHeight||t.lineHeight;return e[`${t.id}fontfamily`]=t.fontFamily,e[`${t.id}fontsize`]=`${t.fontSize}${o}`,e[`${t.id}fontweight`]=t.fontWeight,e[`${t.id}letterspacing`]=void 0!==t.letterSpacing?`${t.letterSpacing}px`:"unset",e[`${t.id}lineheight`]=void 0!==t.lineHeight?`${t.lineHeight}px`:"unset",e[`${t.id}mobilefontsize`]=`${a}${r}`,e[`${t.id}mobilefontweight`]=t.mobileFontWeight||t.fontWeight,e[`${t.id}mobileletterspacing`]=void 0!==n?`${n}px`:"unset",e[`${t.id}mobilelineheight`]=void 0!==i?`${i}px`:"unset",e}),{});return s(s({},r),n)}}))));exports.useThemeStore=c;


/***/ }),

/***/ 805116:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var r=__webpack_require__(85097),t=__webpack_require__(429830);const e=r=>{if(!r)return null;const t=/rgb\(/.test(r),e=r.indexOf(",")>-1?",":" ",o=r.substr(t?4:5).split(")")[0].split(e);let l=(+o[0]).toString(16),n=(+o[1]).toString(16),i=(+o[2]).toString(16),s=1,a="ff";return o.length>=4&&(s=parseFloat(o[3]),a=0===s?"00":Math.round(255*s).toString(16)),1===l.length&&(l="0"+l),1===n.length&&(n="0"+n),1===i.length&&(i="0"+i),1===a.length&&(a="0"+a),{hex:"#"+l+n+i+a,rgba:{r:parseInt(o[0]),g:parseInt(o[1]),b:parseInt(o[2]),a:s}}},o=r=>`rgba(${r.r},${r.g},${r.b},${null!=r.a?r.a:1})`,l=r=>r.startsWith("#")?r:r.startsWith("rgb")?e(r).hex:void 0;exports.getColorThemeCssVarFromId=r=>`var(--tempi-global-${r})`,exports.getColorValue=(e,o=!0)=>{if(!e)return;const n=r.parseColor(e);if((null==n?void 0:n.colorType)===r.ColorType.gradient)return;if((null==n?void 0:n.colorType)===r.ColorType.solid)return l(e);const i=e.match(/var\(--tempi-global-color(\d+)\)/),s=null==i?void 0:i[1];return s?o?`${t.t("Màu")} ${s}`:t.t("color_picker.color_in_theme",{indexColor:s}):i?t.t("common.theme_color"):void 0},exports.getHexColor=l,exports.getRGBAColor=t=>{var l;if(!t)return null;let n=t;/^#.+$/.test(t)&&(n=r.getRgbaFromHex(t));const i=null==(l=e(n))?void 0:l.rgba;return o(i)},exports.rgbaStringToObject=e,exports.rgbaToString=o;


/***/ }),

/***/ 684319:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=Object.defineProperty,e=Object.defineProperties,o=Object.getOwnPropertyDescriptors,r=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,n=Object.prototype.propertyIsEnumerable,a=(e,o,r)=>o in e?t(e,o,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[o]=r,d=(t,e)=>{for(var o in e||(e={}))i.call(e,o)&&a(t,o,e[o]);if(r)for(var o of r(e))n.call(e,o)&&a(t,o,e[o]);return t};const c={commonStyle:{margin:{top:void 0,bottom:void 0,left:void 0,right:void 0},padding:{top:void 0,bottom:void 0,left:void 0,right:void 0},backgroundColor:void 0,backgroundRepeat:void 0,backgroundPosition:void 0,backgroundSize:void 0,width:void 0,maxWidth:void 0,minWidth:void 0,height:void 0,maxHeight:void 0,minHeight:void 0}},s={responsive:{hiddenXs:!1,hiddenMd:!1}};exports.crafting=t=>{var a=t,{props:u={},related:v={},customAttributes:b,commonAttributes:l,advanceAttributes:p,advanceAttributesApp:m,effectAttributes:f,rules:g,custom:A={},tag:y,commonStyle:O={},quickSetting:h}=a,S=((t,e)=>{var o={};for(var a in t)i.call(t,a)&&e.indexOf(a)<0&&(o[a]=t[a]);if(null!=t&&r)for(var a of r(t))e.indexOf(a)<0&&n.call(t,a)&&(o[a]=t[a]);return o})(a,["props","related","customAttributes","commonAttributes","advanceAttributes","advanceAttributesApp","effectAttributes","rules","custom","tag","commonStyle","quickSetting"]);const j=d({},v);return b&&(j.customAttributes=b),l&&(j.commonAttributes=l),p&&(j.advanceAttributes=p),m&&(j.advanceAttributesApp=m),h&&(j.quickSetting=h),f&&(j.effectAttributes=f),d({props:d(d((k=d({},c),x={commonStyle:O},e(k,o(x))),s),u),related:j,rules:g,custom:d(d({},A),{tag:y})},S);var k,x},exports.getEditorName=t=>{var e;return null==(e=Object.keys(t))?void 0:e[0]};


/***/ }),

/***/ 105084:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));const e=new class{constructor(){this.editors=new Map}register(e,t){this.editors.set(e,t)}unregister(e){this.editors.delete(e)}get(e){return this.editors.get(e)}};exports.editorRegistry=e;


/***/ }),

/***/ 737577:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.getImageObject=async e=>new Promise((async(o,r)=>{const t=await(e=>new Promise(((o,r)=>{const t=new FileReader;t.readAsDataURL(e),t.onloadend=()=>o(t.result.toString()),t.onerror=e=>r(e)})))(e),n=new Image;n.src=t,n.onload=()=>{n.complete&&o(n)},n.onerror=e=>r(e)}));


/***/ }),

/***/ 647199:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097),t=__webpack_require__(630839),o=__webpack_require__(567669),r=__webpack_require__(407229),n=__webpack_require__(47248),a=__webpack_require__(184217),i=__webpack_require__(214220);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=l(t),s=l(r),p=l(n),u=Object.defineProperty,c=Object.defineProperties,m=Object.getOwnPropertyDescriptors,g=Object.getOwnPropertySymbols,v=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,y=(e,t,o)=>t in e?u(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o,h=(e,t)=>{for(var o in t||(t={}))v.call(t,o)&&y(e,o,t[o]);if(g)for(var o of g(t))f.call(t,o)&&y(e,o,t[o]);return e},b=(e,t)=>c(e,m(t));const O=e=>Math.floor(100*e)/100,N=(e,t)=>O(e/t*100)+"%",E=[{path:["customAttributes","luckydrawv2","configStorage","formConfigId"],tag:"luckydrawv2"},{path:["elementId"],tag:"luckydrawv2"},{path:["customAttributes","luckymoney","gameId"],tag:"luckymoney"},{path:["customAttributes","luckymoney","configStorage","formConfigId"],tag:"luckymoney"},{path:["customAttributes","potsmashing","configStorage","formConfigId"],tag:"potsmashing"},{path:["customAttributes","potsmashing","gameId"],tag:"potsmashing"},{path:["customAttributes","treasurehunting","configStorage","formConfigId"],tag:"treasurehunting"},{path:["customAttributes","treasurehunting","gameId"],tag:"treasurehunting"},{path:["customAttributes","formv4","configStorage","formConfigId"],tag:"formv4"},{path:["customAttributes","formcheckout","configStorage","formConfigId"],tag:"formcheckout"},{path:["customAttributes","leadform","configStorage","formConfigId"],tag:"leadform"},{path:["customAttributes","tempiproductlistv3","productDisplay","categoryId"],tag:"tempiproductlistv3"},{path:["customAttributes","tempiproductlistv3","productDisplay","skus"],tag:"tempiproductlistv3"},{path:["customAttributes","orderpopupv2","configStorage","formConfigId"],tag:"orderpopupv2"}],P=["tempiproductlistv2","tempiproductlist"],k=["tempiproductlistv3"],j=(e,t,o=null)=>{for(const r in e)t.forEach((t=>{e[r].tag===t.tag&&s.default(e[r],t.path,o)}))},M=new Set([e.HEADER,e.FOOTER,e.TOP_BANNER]),I=({node:e,transformElementConfig:t,tag:o,mappingKey:r})=>{const n=t.filter((e=>e.tags.includes(o)));return(null==n?void 0:n.length)?(n.forEach((t=>{(t.resetFields||[]).forEach((t=>{s.default(e,t,void 0)})),Object.entries(t.mappingFields||{}).forEach((([t,o])=>{const n=p.default(e,t);n&&s.default(e,t,o(n,r))}))})),e):e},C=(e,t)=>{const o=t(e).get();if(o)return o.data.parent&&t(o.data.parent).get()},A=(e,t)=>{var o;t&&e[t]&&(((null==(o=e[t].data)?void 0:o.nodes)||[]).forEach((t=>A(e,t))),delete e[t])},S=e=>{Object.values(e).forEach((t=>{if(t.data.name===i.resolvedNameMapping.TempiProductListEditorV3){let o;t.data.nodes.forEach((t=>{const r=e[t];r.data.name===i.resolvedNameMapping.ProductDetailPopupEditor&&(o=r.id,r.data.props.id=r.id)})),t.data.props.productDetailPopup=o}}))},x=e=>"object"==typeof e&&null!==e&&!Array.isArray(e),R=Array.isArray,D=e=>e!==Object(e),w=(e,t)=>{const o=e.length,r=t.length,n=o>r?o:r;let a,i=!1;for(let l=0;l<n;l++){const n=t[l],d=e[l];if(l>=o){null!=n&&(i||(a=e.slice(),i=!0),a.push(n));continue}if(l>=r||null==n){i&&a.push(d);continue}const s=T(d,n);s!==d?(i||(a=e.slice(0,l),i=!0),a.push(s)):i&&a.push(d)}return i?a:e},T=(e,t)=>{if(D(e)||D(t))return e===t?e:t;const o=R(e),r=R(t);return o&&r?w(e,t):o||r?((e,t)=>{if(e===t)return!0;if("object"!=typeof e||null===e||null===t)return!1;const o=Object.keys(e),r=o.length;if(r!==Object.keys(t).length)return!1;for(let n=0;n<r;n++){const r=o[n];if(e[r]!==t[r])return!1}return!0})(e,t)?e:t:B(e,t)},B=(e,t)=>{const o=Object.keys(t);if(0===o.length)return e;let r=e,n=!1;for(let a=0;a<o.length;a++){const i=o[a],l=t[i];if(void 0===l)continue;const d=e[i];if(l===d)continue;let s;s=R(l)?R(d)?w(d,l):l:x(l)?x(d)||R(d)?B(d,l):l:d===l?d:l,s!==d&&(n||(r=R(e)?e.slice():h({},e),n=!0),r[i]=s)}return r};exports.clonePageContent=(t,o,r=!1)=>{if(!t)return t;const n={},a=Object.keys(t).filter((o=>t[o].parentId===e.ROOT)),i=parseInt(e.generateRandomId(10).replaceAll(".",""),36);for(let e=0;e<a.length;e++)n[a[e]]="."+(i+e).toString(36);for(const o in t)o===e.ROOT?n[o]=o:n[o]||(n[o]=e.generateRandomId(10));const l={};return Object.entries(t).forEach((([e,t])=>{t.id=n[t.id]||t.id,t.children=(t.children||[]).map((e=>n[e]||e)),t.parentId=n[t.parentId]||t.parentId;const r=n[e];l[r]=I({tag:t.tag,node:t,mappingKey:n,transformElementConfig:o})})),r?[l,n]:l},exports.defaultCanCopyPaste=(e,t)=>!Array.from(e).some((e=>{var o,r,n,a,l,d;const s=t(e).get(),p=null==(o=null==s?void 0:s.data)?void 0:o.name;return p===i.resolvedNameMapping.Row?[i.resolvedNameMapping.OrderPopupEditor,i.resolvedNameMapping.ProductDetailPopupEditor].includes(null==(n=null==(r=C(e,t))?void 0:r.data)?void 0:n.name):p===i.resolvedNameMapping.Col?[i.resolvedNameMapping.OrderPopupEditor,i.resolvedNameMapping.ProductDetailPopupEditor].includes(null==(d=null==(l=C(null==(a=null==s?void 0:s.data)?void 0:a.parent,t))?void 0:l.data)?void 0:d.name):[i.resolvedNameMapping.CheckoutFormEditor,i.resolvedNameMapping.OrderPopupEditor,i.resolvedNameMapping.ProductDetailPopupEditor,i.resolvedNameMapping.ButtonSubmitV3Editor].includes(p)})),exports.defaultCanDeleteNode=(t,o)=>!Array.from(t).some((e=>{var t,r,n,a,l,d;const s=o(e).get(),p=null==(t=null==s?void 0:s.data)?void 0:t.name;return p===i.resolvedNameMapping.Row?[i.resolvedNameMapping.OrderPopupEditor,i.resolvedNameMapping.ProductDetailPopupEditor].includes(null==(n=null==(r=C(e,o))?void 0:r.data)?void 0:n.name):p===i.resolvedNameMapping.Col?[i.resolvedNameMapping.OrderPopupEditor,i.resolvedNameMapping.ProductDetailPopupEditor].includes(null==(d=null==(l=C(null==(a=null==s?void 0:s.data)?void 0:a.parent,o))?void 0:l.data)?void 0:d.name):[i.resolvedNameMapping.CheckoutFormEditor,i.resolvedNameMapping.OrderPopupEditor,i.resolvedNameMapping.ProductDetailPopupEditor,i.resolvedNameMapping.ButtonSubmitV3Editor].includes(p)}))||t.has(e.ARTICLE_HEADER),exports.defaultShortcutHandler=(e,t,o)=>{var r;let n;const l=(()=>{var e;const t=window.location.pathname.split("/").filter(Boolean)[0],o=localStorage.getItem("current_mapping_terminals");return o&&(null==(e=JSON.parse(o))?void 0:e.websiteId)===+t})(),d=((e,t)=>(Object.values(e).forEach((o=>{var r,n,a,i,l;if(!t.includes(null==(n=null==(r=null==o?void 0:o.data)?void 0:r.custom)?void 0:n.tag))return;A(e,null==o?void 0:o.id);const d=null==(l=null==(i=e[null==(a=null==o?void 0:o.data)?void 0:a.parent])?void 0:i.data)?void 0:l.nodes;if(!d)return;const s=d.indexOf(o.id);-1!==s&&(d.splice(s,1),e[o.data.parent].data.nodes=d)})),e))(e.nodes,l?P:k);l&&S(d);const s=d[e.rootNodeId];switch(null==(r=null==s?void 0:s.data)?void 0:r.name){case void 0:break;case i.resolvedNameMapping.Col:n=a.getPositionDropCol(t.id,d,o);break;case i.resolvedNameMapping.Row:n=a.getPositionDropRow(t.id,d,o);break;case i.resolvedNameMapping.WebsiteHeaderEditor:case i.resolvedNameMapping.TopBannerEditor:case i.resolvedNameMapping.WebsiteFooterEditor:n=a.getPositionDropGlobalBlock(s.id,o);break;default:n=a.getPositionDropElement(t.id,o)}return n},exports.defaultUniqueNodeIds=M,exports.deserializePB=(t,r,n)=>{if(!t||0===Object.keys(t).length)return"";const a=Object.assign({},d.default(t)),l=[];return Object.keys(a).forEach((e=>{var t,d;const s=a[e],p=(null==s?void 0:s.children)||[];let u={},c=s.tag;if(null==(t=s.customAttributes)?void 0:t[c]){const e=null==(d=s.customAttributes)?void 0:d[c];"galleryslideshow"===c&&(c="slider"),u=h(h({},u),"col"===c?(e=>{const{md:t,xs:r}=e;return"number"==typeof t&&(e.md={flex:N(t,o.GRID_COLUMNS)}),"number"==typeof r&&(e.xs={flex:N(r,o.GRID_COLUMNS)}),e})(e):e)}s.style&&Object.keys(s.style).length&&(u.commonStyle=s.style,s.style.desktop&&Object.keys(s.style.desktop).length&&u.desktop&&(u.desktop.commonStyle=s.style.desktop,delete u.commonStyle.desktop),s.style.mobile&&Object.keys(s.style.mobile).length&&u.mobile&&(u.mobile.commonStyle=s.style.mobile,delete u.commonStyle.mobile)),a[e]={type:{resolvedName:i.resolvedNameMapping[s.resolvedName]||s.resolvedName},displayName:s.resolvedName,isCanvas:void 0===s.isCanvas?"root"===c||"col"===c||"menucol"===c:s.isCanvas,nodes:p,parent:s.parentId,custom:{tag:c,displayName:s.displayName,startTime:s.startTime,endTime:s.endTime,ruleRepeat:s.ruleRepeat,date:s.date,duration:s.duration},props:b(h({},u),{id:s.elementId})},(r&&("section"===s.tag||"globalblock"===s.tag)||n&&["popupv1","inlinebanner"].includes(s.tag))&&l.push(e)})),(r||n)&&(a[e.ROOT]={type:{resolvedName:"RootEditor"},displayName:e.ROOT,isCanvas:!0,nodes:l,parent:null,custom:{tag:e.ROOT.toLowerCase(),isEditingBlock:r},props:{}}),a},exports.floorPercentage=O,exports.gachaGameAndFormPaths=E,exports.percentage=N,exports.resetGachaGameAndFormConfig=e=>j(e,E),exports.selectiveMerge=B,exports.selectiveMergeBatch=(e,t)=>{const o=Object.keys(t);if(0===o.length)return e;const r={};let n=!1;for(let a=0;a<o.length;a++){const i=o[a],l=t[i];if(void 0===l||l===e[i])continue;const d=e[i];let s;s=R(l)?R(d)?w(d,l):l:x(l)?x(d)||R(d)?B(d,l):l:d===l?d:l,s!==d&&(r[i]=s,n=!0)}return n?R(e)?[...e,...Object.values(r)]:h(h({},e),r):e},exports.serializePB=(t,o)=>{const{serializedNodeIds:r,isEditingBlock:n,isEditingPopup:a}=o||{},i=Object.assign({},t);return Object.keys(i).forEach((t=>{var o,l,d,s,p,u,c,m;if(m=t,(null==r?void 0:r.length)?r.includes(m):!n&&!a||m!==e.ROOT){const r=i[t];let n=null==(o=null==r?void 0:r.custom)?void 0:o.tag,a=[];"galleryslideshow"===n&&r.parent===e.ROOT&&(n="slider"),a="section"===n||"row"===n?r.nodes.length?r.nodes:Object.values(r.linkedNodes):r.nodes;const m=r.props||{},{commonStyle:y,hidden:O,id:N}=m,E=((e,t)=>{var o={};for(var r in e)v.call(e,r)&&t.indexOf(r)<0&&(o[r]=e[r]);if(null!=e&&g)for(var r of g(e))t.indexOf(r)<0&&f.call(e,r)&&(o[r]=e[r]);return o})(m,["commonStyle","hidden","id"]),{startTime:P,endTime:k,date:j,duration:M,ruleRepeat:I}=r.custom;(null==y?void 0:y.margin)&&delete y.margin.main,(null==y?void 0:y.padding)&&delete y.padding.main;const C=(null==(l=null==E?void 0:E.desktop)?void 0:l.commonStyle)||{},A=(null==(d=null==E?void 0:E.mobile)?void 0:d.commonStyle)||{};null==(s=null==E?void 0:E.desktop)||delete s.commonStyle,null==(p=null==E?void 0:E.mobile)||delete p.commonStyle,(null==C?void 0:C.margin)&&delete C.margin.main,(null==C?void 0:C.padding)&&delete C.padding.main,(null==A?void 0:A.margin)&&delete A.margin.main,(null==A?void 0:A.padding)&&delete A.padding.main,i[t]={id:t,elementId:N,parentId:r.parent||null,tag:n,displayName:null==(u=null==r?void 0:r.custom)?void 0:u.displayName,resolvedName:null==(c=null==r?void 0:r.type)?void 0:c.resolvedName,style:b(h({},y||{}),{desktop:Object.keys(C).length?C:void 0,mobile:Object.keys(A).length?A:void 0}),isCanvas:r.isCanvas,customAttributes:{[n]:E},children:a,startTime:P,endTime:k,date:j,duration:M,ruleRepeat:I}}else delete i[t]})),i},exports.setPbConfigProperties=j,exports.transformNodeByConfig=I,exports.updateProductDetailIdForProductList=S;


/***/ }),

/***/ 116176:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.percentPropFormatter=e=>{if("number"==typeof e)return Math.floor(100*e)};


/***/ }),

/***/ 904511:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.percentPropParser=e=>{if("number"==typeof e)return e/100};


/***/ }),

/***/ 184217:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097),a=__webpack_require__(214220);const t=(e,a)=>{const t=((e,a)=>{const t=a(e).get();if(t)return t.data.parent&&a(t.data.parent).get()})(e,a);return t&&a(t.id).descendants()||[]},n=(e,a,t)=>{const n=t(a).ancestors(),o=new Set(e);return n.some((e=>{var a,n;return o.has(null==(n=null==(a=t(e).get())?void 0:a.data)?void 0:n.name)}))},o=[a.resolvedNameMapping.TopBannerEditor,a.resolvedNameMapping.Root,a.resolvedNameMapping.WebsiteFooterEditor],d=(e,a,n,o)=>{const{callbackConditionSibling:r,callbackConditionParent:i}=e,s=n(a).get();return s?r(s)?{parentIdToPaste:s.data.parent,indexToPaste:t(s.id,n).findIndex((e=>e===s.id))+1}:(null==i?void 0:i(s))?{parentIdToPaste:s.id,indexToPaste:o?t(o,n).findIndex((e=>e===o))+1:s.data.nodes.length||0}:s.data.parent?d(e,s.data.parent,n,a):null:null};exports.findPosition=d,exports.getPositionDropCol=(e,t,r)=>{if(!r(e).get())return null;const i=Object.values(t).some((e=>e.data.name===a.resolvedNameMapping.Row));return d({callbackConditionSibling:e=>e.data.name===a.resolvedNameMapping.Col&&(!i||n(o,e.id,r)),callbackConditionParent:e=>{const t=r(e.data.parent).get();return e.data.name===a.resolvedNameMapping.Row&&(!i||o.includes(t.data.name))}},e,r)},exports.getPositionDropElement=(e,n)=>{var o,d,r;const i=n(e).get();if(!i)return null;switch(i.data.name){case a.resolvedNameMapping.Row:return{parentIdToPaste:i.data.nodes[0],indexToPaste:(null==(r=null==(d=null==(o=n(i.data.nodes[0]).get())?void 0:o.data)?void 0:d.nodes)?void 0:r.length)||0};case a.resolvedNameMapping.Col:return{parentIdToPaste:i.id,indexToPaste:i.data.nodes.length||0};default:return{indexToPaste:t(i.id,n).findIndex((e=>e===i.id))+1,parentIdToPaste:i.data.parent}}},exports.getPositionDropGlobalBlock=(a,t)=>{const n=t(e.ROOT).get().data.nodes;let o=n.indexOf(a);if(-1===o)switch(a){case e.HEADER:o=n.includes(e.TOP_BANNER)?1:0;break;case e.TOP_BANNER:o=0;break;case e.FOOTER:o=n.length}return{parentIdToPaste:e.ROOT,indexToPaste:o}},exports.getPositionDropRow=(e,t,r)=>{if(!r(e).get())return null;const i=1===Object.values(t).filter((e=>e.data.name===a.resolvedNameMapping.Row)).length;return d({callbackConditionSibling:e=>{if(e.data.name!==a.resolvedNameMapping.Row)return!1;const t=r(e.data.parent).get();return!!t&&(o.includes(t.data.name)||i&&t.data.name===a.resolvedNameMapping.Col&&n(o,t.id,r))},callbackConditionParent:e=>o.includes(e.data.name)||i&&e.data.name===a.resolvedNameMapping.Col&&n(o,e.id,r)},e,r)};


/***/ }),

/***/ 726142:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097);const r={parser:e=>"number"==typeof e?`${e}%`:e,formatter:e=>isNaN(+(null==e?void 0:e.replace("%","")))?e:+e.replace("%","")};exports.combineSize=(r,t=e.UnitEnum.pixel)=>{if(r)return`${r}${t}`},exports.extractSize=(r,t=e.UnitEnum.pixel)=>{if(null==r?void 0:r.includes(e.UnitEnum.pixel)){const t=Number(r.replace(e.UnitEnum.pixel,""));return isNaN(t)?[void 0,e.UnitEnum.pixel]:[t,e.UnitEnum.pixel]}if(null==r?void 0:r.includes(e.UnitEnum.percent)){const t=Number(r.replace(e.UnitEnum.percent,""));return isNaN(t)?[void 0,e.UnitEnum.percent]:[t,e.UnitEnum.percent]}return[void 0,t]},exports.extractUrlFromCssUrl=e=>{const r=e.match(/^url\((.*)\)$/);return r?r[1]:""},exports.isNumeric=e=>"number"==typeof e||"string"==typeof e&&!isNaN(e)&&!isNaN(parseFloat(e)),exports.isPrefixUrl=e=>/^url\((.*)\)$/.test(e),exports.nomalizeText=e=>{let r=e.toLowerCase().trim();return r=r.replace(/\s+/g," "),r=r.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g,"a"),r=r.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g,"e"),r=r.replace(/ì|í|ị|ỉ|ĩ/g,"i"),r=r.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g,"o"),r=r.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g,"u"),r=r.replace(/ỳ|ý|ỵ|ỷ|ỹ/g,"y"),r=r.replace(/đ/g,"d"),r},exports.removeUnit=(r,t=e.UnitEnum.pixel)=>{var n,i;return null!=r?parseInt(null==(i=null==(n=`${r}`)?void 0:n.replace)?void 0:i.call(n,t,"")):r},exports.usePropOptionsUnitPercent=r;


/***/ }),

/***/ 945675:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(891987),n=__webpack_require__(332535),i=__webpack_require__(586753);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=s(t);const u=({src:t})=>{const[s,c]=r.useState(10),u=r.useRef(null);return r.useEffect((()=>{u.current=setInterval((()=>{c((e=>e-1))}),1e3);const e="expires="+(new Date).toUTCString();return document.cookie=`${n.LOCALIZATION_KEY}=;${e};path=/`,()=>clearInterval(u.current)}),[]),r.useEffect((()=>{0===s&&(clearInterval(u.current),window.location.href="/")}),[s]),e.jsxs(a,{children:[e.jsx(i.Image,{src:t}),e.jsxs(o,{children:["Trang không tồn tại. Bạn sẽ được đưa về trang chủ sau ",s,"s"]})]})};u.displayName="404";const a=c.default.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 70vh;
`,o=c.default.div`
  color: #848788;
  font-weight: 400;
`;exports.Page404=u;


/***/ }),

/***/ 989000:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(891987),t=Object.defineProperty,o=Object.defineProperties,n=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,l=Object.prototype.propertyIsEnumerable,a=(e,r,o)=>r in e?t(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,s=(e,r)=>{for(var t in r||(r={}))i.call(r,t)&&a(e,t,r[t]);if(c)for(var t of c(r))l.call(r,t)&&a(e,t,r[t]);return e};const p=r.createContext({activeKeys:[],toggleAccordionItem:()=>{},setActiveKeys:()=>{}});exports.AccordionContext=p,exports.AccordionProvider=t=>{var a=t,{children:u,enableMultiItemOpen:d,defaultOpenKeys:f}=a,v=((e,r)=>{var t={};for(var o in e)i.call(e,o)&&r.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&c)for(var o of c(e))r.indexOf(o)<0&&l.call(e,o)&&(t[o]=e[o]);return t})(a,["children","enableMultiItemOpen","defaultOpenKeys"]);const[O,y]=r.useState(f||[]);return e.jsx(p.Provider,{value:(b=s({},v),x={activeKeys:O,toggleAccordionItem:e=>{let r=[...O];const t=r.findIndex((r=>r===e));t>=0?r.splice(t,1):(d||(r=[e]),r.push(e)),y(r)},setActiveKeys:y},o(b,n(x))),children:u});var b,x};


/***/ }),

/***/ 174958:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),n=__webpack_require__(85097),r=__webpack_require__(891987),i=__webpack_require__(989000),l=__webpack_require__(275802),o=__webpack_require__(787045),c=__webpack_require__(493959);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=a(t),s=a(r),u=a(o),p=Object.defineProperty,y=Object.defineProperties,f=Object.getOwnPropertyDescriptors,m=Object.getOwnPropertySymbols,h=Object.prototype.hasOwnProperty,v=Object.prototype.propertyIsEnumerable,O=(e,t,n)=>t in e?p(e,t,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[t]=n,b=(e,t)=>{for(var n in t||(t={}))h.call(t,n)&&O(e,n,t[n]);if(m)for(var n of m(t))v.call(t,n)&&O(e,n,t[n]);return e};const j=s.default.forwardRef(((t,r)=>{var l=t,{children:o,titleLevel:a="h5",schema:d,enableMultiItemOpen:s,defaultOpenKeys:p,isEditingMode:O}=l,j=((e,t)=>{var n={};for(var r in e)h.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&m)for(var r of m(e))t.indexOf(r)<0&&v.call(e,r)&&(n[r]=e[r]);return n})(l,["children","titleLevel","schema","enableMultiItemOpen","defaultOpenKeys","isEditingMode"]);const x=d?u.default.sanitize(d):"",{device:S}=n.useStore(),{commonStyle:_,titleStyle:q,contentAlign:P,icon:M}=n.getPropsByDevice(j,S);return e.jsxs(g,(w=b({ref:r},j),A={titleStyle:q,commonStyle:_,contentAlign:P,style:b({},!o&&O&&{minHeight:24}),children:[x&&e.jsx("head",{children:e.jsx("script",{type:"application/ld+json",dangerouslySetInnerHTML:{__html:x}},c.v4())}),e.jsx(i.AccordionProvider,{titleLevel:a,icon:M,enableMultiItemOpen:s,defaultOpenKeys:p,children:o})]},y(w,f(A))));var w,A}));j.displayName="Accordion";const g=d.default.div((({commonStyle:e,itemStyle:t,titleStyle:r,duration:i})=>{const l="number"==typeof i?`transition: all ${i}s;`:"";return`\n    ${n.getStyle(e)}\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n\n    .accordion {\n      &__item {\n        ${n.getStyle(t)}\n      }\n      &__title {\n        h1, h2, h3, h4, h5, h6, p {\n          ${n.getStyle(r)}\n        }\n      }\n      &__header,\n      &__content  {\n        ${l}\n      }\n    }\n  `}),l.getAccordionItemChildrenCss);exports.Accordion=j;


/***/ }),

/***/ 331615:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(85097),o=__webpack_require__(891987);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=n(r),c=n(o),i=Object.defineProperty,l=Object.defineProperties,f=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,s=Object.prototype.hasOwnProperty,d=Object.prototype.propertyIsEnumerable,p=(e,r,t)=>r in e?i(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;const y=c.default.forwardRef(((r,t)=>{var o,n=((e,r)=>{var t={};for(var o in e)s.call(e,o)&&r.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&u)for(var o of u(e))r.indexOf(o)<0&&d.call(e,o)&&(t[o]=e[o]);return t})(r,["contentRef","schema"]);return e.jsx(b,(o=((e,r)=>{for(var t in r||(r={}))s.call(r,t)&&p(e,t,r[t]);if(u)for(var t of u(r))d.call(r,t)&&p(e,t,r[t]);return e})({ref:t},n),l(o,f({className:"accordion__content"}))))}));y.displayName="AccordionContent";const b=a.default.div((({commonStyle:e})=>`\n  ${t.getStyle(e)}\n`));exports.AccordionContent=y;


/***/ }),

/***/ 179244:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(212951),t=__webpack_require__(85097),i=__webpack_require__(891987),o=__webpack_require__(989000),r=__webpack_require__(275802),l=__webpack_require__(927322),c=__webpack_require__(484435),a=__webpack_require__(534479);function d(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=d(n),u=d(i),f=Object.defineProperty,m=Object.defineProperties,v=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,x=(e,n,t)=>n in e?f(e,n,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[n]=t,j=(e,n)=>{for(var t in n||(n={}))y.call(n,t)&&x(e,t,n[t]);if(p)for(var t of p(n))g.call(n,t)&&x(e,t,n[t]);return e},_=(e,n)=>{var t={};for(var i in e)y.call(e,i)&&n.indexOf(i)<0&&(t[i]=e[i]);if(null!=e&&p)for(var i of p(e))n.indexOf(i)<0&&g.call(e,i)&&(t[i]=e[i]);return t};const h=u.default.forwardRef(((n,a)=>{var d=n,{children:s,title:u,itemKey:f,icon:p,dataUniqId:y}=d,g=_(d,["children","title","itemKey","icon","dataUniqId"]);const{icon:x,activeKeys:h,toggleAccordionItem:O,titleLevel:q}=i.useContext(o.AccordionContext),w=null==h?void 0:h.includes(y),A={name:w?(null==p?void 0:p.activeName)||(null==x?void 0:x.activeName):(null==p?void 0:p.name)||(null==x?void 0:x.name),size:(null==p?void 0:p.size)||(null==x?void 0:x.size),color:(null==p?void 0:p.color)||(null==x?void 0:x.color),align:(null==p?void 0:p.align)||(null==x?void 0:x.align)},{align:I=t.Alignment.right}=A,$=_(A,["align"]);return e.jsxs(b,(C=j({ref:a},g),P={className:"accordion__item "+(w?"active":"collapsed"),children:[e.jsxs("div",{ref:a,onClick:()=>O(y),className:`accordion__header ${I}`,children:[e.jsx(c.Heading,{text:`<${q}>${r.convertTitleToText(u)}</${q}>`,className:"accordion__title"}),e.jsx(l.PbIcon,j({},$))]}),s]},m(C,v(P))));var C,P}));h.displayName="AccordionItem";const b=s.default.div((e=>{var n=e,{commonStyle:i,iconAlign:o,titleStyle:l}=n,c=_(n,["commonStyle","iconAlign","titleStyle"]);return`\n    &.accordion__item {\n      ${t.getStyle(i)}\n      ${r.getAccordionItemChildrenCss(c)}\n    }\n\n    .accordion {\n      &__header {\n        display: flex;\n        align-items: center;\n        cursor: pointer;\n\n        &.left {\n          flex-direction: row-reverse;\n          justify-content: flex-end;\n        }\n        &.right {\n          flex-direction: row;\n          justify-content: space-between;\n        }\n      }\n\n      &__title {\n        h1, h2, h3, h4, h5, p {\n          ${t.getStyle(l)}\n          ${a.getCommonTextCss()}\n        }\n      }\n\n      &__content {\n        display: flex;\n        flex-direction: column;\n      }\n    }\n\n    &.collapsed .accordion__content {\n      padding-top: 0 !important;\n      padding-bottom: 0 !important;\n      height: 0;\n      opacity: 0;\n      pointer-events: none;\n      overflow: hidden;\n    }\n\n    &.active .accordion__content {\n      opacity: 1;\n    }\n  `}));exports.AccordionItem=h;


/***/ }),

/***/ 275802:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097);exports.convertTitleToText=e=>(e||"").replace(/<([^>]+)>/gm,""),exports.getAccordionItemChildrenCss=({headerStyle:t,contentStyle:n,contentAlign:r})=>`\n  .accordion {\n    &__header {\n      ${e.getStyle(t)}\n    }\n\n    &__content {\n      ${e.getStyle(n)}\n      ${(()=>{if(!r)return"";let t="stretch";return r===e.Alignment.center&&(t="center"),r===e.Alignment.right&&(t="flex-end"),`align-items: ${t};`})()}\n    }\n  }\n`;


/***/ }),

/***/ 655368:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097),n=__webpack_require__(772139),i=__webpack_require__(161627);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=o(t),a=o(n),d=Object.defineProperty,p=Object.defineProperties,c=Object.getOwnPropertyDescriptors,s=Object.getOwnPropertySymbols,u=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,f=(e,t,r)=>t in e?d(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,y=(e,t)=>{for(var r in t||(t={}))u.call(t,r)&&f(e,r,t[r]);if(s)for(var r of s(t))g.call(t,r)&&f(e,r,t[r]);return e},h=(e,t)=>p(e,c(t));const m=t=>{var n,o;const l=t,{showPublishDate:d,showCategories:p,categoryType:c,categoryColor:f}=l,m=((e,t)=>{var r={};for(var n in e)u.call(e,n)&&t.indexOf(n)<0&&(r[n]=e[n]);if(null!=e&&s)for(var n of s(e))t.indexOf(n)<0&&g.call(e,n)&&(r[n]=e[n]);return r})(l,["showPublishDate","showCategories","categoryType","categoryColor"]),{globalData:O={},device:C}=r.useStore(),{page:D}=O||{},{articleInfo:P,categories:z=[]}=D||{},{authorName:$,publishedAt:k}=P||{},{titleStyle:q,publishDateStyle:B,categoryStyle:M}=r.getPropsByDevice(m,C),Y=(null==q?void 0:q.textLevel)||"h1",_=(null==(n=null==m?void 0:m.commonStyle)?void 0:n.fontSize)||(null==q?void 0:q.fontSize),A=null==(o=null==m?void 0:m.commonStyle)?void 0:o.backgroundColor;return e.jsx(v,{backgroundColor:A,children:e.jsxs(x,h(y({},m),{children:[e.jsx(b,{fontSize:_,titleStyle:q,dangerouslySetInnerHTML:{__html:`<${Y}>${null==D?void 0:D.name}</${Y}>`}}),e.jsxs(j,{children:[$&&e.jsx("span",{children:$}),d&&e.jsx(S,{publishDateStyle:B,children:k&&a.default.unix(k).format("DD/MM/YYYY")}),p&&(null==z?void 0:z.length)>0&&e.jsx(w,{children:z.map((t=>e.jsx(i.Category,{category:t,color:f,type:c,commonStyle:M},t.id)))})]})]}))})};m.displayName="ArticleHeader";const v=l.default.div((({backgroundColor:e})=>`\n  ${r.getStyle({backgroundColor:e})}`)),x=l.default.div((({commonStyle:e})=>`\n  margin: 0 auto;\n  padding-left: 15px;\n  padding-top: 40px;\n  padding-bottom: 40px;\n  padding-right: 15px;\n  ${r.getStyle(e)};\n`)),b=l.default.div((({fontSize:e,titleStyle:t})=>`\n    h1, h2, h3, h4, h5, h6, p {\n      margin: 0;\n      padding: 0;\n      font-size: inherit !important;\n      font-weight: inherit !important;\n      line-height: inherit !important;\n      color: inherit !important;\n      text-shadow: inherit !important;\n      font-family: inherit !important;\n      letter-spacing: inherit !important;\n    }\n    ${r.getStyle(h(y({},t),{fontSize:e}))}\n  `)),S=l.default.span((({publishDateStyle:e})=>`${r.getStyle(e)}`)),j=l.default.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 14px;
  color: '#4B4B4B';
  margin-top: 12px;

  & > span {
    &:after {
      content: '•';
      display: inline-block;
      vertical-align: middle;
      margin: 0 8px;
    }

    &:last-child:after {
      content: none;
    }

    vertical-align: middle;
  }
`,w=l.default.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin: 0.5em 0;
  font-weight: 500;
`;exports.ArticleHeader=m;


/***/ }),

/***/ 863988:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),i=__webpack_require__(240228),r=__webpack_require__(772139),o=__webpack_require__(85097),n=__webpack_require__(161627),l=__webpack_require__(875464);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=a(t),d=a(r),p=Object.defineProperty,u=Object.defineProperties,c=Object.getOwnPropertyDescriptors,g=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,h=Object.prototype.propertyIsEnumerable,w=(e,t,i)=>t in e?p(e,t,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[t]=i,m=(e,t)=>{for(var i in t||(t={}))y.call(t,i)&&w(e,i,t[i]);if(g)for(var i of g(t))h.call(t,i)&&w(e,i,t[i]);return e},f=(e,t)=>u(e,c(t));const b=s.default.a((({layout:e,totalShowRows:t,rowGap:i,isMobile:r,cardStyle:n,showImage:l})=>`\n     ${o.getStyle(n)}\n  ${"grid"===e?`\n        display: grid;\n        grid-template-rows: subgrid;\n        grid-row: span ${t}; \n        grid-row-gap: ${i}px;\n        `:`\n       ${!r&&l?"display: flex":""};\n        grid-column-gap: 16px;\n        grid-row: span 2;\n        `}`)),x=s.default.div((({gridRow:e,isListLayout:t,rowGap:i})=>t?`\n    display: grid; \n    grid-template-rows: repeat(${e}, min-content);\n    grid-row-gap: ${i}px;\n    flex: 1;\n    grid-template-columns: 1fr minmax(auto, 100%);\n    `:`\n    display: grid; \n    grid-template-columns: 1fr minmax(auto, 100%);\n    width: 100%;\n    grid-template-rows: subgrid;\n    grid-row: span ${e};\n    `)),S=s.default.div((({imageStyle:e})=>`\n  position: relative;\n  overflow: hidden;\n  border-radius: 8px;\n  ${o.getStyle(e)}\n`)),v=s.default.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`,j=s.default.div`
  display: flex;
  gap: 8px;
  flex-wrap: nowrap;
  overflow-x: auto;
  width: 100%;
  min-width: 0;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`,D=s.default.p((({titleStyle:e,line:t})=>`\n  span {\n    font-weight: bold;\n    ${T(t||2)}\n    ${o.getStyle(e)}\n  }\n`)),C=s.default.p((({descriptionStyle:e})=>`\n  ${T(3)}\n  ${o.getStyle(e)}\n`)),$=s.default.p((({authorStyle:e})=>`\n   ${T(1)}\n  ${o.getStyle(e)}\n  `)),R=s.default.p((({publishDateStyle:e})=>`\n  ${T(1)}\n  ${o.getStyle(e)}\n  `)),T=e=>`\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: ${e};\n  line-clamp: ${e};\n  -webkit-box-orient: vertical;\n  line-height: 1.5;\n`,I=s.default.div((({totalContentRow:e,publishDateStyle:t})=>`\n  border-radius: 4px;\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 58px;\n  flex-shrink: 0;\n  grid-row: 1 / span ${e};\n  align-self: start;\n  margin-right: 12px;\n  \n  font-weight: 700;\n  line-height: 1;\n  ${o.getStyle(t)}\n`)),k=s.default.div`
  font-size: 20px;
`,A=s.default.div`
  font-weight: 500;
  text-transform: capitalize;
  margin-top: 6px;
  font-size: 14px;
`;exports.ArticleCard=({article:t,layout:r="list",displayConfig:a={},isOpenNewTab:s=!0,categoryColor:p="#7367f0",categoryType:u="button",imageStyle:c={},titleStyle:w={},descriptionStyle:T={},authorStyle:O={},publishDateStyle:_={},categoryStyle:E={},rowGap:L=8,publishDateDisplayType:M=i.DisplayTypes.TEXT,cardStyle:U={}})=>{const{device:P,globalData:F}=o.useStore(),{generateCustomUrl:G}=F||{},q="mobile"===P,N="list"===r,Y=c,{width:z=(!q&&N?l.DEFAULT_IMAGE_WIDTH_FOR_DESKTOP_LIST:l.DEFAULT_IMAGE_WIDTH),widthUnit:H=o.UnitEnum.percent,objectFit:W="cover"}=Y,B=((e,t)=>{var i={};for(var r in e)y.call(e,r)&&t.indexOf(r)<0&&(i[r]=e[r]);if(null!=e&&g)for(var r of g(e))t.indexOf(r)<0&&h.call(e,r)&&(i[r]=e[r]);return i})(Y,["width","widthUnit","objectFit"]);if(!t)return null;const{name:K,description:X,extraInfo:J,articleInfo:Q,canonical:V,categories:Z=[],slug:ee}=t||{},{showAuthor:te=!0,showTitle:ie=!0,showDesc:re=!0,showImage:oe=!0,showPublishDate:ne=!0,showCategories:le=!0}=a,{date:ae,day:se,monthName:de}=(()=>{if(!(null==Q?void 0:Q.publishedAt))return null;const e=d.default.unix(Q.publishedAt);return{date:e.format("DD/MM/YYYY"),day:e.format("DD"),monthName:new Intl.DateTimeFormat("en-US",{month:"short"}).format(e.toDate())}})()||{},{totalContentRow:pe,gridRowMap:ue,col:ce}=(()=>{let e=0;const t={},o="list"===r;return[{key:"categories",show:o?!!(null==Z?void 0:Z.length)&&le:le},{key:"title",show:o?!!K&&ie:ie},{key:"description",show:o?re&&!!X:re},{key:"author",show:o?!!(null==Q?void 0:Q.authorName)&&te:te},{key:"date",show:ne&&M!==i.DisplayTypes.CARD}].forEach((i=>{i.show&&(t[i.key]=++e)})),{totalContentRow:e,gridRowMap:t,col:M!==i.DisplayTypes.CARD?"1/ span 2":2}})();return e.jsxs(b,{layout:"carousel"===r?"grid":r,href:G?G(ee):V,target:s?"_blank":"_self",rel:"noreferrer",totalShowRows:oe?pe+1:pe,rowGap:L,isMobile:q,showImage:oe,cardStyle:U,children:[oe&&e.jsx(S,{imageStyle:f(m(m({aspectRatio:"3/2"},B),N&&!q?{width:z,widthUnit:H}:{}),{margin:N?q?{bottom:16}:{right:16}:void 0}),children:e.jsx(v,{children:e.jsx("img",{src:o.constructGoogleImageParams((null==J?void 0:J.metaImage)||l.DEFAULT_ARTICLE_THUMBNAIL,{format:"webp",compressLevel:1}),width:N&&!q?"100%":`${z}${H}`,height:"100%",style:{objectFit:W,margin:"auto"},alt:K})})}),e.jsxs(x,{gridRow:pe,isListLayout:N,rowGap:L,children:[ne&&M===i.DisplayTypes.CARD&&e.jsxs(I,{publishDateStyle:f(m({},_),{backgroundColor:ae?_.backgroundColor:"transparent"}),totalContentRow:pe,children:[e.jsx(k,{children:se}),e.jsx(A,{children:de})]}),le&&e.jsx(j,{style:{gridRow:ue.categories,gridColumn:ce},children:Z.map((t=>e.jsx(n.Category,{category:t,color:p,type:u,commonStyle:E},t.id)))}),ie&&e.jsx(D,{style:{gridRow:ue.title,gridColumn:ce},titleStyle:w,line:w.lineClamp,children:e.jsx("span",{children:K})}),re&&X&&e.jsx(C,{style:{gridRow:ue.description,gridColumn:ce},descriptionStyle:T,children:X}),te&&(null==Q?void 0:Q.authorName)&&e.jsx($,{style:{gridRow:ue.author,gridColumn:ce},authorStyle:O,children:null==Q?void 0:Q.authorName}),ne&&M!==i.DisplayTypes.CARD&&e.jsx(R,{style:{gridRow:ue.date,gridColumn:ce},publishDateStyle:_,children:ae})]})]})},exports.getClampedTextStyle=T;


/***/ }),

/***/ 305140:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),l=__webpack_require__(212951);function C(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const i=()=>e.jsxs("svg",{xmlns:"http://www.w3.org/2000/svg",width:"106",height:"100",viewBox:"0 0 106 100",fill:"none",style:{paddingLeft:"1em"},children:[e.jsx("path",{d:"M44.6033 99.4921C69.237 99.4921 89.2066 95.7607 89.2066 91.1579C89.2066 86.555 69.237 82.8237 44.6033 82.8237C19.9696 82.8237 0 86.555 0 91.1579C0 95.7607 19.9696 99.4921 44.6033 99.4921Z",fill:"#F5F5F7",fillOpacity:"0.8"}),e.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M80.2856 66.6737L64.5455 47.3019C63.7902 46.3901 62.6863 45.8381 61.5238 45.8381H27.6817C26.5198 45.8381 25.4159 46.3901 24.6606 47.3019L8.92114 66.6737V76.7941H80.2863V66.6737H80.2856Z",fill:"#AEB8C2"}),e.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M22.2566 20.8355H66.9493C67.6473 20.8355 68.3166 21.1128 68.8102 21.6063C69.3037 22.0998 69.5809 22.7692 69.5809 23.4671V84.8776C69.5809 85.5755 69.3037 86.2449 68.8102 86.7384C68.3166 87.2319 67.6473 87.5092 66.9493 87.5092H22.2566C21.5586 87.5092 20.8893 87.2319 20.3958 86.7384C19.9023 86.2449 19.625 85.5755 19.625 84.8776V23.4671C19.625 22.7692 19.9023 22.0998 20.3958 21.6063C20.8893 21.1128 21.5586 20.8355 22.2566 20.8355V20.8355Z",fill:"#F5F5F7"}),e.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M28.0777 27.3835H61.1283C61.4773 27.3835 61.812 27.5222 62.0587 27.7689C62.3055 28.0157 62.4441 28.3504 62.4441 28.6993V45.1184C62.4441 45.4674 62.3055 45.8021 62.0587 46.0488C61.812 46.2956 61.4773 46.4342 61.1283 46.4342H28.0777C27.7287 46.4342 27.394 46.2956 27.1472 46.0488C26.9005 45.8021 26.7619 45.4674 26.7619 45.1184V28.6993C26.7619 28.3504 26.9005 28.0157 27.1472 27.7689C27.394 27.5222 27.7287 27.3835 28.0777 27.3835ZM28.25 53.577H60.9559C61.3506 53.577 61.7291 53.7338 62.0082 54.0128C62.2873 54.2919 62.4441 54.6704 62.4441 55.0651C62.4441 55.4598 62.2873 55.8383 62.0082 56.1174C61.7291 56.3965 61.3506 56.5533 60.9559 56.5533H28.25C27.8553 56.5533 27.4768 56.3965 27.1977 56.1174C26.9186 55.8383 26.7619 55.4598 26.7619 55.0651C26.7619 54.6704 26.9186 54.2919 27.1977 54.0128C27.4768 53.7338 27.8553 53.577 28.25 53.577ZM28.25 61.3158H60.9559C61.3507 61.3158 61.7293 61.4726 62.0085 61.7518C62.2876 62.0309 62.4444 62.4095 62.4444 62.8043C62.4444 63.199 62.2876 63.5776 62.0085 63.8568C61.7293 64.1359 61.3507 64.2928 60.9559 64.2928H28.25C27.8552 64.2928 27.4766 64.1359 27.1975 63.8568C26.9184 63.5776 26.7615 63.199 26.7615 62.8043C26.7615 62.4095 26.9184 62.0309 27.1975 61.7518C27.4766 61.4726 27.8552 61.3158 28.25 61.3158ZM80.1402 89.9355C79.6303 91.9559 77.8395 93.4618 75.7092 93.4618H13.4967C11.3665 93.4618 9.57567 91.9553 9.06646 89.9355C8.96934 89.5505 8.92029 89.1549 8.92041 88.7579V66.6743H26.2349C28.1474 66.6743 29.6888 68.2849 29.6888 70.2401V70.2664C29.6888 72.221 31.248 73.7993 33.1605 73.7993H56.0454C57.9579 73.7993 59.5171 72.2066 59.5171 70.2513V70.2434C59.5171 68.2881 61.0586 66.6737 62.9711 66.6737H80.2855V88.7585C80.2855 89.1645 80.2349 89.5585 80.1402 89.9355Z",fill:"#DCE0E6"}),e.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M82.3164 21.9026L77.823 23.6461C77.7075 23.6909 77.5818 23.7023 77.4602 23.6789C77.3385 23.6555 77.226 23.5982 77.1355 23.5137C77.045 23.4292 76.9802 23.3208 76.9485 23.2011C76.9168 23.0813 76.9196 22.9551 76.9565 22.8368L78.2309 18.7533C76.5276 16.8164 75.5276 14.4546 75.5276 11.9059C75.5276 5.33026 82.1842 0 90.396 0C98.6059 0 105.263 5.33026 105.263 11.9059C105.263 18.4816 98.6065 23.8118 90.3954 23.8118C87.4164 23.8118 84.6427 23.1105 82.3164 21.9026Z",fill:"#DCE0E6"}),e.jsx("path",{d:"M96.2528 14.0559C97.2879 14.0559 98.1271 13.2268 98.1271 12.204C98.1271 11.1811 97.2879 10.352 96.2528 10.352C95.2176 10.352 94.3784 11.1811 94.3784 12.204C94.3784 13.2268 95.2176 14.0559 96.2528 14.0559Z",fill:"white"}),e.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M86.4132 13.8243H82.6646L84.5711 10.5836L86.4132 13.8243ZM88.756 10.5836H92.0356V13.8243H88.756V10.5836Z",fill:"white"})]}),t=C(l).default.div`
  height: 400px;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 14px;
`;exports.ArticleEmpty=({description:l})=>e.jsx(t,{children:e.jsxs("div",{children:[e.jsx("div",{children:e.jsx(i,{})}),e.jsx("div",{style:{marginTop:"1em"},children:l||"No articles yet"})]})});


/***/ }),

/***/ 43673:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(115741);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=i(r),n=Object.defineProperty,o=Object.defineProperties,a=Object.getOwnPropertyDescriptors,s=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,p=(e,r,t)=>r in e?n(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,c=(e,r)=>{for(var t in r||(r={}))d.call(r,t)&&p(e,t,r[t]);if(s)for(var t of s(r))u.call(r,t)&&p(e,t,r[t]);return e},g=(e,r)=>o(e,a(r));const f=l.default.div((({column:e=4,gutter:r=16})=>`\ndisplay: grid;\ngrid-template-columns: repeat(${e}, minmax(0,1fr));\ngrid-gap: ${r}px;\n`)),y=l.default.div((({gutter:e=16})=>`\ndisplay: grid;\ngrid-template-columns: 1fr;\ngrid-gap: ${e}px;\n`)),m=l.default(t.DSSlider)`
  .swiper-wrapper {
    display: grid;
    grid-auto-flow: column;
  }

  .swiper-slide {
    display: grid;
    grid-template-rows: subgrid;
    grid-row: span 6;
  }
`;exports.ArticleLayout=({layout:r,children:t,gridConfig:i,listConfig:l,carouselOptions:n,isEditingMode:o})=>{if("list"===r)return e.jsx(y,g(c({},l),{children:t}));if("carousel"===r){const{speed:r,column:i,gutter:l}=n||{};return e.jsx(m,{navigation:!0,navigationStyle:1,speed:1e3*r,slidesPerView:i,spaceBetween:l,autoplay:0!==r&&null!=r,allowTouchMove:!o,children:t})}return e.jsx(f,g(c({},i),{children:t}))};


/***/ }),

/***/ 570867:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(212951),r=__webpack_require__(143599),t=__webpack_require__(986383),a=__webpack_require__(628912);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=n(o),i=n(t),s=Object.defineProperty,u=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,c=Object.prototype.propertyIsEnumerable,p=(e,o,r)=>o in e?s(e,o,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[o]=r,g=(e,o)=>{for(var r in o||(o={}))d.call(o,r)&&p(e,r,o[r]);if(u)for(var r of u(o))c.call(o,r)&&p(e,r,o[r]);return e};const f=l.default.div`
  /* Reset default list styles */
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  /* Pagination styles */
  ul[role='navigation'] {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1em 0;
  }

  ul[role='navigation'] li {
    margin: 0 5px;
  }

  ul[role='navigation'] a {
    display: block;
    padding: 0.25em 0.75em;
    text-decoration: none;
    color: ${e=>e.$textColor};

    border-radius: 4px;
    cursor: pointer;
  }

  ul[role='navigation'] .selected a {
    color: ${e=>e.$paginationColor};
    background-color: transparent;
    border: 1px solid ${e=>e.$paginationColor};
  }

  ul[role='navigation'] .disabled a {
    pointer-events: none;
    color: #d9d9d9;
  }

  /* Arrow styles */
  ul[role='navigation'] a[aria-label='Previous page'],
  ul[role='navigation'] a[aria-label='Next page'] {
    font-weight: bold;
  }

  /* Hover effect */
  ul[role='navigation'] a:hover:not(.disabled) {
    background-color: #ddd;
  }
`;exports.ArticlePagination=o=>{const t=o,{paginationColor:n="#7367f0",textColor:l="#000000"}=t,s=((e,o)=>{var r={};for(var t in e)d.call(e,t)&&o.indexOf(t)<0&&(r[t]=e[t]);if(null!=e&&u)for(var t of u(e))o.indexOf(t)<0&&c.call(e,t)&&(r[t]=e[t]);return r})(t,["paginationColor","textColor"]),p=o=>e.jsx(r.Icon,g({},g({name:o},a.getPropsIcon({color:n}))));return e.jsx(f,{$paginationColor:n,$textColor:l,children:e.jsx(i.default,g({breakLabel:"...",nextLabel:p("RightOutlined"),pageRangeDisplayed:1,previousLabel:p("LeftOutlined"),renderOnZeroPageCount:null},s))})};


/***/ }),

/***/ 717058:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),n=__webpack_require__(85097),r=__webpack_require__(772139),l=__webpack_require__(863988),o=__webpack_require__(305140),i=__webpack_require__(161627);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=a(t),s=a(r),p=Object.defineProperty,c=Object.defineProperties,h=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,b=Object.prototype.propertyIsEnumerable,g=(e,t,n)=>t in e?p(e,t,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[t]=n,x=(e,t)=>{for(var n in t||(t={}))y.call(t,n)&&g(e,n,t[n]);if(u)for(var n of u(t))b.call(t,n)&&g(e,n,t[n]);return e};const f=d.default.div`
  width: 100%;
  overflow-x: auto;
`,m=d.default.table((({tableStyle:e,tableBorderColor:t,enableMobileCardView:r})=>`\n  min-width: 100%;\n  border-collapse: collapse;\n  background: white;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  table-layout: fixed;\n  ${n.getStyle(e)}\n\n  thead, tbody, tfoot, tr, td, th {\n    border-style: solid;\n    border-width: 0px;\n  }\n\n  tr {\n    border: 1px solid ${t||"transparent"};\n  }\n\n  /* Mobile Responsive Styles - Chỉ áp dụng khi enableMobileCardView = true */\n  ${r?`\n    @media (max-width: 768px) {\n      min-width: 100%;\n      display: block;\n      \n      /* Ẩn header trên mobile */\n      thead {\n        display: none;\n      }\n\n      tbody {\n        display: block;\n      }\n\n      /* Mỗi row trở thành một card */\n      tr {\n        display: block;\n        margin-bottom: 16px;\n        border: 1px solid ${t||"transparent"};\n        border-radius: 8px;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n        padding: 0;\n        overflow: hidden;\n      }\n\n      /* Mỗi cell hiển thị như một row */\n      td {\n        display: block;\n        text-align: right;\n        padding: 12px 16px !important;\n        border-bottom: 1px solid #f3f4f6 !important;\n        position: relative;\n        min-height: auto;\n        >p, >div {\n          min-height: 25px;\n          padding-left: 24px;\n        }\n        &.cell-categories > div {\n          justify-content: flex-end;\n        }\n      }\n\n      /* Cell cuối cùng không có border */\n      td:last-child {\n        border-bottom: none !important;\n      }\n\n      /* Thêm label cho mỗi cell */\n      td:before {\n        content: attr(data-label);\n        float: left;\n        font-weight: 600;\n        margin-bottom: 4px;\n        text-transform: uppercase;\n      }\n\n      /* Cell title có style đặc biệt */\n      td.cell-name {\n        text-align: left;\n        padding-top: 16px !important;\n        padding-bottom: 16px !important;\n        >div {\n          padding-left: 0 !important;   \n        }\n        &:before {\n         content: unset;\n        }\n      }\n    }\n  `:""}\n`)),w=d.default.thead((({headerStyle:e})=>`\n   background-color: #2c4a66;\n  color: white;\n  ${n.getStyle(e)}\n`)),v=d.default.th((({width:e})=>`\n  padding: 12px;\n  text-align: left;\n  min-width: ${e?`${e}px`:"150px"};\n`)),S=d.default.tbody((({evenRowBackgroundColor:e,oddRowBackgroundColor:t})=>`\n  tr:hover {\n    background: #dee2e6;\n    transition: background 0.2s ease;\n  }\n\n  tr:nth-child(odd) {\n    background-color: ${t||"transparent"};\n  }\n\n  tr:nth-child(even) {\n    background-color:${e||"transparent"};\n  }\n`)),j=d.default.td`
  padding: 12px;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #d1d5db;
  vertical-align: top;
`,k=d.default.div((({titleStyle:e})=>`\n  ${l.getClampedTextStyle(e.lineClamp||4)}\n  ${n.getStyle(e)}\n`)),C=d.default.p((({descriptionStyle:e})=>`\n  ${l.getClampedTextStyle(4)}\n  ${n.getStyle(e)}\n`)),$=d.default.p((({authorStyle:e})=>`\n  ${l.getClampedTextStyle(3)}\n  ${n.getStyle(e)}\n  `)),M=d.default.p((({publishDateStyle:e})=>`\n  ${l.getClampedTextStyle(1)}\n  ${n.getStyle(e)}\n  `)),D=d.default.div`
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 14px;
`;exports.ArticleTable=({dataSource:t=[],titleStyle:r,authorStyle:l,categoryColor:a,categoryType:d,categoryStyle:p,publishDateStyle:u,descriptionStyle:y,isEditingMode:b,articleTableStyle:g,articleHeaderStyle:O,evenRowBackgroundColor:T,oddRowBackgroundColor:A,isOpenNewTab:B,isEmpty:I,isLoading:_,noArticleDescription:q,loadingDescription:P,mappingColTitle:R,tableBorderColor:E,displayConfig:V,tableHeaderStyle:N,enableMobileCardView:Y=!0})=>{const{globalData:z}=n.useStore(),{generateCustomUrl:H}=z||{},{showAuthor:L=!0,showTitle:U=!0,showDesc:W=!0,showPublishDate:F=!0,showCategories:G=!0}=V,J=new Map([["name",{key:"name",tooltip:e=>e.name,parse:t=>b?e.jsx(k,{titleStyle:r,children:t.name}):e.jsx("a",{href:H?H(t.slug):t.canonical,target:B?"_blank":"_self",rel:"noreferrer",children:e.jsx(k,{titleStyle:r,children:t.name})}),show:U}],["description",{key:"description",tooltip:e=>e.description,parse:t=>e.jsx(C,{title:t.description,descriptionStyle:y,children:t.description}),show:W}],["articleInfo_author",{key:"articleInfo_author",parse:t=>{var n;return e.jsx($,{authorStyle:l,children:(null==(n=null==t?void 0:t.articleInfo)?void 0:n.authorName)||""})},show:L}],["categories",{key:"categories",parse:t=>{var n;return e.jsx("div",{style:{display:"flex",gap:8,flexWrap:"wrap"},children:null==(n=t.categories)?void 0:n.map((t=>e.jsx(i.Category,{category:t,color:a,type:d,commonStyle:p},t.id)))})},show:G}],["articleInfo_publishedAt",{key:"articleInfo_publishedAt",parse:t=>{var n,r;return e.jsx(M,{publishDateStyle:u,children:(null==(n=null==t?void 0:t.articleInfo)?void 0:n.publishedAt)?s.default.unix(null==(r=null==t?void 0:t.articleInfo)?void 0:r.publishedAt).format("DD/MM/YYYY"):""})},show:F}]]),K=R.reduce(((e,t)=>{var n;const r=J.get(t.key);var l,o;return r.show&&e.push((l=x(x({},t),r),o={width:null==(n=null==N?void 0:N[t.key])?void 0:n.width},c(l,h(o)))),e}),[]);return e.jsx(f,{enableMobileCardView:Y,children:e.jsxs(m,{tableBorderColor:E,tableStyle:g,enableMobileCardView:Y,children:[e.jsx(w,{headerStyle:O,children:e.jsx("tr",{children:K.map((t=>e.jsx(v,{className:`header-${t.key}`,width:null==t?void 0:t.width,children:t.title},t.key)))})}),e.jsxs(S,{oddRowBackgroundColor:A,evenRowBackgroundColor:T,children:[I?e.jsx("tr",{children:e.jsx("td",{colSpan:K.length,children:e.jsx(o.ArticleEmpty,{description:q})})}):t.map(((t,n)=>e.jsx("tr",{children:K.map((n=>e.jsx(j,{title:"function"==typeof n.tooltip?n.tooltip(t):void 0,"data-label":n.title,className:`cell-${n.key}`,children:"function"==typeof n.parse?n.parse(t):t[n.key]},`${t.id}-${n.key}`)))},t.id||n))),_&&e.jsx("tr",{children:e.jsx("td",{colSpan:K.length,children:e.jsx(D,{style:{height:(null==t?void 0:t.length)?50:400},children:P||"Loading article ..."})})})]})]})})};


/***/ }),

/***/ 161627:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),o=__webpack_require__(85097);function r(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var n=r(t);const l=n.default.span`
  background-color: ${({color:e})=>o.generate(e)[100]};
  padding: 2px 8px;
  border-radius: 1em;
  white-space: nowrap;
  cursor: default;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
  max-width: 150px;
  ${({commonStyle:e})=>o.getStyle(e)}
  color: ${({color:e})=>e} !important;
`,a=n.default.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
  max-width: 150px;

  &:after {
    content: '•';
    margin-left: 0.5em;
  }

  &:last-child:after {
    content: none;
  }
  ${({commonStyle:e})=>o.getStyle(e)}
  color: ${({color:e})=>e} !important;
`;exports.Category=({category:t,type:o,color:r,commonStyle:n})=>{if(!t)return null;const i="button"===o?l:a;return e.jsx(i,{title:null==t?void 0:t.name,color:r,commonStyle:n,children:t.name})};


/***/ }),

/***/ 333112:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),l=__webpack_require__(891987),i=__webpack_require__(85097),r=__webpack_require__(800656),n=__webpack_require__(844101),o=__webpack_require__(240228),a=__webpack_require__(156788);function d(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var u=d(t),s=Object.defineProperty,c=Object.defineProperties,p=Object.getOwnPropertyDescriptors,h=Object.getOwnPropertySymbols,f=Object.prototype.hasOwnProperty,v=Object.prototype.propertyIsEnumerable,y=(e,t,l)=>t in e?s(e,t,{enumerable:!0,configurable:!0,writable:!0,value:l}):e[t]=l,b=(e,t)=>{for(var l in t||(t={}))f.call(t,l)&&y(e,l,t[l]);if(h)for(var l of h(t))v.call(t,l)&&y(e,l,t[l]);return e};const g="__ALL__",w=u.default.div`
  width: ${e=>e.width?e.width:"130px"};
`,m=u.default.select((e=>`\n    position: relative;\n    display: inline-block;\n    color: rgba(0, 0, 0, 0.85);\n    height: 100%;\n    padding: 0 0.5rem;\n    &:focus,\n    &-focused {\n      outline: 0;\n    }\n    &::-moz-placeholder {\n      opacity: 1;\n    }\n\n    &::placeholder {\n      color: #999;\n    }\n\n    &:placeholder-shown {\n      text-overflow: ellipsis;\n    }\n    border-style: solid;\n    border-color: rgb(238, 238, 238);\n    border-width: 1px;\n    width: 100%;\n    min-width: 100%;\n    height: 32px;\n    border-radius: 99px;\n    ${i.getStyle(e.selectStyle)}\n  `)),x=u.default.div`
  display: flex;
  gap: ${e=>e.gap||0}px;
  flex-wrap: wrap;
  width: ${e=>e.width?e.width:"auto"};
  align-items: flex-start;
`,j=u.default.button`
  padding: 2px 12px;
  border-radius: 1em;
  white-space: nowrap;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  ${e=>`${i.getStyle(null==e?void 0:e.commonStyle)}${e.isActive?`\n        background-color: #7367F0; \n        color: #fff;\n        ${i.getStyle(null==e?void 0:e.activeStyle)}\n        `:""}`};
`;exports.CategoryFilter=({action:t,categories:i,categoryIds:d,filterValue:u,setFilterValue:s,isMobile:y})=>{var S;const[O,C]=l.useState(!1),F={label:t.placeholder||r.t("all_categories"),value:g},W=i.reduce(((e,t)=>{const l={label:t.name,value:t.id.toString()};return e.push(l),e}),[]),q=(null==t?void 0:t.type)||o.FilterCatType.LIST,$=[F,...W],P=(null==t?void 0:t.style)||{},{width:T,widthUnit:_,gap:D}=P,M=((e,t)=>{var l={};for(var i in e)f.call(e,i)&&t.indexOf(i)<0&&(l[i]=e[i]);if(null!=e&&h)for(var i of h(e))t.indexOf(i)<0&&v.call(e,i)&&(l[i]=e[i]);return l})(P,["width","widthUnit","gap"]),A=l.useMemo((()=>{var e;return O||!(null==u?void 0:u.filterCat)?g:(null==(e=u.filterCat[0])?void 0:e.toString())||g}),[null==u?void 0:u.filterCat,O]),I=e=>{var t,l;C(e===g),s((t=b({},u),l={filterCat:e===g?d:e.startsWith("[")&&e.endsWith("]")?JSON.parse(e):[parseInt(e)]},c(t,p(l))))};return y||q===o.FilterCatType.DROPDOWN?e.jsx(w,{width:a.getDefaultWidth({width:T,widthUnit:_,isMobile:y,defaultWidth:150}),children:e.jsx(m,{selectStyle:M,value:A,onChange:e=>{const t=e.target.value;I(t)},children:$.map((t=>e.jsx("option",{value:t.value,children:t.label},t.value)))})}):q===o.FilterCatType.LIST?e.jsx(n.FlatFilter,{options:$,filterLabelStyle:b({width:a.getDefaultWidth({width:T,widthUnit:_,isMobile:y,defaultWidth:150}),marginBottom:D||0,justifyContent:(null==(S=null==t?void 0:t.style)?void 0:S.textAlign)||"center"},M),activeStyle:null==t?void 0:t.activeStyle,value:A,onChange:I}):q===o.FilterCatType.TAG?e.jsx(x,{width:a.getDefaultWidth({width:T,widthUnit:_,isMobile:y,defaultWidth:150}),gap:D||0,children:$.map((l=>e.jsx(j,{isActive:A===l.value,onClick:()=>I(l.value),activeStyle:null==t?void 0:t.activeStyle,commonStyle:M,className:"tooltip tooltip-bottom",title:l.label,children:l.label},l.value)))}):null};


/***/ }),

/***/ 568904:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(959211),n=__webpack_require__(85097),i=__webpack_require__(891987),l=__webpack_require__(800656),o=__webpack_require__(156788);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=a(t),u=Object.defineProperty,d=Object.defineProperties,s=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,f=Object.prototype.hasOwnProperty,h=Object.prototype.propertyIsEnumerable,y=(e,t,r)=>t in e?u(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,g=(e,t)=>{for(var r in t||(t={}))f.call(t,r)&&y(e,r,t[r]);if(p)for(var r of p(t))h.call(t,r)&&y(e,r,t[r]);return e},b=(e,t)=>d(e,s(t));const w=c.default.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid rgb(238, 238, 238);
  height: 38px;
  border-radius: 99px;
  width: ${e=>e.width?e.width:"300px"};
  background-color: #fff;
`,x=c.default.input((e=>`\n    position: relative;\n    display: inline-block;\n    color: rgba(0, 0, 0, 0.85);\n    height: 100%;\n    padding: 0;\n    &:focus,\n    &-focused {\n      outline: 0;\n    }\n    &::-moz-placeholder {\n      opacity: 1;\n    }\n\n    &::placeholder {\n      color: #999;\n    }\n\n    &:placeholder-shown {\n      text-overflow: ellipsis;\n    }\n    border-radius: 99px;\n    border: none;\n    width: 100%;\n    height: 100%;\n\t\ttext-align: center;\n    cursor: pointer;\n\n    &::-webkit-calendar-picker-indicator {\n      display: none;\n    }\n\n    ${n.getStyle(null==e?void 0:e.inputStyle)}\n`));exports.DatePicker=({isEditingMode:t,filterValue:n,setFilterValue:a,action:c,isMobile:u})=>{const d=i.useRef(null),s=i.useRef(null),y=e=>{if(e.current&&!t){e.current.type="date",e.current.click(),e.current.focus();try{e.current.showPicker()}catch(e){}}},j=(null==c?void 0:c.style)||{},{width:v,widthUnit:D}=j,O=((e,t)=>{var r={};for(var n in e)f.call(e,n)&&t.indexOf(n)<0&&(r[n]=e[n]);if(null!=e&&p)for(var n of p(e))t.indexOf(n)<0&&h.call(e,n)&&(r[n]=e[n]);return r})(j,["width","widthUnit"]);return e.jsxs(w,{width:o.getDefaultWidth({width:v,widthUnit:D,isMobile:u,defaultWidth:300}),children:[e.jsx(x,{readOnly:t,type:"text",ref:d,placeholder:c.startDatePlaceholder||l.t("from_date"),inputStyle:O,onChange:e=>{a(b(g({},n),{filterDate:b(g({},n.filterDate),{startDate:Math.ceil(new Date(new Date(e.target.value).setHours(0,0,0,0)).getTime()/1e3)})}))},onFocus:()=>{if(d.current&&!t){d.current.type="date";try{d.current.showPicker()}catch(e){d.current.click()}}},onBlur:()=>{d.current&&!t&&(d.current.type="text")}}),e.jsx("div",{children:e.jsx(r.CalendarLtrRegular,{fontSize:18,color:"rgba(0, 0, 0, 0.5)",style:{marginRight:16},onClick:()=>y(d)})}),e.jsx("div",{children:e.jsx(r.ArrowRightRegular,{color:"#d9d9d9"})}),e.jsx(x,{readOnly:t,type:"text",ref:s,placeholder:c.endDatePlaceholder||l.t("to_date"),inputStyle:O,onChange:e=>{a(b(g({},n),{filterDate:b(g({},n.filterDate),{endDate:Math.ceil(new Date(new Date(e.target.value).setHours(23,59,59,999)).getTime()/1e3)})}))},onFocus:()=>{if(s.current&&!t){s.current.type="date";try{s.current.showPicker()}catch(e){s.current.click()}}},onBlur:()=>{s.current&&!t&&(s.current.type="text")}}),e.jsx("div",{children:e.jsx(r.CalendarLtrRegular,{fontSize:18,color:"rgba(0, 0, 0, 0.5)",style:{marginRight:16},onClick:()=>y(s)})})]})};


/***/ }),

/***/ 370160:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(800656),o=__webpack_require__(750911);exports.LoadMoreButton=({loading:r,isEmpty:d,hasMore:i,loadMore:n,loadMoreText:u=t.t("Xem thêm")})=>r||d||!i?null:e.jsx(o.ButtonV2,{text:u,onClick:n,buttonStyle:{background:"white",hover:{color:"#777777"},border:{borderStyle:"solid",borderWidth:1,borderColor:"#d9d9d9",borderRadius:4},padding:{bottom:8,top:8,left:16,right:16},margin:{top:16,bottom:16}},commonStyle:{justifyContent:"center"}});


/***/ }),

/***/ 403654:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(85097),t=__webpack_require__(891987),i=__webpack_require__(800656),o=__webpack_require__(156788),n=__webpack_require__(802636),a=Object.defineProperty,l=Object.defineProperties,s=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,p=(e,r,t)=>r in e?a(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,h=(e,r)=>{for(var t in r||(r={}))c.call(r,t)&&p(e,t,r[t]);if(d)for(var t of d(r))u.call(r,t)&&p(e,t,r[t]);return e};exports.SearchBar=({isEditingMode:a,setFilterValue:p,fitterValue:f,action:g,isMobile:w})=>{const y=t.useMemo((()=>r.debounce((e=>{var r;p((r=h({},f),l(r,s({searchQuery:e}))))}),500)),[f]),b=(null==g?void 0:g.style)||{},{width:v,widthUnit:m}=b,x=((e,r)=>{var t={};for(var i in e)c.call(e,i)&&r.indexOf(i)<0&&(t[i]=e[i]);if(null!=e&&d)for(var i of d(e))r.indexOf(i)<0&&u.call(e,i)&&(t[i]=e[i]);return t})(b,["width","widthUnit"]);return e.jsx(n.InputText,{style:{paddingRight:30,paddingLeft:20},type:"text",inputStyle:h({width:"100%",borderRadius:"99px",backgroundImage:'url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="%23000000d9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65" style="stroke-width: 2;"></line></svg>\')',backgroundRepeat:"no-repeat",backgroundPosition:"right 10px center"},x),commonStyle:{height:38,width:o.getDefaultWidth({width:v,widthUnit:m,isMobile:w,defaultWidth:300})},readOnly:a,placeholder:g.placeholder||i.t("Tìm kiếm"),onChange:e=>y(e.target.value)})};


/***/ }),

/***/ 875464:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(800656),e=__webpack_require__(240228),a=Object.defineProperty,r=Object.defineProperties,i=Object.getOwnPropertyDescriptors,l=Object.getOwnPropertySymbols,o=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,g=(t,e,r)=>e in t?a(t,e,{enumerable:!0,configurable:!0,writable:!0,value:r}):t[e]=r,n=(t,e)=>{for(var a in e||(e={}))o.call(e,a)&&g(t,a,e[a]);if(l)for(var a of l(e))p.call(e,a)&&g(t,a,e[a]);return t},h=(t,e)=>r(t,i(e));const s={layout:"grid",categoryIds:[],gridConfig:{row:2,column:4,gutter:16,rowGap:8},listConfig:{row:10,gutter:16},carouselOptions:{speed:3,column:4,gutter:16},showLoadMore:!0,imageStyle:{borderRadius:8,aspectRatio:"3/2"},commonStyle:{color:"#000000",backgroundColor:"#ffffff"},displayConfig:{showAuthor:!0,showDesc:!0,showImage:!0,showPublishDate:!0,showCategories:!0,showTitle:!0},loadMoreType:e.LoadMoreType.BUTTON,paginationColor:"#7367f0",isOpenNewTab:!0,categoryColor:"#7367f0",categoryType:"button",actions:{filterCat:{enable:!0,placeholder:t.t("all_categories"),activeStyle:{color:"#ffffff",backgroundColor:"#7367f0",borderColor:"#d9d9d9"},style:{color:"#000",width:150,borderColor:"#d9d9d9"}},searchName:{enable:!0,placeholder:t.t("Tìm kiếm"),style:{}},filterDate:{enable:!0,startDatePlaceholder:t.t("from_date"),endDatePlaceholder:t.t("to_date"),style:{}}},titleStyle:{color:"#000",fontSize:14,lineClamp:2},authorStyle:{color:"#000",fontSize:14},descriptionStyle:{color:"#000",fontSize:14},publishDateStyle:{color:"#000",fontSize:14},categoryStyle:{color:"#7367f0"},isMatchAllCategories:!1,noArticleDescription:t.t("Chưa có bài viết nào"),loadingDescription:t.t("Đang tải bài viết"),publishDateDisplayType:e.DisplayTypes.TEXT,publishDateCardStyle:{backgroundColor:"#1D51AF",color:"#ffffff",fontFamily:"Roboto"},enableMobileTableCardView:!0},f=h(n({},s),{publishDateCardStyle:{backgroundColor:"#1D51AF",color:"#ffffff",fontFamily:"var(--tempi-global-paragraph1fontfamily)"},actions:{filterCat:h(n({},s.actions.filterCat),{style:h(n({},s.actions.filterCat.style),{currentParagraphTheme:"paragraph2",fontFamily:"var(--tempi-global-paragraph2fontfamily)"})}),searchName:h(n({},s.actions.searchName),{style:{currentParagraphTheme:"paragraph2",fontFamily:"var(--tempi-global-paragraph2fontfamily)"}}),filterDate:h(n({},s.actions.filterDate),{style:{currentParagraphTheme:"paragraph2",fontFamily:"var(--tempi-global-paragraph2fontfamily)"}})},titleStyle:h(n({},s.titleStyle),{currentParagraphTheme:"paragraph1",fontFamily:"var(--tempi-global-paragraph1fontfamily)"}),authorStyle:h(n({},s.authorStyle),{currentParagraphTheme:"paragraph2",fontFamily:"var(--tempi-global-paragraph2fontfamily)"}),descriptionStyle:h(n({},s.descriptionStyle),{currentParagraphTheme:"paragraph2",fontFamily:"var(--tempi-global-paragraph2fontfamily)"}),publishDateStyle:h(n({},s.publishDateStyle),{currentParagraphTheme:"paragraph2",fontFamily:"var(--tempi-global-paragraph2fontfamily)"}),categoryStyle:h(n({},s.categoryStyle),{currentParagraphTheme:"paragraph2",fontFamily:"var(--tempi-global-paragraph2fontfamily)"}),desktop:{titleStyle:{fontSize:"var(--tempi-global-paragraph1fontsize)",fontWeight:"700",lineHeight:"var(--tempi-global-paragraph1lineheight)",letterSpacing:"var(--tempi-global-paragraph1letterspacing)"},descriptionStyle:{fontSize:"var(--tempi-global-paragraph2fontsize)",fontWeight:"var(--tempi-global-paragraph2fontweight)",lineHeight:"var(--tempi-global-paragraph2lineheight)",letterSpacing:"var(--tempi-global-paragraph2letterspacing)"},publishDateStyle:{fontSize:"var(--tempi-global-paragraph2fontsize)",fontWeight:"var(--tempi-global-paragraph2fontweight)",lineHeight:"var(--tempi-global-paragraph2lineheight)",letterSpacing:"var(--tempi-global-paragraph2letterspacing)"},authorStyle:{fontSize:"var(--tempi-global-paragraph2fontsize)",fontWeight:"var(--tempi-global-paragraph2fontweight)",lineHeight:"var(--tempi-global-paragraph2lineheight)",letterSpacing:"var(--tempi-global-paragraph2letterspacing)"},categoryStyle:{fontWeight:"var(--tempi-global-paragraph2fontweight)",fontSize:"var(--tempi-global-paragraph2fontsize)",lineHeight:"var(--tempi-global-paragraph2lineheight)",letterSpacing:"var(--tempi-global-paragraph2letterspacing)"},actions:{searchName:{style:{width:300,widthUnit:"px",fontSize:"var(--tempi-global-paragraph2fontsize)",fontWeight:"var(--tempi-global-paragraph2fontweight)",lineHeight:"var(--tempi-global-paragraph2lineheight)",letterSpacing:"var(--tempi-global-paragraph2letterspacing)"}},filterCat:{style:{width:150,widthUnit:"px",fontSize:"var(--tempi-global-paragraph2fontsize)",fontWeight:"var(--tempi-global-paragraph2fontweight)",lineHeight:"var(--tempi-global-paragraph2lineheight)",letterSpacing:"var(--tempi-global-paragraph2letterspacing)"}},filterDate:{style:{width:300,widthUnit:"px",fontSize:"var(--tempi-global-paragraph2fontsize)",fontWeight:"var(--tempi-global-paragraph2fontweight)",lineHeight:"var(--tempi-global-paragraph2lineheight)",letterSpacing:"var(--tempi-global-paragraph2letterspacing)"}}}},mobile:{titleStyle:{fontSize:"var(--tempi-global-paragraph1mobilefontsize)",fontWeight:"700",lineHeight:"var(--tempi-global-paragraph1mobilelineheight)",letterSpacing:"var(--tempi-global-paragraph1mobileletterspacing)"},descriptionStyle:{fontSize:"var(--tempi-global-paragraph2mobilefontsize)",fontWeight:"var(--tempi-global-paragraph2mobilefontweight)",lineHeight:"var(--tempi-global-paragraph2mobilelineheight)",letterSpacing:"var(--tempi-global-paragraph2mobileletterspacing)"},publishDateStyle:{fontSize:"var(--tempi-global-paragraph2mobilefontsize)",fontWeight:"var(--tempi-global-paragraph2mobilefontweight)",lineHeight:"var(--tempi-global-paragraph2mobilelineheight)",letterSpacing:"var(--tempi-global-paragraph2mobileletterspacing)"},authorStyle:{fontSize:"var(--tempi-global-paragraph2mobilefontsize)",fontWeight:"var(--tempi-global-paragraph2mobilefontweight)",lineHeight:"var(--tempi-global-paragraph2mobilelineheight)",letterSpacing:"var(--tempi-global-paragraph2mobileletterspacing)"},categoryStyle:{fontSize:"var(--tempi-global-paragraph2mobilefontsize)",fontWeight:"var(--tempi-global-paragraph2mobilefontweight)",lineHeight:"var(--tempi-global-paragraph2mobilelineheight)",letterSpacing:"var(--tempi-global-paragraph2mobileletterspacing)"},actions:{searchName:{style:{width:100,widthUnit:"%",fontSize:"var(--tempi-global-paragraph2mobilefontsize)",fontWeight:"var(--tempi-global-paragraph2mobilefontweight)",lineHeight:"var(--tempi-global-paragraph2mobilelineheight)",letterSpacing:"var(--tempi-global-paragraph2mobileletterspacing)"}},filterCat:{style:{width:100,widthUnit:"%",fontSize:"var(--tempi-global-paragraph2mobilefontsize)",fontWeight:"var(--tempi-global-paragraph2mobilefontweight)",lineHeight:"var(--tempi-global-paragraph2mobilelineheight)",letterSpacing:"var(--tempi-global-paragraph2mobileletterspacing)"}},filterDate:{style:{width:100,widthUnit:"%",fontSize:"var(--tempi-global-paragraph2mobilefontsize)",fontWeight:"var(--tempi-global-paragraph2mobilefontweight)",lineHeight:"var(--tempi-global-paragraph2mobilelineheight)",letterSpacing:"var(--tempi-global-paragraph2mobileletterspacing)"}}}}}),m=[{tag:"Grid",group:t.t("Dạng lưới"),props:h(n({},s),{layout:"grid",gridConfig:{row:2,column:4,gutter:16}}),src:"https://lh3.googleusercontent.com/0ZAi-CqHYZapP_ziLTblVBnstxyW9EtgyEg5XhYe3VISBDqxvFXTermevj6ua7nyiRffOn-Rt2VojN_A6bIKi3a3uSJb6lU6"},{tag:"Carousel",group:t.t("Dạng trượt"),props:h(n({},s),{layout:"carousel",carouselOptions:{speed:3,column:4,gutter:16}}),src:"https://lh3.googleusercontent.com/VnJw_QkCcF_oQ07f_rpJgIt0XiKXjWY_tStWJUlMv6lYN2ED-zKuTKTjTv_DnG86SWIQcCsirUdgIAeLK7xWKKgCW5d5l5l1"},{tag:"List",group:t.t("Danh sách"),props:h(n({},s),{layout:"list",listConfig:{row:3,gutter:16}}),src:"https://lh3.googleusercontent.com/mCn78saG6S-I32sUPzoW5az9deHnTyj3OC3qc1t2E6igMhy8MlLZKGXqae1uC18vI4NbHq0Rlbnw0kHwf1ACBbwJ9rG_qIBfkA"}],c=[{tag:"Grid",group:t.t("Dạng lưới"),props:h(n({},f),{layout:"grid",gridConfig:{row:2,column:4,gutter:16}}),src:"https://lh3.googleusercontent.com/0ZAi-CqHYZapP_ziLTblVBnstxyW9EtgyEg5XhYe3VISBDqxvFXTermevj6ua7nyiRffOn-Rt2VojN_A6bIKi3a3uSJb6lU6"},{tag:"Carousel",group:t.t("Dạng trượt"),props:h(n({},f),{layout:"carousel",carouselOptions:{speed:3,column:4,gutter:16}}),src:"https://lh3.googleusercontent.com/VnJw_QkCcF_oQ07f_rpJgIt0XiKXjWY_tStWJUlMv6lYN2ED-zKuTKTjTv_DnG86SWIQcCsirUdgIAeLK7xWKKgCW5d5l5l1"},{tag:"List",group:t.t("Danh sách"),props:h(n({},f),{layout:"list",listConfig:{row:3,gutter:16}}),src:"https://lh3.googleusercontent.com/mCn78saG6S-I32sUPzoW5az9deHnTyj3OC3qc1t2E6igMhy8MlLZKGXqae1uC18vI4NbHq0Rlbnw0kHwf1ACBbwJ9rG_qIBfkA"}],b=[{key:"name",title:t.t("article.name")},{key:"description",title:t.t("article.desc")},{key:"articleInfo_author",title:t.t("article.articleInfo_author")},{key:"categories",title:t.t("article.categories")},{key:"articleInfo_publishedAt",title:t.t("article.articleInfo_publishedAt")}];exports.DEFAULT_ARTICLE_HEADER_STYLE=(t=!0)=>t?{currentParagraphTheme:"paragraph1",fontFamily:"var(--tempi-global-paragraph1fontfamily)",backgroundColor:"#183350",textTransform:"uppercase"}:{backgroundColor:"#183350",fontFamily:"Roboto",textTransform:"uppercase"},exports.DEFAULT_ARTICLE_HEADER_STYLE_DESKTOP=(t=!0)=>t?{fontSize:"var(--tempi-global-paragraph1fontsize)",fontWeight:700,lineHeight:"var(--tempi-global-paragraph1lineheight)",letterSpacing:"var(--tempi-global-paragraph1letterspacing)"}:{fontSize:16,fontWeight:700},exports.DEFAULT_ARTICLE_HEADER_STYLE_MOBILE=(t=!0)=>t?{fontSize:"var(--tempi-global-paragraph1mobilefontsize)",fontWeight:700,lineHeight:"var(--tempi-global-paragraph1mobilelineheight)",letterSpacing:"var(--tempi-global-paragraph1mobileletterspacing)"}:{fontSize:16,fontWeight:700},exports.DEFAULT_ARTICLE_LIST=s,exports.DEFAULT_ARTICLE_LIST_THEME=f,exports.DEFAULT_ARTICLE_THUMBNAIL="https://lh3.googleusercontent.com/nAocrNg5Uz_6OlemCdHXyNfPK9uxJpBhADfy_xEc4QiZT7ihSAC_8X_wkht7FGoOxRWfT0IFtkaVxF6mKajLbLbueDZmdlg=rw-w500",exports.DEFAULT_ARTICLE_TITLE_STYLE={color:"#1D51AF",textDecoration:"underline"},exports.DEFAULT_DISPLAY_ROW_COUNT=8,exports.DEFAULT_EVEN_ROW_BACKGROUND="#f8f8f8",exports.DEFAULT_FILTER_VALUE={searchQuery:"",filterCat:"",filterDate:{startDate:0,endDate:0}},exports.DEFAULT_HEADER_STYLE={name:{width:250},description:{width:200},articleInfo_author:{width:150},categories:{width:150},articleInfo_publishedAt:{width:150}},exports.DEFAULT_IMAGE_WIDTH=100,exports.DEFAULT_IMAGE_WIDTH_FOR_DESKTOP_LIST=30,exports.DEFAULT_MAPPING_COL_TITLE=b,exports.DEFAULT_ODD_ROW_BACKGROUND="#ebebeb",exports.DEFAULT_TABLE_BORDER_COLOR="#dddddd",exports.DEFAULT_TITLE_FONT_SIZE=14,exports.MAX_WIDTH_PERCENT=100,exports.MAX_WIDTH_PIXEL=600,exports.SAMPLE_ARTICLE_LIST=m,exports.SAMPLE_ARTICLE_LIST_THEME=c;


/***/ }),

/***/ 156788:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097),t=__webpack_require__(875464),r=Object.defineProperty,i=Object.defineProperties,o=Object.getOwnPropertyDescriptors,n=Object.getOwnPropertySymbols,l=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,s=(e,t,i)=>t in e?r(e,t,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[t]=i,a=(e,t)=>{for(var r in t||(t={}))l.call(t,r)&&s(e,r,t[r]);if(n)for(var r of n(t))p.call(t,r)&&s(e,r,t[r]);return e};exports.backwardPropsArticleList=e=>{const t="titleFontSize"in e?a({fontSize:e.titleFontSize},e.titleStyle):e.titleStyle;return r=a({},e),i(r,o({titleStyle:t}));var r},exports.getDefaultWidth=({width:e,widthUnit:t,isMobile:r,defaultWidth:i})=>e&&t?`${e}${t}`:e?r?"100%":`${e}px`:r?"100%":`${i||130}px`,exports.onChangeUnit=(r,i,o,n)=>{null==o||o(r),r===e.UnitEnum.percent&&i>t.MAX_WIDTH_PERCENT&&(null==n||n(t.MAX_WIDTH_PERCENT))};


/***/ }),

/***/ 508378:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097),t=__webpack_require__(891987),r=__webpack_require__(875464),a=__webpack_require__(240228),i=Object.defineProperty,o=Object.defineProperties,l=Object.getOwnPropertyDescriptors,s=Object.getOwnPropertySymbols,n=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,c=(e,t,r)=>t in e?i(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,d=(e,t)=>{for(var r in t||(t={}))n.call(t,r)&&c(e,r,t[r]);if(s)for(var r of s(t))u.call(t,r)&&c(e,r,t[r]);return e},p=(e,t)=>o(e,l(t));exports.useArticles=i=>{const{websiteId:o,categoryIds:l,layout:s,gridConfig:n,listConfig:u,loadMoreType:c,triggerUpdate:f,websiteTranslationId:g,isMatchAllCategories:y=!1,tableDisplayedRowCount:b=8}=i,[v,h]=t.useState([]),[w,S]=t.useState(1),{env:D}=e.useStore(),[O,A]=t.useState(!0),[j,E]=t.useState(),[I,T]=t.useState([]),[m,C]=t.useState(r.DEFAULT_FILTER_VALUE),[U,L]=t.useState(0),[M,P]=t.useState(!1),F="table"===s?b:"grid"===s?n.row*n.column:"carousel"===s?100:u.row,_=(null==j?void 0:j.total)>w*F,q=()=>Array.isArray(m.filterCat)&&m.filterCat.length>0&&!y?m.filterCat:l.length>0?l:void 0;t.useEffect((()=>{o&&M&&(h([]),S(1),E(void 0),L((e=>e+1)))}),[o,s,JSON.stringify(l),u.row,n.column,n.row,f,JSON.stringify(m),y,b]),t.useEffect((()=>{(()=>{const t=new e.Api(`${e.publicBffUrl[D]}/v1/pages`);A(!0),t.get("/",{params:p(d(d(d(d(d({websiteId:o},q()&&{categoryIds:q()}),(null==m?void 0:m.searchQuery)&&{searchQuery:m.searchQuery}),"object"==typeof(null==m?void 0:m.filterDate)&&m.filterDate.startDate&&{publishedFrom:m.filterDate.startDate}),"object"==typeof(null==m?void 0:m.filterDate)&&m.filterDate.endDate&&{publishedTo:m.filterDate.endDate}),y&&{isMatchAllCategories:y}),{page:w,pageSize:F,isArticle:!0,websiteTranslationId:g})}).then((e=>{var t,r,i,o;const l=null==(r=null==(t=null==e?void 0:e.data)?void 0:t.data)?void 0:r.pages,s=null==(o=null==(i=null==e?void 0:e.data)?void 0:i.data)?void 0:o.pagination;1===w||c!==a.LoadMoreType.BUTTON?h(l):h((e=>[...e,...l])),E(s)})).catch((e=>{console.error(e)})).finally((()=>{A(!1)}))})()}),[w,U]),t.useEffect((()=>{P(!0)}),[]),t.useEffect((()=>{o&&(C(r.DEFAULT_FILTER_VALUE),N())}),[JSON.stringify(l)]);const N=async()=>{new e.Api(`${e.publicBffUrl[D]}/v1/categories`).get("/",{params:p(d({websiteId:o},l.length&&{categoryIds:l}),{page:1,pageSize:999})}).then((e=>{var t,r;const a=null==(r=null==(t=null==e?void 0:e.data)?void 0:t.data)?void 0:r.categories;T(a)})).catch((e=>{console.error(e)}))};return{articles:v,categories:I,loading:O,loadMore:()=>{S((e=>e+1))},hasMore:_,pagination:j,setCurrentPage:S,filterValue:m,setFilterValue:C}};


/***/ }),

/***/ 240228:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=(e=>(e.TEXT="text",e.CARD="card",e))(e||{}),t=(e=>(e.BUTTON="button",e.PAGINATION="pagination",e.NONE="none",e))(t||{}),r=(e=>(e.TAG="tag",e.LIST="text",e.DROPDOWN="dropdown",e))(r||{}),o=(e=>(e.FILTER_CAT="filterCat",e.SEARCH_NAME="searchName",e.FILTER_DATE="filterDate",e))(o||{});exports.ActionKeys=o,exports.DisplayTypes=e,exports.FilterCatType=r,exports.LoadMoreType=t;


/***/ }),

/***/ 602700:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(891987),r=__webpack_require__(212951),i=__webpack_require__(85097),o=__webpack_require__(508378),l=__webpack_require__(240228),a=__webpack_require__(570867),n=__webpack_require__(156788),s=__webpack_require__(717058),c=__webpack_require__(403654),d=__webpack_require__(568904),p=__webpack_require__(333112),g=__webpack_require__(305140),y=__webpack_require__(43673),u=__webpack_require__(863988),b=__webpack_require__(370160);function f(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var m=f(t),C=f(r),T=Object.defineProperty,h=Object.defineProperties,M=Object.getOwnPropertyDescriptors,j=Object.getOwnPropertySymbols,x=Object.prototype.hasOwnProperty,S=Object.prototype.propertyIsEnumerable,w=(e,t,r)=>t in e?T(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,v=(e,t)=>{for(var r in t||(t={}))x.call(t,r)&&w(e,r,t[r]);if(j)for(var r of j(t))S.call(t,r)&&w(e,r,t[r]);return e},D=(e,t)=>h(e,M(t));const O=m.default.forwardRef(((t,r)=>{var f;const m=n.backwardPropsArticleList(t),{categoryIds:C=[],layout:T,showLoadMore:h,isEditingMode:M,displayConfig:w,loadMoreType:O=l.LoadMoreType.BUTTON,paginationColor:F="#7367f0",isOpenNewTab:N=!0,categoryColor:V="#7367f0",categoryType:E="button",triggerUpdate:I,loadMoreText:R,isMatchAllCategories:$,noArticleDescription:k,loadingDescription:U,enableMobileTableCardView:H}=m,G=((e,t)=>{var r={};for(var i in e)x.call(e,i)&&t.indexOf(i)<0&&(r[i]=e[i]);if(null!=e&&j)for(var i of j(e))t.indexOf(i)<0&&S.call(e,i)&&(r[i]=e[i]);return r})(m,["categoryIds","layout","showLoadMore","isEditingMode","displayConfig","loadMoreType","paginationColor","isOpenNewTab","categoryColor","categoryType","triggerUpdate","loadMoreText","isMatchAllCategories","noArticleDescription","loadingDescription","enableMobileTableCardView"]),{globalData:W={},device:z}=i.useStore(),_="mobile"===z,{websiteId:J}=W||{},{gridConfig:K,listConfig:Q,carouselOptions:X,commonStyle:Y,titleStyle:Z,descriptionStyle:ee,authorStyle:te,publishDateStyle:re,categoryStyle:ie,imageStyle:oe,actions:le,publishDateCardStyle:ae,cardStyle:ne,publishDateDisplayType:se,mappingColTitle:ce,oddRowBackgroundColor:de,evenRowBackgroundColor:pe,articleHeaderStyle:ge,tableBorderColor:ye,displayedRowCount:ue,articleTableStyle:be,tableHeaderStyle:fe}=i.getPropsByDevice(G,z),{searchName:me,filterCat:Ce,filterDate:Te}=le||{},{align:he="left",type:Me,enable:je}=Ce||{},{articles:xe=[],categories:Se=[],loading:we,hasMore:ve,loadMore:De,pagination:Oe,setCurrentPage:Ae,filterValue:Pe,setFilterValue:qe}=o.useArticles({isMatchAllCategories:$,websiteId:J,categoryIds:C,layout:T,listConfig:Q,gridConfig:K,carouselOptions:X,loadMoreType:O,triggerUpdate:I,websiteTranslationId:null==(f=null==W?void 0:W.currentLanguage)?void 0:f.id,tableDisplayedRowCount:ue}),Le=0===xe.length,Be=O===l.LoadMoreType.BUTTON,Fe=(_||Me===l.FilterCatType.DROPDOWN)&&je&&!$,Ne=e=>{Ae(e.selected+1)};return e.jsxs(A,D(v({ref:r,isEditingMode:M},G),{commonStyle:Y,categoryAlign:he,children:[((null==me?void 0:me.enable)||(null==Te?void 0:Te.enable)||Fe)&&e.jsxs(q,{isMobile:_,hasFilter:(null==me?void 0:me.enable)||(null==Te?void 0:Te.enable),children:[(null==me?void 0:me.enable)&&e.jsx(c.SearchBar,{action:me,isEditingMode:M,fitterValue:Pe,setFilterValue:qe,isMobile:_}),(null==Te?void 0:Te.enable)&&e.jsx(d.DatePicker,{action:Te,isEditingMode:M,filterValue:Pe,setFilterValue:qe,isMobile:_}),Fe&&e.jsx(p.CategoryFilter,{action:Ce,categories:Se,categoryIds:C,filterValue:Pe,setFilterValue:qe,isMobile:_})]}),e.jsx(P,{allowMargin:!_&&je&&Me!==l.FilterCatType.DROPDOWN,marginType:"left"===he?"right":"left",children:!_&&je&&!$&&Me!==l.FilterCatType.DROPDOWN&&e.jsx(p.CategoryFilter,{action:Ce,categories:Se,categoryIds:C,filterValue:Pe,setFilterValue:qe})}),e.jsxs(L,{categoryAlign:he,children:["table"===T?e.jsx(s.ArticleTable,{dataSource:xe,mappingColTitle:ce,articleTableStyle:be,articleHeaderStyle:ge,oddRowBackgroundColor:de,evenRowBackgroundColor:pe,isOpenNewTab:N,categoryColor:V,categoryType:E,titleStyle:Z,descriptionStyle:ee,authorStyle:te,publishDateStyle:re,categoryStyle:ie,isEmpty:Le&&!we,isLoading:we&&Be,isEditingMode:M,loadingDescription:U,noArticleDescription:k,tableBorderColor:ye,displayConfig:w,tableHeaderStyle:fe,enableMobileCardView:H}):e.jsxs(e.Fragment,{children:[Le&&!we?e.jsx(g.ArticleEmpty,{description:k}):e.jsx(y.ArticleLayout,D(v({},t),{gridConfig:K,listConfig:Q,carouselOptions:X,children:xe.map((t=>e.jsx(u.ArticleCard,{article:t,layout:T,displayConfig:w,isOpenNewTab:N,categoryColor:V,categoryType:E,imageStyle:oe,titleStyle:Z,descriptionStyle:ee,authorStyle:te,publishDateStyle:se!==l.DisplayTypes.CARD?re:ae,categoryStyle:ie,rowGap:null==K?void 0:K.rowGap,cardStyle:ne,publishDateDisplayType:se},t.id||t.canonical)))})),we&&Be&&e.jsx(B,{children:U||"Loading article ..."})]}),(()=>{if("carousel"===T)return null;switch(O){case l.LoadMoreType.BUTTON:return e.jsx(b.LoadMoreButton,v({},{loading:we,hasMore:ve,isEmpty:Le,loadMore:De,loadMoreText:R}));case l.LoadMoreType.PAGINATION:return e.jsx(a.ArticlePagination,{onPageChange:Ne,pageCount:Math.ceil((null==Oe?void 0:Oe.total)/(null==Oe?void 0:Oe.pageSize)),textColor:Y.color,paginationColor:F});default:return null}})()]})]}))}));O.displayName="ArticleList";const A=C.default.div((({commonStyle:e,isEditingMode:t,categoryAlign:r})=>`\n  ${i.getStyle(e)}\n  display: grid;\n  grid-template-columns: ${"left"===r?"min-content minmax(0, 1fr)":"minmax(0, 1fr) min-content"};\n  a{\n    color: ${e.color};\n    ${t?"pointer-events: none;":""}\n  }\n`)),P=C.default.div((({marginType:e,allowMargin:t})=>`\n  grid-column: ${"right"===e?"1":"2"} / span 1;\n  grid-row: 2;\n  margin-${e}: ${t?"32px":"0"};\n`)),q=C.default.div`
  grid-column: 1 / span 2;
  grid-row: 1;
  margin-bottom: ${e=>e.isMobile?"16px":e.hasFilter?"32px":"0"};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 16px;
`,L=C.default.div((({categoryAlign:e})=>`\n  grid-column: ${"right"===e?"1":"2"} / span 1;\n  grid-row: 2;\n`)),B=C.default.div`
  height: 400px;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 14px;
`;exports.ArticleList=O;


/***/ }),

/***/ 851490:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),o=__webpack_require__(143599),r=__webpack_require__(85097);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=n(t);const l=i.default.button`
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    background: #e9ecef;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: scale(0.95);
  }
`,a=i.default(o.Icon)`
  width: 100%;
  height: 100%;
  cursor: pointer;
  ${({iconStyle:e})=>r.getStyle(e)}
`;exports.PlayController=({isPlaying:t,togglePlayPause:r,iconConfig:n})=>{const{iconName:i,iconStyle:c}=n||{};return n?e.jsx("div",{onClick:r,children:t?e.jsx(a,{name:"PauseIconOutlined",iconStyle:c}):e.jsx(a,{name:i,iconStyle:c})}):e.jsx(l,{onClick:r,children:t?e.jsx(o.Icon,{name:"PauseIconOutlined",style:{fontSize:24,color:"#495057"}}):e.jsx(o.Icon,{name:"PlaySharpFillFilled",style:{fontSize:14,color:"#495057"}})})};


/***/ }),

/***/ 739818:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261);exports.SpeedController=({speed:r,handleSpeedChange:t})=>e.jsxs("button",{onClick:t,style:{background:"#f8f9fa",border:"1px solid #dee2e6",borderRadius:"4px",width:"60px",height:"30px",cursor:"pointer",fontSize:"12px",fontWeight:"500",color:"#495057",transition:"all 0.2s ease"},onMouseEnter:e=>{e.currentTarget.style.background="#e9ecef"},onMouseLeave:e=>{e.currentTarget.style.background="#f8f9fa"},children:["x",r]});


/***/ }),

/***/ 318502:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261);exports.VolumeController=({volume:t,handleVolumeChange:l})=>e.jsxs("div",{style:{display:"flex",alignItems:"center",gap:"8px"},children:[e.jsxs("svg",{width:"30",height:"30",viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",style:{minWidth:"20px",display:"flex",alignItems:"center",color:"#666"},children:[e.jsx("path",{d:"M3 9V15H7L12 20V4L7 9H3Z",fill:"currentColor"}),e.jsx("path",{d:"M16.5 12C16.5 10.23 15.48 8.71 14 7.97V16.02C15.48 15.29 16.5 13.77 16.5 12Z",fill:"currentColor"}),e.jsx("path",{d:"M14 3.23V5.29C16.89 6.15 19 8.83 19 12C19 15.17 16.89 17.85 14 18.71V20.77C18.01 19.86 21 16.28 21 12C21 7.72 18.01 4.14 14 3.23Z",fill:"currentColor"})]}),e.jsx("input",{type:"range",min:"0",max:"1",step:"0.05",value:t,onChange:l,style:{width:"100px",height:"4px",cursor:"pointer"}}),e.jsxs("span",{style:{fontSize:"12px",color:"#666",minWidth:"30px"},children:[Math.round(100*t),"%"]})]});


/***/ }),

/***/ 798010:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261);exports.DefaultAudio=o=>{const{uploadSrc:r,autoplay:t,loop:s}=o;return e.jsxs("audio",{controls:!0,style:{width:"100%"},autoPlay:t,loop:s,children:[e.jsx("source",{src:r}),"Your browser does not support the audio element."]},r)};


/***/ }),

/***/ 795688:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(85097),o=__webpack_require__(891987),t=__webpack_require__(152574),l=__webpack_require__(318502),a=__webpack_require__(851490),i=__webpack_require__(739818);function n(e){if(e&&e.__esModule)return e;var r=Object.create(null);return e&&Object.keys(e).forEach((function(o){if("default"!==o){var t=Object.getOwnPropertyDescriptor(e,o);Object.defineProperty(r,o,t.get?t:{enumerable:!0,get:function(){return e[o]}})}})),r.default=e,Object.freeze(r)}var s=Object.defineProperty,u=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,c=(e,r,o)=>r in e?s(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,y=(e,r)=>{for(var o in r||(r={}))d.call(r,o)&&c(e,o,r[o]);if(u)for(var o of u(r))p.call(r,o)&&c(e,o,r[o]);return e};exports.WaveformAudio=s=>{const[c,m]=o.useState(null),{device:v}=r.useStore(),f=s,{loop:g,autoplay:h,waveColor:C,cursorColor:j,progressColor:b,uploadSrc:x,isEditorMode:w,displayConfig:O,waveFormType:P=t.WaveFormType.DEFAULT}=f,S=((e,r)=>{var o={};for(var t in e)d.call(e,t)&&r.indexOf(t)<0&&(o[t]=e[t]);if(null!=e&&u)for(var t of u(e))r.indexOf(t)<0&&p.call(e,t)&&(o[t]=e[t]);return o})(f,["loop","autoplay","waveColor","cursorColor","progressColor","uploadSrc","isEditorMode","displayConfig","waveFormType"]),{zoom:F,cursorWidth:$,barWidth:T,barGap:W,barRadius:q,commonStyle:E,iconConfig:A}=r.getPropsByDevice(S,v),I=null==A?void 0:A.alignment,{showWaveForm:M=!0,showProgressBar:z=!0,showSpeed:B=!0,showVolume:D=!0}=O||{},[V,_]=o.useState(h),[N,R]=o.useState(1),[U,k]=o.useState(1),G=[.25,.5,1,1.5,2],L=()=>{_(!V)};return o.useEffect((()=>{Promise.resolve().then((function(){return n(__webpack_require__(162398))})).then((e=>{m((()=>e.default))}))}),[]),c?e.jsxs("div",{style:{width:"100%"},children:[e.jsx(c,{audioFile:x,className:"react-waves",options:y({audioRate:U,cursorWidth:z?$:0,waveColor:C,cursorColor:j,progressColor:b,barWidth:T,barGap:W,barRadius:q,hideScrollbar:!0,backend:"MediaElement",normalize:!0,responsive:!0,mediaType:"audio"},P!==t.WaveFormType.ICON&&M?{}:{height:0}),pos:w?20:void 0,zoom:F,volume:N,playing:V,onFinish:()=>{g&&(_(!1),setTimeout((()=>{_(!0)}),100))}},`${$}-${T}-${W}-${q}-${C}-${j}-${b}-${v}-${null==E?void 0:E.width}-${null==E?void 0:E.widthUnit}-${M}-${z}-${P} `),P===t.WaveFormType.DEFAULT&&e.jsx(e.Fragment,{children:e.jsxs("div",{style:{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"8px",padding:"8px 20px"},children:[D&&e.jsx(l.VolumeController,{volume:N,handleVolumeChange:e=>{R(parseFloat(e.target.value))}}),e.jsx(a.PlayController,{isPlaying:V,togglePlayPause:L}),B&&e.jsx(i.SpeedController,{speed:U,handleSpeedChange:()=>{const e=(G.indexOf(U)+1)%G.length;k(G[e])}})]})}),P===t.WaveFormType.ICON&&e.jsx("div",{style:{display:"flex",alignItems:"center",justifyContent:I||"center",marginBottom:"8px",padding:"8px 20px"},children:e.jsx(a.PlayController,{isPlaying:V,togglePlayPause:L,iconConfig:A})})]}):null};


/***/ }),

/***/ 152574:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097),o=(e=>(e.DEFAULT="default",e.WAVEFORM="waveform",e))(o||{}),r=(e=>(e.DEFAULT="default",e.ICON="icon",e))(r||{});const t={desktop:{zoom:1,displayType:"default",cursorWidth:2,barWidth:4,barGap:2,barRadius:2,commonStyle:{width:100,widthUnit:e.UnitEnum.percent},iconConfig:{alignment:"center",iconStyle:{fontSize:24}}},loop:!1,autoplay:!1,waveColor:"#cdcdcd",cursorColor:"#7367f0",progressColor:"#7367f0",displayConfig:{showWaveForm:!0,showVolume:!0,showProgressBar:!0,showSpeed:!0},waveFormType:"default",iconConfig:{iconName:"PlayRoundedFillFilled",iconStyle:{color:"#000"}}};exports.AudioDisplayType=o,exports.DEFAULT_AUDIO=t,exports.WaveFormType=r;


/***/ }),

/***/ 336684:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(212951),r=__webpack_require__(85097),t=__webpack_require__(891987),i=__webpack_require__(152574),n=__webpack_require__(795688),a=__webpack_require__(798010);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=l(o),u=Object.defineProperty,p=Object.getOwnPropertySymbols,s=Object.prototype.hasOwnProperty,c=Object.prototype.propertyIsEnumerable,f=(e,o,r)=>o in e?u(e,o,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[o]=r,y=(e,o)=>{for(var r in o||(o={}))s.call(o,r)&&f(e,r,o[r]);if(p)for(var r of p(o))c.call(o,r)&&f(e,r,o[r]);return e};const m=t.forwardRef(((o,t)=>{const l=o,{uploadSrc:d,isEditorMode:u,autoplay:f,loop:m}=l,b=((e,o)=>{var r={};for(var t in e)s.call(e,t)&&o.indexOf(t)<0&&(r[t]=e[t]);if(null!=e&&p)for(var t of p(e))o.indexOf(t)<0&&c.call(e,t)&&(r[t]=e[t]);return r})(l,["uploadSrc","isEditorMode","autoplay","loop"]),{device:x}=r.useStore(),{displayType:O,commonStyle:S,alignment:w}=r.getPropsByDevice(b,x),A=O===i.AudioDisplayType.WAVEFORM&&d&&"undefined"!=typeof window;return e.jsx(v,{alignment:w,"data-id":b.id,children:e.jsx(j,{ref:t,commonStyle:S,isEditorMode:u,children:A?e.jsx(n.WaveformAudio,y({uploadSrc:d,isEditorMode:u,autoplay:!u&&f,loop:m},b)):e.jsx(a.DefaultAudio,{uploadSrc:d,autoplay:!u&&f,loop:m})})})})),v=d.default.div`
  display: flex;
  width: 100%;
  justify-content: ${e=>e.alignment||"left"};
`,j=d.default.div((({commonStyle:e,isEditorMode:o})=>`\n  ${r.getStyle(e)}\n  ${o?"> * { pointer-events: none;}":""}\n  max-width: 100%;\n`));m.displayName="Audio",exports.Audio=m;


/***/ }),

/***/ 750911:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(212951),t=__webpack_require__(85097),r=__webpack_require__(877084),o=__webpack_require__(891987),i=__webpack_require__(570267),l=__webpack_require__(998621),s=__webpack_require__(144497),a=__webpack_require__(319891),u=__webpack_require__(426839),c=__webpack_require__(534479);function d(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var p=d(n),f=d(r),y=d(o),m=Object.defineProperty,g=Object.defineProperties,x=Object.getOwnPropertyDescriptors,v=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,j=Object.prototype.propertyIsEnumerable,h=(e,n,t)=>n in e?m(e,n,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[n]=t,S=(e,n)=>{for(var t in n||(n={}))b.call(n,t)&&h(e,t,n[t]);if(v)for(var t of v(n))j.call(n,t)&&h(e,t,n[t]);return e},w=(e,n)=>g(e,x(n)),C=(e,n)=>{var t={};for(var r in e)b.call(e,r)&&n.indexOf(r)<0&&(t[r]=e[r]);if(null!=e&&v)for(var r of v(e))n.indexOf(r)<0&&j.call(e,r)&&(t[r]=e[r]);return t};const O=y.default.forwardRef(((n,r)=>{const{device:c}=t.useStore(),d=n,{isEditingMode:p=!1,onClick:y,className:m,disabled:g,customText:x,loading:v,parentLayout:b,style:j,isPreventDefault:h=!0,wrapperRef:O}=d,P=C(d,["isEditingMode","onClick","className","disabled","customText","loading","parentLayout","style","isPreventDefault","wrapperRef"]),R=t.getPropsByDevice(P,c),{commonStyle:I,text:L,iconConfig:T,buttonStyle:D,event:N}=R,B=C(R,["commonStyle","text","iconConfig","buttonStyle","event"]),E=i.getIconComponent(null==T?void 0:T.icon),M=(null==T?void 0:T.show)&&"left"===(null==T?void 0:T.position)&&!!E,$=(null==T?void 0:T.show)&&"right"===(null==T?void 0:T.position)&&!!E,_=g||v,z=null==N?void 0:N.tekoTrackingEvent,A=o.useRef(null),{style:V,animationClassName:H}=t.useAnimation(null==I?void 0:I.animation,A),W={className:f.default(m,H),commonStyle:S(S({},I),"row"===b?{flex:1,alignItems:"flex-end"}:{})},F=(null==D?void 0:D.textAlign)||"center",G=e.jsxs(k,w(S({ref:e=>{"function"==typeof r?r(e):r&&(r.current=e),A.current=e},disabled:_,buttonStyle:D,onClick:e=>{"function"!=typeof y||_||p||(h&&e.preventDefault(),y())}},B),{justifyContent:F,style:S(S({},j),V),children:[v&&e.jsx("span",{children:e.jsx(l.StyledSpinningInner,{size:10,transform:5,time:.6})}),M&&!v&&E,e.jsx("span",{style:S(S({},(M||v)&&!!L&&{marginLeft:null==T?void 0:T.spacing}),!!$&&!!L&&{marginRight:null==T?void 0:T.spacing}),children:x||e.jsx("span",{dangerouslySetInnerHTML:{__html:L}})}),$&&E,!g&&!x&&e.jsx(s.Ripple,{})]}));return p?e.jsx(q,w(S({ref:O},W),{children:G})):e.jsx(q,w(S(S({},W),u.getAttrTracking(z)),{children:e.jsx(a.Link,w(S({},N),{children:G}))}))})),k=p.default.button((({buttonStyle:e,justifyContent:n})=>`\n    ${c.getCommonTextCss(!0)}\n    position: relative;\n    border: none;\n    align-items: center;\n    text-decoration: none;\n    display: flex;\n    justify-content: ${n||"center"};\n    cursor: pointer;\n    font-size: 14px;\n    line-height: 16px;\n    background: transparent;\n    max-width: 100%;\n    > span {\n      font-size: inherit;\n      line-height: inherit;\n    }\n    &[disabled] {\n      color: #00000040;\n      border-color: #d9d9d9;\n      background: #f5f5f5;\n      text-shadow: none;\n      box-shadow: none;\n      cursor: not-allowed;\n    }\n    ${t.getStyle(e)}\n`)),q=p.default.div((({commonStyle:e})=>`\n  display: flex;\n  width: 100%;\n  position: relative;\n  ${t.getStyle(e)}\n`));O.displayName="ButtonV2",exports.ButtonV2=O,exports.ButtonWrapper=q;


/***/ }),

/***/ 479287:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(561261),e=__webpack_require__(891987),r=__webpack_require__(85097),o=__webpack_require__(681084),u=__webpack_require__(795625),n=__webpack_require__(77906),i=__webpack_require__(800886),a=__webpack_require__(154407),s=__webpack_require__(800656),l=__webpack_require__(512005),c=__webpack_require__(750911),d=Object.defineProperty,p=Object.defineProperties,y=Object.getOwnPropertyDescriptors,f=Object.getOwnPropertySymbols,v=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,b=(t,e,r)=>e in t?d(t,e,{enumerable:!0,configurable:!0,writable:!0,value:r}):t[e]=r,j=(t,e)=>{for(var r in e||(e={}))v.call(e,r)&&b(t,r,e[r]);if(f)for(var r of f(e))m.call(e,r)&&b(t,r,e[r]);return t},g=(t,e)=>p(t,y(e)),P=(t,e)=>{var r={};for(var o in t)v.call(t,o)&&e.indexOf(o)<0&&(r[o]=t[o]);if(null!=t&&f)for(var o of f(t))e.indexOf(o)<0&&m.call(t,o)&&(r[o]=t[o]);return r};const C=e.forwardRef(((d,p)=>{var y=d,{isEditingMode:f,productSku:v,text:m,buttonStyle:b,iconConfig:C,layout:x=i.ProductActionButtonLayout.Text}=y,q=P(y,["isEditingMode","productSku","text","buttonStyle","iconConfig","layout"]);const S=e.useRef(null),O=e.useMemo((()=>[v]),[v]),{products:h}=a.useProducts({skus:O,filterType:i.ProductFilterType.SKUS}),T=null==h?void 0:h[0],{globalData:k}=r.useStore(),{addToCart:w}=l.useCartStore(),[B,L]=e.useState(!1),A=x===i.ProductActionButtonLayout.Icon||x===i.ProductActionButtonLayout.Combined,M=x===i.ProductActionButtonLayout.Text||x===i.ProductActionButtonLayout.Combined;return t.jsxs(t.Fragment,{children:[t.jsx(c.ButtonV2,j({ref:S,onClick:!f&&T?()=>{return((t,e)=>{var r;const n=o.getProductsInLocalCart(t),i=e,{image:a,link:s}=i,l=P(i,["image","link"]),c=n.findIndex((t=>t.sku===e.sku));c>=0?n[c]=g(j(j({},n[c]),l),{thumbnailAlt:(null==a?void 0:a.alt)||e.name,thumbnailUrl:null==a?void 0:a.src,quantity:((null==(r=n[c])?void 0:r.quantity)||0)+1}):n.push(g(j({},l),{thumbnailAlt:(null==a?void 0:a.alt)||e.name,thumbnailUrl:null==a?void 0:a.src,quantity:1})),o.setProductsToLocalCart(t,n),u.emit("addProductToCart",n)})(null==(t=null==k?void 0:k.currentLanguage)?void 0:t.id,j({},T)),w(T,1),L(!0),void setTimeout((()=>{L(!1)}),1e3);var t}:null,buttonStyle:b,iconConfig:g(j({},C),{show:A}),text:M?m:void 0,isEditingMode:f,commonStyle:{justifyContent:"center",flex:1},className:"button-width",wrapperRef:p},q),v),B&&t.jsx(n.ToastMessage,{message:s.translate("product_list.add_to_cart")})]})}));C.displayName="CartButton",exports.CartButton=C;


/***/ }),

/***/ 228740:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),n=__webpack_require__(85097),t=__webpack_require__(877084),i=__webpack_require__(891987),l=__webpack_require__(227585),o=__webpack_require__(669117),a=__webpack_require__(879774),u=__webpack_require__(319891);function c(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=c(r),s=c(t),f=c(i),v=Object.defineProperty,p=Object.defineProperties,m=Object.getOwnPropertyDescriptors,y=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,j=(e,r,n)=>r in e?v(e,r,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[r]=n,x=(e,r)=>{for(var n in r||(r={}))b.call(r,n)&&j(e,n,r[n]);if(y)for(var n of y(r))g.call(r,n)&&j(e,n,r[n]);return e},A=(e,r)=>p(e,m(r));const O=d.default.div((({commonStyle:e,verticalAlignment:r})=>`\n  ${n.getStyle(e,{lazyBgImage:!0})}\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  justify-content: ${a.MAPPING_VERTICAL_ALIGNMENT_FLEX[r]||a.MAPPING_VERTICAL_ALIGNMENT_FLEX.top};\n`)),P=f.default.forwardRef(((r,t)=>{var a,c,d;const{device:f}=n.useStore(),v=r,{verticalAlignment:p,children:m,event:j}=v,P=((e,r)=>{var n={};for(var t in e)b.call(e,t)&&r.indexOf(t)<0&&(n[t]=e[t]);if(null!=e&&y)for(var t of y(e))r.indexOf(t)<0&&g.call(e,t)&&(n[t]=e[t]);return n})(v,["verticalAlignment","children","event"]),{commonStyle:_}=n.getPropsByDevice(P,f),{backgroundType:L,backgroundVideo:I}=_||{},N=i.useRef(),{style:S,animationClassName:k}=n.useAnimation(null==_?void 0:_.animation,N),E=n.useIntersectionObserver(N,{freezeOnceVisible:!0});return e.jsx(n.BreakpointWidthProvider,{sWidth:{value:l.parseFlexPercent(null==(a=null==P?void 0:P.xs)?void 0:a.flex),unit:"%"},mWidth:{value:l.parseFlexPercent(null==(c=null==P?void 0:P.md)?void 0:c.flex),unit:"%"},children:e.jsxs(o.Col,A(x({ref:t},P),{children:[(!L&&I||L===n.BackgroundType.VIDEO)&&e.jsx(n.BackgroundVideo,A(x({},I||{}),{background:null==(d=null==_?void 0:_.background)?void 0:d.toString(),backgroundBlur:null==_?void 0:_.backgroundBlur})),e.jsx(u.Link,A(x({},j),{children:e.jsx(O,{ref:N,commonStyle:_,verticalAlignment:p,style:S,className:s.default({[n.BG_LAZY_CLASS_NAME]:!0,[n.BG_VISIBLE_LAZY_CLASS_NAME]:E},k),children:m})}))]}))})}));P.displayName=o.Col.displayName,exports.PbCol=P;


/***/ }),

/***/ 227585:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0})),__webpack_require__(891987),__webpack_require__(85097);var e=__webpack_require__(669117);const r=e=>parseFloat(null==e?void 0:e.replace("%",""));exports.MIN_PERCENTAGE_COL_WIDTH=8,exports.getColWidthProps=r=>({md:{flex:e.percentage(r,12)},xs:{flex:"100%"}}),exports.getRemainingPercent=t=>e.floorPercentage(t.reduce(((e,t)=>e-(r(t)||0)),100)),exports.parseFlex=r,exports.parseFlexPercent=e=>{try{if("string"!=typeof e)return 100;const r=e.replace("%","");return isNaN(+r)?100:+r}catch(e){return console.warn(e),100}};


/***/ }),

/***/ 89007:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var n=__webpack_require__(561261),t=__webpack_require__(212951),e=__webpack_require__(891987),i=__webpack_require__(930370),r=__webpack_require__(85097),o=__webpack_require__(473347),a=__webpack_require__(426839);function l(n){return n&&"object"==typeof n&&"default"in n?n:{default:n}}var s=l(t),u=Object.defineProperty,c=Object.defineProperties,d=Object.getOwnPropertyDescriptors,v=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,p=(n,t,e)=>t in n?u(n,t,{enumerable:!0,configurable:!0,writable:!0,value:e}):n[t]=e,f=(n,t)=>{for(var e in t||(t={}))b.call(t,e)&&p(n,e,t[e]);if(v)for(var e of v(t))m.call(t,e)&&p(n,e,t[e]);return n},T=(n,t)=>c(n,d(t));const y=({children:t,item:o})=>{const a=e.useRef(),l=()=>{var n,t,e,i;null==(i=null==(e=null==(t=null==(n=a.current)?void 0:n.ownerDocument)?void 0:t.querySelector)?void 0:e.call(t,`[data-uniq-id="${null==o?void 0:o.popup}"]`))||i.click()},s=()=>{var n,t,e;null==(e=null==(t=null==(n=a.current)?void 0:n.ownerDocument)?void 0:t.defaultView)||e.scrollTo({top:0,behavior:"smooth"})},u=(n,t)=>{t?n.parentElement.classList.add("visible-bubble"):n.parentElement.classList.remove("visible-bubble")};switch(e.useEffect((()=>{var n;if(!a.current)return;const t=(null==(n=a.current)?void 0:n.ownerDocument)||document,e=r.debounce((()=>u(a.current,t.documentElement.scrollTop>=50)),50);return(null==o?void 0:o.animation)===i.AnimationType.VISIBLE_WHEN_SCROLL&&(u(a.current,t.documentElement.scrollTop>=50),t.addEventListener("scroll",e)),()=>{null==t||t.removeEventListener("scroll",e)}}),[null==o?void 0:o.animation]),o.eventType){case i.EventType.SCROLL_TOP_PAGE:return n.jsx("div",{ref:a,onClick:s,style:{cursor:"pointer"},children:t});case i.EventType.POPUP:return n.jsx("div",{ref:a,onClick:l,style:{cursor:"pointer"},children:t});default:return n.jsx("a",T(f({ref:a},(()=>{const n=null==o?void 0:o.href;if(!n)return;const t=n.replace(/-|\.|\s/g,"");return r.PATTERN_VALIDATION.phone.test(t)?{href:`tel:${t}`,target:"_self"}:{href:n,target:"_blank"}})()),{rel:"noreferrer",children:t}))}},E=s.default.div((({position:n,isEditorMode:t})=>`\nposition: relative;\n\na:hover ~ p, div:hover ~ p {\n  opacity: 1;\n  visibility: visible;\n}\n\ndisplay: flex;\nalign-items: center;\nflex-direction: row-reverse;\ngap: 0.8em;\nflex-direction: ${(n=>{switch(n){case i.ContactBubblePosition.BOTTOM_LEFT:case i.ContactBubblePosition.CENTER_LEFT:return"row";case i.ContactBubblePosition.BOTTOM_RIGHT:case i.ContactBubblePosition.CENTER_RIGHT:return"row-reverse";case i.ContactBubblePosition.BOTTOM_CENTER:return"column-reverse";default:return"row"}})(n)};\n${t&&"cursor: pointer;"}\n`)),g=s.default.div`
  border-radius: 50%;

  ${({animationType:n,padding:t,isEditorMode:e})=>{switch(n){case i.AnimationType.SPREAD:return`\n          @keyframes spread-animation {\n            0% {\n              box-shadow: 0 0 0 0 var(--dominant-color);\n            }\n            75% {\n              box-shadow: 0 0 0 16px transparent;\n            }\n            100% {\n              box-shadow: 0 0 0 0 transparent;\n            }\n          }\n          animation: spread-animation 2s infinite ease-out;\n          padding: ${t}px;\n        `;case i.AnimationType.FLICKER:return"\n          @keyframes flicker-animation {\n            0%, 100% {\n              opacity: 1;\n            }\n            50% {\n              opacity: 0.5;\n            }\n          }\n          animation: flicker-animation 1s infinite;\n        ";case i.AnimationType.VIBRATE:return"\n          @keyframes rotateShake {\n            0% {\n              -webkit-transform: rotate(0);\n              transform: rotate(0);\n            }\n            10% {\n              -webkit-transform: rotate(calc(-1 * var(--vibrate-rotate)));\n              transform: rotate(calc(-1 * var(--vibrate-rotate)));\n            }\n            20% {\n              -webkit-transform: rotate(var(--vibrate-rotate));\n              transform: rotate(var(--vibrate-rotate));\n            }\n            30% {\n              -webkit-transform: rotate(calc(-1 * var(--vibrate-rotate)));\n              transform: rotate(calc(-1 * var(--vibrate-rotate)));\n            }\n            40% {\n              -webkit-transform: rotate(var(--vibrate-rotate));\n              transform: rotate(var(--vibrate-rotate));\n            }\n            50% {\n              -webkit-transform: rotate(0);\n              transform: rotate(0);\n            }\n            100% {\n              -webkit-transform: rotate(0);\n              transform: rotate(0);\n            }\n          }\n\n          animation: rotateShake var(--vibrate-duration) infinite;\n        ";case i.AnimationType.VISIBLE_WHEN_SCROLL:return e?"":"\n          opacity: 0; \n          visibility: hidden;\n          transition: all 0.3s ease;\n          &.visible-bubble {\n            opacity: 1;\n            visibility: visible;\n          }\n        ";case i.AnimationType.NONE:default:return""}}}
`,h=s.default.p`
  background: rgba(0, 0, 0, 0.85);
  color: #fff;
  padding: 6px 10px;
  border-radius: 5px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  pointer-events: none;
  ${({position:n})=>(n=>{switch(n){case i.ContactBubblePosition.BOTTOM_LEFT:case i.ContactBubblePosition.CENTER_LEFT:return"\n        left: 100%;\n        margin-left: 0.8em;\n      ";case i.ContactBubblePosition.BOTTOM_RIGHT:case i.ContactBubblePosition.CENTER_RIGHT:return"\n        right: 100%;\n        margin-right: 0.8em;\n      ";case i.ContactBubblePosition.BOTTOM_CENTER:return"\n        bottom: 100%;\n        margin-bottom: 0.8em!important;\n        left: 50%;\n        transform: translateX(-50%);\n      ";default:return"\n        left: 100%;\n        margin-left: 0.8em;\n      "}})(n)}
  ${({position:n})=>n===i.ContactBubblePosition.BOTTOM_CENTER&&"\n    top: auto;\n    transform: translateX(-50%);\n  "}
`;exports.BubbleItem=({item:t,position:e,isEditorMode:l,openBubbleSetting:s})=>{var u,c,d,v,b,m,p,C,O;const w=o.useDominantColor(null==(u=null==t?void 0:t.icon)?void 0:u.src),P=null==(c=null==t?void 0:t.event)?void 0:c.tekoTrackingEvent;return t?n.jsxs(E,T(f({position:e,isEditorMode:l,onClick:l?n=>{n.stopPropagation(),null==s||s()}:void 0},!l&&a.getAttrTracking(P)),{children:[(null==t?void 0:t.icon)&&n.jsx(g,{animationType:null==t?void 0:t.animation,padding:(null==t?void 0:t.animation)===i.AnimationType.SPREAD?null==t?void 0:t.animationSpreadPadding:0,vibrateAnimation:null==t?void 0:t.animationVibrateConfig,style:{"--dominant-color":w,"--vibrate-rotate":`${(null==(b=null==t?void 0:t.animationVibrateConfig)?void 0:b.rotate)||30}deg`,"--vibrate-duration":`${(null==(m=null==t?void 0:t.animationVibrateConfig)?void 0:m.duration)||2}s`},isEditorMode:l,children:n.jsx(y,{item:t,children:n.jsx("img",T(f({src:null==(p=t.icon)?void 0:p.src,alt:t.title,height:t.size},(null==(C=t.icon)?void 0:C.src)&&{srcSet:r.buildSrcsetDPR(null==(O=t.icon)?void 0:O.src,{height:t.size})}),{style:{aspectRatio:"auto 1/1"}}))})},`${null==t?void 0:t.animation}-${null==(d=null==t?void 0:t.animationVibrateConfig)?void 0:d.rotate}-${null==(v=null==t?void 0:t.animationVibrateConfig)?void 0:v.duration}`),n.jsx(h,{position:e,style:{"--dominant-color":w},children:null==t?void 0:t.title})]})):null};


/***/ }),

/***/ 532587:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),i=__webpack_require__(930370),o=__webpack_require__(89007);function r(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const n=r(t).default.div`
  display: flex;
  flex-direction: ${({position:e})=>s(e)};
  gap: 1em;
`,s=e=>e===i.ContactBubblePosition.BOTTOM_CENTER?"row":"column";exports.Bubbles=({items:t,position:i,isEditorMode:r,openBubbleSetting:s})=>{const u=t.filter((e=>{var t;return!!(null==(t=null==e?void 0:e.icon)?void 0:t.src)}));return e.jsx(n,{position:i,children:u.map(((t,n)=>e.jsx(o.BubbleItem,{item:t,position:i,isEditorMode:r,openBubbleSetting:s},n)))})};


/***/ }),

/***/ 930370:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var T=(T=>(T.BOTTOM_RIGHT="BOTTOM_RIGHT",T.BOTTOM_LEFT="BOTTOM_LEFT",T.BOTTOM_CENTER="BOTTOM_CENTER",T.CENTER_RIGHT="CENTER_RIGHT",T.CENTER_LEFT="CENTER_LEFT",T))(T||{}),E=(T=>(T.HREF="href",T.POPUP="popup",T.SCROLL_TOP_PAGE="scroll_top_page",T))(E||{}),e=(T=>(T.NONE="none",T.SPREAD="spread",T.FLICKER="flicker",T.VIBRATE="vibrate",T.VISIBLE_WHEN_SCROLL="visible_when_scroll",T))(e||{});exports.AnimationType=e,exports.ContactBubblePosition=T,exports.EventType=E;


/***/ }),

/***/ 88146:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(561261),e=__webpack_require__(212951),n=__webpack_require__(85097),o=__webpack_require__(930370),i=__webpack_require__(532587);function r(t){return t&&"object"==typeof t&&"default"in t?t:{default:t}}var l=r(e);const s=e=>{const{device:r}=n.useStore(),{enable:l,isEditorMode:s,children:a,openBubbleSetting:b}=e;if(!l)return null;const{items:c=[],position:d=o.ContactBubblePosition.BOTTOM_RIGHT,gap:p}=("desktop"===r?null==e?void 0:e.desktop:null==e?void 0:e.mobile)||{};return t.jsxs(u,{position:d,gap:p,"data-testid":"ContactBubble",children:[t.jsx(i.Bubbles,{items:c,position:d,isEditorMode:s,openBubbleSetting:b}),a]})};s.displayName="ContactBubble";const u=l.default.div((({position:t,gap:e})=>`\nposition: fixed;\nz-index: 9999;\n${((t,e)=>{switch(t){case o.ContactBubblePosition.BOTTOM_RIGHT:return`\nbottom: ${(null==e?void 0:e.vertical)||0}px;\nright: ${(null==e?void 0:e.horizontal)||0}px;\n`;case o.ContactBubblePosition.BOTTOM_LEFT:return`\nbottom: ${(null==e?void 0:e.vertical)||0}px;\nleft: ${(null==e?void 0:e.horizontal)||0}px;\n`;case o.ContactBubblePosition.CENTER_LEFT:return`\ntop: 50%;\nleft: ${(null==e?void 0:e.horizontal)||0}px;\ntransform: translateY(-50%);\n`;case o.ContactBubblePosition.CENTER_RIGHT:return`\ntop: 50%;\nright: ${(null==e?void 0:e.horizontal)||0}px;\ntransform: translateY(-50%);\n`;case o.ContactBubblePosition.BOTTOM_CENTER:return`\nbottom: ${(null==e?void 0:e.vertical)||0}px;\nleft: 50%;\ntransform: translateX(-50%);\n`;default:return""}})(t,e)}\n`));exports.ContactBubble=s;


/***/ }),

/***/ 473347:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(891987);exports.useDominantColor=(e,o="#7367f0")=>{const[r,n]=t.useState("#000000");return t.useEffect((()=>{if(!e)return;const t=new Image;t.crossOrigin="anonymous",t.onload=()=>{try{const e=document.createElement("canvas"),r=e.getContext("2d");if(!r)return;const a=e.width=20,c=e.height=20;r.drawImage(t,0,0,a,c);const{data:i}=r.getImageData(0,0,a,c),s=new Map;for(let t=0;t<i.length;t+=4){if(i[t+3]<128)continue;const e=16*Math.floor(i[t]/16),o=16*Math.floor(i[t+1]/16),r=16*Math.floor(i[t+2]/16),n=.299*e+.587*o+.114*r;if(n<30||n>225)continue;const a=`${e},${o},${r}`;s.set(a,(s.get(a)||0)+1)}if(0===s.size)return void n(o);let l="",u=0;s.forEach(((t,e)=>{t>u&&(u=t,l=e)}));const[d,f,g]=l.split(",").map(Number),m=((t,e,o)=>`#${t.toString(16).padStart(2,"0")}${e.toString(16).padStart(2,"0")}${o.toString(16).padStart(2,"0")}`)(d,f,g);n(m)}catch(t){console.error("Error extracting dominant color:",t),n(o)}},t.onerror=()=>{console.error("Failed to load image for color extraction"),n(o)},t.src=e}),[e,o]),r};


/***/ }),

/***/ 728379:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),a=__webpack_require__(85097),t=__webpack_require__(891987),n=__webpack_require__(877084),o=__webpack_require__(672158),i=__webpack_require__(698636);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var u=l(r),c=l(t),s=l(n),d=Object.defineProperty,g=Object.defineProperties,m=Object.getOwnPropertyDescriptors,f=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,y=Object.prototype.propertyIsEnumerable,p=(e,r,a)=>r in e?d(e,r,{enumerable:!0,configurable:!0,writable:!0,value:a}):e[r]=a,v=(e,r)=>{for(var a in r||(r={}))b.call(r,a)&&p(e,a,r[a]);if(f)for(var a of f(r))y.call(r,a)&&p(e,a,r[a]);return e},O=(e,r)=>{var a={};for(var t in e)b.call(e,t)&&r.indexOf(t)<0&&(a[t]=e[t]);if(null!=e&&f)for(var t of f(e))r.indexOf(t)<0&&y.call(e,t)&&(a[t]=e[t]);return a};const I=u.default(o.Container)((({commonStyle:e})=>`\n  width: unset !important;\n  max-width: 100%;\n  ${a.getStyle(e,{lazyBgImage:!0})}\n`)),j=c.default.forwardRef(((r,n)=>{const{featureFlags:o,device:l}=a.useStore(),u=!!(null==o?void 0:o.flagPB3979),c=r,{children:d,className:f}=c,b=O(c,["children","className"]),{commonStyle:y}=a.getPropsByDevice(b,l),p=y,{backgroundImage:j,bgImageWidth:k,backgroundPosition:q,defaultOverlay:S,backgroundMarqueeDirection:P,backgroundMarqueeSpeed:h}=p,x=O(p,["backgroundImage","bgImageWidth","backgroundPosition","defaultOverlay","backgroundMarqueeDirection","backgroundMarqueeSpeed"]),B=t.useRef(),_=n||B,C=a.useIntersectionObserver(_,{freezeOnceVisible:!0}),{style:N,animationClassName:w}=a.useAnimation(null==y?void 0:y.animation,_);return e.jsxs(I,(A=v({ref:_,className:s.default(f,{[a.BG_LAZY_CLASS_NAME]:!0,[a.BG_VISIBLE_LAZY_CLASS_NAME]:C},w)},b),M={commonStyle:u?x:y,style:v(v({},u?{position:"relative"}:{}),N),children:[u&&e.jsx(i.BackgroundImage,{uniqId:r.dataUniqId,styles:{backgroundImage:j,bgImageWidth:k,backgroundPosition:q,defaultOverlay:S}}),d]},g(A,m(M))));var A,M}));j.displayName=o.Container.displayName,exports.PbContainer=j;


/***/ }),

/***/ 553884:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(534388),t=__webpack_require__(115741),i=Object.defineProperty,o=Object.defineProperties,l=Object.getOwnPropertyDescriptors,n=Object.getOwnPropertySymbols,s=Object.prototype.hasOwnProperty,c=Object.prototype.propertyIsEnumerable,p=(e,r,t)=>r in e?i(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;const a=i=>{return e.jsx(t.DSSlider,(a=((e,r)=>{for(var t in r||(r={}))s.call(r,t)&&p(e,t,r[t]);if(n)for(var t of n(r))c.call(r,t)&&p(e,t,r[t]);return e})({},r.convertOptionSliderV2ToV1(i)),d={children:i.children},o(a,l(d))));var a,d};a.displayName="ContentSlider",exports.ContentSlider=a;


/***/ }),

/***/ 155502:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097),n=__webpack_require__(891987);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=o(t);const l=o(n).default.forwardRef((({children:t,commonStyle:r},n)=>e.jsx(d,{commonStyle:r,ref:n,children:t}))),d=i.default.div((({commonStyle:e})=>`\n    ${r.getStyle(e)}\n  `));l.displayName="ContentSliderItem",exports.ContentSliderItem=l;


/***/ }),

/***/ 334489:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),l=__webpack_require__(85097),n=__webpack_require__(891987),i=__webpack_require__(327844);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var r=a(t),s=Object.defineProperty,o=Object.defineProperties,d=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,y=Object.prototype.propertyIsEnumerable,b=(e,t,l)=>t in e?s(e,t,{enumerable:!0,configurable:!0,writable:!0,value:l}):e[t]=l,p=(e,t)=>{for(var l in t||(t={}))c.call(t,l)&&b(e,l,t[l]);if(u)for(var l of u(t))y.call(t,l)&&b(e,l,t[l]);return e};const m=e=>{if(/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}$/.test(e)){const t=parseInt(e.substring(0,2)),l=parseInt(e.substring(3,5)),n=parseInt(e.substring(6,10)),i=parseInt(e.substring(11,13)),a=parseInt(e.substring(14,16));return new Date(n,l-1,t,i,a).toISOString()}return e},f=n.forwardRef(((t,a)=>{var r=t,{due:s,showDays:b=!0,showHours:f=!0,showMinutes:w=!0,showSeconds:v=!0,showLabel:P=!1,labelDays:D,labelHours:O,labelMinutes:$,labelSeconds:I,splitTimeUnit:N,className:U,id:G}=r,z=((e,t)=>{var l={};for(var n in e)c.call(e,n)&&t.indexOf(n)<0&&(l[n]=e[n]);if(null!=e&&u)for(var n of u(e))t.indexOf(n)<0&&y.call(e,n)&&(l[n]=e[n]);return l})(r,["due","showDays","showHours","showMinutes","showSeconds","showLabel","labelDays","labelHours","labelMinutes","labelSeconds","splitTimeUnit","className","id"]);const{device:q}=l.useStore(),M=l.getPropsByDevice(z,q),{countdownStyle:H,commonStyle:T}=M,{elementGap:F,labelGap:B,digitStyle:C,labelStyle:E,timeUnitStyle:L,layout:_,labelPosition:k,align:R}=H||{},A=m(s),J=new Date(A),[K,Q]=n.useState(l.calculateTimeDelta(new Date,J));return n.useEffect((()=>{const e=setInterval((()=>{Q(l.calculateTimeDelta(new Date,J))}),1e3);return()=>{clearInterval(e)}}),[A]),"Invalid Date"===J.toString()?null:e.jsx(x,{ref:a,id:G,"data-id":G,align:R,className:U,children:e.jsxs(S,{commonStyle:(V=p({},T),W={gap:F},o(V,d(W))),layout:_,children:[b&&e.jsxs(e.Fragment,{children:[e.jsxs(j,{layout:_,labelPosition:k,labelGap:B,timeUnitStyle:L,children:[e.jsx(g,{digitStyle:C,children:i.addPaddingNumber(K.days)}),P&&e.jsx(h,{labelStyle:E,children:D})]}),!!N&&N]}),f&&e.jsxs(e.Fragment,{children:[e.jsxs(j,{layout:_,labelPosition:k,labelGap:B,timeUnitStyle:L,children:[e.jsx(g,{digitStyle:C,children:i.addPaddingNumber(K.hours)}),P&&e.jsx(h,{labelStyle:E,children:O})]}),!!N&&N]}),w&&e.jsxs(e.Fragment,{children:[e.jsxs(j,{layout:_,labelPosition:k,labelGap:B,timeUnitStyle:L,children:[e.jsx(g,{digitStyle:C,children:i.addPaddingNumber(K.minutes)}),P&&e.jsx(h,{labelStyle:E,children:$})]}),!!N&&N]}),v&&e.jsxs(j,{layout:_,labelPosition:k,labelGap:B,timeUnitStyle:L,children:[e.jsx(g,{digitStyle:C,children:i.addPaddingNumber(K.seconds)}),P&&e.jsx(h,{labelStyle:E,children:I})]})]})});var V,W})),x=r.default.div((({align:e})=>`\n  display: flex;\n  justify-content: ${e}};\n`)),S=r.default.div((({commonStyle:e,layout:t})=>`\n  ${l.getStyle(e)};\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  min-width: ${"horizontal"===t?"80px":"50px"};\n`)),g=r.default.div((({digitStyle:e})=>`\n  ${l.getStyle(e)}\n  @media only screen and (max-width: 480px){\n    font-size: min(${null==e?void 0:e.fontSize}px, 30px);\n  }\n`)),h=r.default.div((({labelStyle:e})=>`\n  ${l.getStyle(e)}\n  @media only screen and (max-width: 480px){\n    font-size: min(${null==e?void 0:e.fontSize}px, 30px);\n  }\n`)),j=r.default.div((({layout:e,labelPosition:t,labelGap:n,timeUnitStyle:i})=>`\n  ${l.getStyle(i)}\n  display: flex;\n  ${n?`gap: ${n}px;`:""}\n  ${"horizontal"===e?`align-items: ${t};`:"flex-direction: column;"};\n`));f.displayName="Countdown",exports.Countdown=f,exports.getISODateBackward=m;


/***/ }),

/***/ 282384:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=(e=>(e.solid="solid",e.double="double",e.dotted="dotted",e.dashed="dashed",e))(e||{}),d=(e=>(e.text="text",e.icon="icon",e))(d||{});exports.DividerStyleEnum=e,exports.DividerTypeEnum=d;


/***/ }),

/***/ 799407:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),i=__webpack_require__(212951),t=__webpack_require__(143599),r=__webpack_require__(85097),n=__webpack_require__(282384),o=__webpack_require__(282004),l=__webpack_require__(41259),s=__webpack_require__(534479),c=__webpack_require__(628912);function u(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=u(i),d=Object.defineProperty,p=Object.defineProperties,g=Object.getOwnPropertyDescriptors,v=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,f=(e,i,t)=>i in e?d(e,i,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[i]=t,h=(e,i)=>{for(var t in i||(i={}))y.call(i,t)&&f(e,t,i[t]);if(v)for(var t of v(i))m.call(i,t)&&f(e,t,i[t]);return e},j=(e,i)=>p(e,g(i)),x=(e,i)=>{var t={};for(var r in e)y.call(e,r)&&i.indexOf(r)<0&&(t[r]=e[r]);if(null!=e&&v)for(var r of v(e))i.indexOf(r)<0&&m.call(e,r)&&(t[r]=e[r]);return t};const S=i=>{var s=i,{gap:u,weight:a,style:d,type:p,customText:g}=s,v=x(s,["gap","weight","style","type","customText"]);const{device:y}=r.useStore(),{commonStyle:m,align:f,textConfig:S,iconConfig:D}=r.getPropsByDevice(v,y),O=m||{},{width:P,color:w}=O,q=x(O,["width","color"]);return e.jsx(b,j(h({},v),{commonStyle:q,children:p?e.jsxs(o.Divider,j(h({},v),{width:r.unitParse(P),height:l.getSizeWithUnit(a),color:w,dividerStyle:d,align:f,gap:l.getSizeWithUnit(u),alignContent:p===n.DividerTypeEnum.text?null==S?void 0:S.align:null==D?void 0:D.align,spacingContent:p===n.DividerTypeEnum.text?l.getSizeWithUnit(null==S?void 0:S.spacing):l.getSizeWithUnit(null==D?void 0:D.spacing),children:[p===n.DividerTypeEnum.text&&(g||e.jsx("span",{dangerouslySetInnerHTML:{__html:null==S?void 0:S.text}})),p===n.DividerTypeEnum.icon&&e.jsx(t.Icon,h({},h({name:null==(z=null==D?void 0:D.icon)?void 0:z.name},c.getPropsIcon({color:null==(T=D.icon)?void 0:T.color,size:null==(U=D.icon)?void 0:U.size}))))]})):e.jsx(o.Divider,{width:r.unitParse(P),height:l.getSizeWithUnit(a),color:w,dividerStyle:d,align:f,gap:l.getSizeWithUnit(u)})}));var z,T,U},b=a.default.div((({commonStyle:e})=>`\n  ${r.getStyle(e)}\n  ${s.getCommonTextCss(!0)}\n`));S.displayName="Divider",exports.PbDivider=S;


/***/ }),

/***/ 319058:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097),n=__webpack_require__(800656),i=__webpack_require__(585514);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=o(t),a=Object.defineProperty,l=Object.defineProperties,c=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,u=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,p=(e,t,r)=>t in e?a(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,m=(e,t)=>{for(var r in t||(t={}))u.call(t,r)&&p(e,r,t[r]);if(d)for(var r of d(t))f.call(t,r)&&p(e,r,t[r]);return e};const h=new Set([r.DOCUMENT_TYPE.Pdf,r.DOCUMENT_TYPE.Doc,r.DOCUMENT_TYPE.Docx,r.DOCUMENT_TYPE.Xlsx,r.DOCUMENT_TYPE.Zip]),g=t=>{var o=t,{documentUrl:s,isEditingMode:a,id:p}=o,g=((e,t)=>{var r={};for(var n in e)u.call(e,n)&&t.indexOf(n)<0&&(r[n]=e[n]);if(null!=e&&d)for(var n of d(e))t.indexOf(n)<0&&f.call(e,n)&&(r[n]=e[n]);return r})(o,["documentUrl","isEditingMode","id"]);const{device:y}=r.useStore(),{commonStyle:x}=r.getPropsByDevice(g,y),{calculatedHeight:O}=i.useIgnoreElementTotalHeight({height:null==x?void 0:x.height}),T=g.pdfUrl||s,b=(e=>{if(e)try{const t=e.toLowerCase().match(/\.([^./?#]+)(?:[?#]|$)/),r=null==t?void 0:t[1];return r&&h.has(r)?r:void 0}catch(e){return}})(T);return e.jsx(E,{id:p,"data-id":p,commonStyle:(j=m({},x),D={height:O},l(j,c(D))),isEditingMode:a,children:(()=>{switch(b){case r.DOCUMENT_TYPE.Pdf:return e.jsxs(e.Fragment,{children:[e.jsx(v,{srcIframe:T,docUrl:T,className:"iframe-pdf"}),e.jsx(v,{className:"iframe-pdf-ios",srcIframe:`https://docs.google.com/viewer?url=${T}&embedded=true`,docUrl:T})]});case r.DOCUMENT_TYPE.Doc:case r.DOCUMENT_TYPE.Docx:case r.DOCUMENT_TYPE.Xlsx:return e.jsx(v,{srcIframe:`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURI(T)}`,docUrl:T});default:return e.jsx(w,{children:a?n.t("document_viewer.please_configure_file"):n.t("document_viewer.file_not_found")})}})()});var j,D},v=({docUrl:t,className:r,srcIframe:n})=>e.jsxs("iframe",{className:r,src:n,width:"100%",height:"100%",title:"pdf-viewer",children:["The browser is not supported, please download to view the file",e.jsx("a",{href:t,children:"Download file"}),"."]});g.displayName="DocumentViewer";const E=s.default.div((({commonStyle:e,isEditingMode:t})=>`\n  position: relative;\n  max-width: 100%;\n  ${t?"&:after {\n      content: '';\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      top: 0;\n      left: 0;\n    }":""}\n  .iframe-pdf, .iframe-pdf-ios {\n    display: none;\n  }\n\n  @supports (-webkit-touch-callout: none) {\n    .iframe-pdf-ios {\n      display: unset !important;\n    }\n  }\n\n  @supports not (-webkit-touch-callout: none) {\n    .iframe-pdf {\n      display: unset !important;\n    }\n  }\n  ${r.getStyle(e)};\n`)),w=s.default.div`
  min-height: 100px;
  height: 100%;
  width: 100%;
  background: #ddd;
  display: flex;
  justify-content: center;
  align-items: center;
`;exports.DocumentViewer=g;


/***/ }),

/***/ 927444:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.DEFAULT_INPUTS=[{type:"text",label:"Số báo danh",name:"id",commonStyle:{width:"100%"},required:!0},{type:"tel",label:"Số điện thoại",name:"phoneNumber",commonStyle:{width:"100%"},required:!0},{type:"text",label:"Họ và tên",name:"name",commonStyle:{width:"100%"},required:!1},{type:"number",label:"Mã giảm giá",name:"campaignId",commonStyle:{width:"100%"},required:!1}];


/***/ }),

/***/ 934272:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=Object.getOwnPropertySymbols,r=Object.prototype.hasOwnProperty,t=Object.prototype.propertyIsEnumerable;const o=o=>{const n=((o,n)=>{var c={};for(var s in o)r.call(o,s)&&n.indexOf(s)<0&&(c[s]=o[s]);if(null!=o&&e)for(var s of e(o))n.indexOf(s)<0&&t.call(o,s)&&(c[s]=o[s]);return c})(o,["sbd"]),c=Object.values(n).reduce(((e,r)=>e+Number(r||0)),0),s=Object.values(n).filter((e=>e)).length||6;return Math.round(10*c/s)/10};exports.getAverageScore=o,exports.getVoucherByAverageScore=(e,r)=>{const t=Object.keys(r);if(!t.length)return;const n=[...t].sort(((e,r)=>Number(r)-Number(e))),c=o(e);let s=-1;for(const e of n)if(c>=Number(e)){s=r[e];break}return s};


/***/ }),

/***/ 229441:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(891987),n=__webpack_require__(85097),o=__webpack_require__(212951),i=__webpack_require__(673100),t=__webpack_require__(162952),a=__webpack_require__(426927),d=__webpack_require__(927444),s=__webpack_require__(934272),l=__webpack_require__(832864),c=__webpack_require__(750911);function u(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var h=u(o),p=Object.defineProperty,m=Object.defineProperties,f=Object.getOwnPropertyDescriptors,g=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,v=Object.prototype.propertyIsEnumerable,x=(e,r,n)=>r in e?p(e,r,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[r]=n,j=(e,r)=>{for(var n in r||(r={}))b.call(r,n)&&x(e,n,r[n]);if(g)for(var n of g(r))v.call(r,n)&&x(e,n,r[n]);return e};const y=o=>{var u,h;const{id:p,configStorage:g,device:b,voucherByAverageScoreConfig:v,children:x}=o,[y,O]=r.useState(!1),[F,A]=r.useState(""),P=r.useRef(),{register:k,formState:{errors:E},handleSubmit:I,setError:L}=a.useForm(),{env:T="dev"}=n.useStore(),{getFormSession:V}=t.useLeadForm(),{handleSubmitFormData:B}=i.useForm({wrapperRef:P,response:o.response}),D=new n.Api(n.publicBffUrl[T]),R=new n.Api(n.consumerBffUrl[T]);return e.jsxs("div",{ref:P,children:[y?e.jsx(l.Loading,{}):e.jsx(e.Fragment,{children:e.jsxs(N,{onSubmit:I((async e=>{var r,n,o,i;try{A(""),O(!0);const t=await(async e=>{var r;const n=await D.get("/v1/exam-score?id="+e);return null==(r=null==n?void 0:n.data)?void 0:r.data})(e.id);if(t&&(!(null==(r=null==t?void 0:t.student)?void 0:r.sbd)||["null","undefined"].includes(null==(n=null==t?void 0:t.student)?void 0:n.sbd)))return L("id",{type:"manual",message:"Số báo danh không hợp lệ"});const a=await(async e=>{var r;const n=await R.get("/api/v1/candidate/related-info?candidateNumber="+e);return null==(r=null==n?void 0:n.data)?void 0:r.data})(e.id);if(null==a?void 0:a.appliedOrderId)return A("Số báo danh của bạn đã có đơn hàng hưởng ưu đãi của chương trình");const l=s.getVoucherByAverageScore(t.student,v),c=await V();await B(g,(o=j({},e),i={campaignId:l,formSession:c,formId:p,formName:p,href:window.location.href,domainName:window.location.origin,terminal:b},m(o,f(i))),d.DEFAULT_INPUTS)}catch(e){console.error(e)}finally{O(!1)}})),children:[e.jsxs("div",{style:{width:"100%"},children:[e.jsxs(w,{children:[e.jsx("span",{style:{color:"red"},children:"*"})," Nhập số báo danh"]}),e.jsx(q,j({placeholder:"Nhập số báo danh"},k("id",{required:"Vui lòng nhập số báo danh",pattern:{value:/^\d{8}$/,message:"Số báo danh phải có 8 chữ số"}}))),E.id&&e.jsx(S,{children:e.jsx(e.Fragment,{children:null==(u=E.id)?void 0:u.message})})]}),e.jsxs("div",{style:{width:"100%"},children:[e.jsxs(w,{children:[e.jsx("span",{style:{color:"red"},children:"*"})," Nhập số điện thoại"]}),e.jsx(q,j({placeholder:"Nhập số điện thoại"},k("phoneNumber",{required:"Vui lòng nhập số điện thoại",pattern:{value:n.PATTERN_VALIDATION.phone,message:"Vui lòng nhập đúng định dạng"}}))),E.phoneNumber&&e.jsx(S,{children:e.jsx(e.Fragment,{children:null==(h=E.phoneNumber)?void 0:h.message})})]}),e.jsxs("div",{style:{width:"100%"},children:[e.jsx(w,{children:"Họ và tên"}),e.jsx(q,j({placeholder:"Nhập họ và tên của bạn"},k("name")))]}),!!F&&e.jsx("div",{style:{marginTop:"0.25em"},children:e.jsx("span",{style:{color:"red"},children:F})}),e.jsx("div",{children:e.jsx(c.ButtonV2,{text:"Gán mã",loading:y,style:{color:"#fff",backgroundColor:"#7367F0",borderRadius:6,padding:"4px 15px"},commonStyle:{width:150,height:38}})})]})}),r.Children.map(x,(e=>r.cloneElement(e)))]})};y.displayName="ExamScoreSales";const w=h.default.div`
  margin-bottom: 1em;
`,S=h.default.div`
  color: red;
  margin-top: 0.5em;
`,N=h.default.form`
  display: flex;
  flex-direction: column;
  gap: 1em;
  width: 100%;
`,q=h.default.input`
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  background-color: white;

  &:focus {
    border-color: #007bff;
    background-color: #fff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
`;exports.ExamScoreSales=y;


/***/ }),

/***/ 494252:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),o=__webpack_require__(85097),n=__webpack_require__(891987),t=__webpack_require__(426927),a=__webpack_require__(832864),i=__webpack_require__(750911);function d(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=d(r),s=Object.defineProperty,c=Object.getOwnPropertySymbols,u=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,h=(e,r,o)=>r in e?s(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,p=(e,r)=>{for(var o in r||(r={}))u.call(r,o)&&h(e,o,r[o]);if(c)for(var o of c(r))m.call(r,o)&&h(e,o,r[o]);return e};const g=({textColor:r="#000",boldColor:d="#000",buttonColor:l="#7367F0",buttonTextColor:s="#fff",tableBorderColor:c="#000"})=>{var u;const[m,h]=n.useState(!1),[g,y]=n.useState(null),[S,w]=n.useState(""),{register:C,formState:{errors:q},handleSubmit:L,setError:N}=t.useForm(),{env:O="dev"}=o.useStore(),k=new o.Api(o.publicBffUrl[O]),F=new o.Api(o.consumerBffUrl[O]),B=e=>e>=9?3e6:e>=8?7e5:e>=7?6e5:e>=6?5e5:e>=5?4e5:3e5;return e.jsx("div",{style:{color:r},children:g?(r=>{const{toan:o,van:n,ngoaiNgu:t,lichSu:i,diaLy:l,gdcd:s,vatLy:u,hoaHoc:h,sinhHoc:p,giaoDucKinhTePhapLuat:g,tin:b}=r,x=[{name:"Toán",score:o},{name:"Ngữ văn",score:n},{name:"Ngoại ngữ",score:t},{name:"Lịch sử",score:i},{name:"Địa lý",score:l},{name:"GDCD",score:s},{name:"Vật lý",score:u},{name:"Hóa học",score:h},{name:"Sinh học",score:p},{name:"Giáo dục kinh tế pháp luật",score:g},{name:"Tin học",score:b}],f=x.reduce(((e,r)=>e+Number(r.score||0)),0),v=x.filter((e=>e.score)).length||6,y=Math.round(10*f/v)/10;return m?e.jsx(a.Loading,{}):e.jsxs(e.Fragment,{children:[e.jsxs("div",{style:{marginBottom:"1em"},children:["Điểm trung bình môn của bạn:"," ",e.jsxs("strong",{style:{fontSize:"1.2em",color:d},children:[" ",y.toFixed(1)]})]}),e.jsx(j,{borderColor:c,children:x.map(((r,o)=>r.score?e.jsxs("li",{children:[r.name,":",e.jsx("br",{}),r.score]},o):null))}),e.jsxs("div",{children:["Khuyến mãi giảm thêm của bạn:"," ",e.jsxs("strong",{style:{fontSize:"1.2em",color:d},children:[B(y).toLocaleString().replace(/,/g,"."),"đ"]})]}),!!S&&e.jsx("div",{style:{marginTop:"1em"},children:e.jsx("strong",{style:{color:"red"},children:S})})]})})(g):e.jsxs(e.Fragment,{children:[e.jsx(b,{children:"Nhập số báo danh"}),e.jsxs(f,{onSubmit:L((async({id:e})=>{var r,o;h(!0);try{const n=await k.get("/v1/exam-score?id="+e);if(n.data){const e=null==(r=null==n?void 0:n.data)?void 0:r.data;(null==(o=null==e?void 0:e.student)?void 0:o.sbd)?y(e.student):N("id",{type:"manual",message:"Số báo danh không hợp lệ"})}const t=await(async e=>{var r;const o=await F.get("/api/v1/candidate/related-info?candidateNumber="+e);return null==(r=null==o?void 0:o.data)?void 0:r.data})(e);w((null==t?void 0:t.appliedOrderId)?"Số báo danh của bạn đã có đơn hàng hưởng ưu đãi của chương trình":"")}catch(e){console.error(e)}h(!1)})),children:[e.jsxs("div",{style:{width:"100%"},children:[e.jsx(v,p({placeholder:"Nhập số báo danh của bạn"},C("id",{required:"Vui lòng nhập số báo danh",pattern:{value:/^\d{8}$/,message:"Số báo danh phải có 8 chữ số"}}))),q.id&&e.jsx(x,{children:e.jsx(e.Fragment,{children:null==(u=q.id)?void 0:u.message})})]}),e.jsx("div",{children:e.jsx(i.ButtonV2,{text:"Kiểm tra",loading:m,style:{color:s,backgroundColor:l,borderRadius:6,padding:"4px 15px"},commonStyle:{width:150,height:38}})})]})]})})};g.displayName="ExamScore";const b=l.default.div`
  margin-bottom: 1em;
`,x=l.default.div`
  color: red;
  margin-top: 0.5em;
`,f=l.default.form`
  display: flex;
  gap: 1em;
  width: 100%;
`,v=l.default.input`
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  background-color: white;

  &:focus {
    border-color: #007bff;
    background-color: #fff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
`,j=l.default.ul((({borderColor:e="#000"})=>`\nlist-style: none;\nwidth: 100%;\ndisplay: grid !important;\ngrid-auto-rows: minmax(min-content, max-content);\ngrid-template-columns: repeat(6, minmax(0, 1fr));\nborder: 1px solid ${e};\nfont-size: 14px;\nmargin-bottom: 1em;\n\nli {\n  padding: 0.5em;\n  border: 1px solid ${e};\n}\n`));exports.ExamScore=g;


/***/ }),

/***/ 409541:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097),t=__webpack_require__(800656),a=__webpack_require__(224471),n=Object.defineProperty,o=Object.defineProperties,r=Object.getOwnPropertyDescriptors,l=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,g=(e,t,a)=>t in e?n(e,t,{enumerable:!0,configurable:!0,writable:!0,value:a}):e[t]=a,b=(e,t)=>{for(var a in t||(t={}))i.call(t,a)&&g(e,a,t[a]);if(l)for(var a of l(t))p.call(t,a)&&g(e,a,t[a]);return e},c=(e,t)=>o(e,r(t));const s=[{label:t.t("expanded"),value:a.ExpandContentDisplayType.EXPAND},{label:t.t("collapsed"),value:a.ExpandContentDisplayType.COLLAPSE}],h={expandableContent:{contentStyle:{padding:{top:0,right:0,bottom:0,left:0}},contentAlign:e.Alignment.left,defaultDisplay:a.ExpandContentDisplayType.COLLAPSE,buttonStyle:{color:"#1E90FF",hover:{color:"#1E90FF"},fontSize:14,fontWeight:"400"},button:{align:e.Alignment.center,collapseText:t.t("view_less"),expandText:t.t("view_more"),showIcon:!0,spacingWithContent:8,textLevel:"p"},duration:.3,commonStyle:{width:100,widthUnit:e.UnitEnum.percent},itemSpacing:10,iconStyle:{fontSize:14}},expandableContentBlock:{}},m={expandableContent:c(b({},h.expandableContent),{buttonStyle:c(b({},h.expandableContent.buttonStyle),{currentParagraphTheme:"paragraph1",fontFamily:"var(--tempi-global-paragraph1fontfamily)"}),desktop:{buttonStyle:{fontSize:"var(--tempi-global-paragraph1fontsize)",fontWeight:"var(--tempi-global-paragraph1fontweight)",lineHeight:"var(--tempi-global-paragraph1lineheight)",letterSpacing:"var(--tempi-global-paragraph1letterspacing)"},iconStyle:{fontSize:14}},mobile:{buttonStyle:{fontSize:"var(--tempi-global-paragraph1mobilefontsize)",fontWeight:"var(--tempi-global-paragraph1mobilefontweight)",lineHeight:"var(--tempi-global-paragraph1mobilelineheight)",letterSpacing:"var(--tempi-global-paragraph1mobileletterspacing)"},iconStyle:{fontSize:14}}}),expandableContentBlock:{}};exports.DEFAULT_DISPLAY_TYPE_OPTIONS=s,exports.DEFAULT_EXPANDABLE_CONTENT=h,exports.DEFAULT_EXPANDABLE_CONTENT_THEME=m,exports.DEFAULT_FONT_SIZE=14;


/***/ }),

/***/ 468901:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.getComplementaryRGBA=e=>{var r;if(!e)return"#000";const l=null==(r=null==e?void 0:e.replace(/rgba?\(|\)/g,""))?void 0:r.split(","),t=parseInt(null==l?void 0:l[0]),n=parseInt(null==l?void 0:l[1]),o=parseInt(null==l?void 0:l[2]);return!t&&0!==t||!n&&0!==n||!o&&0!==o?"#000":`rgb(${255-t}, ${255-n}, ${255-o})`};


/***/ }),

/***/ 224471:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=(e=>(e.DEFAULT_BLOCK="default-block",e.EXPAND_BLOCK="expand-block",e))(e||{}),p=(e=>(e.EXPAND="expand",e.COLLAPSE="collapse",e))(p||{});exports.ExpandContentDisplayType=p,exports.ExpandableContentBlockType=e;


/***/ }),

/***/ 569208:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(212951),t=__webpack_require__(85097),r=__webpack_require__(891987),i=__webpack_require__(224471),o=__webpack_require__(409541),l=__webpack_require__(468901),a=__webpack_require__(927322);function c(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=c(n),s=Object.defineProperty,p=Object.defineProperties,u=Object.getOwnPropertyDescriptors,f=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,g=(e,n,t)=>n in e?s(e,n,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[n]=t,x=(e,n)=>{var t={};for(var r in e)y.call(e,r)&&n.indexOf(r)<0&&(t[r]=e[r]);if(null!=e&&f)for(var r of f(e))n.indexOf(r)<0&&m.call(e,r)&&(t[r]=e[r]);return t};const b=r.forwardRef(((n,l)=>{var c=n,{isEditorMode:d,children:s,defaultDisplay:b}=c,h=x(c,["isEditorMode","children","defaultDisplay"]);const[j,_]=r.useState(b===i.ExpandContentDisplayType.EXPAND),{device:O}=t.useStore(),{buttonStyle:$,button:A,commonStyle:E,itemSpacing:w,iconStyle:P,contentAlign:k}=t.getPropsByDevice(h,O),{fontSize:q}=P||{},D=$,{fontSize:C}=D,T=x(D,["fontSize"]),z="number"==typeof C?`${C}px`:C,{align:I,spacingWithContent:M,showIcon:N,expandText:L,collapseText:R,textLevel:B="p"}=A;return e.jsxs(S,(F=((e,n)=>{for(var t in n||(n={}))y.call(n,t)&&g(e,t,n[t]);if(f)for(var t of f(n))m.call(n,t)&&g(e,t,n[t]);return e})({},h),H={isEditorMode:d,className:j||d?"expanded":"collapsed",commonStyle:E,itemSpacing:w,contentAlign:k,ref:l,children:[s,e.jsx("div",{style:{display:"flex",justifyContent:(()=>{let e="flex-start";return I===t.Alignment.center&&(e="center"),I===t.Alignment.right&&(e="flex-end"),e})(),marginTop:M||4},children:e.jsxs(v,{onClick:d?null:()=>_((e=>!e)),commonStyle:T,children:[e.jsx("div",{style:{marginRight:5,lineHeight:"normal"},dangerouslySetInnerHTML:{__html:`<${B} style="font-size:${z}">${(j||d?R:L)||""}</${B}>`}}),N&&e.jsx(a.PbIcon,{name:j||d?"UpOutlined":"DownOutlined",size:+q||+$.fontSize||o.DEFAULT_FONT_SIZE})]})})]},p(F,u(H))));var F,H}));b.displayName="ExpandableContent";const S=d.default.div((({commonStyle:e,contentStyle:n,contentAlign:r,duration:i,itemSpacing:o})=>{const a="number"==typeof i?`transition: all ${i}s;`:"";return`\n    ${t.getStyle(e)};\n    max-width: 100%;\n\n    .expandable__content__block {\n      display: flex;\n      flex-direction: column;\n      ${t.getStyle(n)}\n      ${(()=>{if(!r)return"";let e="stretch";return r===t.Alignment.center&&(e="center"),r===t.Alignment.right&&(e="flex-end"),`align-items: ${e};`})()}\n    }\n\n    .expand__block {\n      ${a}\n    }\n\n    .block__divider {\n      border-color: ${l.getComplementaryRGBA(e.background)};\n    }\n\n    &.expanded .block_spacing {\n      padding: ${o/2}px 0;\n    }\n\n    &.collapsed .expand__block {\n      padding-top: 0 !important;\n      padding-bottom: 0 !important;\n      height: 0;\n      opacity: 0;\n      pointer-events: none;\n      overflow: hidden;\n    }\n\n    &.expanded .expand__block {\n      opacity: 1;\n    }\n  `})),v=d.default.div((({commonStyle:e})=>`\n  display: flex;\n  cursor: pointer;\n  align-items: center;\n  ${t.getStyle(e)}\n`));exports.ExpandableContent=b;


/***/ }),

/***/ 680284:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(85097),o=__webpack_require__(224471),a=__webpack_require__(891987);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=n(r),c=n(a),i=Object.defineProperty,d=Object.defineProperties,s=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,u=(e,r,t)=>r in e?i(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,y=(e,r)=>{for(var t in r||(r={}))b.call(r,t)&&u(e,t,r[t]);if(p)for(var t of p(r))f.call(r,t)&&u(e,t,r[t]);return e};const x=c.default.forwardRef(((r,t)=>{var a,n,l=r,{isEditorMode:c,blockType:i}=l,u=((e,r)=>{var t={};for(var o in e)b.call(e,o)&&r.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&p)for(var o of p(e))r.indexOf(o)<0&&f.call(e,o)&&(t[o]=e[o]);return t})(l,["isEditorMode","blockType"]);return e.jsxs(e.Fragment,{children:[e.jsx(_,(a=y({ref:t},u),n={className:"expandable__content__block "+(i===o.ExpandableContentBlockType.EXPAND_BLOCK?"expand__block":"default__block")},d(a,s(n)))),i===o.ExpandableContentBlockType.DEFAULT_BLOCK&&e.jsx("div",{className:"block_spacing",children:c&&e.jsx(j,{className:"block__divider"})})]})}));x.displayName="ExpandableContentBlock";const _=l.default.div((({commonStyle:e})=>`\n${t.getStyle(e)}\n`)),j=l.default.div`
  border: 1px dashed;
`;exports.ExpandableContentBlock=x;


/***/ }),

/***/ 533657:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),o=__webpack_require__(85097),i=__webpack_require__(891987),r=__webpack_require__(409245);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=n(t),d=Object.getOwnPropertySymbols,m=Object.prototype.hasOwnProperty,s=Object.prototype.propertyIsEnumerable;const l=i.forwardRef(((t,n)=>{var a;const l=t,{numberOfComments:p,isEditorMode:b,id:y}=l,v=((e,t)=>{var o={};for(var i in e)m.call(e,i)&&t.indexOf(i)<0&&(o[i]=e[i]);if(null!=e&&d)for(var i of d(e))t.indexOf(i)<0&&s.call(e,i)&&(o[i]=e[i]);return o})(l,["numberOfComments","isEditorMode","id"]),{device:g,globalData:j}=o.useStore(),{commonStyle:h,alignment:w}=o.getPropsByDevice(v,g),x=null==(a=null==j?void 0:j.page)?void 0:a.id,O=i.useMemo((()=>x?`https://tempi.vn/page/${x}/comments`:""),[x]);return i.useEffect((()=>{O&&r.initFacebookEmbed()}),[O,p]),e.jsx(f,{ref:n,alignment:w,"data-id":y,children:e.jsx(u,{commonStyle:h,isEditorMode:b,children:e.jsx(c,{className:"fb-comments","data-href":O,"data-width":"100%","data-numposts":p},`${O}-${p}`)})})}));l.displayName="FacebookComment";const f=a.default.div((({alignment:e})=>`\n  display: flex;\n  justify-content: ${e||"left"};\n  width: 100%;\n`)),u=a.default.div((({commonStyle:e,isEditorMode:t})=>`\n  pointer-events: ${t?"none":"auto"};\n  ${o.getStyle(e)}\n  min-width: 220px;\n  `)),c=a.default.div`
  .fb_iframe_widget_lift {
    width: 100% !important;
  }

  .fb_iframe_widget_fluid_desktop {
    width: 100% !important;
  }
`;exports.FacebookComment=l;


/***/ }),

/***/ 961804:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097),o=__webpack_require__(891987),n=__webpack_require__(409245);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=a(t),l=Object.getOwnPropertySymbols,s=Object.prototype.hasOwnProperty,c=Object.prototype.propertyIsEnumerable;const u=o.forwardRef(((t,a)=>{const i=t,{sharePage:u,customShareUrl:f,isEditorMode:v,id:h}=i,p=((e,t)=>{var r={};for(var o in e)s.call(e,o)&&t.indexOf(o)<0&&(r[o]=e[o]);if(null!=e&&l)for(var o of l(e))t.indexOf(o)<0&&c.call(e,o)&&(r[o]=e[o]);return r})(i,["sharePage","customShareUrl","isEditorMode","id"]),{globalData:y,device:b}=r.useStore(),{commonStyle:g,alignment:w}=r.getPropsByDevice(p,b),{page:S,isPreviewMode:P}=y||{};let j=(null==S?void 0:S.canonical)||"";const $=null==S?void 0:S.slug;j.endsWith(`/${$}`)&&(j=j.slice(0,j.length-$.length-1));const x=j.replace(/\/$/,""),O=o.useMemo((()=>{var e,t;switch(u){case"currentPage":return x&&$?`${x}/${$}`:`${null==(e=null==window?void 0:window.location)?void 0:e.href}/${$}`;case"homePage":return x?`${x}`:null==(t=null==window?void 0:window.location)?void 0:t.href;case"custom":return f||"https://tempi.vn";default:return""}}),[u,$,x,f]);return o.useEffect((()=>{n.initFacebookEmbed()}),[O]),e.jsx(d,{ref:a,alignment:w,commonStyle:g,"data-id":h,children:e.jsx(m,{isActiveShare:v||P&&("currentPage"===u||"homePage"===u)&&!x||"custom"===u&&!f,className:"fb-share-button","data-href":O,"data-layout":"button_count","data-size":"small"})})}));u.displayName="FacebookShare";const d=i.default.div((({alignment:e,commonStyle:t})=>`\n  display: flex;\n  justify-content: ${e||"left"};\n  ${r.getStyle(t)}\n`)),m=i.default.div((({isActiveShare:e})=>`\n  pointer-events: ${e?"none":"auto"};\n`));exports.FacebookShare=u;


/***/ }),

/***/ 815563:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),l=__webpack_require__(85097);function r(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var n=r(t),i=Object.defineProperty,o=Object.defineProperties,a=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,y=(e,t,l)=>t in e?i(e,t,{enumerable:!0,configurable:!0,writable:!0,value:l}):e[t]=l,d=(e,t)=>{for(var l in t||(t={}))p.call(t,l)&&y(e,l,t[l]);if(c)for(var l of c(t))u.call(t,l)&&y(e,l,t[l]);return e};const f=n.default.div((({commonStyle:e})=>`\n  display: flex;\n  flex-wrap: wrap;\n  overflow: hidden;\n  ${l.getStyle(e)}\n`)),s=n.default.div((({labelStyle:e})=>`\n  margin-left: 0.25rem;\n  vertical-align: middle;\n  width: -webkit-fill-available;\n  ${l.getStyle(e)}\n`)),m=n.default.label`
  vertical-align: middle;
  margin-bottom: 0;
`,b=n.default.input((({inputStyle:e})=>`\n  ${l.getStyle(e)}\n`));exports.CheckboxGroup=t=>{const l=t,{commonStyle:r,inputStyle:n,labelStyle:i,optionStyle:y,register:v,name:S,id:x,options:g=[]}=l,j=((e,t)=>{var l={};for(var r in e)p.call(e,r)&&t.indexOf(r)<0&&(l[r]=e[r]);if(null!=e&&c)for(var r of c(e))t.indexOf(r)<0&&u.call(e,r)&&(l[r]=e[r]);return l})(l,["commonStyle","inputStyle","labelStyle","optionStyle","register","name","id","options"]);return e.jsx(f,{commonStyle:r,id:x,children:g.map((t=>{return e.jsxs(m,{style:{display:"flex",alignItems:"center"},children:[e.jsx(b,(l=d({inputStyle:n,value:t.value},v?v(S,j):d({name:S},j)),r={type:"checkbox"},o(l,a(r)))),e.jsx(s,{labelStyle:y,children:t.label})]},t.value);var l,r}))})};


/***/ }),

/***/ 802636:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(212951),t=__webpack_require__(85097),r=__webpack_require__(143599);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=o(n),i=Object.defineProperty,a=Object.defineProperties,d=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,s=Object.prototype.propertyIsEnumerable,u=(e,n,t)=>n in e?i(e,n,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[n]=t,y=(e,n)=>{for(var t in n||(n={}))c.call(n,t)&&u(e,t,n[t]);if(p)for(var t of p(n))s.call(n,t)&&u(e,t,n[t]);return e};const f=e=>"email"===e?t.PATTERN_VALIDATION.email:"tel"===e?t.PATTERN_VALIDATION.phone:void 0,m=l.default.div((({commonStyle:e})=>`\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  ${t.getStyle(e)}\n`)),b=l.default.input((({inputStyle:e})=>`\n    position: relative;\n    display: inline-block;\n    width: 100%;\n    min-width: 100%;\n    color: rgba(0, 0, 0, 0.85);\n    height: 100%;\n    padding: 0 0.5rem;\n    &:focus,\n    &-focused {\n      outline: 0;\n    }\n    &::-moz-placeholder {\n      opacity: 1;\n    }\n\n    &::placeholder {\n      color: #999;\n    }\n\n    &:placeholder-shown {\n      text-overflow: ellipsis;\n    }\n    border-style: solid;\n    border-color: rgb(238, 238, 238);\n    border-width: 1px;\n  ${t.getStyle(e)}\n`));exports.InputText=n=>{const t=n,{commonStyle:o,inputStyle:l,placeholder:i,register:u,name:h,id:x,type:g="text",disabled:v=!1,icon:O,onChange:j,value:S}=t,w=((e,n)=>{var t={};for(var r in e)c.call(e,r)&&n.indexOf(r)<0&&(t[r]=e[r]);if(null!=e&&p)for(var r of p(e))n.indexOf(r)<0&&s.call(e,r)&&(t[r]=e[r]);return t})(t,["commonStyle","inputStyle","placeholder","register","name","id","type","disabled","icon","onChange","value"]);return e.jsxs(m,{commonStyle:o,children:[e.jsx(b,(P=y({inputStyle:l,placeholder:i,type:g},u?u(h,y({pattern:f(g)},w)):y({name:h},w)),I={id:x,disabled:v,onChange:j,value:S},a(P,d(I)))),O&&e.jsx("div",{style:{padding:"0px 8px",height:"100%",display:"flex",alignItems:"center",border:"1px solid rgb(238, 238, 238)",borderRadius:"0 4px 4px 0"},children:e.jsx(r.Icon,{name:O.name,style:{fontSize:O.size}})})]});var P,I},exports.getPattern=f;


/***/ }),

/***/ 600757:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(891987),t=__webpack_require__(426927),n=__webpack_require__(802636),l=__webpack_require__(980645),a=Object.defineProperty,o=Object.defineProperties,u=Object.getOwnPropertyDescriptors,i=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,s=Object.prototype.propertyIsEnumerable,c=(e,r,t)=>r in e?a(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,d=(e,r)=>{for(var t in r||(r={}))p.call(r,t)&&c(e,t,r[t]);if(i)for(var t of i(r))s.call(r,t)&&c(e,t,r[t]);return e},f=(e,r)=>o(e,u(r));exports.InputControllerWithWarn=a=>{var o=a,{control:u,warn:c,name:g,type:v,required:x,maxLength:y,warningMessageConfig:j,inputType:b,index:m}=o,O=((e,r)=>{var t={};for(var n in e)p.call(e,n)&&r.indexOf(n)<0&&(t[n]=e[n]);if(null!=e&&i)for(var n of i(e))r.indexOf(n)<0&&s.call(e,n)&&(t[n]=e[n]);return t})(o,["control","warn","name","type","required","maxLength","warningMessageConfig","inputType","index"]);const[h,q]=r.useState(""),w=(e,r)=>{var t;(null==c?void 0:c.handle(null==(t=e.target.value||"")?void 0:t.replace(/·/g,"")))?(q((e=>{let r="";return e&&(r=null==j?void 0:j[e]),r})(c.type)),r(e.target.value.slice(0,y))):(q(""),r(e.target.value))};return e.jsx(t.Controller,{control:u,defaultValue:O.value,name:g||`value_${m}`,rules:{required:x,pattern:n.getPattern(v)},render:({field:{onChange:r,onBlur:t,value:a},fieldState:{error:o}})=>(a||q(""),e.jsxs(e.Fragment,{children:["input"===b&&e.jsx(n.InputText,f(d({},O),{type:"email"===v?"text":v,onChange:e=>{w(e,r)},register:null,value:a||"",onBlur:t,style:o?{border:"1px solid #ff0000"}:{}})),"textarea"===b&&e.jsx(l.InputTextarea,f(d({},O),{inputStyle:O.inputStyle,type:v,onChange:e=>{w(e,r)},register:null,value:a||"",onBlur:t,style:o?{border:"1px solid #ff0000"}:{}})),e.jsx("p",{style:{color:"#E9D502"},children:h})]}))})};


/***/ }),

/***/ 472410:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(212951),t=__webpack_require__(85097);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var r=i(n),o=Object.defineProperty,l=Object.defineProperties,a=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,s=(e,n,t)=>n in e?o(e,n,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[n]=t,c=(e,n)=>{for(var t in n||(n={}))d.call(n,t)&&s(e,t,n[t]);if(p)for(var t of p(n))m.call(n,t)&&s(e,t,n[t]);return e};const{defaultImage:u,checkedInputGroupImageBkg:g}=t.mappingAssets,f=r.default.div((({commonStyle:e,imageConfig:n,inputType:i})=>{const r=(null==n?void 0:n.width)||60;let o=void 0!==(null==n?void 0:n.radius)?n.radius:8;return o=o>r/2?r/2:o,`\n    margin-top: 4px;\n    display: flex;\n    flex-wrap: wrap;\n    ${t.getStyle(e)}\n\n    .form-item {\n      width: ${r}px;\n      cursor: pointer;\n      display: flex;\n      align-items: flex-start;\n    }\n    .form-item__label {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n    }\n    [type='${i}'] {\n      position: absolute;\n      opacity: 0;\n      width: 0;\n      height: 0;\n    }\n  \n    .form-item__label__img {\n      border-radius: ${o}px;\n      width: ${r}px;\n      height: ${r}px;\n      position: relative;\n      background-size: ${(null==n?void 0:n.backgroundSize)||"contain"};\n      background-position: center;\n      background-repeat: no-repeat;\n    }\n\n    .form-item__label__img img{\n      width: inherit;\n      height: inherit;\n      border-radius: inherit;\n      object-fit: cover;\n    }\n  \n    [type='${i}']:checked + .form-item__label > .form-item__label__img {\n      &::after {\n        position: absolute;\n        content: ' ';\n        width: 24px;\n        height: 24px;\n        background-image: url(${g});\n        background-size: contain;\n        background-position: center;\n        background-repeat: no-repeat;\n        top: calc(-12px + 0.2939 * ${o}px);\n        right: calc(-12px + 0.2939 * ${o}px);\n      }\n      outline: 2px solid #5ba1e3;\n    }\n  `})),b=r.default.div((({labelStyle:e,imageWidth:n=100})=>`\n  text-align: center;\n  margin-top: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  word-wrap: break-word;\n  max-width: ${n}px;\n  ${t.getStyle(e)}\n`)),y=r.default.input((({inputStyle:e})=>`\n  ${t.getStyle(e)}\n`));exports.InputGroupImage=n=>{const i=n,{commonStyle:r,inputStyle:o,optionStyle:s,register:g,name:x,id:h,options:v=[],imageConfig:_,inputType:w}=i,S=((e,n)=>{var t={};for(var i in e)d.call(e,i)&&n.indexOf(i)<0&&(t[i]=e[i]);if(null!=e&&p)for(var i of p(e))n.indexOf(i)<0&&m.call(e,i)&&(t[i]=e[i]);return t})(i,["commonStyle","inputStyle","optionStyle","register","name","id","options","imageConfig","inputType"]);return e.jsx(f,{inputType:w,imageConfig:_,commonStyle:r,id:h,children:v.map((n=>{var i,r,p,d;const{image:m}=n,f=(null==(i=null==m?void 0:m.googleImageParams)?void 0:i.percent)?Math.round((null==(r=m.googleImageParams)?void 0:r.width)*(null==(p=m.googleImageParams)?void 0:p.percent)/100):null==(d=null==m?void 0:m.googleImageParams)?void 0:d.width,h=t.getImageUrlFromGoogleUserContent(null==m?void 0:m.src,{format:"webp",width:f,compressLevel:1});return e.jsxs("label",{className:"form-item",children:[e.jsx(y,(v=c({inputStyle:o,value:n.value},g?g(x,S):c({name:x},S)),j={type:w},l(v,a(j)))),e.jsxs("div",{className:"form-item__label",children:[e.jsx("div",{className:"form-item__label__img",children:e.jsx("img",c({src:h||u,loading:"lazy",alt:"form selection"},h&&{srcSet:t.buildSrcsetDPR(h,{width:f})}))}),e.jsx(b,{labelStyle:s,imageWidth:null==_?void 0:_.width,className:"form-item__label__text",children:n.label})]})]});var v,j}))})};


/***/ }),

/***/ 952666:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(800656),t=__webpack_require__(212951),r=__webpack_require__(143599),o=__webpack_require__(85097),l=__webpack_require__(891987),i=__webpack_require__(335417);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=a(t),c=Object.defineProperty,s=Object.defineProperties,p=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,h=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,f=(e,n,t)=>n in e?c(e,n,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[n]=t,y=(e,n)=>{for(var t in n||(n={}))h.call(n,t)&&f(e,t,n[t]);if(u)for(var t of u(n))m.call(n,t)&&f(e,t,n[t]);return e},b=(e,n)=>s(e,p(n));const v=d.default.div((({commonStyle:e})=>`\n    width:100%;\n    ${o.getStyle(e)}\n    height: unset!important;\n  `)),g=d.default.input((({inputStyle:e})=>`\n    position: relative;\n    display: inline-block;\n    width: 100%;\n    min-width: 100%;\n    height: 32px;\n    color: rgba(0, 0, 0, 0.85);\n    padding: 0 0.5rem;\n    &:focus,\n    &-focused {\n      outline: 0;\n    }\n    &::-moz-placeholder {\n      opacity: 1;\n    }\n\n    &::placeholder {\n      color: #999;\n    }\n\n    &:placeholder-shown {\n      text-overflow: ellipsis;\n    }\n    border-style: solid;\n    border-color: rgb(238, 238, 238);\n    border-width: 1px;\n  ${o.getStyle(e)}\n`)),x=d.default.select((({inputStyle:e})=>`\n    position: relative;\n    display: inline-block;\n    width: 100%;\n    min-width: 100%;\n    color: rgba(0, 0, 0, 0.85);\n    height: 32px;\n    padding: 0 0.5rem;\n    &:focus,\n    &-focused {\n      outline: 0;\n    }\n    &::-moz-placeholder {\n      opacity: 1;\n    }\n\n    &::placeholder {\n      color: #999;\n    }\n\n    &:placeholder-shown {\n      text-overflow: ellipsis;\n    }\n    border-style: solid;\n    border-color: rgb(238, 238, 238);\n    border-width: 1px;\n    margin-bottom: 8px;\n  ${o.getStyle(e)}\n`));exports.LocationSelect=t=>{const a=t,{commonStyle:d,inputStyle:c,setValue:s,register:p,name:f,trigger:j,wrapperRef:S}=a,w=((e,n)=>{var t={};for(var r in e)h.call(e,r)&&n.indexOf(r)<0&&(t[r]=e[r]);if(null!=e&&u)for(var r of u(e))n.indexOf(r)<0&&m.call(e,r)&&(t[r]=e[r]);return t})(a,["commonStyle","inputStyle","setValue","register","name","trigger","wrapperRef"]),[O,C]=l.useState([]),{device:q}=o.useStore(),[P,E]=l.useState(),[I,k]=l.useState(),[z,L]=l.useState();return l.useEffect((()=>{if(P&&I){const e=[I,P].map((e=>e.label)).join(", ");s(f,e),L(e),j(f)}else s(f,null)}),[P,I]),l.useEffect((()=>{const e=document.createElement("script");e.src="https://landingbuilder-cdn.tekoapis.com/location/2.0.0/location.vi.min.js",e.addEventListener("load",(()=>{C(window.TempiLocation.VN)})),document.body.appendChild(e)}),[]),e.jsx(v,{commonStyle:d,children:"mobile"===q?e.jsxs("div",{children:[e.jsx("input",b(y({},p?p(f,{required:w.required}):{}),{style:{display:"none"}})),e.jsxs(x,{inputStyle:c,placeholder:n.t("Chọn tỉnh/ thành"),onChange:e=>{E(O.find((n=>n.value==e.target.value))),k(null)},children:[e.jsx("option",{children:n.t("Chọn tỉnh/ thành phố")}),O.map((n=>e.jsx("option",{value:n.value,children:n.label},n.value)))]}),e.jsxs(x,{inputStyle:c,placeholder:n.t("Chọn xã/ phường"),onChange:e=>k(P.children.find((n=>n.value==e.target.value))),children:[e.jsx("option",{children:n.t("Chọn xã/ phường")}),null==(V=null==P?void 0:P.children)?void 0:V.map((n=>e.jsx("option",{value:n.value,children:n.label},n.value)))]})]}):e.jsx(i,{options:O,onChange:(e,n)=>{L(n.reverse().map((e=>e.label)).join(", "))},expandIcon:e.jsx(r.Icon,{name:"ForwardOutlined"}),getPopupContainer:()=>S.current,zIndex:1,children:e.jsx(g,b(y({inputStyle:c,value:z},p?p(f,y({},w)):y({name:f},w)),{autoComplete:"off",readOnly:!0}))})});var V};


/***/ }),

/***/ 864465:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),l=__webpack_require__(85097);function r(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var n=r(t),i=Object.defineProperty,a=Object.defineProperties,o=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,y=(e,t,l)=>t in e?i(e,t,{enumerable:!0,configurable:!0,writable:!0,value:l}):e[t]=l,c=(e,t)=>{for(var l in t||(t={}))p.call(t,l)&&y(e,l,t[l]);if(d)for(var l of d(t))u.call(t,l)&&y(e,l,t[l]);return e};const f=n.default.div((({commonStyle:e})=>`\n  display: flex;\n  flex-wrap: wrap;\n  overflow: hidden;\n  ${l.getStyle(e)}\n`)),s=n.default.div((({labelStyle:e})=>`\n  vertical-align: middle;\n  margin-left: 0.25rem;\n  width: -webkit-fill-available;\n  ${l.getStyle(e)}\n  `)),m=n.default.label`
  vertical-align: middle;
  margin-bottom: 0;
`,b=n.default.input((({inputStyle:e})=>`\n  ${l.getStyle(e)}\n`));exports.RadioGroup=t=>{const l=t,{commonStyle:r,inputStyle:n,labelStyle:i,optionStyle:y,register:v,name:S,id:g,options:j=[]}=l,x=((e,t)=>{var l={};for(var r in e)p.call(e,r)&&t.indexOf(r)<0&&(l[r]=e[r]);if(null!=e&&d)for(var r of d(e))t.indexOf(r)<0&&u.call(e,r)&&(l[r]=e[r]);return l})(l,["commonStyle","inputStyle","labelStyle","optionStyle","register","name","id","options"]);return e.jsx(f,{commonStyle:r,id:g,children:j.map((t=>{return e.jsxs(m,{style:{display:"flex",alignItems:"center"},children:[e.jsx(b,(l=c({inputStyle:n,value:t.value},v?v(S,x):c({name:S},x)),r={type:"radio"},a(l,o(r)))),e.jsx(s,{labelStyle:y,children:t.label})]},t.value);var l,r}))})};


/***/ }),

/***/ 317197:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),n=__webpack_require__(85097);function t(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=t(r),o=Object.defineProperty,i=Object.defineProperties,a=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,s=(e,r,n)=>r in e?o(e,r,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[r]=n,u=(e,r)=>{for(var n in r||(r={}))d.call(r,n)&&s(e,n,r[n]);if(c)for(var n of c(r))p.call(r,n)&&s(e,n,r[n]);return e};const m=l.default.div((({commonStyle:e})=>`\n  overflow: hidden;\n  ${n.getStyle(e)}\n`)),y=l.default.select((({inputStyle:e})=>`\n    position: relative;\n    display: inline-block;\n    width: 100%;\n    min-width: 100%;\n    color: rgba(0, 0, 0, 0.85);\n    height: 100%;\n    padding: 0 0.5rem;\n    &:focus,\n    &-focused {\n      outline: 0;\n    }\n    &::-moz-placeholder {\n      opacity: 1;\n    }\n\n    &::placeholder {\n      color: #999;\n    }\n\n    &:placeholder-shown {\n      text-overflow: ellipsis;\n    }\n    border-style: solid;\n    border-color: rgb(238, 238, 238);\n    border-width: 1px;\n  ${n.getStyle(e)}\n`));exports.SelectBox=r=>{const n=r,{commonStyle:t,inputStyle:l,placeholder:o,register:s,name:f,id:b,multiple:v,options:h=[]}=n,j=((e,r)=>{var n={};for(var t in e)d.call(e,t)&&r.indexOf(t)<0&&(n[t]=e[t]);if(null!=e&&c)for(var t of c(e))r.indexOf(t)<0&&p.call(e,t)&&(n[t]=e[t]);return n})(n,["commonStyle","inputStyle","placeholder","register","name","id","multiple","options"]);return e.jsx(m,{commonStyle:t,id:b,children:e.jsxs(y,(x=u({inputStyle:l,multiple:v,name:f},s?s(f,j):u({name:f},j)),O={children:[e.jsx("option",{style:{color:"#999"},value:"",disabled:v,selected:!v,children:o||""}),h.map((r=>e.jsx("option",{value:r.value,children:r.label},r.value)))]},i(x,a(O))))});var x,O};


/***/ }),

/***/ 980645:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(212951),r=__webpack_require__(85097);function t(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var o=t(n),l=Object.defineProperty,i=Object.getOwnPropertySymbols,a=Object.prototype.hasOwnProperty,c=Object.prototype.propertyIsEnumerable,d=(e,n,r)=>n in e?l(e,n,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[n]=r,u=(e,n)=>{for(var r in n||(n={}))a.call(n,r)&&d(e,r,n[r]);if(i)for(var r of i(n))c.call(n,r)&&d(e,r,n[r]);return e};const p=o.default.div((({commonStyle:e})=>`\n  overflow: hidden;\n  ${r.getStyle(e)}\n`)),s=o.default.textarea((({inputStyle:e})=>`\n    position: relative;\n    display: inline-block;\n    width: 100%;\n    min-width: 100%;\n    color: rgba(0, 0, 0, 0.85);\n    height: 100%;\n    padding: 0 0.5rem;\n    &:focus,\n    &-focused {\n      outline: 0;\n    }\n    &::-moz-placeholder {\n      opacity: 1;\n    }\n\n    &::placeholder {\n      color: #999;\n    }\n\n    &:placeholder-shown {\n      text-overflow: ellipsis;\n    }\n    border-style: solid;\n    border-color: rgb(238, 238, 238);\n    border-width: 1px;\n  ${r.getStyle(e)}\n`));exports.InputTextarea=n=>{const r=n,{commonStyle:t,inputStyle:o,placeholder:l,register:d,name:f,id:y,onChange:m,value:h}=r,b=((e,n)=>{var r={};for(var t in e)a.call(e,t)&&n.indexOf(t)<0&&(r[t]=e[t]);if(null!=e&&i)for(var t of i(e))n.indexOf(t)<0&&c.call(e,t)&&(r[t]=e[t]);return r})(r,["commonStyle","inputStyle","placeholder","register","name","id","onChange","value"]);return e.jsx(p,{commonStyle:t,id:y,children:e.jsx(s,u({onChange:m,inputStyle:o,placeholder:l,value:h},d?d(f,b):u({name:f},b)))})};


/***/ }),

/***/ 283019:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(800656),n=__webpack_require__(212951),r=__webpack_require__(143599),i=__webpack_require__(85097),l=__webpack_require__(891987);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=o(n),u=Object.defineProperty,d=Object.defineProperties,c=Object.getOwnPropertyDescriptors,s=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,f=(e,t,n)=>t in e?u(e,t,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[t]=n,v=(e,t)=>{for(var n in t||(t={}))p.call(t,n)&&f(e,n,t[n]);if(s)for(var n of s(t))m.call(t,n)&&f(e,n,t[n]);return e},y=(e,t)=>d(e,c(t));const g=Math.round(20),h=a.default.div((({commonStyle:e})=>`\n  ${i.getStyle(e)}\n    margin-bottom: 0.5em;\n    height: unset!important;\n  `)),b=a.default.button`
  border-radius: 4px;
  margin-right: 4px;
  padding: 0.5em 0.75em;
`,S=a.default.span((({errorStyle:e})=>`\n  color: rgb(255, 77, 79);\n  font-size: 0.9em;\n  ${i.getStyle(e)}\n`));exports.UploadFile=n=>{var o,a;const u=n,{commonStyle:d,inputStyle:c,register:f,name:x,id:j,setValue:O,errorStyle:M,isEditingMode:_=!1}=u,q=((e,t)=>{var n={};for(var r in e)p.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&s)for(var r of s(e))t.indexOf(r)<0&&m.call(e,r)&&(n[r]=e[r]);return n})(u,["commonStyle","inputStyle","register","name","id","setValue","errorStyle","isEditingMode"]),{env:w="local"}=i.useStore(),[E,B]=l.useState(!1),[I,P]=l.useState(""),C=l.useRef(null);return e.jsxs(h,{commonStyle:d,id:j,children:[e.jsxs("div",{children:[e.jsxs(b,{disabled:E,onClick:e=>{var t;e.preventDefault(),null==(t=null==C?void 0:C.current)||t.click()},children:[e.jsx(r.Icon,{name:"UploadOutlined",style:{marginRight:"0.25em",fontSize:"16px"}}),E?"Đang tải lên":_?t.t("Chọn tệp tin (tối đa {{MAX_FILE_MB_SIZE}}MB)",{MAX_FILE_MB_SIZE:g}):`Chọn tệp tin (tối đa ${g}MB)`]}),(null==(o=null==C?void 0:C.current)?void 0:o.files.length)>0?`(${null==(a=null==C?void 0:C.current)?void 0:a.files[0].name})`:""]}),I&&e.jsx(S,{errorStyle:M,children:I}),e.jsx("input",y(v({},f?f(x,y(v({},q),{validate:{preventSubmit:()=>!E}})):v({name:x},q)),{ref:C,onChange:async e=>{var t,n,r,l;P("");const o=e.target.files[0];if(o.size>20971520)return void P(`Dung lượng tệp không được vượt quá ${g}MB. Vui lòng chọn lại`);const a=new FormData;a.append("file",o);const u=!!(null==(t=null==o?void 0:o.type)?void 0:t.match("image")),d=!!(null==(n=null==o?void 0:o.type)?void 0:n.match("video")),c=!!(null==(r=null==o?void 0:o.type)?void 0:r.match("audio")),s=u?"image":d?"video":c?"audio":"doc";a.append("type",s),B(!0);const p=new i.Api(i.publicBffUrl[w]);try{const t=await p.post("/v1/upload",a);f(x).onChange(e);const n=null==(l=null==t?void 0:t.data)?void 0:l.url;O(x,n)}catch(e){P("Đã xảy ra lỗi khi upload file. Vui lòng thử lại.")}finally{B(!1)}},type:"file",accept:".jpg, .jpeg, .png, .gif, .docx, .docs, .doc, .xls, .xlsx, .zip, .pdf, .mp3, .mp4",style:{display:"none"}}))]})};


/***/ }),

/***/ 673100:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(800656),t=__webpack_require__(85097),n=__webpack_require__(891987),r=__webpack_require__(183681),o=__webpack_require__(885973),l=__webpack_require__(47248),i=__webpack_require__(655268),a=__webpack_require__(324259),u=__webpack_require__(80667),s=__webpack_require__(262560),c=__webpack_require__(196170);function d(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var m=d(l),p=Object.defineProperty,f=Object.defineProperties,v=Object.getOwnPropertyDescriptors,h=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,b=(e,t,n)=>t in e?p(e,t,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[t]=n,w=(e,t)=>{for(var n in t||(t={}))y.call(t,n)&&b(e,n,t[n]);if(h)for(var n of h(t))g.call(t,n)&&b(e,n,t[n]);return e};const S=new t.Api(""),T=100;exports.useDynamicWidthCalculation=(e,t,r)=>{const o=n.useCallback((t=>{var n,o;if(r<=0)return{endIndex:t,totalPercent:0,itemCount:0};let l=0,i=t-1;for(let r=t;r<e.length;r++){const t=null==(o=null==(n=e[r])?void 0:n.commonStyle)?void 0:o.width,a="number"==typeof t?t:parseFloat(null==t?void 0:t.toString());if(isNaN(a)||a<=0)break;const u=l+a;if(u>T)break;l=u,i=r}return i<t?{endIndex:t,totalPercent:0,itemCount:0}:{endIndex:i,totalPercent:l,itemCount:i-t+1}}),[e,r]),l=n.useCallback(((e,n,o)=>{if(r<=0||o<=0||isNaN(e))return T;if(1===o)return Math.min(T,e);const l=(o-1)*t;if(n/T*r+l>r){const t=Math.max(0,r-l);if(t<=0)return T/o;if(n<=0||isNaN(n))return t/o/r*T;const i=t*(e/n)/r*T;return Math.floor(10*Math.max(0,i))/10}return e}),[t,r]);return n.useMemo((()=>{var n,i,a,u,s,c;if(!(null==e?void 0:e.length)||t<0||r<=0)return(null==e?void 0:e.map((e=>{var t;const n=null==(t=null==e?void 0:e.commonStyle)?void 0:t.width,r="number"==typeof n?n:parseFloat(null==n?void 0:n.toString());return`${isNaN(r)?T:Math.min(T,r)}%`})))||[];const d=new Array(e.length);for(let t=0;t<e.length;t++){const{endIndex:r,totalPercent:m,itemCount:p}=o(t);if(p>1){for(let o=t;o<=r;o++){const t=null==(i=null==(n=e[o])?void 0:n.commonStyle)?void 0:i.width,r="number"==typeof t?t:parseFloat(null==t?void 0:t.toString());if(isNaN(r)){d[o]="100%";continue}const a=l(r,m,p);d[o]=`${Math.max(0,a)}%`}t=r}else if(0===p){const n=null==(u=null==(a=e[t])?void 0:a.commonStyle)?void 0:u.width,r="number"==typeof n?n:parseFloat(null==n?void 0:n.toString());d[t]=`${isNaN(r)||r>T?T:Math.min(T,r)}%`}else{const n=null==(c=null==(s=e[t])?void 0:s.commonStyle)?void 0:c.width,r="number"==typeof n?n:parseFloat(null==n?void 0:n.toString());d[t]=`${isNaN(r)?T:Math.min(T,r)}%`}}return d}),[e,t,r,o,l])},exports.useForm=({wrapperRef:l,response:d})=>{const[p,b]=n.useState(!1),{env:T}=t.useStore(),P=n.useRef({}),$=async(n,l,c)=>{const{type:d,config:m}=n;let p=w({},l);if((null==m?void 0:m.autoPassParams)&&(p=w(w({},a.queryStringToObject(window.location.search)),p)),"api"===d){const e=C(p,c),t=m;let n;try{n=JSON.parse((null==t?void 0:t.headers)||"{}")}catch(e){n={}}if(["PATCH","POST"].includes(null==t?void 0:t.method)){const l=n["Content-Type"]||(null==t?void 0:t.contentType)||r.ContentType.urlEncoded;return S.post(null==t?void 0:t.url,o.formatData(l,e),{headers:w(w({},!/^multipart\//.test(l)&&{"Content-Type":l}),n)}).catch((e=>(console.error(e),Promise.reject(e))))}if("GET"===(null==t?void 0:t.method))return S.get(null==t?void 0:t.url,{params:e,headers:n}).catch((e=>(console.error(e),Promise.reject(e))))}if("googleSheet"===d){const n=u.transformValuesGGSheet(p,c),r=m;if(!r.valid||r.formAccountId<=0){const t=e.t("Một kết nối Google Sheet chưa sẵn sàng, kiểm tra lại!");return console.error(t),Promise.reject(t)}const o=new Date,{year:l,month:a,day:d,hour:f,minute:v,second:h}=s.getPartialDateTimeTimeZone7(o),y=`${l}-${a}-${d} ${f}:${v}:${h}`,g=(null==r?void 0:r.submitTime)?[{name:e.t("Thời gian gửi"),type:"string",value:y}]:[];return i.formUtils.insertDataToGoogleSheetV2(r,[...g,...n],`${t.publicBffUrl[T]}/v1/submit-form`)}},j=(e,t,n)=>{if(!e||!n)return;const r=l.current.ownerDocument.querySelector(`[data-uniq-id="${e}"]`);(null==r?void 0:r.querySelector(".popup-content")).querySelectorAll("p, h1, h2, h3, h4, h5, h6").forEach(((e,r)=>{const o=null==t?void 0:t.data;e.innerHTML=n[r].replaceAll(/{{([\w,.]*)}}/g,(e=>m.default(o,e.replace(/{{/,"").replace(/}}/,""))))})),null==r||r.click()},q=e=>{(null==d?void 0:d.successPage)&&c.isUrlValid(d.successPage)&&(window.location.href=null==d?void 0:d.successPage),(null==d?void 0:d.success)&&((()=>{var e;const t=null==(e=l.current)?void 0:e.closest(".popup-content"),n=null==t?void 0:t.parentElement;if(!n)return;const r=null==n?void 0:n.parentElement;r.classList.remove("show"),r.classList.add("hide-from-btn"),null==n||n.click()})(),j(d.success,e,_(d.success)))},D=e=>{(null==d?void 0:d.failedPage)&&c.isUrlValid(d.failedPage)&&(window.location.href=null==d?void 0:d.failedPage),(null==d?void 0:d.failed)&&j(d.failed,e,_(d.failed))},O=e=>{var t;(null==(t=null==d?void 0:d.custom)?void 0:t.length)&&d.custom.forEach((t=>{var n,r,o;(null==(r=null==(n=m.default(null==e?void 0:e.data,t.key))?void 0:n.toString)?void 0:r.call(n))!==(null==(o=t.value)?void 0:o.toString())||j(t.popup,e,_(t.popup))}))},_=e=>{if(!P.current[e]){const t=l.current.ownerDocument.querySelector(`[data-uniq-id="${e}"]`);if(t){const n=[...t.querySelectorAll(".popup-content p, h1, h2, h3, h4, h5, h6")].map((e=>e.innerHTML));P.current[e]=n}}return P.current[e]},N=async(e,n,r,o)=>{try{const o=await i.formUtils.submitFormData(null==e?void 0:e.formConfigId,n,`${t.publicBffUrl[T]}/v1/submit-form`);"default"===(null==d?void 0:d.responseType)&&q(o),"custom"===(null==d?void 0:d.responseType)&&O(o),null==r||r()}catch(e){"default"===(null==d?void 0:d.responseType)&&D({data:(null==e?void 0:e.response)||{}}),"custom"===(null==d?void 0:d.responseType)&&O({data:(null==e?void 0:e.response)||{}}),null==o||o()}},M=(e,t,n)=>{const r=a.queryStringToObject(window.location.search)||{},{utm_source:o,utm_medium:l,utm_campaign:i,utm_term:s,utm_content:c}=r,d=((e,t)=>{var n={};for(var r in e)y.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&h)for(var r of h(e))t.indexOf(r)<0&&g.call(e,r)&&(n[r]=e[r]);return n})(r,["utm_source","utm_medium","utm_campaign","utm_term","utm_content"]),m=w(w({utm_source:o,utm_medium:l,utm_campaign:i,utm_term:s,utm_content:c},(null==e?void 0:e.autoPassParams)&&d),t);return u.transformValuesGGSheet(m,n)},x=()=>{var e;const t=new Date,{year:n,month:r,day:o,hour:l,minute:i,second:a}=s.getPartialDateTimeTimeZone7(t);return[{name:"Sending time",type:"string",value:`${n}-${r}-${o} ${l}:${i}:${a}`},{name:"Url page",type:"string",value:null==(e=null==window?void 0:window.location)?void 0:e.href}]},C=(e,t)=>{const n=t.filter((e=>"date"===e.type)).map((e=>e.name)),r=t.filter((e=>"time"===e.type)).map((e=>e.name)),o=t.filter((e=>"datetime-local"===e.type)).map((e=>e.name));return Object.entries(e).map((([e,t])=>{if(n.includes(e)&&t){const{year:n,month:r,day:o}=s.getPartialDateTimeTimeZone7(new Date(t));return[e,`${o}-${r}-${n}`]}if(r.includes(e)&&t){const{hour:n,minute:r,second:o}=s.getPartialDateTimeTimeZone7(new Date(t));return[e,`${n}:${r}:${o}`]}if(o.includes(e)&&t){const{year:n,month:r,day:o,hour:l,minute:i,second:a}=s.getPartialDateTimeTimeZone7(new Date(t));return[e,`${o}-${r}-${n} ${l}:${i}:${a}`]}return[e,t]})).reduce(((e,t)=>{return n=w({},e),r={[t[0]]:t[1]},f(n,v(r));var n,r}),{})};return{handleMultiSubmit:async(e,t,n,r)=>{let o=[...e];const l=null==o?void 0:o[r];b(!0);try{l?(o.splice(r,0),o=[l,...o],await Promise.all(o.map((async(e,r)=>0===r?$(e,t,n):$(e,t,n).catch((()=>{}))))).then((([e])=>{"default"===(null==d?void 0:d.responseType)&&q(e),"custom"===(null==d?void 0:d.responseType)&&O(e)})).catch((e=>{"default"===(null==d?void 0:d.responseType)&&D({data:(null==e?void 0:e.response)||{}}),"custom"===(null==d?void 0:d.responseType)&&O({data:(null==e?void 0:e.response)||{}})}))):await Promise.all(e.map((e=>$(e,t,n))))}finally{b(!1)}},loading:p,handleSubmitFormData:async(e,t,n)=>{try{b(!0);let r=M(e,t,n);const o=x();r=[...r,...o],await N(e,r)}finally{b(!1)}},utilSubmitData:N,buildFormValue:M,buildTrackingValueSubmit:x}};


/***/ }),

/***/ 183681:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=(e=>(e.json="application/json",e.formData="multipart/form-data",e.urlEncoded="application/x-www-form-urlencoded",e))(e||{}),n=(e=>(e.Rectangular="rectangular",e.Rounded="rounded",e.Underlined="underlined",e.OutlinedRectangular="outlinedRectangular",e.OutlinedRounded="outlinedRounded",e))(n||{});exports.ContentType=e,exports.InputShapeType=n;


/***/ }),

/***/ 845589:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),n=__webpack_require__(85097),r=__webpack_require__(877084),o=__webpack_require__(891987),i=__webpack_require__(137127),l=__webpack_require__(846130),a=__webpack_require__(426927),s=__webpack_require__(673100),u=__webpack_require__(600757),d=__webpack_require__(32622),c=__webpack_require__(952666),p=__webpack_require__(283019),m=__webpack_require__(472410),f=__webpack_require__(815563),y=__webpack_require__(864465),h=__webpack_require__(317197);function v(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var g=v(t),b=v(r),x=v(o),S=v(i),w=Object.defineProperty,j=Object.defineProperties,q=Object.getOwnPropertyDescriptors,k=Object.getOwnPropertySymbols,C=Object.prototype.hasOwnProperty,W=Object.prototype.propertyIsEnumerable,F=(e,t,n)=>t in e?w(e,t,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[t]=n,L=(e,t)=>{for(var n in t||(t={}))C.call(t,n)&&F(e,n,t[n]);if(k)for(var n of k(t))W.call(t,n)&&F(e,n,t[n]);return e},R=(e,t)=>j(e,q(t)),G=(e,t)=>{var n={};for(var r in e)C.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&k)for(var r of k(e))t.indexOf(r)<0&&W.call(e,r)&&(n[r]=e[r]);return n};const K=(e,t)=>{const n={pattern:"Vui lòng nhập đúng định dạng",required:"Đây là trường bắt buộc"};let r="";return e&&(r=void 0===t?null==n?void 0:n[e]:null==t?void 0:t[e]),r},O=x.default.forwardRef(((t,r)=>{var i,v;const g=t,{commonStyle:w,children:j,isEditingMode:q=!1,submits:k=[],hiddenFields:C=[],optionStyle:W,errorStyle:F,showLabel:O,mainConnection:I,response:A,captcha:D,event:$,configStorage:T,onFinish:B,customLoading:z,preventResetFormAfterSubmit:N,errorMessageConfig:_,warningMessageConfig:U}=g,X=G(g,["commonStyle","children","isEditingMode","submits","hiddenFields","optionStyle","errorStyle","showLabel","mainConnection","response","captcha","event","configStorage","onFinish","customLoading","preventResetFormAfterSubmit","errorMessageConfig","warningMessageConfig"]),{device:H}=n.useStore(),{formStyle:J,inputStyle:Q,labelStyle:Y}=n.getPropsByDevice(X,H),Z=n.mergeArrayPropSeparateDevice(null==t?void 0:t.inputs,null==(i=null==t?void 0:t.desktop)?void 0:i.inputs,null==(v=null==t?void 0:t.mobile)?void 0:v.inputs,H),ee=Q||{},{textLevel:te,borderBottomWidth:ne,borderTopWidth:re,borderLeftWidth:oe,borderRightWidth:ie,inputShape:le}=ee,ae=G(ee,["textLevel","borderBottomWidth","borderTopWidth","borderLeftWidth","borderRightWidth","inputShape"]),{handleSubmit:se,register:ue,formState:{errors:de,isSubmitting:ce},reset:pe,setValue:me,trigger:fe,control:ye,watch:he}=a.useForm(),ve=o.useRef(null),{handleMultiSubmit:ge,loading:be,handleSubmitFormData:xe}=s.useForm({wrapperRef:ve,response:A}),Se=o.useRef(),{executeRecaptcha:we}=l.useGoogleReCaptcha(),[je,qe]=o.useState(0);o.useLayoutEffect((()=>{const e=()=>{var e;qe((null==(e=null==ve?void 0:ve.current)?void 0:e.offsetWidth)||0)};if(e(),ve.current){const t=new ResizeObserver(e);return t.observe(ve.current),()=>t.disconnect()}}),[]);const ke=s.useDynamicWidthCalculation(Z,+(null==J?void 0:J.columnGap)||8,je),Ce=o.useMemo((()=>Z.map(((e,t)=>R(L({},e),{commonStyle:R(L({},e.commonStyle),{width:ke[t]})})))),[ke,Z]),We=Y||{},{textLevel:Fe}=We,Le=G(We,["textLevel"]),Re=(null==D?void 0:D.requestKey)||"g-captcha-response",Ge="checkboxv2"===(null==D?void 0:D.version)&&!!(null==D?void 0:D.siteKey),Ke="invisiblev2"===(null==D?void 0:D.version)&&!!(null==D?void 0:D.siteKey),Oe="invisiblev3"===(null==D?void 0:D.version)&&!!(null==D?void 0:D.siteKey),[Ie,Ee]=o.useState(0),{trackingEventName:Me,conversionGGAdsId:Ve,conversionGGAdsLabel:Pe,scriptCustom:Ae,conversionValue:De}=$||{};o.useEffect((()=>{!q&&Ge&&ue(Re,{required:!0})}),[Ie]);const $e=e=>{if(null==e?void 0:e.trim())try{new Function(n.unescapeString(e))()}catch(e){console.error(e)}};return e.jsxs(M,{ref:ve,commonStyle:w,children:[e.jsxs(V,R(L({ref:r,onSubmit:se((async(e,t)=>{if(t.preventDefault(),q||ce)return!1;(()=>{var e,t,n,r,o;Me&&(null==(e=null==window?void 0:window.gtag)||e.call(window,"event",Me),De&&(null==(t=null==window?void 0:window.fbq)||t.call(window,"track",Me,{value:De,currency:"VND"})),!De&&(null==(n=null==window?void 0:window.fbq)||n.call(window,"track",Me)),null==(r=null==window?void 0:window.track)||r.call(window,"customEvent",Me)),Ve&&Pe&&(null==(o=null==window?void 0:window.gtag)||o.call(window,"event","conversion",{send_to:`AW-${Ve}/${Pe}`}));const i=(e=>{let t=e||"";const n=Object.keys(he());for(const e of n)t&&t.includes(`{{${e}}}`)&&he(e)&&(t=t.replaceAll(`{{${e}}}`,d.sha256(he(e))));return t})(Ae||"");$e(i)})();const n=L({},e);try{if(Ge&&(D.requestKey||delete n[Re]),Ke){const e=await Se.current.executeAsync();(null==D?void 0:D.requestKey)&&(n[D.requestKey]=e)}if(Oe){const e=await we((null==D?void 0:D.action)||void 0);(null==D?void 0:D.requestKey)&&(n[D.requestKey]=e)}}catch(e){return void alert("Xác minh danh tính không thành công")}try{"function"!=typeof B?(null==T?void 0:T.formConfigId)?await xe(T,n,Z):await ge(k,n,Z,I):await B(n)}finally{(Ge||Ke)&&Se.current.reset(),N||pe(),Ee((e=>e+1))}}))},X),{formStyle:J,children:[(Ce||[]).map(((t,n)=>{const r=L({},t.commonStyle||{}),o=null==r?void 0:r.width,i=de[null==t?void 0:t.name];null==r||delete r.width;const l=e.jsx(e.Fragment,{children:O&&"single-checkbox"!==t.type&&e.jsx(P,{as:"string"==typeof Fe&&"p"!==Fe?Fe:"label",labelStyle:Le,className:b.default({required:t.required}),children:(null==t?void 0:t.label)||""})}),a=e.jsx(e.Fragment,{children:i&&e.jsx(E,{errorStyle:L(L({},ae),F),children:K(i.type,_)})}),s=R(L({register:!q&&!!t.name&&ue},t),{commonStyle:r,inputStyle:L(L({borderBottomWidth:ne,borderTopWidth:re,borderLeftWidth:oe,borderRightWidth:ie},ae||{}),t.inputStyle||{})});let d=null;switch(t.type){case"text":case"tel":case"email":case"number":case"date":case"time":case"datetime-local":case"address":d=e.jsx(u.InputControllerWithWarn,L({index:n,control:ye,warn:{handle:e=>t.max&&(null==e?void 0:e.toString().length)>t.max,type:"max"},inputType:"input",warningMessageConfig:U,maxLength:t.max},s));break;case"textarea":d=e.jsx(u.InputControllerWithWarn,L({index:n,control:ye,warn:{handle:e=>t.max&&(null==e?void 0:e.toString().length)>t.max,type:"max"},inputType:"textarea",warningMessageConfig:U,maxLength:t.max},s));break;case"select-box":d=e.jsx(h.SelectBox,L({},s));break;case"radio-group":d=e.jsx(y.RadioGroup,L({labelStyle:Le,optionStyle:L(L({},W||{}),t.optionStyle||{})},s));break;case"checkbox-group":case"single-checkbox":d=e.jsx(f.CheckboxGroup,L({labelStyle:Le,optionStyle:L(L({},W||{}),t.optionStyle||{})},s));break;case"checkbox-group-image":d=e.jsx(m.InputGroupImage,L({inputType:"checkbox",labelStyle:Le,optionStyle:L(L({},W||{}),t.optionStyle||{})},s));break;case"radio-group-image":d=e.jsx(m.InputGroupImage,L({inputType:"radio",labelStyle:Le,optionStyle:L(L({},W||{}),t.optionStyle||{})},s));break;case"file":d=e.jsx(p.UploadFile,R(L({isEditingMode:q},s),{setValue:me,errorStyle:F}));break;case"location":d=e.jsx(c.LocationSelect,R(L({},s),{setValue:me,trigger:fe,wrapperRef:ve}),Ie)}return d?e.jsxs("div",{style:{width:o},children:[l,d,a]},t.name):null})),(()=>{var t;const n=de[Re];return e.jsx(e.Fragment,{children:Ge&&e.jsxs("div",{style:{width:null==(t=null==D?void 0:D.commonStyle)?void 0:t.width},children:[e.jsx(S.default,{ref:Se,sitekey:D.siteKey,onChange:e=>me(Re,e,{shouldValidate:!0}),onExpired:()=>me(Re,"",{shouldValidate:!0}),onErrored:()=>me(Re,"",{shouldValidate:!0})}),n&&e.jsx(E,{errorStyle:F,children:K(n.type,_)})]})})})(),Ke?e.jsx(S.default,{ref:Se,sitekey:D.siteKey,size:"invisible"}):null,!!C.length&&C.map((t=>t.name?e.jsx("input",R(L({type:"hidden"},ue(t.name)),{value:t.value}),t.name):null)),x.default.Children.map(j,((e,t)=>{var n;if(0===t)return e?x.default.cloneElement(e,{loading:be||z,parentLayout:null==(n=null==X?void 0:X.formStyle)?void 0:n.flexDirection}):null}))]})),x.default.Children.map(j,((e,t)=>{if(0!==t)return x.default.cloneElement(e)}))]})})),I=x.default.forwardRef(((t,n)=>{const{captcha:r}=t;return(null==r?void 0:r.siteKey)&&"invisiblev3"===(null==r?void 0:r.version)?e.jsx(l.GoogleReCaptchaProvider,{reCaptchaKey:r.siteKey,children:e.jsx(O,L({ref:n},t))}):e.jsx(O,L({ref:n},t))})),E=g.default.span((({errorStyle:e})=>`\n  color: rgb(255, 77, 79);\n  font-size: 0.9em;\n  ${n.getStyle(e)}\n`)),M=g.default.div((({commonStyle:e})=>`\n  display: flex;\n  width: 100%;\n  ${n.getStyle(e)}\n`)),V=g.default.form((({formStyle:e})=>`\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 100%;\n  ${n.getStyle(e)}\n`)),P=g.default.label((({labelStyle:e})=>`\n  position: relative;\n  margin-bottom: 4px;\n  display: inline-flex;\n  align-items: center;\n  font-size: 14px;\n  &.required {\n    &:before {\n      display: inline-block;\n      margin-right: 4px;\n      color: #ff4d4f;\n      font-size: 14px;\n      font-family: SimSun, sans-serif;\n      line-height: 1;\n      content: '*';\n    }\n  }\n  ${n.getStyle(e)}\n`));I.displayName="FormV4",exports.FormV4=I,exports.InnerFormV4=O;


/***/ }),

/***/ 885973:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(183681);exports.formatData=(t,o)=>{let n=o||{};if(t===e.ContentType.formData)n=new FormData,Object.entries(o).forEach((([e,t])=>{n.append(e,t)}));else if(t===e.ContentType.urlEncoded){const e=[];Object.entries(o).forEach((([t,o])=>{const n=encodeURIComponent(t),r=encodeURIComponent(o);e.push(`${n}=${r}`)})),n=e.join("&")}return n};


/***/ }),

/***/ 259901:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const t=s(__webpack_require__(212951)).default.div`
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .spinner-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    flex-direction: column;
    opacity: 0.9;
  }
  .loading-text {
    font-size: 16px;
    letter-spacing: 2px;
    color: #f09819;
    margin-bottom: 8px;
  }
  .pulse-container {
    width: 120px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .pulse-bubble {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: linear-gradient(to right, #f09819, #edde5d);
  }

  .pulse-bubble-1 {
    animation: pulse 1s ease 0s infinite alternate;
  }
  .pulse-bubble-2 {
    animation: pulse 1s ease 0.2s infinite alternate;
  }
  .pulse-bubble-3 {
    animation: pulse 1s ease 0.4s infinite alternate;
  }
  .pulse-bubble-4 {
    animation: pulse 1s ease 0.6s infinite alternate;
  }
  .pulse-bubble-5 {
    animation: pulse 1s ease 0.8s infinite alternate;
  }

  @keyframes pulse {
    from {
      opacity: 1;
      transform: scale(1);
    }
    to {
      opacity: 0.25;
      transform: scale(0.75);
    }
  }
`;exports.GameLoading=()=>e.jsx(t,{children:e.jsxs("div",{className:"spinner-box",children:[e.jsx("div",{className:"loading-text",children:"Loading..."}),e.jsxs("div",{className:"pulse-container",children:[e.jsx("div",{className:"pulse-bubble pulse-bubble-1"}),e.jsx("div",{className:"pulse-bubble pulse-bubble-2"}),e.jsx("div",{className:"pulse-bubble pulse-bubble-3"}),e.jsx("div",{className:"pulse-bubble pulse-bubble-4"}),e.jsx("div",{className:"pulse-bubble pulse-bubble-5"})]})]})});


/***/ }),

/***/ 984615:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(800656),i=__webpack_require__(212951),r=__webpack_require__(143599),n=__webpack_require__(534479);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=o(i);const d=a.default.div`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: grid;
  place-items: center;
  z-index: 1;
`,l=a.default.div`
  font-family: ${n.defaultFontFamily};
  color: #e6983a;
  width: 304px;
  background-color: #fffbf5;
  text-align: center;
  border-radius: 8px;
  padding: 8px 12px;
`;exports.PercentageWarning=({percentageToShowWarning:i})=>!i||i<0?null:e.jsx(d,{children:e.jsxs(l,{children:[e.jsx(r.Icon,{name:"InforOutlined",style:{fontSize:40}}),e.jsx("div",{children:t.t("game_config.warning.probability_greater_than_100")}),e.jsxs("div",{children:[t.t("game_config.warning.current_probability"),i,"%"]})]})});


/***/ }),

/***/ 648576:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(85097),t=__webpack_require__(891987),r=__webpack_require__(823413),i=__webpack_require__(845589),a=__webpack_require__(750911),n=Object.defineProperty,l=Object.defineProperties,s=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,h=(e,o,t)=>o in e?n(e,o,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[o]=t;exports.PopupParticipantInfo=({isShowForm:n,formFields:d,setIsShowForm:b,loading:g,onFinishClose:c,handlePlayGame:f,isUseTheme:y,gameId:v})=>{const{globalData:j}=o.useStore(),{userPhoneNumber:w,isDisableLuckyDrawPhoneInput:P=!1}=j||{},F=(e,o)=>o||("phoneNumber"===e?"tel":"email"===e?"email":"text"),O=t.useMemo((()=>null==d?void 0:d.map((({label:e,name:o,required:t,type:r,options:i})=>{let a,n=!1;return"phoneNumber"===o&&w&&(a=w),"phoneNumber"===o&&P&&(n=!0),{type:F(o,r),label:e,name:o,required:t,commonStyle:{height:40,width:"100%",marginBottom:8},inputStyle:{borderRadius:8,fontFamily:y&&"var(--tempi-global-paragraph1fontfamily)"},placeholder:`Nhập ${e.toLowerCase()}`,id:`user-info-${o}-input`,value:a,disabled:n,options:"single-checkbox"===r?[{label:e,value:"checked"}]:i}}))),[w,P,d]);return d?e.jsxs(r.PopupGame,(S=((e,o)=>{for(var t in o||(o={}))p.call(o,t)&&h(e,t,o[t]);if(u)for(var t of u(o))m.call(o,t)&&h(e,t,o[t]);return e})({enableLightConfig:!1,desktop:void 0,mobile:void 0,show:n,onFinishClose:()=>{b(!1),null==c||c()}},{maskClosable:!0,maskStyle:{backgroundColor:"rgba(0, 0, 0, 0.5)"},commonStyle:{borderRadius:8,width:400,height:300,backgroundColor:"#fff",padding:{left:24,right:24,bottom:24,top:24}},position:"default"}),k={children:[e.jsx("div",{style:{marginBottom:32,fontWeight:"bold",fontFamily:y&&"var(--tempi-global-heading1fontfamily)"},children:"Vui lòng điền thông tin để tham gia chương trình"}),e.jsx(i.FormV4,{inputs:O,submits:[],hiddenFields:[],showLabel:!0,onFinish:f,labelStyle:{fontFamily:y&&"var(--tempi-global-paragraph1fontfamily)"},errorStyle:{fontFamily:y&&"var(--tempi-global-paragraph1fontfamily)"},children:e.jsx(a.ButtonV2,{text:"Hoàn tất",buttonStyle:{backgroundColor:"#108143",color:"rgba(255, 255, 255, 1)",height:40,width:120,borderRadius:999,margin:{top:20,left:"auto",right:"auto"}},loading:g,iconConfig:{position:"right",spacing:8,show:!0,icon:{name:"CheckOutlined",size:18}}})},`${v}_PopupParticipantInfoForm_${w}_${P}`)]},l(S,s(k)))):null;var S,k};


/***/ }),

/***/ 673923:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const i=n(t).default.div((({gameStyle:e})=>`\n      width: 100%;\n      text-align: center;\n      margin: 1rem 0;\n      ${r.getStyle(e)}\n    `));exports.TurnDesc=({isEditor:t,showTurn:r,turnCount:n,turnDesc:u,gameStyle:l})=>r?e.jsx(i,{gameStyle:l,children:t?u:u&&void 0!==n&&n>=0&&u.replace("***",null==n?void 0:n.toString())}):null;


/***/ }),

/***/ 667481:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(800656),t=__webpack_require__(108984),o=Object.defineProperty,a=Object.defineProperties,i=Object.getOwnPropertyDescriptors,r=Object.getOwnPropertySymbols,n=Object.prototype.hasOwnProperty,s=Object.prototype.propertyIsEnumerable,p=(e,t,a)=>t in e?o(e,t,{enumerable:!0,configurable:!0,writable:!0,value:a}):e[t]=a,l=(e,t)=>{for(var o in t||(t={}))n.call(t,o)&&p(e,o,t[o]);if(r)for(var o of r(t))s.call(t,o)&&p(e,o,t[o]);return e},g=(e,t)=>a(e,i(t)),m=(e=>(e[e.OUT_OF_TURN=400018]="OUT_OF_TURN",e[e.OUT_OF_PRIZE=400020]="OUT_OF_PRIZE",e))(m||{});const d={[t.EntryTemplateEnum.basic]:{imageInit:{src:"https://lh3.googleusercontent.com/nz2mtos6dgJVXLtLRwussob-IyPQHPYgEZKvtOtnk7T8G-XMTKHjbU312UG0HL5OFpitgENwNJCu0psBqSPwq19zgDvAjqoG=rw-w95"},imageResult:{src:"https://lh3.googleusercontent.com/srXtV07aQo9g08yxGtMbCa8q3BD7KAjx8w7KGojUsKAvJgKWTuhrsgoMp4XNhSO5Gi0xKHMr9clXY3B_LzosYxqf5XlApQ5Y=rw-w95"},popupPrize:{desktop:{closeIcon:{size:24,color:"#a63900",commonStyle:{top:20,right:28}},animationConfig:{totalFrame:87,name:"treasure-animation",showButtonClose:!0,frameShowPopup:50,wrapperStyle:{width:600,height:680},url:"https://storage.googleapis.com/teko-landing-builder-cdn/tempi-elements/static/json/treasure-animation.json"}},mobile:{closeIcon:{size:18,color:"#a63900",commonStyle:{top:16,right:36}},animationConfig:{wrapperStyle:{width:600,height:700}}}}},[t.EntryTemplateEnum.blue]:{imageInit:{src:"https://lh3.googleusercontent.com/JMqobG31oKQmmWAbXnt03yzxyvQTG5FAMN4vEfNhraP2PBs9oTNlinDg8VUGxXilAMajGjGpphpIvK67ed8Rab9HbXn5qg=rw-w320"},imageResult:{src:"https://lh3.googleusercontent.com/KwMvKtqD971Y7b4eLw8rFzigWm59WKc19EuGEQBpjWHaDCB-qxuI9xK-a1uG_bBdMHHLCD00eKE6EXz8uc4MAFOX30dib6e4=rw-w320"},popupPrize:{desktop:{closeIcon:{size:24,color:"#a63900",commonStyle:{top:20,right:28}},animationConfig:{totalFrame:87,name:"treasure-blue-animation",showButtonClose:!0,frameShowPopup:50,wrapperStyle:{width:600,height:680},url:"https://storage.googleapis.com/teko-landing-builder-cdn/tempi-elements/static/json/treasure-blue-animation.json"}},mobile:{closeIcon:{size:18,color:"#a63900",commonStyle:{top:16,right:36}},animationConfig:{wrapperStyle:{width:600,height:700}}}}},[t.EntryTemplateEnum.red]:{imageInit:{src:"https://lh3.googleusercontent.com/_zrjXEVPeo-5oOEzLHo9i6zD103N5V5L6qdyC9esBogrCxhzYKQfILmiw2HPsSEpE80T8AMHy7lawTwuVgN2ClVZDMnUbi90kg=rw-w320"},imageResult:{src:"https://lh3.googleusercontent.com/x7dlAR3BF4V4ZX_66hTr-NCHfh24Y_QJNnf6UjwOfEyg9iKGmadcdvsmlEH1-_7h6NtJDR7SjJOARabbJM993ZKpT0ns0t4=rw-w320"},popupPrize:{desktop:{closeIcon:{size:24,color:"#a63900",commonStyle:{top:20,right:28}},animationConfig:{totalFrame:86,name:"treasure-red-animation",showButtonClose:!0,frameShowPopup:50,wrapperStyle:{width:600,height:680},url:"https://storage.googleapis.com/teko-landing-builder-cdn/tempi-elements/static/json/treasure-red-animation.json"}},mobile:{closeIcon:{size:18,color:"#a63900",commonStyle:{top:16,right:36}},animationConfig:{wrapperStyle:{width:600,height:700}}}}},[t.EntryTemplateEnum.pot]:{imageInit:{src:"https://lh3.googleusercontent.com/XbzR09ahNpQkaBwPtQw_qczWoE1Z-elFICE1xjXBQ6iCSZt6ObefcN-ne9sabC1nFrYsJUswOM4bgaVkJBu1y4pme-wCfxloug=rw-w160"},imageResult:{src:"https://lh3.googleusercontent.com/tLxFKF1rUzAXGhboyowtD3XJH_Y6X_pD_kV-E4KBh-mi0wBApr-VcK1hA8gIBUiT8jqA9BGBnjsPkA_qaqpPUNpS2qZY_3js=rw-w160"},popupPrize:{style:{backgroundImage:"https://lh3.googleusercontent.com/O-6mwyrKO3IJyyi47ja6h75bTiiOIacgJRUvw_GHUGZ_RRSjAMhCpKSDpHKZY3xrxITfIVHJ4pVUAac6UN98YbdI9pLhe0dVGA=rw-w560"},desktop:{closeIcon:{size:24,color:"#a63900",commonStyle:{top:20,right:28}},animationConfig:{totalFrame:96,name:"pot-smashing-animation",showButtonClose:!0,frameShowPopup:80,wrapperStyle:{width:600,height:600},url:"https://storage.googleapis.com/teko-landing-builder-cdn/tempi-elements/static/json/potsmashing-animation.json"}},mobile:{closeIcon:{size:18,color:"#a63900",commonStyle:{top:16,right:36}},animationConfig:{wrapperStyle:{width:500,height:500}}}}}},c={gameId:null,alignment:"center",imageInit:{src:"https://lh3.googleusercontent.com/nz2mtos6dgJVXLtLRwussob-IyPQHPYgEZKvtOtnk7T8G-XMTKHjbU312UG0HL5OFpitgENwNJCu0psBqSPwq19zgDvAjqoG=rw-w95"},imageResult:{src:"https://lh3.googleusercontent.com/srXtV07aQo9g08yxGtMbCa8q3BD7KAjx8w7KGojUsKAvJgKWTuhrsgoMp4XNhSO5Gi0xKHMr9clXY3B_LzosYxqf5XlApQ5Y=rw-w95"},desktop:{columnCount:4,rowCount:2,gameStyle:{color:"#000000",fontSize:14,fontWeight:"400",positionTurnDesc:t.PositionTurnDesc.above}},showTurn:!1,entryTemplate:t.EntryTemplateEnum.basic,turnDesc:e.t("game_config.turn_desc")},h=g(l({},c),{isUseTheme:!0,gameStyle:{currentParagraphTheme:"paragraph1"},desktop:g(l({},c.desktop),{gameStyle:g(l({},c.desktop.gameStyle),{fontFamily:"var(--tempi-global-paragraph1fontfamily)",fontSize:"var(--tempi-global-paragraph1fontsize)",fontWeight:"var(--tempi-global-paragraph1fontweight)",letterSpacing:"var(--tempi-global-paragraph1letterspacing)",lineHeight:"var(--tempi-global-paragraph1lineheight)"})}),mobile:{gameStyle:{fontSize:"var(--tempi-global-paragraph1mobilefontsize)",fontWeight:"var(--tempi-global-paragraph1mobilefontweight)",letterSpacing:"var(--tempi-global-paragraph1mobileletterspacing)",lineHeight:"var(--tempi-global-paragraph1mobilelineheight)"}}}),u={gameId:null,alignment:"center",imageInit:{src:"https://lh3.googleusercontent.com/XbzR09ahNpQkaBwPtQw_qczWoE1Z-elFICE1xjXBQ6iCSZt6ObefcN-ne9sabC1nFrYsJUswOM4bgaVkJBu1y4pme-wCfxloug=rw-w160"},imageResult:{src:"https://lh3.googleusercontent.com/tLxFKF1rUzAXGhboyowtD3XJH_Y6X_pD_kV-E4KBh-mi0wBApr-VcK1hA8gIBUiT8jqA9BGBnjsPkA_qaqpPUNpS2qZY_3js=rw-w160"},desktop:{columnCount:4,rowCount:2,gameStyle:{color:"#000000",fontSize:14,fontWeight:"400",positionTurnDesc:t.PositionTurnDesc.above}},showTurn:!1,entryTemplate:t.EntryTemplateEnum.pot,turnDesc:e.t("game_config.turn_desc")},b=g(l({},u),{isUseTheme:!0,gameStyle:{currentParagraphTheme:"paragraph1"},desktop:g(l({},u.desktop),{gameStyle:g(l({},u.desktop.gameStyle),{fontFamily:"var(--tempi-global-paragraph1fontfamily)",fontSize:"var(--tempi-global-paragraph1fontsize)",fontWeight:"var(--tempi-global-paragraph1fontweight)",letterSpacing:"var(--tempi-global-paragraph1letterspacing)",lineHeight:"var(--tempi-global-paragraph1lineheight)"})}),mobile:{gameStyle:{fontSize:"var(--tempi-global-paragraph1mobilefontsize)",fontWeight:"var(--tempi-global-paragraph1mobilefontweight)",letterSpacing:"var(--tempi-global-paragraph1mobileletterspacing)",lineHeight:"var(--tempi-global-paragraph1mobilelineheight)"}}}),f={gameId:null,alignment:"center",imageInit:{src:"https://lh3.googleusercontent.com/6B2xM1S4lVihKDCkpL1qimYpqCtfVO0Rr_QxUEpyfgyX60cbtrJcEjdO0YugSiR3wcq95GqqbZxdW0dJ0O789RZUq51_Pb37fg"},imageResult:{src:"https://lh3.googleusercontent.com/i_jMl-xNGsZ7aQ86txTCjnX2fOuTa8pWYhyFX8QAzULsdCSfRgmgqpL9MhkjtGqkbT3JLuZTVSOYFJ88e5iKMtdlWYnvyeh1"},mainGameStyle:{backgroundColor:"#9B0101",borderRadius:40,padding:{top:16,bottom:16,left:16,right:16}},cardStyle:{backgroundColor:"#ad200a",padding:{top:16,bottom:16,left:16,right:16},borderRadius:30},backCardStyle:{backgroundColor:"#ffae00"},desktop:{columnCount:4,rowCount:2,gameStyle:{color:"#000000",fontSize:14,fontWeight:"400",positionTurnDesc:t.PositionTurnDesc.above},size:116,width:116,height:116,rowGap:10,columnGap:24},mobile:{size:85,width:85,height:85,rowGap:10,columnGap:24,mainGameStyle:{borderRadius:40,padding:{top:16,bottom:16,left:16,right:16}}},showTurn:!1,turnDesc:e.t("game_config.turn_desc"),aspectRatio:"1/1",imageMode:t.ImageModeEnum.single,images:[],animationType:t.AnimationTypeEnum.flip},y=g(l({},f),{isUseTheme:!0,gameStyle:{currentParagraphTheme:"paragraph1"},desktop:g(l({},f.desktop),{gameStyle:g(l({},f.desktop.gameStyle),{fontFamily:"var(--tempi-global-paragraph1fontfamily)",fontSize:"var(--tempi-global-paragraph1fontsize)",fontWeight:"var(--tempi-global-paragraph1fontweight)",letterSpacing:"var(--tempi-global-paragraph1letterspacing)",lineHeight:"var(--tempi-global-paragraph1lineheight)"})}),mobile:g(l({},f.mobile),{gameStyle:{fontSize:"var(--tempi-global-paragraph1mobilefontsize)",fontWeight:"var(--tempi-global-paragraph1mobilefontweight)",letterSpacing:"var(--tempi-global-paragraph1mobileletterspacing)",lineHeight:"var(--tempi-global-paragraph1mobilelineheight)"}})}),w="https://lh3.googleusercontent.com/O-6mwyrKO3IJyyi47ja6h75bTiiOIacgJRUvw_GHUGZ_RRSjAMhCpKSDpHKZY3xrxITfIVHJ4pVUAac6UN98YbdI9pLhe0dVGA=rw-w560",v=[{tag:"TreasureHunting",group:e.t("mini_game.treasureHunting"),src:"https://lh3.googleusercontent.com/O7GRG-OtiWOhFgpkrU2P3U9FPI7caygZpgRdKjBpchj4IlOGCs9LbprM_DhLhpjwHT2SulmHGtjHku4MN_MtCc09Hxde3Zkr"}],k=[{tag:"LuckyMoney",group:e.t("mini_game.lucky_money"),src:"https://lh3.googleusercontent.com/exxdthx9iRXTqiONhkAm4OYlG0EZ63dGVQjwfflGbHpYjuzgCPn4KI89OAHOn6EmZgCmxHSM2u3WHjcXttsupxk9j5j2N5w"}],x=[{tag:"PotSmashing",group:e.t("mini_game.potSmashing"),src:"https://lh3.googleusercontent.com/aZI0A2Vc-0ENTGekg6xBExMQrzaRTShbesx9_r_5IffKyTcbFK8mBB3o6XXXBvtbt2mXifZkwWga1TwxewRl9upLerZSb_h92Q"}];exports.DEFAULT_GACHA_GAME_STYLE={currentParagraphTheme:"paragraph1"},exports.DEFAULT_GAME_POPUP_EMPTY_PRIZE=(t,o,a)=>{var i,r,n,s;return{".dp38jtsb":{id:".dp38jtsb",elementId:"9QiZ9Mnijk",parentId:"ROOT",tag:"popupgame",resolvedName:"PopupGameEditor",style:{height:235,width:310,backgroundColor:"transparent",padding:{left:24,right:24,bottom:24,top:0},borderRadius:24,borderColor:"#ff5722ff",backgroundImage:w,backgroundPosition:"center",backgroundSize:"contain",backgroundRepeat:"no-repeat",transition:"opacity 0.3s ease-in",mobile:{height:230,width:310}},isActive:!1,isCanvas:!0,customAttributes:{popupgame:{responsive:{hiddenXs:!1,hiddenMd:!1},maskClosable:!0,maskStyle:{backgroundColor:"#000000bd"},position:"default",name:t,showCloseIcon:!0,enableLightConfig:!0,desktop:l({closeIcon:{size:24,color:"#a63900",commonStyle:{top:20,right:28}}},null==(r=null==(i=d[o])?void 0:i.popupPrize)?void 0:r.desktop),mobile:l({closeIcon:{size:18,color:"#a63900",commonStyle:{top:16,right:36}}},null==(s=null==(n=d[o])?void 0:n.popupPrize)?void 0:s.mobile)}},children:[".wmmjc8p2",".xl1nmif4",".ljmoyefo",".ar1582cb"]},".wmmjc8p2":{id:".wmmjc8p2",parentId:".dp38jtsb",tag:"spacer",resolvedName:"SpacerEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{spacer:{responsive:{hiddenXs:!1,hiddenMd:!1},height:24}},children:[]},".xl1nmif4":{id:".xl1nmif4",parentId:".dp38jtsb",tag:"image",resolvedName:"ImageEditor",style:{width:100,widthUnit:"px",heightUnit:"%"},isActive:!1,isCanvas:!1,customAttributes:{image:{responsive:{hiddenXs:!1,hiddenMd:!1},src:"https://lh3.googleusercontent.com/YmOps4kXGr69cywN5hmI4d63hTklIvjZIwaayHuJCuBfrmmJpE2KS8gBIxOAbIxtn8mQlxVMB-w-hqnpQO13Rmn5ueFX4OWV",googleImageParams:{percent:100,width:100},name:"prize-image"}},children:[]},".ljmoyefo":{id:".ljmoyefo",parentId:".dp38jtsb",tag:"spacer",resolvedName:"SpacerEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{spacer:{responsive:{hiddenXs:!1,hiddenMd:!1},height:8}},children:[]},".ar1582cb":{id:".ar1582cb",parentId:".dp38jtsb",tag:"paragraph",resolvedName:"ParagraphEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{paragraph:l({responsive:{hiddenXs:!1,hiddenMd:!1}},a?{text:`<p style="font-family: var(--tempi-global-paragraph1fontfamily); --fontSizeDesktop: 16px; --fontSizeMobile: 16px; font-weight: 700; color: rgb(217, 74, 0); text-align: center" class="fs-desktop fs-mobile fs-desktop fs-mobile fs-desktop fs-mobile"><strong>${e.t("mini_game.good_luck")}</strong></p><p style="font-family: var(--tempi-global-paragraph1fontfamily); --fontSizeDesktop: 16px; --fontSizeMobile: 16px; font-weight: 700; color: rgb(217, 74, 0); text-align: center" class="fs-desktop fs-mobile fs-desktop fs-mobile fs-desktop fs-mobile"><strong> ${e.t("mini_game.next_time")}</strong></p>`,currentParagraphTheme:"custom"}:{text:`<p style="font-family: Quicksand; font-size: 16px; color: rgb(217, 74, 0); text-align: center"><span style="font-weight: 400"><strong>${e.t("mini_game.good_luck")}</strong></span></p><p style="font-family: Quicksand; font-size: 16px; color: rgb(217, 74, 0); text-align: center"><span style="font-weight: 400"><strong> ${e.t("mini_game.next_time")}</strong></span></p>`})},children:[]}}},exports.DEFAULT_GAME_POPUP_OUT_OF_MOVE=(t,o)=>({".xgukw6ne":{id:".xgukw6ne",elementId:"7PhZ7Orijk",parentId:"ROOT",tag:"popupgame",resolvedName:"PopupGameEditor",style:{width:350,height:260,backgroundColor:"transparent",padding:{left:24,right:24,bottom:24,top:0},borderRadius:24,backgroundImage:w,backgroundPosition:"center",backgroundSize:"contain",backgroundRepeat:"no-repeat"},isActive:!1,isCanvas:!0,customAttributes:{popupgame:{responsive:{hiddenXs:!1,hiddenMd:!1},maskClosable:!0,maskStyle:{backgroundColor:"#000000bd"},position:"default",name:t,showCloseIcon:!0,closeIcon:{size:18,color:"#a63900",commonStyle:{top:24,right:32}}}},children:[".k85i8qdw",".g7ef9s9p",".lvhq4cof",".1gmmca8b",".gqixp832",".vrduzqmv"]},".k85i8qdw":{id:".k85i8qdw",parentId:".xgukw6ne",tag:"spacer",resolvedName:"SpacerEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{spacer:{responsive:{hiddenXs:!1,hiddenMd:!1},height:32}},children:[]},".g7ef9s9p":{id:".g7ef9s9p",parentId:".xgukw6ne",tag:"image",resolvedName:"ImageEditor",style:{width:60,widthUnit:"%",height:100,heightUnit:"%",margin:{top:0,bottom:0,right:0,left:0}},isActive:!1,isCanvas:!1,customAttributes:{image:{responsive:{hiddenXs:!1,hiddenMd:!1},src:"https://lh3.googleusercontent.com/B8UCNG5G1RPLbQ4ytQDyUIKOAIEgZKtDSKhlQloAcQB7Xak1Xfv6wnPWfXmdVuNb6w9Zn8krUlixTa_F3z7HOUnyiT6e3fZL",googleImageParams:{percent:100,width:1088}}},children:[]},".lvhq4cof":{id:".lvhq4cof",parentId:".xgukw6ne",tag:"spacer",resolvedName:"SpacerEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{spacer:{responsive:{hiddenXs:!1,hiddenMd:!1},height:16}},children:[]},".1gmmca8b":{id:".1gmmca8b",parentId:".xgukw6ne",tag:"paragraph",resolvedName:"ParagraphEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{paragraph:l({responsive:{hiddenXs:!1,hiddenMd:!1}},o?{text:`\n          <h2 style="font-family: var(--tempi-global-paragraph1fontfamily); --fontSizeDesktop: 24px; --fontSizeMobile: 24px; font-weight: 700; color: rgb(27, 29, 41); text-align: center" class="fs-desktop fs-mobile fs-desktop fs-mobile fs-desktop fs-mobile"><strong>${e.t("mini_game.no_more_turns")}!</strong></h2>\n        `,currentParagraphTheme:"custom"}:{text:`\n          <h2 style="text-align: center; font-family: Quicksand"><strong><span style="font-size: 24px; color: rgb(27, 29, 41); font-weight: 700; text-transform: none">${e.t("mini_game.no_more_turns")}!</span></strong></h2>\n        `})},children:[]},".gqixp832":{id:".gqixp832",parentId:".xgukw6ne",tag:"spacer",resolvedName:"SpacerEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{spacer:{responsive:{hiddenXs:!1,hiddenMd:!1},height:16}},children:[]},".vrduzqmv":{id:".vrduzqmv",parentId:".xgukw6ne",tag:"paragraph",resolvedName:"ParagraphEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{paragraph:l({responsive:{hiddenXs:!1,hiddenMd:!1}},o?{text:`\n                <p style="font-family: var(--tempi-global-paragraph1fontfamily); --fontSizeDesktop: 16px; --fontSizeMobile: 16px; font-weight: 700; color: rgb(67, 70, 87); text-align: center" class="fs-desktop fs-mobile fs-desktop fs-mobile fs-desktop fs-mobile"><strong>${e.t("Vui lòng thử lại sau nhé")}</strong></p>\n              `,currentParagraphTheme:"custom"}:{text:`\n                <p style="text-align: center; font-size: 16px; font-family: Quicksand"><strong><span style="color: rgb(67, 70, 87); font-weight: 400">${e.t("Vui lòng thử lại sau nhé")}</span></strong></p>\n              `})},children:[]}}),exports.DEFAULT_GAME_POPUP_PRIZE=(t,o,a)=>{var i,r,n,s;return{".dxltzxrf":{id:".dxltzxrf",parentId:"ROOT",tag:"popupgame",resolvedName:"PopupGameEditor",style:{height:235,width:310,backgroundColor:"transparent",padding:{left:24,right:24,bottom:24,top:0},borderRadius:24,borderColor:"#ff5722ff",backgroundImage:w,backgroundPosition:"center",backgroundSize:"contain",backgroundRepeat:"no-repeat",transition:"opacity 0.3s ease-in",mobile:{height:230,width:310}},isCanvas:!0,customAttributes:{popupgame:{responsive:{hiddenXs:!1,hiddenMd:!1},maskClosable:!0,maskStyle:{backgroundColor:"#000000bd"},position:"default",zIndex:1050,closeIcon:{size:18},displayOncePerSession:!1,name:t,showCloseIcon:!0,enableLightConfig:!0,desktop:l({closeIcon:{size:24,color:"#a63900",commonStyle:{top:20,right:28}}},null==(r=null==(i=d[o])?void 0:i.popupPrize)?void 0:r.desktop),mobile:l({closeIcon:{size:18,color:"#a63900",commonStyle:{top:16,right:36}}},null==(s=null==(n=d[o])?void 0:n.popupPrize)?void 0:s.mobile)}},children:[".ygc7o6hi",".tn29er30",".w65ro1t1",".6wtt4hg3"]},".ygc7o6hi":{id:".ygc7o6hi",parentId:".dxltzxrf",tag:"spacer",resolvedName:"SpacerEditor",style:{},isCanvas:!1,customAttributes:{spacer:{responsive:{hiddenXs:!1,hiddenMd:!1},height:24}},children:[]},".tn29er30":{id:".tn29er30",parentId:".dxltzxrf",tag:"image",resolvedName:"ImageEditor",style:{width:100,widthUnit:"px",heightUnit:"%"},isCanvas:!1,customAttributes:{image:{responsive:{hiddenXs:!1,hiddenMd:!1},src:"https://lh3.googleusercontent.com/YmOps4kXGr69cywN5hmI4d63hTklIvjZIwaayHuJCuBfrmmJpE2KS8gBIxOAbIxtn8mQlxVMB-w-hqnpQO13Rmn5ueFX4OWV",googleImageParams:{percent:100,width:100},config:{hiddenDelete:!0,hiddenConfigUrlImage:!0},name:"prize-image"}},children:[]},".w65ro1t1":{id:".w65ro1t1",parentId:".dxltzxrf",tag:"spacer",resolvedName:"SpacerEditor",style:{},isCanvas:!1,customAttributes:{spacer:{responsive:{hiddenXs:!1,hiddenMd:!1},height:8}},children:[]},".6wtt4hg3":{id:".6wtt4hg3",parentId:".dxltzxrf",tag:"paragraph",resolvedName:"ParagraphEditor",style:{},isCanvas:!1,customAttributes:{paragraph:l({responsive:{hiddenXs:!1,hiddenMd:!1}},a?{text:`<p style="font-family: var(--tempi-global-paragraph1fontfamily); --fontSizeDesktop: 16px; --fontSizeMobile: 16px; font-weight: 700; color: rgb(217, 74, 0); text-align: center" class="fs-desktop fs-mobile fs-desktop fs-mobile fs-desktop fs-mobile"><strong>${e.t("mini_game.congratulations")}</strong></p><p style="font-family: var(--tempi-global-paragraph1fontfamily); --fontSizeDesktop: 16px; --fontSizeMobile: 16px; font-weight: 700; color: rgb(217, 74, 0); text-align: center" class="fs-desktop fs-mobile fs-desktop fs-mobile fs-desktop fs-mobile"><strong>${e.t("mini_game.received_the_gift")}</strong></p><p style="font-family: var(--tempi-global-paragraph1fontfamily); --fontSizeDesktop: 16px; --fontSizeMobile: 16px; font-weight: 700; color: rgb(217, 74, 0); text-align: center" class="fs-desktop fs-mobile fs-desktop fs-mobile fs-desktop fs-mobile"><strong>{{name}}!</strong></p>`,currentParagraphTheme:"custom"}:{text:`<p style="font-family: Quicksand; font-size: 16px; color: rgb(217, 74, 0); text-align: center"><span style="font-weight: 400"><strong>${e.t("mini_game.congratulations")}</strong></span></p><p style="font-family: Quicksand; font-size: 16px; color: rgb(217, 74, 0); text-align: center"><span style="font-weight: 400"><strong>${e.t("received_the_gift")}</strong></span></p><p style="font-family: Quicksand; font-size: 16px; color: rgb(217, 74, 0); text-align: center"><span style="font-weight: 400"><strong>{{name}}!</strong></span></p>`})},children:[]}}},exports.DEFAULT_GAME_POPUP_RESPONSE_CUSTOM=t=>({a7V6wzgv00:{id:"a7V6wzgv00",parentId:"ROOT",tag:"popupgame",resolvedName:"PopupGameEditor",style:{width:400,height:200,backgroundColor:"#fff",padding:{left:16,right:16,bottom:16,top:16},backgroundSize:"cover",borderRadius:12},isActive:!1,isCanvas:!0,customAttributes:{popupgame:{maskClosable:!0,maskStyle:{backgroundColor:"#0000004a"},position:"default",name:t}},children:["BFbkQmE9WI","RlaZkRZUBx","TdeG0UMb4y"]},BFbkQmE9WI:{id:"BFbkQmE9WI",parentId:"a7V6wzgv00",tag:"heading",resolvedName:"HeadingEditor",style:{backgroundSize:"cover"},isActive:!1,isCanvas:!1,customAttributes:{heading:{text:`<h2 style="text-align: center">${e.t("Thông báo")}</h2>`}},children:[]},RlaZkRZUBx:{id:"RlaZkRZUBx",parentId:"a7V6wzgv00",tag:"paragraph",resolvedName:"ParagraphEditor",style:{backgroundSize:"cover",margin:{top:16}},isActive:!1,isCanvas:!1,customAttributes:{paragraph:{text:'<p><span style="font-size: 14px">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus</span></p>'}},children:[]},TdeG0UMb4y:{id:"TdeG0UMb4y",parentId:"a7V6wzgv00",tag:"buttonv2",resolvedName:"ButtonEditorV2",style:{justifyContent:"center",margin:{top:16}},isActive:!1,isCanvas:!1,customAttributes:{buttonv2:{text:`<p>${e.t("Xác nhận")}</p>`,buttonStyle:{backgroundColor:"rgba(37, 141, 255, 1)",color:"rgba(255, 255, 255, 1)",height:32,width:120,borderRadius:999,backgroundSize:"cover"},event:{eventType:"closePopupList",togglePopupList:"a7V6wzgv00"},iconConfig:{position:"left",spacing:8,show:!0}}},children:[]}}),exports.DEFAULT_LUCKY_MONEY=f,exports.DEFAULT_LUCKY_MONEY_THEME=y,exports.DEFAULT_POT_SMASHING=u,exports.DEFAULT_POT_SMASHING_THEME=b,exports.DEFAULT_TREASURE_HUNTING=c,exports.DEFAULT_TREASURE_HUNTING_THEME=h,exports.ENTRY_TEMPLATE=d,exports.ERROR_CODES=m,exports.MAX_WIDTH_ITEM=116,exports.SAMPLE_LUCKY_MONEYS=k,exports.SAMPLE_POT_SMASHINGS=x,exports.SAMPLE_TREASURE_HUNTINGS=v;


/***/ }),

/***/ 77363:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(800656),t=__webpack_require__(85097),n=__webpack_require__(47248),r=__webpack_require__(891987),i=__webpack_require__(667481),o=__webpack_require__(108984),l=__webpack_require__(262560),u=__webpack_require__(324259),a=__webpack_require__(655268);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=s(n),d=Object.defineProperty,p=Object.defineProperties,m=Object.getOwnPropertyDescriptors,v=Object.getOwnPropertySymbols,f=Object.prototype.hasOwnProperty,h=Object.prototype.propertyIsEnumerable,g=(e,t,n)=>t in e?d(e,t,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[t]=n,y=(e,t)=>{for(var n in t||(t={}))f.call(t,n)&&g(e,n,t[n]);if(v)for(var n of v(t))h.call(t,n)&&g(e,n,t[n]);return e},S=(e,t)=>p(e,m(t));exports.useGachaGame=(n,s)=>{var d;const{popupResponse:p,configStorage:m,wrapperRef:v,isEditor:f,delayToShowPrizePopup:h,animationType:g,bypassShowParticipantForm:w}=s,{env:b,globalData:P}=t.useStore(),[q,O]=r.useState(),[j,I]=r.useState(!f),[T,A]=r.useState(!1),[D,E]=r.useState(),[z,$]=r.useState(),[k,R]=r.useState(!1),[C,_]=r.useState(),{condition:F,items:G,totalPercentage:L=100}=q||{},N=null==(d=null==F?void 0:F.form)?void 0:d.fields,U=new t.Api(`${t.publicBffUrl[b]}/v1/lucky-draw`),{userPhoneNumber:M,isDisableLuckyDrawPhoneInput:H}=P||{},[x,Z]=r.useState(),[B,V]=r.useState({}),[J,K]=r.useState(),Q=async(e,t)=>{var r,o,l;E(e),A(!0),R(!1);try{const i=await U.post("/spin",{wheelId:n,userInfo:e}),o=(null==(r=null==i?void 0:i.data)?void 0:r.data)||{},{isAssignSuccess:l,itemId:u,spinTurn:a,prizeName:s}=o;$(a);const c=null==G?void 0:G.findIndex((e=>e.id===u)),d=(null==G?void 0:G[c])||{name:s,id:u};V(u&&!l?e=>S(y({},e),{[t]:{name:"emptyPrize",id:null}}):e=>S(y({},e),{[t]:d})),X(o,d),W(m,d,e,l)}catch(e){if(parseInt(null==(o=null==e?void 0:e.response)?void 0:o.code)===i.ERROR_CODES.OUT_OF_TURN)return Y(null==p?void 0:p.outOfTurn),void $(0);if(parseInt(null==(l=null==e?void 0:e.response)?void 0:l.code)===i.ERROR_CODES.OUT_OF_PRIZE)return void Y(null==p?void 0:p.outOfPrize)}finally{A(!1),Z(void 0)}},W=async(e,n,r,i)=>{var o;if(!n||!(null==e?void 0:e.formConfigId))return;const s=new Date,{year:c,month:d,day:p,hour:m,minute:v,second:f}=l.getPartialDateTimeTimeZone7(s),h=`${c}-${d}-${p} ${m}:${v}:${f}`;let g=S(y({},r||{}),{prizeName:n.name,spinAt:h,assignmentStatus:(null==n?void 0:n.id)?i?t.AssignmentStatusEnum.success:t.AssignmentStatusEnum.failed:""});(null==e?void 0:e.autoPassParams)&&(g=y(y({},u.queryStringToObject(window.location.search)),g));const w=[...Object.entries(g).map((([e,t])=>({name:e,type:"string",value:null==t?"":t}))),{name:"url_page",type:"string",value:null==(o=null==window?void 0:window.location)?void 0:o.href}];await a.formUtils.submitFormData(null==e?void 0:e.formConfigId,w,`${t.publicBffUrl[b]}/v1/submit-form`)},X=async(e,t)=>{K(!0);const n=()=>{try{const{assignResult:r,isAssignSuccess:i,itemId:o}=e||{};o?i?(null==p?void 0:p.prize)&&ee(t):(n=r)&&((null==p?void 0:p.custom)||[]).some((e=>{var t,r,i;return(null==(r=null==(t=c.default(n,e.key))?void 0:t.toString)?void 0:r.call(t))===(null==(i=e.value)?void 0:i.toString())}))?te(r):(null==p?void 0:p.emptyPrize)&&Y(p.emptyPrize):(null==p?void 0:p.emptyPrize)&&Y(p.emptyPrize)}finally{K(!1)}var n};h?h((()=>n())):n()},Y=e=>{var t;null==(t=v.current.ownerDocument.querySelector(`[data-uniq-id="${e}"]`))||t.click()},ee=e=>{const t=p.prize;t&&(((e,t,n)=>{var r;if(!e||!n)return;const i=/{{([\w,.]*)}}/g,o=v.current.ownerDocument.querySelector(`[data-uniq-id="${e}"]`);o.querySelectorAll(".popup-content p, h1, h2, h3, h4, h5, h6").forEach(((e,r)=>{e.innerHTML=n[r].replaceAll(i,(e=>c.default(t,e.replace(/{{/,"").replace(/}}/,""))))})),(null==(r=null==t?void 0:t.image)?void 0:r.src)&&o.querySelectorAll('.popup-content [data-image-name="prize-image"] source, img').forEach((e=>{var n,r;const i=null==(r=null==(n=e.getAttribute("srcset"))?void 0:n.split(","))?void 0:r.map((e=>e.split(" "))),o=e.getAttribute("src");if(i){const n=i.map((e=>((null==e?void 0:e.length)&&(e[0]=t.image.src),e.join(" ")))).join(",");e.setAttribute("srcset",n)}o&&e.setAttribute("src",t.image.src)}))})(t,e,C),Y(t))},te=e=>{var t;(null==(t=null==p?void 0:p.custom)?void 0:t.length)&&p.custom.forEach((t=>{var n,r,i,o;if((null==(r=null==(n=c.default(e,t.key))?void 0:n.toString)?void 0:r.call(n))===(null==(i=t.value)?void 0:i.toString())){const n=t.popup;return((e,t)=>{const n=v.current.ownerDocument.querySelector(`[data-uniq-id="${e}"]`);e&&n&&n.querySelectorAll(".popup-content p, h1, h2, h3, h4, h5, h6").forEach((e=>{const n=e.innerHTML;e.innerHTML=n.replaceAll(/{{([\w,.]*)}}/g,(e=>c.default(t,e.replace(/{{/,"").replace(/}}/,""))))}))})(n,e),void(null==(o=v.current.ownerDocument.querySelector(`[data-uniq-id="${n}"]`))||o.click())}}))};return r.useEffect((()=>{n&&!f&&(async e=>{try{I(!0),(async e=>{var t;const n=await U.get(`/wheel/${e}`);O(null==(t=null==n?void 0:n.data)?void 0:t.data)})(e)}catch(e){return console.error(e),Promise.reject(e)}finally{setTimeout((()=>{I(!1)}),300)}})(n)}),[n,f]),r.useEffect((()=>{if(v.current&&(null==p?void 0:p.prize)){const e=v.current.ownerDocument.querySelector(`[data-uniq-id="${p.prize}"]`);if(e){const t=[...e.querySelectorAll(".popup-content p, h1, h2, h3, h4, h5, h6")].map((e=>e.innerHTML));_(t)}}}),[v.current]),{game:q,loadingInitGame:j,setLoadingInitGame:I,loading:T,currentItemClick:x,turnCount:z,isShowForm:k,totalPercentage:L,setLoading:A,setUserInfo:E,handlePlayGame:Q,onClickGachaGameItem:t=>{if(!(g!==o.AnimationTypeEnum.none&&B[t]||T||j||J)){if(Z(t),!(null==N?void 0:N.length))return Q(null,t);if(M||!H)return D?Q(D,t):void(M&&w&&1===(null==N?void 0:N.length)&&"phoneNumber"===N[0].name?(E({phoneNumber:M}),Q({phoneNumber:M},t)):R(!0));alert(e.t("Vui lòng đăng nhập tài khoản hoặc cập nhật số điện thoại ở Thông tin tài khoản"))}},setIsShowForm:R,handleStorageData:W,formFields:N,setCurrentItemClick:Z,listItemOpened:B,showingPopupPrize:J}};


/***/ }),

/***/ 179301:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.CARD_TRANSITION_TIME=600,exports.CONTAINER_WIDTH=160,exports.MAX_WIDTH_ITEM_DESKTOP=116,exports.PADDING_HORIZONTAL_ITEM=10;


/***/ }),

/***/ 70456:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(212951),t=__webpack_require__(85097),r=__webpack_require__(891987),o=__webpack_require__(108984),a=__webpack_require__(179301),i=__webpack_require__(77363),s=__webpack_require__(259901),l=__webpack_require__(984615),m=__webpack_require__(673923),c=__webpack_require__(648576),d=__webpack_require__(879774);function u(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var p=u(n),g=Object.defineProperty,f=Object.defineProperties,y=Object.getOwnPropertyDescriptors,h=Object.getOwnPropertySymbols,w=Object.prototype.hasOwnProperty,S=Object.prototype.propertyIsEnumerable,T=(e,n,t)=>n in e?g(e,n,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[n]=t,b=(e,n)=>{for(var t in n||(n={}))w.call(n,t)&&T(e,t,n[t]);if(h)for(var t of h(n))S.call(n,t)&&T(e,t,n[t]);return e},j=(e,n)=>{var t={};for(var r in e)w.call(e,r)&&n.indexOf(r)<0&&(t[r]=e[r]);if(null!=e&&h)for(var r of h(e))n.indexOf(r)<0&&S.call(e,r)&&(t[r]=e[r]);return t};const x=n=>{const d=r.useRef(),{device:u}=t.useStore(),p=n,{percentageToShowWarning:g,isUseTheme:h,gameId:w,children:S,response:T,showTurn:x=!1,isEditor:D=!1,configStorage:M,imageInit:k,imageResult:$,turnDesc:_,backCardStyle:q,animationType:F=o.AnimationTypeEnum.flip,images:R=[],imageMode:N=o.ImageModeEnum.single,bypassShowParticipantForm:L=!1}=p,W=j(p,["percentageToShowWarning","isUseTheme","gameId","children","response","showTurn","isEditor","configStorage","imageInit","imageResult","turnDesc","backCardStyle","animationType","images","imageMode","bypassShowParticipantForm"]),{commonStyle:U,columnCount:Y=4,rowCount:z=2,gameStyle:B,size:H=a.MAX_WIDTH_ITEM_DESKTOP,alignment:X,aspectRatio:K,width:Z,height:J,rowGap:Q=12,columnGap:V=24,cardStyle:ee,mainGameStyle:ne}=t.getPropsByDevice(W,u),te=B||{},{positionTurnDesc:re}=te,oe=j(te,["positionTurnDesc"]),{loading:ae,currentItemClick:ie,turnCount:se,loadingInitGame:le,onClickGachaGameItem:me,formFields:ce,isShowForm:de,setIsShowForm:ue,handlePlayGame:pe,setCurrentItemClick:ge,listItemOpened:fe,totalPercentage:ye}=i.useGachaGame(w,{popupResponse:T,configStorage:M,wrapperRef:d,isEditor:D,delayToShowPrizePopup:e=>{F===o.AnimationTypeEnum.flip?setTimeout(e,a.CARD_TRANSITION_TIME):e()},animationType:F,bypassShowParticipantForm:L}),he=(n,t,r)=>{var a;const i=fe[r];return e.jsx(G,{width:"custom"===K?Z:H,height:"custom"===K?J:H,children:e.jsxs(O,{flipped:!!i&&F===o.AnimationTypeEnum.flip,children:[e.jsx(A,{onClick:()=>!D&&me(r),commonStyle:ee,children:e.jsx(I,{loadingImage:ie===r&&ae,width:H/2,src:i&&F===o.AnimationTypeEnum.transform?null==t?void 0:t.src:null==n?void 0:n.src,alt:i&&F===o.AnimationTypeEnum.transform?i.name:""})}),e.jsx(C,{commonStyle:b(b({},ee),q),children:e.jsx(I,{width:H/2,src:(null==i?void 0:i.id)?(null==(a=i.image)?void 0:a.src)||i.name:null==t?void 0:t.src,alt:(null==i?void 0:i.name)||""})})]})},r)};return e.jsx(e.Fragment,{children:(D||(ye||0)<=100)&&e.jsxs(v,(we=b({},W),Se={ref:d,commonStyle:U,alignment:X,children:[le&&e.jsx(s.GameLoading,{}),e.jsx(l.PercentageWarning,{percentageToShowWarning:g}),e.jsxs(P,{enableOpacity:le||g>0,children:[re===o.PositionTurnDesc.above&&e.jsx(m.TurnDesc,{isEditor:D,turnCount:se,showTurn:x,turnDesc:_,gameStyle:oe}),e.jsx(E,{column:Y,rowGap:Q,columnGap:V,commonStyle:ne,children:(()=>{switch(N){case o.ImageModeEnum.single:return Array(z*Y).fill(1).map(((e,n)=>he(k,$,n)));case o.ImageModeEnum.multiple:return R.map(((e,n)=>he(e,$,n)));default:return[]}})()}),re===o.PositionTurnDesc.below&&e.jsx(m.TurnDesc,{isEditor:D,turnCount:se,showTurn:x,turnDesc:_,gameStyle:oe})]}),e.jsx(c.PopupParticipantInfo,{gameId:w,isUseTheme:h,isShowForm:de,setIsShowForm:ue,loading:ae,formFields:ce,handlePlayGame:e=>pe(e,ie),onFinishClose:()=>ge(void 0)}),S]},f(we,y(Se))))});var we,Se};x.displayName="LuckyMoney";const v=p.default.div((({commonStyle:e,alignment:n})=>`\n    position: relative;\n    user-select: none;\n    display: flex;\n    justify-content: ${d.MAPPING_ALIGNMENT_FLEX[n||t.Alignment.center]};\n    ${t.getStyle(e)}\n  `)),I=p.default.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  justify-self: center;
  ${({loadingImage:e})=>e?"animation: box-body 1s ease 0s infinite alternate;":""}
  @keyframes box-body {
    0% {
      transform: translate3d(0%, 0%, 0) rotate(0deg);
    }
    20% {
      transform: translate3d(0%, 15%, 0) rotate(15deg);
    }
    40% {
      transform: translate3d(0%, -10%, 0) rotate(0deg);
    }
    50% {
      transform: translate3d(0%, 0%, 0) rotate(0deg);
    }
    60% {
      transform: translate3d(0%, 15%, 0) rotate(-15deg);
    }
    80% {
      transform: translate3d(0%, -10%, 0) rotate(0deg);
    }
    100% {
      transform: translate3d(0%, 0%, 0) rotate(0deg);
    }
  }
`,P=p.default.div((({enableOpacity:e})=>`\n    max-width: 100%;\n    ${e?"opacity: 0.3;":""}\n  `)),E=p.default.div((({column:e,commonStyle:n,columnGap:r,rowGap:o})=>`\n    width: 100%;\n    grid-template-columns: repeat(${e}, minmax(0px, 1fr));\n    display: grid;\n    gap: ${null!=o?o:a.PADDING_HORIZONTAL_ITEM}px ${null!=r?r:24}px;\n    ${n?t.getStyle(n):"background-color: #9B0101;border-radius: 40px;padding: 16px;"}\n  `)),G=p.default.div((({width:e,height:n})=>`\n  width: ${e}px;\n  height: ${n}px;\n  perspective: 1000px;\n`)),O=p.default.div((({flipped:e})=>`\nwidth: 100%;\nheight: 100%;\nposition: relative;\ntransform-style: preserve-3d;\ntransition: transform ${a.CARD_TRANSITION_TIME/1e3}s;\ntransform: ${e?"rotateY(180deg)":"rotateY(0)"};\n`)),D=p.default.div`
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`,A=p.default(D)((({commonStyle:e})=>`\n  color: white;\n  cursor: pointer;\n  &:hover {\n    color: #fff;\n    img {\n      transform: scale(1.2);\n      transition: transform 0.2s;\n    }\n  }\n  ${e?t.getStyle(e):"border-radius: 30%;background-color: #ad200a;padding: 1rem;"}\n`)),C=p.default(D)((({commonStyle:e})=>`\n  color: white;\n  transform: rotateY(180deg);\n  ${e?t.getStyle(e):"border-radius: 30%;padding: 1rem;background-color: #ffae00;"}\n`));exports.LuckyMoney=x;


/***/ }),

/***/ 315304:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(85097),r=__webpack_require__(212951),n=__webpack_require__(891987),o=__webpack_require__(85167);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var u=l(r);const a=u.default.div((({maskStyle:e})=>`\n   ${t.getStyle(e)}\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 0;\n  `)),i=u.default.div((({wrapperStyle:e})=>`\n  width: 550px;\n  max-width: 100%;\n  height: 100%;\n  margin: 0 auto;\n  position: relative;\n  ${t.getStyle(e)}\n`));exports.Backdrop=({showCloseIcon:r,maskStyle:l,handleClosePopup:u,showPopup:s,animationConfig:c,isEditor:d,selectPopup:p,setShowMainPopupContent:f,showMainPopupContent:m})=>{const{device:v}=t.useStore(),h=n.useRef(),y=n.useRef(null),S=n.useRef(null),[w,x]=n.useState(),[C,g]=n.useState(!1),{totalFrame:j,showButtonClose:k,wrapperStyle:E,frameShowPopup:P,url:M}=c||{};n.useEffect((()=>{o.loadLottieFromCDN().then((e=>{S.current=e,g(!0)})).catch((e=>{console.error("Failed to load Lottie:",e)}))}),[]);const b=n.useCallback((async()=>{if(M)try{const e=await fetch(M),t=await e.json();x({url:M,data:t})}catch(e){x(void 0)}}),[M]),q=n.useCallback((()=>{var e,t;if(!y.current||!w||!S.current)return;null==(t=null==(e=h.current)?void 0:e.destroy)||t.call(e),h.current=S.current.loadAnimation({container:y.current,animationData:w.data,renderer:"svg",loop:!1,rendererSettings:{preserveAspectRatio:"xMidYMid slice"},initialSegment:[d?j:0,j]});const r=d?0:P;let n=!1;h.current.addEventListener("enterFrame",(()=>{Math.ceil(h.current.currentFrame)!==r||n||(n=!0,null==f||f(!0))})),h.current.addEventListener("complete",(()=>{n||(n=!0,null==f||f(!0))}))}),[w,P,d,f,j]);return n.useEffect((()=>{M!==(null==w?void 0:w.url)&&b()}),[null==w?void 0:w.url,b,M]),n.useEffect((()=>{var e,t;s&&C?q():(null==(t=null==(e=h.current)?void 0:e.destroy)||t.call(e),m&&f(!1))}),[w,C,q,f,s]),n.useEffect((()=>{var e,t;d&&C&&(null==(t=null==(e=h.current)?void 0:e.destroy)||t.call(e),setTimeout((()=>{q()}),250))}),[v,d,C,q,M]),e.jsx(a,{maskStyle:l,onClick:()=>{d?p():r||k||u()},children:e.jsx(i,{wrapperStyle:E,ref:y},(null==w?void 0:w.url)||M||"popup-animation")})};


/***/ }),

/***/ 823413:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),o=__webpack_require__(85097),n=__webpack_require__(891987),r=__webpack_require__(85167),a=__webpack_require__(315304),i=__webpack_require__(705478);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=s(t),u=s(n),p=Object.defineProperty,c=Object.defineProperties,d=Object.getOwnPropertyDescriptors,f=Object.getOwnPropertySymbols,m=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,y=(e,t,o)=>t in e?p(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o,b=(e,t)=>{for(var o in t||(t={}))m.call(t,o)&&y(e,o,t[o]);if(f)for(var o of f(t))g.call(t,o)&&y(e,o,t[o]);return e},h=(e,t)=>c(e,d(t)),v=(e,t)=>{var o={};for(var n in e)m.call(e,n)&&t.indexOf(n)<0&&(o[n]=e[n]);if(null!=e&&f)for(var n of f(e))t.indexOf(n)<0&&g.call(e,n)&&(o[n]=e[n]);return o};const C=u.default.forwardRef(((t,s)=>{var l=t,{showCloseIcon:u,isEditorMode:p,maskStyle:c,selectPopup:d,enableLightConfig:f}=l,m=v(l,["showCloseIcon","isEditorMode","maskStyle","selectPopup","enableLightConfig"]);const{device:g}=o.useStore(),y=o.getPropsByDevice(m,g),{animationConfig:C}=y,j=v(y,["animationConfig"]),[P,x]=n.useState(!1);return n.useEffect((()=>{(null==C?void 0:C.url)&&r.loadLottieFromCDN()}),[null==C?void 0:C.url]),e.jsx(i.PopupV1,h(b({ref:s},h(b({},j),{showCloseIcon:u,isEditorMode:p,maskStyle:c})),{customConditionShowMainPopup:e=>(null==C?void 0:C.url)?e&&P:e,customRenderBackdrop:t=>e.jsx(a.Backdrop,b({selectPopup:d,maskStyle:c,showCloseIcon:u,isEditor:p,animationConfig:C,setShowMainPopupContent:x,showMainPopupContent:P},t)),customContent:f&&!p?e.jsx(w,{isEditor:p}):null,customCss:"transform-style: preserve-3d;"}))}));C.displayName="PopupGame";const w=l.default.div((({isEditor:e})=>`\n  background-image: url(https://lh3.googleusercontent.com/N6cUuCuGNRluhnwQHCbR6d-Q0CciO5vzd06aJ_5WGoRoL1xy5dRXwD5tMUzsT65V6T2zbN71HEWmNtjXW0JlETkKl8eJ8hSIyA=rw-w560);\n  position: absolute;\n  width: 180%;\n  height: 180%;\n  transform: translateZ(-10px);\n  top: -40%;\n  left: -40%;\n  background-position: center;\n  background-size: contain;\n  transition: opacity 1s ease-in;\n  opacity: inherit; \n  ${e?"":"animation: rotate-light 15s infinite linear;"}\n\n  @keyframes rotate-light {\n    0% {\n      transform: translateZ(-10px) rotate(0deg) scale(1);\n    }\n    25% {\n      transform: translateZ(-10px) rotate(90deg) scale(0.8, 1.3);\n    }\n    50% {\n      transform: translateZ(-10px) rotate(180deg) scale(1);\n    }\n    75% {\n      transform: translateZ(-10px) rotate(270deg) scale(0.8, 1.3);\n    }\n    100% {\n      transform: translateZ(-10px) rotate(360deg) scale(1);\n    }\n  }\n`));exports.PopupGame=C;


/***/ }),

/***/ 871847:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(85097),t=__webpack_require__(71880),n=Object.defineProperty,o=Object.defineProperties,i=Object.getOwnPropertyDescriptors,s=Object.getOwnPropertySymbols,a=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,c=(e,r,t)=>r in e?n(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;const p=n=>{const{device:p}=r.useStore(),{alignment:l}=r.getPropsByDevice(n,p);return e.jsx(t.TreasureHunting,(b=((e,r)=>{for(var t in r||(r={}))a.call(r,t)&&c(e,t,r[t]);if(s)for(var t of s(r))u.call(r,t)&&c(e,t,r[t]);return e})({},n),o(b,i({alignment:l}))));var b};p.displayName="PotSmashing",exports.PotSmashing=p;


/***/ }),

/***/ 71880:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(108984),r=__webpack_require__(212951),t=__webpack_require__(85097),o=__webpack_require__(891987),a=__webpack_require__(667481),i=__webpack_require__(77363),s=__webpack_require__(259901),l=__webpack_require__(984615),c=__webpack_require__(673923),m=__webpack_require__(648576),u=__webpack_require__(879774);function d(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var p=d(r),g=Object.defineProperty,f=Object.defineProperties,h=Object.getOwnPropertyDescriptors,y=Object.getOwnPropertySymbols,j=Object.prototype.hasOwnProperty,b=Object.prototype.propertyIsEnumerable,w=(e,n,r)=>n in e?g(e,n,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[n]=r,x=(e,n)=>{for(var r in n||(n={}))j.call(n,r)&&w(e,r,n[r]);if(y)for(var r of y(n))b.call(n,r)&&w(e,r,n[r]);return e},P=(e,n)=>{var r={};for(var t in e)j.call(e,t)&&n.indexOf(t)<0&&(r[t]=e[t]);if(null!=e&&y)for(var t of y(e))n.indexOf(t)<0&&b.call(e,t)&&(r[t]=e[t]);return r};const S=r=>{const a=o.useRef(),{device:u}=t.useStore(),d=r,{percentageToShowWarning:p,isUseTheme:g,gameId:y,children:j,response:b,showTurn:w=!1,isEditor:S=!1,configStorage:D,desktop:q,mobile:F,imageInit:G,imageResult:C,turnDesc:k,bypassShowParticipantForm:E=!1}=d,$=P(d,["percentageToShowWarning","isUseTheme","gameId","children","response","showTurn","isEditor","configStorage","desktop","mobile","imageInit","imageResult","turnDesc","bypassShowParticipantForm"]),{commonStyle:W,columnCount:_=4,rowCount:A=2,gameStyle:M,alignment:R}=t.getPropsByDevice({desktop:q,mobile:F},u),L=M||{},{positionTurnDesc:N}=L,H=P(L,["positionTurnDesc"]),{loading:U,currentItemClick:X,turnCount:B,loadingInitGame:z,onClickGachaGameItem:J,formFields:K,isShowForm:Q,setIsShowForm:V,handlePlayGame:Y,setCurrentItemClick:Z,listItemOpened:ee,totalPercentage:ne}=i.useGachaGame(y,{popupResponse:b,configStorage:D,wrapperRef:a,isEditor:S,bypassShowParticipantForm:E});return e.jsx(e.Fragment,{children:(S||(ne||0)<=100)&&e.jsxs(T,(re=x({},$),te={ref:a,commonStyle:W,alignment:R,children:[z&&e.jsx(s.GameLoading,{}),e.jsx(l.PercentageWarning,{percentageToShowWarning:p}),e.jsxs(I,{enableOpacity:z||p>0,column:_,children:[N===n.PositionTurnDesc.above&&e.jsx(c.TurnDesc,{isEditor:S,turnCount:B,showTurn:w,turnDesc:k,gameStyle:H}),e.jsx(O,{column:_,children:Array(A*_).fill(1).map(((n,r)=>((n,r)=>e.jsx(v,{width:null==n?void 0:n.width,src:null==n?void 0:n.src,onClick:()=>!S&&J(r),loadingImage:X===r&&U},r))(ee[r]?C:G,r)))}),N===n.PositionTurnDesc.below&&e.jsx(c.TurnDesc,{isEditor:S,turnCount:B,showTurn:w,turnDesc:k,gameStyle:H})]}),e.jsx(m.PopupParticipantInfo,{gameId:y,isUseTheme:g,isShowForm:Q,setIsShowForm:V,loading:U,formFields:K,handlePlayGame:e=>Y(e,X),onFinishClose:()=>Z(void 0)}),j]},f(re,h(te))))});var re,te};S.displayName="TreasureHunting";const T=p.default.div((({commonStyle:e,alignment:n})=>`\n  position: relative;\n  user-select: none;\n  display: flex;\n  justify-content: ${u.MAPPING_ALIGNMENT_FLEX[n||t.Alignment.center]};\n  ${t.getStyle(e)}\n`)),v=p.default.img((({loadingImage:e})=>`\ntransition: transform 0.2s;\ncursor: pointer;\nmax-width: 100%;\njustify-self: center;\n&:hover {\n  transform: scale(1.2);\n}\n${e?"animation: box-body 1s ease 0s infinite alternate;":""}\n@keyframes box-body {\n  0% {\n    transform: translate3d(0%, 0%, 0) rotate(0deg);\n  }\n  20% {\n    transform: translate3d(0%, 15%, 0) rotate(15deg);\n  }\n  40% {\n    transform: translate3d(0%, -10%, 0) rotate(0deg);\n  }\n  50% {\n    transform: translate3d(0%, 0%, 0) rotate(0deg);\n  }\n  60% {\n    transform: translate3d(0%, 15%, 0) rotate(-15deg);\n  }\n  80% {\n    transform: translate3d(0%, -10%, 0) rotate(0deg);\n  }\n  100% {\n    transform: translate3d(0%, 0%, 0) rotate(0deg);\n  }\n}\n`)),I=p.default.div((({column:e,enableOpacity:n})=>`\n  max-width: 100%;\n  width: ${e*a.MAX_WIDTH_ITEM}px;\n  ${n?"opacity: 0.3":""}\n`)),O=p.default.div((({column:e})=>`\n  width: 100%;\n  grid-template-columns: repeat(${e}, minmax(0px, 1fr));\n  gap: 32px ${100/e/2}%;\n  display: grid;\n`));exports.TreasureHunting=S;


/***/ }),

/***/ 108984:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=(e=>(e[e.luckyDraw=1]="luckyDraw",e[e.treasureHunting=2]="treasureHunting",e[e.flipLuckyMoney=3]="flipLuckyMoney",e[e.potSmashing=4]="potSmashing",e))(e||{}),n=(e=>(e.flip="flip",e.none="none",e.transform="transform",e))(n||{}),o=(e=>(e.above="above",e.below="below",e))(o||{}),t=(e=>(e.basic="basic",e.red="red",e.blue="blue",e.pot="pot",e))(t||{}),r=(e=>(e.single="single",e.multiple="multiple",e))(r||{});exports.AnimationTypeEnum=n,exports.EntryTemplateEnum=t,exports.GameTypeEnum=e,exports.ImageModeEnum=r,exports.PositionTurnDesc=o;


/***/ }),

/***/ 85167:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));const t=["https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie_light.min.js","https://unpkg.com/lottie-web@5.12.2/build/player/lottie_light.min.js"];let o=null,e=!1;const l=t=>new Promise(((o,e)=>{const l=document.createElement("script");l.src=t,l.async=!0,l.onload=()=>o(window.lottie),l.onerror=()=>{l.remove(),e(new Error(`Failed to load Lottie from: ${t}`))},document.head.appendChild(l)}));exports.loadLottieFromCDN=async()=>window.lottie?window.lottie:(o&&e||(e=!0,o=(async()=>{for(const o of t)try{const t=await l(o);return e=!1,t}catch(t){console.warn(`Lottie CDN failed: ${o}, trying next...`)}throw e=!1,o=null,new Error("Failed to load Lottie from all CDN sources")})()),o);


/***/ }),

/***/ 848818:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}Object.defineProperty(exports, "__esModule", ({value:!0}));var o=e(__webpack_require__(212951));const t=o.default.div((({columnCount:e,gap:o})=>`\n    display: grid;\n    grid-template-columns: repeat(${e}, 1fr);\n    grid-gap: ${o}px;\n  `)),n=o.default.div((({hover:e})=>`\n  position: relative;\n  padding-top: 100%;\n  overflow: hidden;\n  &:hover {\n    ${(null==e?void 0:e.zIndex)?`z-index: ${e.zIndex};`:""}\n    ${(null==e?void 0:e.zoom)?`transform: scale(${e.zoom/100})`:""}\n  }\n`)),d=o.default.div`
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
`;exports.Block=n,exports.Grid=t,exports.ImageWrapper=d;


/***/ }),

/***/ 472658:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}Object.defineProperty(exports, "__esModule", ({value:!0}));var t=e(__webpack_require__(212951));const n=t.default.div((({columnCount:e,gap:t})=>`\n    display: grid;\n    grid-template-columns: repeat(${e}, auto);\n    grid-column-gap: ${t}px;\n    height: calc(100% + ${t}px);\n    margin-bottom: ${-t}px;\n  `)),o=t.default.div((({gap:e})=>`\n  margin-bottom: ${e}px;\n  display: flex;\n  `));exports.Masonry=n,exports.MasonryImageWrapper=o;


/***/ }),

/***/ 275814:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),o=__webpack_require__(85097),t=__webpack_require__(891987),i=__webpack_require__(472658),n=__webpack_require__(848818),l=__webpack_require__(586753);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=a(r),d=Object.defineProperty,c=Object.defineProperties,u=Object.getOwnPropertyDescriptors,m=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,y=Object.prototype.propertyIsEnumerable,v=(e,r,o)=>r in e?d(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,f=(e,r)=>{for(var o in r||(r={}))p.call(r,o)&&v(e,o,r[o]);if(m)for(var o of m(r))y.call(r,o)&&v(e,o,r[o]);return e},h=(e,r)=>c(e,u(r));const j=4,g=t.forwardRef(((r,t)=>{const{device:a}=o.useStore(),s=o.getPropsByDevice(r,a),{columnCount:d=j,gap:c=20,layout:u="masonry",images:v=[],zoomPreview:g,zoomHover:b,allowDownload:P,commonStyle:z}=s,O=((e,r)=>{var o={};for(var t in e)p.call(e,t)&&r.indexOf(t)<0&&(o[t]=e[t]);if(null!=e&&m)for(var t of m(e))r.indexOf(t)<0&&y.call(e,t)&&(o[t]=e[t]);return o})(s,["columnCount","gap","layout","images","zoomPreview","zoomHover","allowDownload","commonStyle"]),I=(S=d,!Number.isInteger(S)||S<1?j:S>16?16:S);var S;const{displayItems:W}=o.useTimeVisibility(v,null==r?void 0:r.isEditor);return e.jsx(x,h(f({isEditor:null==r?void 0:r.isEditor,ref:t},O),{commonStyle:z,children:e.jsx(o.PreviewGroupProvider,{images:v,children:(()=>{const r=(null==W?void 0:W.length)||1;switch(u){case"grid":default:return e.jsx(n.Grid,{columnCount:I,gap:c,children:W.map(((t,i)=>e.jsx(n.Block,{hover:{zoom:b,zIndex:r},children:e.jsx(n.ImageWrapper,{children:e.jsx(o.BreakpointWidthProvider,{sWidth:{value:100/I,unit:"%"},mWidth:{value:100/I,unit:"%"},children:e.jsx(l.Image,h(f({},t),{zoomPreview:g,allowDownload:P,commonStyle:{display:"block",hover:{zoom:b,zIndex:r}}}))})})},i)))});case"masonry":const t=w(W,I);return e.jsx(i.Masonry,{columnCount:I,gap:c,children:t.map(((t,n)=>e.jsx("div",{children:t.map(((t,n)=>e.jsx(i.MasonryImageWrapper,{gap:c,children:e.jsx(o.BreakpointWidthProvider,{sWidth:{value:100/I,unit:"%"},mWidth:{value:100/I,unit:"%"},children:e.jsx(l.Image,h(f({},t),{zoomPreview:g,allowDownload:P,commonStyle:{display:"block",hover:{zoom:b,zIndex:r}}}))})},n)))},n)))})}})()})}))})),x=s.default.div((({commonStyle:e,isEditor:r})=>`${o.getStyle(e)}\n   ${r?"> * {pointer-events: none;}":""}\n  `)),w=(e,r)=>{const o=Array.from(Array(r),(()=>[]));for(let t=0;t<e.length;t++)o[t%r][Math.floor(t/r)]=e[t];return o};g.displayName="Gallery",exports.Gallery=g;


/***/ }),

/***/ 506377:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(800656),t=__webpack_require__(85097);const i=[{id:"5eBqBWoa",name:e.t("Trang chủ"),target:"SELF",isHidden:!1,linkType:"PAGE",page:{id:455,isHomepage:!0,slug:null}},{id:"iCScxX63",name:"Blog",target:"BLANK",linkType:"PAGE",page:{id:456,isHomepage:!1,slug:"add-page-test"}},{id:"LvTwfsZx",name:"About",target:"BLANK",isHidden:!0,linkType:"PAGE",page:{id:458,slug:"test-122312",isHomepage:!1}},{id:"7DWki3lv",name:"Services",target:"SELF",isHidden:!1,linkType:"PAGE",page:{id:419,slug:"test-add-page-3",isHomepage:!1}},{id:"LebWjo9l",name:"Child1",linkType:"PAGE",parentId:"7DWki3lv",page:{id:459,slug:"test-12123",isHomepage:!1}},{id:"moar1sju",name:"Contact",target:"SELF",linkType:"PAGE",page:{id:460,slug:"test-123123123",isHomepage:!1}},{id:"aVtmfMh_",href:"https://vnshop.vn/thung-48-bich-sua-tuoi-tiet-trung-khong-duong-dalatmilk-220ml--s210201486?sku=210201486",name:"Child2",target:"BLANK",linkType:"LINK",nofollow:!0,parentId:"moar1sju"},{id:"IOm6L3zm",href:"https://vnshop.vn/thung-48-bich-sua-tuoi-tiet-trung-khong-duong-dalatmilk-220ml--s210201486?sku=210201486",name:"Child3",target:"BLANK",linkType:"LINK",nofollow:!0,parentId:"moar1sju"},{id:"Nuklf8V1",name:"Gallery",target:"SELF",linkType:"PAGE",page:{id:454,slug:"test-qiwueqw-queqwe",isHomepage:!1}},{id:"iR183_D0",href:"https://vnshop.vn/thung-48-bich-sua-tuoi-tiet-trung-khong-duong-dalatmilk-220ml--s210201486?sku=210201486",name:"Child4",target:"BLANK",isHidden:!0,linkType:"LINK",nofollow:!0,parentId:"Nuklf8V1"},{id:"1hr5sQFD",href:"https://vnshop.vn/thung-48-bich-sua-tuoi-tiet-trung-khong-duong-dalatmilk-220ml--s210201486?sku=210201486",name:"Child5",target:"BLANK",linkType:"LINK",nofollow:!0,parentId:"Nuklf8V1"},{id:"vx6PjNLA",name:"Lorem Ipsum",target:"SELF",isHidden:!1,linkType:"PAGE",page:{id:448,slug:"test-add-2",isHomepage:!1}}],n=i,o={stickyTop:!0,menuConfig:{commonStyle:{columnGap:32},align:t.Alignment.right},logoConfig:{show:!0,src:"https://tempi.vn/static/media/logo.2cc45380.png",align:t.Alignment.left,commonStyle:{width:100},spacingWithMenu:32},menuItemConfig:{commonStyle:{color:"#000000",hover:{color:"#008cff"}}},commonStyle:{backgroundColor:"#ffffff",padding:{top:30,right:16,bottom:30,left:16}}};exports.DEFAULT_GLOBAL_HEADER=o,exports.DEFAULT_MENU=n,exports.MOBILE_WIDTH=767,exports.defaultMenu=i;


/***/ }),

/***/ 436216:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(85097),o=__webpack_require__(877084),n=__webpack_require__(891987),t=__webpack_require__(10667),i=__webpack_require__(944315),l=__webpack_require__(440384),s=__webpack_require__(805416),a=__webpack_require__(649740),d=__webpack_require__(940785),u=__webpack_require__(271734),c=__webpack_require__(594684),g=__webpack_require__(367312),m=__webpack_require__(670284),j=__webpack_require__(171020);function p(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var v=p(o),f=Object.defineProperty,h=Object.defineProperties,x=Object.getOwnPropertyDescriptors,b=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,I=Object.prototype.propertyIsEnumerable,q=(e,r,o)=>r in e?f(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,w=(e,r)=>{for(var o in r||(r={}))y.call(r,o)&&q(e,o,r[o]);if(b)for(var o of b(r))I.call(r,o)&&q(e,o,r[o]);return e},O=(e,r)=>h(e,x(r));exports.GlobalHeader=o=>{const[p,f]=n.useState(!1),{commonStyle:h,logoConfig:x,menuConfig:b,menu:y=[],isEditingMode:I,stickyTop:q}=o||{},C=i.calculateGrid(o),M=v.default({open:p}),P=i.flattenToTreeMax2Level((y||[]).filter((e=>!e.isHidden))),{headerRef:H,headerHeight:L}=t.useHeaderPosition(q?l.PositionHeader.STICKY:l.PositionHeader.NORMAL);return n.useEffect((()=>{const e=e=>{var r,o;(null==(o=null==(r=null==H?void 0:H.current)?void 0:r.contains)?void 0:o.call(r,e.target))||f(!1)};return document.addEventListener("mousedown",e),()=>{document.removeEventListener("mousedown",e)}}),[H]),e.jsxs(e.Fragment,{children:[e.jsx(s.Header,{commonStyle:h,ref:H,grid:C,headerHeight:L,children:e.jsxs(a.Content,{grid:C,commonStyle:h,children:[(null==x?void 0:x.show)&&e.jsx(d.Logo,O(w({},I?{}:{href:"/"}),{grid:C,children:e.jsx(d.LogoImg,{alt:null==x?void 0:x.alt,src:r.getImageUrlFromGoogleUserContent(null==x?void 0:x.src,null==x?void 0:x.googleImageParams),grid:C,loading:"lazy"})})),e.jsx(u.ToggleButton,{className:M,grid:C,onClick:()=>f(!p)}),e.jsx(c.Navbar,{grid:C,children:e.jsx(g.Menu,{className:M,grid:C,children:P.map((r=>{var o;return e.jsx(m.Item,{children:(null==(o=null==r?void 0:r.children)?void 0:o.length)>0?e.jsx(j.DropdownItem,{item:r,grid:C,alignMenu:null==b?void 0:b.align,isEditingMode:I,backgroundColor:h.backgroundColor||"white"}):e.jsx(m.ItemLabel,{children:e.jsx(m.ItemContentWrapper,{alignMenu:null==b?void 0:b.align,children:e.jsxs(m.ItemContent,O(w(O(w({alignMenu:null==b?void 0:b.align},I?{}:{href:i.getUrlOfMenuItem(r)}),{grid:C,target:i.getTargetUrl(r.target)}),"LINK"===(null==r?void 0:r.linkType)&&r.nofollow?{rel:"nofollow"}:{}),{children:[(null==r?void 0:r.iconUrl)&&e.jsx(m.ItemIcon,{src:r.iconUrl,loading:"lazy"}),null==r?void 0:r.name]}))})})},r.id)}))})})]})}),e.jsx("div",{className:"placeholder"})]})};


/***/ }),

/***/ 649740:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(212951),n=__webpack_require__(85097),t=__webpack_require__(506377);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const r=i(e).default.div((({grid:e,commonStyle:i})=>{const{gridArea:r,navigationGridTemplateColumns:a,width:d,mobileNavigationGridTemplateColumns:o}=e;return`\n    position: relative;\n    display: grid;\n    grid-area: ${r};\n    grid-template-columns: ${a};\n    align-items: center;\n    width: 100%;\n    max-width: ${d||1240}px;\n    margin: 0 auto;\n    \n    ${n.getStyle({padding:i.padding})};\n  \n    @media screen and (max-width: ${t.MOBILE_WIDTH}px){\n      grid-template-columns: ${o};\n    }\n  `}));exports.Content=r;


/***/ }),

/***/ 171020:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(212951),r=__webpack_require__(85097),t=__webpack_require__(506377),o=__webpack_require__(944315),i=__webpack_require__(670284);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=l(n),d=Object.defineProperty,s=Object.defineProperties,c=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,m=(e,n,r)=>n in e?d(e,n,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[n]=r,x=(e,n)=>{for(var r in n||(n={}))p.call(n,r)&&m(e,r,n[r]);if(u)for(var r of u(n))g.call(n,r)&&m(e,r,n[r]);return e},b=(e,n)=>s(e,c(n));const f=a.default(i.ItemLabel)`
  cursor: pointer;

  input {
    display: none;
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
  }

  svg {
    transition: transform 0.3s;
  }

  @media screen and (min-width: ${t.MOBILE_WIDTH}px) {
    &:hover {
      .sub-menu {
        display: block;

        ul {
          max-height: 400px;
          overflow-y: auto;
        }
      }
      svg {
        transform: rotate(180deg);
      }
    }
  }

  @media screen and (max-width: ${t.MOBILE_WIDTH}px) {
    input[type='checkbox']:checked ~ {
      .sub-menu {
        display: block;
      }

      div {
        svg {
          transform: rotate(180deg);
        }
      }
    }
  }
`,h=({alignMenu:n,color:t})=>{let o,i;switch(n){case r.Alignment.left:o="2/3";break;case r.Alignment.center:o="3/4";break;case r.Alignment.right:i="1",o="2/3"}return e.jsx("svg",{width:"10",height:"7",viewBox:"0 0 10 7",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-v-b930357f":"",style:{margin:"0 0.2rem",gridColumn:o,gridRow:i,color:t},children:e.jsx("path",{d:"M5 6.5L0.669873 0.5L9.33013 0.500001L5 6.5Z",fill:"currentColor","data-v-b930357f":""})})},v=a.default.div((({grid:e})=>`\n  position: absolute;\n  z-index: 1;\n  display: none;\n  padding-top: 10px;\n  padding-right: 16px;\n  padding-bottom: 48px;\n  margin-left: ${e.menuItemSpacing}px;\n\n  @media screen and (max-width: ${t.MOBILE_WIDTH}px){\n    position: unset;\n    padding: 8px 0;\n  }\n`)),j=a.default.ul((({grid:e,backgroundColor:n})=>`\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 16px 24px;\n  gap: 10px;\n  list-style: none;\n  border-radius: 5px;\n  box-shadow: 0 2px 10px #0000001a;\n  animation: expand-5b652f62 0.2s cubic-bezier(0.45, 0, 0.1, 1);\n  background-color: ${n};\n\n\n  @media screen and (max-width: ${t.MOBILE_WIDTH}px) {\n    padding: 0;\n    background-color: transparent;\n    box-shadow: none;\n    align-items: ${e.navigationJustifySelf};\n  }\n`));exports.DropdownItem=({item:n,grid:r,alignMenu:t,isEditingMode:l,backgroundColor:a})=>{var d;const s=`dropdown-${n.id}`,{menuColor:c}=r;return e.jsx(e.Fragment,{children:e.jsxs(f,{htmlFor:s,children:[e.jsx("input",{type:"checkbox",id:s,value:""}),e.jsxs(i.ItemContentWrapper,{alignMenu:t,hoverColor:r.menuHoverColor,children:[e.jsxs(i.ItemContent,b(x(x({grid:r,alignMenu:t,target:o.getTargetUrl(n.target)},l?{}:{href:o.getUrlOfMenuItem(n)}),"LINK"===(null==n?void 0:n.linkType)&&n.nofollow?{rel:"nofollow"}:{}),{children:[(null==n?void 0:n.iconUrl)&&e.jsx(i.ItemIcon,{src:n.iconUrl,loading:"lazy"}),null==n?void 0:n.name]})),e.jsx(h,{alignMenu:t,color:c})]}),e.jsx(v,{className:"sub-menu",grid:r,children:e.jsx(j,{grid:r,backgroundColor:a,children:null==(d=null==n?void 0:n.children)?void 0:d.map(((n,a)=>e.jsx(i.Item,{children:e.jsx(i.ItemLabel,{children:e.jsx(i.ItemContentWrapper,{alignMenu:t,children:e.jsxs(i.ItemContent,b(x(x({grid:b(x({},r),{menuItemSpacing:null}),alignMenu:t,target:o.getTargetUrl(null==n?void 0:n.target)},l?{}:{href:o.getUrlOfMenuItem(n)}),"LINK"===(null==n?void 0:n.linkType)&&n.nofollow&&{rel:"nofollow"}),{children:[(null==n?void 0:n.iconUrl)&&e.jsx(i.ItemIcon,{src:n.iconUrl,loading:"lazy"}),null==n?void 0:n.name]}))})})},a)))})})]})})};


/***/ }),

/***/ 805416:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(212951),t=__webpack_require__(85097);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var r=n(e),o=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable;const d=r.default.header((({commonStyle:e,headerHeight:n})=>{const r=((e,t)=>{var n={};for(var r in e)i.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&o)for(var r of o(e))t.indexOf(r)<0&&a.call(e,r)&&(n[r]=e[r]);return n})(e,["padding"]);return`\n    display: grid;\n    grid-area: 1/1/-1/-1;\n    grid-template-rows: 100%;\n    grid-template-columns: 100%;\n    width: 100%;\n    transition: box-shadow 0.15s linear;\n  \n    &.sticky {\n      position: fixed;\n      top: 0;\n      width: 100%;\n      z-index: 100;\n    }\n    ${n?`\n    &.sticky + .placeholder{\n      padding-bottom: ${n}px;\n    }\n    `:""}\n    \n    ${t.getStyle(r)}\n  `}));exports.Header=d;


/***/ }),

/***/ 670284:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(212951),n=__webpack_require__(85097),t=__webpack_require__(506377);function r(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=r(e);const o=i.default.li`
  user-select: none;
`,l=i.default.label`
  display: block;
`,a=i.default.div((({alignMenu:e,hoverColor:r})=>`\n  display: flex;\n  align-items: center;\n  text-align: left;\n  @media screen and (max-width: ${t.MOBILE_WIDTH}px) {\n    grid-template-columns: \n      ${e===n.Alignment.left?"auto 1fr auto":""}\n      ${e===n.Alignment.center?"1fr auto 1fr":""}\n      ${e===n.Alignment.right?"1fr auto":""}\n    ;\n    display: grid;\n  }\n\n  ${r?`a:hover ~ svg{\n    color: ${r} !important;\n  }`:""}\n`)),m=i.default.a((({grid:e,alignMenu:r})=>{const{menuItemSpacing:i,menuColor:o,menuHoverColor:l,mobileNavigationTextAlign:a}=e||{};return`\n  position: relative;\n  align-self: center;\n  margin: 0 0 0 ${i}px;\n  text-decoration: none;\n  white-space: nowrap;\n  cursor: pointer;\n  color: ${o};\n\n  &:hover {\n    text-decoration: underline;\n    text-underline-offset: 7px;\n    color: ${l};\n  }\n\n  @media screen and (max-width: ${t.MOBILE_WIDTH}px){\n    margin: 0;\n    text-align: ${a};\n\n    grid-column: \n    ${r===n.Alignment.left?"1/2":""}\n    ${r===n.Alignment.center?"2/3":""}\n    ${r===n.Alignment.right?"3/4":""}\n  }\n`})),u=i.default.img`
  width: 20px;
  height: 20px;
  margin-right: 0.4em;
`;exports.Item=o,exports.ItemContent=m,exports.ItemContentWrapper=a,exports.ItemIcon=u,exports.ItemLabel=l;


/***/ }),

/***/ 940785:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

function o(o){return o&&"object"==typeof o&&"default"in o?o:{default:o}}Object.defineProperty(exports, "__esModule", ({value:!0}));var n=o(__webpack_require__(212951));const e=n.default.a((({grid:o})=>{const{logoGridRow:n,logoGridColumn:e,logoJustifySelf:t,logoSpacing:i,logoWidth:l}=o;return`\n    display: inline-flex;\n    grid-row: ${n};\n    grid-column: ${e};\n    align-self: center;\n    justify-self: ${t};\n    margin: ${i};\n    width: ${l}px;\n  `})),t=n.default.img((({grid:o})=>{const{logoImageObjectPosition:n}=o;return`\n    width: 100%;\n    height: 100%;\n  \n    vertical-align: middle;\n    object-fit: contain;\n    object-position: ${n};\n  `}));exports.Logo=e,exports.LogoImg=t;


/***/ }),

/***/ 367312:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var n=__webpack_require__(212951),t=__webpack_require__(506377);function i(n){return n&&"object"==typeof n&&"default"in n?n:{default:n}}const e=i(n).default.ul((({grid:n})=>{const{navigationTextAlign:i,mobileMenuItemSpacing:e,mobileNavigationJustifySelf:a,paddingRight:o,mobileNavigationTextAlign:r,backgroundOverlayOpacity:s,mobileBackground:p}=n;return`\n    padding-left: unset;\n    display: inline-flex;\n    flex-flow: row wrap;\n    row-gap: 16px;\n    align-items: center;\n    height: 100%;\n    text-align: ${i};\n    list-style: none;\n  \n    @media screen and (max-width: ${t.MOBILE_WIDTH}px) {\n      position: absolute;\n      top: 100%;\n      right: 0;\n      left: 0;\n      z-index: 1;\n      display: grid;\n      grid-gap: ${e||16}px 0;\n      justify-self: ${a};\n      width: auto;\n      height: 0;\n      max-height: 450px;\n      padding: ${e||16}px ${e||16}px ${e||16}px ${o}px;\n      margin: 0;\n      overflow-y: auto;\n      text-align: ${r};\n      pointer-events: none;\n      background-size: cover;\n      box-shadow: 0 6px 14px -14px #0000001a;\n      opacity: 0;\n      transform: translateY(-1em);\n      transition-timing-function: cubic-bezier(.45,0,.1,1);\n      transition-duration: .2s;\n      transition-property: opacity,transform;\n      background: linear-gradient(rgba(0,0,0,${s}),rgba(0,0,0,${s})),${p} no-repeat top;\n  \n      &.open {\n        height: auto;\n        pointer-events: auto;\n        opacity: 1;\n        transform: translate(0);\n        transition-timing-function: cubic-bezier(.45,0,.1,1);\n        transition-duration: .2s;\n        transition-property: opacity,transform;\n      }\n    };\n  `}));exports.Menu=e;


/***/ }),

/***/ 594684:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var n=__webpack_require__(212951),e=__webpack_require__(506377);function t(n){return n&&"object"==typeof n&&"default"in n?n:{default:n}}const r=t(n).default.nav((({grid:n})=>{const{linksGridRow:t,linksGridColumn:r,navigationJustifySelf:i,menuItemSpacing:o}=n;return`\n    grid-row: ${t};\n    grid-column: ${r};\n    justify-self: ${i};\n    height: 100%;\n    margin-left: ${-1*o}px;\n  \n    @media screen and (max-width: ${e.MOBILE_WIDTH}px){\n      grid-row: unset;\n      grid-column: unset;\n    };\n  `}));exports.Navbar=r;


/***/ }),

/***/ 271734:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var n=__webpack_require__(561261),t=__webpack_require__(212951),e=__webpack_require__(506377);function r(n){return n&&"object"==typeof n&&"default"in n?n:{default:n}}var o=r(t),a=Object.defineProperty,s=Object.defineProperties,i=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,l=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,d=(n,t,e)=>t in n?a(n,t,{enumerable:!0,configurable:!0,writable:!0,value:e}):n[t]=e;const f=o.default.button((({grid:n})=>{const{linksGridRow:t,linksGridColumn:r,navigationJustifySelf:o,navigationTextAlign:a,menuColor:s}=n,i=t,p=r,l=o,u=a;return`\n  \n    display: none;\n    grid-row: ${t};\n    grid-column: ${r};\n    justify-self: ${o};\n    text-align: ${a}; \n  \n    width: 24px;\n    height: 18px;\n    cursor: pointer;\n    background-color: transparent;\n    transition: all .4s ease-in-out .1s;\n    transform: rotate(0);\n  \n    border: none;\n    outline: none;\n    box-shadow: none;\n    \n    &:focus{\n      outline: none;\n    }\n  \n    span{\n      position: absolute;\n      display: block;\n      width: 100%;\n      height: 2px;\n      background: ${s||"#7367f0"};\n      border-radius: 2px;\n      transition: all .25s ease-in-out .1s;\n      transform: rotate(0);\n      transform-origin: left center;\n    }\n  \n    span:nth-of-type(1){\n      top: 0;\n    } \n    span:nth-of-type(2){\n      top: 8px;\n    } \n    span:nth-of-type(3){\n      top: 16px;\n    } \n  \n    &.open {\n      span:nth-of-type(1){\n        top: -1px;\n        transform: rotate(45deg);\n      } \n      span:nth-of-type(2){\n        width: 0%;\n        opacity: 0;\n      } \n      span:nth-of-type(3){\n        transform: rotate(-45deg);\n      } \n    }\n    \n    @media screen and (max-width: ${e.MOBILE_WIDTH}px){\n        display: block;\n        grid-row: ${i};\n        grid-column: ${p};\n        justify-self: ${l};\n        text-align: ${u};\n    }\n    `}));exports.ToggleButton=t=>{return n.jsxs(f,(e=((n,t)=>{for(var e in t||(t={}))l.call(t,e)&&d(n,e,t[e]);if(p)for(var e of p(t))u.call(t,e)&&d(n,e,t[e]);return n})({},t),s(e,i({children:[n.jsx("span",{}),n.jsx("span",{}),n.jsx("span",{})]}))));var e};


/***/ }),

/***/ 944315:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097),n=Object.defineProperty,t=Object.defineProperties,i=Object.getOwnPropertyDescriptors,l=Object.getOwnPropertySymbols,o=Object.prototype.hasOwnProperty,r=Object.prototype.propertyIsEnumerable,a=(e,t,i)=>t in e?n(e,t,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[t]=i;const g=e=>{const n=e.split(" "),t={};return n[0]&&(t.paddingTop=parseInt(n[0].replace("px",""))),n[1]&&(t.paddingRight=parseInt(n[1].replace("px",""))),n[2]&&(t.paddingBottom=parseInt(n[2].replace("px",""))),n[3]&&(t.paddingLeft=parseInt(n[3].replace("px",""))),t},c=(n,t,i,l,o,r)=>{const a=("desktop"===o?i:r||i)+l,g=`minmax(${a}px, auto)`;switch(n){case e.Alignment.left:switch(t){case e.Alignment.left:return`${g} 1fr`;case e.Alignment.center:return`minmax(${a}px, 1fr) auto 1fr`;case e.Alignment.right:return`${g} 1fr`}case e.Alignment.center:switch(t){case e.Alignment.left:return`1fr ${g} 1fr`;case e.Alignment.center:return`1fr minmax(${i}px, auto) 1fr`;case e.Alignment.right:return`1fr ${g} 1fr`}case e.Alignment.right:switch(t){case e.Alignment.left:return`1fr ${g}`;case e.Alignment.center:return`1fr auto minmax(${a}px, 1fr)`;case e.Alignment.right:return`1fr ${g}`}}};exports.calculateGrid=n=>{var t,i,l,o,r,a,d,m,s,u,p,f,v,x;const b="30px 16px 30px 16px",h=null==(t=null==n?void 0:n.menuConfig)?void 0:t.align,{paddingTop:A,paddingRight:w,paddingBottom:y,paddingLeft:C}=g(b),$=null==(i=null==n?void 0:n.logoConfig)?void 0:i.show,k=null==(o=null==(l=null==n?void 0:n.logoConfig)?void 0:l.commonStyle)?void 0:o.width,I=null==(r=null==n?void 0:n.logoConfig)?void 0:r.spacingWithMenu,L=null==(a=null==n?void 0:n.logoConfig)?void 0:a.align,O=null==(m=null==(d=null==n?void 0:n.menuConfig)?void 0:d.commonStyle)?void 0:m.columnGap,S=null==(s=null==n?void 0:n.commonStyle)?void 0:s.backgroundColor,P=null==(p=null==(u=null==n?void 0:n.menuItemConfig)?void 0:u.commonStyle)?void 0:p.color,G=null==(x=null==(v=null==(f=null==n?void 0:n.menuItemConfig)?void 0:f.commonStyle)?void 0:v.hover)?void 0:x.color,T=`0 ${I}px 0 0`,j=S;let R,B;R=c(L,h,k,I,void 0),B=c(L,h,k,I,"mobile",70),$||(R="1fr",B="1fr");const M=((n,t)=>{switch(n){case e.Alignment.left:return"1/2";case e.Alignment.center:return"2/3";case e.Alignment.right:switch(t){case e.Alignment.left:case e.Alignment.right:return"2/3";case e.Alignment.center:return"3/4"}}})(L,h);let N,J="1/2",_=`0 ${I}px 0 0`;switch(L){case"left":N="flex-start",_=`0 ${I}px 0 0`;break;case"center":N="center","center"===h?(_=`0 0 ${I}px 0`,J="0/2"):_=`0 ${I}px`;break;case"right":N="flex-end",_=`0 0 0 ${I}px`}const W=`${L} center`;let D="1/2",H="2/3",K="flex-end";const U=h||"right",q=h||"right";let E="flex-end";switch(h){case"left":K="flex-start",E="flex-start";break;case"center":K="center",E="center";break;case"right":K="flex-end",E="flex-end"}return H=((n,t)=>{switch(n){case e.Alignment.left:return"2/3";case e.Alignment.center:switch(t){case e.Alignment.left:return"1/2";case e.Alignment.center:return"1/4";case e.Alignment.right:return"3/4"}case e.Alignment.right:switch(t){case e.Alignment.left:case e.Alignment.right:return"1/2";case e.Alignment.center:return"2/3"}}})(L,h),"center"===L&&"center"===h&&(D="2/2"),$||(H="1/2"),{gridArea:"1/1/-1/-1",navigationGridTemplateColumns:R,padding:b,paddingTop:A,paddingRight:w,paddingBottom:y,paddingLeft:C,width:1240,logoGridRow:J,logoGridColumn:M,logoJustifySelf:N,logoSpacing:_,logoWidth:k,logoImageObjectPosition:W,linksGridRow:D,linksGridColumn:H,navigationJustifySelf:K,menuItemSpacing:O,navigationTextAlign:U,menuColor:P,menuHoverColor:G,mobilePadding:"24px 16px 24px 16px",mobilePaddingTop:24,mobilePaddingRight:16,mobilePaddingBottom:24,mobilePaddingLeft:16,mobileLogoWidth:70,mobileMenuItemSpacing:20,mobileNavigationGridTemplateColumns:B,mobileLogoGridRow:"1/2",mobileLogoGridColumn:"1/2",mobileLogoJustifySelf:"flex-start",mobileLogoImageObjectPosition:"left center",mobileLinksGridRow:"1/2",mobileLinksGridColumn:"2/3",mobileLogoSpacing:T,mobileNavigationTextAlign:q,mobileNavigationJustifySelf:E,mobileDropdownBackgroundColor:"#dcdcdc",mobileBackground:j,backgroundOverlayOpacity:0}},exports.flattenToTreeMax2Level=e=>e.filter((e=>!e.parentId)).map((n=>{const g=e.filter((e=>e.parentId===n.id));return c=((e,n)=>{for(var t in n||(n={}))o.call(n,t)&&a(e,t,n[t]);if(l)for(var t of l(n))r.call(n,t)&&a(e,t,n[t]);return e})({},n),t(c,i({children:g}));var c})),exports.getTargetUrl=e=>"BLANK"===e?"_blank":"_self",exports.getUrlOfMenuItem=e=>{var n,t;return"LINK"===(null==e?void 0:e.linkType)?e.href:(null==(n=null==e?void 0:e.page)?void 0:n.isHomepage)?"/":null==(t=null==e?void 0:e.page)?void 0:t.slug},exports.splitPaddingString=g;


/***/ }),

/***/ 471262:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var O=(O=>(O.HEADER="HEADER",O.FOOTER="FOOTER",O.TOP_BANNER="TOP_BANNER",O.BUBBLE_CONTACT="BUBBLE_CONTACT",O.ORDER_POPUP="ORDER_POPUP",O))(O||{});exports.BLOCK_TYPES=O,exports.GLOBAL_BLOCK_TAG="globalblock";


/***/ }),

/***/ 797214:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(85097),t=__webpack_require__(471262),o=__webpack_require__(436216),l=__webpack_require__(243898),c=Object.defineProperty,i=Object.defineProperties,n=Object.getOwnPropertyDescriptors,a=Object.getOwnPropertySymbols,s=Object.prototype.hasOwnProperty,b=Object.prototype.propertyIsEnumerable,p=(e,r,t)=>r in e?c(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,u=(e,r)=>{for(var t in r||(r={}))s.call(r,t)&&p(e,t,r[t]);if(a)for(var t of a(r))b.call(r,t)&&p(e,t,r[t]);return e};const d=c=>{const{device:p}=r.useStore(),d=r.getPropsByDevice(c,p),{blockId:f,blockType:y,content:j}=d,O=((e,r)=>{var t={};for(var o in e)s.call(e,o)&&r.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&a)for(var o of a(e))r.indexOf(o)<0&&b.call(e,o)&&(t[o]=e[o]);return t})(d,["blockId","blockType","content"]);return y===t.BLOCK_TYPES.HEADER?e.jsx(o.GlobalHeader,u({},O)):e.jsx(l.PbSection,(v=u({},O),P={children:c.children},i(v,n(P))));var v,P};d.displayName="GlobalBlock",exports.GlobalBlock=d;


/***/ }),

/***/ 832258:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=(e=>(e.Start="left",e.End="right",e.Center="center",e))(e||{}),t=(e=>(e.Vertical="vertical",e.Horizontal="horizontal",e))(t||{});exports.AlignmentType=e,exports.Direction=t;


/***/ }),

/***/ 772162:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097),n=__webpack_require__(832258),o=__webpack_require__(891987),i=__webpack_require__(568646);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=l(t),u=Object.defineProperty,c=Object.defineProperties,s=Object.getOwnPropertyDescriptors,f=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,d=(e,t,r)=>t in e?u(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,j=(e,t)=>{for(var r in t||(t={}))y.call(t,r)&&d(e,r,t[r]);if(f)for(var r of f(t))p.call(t,r)&&d(e,r,t[r]);return e};const m=o.forwardRef(((t,n)=>{const o=t,{children:l}=o,a=((e,t)=>{var r={};for(var n in e)y.call(e,n)&&t.indexOf(n)<0&&(r[n]=e[n]);if(null!=e&&f)for(var n of f(e))t.indexOf(n)<0&&p.call(e,n)&&(r[n]=e[n]);return r})(o,["children"]),{device:u}=r.useStore(),{commonStyle:d,justifyContent:m}=r.getPropsByDevice(a,u);return e.jsxs(v,{ref:n,commonStyle:d,children:[!l&&e.jsx(i.Empty,{}),e.jsx(x,(O=j({},a),w={justifyContent:m,children:l&&Array.isArray(l)?l.map(((t,r)=>e.jsx(b,{justifyContent:m,children:t},r))):e.jsx(b,{justifyContent:m,children:l})},c(O,s(w))))]});var O,w})),v=a.default.div((({commonStyle:e})=>`\n    ${r.getStyle(e)};\n  `)),x=a.default.div((({layout:e=n.Direction.Horizontal,justifyContent:t,gap:r})=>`\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: ${e==n.Direction.Horizontal?"row":"column"};\n  justify-content: ${t};\n  gap: ${r}px;\n`)),b=a.default.div((({justifyContent:e})=>`\n  display: flex;\n  justify-content: ${e};\n`));m.displayName="GroupButton",exports.GroupButton=m;


/***/ }),

/***/ 326897:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));const e=(__webpack_require__(891987).createContext)({});exports.HeaderContext=e;


/***/ }),

/***/ 10667:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097),t=__webpack_require__(891987),n=__webpack_require__(440384);exports.useHeaderPosition=r=>{const l=t.useRef(null),[o,s]=t.useState(110),[i,u]=t.useState(""),[c,d]=t.useState(!1);let a=0;const v=e.debounce((e=>a=e),100);return t.useEffect((()=>{if(!l.current)return;const e=new ResizeObserver((()=>{var e,t;s(null==(t=null==(e=null==l?void 0:l.current)?void 0:e.getClientRects()[0])?void 0:t.height)}));return e.observe(l.current),()=>e.disconnect()}),[]),t.useEffect((()=>{var t,o;const s=(null==(t=null==document?void 0:document.querySelector(`#${e.TEMPI_MAIN_IFRAME}`))?void 0:t.contentWindow)||window,i=s.document.querySelector('[data-selector-name="top-banner"]'),w=()=>{const e="true"===(null==i?void 0:i.getAttribute("data-sticky"));d(e)};w();const f=new MutationObserver(w);i instanceof Node&&f.observe(i,{attributes:!0,attributeFilter:["data-sticky"]});const b=c?0:null==(o=null==l?void 0:l.current)?void 0:o.offsetTop,p=()=>((e,t)=>{var n,r;t.pageYOffset>=e?(null==(n=null==l?void 0:l.current)||n.classList.add("sticky"),(null==window?void 0:window.scrollY)>a?u("scrolldown"):u("scrollup"),v(null==window?void 0:window.scrollY)):null==(r=null==l?void 0:l.current)||r.classList.remove("sticky")})(b,s),y=()=>((e,t)=>{var n,r;t.pageYOffset>e?null==(n=null==l?void 0:l.current)||n.classList.add("sticky"):null==(r=null==l?void 0:l.current)||r.classList.remove("sticky")})(b,s);switch(r){case n.PositionHeader.DYNAMIC:null==s||s.addEventListener("scroll",p);break;case n.PositionHeader.STICKY:null==s||s.addEventListener("scroll",y)}return()=>{null==window||window.removeEventListener("scroll",p),null==window||window.removeEventListener("scroll",y),f.disconnect()}}),[r,c]),{headerRef:l,headerHeight:o,direction:i}};


/***/ }),

/***/ 440384:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=(e=>(e.NORMAL="normal",e.STICKY="sticky",e.DYNAMIC="dynamic",e))(e||{}),t=(e=>(e.button="button",e.link="link",e))(t||{});exports.MenuItemType=t,exports.PositionHeader=e;


/***/ }),

/***/ 799434:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(212951),t=__webpack_require__(85097),i=__webpack_require__(891987),o=__webpack_require__(326897),r=__webpack_require__(10667),a=__webpack_require__(440384),l=__webpack_require__(879774);function d(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=d(n),s=d(i),p=Object.defineProperty,u=Object.defineProperties,m=Object.getOwnPropertyDescriptors,f=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,h=Object.prototype.propertyIsEnumerable,g=(e,n,t)=>n in e?p(e,n,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[n]=t,x=(e,n)=>{for(var t in n||(n={}))y.call(n,t)&&g(e,t,n[t]);if(f)for(var t of f(n))h.call(n,t)&&g(e,t,n[t]);return e},b=(e,n)=>{var t={};for(var i in e)y.call(e,i)&&n.indexOf(i)<0&&(t[i]=e[i]);if(null!=e&&f)for(var i of f(e))n.indexOf(i)<0&&h.call(e,i)&&(t[i]=e[i]);return t};const j=s.default.forwardRef(((n,t)=>{var i=n,{children:a,isMobile:l,toggle:d,positionType:c}=i;const s=b(i,["children","isMobile","toggle","positionType"]),{commonStyle:p}=s,f=b(s,["commonStyle"]),y=p,{maxWidth:h}=y,g=b(y,["maxWidth"]),{headerRef:j,headerHeight:v,direction:w}=r.useHeaderPosition(c),P=((...e)=>n=>{e.forEach((e=>{e&&("function"==typeof e?e(n):e.current=n)}))})(j,t);return e.jsxs(e.Fragment,{children:[e.jsx(H,(M=x({ref:P,isMobile:l,commonStyle:g,positionType:c,direction:w,headerHeight:v},f),q={children:e.jsx(O,{style:{maxWidth:h},children:e.jsx(o.HeaderContext.Provider,{value:{toggle:d,isMobile:l},children:a})})},u(M,m(q)))),e.jsx("div",{className:"placeholder"})]});var M,q}));j.displayName="Header";const v=({commonStyle:{maxHeight:e,height:n,minHeight:i}})=>`\n  max-width: 100%;\n\n  .logo {\n    max-width: 50%;\n  }\n\n  .menu {\n    &-desktop {\n      display: none !important;\n    }\n\n    &-col {\n      flex-direction: column;\n      row-gap: 8px;\n    }\n\n    &-item {\n      &.button {\n        justify-content: center;\n      }\n    }\n  }\n\n  .toggle-button {\n    ${t.getStyle({maxHeight:e,height:n,minHeight:i})}\n  }\n`,w=({alignment:e})=>`\n  .menu {\n    &-desktop {\n      flex: 1;\n    }\n\n    &-col {\n      &.left {\n        justify-content: ${l.MAPPING_ALIGNMENT_FLEX[e]};\n      }\n    }\n  }\n\n  .dropdown-menu,\n  .toggle-button {\n    display: none !important;\n  }\n`,H=c.default.div((e=>{const{isMobile:n,commonStyle:i,positionType:o,direction:r,headerHeight:l}=e;return[`\n      ${t.getStyle(i)}\n      display: flex;\n      justify-content: center;\n      margin-left: auto;\n      margin-right: auto;\n      z-index: 100;\n      transition: opacity .5s;\n      ${o===a.PositionHeader.DYNAMIC?"scrolldown"===r?"opacity: 0;":"opacity: 1;":""}\n      \n      \n      &.sticky {\n        position: fixed;\n        top: 0;\n        width: 100%;\n      }\n      \n      &.sticky + .placeholder{\n        padding-bottom: ${l}px;\n      }\n    `,n&&v,!1===n&&w,void 0===n&&`\n        @media (max-width: 767px) {\n          ${v(e)}\n        }\n        @media (min-width: 767px) {\n          ${w(e)}\n        }\n      `]})),O=c.default.div`
  background: inherit;
  width: 100%;
  display: flex;
  align-items: center;
  column-gap: 16px;
`;exports.Header=j;


/***/ }),

/***/ 679566:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(891987),o=__webpack_require__(586753);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=a(r),l=a(t),u=Object.defineProperty,n=Object.getOwnPropertySymbols,s=Object.prototype.hasOwnProperty,c=Object.prototype.propertyIsEnumerable,f=(e,r,t)=>r in e?u(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,p=(e,r)=>{for(var t in r||(r={}))s.call(r,t)&&f(e,t,r[t]);if(n)for(var t of n(r))c.call(r,t)&&f(e,t,r[t]);return e};const d=l.default.forwardRef(((r,t)=>e.jsx(b,{ref:t,className:"logo",children:e.jsx(o.Image,p({autoOptimize:!0},r))})));d.displayName="Logo";const b=i.default.div`
  max-width: 33%;
`;exports.Logo=d;


/***/ }),

/***/ 973095:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261);function t(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var r=t(__webpack_require__(212951)),o=Object.defineProperty,n=Object.getOwnPropertySymbols,a=Object.prototype.hasOwnProperty,l=Object.prototype.propertyIsEnumerable,u=(e,t,r)=>t in e?o(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r;const i=r.default.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 24px;
`;exports.DesktopMenu=t=>e.jsx(i,((e,t)=>{for(var r in t||(t={}))a.call(t,r)&&u(e,r,t[r]);if(n)for(var r of n(t))l.call(t,r)&&u(e,r,t[r]);return e})({className:"menu-desktop"},t));


/***/ }),

/***/ 872278:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(891987),n=__webpack_require__(326897),s=__webpack_require__(973095),t=__webpack_require__(302100);const i=({children:i})=>{const{isMobile:u}=r.useContext(n.HeaderContext);return void 0!==u?u?e.jsx(t.MobileMenu,{children:i}):e.jsx(s.DesktopMenu,{children:i}):e.jsxs(e.Fragment,{children:[e.jsx(t.MobileMenu,{children:i}),e.jsx(s.DesktopMenu,{children:i})]})};i.displayName="Menu",exports.Menu=i;


/***/ }),

/***/ 302100:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),o=__webpack_require__(143599),r=__webpack_require__(891987),i=__webpack_require__(326897),n=__webpack_require__(628912);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=l(t),s=Object.defineProperty,u=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,d=(e,t,o)=>t in e?s(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o,x=(e,t)=>{for(var o in t||(t={}))c.call(t,o)&&d(e,o,t[o]);if(u)for(var o of u(t))p.call(t,o)&&d(e,o,t[o]);return e};const b=a.default.div`
  margin-left: auto;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0 8px;
`,g=a.default.div`
  position: absolute;
  top: 80%;
  left: 0;
  right: 0;
  z-index: 100;

  display: flex;
  flex-direction: column;
  align-content: center;
  row-gap: 8px;

  height: auto;
  padding: 16px;
  overflow-y: auto;

  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease-in-out;

  background: inherit;
  box-shadow: 0 10px 16px rgba(10, 10, 10, 0.1);

  &.show {
    top: 100%;
    opacity: 1;
    visibility: visible;
  }
`;exports.MobileMenu=({children:t})=>{const{toggle:l}=r.useContext(i.HeaderContext),[a,s]=r.useState(!1);return e.jsxs(e.Fragment,{children:[e.jsx(b,{className:"toggle-button",onClick:()=>s(!a),children:a?e.jsx(o.Icon,x({name:"CloseOutlined"},n.getPropsIcon(null==l?void 0:l.icon))):e.jsx(o.Icon,x({name:"MenuOutlined"},n.getPropsIcon(null==l?void 0:l.icon)))}),e.jsx(g,{className:"dropdown-menu "+(a?"show":""),children:t})]})};


/***/ }),

/***/ 855277:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(891987);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=n(r),o=n(t),a=Object.defineProperty,f=Object.defineProperties,i=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,s=Object.prototype.propertyIsEnumerable,p=(e,r,t)=>r in e?a(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,d=(e,r)=>{for(var t in r||(r={}))c.call(r,t)&&p(e,t,r[t]);if(u)for(var t of u(r))s.call(r,t)&&p(e,t,r[t]);return e},y=(e,r)=>f(e,i(r));const b=o.default.forwardRef(((r,t)=>{var n=r,{type:l="right"}=n,o=((e,r)=>{var t={};for(var n in e)c.call(e,n)&&r.indexOf(n)<0&&(t[n]=e[n]);if(null!=e&&u)for(var n of u(e))r.indexOf(n)<0&&s.call(e,n)&&(t[n]=e[n]);return t})(n,["type"]);return"left"===l?e.jsx(v,y(d({ref:t},o),{className:"menu-col left"})):e.jsx(j,y(d({ref:t},o),{className:"menu-col right"}))}));b.displayName="menuCol";const m="\n  display: flex;\n  align-items: center;\n  column-gap: 24px;\n  row-gap: 16px;\n",j=l.default.div(m,"\n    justify-content: flex-end;\n  "),v=l.default.div(m,"\n  flex: 1;\n");exports.MenuCol=b;


/***/ }),

/***/ 22530:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(85097),t=__webpack_require__(891987),i=__webpack_require__(440384),n=__webpack_require__(484435),o=__webpack_require__(750911);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var u=a(t),c=Object.defineProperty,l=Object.defineProperties,s=Object.getOwnPropertyDescriptors,f=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,d=Object.prototype.propertyIsEnumerable,j=(e,r,t)=>r in e?c(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,y=(e,r)=>{for(var t in r||(r={}))p.call(r,t)&&j(e,t,r[t]);if(f)for(var t of f(r))d.call(r,t)&&j(e,t,r[t]);return e};const b=u.default.forwardRef(((t,a)=>{const u=t,{type:c,children:j}=u,b=((e,r)=>{var t={};for(var i in e)p.call(e,i)&&r.indexOf(i)<0&&(t[i]=e[i]);if(null!=e&&f)for(var i of f(e))r.indexOf(i)<0&&d.call(e,i)&&(t[i]=e[i]);return t})(u,["type","children"]),{device:v}=r.useStore(),{itemData:m}=r.getPropsByDevice(t,v);return j||(c===i.MenuItemType.link?e.jsx("div",{ref:a,children:e.jsx(n.Heading,y(y({},m),b))}):e.jsx("div",{ref:a,children:e.jsx(o.ButtonV2,(O=y(y({ref:a},m),b),x={className:"menu-item button"},l(O,s(x))))}));var O,x}));b.displayName="MenuItem",exports.MenuItem=b;


/***/ }),

/***/ 484435:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(85097),t=__webpack_require__(212951),n=__webpack_require__(319891),i=__webpack_require__(534479);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=o(t),a=Object.defineProperty,c=Object.defineProperties,s=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,u=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,p=(e,r,t)=>r in e?a(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,y=(e,r)=>{for(var t in r||(r={}))u.call(r,t)&&p(e,t,r[t]);if(d)for(var t of d(r))f.call(r,t)&&p(e,t,r[t]);return e},b=(e,r)=>c(e,s(r));const j=t=>{var i=t,{text:o,enabled:l,link:a,children:c}=i,s=((e,r)=>{var t={};for(var n in e)u.call(e,n)&&r.indexOf(n)<0&&(t[n]=e[n]);if(null!=e&&d)for(var n of d(e))r.indexOf(n)<0&&f.call(e,n)&&(t[n]=e[n]);return t})(i,["text","enabled","link","children"]);const{text:p}=r.useInjectDynamicLinks(o),j=c?e.jsx(x,b(y({},s),{children:c})):e.jsx(x,b(y({},s),{dangerouslySetInnerHTML:{__html:p}}));return l?j:e.jsx(n.Link,b(y({},a),{children:j}))},x=l.default.div((({commonStyle:e})=>`\n    ${r.getStyle(e)}\n    ${i.getCommonTextCss(!0)}\n  `),"a {\n    color: inherit;\n  }");j.displayName="Heading",exports.Heading=j,exports.StyledHeading=x;


/***/ }),

/***/ 35143:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(891987),i=__webpack_require__(212951),t=__webpack_require__(877084),n=__webpack_require__(85097),o=__webpack_require__(162291),l=__webpack_require__(138989);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=a(i),s=a(t),u=Object.defineProperty,c=Object.defineProperties,f=Object.getOwnPropertyDescriptors,m=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,b=Object.prototype.propertyIsEnumerable,h=(e,r,i)=>r in e?u(e,r,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[r]=i;const v=d.default.div`
  border-radius: 0.5rem;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
  z-index: 980;
  height: ${"28rem"};
  width: ${"12.375rem"};

  &.active {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`,g=d.default.a((({primaryColor:e="#1435c3"})=>`\n  cursor: pointer;\n  color: black;\n  text-decoration: none;\n  height: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  gap: 0.5rem;\n  padding: 0 0.5rem;\n  border-radius: 0.5rem;\n  overflow: hidden;\n\n  &:hover {\n    background-color: #ababab20;\n    color: ${e} !important;\n  }\n`)),x=d.default.div`
  flex: 1 1 0%;
  margin: 0px;
  padding: 0px;
  border-style: none;
  border-width: 1px;
  border-color: unset;
  opacity: 1;
  color: inherit;
  font-weight: 500;
  text-decoration: unset;
  font-size: 12px;
  line-height: 16px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  max-width: unset;
  min-width: unset;
  transition: color 0.3s ease 0s;
`,y=d.default.div`
  position: absolute;
  top: 0;
  width: calc(75rem - 12.375rem);
  left: 12.375rem;
  min-height: 100%;
  z-index: 980;
  overflow: hidden;
  transition: all 0.1s;
  visibility: hidden;
  opacity: 0;
  border-radius: 0.5rem;
  &.active {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    visibility: visible;
    opacity: 1;
  }
`,j=d.default.img`
  width: 22px;
  height: 22px;
`,w=d.default.div`
  background-color: #ffffff;
  min-height: 28rem;
`;exports.MegaMenu=({menu:i=[],primaryColor:t,isEditingMode:a})=>{const{globalData:d}=n.useStore(),u=null==d?void 0:d.isPreviewMode,[M,O]=r.useState(),k=l.flattenToTree((i||[]).filter((e=>!e.isHidden))).slice(0,14);return e.jsxs("div",{onMouseLeave:()=>O(null),children:[e.jsx(v,{className:s.default((null==M?void 0:M.children.length)>0?["active"]:null),children:null==k?void 0:k.map(((r,i)=>{return e.jsx("div",(o=((e,r)=>{for(var i in r||(r={}))p.call(r,i)&&h(e,i,r[i]);if(m)for(var i of m(r))b.call(r,i)&&h(e,i,r[i]);return e})({},!a&&!u&&n.getTrackingData({isTrackContent:!0,contentName:null==r?void 0:r.name,regionName:"megaMenuText"})),d={children:e.jsxs(g,{href:l.getUrlOfMenuItem(r,a),primaryColor:t,onMouseEnter:()=>{O(r)},children:[(null==r?void 0:r.iconUrl)&&e.jsx(j,{src:null==r?void 0:r.iconUrl,alt:null==r?void 0:r.name}),e.jsx(x,{children:null==r?void 0:r.name})]},i)},c(o,f(d))));var o,d}))}),e.jsx(y,{className:s.default((null==M?void 0:M.children.length)>0?["active"]:null),children:M&&e.jsx(w,{children:e.jsx(o.GridMenuContent,{menu:M,isEditingMode:a})})})]})};


/***/ }),

/***/ 355695:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var n=__webpack_require__(561261),e=__webpack_require__(212951),i=__webpack_require__(85097),t=__webpack_require__(891987),r=__webpack_require__(726438),o=__webpack_require__(406968),a=__webpack_require__(50976);function s(n){return n&&"object"==typeof n&&"default"in n?n:{default:n}}var l=s(e),p=s(r),d=Object.defineProperty,u=Object.defineProperties,c=Object.getOwnPropertyDescriptors,g=Object.getOwnPropertySymbols,w=Object.prototype.hasOwnProperty,h=Object.prototype.propertyIsEnumerable,m=(n,e,i)=>e in n?d(n,e,{enumerable:!0,configurable:!0,writable:!0,value:i}):n[e]=i,b=(n,e)=>{for(var i in e||(e={}))w.call(e,i)&&m(n,i,e[i]);if(g)for(var i of g(e))h.call(e,i)&&m(n,i,e[i]);return n};p.default.use([r.Navigation,r.Pagination,r.Thumbs,r.Autoplay,r.Virtual]);const f=l.default.div((({isMultipleRows:n,paginationStyle:e,paginationColor:t,paginationPosition:r,navigationStyle:o,navigationColor:s,commonStyle:l,slidesPerView:p=1,slidesPerColumn:d=1,itemsCount:u,spaceBetween:c=10})=>{const g="undefined"==typeof window;let w,h,m;return g&&(w=Math.ceil(u/d),h=w/("auto"===p?1:p)*100+"%",m=`calc(100% / ${w} - ${c*(w-1)/w}px)`),`\n    .swiper-container {\n      margin-left: auto;\n      margin-right: auto;\n      position: relative;\n      overflow: hidden;\n      list-style: none;\n      padding: 0;\n      ${e&&"outside"===r?"padding-bottom: 3em;":""}\n    }\n    .swiper-wrapper {\n      position: relative;\n      height: 100%;\n      display: flex;\n      transition-property: transform;\n      box-sizing: content-box;\n      flex-wrap: ${n?"wrap":"nowrap"};\n      // Chỉ có tác dụng ở SSR, khi về CSR thư viện swiper sẽ tự động override css này bằng pixel\n      ${g?`width: ${h};`:""}\n    }\n    .swiper-slide {\n      flex-shrink: 0;\n      height: 100%;\n      position: relative;\n      transition-property: transform;\n      ${n?"margin-top: 0px !important":""};\n      // Chỉ có tác dụng ở SSR, khi về CSR thư viện swiper sẽ tự động override css này bằng pixel\n      ${g?`width: ${m};\n            margin-right: ${c}px;`:""}\n    }\n    &:hover {\n      .swiper-button-next,\n      .swiper-button-prev {\n        opacity: 1;\n        &.swiper-button-disabled {\n          opacity: 0.35;\n        }\n      }\n    }\n    .swiper-pagination {\n      position: absolute;\n      text-align: center;\n      transform: translate3d(0, 0, 0);\n      z-index: 10;\n    }\n    .swiper-pagination-fraction {\n      bottom: 0;\n      left: 0;\n      width: 100%;\n    }\n    .swiper-pagination-bullets {\n      bottom: 10px;\n      left: 0;\n      width: 100%;\n    }\n    ${e?a.renderPaginationStyle(e,t):""}\n    .swiper-button-prev,\n    .swiper-button-next {\n      position: absolute;\n      top: 50%;\n      z-index: 10;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 44px;\n      height: 44px;\n      margin-top: -22px;\n      opacity: 0;\n      &.swiper-button-disabled {\n        opacity: 0;\n        cursor: auto;\n        pointer-events: auto;\n      }\n    }\n    .swiper-thumbnail {\n      padding-top: 10px;\n\n      &.swiper-thumbnail__left {\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n      }\n\n      &.swiper-thumbnail__center {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n\n      &.swiper-thumbnail__right {\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n      }\n\n      .swiper-slide {\n        width: 80px !important;\n        height: 80px;\n        cursor: pointer;\n\n        img {\n          width: 80px;\n          height: 80px;\n        }\n\n        &.swiper-slide-thumb-active::after {\n          background: transparent;\n        }\n\n        &::after {\n          content: "";\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 100%;\n          height: 100%;\n          background: rgba(0,0,0,.5);\n        }\n      }\n    }\n    ${i.getStyle(l)}\n    ${o?a.renderSwipeButton(o,s):""}\n`}));exports.EcomSlider=e=>{var i=e,{className:r,children:a,paginationStyle:s,navigationStyle:l,speed:p=3e3,pauseOnMouseEnter:d=!0,paginationColor:m,virtual:y,paginationPosition:v="inside",commonStyle:x,slidesPerViewMobile:S,navigationColor:P}=i,C=((n,e)=>{var i={};for(var t in n)w.call(n,t)&&e.indexOf(t)<0&&(i[t]=n[t]);if(null!=n&&g)for(var t of g(n))e.indexOf(t)<0&&h.call(n,t)&&(i[t]=n[t]);return i})(i,["className","children","paginationStyle","navigationStyle","speed","pauseOnMouseEnter","paginationColor","virtual","paginationPosition","commonStyle","slidesPerViewMobile","navigationColor"]);const{slidesPerView:j,slidesPerColumn:O,pagination:$,autoplay:_,loop:M,showThumbnail:V,alignThumbnail:k}=C,[q,B]=t.useState(0);let E;const[R,N]=t.useState(null),z=O&&O>1;return $&&(C.pagination={clickable:!0}),z&&(C.loop=!1),_&&(C.autoplay={delay:p,disableOnInteraction:!1,pauseOnMouseEnter:d}),S&&(E={320:{slidesPerView:S},640:{slidesPerView:j}}),t.useEffect((()=>{B((n=>n+1))}),[V,_,M,p,d,y,O]),n.jsxs(f,{className:r,paginationStyle:s,navigationStyle:l,isMultipleRows:z,paginationColor:m,navigationColor:P,paginationPosition:v,commonStyle:x,slidesPerView:j,slidesPerColumn:O,itemsCount:t.Children.toArray(a).length,spaceBetween:null==C?void 0:C.spaceBetween,children:[n.jsx(o.Swiper,(I=b({breakpoints:E},C),T={thumbs:{swiper:R&&!R.destroyed?R:null},virtual:!(!y||"number"!=typeof j)&&{addSlidesBefore:j},resizeObserver:!0,slidesPerColumnFill:"row",children:t.Children.map(a,((e,i)=>n.jsx(o.SwiperSlide,{virtualIndex:i,children:e},`slide-${i}`)))},u(I,c(T))),`swiper-${q}`),V&&n.jsx(o.Swiper,{className:"swiper-thumbnail "+(k?`swiper-thumbnail__${k}`:""),onSwiper:N,spaceBetween:10,slidesPerView:"auto",watchSlidesProgress:!0,slideToClickedSlide:!0,children:t.Children.map(a,((e,i)=>n.jsx(o.SwiperSlide,{virtualIndex:i,children:e},`thumb-${i}`)))})]});var I,T};


/***/ }),

/***/ 50976:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.renderPaginationStyle=(n,i)=>n>0?[`.swiper-pagination-bullet {\n      width: 8px;\n      height: 8px;\n      display: inline-block;\n      border-radius: 100%;\n      background: #ddd;\n      margin: 0 4px;\n      cursor: pointer;\n    }\n    .swiper-pagination-bullet-active {\n      background: ${i};\n      border-radius: 0.75rem;\n    }`,`.swiper-pagination-bullet {\n      width: 8px;\n      height: 8px;\n      display: inline-block;\n      border-radius: 100%;\n      background: #ddd;\n      margin: 0 4px;\n      cursor: pointer;\n    }\n    .swiper-pagination-bullet-active {\n      background: ${i};\n      border-radius: 0.75rem;\n      width: 24px;\n    }`,`.swiper-pagination-bullet {\n      width: 8px;\n      height: 8px;\n      display: inline-block;\n      background: #ddd;\n      cursor: pointer;\n      &:first-of-type {\n        border-radius: 999px 0 0 999px;\n      };\n      &:last-of-type {\n        border-radius: 0 999px 999px 0;\n      }\n    }\n    .swiper-pagination-bullet-active {\n      width: 24px;\n      position: relative;\n      &:after {\n        content: "";\n        border-radius: 999px;\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background-color: ${i};\n      }\n    }`,`.swiper-pagination-bullet {\n      width: 8px;\n      height: 8px;\n      display: inline-block;\n      border-radius: 100%;\n      background: #ddd;\n      margin: 0 4px;\n      cursor: pointer;\n    }\n    .swiper-pagination-bullet-active {\n      background: ${i};\n      border-radius: 0.75rem;\n      width: 12px;\n      height: 12px;\n      border-radius: 50%;\n      transform: translateY(2px);\n    }`][n-1]:null,exports.renderSwipeButton=(n,i)=>n>0?[`.swiper-button-next {\n      right: 0;\n      left: auto;\n      border-top-left-radius: 100px;\n      border-bottom-left-radius: 100px;\n      background-color: rgba(168, 168, 168, 0.46);\n      &:after {\n        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');\n        content: ' ';\n        height: 30px;\n        width: 30px;\n        mask-size: contain;\n        display: inline-block;\n        background: ${i||"#333"};\n      }\n    }\n    .swiper-button-prev {\n      left: 0;\n      right: auto;\n      border-top-right-radius: 100px;\n      border-bottom-right-radius: 100px;\n      background-color: rgba(168, 168, 168, 0.46);\n      &:after {\n        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');\n        content: ' ';\n        height: 30px;\n        width: 30px;\n        mask-size: contain;\n        display: inline-block;\n        background: ${i||"#333"};\n      }\n    }`,`.swiper-button-next {\n      right: 0;\n      left: auto;\n      border-radius: 50%;\n      background-color: rgba(168, 168, 168, 0.46);\n      margin-right: 0.5rem;\n      &:after {\n        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');\n        content: ' ';\n        height: 30px;\n        width: 30px;\n        mask-size: contain;\n        display: inline-block;\n        background: ${i||"#333"};\n      }\n    }\n    .swiper-button-prev {\n      left: 0;\n      right: auto;\n      border-radius: 50%;\n      background-color: rgba(168, 168, 168, 0.46);\n      margin-left: 1rem;\n      &:after {\n        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');\n        content: ' ';\n        height: 30px;\n        width: 30px;\n        mask-size: contain;\n        display: inline-block;\n        background: ${i||"#333"};\n      }\n    }`,`.swiper-button-next {\n      right: 0;\n      left: auto;\n      background-color: transparent;\n      &:after {\n        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');\n        content: ' ';\n        height: 30px;\n        width: 30px;\n        mask-size: contain;\n        display: inline-block;\n        background: ${i||"#333"};\n      }\n    }\n    .swiper-button-prev {\n      left: 0;\n      right: auto;\n      background-color: transparent;\n      &:after {\n        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');\n        content: ' ';\n        height: 30px;\n        width: 30px;\n        mask-size: contain;\n        display: inline-block;\n        background: ${i||"#333"};\n      }\n    }`][n-1]:null;


/***/ }),

/***/ 704150:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),i=__webpack_require__(85097),r=__webpack_require__(891987),n=__webpack_require__(35143),o=__webpack_require__(355695),a=__webpack_require__(243898),l=__webpack_require__(879774),s=__webpack_require__(669117),d=__webpack_require__(586753);function g(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=g(t),m=Object.defineProperty,u=Object.defineProperties,p=Object.getOwnPropertyDescriptors,h=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,v=Object.prototype.propertyIsEnumerable,x=(e,t,i)=>t in e?m(e,t,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[t]=i,b=(e,t)=>{for(var i in t||(t={}))y.call(t,i)&&x(e,i,t[i]);if(h)for(var i of h(t))v.call(t,i)&&x(e,i,t[i]);return e},f=(e,t)=>{var i={};for(var r in e)y.call(e,r)&&t.indexOf(r)<0&&(i[r]=e[r]);if(null!=e&&h)for(var r of h(e))t.indexOf(r)<0&&v.call(e,r)&&(i[r]=e[r]);return i};const{cardDefaultImage:j}=i.mappingAssets,I=t=>{var g,c=t,{isEditingMode:m,menu:h}=c,y=f(c,["isEditingMode","menu"]);const{device:v,globalData:x}=i.useStore(),I=r.useRef(null),N=m?h:x.menu||[],Z=i.getPropsByDevice(y,v),{autoSwipeTimeMilliseconds:C=3e3,items:H=[],rightItems:k=[],showMegaMenu:E,menuZone:P,commonStyle:B,primaryColor:O,maxWidth:z}=Z,W=f(Z,["autoSwipeTimeMilliseconds","items","rightItems","showMegaMenu","menuZone","commonStyle","primaryColor","maxWidth"]),A=r.useRef(null),R=r.useRef(null),[U,L]=r.useState(!1),{displayItems:q}=i.useTimeVisibility(H,m),{displayItems:G}=i.useTimeVisibility(k,m);if(r.useEffect((()=>{I.current&&(I.current.style.position="unset")}),[I]),!m&&!(null==H?void 0:H.length))return null;const J=(t,r)=>e.jsx(d.Image,b({isEditingMode:m,event:t.event,googleImageParams:t.googleImageParams||{width:1920},src:t.src||j,alt:t.alt||"Image",commonStyle:{objectFit:"cover",width:"100%",height:566}},!m&&i.getTrackingData({isTrackContent:!0,regionName:"topSliderBannerHomepage",contentName:"heroBannerSlide",target:i.getTargetOfTrackingFromEvent(t.event),index:r})),r);return e.jsx(S,(F=b({commonStyle:B,onMouseEnter:()=>L(!0),onMouseLeave:()=>L(!1)},W),Q={children:e.jsxs(a.PbSection,{ref:I,commonStyle:{maxWidth:z||l.DEFAULT_WIDTH,padding:{left:16,right:16}},row:{commonStyle:{height:556,alignItems:"stretch"}},style:{position:"unset"},children:[e.jsxs(s.Col,{span:2,style:{paddingTop:"1rem",zIndex:980},children:[e.jsx("div",{style:{position:"relative"},children:e.jsx(n.MegaMenu,{menu:N,isEditingMode:m,primaryColor:O})}),(null==q?void 0:q.length)>1&&e.jsx(w,{style:{opacity:U?1:0},ref:A})]}),e.jsx("div",{style:{flex:"1 1 0%"},children:e.jsx(M,{children:1!==q.length?e.jsx(o.EcomSlider,{pagination:!0,paginationStyle:1,navigation:{prevEl:A.current,nextEl:R.current},navigationStyle:1,virtual:!0,paginationColor:"#ffffff",loop:!0,autoplay:!!C,speed:C,allowTouchMove:!m,onBeforeInit:e=>{e.params.navigation.prevEl=A.current,e.params.navigation.nextEl=R.current},children:q.map(((e,t)=>J(e,t)))}):J(q[0],0)})}),e.jsxs(s.Col,{span:2,style:{paddingTop:"1rem",paddingBottom:"1rem"},children:[(null==q?void 0:q.length)>1&&e.jsx(D,{style:{opacity:U?1:0},ref:R}),!!(null==G?void 0:G.length)&&e.jsx(T,{children:null==(g=null==G?void 0:G.slice)?void 0:g.call(G,0,2).map(((t,r)=>e.jsx(d.Image,b({isEditingMode:m,event:t.event,googleImageParams:t.googleImageParams||{width:300},src:t.src||j,alt:t.alt||"Image",commonStyle:{objectFit:"cover",width:"100%",height:220,borderRadius:8,hover:{zoom:105}}},!m&&i.getTrackingData({isTrackContent:!0,regionName:"topRightBannerHomepage",contentName:"heroBannerRight",index:r,target:i.getTargetOfTrackingFromEvent(t.event)})),r)))})]})]})},u(F,p(Q))));var F,Q},S=c.default.div((({commonStyle:e})=>`\n  position: relative;\n  content-visibility: auto;\n  ${i.getStyle(e)}\n`)),M=c.default.div`
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  z-index: 0;

  .swiper-pagination {
    bottom: 7rem !important;
  }
`,T=c.default.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`,w=c.default.div`
  top: 39.5%;
  right: -46px;

  position: absolute;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;

  border-top-right-radius: 100px;
  border-bottom-right-radius: 100px;
  background-color: rgba(168, 168, 168, 0.46);

  &:after {
    mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
    content: ' ';
    height: 30px;
    width: 30px;
    mask-size: contain;
    display: inline-block;
    background: #333;
  }
`,D=c.default.div`
  top: 39.5%;
  left: -48px;

  position: absolute;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;

  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  background-color: rgba(168, 168, 168, 0.46);

  &:after {
    mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
    content: ' ';
    height: 30px;
    width: 30px;
    mask-size: contain;
    display: inline-block;
    background: #333;
  }
`;I.displayName="HeroBanner",exports.HeroBannerTempi=I,exports.StyledFullWidthSlider=M,exports.StyledHeroBanner=S,exports.StyledLeftNav=w,exports.StyledRightNav=D;


/***/ }),

/***/ 514411:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097),n=__webpack_require__(891987),o=__webpack_require__(534479);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=i(t),a=Object.defineProperty,l=Object.defineProperties,s=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,u=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,p=(e,t,r)=>t in e?a(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,m=(e,t)=>{for(var r in t||(t={}))u.call(t,r)&&p(e,r,t[r]);if(d)for(var r of d(t))f.call(t,r)&&p(e,r,t[r]);return e};const y=t=>{var o=t,{htmlCode:i,id:c,isEditor:a,emptyDesc:p}=o,y=((e,t)=>{var r={};for(var n in e)u.call(e,n)&&t.indexOf(n)<0&&(r[n]=e[n]);if(null!=e&&d)for(var n of d(e))t.indexOf(n)<0&&f.call(e,n)&&(r[n]=e[n]);return r})(o,["htmlCode","id","isEditor","emptyDesc"]);const{device:j}=r.useStore(),{commonStyle:h}=r.getPropsByDevice(y,j),x=n.useRef(null);return n.useEffect((()=>{if(!a&&i&&x.current){x.current.innerHTML="";const{contentWithoutScripts:e,loadAllScripts:t}=(e=>{const t=document.createElement("div");t.innerHTML=e;const r=Array.from(t.getElementsByTagName("script"));r.forEach((e=>{e.remove()}));const n=t.innerHTML,o=e=>new Promise(((t,r)=>{var n;const o=document.createElement("script");Array.from(e.attributes).forEach((e=>{o.setAttribute(e.name,e.value)})),o.type=e.type||"text/javascript",e.src?(o.src=e.src,o.onload=()=>t(),o.onerror=()=>r(new Error(`Failed to load script: ${e.src}`))):(o.text=e.text||e.innerHTML,t()),null==(n=x.current)||n.appendChild(o)}));return{contentWithoutScripts:n,loadAllScripts:async()=>{for(const e of r)await o(e)}}})(i);x.current.innerHTML=e,t().catch((e=>console.error(e)))}}),[i,a]),e.jsx(e.Fragment,{children:a?e.jsx(b,{children:p}):e.jsx(v,(O=m({ref:x},y),g={commonStyle:h},l(O,s(g))))});var O,g},v=c.default.div((({commonStyle:e})=>`\n  ${r.getStyle(e)}\n  position: relative;\n`)),b=c.default.div`
  font-family: ${o.defaultFontFamily};
  min-height: 50px;
  background-color: #ddd;
  width: 100;
  display: flex;
  justify-content: center;
  align-items: center;
`;y.displayName="HtmlCode",exports.HtmlCode=y;


/***/ }),

/***/ 927322:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(85097),t=__webpack_require__(212951),n=__webpack_require__(570267),o=__webpack_require__(891987),i=__webpack_require__(319891);function c(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=c(t),a=Object.defineProperty,s=Object.defineProperties,u=Object.getOwnPropertyDescriptors,f=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,d=Object.prototype.propertyIsEnumerable,y=(e,r,t)=>r in e?a(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,b=(e,r)=>{for(var t in r||(r={}))p.call(r,t)&&y(e,t,r[t]);if(f)for(var t of f(r))d.call(r,t)&&y(e,t,r[t]);return e},m=(e,r)=>s(e,u(r));const v=o.forwardRef(((t,o)=>{const c=t,{isEditor:l,event:a}=c,s=((e,r)=>{var t={};for(var n in e)p.call(e,n)&&r.indexOf(n)<0&&(t[n]=e[n]);if(null!=e&&f)for(var n of f(e))r.indexOf(n)<0&&d.call(e,n)&&(t[n]=e[n]);return t})(c,["isEditor","event"]),{device:u}=r.useStore(),{commonStyle:y}=r.getPropsByDevice(s,u),v=n.getIconComponent(s);return e.jsx(j,m(b({ref:o},s),{commonStyle:y,children:l?v:e.jsx(i.Link,m(b({},a),{children:v}))}))})),j=l.default.div((({commonStyle:e})=>`\n  ${r.getStyle(e)};\n  > svg {\n    display: inline-block;\n  }\n`));v.displayName="Icon",exports.PbIcon=v;


/***/ }),

/***/ 586753:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(85097);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var o=n(r),a=Object.defineProperty,i=Object.defineProperties,l=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,s=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,u=(e,r,t)=>r in e?a(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;const m=o.default.div((({alignment:e})=>`\n  display: flex;\n  justify-content: ${e};\n  align-items: center;\n  width: 100%;\n`)),y=r=>{const{device:n}=t.useStore(),{commonStyle:o,alignment:a}=t.getPropsByDevice(r,n);return e.jsx(t.ImageBase,(m=((e,r)=>{for(var t in r||(r={}))s.call(r,t)&&u(e,t,r[t]);if(c)for(var t of c(r))p.call(r,t)&&u(e,t,r[t]);return e})({},r),i(m,l({commonStyle:o,alignment:a}))));var m};y.displayName="Image",exports.Image=y,exports.ImageWrapper=m;


/***/ }),

/***/ 844254:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.DEFAULT_INLINE_BANNER={commonStyle:{height:300,width:500}},exports.DEFAULT_POLLING_INLINE_INTERVAL=100;


/***/ }),

/***/ 757179:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=(e=>(e.BEFORE="before",e.AFTER="after",e.IN="in",e))(e||{});exports.InlineBannerRelativePosition=e;


/***/ }),

/***/ 330094:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(85097),n=__webpack_require__(891987),o=__webpack_require__(926759),i=__webpack_require__(844254),l=__webpack_require__(757179),a=__webpack_require__(319891);function c(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=c(r),u=Object.defineProperty,d=Object.defineProperties,f=Object.getOwnPropertyDescriptors,m=Object.getOwnPropertySymbols,v=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,I=(e,r,t)=>r in e?u(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,y=(e,r)=>{for(var t in r||(r={}))v.call(r,t)&&I(e,t,r[t]);if(m)for(var t of m(r))p.call(r,t)&&I(e,t,r[t]);return e},b=(e,r)=>d(e,f(r));const E=n.forwardRef(((r,c)=>{var s=r,{commonStyle:u,children:d,isEditorMode:f,cssSelector:I,customCss:E,relativePosition:j=l.InlineBannerRelativePosition.BEFORE,event:P,pollingInterval:R=i.DEFAULT_POLLING_INLINE_INTERVAL}=s,S=((e,r)=>{var t={};for(var n in e)v.call(e,n)&&r.indexOf(n)<0&&(t[n]=e[n]);if(null!=e&&m)for(var n of m(e))r.indexOf(n)<0&&p.call(e,n)&&(t[n]=e[n]);return t})(s,["commonStyle","children","isEditorMode","cssSelector","customCss","relativePosition","event","pollingInterval"]);const[B,N]=n.useState(),q=n.useRef(),L=n.useMemo((()=>y(y({},i.DEFAULT_INLINE_BANNER.commonStyle),u)),[u]),h=()=>e.jsx(O,b(y({commonStyle:L,customCss:E,ref:c},S),{children:d}));return n.useEffect((()=>{const e=setInterval((()=>{if(I)try{const r=document.querySelector(I);if(r&&!q.current){clearInterval(e);const n=document.createElement("div"),o=t.generateRandomId(10);switch(n.id=o,q.current=o,j){case l.InlineBannerRelativePosition.BEFORE:r.before(n);break;case l.InlineBannerRelativePosition.AFTER:r.after(n);break;case l.InlineBannerRelativePosition.IN:r.appendChild(n)}N(n)}}catch(e){console.warn("Invalid css selector provided for InlineBanner",e)}}),R);return()=>{clearInterval(e)}}),[I,j,R]),f?h():B?o.createPortal(e.jsx(a.Link,b(y({},P),{children:h()})),B):null})),O=s.default.div((({commonStyle:e,customCss:r})=>`\n  ${t.getStyle(e)}\n  ${null!=r?r:""}\n`));E.displayName="InlineBanner",exports.InlineBanner=E;


/***/ }),

/***/ 469929:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(800656),t=__webpack_require__(481177);const i={formStyle:{flexDirection:"column",gap:8},inputStyle:{borderRadius:4},showLabel:!0,hiddenFields:[],response:{custom:[]},submits:[],inputs:[{type:"text",label:e.t("Họ và tên"),name:"fullname",commonStyle:{height:32,width:"100%"},disabledFormFieldSetting:[t.PROP_KEY.Name,t.PROP_KEY.Type]},{type:"tel",label:e.t("Số điện thoại"),name:"phone",commonStyle:{height:32,width:"100%"},required:!0,disabledFormFieldSetting:[t.PROP_KEY.Name,t.PROP_KEY.Type,t.PROP_KEY.Required]},{type:"email",label:"Email",name:"email",commonStyle:{height:32,width:"100%"},required:!0,disabledFormFieldSetting:[t.PROP_KEY.Name,t.PROP_KEY.Type,t.PROP_KEY.Required]},{type:"text",label:e.t("Mã khách hàng"),name:"externalId",commonStyle:{height:32,width:"100%"},required:!0,disabledFormFieldSetting:[t.PROP_KEY.Name,t.PROP_KEY.Type,t.PROP_KEY.Required]},{type:"radio-group",label:e.t("Giới tính"),name:"gender",commonStyle:{flexDirection:"column",width:"100%"},disabledFormFieldSetting:[t.PROP_KEY.Name,t.PROP_KEY.Type],options:[{value:"M",label:"Nam"},{value:"F",label:e.t("Nữ")},{value:"U",label:e.t("Khác")}]},{type:"date",label:e.t("Ngày sinh"),name:"birthday",commonStyle:{height:32,width:"100%"},disabledFormFieldSetting:[t.PROP_KEY.Name,t.PROP_KEY.Type]},{type:"location",label:e.t("Địa chỉ"),name:"address",commonStyle:{height:32,width:"100%"},disabledFormFieldSetting:[t.PROP_KEY.Name,t.PROP_KEY.Type]},{type:"text",label:e.t("Số nhà, đường phố"),name:"addressStreet",commonStyle:{height:32,width:"100%"},disabledFormFieldSetting:[t.PROP_KEY.Name,t.PROP_KEY.Type]},{type:"checkbox-group",label:e.t("Sở thích"),name:"interest",commonStyle:{flexDirection:"column",width:"100%"},disabledFormFieldSetting:[t.PROP_KEY.Name,t.PROP_KEY.Type],options:[{value:"option1",label:"Option 1"},{value:"option2",label:"Option 2"}]},{type:"text",label:"Tag 1",name:"tag1",commonStyle:{height:32,width:"100%"},disabledFormFieldSetting:[t.PROP_KEY.Name],typeSelectable:["text","checkbox-group","radio-group"]},{type:"text",label:"Tag 2",name:"tag2",commonStyle:{height:32,width:"100%"},disabledFormFieldSetting:[t.PROP_KEY.Name],typeSelectable:["text","checkbox-group","radio-group"]},{type:"text",label:"Tag 3",name:"tag3",commonStyle:{height:32,width:"100%"},disabledFormFieldSetting:[t.PROP_KEY.Name],typeSelectable:["text","checkbox-group","radio-group"]}]};exports.CDPBff={dev:"https://cdp-bff.dev.tekoapis.net",stag:"https://cdp-bff.stag.tekoapis.net",production:"https://cdp-bff.tekoapis.com"},exports.DEFAULT_LEAD_FORM=i,exports.SMART_BANNER_CONTENT_TYPE="TEMPI_SMART_BANNER";


/***/ }),

/***/ 162952:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(891987),r=__webpack_require__(469929),t=__webpack_require__(85097);exports.useLeadForm=()=>{const{env:n}=t.useStore(),o=new t.Api(r.CDPBff[n]),[s,a]=e.useState(!1);return{loading:s,getFormSession:async()=>{var e,r;try{a(!0);const t=await o.get("/v1/lead-form-event/form-session");return null==(r=null==(e=null==t?void 0:t.data)?void 0:e.data)?void 0:r.formSession}catch(e){return""}finally{a(!1)}}}};


/***/ }),

/***/ 694195:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(891987),o=__webpack_require__(162952),t=__webpack_require__(673100),i=__webpack_require__(845589),n=Object.defineProperty,a=Object.defineProperties,s=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,p=(e,r,o)=>r in e?n(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,u=(e,r)=>{for(var o in r||(r={}))d.call(r,o)&&p(e,o,r[o]);if(c)for(var o of c(r))m.call(r,o)&&p(e,o,r[o]);return e},f=(e,r)=>a(e,s(r));const l=n=>{const{getFormSession:a,loading:s}=o.useLeadForm(),c=r.useRef(),{loading:d,handleSubmitFormData:m}=t.useForm({wrapperRef:c,response:n.response}),{id:p,configStorage:l,inputs:y,device:b,isEditingMode:j,associatedContentType:g,associatedContentIdentified:w}=n;return e.jsx(i.FormV4,f(u({},n),{ref:c,onFinish:!j&&(async e=>{try{const r=await a();await m(l,f(u({},e),{formSession:r,formId:p,formName:p,href:window.location.href,domainName:window.location.origin,terminal:b,associatedContentType:g,associatedContentIdentified:w}),y)}catch(e){console.error(e)}}),customLoading:s||d}))};l.displayName="LeadForm",exports.LeadForm=l;


/***/ }),

/***/ 117192:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(85097),i=__webpack_require__(82613),l=__webpack_require__(844101),r=__webpack_require__(317197),n=__webpack_require__(802636),o=Object.defineProperty,a=Object.defineProperties,p=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,c=Object.prototype.propertyIsEnumerable,d=(e,t,i)=>t in e?o(e,t,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[t]=i,s=(e,t)=>{for(var i in t||(t={}))y.call(t,i)&&d(e,i,t[i]);if(u)for(var i of u(t))c.call(t,i)&&d(e,i,t[i]);return e},h=(e,t)=>a(e,p(t));exports.ActionBar=({actions:o=[],display:a,isEditingMode:p,filterValue:u={},setFilterValue:y,flatFilterStyle:c,alignment:d})=>{const m=({by:e,value:t})=>{p||y(h(s({},u),{[e]:t}))},x=(o,a)=>{var y,d,x,f,v;switch(o.type){case i.ActionTypeEnum.search:return e.jsx(n.InputText,{inputStyle:s({width:"calc(100% - 38px)",minWidth:"calc(100% - 38px)",borderRadius:"4px 0 0 4px"},o.inputStyle),icon:{name:"SearchOutlined",size:20},type:"text",placeholder:o.placeholder,commonStyle:{height:32,width:(null==(y=o.inputStyle)?void 0:y.width)||"100%",widthUnit:(null==(d=o.inputStyle)?void 0:d.widthUnit)||t.UnitEnum.pixel,maxWidth:"100%"},readOnly:p,onChange:e=>m({by:o.by,value:e.target.value}),value:u[o.by]||""},a);case i.ActionTypeEnum.filter:return o.display===i.ActionDisplayEnum.dropdown?e.jsx(r.SelectBox,{type:"select-box",options:o.options,value:u[o.by]||"",placeholder:o.placeholder,inputStyle:s({width:"100%"},o.filterStyle),readOnly:p,commonStyle:h(s({height:32},o.inputStyle),{width:(null==(x=o.filterStyle)?void 0:x.width)||"100%",widthUnit:(null==(f=o.filterStyle)?void 0:f.widthUnit)||t.UnitEnum.pixel,maxWidth:"100%"}),onChange:e=>m({by:o.by,value:e.target.value})},a):e.jsx(l.FlatFilter,{options:[{label:o.placeholder,value:""},...o.options],onChange:e=>m({by:o.by,value:e}),value:u[o.by]||"",activeStyle:s(s({},c),o.activeStyle),filterLabelStyle:h(s(s({},o.inputStyle),o.filterStyle),{justifyContent:(null==(v=null==o?void 0:o.filterStyle)?void 0:v.textAlign)||"center"})},a)}};return e.jsx(e.Fragment,{children:"row"===a?e.jsx("div",{style:{display:"flex",gap:12,flexDirection:"row",width:"100%",justifyContent:"center",marginBottom:48,flexWrap:"wrap"},children:o.map(((e,t)=>x(e,t)))}):e.jsx("div",{style:s(s(s({display:"flex",flexDirection:"column",gap:12,marginBottom:32},"left"===d?{marginRight:12}:{}),"right"===d?{marginLeft:12}:{}),d?{}:{margin:"0 12px"}),children:o.map(((e,t)=>x(e,t)))})})};


/***/ }),

/***/ 844101:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),l=__webpack_require__(85097);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const r=i(t).default.div`
  height: 32px;
  width: 60px;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 4px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  ${e=>`${l.getStyle(null==e?void 0:e.commonStyle)}${e.isActive?`\n        color: #fff;\n        ${l.getStyle(null==e?void 0:e.activeStyle)}\n        `:""}`};
`;exports.FlatFilter=({options:t=[],value:l,onChange:i,defaultValue:o="",filterLabelStyle:n,activeStyle:a})=>e.jsx(e.Fragment,{children:t.map((t=>e.jsx(r,{onClick:()=>i(t.value),isActive:(l||o)===t.value,activeStyle:a,commonStyle:n,className:"tooltip tooltip-bottom",title:t.label,children:t.label},t.value)))});


/***/ }),

/***/ 659651:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(85097),i=__webpack_require__(877084),l=__webpack_require__(115741),o=__webpack_require__(825926);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=s(r),n=s(i),a=Object.defineProperty,c=Object.defineProperties,u=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,f=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,v=(e,r,t)=>r in e?a(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,y=(e,r)=>{for(var t in r||(r={}))f.call(r,t)&&v(e,t,r[t]);if(p)for(var t of p(r))m.call(r,t)&&v(e,t,r[t]);return e},b=(e,r)=>c(e,u(r));const j=d.default.p`
  ${e=>t.getStyle(null==e?void 0:e.commonStyle)}
`;exports.ListCarousel=r=>{var i=r,{items:s=[],carouselOptions:d,isEditingMode:a,mobileSlidesPerView:c,desktopSlidesPerView:u,descStyle:v}=i,S=((e,r)=>{var t={};for(var i in e)f.call(e,i)&&r.indexOf(i)<0&&(t[i]=e[i]);if(null!=e&&p)for(var i of p(e))r.indexOf(i)<0&&m.call(e,i)&&(t[i]=e[i]);return t})(i,["items","carouselOptions","isEditingMode","mobileSlidesPerView","desktopSlidesPerView","descStyle"]);return e.jsx(l.DSSlider,b(y({},d),{speed:null==d?void 0:d.speed,slidesPerView:null==d?void 0:d.slidesPerView,slidesPerViewMobile:2.5,allowTouchMove:!a,children:s.map(((r,i)=>e.jsx(t.BreakpointWidthProvider,{sWidth:{value:100/c,unit:"%"},mWidth:{value:100/u,unit:"%"},children:e.jsx(o.CardDetail,b(y({extraElement:e.jsx(j,{className:n.default("detail-card",S.alignment),commonStyle:v,children:r.desc}),eventType:"link"},y(y({},r),S)),{contentStyle:{padding:{top:8,left:8,right:8},flex:"0 0 auto"}}))},i)))}))};


/***/ }),

/***/ 650852:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(85097),i=__webpack_require__(877084),n=__webpack_require__(891987),o=__webpack_require__(234388),l=__webpack_require__(825926),a=__webpack_require__(541076);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=s(r),c=s(i),u=Object.defineProperty,p=Object.defineProperties,m=Object.getOwnPropertyDescriptors,g=Object.getOwnPropertySymbols,f=Object.prototype.hasOwnProperty,y=Object.prototype.propertyIsEnumerable,j=(e,r,t)=>r in e?u(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,v=(e,r)=>{for(var t in r||(r={}))f.call(r,t)&&j(e,t,r[t]);if(g)for(var t of g(r))y.call(r,t)&&j(e,t,r[t]);return e};const x=d.default.div`
  display: grid;
  align-self: stretch;
  gap: ${16}px;
`,b=d.default.p`
  ${e=>t.getStyle(null==e?void 0:e.commonStyle)}
`;exports.ListGrid=r=>{const i=r,{items:s=[],gridOptions:d,isEditingMode:u,mobileColumns:j,desktopColumns:h,descStyle:O}=i,P=((e,r)=>{var t={};for(var i in e)f.call(e,i)&&r.indexOf(i)<0&&(t[i]=e[i]);if(null!=e&&g)for(var i of g(e))r.indexOf(i)<0&&y.call(e,i)&&(t[i]=e[i]);return t})(i,["items","gridOptions","isEditingMode","mobileColumns","desktopColumns","descStyle"]),[C,q]=n.useState(1),{columns:M,rows:S,displayMode:w,columnGap:E,rowGap:G}=d,k=M*S,D=w===o.DisplayModeType.Pagination,T=n.useMemo((()=>D?s.slice((C-1)*k,C*k):s),[s,k,C,D]);return e.jsxs(e.Fragment,{children:[e.jsx(x,{style:{gridTemplateColumns:`repeat(${M}, minmax(0, 1fr))`,columnGap:E,rowGap:G},children:T.map(((r,i)=>{return e.jsx("div",{children:e.jsx(t.BreakpointWidthProvider,{sWidth:{value:100/j,unit:"%"},mWidth:{value:100/h,unit:"%"},children:e.jsx(l.CardDetail,(n=v({extraElement:e.jsx(b,{className:c.default("detail-card",P.alignment),commonStyle:O,children:r.desc}),eventType:"link"},v(v({},r),P)),o={contentStyle:{padding:{top:8,left:8,right:8}}},p(n,m(o))))})},i);var n,o}))}),D&&!!s.length&&e.jsx(a.Pagination,{isEditingMode:u,onPageChange:({selected:e})=>q(e+1),pageCount:Math.ceil(s.length/k)})]})};


/***/ }),

/***/ 134680:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097),a=__webpack_require__(234388),t=__webpack_require__(800656),i=__webpack_require__(82613),r=__webpack_require__(281586),l=Object.defineProperty,o=Object.defineProperties,p=Object.getOwnPropertyDescriptors,n=Object.getOwnPropertySymbols,m=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,s=(e,a,t)=>a in e?l(e,a,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[a]=t,h=(e,a)=>{for(var t in a||(a={}))m.call(a,t)&&s(e,t,a[t]);if(n)for(var t of n(a))g.call(a,t)&&s(e,t,a[t]);return e},c=(e,a)=>o(e,p(a));const f={name:t.t("item_name"),id:"sample_item",desc:"#L1"},y={displayMode:a.DisplayModeType.All,rows:1,columns:4,columnGap:12,rowGap:12},d={displayMode:a.DisplayModeType.All,rows:1,columns:2,columnGap:12,rowGap:12},b={type:r.SliderTypeEnum.product,slidesPerView:5,slidesPerColumn:1,navigation:!0,navigationStyle:1,autoplay:!0,loop:!1,spaceBetween:16,speed:3e3},u={type:r.SliderTypeEnum.product,slidesPerView:2.5,slidesPerColumn:1,navigation:!0,navigationStyle:1,autoplay:!0,loop:!1,spaceBetween:16,speed:3e3},S={searchName:{type:i.ActionTypeEnum.search,by:"name",display:i.ActionDisplayEnum.searchBar,enable:!0,position:i.Position.top,inputStyle:{width:300,widthUnit:e.UnitEnum.pixel,fontSize:14,fontWeight:"400"},placeholder:t.t("search_name.placeholder")},filterLabel:{type:i.ActionTypeEnum.filter,by:"label",display:i.ActionDisplayEnum.flat,enable:!0,position:i.Position.left,filterStyle:{width:150,widthUnit:e.UnitEnum.pixel,fontSize:14,fontWeight:"400"},keyGetOptions:"labels",placeholder:t.t("common.all"),activeStyle:{backgroundColor:"#7367f0",color:"#fff"}},filterCat:{type:i.ActionTypeEnum.filter,by:"category",display:i.ActionDisplayEnum.dropdown,enable:!0,position:i.Position.top,filterStyle:{width:150,widthUnit:e.UnitEnum.pixel,fontSize:14,fontWeight:"400"},placeholder:t.t("filter_cat.placeholder"),keyGetOptions:"categories",activeStyle:{}}},v={searchName:c(h({},S.searchName),{inputStyle:c(h({},S.searchName.inputStyle),{fontSize:"var(--tempi-global-paragraph2fontsize)",fontWeight:"var(--tempi-global-paragraph2fontweight)",lineHeight:"var(--tempi-global-paragraph2lineheight)",letterSpacing:"var(--tempi-global-paragraph2letterspacing)",currentParagraphTheme:"paragraph2",fontFamily:"var(--tempi-global-paragraph2fontfamily)"})}),filterLabel:c(h({},S.filterLabel),{filterStyle:c(h({},S.filterLabel.filterStyle),{fontSize:"var(--tempi-global-paragraph2fontsize)",fontWeight:"var(--tempi-global-paragraph2fontweight)",lineHeight:"var(--tempi-global-paragraph2lineheight)",letterSpacing:"var(--tempi-global-paragraph2letterspacing)",currentParagraphTheme:"paragraph2",fontFamily:"var(--tempi-global-paragraph2fontfamily)"})}),filterCat:c(h({},S.filterCat),{filterStyle:c(h({},S.filterCat.filterStyle),{fontSize:"var(--tempi-global-paragraph2fontsize)",fontWeight:"var(--tempi-global-paragraph2fontweight)",lineHeight:"var(--tempi-global-paragraph2lineheight)",letterSpacing:"var(--tempi-global-paragraph2letterspacing)",currentParagraphTheme:"paragraph2",fontFamily:"var(--tempi-global-paragraph2fontfamily)"})})},E={searchName:{type:i.ActionTypeEnum.search,by:"name",display:i.ActionDisplayEnum.searchBar,enable:!0,position:i.Position.top,inputStyle:{width:50,widthUnit:e.UnitEnum.percent,fontSize:14,fontWeight:"400"},placeholder:t.t("search_name.placeholder")},filterLabel:{type:i.ActionTypeEnum.filter,by:"label",display:i.ActionDisplayEnum.dropdown,enable:!0,position:i.Position.top,filterStyle:{width:100,widthUnit:e.UnitEnum.percent,fontSize:14,fontWeight:"400"},keyGetOptions:"labels",placeholder:t.t("filter_label.placeholder"),activeStyle:{}},filterCat:{type:i.ActionTypeEnum.filter,by:"category",display:i.ActionDisplayEnum.dropdown,enable:!0,position:i.Position.top,activeStyle:{},filterStyle:{width:46,widthUnit:e.UnitEnum.percent,fontSize:14,fontWeight:"400"},placeholder:t.t("filter_cat.placeholder"),keyGetOptions:"categories"}},L={searchName:c(h({},E.searchName),{inputStyle:c(h({},E.searchName.inputStyle),{fontSize:"var(--tempi-global-paragraph2mobilefontsize)",fontWeight:"var(--tempi-global-paragraph2mobilefontweight)",lineHeight:"var(--tempi-global-paragraph2mobilelineheight)",letterSpacing:"var(--tempi-global-paragraph2mobileletterspacing)",currentParagraphTheme:"paragraph2",fontFamily:"var(--tempi-global-paragraph2fontfamily)"})}),filterLabel:c(h({},E.filterLabel),{filterStyle:c(h({},E.filterLabel.filterStyle),{fontSize:"var(--tempi-global-paragraph2mobilefontsize)",fontWeight:"var(--tempi-global-paragraph2mobilefontweight)",lineHeight:"var(--tempi-global-paragraph2mobilelineheight)",letterSpacing:"var(--tempi-global-paragraph2mobileletterspacing)",currentParagraphTheme:"paragraph2",fontFamily:"var(--tempi-global-paragraph2fontfamily)"})}),filterCat:c(h({},E.filterCat),{filterStyle:c(h({},E.filterCat.filterStyle),{fontSize:"var(--tempi-global-paragraph2mobilefontsize)",fontWeight:"var(--tempi-global-paragraph2mobilefontweight)",lineHeight:"var(--tempi-global-paragraph2mobilelineheight)",letterSpacing:"var(--tempi-global-paragraph2mobileletterspacing)",currentParagraphTheme:"paragraph2",fontFamily:"var(--tempi-global-paragraph2fontfamily)"})})},T={desktop:{alignment:"left",gridOptions:y,nameStyle:{color:"#000",fontSize:16,fontWeight:"700"},descStyle:{color:"#000",fontSize:14,fontWeight:"400"},actions:S,imageStyle:{borderStyle:"solid",borderColor:"#d9d9d9",borderWidth:1},layout:"grid",carouselOptions:b},mobile:{alignment:"left",gridOptions:d,nameStyle:{color:"#000",fontSize:14,fontWeight:"700"},descStyle:{fontSize:12,fontWeight:"400"},actions:E,imageStyle:{borderStyle:"solid",borderColor:"#d9d9d9",borderWidth:1},layout:"grid",carouselOptions:u},items:[{name:"Item 1",image:{src:"https://lh3.googleusercontent.com/IlZnamzZ1XdAhL8mgXQAyaTyF_YglEGB_9x7iiliTmxXa1Dpv8n-9_ptYOLsWIb9enIVEZ8m4mAsG-Nyo9Hz9bS9UXebUjk"},id:"SAMPLE00001",desc:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"},{name:"Item 2",image:{src:"https://lh3.googleusercontent.com/IlZnamzZ1XdAhL8mgXQAyaTyF_YglEGB_9x7iiliTmxXa1Dpv8n-9_ptYOLsWIb9enIVEZ8m4mAsG-Nyo9Hz9bS9UXebUjk"},id:"SAMPLE00002",desc:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"},{name:"Item 3",image:{src:"https://lh3.googleusercontent.com/IlZnamzZ1XdAhL8mgXQAyaTyF_YglEGB_9x7iiliTmxXa1Dpv8n-9_ptYOLsWIb9enIVEZ8m4mAsG-Nyo9Hz9bS9UXebUjk"},id:"SAMPLE00003",desc:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"},{name:"Item 4",image:{src:"https://lh3.googleusercontent.com/IlZnamzZ1XdAhL8mgXQAyaTyF_YglEGB_9x7iiliTmxXa1Dpv8n-9_ptYOLsWIb9enIVEZ8m4mAsG-Nyo9Hz9bS9UXebUjk"},id:"SAMPLE00004",desc:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"}],labels:[],categories:[],alignment:"left",carouselOptions:void 0,layout:"grid",nameStyle:{color:"#000"},descStyle:{color:"#000"},actions:{searchName:{inputStyle:{}},filterCat:{filterStyle:{}},filterLabel:{filterStyle:{}}}},A=c(h({},T),{desktop:c(h({},T.desktop),{nameStyle:c(h({},T.desktop.nameStyle),{fontSize:"var(--tempi-global-paragraph1fontsize)",fontWeight:"700",lineHeight:"var(--tempi-global-paragraph1lineheight)",letterSpacing:"var(--tempi-global-paragraph1letterspacing)",currentParagraphTheme:"paragraph1",fontFamily:"var(--tempi-global-paragraph1fontfamily)"}),descStyle:c(h({},T.desktop.descStyle),{fontSize:"var(--tempi-global-paragraph2fontsize)",fontWeight:"var(--tempi-global-paragraph2fontweight)",lineHeight:"var(--tempi-global-paragraph2lineheight)",letterSpacing:"var(--tempi-global-paragraph2letterspacing)",currentParagraphTheme:"paragraph2",fontFamily:"var(--tempi-global-paragraph2fontfamily)"}),actions:v}),mobile:c(h({},T.mobile),{nameStyle:c(h({},T.mobile.nameStyle),{fontSize:"var(--tempi-global-paragraph1mobilefontsize)",fontWeight:"700",lineHeight:"var(--tempi-global-paragraph1mobilelineheight)",letterSpacing:"var(--tempi-global-paragraph1mobileletterspacing)",currentParagraphTheme:"paragraph1",fontFamily:"var(--tempi-global-paragraph1fontfamily)"}),descStyle:c(h({},T.mobile.descStyle),{fontSize:"var(--tempi-global-paragraph2mobilefontsize)",fontWeight:"var(--tempi-global-paragraph2mobilefontweight)",lineHeight:"var(--tempi-global-paragraph2mobilelineheight)",letterSpacing:"var(--tempi-global-paragraph2mobileletterspacing)",currentParagraphTheme:"paragraph2",fontFamily:"var(--tempi-global-paragraph2fontfamily)"}),actions:L}),nameStyle:c(h({},T.nameStyle),{currentParagraphTheme:"paragraph1",fontFamily:"var(--tempi-global-paragraph1fontfamily)"}),descStyle:c(h({},T.descStyle),{currentParagraphTheme:"paragraph2",fontFamily:"var(--tempi-global-paragraph2fontfamily)"}),actions:{searchName:{inputStyle:{currentParagraphTheme:"paragraph2",fontFamily:"var(--tempi-global-paragraph2fontfamily)"}},filterCat:{filterStyle:{currentParagraphTheme:"paragraph2",fontFamily:"var(--tempi-global-paragraph2fontfamily)"}},filterLabel:{filterStyle:{currentParagraphTheme:"paragraph2",fontFamily:"var(--tempi-global-paragraph2fontfamily)"}}}}),_=[{tag:"ListFilter",group:t.t("list_filter"),props:{desktop:{gridOptions:{displayMode:"ALL",rows:1,columns:4,columnGap:12,rowGap:12},actions:{searchName:{enable:!1},filterLabel:{enable:!1},filterCat:{enable:!1}}},items:[{name:"Item name",image:{src:"https://lh3.googleusercontent.com/IlZnamzZ1XdAhL8mgXQAyaTyF_YglEGB_9x7iiliTmxXa1Dpv8n-9_ptYOLsWIb9enIVEZ8m4mAsG-Nyo9Hz9bS9UXebUjk"},id:"SAMPLE00001",desc:"#L1"},{name:"Item name",image:{src:"https://lh3.googleusercontent.com/IlZnamzZ1XdAhL8mgXQAyaTyF_YglEGB_9x7iiliTmxXa1Dpv8n-9_ptYOLsWIb9enIVEZ8m4mAsG-Nyo9Hz9bS9UXebUjk"},id:"SAMPLE00002",desc:"#L1"},{name:"Item name",image:{src:"https://lh3.googleusercontent.com/IlZnamzZ1XdAhL8mgXQAyaTyF_YglEGB_9x7iiliTmxXa1Dpv8n-9_ptYOLsWIb9enIVEZ8m4mAsG-Nyo9Hz9bS9UXebUjk"},id:"SAMPLE00003",desc:"#L1"}]},src:"https://lh3.googleusercontent.com/9ib7hfYkP70lkL4zNK9pebExHutiBejCh-F6eGdccGEL3lZzEXPYyoGZN-sHCUfOn14BrYpq8Kf7HeaL99MLgIla1RwozSJ3"}];exports.DEFAULT_ACTION_DESKTOP=S,exports.DEFAULT_ACTION_DESKTOP_THEME=v,exports.DEFAULT_ACTION_MOBILE=E,exports.DEFAULT_ACTION_MOBILE_THEME=L,exports.DEFAULT_LIST_FILTER=T,exports.DEFAULT_LIST_FILTER_THEME=A,exports.DEFAULT_PRODUCT=f,exports.SAMPLE_LIST_FILTER=_,exports.defaultCarouselOptions=b,exports.defaultGridOptions=y,exports.defaultMobileCarouselOptions=u,exports.defaultMobileGridOptions=d;


/***/ }),

/***/ 82613:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=(t=>(t.filter="filter",t.search="search",t))(t||{}),e=(t=>(t.searchBar="searchBar",t.dropdown="dropdown",t.flat="flat",t))(e||{}),o=(t=>(t.top="top",t.left="left",t.right="right",t.bottom="bottom",t))(o||{});exports.ActionDisplayEnum=e,exports.ActionTypeEnum=t,exports.Position=o;


/***/ }),

/***/ 841849:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),i=__webpack_require__(85097),l=__webpack_require__(143599),o=__webpack_require__(891987),r=__webpack_require__(117192),n=__webpack_require__(659651),s=__webpack_require__(134680),d=__webpack_require__(82613),a=__webpack_require__(650852);function u(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=u(t),p=Object.defineProperty,m=Object.defineProperties,f=Object.getOwnPropertyDescriptors,g=Object.getOwnPropertySymbols,v=Object.prototype.hasOwnProperty,y=Object.prototype.propertyIsEnumerable,b=(e,t,i)=>t in e?p(e,t,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[t]=i,j=(e,t)=>{for(var i in t||(t={}))v.call(t,i)&&b(e,i,t[i]);if(g)for(var i of g(t))y.call(t,i)&&b(e,i,t[i]);return e},O=(e,t)=>m(e,f(t)),h=(e,t)=>{var i={};for(var l in e)v.call(e,l)&&t.indexOf(l)<0&&(i[l]=e[l]);if(null!=e&&g)for(var l of g(e))t.indexOf(l)<0&&y.call(e,l)&&(i[l]=e[l]);return i};const w=o.forwardRef(((t,u)=>{var c,p,m;const f=t,{isEditingMode:g,items:v=[],categories:y,labels:b,className:w,id:q}=f,M=h(f,["isEditingMode","items","categories","labels","className","id"]),{device:C}=i.useStore(),[E,L]=o.useState({name:"",category:"",label:""}),N=i.getPropsByDevice(M,C),{actions:A,flatFilterStyle:B,layout:G,commonStyle:D}=N,I=h(N,["actions","flatFilterStyle","layout","commonStyle"]),{filterLabel:_,filterCat:z,searchName:R}=A,T=[R,z,_].reduce(((e,i)=>{const l=j({},i);i.type===d.ActionTypeEnum.filter&&i.keyGetOptions&&(l.options=t[i.keyGetOptions].map((e=>"string"==typeof e?{label:e,value:e}:e)));let o=i.position;return i===_&&_.alignment&&(o="mobile"===C?d.Position.top:"left"===_.alignment?d.Position.left:d.Position.right),e[o]&&i.enable&&e[o].push(l),!e[o]&&i.enable&&(e[o]=[l]),e}),{}),$=o.useMemo((()=>{const e=Object.keys(E).reduce(((e,t)=>{const i=(E[t]||"").toString().toLowerCase().trim();return i&&(e[t]=i),e}),{});return v.filter((t=>Object.keys(e).every((i=>{var l;const o=null==(l=t[i])?void 0:l.toString().toLowerCase();return!!o&&("name"===i?o.includes(e[i]):o===e[i])}))))}),[v,E]);return e.jsxs(x,{ref:u,"data-id":q,commonStyle:D,className:w,children:[(null==(c=null==T?void 0:T.left)?void 0:c.length)&&e.jsx(S,{children:e.jsx(r.ActionBar,{isEditingMode:g,display:"col",actions:(null==T?void 0:T.left)||[],filterValue:E,setFilterValue:L,flatFilterStyle:B,alignment:"left"})}),(null==(p=null==T?void 0:T.top)?void 0:p.length)&&e.jsx(F,{children:e.jsx(r.ActionBar,{isEditingMode:g,display:"row",actions:T.top,filterValue:E,setFilterValue:L,flatFilterStyle:B})}),e.jsx(V,{children:(null==$?void 0:$.length)?"carousel"===G?e.jsx(n.ListCarousel,O(j({mobileSlidesPerView:(null==(J=null==(H=null==M?void 0:M.mobile)?void 0:H.carouselOptions)?void 0:J.slidesPerView)||s.defaultMobileCarouselOptions.slidesPerView,desktopSlidesPerView:(null==(Q=null==(K=null==M?void 0:M.desktop)?void 0:K.carouselOptions)?void 0:Q.slidesPerView)||s.defaultCarouselOptions.slidesPerView,isEditingMode:g},I),{items:$})):e.jsx(a.ListGrid,O(j({},I),{items:$,isEditingMode:g,desktopColumns:null==(W=null==(U=null==M?void 0:M.desktop)?void 0:U.gridOptions)?void 0:W.columns,mobileColumns:null==(Y=null==(X=null==M?void 0:M.mobile)?void 0:X.gridOptions)?void 0:Y.columns})):e.jsx(k,{children:e.jsx(l.Icon,{name:"NotFoundOutlined",style:{fontSize:120,color:"#ccc"}})})}),(null==(m=null==T?void 0:T.right)?void 0:m.length)&&e.jsx(P,{children:e.jsx(r.ActionBar,{isEditingMode:g,display:"col",actions:(null==T?void 0:T.right)||[],filterValue:E,setFilterValue:L,flatFilterStyle:B,alignment:"right"})})]});var H,J,K,Q,U,W,X,Y}));w.displayName="ListFilter";const x=c.default.div`
  display: grid;
  grid-template-columns: 1fr minmax(auto, 100%);
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  ${e=>i.getStyle(e.commonStyle)}
`,S=c.default.div`
  grid-column: 1 / span 1;
  grid-row: 2;
`,P=c.default.div`
  grid-column: 3 / span 1;
  grid-row: 2;
`,V=c.default.div`
  grid-column: 2 / span 1;
  grid-row: 2;
  display: block;
  min-width: 0;
`,F=c.default.div`
  grid-column: 2 / span 1;
  grid-row: 1;
`,k=c.default.div`
  width: 100%;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f7f7f7ed;
`;exports.ListFilter=w;


/***/ }),

/***/ 690310:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));const e=(__webpack_require__(891987).createContext)({});exports.ListItemContext=e;


/***/ }),

/***/ 647950:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097),n=__webpack_require__(891987),o=__webpack_require__(534479),i=__webpack_require__(426839);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=l(t),c=l(n),s=Object.defineProperty,u=Object.defineProperties,f=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,y=Object.prototype.propertyIsEnumerable,j=(e,t,r)=>t in e?s(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,m=(e,t)=>{for(var r in t||(t={}))p.call(t,r)&&j(e,r,t[r]);if(d)for(var r of d(t))y.call(t,r)&&j(e,r,t[r]);return e},b=(e,t)=>u(e,f(t));const v=a.default.div((({commonStyle:e})=>`\n    ${r.getStyle(e)}\n    ${o.getCommonTextCss(!0)}\n    a {\n      color: inherit;\n    }\n  `)),x=c.default.forwardRef(((t,n)=>{const o=t,{text:l,children:a,event:c}=o,s=((e,t)=>{var r={};for(var n in e)p.call(e,n)&&t.indexOf(n)<0&&(r[n]=e[n]);if(null!=e&&d)for(var n of d(e))t.indexOf(n)<0&&y.call(e,n)&&(r[n]=e[n]);return r})(o,["text","children","event"]),u=null==c?void 0:c.tekoTrackingEvent,{text:f}=r.useInjectDynamicLinks(l,i.objectToAttrString(i.getAttrTracking(u)));return a?e.jsx(v,b(m({ref:n},s),{children:a})):e.jsx(v,b(m({ref:n},s),{dangerouslySetInnerHTML:{__html:f}}))}));x.displayName="ListItemContentV2",exports.ListItemContentV2=x,exports.StyledContent=v;


/***/ }),

/***/ 984175:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097),n=__webpack_require__(891987),o=__webpack_require__(954591),i=__webpack_require__(690310),s=__webpack_require__(570267),c=__webpack_require__(319891);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=l(t),d=l(n),u=Object.defineProperty,p=Object.defineProperties,f=Object.getOwnPropertyDescriptors,y=Object.getOwnPropertySymbols,m=Object.prototype.hasOwnProperty,j=Object.prototype.propertyIsEnumerable,v=(e,t,r)=>t in e?u(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,x=(e,t)=>{for(var r in t||(t={}))m.call(t,r)&&v(e,r,t[r]);if(y)for(var r of y(t))j.call(t,r)&&v(e,r,t[r]);return e};const b=a.default.div((({commonStyle:e,iconStyle:t})=>`\n  display: flex;\n  ${r.getStyle(t)}\n  ${r.getStyle(e)}\n`)),g=d.default.forwardRef(((t,l)=>{const a=t,{event:d,position:u,isEditor:v}=a,g=((e,t)=>{var r={};for(var n in e)m.call(e,n)&&t.indexOf(n)<0&&(r[n]=e[n]);if(null!=e&&y)for(var n of y(e))t.indexOf(n)<0&&j.call(e,n)&&(r[n]=e[n]);return r})(a,["event","position","isEditor"]),{device:O}=r.useStore(),{iconConfig:S,iconStyle:I}=n.useContext(i.ListItemContext),{icon:P,commonStyle:q}=r.getPropsByDevice(g,O),h=s.getIconComponent(null==S?void 0:S.icon),w=s.getIconComponent(P);return e.jsxs(e.Fragment,{children:[u===o.Position.behind&&e.jsx("div",{style:{width:S.spacing}}),e.jsx(b,{ref:l,commonStyle:q,iconStyle:I,children:v?w||h:e.jsx(c.Link,(C=x({},d),L={children:w||h},p(C,f(L))))}),u===o.Position.front&&e.jsx("div",{style:{width:S.spacing}})]});var C,L}));g.displayName="ListItemIconV2",exports.ListItemIconV2=g;


/***/ }),

/***/ 142848:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(85097),o=__webpack_require__(891987),n=__webpack_require__(690310);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=i(r),c=i(o),a=Object.defineProperty,f=Object.defineProperties,s=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,y=(e,r,t)=>r in e?a(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,m=(e,r)=>{for(var t in r||(r={}))d.call(r,t)&&y(e,t,r[t]);if(u)for(var t of u(r))p.call(r,t)&&y(e,t,r[t]);return e};const v=c.default.forwardRef(((r,o)=>{var i=r,{children:l}=i,c=((e,r)=>{var t={};for(var o in e)d.call(e,o)&&r.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&u)for(var o of u(e))r.indexOf(o)<0&&p.call(e,o)&&(t[o]=e[o]);return t})(i,["children"]);const{iconConfig:a,iconStyle:y}=c,{device:v}=t.useStore(),{commonStyle:j}=t.getPropsByDevice(c,v);return e.jsx(n.ListItemContext.Provider,{value:{iconConfig:a,iconStyle:y},children:e.jsx(b,(O=m({ref:o},c),x={commonStyle:j,children:l},f(O,s(x))))});var O,x})),b=l.default.div((({commonStyle:e})=>`\n    display: flex;\n    ${t.getStyle(e)}\n`));v.displayName="ListItemV2",exports.ListItemV2=v;


/***/ }),

/***/ 180605:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(800656),t=Object.defineProperty,i=Object.getOwnPropertySymbols,r=Object.prototype.hasOwnProperty,s=Object.prototype.propertyIsEnumerable,o=(e,i,r)=>i in e?t(e,i,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[i]=r,a=(e,t)=>{for(var a in t||(t={}))r.call(t,a)&&o(e,a,t[a]);if(i)for(var a of i(t))s.call(t,a)&&o(e,a,t[a]);return e},n=(e=>(e[e.OUT_OF_TURN=400018]="OUT_OF_TURN",e[e.OUT_OF_PRIZE=400020]="OUT_OF_PRIZE",e))(n||{});const d={id:null,gameId:null,backgroundColors:["#e70a12","#fee7b5"],prizeAngle:90,spinDuration:1,textColors:["white"],canvasConfig:{innerRadius:0,fontSize:17,radiusLineColor:"#eeeeee",radiusLineWidth:0,perpendicularPrize:!0,textDistance:60,border:{innerBorderColor:"#ffffff",innerBorderWidth:0,outerBorderColor:"#ffffff",outerBorderWidth:-10,image:{src:"https://lh3.googleusercontent.com/SVu3oUkfvSqHso_2nPT7ZV-tbkcXohRGK73XK-0RAieqjpVzvahMB_sNerbsD9z-RU9YgVEQz8OvJDPC2FX2xz-u5tK8Vpcw"}}},spinTrigger:{text:"Spin",buttonStyle:{backgroundColor:"#ff4646",borderColor:"#328ed9",borderWidth:6,color:"#ffffff",fontSize:"1.5em",fontWeight:"bold",hover:{zoom:105}},image:{src:"https://lh3.googleusercontent.com/r5nZppsbH9EsI9GdyNqXFH19lto88WhhL2XL1Juexc9sElHTLXUWx-8HkHwMwsoe6rpVe3R3m2gR6fC10yMJ7s8U4mBgaW4"},imageStyle:{hover:{zoom:110}}},roulette:{rotate:90,color:"#328ed9",size:40},emptyPrizeConfig:{enable:!1,name:e.t("game.empty_prize.name"),image:{src:"https://lh3.googleusercontent.com/YmOps4kXGr69cywN5hmI4d63hTklIvjZIwaayHuJCuBfrmmJpE2KS8gBIxOAbIxtn8mQlxVMB-w-hqnpQO13Rmn5ueFX4OWV"}}},l=[{tag:"LuckyDrawV2",group:e.t("Vòng quay may mắn"),src:"https://lh3.googleusercontent.com/oasJmjLkMJCnD3nQ5nAsEUqKsnVSjaGjoLr_5OXuJNVFHYZgrIVN73KYmzBZmOTxNkMZFnOffr-gslbwWYR9DD7Kua8tTG-B"}];exports.DEFAULT_LUCKY_DRAW_V2=d,exports.DEFAULT_POPUP_EMPTY_PRIZE=(t,i)=>({BraTGniUhP:{id:"BraTGniUhP",parentId:"7PhZ7Orijk",tag:"spacer",resolvedName:"SpacerEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{spacer:{responsive:{hiddenXs:!1,hiddenMd:!1},height:16}},children:[]},hZJ3PSQWs3:{id:"hZJ3PSQWs3",parentId:"7PhZ7Orijk",tag:"image",resolvedName:"ImageEditor",style:{width:60,widthUnit:"%",height:100,heightUnit:"%",margin:{top:0,bottom:0,right:0,left:0}},isActive:!1,isCanvas:!1,customAttributes:{image:{responsive:{hiddenXs:!1,hiddenMd:!1},src:"https://lh3.googleusercontent.com/B8UCNG5G1RPLbQ4ytQDyUIKOAIEgZKtDSKhlQloAcQB7Xak1Xfv6wnPWfXmdVuNb6w9Zn8krUlixTa_F3z7HOUnyiT6e3fZL",googleImageParams:{percent:100,width:1088}}},children:[]},".wuwrv13b":{id:".wuwrv13b",parentId:"7PhZ7Orijk",tag:"spacer",resolvedName:"SpacerEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{spacer:{responsive:{hiddenXs:!1,hiddenMd:!1},height:16}},children:[]},UeMBzuDA2c:{id:"UeMBzuDA2c",parentId:"7PhZ7Orijk",tag:"paragraph",resolvedName:"ParagraphEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{paragraph:a({responsive:{hiddenXs:!1,hiddenMd:!1},text:i?`\n          <h2 style="font-family: var(--tempi-global-paragraph1fontfamily); --fontSizeDesktop: 24px; --fontSizeMobile: 24px; font-weight: 700; color: rgb(27, 29, 41); text-align: center" class="fs-desktop fs-mobile fs-desktop fs-mobile fs-desktop fs-mobile"><strong>${e.t("Chúc bạn may mắn lần sau!")}</strong></h2> \n        `:`\n          <h2 style="text-align: center; font-family: Quicksand"><strong><span style="font-size: 24px; color: rgb(27, 29, 41); background-color: rgb(255, 255, 255); font-weight: 700; text-transform: none">${e.t("Chúc bạn may mắn lần sau!")}</span></strong></h2> \n        `},i&&{currentParagraphTheme:"custom"})},children:[]},"7PhZ7Orijk":{id:"7PhZ7Orijk",elementId:"7PhZ7Orijk",parentId:"ROOT",tag:"popupv1",resolvedName:"PopupEditorV1",style:{width:400,height:200,backgroundColor:"#fff",padding:{left:24,right:24,bottom:24,top:0},borderRadius:24,borderColor:"#ff5722ff"},isActive:!1,isCanvas:!0,customAttributes:{popupv1:{responsive:{hiddenXs:!1,hiddenMd:!1},maskClosable:!0,maskStyle:{backgroundColor:"rgba(0, 0, 0, 0.1)"},position:"default",name:t,showCloseIcon:!0}},children:["BraTGniUhP","hZJ3PSQWs3",".wuwrv13b","UeMBzuDA2c"]}}),exports.DEFAULT_POPUP_OUT_OF_MOVE_V2=(t,i)=>({".xgukw6ne":{id:".xgukw6ne",elementId:"7PhZ7Orijk",parentId:"ROOT",tag:"popupv1",resolvedName:"PopupEditorV1",style:{width:400,height:200,backgroundColor:"#fff",padding:{left:24,right:24,bottom:24,top:0},borderRadius:24,borderColor:"#ff5722ff"},isActive:!1,isCanvas:!0,customAttributes:{popupv1:{responsive:{hiddenXs:!1,hiddenMd:!1},maskClosable:!0,maskStyle:{backgroundColor:"rgba(0, 0, 0, 0.1)"},position:"default",name:t,showCloseIcon:!0}},children:[".k85i8qdw",".g7ef9s9p",".lvhq4cof",".1gmmca8b",".gqixp832",".vrduzqmv"]},".k85i8qdw":{id:".k85i8qdw",parentId:".xgukw6ne",tag:"spacer",resolvedName:"SpacerEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{spacer:{responsive:{hiddenXs:!1,hiddenMd:!1},height:16}},children:[]},".g7ef9s9p":{id:".g7ef9s9p",parentId:".xgukw6ne",tag:"image",resolvedName:"ImageEditor",style:{width:60,widthUnit:"%",height:100,heightUnit:"%",margin:{top:0,bottom:0,right:0,left:0}},isActive:!1,isCanvas:!1,customAttributes:{image:{responsive:{hiddenXs:!1,hiddenMd:!1},src:"https://lh3.googleusercontent.com/B8UCNG5G1RPLbQ4ytQDyUIKOAIEgZKtDSKhlQloAcQB7Xak1Xfv6wnPWfXmdVuNb6w9Zn8krUlixTa_F3z7HOUnyiT6e3fZL",googleImageParams:{percent:100,width:1088}}},children:[]},".lvhq4cof":{id:".lvhq4cof",parentId:".xgukw6ne",tag:"spacer",resolvedName:"SpacerEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{spacer:{responsive:{hiddenXs:!1,hiddenMd:!1},height:16}},children:[]},".1gmmca8b":{id:".1gmmca8b",parentId:".xgukw6ne",tag:"paragraph",resolvedName:"ParagraphEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{paragraph:a({responsive:{hiddenXs:!1,hiddenMd:!1},text:i?`\n          <h2 style="font-family: var(--tempi-global-paragraph1fontfamily); --fontSizeDesktop: 24px; --fontSizeMobile: 24px; font-weight: 700; color: rgb(27, 29, 41); text-align: center" class="fs-desktop fs-mobile fs-desktop fs-mobile fs-desktop fs-mobile"><strong>${e.t("Bạn đã hết lượt quay!")}</strong></h2>\n        `:`\n          <h2 style="text-align: center; font-family: Quicksand"><strong><span style="font-size: 24px; color: rgb(27, 29, 41); background-color: rgb(255, 255, 255); font-weight: 700; text-transform: none">${e.t("Bạn đã hết lượt quay!")}</span></strong></h2>\n        `},i&&{currentParagraphTheme:"custom"})},children:[]},".gqixp832":{id:".gqixp832",parentId:".xgukw6ne",tag:"spacer",resolvedName:"SpacerEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{spacer:{responsive:{hiddenXs:!1,hiddenMd:!1},height:16}},children:[]},".vrduzqmv":{id:".vrduzqmv",parentId:".xgukw6ne",tag:"paragraph",resolvedName:"ParagraphEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{paragraph:a({responsive:{hiddenXs:!1,hiddenMd:!1},text:i?`\n          <h6 style="font-family: var(--tempi-global-paragraph1fontfamily); --fontSizeDesktop: 16px; --fontSizeMobile: 16px; font-weight: 700; color: rgb(67, 70, 87); text-align: center" class="fs-desktop fs-mobile fs-desktop fs-mobile fs-desktop fs-mobile"><strong>${e.t("Vui lòng thử lại sau nhé")}</strong></h6>\n        `:`\n          <h6 style="text-align: center; font-size: 16px; font-family: Quicksand"><strong><span style="color: rgb(67, 70, 87); font-weight: 400">${e.t("Vui lòng thử lại sau nhé")}</span></strong></h6>\n        `},i&&{currentParagraphTheme:"custom"})},children:[]}}),exports.DEFAULT_POPUP_OUT_OF_PRIZE_V2=(t,i)=>({BraTGniUhP:{id:"BraTGniUhP",parentId:"7PhZ7Orijk",tag:"spacer",resolvedName:"SpacerEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{spacer:{responsive:{hiddenXs:!1,hiddenMd:!1},height:16}},children:[]},hZJ3PSQWs3:{id:"hZJ3PSQWs3",parentId:"7PhZ7Orijk",tag:"image",resolvedName:"ImageEditor",style:{width:60,widthUnit:"%",height:100,heightUnit:"%",margin:{top:0,bottom:0,right:0,left:0}},isActive:!1,isCanvas:!1,customAttributes:{image:{responsive:{hiddenXs:!1,hiddenMd:!1},src:"https://lh3.googleusercontent.com/B8UCNG5G1RPLbQ4ytQDyUIKOAIEgZKtDSKhlQloAcQB7Xak1Xfv6wnPWfXmdVuNb6w9Zn8krUlixTa_F3z7HOUnyiT6e3fZL",googleImageParams:{percent:100,width:1088}}},children:[]},".wuwrv13b":{id:".wuwrv13b",parentId:"7PhZ7Orijk",tag:"spacer",resolvedName:"SpacerEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{spacer:{responsive:{hiddenXs:!1,hiddenMd:!1},height:16}},children:[]},UeMBzuDA2c:{id:"UeMBzuDA2c",parentId:"7PhZ7Orijk",tag:"paragraph",resolvedName:"ParagraphEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{paragraph:a({responsive:{hiddenXs:!1,hiddenMd:!1},text:i?`\n          <h2 style="font-family: var(--tempi-global-paragraph1fontfamily); --fontSizeDesktop: 24px; --fontSizeMobile: 24px; font-weight: 700; color: rgb(27, 29, 41); text-align: center" class="fs-desktop fs-mobile fs-desktop fs-mobile fs-desktop fs-mobile"><strong>${e.t("Rất tiếc, quà đã hết!")}</strong></h2> \n        `:`\n          <h2 style="text-align: center; font-family: Quicksand"><strong><span style="font-size: 24px; color: rgb(27, 29, 41); background-color: rgb(255, 255, 255); font-weight: 700; text-transform: none">${e.t("Rất tiếc, quà đã hết!")}</span></strong></h2> \n        `},i&&{currentParagraphTheme:"custom"})},children:[]},".cyapx8b1":{id:".cyapx8b1",parentId:"7PhZ7Orijk",tag:"spacer",resolvedName:"SpacerEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{spacer:{responsive:{hiddenXs:!1,hiddenMd:!1},height:16}},children:[]},".vt2iwmb0":{id:".vt2iwmb0",parentId:"7PhZ7Orijk",tag:"paragraph",resolvedName:"ParagraphEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{paragraph:a({responsive:{hiddenXs:!1,hiddenMd:!1},text:i?`\n          <h6 style="font-family: var(--tempi-global-paragraph1fontfamily); --fontSizeDesktop: 16px; --fontSizeMobile: 16px; font-weight: 700; color: rgb(67, 70, 87); text-align: center" class="fs-desktop fs-mobile fs-desktop fs-mobile fs-desktop fs-mobile"><strong>${e.t("Vui lòng thử lại sau nhé")}</strong></h6>\n        `:`\n        <h6 style="text-align: center; font-size: 16px; font-family: Quicksand"><strong><span style="color: rgb(67, 70, 87); font-weight: 400">${e.t("Vui lòng thử lại sau nhé")}</span></strong></h6>\n      `},i&&{currentParagraphTheme:"custom"})},children:[]},"7PhZ7Orijk":{id:"7PhZ7Orijk",elementId:"7PhZ7Orijk",parentId:"ROOT",tag:"popupv1",resolvedName:"PopupEditorV1",style:{width:400,height:200,backgroundColor:"#fff",padding:{left:24,right:24,bottom:24,top:0},borderRadius:24,borderColor:"#ff5722ff"},isActive:!1,isCanvas:!0,customAttributes:{popupv1:{responsive:{hiddenXs:!1,hiddenMd:!1},maskClosable:!0,maskStyle:{backgroundColor:"rgba(0, 0, 0, 0.1)"},position:"default",name:t,showCloseIcon:!0}},children:["BraTGniUhP","hZJ3PSQWs3",".wuwrv13b","UeMBzuDA2c",".cyapx8b1",".vt2iwmb0"]}}),exports.DEFAULT_POPUP_PRIZE_V2=(t,i)=>({".dp27jtsb":{id:".dp27jtsb",elementId:"7PhZ7Orijk",parentId:"ROOT",tag:"popupv1",resolvedName:"PopupEditorV1",style:{width:400,backgroundColor:"#fff",padding:{left:24,right:24,bottom:24,top:0},borderRadius:24,borderColor:"#ff5722ff"},isActive:!1,isCanvas:!0,customAttributes:{popupv1:{responsive:{hiddenXs:!1,hiddenMd:!1},maskClosable:!0,maskStyle:{backgroundColor:"rgba(0, 0, 0, 0.1)"},position:"default",name:t,showCloseIcon:!0}},children:[".wmmjc6p0",".t3o9bcjz",".xl9nmif2",".ishc5gft",".likgxefm",".ar9360ca"]},".wmmjc6p0":{id:".wmmjc6p0",parentId:".dp27jtsb",tag:"spacer",resolvedName:"SpacerEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{spacer:{responsive:{hiddenXs:!1,hiddenMd:!1},height:16}},children:[]},".t3o9bcjz":{id:".t3o9bcjz",parentId:".dp27jtsb",tag:"image",resolvedName:"ImageEditor",style:{width:60,widthUnit:"%",height:100,heightUnit:"%"},isActive:!1,isCanvas:!1,customAttributes:{image:{responsive:{hiddenXs:!1,hiddenMd:!1},src:"https://lh3.googleusercontent.com/TCygQ0UckARy2xGqh3lBAcEJLpEbCRdjqvk4OnuOm5FVWchbXgFNFI_WgOoparnjX0xkQ_fK5W3qNHQVEXY3Xliqm62CADPUfA",googleImageParams:{percent:100,width:1088}}},children:[]},".xl9nmif2":{id:".xl9nmif2",parentId:".dp27jtsb",tag:"image",resolvedName:"ImageEditor",style:{width:75,widthUnit:"%",height:100,heightUnit:"%"},isActive:!1,isCanvas:!1,customAttributes:{image:{responsive:{hiddenXs:!1,hiddenMd:!1},src:"https://lh3.googleusercontent.com/dMzPbBXMFw4WUKWqtdw0wxFvRxXuoVQwsJH6iQg4nx-CDzLynOTPao3qLnT7926_UDIOrzdhdKx41DuTMf1luoMIAuyQ3UuyTQ",googleImageParams:{percent:100,width:1053}}},children:[]},".ishc5gft":{id:".ishc5gft",parentId:".dp27jtsb",tag:"paragraph",resolvedName:"ParagraphEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{paragraph:a({responsive:{hiddenXs:!1,hiddenMd:!1},text:i?'<h2 style="font-family: var(--tempi-global-paragraph1fontfamily); --fontSizeDesktop: 24px; --fontSizeMobile: 24px; font-weight: 700; color: rgb(27, 29, 41); text-align: center" class="fs-desktop fs-mobile fs-desktop fs-mobile fs-desktop fs-mobile"><strong>{{name}}</strong></h2>':'<h2 style="text-align: center; font-family: Quicksand"><strong><span style="font-size: 24px; color: rgb(27, 29, 41); background-color: rgb(255, 255, 255); font-weight: 700; text-transform: none">{{name}}</span></strong></h2>'},i&&{currentParagraphTheme:"custom"})},children:[]},".likgxefm":{id:".likgxefm",parentId:".dp27jtsb",tag:"spacer",resolvedName:"SpacerEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{spacer:{responsive:{hiddenXs:!1,hiddenMd:!1},height:16}},children:[]},".ar9360ca":{id:".ar9360ca",parentId:".dp27jtsb",tag:"paragraph",resolvedName:"ParagraphEditor",style:{},isActive:!1,isCanvas:!1,customAttributes:{paragraph:a({responsive:{hiddenXs:!1,hiddenMd:!1},text:i?`\n          <h6 style="font-family: var(--tempi-global-paragraph1fontfamily); --fontSizeDesktop: 16px; --fontSizeMobile: 16px; font-weight: 700; color: rgb(67, 70, 87); text-align: center" class="fs-desktop fs-mobile fs-desktop fs-mobile fs-desktop fs-mobile"><strong>${e.t("Chúc mừng bạn đã nhận được phần quà")} {{name}}!</strong></h6>\n        `:`\n          <h6 style="text-align: center; font-size: 16px; font-family: Quicksand"><strong><span style="color: rgb(67, 70, 87); font-weight: 400">${e.t("Chúc mừng bạn đã nhận được phần quà")} {{name}}!</span></strong></h6>\n        `},i&&{currentParagraphTheme:"custom"})},children:[]},"83EW4j2go1":{id:"83EW4j2go1",parentId:"ROOT",tag:"section",resolvedName:"RowEditor",style:{padding:{top:8,bottom:8,left:16,right:16},maxWidth:1232,margin:{bottom:1e3}},isActive:!1,isCanvas:!0,customAttributes:{section:{responsive:{hiddenXs:!1,hiddenMd:!1},gutter:[0,0],widthType:"fixed"}},children:["tvXFs-v-ux"]},"tvXFs-v-ux":{id:"tvXFs-v-ux",parentId:"83EW4j2go1",tag:"col",resolvedName:"ColEditor",style:{padding:{left:15,top:5,bottom:5,right:15}},isActive:!1,isCanvas:!0,customAttributes:{col:{responsive:{hiddenXs:!1,hiddenMd:!1},md:{flex:"100%"},xs:{flex:"100%"}}},children:[]}}),exports.ERROR_CODES=n,exports.LUCKY_DRAW_DEFAULT_COLOR="#e70a12",exports.SAMPLE_LUCKY_DRAWS=l,exports.TEXT_STYLE_DEFAULT={isUseTheme:!0,spinCountStyle:{currentParagraphTheme:"paragraph1"},desktop:{spinCountStyle:{color:"#000000",fontFamily:"var(--tempi-global-paragraph1fontfamily)",fontSize:"var(--tempi-global-paragraph1fontsize)",fontWeight:"var(--tempi-global-paragraph1fontweight)",letterSpacing:"var(--tempi-global-paragraph1letterspacing)",lineHeight:"var(--tempi-global-paragraph1lineheight)"},giftNameStyle:{color:"#ffffff",fontFamily:"Helvetica",fontSize:17,fontWeight:"400"}},mobile:{spinCountStyle:{fontSize:"var(--tempi-global-paragraph1mobilefontsize)",fontWeight:"var(--tempi-global-paragraph1mobilefontweight)",letterSpacing:"var(--tempi-global-paragraph1mobileletterspacing)",lineHeight:"var(--tempi-global-paragraph1mobilelineheight)"}}};


/***/ }),

/***/ 148205:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(800656),i=__webpack_require__(212951),r=__webpack_require__(143599),n=__webpack_require__(534479);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=o(i);const s=l.default.div`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: grid;
  place-items: center;
`,a=l.default.div`
  font-family: ${n.defaultFontFamily};
  color: #e6983a;
  width: 304px;
  background-color: #fffbf5;
  text-align: center;
  border-radius: 8px;
  padding: 8px 12px;
`;exports.PercentageWarning=({totalPercentage:i=100,enableEmptyPrize:n})=>100===i||i<100&&n?null:e.jsx(s,{children:e.jsxs(a,{children:[e.jsx(r.Icon,{name:"InforOutlined",style:{fontSize:40}}),e.jsx("div",{children:t.t("Tổng xác xuất rơi quà phải bằng 100%.")}),e.jsxs("div",{children:[t.t("Tổng xác xuất hiện tại:"),i,"%"]})]})});


/***/ }),

/***/ 814563:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(85097);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var n=o(r),a=Object.defineProperty,i=Object.defineProperties,l=Object.getOwnPropertyDescriptors,s=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,p=(e,r,t)=>r in e?a(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,u=(e,r)=>{for(var t in r||(r={}))c.call(r,t)&&p(e,t,r[t]);if(s)for(var t of s(r))g.call(r,t)&&p(e,t,r[t]);return e};const{rouletteImage:f}=t.mappingAssets,d=n.default.img((({rotate:e})=>`\n    position: absolute;\n    right: 0;\n    top: calc(50%);\n    width: 12%;\n    transform: translateY(-50%) rotate(${e}deg);\n    `)),m=n.default.div((({prizeAngle:e})=>`\n  width: 100%;\n  height: 100%;\n  transform: rotate(${360-e}deg)\n`));exports.Roulette=({image:r,prizeAngle:o=90,rotate:n=90})=>{const a=r||{},{src:p,googleImageParams:b}=a,y=((e,r)=>{var t={};for(var o in e)c.call(e,o)&&r.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&s)for(var o of s(e))r.indexOf(o)<0&&g.call(e,o)&&(t[o]=e[o]);return t})(a,["src","googleImageParams"]);return e.jsx(m,{prizeAngle:o,children:e.jsx(d,(O=u({rotate:n},y),j={src:t.getImageUrlFromGoogleUserContent(p,b)||f,loading:"lazy"},i(O,l(j))))});var O,j};


/***/ }),

/***/ 613294:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(85097);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var n=o(r),a=Object.defineProperty,i=Object.defineProperties,l=Object.getOwnPropertyDescriptors,s=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,u=(e,r,t)=>r in e?a(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;const b=n.default.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;exports.SpinBorder=({image:r})=>{const{src:o,googleImageParams:n}=r||{};return o?e.jsx(b,(a=((e,r)=>{for(var t in r||(r={}))c.call(r,t)&&u(e,t,r[t]);if(s)for(var t of s(r))p.call(r,t)&&u(e,t,r[t]);return e})({alt:""},r),f={src:t.getImageUrlFromGoogleUserContent(o,n),loading:"lazy"},i(a,l(f)))):null;var a,f};


/***/ }),

/***/ 312041:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(85097),n=__webpack_require__(958385),i=__webpack_require__(998621);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=o(r),l=Object.defineProperty,s=Object.defineProperties,g=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,d=Object.prototype.propertyIsEnumerable,m=(e,r,t)=>r in e?l(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,u=(e,r)=>{for(var t in r||(r={}))p.call(r,t)&&m(e,t,r[t]);if(c)for(var t of c(r))d.call(r,t)&&m(e,t,r[t]);return e};const{spinTriggerImage:h}=t.mappingAssets,f=a.default.div((({width:e,height:r})=>`\nposition: absolute;\ntop: 50%;\nleft: 50%;\ntransform: translate(-50%,-50%);\nwidth: ${e}px;\nheight: ${r}px;\nmax-width: 25%;\nmax-height: 25%;\n`)),j=a.default(n.NonDraggableImage)((({imageStyle:e})=>`\ncursor: pointer;\ntransition: 0.3s all;\nwidth: 100%;\n\n${t.getStyle(e)}\n`));exports.SpinTrigger=({disabled:r=!1,height:n=80,width:o=80,imageStyle:a,image:l,loading:m,onStartSpinning:y})=>{const b=l||{},{src:x,googleImageParams:w}=b,O=((e,r)=>{var t={};for(var n in e)p.call(e,n)&&r.indexOf(n)<0&&(t[n]=e[n]);if(null!=e&&c)for(var n of c(e))r.indexOf(n)<0&&d.call(e,n)&&(t[n]=e[n]);return t})(b,["src","googleImageParams"]);return r?null:e.jsx(e.Fragment,{children:m?e.jsx(f,{width:60,height:60,children:e.jsx(i.StyledSpinningInner,{size:60,transform:30,color:"white"})}):e.jsx(e.Fragment,{children:e.jsx(f,{width:o,height:n,children:e.jsx(j,(S=u({},O),v={src:t.getImageUrlFromGoogleUserContent(x,w)||h,onClick:y,imageStyle:a,alt:""},s(S,g(v))))})})});var S,v};


/***/ }),

/***/ 795083:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(85097),r=__webpack_require__(891987),n=__webpack_require__(542487),i=__webpack_require__(412737),o=__webpack_require__(660463),s=__webpack_require__(814563),a=__webpack_require__(613294),l=__webpack_require__(312041),u=__webpack_require__(39159),g=Object.defineProperty,c=Object.defineProperties,p=Object.getOwnPropertyDescriptors,S=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,m=(e,t,r)=>t in e?g(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,j=(e,t)=>{for(var r in t||(t={}))d.call(t,r)&&m(e,r,t[r]);if(S)for(var r of S(t))f.call(t,r)&&m(e,r,t[r]);return e},y=(e,t)=>c(e,p(t));exports.Wheel=({giftNameStyle:g,mustStartSpinning:c,prizeNumber:p,items:S=[],onStartSpinning:d=()=>null,onStopSpinning:f=()=>null,backgroundColors:m=n.DEFAULT_BACKGROUND_COLORS,textColors:b=n.DEFAULT_TEXT_COLORS,spinDuration:O=n.DEFAULT_SPIN_DURATION,prizeAngle:v=n.DEFAULT_PRIZE_ANGLE,spinTrigger:C,roulette:T,canvasConfig:h,loading:x=!1,backgroundType:R})=>{var D;const[E,q]=r.useState([...S]),[_,A]=r.useState(0),[k,L]=r.useState(0),[N,P]=r.useState(!1),[F,U]=r.useState(!1),[w,B]=r.useState(!1),[I,z]=r.useState(!1),[K]=r.useState(i.makeClassKey(5)),W=Math.max(.01,O),G=2600*W,M=750*W,X=8e3*W,Z=G+M+X,H=r.useRef(!1);r.useEffect((()=>{var e,t;const r=S.length,n=[{name:""}];for(let i=0;i<r;i++)n[i]=y(j({},S[i]),{style:{backgroundColor:(null==(e=S[i].style)?void 0:e.backgroundColor)||m[i%m.length],textColor:(null==(t=S[i].style)?void 0:t.textColor)||b[i%b.length]}});q([...n]),z(!0)}),[S,m,b]),r.useEffect((()=>{if(c&&!w){B(!0),J();const e=i.getRotationDegrees(p,S.length,v);L(e)}}),[c]),r.useEffect((()=>{F&&(B(!1),A(k))}),[F]);const J=()=>{P(!0),U(!1),H.current=!0,setTimeout((()=>{H.current&&(H.current=!1,P(!1),U(!0),f())}),Z)};return I?e.jsxs(u.RouletteContainer,{children:[e.jsx(u.RotationContainer,{className:N?"started-spinning":"",startSpinningTime:G,continueSpinningTime:M,stopSpinningTime:X,startRotationDegrees:_,finalRotationDegrees:k,classKey:K,children:e.jsx(o,y(j({width:"900",height:"900",items:E,giftNameStyle:g},h),{background:R===t.BackgroundType.COLOR?void 0:h.background}))}),e.jsx(a.SpinBorder,{image:null==(D=null==h?void 0:h.border)?void 0:D.image}),e.jsx(s.Roulette,j({prizeAngle:v},T)),e.jsx(l.SpinTrigger,y(j({onStartSpinning:d},C),{loading:x})),e.jsx("span",{style:{fontFamily:null==g?void 0:g.fontFamily}})]}):null};


/***/ }),

/***/ 39159:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var n=__webpack_require__(212951),e=__webpack_require__(958385);function t(n){return n&&"object"==typeof n&&"default"in n?n:{default:n}}var o=t(n);const r=o.default.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: inline-block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  flex-shrink: 0;
`,i=o.default.div((({startSpinningTime:n,startRotationDegrees:e,continueSpinningTime:t,stopSpinningTime:o,finalRotationDegrees:r,classKey:i})=>`\n  position: absolute;\n  width: 100%;\n  left: 0px;\n  right: 0px;\n  top: 0px;\n  bottom: 0px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transform: rotate(${e}deg);\n  pointer-events: none;\n  border-radius: 50%;\n  overflow: hidden;\n\n  &.started-spinning {\n    animation: spin-${i} ${n/1e3}s\n        cubic-bezier(0.71, -0.29, 0.96, 0.9) 0s 1 normal forwards running,\n      continueSpin-${i}\n        ${t/1e3}s\n        linear ${n/1e3}s 1\n        normal forwards running,\n      stopSpin-${i} ${o/1e3}s\n        cubic-bezier(0, 0, 0.35, 1.02)\n        ${(n+t)/1e3}s\n        1 normal forwards running;\n  }\n\n  @keyframes spin-${i} {\n    from {\n      transform: rotate(${e}deg);\n    }\n    to {\n      transform: rotate(${e+360}deg);\n    }\n  }\n  @keyframes continueSpin-${i} {\n    from {\n      transform: rotate(${e}deg);\n    }\n    to {\n      transform: rotate(${e+360}deg);\n    }\n  }\n  @keyframes stopSpin-${i} {\n    from {\n      transform: rotate(${e}deg);\n    }\n    to {\n      transform: rotate(\n        ${1440+r}deg\n      );\n    }\n  }\n`));o.default(e.NonDraggableImage)`
  position: absolute;
  z-index: 5;
  width: 17%;
  right: 6px;
  top: 15px;
`,exports.RotationContainer=i,exports.RouletteContainer=r;


/***/ }),

/***/ 660463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var t=__webpack_require__(561261),e=__webpack_require__(85097),i=__webpack_require__(891987),a=__webpack_require__(180605),n=__webpack_require__(412737),r=__webpack_require__(951731);const o=async(t,i,r)=>{var o,l,s,c;const h=i.length;let{innerRadius:d,radiusLineColor:u,radiusLineWidth:g,perpendicularPrize:f,textDistance:m,background:w,giftNameStyle:v}=r,{fontSize:y=17,fontWeight:p="700",fontFamily:x="Helvetica",color:I="#ffffff"}=v||{};"string"==typeof y&&(y=parseInt(y.slice(0,-2))),y*=2;const S=t.current;if(null==S?void 0:S.getContext("2d")){const t=S.getContext("2d");t.clearRect(0,0,500,500),t.strokeStyle="transparent",t.lineWidth=0;const r=Math.PI/(h/2),v=0,C=S.width/2-10,M=C*n.clamp(0,100,m)/100,P=C*n.clamp(0,100,d)/100,W=S.width/2,b=S.height/2,k=150;if(t.font=`${p} ${y}px '${x}'`,t.beginPath(),t.arc(W,b,S.width/2-32,0,360,!1),t.fillStyle="#ff6666",t.fill(),null==(o=null==w?void 0:w.image)?void 0:o.src){const i=await(async t=>new Promise((function(e){const i=new Image;i.onload=function(){e(i)},i.src=t})))(e.getImageUrlFromGoogleUserContent(w.image.src,w.image.googleImageParams)),a=null!==(null==w?void 0:w.rotate),r=n.calculateImageSize(i.width,i.height,null,S.width);t.translate(W,b),a&&t.rotate(w.rotate*Math.PI/180),t.drawImage(i,-r.width/2,-r.height/2,r.width,r.height),a&&t.rotate(-w.rotate*Math.PI/180),t.translate(-W,-b)}const L=!!(null==(l=null==w?void 0:w.image)?void 0:l.src);for(let e=0;e<i.length;e++){const o=v+e*r,{style:l}=i[e];if(t.fillStyle=(null==l?void 0:l.backgroundColor)||a.LUCKY_DRAW_DEFAULT_COLOR,L||(t.beginPath(),t.arc(W,b,C,o,o+r,!1),t.arc(W,b,P,o+r,o,!0),t.stroke(),t.fill()),t.save(),!L){t.strokeStyle=g<=0?"transparent":u,t.lineWidth=g;for(let e=0;e<i.length;e++){const i=v+e*r;t.beginPath(),t.moveTo(W+(P+1)*Math.cos(i),b+(P+1)*Math.sin(i)),t.lineTo(W+(C-1)*Math.cos(i),b+(C-1)*Math.sin(i)),t.closePath(),t.stroke()}}t.fillStyle=l&&l.textColor,t.translate(W+Math.cos(o+r/2)*M,b+Math.sin(o+r/2)*M);const h=i[e].name,d=null==(s=i[e].image)?void 0:s.src,m=null==(c=i[e].image)?void 0:c.width,w=f?o+r/2+Math.PI/2:o+r/2;if(t.rotate(w),d){const e=new Image;e.src=d,e.onload=function(){const{width:i,height:a}=n.calculateImageSize(e.width,e.height,m,k),l=W+Math.cos(o+r/2)*M,s=b+Math.sin(o+r/2)*M;t.translate(l,s),t.rotate(w),t.drawImage(e,-i/2,-a/2,i,a),t.rotate(-w),t.translate(-l,-s)}}else t.fillStyle=I,t.fillText(h,-t.measureText(h).width/2,y/2.7);t.restore()}}};module.exports=e=>{const a=i.createRef(),{items:n,width:l,height:s,innerRadius:c,perpendicularPrize:h,radiusLineColor:d,radiusLineWidth:u,textDistance:g,background:f,border:m,giftNameStyle:w}=e,{fontFamily:v,fontSize:y,fontWeight:p,color:x}=w||{};return i.useEffect((()=>{o(a,n,e)}),[n,m,c,h,d,u,g,l,s,v,y,p,x]),i.useEffect((()=>{((t,e,i)=>{const a=t.current;(null==a?void 0:a.getContext("2d"))&&(a.getContext("2d").clearRect(0,0,a.width,a.height),o(t,e,i))})(a,n,e)}),[f,n]),i.useEffect((()=>{setTimeout((()=>{o(a,n,e)}),2e3)}),[v]),t.jsx(r.WheelCanvasStyle,{ref:a,width:l,height:s})};


/***/ }),

/***/ 951731:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}Object.defineProperty(exports, "__esModule", ({value:!0}));const t=e(__webpack_require__(212951)).default.canvas`
  width: 98%;
  height: 98%;
`;exports.WheelCanvasStyle=t;


/***/ }),

/***/ 958385:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}Object.defineProperty(exports, "__esModule", ({value:!0}));const r=e(__webpack_require__(212951)).default.img`
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
`;exports.NonDraggableImage=r;


/***/ }),

/***/ 542487:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.DEFAULT_BACKGROUND_COLORS=["darkgrey","lightgrey"],exports.DEFAULT_PRIZE_ANGLE=90,exports.DEFAULT_SPIN_DURATION=1,exports.DEFAULT_TEXT_COLORS=["black"];


/***/ }),

/***/ 412737:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.calculateImageSize=(e,t,r,a)=>{if(!e||!t)return;const o=r||a;return{width:o,height:o/(e/t)}},exports.clamp=(e,t,r)=>Math.min(Math.max(e,+r),t),exports.getRotationDegrees=(e,t,r)=>{const a=360/t,o=a*(t-e)-(r+a/2)+(2*Math.random()-1)*a*.35;return t-e>t/2?-360+o:o},exports.makeClassKey=e=>{let t="";for(let r=0;r<e;r++)t+="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".charAt(Math.floor(62*Math.random()));return t};


/***/ }),

/***/ 390524:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(800656),t=__webpack_require__(85097),n=__webpack_require__(47248),r=__webpack_require__(891987),i=__webpack_require__(180605),o=__webpack_require__(988245),l=__webpack_require__(262560),u=__webpack_require__(324259),a=__webpack_require__(655268);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=s(n),d=Object.defineProperty,p=Object.defineProperties,m=Object.getOwnPropertyDescriptors,h=Object.getOwnPropertySymbols,f=Object.prototype.hasOwnProperty,v=Object.prototype.propertyIsEnumerable,g=(e,t,n)=>t in e?d(e,t,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[t]=n,S=(e,t)=>{for(var n in t||(t={}))f.call(t,n)&&g(e,n,t[n]);if(h)for(var n of h(t))v.call(t,n)&&g(e,n,t[n]);return e};exports.useLuckyDraw=(n,s)=>{var d;const{triggerUpdate:h,popupResponse:f,configStorage:v,wrapperRef:g,isDisableLuckyDrawPhoneInput:y,userPhoneNumber:w,bypassShowParticipantForm:b,emptyPrizeConfig:q}=s,[P,O]=r.useState(!0),[j,I]=r.useState(),[D,T]=r.useState(),[z,E]=r.useState(!1),[$,A]=r.useState(),[R,C]=r.useState(),[_,k]=r.useState(!1),[U,L]=r.useState(),[M,F]=r.useState(),{env:N}=t.useStore(),{condition:x,totalPercentage:H=100}=D||{},Z=null==(d=null==x?void 0:x.form)?void 0:d.fields,B=new t.Api(`${t.publicBffUrl[N]}/v1/lucky-draw`),V=r.useMemo((()=>{const{enable:t,name:n,image:r,slotCount:i=1}=q||{};let l=o.buildPrizesWithSlotCount((null==D?void 0:D.items)||[]);const u=100-l.reduce(((e,t)=>e+(t.percentage||0)),0);return t&&(l=o.insertEmptyPrize(l,{name:n||e.t("game.empty_prize.name"),image:r,id:null,percentage:u<0?0:u,wheelId:(null==D?void 0:D.id)||null,slotCount:i})),l}),[q,null==D?void 0:D.id,null==D?void 0:D.items]),W=async e=>{let t;if(I(e),O(!0),k(!1),await B.post("/spin",{wheelId:n,userInfo:e}).then((e=>{t=e.data,F(t.data)})).catch((e=>{var t,n;if(parseInt(null==(t=null==e?void 0:e.response)?void 0:t.code)===i.ERROR_CODES.OUT_OF_TURN)return J(null==f?void 0:f.outOfTurn),void A(0);parseInt(null==(n=null==e?void 0:e.response)?void 0:n.code)!==i.ERROR_CODES.OUT_OF_PRIZE||J(null==f?void 0:f.outOfPrize)})),null==t?void 0:t.data){const e=!!(null==q?void 0:q.enable),{spinTurn:n,itemId:r,isAssignSuccess:i}=t.data;A(n);let o=V.findIndex((e=>e.id===r));r||e?(!i&&e&&(o=V.findIndex((e=>!e.id))),C(o),E(!0)):(J(null==f?void 0:f.emptyPrize),await G(v,i,r))}O(!1)},G=async(e,n,r)=>{var i;const o=V.find((e=>e.id===r));if(!o||!(null==e?void 0:e.formConfigId))return;const s=new Date,{year:c,month:d,day:h,hour:f,minute:v,second:g}=l.getPartialDateTimeTimeZone7(s),y=`${c}-${d}-${h} ${f}:${v}:${g}`;let w=(b=S({},j||{}),q={prizeName:o.name,spinAt:y,assignmentStatus:n?t.AssignmentStatusEnum.success:t.AssignmentStatusEnum.failed},p(b,m(q)));var b,q;(null==e?void 0:e.autoPassParams)&&(w=S(S({},u.queryStringToObject(window.location.search)),w));const P=[...Object.entries(w).map((([e,t])=>({name:e,type:"string",value:null==t?"":t}))),{name:"url_page",type:"string",value:null==(i=null==window?void 0:window.location)?void 0:i.href}];await a.formUtils.submitFormData(null==e?void 0:e.formConfigId,P,`${t.publicBffUrl[N]}/v1/submit-form`)},J=e=>{var t;null==(t=g.current.ownerDocument.querySelector(`[data-uniq-id="${e}"]`))||t.click()},K=e=>{const t=f.prize;t&&(((e,t,n)=>{if(!e||!n)return;const r=/{{([\w,.]*)}}/g;g.current.ownerDocument.querySelector(`[data-uniq-id="${e}"]`).querySelectorAll(".popup-content p, h1, h2, h3, h4, h5, h6").forEach(((e,i)=>{e.innerHTML=n[i].replaceAll(r,(e=>c.default(t,e.replace(/{{/,"").replace(/}}/,""))))}))})(t,e,U),J(t))};return r.useEffect((()=>{var e;n&&(e=n,B.get(`/wheel/${e}`).then((e=>e.data)).then((e=>T(e.data))).catch((e=>(console.error(e),Promise.reject(e)))).finally((()=>{O(!1)})))}),[n,h]),r.useEffect((()=>{if(g.current&&(null==f?void 0:f.prize)){const e=g.current.ownerDocument.querySelector(`[data-uniq-id="${f.prize}"]`);if(e){const t=[...e.querySelectorAll(".popup-content p, h1, h2, h3, h4, h5, h6")].map((e=>e.innerHTML));L(t)}}}),[g.current]),{wheel:D,loading:P,mustSpin:z,turnCount:$,displayPrizeIndex:R,isShowForm:_,totalPercentage:H,setLoading:O,setUserInfo:I,handleSpin:W,handleSpinClick:()=>{z||((null==Z?void 0:Z.length)?w||!y?j?W(j):w&&b&&1===(null==Z?void 0:Z.length)&&"phoneNumber"===Z[0].name?(I({phoneNumber:w}),W({phoneNumber:w})):k(!0):alert(e.t("Vui lòng đăng nhập tài khoản hoặc cập nhật số điện thoại ở Thông tin tài khoản")):W(null))},setMustSpin:E,setIsShowForm:k,handleStorageData:G,handleStopSpin:async()=>{E(!1);const{assignResult:e,isAssignSuccess:t,itemId:n}=M,r=V[R];var i,o;r&&(t||!t&&(null==q?void 0:q.enable)?r.id?(null==f?void 0:f.prize)&&K(r):J(null==f?void 0:f.emptyPrize):e?(i=e,(null==(o=null==f?void 0:f.custom)?void 0:o.length)&&f.custom.forEach((e=>{var t,n,r,o;if((null==(n=null==(t=c.default(i,e.key))?void 0:t.toString)?void 0:n.call(t))===(null==(r=e.value)?void 0:r.toString())){const t=e.popup;return((e,t)=>{const n=g.current.ownerDocument.querySelector(`[data-uniq-id="${e}"]`);e&&n&&n.querySelectorAll(".popup-content p, h1, h2, h3, h4, h5, h6").forEach((e=>{const n=e.innerHTML;e.innerHTML=n.replaceAll(/{{([\w,.]*)}}/g,(e=>c.default(t,e.replace(/{{/,"").replace(/}}/,""))))}))})(t,i),void(null==(o=g.current.ownerDocument.querySelector(`[data-uniq-id="${t}"]`))||o.click())}}))):(null==f?void 0:f.prize)&&K(r),await G(v,t,n))},prizes:V}};


/***/ }),

/***/ 378800:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(212951),i=__webpack_require__(85097),t=__webpack_require__(891987),r=__webpack_require__(390524),o=__webpack_require__(465112),l=__webpack_require__(795083),a=__webpack_require__(148205),s=__webpack_require__(705478),p=__webpack_require__(845589),d=__webpack_require__(750911);function u(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=u(n),m=Object.defineProperty,g=Object.defineProperties,h=Object.getOwnPropertyDescriptors,y=Object.getOwnPropertySymbols,f=Object.prototype.hasOwnProperty,b=Object.prototype.propertyIsEnumerable,S=(e,n,i)=>n in e?m(e,n,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[n]=i,v=(e,n)=>{for(var i in n||(n={}))f.call(n,i)&&S(e,i,n[i]);if(y)for(var i of y(n))b.call(n,i)&&S(e,i,n[i]);return e},j=(e,n)=>g(e,h(n));const x=n=>{var u;const c=n,{id:m,isUseTheme:g,dimension:h,response:S,showTurn:x=!1,isEditor:k=!1,configStorage:C,triggerUpdate:F,children:q,gameId:O,emptyPrizeConfig:D,bypassShowParticipantForm:N=!1}=c,z=((e,n)=>{var i={};for(var t in e)f.call(e,t)&&n.indexOf(t)<0&&(i[t]=e[t]);if(null!=e&&y)for(var t of y(e))n.indexOf(t)<0&&b.call(e,t)&&(i[t]=e[t]);return i})(c,["id","isUseTheme","dimension","response","showTurn","isEditor","configStorage","triggerUpdate","children","gameId","emptyPrizeConfig","bypassShowParticipantForm"]),I=t.useRef(),L=O||m,{globalData:V,device:W}=i.useStore(),{userPhoneNumber:$,isDisableLuckyDrawPhoneInput:B=!1}=V||{},{commonStyle:R,spinCountStyle:U,giftNameStyle:_,alignment:E="center"}=i.getPropsByDevice(z,W),{loading:T,wheel:A,totalPercentage:M,isShowForm:H,setIsShowForm:G,turnCount:J,handleSpin:K,mustSpin:Q,displayPrizeIndex:X,handleSpinClick:Y,handleStopSpin:Z,prizes:ee}=r.useLuckyDraw(L,{triggerUpdate:F,popupResponse:S,configStorage:C,wrapperRef:I,userPhoneNumber:$,isDisableLuckyDrawPhoneInput:B,bypassShowParticipantForm:N,emptyPrizeConfig:D}),{condition:ne}=A||{},ie=(e,n)=>n||("phoneNumber"===e?"tel":"email"===e?"email":"text"),te=t.useMemo((()=>{var e,n;return null==(n=null==(e=null==ne?void 0:ne.form)?void 0:e.fields)?void 0:n.map((({label:e,name:n,required:i,type:t,options:r})=>{let o,l=!1;return"phoneNumber"===n&&$&&(o=$),"phoneNumber"===n&&B&&(l=!0),{type:ie(n,t),label:e,name:n,required:i,commonStyle:{height:40,width:"100%",marginBottom:8},inputStyle:{borderRadius:8,fontFamily:g&&"var(--tempi-global-paragraph1fontfamily)"},placeholder:`Nhập ${e.toLowerCase()}`,id:`user-info-${n}-input`,value:o,disabled:l,options:"single-checkbox"===t?[{label:e,value:"checked"}]:r}}))}),[$,B,null==(u=null==ne?void 0:ne.form)?void 0:u.fields]);return L?e.jsx(e.Fragment,{children:((null==D?void 0:D.enable)&&M<100||100===M||k)&&e.jsxs(e.Fragment,{children:[e.jsxs("div",{style:{textAlign:E,padding:"1.2em",overflow:"hidden"},children:[e.jsxs(w,{"data-id":m,commonStyle:R,ref:I,children:[e.jsx(l.Wheel,j(v(j(v({giftNameStyle:_,items:T?[]:ee,loading:T,mustStartSpinning:Q},z),{prizeNumber:X}),!k&&{onStartSpinning:Y}),{onStopSpinning:Z})),k&&e.jsx(a.PercentageWarning,{enableEmptyPrize:null==D?void 0:D.enable,totalPercentage:M})]}),x&&e.jsxs(e.Fragment,{children:[k&&e.jsxs(P,{spinCountStyle:U,children:["Bạn còn ",e.jsx("strong",{children:"***"})," lượt quay!"]}),void 0!==J&&-1!==J&&e.jsxs(P,{spinCountStyle:U,children:["Bạn còn ",e.jsx("strong",{children:J})," lượt quay!"]})]})]}),te&&e.jsxs(s.PopupV1,j(v({show:H,onFinishClose:()=>G(!1)},{maskClosable:!0,maskStyle:{backgroundColor:"rgba(0, 0, 0, 0.5)"},commonStyle:{borderRadius:8,width:400,height:300,backgroundColor:"#fff",padding:{left:24,right:24,bottom:24,top:24}},position:"default"}),{children:[e.jsx("div",{style:{marginBottom:32,fontWeight:"bold",fontFamily:g&&"var(--tempi-global-heading1fontfamily)"},children:"Vui lòng điền thông tin để tham gia chương trình"}),e.jsx(p.FormV4,{inputs:te,submits:[],hiddenFields:[],showLabel:!0,onFinish:K,labelStyle:{fontFamily:g&&"var(--tempi-global-paragraph1fontfamily)"},errorStyle:{fontFamily:g&&"var(--tempi-global-paragraph1fontfamily)"},children:e.jsx(d.ButtonV2,{text:"Hoàn tất",buttonStyle:{backgroundColor:"#108143",color:"rgba(255, 255, 255, 1)",height:40,width:120,borderRadius:999,margin:{top:20,left:"auto",right:"auto"}},loading:T,iconConfig:{position:"right",spacing:8,show:!0,icon:{name:"CheckOutlined",size:18}}})},`${L}_LuckyDrawV2ParticipantForm_${$}_${B}`)]})),q]})}):e.jsx("div",{style:{textAlign:"center",height:400,display:"grid",placeItems:"center"},children:e.jsx(o.Spin,{})})};x.displayName="LuckyDrawV2";const w=c.default.div((({commonStyle:e})=>`\n  display: inline-block;\n  position: relative;\n  width: min(400px,100%);\n  padding-bottom: min(400px,100%);\n  user-select: none;\n  ${i.getStyle(e)}\n`)),P=c.default.div((({spinCountStyle:e})=>`\n  font-size: 1.2em;\n  text-align: center;\n  margin-top: 1em;\n  ${i.getStyle(e)}\n`));exports.LuckyDrawV2=x;


/***/ }),

/***/ 988245:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=Object.defineProperty,t=Object.defineProperties,r=Object.getOwnPropertyDescriptors,n=Object.getOwnPropertySymbols,o=Object.prototype.hasOwnProperty,i=Object.prototype.propertyIsEnumerable,l=(t,r,n)=>r in t?e(t,r,{enumerable:!0,configurable:!0,writable:!0,value:n}):t[r]=n,s=(e,t)=>{for(var r in t||(t={}))o.call(t,r)&&l(e,r,t[r]);if(n)for(var r of n(t))i.call(t,r)&&l(e,r,t[r]);return e},u=(e,n)=>t(e,r(n));exports.buildPrizesWithSlotCount=e=>{const t=e.map((e=>u(s({},e),{remaining:(null==e?void 0:e.slotCount)||1}))),r=[];let n=null;for(;t.some((e=>e.remaining>0));){const e=t.filter((e=>e.remaining>0)).sort(((e,t)=>t.remaining-e.remaining)),o=e.find((e=>(null==e?void 0:e.id)!==n))||e[0];r.push(s({},o)),o.remaining--,n=o.id}return r},exports.insertEmptyPrize=(e,t)=>{if(!t||t.slotCount<=0)return e;const r=[...e];let n=(null==t?void 0:t.slotCount)||1;const o=Math.min(n,r.length+1);if(o<=0)return r;const i=Math.round(r.length/o);for(let e=0;e<o;e++){const o=e*i+e;r.splice(o,0,u(s({},t),{slotCount:1})),n--}for(;n>0;)r.push(u(s({},t),{slotCount:1})),n--;return r};


/***/ }),

/***/ 581345:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(85097),o=__webpack_require__(891987);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=i(r),n=i(o),l=Object.defineProperty,c=Object.defineProperties,d=Object.getOwnPropertyDescriptors,s=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,u=(e,r,t)=>r in e?l(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;const m=n.default.forwardRef(((r,o)=>{const i=r,{address:a,zoom:n,id:l}=i,m=((e,r)=>{var t={};for(var o in e)p.call(e,o)&&r.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&s)for(var o of s(e))r.indexOf(o)<0&&f.call(e,o)&&(t[o]=e[o]);return t})(i,["address","zoom","id"]),{device:b}=t.useStore(),{commonStyle:v}=t.getPropsByDevice(m,b);return e.jsx(y,(g=((e,r)=>{for(var t in r||(r={}))p.call(r,t)&&u(e,t,r[t]);if(s)for(var t of s(r))f.call(r,t)&&u(e,t,r[t]);return e})({ref:o,id:l,"data-id":l},m),O={commonStyle:v,children:e.jsx("iframe",{title:"map",width:"100%",height:"100%",frameBorder:0,scrolling:"no",marginHeight:0,marginWidth:0,src:`https://maps.google.com/maps?q=${encodeURI(a||"")}&z=${n||14}&ie=UTF8&iwloc=B&output=embed`})},c(g,d(O))));var g,O})),y=a.default.div((({commonStyle:e})=>`\n    ${t.getStyle(e)}`));m.displayName="Map",exports.Map=m;


/***/ }),

/***/ 249752:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(85097),n=__webpack_require__(891987),o=__webpack_require__(743819),i=__webpack_require__(650754);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var u=l(r),a=Object.defineProperty,s=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,d=Object.prototype.propertyIsEnumerable,f=(e,r,t)=>r in e?a(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,m=(e,r)=>{for(var t in r||(r={}))c.call(r,t)&&f(e,t,r[t]);if(s)for(var t of s(r))d.call(r,t)&&f(e,t,r[t]);return e};const y=u.default.div((({commonStyle:e})=>`\n  ${t.getStyle(e)}\n\n  position: relative;\n  width: 100%;\n`)),b=u.default.div((({commonStyle:e,duration:r})=>`\n      ${t.getStyle(e)}\n\n      position: absolute;\n      height: 100%;\n      width: 0%;\n\n      display: flex;\n      align-items: center;\n\n      overflow: hidden;\n      transition: width ${r}s linear;\n    `));exports.BarProgress=({value:r,maxValue:t,numberElement:l,textBeforeElement:u,textAfterElement:a,style:f})=>{const p=f||{},{numberPosition:v,duration:h=0,delay:j=0,foregroundColor:x}=p,P=((e,r)=>{var t={};for(var n in e)c.call(e,n)&&r.indexOf(n)<0&&(t[n]=e[n]);if(null!=e&&s)for(var n of s(e))r.indexOf(n)<0&&d.call(e,n)&&(t[n]=e[n]);return t})(p,["numberPosition","duration","delay","foregroundColor"]),g=n.useRef();return n.useEffect((()=>{let e;return r&&(e=setTimeout((async()=>{g.current&&(g.current.style.removeProperty("transition"),g.current.style.width=`${i.calculatePercent(r,t)}%`)}),1e3*j)),()=>{clearTimeout(e),g.current&&(g.current.style.transition="none",g.current.style.width="0%")}}),[r,t]),e.jsxs(e.Fragment,{children:[u,v===o.NumberPosition.above&&l,e.jsx(y,{commonStyle:m({},P),children:e.jsx(b,{ref:g,commonStyle:{background:x},duration:h,children:v===o.NumberPosition.inside&&l})}),v===o.NumberPosition.below&&l,a]})};


/***/ }),

/***/ 776132:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(891987);exports.useFirstVisible=r=>{const[t,n]=e.useState(!1),s=e.useRef(0);return e.useEffect((()=>{if((null==r?void 0:r.current)&&!s.current){const e=new IntersectionObserver((([t])=>{t.isIntersecting&&!s.current&&(n(t.isIntersecting),e.unobserve(r.current),s.current++)}));return e.observe(r.current),()=>{(null==r?void 0:r.current)&&e.unobserve(r.current)}}}),[r]),t};


/***/ }),

/***/ 743819:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=(e=>(e.standard="standard",e.percent="percent",e))(e||{}),r=(e=>(e.number="number",e.bar="bar",e.circle="circle",e))(r||{}),t=(e=>(e.above="above",e.inside="inside",e.below="below",e.hidden="hidden",e))(t||{});exports.NumberCounterLayout=r,exports.NumberPosition=t,exports.NumberType=e;


/***/ }),

/***/ 16394:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(85097),n=__webpack_require__(891987),o=__webpack_require__(739237),l=__webpack_require__(610796),u=__webpack_require__(743819),i=__webpack_require__(650754),a=__webpack_require__(776132),s=__webpack_require__(249752);function c(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=c(r),f=Object.defineProperty,y=Object.defineProperties,m=Object.getOwnPropertyDescriptors,b=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,x=Object.prototype.propertyIsEnumerable,g=(e,r,t)=>r in e?f(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,h=(e,r)=>{for(var t in r||(r={}))p.call(r,t)&&g(e,t,r[t]);if(b)for(var t of b(r))x.call(r,t)&&g(e,t,r[t]);return e},v=(e,r)=>y(e,m(r));const S=r=>{const c=r,{number:d,total:f,numberType:y,layout:m,circleStyle:g,duration:S=0,delay:w=0,prefixNumber:P="",suffixNumber:T="",textBefore:$,textAfter:B,foregroundColor:A,backgroundColor:I,background:M}=c,E=((e,r)=>{var t={};for(var n in e)p.call(e,n)&&r.indexOf(n)<0&&(t[n]=e[n]);if(null!=e&&b)for(var n of b(e))r.indexOf(n)<0&&x.call(e,n)&&(t[n]=e[n]);return t})(c,["number","total","numberType","layout","circleStyle","duration","delay","prefixNumber","suffixNumber","textBefore","textAfter","foregroundColor","backgroundColor","background"]),{device:F}=t.useStore(),{textStyle:V,textAfterStyle:L,textBeforeStyle:z,numberStyle:D,barStyle:W,commonStyle:_}=t.getPropsByDevice(E,F),H=n.useRef(),R=a.useFirstVisible(H),G=Math.abs(d||0),J=Math.abs(f||1),K=i.getMaxValue(G,J,y),[Q,U]=n.useState(0),{document:X}=l.useFrame();t.useInjectLinksToHTML([{rel:"stylesheet",href:"https://cdn.jsdelivr.net/npm/react-circular-progressbar@2.0.4/dist/styles.css"}],X),n.useEffect((()=>{if(d&&R){let e;const r=setTimeout((async()=>{const t=Math.floor(S/G*100)/100;e=setInterval((()=>{U((t=>{const n=t+1;return n<G?n:(clearInterval(e),clearTimeout(r),G)}))}),1e3*t)}),1e3*w);return()=>{clearInterval(e),clearTimeout(r),U(0)}}}),[R,m,y,d,f,S,w]);const Y=e.jsx(O,{numberStyle:D,children:(()=>{const e=void 0===d?0:d>=0?Q:-1*Q,r=new Intl.NumberFormat("en-CA").format(e);return y===u.NumberType.standard?`${P}${r}${T}`:`${r}%`})()}),Z=$&&"string"==typeof $&&e.jsx(k,{textBeforeStyle:z||V,children:$}),ee=B&&"string"==typeof B&&e.jsx(q,{textAfterStyle:L||V,children:B});return e.jsx(N,v(h({ref:H},r),{commonStyle:_,children:m===u.NumberCounterLayout.bar?(()=>{const r=y===u.NumberType.percent&&d<0?0:G;return e.jsx(s.BarProgress,{value:r,maxValue:K,numberElement:Y,textBeforeElement:Z,textAfterElement:ee,style:v(h({},W),{backgroundColor:I,foregroundColor:A,duration:S,delay:w,background:M})})})():m===u.NumberCounterLayout.circle?(()=>{const r=y===u.NumberType.percent&&d<0?0:Q;return e.jsx(j,{circleStyle:g,children:e.jsx(o.CircularProgressbarWithChildren,{value:r,maxValue:K,strokeWidth:null==g?void 0:g.strokeSize,styles:{path:{stroke:A,transitionDuration:S/G+"s"},trail:{stroke:I||M}},children:e.jsxs(C,{children:[Z,Y,ee]})})})})():e.jsxs(e.Fragment,{children:[Z,Y,ee]})}))};S.displayName="NumberCounter";const j=d.default.div((({circleStyle:e})=>`\n    width: ${null==e?void 0:e.size}px;\n    height: ${null==e?void 0:e.size}px;\n    max-width: 100%;\n    max-height: 100%;\n\n    margin: auto;\n  `)),C=d.default.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`,N=d.default.div((e=>{const{commonStyle:r}=e;return`\n    ${t.getStyle(r)};\n    overflow: hidden;\n    max-width: 100%;\n  `})),k=d.default.div((({textBeforeStyle:e})=>`\n  ${t.getStyle(e)}\n`)),O=d.default.div((({numberStyle:e})=>`\n  height: 100%;\n  width: 100%;\n  ${t.getStyle(e)}\n`)),q=d.default.div((({textAfterStyle:e})=>`\n  ${t.getStyle(e)}\n`));exports.NumberCounter=S;


/***/ }),

/***/ 650754:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(743819);exports.calculatePercent=(e,t)=>Math.min(100,Math.round(e/t*1e4)/1e4*100),exports.getMaxValue=(t,r,a)=>{let u=r;return a===e.NumberType.percent&&(u=100),Math.max(t,u)};


/***/ }),

/***/ 163962:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(891987),t=__webpack_require__(85097),o=__webpack_require__(154407),u=__webpack_require__(800886),i=__webpack_require__(512005),n=__webpack_require__(750911),l=Object.defineProperty,s=Object.defineProperties,c=Object.getOwnPropertyDescriptors,a=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,f=(e,r,t)=>r in e?l(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;const y=r.forwardRef(((l,y)=>{var b=l,{isEditingMode:v,productSku:O,text:j,buttonStyle:P,iconConfig:S}=b,m=((e,r)=>{var t={};for(var o in e)d.call(e,o)&&r.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&a)for(var o of a(e))r.indexOf(o)<0&&p.call(e,o)&&(t[o]=e[o]);return t})(b,["isEditingMode","productSku","text","buttonStyle","iconConfig"]);const x=r.useRef(null),g=r.useMemo((()=>[O]),[O]),{products:q}=o.useProducts({skus:g,filterType:u.ProductFilterType.SKUS}),w=null==q?void 0:q[0],{buyNow:C}=i.useCartStore();return e.jsx(n.ButtonV2,(k=((e,r)=>{for(var t in r||(r={}))d.call(r,t)&&f(e,t,r[t]);if(a)for(var t of a(r))p.call(r,t)&&f(e,t,r[t]);return e})({ref:x,onClick:!v&&w?()=>{var e,r,o;(e=w)&&(C(e),null==(o=null==(r=null==x?void 0:x.current)?void 0:r.ownerDocument.querySelector(`[data-uniq-id="${t.ORDER_POPUP}"]`))||o.click())}:null,buttonStyle:P,iconConfig:S,text:j,isEditingMode:v,commonStyle:{justifyContent:"center",flex:1},className:"button-width"},m),s(k,c({wrapperRef:y}))),O);var k}));y.displayName="OrderButton",exports.OrderButton=y;


/***/ }),

/***/ 473520:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var r=__webpack_require__(596221),e=Object.defineProperty,t=Object.defineProperties,o=Object.getOwnPropertyDescriptors,i=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable,l=(r,t,o)=>t in r?e(r,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):r[t]=o;const n={".r63nrhof":{id:".r63nrhof",parentId:"ROOT",tag:"orderfailpopup",resolvedName:"OrderFailPopupEditor",style:{borderRadius:16,width:550,minHeight:350,backgroundColor:"#fff",padding:{left:32,right:32,bottom:48,top:48}},isCanvas:!0,customAttributes:{orderfailpopup:(s=((r,e)=>{for(var t in e||(e={}))p.call(e,t)&&l(r,t,e[t]);if(i)for(var t of i(e))a.call(e,t)&&l(r,t,e[t]);return r})({},r.DEFAULT_POPUP_V1),u={maskStyle:{backgroundColor:"rgba(0, 0, 0, 0.4)"},closeButton:{text:"Đóng",buttonStyle:{color:"#ffffff",backgroundColor:"#7367F0"}},title:"Đặt hàng thất bại",description:"Có lỗi xảy ra, vui lòng thử lại sau"},t(s,o(u)))},children:[]}};var s,u;exports.DEFAULT_ORDER_FAIL_POPUP=n,exports.DISPLAY_NAME_ORDER_FAIL_POPUP="OrderFailPopup";


/***/ }),

/***/ 611489:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(85097),o=__webpack_require__(891987),i=__webpack_require__(473520),l=__webpack_require__(143599),n=__webpack_require__(956289),a=__webpack_require__(361713),s=__webpack_require__(512005),d=__webpack_require__(705478),p=__webpack_require__(750911);function u(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var f=u(r),c=u(o),h=Object.defineProperty,g=Object.defineProperties,y=Object.getOwnPropertyDescriptors,b=Object.getOwnPropertySymbols,x=Object.prototype.hasOwnProperty,v=Object.prototype.propertyIsEnumerable,m=(e,r,t)=>r in e?h(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,j=(e,r)=>{for(var t in r||(r={}))x.call(r,t)&&m(e,t,r[t]);if(b)for(var t of b(r))v.call(r,t)&&m(e,t,r[t]);return e},O=(e,r)=>{var t={};for(var o in e)x.call(e,o)&&r.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&b)for(var o of b(e))r.indexOf(o)<0&&v.call(e,o)&&(t[o]=e[o]);return t};const P=c.default.forwardRef(((r,o)=>{var i=r,{isEditorMode:u,children:f,show:c}=i,h=O(i,["isEditorMode","children","show"]);const{isShowErrorPopup:b,setShowErrorPopup:x,orderInfo:v,errorMessage:m}=s.useCartStore(),{device:P}=t.useStore(),I=t.getPropsByDevice(h,P),{title:M,description:_,closeButton:z}=I,D=O(I,["title","description","closeButton"]);return e.jsxs(d.PopupV1,(B=j({ref:o},D),L={onFinishClose:()=>{x(!1)},isEditorMode:u,allowCloseOnEscPressed:!0,show:u?c:b,children:[f,e.jsxs(w,{children:[e.jsxs(S,{children:[e.jsx(q,{children:e.jsx(l.Icon,{name:"CautionFilled",style:{fontSize:80,color:"rgba(215, 40, 40, 1)"}})}),e.jsx(C,{children:M||"Đặt hàng thất bại"}),e.jsx(E,{children:m||_||"Có lỗi xảy ra, vui lòng thử lại sau"}),(null==v?void 0:v.orderId)&&e.jsxs(F,{children:[e.jsx("p",{className:"order-id-label",children:"Mã đơn: "}),e.jsx(n.LabelWithCopy,{label:null==v?void 0:v.orderId})]})]}),e.jsx(p.ButtonV2,{isPreventDefault:!1,text:(null==z?void 0:z.text)||"Đóng",commonStyle:{justifyContent:"center"},style:{marginTop:36,paddingTop:0},buttonStyle:j({height:32,backgroundColor:"#7367F0",color:"#ffffff",padding:{top:65,left:48,right:48},borderRadius:4,borderWidth:1,borderStyle:"solid",fontFamily:"var(--tempi-global-paragraph1fontfamily)"},a.clearObject(null==z?void 0:z.buttonStyle)),event:null==z?void 0:z.event,onClick:()=>x(!1)})]})]},g(B,y(L))));var B,L}));P.displayName=i.DISPLAY_NAME_ORDER_FAIL_POPUP;const w=f.default.div`
  color: #000000d9;
`,S=f.default.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`,q=f.default.div`
  display: flex;
  justify-content: center;
`,C=f.default.p`
  font-weight: 600;
  font-size: 26px;
  line-height: 36px;
  color: rgba(75, 70, 92, 1);
  font-family: var(--tempi-global-heading1fontfamily);
`,E=f.default.p`
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  color: rgba(75, 70, 92, 0.8);
  font-family: var(--tempi-global-paragraph1fontfamily);
`,F=f.default.div`
  display: flex;
  align-items: start;
  max-width: 100%;
  font-family: var(--tempi-global-paragraph1fontfamily);

  .order-id-label {
    font-weight: 400;
    font-size: 15px;
    line-height: 22px;
    color: rgba(75, 70, 92, 0.8);
  }

  .label-copy {
    margin-left: 4px;
    font-weight: 700;
    font-size: 20px;
    line-height: 22px;
    color: rgba(75, 70, 92, 0.85);
  }

  .copy-icon {
    top: -4px;
  }
`;exports.OrderFailPopup=P;


/***/ }),

/***/ 702004:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(154815),n=__webpack_require__(467599),t=Object.defineProperty,o=Object.getOwnPropertySymbols,r=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,a=(e,n,o)=>n in e?t(e,n,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[n]=o;const i={orderInfoFields:[{name:"order_popup.order_info_fields.order_id",type:n.OrderInfoFieldType.OrderId,isActive:!0},{name:"order_popup.order_info_fields.date",type:n.OrderInfoFieldType.Date,isActive:!0},{name:"order_popup.order_info_fields.price",type:n.OrderInfoFieldType.Price,isActive:!0},{name:"order_popup.order_info_fields.payment_method",type:n.OrderInfoFieldType.PaymentMethod,isActive:!0}],paymentInfoFields:[{name:"order_popup.payment_info_fields.qr_code",type:n.PaymentInfoFieldType.QrCode,isActive:!0},{name:"order_popup.payment_info_fields.bank_name",type:n.PaymentInfoFieldType.BankName,isActive:!0},{name:"order_popup.payment_info_fields.account_holder_name",type:n.PaymentInfoFieldType.AccountHolderName,isActive:!0},{name:"order_popup.payment_info_fields.account_number",type:n.PaymentInfoFieldType.AccountNumber,isActive:!0},{name:"order_popup.payment_info_fields.transfer_description",type:n.PaymentInfoFieldType.TransferDescription,isActive:!0}]},d={title:"<p>Cảm ơn bạn đã mua sắm tại cửa hàng</p>",description:"<p>Xác nhận đặt hàng thành công</p>",deliveryInfoTitle:"<p>Thông tin giao hàng</p>",customOrderText:{orderIdText:"<p>Mã đơn hàng: </p>",orderDateText:"<p>Ngày đặt hàng: </p>",orderPriceText:"<p>Tổng tiền: </p>",orderPaymentMethodText:"<p>Phương thức thanh toán: </p>"},customBankInfoText:{bankTransferNote:"<p>Quý khách vui lòng chuyển khoản đúng nội dung để chúng tôi có thể xác nhận thanh toán</p>",bankNameText:"<p>Tên ngân hàng: </p>",bankAccountNameText:"<p>Tên chủ tài khoản: </p>",bankAccountNumberText:"<p>Số tài khoản: </p>",bankTransferDescriptionText:"<p>Nội dung chuyển khoản: </p>"},customProductInfoText:{productInfoTitle:"<p>Thông tin sản phẩm</p>",totalPaymentText:"<p>Tổng thanh toán</p>"}},s={".r63nrhof":{id:".r63nrhof",parentId:"ROOT",tag:"ordersuccesspopup",resolvedName:"OrderSuccessPopupEditor",style:{width:850,backgroundColor:"#fff",borderRadius:16,padding:{left:32,right:32,bottom:48,top:24}},isCanvas:!0,customAttributes:{ordersuccesspopup:((e,n)=>{for(var t in n||(n={}))r.call(n,t)&&a(e,t,n[t]);if(o)for(var t of o(n))p.call(n,t)&&a(e,t,n[t]);return e})({responsive:{hiddenXs:!1,hiddenMd:!1},maskClosable:!0,maskStyle:{backgroundColor:"rgba(0, 0, 0, 0.4)"},position:"default",zIndex:1050,closeIcon:{size:18},displayOncePerSession:!1,name:".r63nrhof",brandName:"cửa hàng",showCloseIcon:!0,hiddenDelete:!0,hiddenDuplicate:!0,downloadButton:{text:"Tải về xác nhận đặt hàng",buttonStyle:{color:"#000000D9",borderColor:"rgba(217,217,217,1)"}},continueShoppingButton:{text:"Tiếp tục mua sắm",buttonStyle:{color:"#ffffff",backgroundColor:"#7367F0"}},customText:d},i)},children:[]}},c={orderId:"XXXXYYYY",orderCode:"XXXXYYYY",createdAt:1741601380,cartData:{items:[{sku:"SKU1",name:"Acne Defense Cleanser Acne Defense Cleanser",quantity:1,price:"200000",imageUrl:"https://lh3.googleusercontent.com/csDtrswwwjz11yaJGDOhwBEb2dNodtRnjrHqkwXenhBR6RBxFEzE1oFky0rp8pGkEK_7AWM2mxi7K0NycIXZYhaPEQ4LCnA"}],paymentMethod:e.PaymentMethod.BankTransfer},deliveryInfo:{name:"Nguyen Van A",phone:"0964xxxxxx",address:"Phường Thành Công, Ba Đình, Hà Nội, Việt Nam"},note:"Giao giờ hành chính",paymentUrl:"",qrCode:"00020101021238540010A00000072701240006970436011093275578510208QRIBFTTA53037045405110005802VN62200816250310938605530063046E63",bankTransferInfo:{bankName:"VIETCOMBANK",accountName:"NGUYEN VAN A",accountNumber:"0000111122222",bankTransferNote:"XXXXYYYY"},totalPaymentAmount:"200000",orderStatus:e.OrderStatus.Processing,paymentStatus:e.PaymentStatus.Unpaid};exports.DEFAULT_CUSTOM_TEXT=d,exports.DEFAULT_ORDER_NOTE={show:!1,text:"<p>Double click vào đây để chỉnh sửa thông tin lưu ý</p>"},exports.DEFAULT_ORDER_SUCCESS_POPUP=s,exports.DISPLAY_NAME_ORDER_SUCCESS_POPUP="OrderSuccessPopup",exports.MOCK_ORDER_INFO=c,exports.ORDER_SUCCESS_POPUP_FIELDS=i;


/***/ }),

/***/ 797012:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097);const n=["https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js","https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js","https://unpkg.com/html2canvas@1.4.1/dist/html2canvas.min.js"];let a=null,t=!1;const o=e=>new Promise(((n,a)=>{const t=document.createElement("script");t.src=e,t.async=!0,t.onload=()=>n(window.html2canvas),t.onerror=()=>{t.remove(),a(new Error(`Failed to load html2canvas from: ${e}`))},document.head.appendChild(t)}));exports.convertNumberToVND=(n,a="đ")=>e.formatCurrencyVND(Number(n)||0,!1)+a,exports.downloadOrderInfo=async(e,r)=>{var c,l,s;try{const m=await(async()=>window.html2canvas?window.html2canvas:(a&&t||(t=!0,a=(async()=>{for(const e of n)try{const n=await o(e);return t=!1,n}catch(n){console.warn(`html2canvas CDN failed: ${e}, trying next...`)}throw t=!1,a=null,new Error("Failed to load html2canvas from all CDN sources")})()),a))(),i=null==(s=null==(l=null==(c=r.current)?void 0:c.ownerDocument)?void 0:l.querySelector)?void 0:s.call(l,`[data-uniq-id="${e}"]`),d=await m(i,{imageTimeout:5e3,removeContainer:!0,foreignObjectRendering:!1,allowTaint:!0,useCORS:!0,onclone:e=>{const n=e.querySelectorAll('[style*="mask-image"]');Array.from(n).forEach((e=>{e.style.maskImage.match(/url\("(.*)"\)/)&&(e.style.display="none")}))}}),u=document.createElement("a");u.href=d.toDataURL("image/png"),u.download="xac_nhan_dat_hang.png",u.click()}catch(e){console.error(e)}};


/***/ }),

/***/ 243531:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(891987),r=__webpack_require__(154815),t=__webpack_require__(85097),s=__webpack_require__(512005),o=__webpack_require__(324259);exports.useGetOrderInfo=()=>{var a;const[i,n]=e.useState(!1),[u,c]=e.useState(!1),{isShowSuccessPopup:d,setShowSuccessPopup:l,setShowErrorPopup:p,orderInfo:y,setOrderInfo:S,clearCart:w}=s.useCartStore();e.useEffect((()=>{d||c(!1)}),[d]);const{env:f,globalData:v={}}=t.useStore(),{retryVNPayDelay:P=200,retryVNPayTimes:m=3}=v,{orderId:h,isBuyNow:I,isSuccess:q}=o.queryStringToObject(null==(a=null==window?void 0:window.location)?void 0:a.search)||{};return e.useEffect((()=>{if(!h)return;const e=new t.Api(t.pinposBffUrl[f]),s=async(t=m,o=P)=>{var a;const{data:i}=await e.get(`/api/v1/public/orders/${h}`);return(null==(a=null==i?void 0:i.data)?void 0:a.paymentStatus)===r.PaymentStatus.Unpaid&&t>1?(await new Promise((e=>{setTimeout(e,o)})),s(t-1,o)):null==i?void 0:i.data};(async()=>{try{n(!0);const e=q?m:1,t=await s(e);S(t),(null==t?void 0:t.paymentStatus)===r.PaymentStatus.Paid?(l(!0),I||w()):p(!0)}catch(e){c(!0),console.error((null==e?void 0:e.response)||e)}finally{n(!1);const e=new URL(window.location.href);e.searchParams.delete("orderId"),e.searchParams.delete("isBuyNow"),e.searchParams.delete("isSuccess"),window.history.replaceState({},document.title,e.toString())}})()}),[h]),{orderInfo:y,setOrderInfo:S,orderId:h,isLoading:i,isError:u}};


/***/ }),

/***/ 467599:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=(e=>(e.OrderId="orderId",e.Date="date",e.Price="price",e.PaymentMethod="paymentMethod",e.Note="note",e))(e||{}),r=(e=>(e.QrCode="qrCode",e.BankName="bankName",e.AccountHolderName="accountHolderName",e.AccountNumber="accountNumber",e.TransferDescription="transferDescription",e))(r||{});exports.OrderInfoFieldType=e,exports.PaymentInfoFieldType=r;


/***/ }),

/***/ 779686:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),i=__webpack_require__(212951),t=__webpack_require__(702004),r=__webpack_require__(740295);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=n(i);const o=l.default.div`
  margin-top: 28px;
`,d=l.default.p`
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  font-family: var(--tempi-global-heading1fontfamily);
`,s=l.default.div`
  padding-top: 8px;
`;exports.DeliveryInfo=({orderInfo:i,customDeliveryInfoTitleEditor:n,deliveryInfoTitle:l})=>{const{note:p,deliveryInfo:a}=i||{};return e.jsxs(o,{children:[e.jsx(d,{children:n||e.jsx(r.TipTapTextDisplay,{text:l||t.DEFAULT_CUSTOM_TEXT.deliveryInfoTitle})}),e.jsxs(s,{children:[e.jsx("p",{children:null==a?void 0:a.name}),e.jsx("p",{children:null==a?void 0:a.phone}),e.jsx("p",{children:null==a?void 0:a.address}),e.jsx("p",{children:p})]})]})};


/***/ }),

/***/ 956289:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),i=__webpack_require__(212951),t=__webpack_require__(143599);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=o(i);const a=l.default.p`
  .label-copy {
    font-size: 16px;
    font-weight: bold;
    padding: 0;
    margin-right: 2px;
  }
`,n=l.default.span`
  display: inline;
  cursor: pointer;
  position: relative;
  top: -2px;
`;exports.LabelWithCopy=({label:i,labelClass:o,containerClass:l})=>e.jsxs(a,{className:l,children:[e.jsx("span",{className:`label-copy ${o||""}`,children:i}),e.jsx(n,{onClick:()=>{(null==navigator?void 0:navigator.clipboard)&&i&&navigator.clipboard.writeText(null==i?void 0:i.toString())},className:"copy-icon",children:e.jsx(t.Icon,{name:"CopyOutlined",style:{fontSize:18,color:"#7367F0"}})})]});


/***/ }),

/***/ 973622:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),i=__webpack_require__(797012),r=__webpack_require__(702004),o=__webpack_require__(800656),l=__webpack_require__(740295),d=__webpack_require__(282004);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var n=s(t);const a=({product:t})=>e.jsxs("div",{className:"product-item",children:[e.jsx("img",{width:84,height:84,style:{objectFit:"cover"},alt:"product-item",src:null==t?void 0:t.imageUrl}),e.jsxs("div",{className:"product-item-info",children:[e.jsxs("div",{className:"product-item-top",children:[e.jsx("p",{style:{fontWeight:500},children:null==t?void 0:t.name}),e.jsx("p",{children:i.convertNumberToVND(null==t?void 0:t.price)})]}),e.jsxs("p",{children:[o.translate("common.quantity")," : ",null==t?void 0:t.quantity]})]})]}),c=n.default.div`
  background-color: #f0f0f080;
  padding: 8px 12px;
  border-radius: 4px;

  .text-bold {
    font-weight: 500;
  }
`,p=n.default.p`
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  font-family: var(--tempi-global-heading1fontfamily);
`,u=n.default.div`
  display: flex;
  justify-content: space-between;
`,x=n.default.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .product-item {
    display: flex;
    gap: 12px;

    .product-item-info {
      display: flex;
      width: 100%;
      flex-grow: 1;
      flex-direction: column;
      gap: 4px;
    }

    .product-item-top {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }
`;exports.ListProductOrder=({orderInfo:t,customTextEditor:i,customText:o})=>{var s,n;const{customProductInfoTitleEditor:f,customTotalPaymentTextEditor:m}=i||{},{productInfoTitle:T,totalPaymentText:j}=o||{};return e.jsxs(c,{children:[e.jsx(p,{children:f||e.jsx(l.TipTapTextDisplay,{text:T||r.DEFAULT_CUSTOM_TEXT.customProductInfoText.productInfoTitle})}),e.jsx(x,{children:null==(n=null==(s=null==t?void 0:t.cartData)?void 0:s.items)?void 0:n.map(((t,i)=>e.jsx(a,{product:t},i)))}),e.jsx(d.Divider,{gap:20,color:"#0000000F"}),e.jsx(u,{children:e.jsx("p",{className:"text-bold",children:m||e.jsx(l.TipTapTextDisplay,{text:j||r.DEFAULT_CUSTOM_TEXT.customProductInfoText.totalPaymentText})})})]})},exports.ProductItemOrder=a;


/***/ }),

/***/ 668764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(467599),d=__webpack_require__(956289),i=__webpack_require__(772139),o=__webpack_require__(797012),s=__webpack_require__(202247),l=__webpack_require__(702004),a=__webpack_require__(740295);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var T=n(r),x=n(i);const c=T.default.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  margin-top: 20px;

  .order-info-item_value {
    font-weight: bold;
  }
`,p=T.default.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;exports.OrderInfo=({orderInfoFields:r=[],orderInfo:i,orderNote:n,customTextEditor:T,customText:u})=>{const{customOrderIdTextEditor:m,customOrderDateTextEditor:j,customOrderPriceTextEditor:y,customOrderPaymentMethodTextEditor:f,customOrderNoteEditor:h}=T||{},{orderIdText:O,orderDateText:D,orderPriceText:v,orderPaymentMethodText:E}=u||{};return e.jsxs(c,{children:[r.filter((e=>e.isActive)).map(((r,n)=>{var T;switch(r.type){case t.OrderInfoFieldType.OrderId:return e.jsxs(p,{children:[e.jsx("p",{children:m||e.jsx(a.TipTapTextDisplay,{text:O||l.DEFAULT_CUSTOM_TEXT.customOrderText.orderIdText})}),e.jsx(d.LabelWithCopy,{label:null==i?void 0:i.orderId})]},n);case t.OrderInfoFieldType.Date:return e.jsxs(p,{children:[e.jsx("p",{children:j||e.jsx(a.TipTapTextDisplay,{text:D||l.DEFAULT_CUSTOM_TEXT.customOrderText.orderDateText})}),e.jsx("p",{className:"order-info-item_value",children:x.default.unix(null==i?void 0:i.createdAt).format("DD/MM/YYYY HH:mm:ss")})]},n);case t.OrderInfoFieldType.Price:return e.jsxs(p,{children:[e.jsx("p",{children:y||e.jsx(a.TipTapTextDisplay,{text:v||l.DEFAULT_CUSTOM_TEXT.customOrderText.orderPriceText})}),e.jsx("p",{className:"order-info-item_value",children:o.convertNumberToVND(null==i?void 0:i.totalPaymentAmount)})]},n);case t.OrderInfoFieldType.PaymentMethod:return e.jsxs(p,{children:[e.jsx("p",{children:f||e.jsx(a.TipTapTextDisplay,{text:E||l.DEFAULT_CUSTOM_TEXT.customOrderText.orderPaymentMethodText})}),e.jsx("p",{className:"order-info-item_value",children:s.paymentMethodLabelMapping(null==(T=null==i?void 0:i.cartData)?void 0:T.paymentMethod)})]},n);default:return null}})),(null==n?void 0:n.show)&&e.jsx("div",{style:{color:"#ff1212d9"},children:h||e.jsx(a.TipTapTextDisplay,{text:n.text||l.DEFAULT_ORDER_NOTE.text})})]})};


/***/ }),

/***/ 364500:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(212951),t=__webpack_require__(467599),a=__webpack_require__(956289),i=__webpack_require__(109873),l=__webpack_require__(702004),r=__webpack_require__(740295);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=o(n);const d=s.default.div`
  padding: 16px 0;
`,c=s.default.p`
  color: #ff1212d9;
`,T=s.default.div`
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 32px;

  .bank-info {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    width: 60%;
    flex-grow: 2;
  }

  .qr-code-wrap {
    min-width: 180px;
    max-width: 100%;
    width: 25%;
    flex-grow: 1;
  }

  .payment-info-label {
    white-space: nowrap;
    min-width: 180px;
  }
`,p=s.default.div`
  display: flex;
  align-items: start;
  max-width: 100%;
`;exports.PaymentInfo=({paymentInfoFields:n=[],orderInfo:o,customTextEditor:s,customText:u})=>{const{customBankTransferNoteEditor:x,customBankNameTextEditor:f,customBankAccountNameTextEditor:m,customBankAccountNumberTextEditor:b,customBankTransferDescriptionTextEditor:y}=s||{},{bankTransferNote:h,bankNameText:j,bankAccountNameText:k,bankAccountNumberText:v,bankTransferDescriptionText:N}=u||{},w=null==n?void 0:n.find((e=>e.type===t.PaymentInfoFieldType.QrCode)),I=(null==n?void 0:n.indexOf(w))===(null==n?void 0:n.length)-1;return(null==n?void 0:n.length)?e.jsxs(d,{children:[e.jsx(c,{children:x||e.jsx(r.TipTapTextDisplay,{text:h||l.DEFAULT_CUSTOM_TEXT.customBankInfoText.bankTransferNote})}),e.jsxs(T,{children:[(null==w?void 0:w.isActive)&&(null==o?void 0:o.qrCode)&&e.jsx("div",{className:"qr-code-wrap",style:{order:I?1:0},children:(null==o?void 0:o.qrCode)&&e.jsx(i.QRCodeSVG,{width:"100%",height:"100%",value:null==o?void 0:o.qrCode})}),e.jsx("div",{className:"bank-info",children:n.filter((e=>e.isActive)).map(((n,i)=>{var s,d,c,T;switch(n.type){case t.PaymentInfoFieldType.BankName:return e.jsxs(p,{children:[e.jsx("p",{className:"payment-info-label",children:f||e.jsx(r.TipTapTextDisplay,{text:j||l.DEFAULT_CUSTOM_TEXT.customBankInfoText.bankNameText})}),e.jsx(a.LabelWithCopy,{label:null==(s=null==o?void 0:o.bankTransferInfo)?void 0:s.bankName})]},i);case t.PaymentInfoFieldType.AccountHolderName:return e.jsxs(p,{children:[e.jsx("p",{className:"payment-info-label",children:m||e.jsx(r.TipTapTextDisplay,{text:k||l.DEFAULT_CUSTOM_TEXT.customBankInfoText.bankAccountNameText})}),e.jsx(a.LabelWithCopy,{label:null==(d=null==o?void 0:o.bankTransferInfo)?void 0:d.accountName})]},i);case t.PaymentInfoFieldType.AccountNumber:return e.jsxs(p,{children:[e.jsx("p",{className:"payment-info-label",children:b||e.jsx(r.TipTapTextDisplay,{text:v||l.DEFAULT_CUSTOM_TEXT.customBankInfoText.bankAccountNumberText})}),e.jsx(a.LabelWithCopy,{label:null==(c=null==o?void 0:o.bankTransferInfo)?void 0:c.accountNumber})]},i);case t.PaymentInfoFieldType.TransferDescription:return e.jsxs(p,{children:[e.jsx("p",{className:"payment-info-label",children:y||e.jsx(r.TipTapTextDisplay,{text:N||l.DEFAULT_CUSTOM_TEXT.customBankInfoText.bankTransferDescriptionText})}),e.jsx(a.LabelWithCopy,{label:null==(T=null==o?void 0:o.bankTransferInfo)?void 0:T.bankTransferNote})]},i);default:return null}}))})]})]}):null};


/***/ }),

/***/ 145567:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),o=__webpack_require__(85097),i=__webpack_require__(143599),r=__webpack_require__(891987),n=__webpack_require__(797012),l=__webpack_require__(702004),d=__webpack_require__(779686),s=__webpack_require__(973622),a=__webpack_require__(668764),c=__webpack_require__(364500),u=__webpack_require__(243531),p=__webpack_require__(512005),f=__webpack_require__(705478),x=__webpack_require__(740295),h=__webpack_require__(750911),m=__webpack_require__(282004),g=__webpack_require__(361713);function v(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var y=v(t),b=v(r),j=Object.defineProperty,T=Object.defineProperties,I=Object.getOwnPropertyDescriptors,O=Object.getOwnPropertySymbols,w=Object.prototype.hasOwnProperty,S=Object.prototype.propertyIsEnumerable,E=(e,t,o)=>t in e?j(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o,q=(e,t)=>{for(var o in t||(t={}))w.call(t,o)&&E(e,o,t[o]);if(O)for(var o of O(t))S.call(t,o)&&E(e,o,t[o]);return e},P=(e,t)=>{var o={};for(var i in e)w.call(e,i)&&t.indexOf(i)<0&&(o[i]=e[i]);if(null!=e&&O)for(var i of O(e))t.indexOf(i)<0&&S.call(e,i)&&(o[i]=e[i]);return o};const D=b.default.forwardRef(((t,i)=>{var v=t,{isEditorMode:y,children:b,show:j,dataUniqId:O,customText:w,customTextEditor:S,orderNote:E}=v,D=P(v,["isEditorMode","children","show","dataUniqId","customText","customTextEditor","orderNote"]);const{customTitleEditor:_,customDescriptionEditor:z,customDeliveryInfoTitleEditor:L,customOrderTextEditor:V,customBankInfoTextEditor:W,customProductInfoTextEditor:A}=S||{},{title:J,description:$,deliveryInfoTitle:G,customOrderText:X,customBankInfoText:Y,customProductInfoText:H}=w||{},K=r.useRef(),{isShowSuccessPopup:Q,setShowSuccessPopup:Z,setOrderInfo:ee}=p.useCartStore(),{orderInfo:te,isLoading:oe,isError:ie}=u.useGetOrderInfo(),re=y?l.MOCK_ORDER_INFO:te,{device:ne}=o.useStore(),le=o.getPropsByDevice(D,ne),{orderInfoFields:de,paymentInfoFields:se,brandName:ae,downloadButton:ce,continueShoppingButton:ue}=le,pe=P(le,["orderInfoFields","paymentInfoFields","brandName","downloadButton","continueShoppingButton"]);return e.jsxs(f.PopupV1,(fe=q({ref:i},pe),xe={onFinishClose:()=>{Z(!1),ee(null)},show:y?j:Q,isEditorMode:y,allowCloseOnEscPressed:!0,children:[b,oe?e.jsx(R,{children:e.jsx("h4",{children:"Đang tải dữ liệu đơn hàng ..."})}):ie?e.jsx(C,{}):e.jsxs(F,{ref:K,style:{fontFamily:"var(--tempi-global-paragraph1fontfamily)"},children:[e.jsxs(k,{children:[e.jsx("img",{className:"icon-success",alt:"icon-success",src:"https://lh3.googleusercontent.com/0xVewRNqf3Zi2gCI66_M8qW2fnRHFCeJ0VO97cR-VcS-sWLrLTwrUzIEi1AWoxtDYrUJqzMMdz2UBz13tQ9MR7VIniTJfmNT",width:36,height:36}),e.jsxs("div",{children:[e.jsx(M,{children:_||e.jsx(x.TipTapTextDisplay,{text:J||`Cảm ơn bạn đã mua sắm tại ${ae||"Tempi"}`})}),e.jsx("p",{style:{marginTop:8},children:z||e.jsx(x.TipTapTextDisplay,{text:$||l.DEFAULT_CUSTOM_TEXT.description})})]}),e.jsx(h.ButtonV2,{onClick:()=>{n.downloadOrderInfo(O,K)},text:(null==ce?void 0:ce.text)||"Tải về xác nhận đặt hàng",style:{paddingTop:0},commonStyle:{width:"fit-content"},buttonStyle:q({height:32,padding:{left:16,right:16},borderStyle:"solid",borderWidth:1,borderColor:"rgba(217,217,217,1)",borderRadius:4},null==ce?void 0:ce.buttonStyle),iconConfig:{icon:{name:"DownloadLightOutlined",color:"#00000085",size:18},show:!0,position:"left",spacing:8},event:null==ce?void 0:ce.event})]}),e.jsx(a.OrderInfo,{orderInfoFields:de,orderInfo:re,orderNote:E,customText:X,customTextEditor:V}),(y||(null==re?void 0:re.bankTransferInfo))&&e.jsxs(N,{isEditorMode:y,commonStyle:null==pe?void 0:pe.commonStyle,children:[y&&e.jsx(B,{children:e.jsx(U,{className:"tooltip-text",children:"Chỉ hiển thị khi khách hàng chọn thanh toán chuyển khoản qua ngân hàng"})}),e.jsx(c.PaymentInfo,{paymentInfoFields:se,orderInfo:re,customText:Y,customTextEditor:W})]}),e.jsx(d.DeliveryInfo,{orderInfo:re,customDeliveryInfoTitleEditor:L,deliveryInfoTitle:G}),e.jsx(m.Divider,{gap:24,color:"#0000000F"}),e.jsx(s.ListProductOrder,{orderInfo:re,customText:H,customTextEditor:A}),e.jsx(h.ButtonV2,{isPreventDefault:!1,text:(null==ue?void 0:ue.text)||'Tiếp tục mua sắm"',style:{marginTop:24,paddingTop:0},buttonStyle:q({height:32,backgroundColor:"#7367F0",color:"#ffffff",padding:{left:48,right:48},borderRadius:4,borderWidth:1,borderStyle:"solid"},g.clearObject(null==ue?void 0:ue.buttonStyle)),event:null==ue?void 0:ue.event,onClick:()=>Z(!1)})]})]},T(fe,I(xe))));var fe,xe}));D.displayName=l.DISPLAY_NAME_ORDER_SUCCESS_POPUP;const C=()=>e.jsxs(z,{children:[e.jsx(i.Icon,{name:"CautionFilled",style:{fontSize:80,color:"rgba(215, 40, 40, 1)"}}),e.jsx(_,{children:"Có lỗi xảy ra trong lúc tải dữ liệu đơn hàng"})]}),F=y.default.div`
  color: #000000d9;
  padding-left: 45px;

  @media (max-width: 768px) {
    padding-left: 0px;
    padding-top: 25px;
  }
}
`,k=y.default.div`
  margin-top: 20px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: space-between;
  position: relative;

  .icon-success {
    position: absolute;
    top: 0;
    left: -45px;
    @media (max-width: 768px) {
      top: -25px;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`,M=y.default.p`
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  font-family: var(--tempi-global-heading1fontfamily);
`,N=y.default.div((({commonStyle:e,isEditorMode:t})=>{var i,r,n,l;const d={margin:{left:-45-(null==(i=null==e?void 0:e.padding)?void 0:i.left)||0,right:0-(null==(r=null==e?void 0:e.padding)?void 0:r.right)||0},padding:{left:45+(null==(n=null==e?void 0:e.padding)?void 0:n.left)||0,right:(null==(l=null==e?void 0:e.padding)?void 0:l.right)||0}};return`\n      position: relative;\n      margin-top: 12px;\n      ${t?`&:hover {\n        border: 1px #fd4807 solid;\n        ${o.getStyle(d)}\n\n        .tooltip-text {\n          visibility: visible;\n          opacity: 1;\n        }`:""}\n      }\n    `})),R=y.default.div`
  height: 400px;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 14px;
`,_=y.default.p`
  font-weight: 600;
  font-size: 26px;
  line-height: 36px;
  color: rgba(75, 70, 92, 1);
`,z=y.default.div`
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
`,B=y.default.div`
  position: absolute;
  top: -10px;
  right: 20px;
  cursor: pointer;
`,U=y.default.div`
  visibility: hidden;
  width: 280px;
  background-color: black;
  color: white;
  text-align: center;
  padding: 8px;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  transform: translateX(-100%);
  opacity: 0;
  transition: opacity 0.3s;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent transparent; /* Tạo mũi tên */
  }
`;exports.OrderSuccessPopup=D;


/***/ }),

/***/ 599361:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));const n={400011:"Thiếu mã sản phẩm. Vui lòng thử lại sau",400012:"Thiếu thông tin số lượng sản phẩm. Vui lòng chọn số lượng trước khi đặt hàng",400013:"Số lượng sản phẩm không hợp lệ. Vui lòng kiểm tra lại",400018:"Mã sản phẩm không hợp lệ. Vui lòng thử lại sau",400036:"Mã đơn hàng không hợp lệ. Vui lòng kiểm tra lại",400064:"Phương thức thanh toán không hợp lệ. Vui lòng chọn phương thức khác",400067:"Không có sản phẩm nào trong giỏ hàng. Vui lòng thêm sản phẩm trước khi thanh toán",400068:"Giỏ hàng trống. Vui lòng thêm sản phẩm để tiếp tục đặt hàng",400069:"Website không hợp lệ. Vui lòng thử lại sau",400070:"Sản phẩm bạn chọn hiện không đủ hàng. Vui lòng giảm số lượng hoặc chọn sản phẩm khác",400071:"Giá sản phẩm không đúng. Vui lòng tải lại trang hoặc thử lại sau",400072:"Thông tin sản phẩm không đúng. Vui lòng thử lại sau",400073:"Thiếu thông tin website. Vui lòng thử lại sau",404003:"Sản phẩm hiện không còn khả dụng, vui lòng thử lại sau",404004:"Website không tồn tại. Vui lòng kiểm tra lại đường dẫn",404006:"Giá sản phẩm hiện không còn khả dụng, vui lòng thử lại sau",404007:"Không tìm thấy thông tin đơn hàng. Vui lòng thử lại sau"};exports.getMessageErrorCheckout=(h,g)=>(null==n?void 0:n[h])||g;


/***/ }),

/***/ 143201:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(891987),t=__webpack_require__(85097),a=__webpack_require__(202247),o=__webpack_require__(599361),r=__webpack_require__(512005);exports.usePinposOrderCheckout=n=>{const{cart:s,buyNowItem:u,getBuyNowTotal:l,getCartTotal:i,setShowErrorPopup:d,setShowSuccessPopup:c,setOrderInfo:p,setShowCheckoutPopup:y,clearCart:m,clearBuyNow:h}=r.useCartStore(),{env:v,globalData:w={}}=t.useStore(),{websiteId:f}=w,[P,g]=e.useState(!1),[S,M]=e.useState(!1),[b,k]=e.useState([]),q=!!u,C=q?[u]:s,I=q?l():i(),U=new t.Api(`${t.pinposBffUrl[v]}/api/v1/public`),j=()=>{M(!0),U.get("/payments/configs",{params:{websiteId:f}}).then((e=>{var t;k(null==(t=null==e?void 0:e.data)?void 0:t.data)})).finally((()=>{M(!1)}))};return e.useEffect((()=>{j()}),[n]),{isLoading:P,setIsLoading:g,checkoutOrder:async({paymentMethod:e,name:t,phone:r,address:n,note:s})=>{var u,l,i,v,w,P;g(!0);try{const o=e=>{const t=new URL(window.location.href);if(q&&t.searchParams.set("isBuyNow","true"),e)for(const[a,o]of Object.entries(e))t.searchParams.set(a,o);return null==t?void 0:t.toString()},d=await U.post("/orders/checkout",{websiteId:f,totalPaymentAmount:I,cartData:{items:C.map((({sku:e,name:t,quantity:a,price:o})=>({sku:e,name:t,quantity:a,price:o}))),paymentMethod:e},successUrl:o({isSuccess:!0}),cancelUrl:o(),deliveryInfo:{name:t,phone:r,address:n},note:s});return y(!1),q?h():e!==a.PaymentMethodEnum.VnPayGateway&&m(),p(null==(u=null==d?void 0:d.data)?void 0:u.data),e===a.PaymentMethodEnum.VnPayGateway&&(null==(i=null==(l=null==d?void 0:d.data)?void 0:l.data)?void 0:i.paymentUrl)?window.location.href=null==(w=null==(v=null==d?void 0:d.data)?void 0:v.data)?void 0:w.paymentUrl:c(!0),null==(P=null==d?void 0:d.data)?void 0:P.data}catch(e){q?h():m();const{code:t,message:a}=null==e?void 0:e.response,r=o.getMessageErrorCheckout(t,a);return d(!0,r),console.error(e),null}finally{g(!1)}},paymentMethods:b,isLoadingPaymentMethods:S,getPaymentMethods:j}};


/***/ }),

/***/ 390181:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(891987),t=__webpack_require__(681084),o=__webpack_require__(673100),n=__webpack_require__(100902),u=__webpack_require__(845589);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=l(r),a=Object.defineProperty,c=Object.defineProperties,s=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,f=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,b=(e,r,t)=>r in e?a(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,m=(e,r)=>{for(var t in r||(r={}))f.call(r,t)&&b(e,t,r[t]);if(d)for(var t of d(r))p.call(r,t)&&b(e,t,r[t]);return e};const v=l=>{var a=l,{response:b,configStorage:v,inputs:y,children:h,displayCheckoutProduct:g,enableGenerateOrderCode:C}=a,j=((e,r)=>{var t={};for(var o in e)f.call(e,o)&&r.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&d)for(var o of d(e))r.indexOf(o)<0&&p.call(e,o)&&(t[o]=e[o]);return t})(a,["response","configStorage","inputs","children","displayCheckoutProduct","enableGenerateOrderCode"]);const O=i.default.Children.toArray(h),k=null==O?void 0:O.shift(),x=r.useRef(null),{selectedProducts:P,customExtraFieldSubmit:F,setDoneCheckout:S,setSelectedProducts:w,loading:q,setLoading:E,clearProductInCart:R,checkoutFormRef:D}=n.useCheckoutContext(),{utilSubmitData:V,buildFormValue:A,buildTrackingValueSubmit:G}=o.useForm({wrapperRef:x,response:b});return e.jsxs("div",{ref:x,children:[e.jsx(u.FormV4,(I=m({ref:D,onFinish:e=>(async(e,r,o)=>{try{E(!0);let n=A(e,r,o);const u=F(P),l=G();n=[...C?[{name:"orderCode",type:"string",value:t.generateCode()}]:[],...n,...u,...l],await V(e,n,(()=>{var e;S(!0),w(void 0),null==R||R(),null==(e=null==D?void 0:D.current)||e.reset()}))}finally{E(!1)}})(v,e,y),customLoading:q},m({configStorage:v,inputs:y},j)),L={preventResetFormAfterSubmit:!0},c(I,s(L)))),k&&i.default.cloneElement(k,{loading:q,onClick:()=>{D.current.dispatchEvent(new Event("submit",{cancelable:!0,bubbles:!0}))}}),null==O?void 0:O.map((e=>i.default.cloneElement(e)))]});var I,L};v.displayName="CheckoutForm",exports.CheckoutForm=v;


/***/ }),

/***/ 135104:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(85097),o=__webpack_require__(891987),t=__webpack_require__(100902),s=__webpack_require__(705478);function c(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=c(o),i=Object.defineProperty,n=Object.defineProperties,u=Object.getOwnPropertyDescriptors,a=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,f=(e,r,o)=>r in e?i(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o;const v=l.default.forwardRef(((o,c)=>{var l=o,{isEditorMode:i,children:v,show:O,allowCloseOnEscPressed:P,className:b,customCss:m}=l,j=((e,r)=>{var o={};for(var t in e)d.call(e,t)&&r.indexOf(t)<0&&(o[t]=e[t]);if(null!=e&&a)for(var t of a(e))r.indexOf(t)<0&&p.call(e,t)&&(o[t]=e[t]);return o})(l,["isEditorMode","children","show","allowCloseOnEscPressed","className","customCss"]);const{loading:y,selectedProducts:h,setSelectedProducts:w,checkoutFormRef:C}=t.useCheckoutContext(),{device:x}=r.useStore(),E=r.getPropsByDevice(j,x);return e.jsx(s.PopupV1,(g=((e,r)=>{for(var o in r||(r={}))d.call(r,o)&&f(e,o,r[o]);if(a)for(var o of a(r))p.call(r,o)&&f(e,o,r[o]);return e})({ref:c},E),n(g,u({onFinishClose:()=>{var e;y||(w(void 0),null==(e=null==C?void 0:C.current)||e.reset())},show:i?O:!!h,isEditorMode:i,customCss:m,className:b,allowCloseOnEscPressed:P,children:v}))));var g}));v.displayName="OrderPopup",exports.OrderPopup=v;


/***/ }),

/***/ 100902:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(891987);const r=t.createContext(void 0);exports.CheckoutProvider=({children:o,orderPopupId:u,wrapperCheckoutRef:c,customExtraFieldSubmit:d,clearProductInCart:n})=>{const s=t.useRef(null),[i,a]=t.useState(),[l,p]=t.useState(!1),[h,C]=t.useState(!1),v={loading:l,selectedProducts:i,setSelectedProducts:a,doneCheckout:h,setDoneCheckout:C,orderPopupId:u,openOrderPopup:e=>{var t,r;a(e),null==(r=null==(t=null==c?void 0:c.current)?void 0:t.ownerDocument.querySelector(`[data-uniq-id="${u}"]`))||r.click()},setLoading:p,customExtraFieldSubmit:d,clearProductInCart:n,checkoutFormRef:s};return e.jsx(r.Provider,{value:v,children:o})},exports.useCheckoutContext=()=>{const e=t.useContext(r);if(void 0===e)throw new Error("useCheckout must be used within a CheckoutProvider");return e};


/***/ }),

/***/ 202247:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097),t=__webpack_require__(970348),r=__webpack_require__(800656),o=__webpack_require__(596221),n=Object.defineProperty,i=Object.defineProperties,a=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,l=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,s=(e,t,r)=>t in e?n(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,h=(e,t)=>{for(var r in t||(t={}))l.call(t,r)&&s(e,r,t[r]);if(d)for(var r of d(t))p.call(t,r)&&s(e,r,t[r]);return e},c=(e,t)=>i(e,a(t));const m={text:"Đặt hàng",commonStyle:{color:"#ffffff",backgroundColor:"#7367f0",borderColor:""}},u=[{name:t.OrderFormFieldEnum.name,label:r.t("field.config.name"),required:!0,placeholder:r.t("field.config.name.placeholder"),isEnabled:!0},{name:t.OrderFormFieldEnum.phone,label:r.t("field.config.phone"),required:!0,placeholder:r.t("field.config.phone.placeholder"),isEnabled:!0},{name:t.OrderFormFieldEnum.address,label:r.t("field.config.address"),required:!0,placeholder:r.t("field.config.address.placeholder"),isEnabled:!0},{name:t.OrderFormFieldEnum.note,label:r.t("field.config.note"),required:!1,placeholder:r.t("form.config.note.placeholder"),isEnabled:!0}],O={formFields:u,orderButton:m},E={[t.OrderFormFieldEnum.name]:{type:"text",commonStyle:{height:32,width:"calc(50% - 4px)"},inputStyle:{borderRadius:4}},[t.OrderFormFieldEnum.phone]:{type:"tel",commonStyle:{height:32,width:"calc(50% - 4px)"},inputStyle:{borderRadius:4}},[t.OrderFormFieldEnum.address]:{type:"text",commonStyle:{height:32,width:"100%"},inputStyle:{borderRadius:4}},[t.OrderFormFieldEnum.note]:{type:"textarea",commonStyle:{minHeight:70,width:"100%"},inputStyle:{minHeight:70,borderRadius:4}}},g={title:"<p>Đặt hàng</p>",shippingInfoTitle:"<p>Thông tin giao hàng</p>",productInfoTitle:"<p>Thông tin sản phẩm</p>",totalPaymentText:"<p>Tổng thanh toán</p>",paymentMethodTitle:"<p>Phương thức thanh toán</p>",paymentMethodDescription:"<p>Thông tin thanh toán của bạn sẽ luôn được bảo mật</p>"},y={[e.ORDER_POPUP]:{id:e.ORDER_POPUP,parentId:e.ROOT,tag:"orderpopupv2",resolvedName:"OrderPopupV2Editor",style:{},isCanvas:!1,customAttributes:{orderpopupv2:c(h(h({responsive:{hiddenXs:!1,hiddenMd:!1}},O),o.DEFAULT_POPUP_V1),{maskStyle:{backgroundColor:"rgba(0, 0, 0, 0.4)"},commonStyle:c(h({},o.DEFAULT_POPUP_V1.commonStyle),{width:720,marginBottom:32}),customText:g})},children:[]}};var f=(e=>(e.Cash="CASH",e.Cod="COD",e.BankTransfer="BANK_TRANSFER",e.VnPayGateway="VNPAY_GATEWAY",e))(f||{});exports.DEFAULT_CUSTOM_TEXT=g,exports.DEFAULT_FORM_FIELDS=u,exports.DEFAULT_ORDER_BUTTON=m,exports.DEFAULT_ORDER_NOTE={show:!1,text:"<p>Double click vào đây để chỉnh sửa thông tin lưu ý</p>"},exports.DEFAULT_ORDER_POPUP_V2=O,exports.DEFAULT_ORDER_POPUP_V2_CONTENT=y,exports.DEFAULT_ORDER_POPUP_V2_FORM_FIELDS_CONFIG=E,exports.PaymentMethodEnum=f,exports.paymentMethodIconMapping=e=>{switch(e){case"CASH":default:return"CashColored";case"COD":return"ShippingColored";case"BANK_TRANSFER":return"BankColored";case"VNPAY_GATEWAY":return"VnPayColored"}},exports.paymentMethodLabelMapping=e=>{switch(e){case"CASH":return"Tiền mặt";case"COD":default:return"Thanh toán khi nhận hàng (COD)";case"BANK_TRANSFER":return"Chuyển khoản qua ngân hàng";case"VNPAY_GATEWAY":return"Thanh toán qua VNPAY"}};


/***/ }),

/***/ 970348:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=(e=>(e.name="name",e.phone="phone",e.address="address",e.note="note",e))(e||{});exports.OrderFormFieldEnum=e;


/***/ }),

/***/ 893462:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(891987),r=__webpack_require__(212951),o=__webpack_require__(7698),i=__webpack_require__(143599),n=__webpack_require__(85097),a=__webpack_require__(202247),l=__webpack_require__(874395),s=__webpack_require__(143201),d=__webpack_require__(877084),p=__webpack_require__(895325),u=__webpack_require__(203832),c=__webpack_require__(681084),m=__webpack_require__(655268),f=__webpack_require__(512005),x=__webpack_require__(705478),g=__webpack_require__(740295),h=__webpack_require__(845589),y=__webpack_require__(998621);function T(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var b=T(t),v=T(r),j=T(d),E=Object.defineProperty,w=Object.defineProperties,S=Object.getOwnPropertyDescriptors,O=Object.getOwnPropertySymbols,P=Object.prototype.hasOwnProperty,C=Object.prototype.propertyIsEnumerable,D=(e,t,r)=>t in e?E(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,M=(e,t)=>{for(var r in t||(t={}))P.call(t,r)&&D(e,r,t[r]);if(O)for(var r of O(t))C.call(t,r)&&D(e,r,t[r]);return e},q=(e,t)=>w(e,S(t));const _=[u.MOCK_PRODUCT_LIST_DATA[0]],F=b.default.forwardRef(((r,d)=>{const u=r,{isEditorMode:T,show:v,children:E,formFields:w,orderButton:S=a.DEFAULT_ORDER_BUTTON,quickSetting:D,configStorage:F,triggerUpdate:Q,customText:G,customTextEditor:K,orderNote:W,errorMessageConfig:Y}=u,H=((e,t)=>{var r={};for(var o in e)P.call(e,o)&&t.indexOf(o)<0&&(r[o]=e[o]);if(null!=e&&O)for(var o of O(e))t.indexOf(o)<0&&C.call(e,o)&&(r[o]=e[o]);return r})(u,["isEditorMode","show","children","formFields","orderButton","quickSetting","configStorage","triggerUpdate","customText","customTextEditor","orderNote","errorMessageConfig"]),{customTitleEditor:J,customShippingInfoTitleEditor:Z,customProductInfoTitleEditor:ee,customPaymentMethodTitleEditor:te,customTotalPaymentTextEditor:re,customPaymentMethodDescriptionEditor:oe,customOrderNoteEditor:ie}=K||{},{title:ne,shippingInfoTitle:ae,productInfoTitle:le,paymentMethodTitle:se,totalPaymentText:de,paymentMethodDescription:pe}=G||{},[ue,ce]=t.useState(""),{device:me,globalData:fe}=n.useStore(),xe=b.default.useRef(null),ge=n.getPropsByDevice(H,me),{cart:he,isShowCheckoutPopup:ye,buyNowItem:Te,clearBuyNow:be,getCartTotal:ve,getBuyNowTotal:je,updateQuantity:Ee,removeFromCart:we,updateBuyNowItemQuantity:Se,setShowCheckoutPopup:Oe}=f.useCartStore(),Pe=!!Te,{env:Ce}=n.useStore(),{checkoutOrder:De,isLoading:Me,paymentMethods:qe,setIsLoading:_e}=s.usePinposOrderCheckout(Q),Fe=T?_:Pe?[Te]:he||[],Ue=(null==fe?void 0:fe.isPreviewMode)&&ue===a.PaymentMethodEnum.VnPayGateway,Ie=T?_.reduce(((e,t)=>e+t.price),0):Pe?je():ve(),Ae=T?qe:qe.filter((e=>e.isActive)),ke=e=>{ce(e.target.value)};return t.useEffect((()=>{!ye||(null==he?void 0:he.length)||Te||Oe(!1)}),[he,ye,Te,Oe]),t.useEffect((()=>{const e=qe.filter((e=>e.isActive));e.length>0&&ce(e[0].methodCode)}),[qe]),e.jsxs(e.Fragment,{children:[e.jsxs(x.PopupV1,q(M({ref:d},ge),{show:T?v:ye,isEditorMode:T,showCloseIcon:!0,onFinishClose:()=>{Oe(!1),be()},children:[e.jsxs(U,{style:{pointerEvents:Me?"none":"auto",fontFamily:"var(--tempi-global-paragraph1fontfamily)"},children:[e.jsx(I,{children:J||e.jsx(g.TipTapTextDisplay,{text:ne||a.DEFAULT_CUSTOM_TEXT.title})}),e.jsx(k,{children:Z||e.jsx(g.TipTapTextDisplay,{text:ae||a.DEFAULT_CUSTOM_TEXT.shippingInfoTitle})}),e.jsx(h.FormV4,{ref:xe,inputs:l.getFormFields(w,me),submits:[],hiddenFields:[],showLabel:!0,onFinish:async e=>{if(!T&&!Me&&((null==he?void 0:he.length)||Te))try{_e(!0);const t=p.formatOrderPayload(he,ue),r=q(M({},e),{note:e.note||""});await Promise.allSettled([m.handleStorageData(F,r,Ce,t),De(M({paymentMethod:ue},r))])}finally{_e(!1)}},formStyle:{flexDirection:"row",gap:8,fontFamily:"var(--tempi-global-paragraph1fontfamily)"},errorMessageConfig:Y}),(null==W?void 0:W.show)&&e.jsx("div",{style:{color:"#f57c00",marginTop:10},children:ie||e.jsx(g.TipTapTextDisplay,{text:W.text||a.DEFAULT_ORDER_NOTE.text})}),e.jsxs(N,{children:[e.jsx(k,{children:ee||e.jsx(g.TipTapTextDisplay,{text:le||a.DEFAULT_CUSTOM_TEXT.productInfoTitle})}),Fe.map(((t,r)=>{var i,n;return e.jsx(o.ProductItem,{index:r,removeProduct:()=>(e=>{T||we(e)})(t),setQuantity:e=>((e,t)=>{T||(Pe?Se(t):Ee(e,t))})(t,e),name:null==t?void 0:t.name,price:null==t?void 0:t.price,currencyUnit:"đ",thumbnailAlt:null==t?void 0:t.name,thumbnailUrl:(null==(i=null==t?void 0:t.images)?void 0:i[0])||(null==(n=null==t?void 0:t.image)?void 0:n.src),quantity:null==t?void 0:t.quantity},`${(null==t?void 0:t.sku)||(null==t?void 0:t.name)}-${r}`)})),e.jsx(X,{}),e.jsxs(B,{children:[e.jsx("div",{children:re||e.jsx(g.TipTapTextDisplay,{text:de||a.DEFAULT_CUSTOM_TEXT.totalPaymentText})}),e.jsx("div",{children:c.getPriceText(Ie)})]})]}),e.jsxs(A,{children:[e.jsx(k,{children:te||e.jsx(g.TipTapTextDisplay,{text:se||a.DEFAULT_CUSTOM_TEXT.paymentMethodTitle})}),e.jsx(L,{children:oe||e.jsx(g.TipTapTextDisplay,{text:pe||a.DEFAULT_CUSTOM_TEXT.paymentMethodDescription})}),e.jsx(R,{children:Ae.map(((t,r)=>e.jsxs(V,{className:j.default({inactive:!t.isActive}),children:[e.jsx("input",{type:"radio",name:"paymentMethod",value:t.methodCode,checked:ue===t.methodCode,onChange:ke,disabled:!t.isActive}),e.jsx(i.Icon,{name:a.paymentMethodIconMapping(t.methodCode),style:{fontSize:24}}),a.paymentMethodLabelMapping(t.methodCode)]},r)))})]}),Ue&&e.jsx($,{children:"Vui lòng xuất bản Website để tiếp tục thanh toán qua VNPAY !"}),e.jsxs(z,{disabled:Me||Ue,type:"submit",commonStyle:S.commonStyle,onClick:()=>{var e;return null==(e=xe.current)?void 0:e.dispatchEvent(new Event("submit",{cancelable:!0,bubbles:!0}))},style:{cursor:Me||Ue?"not-allowed":"pointer"},children:[Me&&e.jsx(y.StyledSpinningInner,{size:10,transform:5,time:.6,color:"white"}),S.text||"Đặt hàng"]})]}),D]})),E]})}));F.displayName="OrderPopupV2";const U=v.default.div`
  max-width: 720px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  color: rgba(0, 0, 0, 0.85);
`,I=v.default.h2`
  font-size: 20px;
  margin-bottom: 20px;
  font-weight: bold;
  font-family: var(--tempi-global-heading1fontfamily);
`,A=v.default.div`
  margin-bottom: 15px;
`,k=v.default.label`
  display: block;
  margin-bottom: 16px;
  font-weight: bold;
  font-size: 16px;
  font-family: var(--tempi-global-heading1fontfamily);
`,L=v.default.div`
  color: rgba(130, 134, 139, 1);
  margin-top: -1em;
  margin-bottom: 1em;
`,N=v.default.div`
  padding: 15px;
  border-radius: 4px;
  margin: 2em 0;
  background: rgba(240, 240, 240, 0.5);
`,B=v.default.div`
  font-size: 14px;
  font-weight: 500;
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
`,R=v.default.div`
  margin-bottom: 20px;
`,V=v.default.label`
  display: flex;
  align-items: center;
  padding: 20px 10px;
  border: 1px solid #ddd;
  /* border-radius: 4px; */
  margin: 0;
  cursor: pointer;
  position: relative;

  &.inactive {
    &::after {
      pointer-events: none;
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: repeating-linear-gradient(
        125deg,
        rgba(0, 0, 0, 0.05),
        rgba(0, 0, 0, 0.05) 1px,
        transparent 2px,
        transparent 9px
      );
    }
  }

  input {
    margin-right: 1em;
  }

  span {
    margin-right: 0.5em;
  }

  &:hover {
    background-color: #f5f5f5;
  }

  &:first-of-type {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  &:last-of-type {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  &:not(:first-of-type) {
    border-top: none;
  }
`,z=v.default.button((({commonStyle:e,disabled:t})=>{var r;return`\n  width: 100%;\n  padding: 12px;\n  border-radius: 4px;\n  font-size: 14px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1em;\n  border-width: 1px;\n\n  ${e.borderColor||(null==(r=null==e?void 0:e.hover)?void 0:r.borderColor)?"\n          border-width: 1px;\n          border-style: solid;\n        ":""}\n  ${n.getStyle(e)}\n\n   ${t?"\n     opacity: 0.65;":""}\n`})),X=v.default.hr`
  opacity: 0.06;
`,$=v.default.p`
  color: rgba(245, 124, 0, 1);
  padding: 8px 12px;
  margin: -20px 0 8px 0 !important;
  padding-left: 0;
`;exports.OrderPopupV2=F;


/***/ }),

/***/ 874395:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(202247),r=__webpack_require__(970348),o=Object.defineProperty,n=Object.defineProperties,t=Object.getOwnPropertyDescriptors,a=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,l=Object.prototype.propertyIsEnumerable,p=(e,r,n)=>r in e?o(e,r,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[r]=n,d=(e,r)=>{for(var o in r||(r={}))i.call(r,o)&&p(e,o,r[o]);if(a)for(var o of a(r))l.call(r,o)&&p(e,o,r[o]);return e},s=(e,r)=>n(e,t(r));const c="userInfo",m="/setting/payment",O="/invoices",u=(e,o)=>{const n=r=>e.some((({name:e,isEnabled:o})=>e===r&&o));return[r.OrderFormFieldEnum.name,r.OrderFormFieldEnum.phone].includes(o)&&n(r.OrderFormFieldEnum.name)&&n(r.OrderFormFieldEnum.phone)?"calc(50% - 4px)":"100%"},P=()=>{var e,r;const o=localStorage.getItem(c);return o?null==(r=null==(e=JSON.parse(o))?void 0:e.meta_data)?void 0:r.merchant_id:void 0},_=(e,r,o)=>{const n=P(),t=new URL(`${r}/app/${o}`);return t.searchParams.append("merchant",n),t.searchParams.append("redirectTo",e),t.toString()};exports.LOCALSTORAGE_USER_INFO=c,exports.PINPOS_INVOICES_PATH=O,exports.PINPOS_PAYMENT_PATH=m,exports.PINPOS_PRODUCT_PATH="/v2/products",exports.getFieldWidth=u,exports.getFormFields=(r,o)=>r.filter((({isEnabled:e})=>e)).map((({label:n,name:t,required:a,placeholder:i})=>s(d(d({},e.DEFAULT_ORDER_POPUP_V2_FORM_FIELDS_CONFIG[t]),{label:n,name:t,required:a,placeholder:i}),{commonStyle:s(d({},e.DEFAULT_ORDER_POPUP_V2_FORM_FIELDS_CONFIG[t].commonStyle),{width:"mobile"===o?"100%":u(r,t)})}))),exports.getMerchantFromLocalStorage=P,exports.handleAddAuthParams=_,exports.handleOrderManagement=()=>{const{pinposUrl:e,market:r={},pinposAppId:o}=(null==window?void 0:window.config)||{},{defaultLoginUri:n}=r;e&&window.open(_(e+O,n,o),"_blank")},exports.handlePaymentConfiguration=()=>{const{pinposUrl:e,market:r={},pinposAppId:o}=(null==window?void 0:window.config)||{},{defaultLoginUri:n}=r;e&&window.open(_(e+m,n,o),"_blank")};


/***/ }),

/***/ 247603:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var n=__webpack_require__(561261),e=__webpack_require__(891987);const t=["#e74c3c","#c0392b","#e67e22","#d35400","#f39c12","#f1c40f","#d4ac0d","#935116","#a04000"];exports.AutumnLeavesEffect=()=>{const a=e.useMemo((()=>Array.from({length:40},((n,e)=>({id:e,x:100*Math.random(),size:20*Math.random()+20,duration:10*Math.random()+10,delay:15*Math.random(),opacity:.3*Math.random()+.7,color:t[Math.floor(Math.random()*t.length)],swayAmount:60*Math.random()+40,leafType:Math.random()>.5?"maple":"oval"})))),[]),r=e=>n.jsx("span",{style:{fontSize:`${e.size}px`,opacity:e.opacity,filter:"drop-shadow(1px 2px 2px rgba(0,0,0,0.2))",display:"inline-block",lineHeight:1},children:"🍁"}),o=e=>n.jsxs("svg",{width:e.size,height:1.3*e.size,viewBox:"0 0 60 100",style:{opacity:e.opacity,filter:"drop-shadow(1px 2px 2px rgba(0,0,0,0.2))"},children:[n.jsx("path",{d:"\n          M30 5\n          C32 7 34 8 33 10\n          C36 12 38 14 37 16\n          C42 18 46 22 45 26\n          C50 30 54 36 52 42\n          C56 48 57 54 54 60\n          C56 66 54 72 50 76\n          C48 80 44 84 40 86\n          C38 88 35 90 32 90\n          L30 90\n          C28 90 25 88 22 86\n          C18 84 14 80 12 76\n          C8 72 6 66 8 60\n          C5 54 6 48 10 42\n          C8 36 12 30 17 26\n          C16 22 20 18 25 16\n          C24 14 26 12 29 10\n          C28 8 30 7 30 5\n          Z\n        ",fill:e.color}),n.jsx("path",{d:"M30 12 L30 85",stroke:"#f1c40f"===e.color||"#f39c12"===e.color?"#CD853F":"rgba(0,0,0,0.2)",strokeWidth:"1.5",strokeLinecap:"round",fill:"none"}),n.jsx("path",{d:"M30 25 Q40 22 48 28 M30 25 Q20 22 12 28 M30 40 Q42 38 52 44 M30 40 Q18 38 8 44 M30 55 Q40 54 50 60 M30 55 Q20 54 10 60 M30 70 Q38 70 44 76 M30 70 Q22 70 16 76",stroke:"#f1c40f"===e.color||"#f39c12"===e.color?"#CD853F":"rgba(0,0,0,0.15)",strokeWidth:"0.8",strokeLinecap:"round",fill:"none"}),n.jsx("path",{d:"M30 85 Q31 92 32 100",stroke:"#8B6914",strokeWidth:"2",strokeLinecap:"round",fill:"none"})]});return n.jsxs("div",{style:{position:"fixed",top:0,left:0,width:"100%",height:"100%",pointerEvents:"none",overflow:"hidden",zIndex:9999},children:[n.jsx("style",{children:"\n          @keyframes tempiLeafFall {\n            0% {\n              transform: translateY(-20px);\n              opacity: 0;\n            }\n            5% {\n              opacity: 1;\n            }\n            95% {\n              opacity: 1;\n            }\n            100% {\n              transform: translateY(calc(100vh + 50px));\n              opacity: 0;\n            }\n          }\n          \n          @keyframes tempiLeafSway {\n            0%, 100% {\n              transform: translateX(0) rotateZ(0deg);\n            }\n            25% {\n              transform: translateX(var(--sway)) rotateZ(15deg);\n            }\n            50% {\n              transform: translateX(0) rotateZ(-10deg);\n            }\n            75% {\n              transform: translateX(calc(var(--sway) * -0.7)) rotateZ(20deg);\n            }\n          }\n          \n          @keyframes tempiLeafSpin {\n            0% {\n              transform: rotateY(0deg) rotateX(0deg);\n            }\n            50% {\n              transform: rotateY(180deg) rotateX(20deg);\n            }\n            100% {\n              transform: rotateY(360deg) rotateX(0deg);\n            }\n          }\n        "}),a.map((e=>n.jsx("div",{style:{position:"absolute",left:`${e.x}%`,top:"-100px",animation:`tempiLeafFall ${e.duration}s ease-in-out infinite`,animationDelay:`${e.delay}s`},children:n.jsx("div",{style:{"--sway":`${e.swayAmount}px`,animation:`tempiLeafSway ${e.duration/2}s ease-in-out infinite`,animationDelay:`${e.delay}s`},children:n.jsx("div",{style:{animation:`tempiLeafSpin ${e.duration/2.5}s ease-in-out infinite`,animationDelay:`${e.delay}s`,transformStyle:"preserve-3d"},children:"maple"===e.leafType?r(e):o(e)})})},e.id)))]})};


/***/ }),

/***/ 124511:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(891987);const r=[{r:255,g:71,b:87},{r:255,g:165,b:2},{r:255,g:250,b:101},{r:46,g:213,b:115},{r:30,g:144,b:255},{r:255,g:107,b:129},{r:165,g:94,b:234},{r:0,g:210,b:211}];exports.FireworksEffect=()=>{const n=t.useRef(null),a=t.useRef(),i=t.useRef([]),s=t.useRef(0);return t.useEffect((()=>{const e=n.current;if(!e)return;const t=e.getContext("2d",{alpha:!0});if(!t)return;t.imageSmoothingEnabled=!1;let o=0,l=0;const c=()=>{o=window.innerWidth,l=window.innerHeight,e.width=o,e.height=l};c(),window.addEventListener("resize",c);const h=e=>{const t=[];for(let r=0;r<60;r++){const n=2*Math.PI*r/60,a=5*Math.random()+4;t.push({x:e.x,y:e.y,vx:Math.cos(n)*a,vy:Math.sin(n)*a,alpha:1,r:e.r,g:e.g,b:e.b,size:3*Math.random()+2,decay:.012*Math.random()+.008})}for(let r=0;r<15;r++){const r=Math.random()*Math.PI*2,n=6*Math.random()+4;t.push({x:e.x,y:e.y,vx:Math.cos(r)*n,vy:Math.sin(r)*n,alpha:1,r:255,g:255,b:255,size:2*Math.random()+1.5,decay:.018*Math.random()+.012})}return t},u=e=>{t.clearRect(0,0,o,l),e-s.current>400&&i.current.length<10&&(i.current.push((()=>{const e=Math.random()*o*.8+.1*o,t=r[Math.floor(Math.random()*r.length)];return{x:e,y:l,targetY:Math.random()*l*.4+.1*l,vy:-(2*Math.random()+7),r:t.r,g:t.g,b:t.b,exploded:!1,particles:[]}})()),s.current=e);let n=i.current.length;for(;n--;){const e=i.current[n];if(e.exploded){let r=e.particles.length;for(;r--;){const n=e.particles[r];if(n.x+=n.vx,n.y+=n.vy,n.vy+=.06,n.vx*=.99,n.alpha-=n.decay,n.alpha<=0){e.particles.splice(r,1);continue}const a=Math.min(1,n.alpha);for(let e=8;e>0;e--){const r=a*(e/8)*.4,i=n.x-n.vx*e*.8,s=n.y-n.vy*e*.8;t.fillStyle=`rgba(${n.r},${n.g},${n.b},${r})`,t.fillRect(i-.5*n.size,s-.5*n.size,n.size,n.size)}t.fillStyle=`rgba(${n.r},${n.g},${n.b},${a})`,t.fillRect(n.x-.5*n.size,n.y-.5*n.size,n.size,n.size)}0===e.particles.length&&i.current.splice(n,1)}else{const r=4;t.fillStyle=`rgb(${e.r},${e.g},${e.b})`,t.fillRect(e.x-r/2,e.y-r,r,2*r),t.fillStyle=`rgba(${e.r},${e.g},${e.b},0.5)`,t.fillRect(e.x-r/4,e.y,r/2,3*r),e.y+=e.vy,e.vy+=.06,(e.y<=e.targetY||e.vy>=0)&&(e.exploded=!0,e.particles=h(e))}}a.current=requestAnimationFrame(u)};return a.current=requestAnimationFrame(u),()=>{window.removeEventListener("resize",c),a.current&&cancelAnimationFrame(a.current)}}),[]),e.jsx("canvas",{ref:n,style:{position:"fixed",top:0,left:0,width:"100%",height:"100%",pointerEvents:"none",zIndex:9999}})};


/***/ }),

/***/ 320353:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(891987);const n=["#ff6b6b","#ee5a5a","#ff8787","#f06595","#e64980","#ff85a1","#ff4d6d","#c71f37"];exports.HeartEffect=()=>{const a=t.useMemo((()=>Array.from({length:25},((e,t)=>({id:t,startX:100*Math.random(),endX:100*Math.random(),size:20*Math.random()+18,duration:4*Math.random()+4,delay:8*Math.random(),color:n[Math.floor(Math.random()*n.length)]})))),[]);return e.jsxs("div",{style:{position:"fixed",top:0,left:0,width:"100%",height:"100%",pointerEvents:"none",overflow:"hidden",zIndex:9999},children:[e.jsx("style",{children:"\n          @keyframes tempiHeartRise {\n            0% {\n              transform: translateY(0) scale(0.3);\n              opacity: 0;\n            }\n            10% {\n              opacity: 1;\n              transform: translateY(-10vh) scale(1);\n            }\n            50% {\n              opacity: 0.8;\n            }\n            100% {\n              transform: translateY(-100vh) scale(0.6);\n              opacity: 0;\n            }\n          }\n          \n          @keyframes tempiHeartSpread {\n            0% {\n              left: var(--start-x);\n            }\n            100% {\n              left: var(--end-x);\n            }\n          }\n\n          @keyframes tempiHeartPulse {\n            0%, 100% {\n              transform: scale(1);\n            }\n            50% {\n              transform: scale(1.15);\n            }\n          }\n        "}),a.map((t=>e.jsx("div",{style:{"--start-x":`${t.startX}%`,"--end-x":`${t.endX}%`,position:"absolute",left:`${t.startX}%`,bottom:"5%",animation:`tempiHeartRise ${t.duration}s ease-out infinite, tempiHeartSpread ${t.duration}s ease-out infinite`,animationDelay:`${t.delay}s`,animationFillMode:"backwards"},children:e.jsx("div",{style:{animation:"tempiHeartPulse 0.8s ease-in-out infinite",animationDelay:`${t.delay}s`},children:e.jsxs("svg",{width:t.size,height:t.size,viewBox:"0 0 32 32",style:{filter:`drop-shadow(0 0 8px ${t.color}80)`},children:[e.jsx("path",{d:"M16 28s-1.5-1.1-3.5-2.7C8.5 22 4 17.5 4 12.5 4 8.4 7.2 5 11 5c2.2 0 4.2 1.1 5 2.8C16.8 6.1 18.8 5 21 5c3.8 0 7 3.4 7 7.5 0 5-4.5 9.5-8.5 12.8-2 1.6-3.5 2.7-3.5 2.7z",fill:t.color}),e.jsx("ellipse",{cx:"11",cy:"11",rx:"3",ry:"2.5",fill:"rgba(255,255,255,0.3)",transform:"rotate(-30 11 11)"})]})})},t.id)))]})};


/***/ }),

/***/ 213665:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var n=__webpack_require__(561261),e=__webpack_require__(891987);exports.RedEnvelopeEffect=()=>{const t=e.useMemo((()=>Array.from({length:30},((n,e)=>({id:e,x:100*Math.random(),size:20*Math.random()+25,duration:6*Math.random()+5,delay:10*Math.random(),opacity:.3*Math.random()+.7,swayAmount:40*Math.random()+20,rotateDirection:Math.random()>.5?1:-1})))),[]);return n.jsxs("div",{style:{position:"fixed",top:0,left:0,width:"100%",height:"100%",pointerEvents:"none",overflow:"hidden",zIndex:9999},children:[n.jsx("style",{children:"\n          @keyframes tempiEnvelopeFall {\n            0% {\n              transform: translateY(-60px);\n              opacity: 0;\n            }\n            5% {\n              opacity: 1;\n            }\n            95% {\n              opacity: 1;\n            }\n            100% {\n              transform: translateY(calc(100vh + 60px));\n              opacity: 0;\n            }\n          }\n          \n          @keyframes tempiEnvelopeSway {\n            0%, 100% {\n              transform: translateX(0) rotate(0deg);\n            }\n            25% {\n              transform: translateX(var(--sway)) rotate(calc(var(--rotate-dir) * 15deg));\n            }\n            50% {\n              transform: translateX(0) rotate(0deg);\n            }\n            75% {\n              transform: translateX(calc(var(--sway) * -1)) rotate(calc(var(--rotate-dir) * -15deg));\n            }\n          }\n\n          @keyframes tempiEnvelopeGlow {\n            0%, 100% {\n              filter: drop-shadow(0 0 8px rgba(255, 215, 0, 0.6));\n            }\n            50% {\n              filter: drop-shadow(0 0 16px rgba(255, 215, 0, 0.9));\n            }\n          }\n        "}),t.map((e=>n.jsx("div",{style:{position:"fixed",left:`${e.x}%`,top:0,animation:`tempiEnvelopeFall ${e.duration}s ease-in-out infinite`,animationDelay:`${e.delay}s`,animationFillMode:"backwards"},children:n.jsx("div",{style:{"--sway":`${e.swayAmount}px`,"--rotate-dir":e.rotateDirection,fontSize:`${e.size}px`,opacity:e.opacity,animation:`tempiEnvelopeSway ${e.duration/2}s ease-in-out infinite, tempiEnvelopeGlow 2s ease-in-out infinite`,animationDelay:`${e.delay}s`,lineHeight:1,display:"inline-block"},children:"🧧"})},e.id)))]})};


/***/ }),

/***/ 235170:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(561261),a=__webpack_require__(891987);exports.SakuraEffect=()=>{const e=a.useMemo((()=>Array.from({length:35},((t,a)=>({id:a,x:100*Math.random(),size:12*Math.random()+8,duration:10*Math.random()+8,delay:12*Math.random(),opacity:.5*Math.random()+.5,rotateStart:360*Math.random()})))),[]);return t.jsxs("div",{style:{position:"fixed",top:0,left:0,width:"100%",height:"100%",pointerEvents:"none",overflow:"hidden",zIndex:9999},children:[t.jsx("style",{children:"\n          @keyframes sakuraFall {\n            0% {\n              transform: translateY(-20px) translateX(0) rotate(0deg);\n            }\n            25% {\n              transform: translateY(25vh) translateX(30px) rotate(90deg);\n            }\n            50% {\n              transform: translateY(50vh) translateX(-20px) rotate(180deg);\n            }\n            75% {\n              transform: translateY(75vh) translateX(40px) rotate(270deg);\n            }\n            100% {\n              transform: translateY(100vh) translateX(10px) rotate(360deg);\n            }\n          }\n          \n          @keyframes sakuraFloat {\n            0%, 100% {\n              transform: rotateY(0deg) rotateX(0deg);\n            }\n            25% {\n              transform: rotateY(45deg) rotateX(15deg);\n            }\n            50% {\n              transform: rotateY(0deg) rotateX(30deg);\n            }\n            75% {\n              transform: rotateY(-45deg) rotateX(15deg);\n            }\n          }\n        "}),e.map((a=>t.jsx("div",{style:{position:"absolute",left:`${a.x}%`,top:"-30px",animation:`sakuraFall ${a.duration}s ease-in-out infinite`,animationDelay:`${a.delay}s`},children:t.jsx("div",{style:{width:`${a.size}px`,height:1.2*a.size+"px",opacity:a.opacity,animation:`sakuraFloat ${a.duration/3}s ease-in-out infinite`,animationDelay:`${a.delay}s`},children:t.jsxs("svg",{viewBox:"0 0 24 30",style:{width:"100%",height:"100%",filter:"drop-shadow(0 2px 4px rgba(219, 112, 147, 0.4))"},children:[t.jsx("path",{d:"M12 0 C8 6 0 12 0 18 C0 24 6 30 12 30 C18 30 24 24 24 18 C24 12 16 6 12 0 Z",fill:`rgba(255, ${180+40*Math.random()}, ${200+30*Math.random()}, ${a.opacity})`}),t.jsx("path",{d:"M12 5 L12 25",stroke:"rgba(255, 150, 180, 0.5)",strokeWidth:"0.5",fill:"none"})]})})},a.id)))]})};


/***/ }),

/***/ 270846:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var n=__webpack_require__(561261),a=__webpack_require__(891987);const t=["❄","❅","❆"];exports.SnowEffect=()=>{const e=a.useMemo((()=>Array.from({length:50},((n,a)=>({id:a,x:100*Math.random(),size:16*Math.random()+10,duration:8*Math.random()+6,delay:10*Math.random(),opacity:.6*Math.random()+.4,swayAmount:30*Math.random()+10,variant:Math.floor(Math.random()*t.length)})))),[]);return n.jsxs("div",{style:{position:"fixed",top:0,left:0,width:"100%",height:"100%",pointerEvents:"none",overflow:"hidden",zIndex:9999},children:[n.jsx("style",{children:"\n          @keyframes tempiSnowfall {\n            0% {\n              transform: translateY(-30px);\n            }\n            100% {\n              transform: translateY(calc(100vh + 20px));\n            }\n          }\n          \n          @keyframes tempiSnowSway {\n            0%, 100% {\n              transform: translateX(0) rotate(0deg);\n            }\n            25% {\n              transform: translateX(var(--sway)) rotate(90deg);\n            }\n            50% {\n              transform: translateX(0) rotate(180deg);\n            }\n            75% {\n              transform: translateX(calc(var(--sway) * -1)) rotate(270deg);\n            }\n          }\n        "}),e.map((a=>n.jsx("div",{style:{position:"fixed",left:`${a.x}%`,top:0,animation:`tempiSnowfall ${a.duration}s linear infinite`,animationDelay:`${a.delay}s`,animationFillMode:"backwards"},children:n.jsx("div",{style:{"--sway":`${a.swayAmount}px`,fontSize:`${a.size}px`,color:"#80d0ff",textShadow:"0 0 8px rgba(255, 255, 255, 0.8), 0 0 12px rgba(200, 220, 255, 0.6)",opacity:a.opacity,animation:`tempiSnowSway ${a.duration/2}s ease-in-out infinite`,animationDelay:`${a.delay}s`,lineHeight:1,fontFamily:"Arial, sans-serif"},children:t[a.variant]})},a.id)))]})};


/***/ }),

/***/ 457336:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(270846),t=__webpack_require__(320353),f=__webpack_require__(213665),s=__webpack_require__(247603),c=__webpack_require__(124511),u=__webpack_require__(235170);const a=({enabled:a,type:n})=>{if(!a)return null;switch(n){case"snow":default:return e.jsx(r.SnowEffect,{});case"sakura":return e.jsx(u.SakuraEffect,{});case"fireworks":return e.jsx(c.FireworksEffect,{});case"autumn":return e.jsx(s.AutumnLeavesEffect,{});case"redenvelope":return e.jsx(f.RedEnvelopeEffect,{});case"heart":return e.jsx(t.HeartEffect,{})}};a.displayName="Tempi Page Effect",exports.PageEffect=a;


/***/ }),

/***/ 500565:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));const e={commonStyle:{justifyContent:"center"},width:595,height:842,size:"fixed",drawShadow:!0,flippingTime:1e3,usePortrait:!0,startZIndex:0,autoSize:!1,showCover:!1,showNavigation:!0,align:(__webpack_require__(85097).Alignment.center),images:[{src:"https://lh3.googleusercontent.com/fme57ZJ5E8LDAuiBOdfSCl6Ox2J-dm_tkSJFpPH84KJH-FiFHmmJuu7tLYWCx8aIbPHYUtXjmMqkkrD9S3N3spmmZGFhyAc",googleImageParams:{width:0}},{src:"https://lh3.googleusercontent.com/4CyrPB24nPsyzkRiOvhkHjoXnp85CZk0PGV24jHy3Cg6V3b0Xpwa7sUq-FrseKv1V5ANBEF2_u6kQZhjacrrs8TNTCTRznc",googleImageParams:{width:0}},{src:"https://lh3.googleusercontent.com/eubbkpQN-TWjh6Jghnb28geuiiHBtUjKWfPfSYjp2Y5nAIPrJ84U00yUTiLFAquesy15gkRg1sgZchdpdTMM0tYxpqlzLbw",googleImageParams:{width:0}},{src:"https://lh3.googleusercontent.com/1DMzHybfiLsRu3VAkUUiSTwX75KFOwgcImCqrXdk4JrIJnI7BRkqPv3Ou8YUWk1p_8nef39GZ9oyBvBB16cFXfuKFh8Yhmo=rw-w1754",googleImageParams:{width:0}}]};exports.DEFAULT_PAGE_FLIP=e;


/***/ }),

/***/ 953264:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var n=__webpack_require__(561261),e=__webpack_require__(212951),t=__webpack_require__(85097),i=__webpack_require__(891987),r=__webpack_require__(447670),o=__webpack_require__(500565);function a(n){return n&&"object"==typeof n&&"default"in n?n:{default:n}}var l=a(e),s=a(r),p=Object.defineProperty,d=Object.defineProperties,h=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,m=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,u=(n,e,t)=>e in n?p(n,e,{enumerable:!0,configurable:!0,writable:!0,value:t}):n[e]=t,f=(n,e)=>{for(var t in e||(e={}))m.call(e,t)&&u(n,t,e[t]);if(c)for(var t of c(e))g.call(e,t)&&u(n,t,e[t]);return n};const x=i.forwardRef(((e,r)=>{var a=e,{id:l,images:p,isEditorMode:u}=a,x=((n,e)=>{var t={};for(var i in n)m.call(n,i)&&e.indexOf(i)<0&&(t[i]=n[i]);if(null!=n&&c)for(var i of c(n))e.indexOf(i)<0&&g.call(n,i)&&(t[i]=n[i]);return t})(a,["id","images","isEditorMode"]);const k=i.useRef(),[j,S]=i.useState(0),[P,F]=i.useState(x.showCover||!1),[C,O]=i.useState(!1),[T,z]=i.useState(!1),[_,E]=i.useState(!1),[H,I]=i.useState(x.showCover?0:1),{device:M}=t.useStore(),{width:q,height:W,commonStyle:A,align:U}=t.getPropsByDevice(x,M),L="mobile"===M,N=q||596,R=W||842,D=2*N,{showCover:G}=x,Y=(null==p?void 0:p.length)||0,X=G?H>0:H>1,B=H<Y-2,Z=!1!==x.showNavigation&&Y>1;i.useEffect((()=>{S((n=>n+1)),G&&!P&&F(!0)}),[x.autoSize,x.drawShadow,x.flippingTime,x.height,q,W,G,x.size,x.startZIndex,x.usePortrait]),i.useEffect((()=>{if(G&&T&&k.current&&!P){const n=setTimeout((()=>{try{k.current.pageFlip().flipNext(),z(!1)}catch(n){console.warn("Could not auto flip page:",n)}}),200);return()=>clearTimeout(n)}}),[T,P,G]);const J=()=>{G&&P&&!C&&(O(!0),z(!0),setTimeout((()=>{F(!1),O(!1)}),600))},K=G&&(null==p?void 0:p.length)>0?p[0]:null,Q=G&&P&&K,V=Z&&!u&&!L&&Y>1&&n.jsxs(n.Fragment,{children:[n.jsx(y,{position:"left",onClick:()=>{var n;(null==k?void 0:k.current)&&X&&(null==(n=null==k?void 0:k.current)||n.pageFlip().flipPrev())},disabled:!X,children:"‹"}),n.jsx(y,{position:"right",onClick:()=>{var n;0===H&&G?J():(null==k?void 0:k.current)&&B&&(null==(n=null==k?void 0:k.current)||n.pageFlip().flipNext())},disabled:0!==H&&!B,children:"›"})]});return n.jsxs(b,{ref:r,commonStyle:A,id:l,"data-id":l,bookWidth:D,bookHeight:R,align:U,isEditorMode:!0,children:[V,Q&&!L&&n.jsx(v,{onClick:u?void 0:J,width:N,height:R,isMoving:C,children:n.jsx(w,{src:t.getImageUrlFromGoogleUserContent(K.src,f({format:"webp",compressLevel:1},K.googleImageParams)),width:N,height:R})}),n.jsx($,{isReturningToCover:_,isHidden:Q&&!L,bookWidth:D,bookHeight:R,children:n.jsx(s.default,(nn=f({ref:k},x),en={flippingTime:x.flippingTime>0?x.flippingTime:o.DEFAULT_PAGE_FLIP.flippingTime,width:N,height:R,minWidth:N,maxWidth:N,minHeight:R,maxHeight:R,mobileScrollSupport:!0,drawShadow:!1!==x.drawShadow,onFlip:n=>{I(n.data),!G||0!==n.data||P||_||(E(!0),setTimeout((()=>{F(!0),E(!1)}),600))},children:null==p?void 0:p.map(((e,i)=>{const{src:r,googleImageParams:o}=e;return n.jsx(w,{src:t.getImageUrlFromGoogleUserContent(r,f({format:"webp",compressLevel:1},o)),width:N,height:R},i)}))},d(nn,h(en))),j)})]});var nn,en})),b=l.default.div((({commonStyle:n,bookWidth:e,bookHeight:i,align:r,isEditorMode:o})=>`\n  display: flex;\n  position: relative;\n  overflow: visible; /* Critical: Allow book to render at full size */\n  ${t.getStyle(n)}\n\n  /* Force exact container dimensions */\n  width: ${e}px !important;\n  min-width: ${e}px !important;\n  max-width: ${e}px !important;\n  height: ${i}px !important;\n  min-height: ${i}px !important;\n  max-height: ${i}px !important;\n  ${(n=>{switch(n){case t.Alignment.center:return"margin: 0 auto;";case t.Alignment.right:return"\n        margin: 0 auto;\n        margin-right: 0;\n      ";default:return""}})(r)}\n  ${o?"> * {pointer-event: none;}":""}\n`)),v=l.default.div((({width:n,height:e,isMoving:t})=>`\n  width: ${n}px;\n  height: ${e}px;\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n  flex-shrink: 0; /* Prevent shrinking */\n\n  &:hover {\n    ${t?"":"transform: scale(1.02);"}\n  }\n\n  ${t?"transform: translateX(50%);":""}\n`)),w=l.default.div((({src:n,width:e,height:t})=>`\n  width: 100%;\n  height: 100%;\n  background-repeat: no-repeat;\n  background-image: url(${n});\n  background-size: ${e}px ${t}px;\n  background-position: center;\n`)),$=l.default.div((({isReturningToCover:n,isHidden:e,bookWidth:t,bookHeight:i})=>`\n  position: relative;\n  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n\n  /* Force exact dimensions for book container */\n  width: ${t}px !important;\n  height: ${i}px !important;\n  min-width: ${t}px !important;\n  min-height: ${i}px !important;\n  flex-shrink: 0;\n\n  /* Force all child elements to use exact dimensions */\n  .stf__parent {\n    width: ${t}px !important;\n    min-width: ${t}px !important;\n    max-width: ${t}px !important;\n    height: ${i}px !important;\n    min-height: ${i}px !important;\n    max-height: ${i}px !important;\n  }\n\n  .stf__wrapper {\n    width: ${t}px !important;\n    height: ${i}px !important;\n    padding-bottom: 0 !important;\n  }\n\n  .stf__block {\n    width: ${t}px !important;\n    height: ${i}px !important;\n  }\n\n  ${e?"\n    visibility: hidden;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: -1;\n  ":""}\n\n  ${n?"\n    transform: translateX(-25%);\n  ":""}\n`)),y=l.default.button((({position:n,disabled:e})=>`\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  ${"left"===n?"left: 0px;":"right: 0px;"}\n  visibility: ${e?"hidden":"visible"};\n\n  width: 30px;\n  height: 30px;\n  border: none;\n  color: #333;\n  font-size: 56px;\n  font-weight: bold;\n  background-color: transparent;\n  color:rgb(190, 190, 190);\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  transition: all 0.2s ease;\n  z-index: 10;\n\n  &:hover {\n    ${e?"":"\n      background-color: transparent;\n      transform: translateY(-50%) scale(1.05);\n      color: #ffffff;\n    "}\n  }\n\n  &:active {\n    ${e?"":"\n      transform: translateY(-50%) scale(0.95);\n      color: #ffffff;\n    "}\n  }\n\n  @media (max-width: 768px) {\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n    ${"left"===n?"left: 0px;":"right: 0px;"}\n  }\n`));x.displayName="PageFlip",exports.PageFlip=x;


/***/ }),

/***/ 840424:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(85097),n=__webpack_require__(877084),o=__webpack_require__(891987),a=__webpack_require__(110442),i=__webpack_require__(426839),l=__webpack_require__(534479);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=s(r),u=s(n),p=Object.defineProperty,d=Object.defineProperties,f=Object.getOwnPropertyDescriptors,m=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,v=Object.prototype.propertyIsEnumerable,g=(e,r,t)=>r in e?p(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,j=(e,r)=>{for(var t in r||(r={}))y.call(r,t)&&g(e,t,r[t]);if(m)for(var t of m(r))v.call(r,t)&&g(e,t,r[t]);return e},b=(e,r)=>d(e,f(r));const x=r=>{var n=r,{text:a,children:l,event:s}=n,c=((e,r)=>{var t={};for(var n in e)y.call(e,n)&&r.indexOf(n)<0&&(t[n]=e[n]);if(null!=e&&m)for(var n of m(e))r.indexOf(n)<0&&v.call(e,n)&&(t[n]=e[n]);return t})(n,["text","children","event"]);const p=o.useRef(null),{device:d}=t.useStore(),{commonStyle:f}=t.getPropsByDevice(c,d),{style:g,animationClassName:x}=t.useAnimation(null==f?void 0:f.animation,p),h=null==s?void 0:s.tekoTrackingEvent,{text:P}=t.useInjectDynamicLinks(a,i.objectToAttrString(i.getAttrTracking(h))),S=b(j({},c),{ref:p,className:u.default(c.className,x),style:g,commonStyle:f});return l?e.jsx(O,b(j({},S),{children:l})):e.jsx(O,b(j({},S),{dangerouslySetInnerHTML:{__html:P}}))},O=c.default.div((({commonStyle:e})=>`\n    ${t.getStyle(e)};\n    ${l.getCommonTextCss(!0)}\n    ${a.getParagraphHoverStyle(null==e?void 0:e.hover)}\n    a {\n      color: inherit;\n    }\n  `));x.displayName="Paragraph",exports.Paragraph=x,exports.StyledParagraph=O;


/***/ }),

/***/ 110442:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(66811),t=__webpack_require__(85097),i=__webpack_require__(387064),r=__webpack_require__(534479),o=__webpack_require__(292471),n=__webpack_require__(481177);const l=[i.NODE_TYPES.orderedList,i.NODE_TYPES.bulletList],a=(e,t)=>{if(null==e||""===e)return;const i=t||16,r=parseFloat(e);switch(e.replace(/[\d.]/g,"").toLowerCase()){case"em":case"rem":case"":default:return Math.round(r*i);case"pt":return Math.round(4*r/3);case"%":return Math.round(r*i/100);case"px":return Math.round(r)}},u=e=>{if(null==e||""===e)return;const t=parseFloat(e);switch(e.replace(/[\d.]/g,"").toLowerCase()){case"em":case"rem":return 16*t;case"pt":return Math.round(4*t/3);case"%":return Math.round(16*t/100);default:return t}};exports.createCommandMap=(e,o)=>({fontFamily:(e,t)=>e.setFontFamily(t),fontSize:(e,t)=>e.setFontSize("number"==typeof t?t+"px":t,o?"desktop":void 0),mobileFontSize:(e,t)=>e.setFontSize("number"==typeof t?t+"px":t,"mobile"),fontWeight:(e,t)=>e.setFontWeight(t),lineHeight:(e,i)=>e.setLineHeight(t.unitParse(i),o?"desktop":void 0),mobileLineHeight:(e,i)=>e.setLineHeight(t.unitParse(i),"mobile"),letterSpacing:(e,i)=>e.setLetterSpacing(t.unitParse(i),o?"desktop":void 0),mobileLetterSpacing:(e,i)=>e.setLetterSpacing(t.unitParse(i),"mobile"),color:(e,t)=>e.setColor(t),backgroundColor:(e,t)=>e.setBackgroundColor(t),level:(t,o)=>{const{level:n}=null==e?void 0:e.getAttributes((null==e?void 0:e.isActive(i.NODE_TYPES.heading))?i.NODE_TYPES.heading:i.NODE_TYPES.paragraph);return parseInt(o.replace("h",""))===n?t:o&&o!==r.paragraphType?t.toggleHeadingSafe({level:parseInt(o.replace("h",""))}):t.setParagraphSafe()},bold:e=>e.toggleBold(),italic:e=>e.toggleItalic(),underline:e=>e.toggleUnderline(),strike:e=>e.toggleStrike(),textAlign:(e,t)=>e.setTextAlign(t,o?"desktop":void 0),mobileTextAlign:(e,t)=>e.setTextAlign(t,"mobile"),listType:(t,r)=>t.toggleList(r,i.NODE_TYPES.listItem,!0).updateAttributes(i.NODE_TYPES.listItem,null==e?void 0:e.getAttributes((null==e?void 0:e.isActive(i.NODE_TYPES.heading))?i.NODE_TYPES.heading:i.NODE_TYPES.paragraph)),textTransform:(e,t)=>e.setTextTransform(t),fontVariant:(e,t)=>e.setFontVariant(t)}),exports.getParagraphHoverStyle=e=>e?`\n    &:hover p {\n      ${(null==e?void 0:e.color)?`color: ${e.color} !important;`:""}\n      ${(null==e?void 0:e.borderColor)?`border-color: ${e.borderColor} !important;`:""}\n      ${(null==e?void 0:e.background)?`background: ${e.background} !important;`:""}\n      ${(null==e?void 0:e.backgroundColor)?`background-color: ${e.backgroundColor} !important;`:""}\n      ${(null==e?void 0:e.transparent)?`opacity: ${e.transparent/100};`:""}\n      ${(null==e?void 0:e.zoom)?`transform: scale(${e.zoom/100})`:""}\n    }\n  `:"",exports.getTextEditorConfig=(t,s)=>{var d;if(!t)return;const g=t.getAttributes(i.NODE_TYPES.heading).level,c=u(o.getEditorAttributeValue(t,n.PROP_KEY.FontSize,s?"desktop":void 0)),p=u(o.getEditorAttributeValue(t,n.PROP_KEY.FontSize,s?"mobile":void 0));return{level:g?`h${g}`:r.paragraphType,fontFamily:o.getEditorAttributeValue(t,n.PROP_KEY.FontFamily),backgroundColor:o.getEditorAttributeValue(t,"backgroundColor"),color:o.getEditorAttributeValue(t,"color"),fontSize:c,mobileFontSize:p,fontWeight:o.getEditorAttributeValue(t,n.PROP_KEY.FontWeight),letterSpacing:e.removeUnit(o.getEditorAttributeValue(t,n.PROP_KEY.LetterSpacing,s?"desktop":void 0)),mobileLetterSpacing:e.removeUnit(o.getEditorAttributeValue(t,n.PROP_KEY.LetterSpacing,s?"mobile":void 0)),lineHeight:a(o.getEditorAttributeValue(t,n.PROP_KEY.LineHeight,s?"desktop":void 0),c),mobileLineHeight:a(o.getEditorAttributeValue(t,n.PROP_KEY.LineHeight,s?"mobile":void 0),p),bold:null==t?void 0:t.isActive("bold"),italic:null==t?void 0:t.isActive("italic"),underline:null==(d=null==t?void 0:t.isActive)?void 0:d.call(t,"underline"),strike:null==t?void 0:t.isActive("strike"),textAlign:o.getEditorAttributeValue(t,n.PROP_KEY.TextAlign,s?"desktop":void 0),mobileTextAlign:o.getEditorAttributeValue(t,n.PROP_KEY.TextAlign,s?"mobile":void 0),listType:l.find((e=>t.isActive(e))),textTransform:o.getEditorAttributeValue(t,"textTransform"),fontVariant:o.getEditorAttributeValue(t,"fontVariant"),link:t.getAttributes("link")||{}}};


/***/ }),

/***/ 596221:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.DEFAULT_POPUP_V1={maskClosable:!0,maskStyle:{backgroundColor:"rgba(0, 0, 0, 0.2)"},commonStyle:{width:400,backgroundColor:"#fff",padding:{left:16,right:16,bottom:16,top:16}},position:"default",zIndex:1050,closeIcon:{size:18},displayOncePerSession:!1},exports.WAITING_FOR_DISABLED_POPUP=5e3;


/***/ }),

/***/ 705478:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(561261),e=__webpack_require__(212951),n=__webpack_require__(143599),o=__webpack_require__(85097),i=__webpack_require__(877084),r=__webpack_require__(891987),l=__webpack_require__(926759),s=__webpack_require__(596221),a=__webpack_require__(628912);function c(t){return t&&"object"==typeof t&&"default"in t?t:{default:t}}var d=c(e),u=c(i),p=c(r),m=c(l),g=Object.defineProperty,v=Object.defineProperties,f=Object.getOwnPropertyDescriptors,h=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,y=Object.prototype.propertyIsEnumerable,w=(t,e,n)=>e in t?g(t,e,{enumerable:!0,configurable:!0,writable:!0,value:n}):t[e]=n,x=(t,e)=>{for(var n in e||(e={}))b.call(e,n)&&w(t,n,e[n]);if(h)for(var n of h(e))y.call(e,n)&&w(t,n,e[n]);return t},C=(t,e)=>v(t,f(e)),S=(t,e)=>{var n={};for(var o in t)b.call(t,o)&&e.indexOf(o)<0&&(n[o]=t[o]);if(null!=t&&h)for(var o of h(t))e.indexOf(o)<0&&y.call(t,o)&&(n[o]=t[o]);return n};const P=p.default.forwardRef(((e,i)=>{var l;const c=e,{maskStyle:d,position:p,children:g,show:v,onFinishClose:f,displayOnVisitPage:h,delay:b,isEditorMode:y,displayOnScrollTo:w,displayOnExitPage:P,showCloseIcon:E,event:I,closeIconWrapperStyle:L,allowCloseOnEscPressed:O,zIndex:q,editorModeZIndex:M,className:z,displayOncePerSession:B=!1,id:N,dataUniqId:_,customCss:A,customRenderBackdrop:T,customConditionShowMainPopup:V,customContent:D,responsive:W}=c,F=S(c,["maskStyle","position","children","show","onFinishClose","displayOnVisitPage","delay","isEditorMode","displayOnScrollTo","displayOnExitPage","showCloseIcon","event","closeIconWrapperStyle","allowCloseOnEscPressed","zIndex","editorModeZIndex","className","displayOncePerSession","id","dataUniqId","customCss","customRenderBackdrop","customConditionShowMainPopup","customContent","responsive"]),{device:G}=o.useStore(),U=o.getPropsByDevice(F,G),{commonStyle:H,closeIcon:Z}=U,J=S(U,["commonStyle","closeIcon"]),K=r.useRef(null);r.useEffect((()=>{var t,e;K.current=null==(e=(null==(t=null==document?void 0:document.getElementById(o.TEMPI_MAIN_IFRAME))?void 0:t.contentDocument)||document)?void 0:e.body}),[]);const[Q,X]=r.useState(!1),[Y,tt]=r.useState(!1),[et,nt]=r.useState(!1),ot=r.useRef(null),[it,rt]=r.useState(!1),{trackingEventName:lt,conversionGGAdsId:st,conversionGGAdsLabel:at,scriptCustom:ct}=I||{},dt=r.useCallback((()=>{ut(!0),nt(!0)}),[]),ut=(t=!1)=>{if(B){const e=`is-disabled-popup-v1-${t?"exit":"visit"}-${N}`,n=sessionStorage.getItem(e);y||n||(gt(),setTimeout((()=>{sessionStorage.setItem(e,"true")}),s.WAITING_FOR_DISABLED_POPUP))}else gt()};r.useEffect((()=>{let t;return h&&!y&&(t=setTimeout((()=>ut()),1e3*b)),()=>{clearTimeout(t)}}),[h,b,y]),r.useEffect((()=>{!y&&P&&(et?document.body.removeEventListener("mouseleave",dt):document.body.addEventListener("mouseleave",dt))}),[et]);const pt=r.useCallback((()=>{var t,e;const n=document.getElementById(w),o=null==n?void 0:n.getBoundingClientRect();!Q&&o&&o.top>=0&&o.left>=0&&o.bottom<=((null==window?void 0:window.innerHeight)||(null==(t=null==document?void 0:document.documentElement)?void 0:t.clientHeight))&&o.right<=((null==window?void 0:window.innerWidth)||(null==(e=null==document?void 0:document.documentElement)?void 0:e.clientWidth))&&(gt(),tt(!0))}),[]);r.useEffect((()=>(Y?document.removeEventListener("scroll",pt):document.addEventListener("scroll",pt),()=>{document.removeEventListener("scroll",pt)})),[Y]);const mt=t=>{X(t)},gt=()=>{mt(!0),vt()},vt=()=>{var t,e,n,o;lt&&(null==(t=null==window?void 0:window.gtag)||t.call(window,"event",lt),null==(e=null==window?void 0:window.fbq)||e.call(window,"trackCustom",lt),null==(n=null==window?void 0:window.track)||n.call(window,"customEvent",lt)),st&&at&&(null==(o=null==window?void 0:window.gtag)||o.call(window,"event","conversion",{send_to:`AW-${st}/${at}`})),ft(ct)},ft=t=>{if(null==t?void 0:t.trim())try{new Function(o.unescapeString(t))()}catch(t){console.error(t)}},ht=()=>{mt(!1),null==f||f()};r.useEffect((()=>{Q!==v&&mt(v)}),[v]),r.useEffect((()=>{if(Q&&O&&!y){const t=t=>{27===t.keyCode&&ht()};return document.addEventListener("keydown",t),()=>{document.removeEventListener("keydown",t)}}}),[Q]),r.useEffect((()=>{rt("function"==typeof V?V(v||Q):v||Q)}),[V,v,Q]);const bt=y?M||1e3:q||1050,yt=t.jsxs(k,{className:u.default([v||Q?"show":"hide",z]),ref:ot,style:{zIndex:bt},position:p,onClick:t=>{t.stopPropagation(),t.preventDefault(),y||E||ht()},children:[T?T({handleClosePopup:ht,showPopup:Q}):t.jsx($,{maskStyle:d,style:{pointerEvents:"none"}}),t.jsxs(R,C(x({onClick:t=>{var e,n,o,i;t.stopPropagation(),Q||gt(),(null==(n=null==(e=ot.current)?void 0:e.classList)?void 0:n.contains("hide-from-btn"))&&(ht(),null==(i=null==(o=ot.current)?void 0:o.classList)||i.remove("hide-from-btn"))},ref:i,position:p,customCss:A,isShowMainPopup:it,commonStyle:H},J),{children:[it&&(null==H?void 0:H.backgroundVideo)&&t.jsx(o.BackgroundVideo,C(x({},H.backgroundVideo),{background:null==(l=H.background)?void 0:l.toString(),style:{borderRadius:null==H?void 0:H.borderRadius,zIndex:"-2"}})),E&&t.jsx(j,{style:L,onClick:()=>!y&&ht(),iconStyle:null==Z?void 0:Z.commonStyle,children:t.jsx(n.Icon,x({name:"CloseOutlined"},a.getPropsIcon({size:(null==Z?void 0:Z.size)||18,color:null==Z?void 0:Z.color})))}),t.jsx("div",{className:"popup-content",children:g}),!!D&&D]}))]});return K.current?m.default.createPortal(yt,K.current):yt})),E={topLeft:"vertical-align: top;\n            top: 0;\n            left: 0;\n            right: unset !important;\n            bottom:unset !important;",topCenter:"vertical-align: top;\n              top: 0;\n              left: unset !important;\n              right: unset !important;\n              bottom: unset !important;",topRight:"vertical-align: top;\n            top: 0;\n            left: unset !important;\n            right: 0;\n            bottom: unset !important;",centerLeft:"vertical-align: middle;\n              top: unset !important;\n              left: 0;\n              right: unset !important;\n              bottom: unset !important;",centerRight:"vertical-align: middle;\n                top: unset !important;\n                left: unset !important;\n                right: 0;\n                bottom: unset !important;",bottomLeft:"vertical-align: bottom;\n              top: unset !important;\n              left: 0;\n              right:unset !important;\n              bottom: 0;",bottomRight:"vertical-align: bottom;\n                bottom: 0;\n                right: 0;\n                top: unset !important;;\n                left: unset !important;",bottomCenter:"vertical-align: bottom;\n                top: unset !important;\n                left: unset !important;\n                right:unset !important;\n                bottom: 0;",center:"vertical-align: middle;",default:"top: 100px;\n            left: unset !important;\n            right:unset !important;\n            bottom: unset !important;\n            vertical-align: top;"},I={topLeft:"text-align: start;",topCenter:"text-align: center;",topRight:"text-align: end;",centerLeft:"text-align: start;",centerRight:"text-align: end;",bottomLeft:"text-align: start;",bottomRight:"text-align: end;",bottomCenter:"text-align: center;",center:"text-align: center",default:"text-align: center;"},L={topLeft:"vertical-align: top;",topCenter:"vertical-align: top;",topRight:"vertical-align: top;",centerLeft:"vertical-align: middle;",centerRight:"vertical-align: middle;",bottomLeft:"vertical-align: bottom;",bottomRight:"vertical-align: bottom;",bottomCenter:"vertical-align: bottom;",center:"vertical-align: middle;",default:"vertical-align: top;"},O=(t,e)=>{switch(t){case"default":default:return`\n        ${e.default}\n      `;case"topLeft":return`\n        ${e.topLeft}\n      `;case"topCenter":return`\n        ${e.topCenter}\n      `;case"topRight":return`\n        ${e.topRight}\n      `;case"centerLeft":return`\n        ${e.centerLeft}\n      `;case"centerRight":return`\n        ${e.centerRight}\n      `;case"bottomLeft":return`\n            ${e.bottomLeft}\n        `;case"bottomCenter":return`\n        ${e.bottomCenter}\n      `;case"bottomRight":return`\n        ${e.bottomRight}\n      `;case"center":return`\n        ${e.center}\n      `}},R=d.default.div((({commonStyle:t,position:e,customCss:n,isShowMainPopup:i})=>{const r=t||{},{height:l}=r,s=S(r,["height"]);return`\n    position: relative !important;\n    z-index: 1050;\n    max-width: 100%;\n    min-height: ${l||400}px;\n    height: max-content;\n    text-align: start;\n    display: inline-block;\n    opacity: ${i?1:0};\n    ${O(e,E)}\n    ${o.getStyle(s)}\n    ${null!=n?n:""}\n  `})),k=d.default.div((({position:t})=>`\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1000;\n  overflow: auto;\n  ${O(t,I)}\n  &.hide {\n    display: none;\n  }\n  &::before {\n    display: inline-block;\n    width: 0;\n    height: 100%;\n    content: '';\n    ${O(t,L)}\n  }\n  `)),$=d.default.div((({maskStyle:t})=>`\n ${o.getStyle(t)}\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 0;\n`)),j=d.default.div((({iconStyle:t})=>`\n  position: absolute;\n  right: 10px;\n  top: 8px;\n  cursor: pointer;\n  z-index: 1;\n  ${o.getStyle(t)}\n`));P.displayName="PopupV1",exports.PopupV1=P;


/***/ }),

/***/ 940315:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(891987);function r(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const o=r(__webpack_require__(212951)).default.div`
  position: absolute;
  width: 0;
  height: 0;
`,i=t.forwardRef(((t,r)=>{const{children:i}=t;return e.jsx(e.Fragment,{children:e.jsx(o,{ref:r,children:i})})}));i.displayName="PopupRoot",exports.PopupRoot=i;


/***/ }),

/***/ 755165:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),i=__webpack_require__(891987),r=__webpack_require__(85097),n=__webpack_require__(586753),s=__webpack_require__(927322);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=o(t);const l=a.default.img`
  flex-shrink: 0;
  aspect-ratio: 1/1;
  width: calc(25% - 6px);
  margin-right: 6px;
  opacity: 0.7;
`,d=a.default.div`
  position: relative;
  width: 100%;
  overflow: hidden;
`,c=a.default.div`
  display: flex;
  transition: transform 0.5s ease-in-out;
`,u=a.default.div`
  width: 100%;
  min-height: 330px;
`,m=a.default.div((({disable:e})=>`\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #fff;\n  background-color: #ccc;\n  padding: 10px 0;\n  ${e?"cursor: not-allowed;":"cursor: pointer;"}\n  z-index: 1061;\n`));exports.ImageSlider=({images:t=[],imageStyle:o={},thumbnailConfig:a={}})=>{const{borderColor:f}=a,p=t.length,[x,h]=i.useState(0),[j,g]=i.useState(0);return i.useEffect((()=>{h(0),g(0)}),[t]),e.jsxs("div",{style:{width:"100%"},children:[e.jsx(d,{children:e.jsx(u,{children:e.jsx(r.PreviewGroupProvider,{images:t.map((e=>({src:e,alt:""}))),children:e.jsx(n.Image,{src:t[x],alt:"",commonStyle:o,zoomPreview:!0,aspectRatio:"1/1",objectFit:r.ImageObjectFit.Contain},x)})})}),e.jsxs(d,{style:{marginTop:10},children:[p>4&&e.jsxs(e.Fragment,{children:[e.jsx(m,{style:{left:0},onClick:()=>{g((e=>e-1<0?p-4:e-1))},children:e.jsx(s.PbIcon,{name:"LeftOutlined",size:20})}),e.jsx(m,{style:{right:0},onClick:()=>{g((e=>e+4>=p?0:e+1))},children:e.jsx(s.PbIcon,{name:"RightOutlined",size:20})})]}),e.jsx(c,{style:{transform:`translateX(-${25*j}%)`},children:t.map(((t,i)=>e.jsx(l,{src:t,alt:"",style:x===i?{opacity:1,border:`${f||"#7367f0"} 2px solid`,width:"25%"}:{},onClick:()=>(e=>{h(e),0!==e&&e===j&&g(e-1),e!==p-1&&e===j+4-1&&g((e=>e+1))})(i)},i)))})]})]})};


/***/ }),

/***/ 988130:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),i=__webpack_require__(800886),r=__webpack_require__(681084),o=__webpack_require__(800656),l=__webpack_require__(318610),n=__webpack_require__(840424),a=__webpack_require__(134166);function d(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=d(t);const u=c.default.div((({numberItemPerRow:e})=>`\n  position: relative;\n  width: calc(${100/e}% - 10px);\n  flex-shrink: 0;\n  margin-right: 10px;\n  border: 1px solid #bbb6;\n  border-radius: 3px;\n  cursor: pointer;\n`)),s=c.default.div`
  padding: 10px;
`,p=c.default.img`
  aspect-ratio: 1/1;
  width: 100%;
  object-fit: cover;
`,f=c.default.div`
  position: absolute;
  top: 4px;
  right: 8px;
  z-index: 1;
`,m=c.default.span`
  padding: 0 4px;
  color: #ffffff;
  background-color: #e40303;
  font-weight: 700;
  border-radius: 2px;
`,x=c.default(n.Paragraph)`
  font-size: 14px;
  font-weight: 700;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  height: 2lh;
  color: #000000;
  margin-top: 10px;
`,y=c.default(n.Paragraph)`
  font-weight: 700;
  font-size: 14px;
  // margin-top: 5px;
`,v=c.default.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`,g=c.default(n.Paragraph)`
  font-weight: 400;
  font-size: 12px;
`;exports.Product=({product:t,numberItemPerRow:n,fields:d,fieldsStyle:c,isEditorMode:h})=>{const{setSelectedProduct:b}=l.useSelectedProduct(),{images:j,name:P,price:F,discount:S,virtualSold:w,virtualRating:$}=t,{discountStyleByDevice:k,nameStyleByDevice:q,priceStyleByDevice:R,virtualSoldStyleByDevice:T}=c,_=()=>{const t=Intl.NumberFormat("en-US",{notation:"compact",maximumFractionDigits:1}).format(w);return e.jsx(g,{commonStyle:{color:T.color,fontFamily:T.fontFamily},text:`${o.translate("product_list.sold")} ${t}`})};return e.jsxs(u,{numberItemPerRow:n,onClick:()=>{h||b(t)},children:[j&&(null==(D=null==d?void 0:d.find((e=>(null==e?void 0:e.type)===i.ProductFieldType.Image)))?void 0:D.isActive)?e.jsx(p,{src:j[0],alt:""}):null,(()=>{var t;return S&&(null==(t=null==d?void 0:d.find((e=>(null==e?void 0:e.type)===i.ProductFieldType.Discount)))?void 0:t.isActive)?e.jsx(f,{children:e.jsx(m,{style:{color:null==k?void 0:k.color,backgroundColor:null==k?void 0:k.backgroundColor,fontFamily:null==k?void 0:k.fontFamily},children:`-${S}%`})}):null})(),e.jsx(s,{children:null==d?void 0:d.filter((e=>e.isActive)).map(((t,o)=>{switch(null==t?void 0:t.type){case i.ProductFieldType.Name:return e.jsx(x,{commonStyle:{color:q.color,fontFamily:q.fontFamily},text:P},`${t.type}-${o}`);case i.ProductFieldType.Price:return e.jsx("div",{children:(!!F||0===F)&&e.jsx(y,{commonStyle:{color:R.color,fontFamily:R.fontFamily},text:r.getPriceText(F,"đ","right")})},`${t.type}-${o}`);case i.ProductFieldType.VirtualRating:return $>0?e.jsx(v,{className:"detail-card__extra",children:e.jsx(a.Rating,{style:{fontSize:20},value:$,disabled:!0})},`${t.type}-${o}`):null;case i.ProductFieldType.VirtualSold:return w>0?e.jsx(v,{className:"detail-card__extra",children:_()},`${t.type}-${o}`):null}}))})]});var D};


/***/ }),

/***/ 126344:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(891987),o=__webpack_require__(154407),n=__webpack_require__(139720),i=__webpack_require__(800886),s=__webpack_require__(988130),a=__webpack_require__(740295),l=__webpack_require__(105122),d=__webpack_require__(927322);function u(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=u(t),p=Object.defineProperty,f=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,j=(e,t,r)=>t in e?p(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r;const x=c.default.div`
  padding: 24px;
`,v=c.default.div`
  position: relative;
  width: 100%;
  overflow: hidden;
`,g=c.default.div`
  display: flex;
  transition: transform 0.5s ease-in-out;
`,P=c.default.div((({disable:e})=>`\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #fff;\n  background-color: #ccc;\n  padding: 10px;\n  ${e?"cursor: not-allowed;":"cursor: pointer;"}\n  z-index: 1061;\n`));exports.RelatedProducts=t=>{const u=t,{contentType:c,numberItemPerRow:p=4,categoryId:T,customRelatedProductsTitleEditor:b,relatedProductsTitle:h}=u,O=((e,t)=>{var r={};for(var o in e)y.call(e,o)&&t.indexOf(o)<0&&(r[o]=e[o]);if(null!=e&&f)for(var o of f(e))t.indexOf(o)<0&&m.call(e,o)&&(r[o]=e[o]);return r})(u,["contentType","numberItemPerRow","categoryId","customRelatedProductsTitleEditor","relatedProductsTitle"]),[q,R]=r.useState(0),{products:w,loading:I}=o.useProducts({filterType:c===n.RelatedProductsContentType.SameCategory?i.ProductFilterType.CATEGORY:void 0,categoryId:c===n.RelatedProductsContentType.SameCategory?+T:void 0,ssrData:[]}),C=(null==w?void 0:w.length)||0;return r.useEffect((()=>{R(0)}),[T,p,c]),e.jsxs(x,{children:[e.jsx("div",{style:{fontSize:16,fontWeight:700,fontFamily:"var(--tempi-global-heading1fontfamily)"},children:b||e.jsx(a.TipTapTextDisplay,{text:h||"Các sản phẩm liên quan"})}),I?e.jsx(l.Loading,{customHeight:160}):e.jsxs(v,{style:{marginTop:10},children:[C>p&&e.jsxs(e.Fragment,{children:[e.jsx(P,{style:{left:0},onClick:()=>{R((e=>e-p<0?0===e?C-p:0:e-p))},children:e.jsx(d.PbIcon,{name:"LeftOutlined",size:20})}),e.jsx(P,{style:{right:10},onClick:()=>{R((e=>e+2*p>=C?e===C-p?0:C-p:e+p))},children:e.jsx(d.PbIcon,{name:"RightOutlined",size:20})})]}),e.jsx(g,{style:{transform:`translateX(-${100/p*q}%)`},children:null==w?void 0:w.map(((t,r)=>e.jsx(s.Product,((e,t)=>{for(var r in t||(t={}))y.call(t,r)&&j(e,r,t[r]);if(f)for(var r of f(t))m.call(t,r)&&j(e,r,t[r]);return e})({product:t,numberItemPerRow:p},O),r)))})]})]})};


/***/ }),

/***/ 139720:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(29789),o=__webpack_require__(800886),a=Object.defineProperty,i=Object.defineProperties,r=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,l=Object.prototype.hasOwnProperty,n=Object.prototype.propertyIsEnumerable,s=(e,t,o)=>t in e?a(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o,d=(e,t)=>{for(var o in t||(t={}))l.call(t,o)&&s(e,o,t[o]);if(p)for(var o of p(t))n.call(t,o)&&s(e,o,t[o]);return e},h=(e,t)=>i(e,r(t)),g=(e=>(e.HORIZONTAL="horizontal",e.VERTICAL="vertical",e))(g||{}),c=(e=>(e.SameCategory="same_category",e.Newest="newest",e))(c||{});const u={icon:{name:"CartPlusOutlined",size:18,color:"#7367f0"},spacing:4,position:"left"},f=[{type:o.ProductActionButtonType.AddToCart,name:"Thêm vào giỏ",text:"Thêm vào giỏ",buttonStyle:{borderStyle:"solid",borderColor:"#7367f0",borderWidth:1,height:32,width:"100%",borderRadius:2,color:"#7367f0",background:"#ffffff",padding:{left:15,right:15},fontSize:14,fontWeight:"400"},layout:o.ProductActionButtonLayout.Combined,iconConfig:u},{type:o.ProductActionButtonType.Order,name:"Mua ngay",text:"Mua ngay",buttonStyle:{borderStyle:"solid",borderColor:"#7367f0",borderWidth:1,height:32,width:"100%",borderRadius:2,color:"#ffffff",background:"#7367f0",padding:{left:15,right:15},fontSize:14},layout:o.ProductActionButtonLayout.Text,iconConfig:u}],m=[{name:"product_detail_popup_fields.image",type:o.ProductFieldType.Image,isActive:!0},{name:"product_detail_popup_fields.discount",type:o.ProductFieldType.Discount,isActive:!0},{name:"product_detail_popup_fields.virtual_rating",type:o.ProductFieldType.VirtualRating,isActive:!0},{name:"product_detail_popup_fields.name",type:o.ProductFieldType.Name,isActive:!0},{name:"product_detail_popup_fields.price",type:o.ProductFieldType.Price,isActive:!0},{name:"product_detail_popup_fields.virtual_sold",type:o.ProductFieldType.VirtualSold,isActive:!0},{name:"product_detail_popup_fields.action_button",type:o.ProductFieldType.ActionButton,isActive:!0},{name:"product_detail_popup_fields.description",type:o.ProductFieldType.Description,isActive:!0}],y={show:!1,contentType:"same_category",numberItemPerRow:4,fields:[{name:"product_detail_popup_fields.image",type:o.ProductFieldType.Image,isActive:!0},{name:"product_detail_popup_fields.discount",type:o.ProductFieldType.Discount,isActive:!0},{name:"product_detail_popup_fields.name",type:o.ProductFieldType.Name,isActive:!0},{name:"product_detail_popup_fields.price",type:o.ProductFieldType.Price,isActive:!0},{name:"product_detail_popup_fields.virtual_rating",type:o.ProductFieldType.VirtualRating,isActive:!0},{name:"product_detail_popup_fields.virtual_sold",type:o.ProductFieldType.VirtualSold,isActive:!0}]},b={layout:"horizontal",imageThumbnailConfig:{borderColor:"#7367f0"},imageStyle:{borderRadius:8},nameStyle:{color:"#000000",fontSize:24,fontWeight:"700"},priceStyle:{color:"#5B8AFF",fontSize:20,fontWeight:"700"},discountStyle:{color:"#fff",backgroundColor:"#e40303",fontSize:14,fontWeight:"400"},virtualSoldStyle:{color:"#000",fontSize:14,fontWeight:"400"},descriptionStyle:{color:"#000",fontSize:14,fontWeight:"400"},fields:m,actionButtons:f,relatedProducts:y},S={layout:"vertical",imageStyle:{borderRadius:8},nameStyle:{fontSize:20},priceStyle:{fontSize:16},discountStyle:{fontSize:12,fontWeight:"400"},virtualSoldStyle:{fontSize:12,fontWeight:"400"},descriptionStyle:{fontSize:12,fontWeight:"400"},actionButtons:f.map((()=>({})))},v={title:"<p>Chi tiết sản phẩm</p>",relatedProductsTitle:"<p>Các sản phẩm liên quan</p>",description:"<strong>Mô tả sản phẩm</strong>"},w={".r63nrhof":{id:".r63nrhof",parentId:"ROOT",tag:"productdetailpopup",resolvedName:"ProductDetailPopupEditor",style:{backgroundColor:"#fff",padding:{left:0,right:0,bottom:0,top:0}},isCanvas:!0,customAttributes:{productdetailpopup:{desktop:b,mobile:S,responsive:{hiddenXs:!1,hiddenMd:!1},maskClosable:!0,maskStyle:{backgroundColor:"rgba(0, 0, 0, 0.4)"},position:"default",zIndex:1040,editorModeZIndex:999,closeIcon:{size:18},customText:v,displayOncePerSession:!1,name:".r63nrhof",showCloseIcon:!0,hiddenDelete:!0,hiddenDuplicate:!0}},children:[]}},_=[h(d({},f[0]),{buttonStyle:h(d({},f[0].buttonStyle),{currentParagraphTheme:"paragraph2",fontFamily:"var(--tempi-global-paragraph2fontfamily)",fontSize:"var(--tempi-global-paragraph2fontsize)",fontWeight:"var(--tempi-global-paragraph2fontweight)",letterSpacing:"var(--tempi-global-paragraph2letterspacing)",lineHeight:"var(--tempi-global-paragraph2lineheight)"})}),h(d({},f[1]),{buttonStyle:h(d({},f[1].buttonStyle),{currentParagraphTheme:"paragraph2",fontFamily:"var(--tempi-global-paragraph2fontfamily)",fontSize:"var(--tempi-global-paragraph2fontsize)",fontWeight:"var(--tempi-global-paragraph2fontweight)",letterSpacing:"var(--tempi-global-paragraph2letterspacing)",lineHeight:"var(--tempi-global-paragraph2lineheight)"})})],A=h(d({},b),{nameStyle:h(d({},b.nameStyle),{fontFamily:"var(--tempi-global-paragraph1fontfamily)"}),priceStyle:h(d({},b.priceStyle),{fontFamily:"var(--tempi-global-paragraph1fontfamily)"}),discountStyle:h(d({},b.discountStyle),{fontFamily:"var(--tempi-global-paragraph3fontfamily)",fontSize:"var(--tempi-global-paragraph3fontsize)",fontWeight:"var(--tempi-global-paragraph3fontweight)",letterSpacing:"var(--tempi-global-paragraph3letterspacing)",lineHeight:"var(--tempi-global-paragraph3lineheight)"}),virtualSoldStyle:h(d({},b.virtualSoldStyle),{fontFamily:"var(--tempi-global-paragraph3fontfamily)",fontSize:"var(--tempi-global-paragraph3fontsize)",fontWeight:"var(--tempi-global-paragraph3fontweight)",letterSpacing:"var(--tempi-global-paragraph3letterspacing)",lineHeight:"var(--tempi-global-paragraph3lineheight)"}),descriptionStyle:h(d({},b.descriptionStyle),{fontFamily:"var(--tempi-global-paragraph2fontfamily)",fontSize:"var(--tempi-global-paragraph2fontsize)",fontWeight:"var(--tempi-global-paragraph2fontweight)",letterSpacing:"var(--tempi-global-paragraph2letterspacing)",lineHeight:"var(--tempi-global-paragraph2lineheight)"}),actionButtons:_}),T=h(d({},S),{discountStyle:h(d({},S.discountStyle),{fontSize:"var(--tempi-global-paragraph3mobilefontsize)",fontWeight:"var(--tempi-global-paragraph3mobilefontweight)",letterSpacing:"var(--tempi-global-paragraph3mobileletterspacing)",lineHeight:"var(--tempi-global-paragraph3mobilelineheight)"}),virtualSoldStyle:h(d({},S.virtualSoldStyle),{fontSize:"var(--tempi-global-paragraph3mobilefontsize)",fontWeight:"var(--tempi-global-paragraph3mobilefontweight)",letterSpacing:"var(--tempi-global-paragraph3mobileletterspacing)",lineHeight:"var(--tempi-global-paragraph3mobilelineheight)"}),descriptionStyle:h(d({},S.descriptionStyle),{fontSize:"var(--tempi-global-paragraph2mobilefontsize)",fontWeight:"var(--tempi-global-paragraph2mobilefontweight)",letterSpacing:"var(--tempi-global-paragraph2mobileletterspacing)",lineHeight:"var(--tempi-global-paragraph2mobilelineheight)"})}),C={".r63nrhof":h(d({},w[".r63nrhof"]),{customAttributes:{productdetailpopup:h(d({},w[".r63nrhof"].customAttributes.productdetailpopup),{desktop:A,mobile:T,discountStyle:{currentParagraphTheme:"paragraph3"},virtualSoldStyle:{currentParagraphTheme:"paragraph3"},descriptionStyle:{currentParagraphTheme:"paragraph2"}})}})},M=[{value:"horizontal",children:e.jsx(t.AntdCustomIcon,{name:"HorizontalLayoutOutlined",style:{fontSize:85,width:85,height:60}})},{value:"vertical",children:e.jsx(t.AntdCustomIcon,{name:"VerticalLayoutOutlined",style:{fontSize:120,width:120,height:60},width:120,height:60})}];exports.DEFAULT_ACTION_BUTTONS=f,exports.DEFAULT_ACTION_BUTTONS_THEME=_,exports.DEFAULT_CUSTOM_TEXT=v,exports.DEFAULT_ICON_CONFIG=u,exports.DEFAULT_PRODUCT_DETAIL_POPUP=w,exports.DEFAULT_PRODUCT_DETAIL_POPUP_THEME=C,exports.DEFAULT_RELATED_PRODUCTS_DESKTOP=y,exports.Layout=g,exports.MOCK_SELECTED_PRODUCT={name:"Acne Defense Cleanser Acne Defense Cleanser Acne ....",price:1e5,discount:30,images:["https://lh3.googleusercontent.com/8uLsW5MRqfvFIpoVhchpQN6CuMdj0hXZV7dOplezAJ6j6RSdymfMCNstJMhs_G8QNZaNwh60gAhFrjYfZr2wG4JmnKfwGDw=rw-w500","https://lh3.googleusercontent.com/8uLsW5MRqfvFIpoVhchpQN6CuMdj0hXZV7dOplezAJ6j6RSdymfMCNstJMhs_G8QNZaNwh60gAhFrjYfZr2wG4JmnKfwGDw=rw-w500","https://lh3.googleusercontent.com/8uLsW5MRqfvFIpoVhchpQN6CuMdj0hXZV7dOplezAJ6j6RSdymfMCNstJMhs_G8QNZaNwh60gAhFrjYfZr2wG4JmnKfwGDw=rw-w500","https://lh3.googleusercontent.com/8uLsW5MRqfvFIpoVhchpQN6CuMdj0hXZV7dOplezAJ6j6RSdymfMCNstJMhs_G8QNZaNwh60gAhFrjYfZr2wG4JmnKfwGDw=rw-w500","https://lh3.googleusercontent.com/8uLsW5MRqfvFIpoVhchpQN6CuMdj0hXZV7dOplezAJ6j6RSdymfMCNstJMhs_G8QNZaNwh60gAhFrjYfZr2wG4JmnKfwGDw=rw-w500","https://lh3.googleusercontent.com/8uLsW5MRqfvFIpoVhchpQN6CuMdj0hXZV7dOplezAJ6j6RSdymfMCNstJMhs_G8QNZaNwh60gAhFrjYfZr2wG4JmnKfwGDw=rw-w500","https://lh3.googleusercontent.com/8uLsW5MRqfvFIpoVhchpQN6CuMdj0hXZV7dOplezAJ6j6RSdymfMCNstJMhs_G8QNZaNwh60gAhFrjYfZr2wG4JmnKfwGDw=rw-w500","https://lh3.googleusercontent.com/8uLsW5MRqfvFIpoVhchpQN6CuMdj0hXZV7dOplezAJ6j6RSdymfMCNstJMhs_G8QNZaNwh60gAhFrjYfZr2wG4JmnKfwGDw=rw-w500","https://lh3.googleusercontent.com/8uLsW5MRqfvFIpoVhchpQN6CuMdj0hXZV7dOplezAJ6j6RSdymfMCNstJMhs_G8QNZaNwh60gAhFrjYfZr2wG4JmnKfwGDw=rw-w500"],image:{src:"https://lh3.googleusercontent.com/8uLsW5MRqfvFIpoVhchpQN6CuMdj0hXZV7dOplezAJ6j6RSdymfMCNstJMhs_G8QNZaNwh60gAhFrjYfZr2wG4JmnKfwGDw=rw-w500"},virtualRating:5,virtualSold:100,sku:"SAMPLE00001",description:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",categoryId:null},exports.RelatedProductsContentType=c,exports.productDetailLayoutOptions=M;


/***/ }),

/***/ 314413:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(891987),o=__webpack_require__(212951),r=__webpack_require__(85097),i=__webpack_require__(787045),l=__webpack_require__(681084),n=__webpack_require__(800886),d=__webpack_require__(242942),u=__webpack_require__(15161),s=__webpack_require__(139720),c=__webpack_require__(215477),a=__webpack_require__(47248),p=__webpack_require__(800656),y=__webpack_require__(760339),m=__webpack_require__(126344),P=__webpack_require__(755165),v=__webpack_require__(318610),g=__webpack_require__(512005),f=__webpack_require__(481177),x=__webpack_require__(705478),h=__webpack_require__(740295),j=__webpack_require__(840424),S=__webpack_require__(134166),T=__webpack_require__(750911);function E(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var O=E(t),b=E(o),w=E(i),R=E(c),D=E(a),_=Object.defineProperty,B=Object.defineProperties,q=Object.getOwnPropertyDescriptors,C=Object.getOwnPropertySymbols,$=Object.prototype.hasOwnProperty,K=Object.prototype.propertyIsEnumerable,A=(e,t,o)=>t in e?_(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o,F=(e,t)=>{for(var o in t||(t={}))$.call(t,o)&&A(e,o,t[o]);if(C)for(var o of C(t))K.call(t,o)&&A(e,o,t[o]);return e},Y=(e,t)=>B(e,q(t)),k=(e,t)=>{var o={};for(var r in e)$.call(e,r)&&t.indexOf(r)<0&&(o[r]=e[r]);if(null!=e&&C)for(var r of C(e))t.indexOf(r)<0&&K.call(e,r)&&(o[r]=e[r]);return o};const N=e=>{const t=document.createElement("textarea");return t.innerHTML=e,t.value},I=O.default.forwardRef(((o,i)=>{var c=o,{isEditorMode:a,children:j,show:E,allowCloseOnEscPressed:O,className:b,customCss:_,quickSetting:B,customText:q,customTextEditor:C}=c,$=k(c,["isEditorMode","children","show","allowCloseOnEscPressed","className","customCss","quickSetting","customText","customTextEditor"]);const K=t.useRef(),{selectedProduct:A,setSelectedProduct:I}=v.useSelectedProduct(),{currencyConfigMap:G}=y.useProductListStore(),J=G.get((null==$?void 0:$.id)||""),{images:Q,discount:X,name:ee,price:te,virtualRating:oe,virtualSold:re,description:ie,categoryId:le}=A||(a?s.MOCK_SELECTED_PRODUCT:{}),{customTitleEditor:ne,customRelatedProductsTitleEditor:de,customDescriptionEditor:ue}=C||{},{buyNow:se}=g.useCartStore(),{device:ce}=r.useStore(),ae=r.getPropsByDevice($,ce),{commonStyle:pe}=ae,ye=k(ae,["commonStyle"]),me=D.default($,f.PROP_KEY.joinKey("desktop",f.PROP_KEY.RelatedProducts)),Pe=D.default($,f.PROP_KEY.joinKey("mobile",f.PROP_KEY.RelatedProducts)),ve="desktop"!==ce&&Pe?R.default({},me,Pe):me,ge=u.getProductPropByDevice($,f.PROP_KEY.Fields,ce)||[],fe=D.default($,f.PROP_KEY.joinKey("desktop",f.PROP_KEY.ActionButtons))||s.DEFAULT_ACTION_BUTTONS,xe=D.default($,f.PROP_KEY.joinKey("mobile",f.PROP_KEY.ActionButtons)),he=u.getProductPropByDevice($,f.PROP_KEY.Layout,ce)===s.Layout.HORIZONTAL,je=u.getProductPropsByDeviceV2($,f.PROP_KEY.DiscountStyle,ce),Se=u.getProductPropByDevice($,f.PROP_KEY.ImageStyle,ce),Te=u.getProductPropByDevice($,f.PROP_KEY.ImageThumbnailConfig,ce),Ee=u.getProductPropsByDeviceV2($,f.PROP_KEY.VirtualSoldStyle,ce),Oe=u.getProductPropsByDeviceV2($,f.PROP_KEY.NameStyle,ce),be=u.getProductPropsByDeviceV2($,f.PROP_KEY.PriceStyle,ce),we=u.getProductPropsByDeviceV2($,f.PROP_KEY.DescriptionStyle,ce),Re=()=>{const t=Intl.NumberFormat("en-US",{notation:"compact",maximumFractionDigits:1}).format(re);return e.jsx(W,{text:`${p.translate("product_list.sold")} ${t}`,commonStyle:Ee})},De=()=>{const o=fe||[],i=o.some((e=>e.layout===n.ProductActionButtonLayout.Icon));return e.jsx(Z,{className:i?"icon-button":"",children:null==o?void 0:o.map(((o,i)=>{let l;switch(l="desktop"!==ce&&(null==xe?void 0:xe[i])?R.default({},o,xe[i]):o,l.type){case n.ProductActionButtonType.AddToCart:return e.jsx(d.AddToCartButton,{product:A,showAddToCartButton:!0,isEditingMode:a,addToCartButton:l,currencyUnit:(null==J?void 0:J.currencyUnit)||"đ",currencyAlignment:(null==J?void 0:J.currencyAlignment)||"right",layout:l.layout},`${l.name}-${i}`);case n.ProductActionButtonType.Order:return t.createElement(T.ButtonV2,Y(F({onClick:()=>{I(void 0),(e=>{var t,o;se(e),null==(o=null==(t=K.current)?void 0:t.ownerDocument.querySelector(`[data-uniq-id="${r.ORDER_POPUP}"]`))||o.click()})(A)}},l),{isEditingMode:a,key:`${l.name}-${i}`,commonStyle:{justifyContent:"center",flex:1},className:"button-width",style:{marginTop:6}}));case n.ProductActionButtonType.Contact:return e.jsx(T.ButtonV2,Y(F({},l),{commonStyle:{justifyContent:"center",flex:1},className:"button-width",style:{marginTop:6}}),`${l.name}-${i}`);default:return null}}))})};return e.jsx(x.PopupV1,Y(F({ref:i},ye),{commonStyle:F(F({},pe),"desktop"===ce?{width:800,maxWidth:"calc(100% - 80px)"}:{width:400,minWidth:"unset",maxWidth:"calc(100% - 70px)"}),onFinishClose:()=>{I(void 0)},show:a?E:!!A,isEditorMode:a,customCss:_,className:b,allowCloseOnEscPressed:O,children:e.jsxs("div",{ref:K,children:[B,e.jsx("div",{style:{fontSize:16,fontWeight:700,padding:"16px 24px",borderBottom:"1px solid #F0F0F0",fontFamily:"var(--tempi-global-heading1fontfamily)"},children:ne||e.jsx(h.TipTapTextDisplay,{text:(null==q?void 0:q.title)||"Chi tiết sản phẩm"})}),e.jsxs("div",{style:{display:he?"flex":"block",justifyContent:"space-between",padding:24},children:[e.jsxs("div",{style:{position:"relative",width:he?"42%":"100%"},children:[X&&(null==(_e=null==ge?void 0:ge.find((e=>(null==e?void 0:e.type)===n.ProductFieldType.Discount)))?void 0:_e.isActive)?e.jsx(V,{children:e.jsx(M,{commonStyle:je,children:`-${X}%`})}):null,(()=>{var t;return Q&&(null==(t=null==ge?void 0:ge.find((e=>(null==e?void 0:e.type)===n.ProductFieldType.Image)))?void 0:t.isActive)?e.jsx(P.ImageSlider,{images:Q,imageStyle:Se,thumbnailConfig:Te}):null})()]}),e.jsx("div",{style:{width:he?"54%":"100%"},children:ge.filter((e=>e.isActive)).map(((t,o)=>{switch(null==t?void 0:t.type){case n.ProductFieldType.Name:return e.jsx(L,{text:ee,commonStyle:Oe},`${t.type}-${o}`);case n.ProductFieldType.Price:return e.jsx("div",{children:(!!te||0===te)&&e.jsx(U,{text:l.getPriceText(te,(null==J?void 0:J.currencyUnit)||"đ",(null==J?void 0:J.currencyAlignment)||"right"),commonStyle:be})},`${t.type}-${o}`);case n.ProductFieldType.VirtualRating:return oe>0?e.jsx(z,{className:"detail-card__extra",children:e.jsx(S.Rating,{style:{fontSize:22},value:oe,disabled:!0})},`${t.type}-${o}`):null;case n.ProductFieldType.VirtualSold:return re>0?e.jsx(z,{className:"detail-card__extra",children:Re()},`${t.type}-${o}`):null;case n.ProductFieldType.Description:return ie?e.jsx(H,{commonStyle:we,children:e.jsxs(e.Fragment,{children:[ue||e.jsx(h.TipTapTextDisplay,{text:(null==q?void 0:q.description)||"Mô tả sản phẩm"}),e.jsx("br",{}),e.jsx("span",{dangerouslySetInnerHTML:{__html:w.default.sanitize(N(ie))}})]})},`${t.type}-${o}`):null;case n.ProductFieldType.ActionButton:return(null==fe?void 0:fe.length)?e.jsx(Z,{style:{pointerEvents:a?"none":"auto"},children:De()},`${t.type}-${o}`):null;default:return null}}))})]}),(null==ve?void 0:ve.show)&&e.jsx(m.RelatedProducts,Y(F({},ve),{categoryId:le,isEditorMode:a,customRelatedProductsTitleEditor:de,relatedProductsTitle:null==q?void 0:q.relatedProductsTitle,fieldsStyle:{discountStyleByDevice:je,nameStyleByDevice:Oe,priceStyleByDevice:be,virtualSoldStyleByDevice:Ee}}))]})}));var _e})),M=b.default.span`
  padding: 0 4px;
  color: #ffffff;
  background-color: #e40303;
  font-weight: 700;
  border-radius: 2px;
  ${e=>r.getStyle(null==e?void 0:e.commonStyle)}
`,V=b.default.div`
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1;
`,L=b.default(j.Paragraph)`
  font-size: 14px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: #000000;
  font-weight: 700;
  ${e=>r.getStyle(null==e?void 0:e.commonStyle)}
`,U=b.default(j.Paragraph)`
  font-weight: 700;
  font-size: 14px;
  margin-top: 18px;
  ${e=>r.getStyle(null==e?void 0:e.commonStyle)}
`,z=b.default.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`,W=b.default(j.Paragraph)`
  font-weight: 400;
  ${e=>r.getStyle(null==e?void 0:e.commonStyle)}
`,H=b.default(j.Paragraph)`
  margin-top: 25px;
  ${e=>r.getStyle(null==e?void 0:e.commonStyle)}
`,Z=b.default.div`
  margin-top: 15px;
  display: inline-flex;
  align-items: center;
  column-gap: 0.5em;
  row-gap: 0.5em;
  width: 100%;

  &.icon-button {
    column-gap: 0;
  }

  .button-width {
    width: fit-content;

    a {
      width: 100%;
    }
  }
`;I.displayName="ProductDetailPopup",exports.ProductDetailPopup=I;


/***/ }),

/***/ 318610:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(891987);const r=t.createContext(void 0);exports.SelectedProductProvider=({children:o})=>{const[c,d]=t.useState(),u={selectedProduct:c,setSelectedProduct:d};return e.jsx(r.Provider,{value:u,children:o})},exports.useSelectedProduct=()=>{const e=t.useContext(r);if(void 0===e)throw new Error("useSelectedProduct must be used within a SelectedProductProvider");return e};


/***/ }),

/***/ 152176:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(800656),t=__webpack_require__(707068),r=__webpack_require__(705478),i=__webpack_require__(840424),n=__webpack_require__(845589),s=__webpack_require__(750911),a=Object.defineProperty,l=Object.defineProperties,u=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,b=Object.prototype.propertyIsEnumerable,d=(e,o,t)=>o in e?a(e,o,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[o]=t;exports.CheckoutPopup=({open:a,setOpen:g,onFinish:h,loading:m})=>{return e.jsxs(r.PopupV1,(f=((e,o)=>{for(var t in o||(o={}))c.call(o,t)&&d(e,t,o[t]);if(p)for(var t of p(o))b.call(o,t)&&d(e,t,o[t]);return e})({show:a,onFinishClose:()=>!m&&g(!1)},{maskClosable:!0,showCloseIcon:!0,closeIcon:{size:24},closeIconWrapperStyle:{top:16,right:16},maskStyle:{backgroundColor:"rgba(0, 0, 0, 0.5)"},commonStyle:{borderRadius:8,width:334,backgroundColor:"#fff",padding:{left:24,right:24,bottom:16,top:16}},position:"default"}),j={children:[e.jsx(i.Paragraph,{text:o.t("Tạo đơn hàng"),commonStyle:{fontSize:16,lineHeight:"24px",fontWeight:"bold",margin:{bottom:4}}}),e.jsx(n.FormV4,{labelStyle:{margin:{top:12}},inputs:t.inputsConfig,submits:[],hiddenFields:[],showLabel:!0,onFinish:h,customLoading:m,children:e.jsx(s.ButtonV2,{text:o.t("Tạo đơn"),buttonStyle:{backgroundColor:"#7367F0",color:"rgba(255, 255, 255, 1)",height:32,width:83,borderRadius:4},commonStyle:{justifyContent:"flex-end",margin:{top:12}}})})]},l(f,u(j))));var f,j};


/***/ }),

/***/ 561618:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(800656),r=__webpack_require__(143599),o=__webpack_require__(212951),n=__webpack_require__(705478),i=__webpack_require__(484435),s=__webpack_require__(840424),a=__webpack_require__(750911);function u(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=u(o),p=Object.defineProperty,c=Object.defineProperties,d=Object.getOwnPropertyDescriptors,b=Object.getOwnPropertySymbols,g=Object.prototype.hasOwnProperty,h=Object.prototype.propertyIsEnumerable,m=(e,t,r)=>t in e?p(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,f=(e,t)=>{for(var r in t||(t={}))g.call(t,r)&&m(e,r,t[r]);if(b)for(var r of b(t))h.call(t,r)&&m(e,r,t[r]);return e},j=(e,t)=>c(e,d(t));const y=l.default.div`
  position: absolute;
  top: -60px;
  left: calc(50% - 60px);
`;exports.CheckoutSuccessPopup=({open:o,setOpen:u})=>e.jsxs(n.PopupV1,j(f({show:o,onFinishClose:()=>u(!1)},{maskClosable:!0,maskStyle:{backgroundColor:"rgba(0, 0, 0, 0.5)"},commonStyle:{borderRadius:8,width:334,backgroundColor:"#fff",height:200,padding:{left:32,right:32,bottom:32,top:32}},position:"default"}),{children:[e.jsx(y,{children:e.jsx(r.Icon,{name:"SuccessColored",style:{fontSize:120}})}),e.jsx(i.Heading,{commonStyle:{margin:{top:32},textAlign:"center"},text:`<h3>${t.t("Thành công!")}</h3>`}),e.jsx(s.Paragraph,{commonStyle:{margin:{top:12},textAlign:"center"},text:t.t("Tạo đơn hàng thành công")}),e.jsx(a.ButtonV2,j(f({},{text:`<span>${t.t("Đóng")}</span>`,commonStyle:{margin:{top:24}},buttonStyle:{backgroundColor:"#7367F0",color:"rgba(255, 255, 255, 1)",borderRadius:4,height:36,width:"100%"}}),{onClick:()=>u(!1)}))]}));


/***/ }),

/***/ 195329:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(561261),e=__webpack_require__(85097),r=__webpack_require__(681084),n=__webpack_require__(570489),o=__webpack_require__(795625),i=__webpack_require__(891987),u=__webpack_require__(521458),a=__webpack_require__(800656),l=__webpack_require__(512005),s=__webpack_require__(750911),c=Object.defineProperty,d=Object.defineProperties,p=Object.getOwnPropertyDescriptors,g=Object.getOwnPropertySymbols,m=Object.prototype.hasOwnProperty,y=Object.prototype.propertyIsEnumerable,b=(t,e,r)=>e in t?c(t,e,{enumerable:!0,configurable:!0,writable:!0,value:r}):t[e]=r,v=(t,e)=>{for(var r in e||(e={}))m.call(e,r)&&b(t,r,e[r]);if(g)for(var r of g(e))y.call(e,r)&&b(t,r,e[r]);return t},f=(t,e)=>d(t,p(e));exports.AddToCartButton=({isEditingMode:c,addToCartButton:d,showAddToCartButton:p,product:b,currencyAlignment:x,currencyUnit:h,addToCartCallback:C,layout:j=n.ProductActionButtonLayout.Text,wrapperRef:T,customCommonStyle:q})=>{const{globalData:P}=e.useStore(),{addToCart:w}=l.useCartStore(),[O,A]=i.useState(!1),B=j===n.ProductActionButtonLayout.Icon||j===n.ProductActionButtonLayout.Combined,k=j===n.ProductActionButtonLayout.Text||j===n.ProductActionButtonLayout.Combined;if(!p)return null;const{iconConfig:L,text:S}=d;return t.jsxs(t.Fragment,{children:[t.jsx(s.ButtonV2,f(v({onClick:()=>{var t;((t,e)=>{var n;const i=r.getProductsInLocalCart(t),u=e,{image:a,link:l}=u,s=((t,e)=>{var r={};for(var n in t)m.call(t,n)&&e.indexOf(n)<0&&(r[n]=t[n]);if(null!=t&&g)for(var n of g(t))e.indexOf(n)<0&&y.call(t,n)&&(r[n]=t[n]);return r})(u,["image","link"]),c=i.findIndex((t=>t.sku===e.sku));c>=0?i[c]=f(v(v({},i[c]),s),{thumbnailAlt:null==a?void 0:a.alt,thumbnailUrl:null==a?void 0:a.src,quantity:((null==(n=i[c])?void 0:n.quantity)||0)+1}):i.push(f(v({},s),{thumbnailAlt:null==a?void 0:a.alt,thumbnailUrl:null==a?void 0:a.src,quantity:1})),r.setProductsToLocalCart(t,i),o.emit("addProductToCart",i)})(null==(t=null==P?void 0:P.currentLanguage)?void 0:t.id,f(v({},b),{currencyAlignment:x,currencyUnit:h})),(()=>{var t,e;if(!(null==T?void 0:T.current))return;const r=null==(t=null==T?void 0:T.current)?void 0:t.ownerDocument,n=r.createElement("div"),o=r.querySelector(".shopping-cart");if(!o)return;const i=T.current.getBoundingClientRect(),u=o.getBoundingClientRect();n.style.cssText=`\n      position: fixed;\n      left: ${i.left}px;\n      top: ${i.top}px;\n      width: ${i.width}px;\n      height: ${i.height}px;\n      background-image: url(${(null==(e=b.image)?void 0:e.src)||""});\n      background-size: cover;\n      background-position: center;\n      border-radius: 10px;\n      box-shadow: 0 2px 15px rgba(0,0,0,0.2);\n      z-index: 9999;\n      pointer-events: none;\n      transition: all 1.5s cubic-bezier(0.19, 1, 0.22, 1);\n    `,r.body.appendChild(n),setTimeout((()=>{n.style.transform=`translate(${u.left-i.left-i.width/3}px, ${u.top-i.top-i.height/2}px) scale(0)`,n.style.opacity="0",setTimeout((()=>{r.body.removeChild(n)}),800)}),1)})(),w(b,1),null==C||C(),A(!0),setTimeout((()=>{A(!1)}),1e3)}},d),{iconConfig:f(v({},L),{show:B}),text:k?S:void 0,isEditingMode:c,commonStyle:v({justifyContent:"center",flex:k?1:void 0},q),style:{marginTop:6},className:"button-width"})),O&&t.jsx(u.ToastMessage,{message:a.translate("product_list.add_to_cart")})]})};


/***/ }),

/***/ 293949:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),i=__webpack_require__(85097),n=__webpack_require__(877084),o=__webpack_require__(681084),r=__webpack_require__(195329),l=__webpack_require__(800656),a=__webpack_require__(750911),d=__webpack_require__(319891),c=__webpack_require__(586753),s=__webpack_require__(840424),u=__webpack_require__(134166);function f(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var p=f(t),m=f(n),x=Object.defineProperty,h=Object.defineProperties,g=Object.getOwnPropertyDescriptors,y=Object.getOwnPropertySymbols,j=Object.prototype.hasOwnProperty,v=Object.prototype.propertyIsEnumerable,b=(e,t,i)=>t in e?x(e,t,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[t]=i,w=(e,t)=>{for(var i in t||(t={}))j.call(t,i)&&b(e,i,t[i]);if(y)for(var i of y(t))v.call(t,i)&&b(e,i,t[i]);return e},S=(e,t)=>h(e,g(t));const _=p.default.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: transparent;
`,k=p.default.div`
  position: relative;
  flex: 1 0 auto;

  &.allow-click {
    &:hover {
      cursor: pointer;
    }
  }
`,z=p.default.div`
  position: relative;
  margin-bottom: 4px;
`,T=p.default(c.Image)`
  display: inline-block;
  overflow: hidden;
  position: absolute;
  height: 100%;
  inset: 0;
`,q=p.default.div`
  &.detail-card.left {
    .detail-card__name {
      text-align: left;
    }
    .detail-card__price,
    .detail-card__extra {
      justify-content: flex-start;
    }
  }
  &.detail-card.center {
    .detail-card__name {
      text-align: center;
    }
    .detail-card__price,
    .detail-card__extra {
      justify-content: center;
    }
  }
  &.detail-card.right {
    .detail-card__name {
      text-align: right;
    }
    .detail-card__price,
    .detail-card__extra {
      justify-content: flex-end;
    }
  }
`,C=p.default(s.Paragraph)`
  font-size: 14px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: #000000;
  font-weight: 700;
  ${e=>i.getStyle(null==e?void 0:e.commonStyle)}
`,O=p.default.div`
  display: flex;
`,P=p.default(s.Paragraph)`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  ${e=>i.getStyle(null==e?void 0:e.commonStyle)}
`,B=p.default.div`
  margin-left: 8px;
`,N=p.default.span((({fontSize:e=10})=>`\npadding: 0 4px;\ncolor: #ffffff;\nbackground-color: #e40303;\nfont-size: ${e}px;\nline-height: 14px;\nfont-weight: 700;\nborder-radius: 2px;\n`)),$=p.default.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`,A=p.default(s.Paragraph)((({fontSize:e=13})=>`\nfont-weight: 400;\nfont-size: ${e}px;\nline-height: 22px;\n`)),L=p.default.div`
  display: inline-flex;
  align-items: center;
  column-gap: 0.5em;
  row-gap: 0.5em;
  width: 100%;
  justify-content: center;
  .button-width {
    width: fit-content;
  }
`;exports.ProductCard=({product:t,nameStyle:n,priceStyle:c,alignment:s,onClick:f,isEditingMode:p=!1,currencyUnit:x,currencyAlignment:h,orderButton:g,buttonLink:y,showButton:j,mobile:v,desktop:b,showAddToCartButton:E,addToCartButton:M})=>{var R,F;const I="function"==typeof f,{name:U,discount:D,price:V,image:G,link:H,virtualSold:J,virtualRating:K}=t,{device:Q}=i.useStore(),W="mobile"===Q?v:b,X=S(w({},n),{fontSize:(null==(R=null==W?void 0:W.nameStyle)?void 0:R.fontSize)||(null==n?void 0:n.fontSize)}),Y=S(w({},c),{fontSize:(null==(F=null==W?void 0:W.priceStyle)?void 0:F.fontSize)||(null==c?void 0:c.fontSize)}),Z=()=>{I&&f(t)},ee=()=>{const t=Intl.NumberFormat("en-US",{notation:"compact",maximumFractionDigits:1}).format(J);return e.jsx(A,{text:`${l.translate("product_list.sold")} ${t}`,fontSize:+(null==Y?void 0:Y.fontSize)-1})},te=e.jsx(z,{children:e.jsx("div",{style:{position:"relative",paddingBottom:"100%"},children:e.jsx(T,w({commonStyle:{objectFit:"contain",height:"100%",width:"100%"},autoOptimize:!0},G))})}),ie=e.jsx(a.ButtonV2,S(w({onClick:I&&!p?Z:null},g),{isEditingMode:p,commonStyle:{justifyContent:"center"},style:{marginTop:6},className:"button-width"})),ne=()=>e.jsxs(k,{className:m.default({"allow-click":I}),children:[p||!j?te:e.jsx(d.Link,S(w({},{eventType:"link",link:{openNewTab:!0,nofollow:!0,href:H}}),{children:te})),e.jsxs(q,{className:m.default("detail-card",s),children:[e.jsx(C,{className:"detail-card__name",text:U,commonStyle:X}),e.jsxs(O,{className:"detail-card__price",children:[(!!V||0===V)&&e.jsx(P,{text:o.getPriceText(V,x,h),commonStyle:Y}),!!D&&e.jsx(B,{children:e.jsx(N,{fontSize:+(null==Y?void 0:Y.fontSize)-4,children:`-${D}%`})})]}),(K>0||J>0)&&e.jsxs($,{className:"detail-card__extra",children:[K>0&&e.jsx(u.Rating,{style:{fontSize:(null==Y?void 0:Y.fontSize)||14},value:K,disabled:!0}),J>0&&ee()]})]}),e.jsxs(L,{children:[j?I||p?ie:e.jsx(d.Link,S(w({},{eventType:"link",link:{openNewTab:!0,nofollow:!0,href:y}}),{children:ie})):null,e.jsx(r.AddToCartButton,{product:t,showAddToCartButton:E,isEditingMode:p,addToCartButton:M,currencyUnit:x,currencyAlignment:h,customCommonStyle:{flex:void 0}})]})]});return p||j?e.jsx(_,{children:ne()}):I?e.jsx(_,{onClick:Z,children:ne()}):e.jsx(d.Link,S(w({},{eventType:"link",link:{openNewTab:!0,nofollow:!0,href:H}}),{children:e.jsx(_,{children:ne()})}))};


/***/ }),

/***/ 521458:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097),o=__webpack_require__(143599),n=__webpack_require__(891987),a=__webpack_require__(926759);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const i=s(t).default.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.6);
  padding: 12px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 10000;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #ffffff;
  pointer-events: none;
  flex-direction: column;
  animation: fadeIn 0.2s, fadeOut 0.2s 2.8s;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translate(-50%, -40%);
    }
    to {
      opacity: 1;
      transform: translate(-50%, -50%);
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
      transform: translate(-50%, -50%);
    }
    to {
      opacity: 0;
      transform: translate(-50%, -40%);
    }
  }
`;exports.ToastMessage=({message:t})=>{var s,u;const[c,f]=n.useState(!0);if(n.useEffect((()=>{const e=setTimeout((()=>{f(!1)}),3e3);return()=>clearTimeout(e)}),[]),!c)return null;const d=e.jsxs(i,{children:[e.jsx(o.Icon,{name:"SuccessColored",style:{fontSize:72}}),t]});return a.createPortal(d,null==(u=(null==(s=null==document?void 0:document.getElementById(r.TEMPI_MAIN_IFRAME))?void 0:s.contentDocument)||document)?void 0:u.body)};


/***/ }),

/***/ 279325:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(85097),i=__webpack_require__(707068),o=__webpack_require__(822622),t=__webpack_require__(293949),s=__webpack_require__(481177),l=__webpack_require__(115741),u=Object.defineProperty,d=Object.defineProperties,a=Object.getOwnPropertyDescriptors,n=Object.getOwnPropertySymbols,P=Object.prototype.hasOwnProperty,c=Object.prototype.propertyIsEnumerable,p=(e,r,i)=>r in e?u(e,r,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[r]=i,O=(e,r)=>{for(var i in r||(r={}))P.call(r,i)&&p(e,i,r[i]);if(n)for(var i of n(r))c.call(r,i)&&p(e,i,r[i]);return e};exports.ProductCarousel=u=>{const p=u,{items:j=[],carouselOptions:b,layout:f,isEditingMode:y}=p,v=((e,r)=>{var i={};for(var o in e)P.call(e,o)&&r.indexOf(o)<0&&(i[o]=e[o]);if(null!=e&&n)for(var o of n(e))r.indexOf(o)<0&&c.call(e,o)&&(i[o]=e[o]);return i})(p,["items","carouselOptions","layout","isEditingMode"]),{device:K}=r.useStore(),m=o.getProductPropByDevice(u,s.PROP_KEY.joinKey(s.PROP_KEY.CarouselOptions,s.PROP_KEY.SlidesPerView),"desktop",i.defaultCarouselOptions.slidesPerView),E=o.getProductPropByDevice(u,s.PROP_KEY.joinKey(s.PROP_KEY.CarouselOptions,s.PROP_KEY.SlidesPerView),"mobile",i.defaultMobileCarouselOptions.slidesPerView),w="mobile"===K?E:m,C=o.getProductPropByDevice(u,s.PROP_KEY.joinKey(s.PROP_KEY.CarouselOptions,s.PROP_KEY.Speed),K,("mobile"===K?i.defaultMobileCarouselOptions:i.defaultCarouselOptions).speed);return e.jsx(l.DSSlider,(_=O({},b),R={speed:C,slidesPerView:w,slidesPerViewMobile:2.5,allowTouchMove:!y,children:j.map(((i,o)=>e.jsx(r.BreakpointWidthProvider,{sWidth:{value:100/E,unit:"%"},mWidth:{value:100/m,unit:"%"},children:e.jsx(t.ProductCard,O({product:i},v))},o)))},d(_,a(R))));var _,R};


/***/ }),

/***/ 46558:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),i=__webpack_require__(85097),t=__webpack_require__(891987),o=__webpack_require__(707068),n=__webpack_require__(570489),s=__webpack_require__(822622),d=__webpack_require__(541076),a=__webpack_require__(481177),l=__webpack_require__(293949);function u(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var P=u(r),c=Object.defineProperty,p=Object.getOwnPropertySymbols,O=Object.prototype.hasOwnProperty,y=Object.prototype.propertyIsEnumerable,g=(e,r,i)=>r in e?c(e,r,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[r]=i,f=(e,r)=>{for(var i in r||(r={}))O.call(r,i)&&g(e,i,r[i]);if(p)for(var i of p(r))y.call(r,i)&&g(e,i,r[i]);return e};const j=P.default.div`
  display: grid;
  align-self: stretch;
  gap: ${16}px;
`;exports.ProductGrid=r=>{const u=r,{items:P=[],gridOptions:c,layout:g,isEditingMode:m}=u,K=((e,r)=>{var i={};for(var t in e)O.call(e,t)&&r.indexOf(t)<0&&(i[t]=e[t]);if(null!=e&&p)for(var t of p(e))r.indexOf(t)<0&&y.call(e,t)&&(i[t]=e[t]);return i})(u,["items","gridOptions","layout","isEditingMode"]),[v,E]=t.useState(1),{device:b}=i.useStore(),R=s.getProductPropByDevice(r,a.PROP_KEY.joinKey(a.PROP_KEY.GridOptions,a.PROP_KEY.DisplayMode),b),_=s.getProductPropByDevice(r,a.PROP_KEY.joinKey(a.PROP_KEY.GridOptions,a.PROP_KEY.Columns),"desktop",o.defaultGridOptions.columns),Y=s.getProductPropByDevice(r,a.PROP_KEY.joinKey(a.PROP_KEY.GridOptions,a.PROP_KEY.Columns),"mobile",o.defaultMobileGridOptions.columns),h=s.getProductPropByDevice(r,a.PROP_KEY.joinKey(a.PROP_KEY.GridOptions,a.PROP_KEY.Rows),"desktop",o.defaultGridOptions.rows),x=s.getProductPropByDevice(r,a.PROP_KEY.joinKey(a.PROP_KEY.GridOptions,a.PROP_KEY.Rows),"mobile",o.defaultMobileGridOptions.rows),M="mobile"===b?Y:_,q=M*("mobile"===b?x:h),G=R===n.DisplayModeType.Pagination,C=t.useMemo((()=>G?P.slice((v-1)*q,v*q):P),[P,q,v,G]);return e.jsxs(e.Fragment,{children:[e.jsx(j,{style:{gridTemplateColumns:`repeat(${M}, minmax(0, 1fr))`},children:C.map(((r,t)=>e.jsx("div",{children:e.jsx(i.BreakpointWidthProvider,{sWidth:{value:100/Y,unit:"%"},mWidth:{value:100/_,unit:"%"},children:e.jsx(l.ProductCard,f({product:r,isEditingMode:m},K))})},t)))}),G&&!!P.length&&e.jsx(d.Pagination,{isEditingMode:m,onPageChange:({selected:e})=>E(e+1),pageCount:Math.ceil(P.length/q)})]})};


/***/ }),

/***/ 707068:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(800656),t=__webpack_require__(570489),o=__webpack_require__(281586),r=Object.defineProperty,n=Object.defineProperties,i=Object.getOwnPropertyDescriptors,l=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,s=Object.prototype.propertyIsEnumerable,a=(e,t,o)=>t in e?r(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o,c=(e,t)=>{for(var o in t||(t={}))p.call(t,o)&&a(e,o,t[o]);if(l)for(var o of l(t))s.call(t,o)&&a(e,o,t[o]);return e},d=(e,t)=>n(e,i(t));e.t("Sản phẩm mới");const u={displayMode:t.DisplayModeType.All,rows:1,columns:4},h={displayMode:t.DisplayModeType.All,rows:1,columns:2},g={type:o.SliderTypeEnum.product,slidesPerView:5,slidesPerColumn:1,navigation:!0,navigationStyle:1,autoplay:!0,loop:!1,spaceBetween:16,speed:3e3},m={type:o.SliderTypeEnum.product,slidesPerView:2.5,slidesPerColumn:1,navigation:!0,navigationStyle:1,autoplay:!0,loop:!1,spaceBetween:16,speed:3e3},y={icon:{name:"CartPlusOutlined",size:18,color:"#7367f0"},spacing:4,position:"left"},f=[{type:t.ProductActionButtonType.AddToCart,name:"Thêm vào giỏ",text:"Thêm vào giỏ",buttonStyle:{borderStyle:"solid",borderColor:"#7367f0",borderWidth:0,height:32,width:"100%",borderRadius:2,color:"#7367f0",background:"#7367F014",padding:{left:15,right:15},fontSize:14},layout:t.ProductActionButtonLayout.Icon,iconConfig:y},{type:t.ProductActionButtonType.Order,name:"Mua ngay",text:"Mua ngay",buttonStyle:{borderStyle:"solid",borderColor:"#7367f0",borderWidth:1,height:32,width:"100%",borderRadius:2,color:"#ffffff",background:"#7367f0",padding:{left:15,right:15}},iconConfig:y}],S={desktop:{eventType:"link",items:[],alignment:"left",layout:"grid",gridOptions:u,nameStyle:{color:"#000",fontSize:16},priceStyle:{color:"#000",fontSize:14},discountStyle:{color:"#fff",fontSize:12,backgroundColor:"#e40303"},virtualSoldStyle:{color:"#000",fontSize:12}},mobile:{eventType:"link",items:[],alignment:"left",layout:"grid",gridOptions:h,nameStyle:{color:"#000",fontSize:16},priceStyle:{color:"#000",fontSize:14},discountStyle:{color:"#fff",fontSize:12,backgroundColor:"#e40303"},virtualSoldStyle:{color:"#000",fontSize:12}},layout:"grid",currencyUnit:e.t("đ"),currencyAlignment:"right",gridOptions:{rows:4,columns:4},items:[{name:e.t("Sản phẩm 1"),price:1e5,discount:30,image:{src:"https://lh3.googleusercontent.com/8uLsW5MRqfvFIpoVhchpQN6CuMdj0hXZV7dOplezAJ6j6RSdymfMCNstJMhs_G8QNZaNwh60gAhFrjYfZr2wG4JmnKfwGDw=rw-w500"},virtualRating:5,virtualSold:100,sku:"SAMPLE00001"},{name:e.t("Sản phẩm 2"),price:1e5,discount:30,image:{src:"https://lh3.googleusercontent.com/s30ROB2cqLL_G97fr4qG8VjryAdAREIOV2pUSjq9p0IjXy8V7Jy3hf-E1f-wtA9t69JIbg4xSyNR3ck_Jnfpn4bfZ6rSmJNg=rw-w500"},virtualRating:5,sku:"SAMPLE00002"},{name:e.t("Sản phẩm 3"),price:1e5,discount:30,image:{src:"https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500"},virtualRating:5,sku:"SAMPLE00003"},{name:e.t("Sản phẩm 4"),price:1e5,discount:30,image:{src:"https://lh3.googleusercontent.com/xR9Sx8XT-vsY7F-2x4wnlGk7LXFLb2sCW1RoWtR7dTUmfrpqVvdO2F00Q8g51s7b1TYVZddlIIQXoUzRiv50Ao4k3TLQbvY=rw-w500"},virtualRating:5,sku:"SAMPLE00004"}],eventType:"showPopup",alignment:"left",nameStyle:{color:"#000",fontSize:16},priceStyle:{color:"#000",fontSize:14},discountStyle:{color:"#fff",fontSize:12,backgroundColor:"#e40303"},virtualSoldStyle:{color:"#000",fontSize:12},orderButton:{buttonStyle:{height:32,borderRadius:16,color:"#ffffff",background:"#7367f0",padding:{left:15,right:15},hover:{backgroundColor:"#a195fc"},fontSize:14},text:e.t("Đặt hàng")},showButton:!1,showAddToCartButton:!1,addToCartButton:{buttonStyle:{borderStyle:"solid",borderColor:"#7367f0",borderWidth:1,height:32,borderRadius:16,color:"#7367f0",background:"#ffffff",padding:{left:15,right:15},hover:{backgroundColor:"#7367f0",color:"#ffffff"},fontSize:14},text:e.t("product_list.add_to_cart")},productDisplay:{filterType:t.ProductFilterType.CATEGORY,skus:[]},actionButtons:f,borderColor:"#F0F0F0"};t.ProductFieldType.Image,t.ProductFieldType.Name,t.ProductFieldType.Price,t.ProductFieldType.Discount,t.ProductFieldType.VirtualRating,t.ProductFieldType.VirtualSold;const w={name:e.t("Tên khách hàng"),phoneNumber:e.t("Số điện thoại"),address:e.t("Địa chỉ"),note:e.t("Thông tin bổ sung"),productName:e.t("Tên sản phẩm"),price:e.t("Giá bán")},b=[{type:"text",name:w.name,label:e.t("Tên"),placeholder:e.t("Nhập họ và tên"),required:!0,commonStyle:{height:32,width:"100%"},inputStyle:{borderRadius:4}},{type:"tel",name:w.phoneNumber,label:e.t("Số điện thoại"),placeholder:e.t("Nhập số điện thoại"),required:!0,commonStyle:{height:32,width:"100%"},inputStyle:{borderRadius:4}},{type:"text",name:w.address,label:e.t("Địa chỉ"),placeholder:e.t("Nhập địa chỉ nhận hàng"),required:!0,commonStyle:{height:32,width:"100%"},inputStyle:{borderRadius:4}},{type:"textarea",name:w.note,label:e.t("Thông tin bổ sung"),placeholder:e.t("Thông tin bổ sung cho người bán.\\nVD: Số lượng, kích thước, giao giờ hành chính..."),commonStyle:{width:"100%"},inputStyle:{borderRadius:4,minHeight:100}}],k=[{tag:"Grid",group:e.t("Dạng lưới"),props:d(c({},S),{gridOptions:{displayMode:t.DisplayModeType.All,rows:1,columns:4},desktop:{gridOptions:{displayMode:t.DisplayModeType.All,rows:1,columns:4}},items:[{name:e.t("New product"),price:2e5,image:{src:"https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500"},sku:"SAMPLE00001"},{name:e.t("New product"),price:2e5,image:{src:"https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500"},sku:"SAMPLE00002"},{name:e.t("New product"),price:2e5,image:{src:"https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500"},sku:"SAMPLE00003"},{name:e.t("New product"),price:2e5,image:{src:"https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500"},sku:"SAMPLE00004"}]}),src:"https://lh3.googleusercontent.com/xPDYw-BXh6mmJJSn-rmuhyAndn3eUgOgalyYUgA0uTNbBhYI7BbogePnsuCqr9FVcgB4V6H8y1IdJCzkY8B6VtQwM9He2Vb7"},{tag:"Carousel",group:e.t("Dạng trượt"),props:d(c({},S),{layout:"carousel",carouselOptions:{slidesPerView:4},desktop:{layout:"carousel",carouselOptions:{slidesPerView:4}},items:[{name:e.t("New product"),price:2e5,image:{src:"https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500"},sku:"SAMPLE00001"},{name:e.t("New product"),price:2e5,image:{src:"https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500"},sku:"SAMPLE00002"},{name:e.t("New product"),price:2e5,image:{src:"https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500"},sku:"SAMPLE00003"},{name:e.t("New product"),price:2e5,image:{src:"https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500"},sku:"SAMPLE00004"}]}),src:"https://lh3.googleusercontent.com/L3J3dn_nPzpMJ6x5MLwyDMXXOtrjds1aIl5lReZYo-guciV15J8OwpAZtRIsaQyaizm3GSEf7mW6YXhJ71H8hX5p850b5aMUew"}];exports.DATA_KEYS=w,exports.DEFAULT_ACTION_BUTTONS=f,exports.DEFAULT_ICON_CONFIG=y,exports.DEFAULT_PRODUCT_LIST=S,exports.SAMPLE_PRODUCT_LIST=k,exports.defaultCarouselOptions=g,exports.defaultGridOptions=u,exports.defaultMobileCarouselOptions=m,exports.defaultMobileGridOptions=h,exports.inputsConfig=b;


/***/ }),

/***/ 548477:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(800656),t=__webpack_require__(891987),r=__webpack_require__(85097),u=__webpack_require__(707068),n=__webpack_require__(324259),i=__webpack_require__(262560),o=__webpack_require__(80667),a=__webpack_require__(655268),l=Object.defineProperty,m=Object.getOwnPropertySymbols,s=Object.prototype.hasOwnProperty,c=Object.prototype.propertyIsEnumerable,d=(e,t,r)=>t in e?l(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,f=(e,t)=>{for(var r in t||(t={}))s.call(t,r)&&d(e,r,t[r]);if(m)for(var r of m(t))c.call(t,r)&&d(e,r,t[r]);return e};exports.useCheckout=l=>{const{env:d}=r.useStore(),[p,v]=t.useState(),[y,b]=t.useState(!1),[g,_]=t.useState(!1);return{loading:y,handleFinishCheckout:async t=>{var y;try{b(!0);const g=n.queryStringToObject(window.location.search)||{},{utm_source:h,utm_medium:j,utm_campaign:w,utm_term:O,utm_content:q}=g,P=((e,t)=>{var r={};for(var u in e)s.call(e,u)&&t.indexOf(u)<0&&(r[u]=e[u]);if(null!=e&&m)for(var u of m(e))t.indexOf(u)<0&&c.call(e,u)&&(r[u]=e[u]);return r})(g,["utm_source","utm_medium","utm_campaign","utm_term","utm_content"]),S=f(f({utm_source:h,utm_medium:j,utm_campaign:w,utm_term:O,utm_content:q},(null==l?void 0:l.autoPassParams)&&P),t),T=new Date,{year:$,month:C,day:G,hour:D,minute:k,second:x}=i.getPartialDateTimeTimeZone7(T),U=`${$}-${C}-${G} ${D}:${k}:${x}`;let F=o.transformValuesGGSheet(S,u.inputsConfig);F=[...F,{name:e.t("Tên sản phẩm"),type:"string",value:null==p?void 0:p.name},{name:e.t("Giá bán"),type:"number",value:null==p?void 0:p.price},{name:e.t("Thời gian gửi"),type:"string",value:U},{name:e.t("Gửi từ URL"),type:"string",value:null==(y=null==window?void 0:window.location)?void 0:y.href}],await a.formUtils.submitFormData(null==l?void 0:l.formConfigId,F,`${r.publicBffUrl[d]}/v1/submit-form`),v(void 0),_(!0)}finally{b(!1)}},selectedProduct:p,setSelectedProduct:v,doneCheckout:g,setDoneCheckout:_}};


/***/ }),

/***/ 570489:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=(t=>(t.CATEGORY="filter_by_category",t.SKUS="filter_by_skus",t))(t||{}),o=(t=>(t.Name="name",t.Price="price",t.Image="image",t.Discount="discount",t.VirtualRating="virtualRating",t.VirtualSold="virtualSold",t.Description="description",t.ActionButton="actionButton",t))(o||{}),e=(t=>(t.Order="order",t.AddToCart="addToCart",t.Contact="contact",t))(e||{}),r=(t=>(t.Icon="icon",t.Text="text",t.Combined="combined",t))(r||{}),i=(t=>(t.All="ALL",t.Pagination="PAGINATION",t))(i||{});exports.DisplayModeType=i,exports.ProductActionButtonLayout=r,exports.ProductActionButtonType=e,exports.ProductFieldType=o,exports.ProductFilterType=t;


/***/ }),

/***/ 270992:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(85097),r=__webpack_require__(548477),t=__webpack_require__(822622),i=__webpack_require__(152176),c=__webpack_require__(561618),s=__webpack_require__(279325),u=__webpack_require__(46558),n=__webpack_require__(481177),p=Object.defineProperty,d=Object.defineProperties,l=Object.getOwnPropertyDescriptors,a=Object.getOwnPropertySymbols,P=Object.prototype.hasOwnProperty,j=Object.prototype.propertyIsEnumerable,h=(e,o,r)=>o in e?p(e,o,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[o]=r,f=(e,o)=>{for(var r in o||(o={}))P.call(o,r)&&h(e,r,o[r]);if(a)for(var r of a(o))j.call(o,r)&&h(e,r,o[r]);return e},g=(e,o)=>d(e,l(o));const v=p=>{var d=p,{isEditingMode:l,configStorage:h,children:v}=d,y=((e,o)=>{var r={};for(var t in e)P.call(e,t)&&o.indexOf(t)<0&&(r[t]=e[t]);if(null!=e&&a)for(var t of a(e))o.indexOf(t)<0&&j.call(e,t)&&(r[t]=e[t]);return r})(d,["isEditingMode","configStorage","children"]);const{device:C}=o.useStore(),O=t.getProductPropByDevice(y,n.PROP_KEY.Layout,C,y.layout),{selectedProduct:k,setSelectedProduct:m,loading:b,doneCheckout:x,setDoneCheckout:q,handleFinishCheckout:S}=r.useCheckout(h),E="showPopup"===(null==y?void 0:y.eventType)?m:void 0;return e.jsxs(e.Fragment,{children:["carousel"===O?e.jsx(s.ProductCarousel,g(f({isEditingMode:l},y),{onClick:E})):e.jsx(u.ProductGrid,g(f({isEditingMode:l},y),{onClick:E})),v,e.jsx(i.CheckoutPopup,{open:!!k,setOpen:()=>m(void 0),loading:b,onFinish:S}),e.jsx(c.CheckoutSuccessPopup,{open:x,setOpen:()=>q(!1)})]})};v.displayName="TempiProductList",exports.TempiProductList=v;


/***/ }),

/***/ 822622:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(47248),t=__webpack_require__(481177);function r(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var o=r(e);exports.getProductPropByDevice=(e,r,u,i)=>{if(u){const i=o.default(e,t.PROP_KEY.joinKey(u,r));if(i)return i}if("mobile"===u){const u=o.default(e,t.PROP_KEY.joinKey("desktop",r));if(u)return u}if("desktop"===u||!u){const t=o.default(e,r);if(t)return t}return i};


/***/ }),

/***/ 926930:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(85097),o=__webpack_require__(822622),t=__webpack_require__(891987),u=__webpack_require__(681084),c=__webpack_require__(481177),i=__webpack_require__(100902),s=__webpack_require__(279325),n=__webpack_require__(46558),d=__webpack_require__(561618),p=Object.defineProperty,l=Object.defineProperties,a=Object.getOwnPropertyDescriptors,P=Object.getOwnPropertySymbols,v=Object.prototype.hasOwnProperty,j=Object.prototype.propertyIsEnumerable,m=(e,r,o)=>r in e?p(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,f=(e,r)=>{for(var o in r||(r={}))v.call(r,o)&&m(e,o,r[o]);if(P)for(var o of P(r))j.call(r,o)&&m(e,o,r[o]);return e},x=(e,r)=>l(e,a(r));const h=p=>{var l=p,{isEditingMode:a,configStorage:m,children:h,orderPopupId:y,className:C}=l,b=((e,r)=>{var o={};for(var t in e)v.call(e,t)&&r.indexOf(t)<0&&(o[t]=e[t]);if(null!=e&&P)for(var t of P(e))r.indexOf(t)<0&&j.call(e,t)&&(o[t]=e[t]);return o})(l,["isEditingMode","configStorage","children","orderPopupId","className"]);const{device:O}=r.useStore(),g=o.getProductPropByDevice(b,c.PROP_KEY.Layout,O,b.layout),k=t.useRef(),q=()=>{const{setSelectedProducts:r,doneCheckout:o,setDoneCheckout:t}=i.useCheckoutContext(),u="showPopup"===(null==b?void 0:b.eventType)?e=>{var o,t;r([e]),null==(t=null==(o=k.current)?void 0:o.ownerDocument.querySelector(`[data-uniq-id="${y}"]`))||t.click()}:void 0;return"carousel"===g?e.jsx(s.ProductCarousel,x(f({isEditingMode:a},b),{onClick:u})):e.jsxs(e.Fragment,{children:[e.jsx(n.ProductGrid,x(f({isEditingMode:a},b),{onClick:u})),e.jsx(d.CheckoutSuccessPopup,{open:o,setOpen:()=>t(!1)})]})};return e.jsx(i.CheckoutProvider,{orderPopupId:y,wrapperCheckoutRef:k,customExtraFieldSubmit:u.customExtraFieldProductSubmit,children:e.jsxs("div",{ref:k,className:C,children:[e.jsx(q,{}),h]})})};h.displayName="TempiProductListV2",exports.TempiProductListV2=h;


/***/ }),

/***/ 105122:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261);function t(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=t(__webpack_require__(212951));const i=s.default.div`
  position: relative;
  height: 400px;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 14px;
`,l=s.default.div`
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .spinner-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    flex-direction: column;
    opacity: 0.9;
  }
  .loading-text {
    font-size: 16px;
    letter-spacing: 2px;
    color: #7367f0;
    margin-bottom: 8px;
  }
  .pulse-container {
    width: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .pulse-bubble {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: linear-gradient(to right, #7367f0, #a29af6);
  }

  .pulse-bubble-1 {
    animation: pulse 1s ease 0s infinite alternate;
  }
  .pulse-bubble-2 {
    animation: pulse 1s ease 0.2s infinite alternate;
  }
  .pulse-bubble-3 {
    animation: pulse 1s ease 0.4s infinite alternate;
  }
  .pulse-bubble-4 {
    animation: pulse 1s ease 0.6s infinite alternate;
  }
  .pulse-bubble-5 {
    animation: pulse 1s ease 0.8s infinite alternate;
  }

  @keyframes pulse {
    from {
      opacity: 1;
      transform: scale(1);
    }
    to {
      opacity: 0.25;
      transform: scale(0.75);
    }
  }
`;exports.Loading=({customHeight:t})=>e.jsx(i,{style:{height:t},children:e.jsx(l,{children:e.jsx("div",{className:"spinner-box",children:e.jsxs("div",{className:"pulse-container",children:[e.jsx("div",{className:"pulse-bubble pulse-bubble-1"}),e.jsx("div",{className:"pulse-bubble pulse-bubble-2"}),e.jsx("div",{className:"pulse-bubble pulse-bubble-3"}),e.jsx("div",{className:"pulse-bubble pulse-bubble-4"}),e.jsx("div",{className:"pulse-bubble pulse-bubble-5"})]})})})});


/***/ }),

/***/ 242942:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(561261),e=__webpack_require__(85097),r=__webpack_require__(681084),n=__webpack_require__(800886),o=__webpack_require__(795625),i=__webpack_require__(891987),u=__webpack_require__(77906),a=__webpack_require__(800656),l=__webpack_require__(512005),s=__webpack_require__(750911),c=Object.defineProperty,d=Object.defineProperties,p=Object.getOwnPropertyDescriptors,m=Object.getOwnPropertySymbols,g=Object.prototype.hasOwnProperty,y=Object.prototype.propertyIsEnumerable,b=(t,e,r)=>e in t?c(t,e,{enumerable:!0,configurable:!0,writable:!0,value:r}):t[e]=r,v=(t,e)=>{for(var r in e||(e={}))g.call(e,r)&&b(t,r,e[r]);if(m)for(var r of m(e))y.call(e,r)&&b(t,r,e[r]);return t},f=(t,e)=>d(t,p(e));exports.AddToCartButton=({isEditingMode:c,addToCartButton:d,showAddToCartButton:p,product:b,currencyAlignment:x,currencyUnit:h,addToCartCallback:C,layout:j=n.ProductActionButtonLayout.Text,wrapperRef:T,customCommonStyle:q})=>{const{globalData:P}=e.useStore(),{addToCart:w}=l.useCartStore(),[O,A]=i.useState(!1),B=j===n.ProductActionButtonLayout.Icon||j===n.ProductActionButtonLayout.Combined,k=j===n.ProductActionButtonLayout.Text||j===n.ProductActionButtonLayout.Combined;if(!p)return null;const{iconConfig:L,text:S}=d;return t.jsxs(t.Fragment,{children:[t.jsx(s.ButtonV2,f(v({onClick:()=>{var t;((t,e)=>{var n;const i=r.getProductsInLocalCart(t),u=e,{image:a,link:l}=u,s=((t,e)=>{var r={};for(var n in t)g.call(t,n)&&e.indexOf(n)<0&&(r[n]=t[n]);if(null!=t&&m)for(var n of m(t))e.indexOf(n)<0&&y.call(t,n)&&(r[n]=t[n]);return r})(u,["image","link"]),c=i.findIndex((t=>t.sku===e.sku));c>=0?i[c]=f(v(v({},i[c]),s),{thumbnailAlt:(null==a?void 0:a.alt)||e.name,thumbnailUrl:null==a?void 0:a.src,quantity:((null==(n=i[c])?void 0:n.quantity)||0)+1}):i.push(f(v({},s),{thumbnailAlt:(null==a?void 0:a.alt)||e.name,thumbnailUrl:null==a?void 0:a.src,quantity:1})),r.setProductsToLocalCart(t,i),o.emit("addProductToCart",i)})(null==(t=null==P?void 0:P.currentLanguage)?void 0:t.id,f(v({},b),{currencyAlignment:x,currencyUnit:h})),(()=>{var t,e;if(!(null==T?void 0:T.current))return;const r=null==(t=null==T?void 0:T.current)?void 0:t.ownerDocument,n=r.createElement("div"),o=r.querySelector(".shopping-cart");if(!o)return;const i=T.current.getBoundingClientRect(),u=o.getBoundingClientRect();n.style.cssText=`\n      position: fixed;\n      left: ${i.left}px;\n      top: ${i.top}px;\n      width: ${i.width}px;\n      height: ${i.height}px;\n      background-image: url(${(null==(e=b.image)?void 0:e.src)||""});\n      background-size: cover;\n      background-position: center;\n      border-radius: 10px;\n      box-shadow: 0 2px 15px rgba(0,0,0,0.2);\n      z-index: 9999;\n      pointer-events: none;\n      transition: all 1.5s cubic-bezier(0.19, 1, 0.22, 1);\n    `,r.body.appendChild(n),setTimeout((()=>{n.style.transform=`translate(${u.left-i.left-i.width/3}px, ${u.top-i.top-i.height/2}px) scale(0)`,n.style.opacity="0",setTimeout((()=>{r.body.removeChild(n)}),800)}),1)})(),w(b,1),null==C||C(),A(!0),setTimeout((()=>{A(!1)}),1e3)}},d),{iconConfig:f(v({},L),{show:B}),text:k?S:void 0,isEditingMode:c,commonStyle:v({justifyContent:"center",flex:k?1:void 0},q),style:{marginTop:6},className:"button-width"})),O&&t.jsx(u.ToastMessage,{message:a.translate("product_list.add_to_cart")})]})};


/***/ }),

/***/ 839165:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(891987),i=__webpack_require__(212951),l=__webpack_require__(85097),r=__webpack_require__(877084),n=__webpack_require__(800886),a=__webpack_require__(681084),o=__webpack_require__(242942),d=__webpack_require__(800656),c=__webpack_require__(586753),s=__webpack_require__(840424),u=__webpack_require__(750911),p=__webpack_require__(319891),y=__webpack_require__(134166);function m(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var f=m(i),x=m(r),g=Object.defineProperty,h=Object.defineProperties,j=Object.getOwnPropertyDescriptors,v=Object.getOwnPropertySymbols,S=Object.prototype.hasOwnProperty,b=Object.prototype.propertyIsEnumerable,w=(e,t,i)=>t in e?g(e,t,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[t]=i,_=(e,t)=>{for(var i in t||(t={}))S.call(t,i)&&w(e,i,t[i]);if(v)for(var i of v(t))b.call(t,i)&&w(e,i,t[i]);return e},$=(e,t)=>h(e,j(t)),k=(e,t)=>{var i={};for(var l in e)S.call(e,l)&&t.indexOf(l)<0&&(i[l]=e[l]);if(null!=e&&v)for(var l of v(e))t.indexOf(l)<0&&b.call(e,l)&&(i[l]=e[l]);return i};const P=f.default.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: transparent;
`,T=f.default.div`
  position: relative;
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &.allow-click {
    &:hover {
      cursor: pointer;
    }
  }
  border: 1px solid ${({borderColor:e})=>e||"transparent"};
`,N=f.default.div`
  position: relative;
  margin-bottom: 4px;
`,C=f.default(c.Image)`
  display: inline-block;
  overflow: hidden;
  position: absolute;
  height: 100%;
  inset: 0;
  ${e=>l.getStyle(null==e?void 0:e.commonStyle)}
`,O=f.default.div`
  &.detail-card {
    &.left {
      .detail-card__name {
        text-align: left;
      }
      .detail-card__price,
      .detail-card__extra {
        justify-content: flex-start;
      }
    }
    &.center {
      .detail-card__name {
        text-align: center;
      }
      .detail-card__price,
      .detail-card__extra {
        justify-content: center;
      }
    }
    &.right {
      .detail-card__name {
        text-align: right;
      }
      .detail-card__price,
      .detail-card__extra {
        justify-content: flex-end;
      }
    }
  }
`,q=f.default(s.Paragraph)`
  padding: 0 8px;
  font-size: 14px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: #000000;
  height: 2lh;
  font-weight: 700;
  ${e=>l.getStyle(null==e?void 0:e.commonStyle)}
`,F=f.default.div`
  display: flex;
  padding: 0 8px;
`,B=f.default(s.Paragraph)`
  font-weight: 400;
  font-size: 14px;
  ${e=>l.getStyle(null==e?void 0:e.commonStyle)}
`,A=f.default.span`
  padding: 0 4px;
  color: #ffffff;
  background-color: #e40303;
  border-radius: 2px;
  font-weight: 700;
  ${e=>l.getStyle(null==e?void 0:e.commonStyle)}
`,R=f.default.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  padding: 0 8px;
`,z=f.default(s.Paragraph)`
  font-weight: 400;
  ${e=>l.getStyle(null==e?void 0:e.commonStyle)}
`,D=f.default.div`
  display: inline-flex;
  align-items: center;
  column-gap: 0.5em;
  row-gap: 0.5em;
  width: 100%;
  padding: 8px;
  justify-content: center;

  &.icon-button {
    column-gap: 0;
  }

  .button-width {
    width: fit-content;
  }

  a {
    width: 100%;
  }
`,E=f.default.div`
  position: absolute;
  top: 4px;
  right: 8px;
  z-index: 1;
`;exports.DraggableProductCard=({product:i,nameStyle:r,priceStyle:c,discountStyle:s,imageStyle:m,virtualSoldStyle:f,virtualSoldTitle:g,alignment:h,onClick:j,handleClickOrder:v=()=>{},isEditingMode:S=!1,currencyUnit:b,currencyAlignment:w,showButton:I,mobile:L,desktop:M,fields:V,actionButtons:U,borderColor:G})=>{var H;const{device:J}=l.useStore(),{name:K,discount:Q,price:W,image:X,link:Y,virtualSold:Z,virtualRating:ee}=i,te=t.useRef(null),ie=e=>e?k(e,["color"]):e,le=e=>e?$(_({},e),{nameStyle:ie(e.nameStyle),priceStyle:ie(e.priceStyle),discountStyle:ie(e.discountStyle),virtualSoldStyle:ie(e.virtualSoldStyle)}):e,re={nameStyle:r,priceStyle:c,discountStyle:s,virtualSoldStyle:f,imageStyle:m,desktop:le(M),mobile:le(L)},{nameStyle:ne,discountStyle:ae,virtualSoldStyle:oe,priceStyle:de,imageStyle:ce}=l.getPropsByDevice(re,J),se=ce||{},{aspectRatio:ue="1 / 1",objectFit:pe="cover"}=se,ye=k(se,["aspectRatio","objectFit"]),me=e.jsx(N,{ref:te,children:e.jsxs("div",{style:{position:"relative",aspectRatio:ue},children:[!!Q&&(null==(H=null==V?void 0:V.find((e=>e.type===n.ProductFieldType.Discount)))?void 0:H.isActive)&&e.jsx(E,{children:e.jsx(A,{commonStyle:ae,children:`-${Q}%`})}),e.jsx(C,$(_({commonStyle:_({objectFit:pe,height:"100%",width:"100%"},ye),autoOptimize:!0},X),{alt:(null==X?void 0:X.alt)||K}))]})}),fe="function"==typeof j,xe=()=>{const t=Intl.NumberFormat("en-US",{notation:"compact",maximumFractionDigits:1}).format(Z);return e.jsx(z,{text:`${g||d.translate("product_list.sold")} ${t}`,commonStyle:oe})},ge=me,he=()=>S||!I?ge:e.jsx(p.Link,$(_({},{eventType:"link",link:{openNewTab:!0,nofollow:!0,href:Y}}),{children:ge})),je=()=>(null==V?void 0:V.length)?V.filter((e=>e.isActive)).map(((i,l)=>{switch(i.type){case n.ProductFieldType.Name:return e.jsx(q,{className:"detail-card__name",text:K,commonStyle:ne},`${i.type}-${l}`);case n.ProductFieldType.Price:return e.jsx(F,{className:"detail-card__price",children:(!!W||0===W)&&e.jsx(B,{text:a.getPriceText(W,b,w),commonStyle:de})},`${i.type}-${l}`);case n.ProductFieldType.VirtualRating:return ee>0?e.jsx(R,{className:"detail-card__extra",children:e.jsx(y.Rating,{style:{fontSize:(null==de?void 0:de.fontSize)||14},value:ee,disabled:!0})},`${i.type}-${l}`):null;case n.ProductFieldType.VirtualSold:return Z>0?e.jsx(R,{className:"detail-card__extra",children:xe()},`${i.type}-${l}`):null;case n.ProductFieldType.Image:return e.jsx(t.Fragment,{children:he()},`${i.type}-${l}`);default:return null}})):e.jsxs(e.Fragment,{children:[he(),e.jsx(q,{className:"detail-card__name",text:K,commonStyle:ne}),e.jsx(F,{className:"detail-card__price",children:(!!W||0===W)&&e.jsx(B,{text:a.getPriceText(W,b,w),commonStyle:de})}),(ee>0||Z>0)&&e.jsxs(R,{className:"detail-card__extra",children:[ee>0&&e.jsx(y.Rating,{style:{fontSize:(null==de?void 0:de.fontSize)||14},value:ee,disabled:!0}),Z>0&&xe()]})]});return e.jsx(P,{children:e.jsxs(T,{borderColor:G,children:[S||I?e.jsx(O,{className:`${x.default("detail-card",h)} ${x.default({"allow-click":fe})}`,children:je()}):fe?e.jsx(O,{onClick:()=>{fe&&j(i)},className:`${x.default("detail-card",h)} ${x.default({"allow-click":fe})}`,style:{cursor:"pointer"},children:je()}):e.jsx(p.Link,$(_({},{eventType:"link",link:{openNewTab:!0,nofollow:!0,href:Y}}),{children:e.jsx(O,{className:`${x.default("detail-card",h)} ${x.default({"allow-click":fe})}`,children:je()})})),(()=>{const l=U||[],r=l.some((e=>e.layout===n.ProductActionButtonLayout.Icon));return e.jsx(D,{className:r?"icon-button":"",children:null==l?void 0:l.map(((l,r)=>{switch(l.type){case n.ProductActionButtonType.AddToCart:return e.jsx(o.AddToCartButton,{product:i,showAddToCartButton:!0,isEditingMode:S,addToCartButton:l,currencyUnit:b,currencyAlignment:w,layout:l.layout,wrapperRef:te},`${l.name}-${r}`);case n.ProductActionButtonType.Order:return e.jsx(t.Fragment,{children:(a=l,t.createElement(u.ButtonV2,$(_({onClick:S?null:()=>v(i)},a),{isEditingMode:S,key:a.id,commonStyle:{justifyContent:"center",flex:1},className:"button-width",style:{marginTop:6}})))},`${l.name||l.id}-${r}`);case n.ProductActionButtonType.Contact:return e.jsx(u.ButtonV2,$(_({},l),{commonStyle:{justifyContent:"center",flex:1},className:"button-width",style:{marginTop:6}}),`${l.name}-${r}`);default:return null}var a}))})})()]})})};


/***/ }),

/***/ 77906:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097),o=__webpack_require__(143599),a=__webpack_require__(891987),n=__webpack_require__(926759);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const i=s(t).default.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.6);
  padding: 12px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 10000;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #ffffff;
  pointer-events: none;
  flex-direction: column;
  animation: fadeIn 0.2s, fadeOut 0.2s 2.8s;
  font-family: var(--tempi-global-paragraph1fontfamily);

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translate(-50%, -40%);
    }
    to {
      opacity: 1;
      transform: translate(-50%, -50%);
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
      transform: translate(-50%, -50%);
    }
    to {
      opacity: 0;
      transform: translate(-50%, -40%);
    }
  }
`;exports.ToastMessage=({message:t})=>{var s,f;const[l,u]=a.useState(!0);if(a.useEffect((()=>{const e=setTimeout((()=>{u(!1)}),3e3);return()=>clearTimeout(e)}),[]),!l)return null;const c=e.jsxs(i,{children:[e.jsx(o.Icon,{name:"SuccessColored",style:{fontSize:72}}),t]});return n.createPortal(c,null==(f=(null==(s=null==document?void 0:document.getElementById(r.TEMPI_MAIN_IFRAME))?void 0:s.contentDocument)||document)?void 0:f.body)};


/***/ }),

/***/ 373476:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(85097),o=__webpack_require__(203832),t=__webpack_require__(15161),i=__webpack_require__(839165),s=__webpack_require__(481177),l=__webpack_require__(115741),u=Object.defineProperty,a=Object.defineProperties,d=Object.getOwnPropertyDescriptors,n=Object.getOwnPropertySymbols,P=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,c=(e,r,o)=>r in e?u(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,O=(e,r)=>{for(var o in r||(r={}))P.call(r,o)&&c(e,o,r[o]);if(n)for(var o of n(r))p.call(r,o)&&c(e,o,r[o]);return e};exports.ProductCarousel=u=>{const c=u,{items:b=[],carouselOptions:j,layout:y,isEditingMode:f}=c,v=((e,r)=>{var o={};for(var t in e)P.call(e,t)&&r.indexOf(t)<0&&(o[t]=e[t]);if(null!=e&&n)for(var t of n(e))r.indexOf(t)<0&&p.call(e,t)&&(o[t]=e[t]);return o})(c,["items","carouselOptions","layout","isEditingMode"]),{device:K}=r.useStore(),E=t.getProductPropByDevice(u,s.PROP_KEY.joinKey(s.PROP_KEY.CarouselOptions,s.PROP_KEY.SlidesPerView),"desktop",o.defaultCarouselOptions.slidesPerView),g=t.getProductPropByDevice(u,s.PROP_KEY.joinKey(s.PROP_KEY.CarouselOptions,s.PROP_KEY.SlidesPerView),"mobile",o.defaultMobileCarouselOptions.slidesPerView),_="mobile"===K?g:E,C=t.getProductPropByDevice(u,s.PROP_KEY.joinKey(s.PROP_KEY.CarouselOptions,s.PROP_KEY.Gutter),K,o.defaultCarouselOptions.gutter),m=t.getProductPropByDevice(u,s.PROP_KEY.joinKey(s.PROP_KEY.CarouselOptions,s.PROP_KEY.Speed),K,("mobile"===K?o.defaultMobileCarouselOptions:o.defaultCarouselOptions).speed);return e.jsx(l.DSSlider,(w=O({},j),R={speed:m,slidesPerView:_,slidesPerViewMobile:2.5,allowTouchMove:!f,spaceBetween:C,children:b.map(((o,t)=>e.jsx(r.BreakpointWidthProvider,{sWidth:{value:100/g,unit:"%"},mWidth:{value:100/E,unit:"%"},children:e.jsx(i.DraggableProductCard,O({product:o,isEditingMode:f},v))},t)))},a(w,d(R))));var w,R};


/***/ }),

/***/ 841870:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),C=__webpack_require__(212951);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const i=()=>e.jsxs("svg",{xmlns:"http://www.w3.org/2000/svg",width:"106",height:"100",viewBox:"0 0 106 100",fill:"none",style:{paddingLeft:"1em"},children:[e.jsx("path",{d:"M44.6033 99.4921C69.237 99.4921 89.2066 95.7607 89.2066 91.1579C89.2066 86.555 69.237 82.8237 44.6033 82.8237C19.9696 82.8237 0 86.555 0 91.1579C0 95.7607 19.9696 99.4921 44.6033 99.4921Z",fill:"#F5F5F7",fillOpacity:"0.8"}),e.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M80.2856 66.6737L64.5455 47.3019C63.7902 46.3901 62.6863 45.8381 61.5238 45.8381H27.6817C26.5198 45.8381 25.4159 46.3901 24.6606 47.3019L8.92114 66.6737V76.7941H80.2863V66.6737H80.2856Z",fill:"#AEB8C2"}),e.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M22.2566 20.8355H66.9493C67.6473 20.8355 68.3166 21.1128 68.8102 21.6063C69.3037 22.0998 69.5809 22.7692 69.5809 23.4671V84.8776C69.5809 85.5755 69.3037 86.2449 68.8102 86.7384C68.3166 87.2319 67.6473 87.5092 66.9493 87.5092H22.2566C21.5586 87.5092 20.8893 87.2319 20.3958 86.7384C19.9023 86.2449 19.625 85.5755 19.625 84.8776V23.4671C19.625 22.7692 19.9023 22.0998 20.3958 21.6063C20.8893 21.1128 21.5586 20.8355 22.2566 20.8355V20.8355Z",fill:"#F5F5F7"}),e.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M28.0777 27.3835H61.1283C61.4773 27.3835 61.812 27.5222 62.0587 27.7689C62.3055 28.0157 62.4441 28.3504 62.4441 28.6993V45.1184C62.4441 45.4674 62.3055 45.8021 62.0587 46.0488C61.812 46.2956 61.4773 46.4342 61.1283 46.4342H28.0777C27.7287 46.4342 27.394 46.2956 27.1472 46.0488C26.9005 45.8021 26.7619 45.4674 26.7619 45.1184V28.6993C26.7619 28.3504 26.9005 28.0157 27.1472 27.7689C27.394 27.5222 27.7287 27.3835 28.0777 27.3835ZM28.25 53.577H60.9559C61.3506 53.577 61.7291 53.7338 62.0082 54.0128C62.2873 54.2919 62.4441 54.6704 62.4441 55.0651C62.4441 55.4598 62.2873 55.8383 62.0082 56.1174C61.7291 56.3965 61.3506 56.5533 60.9559 56.5533H28.25C27.8553 56.5533 27.4768 56.3965 27.1977 56.1174C26.9186 55.8383 26.7619 55.4598 26.7619 55.0651C26.7619 54.6704 26.9186 54.2919 27.1977 54.0128C27.4768 53.7338 27.8553 53.577 28.25 53.577ZM28.25 61.3158H60.9559C61.3507 61.3158 61.7293 61.4726 62.0085 61.7518C62.2876 62.0309 62.4444 62.4095 62.4444 62.8043C62.4444 63.199 62.2876 63.5776 62.0085 63.8568C61.7293 64.1359 61.3507 64.2928 60.9559 64.2928H28.25C27.8552 64.2928 27.4766 64.1359 27.1975 63.8568C26.9184 63.5776 26.7615 63.199 26.7615 62.8043C26.7615 62.4095 26.9184 62.0309 27.1975 61.7518C27.4766 61.4726 27.8552 61.3158 28.25 61.3158ZM80.1402 89.9355C79.6303 91.9559 77.8395 93.4618 75.7092 93.4618H13.4967C11.3665 93.4618 9.57567 91.9553 9.06646 89.9355C8.96934 89.5505 8.92029 89.1549 8.92041 88.7579V66.6743H26.2349C28.1474 66.6743 29.6888 68.2849 29.6888 70.2401V70.2664C29.6888 72.221 31.248 73.7993 33.1605 73.7993H56.0454C57.9579 73.7993 59.5171 72.2066 59.5171 70.2513V70.2434C59.5171 68.2881 61.0586 66.6737 62.9711 66.6737H80.2855V88.7585C80.2855 89.1645 80.2349 89.5585 80.1402 89.9355Z",fill:"#DCE0E6"}),e.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M82.3164 21.9026L77.823 23.6461C77.7075 23.6909 77.5818 23.7023 77.4602 23.6789C77.3385 23.6555 77.226 23.5982 77.1355 23.5137C77.045 23.4292 76.9802 23.3208 76.9485 23.2011C76.9168 23.0813 76.9196 22.9551 76.9565 22.8368L78.2309 18.7533C76.5276 16.8164 75.5276 14.4546 75.5276 11.9059C75.5276 5.33026 82.1842 0 90.396 0C98.6059 0 105.263 5.33026 105.263 11.9059C105.263 18.4816 98.6065 23.8118 90.3954 23.8118C87.4164 23.8118 84.6427 23.1105 82.3164 21.9026Z",fill:"#DCE0E6"}),e.jsx("path",{d:"M96.2528 14.0559C97.2879 14.0559 98.1271 13.2268 98.1271 12.204C98.1271 11.1811 97.2879 10.352 96.2528 10.352C95.2176 10.352 94.3784 11.1811 94.3784 12.204C94.3784 13.2268 95.2176 14.0559 96.2528 14.0559Z",fill:"white"}),e.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M86.4132 13.8243H82.6646L84.5711 10.5836L86.4132 13.8243ZM88.756 10.5836H92.0356V13.8243H88.756V10.5836Z",fill:"white"})]}),t=l(C).default.div`
  height: 400px;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 14px;
`;exports.ProductEmpty=()=>e.jsx(t,{children:e.jsxs("div",{children:[e.jsx("div",{children:e.jsx(i,{})}),e.jsx("div",{style:{marginTop:"1em"},children:"Chưa có sản phẩm nào"})]})});


/***/ }),

/***/ 209325:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),i=__webpack_require__(85097),o=__webpack_require__(891987),t=__webpack_require__(203832),n=__webpack_require__(800886),P=__webpack_require__(15161),a=__webpack_require__(839165),d=__webpack_require__(481177),s=__webpack_require__(541076);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var u=l(r),p=Object.defineProperty,c=Object.getOwnPropertySymbols,O=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,y=(e,r,i)=>r in e?p(e,r,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[r]=i,E=(e,r)=>{for(var i in r||(r={}))O.call(r,i)&&y(e,i,r[i]);if(c)for(var i of c(r))g.call(r,i)&&y(e,i,r[i]);return e};const K=u.default.div`
  display: grid;
  align-self: stretch;
  gap: ${({rowGap:e,columnGap:r})=>`${e}px ${r}px`};
`;exports.ProductGrid=r=>{const l=r,{items:u=[],gridOptions:p,layout:y,isEditingMode:_}=l,m=((e,r)=>{var i={};for(var o in e)O.call(e,o)&&r.indexOf(o)<0&&(i[o]=e[o]);if(null!=e&&c)for(var o of c(e))r.indexOf(o)<0&&g.call(e,o)&&(i[o]=e[o]);return i})(l,["items","gridOptions","layout","isEditingMode"]),[R,f]=o.useState(1),{device:j}=i.useStore(),v=P.getProductPropByDevice(r,d.PROP_KEY.PaginationActiveColor,j,t.DEFAULT_PAGINATION_ACTIVE_COLOR),G=P.getProductPropByDevice(r,d.PROP_KEY.PaginationColor,j,t.DEFAULT_PAGINATION_COLOR),Y=P.getProductPropByDevice(r,d.PROP_KEY.joinKey(d.PROP_KEY.GridOptions,d.PROP_KEY.DisplayMode),j),b=P.getProductPropByDevice(r,d.PROP_KEY.joinKey(d.PROP_KEY.GridOptions,d.PROP_KEY.Columns),"desktop",t.defaultGridOptions.columns),C=P.getProductPropByDevice(r,d.PROP_KEY.joinKey(d.PROP_KEY.GridOptions,d.PROP_KEY.Columns),"mobile",t.defaultMobileGridOptions.columns),x=P.getProductPropByDevice(r,d.PROP_KEY.joinKey(d.PROP_KEY.GridOptions,d.PROP_KEY.Rows),"desktop",t.defaultGridOptions.rows),D=P.getProductPropByDevice(r,d.PROP_KEY.joinKey(d.PROP_KEY.GridOptions,d.PROP_KEY.Rows),"mobile",t.defaultMobileGridOptions.rows),h=P.getProductPropByDevice(r,d.PROP_KEY.joinKey(d.PROP_KEY.GridOptions,d.PROP_KEY.RowGap),j,t.defaultGridOptions.rowGap),w=P.getProductPropByDevice(r,d.PROP_KEY.joinKey(d.PROP_KEY.GridOptions,d.PROP_KEY.ColumnGap),j,t.defaultGridOptions.columnGap),M="mobile"===j?C:b,q=M*("mobile"===j?D:x),B=Y===n.DisplayModeType.Pagination,A=o.useMemo((()=>B?u.slice((R-1)*q,R*q):u),[u,q,R,B]);return e.jsxs(e.Fragment,{children:[e.jsx(K,{style:{gridTemplateColumns:`repeat(${M}, minmax(0, 1fr))`},rowGap:h,columnGap:w,children:A.map(((r,o)=>e.jsx("div",{children:e.jsx(i.BreakpointWidthProvider,{sWidth:{value:100/C,unit:"%"},mWidth:{value:100/b,unit:"%"},children:e.jsx(a.DraggableProductCard,E({product:r,isEditingMode:_},m))})},o)))}),B&&!!u.length&&e.jsx(s.Pagination,{isEditingMode:_,onPageChange:({selected:e})=>f(e+1),pageCount:Math.ceil(u.length/q),textColor:G,paginationColor:v})]})};


/***/ }),

/***/ 673532:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097),n=__webpack_require__(891987),i=__webpack_require__(203832),l=__webpack_require__(802636);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=o(t),c=Object.defineProperty,s=Object.getOwnPropertySymbols,u=Object.prototype.hasOwnProperty,d=Object.prototype.propertyIsEnumerable,g=(e,t,r)=>t in e?c(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,p=(e,t)=>{for(var r in t||(t={}))u.call(t,r)&&g(e,r,t[r]);if(s)for(var r of s(t))d.call(t,r)&&g(e,r,t[r]);return e};const h=a.default.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: ${({align:e})=>e};
  margin: 10px 0;
`;exports.SearchBar=({isEditingMode:t,value:o,onChange:a,isMobile:c,align:s=i.DEFAULT_SEARCH_BAR.align,placeholder:u=i.DEFAULT_SEARCH_BAR.placeholder,textStyle:d,colorStyle:g})=>{const f=n.useMemo((()=>r.debounce((e=>{a(e)}),500)),[a]),[y,m]=n.useState(o||""),x={[r.Alignment.left]:"flex-start",[r.Alignment.center]:"center",[r.Alignment.right]:"flex-end"};return e.jsx(h,{align:x[s],children:e.jsx(l.InputText,{style:{paddingRight:30,paddingLeft:20},type:"text",inputStyle:p(p({width:"100%",borderRadius:"99px",backgroundImage:'url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="%23000000d9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65" style="stroke-width: 2;"></line></svg>\')',backgroundRepeat:"no-repeat",backgroundPosition:"right 10px center"},d),g),commonStyle:{height:38,width:c?"100%":300},readOnly:t,placeholder:u,value:y,onChange:e=>{m(e.target.value),f(e.target.value)}})})};


/***/ }),

/***/ 203832:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(85097),e=__webpack_require__(800656),r=__webpack_require__(800886),a=__webpack_require__(281586),o=Object.defineProperty,i=Object.defineProperties,p=Object.getOwnPropertyDescriptors,l=Object.getOwnPropertySymbols,n=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,h=(t,e,r)=>e in t?o(t,e,{enumerable:!0,configurable:!0,writable:!0,value:r}):t[e]=r,s=(t,e)=>{for(var r in e||(e={}))n.call(e,r)&&h(t,r,e[r]);if(l)for(var r of l(e))g.call(e,r)&&h(t,r,e[r]);return t},c=(t,e)=>i(t,p(e));const m="#7367f0",d="#000000";e.t("Sản phẩm mới");const u={displayMode:r.DisplayModeType.All,rows:1,columns:4,gutter:16,rowGap:16,columnGap:16},f={displayMode:r.DisplayModeType.All,rows:1,columns:2},b={type:a.SliderTypeEnum.product,slidesPerView:5,slidesPerColumn:1,navigation:!0,navigationStyle:1,autoplay:!0,loop:!1,spaceBetween:16,speed:3e3,gutter:16},y={type:a.SliderTypeEnum.product,slidesPerView:2.5,slidesPerColumn:1,navigation:!0,navigationStyle:1,autoplay:!0,loop:!1,spaceBetween:16,speed:3e3},S={icon:{name:"CartPlusOutlined",size:18,color:"#7367f0"},spacing:4,position:"left"},v=[{type:r.ProductActionButtonType.AddToCart,name:e.t("product_list.add_to_cart_text"),text:e.t("product_list.add_to_cart_text"),buttonStyle:{borderStyle:"solid",borderColor:"#7367f0",borderWidth:0,height:32,width:"100%",borderRadius:2,color:"#7367f0",background:"#7367F014",padding:{left:15,right:15},currentParagraphTheme:"paragraph2",fontSize:"var(--tempi-global-paragraph2fontsize)",fontFamily:"var(--tempi-global-paragraph2fontfamily)",fontWeight:"var(--tempi-global-paragraph2fontweight)",lineHeight:"var(--tempi-global-paragraph2lineheight)",letterSpacing:"var(--tempi-global-paragraph2letterspacing)"},layout:r.ProductActionButtonLayout.Icon,iconConfig:S},{type:r.ProductActionButtonType.Order,name:e.t("product_list.buy_now"),text:e.t("product_list.buy_now"),buttonStyle:{borderStyle:"solid",borderColor:"#7367f0",borderWidth:1,height:32,width:"100%",borderRadius:2,color:"#ffffff",background:"#7367f0",padding:{left:15,right:15},currentParagraphTheme:"paragraph2",fontSize:"var(--tempi-global-paragraph2fontsize)",fontFamily:"var(--tempi-global-paragraph2fontfamily)",fontWeight:"var(--tempi-global-paragraph2fontweight)",lineHeight:"var(--tempi-global-paragraph2lineheight)",letterSpacing:"var(--tempi-global-paragraph2letterspacing)"},layout:r.ProductActionButtonLayout.Text,iconConfig:S}],w={align:t.Alignment.center,placeholder:e.t("product.search"),show:!0,textStyle:{currentParagraphTheme:"paragraph2",fontFamily:"var(--tempi-global-paragraph2fontfamily)"}},A={desktop:{eventType:"link",items:[],alignment:"left",layout:"grid",gridOptions:u,searchConfig:{textStyle:{fontSize:"var(--tempi-global-paragraph2fontsize)",fontWeight:"var(--tempi-global-paragraph2fontweight)",lineHeight:"var(--tempi-global-paragraph2lineheight)",letterSpacing:"var(--tempi-global-paragraph2letterspacing)"}},nameStyle:{color:"#000",fontSize:"var(--tempi-global-paragraph1fontsize)",fontWeight:"700",lineHeight:"var(--tempi-global-paragraph1lineheight)",letterSpacing:"var(--tempi-global-paragraph1letterspacing)"},priceStyle:{color:"#000",fontSize:"var(--tempi-global-paragraph2fontsize)",fontWeight:"var(--tempi-global-paragraph2fontweight)",lineHeight:"var(--tempi-global-paragraph2lineheight)",letterSpacing:"var(--tempi-global-paragraph2letterspacing)"},discountStyle:{color:"#fff",fontSize:"var(--tempi-global-paragraph3fontsize)",fontWeight:"700",lineHeight:"var(--tempi-global-paragraph3lineheight)",letterSpacing:"var(--tempi-global-paragraph3letterspacing)"},virtualSoldStyle:{color:"#000",fontSize:"var(--tempi-global-paragraph3fontsize)",fontWeight:"var(--tempi-global-paragraph3fontweight)",lineHeight:"var(--tempi-global-paragraph3lineheight)",letterSpacing:"var(--tempi-global-paragraph3letterspacing)"},paginationActiveColor:m,paginationColor:d},mobile:{eventType:"link",items:[],alignment:"left",layout:"grid",gridOptions:f,searchConfig:{textStyle:{fontSize:"var(--tempi-global-paragraph2mobilefontsize)",fontWeight:"var(--tempi-global-paragraph2mobilefontweight)",lineHeight:"var(--tempi-global-paragraph2mobilelineheight)",letterSpacing:"var(--tempi-global-paragraph2mobileletterspacing)"}},nameStyle:{color:"#000",fontSize:"var(--tempi-global-paragraph1mobilefontsize)",fontWeight:"700",lineHeight:"var(--tempi-global-paragraph1mobilelineheight)",letterSpacing:"var(--tempi-global-paragraph1mobileletterspacing)"},priceStyle:{color:"#000",fontSize:"var(--tempi-global-paragraph2mobilefontsize)",fontWeight:"var(--tempi-global-paragraph2mobilefontweight)",lineHeight:"var(--tempi-global-paragraph2mobilelineheight)",letterSpacing:"var(--tempi-global-paragraph2mobileletterspacing)"},discountStyle:{color:"#fff",fontSize:"var(--tempi-global-paragraph3mobilefontsize)",fontWeight:"700",lineHeight:"var(--tempi-global-paragraph3mobilelineheight)",letterSpacing:"var(--tempi-global-paragraph3mobileletterspacing)"},virtualSoldStyle:{color:"#000",fontSize:"var(--tempi-global-paragraph3mobilefontsize)",fontWeight:"var(--tempi-global-paragraph3mobilefontweight)",lineHeight:"var(--tempi-global-paragraph3mobilelineheight)",letterSpacing:"var(--tempi-global-paragraph3mobileletterspacing)"}},layout:"grid",currencyUnit:e.t("đ"),currencyAlignment:"right",gridOptions:{rows:4,columns:4},items:[{name:e.t("Sản phẩm 1"),price:1e5,discount:30,image:{src:"https://lh3.googleusercontent.com/8uLsW5MRqfvFIpoVhchpQN6CuMdj0hXZV7dOplezAJ6j6RSdymfMCNstJMhs_G8QNZaNwh60gAhFrjYfZr2wG4JmnKfwGDw=rw-w500"},virtualRating:5,virtualSold:100,sku:"SAMPLE00001"},{name:e.t("Sản phẩm 2"),price:1e5,discount:30,image:{src:"https://lh3.googleusercontent.com/s30ROB2cqLL_G97fr4qG8VjryAdAREIOV2pUSjq9p0IjXy8V7Jy3hf-E1f-wtA9t69JIbg4xSyNR3ck_Jnfpn4bfZ6rSmJNg=rw-w500"},virtualRating:5,sku:"SAMPLE00002"},{name:e.t("Sản phẩm 3"),price:1e5,discount:30,image:{src:"https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500"},virtualRating:5,sku:"SAMPLE00003"},{name:e.t("Sản phẩm 4"),price:1e5,discount:30,image:{src:"https://lh3.googleusercontent.com/xR9Sx8XT-vsY7F-2x4wnlGk7LXFLb2sCW1RoWtR7dTUmfrpqVvdO2F00Q8g51s7b1TYVZddlIIQXoUzRiv50Ao4k3TLQbvY=rw-w500"},virtualRating:5,sku:"SAMPLE00004"}],eventType:"showPopup",alignment:"left",nameStyle:{color:"#000",currentParagraphTheme:"paragraph1",fontFamily:"var(--tempi-global-paragraph1fontfamily)"},priceStyle:{color:"#000",currentParagraphTheme:"paragraph2",fontFamily:"var(--tempi-global-paragraph2fontfamily)"},discountStyle:{color:"#fff",backgroundColor:"#e40303",currentParagraphTheme:"paragraph3",fontFamily:"var(--tempi-global-paragraph3fontfamily)"},virtualSoldStyle:{color:"#000",currentParagraphTheme:"paragraph3",fontFamily:"var(--tempi-global-paragraph3fontfamily)"},virtualSoldTitle:e.t("product_list.sold"),orderButton:{buttonStyle:{height:32,borderRadius:16,color:"#ffffff",background:"#7367f0",padding:{left:15,right:15},hover:{backgroundColor:"#a195fc"},fontSize:14},text:e.t("Đặt hàng")},showButton:!1,showAddToCartButton:!1,addToCartButton:{buttonStyle:{borderStyle:"solid",borderColor:"#7367f0",borderWidth:1,height:32,borderRadius:16,color:"#7367f0",background:"#ffffff",padding:{left:15,right:15},hover:{backgroundColor:"#7367f0",color:"#ffffff"},fontSize:14},text:e.t("product_list.add_to_cart")},productDisplay:{filterType:r.ProductFilterType.CATEGORY,skus:[]},actionButtons:v,borderColor:"#F0F0F0",searchConfig:w,paginationActiveColor:"#7367f0",paginationColor:"#000000"},T={fields:[{name:"product.product_fields.image",type:r.ProductFieldType.Image,isActive:!0},{name:"product.product_fields.name",type:r.ProductFieldType.Name,isActive:!0},{name:"product.product_fields.price",type:r.ProductFieldType.Price,isActive:!0},{name:"product.product_fields.discount",type:r.ProductFieldType.Discount,isActive:!0},{name:"product.product_fields.virtual_rating",type:r.ProductFieldType.VirtualRating,isActive:!0},{name:"product.product_fields.virtual_sold",type:r.ProductFieldType.VirtualSold,isActive:!0}]},k=[{label:e.t("product_list.buy_now"),value:r.ProductActionButtonType.Order},{label:"product_list.add_to_cart",value:r.ProductActionButtonType.AddToCart},{label:"Liên hệ",value:r.ProductActionButtonType.Contact}],L={name:e.t("Tên khách hàng"),phoneNumber:e.t("Số điện thoại"),address:e.t("Địa chỉ"),note:e.t("Thông tin bổ sung"),productName:e.t("Tên sản phẩm"),price:e.t("Giá bán")};e.t("Tên"),e.t("Nhập họ và tên"),e.t("Số điện thoại"),e.t("Nhập số điện thoại"),e.t("Địa chỉ"),e.t("Nhập địa chỉ nhận hàng"),e.t("Thông tin bổ sung"),e.t("Thông tin bổ sung cho người bán.\\nVD: Số lượng, kích thước, giao giờ hành chính...");const P=[{tag:"Grid",group:e.t("Dạng lưới"),props:c(s({},A),{gridOptions:{displayMode:r.DisplayModeType.All,rows:1,columns:4},desktop:c(s({},A.desktop),{gridOptions:{displayMode:r.DisplayModeType.All,rows:1,columns:4}}),items:[{name:e.t("New product"),price:2e5,image:{src:"https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500"},sku:"SAMPLE00001"},{name:e.t("New product"),price:2e5,image:{src:"https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500"},sku:"SAMPLE00002"},{name:e.t("New product"),price:2e5,image:{src:"https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500"},sku:"SAMPLE00003"},{name:e.t("New product"),price:2e5,image:{src:"https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500"},sku:"SAMPLE00004"}]}),src:"https://lh3.googleusercontent.com/xPDYw-BXh6mmJJSn-rmuhyAndn3eUgOgalyYUgA0uTNbBhYI7BbogePnsuCqr9FVcgB4V6H8y1IdJCzkY8B6VtQwM9He2Vb7"},{tag:"Carousel",group:e.t("Dạng trượt"),props:c(s({},A),{layout:"carousel",carouselOptions:{slidesPerView:4},desktop:c(s({},A.desktop),{layout:"carousel",carouselOptions:{slidesPerView:4}}),items:[{name:e.t("New product"),price:2e5,image:{src:"https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500"},sku:"SAMPLE00001"},{name:e.t("New product"),price:2e5,image:{src:"https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500"},sku:"SAMPLE00002"},{name:e.t("New product"),price:2e5,image:{src:"https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500"},sku:"SAMPLE00003"},{name:e.t("New product"),price:2e5,image:{src:"https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500"},sku:"SAMPLE00004"}]}),src:"https://lh3.googleusercontent.com/L3J3dn_nPzpMJ6x5MLwyDMXXOtrjds1aIl5lReZYo-guciV15J8OwpAZtRIsaQyaizm3GSEf7mW6YXhJ71H8hX5p850b5aMUew"}];exports.DATA_KEYS=L,exports.DEFAULT_ACTION_BUTTONS=v,exports.DEFAULT_ACTION_BUTTONS_STYLE={borderStyle:"solid",borderColor:"#7367f0",borderWidth:1,height:32,width:"100%",borderRadius:2,color:"#ffffff",background:"#7367f0",padding:{left:15,right:15},currentParagraphTheme:"paragraph2",fontSize:"var(--tempi-global-paragraph2fontsize)",fontFamily:"var(--tempi-global-paragraph2fontfamily)",fontWeight:"var(--tempi-global-paragraph2fontweight)",lineHeight:"var(--tempi-global-paragraph2lineheight)",letterSpacing:"var(--tempi-global-paragraph2letterspacing)"},exports.DEFAULT_ACTION_BUTTON_TYPE_OPTIONS=k,exports.DEFAULT_ADD_TO_CART_BUTTONS_STYLE={borderStyle:"solid",borderColor:"#7367f0",borderWidth:0,height:32,width:"100%",borderRadius:2,color:"#7367f0",background:"#7367F014",padding:{left:15,right:15},currentParagraphTheme:"paragraph2",fontSize:"var(--tempi-global-paragraph2fontsize)",fontFamily:"var(--tempi-global-paragraph2fontfamily)",fontWeight:"var(--tempi-global-paragraph2fontweight)",lineHeight:"var(--tempi-global-paragraph2lineheight)",letterSpacing:"var(--tempi-global-paragraph2letterspacing)"},exports.DEFAULT_ICON_CONFIG=S,exports.DEFAULT_PAGINATION_ACTIVE_COLOR=m,exports.DEFAULT_PAGINATION_COLOR=d,exports.DEFAULT_PRODUCT_LIST=A,exports.DEFAULT_SEARCH_BAR=w,exports.MOCK_PRODUCT_LIST_DATA=[{sku:"SAMPLE00001",sellerSku:"SELLER00001",name:"Sản phẩm mẫu",price:1e5,categoryId:1,uom:"Cái",rating:5,fakePurchases:100,discountPercent:.3,link:"https://www.teko.vn/san-pham-1",images:["https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500"],descriptionDetail:"Description for Sản phẩm 1"},{sku:"SAMPLE00002",sellerSku:"SELLER00002",name:"Sản phẩm 2",price:2e5,categoryId:2,uom:"Cái",rating:4.5,fakePurchases:200,discountPercent:.2,link:"https://www.teko.vn/san-pham-2",images:["https://lh3.googleusercontent.com/s30ROB2cqLL_G97fr4qG8VjryAdAREIOV2pUSjq9p0IjXy8V7Jy3hf-E1f-wtA9t69JIbg4xSyNR3ck_Jnfpn4bfZ6rSmJNg=rw-w500"],descriptionDetail:"Description for Sản phẩm 2"},{sku:"SAMPLE00003",sellerSku:"SELLER00003",name:"Sản phẩm 3",price:3e5,categoryId:3,uom:"Cái",rating:4,fakePurchases:300,discountPercent:.1,link:"https://www.teko.vn/san-pham-3",images:["https://lh3.googleusercontent.com/8uLsW5MRqfvFIpoVhchpQN6CuMdj0hXZV7dOplezAJ6j6RSdymfMCNstJMhs_G8QNZaNwh60gAhFrjYfZr2wG4JmnKfwGDw=rw-w500"],descriptionDetail:"Description for Sản phẩm 3"},{sku:"SAMPLE00004",sellerSku:"SELLER00004",name:"Sản phẩm 4",price:4e5,categoryId:4,uom:"Cái",rating:3.5,fakePurchases:400,discountPercent:.05,link:"https://www.teko.vn/san-pham-4",images:["https://lh3.googleusercontent.com/xR9Sx8XT-vsY7F-2x4wnlGk7LXFLb2sCW1RoWtR7dTUmfrpqVvdO2F00Q8g51s7b1TYVZddlIIQXoUzRiv50Ao4k3TLQbvY=rw-w500"],descriptionDetail:"Description for Sản phẩm 4"}],exports.PRODUCT_FIELDS=T,exports.SAMPLE_PRODUCT_LIST=P,exports.defaultCarouselOptions=b,exports.defaultGridOptions=u,exports.defaultMobileCarouselOptions=y,exports.defaultMobileGridOptions=f;


/***/ }),

/***/ 154407:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097),t=__webpack_require__(891987),r=__webpack_require__(800886),s=__webpack_require__(15161);exports.useProducts=i=>{const{skus:o,categoryId:a,ssrData:l,triggerUpdate:u=!1,isFetchCategories:c=!1,filterType:n,productOrder:d}=i,[p,g]=t.useState(l),[v,f]=t.useState([]),{env:m,globalData:y}=e.useStore(),[h,w]=t.useState(!0),[b,I]=t.useState(""),S=t.useCallback((()=>{const t=`${e.pinposBffUrl[m]}/api/v1/public/categories`,r=new e.Api(t),s=async(e=0,i=1e3)=>{var o;try{const e=await r.get(t,{params:{websiteId:y.websiteId}});f(null==(o=null==e?void 0:e.data)?void 0:o.data)}catch(t){console.error(`Attempt ${e+1} failed:`,t),e<3?setTimeout((()=>{s(e+1,4*i)}),i):console.error("Max retries reached:",t)}};s()}),[m,y.websiteId]),P=()=>{const t=`${e.pinposBffUrl[m]}/api/v1/public/products/search`,i=new e.Api(t);w(!0);const l={websiteId:y.websiteId,page:1,pageSize:999};n===r.ProductFilterType.SKUS&&(null==o?void 0:o.length)?l.skus=o:n===r.ProductFilterType.CATEGORY&&a&&(l.categoryId=+a);const u=async(e=0,r=1e3)=>{var o,a;try{const e=await i.post(t,l);let r=(e=>null==e?void 0:e.map((e=>({name:e.name,price:+e.price,discount:e.discountPercent,image:{src:e.images[0]},virtualRating:e.rating,virtualSold:+e.fakePurchases,sku:e.sku,categoryId:+e.categoryId,link:e.link,description:e.descriptionDetail,images:e.images}))))(null==(a=null==(o=null==e?void 0:e.data)?void 0:o.data)?void 0:a.products);(null==d?void 0:d.length)&&(r=s.sortProducts(r,d)),g(r),w(!1)}catch(t){console.error(`Attempt ${e+1} failed:`,t),e<3?setTimeout((()=>{u(e+1,4*r)}),r):(console.error("Max retries reached:",t),w(!1))}};u()};return t.useEffect((()=>{c&&S()}),[c,y.websiteId,S,u]),t.useEffect((()=>{P()}),[o,a,null==y?void 0:y.websiteId,u,n]),t.useEffect((()=>{if((null==d?void 0:d.length)&&(null==p?void 0:p.length)){const e=s.sortProducts(p,d);g(e)}else g(p)}),[d]),{products:t.useMemo((()=>{if(!b)return p;const e=b.toLowerCase();return null==p?void 0:p.filter((t=>{var r;return null==(r=null==t?void 0:t.name)?void 0:r.toLowerCase().includes(e)}))}),[p,b]),loading:h||!p,fetchProducts:P,categories:v,searchQuery:b,setSearchQuery:I}};


/***/ }),

/***/ 800886:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=(t=>(t.CATEGORY="filter_by_category",t.SKUS="filter_by_skus",t))(t||{}),o=(t=>(t.Name="name",t.Price="price",t.Image="image",t.Discount="discount",t.VirtualRating="virtualRating",t.VirtualSold="virtualSold",t.Description="description",t.ActionButton="actionButton",t))(o||{}),e=(t=>(t.Order="order",t.AddToCart="addToCart",t.Contact="contact",t))(e||{}),r=(t=>(t.Icon="icon",t.Text="text",t.Combined="combined",t))(r||{}),i=(t=>(t.All="ALL",t.Pagination="PAGINATION",t))(i||{});exports.DisplayModeType=i,exports.ProductActionButtonLayout=r,exports.ProductActionButtonType=e,exports.ProductFieldType=o,exports.ProductFilterType=t;


/***/ }),

/***/ 326485:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(85097),t=__webpack_require__(891987),o=__webpack_require__(15161),i=__webpack_require__(841870),u=__webpack_require__(154407),s=__webpack_require__(212951),c=__webpack_require__(760339),d=__webpack_require__(318610),n=__webpack_require__(105122),a=__webpack_require__(673532),l=__webpack_require__(373476),p=__webpack_require__(209325),y=__webpack_require__(481177),g=__webpack_require__(512005);function P(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var f=P(s),m=Object.defineProperty,j=Object.defineProperties,S=Object.getOwnPropertyDescriptors,v=Object.getOwnPropertySymbols,h=Object.prototype.hasOwnProperty,q=Object.prototype.propertyIsEnumerable,O=(e,r,t)=>r in e?m(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,x=(e,r)=>{for(var t in r||(r={}))h.call(r,t)&&O(e,t,r[t]);if(v)for(var t of v(r))q.call(r,t)&&O(e,t,r[t]);return e},b=(e,r)=>j(e,S(r)),E=(e,r)=>{var t={};for(var o in e)h.call(e,o)&&r.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&v)for(var o of v(e))r.indexOf(o)<0&&q.call(e,o)&&(t[o]=e[o]);return t};const C=r=>{var t=r,{wrapperRef:o,orderPopupId:i,layout:u,isEditingMode:s,products:c}=t,n=E(t,["wrapperRef","orderPopupId","layout","isEditingMode","products"]);const{buyNow:a}=g.useCartStore(),y=e=>{var r,t;a(e),null==(t=null==(r=o.current)?void 0:r.ownerDocument.querySelector(`[data-uniq-id="${i}"]`))||t.click()},{setSelectedProduct:P}=d.useSelectedProduct(),f="showPopup"===(null==n?void 0:n.eventType)?e=>{P(e)}:void 0;return"carousel"===u?e.jsx(l.ProductCarousel,b(x({isEditingMode:s},n),{items:c,layout:u,onClick:f,handleClickOrder:y})):e.jsx(p.ProductGrid,b(x({isEditingMode:s},n),{items:c,layout:u,onClick:f,handleClickOrder:y}))},w=s=>{var l=s,{isEditingMode:p,configStorage:g,children:P,orderPopupId:f,ssrData:m,triggerUpdate:j,className:S}=l,v=E(l,["isEditingMode","configStorage","children","orderPopupId","ssrData","triggerUpdate","className"]);const{device:h}=r.useStore(),q=o.getProductPropByDevice(v,y.PROP_KEY.Layout,h,v.layout),{filterType:O,categoryId:w,skus:D,productOrder:M}=v.productDisplay||{},I=t.useRef(),{products:L,loading:N,searchQuery:R,setSearchQuery:T}=u.useProducts({skus:D,categoryId:w,ssrData:m,triggerUpdate:j,filterType:O,productOrder:M}),{commonStyle:U,currencyAlignment:B,searchConfig:A}=r.getPropsByDevice(v,h),{show:G,placeholder:_,align:F,colorStyle:K,textStyle:Q}=A||{},{updateProductForPopup:V,updateCurrencyConfig:$}=c.useProductListStore(),{productDetailPopup:Y,currencyUnit:z}=v;return t.useEffect((()=>{p&&V(Y,L)}),[L,p,Y,V]),t.useEffect((()=>{$(Y,{currencyUnit:z,currencyAlignment:B})}),[z,B,Y,$]),e.jsx(d.SelectedProductProvider,{children:e.jsxs(k,{ref:I,commonStyle:U,className:S,"data-id":v.id,children:[N?e.jsx(n.Loading,{}):e.jsxs(e.Fragment,{children:[G&&e.jsx(a.SearchBar,{isEditingMode:p,placeholder:_,onChange:T,value:R,align:F,textStyle:Q,colorStyle:K}),(null==L?void 0:L.length)>0?e.jsx(C,b(x({},v),{wrapperRef:I,orderPopupId:f,layout:q,isEditingMode:p,products:L,currencyAlignment:B})):e.jsx(i.ProductEmpty,{})]}),P]})})},k=f.default.div((({commonStyle:e})=>`${r.getStyle(e)};`));w.displayName="TempiProductListV3",exports.TempiProductListV3=w;


/***/ }),

/***/ 15161:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(47248),t=__webpack_require__(481177);function r(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var o=r(e),n=Object.defineProperty,i=Object.getOwnPropertySymbols,u=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,s=(e,t,r)=>t in e?n(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,l=(e,t)=>{for(var r in t||(t={}))u.call(t,r)&&s(e,r,t[r]);if(i)for(var r of i(t))f.call(t,r)&&s(e,r,t[r]);return e};exports.getProductPropByDevice=(e,r,n,i)=>{if(n){const i=o.default(e,t.PROP_KEY.joinKey(n,r));if(i)return i}if("mobile"===n){const n=o.default(e,t.PROP_KEY.joinKey("desktop",r));if(n)return n}if("desktop"===n||!n){const t=o.default(e,r);if(t)return t}return i},exports.getProductPropsByDeviceV2=(e,r,n,i)=>{if("desktop"===n){const i=o.default(e,t.PROP_KEY.joinKey(n,r));if(i)return i}if("mobile"===n){const n=o.default(e,t.PROP_KEY.joinKey("mobile",r)),i=o.default(e,t.PROP_KEY.joinKey("desktop",r));if(i||n)return l(l({},i),n)}return o.default(e,r)||i},exports.sortProducts=(e,t=[])=>[...e].sort(((e,r)=>{const o=t.indexOf(e.sku),n=t.indexOf(r.sku);return-1===o&&-1===n?0:-1===o?-1:-1===n?1:o-n}));


/***/ }),

/***/ 707777:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),o=__webpack_require__(85097),n=__webpack_require__(109873),t=__webpack_require__(891987),l=__webpack_require__(879774);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=i(r),d=Object.defineProperty,s=Object.defineProperties,c=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,f=Object.prototype.hasOwnProperty,b=Object.prototype.propertyIsEnumerable,p=(e,r,o)=>r in e?d(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,v=(e,r)=>{for(var o in r||(r={}))f.call(r,o)&&p(e,o,r[o]);if(u)for(var o of u(r))b.call(r,o)&&p(e,o,r[o]);return e};const y=t.forwardRef(((r,i)=>{const a=r,{value:d,qrCodeStyle:p,bordered:y=!0,className:j,id:x}=a,C=((e,r)=>{var o={};for(var n in e)f.call(e,n)&&r.indexOf(n)<0&&(o[n]=e[n]);if(null!=e&&u)for(var n of u(e))r.indexOf(n)<0&&b.call(e,n)&&(o[n]=e[n]);return o})(a,["value","qrCodeStyle","bordered","className","id"]),{device:O}=o.useStore(),{size:P,commonStyle:N,alignment:q=l.MAPPING_VERTICAL_ALIGNMENT_FLEX.center}=o.getPropsByDevice(C,O),S=t.useMemo((()=>({value:d,size:P,level:"M",bgColor:(null==p?void 0:p.backgroundColor)||"transparent",fgColor:null==p?void 0:p.color})),[p,P,d]);return e.jsx(g,{ref:i,align:q,className:j,"data-id":x,children:e.jsx(m,(h=v({commonStyle:N},{size:P,bordered:y,backgroundColor:null==p?void 0:p.backgroundColor}),w={children:e.jsx(n.QRCodeCanvas,v({},S))},s(h,c(w))))});var h,w}));y.displayName="QRCode";const g=a.default.div((({align:e})=>`\n  display: flex;\n  justify-content: ${l.MAPPING_ALIGNMENT_FLEX[e]};\n`)),m=a.default.div((({size:e,backgroundColor:r,bordered:n,commonStyle:t})=>`\n  box-sizing: border-box;\n  margin: 0;\n  list-style: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ${r||"#fff"};\n  border-radius: 8px;\n  ${n?"border: 1px solid rgba(5, 5, 5, 0.06);":""}\n  position: relative;\n  width: ${e};\n  height: ${e};\n  overflow: hidden;\n  ${o.getStyle(t)};\n`));exports.QRCode=y;


/***/ }),

/***/ 559701:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),n=__webpack_require__(85097),o=__webpack_require__(891987),i=__webpack_require__(534479);function r(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const l=r(t).default.div((({commonStyle:e,isEditor:t,pageFontType:o})=>(o===i.PageFontTypeEnum.HEADING?e.fontFamily="var(--tempi-global-heading1fontfamily)":o===i.PageFontTypeEnum.PARAGRAPH&&(e.fontFamily="var(--tempi-global-paragraph1fontfamily)"),`\n    min-height: 100vh;\n    overflow: hidden;\n    \n    ${t?"padding-bottom: 20px;":""}\n    ${(null==e?void 0:e.backgroundOverlay)?"z-index: 0;":""}\n    ${n.getStyle(e)};\n  `))),a=t=>{const r=o.useRef(null),{device:a,featureFlags:d}=n.useStore(),m=null==d?void 0:d.flagWebsiteTheme,u=n.getPropsByDevice(t,a),{children:f,commonStyle:p,isEditor:s,pageFontType:y}=u;return o.useEffect((()=>{var e;const t=null==(e=null==r?void 0:r.current)?void 0:e.ownerDocument;if(!(null==p?void 0:p.fontFamily)||!t)return;const n="tempi-root-font-family";let o=p.fontFamily;m&&(y===i.PageFontTypeEnum.HEADING?o="var(--tempi-global-heading1fontfamily)":y===i.PageFontTypeEnum.PARAGRAPH&&(o="var(--tempi-global-paragraph1fontfamily)"));const l=`\n      body {\n        font-family: ${o};\n      }\n    `,a=t.getElementById(n);if(a)a.textContent=l;else{const e=t.createElement("style");e.id=n,e.textContent=l,t.head.appendChild(e)}return()=>{const e=t.getElementById(n);e&&e.parentNode&&e.parentNode.removeChild(e)}}),[null==p?void 0:p.fontFamily,y,m]),e.jsx(n.BreakpointWidthProvider,{sWidth:{value:100,unit:"%"},mWidth:{value:100,unit:"%"},children:e.jsx(l,{ref:r,commonStyle:p,isEditor:s,pageFontType:m?y:void 0,children:f})})};a.displayName="Root",exports.Root=a;


/***/ }),

/***/ 570203:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097),t=__webpack_require__(891987);exports.useIgnoreElementTotalHeight=n=>{const[r,o]=t.useState(0);return t.useEffect((()=>{const t=()=>{var t;const i=null==n?void 0:n.map((e=>`[data-uniq-id="${e}"]`));if(!(null==i?void 0:i.length)&&!r)return;let u=0;if(null==i?void 0:i.length){const n=((null==(t=null==document?void 0:document.querySelector(`#${e.TEMPI_MAIN_IFRAME}`))?void 0:t.contentDocument)||document).querySelectorAll(i.join(","));null==n||n.forEach((e=>{u+=e.getBoundingClientRect().height}))}o(u)},i=e.debounce((()=>t()),200);return t(),window.addEventListener("resize",i),()=>{window.removeEventListener("resize",i)}}),[n]),{totalIgnoreHeight:r}};


/***/ }),

/***/ 510690:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097),n=__webpack_require__(877084),i=__webpack_require__(891987),l=__webpack_require__(930907),o=__webpack_require__(879774),u=__webpack_require__(570203);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=a(t),s=a(n),d=a(i),g=Object.defineProperty,m=Object.defineProperties,v=Object.getOwnPropertyDescriptors,f=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,b=Object.prototype.propertyIsEnumerable,h=(e,t,r)=>t in e?g(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,y=(e,t)=>{for(var r in t||(t={}))p.call(t,r)&&h(e,r,t[r]);if(f)for(var r of f(t))b.call(t,r)&&h(e,r,t[r]);return e},A=(e,t)=>m(e,v(t));const j=c.default(l.Row)((({verticalAlignment:e,commonStyle:t})=>`\n  ${r.getStyle(t,{lazyBgImage:!0})}\n  align-items: ${o.MAPPING_VERTICAL_ALIGNMENT_FLEX[e]||o.MAPPING_VERTICAL_ALIGNMENT_FLEX.top};\n`)),E=d.default.forwardRef(((t,n)=>{var l,o,a,c,d,g,m;const v=t,{children:h,verticalAlignment:E,gutter:I,className:O,ignoreHeightElements:_}=v,N=((e,t)=>{var r={};for(var n in e)p.call(e,n)&&t.indexOf(n)<0&&(r[n]=e[n]);if(null!=e&&f)for(var n of f(e))t.indexOf(n)<0&&b.call(e,n)&&(r[n]=e[n]);return r})(v,["children","verticalAlignment","gutter","className","ignoreHeightElements"]),{device:P}=r.useStore(),{commonStyle:S}=r.getPropsByDevice(N,P),{backgroundType:k,backgroundVideo:L}=S||{};let x=I;x="mobile"===P?null!=(c=null!=(a=null==(l=N.mobile)?void 0:l.gutter)?a:null==(o=N.desktop)?void 0:o.gutter)?c:I:null!=(g=null==(d=N.desktop)?void 0:d.gutter)?g:I;const w=i.useRef(null),B=n||w,q=r.useIntersectionObserver(B,{freezeOnceVisible:!0}),{totalIgnoreHeight:H}=u.useIgnoreElementTotalHeight(_),{style:R,animationClassName:T}=r.useAnimation(null==S?void 0:S.animation,w);return e.jsx("div",{children:e.jsxs(j,A(y({verticalAlignment:E,ref:e=>{"function"==typeof n?n(e):n&&(n.current=e),w.current=e},style:R,gutter:x||[16,16],className:s.default(O,{[r.BG_LAZY_CLASS_NAME]:!0,[r.BG_VISIBLE_LAZY_CLASS_NAME]:q},T)},N),{commonStyle:A(y({},S),{minHeight:"100vh"===((null==S?void 0:S.minHeight)||(null==S?void 0:S.height))?`calc(100vh - ${H}px)`:(null==S?void 0:S.minHeight)||(null==S?void 0:S.height)||"auto",height:void 0,heightUnit:void 0}),children:[(!k&&L||k===r.BackgroundType.VIDEO)&&e.jsx(r.BackgroundVideo,A(y({},L||{}),{background:null==(m=null==S?void 0:S.background)?void 0:m.toString(),backgroundBlur:null==S?void 0:S.backgroundBlur})),h]}))})}));E.displayName=l.Row.displayName,exports.PbRow=E;


/***/ }),

/***/ 543729:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261);const t=({text:t})=>e.jsx(e.Fragment,{children:t});t.displayName="Tempi Sample",exports.SampleComponent=t;


/***/ }),

/***/ 818959:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=Object.defineProperty,t=Object.defineProperties,o=Object.getOwnPropertyDescriptors,r=Object.getOwnPropertySymbols,a=Object.prototype.hasOwnProperty,i=Object.prototype.propertyIsEnumerable,l=(t,o,r)=>o in t?e(t,o,{enumerable:!0,configurable:!0,writable:!0,value:r}):t[o]=r,p=(e,t)=>{for(var o in t||(t={}))a.call(t,o)&&l(e,o,t[o]);if(r)for(var o of r(t))i.call(t,o)&&l(e,o,t[o]);return e},n=(e,r)=>t(e,o(r));const g={textConfig:{text:"Tìm kiếm",show:!0,textDecoration:void 0,textTransform:void 0,fontSize:16,fontWeight:400,lineHeight:void 0,letterSpacing:void 0,color:"#000000",textLevel:"p",placeholderColor:"#d9d9d9"},iconConfig:{color:"#9aa0a6",show:!0,autoSize:!0,size:24},desktop:{textConfig:{fontSize:16,fontWeight:"400"}},mobile:{textConfig:{fontSize:14,fontWeight:"400"}},commonStyle:{width:100,height:60,backgroundColor:"#ffffff",borderRadius:6,shadow:{color:"rgba(0, 0, 0, 0.15)",blur:20,spread:0,x:4,y:4}}},f=n(p({},g),{textConfig:n(p({},g.textConfig),{fontFamily:"var(--tempi-global-paragraph1fontfamily)",currentParagraphTheme:"paragraph1"}),desktop:{textConfig:{fontSize:"var(--tempi-global-paragraph1fontsize)",fontWeight:"var(--tempi-global-paragraph1fontweight)",lineHeight:"var(--tempi-global-paragraph1lineheight)",letterSpacing:"var(--tempi-global-paragraph1letterspacing)"}},mobile:{textConfig:{fontSize:"var(--tempi-global-paragraph1mobilefontsize)",fontWeight:"var(--tempi-global-paragraph1mobilefontweight)",lineHeight:"var(--tempi-global-paragraph1mobilelineheight)",letterSpacing:"var(--tempi-global-paragraph1mobileletterspacing)"}}});exports.DEFAULT_SEARCH=g,exports.DEFAULT_SEARCH_THEME=f;


/***/ }),

/***/ 134496:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(891987),i=__webpack_require__(212951),o=__webpack_require__(75537),r=__webpack_require__(85097),n=__webpack_require__(143599),l=__webpack_require__(987573),s=__webpack_require__(818959);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=a(i),c=Object.getOwnPropertySymbols,u=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,p=(e,t)=>{var i={};for(var o in e)u.call(e,o)&&t.indexOf(o)<0&&(i[o]=e[o]);if(null!=e&&c)for(var o of c(e))t.indexOf(o)<0&&f.call(e,o)&&(i[o]=e[o]);return i};const h=t.forwardRef(((i,o)=>{const a=i,{isEditor:d,iconConfig:c,id:u}=a,f=p(a,["isEditor","iconConfig","id"]),{device:h}=r.useStore(),{textConfig:g,commonStyle:k}=r.getPropsByDevice(f,h),z=g,{text:$,show:E}=z,P=p(z,["text","show"]),{color:M,show:R,autoSize:I,size:L=s.DEFAULT_SEARCH.iconConfig.size}=c,D=k||{},{height:T,width:_}=D,H=p(D,["height","width"]),[A,F]=t.useState(""),N=t.useRef(null),B=t.useRef(null),{globalData:U={}}=r.useStore(),{websiteId:G,currentLanguage:J,isPreviewMode:K}=U||{},{searchResults:Q,loading:V,debouncedSearch:W,hasMore:X,loadMore:Y,total:Z}=l.useSearch({websiteId:G,pageSize:10,websiteTranslationId:null==J?void 0:J.id}),ee=t.useCallback((e=>{if(d)return;e.preventDefault(),e.stopPropagation();const t=e.target.value;F(t),W(t)}),[W,d]),te=t.useCallback((()=>{var e;F(""),W(""),null==(e=B.current)||e.focus()}),[W]),ie=t.useCallback((()=>{if(!N.current)return;const{scrollTop:e,scrollHeight:t,clientHeight:i}=N.current;e>=t-i-100&&X&&!V&&Y()}),[V,X,Y]);t.useEffect((()=>{const e=N.current;if(e)return e.addEventListener("scroll",ie),()=>e.removeEventListener("scroll",ie)}),[ie]);const oe=A.trim(),re=""!==oe&&Q.length>0,ne=""!==oe&&0===Q.length;return e.jsxs(m,{ref:o,"data-id":u,commonStyle:H,width:+_,children:[V&&e.jsx(q,{}),e.jsx(b,{height:+T,children:e.jsxs(v,{children:[R&&e.jsx(y,{onClick:oe?te:void 0,style:{color:M,fontSize:I?"2em":L},children:e.jsx(n.Icon,{name:oe?"CloseOutlined":"SearchOutlined"})}),e.jsx(w,{ref:B,placeholder:E?$:"",commonStyle:P,value:A,onChange:ee,autoFocus:!0})]})}),e.jsxs(j,{ref:N,showResults:re,children:[re&&e.jsxs(C,{children:[Z," results"]}),e.jsx(S,{visible:re,children:Q.map(((t,i)=>e.jsx(x,{item:t,currentLanguage:J,isPreviewMode:K},i)))}),ne&&e.jsx(O,{children:void 0===V||V?"":"No results found"})]})]})})),x=({item:i,currentLanguage:o,isPreviewMode:r})=>{const{extraInfo:n,description:l,name:s,slug:a}=i||{},{metaDescription:d,metaTitle:c}=n||{},u=t.useMemo((()=>(null==o?void 0:o.languageCode)?`${location.origin}/${o.languageCode}/${a}`:`${location.origin}/${a}`),[o,a]),f=t.useCallback((()=>{r||window.open(u,"_self")}),[r,u]);return e.jsxs(k,{onClick:f,children:[e.jsx(z,{children:c||s}),e.jsx($,{children:d||l})]})};h.displayName="Search";const g=o.keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`,m=d.default.div((({commonStyle:e,width:t})=>`\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  max-height: 70vh;\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  ${r.getStyle(e)}\n  width: ${t}%;\n`)),b=d.default.div((({height:e})=>`\n  display: flex;\n  flex-direction: column;\n  padding: 8px 4px;\n  height: ${e}px;\n`)),v=d.default.div`
  display: flex;
  align-items: center;
  padding: 8px;
  height: 100%;
`,y=d.default.span`
  margin-right: 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }
`,w=d.default.input`
  border: none;
  outline: none;
  width: 100%;
  transition: all 0.2s ease;
  background-color: transparent;
  ${e=>r.getStyle(e.commonStyle)}
`,j=d.default.div`
  flex: 1;
  overflow-y: auto;
  max-height: 60vh;
  border-top: ${e=>e.showResults?"1px solid #ebebeb":"none"};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  position: relative;
`,S=d.default.div`
  opacity: ${e=>e.visible?1:0};
  max-height: ${e=>e.visible?"100%":"0"};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`,C=d.default.div`
  padding: 12px 16px;
  font-size: 14px;
  color: #70757a;
  opacity: 1;
  transition: opacity 0.3s ease;
`,k=d.default.div`
  padding: 16px;
  border-bottom: 1px solid #f5f5f5;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    background-color: #f9f9f9;
  }

  &:last-child {
    border-bottom: none;
    margin-bottom: 12px;
  }
`,z=d.default.div`
  font-size: 16px;
  color: #202124;
  text-decoration: none;
  font-weight: 500;
  display: block;
  margin-bottom: 8px;
  line-height: 1.3;
  transition: color 0.2s ease;
`,$=d.default.div`
  font-size: 14px;
  color: #5f6368;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 4.2em;
  transition: all 0.3s ease;
`,O=d.default.div`
  padding: 32px 16px;
  text-align: center;
  color: #5f6368;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 200px;
  opacity: 1;
  transition: opacity 0.3s ease;
  flex: 1;
  height: 350px;
`,q=d.default.div`
  width: 24px;
  height: 24px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #7367f0;
  border-radius: 50%;
  animation: ${g} 1s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
`;exports.Search=h;


/***/ }),

/***/ 243898:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(85097),r=__webpack_require__(891987),o=__webpack_require__(954591),i=__webpack_require__(728379),n=__webpack_require__(510690),l=__webpack_require__(570203);function u(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=u(r),d=Object.defineProperty,c=Object.defineProperties,g=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,m=Object.prototype.hasOwnProperty,s=Object.prototype.propertyIsEnumerable,v=(e,t,r)=>t in e?d(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,h=(e,t)=>{for(var r in t||(t={}))m.call(t,r)&&v(e,r,t[r]);if(p)for(var r of p(t))s.call(t,r)&&v(e,r,t[r]);return e},b=(e,t)=>c(e,g(t));const f=a.default.forwardRef(((r,u)=>{var a,d,c,g,v,f,y,j,x,O;const w=r,{children:k,verticalAlignment:P,widthType:S,row:H,gutter:q,ignoreHeightElements:E}=w,T=((e,t)=>{var r={};for(var o in e)m.call(e,o)&&t.indexOf(o)<0&&(r[o]=e[o]);if(null!=e&&p)for(var o of p(e))t.indexOf(o)<0&&s.call(e,o)&&(r[o]=e[o]);return r})(w,["children","verticalAlignment","widthType","row","gutter","ignoreHeightElements"]),{device:B}=t.useStore(),{commonStyle:I}=t.getPropsByDevice(T,B),{backgroundType:W,backgroundVideo:$}=I||{};let A=q;A="mobile"===B?null!=(g=null!=(c=null==(a=T.mobile)?void 0:a.gutter)?c:null==(d=T.desktop)?void 0:d.gutter)?g:q:null!=(f=null==(v=T.desktop)?void 0:v.gutter)?f:q;const{maxWidth:D,height:R,minHeight:V}=I||{},{totalIgnoreHeight:_}=l.useIgnoreElementTotalHeight(E);let C=null==H?void 0:H.commonStyle;return C=b(h({},C),{minHeight:"100vh"===(V||R)?`calc(100vh  - ${_}px - ${((null==(y=null==I?void 0:I.padding)?void 0:y.bottom)||0)+((null==(j=null==I?void 0:I.padding)?void 0:j.top)||0)}${(null==(x=null==I?void 0:I.padding)?void 0:x.unit)||"px"})`:V||R||"auto",height:"auto"}),(null==C?void 0:C.maxWidth)&&(C=h({marginLeft:"auto !important",marginRight:"auto !important"},C)),e.jsxs(i.PbContainer,b(h({maxWidth:D,fluid:S===o.WidthTypeEnum.full,ref:u,commonStyle:b(h({},I),{minHeight:"100vh"===(V||R)?`calc(100vh - ${_}px)`:V||R||"auto",height:"auto"})},T),{children:[(!W&&$||W===t.BackgroundType.VIDEO)&&e.jsx(t.BackgroundVideo,b(h({},$||{}),{background:null==(O=null==I?void 0:I.background)?void 0:O.toString(),backgroundBlur:null==I?void 0:I.backgroundBlur})),e.jsx(n.PbRow,{commonStyle:C,verticalAlignment:P,gutter:A,children:k})]}))}));f.displayName="Section",exports.PbSection=f;


/***/ }),

/***/ 439205:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.ADVANCED_SLIDER_DISPLAY_NAME="AdvancedSlider",exports.ADVANCED_SLIDER_ITEM_DISPLAY_NAME="AdvancedSliderItem",exports.DEFAULT_ADVANCED_SLIDER={slidesPerView:1,paginationColor:"rgba(37, 141, 255, 1)",paginationDeactiveColor:"rgba(221, 221, 221, 1)",pagination:!0,autoplay:!1,loop:!1,speed:3e3,commonStyle:{height:350}},exports.DEFAULT_ADVANCED_SLIDER_ITEM={commonStyle:{justifyContent:"center",padding:{left:48,right:48}}},exports.DEFAULT_ADVANCED_SLIDER_SLIDERS=[{title:"Slide 1"},{title:"Slide 2"},{title:"Slide 3"}],exports.getTitleNextSlide=e=>`Slide ${e?e+1:"new"}`;


/***/ }),

/***/ 643452:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(85097),n=__webpack_require__(891987),i=__webpack_require__(439205),o=__webpack_require__(913658),l=__webpack_require__(84140);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=a(r),c=Object.defineProperty,u=Object.defineProperties,s=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,v=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,y=(e,r,t)=>r in e?c(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,S=(e,r)=>{for(var t in r||(r={}))v.call(r,t)&&y(e,t,r[t]);if(p)for(var t of p(r))f.call(r,t)&&y(e,t,r[t]);return e},h=(e,r)=>{var t={};for(var n in e)v.call(e,n)&&r.indexOf(n)<0&&(t[n]=e[n]);if(null!=e&&p)for(var n of p(e))r.indexOf(n)<0&&f.call(e,n)&&(t[n]=e[n]);return t};const m={navigation:!0,spaceBetween:12,pauseOnMouseEnter:!0,virtual:!1,crop:!0},w={autoPlay:!1,loop:!1},j=n.forwardRef(((r,i)=>{var a=r,{children:d,isEditorMode:c,isActive:p,handleSelectSlideItem:v,id:f}=a,y=h(a,["children","isEditorMode","isActive","handleSelectSlideItem","id"]);const{device:j}=t.useStore(),g=t.getPropsByDevice(y,j),{commonStyle:x,slidesPerView:A=1,autoplay:O}=g,P=h(g,["commonStyle","slidesPerView","autoplay"]),M=!c&&O,E=n.useRef(null),{updateSwiperCurrent:I,updateActiveIndex:q,updateTotalSlide:D,updateSlidePerView:C}=l.useSwiperStore();return n.useEffect((()=>{var e,r;if(!p||!c)return;C(A),I(E.current),q(null==(e=E.current)?void 0:e.activeIndex),null==v||v((null==(r=E.current)?void 0:r.realIndex)||0);const t=Array.isArray(d)?null==d?void 0:d.length:1;D(Math.ceil(t/Math.floor(A)))}),[p,!!E.current,null==d?void 0:d.length,A]),e.jsx(b,{"data-id":f,commonStyle:x,ref:i,children:e.jsx(o.AdvancedSliderCore,(V=S(S(S({isEditorMode:c,touchEventsTarget:"wrapper"},m),P),c?w:{}),_={autoplay:M,slidesPerView:A,onMounted:e=>{E.current=e,I(E.current)},onActiveIndexChange:({realIndex:e})=>{null==v||v(e),q(Math.ceil(e/Math.floor(A)))},children:d},u(V,s(_))))});var V,_})),b=d.default.div((({commonStyle:e})=>`\n    width: 100%;\n    position: relative;\n    ${t.getStyle(e)};\n\n    .swiper-container {\n      height: 100%;\n    }\n\n    .swiper-slide {\n      height: unset !important;\n      display: flex;\n      align-items:center;\n      justify-content: center;\n    }\n`));j.displayName=i.ADVANCED_SLIDER_DISPLAY_NAME,exports.AdvancedSlider=j;


/***/ }),

/***/ 913658:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var n=__webpack_require__(561261),e=__webpack_require__(212951),i=__webpack_require__(85097),t=__webpack_require__(891987),o=__webpack_require__(726438),r=__webpack_require__(406968);function a(n){return n&&"object"==typeof n&&"default"in n?n:{default:n}}var l=a(e),s=a(o),p=Object.defineProperty,d=Object.defineProperties,u=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,g=Object.prototype.hasOwnProperty,b=Object.prototype.propertyIsEnumerable,m=(n,e,i)=>e in n?p(n,e,{enumerable:!0,configurable:!0,writable:!0,value:i}):n[e]=i,h=(n,e)=>{for(var i in e||(e={}))g.call(e,i)&&m(n,i,e[i]);if(c)for(var i of c(e))b.call(e,i)&&m(n,i,e[i]);return n};s.default.use([o.Navigation,o.Pagination,o.Thumbs,o.Autoplay,o.Virtual]);const v=l.default.div((({isMultipleRows:n,paginationColor:e,paginationPosition:t,paginationDeactiveColor:o,navigationColor:r,commonStyle:a,slidesPerView:l=1,slidesPerColumn:s=1,itemsCount:p,spaceBetween:d=10,isEditorMode:u})=>{var c;const g="undefined"==typeof window;let b,m,h;return g&&(b=Math.ceil(p/s),m=b/l*100+"%",h=`calc(100% / ${b} - ${d*(b-1)/b}px)`),`\n      height: 100%;\n      ${i.getStyle(a)}\n\n      .swiper-container {\n        margin-left: auto;\n        margin-right: auto;\n        position: relative;\n        overflow: hidden;\n        list-style: none;\n        padding: 0;\n        ${"outside"===t?"padding-bottom: 3em;":""}\n      }\n      .swiper-wrapper {\n        position: relative;\n        height: 100%;\n        display: flex;\n        transition-property: transform;\n        box-sizing: content-box;\n        flex-wrap: ${n?"wrap":"nowrap"};\n        // Chỉ có tác dụng ở SSR, khi về CSR thư viện swiper sẽ tự động override css này bằng pixel\n        ${g?`width: ${m}`:""}\n      }\n      .swiper-slide {\n        flex-shrink: 0;\n        height: 100%;\n        position: relative;\n        border-radius: ${i.unitParse(null!=(c=null==a?void 0:a.borderRadius)?c:0,i.UnitEnum.percent)};\n        overflow: hidden;\n        transition-property: transform;\n        ${n?"margin-top: 0px !important":""};\n        // Chỉ có tác dụng ở SSR, khi về CSR thư viện swiper sẽ tự động override css này bằng pixel\n        ${g?`width: ${h};\n              margin-right: ${d}px;`:""}\n      }\n      &:hover {\n        .swiper-button-next,\n        .swiper-button-prev {\n         ${u?"pointer-events: none;":""}\n          opacity: 1;\n          &.swiper-button-disabled {\n            opacity: 0.35;\n          }\n        }\n      }\n      .swiper-pagination {\n        position: absolute;\n        text-align: center;\n        transform: translate3d(0, 0, 0);\n        z-index: 10;\n      }\n      .swiper-pagination-fraction {\n        bottom: 0;\n        left: 0;\n        width: 100%;\n      }\n      .swiper-pagination-bullets {\n        bottom: 10px;\n        left: 0;\n        width: 100%;\n      }\n\n      .swiper-pagination-bullet {\n        width: 8px;\n        height: 8px;\n        display: inline-block;\n        border-radius: 100%;\n        background:${o};\n        margin: 0 4px;\n        cursor: pointer;\n      }\n      .swiper-pagination-bullet-active {\n        background: ${e};\n        border-radius: 0.75rem;\n        width: 24px;\n      }\n\n      .swiper-button-prev,\n      .swiper-button-next {\n        position: absolute;\n        top: 50%;\n        z-index: 10;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 44px;\n        height: 44px;\n        margin-top: -22px;\n        opacity: ${u?1:0};\n        &.swiper-button-disabled {\n          opacity: ${u?.35:0};\n          cursor: auto;\n          pointer-events: auto;\n        }\n      }\n\n      .swiper-button-next {\n        right: 0;\n        left: auto;\n        background-color: transparent;\n        &:after {\n          mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');\n          content: ' ';\n          height: 30px;\n          width: 30px;\n          mask-size: contain;\n          display: inline-block;\n          background: ${r||"#333"};\n        }\n      }\n      .swiper-button-prev {\n        left: 0;\n        right: auto;\n        background-color: transparent;\n        &:after {\n          mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');\n          content: ' ';\n          height: 30px;\n          width: 30px;\n          mask-size: contain;\n          display: inline-block;\n          background: ${r||"#333"};\n        }\n      }\n`}));exports.AdvancedSliderCore=e=>{var i=e,{className:o,children:a,speed:l=3e3,pauseOnMouseEnter:s=!0,paginationColor:p,virtual:m,paginationPosition:w="inside",paginationDeactiveColor:y,commonStyle:f,slidesPerViewMobile:x,navigationColor:C,onMounted:I,isEditorMode:M,onActiveIndexChange:P}=i,j=((n,e)=>{var i={};for(var t in n)g.call(n,t)&&e.indexOf(t)<0&&(i[t]=n[t]);if(null!=n&&c)for(var t of c(n))e.indexOf(t)<0&&b.call(n,t)&&(i[t]=n[t]);return i})(i,["className","children","speed","pauseOnMouseEnter","paginationColor","virtual","paginationPosition","paginationDeactiveColor","commonStyle","slidesPerViewMobile","navigationColor","onMounted","isEditorMode","onActiveIndexChange"]);const{slidesPerView:S,slidesPerColumn:k,pagination:A,autoplay:O,loop:$}=j,[D,N]=t.useState(0);let Z;const z=t.useRef(null),H=k&&k>1;return A&&(j.pagination={clickable:!0}),H&&(j.loop=!1),O&&(j.autoplay={delay:l,disableOnInteraction:!1,pauseOnMouseEnter:s}),x&&(Z={320:{slidesPerView:x,slidesPerGroup:Math.floor(x)},640:{slidesPerView:S,slidesPerGroup:Math.floor(S)}}),t.useEffect((()=>{N((n=>n+1))}),[O,$,l,s,m,k]),n.jsx(v,{isEditorMode:M,className:o,isMultipleRows:H,paginationColor:p,paginationDeactiveColor:y,navigationColor:C,paginationPosition:w,commonStyle:f,slidesPerView:S,slidesPerColumn:k,itemsCount:t.Children.toArray(a).length,spaceBetween:null==j?void 0:j.spaceBetween,children:n.jsx(r.Swiper,(E=h({onInit:n=>{z.current=n.el,null==I||I(n)},breakpoints:Z,slidesPerGroup:Math.floor(S)},j),R={thumbs:{swiper:null,multipleActiveThumbs:!1},virtual:!(!m||!S)&&{addSlidesBefore:2},resizeObserver:!0,slidesPerColumnFill:"row",simulateTouch:!1,onActiveIndexChange:n=>{null==P||P(n)},children:t.Children.map(a,((e,i)=>n.jsx(r.SwiperSlide,{virtualIndex:i,children:e},`slide-${i}`)))},d(E,u(R))),`swiper-${D}`)});var E,R};


/***/ }),

/***/ 734645:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(85097),n=__webpack_require__(891987),o=__webpack_require__(439205);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=i(r),d=Object.defineProperty,l=Object.defineProperties,a=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,s=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,p=(e,r,t)=>r in e?d(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,y=(e,r)=>{for(var t in r||(r={}))s.call(r,t)&&p(e,t,r[t]);if(u)for(var t of u(r))f.call(r,t)&&p(e,t,r[t]);return e},b=(e,r)=>l(e,a(r));const v=n.forwardRef(((r,n)=>{var o,i=r,{children:c,isEditingMode:d}=i,l=((e,r)=>{var t={};for(var n in e)s.call(e,n)&&r.indexOf(n)<0&&(t[n]=e[n]);if(null!=e&&u)for(var n of u(e))r.indexOf(n)<0&&f.call(e,n)&&(t[n]=e[n]);return t})(i,["children","isEditingMode"]);const{device:a}=t.useStore(),{commonStyle:p}=t.getPropsByDevice(l,a);return e.jsxs(m,b(y({ref:n},l),{commonStyle:p,children:[(null==p?void 0:p.backgroundVideo)&&e.jsx(t.BackgroundVideo,b(y({},p.backgroundVideo),{background:null==(o=p.background)?void 0:o.toString()})),c]}))})),m=c.default.div((({commonStyle:e})=>`\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    overflow: hidden;\n    ${t.getStyle(e)};\n`));v.displayName=o.ADVANCED_SLIDER_ITEM_DISPLAY_NAME,exports.AdvancedSliderItem=v;


/***/ }),

/***/ 281586:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=(e=>(e.image="image",e.product="product",e))(e||{});exports.SliderTypeEnum=e;


/***/ }),

/***/ 921265:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(85097),i=__webpack_require__(212951),r=__webpack_require__(115741),o=__webpack_require__(586753);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=n(i),s=Object.defineProperty,a=Object.defineProperties,d=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,u=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,m=(e,t,i)=>t in e?s(e,t,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[t]=i,h=(e,t)=>{for(var i in t||(t={}))u.call(t,i)&&m(e,i,t[i]);if(c)for(var i of c(t))p.call(t,i)&&m(e,i,t[i]);return e},y=(e,t)=>a(e,d(t)),v=(e,t)=>{var i={};for(var r in e)u.call(e,r)&&t.indexOf(r)<0&&(i[r]=e[r]);if(null!=e&&c)for(var r of c(e))t.indexOf(r)<0&&p.call(e,r)&&(i[r]=e[r]);return i};const f=i=>{const n=i,{items:l,type:s,isEditingMode:a,speed:d}=n,c=v(n,["items","type","isEditingMode","speed"]),{showThumbnail:u}=c||{},{displayItems:p}=t.useTimeVisibility(l,a),{device:m}=t.useStore(),{commonStyle:f,slidesPerView:g}=t.getPropsByDevice(c,m),j=(null==c?void 0:c.slidesPerColumn)||1;return e.jsx(b,{commonStyle:f,showThumbnail:u,children:e.jsx(r.DSSlider,y(h(h({commonStyle:f,touchEventsTarget:"wrapper",speed:d},c),!u&&{paginationStyle:2,navigationStyle:3}),{slidesPerView:g,children:null==p?void 0:p.map(((r,n)=>e.jsx(t.BreakpointWidthProvider,{sWidth:{value:100/j,unit:"%"},mWidth:{value:100/j,unit:"%"},children:e.jsx(o.Image,h({commonStyle:{objectFit:i.crop?"cover":"contain",height:null==f?void 0:f.height,width:"100%"},fetchPriority:0===n?"high":"auto"},r))},n)))}))})};f.displayName="Slider";const b=l.default.div((({commonStyle:e,showThumbnail:i})=>{const r=e,{height:o}=r,n=v(r,["height"]);let l=o;return i&&("100vh"===o?l="calc(100vh + 90px)":"number"==typeof o&&(l=o+90)),`\n  ${t.getStyle(y(h({},n),{height:l}))};\n  overflow: hidden;\n  & img {\n    aspect-ratio: unset !important;\n  }\n`}));exports.Slider=f;


/***/ }),

/***/ 534388:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(281586),r=Object.defineProperty,o=Object.defineProperties,t=Object.getOwnPropertyDescriptors,i=Object.getOwnPropertySymbols,a=Object.prototype.hasOwnProperty,n=Object.prototype.propertyIsEnumerable,l=(e,o,t)=>o in e?r(e,o,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[o]=t,p=(e,r)=>{for(var o in r||(r={}))a.call(r,o)&&l(e,o,r[o]);if(i)for(var o of i(r))n.call(r,o)&&l(e,o,r[o]);return e};exports.convertOptionSliderV2ToV1=r=>{const l=r,{items:s,gridCols:u,gridRows:y,arrows:c,arrowStyle:d,pagination:g,paginationStyle:v,autoplay:O,pauseOnHover:f,rewind:b,paginationColor:w}=l,j=((e,r)=>{var o={};for(var t in e)a.call(e,t)&&r.indexOf(t)<0&&(o[t]=e[t]);if(null!=e&&i)for(var t of i(e))r.indexOf(t)<0&&n.call(e,t)&&(o[t]=e[t]);return o})(l,["items","gridCols","gridRows","arrows","arrowStyle","pagination","paginationStyle","autoplay","pauseOnHover","rewind","paginationColor"]),S=p({type:e.SliderTypeEnum.product,items:s,slidesPerColumn:y,slidesPerView:u,navigation:c||!!d,navigationStyle:d,pagination:g||!!v,paginationStyle:v,autoplay:O,loop:b,pauseOnMouseEnter:f,paginationColor:w,virtual:1===y},j);return Object.keys(S).filter((e=>void 0!==S[e])).reduce(((e,r)=>{return i=p({},e),a={[r]:S[r]},o(i,t(a));var i,a}),{})};


/***/ }),

/***/ 503446:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(212951),r=__webpack_require__(143599),t=__webpack_require__(85097),i=__webpack_require__(891987),n=__webpack_require__(319891);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=l(o),a=Object.defineProperty,d=Object.defineProperties,s=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,m=(e,o,r)=>o in e?a(e,o,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[o]=r,p=(e,o)=>{for(var r in o||(o={}))y.call(o,r)&&m(e,r,o[r]);if(u)for(var r of u(o))f.call(o,r)&&m(e,r,o[r]);return e},b=(e,o)=>d(e,s(o));const j={facebook:{icon:"FacebookFilled",color:"#415993"},youtube:{icon:"YoutubeFilled",color:"#bd342b"},tiktok:{icon:"TiktokFilled",color:"#262626"},instagram:{icon:"InstagramFilled",color:"#d96357"},twitter:{icon:"TwitterFilled",color:"#1DA1F2"},github:{icon:"GithubFilled",color:"#000000"},zalo:{icon:"ZaloFilled",color:"#2d75f6"}},v=i.forwardRef(((o,i)=>{const{icons:l,className:c,id:a}=o,{device:d}=t.useStore(),{iconSize:s,iconStyle:u,commonStyle:y}=t.getPropsByDevice(o,d);return e.jsx(S,{ref:i,"data-id":a,commonStyle:y,className:c,children:l.map(((o,t)=>{var i,l;if(j[o.name])return e.jsx(n.Link,b(p({},o.link),{children:e.jsx(g,{iconStyle:b(p({},u),{height:u.width,backgroundColor:null==(i=j[o.name])?void 0:i.color}),children:e.jsx(r.Icon,{name:null==(l=null==j?void 0:j[o.name])?void 0:l.icon,style:{fontSize:s||25}})})}),t)}))})})),S=c.default.div((({commonStyle:e})=>`\n  ${t.getStyle(e)};\n  display: flex;\n`)),g=c.default.div((({iconStyle:e})=>`\n${t.getStyle(e)};\ndisplay: flex;\nalign-items: center;\njustify-content: center;\nborder-radius: 10%;\n> span {\n  color: white;\n  line-height: 1;\n}\n`));v.displayName="SocialIcon",exports.SocialIcon=v;


/***/ }),

/***/ 990475:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261);exports.InvalidFbPageEmbedFallback=({width:r,href:o})=>e.jsxs("div",{style:{width:r,border:"1px solid #ddd",borderRadius:"8px",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",backgroundColor:"#f8f9fa",padding:"20px",textAlign:"center"},children:[e.jsx("div",{style:{fontSize:"48px",color:"#1877f2"},children:"📘"}),e.jsx("h6",{style:{margin:"16px 0 8px 0",color:"#1c1e21"},children:"Page Cannot Be Found"}),e.jsx("p",{style:{color:"#65676b"},children:"The Facebook page could not be loaded. Please check the URL."}),e.jsx("a",{href:o,target:"_blank",rel:"noopener noreferrer",style:{marginTop:"12px",color:"#1877f2",textDecoration:"none"},children:"Visit Page Directly →"})]});


/***/ }),

/***/ 264707:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),i=__webpack_require__(800656);exports.InvalidLinkFallback=()=>e.jsxs("div",{style:{width:"100%",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",textAlign:"center",backgroundColor:"#e8e9ea",padding:"20px"},children:[e.jsx("div",{style:{fontSize:"36px"},children:"⚠️"}),e.jsx("h5",{style:{margin:"12px 0 8px 0",color:"#495057"},children:i.t("social_media.invalid_link")}),e.jsx("p",{style:{color:"#6c757d"},children:i.t("social_media.invalid_link_description")})]});


/***/ }),

/***/ 963328:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),a=__webpack_require__(891987),i=__webpack_require__(409245),r=__webpack_require__(990475);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const s=o(t).default.div`
  max-width: 100%;
  * {
    max-width: 100% !important;
  }
`;exports.FbPageEmbed=({href:t,commonStyle:o,showPosts:d=!1,isEditorMode:n=!1})=>{const u=a.useRef(null),[l,c]=a.useState(!1),{width:h=340,height:m=500}=o;return a.useEffect((()=>{i.initFacebookEmbed(),setTimeout((()=>{if(u.current){const e=u.current.getElementsByTagName("iframe")[0].getBoundingClientRect();e.width&&e.height||c(!0)}}),5e3)}),[t,h,m,n,d]),l?e.jsx(r.InvalidFbPageEmbedFallback,{width:h,href:t}):e.jsx(s,{ref:u,className:"fb-page","data-width":h,"data-height":m,"data-href":t,"data-show-posts":`${d}`,"data-adapt-container-width":"true",style:{pointerEvents:n?"none":"auto"}},`${t}-${h}-${m}-${d}`)};


/***/ }),

/***/ 106820:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),o=__webpack_require__(85097),r=__webpack_require__(891987),n=__webpack_require__(409245);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const s=i(t).default.div((({commonStyle:e,isEditorMode:t})=>`\n  ${o.getStyle(e)}\n  max-width: 100%;\n  height: auto !important;\n  pointer-events: ${t?"none":"auto"};\n\n  &.fb-post span,\n  &.fb-post span iframe[style] {\n    width: 100% !important;\n  }\n`));exports.FbPostEmbed=({href:t,commonStyle:o,showText:i=!0,isEditorMode:a=!1})=>(r.useEffect((()=>{n.initFacebookEmbed()}),[t,i]),e.jsx(s,{isEditorMode:a,commonStyle:o,className:"fb-post","data-href":t,"data-show-text":`${i}`}));


/***/ }),

/***/ 900583:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097),i=__webpack_require__(891987),n=__webpack_require__(708767),o=__webpack_require__(266666);function d(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const m=d(t).default(n.InstagramEmbed)((({commonStyle:e,isEditorMode:t})=>`\n  ${r.getStyle(e)}\n  max-width: 100%;\n  min-width: 300px;\n  border: none;\n  pointer-events: ${t?"none":"auto"};\n`));exports.InstagramEmbed=({href:t,commonStyle:n,isEditorMode:d=!1})=>{const{width:s=400,widthUnit:u=r.UnitEnum.pixel}=n||{};return i.useEffect((()=>{o.initInstagramEmbed()}),[t]),e.jsx(m,{url:t,commonStyle:{width:s,widthUnit:u},isEditorMode:d},t)};


/***/ }),

/***/ 78449:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var o=__webpack_require__(85097),e=(o=>(o.FacebookPage="facebook_page",o.FacebookPost="facebook_post",o.FacebookGroup="facebook_group",o.Instagram="instagram",o.Other="other",o))(e||{}),t=(o=>(o.Facebook="facebook",o.Instagram="instagram",o))(t||{});const a={desktop:{commonStyle:{width:340,height:500}},socialMediaConfig:{align:o.Alignment.left,platform:"facebook",link:{facebookLink:"https://www.facebook.com/tempi.vn",instagramLink:"https://www.instagram.com/instagram/"},facebookPostEmbed:{showText:!0},facebookPageEmbed:{showPosts:!0}}},s=[{tag:"FacebookPageSocialMedia",src:"https://lh3.googleusercontent.com/arhcmvUzdXaPS-0CJjzcLEuAs7kiAtlBa8108DfhE-Mn7hpFbaq5fI1HYl3wy75h1z2lIcwSC5E9sOH4-p7MUB5qUtnM_NBD",props:{desktop:{commonStyle:{width:340,height:500}},socialMediaConfig:{align:o.Alignment.center,platform:"facebook",link:{facebookLink:"https://www.facebook.com/tempi.vn",instagramLink:"https://www.instagram.com/instagram/"},facebookPostEmbed:{showText:!0},facebookPageEmbed:{showPosts:!0}}}},{tag:"InstagramProfileSocialMedia",src:"https://lh3.googleusercontent.com/CCOAtswuqoQXuLvBYDCS_etLhnkUxjj9D0aLC6VLHF1nYCEedcm-zRLkrED8LzP7Hmqxc3aSQT3pf7e3SiwgS_K8H-GQsXo0",props:{desktop:{commonStyle:{width:600,height:500}},socialMediaConfig:{align:o.Alignment.center,platform:"instagram",link:{facebookLink:"https://www.facebook.com/tempi.vn",instagramLink:"https://www.instagram.com/instagram/"},facebookPostEmbed:{showText:!0},facebookPageEmbed:{showPosts:!0}}}}];exports.DEFAULT_SOCIAL_MEDIA=a,exports.LinkType=e,exports.SAMPLE_SOCIAL_MEDIA=s,exports.SocialMediaPlatform=t;


/***/ }),

/***/ 147302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(85097),i=__webpack_require__(891987),n=__webpack_require__(78449),o=__webpack_require__(476197),a=__webpack_require__(264707),l=__webpack_require__(106820),s=__webpack_require__(963328),c=__webpack_require__(900583);function d(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var u=d(r),m=Object.defineProperty,f=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,g=(e,r,t)=>r in e?m(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,y=(e,r)=>{for(var t in r||(r={}))b.call(r,t)&&g(e,t,r[t]);if(f)for(var t of f(r))p.call(r,t)&&g(e,t,r[t]);return e};const k=i.forwardRef(((r,i)=>{const{device:d}=t.useStore(),u=r,{isEditorMode:m,id:g}=u,k=((e,r)=>{var t={};for(var i in e)b.call(e,i)&&r.indexOf(i)<0&&(t[i]=e[i]);if(null!=e&&f)for(var i of f(e))r.indexOf(i)<0&&p.call(e,i)&&(t[i]=e[i]);return t})(u,["isEditorMode","id"]),{commonStyle:v,socialMediaConfig:x}=t.getPropsByDevice(k,d),{align:E,link:P,platform:M,facebookPageEmbed:h={},facebookPostEmbed:F={}}=x,q={[t.Alignment.left]:"flex-start",[t.Alignment.center]:"center",[t.Alignment.right]:"flex-end"};return e.jsx(j,{ref:i,"data-id":g,align:q[E],isEditorMode:m,children:(()=>{switch(M){case n.SocialMediaPlatform.Facebook:return(()=>{const r=null==P?void 0:P.facebookLink;switch(o.detectLinkType(r)){case n.LinkType.FacebookPage:return e.jsx(s.FbPageEmbed,y({href:r,commonStyle:v,isEditorMode:m},h));case n.LinkType.FacebookPost:return e.jsx(l.FbPostEmbed,y({href:r,commonStyle:v,isEditorMode:m},F));default:return m&&e.jsx(a.InvalidLinkFallback,{})}})();case n.SocialMediaPlatform.Instagram:return(()=>{const r=null==P?void 0:P.instagramLink;return o.detectLinkType(r)===n.LinkType.Instagram?e.jsx(c.InstagramEmbed,{href:r,commonStyle:v,isEditorMode:m}):m&&e.jsx(a.InvalidLinkFallback,{})})();default:return null}})()})})),j=u.default.div((({align:e,isEditorMode:r})=>`\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: ${r?"70px":"0px"};\n  ${e?`align-items: ${e};`:""}\n`));k.displayName="SocialMedia",exports.SocialMedia=k;


/***/ }),

/***/ 476197:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(78449);const t=t=>/facebook\.com\/(?:[^\/\s?]+\/posts\/[^\/\s?]+|permalink\.php)/.test(t)?e.LinkType.FacebookPost:/facebook\.com\/[^\/\s?]+/.test(t)?e.LinkType.FacebookPage:/instagram\.com\/[^\/\s?]+/.test(t)?e.LinkType.Instagram:e.LinkType.Other;exports.detectLinkType=t,exports.getStyleSettingType=(o,a)=>{switch(o){case e.SocialMediaPlatform.Instagram:return e.LinkType.Instagram;case e.SocialMediaPlatform.Facebook:const o=t(a);return[e.LinkType.FacebookPage,e.LinkType.FacebookPost].includes(o)?o:null;default:return null}};


/***/ }),

/***/ 3382:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=(e=>(e.FillContainer="fillContainer",e.HugContent="hugContent",e.FixedWidth="fixedWidth",e))(e||{}),t=(e=>(e.Column="column",e.Row="row",e))(t||{}),n=(e=>(e.Start="start",e.End="end",e.Center="center",e))(n||{}),r=(e=>(e.Start="start",e.Center="center",e.End="end",e.SpaceAround="space-around",e.SpaceBetween="space-between",e))(r||{});exports.FlexDirection=t,exports.HorizontalAlignmentType=r,exports.VerticalAlignmentType=n,exports.WidthType=e;


/***/ }),

/***/ 13674:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097),i=__webpack_require__(891987),a=__webpack_require__(3382),n=__webpack_require__(568646);function p(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=p(t),l=Object.getOwnPropertySymbols,o=Object.prototype.hasOwnProperty,s=Object.prototype.propertyIsEnumerable;const c=i.forwardRef(((t,i)=>{const a=t,{children:p,flexWrap:d}=a,c=((e,t)=>{var r={};for(var i in e)o.call(e,i)&&t.indexOf(i)<0&&(r[i]=e[i]);if(null!=e&&l)for(var i of l(e))t.indexOf(i)<0&&s.call(e,i)&&(r[i]=e[i]);return r})(a,["children","flexWrap"]),{device:u}=r.useStore(),{commonStyle:f,alignment:w,widthType:m,width:x}=r.getPropsByDevice(c,u);return e.jsx(y,{alignment:w,widthType:m,children:e.jsx(h,{ref:i,widthType:m,width:x,commonStyle:f,flexWrap:d,children:p||e.jsx(n.Empty,{style:{minWidth:300,width:"100% !important"}})})})})),y=d.default.div`
  width: 100%;
  display: flex;
  justify-content: ${({alignment:e})=>e||"flex-start"};

  ${({widthType:e})=>e===a.WidthType.FillContainer&&"\n    &&& {\n      width: 100%;\n    }\n  "}
`,h=d.default.div`
  display: flex;
  flex-wrap: ${({flexWrap:e})=>e?"wrap":"nowrap"};

  ${({widthType:e,width:t})=>{switch(e){case a.WidthType.FillContainer:return"width: 100%;";case a.WidthType.HugContent:return"width: fit-content;";case a.WidthType.FixedWidth:return t?`width: ${t}px;`:"";default:return""}}}

  ${({commonStyle:e})=>r.getStyle(e)}

  & > div {
    width: auto;
  }

  & > div:has([class*='ImageWrapper']),
  & > div:has([class*='image-wrapper']) {
    flex: 1;
  }
`;c.displayName="Space",exports.Space=c,exports.SpaceWrapper=h,exports.Wrapper=y;


/***/ }),

/***/ 752928:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097),i=__webpack_require__(891987);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var n=o(t);const c=i.forwardRef(((t,i)=>{const{device:o}=r.useStore(),{height:n,commonStyle:c,id:d}=r.getPropsByDevice(t,o);return e.jsx(a,{ref:i,"data-id":d,height:n,commonStyle:c})})),a=n.default.div((({height:e,commonStyle:t})=>`\n  height: ${e}px;\n  width: 100%;\n  ${r.getStyle(t)}\n`));c.displayName="Spacer",exports.Spacer=c;


/***/ }),

/***/ 460344:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(800656),r=__webpack_require__(212951),s=__webpack_require__(143599),i=__webpack_require__(891987);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const t=o(r).default.div((({mainColor:e})=>`\n  line-height: 2;\n  padding: 0.8em 1.5em;\n  background-color: white;\n  border-bottom: 1px solid #eaeaea;\n\n  &:hover{\n    background: color-mix(in srgb, ${e} 10%, white);\n  }\n\n\n  .store-name{\n    font-size: 1.4em;\n    color: ${e};\n  }\n\n  .store-details{\n    position: relative;\n\n    .bottom-elements{\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n\n      .store-info{\n        display: inline-block;\n        margin-right: auto;\n        padding-bottom: 0.5em;\n      }   \n\n      .map-toggle{\n        border: 1px solid ${e};\n        background-color: white;\n      \n        height: 40px;\n        color: ${e};\n        line-height: 40px;\n        display: block;\n        padding: 0 15px;\n        border-radius: 4px;\n        outline-color: ${e};\n\n        svg{\n          vertical-align: baseline;\n        }\n      }\n    }\n  }\n  \n  .store-map{\n    margin-top: 1em;\n\n    iframe{\n      width: 100%;\n      border: none;\n      border-radius: 1em;\n    }\n  }\n`));exports.Store=({store:r,mainColor:o})=>{const{name:a,address:l,phone:d,workHours:c,map:m}=r,[h,p]=i.useState(!1);return e.jsxs(t,{mainColor:o,children:[e.jsx("div",{className:"store-name",children:e.jsx("b",{children:a})}),e.jsxs("div",{className:"store-details",children:[e.jsxs("div",{className:"store-address",children:[e.jsx("b",{children:n.t("Địa chỉ:")}),l]}),e.jsxs("div",{className:"bottom-elements",children:[e.jsxs("div",{className:"store-info",children:[e.jsxs("div",{className:"store-phone",children:[e.jsx("b",{children:n.t("Số điện thoại:")}),e.jsx("span",{children:d})]}),e.jsxs("div",{className:"store-working-hours",children:[e.jsx("b",{children:n.t("Giờ mở cửa:")}),e.jsx("span",{children:c})]})]}),m&&e.jsxs("button",{onClick:()=>p(!h),className:"map-toggle",children:[n.t("Tìm đường")," ",h?e.jsx(s.Icon,{name:"ArrowDownTinyFilled"}):e.jsx(s.Icon,{name:"ArrowUpTinyFilled"})]})]})]}),h&&m&&e.jsx("div",{className:"store-map",children:m.startsWith("<iframe")?e.jsx("div",{dangerouslySetInnerHTML:{__html:m}}):e.jsx("iframe",{src:m,title:"map",allowFullScreen:!0})})]})};


/***/ }),

/***/ 637035:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097),t=__webpack_require__(891987);exports.useGetCitiesAndDistricts=()=>{const[r,s]=t.useState({});return t.useEffect((()=>{(async()=>{try{const t=await fetch(e.mappingAssets.VN),r=await t.json();s(r)}catch(e){console.error(e)}})()}),[]),{cities:r.province||[],districts:r.district||[]}};


/***/ }),

/***/ 972076:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(212951),t=__webpack_require__(85097),r=__webpack_require__(891987),i=__webpack_require__(637035),o=__webpack_require__(460344),a=__webpack_require__(930907),c=__webpack_require__(669117);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=s(n),d=Object.getOwnPropertySymbols,m=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable;const h=r.forwardRef(((n,s)=>{var l=n,{stores:h,mainColor:g="#2e7ac1",title:f,id:j}=l,b=((e,n)=>{var t={};for(var r in e)m.call(e,r)&&n.indexOf(r)<0&&(t[r]=e[r]);if(null!=e&&d)for(var r of d(e))n.indexOf(r)<0&&p.call(e,r)&&(t[r]=e[r]);return t})(l,["stores","mainColor","title","id"]);const[v,y]=r.useState(),[C,k]=r.useState(),[S,w]=r.useState(h),{cities:q,districts:O}=i.useGetCitiesAndDistricts(),{device:P}=t.useStore(),{stickyTop:I,commonStyle:D}=t.getPropsByDevice(b,P),N=q.filter((e=>!!h.find((n=>n.cityId===e.idProvince)))),$=O.filter((e=>e.idProvince===v&&!!h.find((n=>n.districtId===e.idDistrict)))),z=(e,n)=>{e&&(y(e),k(null)),n&&k(n)};return r.useEffect((()=>{w(v&&"0"!==v?!v||C&&"0"!==C?h.filter((e=>e.cityId===v&&e.districtId===C)):h.filter((e=>e.cityId===v)):h)}),[v,C,h]),e.jsx(x,{ref:s,"data-id":j,stickyTop:I,mainColor:g,commonStyle:D,children:e.jsxs(a.Row,{gutter:[24,16],children:[e.jsxs(c.Col,{md:5,xs:12,children:[e.jsxs("div",{className:"label",children:["Hệ thống ",h.length," cửa hàng"]}),e.jsxs("div",{className:"select-location",children:[e.jsx("h5",{children:e.jsx("b",{children:f||"Chọn cửa hàng theo tỉnh/thành phố"})}),e.jsxs("select",{onChange:e=>z(e.target.value),children:[e.jsx("option",{value:0,children:"Chọn tỉnh/ thành phố"}),N.map((n=>e.jsx("option",{value:n.idProvince,children:n.name},n.idProvince)))]}),e.jsxs("select",{onChange:e=>z(null,e.target.value),children:[e.jsx("option",{value:0,children:"Chọn quận/ huyện"}),$.sort(((e,n)=>e.name<n.name?-1:1)).map((n=>e.jsx("option",{value:n.idDistrict,children:n.name},n.idDistrict)))]})]})]}),e.jsxs(c.Col,{md:7,xs:12,children:[e.jsxs("div",{className:"label",children:[S.length," kết quả"]}),e.jsx("div",{className:"store-list",children:S.length>0?S.map(((n,t)=>e.jsx(o.Store,{store:n,mainColor:g},t))):e.jsx(u,{mainColor:g,children:"Không có cửa hàng"})})]})]})})}));h.displayName="StoreList";const u=l.default.div((({mainColor:e})=>`\n  font-size: 1.8em;\n  text-align: center;\n  padding: 2em;\n  color: ${e};\n  opacity: 0.85;\n\n`)),x=l.default.div((({mainColor:e,commonStyle:n,stickyTop:r})=>`\n  ${t.getStyle(n)}\n  max-width: 100%;\n\n  .label{\n    font-size: 1em;\n    margin-bottom: 0.5em;\n  }\n\n  .select-location{\n    padding: 0.8em 1.5em;\n    background-color: ${e};\n    border-radius: 3px;\n    font-size: 1.1em;\n    position: sticky;\n    top: ${r}px;\n\n    h5 {\n      color: white;\n      margin-top: 0.5em;\n      margin-bottom: 1em;\n    }\n\n    select{\n      width: 100%;\n      margin-bottom: 1em;\n      border-radius: 4px;\n      -webkit-appearance: none;\n      padding: 0.5em 3.5em 0.5em 1em;\n\n      background-color: white;\n      background-image: linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%), linear-gradient(to right, #ccc, #ccc);\n      background-position: calc(100% - 20px) calc(1em + 2px), calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;\n      background-size: 5px 5px, 5px 5px, 1px 1.5em;\n      background-repeat: no-repeat;\n    }\n  }\n\n  .store-list{\n    border: 1px solid ${e};\n    border-radius: 5px;\n    overflow: hidden;\n    background-color: white;\n  }\n`));exports.StoreList=h;


/***/ }),

/***/ 471821:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(85097),e=Object.defineProperty,r=Object.defineProperties,o=Object.getOwnPropertyDescriptors,a=Object.getOwnPropertySymbols,g=Object.prototype.hasOwnProperty,i=Object.prototype.propertyIsEnumerable,n=(t,r,o)=>r in t?e(t,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):t[r]=o,p=(t=>(t.Horizontal="horizontal",t.Vertical="vertical",t))(p||{});const l={type:"button",activeColor:"rgba(37, 141, 255, 1)",textColor:"rgba(0, 0, 0, 1)",alignment:"left",textAlign:"center",fontWeight:"400",fontSize:14,desktop:{tabTitle:{width:200,widthUnit:t.UnitEnum.pixel}},mobile:{layout:"horizontal"}},c=r(((t,e)=>{for(var r in e||(e={}))g.call(e,r)&&n(t,r,e[r]);if(a)for(var r of a(e))i.call(e,r)&&n(t,r,e[r]);return t})({},l),o({currentParagraphTheme:"paragraph1",fontSize:"var(--tempi-global-paragraph1fontsize)",fontFamily:"var(--tempi-global-paragraph1fontfamily)",fontWeight:"var(--tempi-global-paragraph1fontweight)"}));const b=[{tag:"Rectangle",group:"Tab",props:c,src:"https://lh3.googleusercontent.com/Z6cm67hJGE_3PVZtqVWzO6HOmnCI5Z8bxCqfMcnIrLCv_yiPEMlW5xkbQ40qMUNZRzkQQgCl8vt4Mrqi4AXJilwudcs7fvoi"},{tag:"Button",group:"Tab",props:c,src:"https://lh3.googleusercontent.com/-QrRg_x1e3FzQ0wSAPZlw8i54dYCmP-IMaiiReQ8cbF_Mi8Lvx_M3iRvXi6b1OgPwJdDcgUQ5S-cGHPrZJ9XFWunQFmxJdgOfg"},{tag:"Line",group:"Tab",props:c,src:"https://lh3.googleusercontent.com/-JbbrnwqdGaKpPQi7Fr82P5T3xGPv7w6NyCNOkVbSLQ0xMhByb5kpPor26cuebQ6SMC2_oD_CXTRtgQbEvMAq7NNQlWVYhm-"},{tag:"Card",group:"Tab",props:c,src:"https://lh3.googleusercontent.com/QCjtqKNUZKeUbyDYntH7E_HxjUeSOETygcmHvIHp6iC4bAYPk_TYuSSIIX9L1r_L8cIPxe7dmFeezbJB7V7xumGMk_viyIssEg"}];exports.DEFAULT_TABS=[{title:"Tab 1"},{title:"Tab 2"},{title:"Tab 3"}],exports.DEFAULT_TAB_STYLE=l,exports.DEFAULT_TAB_STYLE_THEME=c,exports.SAMPLE_TABS=[{tag:"Rectangle",group:"Tab",src:"https://lh3.googleusercontent.com/Z6cm67hJGE_3PVZtqVWzO6HOmnCI5Z8bxCqfMcnIrLCv_yiPEMlW5xkbQ40qMUNZRzkQQgCl8vt4Mrqi4AXJilwudcs7fvoi"},{tag:"Button",group:"Tab",src:"https://lh3.googleusercontent.com/-QrRg_x1e3FzQ0wSAPZlw8i54dYCmP-IMaiiReQ8cbF_Mi8Lvx_M3iRvXi6b1OgPwJdDcgUQ5S-cGHPrZJ9XFWunQFmxJdgOfg"},{tag:"Line",group:"Tab",src:"https://lh3.googleusercontent.com/-JbbrnwqdGaKpPQi7Fr82P5T3xGPv7w6NyCNOkVbSLQ0xMhByb5kpPor26cuebQ6SMC2_oD_CXTRtgQbEvMAq7NNQlWVYhm-"},{tag:"Card",group:"Tab",src:"https://lh3.googleusercontent.com/QCjtqKNUZKeUbyDYntH7E_HxjUeSOETygcmHvIHp6iC4bAYPk_TYuSSIIX9L1r_L8cIPxe7dmFeezbJB7V7xumGMk_viyIssEg"}],exports.SAMPLE_TABS_THEME=b,exports.TabLayout=p;


/***/ }),

/***/ 22177:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(561261),e=__webpack_require__(212951),r=__webpack_require__(85097),n=__webpack_require__(891987),a=__webpack_require__(471821),o=__webpack_require__(404607);function i(t){return t&&"object"==typeof t&&"default"in t?t:{default:t}}var l=i(e),c=Object.defineProperty,u=Object.defineProperties,s=Object.getOwnPropertyDescriptors,f=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,y=Object.prototype.propertyIsEnumerable,m=(t,e,r)=>e in t?c(t,e,{enumerable:!0,configurable:!0,writable:!0,value:r}):t[e]=r,b=(t,e)=>{for(var r in e||(e={}))d.call(e,r)&&m(t,r,e[r]);if(f)for(var r of f(e))y.call(e,r)&&m(t,r,e[r]);return t},x=(t,e)=>u(t,s(e));const p=n.forwardRef(((e,i)=>{var l=e,{children:c,tabs:u=[],activeColor:s,tabColor:m,textColor:p,type:T,fontWeight:j,fontFamily:w,fontStyle:S,textDecoration:C,textTransform:L,textAlign:O,activeTextColor:$}=l,P=((t,e)=>{var r={};for(var n in t)d.call(t,n)&&e.indexOf(n)<0&&(r[n]=t[n]);if(null!=t&&f)for(var n of f(t))e.indexOf(n)<0&&y.call(t,n)&&(r[n]=t[n]);return r})(l,["children","tabs","activeColor","tabColor","textColor","type","fontWeight","fontFamily","fontStyle","textDecoration","textTransform","textAlign","activeTextColor"]);const V=u.length,[W,q]=n.useState(0),H=n.useRef(),D=null==H?void 0:H.current,{device:I}=r.useStore(),{fontSize:A,commonStyle:E,tabTitle:U={width:200,widthUnit:r.UnitEnum.pixel},layout:_=a.TabLayout.Horizontal,alignment:k="left"}=r.getPropsByDevice(P,I);return n.useEffect((()=>{if(D&&D.scroll){const t=D.childNodes[W];D.scroll({left:(null==t?void 0:t.offsetLeft)-(D.offsetWidth-(null==t?void 0:t.offsetWidth))/2,behavior:"smooth"})}}),[W]),n.useEffect((()=>{u.length-1<W&&q(Math.max(u.length-1,0))}),[u]),t.jsxs(g,x(b({ref:i},P),{layout:_,commonStyle:E,children:[!!u.length&&t.jsx(h,{layout:_,tabTitleStyle:{width:U.width,widthUnit:U.widthUnit},alignment:k,ref:H,children:u.map(((e,r)=>t.jsx(v,{alignment:k,index:r,arrayLength:V,layout:_,children:t.jsx(o.TabItemHead,x(b({id:`tab-${r}`,activeColor:s,tabColor:m,textColor:p,isActive:r===W,alignment:k,onClick:()=>{q(r)},fontFamily:w,fontSize:A,fontWeight:j,type:T,fontStyle:S,textAlign:O,textDecoration:C,textTransform:L,activeTextColor:$},e),{children:t.jsx("span",{dangerouslySetInnerHTML:{__html:e.title}})}))},r)))}),t.jsx("div",{style:_===a.TabLayout.Vertical?{flex:1,minWidth:0}:{},children:(null==c?void 0:c[W])||(null!=c?c:null)})]}))})),h=l.default.div((({layout:t,tabTitleStyle:e,alignment:n})=>`\n  display: flex;\n  flex-direction: ${t===a.TabLayout.Vertical?"column":"row"};\n  white-space: nowrap;\n  overflow-x: scroll;\n  gap: 8px;\n  ${t===a.TabLayout.Vertical?r.getStyle(e):""};\n  ${t===a.TabLayout.Vertical?(t=>{switch(t){case"center":return"justify-content: center;";case"justify":return"justify-content: space-around;";case"bottom":return"justify-content: flex-end;";case"top":return"justify-content: flex-start;";default:return""}})(n):""}\n  padding: ${t===a.TabLayout.Vertical?"10px":"0"};\n  max-width: 100%;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n`)),g=l.default.div((({commonStyle:t,layout:e})=>`\n    width: 100%;\n    position: relative;\n    display: ${e===a.TabLayout.Vertical?"flex":"block"};\n    ${r.getStyle(t)};\n`)),v=l.default.div((({alignment:t,index:e,arrayLength:r,layout:n})=>`\n  ${n===a.TabLayout.Vertical?"":((t,e,r)=>{switch(t){case"center":return 0===e?"margin-left: auto;":e===r-1?"margin-right: auto;":"";case"justify":return"margin: auto;";case"right":return 0===e?"margin-left: auto;":"";case"left":return e===r-1?"margin-right: auto":"";default:return""}})(t,e,r)}`));p.displayName="Tab",exports.Tab=p,exports.TabHeadWrapper=h;


/***/ }),

/***/ 998089:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(891987);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var o=i(r),n=Object.defineProperty,a=Object.defineProperties,l=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,f=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,d=(e,r,t)=>r in e?n(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;const p=t.forwardRef(((r,t)=>{var i,o=r,{children:n,onClick:p}=o,b=((e,r)=>{var t={};for(var i in e)f.call(e,i)&&r.indexOf(i)<0&&(t[i]=e[i]);if(null!=e&&c)for(var i of c(e))r.indexOf(i)<0&&u.call(e,i)&&(t[i]=e[i]);return t})(o,["children","onClick"]);return e.jsx(s,(i=((e,r)=>{for(var t in r||(r={}))f.call(r,t)&&d(e,t,r[t]);if(c)for(var t of c(r))u.call(r,t)&&d(e,t,r[t]);return e})({ref:t,onClick:p},b),a(i,l({children:n}))))})),s=o.default.div`
  padding: 8px;
  width: 100%;
  height: 100%;
`;p.displayName="TabItem",exports.TabItem=p;


/***/ }),

/***/ 404607:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(561261);function e(t){return t&&"object"==typeof t&&"default"in t?t:{default:t}}var n=e(__webpack_require__(212951)),o=Object.defineProperty,r=Object.defineProperties,i=Object.getOwnPropertyDescriptors,a=Object.getOwnPropertySymbols,l=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,c=(t,e,n)=>e in t?o(t,e,{enumerable:!0,configurable:!0,writable:!0,value:n}):t[e]=n,x=(t,e)=>{for(var n in e||(e={}))l.call(e,n)&&c(t,n,e[n]);if(a)for(var n of a(e))f.call(e,n)&&c(t,n,e[n]);return t},s=(t,e)=>r(t,i(e));const g=e=>{var n=e,{type:o,children:r,isActive:i,activeColor:c="#258DFF",textColor:g,alignment:m,fontStyle:C,textTransform:h,fontSize:b,textAlign:S,activeTextColor:T}=n,$=((t,e)=>{var n={};for(var o in t)l.call(t,o)&&e.indexOf(o)<0&&(n[o]=t[o]);if(null!=t&&a)for(var o of a(t))e.indexOf(o)<0&&f.call(t,o)&&(n[o]=t[o]);return n})(n,["type","children","isActive","activeColor","textColor","alignment","fontStyle","textTransform","fontSize","textAlign","activeTextColor"]);const A=d(b);switch(o){case"line":return t.jsx(y,s(x({alignment:m,className:i?"active":"",textColor:g,activeColor:c,fontStyle:C,textAlign:S,textTransform:h,fontSize:A,activeTextColor:T},$),{children:r}));case"card":return t.jsx(p,s(x({alignment:m,className:i?"active":"",activeColor:c,textColor:g,fontStyle:C,textAlign:S,textTransform:h,fontSize:A,activeTextColor:T},$),{children:r}));case"rectangle":return t.jsx(u,s(x({className:i?"active":"",activeColor:c,textColor:g,fontStyle:C,textAlign:S,textTransform:h,fontSize:A,activeTextColor:T},$),{children:r}));default:return t.jsx(v,s(x({textTransform:h,className:i?"active":"",activeColor:c,textColor:g,fontStyle:C,textAlign:S,fontSize:A,activeTextColor:T},$),{children:r}))}},d=t=>{if(null!=t&&""!==t)return"string"==typeof t?t.replace(/px$/i,""):String(t)},m=({textColor:t,fontSize:e,fontFamily:n,fontWeight:o,fontStyle:r,textTransform:i,textDecoration:a,textAlign:l})=>`\n  transition: 0.2s;\n  cursor: pointer;\n  min-height: 32px;\n  padding: 0 16px;\n  display: flex;\n  align-items: center;\n  color: ${t||"inherit"};\n  font-size: ${null!=e&&""!==e?(null==e?void 0:e.includes("var"))?e:`${e}px`:"inherit"};\n  font-family: ${n||"inherit"};\n  font-weight: ${o||"inherit"};\n  font-style: ${r||"inherit"};\n  text-decoration: ${a||"inherit"};\n  text-transform: ${i||"inherit"};\n  justify-content: ${l||"center"};  // vì đang là flex nên không thể dùng textAlign\n`,v=n.default.div((({activeColor:t,textColor:e,fontSize:n,fontFamily:o,fontWeight:r,tabColor:i,fontStyle:a,textTransform:l,textDecoration:f,textAlign:c,activeTextColor:x})=>`\nborder-radius: 999px;\nbackground-color: ${i||"transparent"};\n${m({textColor:e,fontSize:n,fontFamily:o,fontWeight:r,fontStyle:a,textTransform:l,textDecoration:f,textAlign:c})}\n&.active {\n  background: ${t};\n  color: ${x||"#fff"};\n}\n`)),u=n.default.div((({activeColor:t,textColor:e,fontSize:n,fontFamily:o,fontWeight:r,tabColor:i,fontStyle:a,textTransform:l,textDecoration:f,textAlign:c,activeTextColor:x})=>`\nborder-radius: 0;\nbackground-color: ${i||"transparent"};\n${m({textColor:e,fontSize:n,fontFamily:o,fontWeight:r,fontStyle:a,textTransform:l,textDecoration:f,textAlign:c})}\n&.active {\n  background: ${t};\n  color: ${x||"#fff"};\n}\n`)),y=n.default.div((({activeColor:t,alignment:e,textColor:n,fontSize:o,fontFamily:r,fontWeight:i,tabColor:a,fontStyle:l,textTransform:f,textDecoration:c,textAlign:x,activeTextColor:s})=>`\n  ${m({textColor:n,fontSize:o,fontFamily:r,fontWeight:i,fontStyle:l,textTransform:f,textDecoration:c,textAlign:x})}\n  ${"justify"===e?"width: 100% !important;":""}\n  position: relative;\n  &::after {\n    content: '';\n    height: 2px;\n    background-color: ${a||"transparent"};\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    transition: all 0.3s ease;\n  }\n  &.active {\n    &::after {\n      background-color: ${t};\n    }\n    ${s?`color: ${s};`:""}\n  }\n`)),p=n.default.div((({activeColor:t,alignment:e,textColor:n,fontSize:o,fontFamily:r,fontWeight:i,tabColor:a,fontStyle:l,textDecoration:f,textTransform:c,textAlign:x})=>`\n  ${m({textColor:n,fontSize:o,fontFamily:r,fontWeight:i,fontStyle:l,textTransform:c,textDecoration:f,textAlign:x})}\n  ${"justify"===e?"width: 100% !important;":""}\n  ${a?`color: ${a};`:""}\n  &.active {\n    color: ${t};\n  }\n`));g.displayName="TabItemHead",exports.TabHeadButton=v,exports.TabHeadCard=p,exports.TabHeadLine=y,exports.TabHeadRectangle=u,exports.TabItemHead=g;


/***/ }),

/***/ 570953:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(212951),r=__webpack_require__(85097),t=__webpack_require__(534479);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=o(n),a=Object.defineProperty,i=Object.defineProperties,d=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,s=Object.prototype.propertyIsEnumerable,p=(e,n,r)=>n in e?a(e,n,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[n]=r,u=(e,n)=>{for(var r in n||(n={}))b.call(n,r)&&p(e,r,n[r]);if(c)for(var r of c(n))s.call(n,r)&&p(e,r,n[r]);return e},f=(e,n)=>i(e,d(n));const g=n=>{var r=n,{text:t,children:o}=r,l=((e,n)=>{var r={};for(var t in e)b.call(e,t)&&n.indexOf(t)<0&&(r[t]=e[t]);if(null!=e&&c)for(var t of c(e))n.indexOf(t)<0&&s.call(e,t)&&(r[t]=e[t]);return r})(r,["text","children"]);return o?e.jsx(x,f(u({},l),{children:o})):e.jsx(x,f(u({},l),{dangerouslySetInnerHTML:{__html:t}}))},x=l.default.div((({commonStyle:e,color:n,backgroundColor:o,borderColor:l,headerBackgroundColor:a})=>`\n    ${r.getStyle(e)};\n    ${t.getCommonTextCss()}\n    overflow-x: auto;\n    color: ${n||"inherit"};\n    background-color: ${o||"inherit"};\n\n    table {\n      border-collapse: collapse;\n      margin: 0;\n      overflow: hidden;\n      table-layout: fixed;\n      min-width: 100%;\n    }\n    table td, table th {\n      border: 2px solid ${l||"#ced4da"};\n      box-sizing: border-box;\n      min-width: 1em;\n      padding: 3px 5px;\n      position: relative;\n      vertical-align: top;\n    }\n    table td > *, table th > * {\n      margin-bottom: 0;\n    }\n    table th {\n      background-color: ${a||"#f1f3f5"};\n      font-weight: bold;\n      text-align: left;\n    }\n    table .selectedCell:after {\n      background: rgba(200, 200, 255, 0.4);\n      content: "";\n      left: 0;\n      right: 0;\n      top: 0;\n      bottom: 0;\n      pointer-events: none;\n      position: absolute;\n      z-index: 2;\n    }\n    table .column-resize-handle {\n      background-color: #adf;\n      bottom: -2px;\n      position: absolute;\n      right: -2px;\n      pointer-events: none;\n      top: 0;\n      width: 4px;\n    }\n    table p {\n      margin: 0;\n    }\n    .tableWrapper {\n      padding: 1rem 0;\n      overflow-x: auto;\n    }\n    .resize-cursor {\n      cursor: ew-resize;\n      cursor: col-resize;\n    }   \n  `));g.displayName="Table",exports.StyledTable=x,exports.Table=g;


/***/ }),

/***/ 925253:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(800656);const e={limit:10,type:"grid",itemSettings:{priceColor:"rgb(235, 31, 58)"},responsiveSettings:{desktop:{gap:4,itemsPerRow:5},mobile:{gap:4,itemsPerRow:2}},carouselSettings:{desktop:{paginationColor:"rgba(37, 141, 255, 1)",paginationPosition:"inside",gridRows:1,gridCols:5},mobile:{paginationColor:"rgba(37, 141, 255, 1)",paginationPosition:"inside",gridRows:1,gridCols:2.5}},button:{text:t.t("Xem thêm"),buttonStyle:{backgroundColor:"rgba(37, 141, 255, 1)",color:"rgba(255, 255, 255, 1)",height:32,width:120,borderRadius:999},iconConfig:{position:"left",spacing:8,show:!0,icon:{size:24}},commonStyle:{justifyContent:"center"}}},i={text:`<h4 style="text-align: center;">${t.t("Danh sách sản phẩm")}</h4>`};exports.DEFAULT_PRODUCT_LIST=e,exports.DEFAULT_PRODUCT_LIST_HEADING=i,exports.discoveryURIMap={"test-1":"https://discovery.dev.tekoapis.net/api",dev:"https://discovery.dev.tekoapis.net/api",stag:"https://discovery.stag.tekoapis.net/api",production:"https://discovery.tekoapis.com/api"};


/***/ }),

/***/ 65896:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(561261),e=__webpack_require__(891987);const r=e.createContext({products:[],setProducts:()=>{}});exports.ProductListContext=r,exports.ProductListProvider=({children:s})=>{const[o,u]=e.useState([]),[c,i]=e.useState(!0),n=e.useCallback(u,[]),a=e.useCallback(i,[]);return t.jsx(r.Provider,{value:{products:o,setProducts:n,showBlock:c,setShowBlock:a},children:s})},exports.useProductList=function(){const t=e.useContext(r);if(!t)throw new Error("useProductList must be inside a ProductListContext with a state value");return t};


/***/ }),

/***/ 828605:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(85097),o=__webpack_require__(586753);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var n=i(r),a=Object.defineProperty,l=Object.defineProperties,u=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,s=Object.prototype.hasOwnProperty,d=Object.prototype.propertyIsEnumerable,f=(e,r,t)=>r in e?a(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;const{noProductFoundImage:p}=t.mappingAssets,m=n.default.div`
  text-align: center;
  width: 100%;
  padding: 0.5rem 0;
`,b=n.default.div`
  margin-top: 0.5rem;
  font-size: 0.9rem;
  color: #82869e;
`;exports.NoProductsFound=r=>{var t,i,n=r,{text:a}=n,j=((e,r)=>{var t={};for(var o in e)s.call(e,o)&&r.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&c)for(var o of c(e))r.indexOf(o)<0&&d.call(e,o)&&(t[o]=e[o]);return t})(n,["text"]);return e.jsxs(m,(t=((e,r)=>{for(var t in r||(r={}))s.call(r,t)&&f(e,t,r[t]);if(c)for(var t of c(r))d.call(r,t)&&f(e,t,r[t]);return e})({},j),i={children:[e.jsx(o.Image,{width:200,src:p}),!!a&&e.jsx(b,{children:a})]},l(t,u(i))))};


/***/ }),

/***/ 764975:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),i=__webpack_require__(800656),t=__webpack_require__(212951),r=__webpack_require__(610314),o=__webpack_require__(697741),l=__webpack_require__(840424),n=__webpack_require__(586753);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=a(t),s=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable;const u=d.default.div`
  position: relative;
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  background-color: transparent;
`,h=d.default.div`
  position: relative;
  flex: 1 0 auto;
  margin-bottom: 8px;
`,x=d.default.div`
  position: relative;
  margin-bottom: 4px;
`,f=d.default.div`
  height: 2rem;
`,g=d.default(l.Paragraph)`
  font-size: 12px;
  line-height: 16px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: #434657;
  font-weight: 400;
`,j=d.default.div`
  position: relative;
  margin-top: 4px;
`,m=d.default(r.Tag)`
  line-height: 16px;
  margin-inline-end: 4px;
`,v=d.default(n.Image)`
  display: inline-block;
  overflow: hidden;
  position: absolute;
  height: 100%;
  inset: 0;
`;exports.ProductItem=t=>{var r=t,{product:l,isEditorMode:n}=r,a=((e,i)=>{var t={};for(var r in e)c.call(e,r)&&i.indexOf(r)<0&&(t[r]=e[r]);if(null!=e&&s)for(var r of s(e))i.indexOf(r)<0&&p.call(e,r)&&(t[r]=e[r]);return t})(r,["product","isEditorMode"]);const d=0===l.totalAvailable?e.jsx(m,{color:"#55acee",children:i.t("Hết hàng")}):null,b=e.jsx(u,{children:e.jsxs(h,{children:[e.jsx(x,{children:e.jsx("div",{style:{position:"relative",paddingBottom:"100%"},children:e.jsx(v,{commonStyle:{objectFit:"contain",height:"100%",width:"100%"},src:l.imageUrl,width:300,showPlaceholder:!1})})}),e.jsx(f,{children:e.jsx(g,{children:e.jsxs(e.Fragment,{children:[d,l.name]})})}),e.jsx(j,{children:e.jsx(o.ProductPrice,{latestPrice:l.latestPrice,supplierRetailPrice:l.supplierRetailPrice,textColor:a.priceColor})})]})});return l.url&&!n?e.jsx(e.Fragment,{children:e.jsx("a",{href:l.url,target:"_blank",children:b})}):b};


/***/ }),

/***/ 697741:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var n=i(t);const o=n.default.div((({align:e})=>`\n  display: flex;\n  flex-direction: column;\n  align-items: ${e};\n`)),l=n.default.div((({color:e})=>`\n  color: ${e||"rgb(235, 31, 58)"};\n  font-weight: 700;\n  text-decoration: unset;\n  font-size: 15px;\n  line-height: 24px;\n`)),c=n.default.div`
  text-decoration: line-through;
  color: rgb(130, 134, 158);
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
`,d=n.default.div`
  display: flex;
  height: 1rem;
`;exports.ProductPrice=({supplierRetailPrice:t,latestPrice:i,textColor:n,align:a="start"})=>{const s=r.formatCurrencyVND(t),u=r.formatCurrencyVND(i),f=e.jsx(l,{color:n,children:u}),x=e.jsx(c,{children:s});return e.jsxs(o,{align:a,children:[f,e.jsx(d,{children:t&&t>i&&x})]})};


/***/ }),

/***/ 242605:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(891987),t=__webpack_require__(212951),o=__webpack_require__(85097),n=__webpack_require__(65896),i=__webpack_require__(124946);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=a(r),u=a(t),d=Object.defineProperty,c=Object.getOwnPropertySymbols,s=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,p=(e,r,t)=>r in e?d(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,y=(e,r)=>{for(var t in r||(r={}))s.call(r,t)&&p(e,t,r[t]);if(c)for(var t of c(r))f.call(r,t)&&p(e,t,r[t]);return e};const j=l.default.forwardRef(((r,t)=>{const o=r,{isEditorMode:i=!1}=o,a=((e,r)=>{var t={};for(var o in e)s.call(e,o)&&r.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&c)for(var o of c(e))r.indexOf(o)<0&&f.call(e,o)&&(t[o]=e[o]);return t})(o,["isEditorMode"]),{showBlock:l}=n.useProductList();return i||l?e.jsx(b,y({ref:t},a)):null})),m=l.default.forwardRef(((r,t)=>{const o=r.isEditorMode?l.default.Fragment:i.LazyComponent;return e.jsx(o,{children:e.jsx(n.ProductListProvider,{children:e.jsx(j,y({ref:t},r))})})})),b=u.default.div((({commonStyle:e})=>`\n  ${o.getStyle(e)}\n`));m.displayName="TekoProductListV1",exports.ProductList=m;


/***/ }),

/***/ 61444:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(800656),n=__webpack_require__(212951),o=__webpack_require__(85097),i=__webpack_require__(891987),r=__webpack_require__(534388),s=__webpack_require__(65896),d=__webpack_require__(660218),l=__webpack_require__(228740),u=__webpack_require__(828605),c=__webpack_require__(764975),a=__webpack_require__(465112),p=__webpack_require__(750911),m=__webpack_require__(510690),h=__webpack_require__(115741);function x(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var v=x(n),g=x(i),j=Object.defineProperty,S=Object.defineProperties,f=Object.getOwnPropertyDescriptors,P=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,b=Object.prototype.propertyIsEnumerable,w=(e,t,n)=>t in e?j(e,t,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[t]=n,I=(e,t)=>{for(var n in t||(t={}))y.call(t,n)&&w(e,n,t[n]);if(P)for(var n of P(t))b.call(t,n)&&w(e,n,t[n]);return e},M=(e,t)=>S(e,f(t));const k=g.default.forwardRef(((n,l)=>{const{commonStyle:m,isEditorMode:x=!1,editorTerminal:v,type:g,responsiveSettings:j,carouselSettings:S,limit:f,menuItemId:P,slug:y,itemSettings:b,button:w,actionButton:k}=n,{terminalCode:q,terminalId:O,env:V}=o.useStore(),E=x?"number"==typeof v?{id:v}:{code:v}:{code:q,id:O},B=(null==E?void 0:E.code)||(null==E?void 0:E.id),{products:D,setProducts:z,setShowBlock:R}=s.useProductList(),[L,H]=i.useState(!1),[K,_]=i.useState(),[J,U]=i.useState(1),[A,G]=i.useState(!1);i.useEffect((()=>{U(1),(async()=>{if(B&&(P||y)&&k)try{if(G(!0),y){const{products:e,hasNextPage:t}=await d.fetchProductsByCollection(V,{slug:y,terminal:E,size:f});H(t),z(d.cookProducts(e)),0===e.length&&R(!1)}else{const{products:e,hasNextPage:t,menuItem:n}=await d.fetchProducts(V,{menuItemId:+P,terminal:E,size:f});H(t),z(d.cookProducts(e)),_(n),0===e.length&&R(!1)}}finally{G(!1)}else z([]),R(!1)})()}),[P,f,JSON.stringify(E),k,y]),i.useEffect((()=>{J>1&&(async()=>{if(B&&(P||y)&&k)try{if(G(!0),y){const{products:e,hasNextPage:t}=await d.fetchProductsByCollection(V,{slug:y,terminal:E,size:f,page:J});H(t),z((t=>[...t,...d.cookProducts(e)]))}else{const{products:e,hasNextPage:t}=await d.fetchProducts(V,{menuItemId:+P,terminal:E,size:f,page:J},K);H(t),z((t=>[...t,...d.cookProducts(e)]))}}finally{G(!1)}else z([]),R(!1)})()}),[J]);const Q="openSearch"===k||"loadMore"===k&&L,W="openSearch"===k&&(K||y)?{eventType:"link",link:{href:y||d.convertMenuItemConfigToUrl(K),openNewTab:!0,nofollow:!1}}:void 0,X="loadMore"===k&&(K||y)?()=>{U((e=>e+1))}:void 0;return"carousel"===g?e.jsx(F,{commonStyle:m,ref:l,children:e.jsxs(a.Spin,{spinning:A,style:{minHeight:250},children:[x?B&&(P||y)?B&&(P||y)&&0===(null==D?void 0:D.length)?e.jsx(u.NoProductsFound,{text:t.t("Không tìm thấy sản phẩm nào")}):n.isMobile?e.jsx(h.DSSlider,M(I({},r.convertOptionSliderV2ToV1(S.mobile)),{children:D.map(((t,n)=>e.jsx(c.ProductItem,I({product:t,isEditorMode:x},b),n)))})):e.jsx(h.DSSlider,M(I({},r.convertOptionSliderV2ToV1(S.desktop)),{children:D.map(((t,n)=>e.jsx(c.ProductItem,I({product:t,isEditorMode:x},b),n)))})):e.jsx(u.NoProductsFound,{text:t.t("Vui lòng chọn điểm bán và nhập trang danh sách sản phẩm")}):e.jsxs(e.Fragment,{children:[e.jsx(C,{children:e.jsx(h.DSSlider,M(I({},r.convertOptionSliderV2ToV1(S.mobile)),{children:(D||[]).map(((t,n)=>e.jsx(c.ProductItem,I({product:t,isEditorMode:x},b),n)))}))}),e.jsx(T,{children:e.jsx(h.DSSlider,M(I({},r.convertOptionSliderV2ToV1(S.desktop)),{children:(D||[]).map(((t,n)=>e.jsx(c.ProductItem,I({product:t,isEditorMode:x},b),n)))}))})]}),Q&&e.jsx(p.ButtonV2,M(I({isEditingMode:x},w),{event:W,onClick:X}))]})}):e.jsx(F,{commonStyle:m,ref:l,children:e.jsxs(a.Spin,{spinning:A,style:{minHeight:250},children:[x?B&&(P||y)?B&&(P||y)&&0===(null==D?void 0:D.length)?e.jsx(u.NoProductsFound,{text:t.t("Không tìm thấy sản phẩm nào")}):e.jsx(N,{responsiveSettings:j,children:D.map(((t,n)=>e.jsx($,{responsiveSettings:j,children:e.jsx(c.ProductItem,I({product:t,isEditorMode:x},b))},n)))}):e.jsx(u.NoProductsFound,{text:t.t("Vui lòng chọn điểm bán và nhập trang danh sách sản phẩm")}):e.jsx(N,{responsiveSettings:j,children:D.map(((t,n)=>e.jsx($,{responsiveSettings:j,children:e.jsx(c.ProductItem,I({product:t,isEditorMode:x},b))},n)))}),Q&&e.jsx(p.ButtonV2,M(I({isEditingMode:x},w),{event:W,onClick:X}))]})})})),q=({responsiveSettings:e})=>{var t;return`\n    gap: ${(null==(t=null==e?void 0:e.mobile)?void 0:t.gap)||4}px;\n  `},O=({responsiveSettings:e})=>{var t;return`\n    gap: ${(null==(t=null==e?void 0:e.desktop)?void 0:t.gap)||4}px;\n  `},N=v.default(m.PbRow)((e=>{const{isMobile:t,commonStyle:n}=e;return[`\n      ${o.getStyle(n)}\n      display: flex;\n      flex-wrap: wrap;\n      place-content: flex-start;\n      min-height: 150px;\n    `,t&&q,!1===t&&O,void 0===t&&`\n        @media (max-width: 767px) {\n          ${q(e)}\n        }\n        @media (min-width: 767px) {\n          ${O(e)}\n        }\n      `]})),V=({responsiveSettings:e})=>{var t,n;const o=(null==(t=null==e?void 0:e.mobile)?void 0:t.gap)||4;return`\n    width: calc(${100/((null==(n=null==e?void 0:e.mobile)?void 0:n.itemsPerRow)||2)}% - ${o}px);\n  `},E=({responsiveSettings:e})=>{var t,n;const o=(null==(t=null==e?void 0:e.desktop)?void 0:t.gap)||4;return`\n  width: calc(${100/((null==(n=null==e?void 0:e.desktop)?void 0:n.itemsPerRow)||5)}% - ${o}px);\n  `},$=v.default(l.PbCol)((e=>{const{isMobile:t}=e;return[t&&V,!1===t&&E,void 0===t&&`\n        @media (max-width: 767px) {\n          ${V(e)}\n        }\n        @media (min-width: 767px) {\n          ${E(e)}\n        }\n      `]})),C=v.default.div`
  @media (min-width: 767px) {
    display: none;
  }
`,T=v.default.div`
  @media (max-width: 767px) {
    display: none;
  }
`,F=v.default.div((({commonStyle:e})=>`\n  ${o.getStyle(e)}\n`));k.displayName="TekoProductListContentV1",exports.ProductListContent=k;


/***/ }),

/***/ 660218:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(925253),e=__webpack_require__(85097),o=Object.defineProperty,r=Object.defineProperties,i=Object.getOwnPropertyDescriptors,n=Object.getOwnPropertySymbols,l=Object.prototype.hasOwnProperty,s=Object.prototype.propertyIsEnumerable,a=(t,e,r)=>e in t?o(t,e,{enumerable:!0,configurable:!0,writable:!0,value:r}):t[e]=r,c=(t,e)=>{for(var o in e||(e={}))l.call(e,o)&&a(t,o,e[o]);if(n)for(var o of n(e))s.call(e,o)&&a(t,o,e[o]);return t},u=(t,e)=>r(t,i(e)),d=(t,e)=>{var o={};for(var r in t)l.call(t,r)&&e.indexOf(r)<0&&(o[r]=t[r]);if(null!=t&&n)for(var r of n(t))e.indexOf(r)<0&&s.call(t,r)&&(o[r]=t[r]);return o};const p=t=>{var e;const o=null==(e=t.filter((t=>{var e;const o="coupon"===t.type,r="product"===t.applyOn,i=!!(null==(e=null==t?void 0:t.condition)?void 0:e.coupon);return o&&r&&i})))?void 0:e[0];return[...t.filter((t=>{const e="product"===t.type,o="product"===t.applyOn,r=t.isDefault;return e&&o&&r})),o].filter(Boolean)},v=t=>t.filter((t=>{const e="product"===t.type,o="product"===t.applyOn,r=t.isDefault;return e&&o&&!r})),f=t=>[...p(t),...v(t)].some((t=>{var e;return((null==(e=null==t?void 0:t.benefit)?void 0:e.gifts)||[]).length})),g=t=>{const e={sorting:{order:"ORDER_BY_UNSPECIFIED",sort:"SORT_BY_UNSPECIFIED"},filter:{}};if(Object.keys((null==t?void 0:t.sorting)||{}).length&&(e.sorting=c(c({},e.sorting),t.sorting)),Object.keys((null==t?void 0:t.configs)||{}).length){const o=t.configs,{price:r,providerIds:i,sellerIds:n,attributes:l,hasPromotions:s}=o,a=d(o,["price","providerIds","sellerIds","attributes","hasPromotions"]);e.filter=a,(null==i?void 0:i.length)&&(e.filter.providerIds=i.map((t=>t.toString()))),(null==n?void 0:n.length)&&(e.filter.sellerIds=n.map((t=>t.toString()))),(null==l?void 0:l.length)&&(e.filter.attributes=l.map((t=>({code:t.code,optionIds:(t.optionIds||[]).map((t=>t.toString()))})))),(null==r?void 0:r.from)&&(e.filter.priceGte=r.from.toString()),(null==r?void 0:r.to)&&(e.filter.priceLte=r.to.toString()),s&&(e.filter.hasPromotions=!!s)}return e};exports.convertMenuItemConfigToUrl=t=>{const e=t.configs||{},o=t.sorting||{},r=new URLSearchParams;Object.keys(o).forEach((t=>r.append(t,o[t])));const i=e,{price:n,attributes:l}=i,s=d(i,["price","attributes"]),{from:a,to:c}=n||{};return a&&r.set("price_gte",a.toString()),c&&r.set("price_lte",c.toString()),(l||[]).forEach((t=>{r.set(`attributes.${t.code}`,t.optionIds.join(","))})),Object.keys(s).forEach((t=>{const e=s[t];Array.isArray(e)&&e.length>0?r.set(t,e.join(",")):"number"!=typeof e&&"string"!=typeof e&&"boolean"!=typeof e||r.set(t,`${e}`)})),`/search?${r.toString()}`},exports.cookProducts=t=>t.map((t=>(t=>{const{flashSales:e,prices:o,productInfo:r,promotions:i,totalAvailable:n}=t,{canonical:l,name:s,sku:a,imageUrl:d}=r;return u(c({totalAvailable:n},(t=>{var e,o,r,i;const n=null==(e=null==t?void 0:t[0])?void 0:e.latestPrice,l=null==(o=null==t?void 0:t[0])?void 0:o.supplierRetailPrice,s=null==(r=null==t?void 0:t[0])?void 0:r.discountPercent,a=null==(i=null==t?void 0:t[0])?void 0:i.discountAmount;return{latestPrice:n&&+n,discountAmount:a&&+a,discountPercent:s,supplierRetailPrice:l&&+l}})(o)),{url:`/${l}`,name:s,sku:a,imageUrl:d,hasGift:f(i),flashSale:null==e?void 0:e[0]})})(t))),exports.fetchProducts=async(o,r,i)=>{var n,l;const{menuItemId:s,terminal:a,locationCode:d,size:p=10,page:v=1}=r,f=(null==a?void 0:a.code)||(null==a?void 0:a.id),m=(null==a?void 0:a.code)||void 0,y=(null==a?void 0:a.id)||void 0,P=t.discoveryURIMap[o];if(!P)throw"Please set discoveryURI!";if(!s||!f)return;const b=new e.Api("");let h=i;if(h||(h=await b.get(`${P}/v1/menu-item/${s}`).then((t=>{var e;return null==(e=t.data)?void 0:e.result}))),!h)return{products:[]};const I=await b.post(`${P}/v1/search`,u(c({},g(h)),{terminalCode:m,terminalId:y,location:d,pagination:{pageNumber:v,itemsPerPage:p}}));return{products:(null==(n=I.data.result)?void 0:n.products)||[],hasNextPage:((null==(l=I.data.pagination)?void 0:l.totalPages)||0)>v,menuItem:h}},exports.fetchProductsByCollection=async(o,r)=>{var i,n;const{slug:l,terminal:s,locationCode:a,size:c=10,page:u=1}=r,d=(null==s?void 0:s.code)||(null==s?void 0:s.id),p=(null==s?void 0:s.code)||void 0,v=(null==s?void 0:s.id)||void 0,f=t.discoveryURIMap[o];if(!f)throw"Please set discoveryURI!";if(!l||!d)return;const g=new e.Api(""),m=await g.post(`${f}/v1/search`,{slug:l,terminalCode:p,terminalId:v,location:a,pagination:{pageNumber:u,itemsPerPage:c}});return{products:(null==(i=m.data.result)?void 0:i.products)||[],hasNextPage:((null==(n=m.data.pagination)?void 0:n.totalPages)||0)>u}},exports.transformSearchBody=g;


/***/ }),

/***/ 416327:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(212951),t=__webpack_require__(85097),r=__webpack_require__(586753);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=i(n),o=Object.defineProperty,l=Object.defineProperties,m=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,g=Object.prototype.hasOwnProperty,s=Object.prototype.propertyIsEnumerable,c=(e,n,t)=>n in e?o(e,n,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[n]=t,u=(e,n)=>{for(var t in n||(n={}))g.call(n,t)&&c(e,t,n[t]);if(d)for(var t of d(n))s.call(n,t)&&c(e,t,n[t]);return e},p=(e,n)=>l(e,m(n));const f=(e,n)=>`arrow-${e.split(/(?=[A-Z])/).join("-").toLowerCase()}-${n}`,w=a.default.div((({width:e,layout:n,alignment:t,skin:r})=>`\n      width: ${e||100}%;\n      justify-content: ${"left"===t?"flex-start":"right"===t?"flex-end":"center"};\n      .image{\n        padding: 12px;\n      }\n      ${((e,n)=>{switch(e){case"bubble":return`${(e=>{switch(e){case"imageAbove":return"display: flex; \n            align-items: center;\n            flex-wrap: wrap;\n            .testimonial {\n              &__image {\n                order: 1;\n              }\n              &__footer {\n                order: 2;\n              }\n              &__content {\n                order: 3;\n              }\n            }";case"imageStacked":return"display: grid;\n            grid-template-rows: auto auto auto;\n            grid-template-columns: 1fr;\n            .testimonial {\n              &__content {\n                grid-row: 1/2;\n              }\n              &__image {\n                grid-row: 2/3;\n              }\n              &__footer {\n                grid-row: 3/4;\n              }\n            }";case"imageInline":return"display: flex; \n            flex-wrap: wrap;\n            align-items: center;";case"imageRight":return"display: grid;\n            grid-template-rows: auto 1fr;\n            grid-template-columns: 1fr auto;\n            .testimonial {\n              &__content {\n                grid-row: 1/3; \n                grid-column: 1/2;\n              }\n              &__image {\n                grid-row: 1/2; \n                grid-column: 2/3;\n              }\n              &__footer {\n                grid-row: 2/3; \n                grid-column: 2/3;\n              }\n            }";case"imageLeft":return"display: grid;\n            grid-template-rows: auto 1fr;\n            grid-template-columns: auto 1fr;\n            .testimonial {\n              &__content {\n                grid-row: 1/3;\n                grid-column: 2/3;\n              }\n              &__image {\n                grid-row: 1/2; \n                grid-column: 1/2;\n              }\n              &__footer {\n                grid-row: 2/3; \n                grid-column: 1/2;\n              }\n            }";default:return""}})(n)} \n              ${(e=>{switch(e){case"imageAbove":return".testimonial__content { margin-top: 20px; }";case"imageStacked":case"imageInline":return".testimonial__content { margin-bottom: 20px; }";case"imageRight":case"imageLeft":return"column-gap: 20px;";default:return""}})(n)}`;case"default":return(e=>{switch(e){case"imageAbove":return"display: grid;\n            grid-template-rows: auto auto auto;\n            grid-template-columns: 1fr;\n            .testimonial {\n              &__content {\n                grid-row: 2/3;\n              }\n              &__image {\n                grid-row: 1/2;\n              }\n              &__footer {\n                grid-row: 3/4;\n              }\n            }";case"imageStacked":return"display: grid;\n            grid-template-rows: auto auto auto;\n            grid-template-columns: 1fr;\n            .testimonial {\n              &__content {\n                grid-row: 1/2;\n              }\n              &__image {\n                grid-row: 2/3;\n              }\n              &__footer {\n                grid-row: 3/4;\n              }\n            }";case"imageInline":return"display: flex; \n            flex-wrap: wrap;\n            align-items: center;";case"imageRight":return"display: grid;\n            grid-template-rows: auto 1fr;\n            grid-template-columns: 1fr auto;\n            .testimonial {\n              &__content {\n                grid-row: 1/2; \n                grid-column: 1/2;\n              }\n              &__image {\n                grid-row: 1/3; \n                grid-column: 2/3;\n              }\n              &__footer {\n                grid-row: 2/3; \n                grid-column: 1/2;\n              }\n            }";case"imageLeft":return"display: grid;\n            grid-template-rows: auto 1fr;\n            grid-template-columns: auto 1fr;\n            .testimonial {\n              &__content {\n                grid-row: 1/2;\n                grid-column: 2/3;\n              }\n              &__image {\n                grid-row: 1/3; \n                grid-column: 1/2;\n              }\n              &__footer {\n                grid-row: 2/3; \n                grid-column: 2/3;\n              }\n            }";default:return""}})(n);default:return""}})(r,n)}\n    `)),_=a.default.div((({commonStyle:e})=>`\n      ${t.getStyle(e)}\n    `)),y=a.default.div((({commonStyle:e})=>`\n      ${t.getStyle(e)}\n    `)),h=a.default.div((({commonStyle:e})=>`\n      ${t.getStyle(e)}\n    `)),x=a.default.div((({skin:e,commonStyle:n})=>`\n  width: 100%;\n  position: relative;\n  ${((e,n)=>{switch(e){case"bubble":return t.getStyle(n);case"default":return".arrow{ display: none; }";default:return""}})(e,n)}`)),b=a.default.div((({imgWidth:e,className:n})=>`\n    position: absolute;\n    width: 12px;\n    height: 12px;\n    background: inherit;\n    z-index: -1;\n    transform: rotate(45deg);\n    ${(e=>e.includes("inline")||e.includes("stacked")?"bottom":e.includes("image-left")?"left":e.includes("image-right")?"right":e.includes("above")?"top":void 0)(n)}: -6px;\n    &.arrow-image-inline-left, \n    &.arrow-image-stacked-left, \n    &.arrow-image-above-left {\n      left: ${e/2-6}px;\n    }\n    &.arrow-image-inline-right,\n    &.arrow-image-stacked-right, \n    &.arrow-image-above-right {\n      right: ${e/2-6}px;\n    }\n    &.arrow-image-inline-center,\n    &.arrow-image-stacked-center, \n    &.arrow-image-above-center {\n      right: calc(50% - 6px);\n    }\n    ${n.includes("image-left")||n.includes("image-right")?`top: ${e/2-6}px;`:""}\n  `));exports.Arrow=b,exports.Content=_,exports.ContentWrapper=x,exports.Name=y,exports.StyledItem=w,exports.TestimonialItem=({image:n,imageStyle:t,content:i,contentStyle:a,title:o,titleStyle:l,name:m,nameStyle:d,width:g,alignment:s,layout:c,skin:v,bubbleStyle:S})=>{const j="imageInline"===c||"imageAbove"===c?s:null==t?void 0:t.alignment;return e.jsxs(w,{width:g,layout:c,alignment:s,skin:v,children:[e.jsxs(x,{skin:v,className:"testimonial__content",commonStyle:S,children:[e.jsx(_,{commonStyle:a,children:i}),e.jsx(b,{className:`arrow ${f(c,j||"center")}`,imgWidth:t.width})]}),e.jsx("div",{className:"testimonial__image",children:e.jsx(r.Image,p(u({},n),{commonStyle:p(u({},t),{height:t.width,objectFit:"cover"}),alignment:t.alignment}))}),e.jsxs("div",{className:"testimonial__footer",children:[e.jsx(y,{commonStyle:d,children:m}),e.jsx(h,{commonStyle:l,children:o})]})]})},exports.Title=h,exports.getArrowClassName=f;


/***/ }),

/***/ 865338:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),l=__webpack_require__(85097),r=__webpack_require__(416327),n=__webpack_require__(115741);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var o=i(t),a=Object.defineProperty,s=Object.defineProperties,y=Object.getOwnPropertyDescriptors,m=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,d=(e,t,l)=>t in e?a(e,t,{enumerable:!0,configurable:!0,writable:!0,value:l}):e[t]=l,f=(e,t)=>{for(var l in t||(t={}))c.call(t,l)&&d(e,l,t[l]);if(m)for(var l of m(t))u.call(t,l)&&d(e,l,t[l]);return e},S=(e,t)=>s(e,y(t));const b=t=>{var l=t,{items:i,commonStyle:o,contentStyle:a,nameStyle:s,titleStyle:y,imageStyle:d,bubbleStyle:b,width:g,alignment:v="center",layout:x,skin:O}=l,h=((e,t)=>{var l={};for(var r in e)c.call(e,r)&&t.indexOf(r)<0&&(l[r]=e[r]);if(null!=e&&m)for(var r of m(e))t.indexOf(r)<0&&u.call(e,r)&&(l[r]=e[r]);return l})(l,["items","commonStyle","contentStyle","nameStyle","titleStyle","imageStyle","bubbleStyle","width","alignment","layout","skin"]);return e.jsx(p,{commonStyle:o,children:e.jsx(n.DSSlider,S(f({},h),{children:i.map(((t,l)=>e.jsx(j,{alignment:v,children:e.jsx(r.TestimonialItem,S(f({},t),{skin:O,contentStyle:a,titleStyle:y,nameStyle:s,imageStyle:d,bubbleStyle:b,width:g,alignment:v,layout:x}))},l)))}))})},p=o.default.div((({commonStyle:e})=>`\n    ${l.getStyle(e)}\n  `)),j=o.default.div((({alignment:e})=>`\n    display: flex;\n    justify-content: ${"left"===e?"flex-start":"right"===e?"flex-end":"center"};\n`));b.displayName="TestimonialCarousel",exports.TestimonialCarousel=b;


/***/ }),

/***/ 690131:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097),o=__webpack_require__(891987);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var n=i(t);const l=i(o).default.forwardRef((({children:t,commonStyle:r},o)=>e.jsx(a,{commonStyle:r,ref:o,children:t}))),a=n.default.div((({commonStyle:e})=>`\n    ${r.getStyle(e)}\n  `));l.displayName="TestimonialV2Item",exports.TestimonialV2Item=l;


/***/ }),

/***/ 963766:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(534388),t=__webpack_require__(115741),i=Object.defineProperty,o=Object.defineProperties,l=Object.getOwnPropertyDescriptors,s=Object.getOwnPropertySymbols,n=Object.prototype.hasOwnProperty,c=Object.prototype.propertyIsEnumerable,a=(e,r,t)=>r in e?i(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;const p=i=>{const{children:p}=i;return e.jsx(t.DSSlider,(u=((e,r)=>{for(var t in r||(r={}))n.call(r,t)&&a(e,t,r[t]);if(s)for(var t of s(r))c.call(r,t)&&a(e,t,r[t]);return e})({},r.convertOptionSliderV2ToV1(i)),o(u,l({children:p}))));var u};p.displayName="TestimonialV2",exports.TestimonialV2=p;


/***/ }),

/***/ 630944:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=(e=>(e.Image="image",e.Color="color",e))(e||{});exports.BackgroundText=e;


/***/ }),

/***/ 127575:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),n=__webpack_require__(85097),r=__webpack_require__(891987),i=__webpack_require__(630944),o=__webpack_require__(319891);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=a(t),d=Object.defineProperty,c=Object.defineProperties,s=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,y=(e,t,n)=>t in e?d(e,t,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[t]=n,f=(e,t)=>{for(var n in t||(t={}))p.call(t,n)&&y(e,n,t[n]);if(u)for(var n of u(t))g.call(t,n)&&y(e,n,t[n]);return e},x=(e,t)=>c(e,s(t)),b=(e,t)=>{var n={};for(var r in e)p.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&u)for(var r of u(e))t.indexOf(r)<0&&g.call(e,r)&&(n[r]=e[r]);return n};const h=t=>{var i;const a=t,{content:l,event:d,type:c,backgroundText:s,isEditingMode:u}=a,p=b(a,["content","event","type","backgroundText","isEditingMode"]),g=null==d?void 0:d.tekoTrackingEvent,{device:y}=n.useStore(),{commonStyle:h,textStyle:k}=n.getPropsByDevice(p,y),w=(null==k?void 0:k.textLevel)||"p",S=(null==k?void 0:k.textAlign)||"left",O=null==(i=null==h?void 0:h.textShadow)?void 0:i.on,$=h||{},{textShadow:j,defaultOverlay:T}=$,E=b($,["textShadow","defaultOverlay"]),M=r.useRef(),{style:P,animationClassName:q}=n.useAnimation(null==h?void 0:h.animation,M);return e.jsx(m,x(f({ref:M,commonStyle:E,align:S,isEditingMode:u,style:P,className:q,"data-id":p.id},n.getAttrTracking(g)),{children:e.jsx(o.Link,x(f({},d),{children:e.jsx(v,{type:c,textStyle:k,isEnabledShadow:O,textShadow:j,backgroundText:s,overlayOpacity:T,dangerouslySetInnerHTML:{__html:`<${w}>${l}</${w}>`}})}))}))},m=l.default.div((({commonStyle:e,align:t,isEditingMode:r})=>`\n      display: flex;\n      justify-content: ${t};\n      ${r?"pointer-events: none;":""}\n      ${n.getStyle(e)}\n    `)),v=l.default.div((({textStyle:e,type:t,backgroundText:r,isEnabledShadow:o,textShadow:a,overlayOpacity:l})=>{let d="";switch(t){case i.BackgroundText.Image:(null==r?void 0:r.image)&&(d=`\n          background-image:\n            linear-gradient(rgba(0,0,0,${l||0}), rgba(0,0,0,${l||0})),\n            url('${r.image}');\n          background-size: cover;\n          -webkit-background-clip: text;\n          -webkit-text-fill-color: transparent;\n          background-clip: text;\n          color: transparent;\n          ${o?n.getDropShadowFilter(a):""}\n        `);break;case i.BackgroundText.Color:if(null==r?void 0:r.color){const e=r.color;d=e.includes("gradient")?`\n            background-image: ${e};\n            background-size: cover;\n            -webkit-background-clip: text;\n            -webkit-text-fill-color: transparent;\n            background-clip: text;\n            color: transparent;\n            ${o?n.getDropShadowFilter(a):""}\n          `:`\n            color: ${e};\n             ${o?n.getTextShadow(a):""}\n          `}break;default:d="\n        color: #000;  \n      "}return`\n    width: fit-content;\n    max-width: 100%;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n    ${d}\n    ${n.getStyle(e)}\n    \n    /* Override default heading styles */\n    h1, h2, h3, h4, h5, h6, p {\n      margin: 0;\n      padding: 0;\n      font-size: inherit !important;\n      font-weight: inherit !important;\n      line-height: inherit !important;\n      color: inherit !important;\n      text-shadow: inherit !important;\n      font-family: inherit !important;\n      letter-spacing: inherit !important;\n    }\n  `}));h.displayName="TextMask",exports.TextMask=h;


/***/ }),

/***/ 909381:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(398985),e=Object.defineProperty,i=Object.defineProperties,r=Object.getOwnPropertyDescriptors,o=Object.getOwnPropertySymbols,l=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable,n=(t,i,r)=>i in t?e(t,i,{enumerable:!0,configurable:!0,writable:!0,value:r}):t[i]=r,g=(t,e)=>{for(var i in e||(e={}))l.call(e,i)&&n(t,i,e[i]);if(o)for(var i of o(e))a.call(e,i)&&n(t,i,e[i]);return t};const p={icon:{name:"CheckOutlined",color:"rgba(0,0,0,1)",background:"rgba(255,255,255,1)"},style:{background:"rgba(255,255,255,1)",borderColor:"rgba(220,222,225,1)"}},c=[g({title:"Tab 1"},p),g({title:"Tab 2"},p),g({title:"Tab 3"},p)],b={timelines:c,itemSpacingMode:t.ItemSpacingMode.Auto,lineStyle:{borderColor:"rgba(220,222,225,1)"},icon:{size:34},commonStyle:{padding:{left:20,right:20,top:20,bottom:20}},isShowTitle:!1,desktop:{direction:t.TimelineDirection.Horizontal,horizontalAlign:t.HorizontalAlign.Alternate,verticalAlign:t.VerticalAlign.Alternate,itemWidth:300,itemSpacingHorizontal:300,titleStyle:{fontSize:16,fontWeight:"400",width:200}},mobile:{direction:t.TimelineDirection.Vertical,horizontalAlign:t.HorizontalAlign.Alternate,verticalAlign:t.VerticalAlign.Right,itemWidth:300,itemSpacingHorizontal:300,titleStyle:{fontSize:14,fontWeight:"400",width:80}}},m=i(g({},b),r({titleStyle:{currentParagraphTheme:"paragraph1",fontFamily:"var(--tempi-global-paragraph1fontfamily)",color:"#000000"},desktop:{direction:t.TimelineDirection.Horizontal,horizontalAlign:t.HorizontalAlign.Alternate,verticalAlign:t.VerticalAlign.Alternate,itemWidth:300,itemSpacingHorizontal:300,titleStyle:{fontSize:"var(--tempi-global-paragraph1fontsize)",fontWeight:"var(--tempi-global-paragraph1fontweight)",lineHeight:"var(--tempi-global-paragraph1lineheight)",letterSpacing:"var(--tempi-global-paragraph1letterspacing)",width:200}},mobile:{direction:t.TimelineDirection.Vertical,horizontalAlign:t.HorizontalAlign.Alternate,verticalAlign:t.VerticalAlign.Right,itemWidth:300,itemSpacingHorizontal:300,titleStyle:{fontSize:"var(--tempi-global-paragraph1mobilefontsize)",fontWeight:"var(--tempi-global-paragraph1mobilefontweight)",lineHeight:"var(--tempi-global-paragraph1mobilelineheight)",letterSpacing:"var(--tempi-global-paragraph1mobileletterspacing)",width:80}}}));exports.DEFAULT_TIMELINE=b,exports.DEFAULT_TIMELINES=c,exports.DEFAULT_TIMELINE_THEME=m,exports.ITEM_TIMELINE_DEFAULT=p,exports.SAMPLE_TIMELINE=[{tag:"Rectangle",group:"Tab",src:"https://lh3.googleusercontent.com/Z6cm67hJGE_3PVZtqVWzO6HOmnCI5Z8bxCqfMcnIrLCv_yiPEMlW5xkbQ40qMUNZRzkQQgCl8vt4Mrqi4AXJilwudcs7fvoi"},{tag:"Button",group:"Tab",src:"https://lh3.googleusercontent.com/-QrRg_x1e3FzQ0wSAPZlw8i54dYCmP-IMaiiReQ8cbF_Mi8Lvx_M3iRvXi6b1OgPwJdDcgUQ5S-cGHPrZJ9XFWunQFmxJdgOfg"},{tag:"Line",group:"Tab",src:"https://lh3.googleusercontent.com/-JbbrnwqdGaKpPQi7Fr82P5T3xGPv7w6NyCNOkVbSLQ0xMhByb5kpPor26cuebQ6SMC2_oD_CXTRtgQbEvMAq7NNQlWVYhm-"},{tag:"Card",group:"Tab",src:"https://lh3.googleusercontent.com/QCjtqKNUZKeUbyDYntH7E_HxjUeSOETygcmHvIHp6iC4bAYPk_TYuSSIIX9L1r_L8cIPxe7dmFeezbJB7V7xumGMk_viyIssEg"}],exports.TIMELINE_DISPLAY_NAME="Timeline",exports.TIMELINE_ITEM_DISPLAY_NAME="TimelineItem",exports.TIMELINE_ITEM_WIDTH_DEFAULT=300,exports.TIMELINE_ITEM_WIDTH_MOBILE_DEFAULT=300,exports.TIMELINE_TITLE_WIDTH_DESKTOP_DEFAULT=200,exports.TIMELINE_TITLE_WIDTH_MOBILE_DEFAULT=80;


/***/ }),

/***/ 398985:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=(t=>(t.Top="top",t.Bottom="bottom",t.Alternate="alternate",t))(t||{}),e=(t=>(t.Left="start",t.Right="end",t.Alternate="alternate",t))(e||{}),o=(t=>(t.Horizontal="horizontal",t.Vertical="vertical",t))(o||{}),r=(t=>(t.Auto="auto",t.Custom="custom",t))(r||{});exports.HorizontalAlign=t,exports.ItemSpacingMode=r,exports.TimelineDirection=o,exports.VerticalAlign=e;


/***/ }),

/***/ 292221:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var n=__webpack_require__(561261),t=__webpack_require__(212951),e=__webpack_require__(85097),i=__webpack_require__(143599),r=__webpack_require__(891987),o=__webpack_require__(909381),l=__webpack_require__(398985),a=__webpack_require__(628912);function s(n){return n&&"object"==typeof n&&"default"in n?n:{default:n}}var p=s(t),d=s(r),c=Object.defineProperty,m=Object.defineProperties,g=Object.getOwnPropertyDescriptors,f=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,x=Object.prototype.propertyIsEnumerable,u=(n,t,e)=>t in n?c(n,t,{enumerable:!0,configurable:!0,writable:!0,value:e}):n[t]=e,h=(n,t)=>{for(var e in t||(t={}))b.call(t,e)&&u(n,e,t[e]);if(f)for(var e of f(t))x.call(t,e)&&u(n,e,t[e]);return n},v=(n,t)=>m(n,g(t));const y=r.forwardRef(((t,r)=>{var s=t,{children:p,timelines:c,itemSpacingMode:m,lineStyle:g,isShowTitle:u}=s,y=((n,t)=>{var e={};for(var i in n)b.call(n,i)&&t.indexOf(i)<0&&(e[i]=n[i]);if(null!=n&&f)for(var i of f(n))t.indexOf(i)<0&&x.call(n,i)&&(e[i]=n[i]);return e})(s,["children","timelines","itemSpacingMode","lineStyle","isShowTitle"]);const{device:z}=e.useStore(),I="mobile"===z,{icon:T,itemWidth:j=o.TIMELINE_ITEM_WIDTH_DEFAULT,itemSpacingVertical:E,itemSpacingHorizontal:M,commonStyle:k,titleStyle:H,horizontalAlign:O,verticalAlign:X,direction:N}=e.getPropsByDevice(y,z),D=d.default.Children.map(p,(n=>{if(n)return n}))||[],L=null==p?void 0:p.length,P=(null==T?void 0:T.size)||o.DEFAULT_TIMELINE.icon.size,V=P+10,_=I&&X===l.VerticalAlign.Alternate?l.VerticalAlign.Right:X;return n.jsx(S,v(h({ref:r},y),{lengthTimeline:L,blockIconSize:V,itemSpacingMode:m,itemSpacingHorizontal:M,itemSpacingVertical:E,commonStyle:k,lineStyle:g,direction:N,horizontalAlign:O,verticalAlign:_,isShowTitle:u,titleStyle:H,isMobile:I,children:c.map(((t,e)=>{const{nodeId:r,icon:s,style:p,title:d}=t||{},c=D.find((n=>{var t,e;return(null==(t=n.props)?void 0:t.id)===r||(null==(e=n.props)?void 0:e.dataUniqId)===r}));let m;if(N===l.TimelineDirection.Horizontal)switch(O){case l.HorizontalAlign.Top:m="item-top";break;case l.HorizontalAlign.Bottom:m="item-bottom";break;case l.HorizontalAlign.Alternate:m=e%2?"item-top":"item-bottom"}else switch(_){case l.VerticalAlign.Left:m="item-left";break;case l.VerticalAlign.Right:m="item-right";break;case l.VerticalAlign.Alternate:m=e%2?"item-right":"item-left"}return n.jsxs("div",{className:`timeline-item ${m}`,children:[d&&u&&n.jsx(A,{className:"title-item",titleStyle:H,children:d}),n.jsx($,{style:{backgroundColor:null==s?void 0:s.background,borderColor:null==p?void 0:p.borderColor},direction:N,className:"icon-wrap",children:n.jsx(i.Icon,h({},h({name:(null==s?void 0:s.name)||o.ITEM_TIMELINE_DEFAULT.icon.name},a.getPropsIcon(h({size:P},s)))))}),n.jsx(w,{style:p,width:j,className:"content-item",blockIconSize:V,children:c})]},e)}))}))})),S=p.default.div((({commonStyle:n,lengthTimeline:t,blockIconSize:i,itemSpacingHorizontal:r,itemSpacingVertical:o,itemSpacingMode:a,lineStyle:s,direction:p,horizontalAlign:d,isShowTitle:c,isMobile:m,verticalAlign:g,titleStyle:f})=>{const b=a===l.ItemSpacingMode.Auto?100/Number(t)+"%":`${r}px`;if(p===l.TimelineDirection.Horizontal){const r=v(h({},n),{padding:h({},n.padding)});return c&&d===l.HorizontalAlign.Top?r.padding.bottom=(r.padding.bottom||0)+24:c&&d===l.HorizontalAlign.Bottom&&(r.padding.top=(r.padding.top||0)+24),`\n      width: 100%;\n      position: relative;\n      grid-template-columns: repeat(${t}, ${b});\n      grid-template-rows: 1fr ${i}px max-content;\n      display: grid;\n      overflow-x: auto;\n      ::-webkit-scrollbar {\n        height: 8px;\n      }\n      padding-bottom: 10px;\n\n      .timeline-item {\n        display: flex;\n        width: 100%;\n        flex-direction: column;\n        left: auto;\n        position: relative;\n        &:not(:last-child):after {\n          right: auto;\n          left: ${i}px;\n          width: calc(100% + 0px);\n          height: 2px;\n          content: "";\n          position: absolute;\n          border-top: rgba(220, 222, 225, 1) 2px solid;\n          z-index: 1;\n          ${e.getStyle(s)}\n        }\n\n        .title-item {\n          text-align: center;\n        }\n      }\n\n      .item-bottom {\n        grid-row: 2 / 4;\n        &:after {\n          top: ${i/2}px;\n          bottom: unset;\n          transform: translateY(-50%);\n        }\n\n        .content-item {\n          margin-top: 20px;\n          &:before {\n            top: -2px;\n            bottom: unset;\n            transform: translateY(-50%) translateX(-50%) rotate(45deg);\n            border-right: transparent;\n            border-bottom: transparent;\n          }\n        }\n\n        .title-item {\n          transform: translateY(-100%) translateX(-50%);\n          margin-left: 20px;\n          left: ${i/2}px;\n          top: -8px;\n        }\n      }\n\n    .item-top {\n        grid-row: 1 / 3;\n        flex-direction: column-reverse;\n        &:after {\n          top: unset;\n          bottom: ${i/2}px;\n          transform: translateY(50%);\n        }\n\n        .content-item {\n          margin-bottom: 20px;\n          &:before {\n            bottom: -2px;\n            top: unset;\n            transform: translateY(50%) translateX(-50%) rotate(45deg);\n            border-left: transparent;\n            border-top: transparent;\n          }\n        }\n\n        .title-item {\n          transform: translateY(100%) translateX(-50%);\n          margin-left: 20px;\n          left: ${i/2}px;\n          bottom: -8px;\n        }\n    }\n    ${e.getStyle(r)}\n`}const x=!m;let u=`1fr ${i}px 1fr`;const y=(null==f?void 0:f.width)?`${null==f?void 0:f.width}px`:void 0,S=m&&c&&!!y;return x||(g===l.VerticalAlign.Left?u=`1fr ${i}px ${S?y:""}`:g===l.VerticalAlign.Right&&(u=`${S?y:""} ${i}px 1fr `)),`\n      width: 100%;\n      position: relative;\n      grid-template-columns: ${u};\n      grid-template-rows: auto;\n      display: grid;\n      row-gap: ${o}px;\n      overflow-x: auto;\n      ::-webkit-scrollbar {\n        height: 8px;\n      }\n      padding-bottom: 10px;\n\n      .timeline-item {\n        display: flex;\n        align-items: center;\n        width: 100%;\n        max-width: 100%;\n        flex-direction: row;\n        position: relative;\n        &:not(:last-child):after, &:not(:first-child):before {\n          top: calc(${i/2}px + 50%);\n          height: calc(${o}px + 50% - ${i/2}px);\n          width: 2px;\n          content: "";\n          position: absolute;\n          border-left: rgba(220, 222, 225, 1) 2px solid;\n          z-index: 1;\n          ${e.getStyle(s)}\n\n        }\n\n        &:not(:first-child):before {\n          top: 0;\n          height: calc(50% - ${i/2}px);\n        }\n      }\n\n      .item-left {\n        grid-column: 1 / 3;\n        flex-direction: row-reverse;\n        &:after,&:before {\n          right: ${i/2}px;\n          left: unset;\n          transform: translateX(50%);\n        }\n\n        .content-item {\n          margin-right: 20px;\n          &:before {\n            top: 50%;\n            right: -2px;\n            left: unset;\n            transform: translateY(-50%) translateX(50%) rotate(45deg);\n            border-left: transparent;\n            border-bottom: transparent;\n          }\n        }\n\n        .icon-wrap {\n          transform: translateX(1px);\n        }\n\n        .title-item {\n          text-align: left;\n          padding-left: 12px;\n          transform: translateX(100%);\n        }\n      }\n\n    .item-right {\n        grid-column: ${x||S?"2 / 4":"1 / 3"};\n        &:after,&:before {\n          left: ${i/2}px;\n          right: unset;\n          transform: translateX(-50%);\n        }\n\n        .content-item {\n          margin-left: 20px;\n          &:before {\n            top: 50%;\n            left: -2px;\n            bottom: unset;\n            transform: translateY(-50%) translateX(-50%) rotate(45deg);\n            border-right: transparent;\n            border-top: transparent;\n          }\n        }\n\n        .icon-wrap {\n           transform: translateX(-1px);\n        }\n\n        .title-item {\n          padding-right: 12px;\n          transform: translateX(-100%);\n          text-align: right;\n        }\n    }\n    ${e.getStyle(n)}\n`})),w=p.default.div((({blockIconSize:n,width:t,style:i})=>`\n    width: ${t}px;\n    position: relative;\n    border: ${(null==i?void 0:i.borderColor)||"transparent"} solid 2px;\n\n    &:before {\n      ${(null==i?void 0:i.background)?"":"display: none;"}\n      content: '';\n      position: absolute;\n      width: 15px;\n      height: 15px;\n      border:  ${(null==i?void 0:i.borderColor)||"transparent"} solid 2px;\n      left: ${20+n/2}px;\n       ${e.getStyle(i)}\n  `)),$=p.default.div((({direction:n})=>`\n  width: fit-content;\n  height: fit-content;\n  display: flex;\n  padding: 5px;\n  border-radius: 50%;\n  z-index: 2;\n  border: transparent solid 1px;\n  background: #ffffff;\n  ${n===l.TimelineDirection.Horizontal?"margin-left: 20px":""};\n`)),A=p.default.p`
  position: absolute;
  font-size: 16px;
  ${n=>e.getStyle(n.titleStyle)}
`;y.displayName=o.TIMELINE_DISPLAY_NAME,exports.Timeline=y;


/***/ }),

/***/ 471908:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(85097),n=__webpack_require__(891987),i=__webpack_require__(909381);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=o(r);const c=n.forwardRef((({children:r,commonStyle:t},n)=>e.jsx(l,{ref:n,commonStyle:t,children:r}))),l=d.default.div((({commonStyle:e})=>`\n    width: 100%;\n    padding: 8px;\n    ${t.getStyle(e)};\n`));c.displayName=i.TIMELINE_ITEM_DISPLAY_NAME,exports.TimelineItem=c;


/***/ }),

/***/ 703628:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(561261),e=__webpack_require__(212951),o=__webpack_require__(85097),n=__webpack_require__(891987),r=__webpack_require__(926759),s=__webpack_require__(832027);function a(t){return t&&"object"==typeof t&&"default"in t?t:{default:t}}const i=a(e).default.div`
  position: fixed;
  ${({position:t})=>{switch(t){case s.ToastPosition.TOP_LEFT:return"top: 10px; left: 10px; transform: none;";case s.ToastPosition.TOP_CENTER:return"top: 10px; left: 50%; transform: translateX(-50%);";case s.ToastPosition.TOP_RIGHT:return"top: 10px; right: 10px; transform: none;";case s.ToastPosition.CENTER:return"top: 50%; left: 50%; transform: translate(-50%, -50%);";case s.ToastPosition.BOTTOM_LEFT:return"bottom: 10px; left: 10px; transform: none;";case s.ToastPosition.BOTTOM_CENTER:return"bottom: 10px; left: 50%; transform: translateX(-50%);";case s.ToastPosition.BOTTOM_RIGHT:return"bottom: 10px; right: 10px; transform: none;";default:return"top: 10px; left: 50%; transform: translateX(-50%);"}}};
  background-color: white;
  padding: 10px 16px;
  border-radius: 8px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15), 0px 4px 20px rgba(0, 0, 0, 0.1);
  z-index: 10000;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #000000;
  pointer-events: none;
  animation: fadeIn 0.3s, fadeOut 0.3s ${({duration:t})=>t-200}ms;
  ${({commonStyle:t})=>o.getStyle(t)};
`;exports.ToastMessage=({position:e,icon:s,message:a,duration:u=3e3,commonStyle:l,onClose:p})=>{var c,d;const[m,x]=n.useState(!0);if(n.useEffect((()=>{const t=setTimeout((()=>{x(!1),null==p||p()}),u);return()=>clearTimeout(t)}),[u]),!m)return null;const f=t.jsxs(i,{position:e,duration:u,commonStyle:l,children:[s,a]});return r.createPortal(f,null==(d=(null==(c=null==document?void 0:document.getElementById(o.TEMPI_MAIN_IFRAME))?void 0:c.contentDocument)||document)?void 0:d.body)};


/***/ }),

/***/ 832027:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=(t=>(t.TOP_LEFT="top-left",t.TOP_CENTER="top-center",t.TOP_RIGHT="top-right",t.CENTER="center",t.BOTTOM_LEFT="bottom-left",t.BOTTOM_CENTER="bottom-center",t.BOTTOM_RIGHT="bottom-right",t))(t||{}),e=(t=>(t.SUCCESS="success",t.ERROR="error",t.WARNING="warning",t.INFO="info",t))(e||{});exports.ToastPosition=t,exports.ToastType=e;


/***/ }),

/***/ 503915:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(959211),s=__webpack_require__(143599),i=__webpack_require__(891987),t=__webpack_require__(832027),n=__webpack_require__(703628);exports.useToast=()=>{const[r,a]=i.useState([]);return{ToastComponent:e.jsx(e.Fragment,{children:r.map((o=>e.jsx(n.ToastMessage,{position:null==o?void 0:o.position,message:null==o?void 0:o.message,icon:null==o?void 0:o.icon,duration:null==o?void 0:o.duration,commonStyle:null==o?void 0:o.commonStyle,onClose:()=>{return e=o.id,void a((o=>o.filter((o=>o.id!==e))));var e}},o.id)))}),addToast:({message:i,icon:n,type:r,position:c,duration:l,commonStyle:u})=>{const d=Date.now();switch(r){case t.ToastType.SUCCESS:n=e.jsx(s.Icon,{name:"SuccessColored",style:{fontSize:18}});break;case t.ToastType.ERROR:n=e.jsx(o.DismissCircleFilled,{color:"#FF4D4F",fontSize:18});break;case t.ToastType.WARNING:n=e.jsx(o.WarningFilled,{color:"#FAAD14",fontSize:18});break;case t.ToastType.INFO:n=e.jsx(o.InfoFilled,{color:"#1677FF",fontSize:18})}const m={id:d,message:i,icon:n,position:c,duration:l,commonStyle:u};a((e=>[...e,m]))}}};


/***/ }),

/***/ 892195:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),i=__webpack_require__(85097),n=__webpack_require__(10667),t=__webpack_require__(440384);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var o=a(r),d=Object.defineProperty,l=Object.getOwnPropertySymbols,s=Object.prototype.hasOwnProperty,c=Object.prototype.propertyIsEnumerable,u=(e,r,i)=>r in e?d(e,r,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[r]=i;const p=r=>{var a,o;const d=r,{children:p,isEditingMode:f,stickyTop:h,dataUniqId:v,id:b}=d,g=((e,r)=>{var i={};for(var n in e)s.call(e,n)&&r.indexOf(n)<0&&(i[n]=e[n]);if(null!=e&&l)for(var n of l(e))r.indexOf(n)<0&&c.call(e,n)&&(i[n]=e[n]);return i})(d,["children","isEditingMode","stickyTop","dataUniqId","id"]),{device:j,globalData:x}=i.useStore(),{headerRef:m,headerHeight:O}=n.useHeaderPosition(f?t.PositionHeader.NORMAL:h?t.PositionHeader.STICKY:t.PositionHeader.NORMAL),P=i.getPropsByDevice(((e,r)=>{for(var i in r||(r={}))s.call(r,i)&&u(e,i,r[i]);if(l)for(var i of l(r))c.call(r,i)&&u(e,i,r[i]);return e})({syncDeviceStyle:!1},g),j)||{},k=null==(a=null==x?void 0:x.page)?void 0:a.id;return!f&&(null==(o=null==P?void 0:P.hiddenPageIds)?void 0:o.includes(k))?null:e.jsxs(e.Fragment,{children:[e.jsx(y,{"data-id":b,ref:m,headerHeight:O,stickyTop:h,"data-selector-name":"top-banner","data-sticky":h,"data-uniq-id":v,children:p}),e.jsx("div",{className:"placeholder"})]})};p.displayName="TopBanner";const y=o.default.div((({headerHeight:e,stickyTop:r})=>`\n  width: 100%;\n  transition: box-shadow 0.15s linear;\n\n  ${r?`\n        &.sticky {\n          position: fixed;\n          width: 100%;\n          z-index: 100;\n        }\n        ${e?`\n              &.sticky + .placeholder {\n                padding-bottom: ${e}px;\n              }\n            `:""}\n      `:""}\n`));exports.TopBanner=p;


/***/ }),

/***/ 819696:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(891987),s=__webpack_require__(719713),t=__webpack_require__(409245);exports.FacebookEmbed=({isEditorMode:i,src:o,fullscreen:a})=>(r.useEffect((()=>{t.initFacebookEmbed()}),[o]),e.jsx("div",{className:"fb-video","data-href":o||s.FB_VIDEO_NOT_AVAILABLE_LINK,"data-allowfullscreen":a?"true":"false",style:i?{pointerEvents:"none"}:void 0}));


/***/ }),

/***/ 425667:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),o=__webpack_require__(85097);function r(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const i=r(t).default.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &.editor-mode {
    pointer-events: none;
  }
`;exports.TikTokEmbed=({isEditorMode:t,src:r,autoplay:s,loop:n,controls:c,description:u,musicDescription:d})=>{let l;return r&&(l=o.tiktokParser(r)),e.jsx(i,{className:t?"editor-mode":"",src:`https://www.tiktok.com/player/v1/${l}?autoplay=${t?0:s?1:0}&loop=${n?1:0}&controls=${c?1:0}&description=${u?1:0}&music_info=${d?1:0}`})};


/***/ }),

/***/ 358090:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261);function t(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const o=t(__webpack_require__(212951)).default.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &.editor-mode {
    pointer-events: none;
  }
`;exports.Upload=({src:t,autoplay:r,loop:n,controls:s=!0})=>{const i=t+"#t=0.001";return e.jsx(e.Fragment,{children:e.jsx(o,{controls:s,autoPlay:r,loop:n,muted:!0,src:i,playsInline:!0,crossOrigin:"anonymous"})})};


/***/ }),

/***/ 856660:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097),o=__webpack_require__(266368);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=a(t),l=a(o),s=Object.defineProperty,n=Object.defineProperties,p=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,d=Object.prototype.propertyIsEnumerable,y=(e,t,r)=>t in e?s(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,b=(e,t)=>{for(var r in t||(t={}))c.call(t,r)&&y(e,r,t[r]);if(u)for(var r of u(t))d.call(t,r)&&y(e,r,t[r]);return e};const f=i.default(l.default)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &.editor-mode {
    pointer-events: none;
  }
`;exports.YoutubeEmbed=({src:t,isEditorMode:o,autoplay:a,loop:i,showController:l})=>{const{videoId:s,playlistId:u}=r.youtubeParser(t);return e.jsx(f,{className:o?"editor-mode":"",containerClassName:"container",videoId:s,loading:"lazy",opts:o?{}:{playerVars:(c=b({},u?{listType:"playlist",list:u}:{playlist:s}),d={autoplay:a?1:0,mute:a?1:0,loop:i?1:0,controls:l?1:0},n(c,p(d)))}});var c,d};


/***/ }),

/***/ 719713:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var o=__webpack_require__(85097),t=__webpack_require__(487143);const e={platform:t.VideoPlatform.YouTube,objectFit:"fill",commonStyle:{width:100,widthUnit:o.UnitEnum.percent}},r=[{tag:"Youtube",props:{platform:t.VideoPlatform.YouTube},src:"https://lh3.googleusercontent.com/Wy3-koO0MS-4S9rNB5ztl4SmqpYzmL8PttoYgnaIHuRiwmw36pGHMX4jL2QVXnz3mBZ3tKHBBvBfqfho0LJMYO7lTqAF1jMi"},{tag:"Facebook",props:{platform:t.VideoPlatform.Facebook},src:"https://lh3.googleusercontent.com/J2nMgy8lFsFqhj5jGUtYQPxXdoHYPuFeyMfHA9OCf9cr8Du3PqwhHdxPVn5uftCRdcXwJFOqXcPcSqzkc0qxwZTESiNURbo"},{tag:"Tiktok",props:{platform:t.VideoPlatform.TikTok},src:"https://lh3.googleusercontent.com/v8KsQsNmt7RFCMnC84hicsmL17MJf7htU_3AiZOCJua-PEcSo96qcngApilWUxZ-h-DG7RfLUGHh8FHw0UYMuDCtGRrA9qsb"},{tag:"Upload",props:{platform:t.VideoPlatform.Upload},src:"https://lh3.googleusercontent.com/Bf0gyBoMRL7XmECuKBrzoYciCmbzrzClGHqoH9IIZZG05paybwdC0PChLiUuvHWWioY7x7-4pUTEXNDw6m7W7ZnR7DYWmnKnvQ"}];exports.ASPECT_RATIO_DEFAULT="16 / 9",exports.DEFAULT_VIDEO=e,exports.FB_SDK_URL="https://connect.facebook.net/vi_VN/sdk.js#xfbml=1&version=v22.0",exports.FB_VIDEO_NOT_AVAILABLE_LINK="https://www.facebook.com/plugins/video.php?href=https://fb.watch",exports.SAMPLE_VIDEOS=r;


/***/ }),

/***/ 487143:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var o=(o=>(o.YouTube="YouTube",o.Facebook="Facebook",o.TikTok="TikTok",o.Upload="Upload",o))(o||{});exports.VideoPlatform=o;


/***/ }),

/***/ 147428:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(212951),r=__webpack_require__(891987),t=__webpack_require__(85097),l=__webpack_require__(487143),i=__webpack_require__(143092),n=__webpack_require__(493959),s=__webpack_require__(787045),u=__webpack_require__(719713),a=__webpack_require__(358090),d=__webpack_require__(425667),c=__webpack_require__(819696),p=__webpack_require__(856660);function f(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var m=f(o),v=f(r),b=f(s),y=Object.defineProperty,j=Object.defineProperties,k=Object.getOwnPropertyDescriptors,x=Object.getOwnPropertySymbols,E=Object.prototype.hasOwnProperty,h=Object.prototype.propertyIsEnumerable,q=(e,o,r)=>o in e?y(e,o,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[o]=r;const O=v.default.forwardRef(((o,r)=>{const s=i.getPropsBackward(o),{platform:f,isEditorMode:m,facebook:v,youtube:y,tiktok:O,upload:w,schema:g}=s,S=((e,o)=>{var r={};for(var t in e)E.call(e,t)&&o.indexOf(t)<0&&(r[t]=e[t]);if(null!=e&&x)for(var t of x(e))o.indexOf(t)<0&&h.call(e,t)&&(r[t]=e[t]);return r})(s,["platform","isEditorMode","facebook","youtube","tiktok","upload","schema"]),{device:M}=t.useStore(),{commonStyle:V}=t.getPropsByDevice(S,M),_=g?b.default.sanitize(g):"";return e.jsxs(P,(D=((e,o)=>{for(var r in o||(o={}))E.call(o,r)&&q(e,r,o[r]);if(x)for(var r of x(o))h.call(o,r)&&q(e,r,o[r]);return e})({},S),R={commonStyle:V,ref:r,children:[_&&e.jsx("head",{children:e.jsx("script",{type:"application/ld+json",dangerouslySetInnerHTML:{__html:_}},n.v4())}),e.jsx(T,{aspectRatio:(()=>{var e;const r=null==(e=null==o?void 0:o[null==f?void 0:f.toLocaleLowerCase()])?void 0:e.aspectRatio;return r&&/^\d+\s{0,1}\/\s{0,1}\d+$/.test(r)?r:u.ASPECT_RATIO_DEFAULT})(),children:(()=>{switch(f){case l.VideoPlatform.YouTube:return e.jsx(p.YoutubeEmbed,{isEditorMode:m,src:null==y?void 0:y.src,autoplay:null==y?void 0:y.autoplay,loop:null==y?void 0:y.loop,showController:null==y?void 0:y.controls});case l.VideoPlatform.Facebook:return e.jsx(c.FacebookEmbed,{isEditorMode:m,src:null==v?void 0:v.src,fullscreen:null==v?void 0:v.fullscreen});case l.VideoPlatform.TikTok:return e.jsx(d.TikTokEmbed,{isEditorMode:m,src:null==O?void 0:O.src,autoplay:null==O?void 0:O.autoplay,loop:null==O?void 0:O.loop,controls:null==O?void 0:O.controls,description:null==O?void 0:O.description,musicDescription:null==O?void 0:O.musicDescription});case l.VideoPlatform.Upload:return e.jsx(a.Upload,{src:null==w?void 0:w.src,autoplay:null==w?void 0:w.autoplay,loop:null==w?void 0:w.loop,controls:!!(null==w?void 0:w.controls)});default:return null}})()})]},j(D,k(R))));var D,R})),P=m.default.div((({commonStyle:e})=>`\n  ${t.getStyle(e)}\n  max-width: 100%;\n  `)),T=m.default.div((({aspectRatio:e})=>`\n  position: relative;\n  aspect-ratio: auto ${e};\n  .container {\n    height: 100%;\n  }\n  `));O.displayName="Video",exports.Video=O;


/***/ }),

/***/ 143092:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var o=__webpack_require__(487143),r=Object.defineProperty,e=Object.getOwnPropertySymbols,t=Object.prototype.hasOwnProperty,l=Object.prototype.propertyIsEnumerable,a=(o,e,t)=>e in o?r(o,e,{enumerable:!0,configurable:!0,writable:!0,value:t}):o[e]=t;exports.getPropsBackward=r=>{const p=((o,r)=>{for(var p in r||(r={}))t.call(r,p)&&a(o,p,r[p]);if(e)for(var p of e(r))l.call(r,p)&&a(o,p,r[p]);return o})({},r),{uploadSrc:u,src:c,autoplay:s,showController:n,loop:y}=p;return u?(p.platform=o.VideoPlatform.Upload,p.upload={src:u,autoplay:s,controls:n,loop:y}):c&&(p.platform=o.VideoPlatform.YouTube,p.youtube={src:c,autoplay:s,controls:n,loop:y}),p};


/***/ }),

/***/ 159800:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(85097),i=Object.defineProperty,t=Object.getOwnPropertySymbols,l=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable,o=(e,r,t)=>r in e?i(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;const n=i=>{var n,d;const s=i,{children:c,isEditingMode:u,dataUniqId:p,className:v}=s,f=((e,r)=>{var i={};for(var o in e)l.call(e,o)&&r.indexOf(o)<0&&(i[o]=e[o]);if(null!=e&&t)for(var o of t(e))r.indexOf(o)<0&&a.call(e,o)&&(i[o]=e[o]);return i})(s,["children","isEditingMode","dataUniqId","className"]),{device:b,globalData:y}=r.useStore(),m=r.getPropsByDevice(((e,r)=>{for(var i in r||(r={}))l.call(r,i)&&o(e,i,r[i]);if(t)for(var i of t(r))a.call(r,i)&&o(e,i,r[i]);return e})({syncDeviceStyle:!1},f),b)||{},O=null==(n=null==y?void 0:y.page)?void 0:n.id;return!u&&(null==(d=null==m?void 0:m.hiddenPageIds)?void 0:d.includes(O))?null:e.jsx("footer",{"data-uniq-id":p,className:v,children:c})};n.displayName="WebsiteFooter",exports.WebsiteFooter=n;


/***/ }),

/***/ 402684:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var n=__webpack_require__(212951),e=__webpack_require__(88928);function t(n){return n&&"object"==typeof n&&"default"in n?n:{default:n}}var i=t(n);const a=i.default.div((({})=>`\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 16px;\n    padding-left: 16px;\n\n    div {\n      margin: 0px;\n    }\n\n    @media screen and (max-width: ${e.MOBILE_WIDTH}px){\n      display: none;\n    }\n  `)),r=i.default.div((({grid:n})=>{const{navigationTextAlign:t}=n;let i;switch(t){case"left":i="flex-start";break;case"right":i="flex-end";break;case"center":i="center"}return`\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    gap: 16px;\n    @media screen and (min-width: ${e.MOBILE_WIDTH}px){\n      display: none;\n    }\n\n    div {\n      // because buttonV2 has a wrapper flex, setting align-item in parent div has no value.\n      justify-content: ${i};\n      margin: 0px;\n    }\n  `}));exports.ActionButton=a,exports.ActionButtonMobile=r;


/***/ }),

/***/ 649351:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),n=__webpack_require__(85097),o=__webpack_require__(143599),i=__webpack_require__(891987),r=__webpack_require__(656471),l=__webpack_require__(203832),a=__webpack_require__(512005);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=s(t);const d=[l.MOCK_PRODUCT_LIST_DATA[0]],u=c.default.div`
  position: relative;
  margin-left: 1em;
`,p=c.default.div((({commonStyle:e,flagSize:t})=>`\n  font-family: var(--tempi-global-paragraph1fontfamily);\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  background: ${(null==e?void 0:e.background)||"white"};\n  position: absolute;\n    top: ${20+Math.max(+(null==e?void 0:e.fontSize),t,0)}px;\n    right: -6px;\n  border-radius: 6px;\n  box-shadow: 0px 4px 20px 0px #a5a3ae66;\n  overflow: hidden;\n  z-index: 1001;\n`)),x=c.default.span`
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #c90024;
  border-radius: 100px;
  bottom: 5px;
  color: #fff;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  font-size: 10px;
  font-weight: 500;
  height: 16px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  pointer-events: none;
  position: absolute;
  top: -5px;
  width: 16px;
  right: -5px;
  z-index: 1;
`;exports.Cart=t=>{const{isEditingMode:l,icon:s,show:c,cartCommonStyle:f,buttonStyle:m,buttonText:b,iconColorInTransparentMode:v}=t||{},g=i.useRef(null),{getCartQuantity:y,isOpenCart:C,setOpenCart:h}=a.useCartStore(),w=e=>{var t,o;const i=(null==(t=null==document?void 0:document.querySelector(`#${n.TEMPI_MAIN_IFRAME}`))?void 0:t.contentWindow)||window;(null==(o=g.current)?void 0:o.contains(e.target))||(h(!1),i.removeEventListener("click",w,!1))};return i.useEffect((()=>{l||h(!1)}),[l,h]),c?e.jsxs(u,{style:{position:"relative"},ref:g,className:"shopping-cart",children:[e.jsx(x,{children:l?d.length:y()}),e.jsx(o.Icon,{onClick:()=>(()=>{var e;const t=(null==(e=null==document?void 0:document.querySelector(`#${n.TEMPI_MAIN_IFRAME}`))?void 0:e.contentWindow)||window,o=!C;h(o),o&&t.addEventListener("click",w,!1)})(),name:"ShoppingCartOutlined",style:{fontSize:24,color:v||(null==s?void 0:s.color),cursor:"pointer"}}),C&&e.jsx(p,{commonStyle:f,children:e.jsx(r.CartContent,{buttonStyle:m,isEditingMode:l,open:C,buttonText:b,setOpenCart:h})})]}):null},exports.MOCK_CART_DATA=d;


/***/ }),

/***/ 656471:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),r=__webpack_require__(85097),o=__webpack_require__(800656),i=__webpack_require__(681084),n=__webpack_require__(649351),l=__webpack_require__(7698),a=__webpack_require__(512005),u=__webpack_require__(840424),d=__webpack_require__(750911);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=s(t),p=Object.defineProperty,h=Object.getOwnPropertySymbols,m=Object.prototype.hasOwnProperty,b=Object.prototype.propertyIsEnumerable,g=(e,t,r)=>t in e?p(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,x=(e,t)=>{for(var r in t||(t={}))m.call(t,r)&&g(e,r,t[r]);if(h)for(var r of h(t))b.call(t,r)&&g(e,r,t[r]);return e};const j=c.default.div`
  width: 380px;
  min-height: 208px;
  max-width: calc(100vw - 45px);
`,v=c.default.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.5em;
`,y=c.default(u.Paragraph)`
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  white-space: nowrap;
`,f=c.default.div`
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`,C=c.default.div`
  max-height: 315px;
  overflow: auto;
`;exports.CartContent=({isEditingMode:t,buttonText:u="Đặt hàng",buttonStyle:s,setOpenCart:c})=>{const{cart:p,getCartTotal:h,removeFromCart:m,updateQuantity:b,setShowCheckoutPopup:g}=a.useCartStore(),w=t?n.MOCK_CART_DATA.reduce(((e,t)=>e+t.price),0):h();return e.jsx(j,{children:e.jsx(e.Fragment,{children:t||(null==p?void 0:p.length)?e.jsxs(e.Fragment,{children:[e.jsx(C,{children:null==(q=t?n.MOCK_CART_DATA:p)?void 0:q.map(((r,o)=>{var i,n;return e.jsx(l.ProductItem,{index:o,removeProduct:()=>(e=>{t||m(e)})(r),setQuantity:e=>((e,r)=>{t||b(e,r)})(r,e),name:r.name,price:r.price,currencyUnit:"đ",thumbnailAlt:r.name,thumbnailUrl:(null==(i=r.images)?void 0:i[0])||(null==(n=r.image)?void 0:n.src),quantity:r.quantity})}))}),e.jsx("hr",{style:{margin:"1.5em 0"}}),e.jsxs(v,{children:[e.jsx(y,{text:o.translate("website-header.cart.total-price")}),e.jsx(y,{text:i.getPriceText(w,"đ","right")})]}),e.jsx(d.ButtonV2,{text:u,buttonStyle:x(x(x({width:100,widthUnit:r.UnitEnum.percent,background:"rgba(37, 141, 255, 1)",height:32},(null==s?void 0:s.borderColor)?{borderWidth:1,borderStyle:"solid",borderColor:s.borderColor}:{}),(null==(P=null==s?void 0:s.hover)?void 0:P.borderColor)?{borderWidth:1,borderStyle:"solid",borderColor:null==(A=s.hover)?void 0:A.borderColor}:{}),s),onClick:()=>{t||(g(!0),c(!1))},isEditingMode:t})]}):e.jsx(f,{children:e.jsx("img",{alt:"empty-cart",width:150,src:"https://lh3.googleusercontent.com/DDgoWbI-vgQzr-ADPA1u57u4F6mbIXb2WBWmruh7Ygz5ZHUAhP9wxQOV_ynyz-7n9irg6m4F7CjjDHn6p9vu5RpidH_BMAsD=rw"})})})});var q,P,A};


/***/ }),

/***/ 708688:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(212951),t=__webpack_require__(85097),n=__webpack_require__(88928);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const r=i(e).default.div((({grid:e,commonStyle:i})=>{const{gridArea:r,navigationGridTemplateColumns:a,navigationGridTemplateRows:d,width:o,mobileNavigationGridTemplateColumns:l}=e,{width:m,widthUnit:s,columnGap:p,padding:u}=i;return`\n    position: relative;\n    display: grid;\n    grid-area: ${r};\n    grid-template-columns: ${a};\n    ${d?`grid-template-rows: ${d};`:""}\n    align-items: center;\n    width: 100%;\n    max-width: ${m?"100%":(o||1240)+"px"};\n    margin: 0 auto;\n    \n    ${t.getStyle({columnGap:p,padding:u,width:m,widthUnit:s})};\n  \n    @media screen and (max-width: ${n.MOBILE_WIDTH}px){\n      grid-template-columns: ${l};\n    }\n  `}));exports.Content=r;


/***/ }),

/***/ 756807:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(85097),n=__webpack_require__(88928);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const l=i(r).default.span`
  all: unset;
  display: flex;
  margin-left: 8px;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 3px;
  transition: border 0.3s;

  @media screen and (max-width: ${n.MOBILE_WIDTH}px) {
    display: inline-block;
  }
`;exports.DropdownArrow=({alignMenu:r,color:n})=>{let i,o;switch(r){case t.Alignment.left:case t.Alignment.center:i="3/4";break;case t.Alignment.right:o="1",i="2/3"}return e.jsx("div",{style:{gridColumn:i,gridRow:o,color:n},children:e.jsx(l,{children:e.jsx("svg",{width:"20",height:"20",viewBox:"0 0 20 20",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:e.jsx("path",{d:"M15.8 7.73c.28.3.27.78-.03 1.06l-5.25 5a.75.75 0 0 1-1.04 0l-5.25-5a.75.75 0 0 1 1.04-1.08L10 12.2l4.73-4.5a.75.75 0 0 1 1.06.02Z",fill:"currentColor",strokeWidth:"0.4",stroke:"currentcolor"})})})})};


/***/ }),

/***/ 527470:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(212951),r=__webpack_require__(891987),t=__webpack_require__(88928),i=__webpack_require__(870141),o=__webpack_require__(85097),a=__webpack_require__(827273);function d(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=d(n),l=d(r),u=Object.defineProperty,c=Object.defineProperties,p=Object.getOwnPropertyDescriptors,g=Object.getOwnPropertySymbols,m=Object.prototype.hasOwnProperty,b=Object.prototype.propertyIsEnumerable,f=(e,n,r)=>n in e?u(e,n,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[n]=r;const x=({item:n,alignMenu:r,isEditingMode:d,background:s,isHeaderTransparent:u=!1,subMenuBackgroundColor:c="#f1f1f1"})=>{var p;const{grid:g}=a.useWebsiteHeaderContext(),m=`dropdown-${n.id}`,b=l.default.useRef(null),[f,h]=l.default.useState(null);return l.default.useEffect((()=>{var e;const n=(null==(e=null==document?void 0:document.querySelector(`#${o.TEMPI_MAIN_IFRAME}`))?void 0:e.contentWindow)||window,r=()=>{if(b.current&&n.innerWidth>t.MOBILE_WIDTH){const e=b.current.style.display;b.current.style.display="block",b.current.style.opacity="0",b.current.style.pointerEvents="none";const r=b.current.getBoundingClientRect(),t=n.innerWidth;if(b.current.style.display=e,b.current.style.opacity="",b.current.style.pointerEvents="",r.right>t){const e=r.right-t;h(-e-16)}}};return r(),n.addEventListener("resize",r),()=>{n.removeEventListener("resize",r)}}),[m]),e.jsx(i.MenuItemRenderer,{item:n,alignMenu:r,isEditingMode:d,hasDropdownArrow:!0,hasInput:!0,htmlFor:m,customLabel:y,level:1,subMenu:e.jsx(v,{backgroundColor:c,className:"sub-menu",ref:b,style:null!==f?{marginLeft:`calc(${g.menuItemSpacing}px + ${f}px)`}:{marginLeft:"1em"},children:e.jsx(I,{background:u?"transparent":s,children:null==(p=null==n?void 0:n.children)?void 0:p.map(((n,t)=>e.jsx(i.Item,{children:(null==n?void 0:n.children)&&n.children.length>0?e.jsx(x,{item:n,alignMenu:r,isEditingMode:d,background:s,isHeaderTransparent:u,subMenuBackgroundColor:c}):e.jsx(i.MenuItemRenderer,{item:n,alignMenu:r,isEditingMode:d,level:2})},t)))})})})},y=s.default(i.ItemLabel)`
  cursor: pointer;

  input {
    display: none;
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
  }

  svg {
    transition: transform 0.3s;
  }

  @media screen and (min-width: ${t.MOBILE_WIDTH}px) {
    &:hover {
      .sub-menu {
        display: block;

        ul {
          max-height: 400px;
          overflow-y: auto;
          display: block;

          li {
            padding: 5px 0;
          }
        }
      }

      & > svg {
        transform: rotate(180deg);
      }
    }
  }

  @media screen and (max-width: ${t.MOBILE_WIDTH}px) {
    input[type='checkbox']:checked ~ {
      .sub-menu {
        display: block;
      }

      /* div {
        svg {
          transform: rotate(180deg);
        }
      } */

      div > div > span > svg {
        transform: rotate(180deg);
      }
    }
  }
`,v=s.default.div`
  position: absolute;
  z-index: 1;
  display: none;
  padding-top: 10px;
  padding-right: 16px;
  padding-bottom: 48px;

  padding-left: 1em;
  border-radius: 1em;

  @media screen and (max-width: ${t.MOBILE_WIDTH}px) {
    background-color: ${({backgroundColor:e})=>e};
    position: unset;
    padding: 8px 16px;
    margin-top: 8px;
    margin-bottom: 8px;
  }
`,h=s.default.ul((({navigationJustifySelf:e,background:n})=>`\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 16px 24px;\n  gap: 10px;\n  list-style: none;\n  border-radius: 5px;\n  box-shadow: 0 2px 10px #0000001a;\n  animation: expand-5b652f62 0.2s cubic-bezier(0.45, 0, 0.1, 1);\n  background: ${n};\n\n\n  @media screen and (max-width: ${t.MOBILE_WIDTH}px) {\n    padding: 0;\n    background-color: transparent;\n    box-shadow: none;\n    align-items: ${e};\n  }\n`)),I=n=>{var r=n,{background:t,children:i}=r,o=((e,n)=>{var r={};for(var t in e)m.call(e,t)&&n.indexOf(t)<0&&(r[t]=e[t]);if(null!=e&&g)for(var t of g(e))n.indexOf(t)<0&&b.call(e,t)&&(r[t]=e[t]);return r})(r,["background","children"]);const{grid:d}=a.useWebsiteHeaderContext(),{navigationJustifySelf:s}=d||{};return e.jsx(h,(l=((e,n)=>{for(var r in n||(n={}))m.call(n,r)&&f(e,r,n[r]);if(g)for(var r of g(n))b.call(n,r)&&f(e,r,n[r]);return e})({navigationJustifySelf:s,background:t},o),c(l,p({children:i}))));var l};exports.DropdownItem=x;


/***/ }),

/***/ 162291:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(212951),i=__webpack_require__(801416),r=__webpack_require__(85097),t=__webpack_require__(870141);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=l(n);const o=d.default.div`
  display: flex;
  flex: 1 1 0%;
  padding: 0.75rem;
`,a=d.default.a((({primaryColor:e})=>`\ncolor: ${e};\ntext-decoration: none;\nfont-size: 14px;\na {\n  font-weight: bold !important;\n}\n&:hover {\n  color: ${e};\n}\n`)),u=d.default.div`
  width: 250px;
  padding: 0px 8px;
`,m=d.default.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
`;exports.GridMenuContent=({menu:n,isEditingMode:l=!1})=>{const d=i.convertMegaMenu(n,4);return e.jsx(o,{children:null==d?void 0:d.map((n=>e.jsx(u,{children:n.items.map(((n,i)=>{var d;return e.jsxs(m,{style:{display:"flex",flexDirection:"column",gap:"0.5rem",marginBottom:"1.5rem"},children:[e.jsx("div",{children:e.jsx(t.MenuItemRenderer,{item:n,alignMenu:r.Alignment.left,isEditingMode:l,level:2,customLabel:a})}),null==(d=null==n?void 0:n.children)?void 0:d.map((n=>e.jsx(e.Fragment,{children:e.jsx(t.MenuItemRenderer,{item:n,alignMenu:r.Alignment.left,isEditingMode:l,level:3})})))]},i)}))})))})};


/***/ }),

/***/ 549179:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),n=__webpack_require__(85097),r=__webpack_require__(891987);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=o(t),i=o(r),s=Object.defineProperty,c=Object.defineProperties,d=Object.getOwnPropertyDescriptors,l=Object.getOwnPropertySymbols,u=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,m=(e,t,n)=>t in e?s(e,t,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[t]=n,f=(e,t)=>{for(var n in t||(t={}))u.call(t,n)&&m(e,n,t[n]);if(l)for(var n of l(t))p.call(t,n)&&m(e,n,t[n]);return e},y=(e,t)=>{var n={};for(var r in e)u.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&l)for(var r of l(e))t.indexOf(r)<0&&p.call(e,r)&&(n[r]=e[r]);return n};const g=a.default.header((e=>{const{commonStyle:t,headerHeight:r,isTransparentMode:o,isHeaderTransparent:a,topBannerHeight:i,isTopBannerSticky:s}=e,c=y(t,["padding"]);return`\n    display: grid;\n    grid-area: 1/1/-1/-1;\n    grid-template-rows: 100%;\n    grid-template-columns: 100%;\n    width: 100% !important;\n    transition: box-shadow 0.15s linear, background-color 0.3s ease;\n    position: relative;\n    z-index: 100;\n  \n    &.sticky {\n      position: fixed;\n      width: 100%;\n      top: ${s?i:0}px;\n    }\n    ${r&&!o?`\n            &.sticky + .placeholder{\n              padding-bottom: ${r}px;\n            }\n          `:""}\n\n    ${a?`\n            background-color: transparent !important;\n            margin-bottom: -${r}px;\n            position: relative;\n            z-index: 1;\n          `:""}\n\n    ${n.getStyle(c)}\n  `})),v=i.default.forwardRef(((t,o)=>{const a=t,{commonStyle:i,headerHeight:s=0,isTransparentMode:l=!1,isHeaderTransparent:u=!1,setIsHeaderTransparent:p=()=>{},children:m,className:h}=a,b=y(a,["commonStyle","headerHeight","isTransparentMode","isHeaderTransparent","setIsHeaderTransparent","children","className"]),{topBannerHeight:w,isTopBannerSticky:S}=(()=>{const[e,t]=r.useState(0),[o,a]=r.useState(!1);return r.useEffect((()=>{var e;const r=((null==(e=null==document?void 0:document.querySelector(`#${n.TEMPI_MAIN_IFRAME}`))?void 0:e.contentWindow)||window).document.querySelector('[data-selector-name="top-banner"]'),o=()=>{const e="true"===(null==r?void 0:r.getAttribute("data-sticky"));a(e)};if(r){o();const e=new ResizeObserver((()=>{var e;const n=null==(e=r.getClientRects()[0])?void 0:e.height;t(n)}));v.displayName="Header",e.observe(r);const n=new MutationObserver(o);return r instanceof Node&&n.observe(r,{attributes:!0,attributeFilter:["data-sticky"]}),()=>{e.disconnect(),n.disconnect()}}}),[]),{topBannerHeight:e,isTopBannerSticky:o}})();return((e,t,o)=>{const{device:a}=n.useStore();r.useEffect((()=>{if(!e)return;const r=document.getElementById(n.TEMPI_MAIN_IFRAME),i=(null==r?void 0:r.contentDocument)||document;let s,c=0,d=!1;const l=e=>{c=e,d=e>=t,o(d)},u=()=>{if(!d)return;const e=((null==r?void 0:r.contentWindow)||window).scrollY;o(e<c-t)},p=setTimeout((()=>{const e=i.querySelector(':not([data-selector-name]) > [data-selector-name="section-container"]'+("desktop"===a?":not(.hidden-md)":":not(.hidden-xs)"));e?(s=new ResizeObserver((e=>{for(const t of e){const e=t.target;"none"!==window.getComputedStyle(e).display&&l(t.contentRect.height)}})),s.observe(e),"none"!==window.getComputedStyle(e).display&&l(e.getBoundingClientRect().height)):o(!1)}),0);return i.addEventListener("scroll",u,{passive:!0}),()=>{clearTimeout(p),i.removeEventListener("scroll",u),null==s||s.disconnect()}}),[e,t,o,a])})(l,s,p),e.jsxs(e.Fragment,{children:[e.jsx(g,(T=f({ref:o,commonStyle:i,headerHeight:s,isTransparentMode:l,isHeaderTransparent:u,topBannerHeight:w,isTopBannerSticky:S,className:h},b),x={children:m},c(T,d(x)))),s&&!l&&e.jsx("div",{className:"placeholder"})]});var T,x}));exports.Header=v;


/***/ }),

/***/ 166311:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(891987),n=__webpack_require__(212951),t=__webpack_require__(85097),o=__webpack_require__(870141);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=i(r),a=i(n),c=Object.defineProperty,l=Object.defineProperties,u=Object.getOwnPropertyDescriptors,s=Object.getOwnPropertySymbols,f=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,b=(e,r,n)=>r in e?c(e,r,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[r]=n;const g=a.default.div`
  display: flex;
  flex: 1 1 0%;
  background-color: ${({background:e})=>e||"#fff"};
`,x=a.default.div`
  width: 200px;
  background-color: ${({background:e})=>e||"#f8f9fa"};
  border-right: 1px solid #e9ecef;
`,h=a.default.div`
  flex: 1;
  background-color: ${({background:e})=>e||"#fff"};
  min-width: 100px;
  max-width: 200px;
`,m=a.default.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  background-color: ${({isActive:e,background:r})=>e?r||"#e3f2fd":"transparent"};

  &:hover {
    background-color: ${({background:e})=>e||"#e3f2fd"};
  }
`,v=a.default.a`
  color: #434657;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  flex: 1;
  width: 100%;
`,k=a.default.div`
  min-width: 150px;
  padding: 12px 24px;
  cursor: pointer;
`;exports.HierarchicalMenuContent=({menu:r,isEditingMode:n=!1,commonStyle:i})=>{var a;const{globalData:c}=t.useStore(),j=null==c?void 0:c.isPreviewMode,[y,w]=d.default.useState(null),M=r.children||[],O=y&&(null==(a=M.find((e=>e.id===y)))?void 0:a.children)||[];return e.jsxs(g,{background:i.background,children:[e.jsx(x,{background:i.background,children:M.map((d=>{return e.jsxs(m,(a=((e,r)=>{for(var n in r||(r={}))f.call(r,n)&&b(e,n,r[n]);if(s)for(var n of s(r))p.call(r,n)&&b(e,n,r[n]);return e})({onMouseEnter:()=>(e=>{const r=M.find((r=>r.id===e));(null==r?void 0:r.children)&&r.children.length>0&&w(e)})(d.id),isActive:y===d.id},!n&&!j&&t.getTrackingData({isTrackContent:!0,contentName:`${r.name} > ${d.name}`,regionName:"hierarchicalMenuText"})),c={background:i.background,children:[e.jsx(o.MenuItemRenderer,{item:d,isEditingMode:n,level:2,customLabel:v}),d.children&&d.children.length>0&&e.jsx("span",{children:"›"})]},l(a,u(c))),d.id);var a,c}))}),O.length>0&&e.jsx(h,{background:i.background,children:O.map((r=>e.jsx(o.MenuItemRenderer,{item:r,isEditingMode:n,level:3,customLabel:k})))})]})};


/***/ }),

/***/ 870141:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(212951),t=__webpack_require__(85097),r=__webpack_require__(88928),i=__webpack_require__(756807),o=__webpack_require__(827273),l=__webpack_require__(891987),a=__webpack_require__(138989),u=__webpack_require__(426839);function m(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=m(n),c=Object.defineProperty,g=Object.defineProperties,d=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,x=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,v=(e,n,t)=>n in e?c(e,n,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[n]=t,h=(e,n)=>{for(var t in n||(n={}))x.call(n,t)&&v(e,t,n[t]);if(p)for(var t of p(n))f.call(n,t)&&v(e,t,n[t]);return e},b=(e,n)=>g(e,d(n)),w=(e,n)=>{var t={};for(var r in e)x.call(e,r)&&n.indexOf(r)<0&&(t[r]=e[r]);if(null!=e&&p)for(var r of p(e))n.indexOf(r)<0&&f.call(e,r)&&(t[r]=e[r]);return t};const y=s.default.li`
  user-select: none;

  @media screen and (max-width: ${r.MOBILE_WIDTH}px) {
    width: 100%;
  }
`,A=s.default.label`
  display: block;

  &:last-child {
    margin-bottom: 0;
  }
`,M=s.default.div((({alignMenu:e,hoverColor:n,isActive:i})=>`\n  display: flex;\n  align-items: center;\n  text-align: left;\n  @media screen and (max-width: ${r.MOBILE_WIDTH}px) {\n    gap: 12px;\n    grid-template-columns:\n      ${e===t.Alignment.left?"auto 1fr auto":""}\n      ${e===t.Alignment.center?"1fr auto 1fr":""}\n      ${e===t.Alignment.right?"1fr auto auto":""}\n    ;\n    display: grid;\n\n    svg {\n      width: 22px !important;\n      height: 22px !important;\n    }\n  }\n\n  ${i?`\n    &{\n      color: ${n};\n\n      svg {\n        color: ${n} !important;\n        }\n    }`:""}\n\n  ${n?`\n    &:hover {\n      color: ${n};\n\n      svg {\n        color: ${n} !important;\n        }\n    }`:""}\n`)),$=n=>{var t=n,{alignMenu:r,isActive:i,children:a}=t,u=w(t,["alignMenu","isActive","children"]);let m;const s=l.useContext(o.WebsiteHeaderContext);s&&(m=s.grid);const{menuHoverColor:c}=m||{};return e.jsx(M,b(h({alignMenu:r,hoverColor:c,isActive:i},u),{children:a}))},j=s.default.a((({alignMenu:e,isActive:n,menuItemSpacing:i,menuColor:o,menuHoverColor:l,mobileNavigationTextAlign:a,menuFontSize:u,menuFontStyle:m,menuFontWeight:s,menuTextDecoration:c,menuFontFamily:g,menuFontVariant:d,menuTextTransform:p,menuLineHeight:x,menuLetterSpacing:f})=>`\n  position: relative;\n  display: inline-flex;\n  align-self: center;\n  margin: 0 0 0 ${i}px;\n  text-decoration: ${c?`${c} !important`:"none"};\n  max-width: 100%;\n  white-space: nowrap;\n  cursor: pointer;\n\n  ${t.getStyle({fontSize:u,fontFamily:g,fontVariant:d,fontWeight:s,fontStyle:m,textTransform:p,lineHeight:x,letterSpacing:f})}\n  \n\n  ${n?`\n      color: ${l};`:`color: ${o};`}\n\n  &:hover {\n    text-decoration: underline;\n    text-underline-offset: 7px;\n    color: ${l};\n  }\n\n  @media screen and (max-width: ${r.MOBILE_WIDTH}px){\n    margin: 0;\n    text-align: ${a};\n\n    grid-column:\n    ${e===t.Alignment.left?"1/3":""}\n    ${e===t.Alignment.center?"2/3":""}\n    ${e===t.Alignment.right?"3/4":""}\n  }\n`)),I=n=>{var t=n,{alignMenu:r,isActive:i,children:a,level:u=1}=t,m=w(t,["alignMenu","isActive","children","level"]);let s;const c=l.useContext(o.WebsiteHeaderContext);c&&(s=c.grid);const{menuItemSpacing:g,menuColor:d,menuHoverColor:p,mobileNavigationTextAlign:x,menuFontSize:f,menuFontStyle:v,menuFontWeight:y,menuTextDecoration:A,menuFontFamily:M,menuFontVariant:$,menuTextTransform:I,menuLineHeight:C,menuLetterSpacing:F}=s||{};return e.jsx(j,b(h({alignMenu:r,isActive:i,menuItemSpacing:1===u?g:0,menuColor:d,menuHoverColor:p,mobileNavigationTextAlign:x,menuFontSize:f,menuFontStyle:v,menuFontWeight:y,menuTextDecoration:A,menuFontFamily:M,menuFontVariant:$,menuTextTransform:I,menuLineHeight:C,menuLetterSpacing:F},m),{children:a}))},C=s.default.img`
  width: 20px;
  height: 20px;
  margin-right: 0.4em;
`,F=s.default.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 60vw;
`;exports.Item=y,exports.ItemContent=I,exports.ItemContentWrapper=$,exports.ItemIcon=C,exports.ItemLabel=A,exports.ItemName=F,exports.MenuItemRenderer=n=>{var r=n,{item:m,alignMenu:s=t.Alignment.left,isEditingMode:c,hasInput:g=!1,hasDropdownArrow:d=!1,customLabel:p,subMenu:x,level:f=1}=r,v=w(r,["item","alignMenu","isEditingMode","hasInput","hasDropdownArrow","customLabel","subMenu","level"]);let y,M;const j=l.useContext(o.WebsiteHeaderContext);j&&(y=j.grid,M=j.prefixLangUrl);const{menuColor:T}=y||{},O=p||A;return e.jsxs(O,b(h({},v),{children:[g&&e.jsx("input",{type:"checkbox",id:v.htmlFor,value:""}),e.jsxs($,b(h({alignMenu:s},u.getAttrTracking({regionName:"header",contentName:null==m?void 0:m.name,target:a.getUrlOfMenuItem(m,c,M)})),{children:[e.jsxs(I,b(h({alignMenu:s,href:a.getUrlOfMenuItem(m,c,M),onClick:e=>{""!==(null==m?void 0:m.href)&&"#"!==(null==m?void 0:m.href)||e.preventDefault()},isActive:null==m?void 0:m.isActive,target:a.getTargetUrl(m.target),level:f},"LINK"===(null==m?void 0:m.linkType)&&m.nofollow?{rel:"nofollow"}:{}),{children:[(null==m?void 0:m.iconUrl)&&e.jsx(C,{src:m.iconUrl,loading:"lazy"}),e.jsx(F,{title:null==m?void 0:m.name,children:null==m?void 0:m.name})]})),d&&e.jsx(i.DropdownArrow,{alignMenu:s,color:T})]})),x]}))};


/***/ }),

/***/ 48812:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(212951),t=__webpack_require__(891987),r=__webpack_require__(143599),o=__webpack_require__(85097),i=__webpack_require__(88928),a=__webpack_require__(801416),l=__webpack_require__(426839);function d(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=d(n),u=Object.defineProperty,s=Object.defineProperties,g=Object.getOwnPropertyDescriptors,m=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,v=(e,n,t)=>n in e?u(e,n,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[n]=t;const y=e=>(null==e?void 0:e.charAt(0).toUpperCase())+(null==e?void 0:e.slice(1).toLowerCase()),x=c.default.div((({device:e,align:n})=>`\nposition: relative;\n${"desktop"===e?`\n    ${"left"===n?"margin-right: 1em;":"margin-left: 1em;"}\n    @media screen and (max-width: ${i.MOBILE_WIDTH}px){\n      display: none;\n    }`:`\n    @media screen and (min-width: ${i.MOBILE_WIDTH}px){\n      display: none;\n    }\n  `}\n`)),h=c.default.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5em;
  cursor: pointer;
  justify-content: flex-end;
`,C=c.default.div((({device:e,commonStyle:n,flagSize:t})=>`\n  display: flex;\n  flex-direction: column;\n  background: ${(null==n?void 0:n.background)||"white"};\n  \n  ${"desktop"===e?`\n    position: absolute;\n    top: ${20+Math.max(+n.fontSize,t,0)}px;\n    left: -1em;\n    `:"\n    position: unset;\n    right: 0;\n    margin-top: 1em;\n    \n    "}\n  border-radius: 6px;\n  box-shadow: 0px 4px 20px 0px #a5a3ae66;\n  overflow: hidden;\n  z-index: 1;\n\n`)),b=c.default.div((({activeColor:e})=>`\n  display: flex;\n  align-items: center;\n  gap: 0.5em;\n  cursor: pointer;\n  padding: 0.5em 1em;\n  padding-right: 2em;\n  white-space: nowrap;\n  &:hover,\n  &.active {\n    background: ${e};\n  }\n`)),w=c.default.span((({languageCommonStyle:e})=>{const n=((e,n)=>{var t={};for(var r in e)p.call(e,r)&&n.indexOf(r)<0&&(t[r]=e[r]);if(null!=e&&m)for(var r of m(e))n.indexOf(r)<0&&f.call(e,r)&&(t[r]=e[r]);return t})(e||{},["hover","background"]);return o.getStyle(n)}));exports.LanguageSelect=n=>{const d=t.useRef(null),[c,u]=t.useState(!1),{flagSize:j=20,flagStyle:S="round",layout:O="full",showFlag:I=!0,isEditingMode:k=!1,device:A="desktop",align:_=o.Alignment.right,currentLanguage:L,setCurrentLanguage:E,languages:M=[],languageCommonStyle:z,menuAlign:$=o.Alignment.right}=n||{},q=I||"flag"===O,R="round"===S,T="short"===O;if(!L||(M||[]).length<=1)return null;const N=e=>{var n,t;const r=(null==(n=null==document?void 0:document.querySelector(`#${o.TEMPI_MAIN_IFRAME}`))?void 0:n.contentWindow)||window;(null==(t=d.current)?void 0:t.contains(e.target))||(u(!1),r.removeEventListener("click",N,!1))},P=e=>{var n;return T?null==(n=e.languageCode)?void 0:n.toUpperCase():e.languageLocalizeName};return e.jsx("div",{style:{display:"flex",justifyContent:(()=>{switch($){case o.Alignment.left:return"flex-start";case o.Alignment.center:return"center";case o.Alignment.right:return"flex-end"}})()},children:e.jsxs(x,{onClick:()=>(()=>{var e;const n=(null==(e=null==document?void 0:document.querySelector(`#${o.TEMPI_MAIN_IFRAME}`))?void 0:e.contentWindow)||window,t=!c;u(t),t&&n.addEventListener("click",N,!1)})(),device:A,align:_,ref:d,children:[e.jsxs(h,{children:[q&&e.jsx(r.Icon,{name:`${y(L.countryCode)}Flags`,style:{fontSize:j,borderRadius:R?"50%":"0",backgroundSize:R?"cover":"contain"}}),"flag"!==O&&e.jsxs(w,{languageCommonStyle:z,children:[P(L),e.jsx(r.Icon,{name:"DownOutlined",style:{marginLeft:"0.4em",fontSize:"1.1em"}})]})]}),c&&e.jsx(C,{device:A,commonStyle:z,flagSize:j,children:M.map((n=>{var t,o,d;return e.jsxs(b,(o=((e,n)=>{for(var t in n||(n={}))p.call(n,t)&&v(e,t,n[t]);if(m)for(var t of m(n))f.call(n,t)&&v(e,t,n[t]);return e})({className:n.languageCode===L.languageCode?"option-lang active":"option-lang",onClick:()=>{k||E(n)},activeColor:a.isLightColor(null==z?void 0:z.background)?i.LIGHT_ACTIVE_ITEM_BACKGROUND_COLOR:i.DARK_ACTIVE_ITEM_BACKGROUND_COLOR},l.getAttrTracking({regionName:"header",contentName:n.languageCode,target:(null==(t=null==window?void 0:window.location)?void 0:t.origin)+"/"+n.languageCode})),d={children:[q&&e.jsx(r.Icon,{name:`${y(n.countryCode)}Flags`,style:{fontSize:j,display:I?"block":"none",borderRadius:R?"50%":"0",backgroundSize:R?"cover":"contain"}}),e.jsx(w,{languageCommonStyle:z,children:P(n)})]},s(o,g(d))),n.languageCode)}))})]})})},exports.capitalizeFirstLetter=y;


/***/ }),

/***/ 565445:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const t=s(__webpack_require__(212951)).default.div`
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .spinner-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    flex-direction: column;
    opacity: 0.9;
  }
  .loading-text {
    font-size: 16px;
    letter-spacing: 2px;
    color: #7367f0;
    margin-bottom: 8px;
  }
  .pulse-container {
    width: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .pulse-bubble {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: linear-gradient(to right, #7367f0, #a29af6);
  }

  .pulse-bubble-1 {
    animation: pulse 1s ease 0s infinite alternate;
  }
  .pulse-bubble-2 {
    animation: pulse 1s ease 0.2s infinite alternate;
  }
  .pulse-bubble-3 {
    animation: pulse 1s ease 0.4s infinite alternate;
  }
  .pulse-bubble-4 {
    animation: pulse 1s ease 0.6s infinite alternate;
  }
  .pulse-bubble-5 {
    animation: pulse 1s ease 0.8s infinite alternate;
  }

  @keyframes pulse {
    from {
      opacity: 1;
      transform: scale(1);
    }
    to {
      opacity: 0.25;
      transform: scale(0.75);
    }
  }
`;exports.Loading=()=>e.jsx(t,{children:e.jsx("div",{className:"spinner-box",children:e.jsxs("div",{className:"pulse-container",children:[e.jsx("div",{className:"pulse-bubble pulse-bubble-1"}),e.jsx("div",{className:"pulse-bubble pulse-bubble-2"}),e.jsx("div",{className:"pulse-bubble pulse-bubble-3"}),e.jsx("div",{className:"pulse-bubble pulse-bubble-4"}),e.jsx("div",{className:"pulse-bubble pulse-bubble-5"})]})})});


/***/ }),

/***/ 647816:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

function n(n){return n&&"object"==typeof n&&"default"in n?n:{default:n}}Object.defineProperty(exports, "__esModule", ({value:!0}));var o=n(__webpack_require__(212951));const e=o.default.a((({grid:n})=>{const{logoGridRow:o,logoGridColumn:e,logoJustifySelf:i,logoSpacing:t,mobileLogoSpacing:l,logoWidth:r}=n;return`\n    display: inline-flex;\n    grid-row: ${o};\n    grid-column: ${e};\n    align-self: center;\n    justify-self: ${i};\n    margin: ${t};\n    width: ${r}px;\n\n    @media (max-width: 768px) {\n      margin: ${l||t};\n    }\n  `})),i=o.default.img((({grid:n})=>{const{logoImageObjectPosition:o}=n;return`\n    width: 100%;\n    height: 100%;\n  \n    vertical-align: middle;\n    object-fit: contain;\n    object-position: ${o};\n  `}));exports.Logo=e,exports.LogoImg=i;


/***/ }),

/***/ 82126:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var n=__webpack_require__(212951),t=__webpack_require__(88928);function i(n){return n&&"object"==typeof n&&"default"in n?n:{default:n}}const e=i(n).default.ul((({grid:n})=>{const{navigationTextAlign:i,mobileMenuItemSpacing:e,mobileNavigationJustifySelf:o,paddingRight:a,mobileNavigationTextAlign:r,mobileBackground:s="#ffffff"}=n;return`\n    padding-left: unset;\n    display: inline-flex;\n    flex-flow: row wrap;\n    row-gap: 16px;\n    align-items: center;\n    height: 100%;\n    text-align: ${i};\n    list-style: none;\n\n    @media screen and (max-width: ${t.MOBILE_WIDTH}px) {\n      position: absolute;\n      top: 100%;\n      right: 0;\n      left: 0;\n      z-index: 1;\n      display: grid;\n      grid-gap: ${e||16}px 0;\n      justify-self: ${o};\n      width: 100%;\n      height: 0;\n      max-height: 450px;\n      padding: ${e||16}px ${e||16}px ${e||16}px ${a}px;\n      margin: 0;\n      overflow-y: auto;\n      text-align: ${r};\n      pointer-events: none;\n      background-size: cover;\n      box-shadow: 0 6px 14px -14px #0000001a;\n      opacity: 0;\n      transform: translateY(-1em);\n      transition-timing-function: cubic-bezier(.45,0,.1,1);\n      transition-duration: .2s;\n      transition-property: opacity,transform;\n      background: ${s};\n\n      &.open {\n        height: auto;\n        pointer-events: auto;\n        opacity: 1;\n        transform: translate(0);\n        transition-timing-function: cubic-bezier(.45,0,.1,1);\n        transition-duration: .2s;\n        transition-property: opacity,transform;\n      }\n    };\n  `}));exports.Menu=e;


/***/ }),

/***/ 760187:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var e=__webpack_require__(561261),r=__webpack_require__(891987),n=__webpack_require__(870141),t=__webpack_require__(622065),o=__webpack_require__(212951),i=__webpack_require__(162291),u=__webpack_require__(166311);function d(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=d(r),a=d(o);const l=a.default.div`
  float: left;
  overflow: hidden;

  &:hover > .dropdown-content-wrapper {
    display: block;
  }
`,c=a.default.div`
  display: none;
  position: absolute;
  padding-top: 0.75em;
  z-index: 1000;
  min-width: 200px;
  text-align: left;
`,f=a.default.div`
  background-color: ${({background:e})=>e||"#fff"};
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  overflow: hidden;
`;module.exports=({item:o,menuConfig:d,isEditingMode:a,commonStyle:p})=>{const h=s.default.useRef(null),m=()=>{if(!h.current)return;const e=h.current;e.style.transform="translateX(0)";const r=e.getBoundingClientRect(),n=window.innerWidth;if(r.right>n){const t=r.right-n+16;e.style.transform=`translateX(-${t}px)`}};return r.useEffect((()=>{if(!h.current)return;const e=new ResizeObserver((()=>{m()}));return e.observe(h.current),()=>{e.disconnect()}}),[]),e.jsxs(l,{children:[e.jsx(n.MenuItemRenderer,{item:o,alignMenu:null==d?void 0:d.align,isEditingMode:a,onMouseEnter:()=>{m()},hasDropdownArrow:!0}),e.jsx(c,{className:"dropdown-content-wrapper",children:e.jsx(f,{ref:h,background:p.background,children:(()=>{let r;switch(null==d?void 0:d.threeLevelMenuLayout){case t.ThreeLevelMenuLayout.HIERARCHICAL:r=u.HierarchicalMenuContent;break;case t.ThreeLevelMenuLayout.GRID:default:r=i.GridMenuContent}return e.jsx(r,{menu:o,isEditingMode:a,commonStyle:p})})()})})]})};


/***/ }),

/***/ 879584:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var n=__webpack_require__(212951),e=__webpack_require__(88928);function t(n){return n&&"object"==typeof n&&"default"in n?n:{default:n}}const r=t(n).default.nav((({grid:n})=>{const{linksGridRow:t,linksGridColumn:r,navigationJustifySelf:i,menuItemSpacing:o}=n;return`\n    grid-row: ${t};\n    grid-column: ${r};\n    justify-self: ${i};\n    height: 100%;\n    margin-left: ${-1*o}px;\n  \n    @media screen and (max-width: ${e.MOBILE_WIDTH}px){\n      grid-row: unset;\n      grid-column: unset;\n    };\n  `}));exports.Navbar=r;


/***/ }),

/***/ 713900:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),o=__webpack_require__(75537),r=__webpack_require__(891987),i=__webpack_require__(987573),n=__webpack_require__(85097),a=__webpack_require__(143599),l=__webpack_require__(570267);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=s(t),d=Object.defineProperty,u=Object.defineProperties,p=Object.getOwnPropertyDescriptors,f=Object.getOwnPropertySymbols,x=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,h=(e,t,o)=>t in e?d(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o;const b=({item:t,currentLanguage:o,isPreviewMode:i})=>{const{extraInfo:n,description:a,name:l,slug:s}=t||{},{metaDescription:c,metaTitle:d}=n||{},u=r.useMemo((()=>(null==o?void 0:o.languageCode)?`${location.origin}/${o.languageCode}/${s}`:`${location.origin}/${s}`),[o,s]),p=r.useCallback((()=>{i||window.open(u,"_self")}),[i,u]);return e.jsxs($,{onClick:p,children:[e.jsx(I,{children:d||l}),e.jsx(M,{children:c||a})]})},m=o.keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`,v=c.default.div`
  grid-column: last-col / span 1;
  grid-row: span 2;
  margin-left: 16px;
  cursor: pointer;
`,w=c.default.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  z-index: 1000;
  opacity: 1;
  transition: opacity 0.3s ease;
`,y=c.default.div`
  background-color: white;
  max-width: 600px;
  width: 70vw;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translate(-50%, 0);
  transform-origin: top center;
  border-radius: 6px;
  max-height: 70vh;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  ${({loading:e})=>e&&"\n    opacity: 0.9;\n    overflow: hidden;\n  "}
`,j=c.default.div`
  display: flex;
  flex-direction: column;
  padding: 8px 4px;
`,k=c.default.div`
  display: flex;
  align-items: center;
  padding: 8px;
`,C=c.default.span`
  color: #9aa0a6;
  margin-right: 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }
`,z=c.default.input`
  border: none;
  outline: none;
  font-size: 16px;
  width: 100%;
  transition: all 0.2s ease;

  &::placeholder {
    color: #9aa0a6;
  }

  &:focus {
    font-size: 17px;
  }
`,O=c.default.div`
  flex: 1;
  overflow-y: auto;
  max-height: 70vh;
  border-top: ${e=>e.showResults?"1px solid #ebebeb":"none"};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  position: relative;
`,P=c.default.div`
  opacity: ${e=>e.visible?1:0};
  max-height: ${e=>e.visible?"100%":"0"};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`,S=c.default.div`
  padding: 12px 16px;
  font-size: 14px;
  color: #70757a;
  opacity: 1;
  transition: opacity 0.3s ease;
`,$=c.default.div`
  padding: 16px;
  border-bottom: 1px solid #f5f5f5;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    background-color: #f9f9f9;
  }

  &:last-child {
    border-bottom: none;
    margin-bottom: 12px;
  }
`,I=c.default.div`
  font-size: 16px;
  color: #202124;
  text-decoration: none;
  font-weight: 500;
  display: block;
  margin-bottom: 8px;
  line-height: 1.3;
  transition: color 0.2s ease;
`,M=c.default.div`
  font-size: 14px;
  color: #5f6368;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 4.2em;
  transition: all 0.3s ease;
`,q=c.default.div`
  padding: 32px 16px;
  text-align: center;
  color: #5f6368;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 200px;
  opacity: 1;
  transition: opacity 0.3s ease;
  flex: 1;
  height: 650px;
`,E=c.default.div`
  width: 24px;
  height: 24px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #7367f0;
  border-radius: 50%;
  animation: ${m} 1s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
`;exports.PageSearch=({searchConfig:t,isEditingMode:o,iconColorInTransparentMode:s})=>{var c;const d=l.getIconComponent((m=((e,t)=>{for(var o in t||(t={}))x.call(t,o)&&h(e,o,t[o]);if(f)for(var o of f(t))g.call(t,o)&&h(e,o,t[o]);return e})({},null==t?void 0:t.icon),$={color:s||(null==(c=null==t?void 0:t.icon)?void 0:c.color)},u(m,p($))));var m,$;const[I,M]=r.useState(""),[L,R]=r.useState(!1),D=r.useRef(null),T=r.useRef(null),_=r.useRef(null),F=r.useRef(null),{globalData:H={}}=n.useStore(),{websiteId:N,currentLanguage:A,isPreviewMode:B}=H||{},{show:G=!1}=t||{},{searchResults:J,loading:K,debouncedSearch:Q,hasMore:U,loadMore:V,total:W}=i.useSearch({websiteId:N,pageSize:10,websiteTranslationId:null==A?void 0:A.id}),X=r.useCallback((e=>{e.preventDefault(),e.stopPropagation();const t=e.target.value;M(t),Q(t)}),[Q]),Y=r.useCallback((()=>{var e;M(""),Q(""),null==(e=F.current)||e.focus()}),[Q]),Z=r.useCallback((()=>{o||R(!0)}),[o]),ee=r.useCallback((()=>{M(""),Q(""),R(!1)}),[Q]);r.useEffect((()=>{if(!L)return;const e=e=>{D.current&&!D.current.contains(e.target)&&T.current&&T.current.contains(e.target)&&ee()};return document.addEventListener("mousedown",e),()=>{document.removeEventListener("mousedown",e)}}),[L,ee]);const te=r.useCallback((e=>{e.target===T.current&&ee()}),[ee]),oe=r.useCallback((()=>{if(!_.current)return;const{scrollTop:e,scrollHeight:t,clientHeight:o}=_.current;e>=t-o-100&&U&&!K&&V()}),[K,U,V]);r.useEffect((()=>{const e=_.current;if(e)return e.addEventListener("scroll",oe),()=>e.removeEventListener("scroll",oe)}),[oe]);const re=I.trim(),ie=""!==re&&J.length>0,ne=""!==re&&0===J.length;return G?e.jsxs(e.Fragment,{children:[e.jsx(v,{onClick:Z,children:d}),L&&e.jsx(w,{ref:T,onClick:te,children:e.jsxs(y,{loading:!!K,ref:D,onClick:e=>e.stopPropagation(),children:[K&&e.jsx(E,{}),e.jsx(j,{children:e.jsxs(k,{children:[e.jsx(C,{onClick:re?Y:void 0,children:e.jsx(a.Icon,{name:re?"CloseOutlined":"SearchOutlined",style:{fontSize:24}})}),e.jsx(z,{ref:F,placeholder:"Search...",value:I,onChange:X,autoFocus:!0})]})}),e.jsxs(O,{ref:_,showResults:ie,children:[ie&&e.jsxs(S,{children:[W," results"]}),e.jsx(P,{visible:ie,children:J.map(((t,o)=>e.jsx(b,{item:t,currentLanguage:A,isPreviewMode:B},o)))}),ne&&e.jsx(q,{children:void 0===K||K?"":"No results found"})]})]})})]}):null};


/***/ }),

/***/ 7698:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),i=__webpack_require__(143599),n=__webpack_require__(681084),r=__webpack_require__(586753),a=__webpack_require__(840424);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=o(t);const l=s.default.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 1em;

  @media (max-width: 480px) {
    gap: 12px;
  }
`,d=s.default.div`
  display: flex;
  align-items: flex-end;
  max-width: 100%;
`,p=s.default.div`
  display: flex;
  flex-direction: column;
  margin-left: 1em;
  align-items: flex-start;

  @media (max-width: 480px) {
    margin-left: 10px;
  }
`,c=s.default(a.Paragraph)`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  white-space: nowrap;
`,x=s.default(a.Paragraph)`
  font-size: 14px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-weight: 700;
  margin-bottom: 12px;
`,u=s.default.div`
  display: flex;
  align-items: center;
  border-collapse: separate;
  border-spacing: 0;
`,m=s.default.div`
  align-items: center;
  background: transparent;
  border: 0;
  border: 1px solid rgba(0, 0, 0, 0.09);
  border-radius: 2px;
  color: rgba(0, 0, 0, 0.8);
  cursor: pointer;
  display: flex;
  font-size: 0.875rem;
  font-weight: 300;
  height: 32px;
  justify-content: center;
  letter-spacing: 0;
  line-height: 1;
  outline: none;
  transition: background-color 0.1s cubic-bezier(0.4, 0, 0.6, 1);
  width: 32px;
  user-select: none;

  @media (max-width: 480px) {
    height: 25px;
    width: 25px;
  }
`,h=s.default.input`
  border: 1px solid rgba(0, 0, 0, 0.09);
  border-left: 0;
  border-radius: 0;
  border-right: 0;
  box-sizing: border-box;
  cursor: text;
  font-size: 16px;
  font-weight: 400;
  height: 32px;
  text-align: center;
  width: 50px;
  outline: none;
  &.no-spinners {
    -moz-appearance: textfield;
  }

  &.no-spinners::-webkit-outer-spin-button,
  &.no-spinners::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  @media (max-width: 480px) {
    height: 25px;
    width: 40px;
    font-size: 14px;
  }
`,g=s.default.div`
  background-color: #636363;
  border-radius: 50%;
  cursor: pointer;
  min-width: 16px;
  min-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
`,f=s.default.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1em;

  @media (max-width: 480px) {
    gap: 8px;
  }
`;exports.ProductItem=({thumbnailAlt:t,thumbnailUrl:a,name:o,price:s,currencyUnit:b,quantity:w=1,currencyAlignment:j="right",setQuantity:y,index:v,removeProduct:k,showRemoveIcon:z=!0})=>e.jsxs(l,{children:[e.jsxs(d,{children:[e.jsx(r.Image,{src:a||"https://lh3.googleusercontent.com/0_9tvizWOfHonGP4_6IsDOo_tstObXmVmcw4E_FTOWl1Z4b8QOfzsqlVavZdUwtgmyRA0h4il285XZWjUXUxX1cnAtIK8Ik=rw-w1000",alt:t||"",commonStyle:{display:"block",width:90,height:90}}),e.jsxs(p,{children:[e.jsx(x,{className:"detail-card__name",text:o}),e.jsxs(u,{children:[e.jsx(m,{onClick:()=>y(w-1,v),children:"-"}),e.jsx(h,{type:"number",min:1,value:w,autoComplete:"off",step:1,className:"no-spinners",onChange:e=>y(+e.target.value,v)}),e.jsx(m,{onClick:()=>y(w+1,v),children:"+"})]})]})]}),e.jsxs(f,{children:[e.jsx(c,{text:n.getPriceText(s,b,j)}),z&&e.jsx(g,{onClick:()=>k(v),children:e.jsx(i.Icon,{name:"CloseOutlined",style:{fontSize:12,color:"#fff"}})})]})]});


/***/ }),

/***/ 870206:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),n=__webpack_require__(85097),o=__webpack_require__(143599),i=__webpack_require__(891987),r=__webpack_require__(824265),l=__webpack_require__(795625),d=__webpack_require__(681084);function u(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=u(t);const c=a.default.div`
  position: relative;
  margin-left: 1em;
`,s=a.default.div((({commonStyle:e,flagSize:t})=>`\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  background: ${(null==e?void 0:e.background)||"white"};\n  position: absolute;\n    top: ${20+Math.max(+(null==e?void 0:e.fontSize),t,0)}px;\n    right: 0;\n  border-radius: 6px;\n  box-shadow: 0px 4px 20px 0px #a5a3ae66;\n  overflow: hidden;\n  z-index: 1001;\n`)),p=a.default.span`
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #c90024;
  border-radius: 100px;
  bottom: 5px;
  color: #fff;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  font-size: 10px;
  font-weight: 500;
  height: 16px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  pointer-events: none;
  position: absolute;
  top: -5px;
  width: 16px;
  right: -5px;
  z-index: 1;
`;exports.ShoppingCart=t=>{const{isEditingMode:u,icon:a,show:x,cartCommonStyle:f,buttonStyle:v,buttonText:m,iconColorInTransparentMode:b}=t||{},{globalData:g}=n.useStore(),y=i.useRef(null),[h,w]=i.useState(!1),[S,k]=i.useState(),C=e=>{var t,o;const i=(null==(t=null==document?void 0:document.querySelector(`#${n.TEMPI_MAIN_IFRAME}`))?void 0:t.contentWindow)||window;(null==(o=y.current)?void 0:o.contains(e.target))||(w(!1),i.removeEventListener("click",C,!1))},j=e=>{const t=null==e?void 0:e.reduce(((e,t)=>e+(t.quantity||0)),0);k(t)};return i.useEffect((()=>((()=>{var e;let t=[];t=u?r.MOCK_EDITOR_DATA:d.getProductsInLocalCart(null==(e=null==g?void 0:g.currentLanguage)?void 0:e.id),j(t)})(),l.addListener("addProductToCart",j),()=>{l.removeAllListeners("addProductToCart")})),[]),x?e.jsxs(c,{style:{position:"relative"},ref:y,children:[e.jsx(p,{children:S}),e.jsx(o.Icon,{onClick:()=>(()=>{var e;const t=(null==(e=null==document?void 0:document.querySelector(`#${n.TEMPI_MAIN_IFRAME}`))?void 0:e.contentWindow)||window,o=!h;w(o),o&&t.addEventListener("click",C,!1)})(),name:"ShoppingCartOutlined",style:{fontSize:24,color:b||(null==a?void 0:a.color),cursor:"pointer"}}),h&&e.jsx(s,{commonStyle:f,children:e.jsx(r.ShoppingCartContent,{buttonStyle:v,isEditingMode:u,open:h,buttonText:m,setOpenCart:w,updateTotalQuantityProduct:j})})]}):null};


/***/ }),

/***/ 824265:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(561261),e=__webpack_require__(212951),r=__webpack_require__(85097),n=__webpack_require__(891987),i=__webpack_require__(681084),o=__webpack_require__(565445),u=__webpack_require__(7698),l=__webpack_require__(100902),a=__webpack_require__(840424),s=__webpack_require__(750911);function c(t){return t&&"object"==typeof t&&"default"in t?t:{default:t}}var p=c(e),d=Object.defineProperty,m=Object.defineProperties,h=Object.getOwnPropertyDescriptors,g=Object.getOwnPropertySymbols,x=Object.prototype.hasOwnProperty,v=Object.prototype.propertyIsEnumerable,j=(t,e,r)=>e in t?d(t,e,{enumerable:!0,configurable:!0,writable:!0,value:r}):t[e]=r,y=(t,e)=>{for(var r in e||(e={}))x.call(e,r)&&j(t,r,e[r]);if(g)for(var r of g(e))v.call(e,r)&&j(t,r,e[r]);return t};const b=[{sku:"CARTSAMPLE1",thumbnailUrl:"https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500",thumbnailAlt:"",name:"Lorem ipsum dolor sit amet, consectetur adipiscing elit",price:1e5,quantity:1},{sku:"CARTSAMPLE2",thumbnailUrl:"https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500",thumbnailAlt:"",name:"Lorem ipsum dolor sit amet, consectetur adipiscing elit",price:1e5,quantity:1},{sku:"CARTSAMPLE3",thumbnailUrl:"https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500",thumbnailAlt:"",name:"Lorem ipsum dolor sit amet, consectetur adipiscing elit",price:1e5,quantity:1}],f=p.default.div`
  width: 380px;
  min-height: 208px;
`,w=p.default.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.5em;
`,A=p.default(a.Paragraph)`
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  white-space: nowrap;
`,q=p.default.div`
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`,P=p.default.div`
  max-height: 315px;
  overflow: auto;
`;exports.MOCK_EDITOR_DATA=b,exports.ShoppingCartContent=({isEditingMode:e,open:a,buttonText:c="Đặt hàng",buttonStyle:p,setOpenCart:d,updateTotalQuantityProduct:g})=>{const[x,v]=n.useState(!0),{globalData:j}=r.useStore(),[L,O]=n.useState(),{openOrderPopup:Q}=l.useCheckoutContext(),C=t=>{var e;O(t),i.setProductsToLocalCart(null==(e=null==j?void 0:j.currentLanguage)?void 0:e.id,t),g(t)},k=(t,r)=>{if(t<1||e)return;const n=[...L];(null==n?void 0:n[r])&&(n[r].quantity=t),C(n)},U=t=>{if(t<0||e)return;const r=[...L];r.splice(t,1),C(r)};return n.useEffect((()=>{var t;a?(()=>{var t;v(!0);let r=[];r=e?b:i.getProductsInLocalCart(null==(t=null==j?void 0:j.currentLanguage)?void 0:t.id),O(r||[]),setTimeout((()=>v(!1)),300)})():(O(void 0),localStorage.setItem(`in_cart_product_list_${null==(t=null==j?void 0:j.currentLanguage)?void 0:t.id}`,JSON.stringify(L||[])))}),[a]),t.jsx(f,{children:t.jsx(t.Fragment,{children:x?t.jsx(o.Loading,{}):(null==L?void 0:L.length)?t.jsxs(t.Fragment,{children:[t.jsx(P,{children:null==L?void 0:L.map(((e,r)=>{return t.jsx(u.ProductItem,(n=y({},e),m(n,h({setQuantity:k,index:r,removeProduct:U}))));var n}))}),t.jsx("hr",{style:{margin:"1.5em 0"}}),t.jsxs(w,{children:[t.jsx(A,{text:"Tổng thanh toán"}),t.jsx(A,{text:i.getPriceText((K=L,null==K?void 0:K.reduce(((t,e)=>t+(e.quantity||1)*(e.price||0)),0)),null==(S=null==L?void 0:L[0])?void 0:S.currencyUnit,null==(I=null==L?void 0:L[0])?void 0:I.currencyAlignment)})]}),t.jsx(s.ButtonV2,{text:c,buttonStyle:y({width:100,widthUnit:r.UnitEnum.percent,background:"rgba(37, 141, 255, 1)",height:32},p),onClick:()=>{Q(L),d(!1)},isEditingMode:e})]}):t.jsx(q,{children:t.jsx("img",{alt:"empty-cart",width:150,src:"https://lh3.googleusercontent.com/DDgoWbI-vgQzr-ADPA1u57u4F6mbIXb2WBWmruh7Ygz5ZHUAhP9wxQOV_ynyz-7n9irg6m4F7CjjDHn6p9vu5RpidH_BMAsD=rw"})})})});var S,I,K};


/***/ }),

/***/ 958875:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var n=__webpack_require__(561261),t=__webpack_require__(212951),e=__webpack_require__(88928);function o(n){return n&&"object"==typeof n&&"default"in n?n:{default:n}}var r=o(t),i=Object.defineProperty,a=Object.defineProperties,s=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,l=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,d=(n,t,e)=>t in n?i(n,t,{enumerable:!0,configurable:!0,writable:!0,value:e}):n[t]=e;const f=r.default.button((({grid:n})=>{const{linksGridRow:t,linksGridColumn:o,navigationJustifySelf:r,navigationTextAlign:i,toggleButtonGridRow:a,toggleButtonGridColumn:s,menuColor:p}=n,l=r,u=i;return`\n    padding: 0;\n    display: none;\n    grid-row: ${t};\n    grid-column: ${o};\n    justify-self: ${r};\n    text-align: ${i}; \n  \n    width: 24px;\n    height: 18px;\n    cursor: pointer;\n    background-color: transparent;\n    transition: all .4s ease-in-out .1s;\n    transform: rotate(0);\n  \n    border: none;\n    outline: none;\n    box-shadow: none;\n    \n    &:focus{\n      outline: none;\n    }\n  \n    span{\n      position: absolute;\n      display: block;\n      width: 100%;\n      height: 2px;\n      background: ${p||"#7367f0"};\n      border-radius: 2px;\n      transition: all .25s ease-in-out .1s;\n      transform: rotate(0);\n      transform-origin: left center;\n    }\n  \n    span:nth-of-type(1){\n      top: 0;\n    } \n    span:nth-of-type(2){\n      top: 8px;\n    } \n    span:nth-of-type(3){\n      top: 16px;\n    } \n  \n    &.open {\n      span:nth-of-type(1){\n        top: -1px;\n        transform: rotate(45deg);\n      } \n      span:nth-of-type(2){\n        width: 0%;\n        opacity: 0;\n      } \n      span:nth-of-type(3){\n        transform: rotate(-45deg);\n      } \n    }\n    \n    @media screen and (max-width: ${e.MOBILE_WIDTH}px){\n        display: block;\n        grid-row: ${a};\n        grid-column: ${s};\n        justify-self: ${l};\n        text-align: ${u};\n    }\n    `}));exports.ToggleButton=t=>{return n.jsxs(f,(e=((n,t)=>{for(var e in t||(t={}))l.call(t,e)&&d(n,e,t[e]);if(p)for(var e of p(t))u.call(t,e)&&d(n,e,t[e]);return n})({},t),a(e,s({children:[n.jsx("span",{}),n.jsx("span",{}),n.jsx("span",{})]}))));var e};


/***/ }),

/***/ 88928:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(800656),o=__webpack_require__(85097),t=__webpack_require__(622065),r=Object.defineProperty,n=Object.defineProperties,a=Object.getOwnPropertyDescriptors,i=Object.getOwnPropertySymbols,l=Object.prototype.hasOwnProperty,g=Object.prototype.propertyIsEnumerable,p=(e,o,t)=>o in e?r(e,o,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[o]=t,f=(e,o)=>{for(var t in o||(o={}))l.call(o,t)&&p(e,t,o[t]);if(i)for(var t of i(o))g.call(o,t)&&p(e,t,o[t]);return e},m=(e,o)=>n(e,a(o));const{isGlobalWebsite:h}="undefined"!=typeof window&&(null==window?void 0:window.config)||{},b={stickyTop:!0,menuConfig:{commonStyle:{columnGap:32},align:o.Alignment.left,threeLevelMenuLayout:t.ThreeLevelMenuLayout.HIERARCHICAL},logoConfig:{show:!0,src:h?"https://lh3.googleusercontent.com/dYr4UwPWGT-RXtm3lZzoLiWLGpTf69zY_jOEEXy7-MA69r15VE0PHuhL71LhpHgabeXkOh7yS1r8Vo_AvVAii9P9vYb59Sa7":"https://lh3.googleusercontent.com/bhg6FoxZPA5S6q50_Gmu6YgMt2GcKxpjsbnaRvvHUwSV9JSnAj83TpbJEHIJjgKnbNoZmM7Mnx0pBlUau5CG2yIOG5v7rGc",align:o.Alignment.left,commonStyle:{width:100},spacingWithMenu:32},menuItemConfig:{commonStyle:{color:"#000000",hover:{color:"#008cff"},fontSize:16,fontWeight:"400"}},languageConfig:{align:o.Alignment.right,flagStyle:"round",layout:"short",showFlag:!0,flagSize:24},commonStyle:{backgroundColor:"#ffffff",padding:{top:30,right:16,bottom:30,left:16}},hiddenPageIds:[],cartConfig:{show:!1,isInitCart:!1,buttonStyle:{background:"#7367f0",borderColor:"#7367f0",color:"#ffffff",fontSize:14,hover:{background:"#5b4de0",borderColor:"#5b4de0",color:"rgba(255,255,255,1)"}},buttonText:e.t("common.order"),icon:{color:"#212529"}},subMenuBackgroundColor:"#f1f1f1"},c=m(f({},b),{menuItemConfig:{commonStyle:m(f({},b.menuItemConfig.commonStyle),{fontSize:"var(--tempi-global-paragraph1fontsize)",lineHeight:"var(--tempi-global-paragraph1lineheight)",fontWeight:"var(--tempi-global-paragraph1fontweight)",letterSpacing:"var(--tempi-global-paragraph1letterspacing)"})}}),E={commonStyle:{padding:{top:24,right:16,bottom:24,left:16}},menuItemConfig:{commonStyle:{fontSize:14,fontWeight:"400"}},hiddenPageIds:[]},s=m(f({},E),{menuItemConfig:{commonStyle:m(f({},E.menuItemConfig.commonStyle),{fontSize:"var(--tempi-global-paragraph1mobilefontsize)",fontWeight:"var(--tempi-global-paragraph1mobilefontweight)",lineHeight:"var(--tempi-global-paragraph1mobilelineheight)",letterSpacing:"var(--tempi-global-paragraph1mobileletterspacing)"})}}),d={desktop:f({},b),mobile:f({},E),commonStyle:{width:1240,widthUnit:o.UnitEnum.pixel},menuItemConfig:{commonStyle:{fontFamily:"Inter"}}},u=m(f({},d),{desktop:f({},c),mobile:f({},s),menuItemConfig:{commonStyle:{currentParagraphTheme:"paragraph1",fontFamily:"var(--tempi-global-paragraph1fontfamily)"}}});e.t("Trang chủ"),exports.DARK_ACTIVE_ITEM_BACKGROUND_COLOR="#4b5563",exports.DEFAULT_BUTTONS=[{text:"",buttonStyle:{backgroundColor:"#7367F0",color:"#ffffff",height:40,width:100,borderRadius:16,borderStyle:"solid",borderWidth:0,fontSize:16,fontWeight:"400"}}],exports.DEFAULT_BUTTONS_THEME=[{text:"",buttonStyle:{currentParagraphTheme:"paragraph1",backgroundColor:"#7367F0",color:"#ffffff",height:40,width:100,borderRadius:16,borderStyle:"solid",borderWidth:0,fontFamily:"var(--tempi-global-paragraph1fontfamily)",fontSize:"var(--tempi-global-paragraph1fontsize)",fontWeight:"var(--tempi-global-paragraph1fontweight)",lineHeight:"var(--tempi-global-paragraph1lineheight)",letterSpacing:"var(--tempi-global-paragraph1letterspacing)"}}],exports.DEFAULT_WEBSITE_HEADER=d,exports.DEFAULT_WEBSITE_HEADER_DESKTOP=b,exports.DEFAULT_WEBSITE_HEADER_DESKTOP_THEME=c,exports.DEFAULT_WEBSITE_HEADER_MOBILE=E,exports.DEFAULT_WEBSITE_HEADER_MOBILE_THEME=s,exports.DEFAULT_WEBSITE_HEADER_THEME=u,exports.LIGHT_ACTIVE_ITEM_BACKGROUND_COLOR="#f3f4f6",exports.MOBILE_WIDTH=767;


/***/ }),

/***/ 827273:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(891987);const t=r.createContext(void 0);exports.WebsiteHeaderContext=t,exports.WebsiteHeaderProvider=({children:r,grid:i,prefixLangUrl:s})=>e.jsx(t.Provider,{value:{grid:i,prefixLangUrl:s},children:r}),exports.useWebsiteHeaderContext=()=>{const e=r.useContext(t);if(void 0===e)throw new Error("useWebsiteHeaderContext must be used within a WebsiteHeaderProvider");return e};


/***/ }),

/***/ 987573:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097),a=__webpack_require__(891987);exports.useSearch=t=>{const{websiteId:r,pageSize:s=5,websiteTranslationId:u}=t,[l,o]=a.useState(""),[i,n]=a.useState([]),[c,d]=a.useState(1),[p,v]=a.useState(void 0),[b,S]=a.useState(!1),[h,g]=a.useState(0),{env:f}=e.useStore(),y=l.trim(),w=a.useMemo((()=>`${e.publicBffUrl[f]}/v1/pages`),[f]),m=a.useCallback((()=>{d(1),S(!1),g(0)}),[]),M=a.useCallback((async()=>{var a,t,l,o;if(!p){if(!y)return n([]),void m();v(!0);try{const i=new e.Api(w),d=await i.get("/",{params:{websiteId:r,searchQuery:y,page:c,pageSize:s,websiteTranslationId:u,statuses:["published"]}}),p=(null==(t=null==(a=null==d?void 0:d.data)?void 0:a.data)?void 0:t.pages)||[],v=null==(o=null==(l=null==d?void 0:d.data)?void 0:l.data)?void 0:o.pagination,b=(null==v?void 0:v.total)||0;n((e=>1===c?p:[...e,...p])),g(b),S(b>c*s)}catch(e){console.error("Error fetching search results:",e)}finally{v(!1)}}}),[y,w,r,c,s,u]);a.useEffect((()=>{""!==y&&M()}),[y,c,M]);const I=a.useCallback((()=>{!p&&b&&d((e=>e+1))}),[b]),k=a.useMemo((()=>e.debounce((e=>{o(e),1!==c&&d(1)}),500)),[c]);return{searchQuery:l,setSearchQuery:o,debouncedSearch:k,searchResults:i,loading:p,hasMore:b,loadMore:I,total:h,currentPage:c}};


/***/ }),

/***/ 622065:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=(e=>(e.GRID="grid",e.HIERARCHICAL="hierarchical",e))(e||{});exports.ThreeLevelMenuLayout=e;


/***/ }),

/***/ 171860:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(85097),n=__webpack_require__(877084),o=__webpack_require__(891987),i=__webpack_require__(10667),t=__webpack_require__(527470),l=__webpack_require__(801416),a=__webpack_require__(48812),d=__webpack_require__(212951),u=__webpack_require__(332535),s=__webpack_require__(681084),c=__webpack_require__(649351),g=__webpack_require__(870206),m=__webpack_require__(760187),p=__webpack_require__(827273),v=__webpack_require__(100902),h=__webpack_require__(549179),j=__webpack_require__(708688),f=__webpack_require__(647816),x=__webpack_require__(958875),C=__webpack_require__(879584),b=__webpack_require__(82126),I=__webpack_require__(870141),y=__webpack_require__(713900),w=__webpack_require__(402684),M=__webpack_require__(440384),q=__webpack_require__(138989),P=__webpack_require__(426839),S=__webpack_require__(750911);function L(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var k=L(n),E=L(d),O=Object.defineProperty,H=Object.defineProperties,R=Object.getOwnPropertyDescriptors,T=Object.getOwnPropertySymbols,W=Object.prototype.hasOwnProperty,A=Object.prototype.propertyIsEnumerable,G=(e,r,n)=>r in e?O(e,r,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[r]=n,B=(e,r)=>{for(var n in r||(r={}))W.call(r,n)&&G(e,n,r[n]);if(T)for(var n of T(r))A.call(r,n)&&G(e,n,r[n]);return e},N=(e,r)=>H(e,R(r));const U=n=>{var d,L,E,O,H;const{device:R,globalData:G}=r.useStore(),[U,$]=o.useState(!1),_=n,{isEditingMode:F,menu:K,children:z,orderPopupId:Y,dataUniqId:V}=_,Z=((e,r)=>{var n={};for(var o in e)W.call(e,o)&&r.indexOf(o)<0&&(n[o]=e[o]);if(null!=e&&T)for(var o of T(e))r.indexOf(o)<0&&A.call(e,o)&&(n[o]=e[o]);return n})(_,["isEditingMode","menu","children","orderPopupId","dataUniqId"]),J=r.getPropsByDevice(Z,R)||{},Q=F?K:(null==G?void 0:G.menu)||[],{mobile:X,desktop:ee}=Z,re=r.getPropsByDevice({mobile:X,desktop:ee,syncDeviceStyle:!1},R),ne=(null==G?void 0:G.prefixLangUrl)||"",oe=(null==G?void 0:G.languages)||[],ie=null==G?void 0:G.currentLanguage,te=null==(d=null==G?void 0:G.page)?void 0:d.id,le=!F&&(null==(L=null==re?void 0:re.hiddenPageIds)?void 0:L.includes(te)),{commonStyle:ae,logoConfig:de,menuConfig:ue,languageConfig:se,stickyTop:ce,transparentMode:ge,transparentModeCustom:me,transparentModeConfig:pe,searchConfig:ve,menuItemConfig:he,actionButtons:je,cartConfig:fe}=J,xe=null!=je?je:[],Ce=ge?!(null==(E=null==me?void 0:me.excludePageId)?void 0:E.includes(te)):null==(O=null==me?void 0:me.includePageId)?void 0:O.includes(te),[be,Ie]=o.useState(Ce),ye=l.calculateGrid(J,!F&&be),we=k.default({open:U}),Me=o.useMemo((()=>{var e;return l.buildMenuHierarchyWithActiveState(Q||[],null==(e=null==G?void 0:G.page)?void 0:e.slug)}),[Q,null==(H=null==G?void 0:G.page)?void 0:H.slug]),qe=(null==se?void 0:se.align)||r.Alignment.right,{headerRef:Pe,headerHeight:Se}=i.useHeaderPosition(F?M.PositionHeader.NORMAL:ce?M.PositionHeader.STICKY:M.PositionHeader.NORMAL);o.useEffect((()=>{const e=e=>{var r,n;(null==(n=null==(r=null==Pe?void 0:Pe.current)?void 0:r.contains)?void 0:n.call(r,e.target))||$(!1)};return document.addEventListener("mousedown",e),()=>{document.removeEventListener("mousedown",e)}}),[Pe]);const Le=()=>xe.map(((r,n)=>e.jsx(S.ButtonV2,N(B({},r),{isEditingMode:F}),n))),ke=N(B({},se),{isEditingMode:F,languages:oe,currentLanguage:ie,setCurrentLanguage:e=>{e.languageCode!==(null==ie?void 0:ie.languageCode)&&(u.setCookie(u.LOCALIZATION_KEY,e.languageCode),"undefined"!=typeof window&&window.open(`/${e.languageCode}`,"_self"))},languageCommonStyle:N(B({},he.commonStyle),{color:ye.menuColor,hover:N(B({},he.commonStyle.hover||{}),{color:ye.menuHoverColor}),background:ae.background})}),Ee=()=>e.jsx(a.LanguageSelect,N(B({},ke),{device:"desktop"})),Oe=r=>{const{threeLevelMenuLayout:n="grid"}=ue||{};return l.getMenuTreeDepth(r.children)>1&&"desktop"===R?e.jsx(m,{item:r,menuConfig:ue,isEditingMode:F,layout:n,commonStyle:ae}):e.jsx(t.DropdownItem,{item:r,alignMenu:null==ue?void 0:ue.align,isEditingMode:F,background:ae.backgroundColor||ae.background||"white",isHeaderTransparent:!F&&be,subMenuBackgroundColor:null==J?void 0:J.subMenuBackgroundColor})},He=Y===r.ORDER_POPUP?c.Cart:g.ShoppingCart;return o.useEffect((()=>{!F&&(null==fe?void 0:fe.show)||s.clearProductInCart(null==ie?void 0:ie.id)}),[F,null==fe?void 0:fe.show]),e.jsxs(v.CheckoutProvider,{orderPopupId:Y,wrapperCheckoutRef:Pe,customExtraFieldSubmit:s.customExtraFieldProductsSubmit,clearProductInCart:()=>s.clearProductInCart(null==ie?void 0:ie.id),children:[le?null:e.jsxs(h.Header,{commonStyle:ae,ref:Pe,headerHeight:Se,"data-selector-name":"website-header","data-sticky":ce,"data-uniq-id":V,isTransparentMode:!F&&!!Ce,isHeaderTransparent:!F&&be,setIsHeaderTransparent:Ie,children:[e.jsx(p.WebsiteHeaderProvider,{grid:ye,prefixLangUrl:ne,children:e.jsxs(j.Content,{grid:ye,commonStyle:ae,children:[(null==de?void 0:de.show)&&e.jsx(f.Logo,N(B({grid:ye},F?{}:{href:`${ne||"/"}`}),{children:e.jsx(f.LogoImg,{grid:ye,alt:null==de?void 0:de.alt,src:r.getImageUrlFromGoogleUserContent(null==de?void 0:de.src,null==de?void 0:de.googleImageParams),srcSet:r.buildSrcsetDPR(null==de?void 0:de.src,{width:ye.logoWidth}),loading:"lazy"})})),"left"===qe&&e.jsx("div",{style:{gridRow:ye.leftLanguageSelectGridRow,gridColumn:ye.leftLanguageSelectGridColumn},children:Ee()}),e.jsx(x.ToggleButton,{className:we,onClick:()=>$(!U),grid:ye}),e.jsx(C.Navbar,{grid:ye,children:e.jsxs(b.Menu,{className:we,grid:ye,children:[Me.map((r=>{var n;return e.jsx(I.Item,{children:(null==(n=null==r?void 0:r.children)?void 0:n.length)>0?Oe(r):e.jsx(I.ItemLabel,{children:e.jsx(I.ItemContentWrapper,N(B({alignMenu:null==ue?void 0:ue.align},P.getAttrTracking({regionName:"header",contentName:null==r?void 0:r.name,target:q.getUrlOfMenuItem(r,F,ne)})),{children:e.jsxs(I.ItemContent,N(B({alignMenu:null==ue?void 0:ue.align,href:q.getUrlOfMenuItem(r,F,ne),onClick:e=>{""!==(null==r?void 0:r.href)&&"#"!==(null==r?void 0:r.href)||e.preventDefault()},isActive:null==r?void 0:r.isActive,target:q.getTargetUrl(r.target)},"LINK"===(null==r?void 0:r.linkType)&&r.nofollow?{rel:"nofollow"}:{}),{children:[(null==r?void 0:r.iconUrl)&&e.jsx(I.ItemIcon,{src:r.iconUrl,loading:"lazy"}),null==r?void 0:r.name]}))}))})},r.id)})),e.jsxs(e.Fragment,{children:[e.jsx(a.LanguageSelect,N(B({},ke),{menuAlign:null==ue?void 0:ue.align,device:"mobile"})),(null==xe?void 0:xe.length)?e.jsx(w.ActionButtonMobile,{grid:ye,children:Le()}):null]})]})}),e.jsxs(D,{extraWrapperGridRow:ye.extraWrapperGridRow,mobileExtraWrapperGridRow:ye.mobileExtraWrapperGridRow,mobileExtraWrapperGridColumn:ye.mobileExtraWrapperGridColumn,children:[qe===r.Alignment.right?Ee():null,(null==fe?void 0:fe.show)?e.jsx(He,N(B({},fe),{isEditingMode:F,iconColorInTransparentMode:!F&&be&&(null==pe?void 0:pe.cartIconColor)})):null,e.jsx(y.PageSearch,{searchConfig:ve,isEditingMode:F,iconColorInTransparentMode:!F&&be&&(null==pe?void 0:pe.searchIconColor)}),(null==xe?void 0:xe.length)?e.jsx(w.ActionButton,{grid:ye,children:Le()}):null]})]})}),z]}),e.jsx("div",{className:"placeholder"})]})};U.displayName="websiteheader";const D=E.default.div((({extraWrapperGridRow:e,mobileExtraWrapperGridRow:r,mobileExtraWrapperGridColumn:n})=>`\n    grid-column: last-col / span 1;\n    grid-row: ${e};\n    display: flex;\n    align-items: center;\n\n    @media (max-width: 768px) {\n      grid-row: ${r};\n      grid-column: ${n};\n    }\n  `));exports.WebsiteHeader=U;


/***/ }),

/***/ 801416:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097),t=__webpack_require__(88928);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=n(__webpack_require__(630839)),r=Object.defineProperty,o=Object.defineProperties,l=Object.getOwnPropertyDescriptors,a=Object.getOwnPropertySymbols,g=Object.prototype.hasOwnProperty,c=Object.prototype.propertyIsEnumerable,u=(e,t,n)=>t in e?r(e,t,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[t]=n,m=(e,t)=>{for(var n in t||(t={}))g.call(t,n)&&u(e,n,t[n]);if(a)for(var n of a(t))c.call(t,n)&&u(e,n,t[n]);return e};const s=e=>{const t=e.split(" "),n={};return t[0]&&(n.paddingTop=parseInt(t[0].replace("px",""))),t[1]&&(n.paddingRight=parseInt(t[1].replace("px",""))),t[2]&&(n.paddingBottom=parseInt(t[2].replace("px",""))),t[3]&&(n.paddingLeft=parseInt(t[3].replace("px",""))),n},d=(t,n)=>t===e.Alignment.center&&n===e.Alignment.center?"2/2":"1/2",f=(t,n)=>{if(n===e.Alignment.center)return"1/4";switch(t){case e.Alignment.left:return"2/3";case e.Alignment.center:switch(n){case e.Alignment.left:return"1/2";case e.Alignment.right:return"3/4"}case e.Alignment.right:return"1/2"}},p=({logoPosition:t,menuPosition:n,logoWidth:i,spaceBetweenMenu:r,device:o,mobileLogoWidth:l,languageSelectPosition:a})=>{const g=("desktop"===o?i:l||i)+r,c=`minmax(${g}px, auto)`;switch(t){case e.Alignment.left:switch(n){case e.Alignment.left:return a===e.Alignment.left?`${c} auto 1fr auto`:`${c} 1fr auto`;case e.Alignment.center:return a===e.Alignment.left?`minmax(${g}px, auto) 1fr auto 1fr auto`:`minmax(${g}px, 1fr) auto 1fr auto`;case e.Alignment.right:return a===e.Alignment.left?`${c} auto 1fr auto`:`${c} 1fr auto`}case e.Alignment.center:if("desktop"===o)return a===e.Alignment.left?"auto 1fr [last-col] auto":"1fr 1fr [last-col] auto";switch(n){case e.Alignment.left:return a===e.Alignment.left?`auto 1fr ${c} auto`:`1fr ${c} 1fr auto`;case e.Alignment.center:return`1fr minmax(${i}px, auto) 1fr auto`;case e.Alignment.right:return`1fr ${c} 1fr auto`}case e.Alignment.right:switch(n){case e.Alignment.left:return a===e.Alignment.left?`auto 1fr ${c} auto`:`1fr ${c} auto`;case e.Alignment.center:return`1fr auto minmax(${g}px, 1fr) auto`;case e.Alignment.right:return`1fr ${c} auto`}}},h=e=>e.filter((e=>!e.isHidden)),A=(e,t)=>{const n=t?((e,t)=>e.filter((e=>e.parentId===t)))(e,t):(e=>e.filter((e=>!e.parentId)))(e);return h(n).map((t=>{return n=m({},t),i={children:A(e,t.id)},o(n,l(i));var n,i}))},x=(e,t)=>{if(((e,t)=>{var n;return(null==(n=e.page)?void 0:n.slug)===t})(e,t))return e.isActive=!0,!0;if(e.children&&e.children.length>0)for(const n of e.children)if(x(n,t))return e.isActive=!0,!0;return!1},b=e=>{if(!e||0===e.length)return 0;let t=1;for(const n of e)if(n.children&&n.children.length>0){const e=1+b(n.children);t=Math.max(t,e)}return t};exports.buildMenuHierarchyWithActiveState=(e,t)=>{if(!t)return(e=>{const t=h(e);return A(t)})(e);const n=i.default(e),r=h(n),o=A(r);let l=!1;for(const e of o)l||x(e,t)&&(l=!0);return o},exports.calculateGrid=(n,i)=>{var r,o,l,a,g,c,u;const m="30px 16px 30px 16px",h=(null==(r=null==n?void 0:n.menuConfig)?void 0:r.align)||e.Alignment.right,{paddingTop:A,paddingRight:x,paddingBottom:b,paddingLeft:v}=s(m),w=null==n?void 0:n.logoConfig,S=null==w?void 0:w.show,y=null==(o=null==w?void 0:w.commonStyle)?void 0:o.width,C=null!=(l=null==w?void 0:w.spacingWithMenu)?l:t.DEFAULT_WEBSITE_HEADER_DESKTOP.logoConfig.spacingWithMenu,P=(null==w?void 0:w.align)||e.Alignment.left,{fontFamily:$,fontSize:G,fontStyle:L,fontWeight:I,textDecoration:T,textTransform:k,fontVariant:W,lineHeight:M,letterSpacing:O,color:R,hover:{color:j}}=(null==(a=null==n?void 0:n.menuItemConfig)?void 0:a.commonStyle)||{},{menuItemColor:B,menuItemHoverColor:E}=(null==n?void 0:n.transparentModeConfig)||{},{background:D,backgroundColor:F}=(null==n?void 0:n.commonStyle)||{},H=null==(c=null==(g=null==n?void 0:n.menuConfig)?void 0:g.commonStyle)?void 0:c.columnGap,_=i&&B?B:R,J=i&&E?E:j,N=i?"transparent":D||F,q=(null==(u=null==n?void 0:n.languageConfig)?void 0:u.align)||e.Alignment.right;let z,V,K;V=p({logoPosition:P,menuPosition:h,logoWidth:y,spaceBetweenMenu:C,languageSelectPosition:q,device:"desktop"}),z=(t=>{if(t===e.Alignment.center)return"auto auto"})(P),K=p({logoPosition:P,menuPosition:h,logoWidth:y,spaceBetweenMenu:C,device:"mobile",mobileLogoWidth:70}),S||(V="1fr",K="1fr",z=void 0);const U=((t,n,i)=>{switch(t){case e.Alignment.left:return"1/2";case e.Alignment.center:return"1/-1";case e.Alignment.right:switch(n){case e.Alignment.left:return i===e.Alignment.left?"3/4":"2/3";case e.Alignment.right:return"2/3";case e.Alignment.center:return"3/4"}}})(P,h,q);let Q,X,Y="1/2",Z=`0 ${C}px 0 0`;switch(P){case"left":X="flex-start",Z=`0 ${C}px 0 0`;break;case"center":Y="1",X="center",Z=`0 0 ${C}px 0`,h!==e.Alignment.center&&(Q=`0 ${C}px`);break;case"right":X="flex-end",Z=`0 0 0 ${C}px`}const ee=`${P} center`,te="left"===P?"2/3":"1/2",ne=P===e.Alignment.center?"2/2":"1/2",ie=P===e.Alignment.center?"2":"1",re=P===e.Alignment.center&&h===e.Alignment.center?"2":"1",oe=P===e.Alignment.center&&h===e.Alignment.center?"3":"last-col / span 1";let le="1/2",ae="2/3",ge="flex-end";const ce=h||"right",ue=h||"right";let me="flex-end";switch(h){case"left":ge="flex-start",me="flex-start";break;case"center":ge="center",me="center";break;case"right":ge="flex-end",me="flex-end"}return ae=((t,n,i)=>{switch(t){case e.Alignment.left:return i===e.Alignment.left?"3/4":"2/3";case e.Alignment.center:return i===e.Alignment.left?"2/3":"1/3";case e.Alignment.right:switch(n){case e.Alignment.left:return i===e.Alignment.left?"2/3":"1/2";case e.Alignment.right:return"1/2";case e.Alignment.center:return"2/3"}}})(P,h,q),"center"===P&&(le="2/2"),S||(ae="1/2"),{gridArea:"1/1/-1/-1",navigationGridTemplateColumns:V,navigationGridTemplateRows:z,padding:m,paddingTop:A,paddingRight:x,paddingBottom:b,paddingLeft:v,width:1240,logoGridRow:Y,logoGridColumn:U,logoJustifySelf:X,logoSpacing:Z,logoWidth:y,logoImageObjectPosition:ee,toggleButtonGridRow:d(P,h),toggleButtonGridColumn:f(P,h),linksGridRow:le,linksGridColumn:ae,navigationJustifySelf:ge,menuItemSpacing:H,navigationTextAlign:ce,menuColor:_,menuHoverColor:J,menuFontFamily:$,menuFontSize:G,menuFontStyle:L,menuFontWeight:I,menuTextDecoration:T,menuTextTransform:k,menuFontVariant:W,menuLetterSpacing:O,menuLineHeight:M,mobilePadding:"24px 16px 24px 16px",mobilePaddingTop:24,mobilePaddingRight:16,mobilePaddingBottom:24,mobilePaddingLeft:16,mobileLogoWidth:70,mobileMenuItemSpacing:20,mobileNavigationGridTemplateColumns:K,mobileLogoGridRow:"1/2",mobileLogoGridColumn:"1/2",mobileLogoJustifySelf:"flex-start",mobileLogoImageObjectPosition:"left center",mobileLinksGridRow:"1/2",mobileLinksGridColumn:"2/3",mobileLogoSpacing:Q,mobileNavigationTextAlign:ue,mobileNavigationJustifySelf:me,mobileDropdownBackgroundColor:"#dcdcdc",mobileBackground:N,backgroundOverlayOpacity:0,leftLanguageSelectGridColumn:te,leftLanguageSelectGridRow:ne,extraWrapperGridRow:ie,mobileExtraWrapperGridRow:re,mobileExtraWrapperGridColumn:oe}},exports.convertMegaMenu=(e,t)=>{if(t<1)return[];const n=e.children.map((e=>({len:e.children.length+1,items:[m({},e)]})));if(n.length<=t)return n;n.sort(((e,t)=>t.len-e.len));const i=[...n.slice(0,t)];let r,o;for(let e=t;e<n.length;e++){r=i[0].len,o=0;for(let e=0;e<t;e++)r>i[e].len&&(r=i[e].len,o=e);i[o]={len:i[o].len+n[e].len,items:[...i[o].items,...n[e].items]}}return i},exports.getMenuTreeDepth=b,exports.isLightColor=e=>{const t=/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*[\d.]+)?\)$/.exec(e),n=/^#([a-f\d]{3}){1,2}$/.exec(e);let i,r,o;if(t)[i,r,o]=t.slice(1,4).map(Number);else if(n){const e=3===n[1].length?n[1].split("").map((e=>e+e)).join(""):n[1];[i,r,o]=[0,2,4].map((t=>parseInt(e.substring(t,t+2),16)))}else console.error("Invalid color format");return i/=255,r/=255,o/=255,(Math.max(i,r,o)+Math.min(i,r,o))/2>=.5},exports.splitPaddingString=s;


/***/ }),

/***/ 618137:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(891987),r=__webpack_require__(85097),o=__webpack_require__(266368),i=__webpack_require__(212951);function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var n=a(t),l=a(o),u=a(i),d=Object.defineProperty,s=Object.defineProperties,c=Object.getOwnPropertyDescriptors,p=Object.getOwnPropertySymbols,f=Object.prototype.hasOwnProperty,y=Object.prototype.propertyIsEnumerable,b=(e,t,r)=>t in e?d(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r;const v=n.default.forwardRef(((t,o)=>{var i;const a=t,{link:n,isEditorMode:l=!1,autoplay:u=!1}=a,d=((e,t)=>{var r={};for(var o in e)f.call(e,o)&&t.indexOf(o)<0&&(r[o]=e[o]);if(null!=e&&p)for(var o of p(e))t.indexOf(o)<0&&y.call(e,o)&&(r[o]=e[o]);return r})(a,["link","isEditorMode","autoplay"]);return e.jsx(m,(v=((e,t)=>{for(var r in t||(t={}))f.call(t,r)&&b(e,r,t[r]);if(p)for(var r of p(t))y.call(t,r)&&b(e,r,t[r]);return e})({},d),h={ref:o,children:e.jsx(j,{children:e.jsx(O,{className:l?"editor-mode":"",containerClassName:"container",videoId:(null==(i=r.youtubeParser(n))?void 0:i.videoId)||"",opts:l?{}:{playerVars:{autoplay:u?1:0,mute:u?1:0}}})})},s(v,c(h))));var v,h})),m=u.default.div((({commonStyle:e})=>`\n  ${r.getStyle(e)}\n  width: 100%\n`)),j=u.default.div`
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
  .container {
    height: 100%;
  }
`,O=u.default(l.default)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &.editor-mode {
    pointer-events: none;
  }
`;v.displayName="Youtube",exports.Youtube=v;


/***/ }),

/***/ 387064:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.ADD_TO_HISTORY_KEY="addToHistory",exports.APPLY_TO_NODE_BLOCK="applyToNodeBlock",exports.NODE_TYPES={orderedList:"orderedList",bulletList:"bulletList",heading:"heading",paragraph:"paragraph",textStyle:"textStyle",table:"table",listItem:"listItem"};


/***/ }),

/***/ 534479:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097),t=__webpack_require__(800656),i=__webpack_require__(16793),l=__webpack_require__(368380),n=(e=>(e.PARAGRAPH="paragraph",e.HEADING="heading",e))(n||{});const o=[...[1,2,3,4,5,6].map((e=>({value:`h${e}`,label:t.t("H{{level}}",{level:e})}))),{value:"p",label:t.t("P")}],a=e.pbFontFamily.map((e=>({label:e,value:e}))),r=Object.entries(e.pbFontWeight).reduce(((e,t)=>{var l;return[...e,{label:i.capitalize(t[0]),value:null==(l=t[1])?void 0:l.toString()}]}),[]),s=[12,14,16,18,24,32,48,64,72].map((e=>({label:e,key:e}))),p={fontSize:"fontSize",lineHeight:"lineHeight",letterSpacing:"letterSpacing",textAlign:"textAlign"},g={fontSize:{desktop:l.getResponsiveAttrKey(p.fontSize,"desktop"),mobile:l.getResponsiveAttrKey(p.fontSize,"mobile")},lineHeight:{desktop:l.getResponsiveAttrKey(p.lineHeight,"desktop"),mobile:l.getResponsiveAttrKey(p.lineHeight,"mobile")},letterSpacing:{desktop:l.getResponsiveAttrKey(p.letterSpacing,"desktop"),mobile:l.getResponsiveAttrKey(p.letterSpacing,"mobile")},textAlign:{desktop:l.getResponsiveAttrKey(p.textAlign,"desktop"),mobile:l.getResponsiveAttrKey(p.textAlign,"mobile")}};exports.PageFontTypeEnum=n,exports.RESPONSIVE_TEXT_STYLE_KEY=g,exports.TEXT_STYLE_KEY=p,exports.defaultFontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",exports.fontFamilyOptions=a,exports.fontSizeOptions=s,exports.fontStyleOptions=[{label:"Normal",value:"normal"},{label:"Italic",value:"italic"},{label:"Oblique",value:"oblique"}],exports.fontVariantOptions=[{label:"Normal",value:"normal"},{label:"Small Caps",value:"small-caps"}],exports.fontWeightOptions=r,exports.getCommonTextCss=e=>{const{fontSize:t,lineHeight:i,letterSpacing:l,textAlign:n}=g;return`\n    *:not(.ProseMirror-trailingBreak):empty:after {\n      content: "";\n      display: inline-block;\n    }\n\n    ${e?`\n        @media (min-width: 768px) {\n          .fs-desktop {\n            font-size: var(--${t.desktop});\n            line-height: var(--${i.desktop});\n            letter-spacing: var(--${l.desktop});\n            text-align: var(--${n.desktop});\n          }\n\n          li {\n            margin-left: var(--${t.desktop}, 1rem);\n            line-height: var(--${i.desktop}, 1.5);\n            letter-spacing: var(--${l.desktop});\n          }\n        }\n\n        @media (max-width: 767px) {\n          .fs-mobile {\n            font-size: var(--${t.mobile});\n            line-height: var(--${i.mobile});\n            letter-spacing: var(--${l.mobile});\n            text-align: var(--${n.mobile});\n          }\n\n          li {\n            margin-left: var(--${t.mobile}, 1rem);\n            line-height: var(--${i.mobile}, 1.5);\n            letter-spacing: var(--${l.mobile});\n          }\n        }\n      `:"\n        li {\n          margin-left: 1rem;\n          line-height: 1.5;\n        }\n      "}\n  `},exports.headingTypePrefix="h",exports.paragraphType="p",exports.textDecorationOptions=[{label:"Underline",value:"underline"},{label:"Overline",value:"overline"},{label:"Line Through",value:"line-through"}],exports.textTransformOptions=[{label:"Capitalize",value:"capitalize"},{label:"Uppercase",value:"uppercase"},{label:"Lowercase",value:"lowercase"}],exports.typeOptions=o;


/***/ }),

/***/ 879774:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097),t=__webpack_require__(954591);const l={[e.VerticalAlignment.top]:"flex-start",[e.VerticalAlignment.center]:"center",[e.VerticalAlignment.bottom]:"flex-end",[e.VerticalAlignment.justify]:"space-between"},n={[e.Alignment.center]:"center",[e.Alignment.left]:"flex-start",[e.Alignment.right]:"flex-end",[e.Alignment.justify]:"space-between"},r=[{label:"common.full_width",value:t.WidthTypeEnum.full},{label:"common.custom",value:t.WidthTypeEnum.fixed}],i=[{label:"common.default",value:t.HeightTypeEnum.default},{label:"common.custom",value:t.HeightTypeEnum.fixed},{label:"common.full_screen_height",value:t.HeightTypeEnum.fullHeight}];exports.BREAK_POINTS={xs:"480px",sm:"576px",md:"768px",lg:"1024px",xl:"1440px",xxl:"1600px"},exports.DEFAULT_GUTTER=[0,0],exports.DEFAULT_HEIGHT=400,exports.DEFAULT_WIDTH=1232,exports.GRID_COLUMNS=12,exports.HEIGHT_TYPE_OPTIONS=i,exports.MAPPING_ALIGNMENT_FLEX=n,exports.MAPPING_VERTICAL_ALIGNMENT_FLEX=l,exports.WIDTH_TYPE_OPTIONS=r;


/***/ }),

/***/ 481177:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(66811),t=Object.defineProperty,o=Object.defineProperties,i=Object.getOwnPropertyDescriptors,n=Object.getOwnPropertySymbols,a=Object.prototype.hasOwnProperty,r=Object.prototype.propertyIsEnumerable,l=(e,o,i)=>o in e?t(e,o,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[o]=i;const s=o(((e,t)=>{for(var o in t||(t={}))a.call(t,o)&&l(e,o,t[o]);if(n)for(var o of n(t))r.call(t,o)&&l(e,o,t[o]);return e})({},e.PROP_KEY),i({Name:"name",Color:"color",Size:"size",TextAlign:"textAlign",AutoSize:"autoSize",WidthType:"widthType",ContentWidthType:"contentWidthType",ContentMaxWidthKey:"row.commonStyle.maxWidth",HiddenXs:"responsive.hiddenXs",HiddenMd:"responsive.hiddenMd",Md:"md.flex",Xs:"xs.flex",MinHeight:"minHeight",Gutter:"gutter",Spacing:"spacing",Icon:"icon",IconConfig:"iconConfig",IconName:"iconName",SearchConfig:"searchConfig",Position:"position",ButtonStyle:"buttonStyle",Shadow:"shadow",DrawShadow:"drawShadow",JustifyContent:"justifyContent",Text:"text",Align:"align",Weight:"weight",Gap:"gap",Style:"style",TextConfig:"textConfig",Type:"type",CountdownStyle:"countdownStyle",ShowLabel:"showLabel",Layout:"layout",ElementGap:"elementGap",LabelGap:"labelGap",LabelPosition:"labelPosition",DigitStyle:"digitStyle",LabelStyle:"labelStyle",LetterSpacing:"letterSpacing",TextTransform:"textTransform",TextDecoration:"textDecoration",FontStyle:"fontStyle",FontVariant:"fontVariant",TextShadow:"textShadow",Address:"address",Zoom:"zoom",Alignment:"alignment",ZoomPreview:"zoomPreview",Images:"images",ColumnCount:"columnCount",HtmlCode:"htmlCode",BarStyle:"barStyle",CircleStyle:"circleStyle",TextStyle:"textStyle",TextBeforeStyle:"textBeforeStyle",TextAfterStyle:"textAfterStyle",ColorStyle:"colorStyle",NumberStyle:"numberStyle",NumberType:"numberType",Total:"total",PrefixNumber:"prefixNumber",SuffixNumber:"suffixNumber",NumberPosition:"numberPosition",Number:"number",TextBefore:"textBefore",TextAfter:"textAfter",Delay:"delay",ForegroundColor:"foregroundColor",StrokeSize:"strokeSize",MainColor:"mainColor",StickyTop:"stickyTop",Stores:"stores",CityId:"cityId",DistrictId:"districtId",WorkHours:"workHours",Map:"map",ShowThumbnail:"showThumbnail",Pagination:"pagination",PaginationColor:"paginationColor",PaginationDeactiveColor:"paginationDeactiveColor",NavigationColor:"navigationColor",Autoplay:"autoplay",ShowController:"showController",Loop:"loop",Crop:"crop",AllowSetupThumbnail:"allowSetupThumbnail",Title:"title",ItemKey:"itemKey",TitleStyle:"titleStyle",ContentStyle:"contentStyle",ContentAlign:"contentAlign",HeaderStyle:"headerStyle",ColumnGap:"columnGap",RowGap:"rowGap",AlignItems:"alignItems",IconStyle:"iconStyle",FormStyle:"formStyle",FlexDirection:"flexDirection",InputStyle:"inputStyle",OptionStyle:"optionStyle",ErrorStyle:"errorStyle",HiddenFields:"hiddenFields",Submits:"submits",Version:"version",Captcha:"captcha",SiteKey:"siteKey",RequestKey:"requestKey",Action:"action",ConfigStorage:"configStorage",FormConfigId:"formConfigId",Inputs:"inputs",Multiple:"multiple",Options:"options",ImageConfig:"imageConfig",Placeholder:"placeholder",PlaceholderColor:"placeholderColor",Label:"label",Required:"required",Radius:"radius",Value:"value",Image:"image",Percent:"percent",Response:"response",IsMainPopup:"isMainPopup",ShowCloseIcon:"showCloseIcon",CloseIcon:"closeIcon",ZIndex:"zIndex",MaxWidth:"maxWidth",PositionType:"positionType",Toggle:"toggle",ItemData:"itemData",Id:"id",CanvasConfig:"canvasConfig",BackgroundColors:"backgroundColors",Rotate:"rotate",SpinTrigger:"spinTrigger",Roulette:"roulette",PrizeAngle:"prizeAngle",PerpendicularPrize:"perpendicularPrize",ShowTurn:"showTurn",Prize:"prize",OutOfTurn:"outOfTurn",OutOfPrize:"outOfPrize",Custom:"custom",Key:"key",Popup:"popup",TriggerUpdate:"triggerUpdate",Tabs:"tabs",ActionButtons:"actionButtons",ActionButton:"actionButton",OrderButton:"orderButton",OrderPopupId:"orderPopupId",OrderSuccessPopupId:"orderSuccessPopupId",PopupParentType:"popupParentType",ButtonLink:"buttonLink",MenuItemId:"menuItemId",Slug:"slug",Limit:"limit",ItemSettings:"itemSettings",PriceColor:"priceColor",ResponsiveSettings:"responsiveSettings",ItemsPerRow:"itemsPerRow",CarouselSettings:"carouselSettings",GridRows:"gridRows",ArrowStyle:"arrowStyle",PaginationStyle:"paginationStyle",Interval:"interval",GridCols:"gridCols",PaginationPosition:"paginationPosition",Rewind:"rewind",PauseOnHover:"pauseOnHover",Button:"button",Items:"items",Skin:"skin",Content:"content",ImageStyle:"imageStyle",NameStyle:"nameStyle",BubbleStyle:"bubbleStyle",PageWidthType:"pageWidthType",PageMaxWidth:"pageMaxWidth",BlockType:"blockType",MenuConfig:"menuConfig",LogoConfig:"logoConfig",LanguageConfig:"languageConfig",SpacingWithMenu:"spacingWithMenu",MenuItemConfig:"menuItemConfig",Top:"top",Bottom:"bottom",Show:"show",ShowFlag:"showFlag",FlagStyle:"flagStyle",FlagSize:"flagSize",Enable:"enable",Enabled:"enabled",Horizontal:"horizontal",Vertical:"vertical",CarouselOptions:"carouselOptions",GridOptions:"gridOptions",Speed:"speed",Columns:"columns",SlidesPerView:"slidesPerView",PriceStyle:"priceStyle",VirtualRating:"virtualRating",VirtualSold:"virtualSold",VirtualSoldTitle:"virtualSoldTitle",DisplayMode:"displayMode",Rows:"rows",QRCodeStyle:"qrCodeStyle",Bordered:"bordered",CurrencyUnit:"currencyUnit",CurrencyAlignment:"currencyAlignment",HeaderBackgroundColor:"headerBackgroundColor",CategoryId:"categoryId",CategoryIds:"categoryIds",GridConfig:"gridConfig",ListConfig:"listConfig",ShowLoadMore:"showLoadMore",LoadMoreType:"loadMoreType",LoadMoreText:"loadMoreText",Row:"row",Column:"column",IsOpenNewTab:"isOpenNewTab",TitleFontSize:"titleFontSize",ShowImage:"showImage",ShowTitle:"showTitle",ShowDesc:"showDesc",ShowPublishDate:"showPublishDate",ShowCategories:"showCategories",ShowAuthor:"showAuthor",ShowButton:"showButton",DisplayConfig:"displayConfig",CategoryType:"categoryType",CategoryColor:"categoryColor",CategoryStyle:"categoryStyle",TitleLevel:"titleLevel",CssSelector:"cssSelector",CustomCss:"customCss",GameId:"gameId",RowCount:"rowCount",GameStyle:"gameStyle",PositionTurnDesc:"positionTurnDesc",HiddenConfigUrlImage:"hiddenConfigUrlImage",HiddenDelete:"hiddenDelete",HiddenPageIds:"hiddenPageIds",EmptyPrize:"emptyPrize",AssociatedContentType:"associatedContentType",AssociatedContentIdentified:"associatedContentIdentified",EntryTemplate:"entryTemplate",ImageInit:"imageInit",ImageResult:"imageResult",InputShape:"inputShape",AllowDownload:"allowDownload",CartConfig:"cartConfig",ButtonText:"buttonText",IsInitCart:"isInitCart",ShowAddToCartButton:"showAddToCartButton",AddToCartButton:"addToCartButton",EnableExtraConfig:"enableExtraConfig",Fields:"fields",IsActive:"isActive",DiscountStyle:"discountStyle",VirtualRatingStyle:"virtualRatingStyle",VirtualSoldStyle:"virtualSoldStyle",Actions:"actions",Categories:"categories",Labels:"labels",DescStyle:"descStyle",FlatFilterStyle:"flatFilterStyle",FilterType:"filterType",Skus:"skus",ProductDisplay:"productDisplay",FormFields:"formFields",PaymentMethods:"paymentMethods",IsEnabled:"isEnabled",BrandName:"brandName",DownloadButton:"downloadButton",ContinueShoppingButton:"continueShoppingButton",OrderInfoFields:"orderInfoFields",PaymentInfoFields:"paymentInfoFields",OrderFailPopupId:"OrderFailPopupId",CloseButton:"closeButton",ProductDetailPopup:"productDetailPopup",ProductDetailStyle:"productDetailStyle",DescriptionStyle:"descriptionStyle",ImageThumbnailConfig:"imageThumbnailConfig",BorderColor:"borderColor",FilterLabel:"filterLabel",ActiveStyle:"activeStyle",FilterStyle:"filterStyle",SearchName:"searchName",FilterCat:"filterCat",FilterDate:"filterDate",StartDatePlaceholder:"startDatePlaceholder",EndDatePlaceholder:"endDatePlaceholder",PDFUrl:"pdfUrl",DocumentUrl:"documentUrl",ExpandText:"expandText",CollapseText:"collapseText",DefaultDisplay:"defaultDisplay",SpacingWithContent:"spacingWithContent",ShowIcon:"showIcon",TextLevel:"textLevel",EnableMultiItemOpen:"enableMultiItemOpen",DefaultOpenKeys:"defaultOpenKeys",IgnoreHeightElements:"ignoreHeightElements",Timelines:"timelines",NodeId:"nodeId",Direction:"direction",VerticalAlign:"verticalAlign",HorizontalAlign:"horizontalAlign",ItemWidth:"itemWidth",ItemSpacing:"itemSpacing",ItemSpacingHorizontal:"itemSpacingHorizontal",ItemSpacingVertical:"itemSpacingVertical",ItemSpacingMode:"itemSpacingMode",LineStyle:"lineStyle",IsShowTitle:"isShowTitle",Sliders:"sliders",AspectRatio:"aspectRatio",PublishDateStyle:"publishDateStyle",AuthorStyle:"authorStyle",ErrorMessageConfig:"errorMessageConfig",WarningMessageConfig:"warningMessageConfig",Max:"max",Pattern:"pattern",RelatedProducts:"relatedProducts",ProductOrder:"productOrder",ProductSku:"productSku",ShowDays:"showDays",ShowHours:"showHours",ShowMinutes:"showMinutes",ShowSeconds:"showSeconds",LabelDays:"labelDays",LabelHours:"labelHours",LabelMinutes:"labelMinutes",LabelSeconds:"labelSeconds",SocialMediaConfig:"socialMediaConfig",FacebookPageEmbed:"facebookPageEmbed",FacebookPostEmbed:"facebookPostEmbed",ShowPosts:"showPosts",ShowText:"showText",FacebookLink:"facebookLink",InstagramLink:"instagramLink",TransparentMode:"transparentMode",TransparentModeCustom:"transparentModeCustom",TabTitle:"tabTitle",NumberOfComments:"numberOfComments",SharePage:"sharePage",CustomShareUrl:"customShareUrl",CustomText:"customText",RelatedProductsTitle:"relatedProductsTitle",ShippingInfoTitle:"shippingInfoTitle",ProductInfoTitle:"productInfoTitle",TotalPaymentText:"totalPaymentText",PaymentMethodTitle:"paymentMethodTitle",PaymentMethodDescription:"paymentMethodDescription",OrderNote:"orderNote",DeliveryInfoTitle:"deliveryInfoTitle",CustomOrderText:"customOrderText",CustomBankInfoText:"customBankInfoText",CustomProductInfoText:"customProductInfoText",OrderIdText:"orderIdText",OrderDateText:"orderDateText",OrderPriceText:"orderPriceText",OrderPaymentMethodText:"orderPaymentMethodText",BankTransferNote:"bankTransferNote",BankNameText:"bankNameText",BankAccountNameText:"bankAccountNameText",BankAccountNumberText:"bankAccountNumberText",BankTransferDescriptionText:"bankTransferDescriptionText",Animation:"animation",AnimationSpreadPadding:"animationSpreadPadding",AnimationVibrateConfig:"animationVibrateConfig",BackgroundType:"backgroundType",GiftNameStyle:"giftNameStyle",SpinCountStyle:"spinCountStyle",TransparentModeConfig:"transparentModeConfig",MenuItemColor:"menuItemColor",MenuItemHoverColor:"menuItemHoverColor",SearchIconColor:"searchIconColor",CartIconColor:"cartIconColor",IsMatchAllCategories:"isMatchAllCategories",NoArticleDescription:"noArticleDescription",LoadingDescription:"loadingDescription",CurrentParagraphTheme:"currentParagraphTheme",BackgroundText:"backgroundText",On:"on",ThreeLevelMenuLayout:"threeLevelMenuLayout",ZoomHover:"zoomHover",PublishDateDisplayType:"publishDateDisplayType",PublishDateCardStyle:"publishDateCardStyle",CardStyle:"cardStyle",MappingColTitle:"mappingColTitle",ArticleHeaderStyle:"articleHeaderStyle",DisplayedRowCount:"displayedRowCount",OddRowBackgroundColor:"oddRowBackgroundColor",EvenRowBackgroundColor:"evenRowBackgroundColor",TableBorderColor:"tableBorderColor",SpaceBetween:"spaceBetween",WaveFormType:"waveFormType",ShowWaveForm:"showWaveForm",ShowVolume:"showVolume",ShowProgressBar:"showProgressBar",ShowSpeed:"showSpeed",ShowDuration:"showDuration",TableHeaderStyle:"tableHeaderStyle",EmptyPrizeConfig:"emptyPrizeConfig",BackCardStyle:"backCardStyle",MainGameStyle:"mainGameStyle",DisableFlipAnimation:"disableFlipAnimation",AnimationConfig:"animationConfig",TotalFrame:"totalFrame",FrameShowPopup:"frameShowPopup",WrapperStyle:"wrapperStyle",ImageMode:"imageMode",AnimationType:"animationType",BypassShowParticipantForm:"bypassShowParticipantForm",LineClamp:"lineClamp",EnableMobileTableCardView:"enableMobileTableCardView",PaginationActiveColor:"paginationActiveColor",Notifications:"notifications",DisplayDuration:"displayDuration",SlotCount:"slotCount"}));exports.PROP_KEY=s;


/***/ }),

/***/ 698636:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(212951),t=__webpack_require__(85097);function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var n=o(r),i=Object.defineProperty,a=Object.defineProperties,l=Object.getOwnPropertyDescriptors,s=Object.getOwnPropertySymbols,u=Object.prototype.hasOwnProperty,c=Object.prototype.propertyIsEnumerable,d=(e,r,t)=>r in e?i(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,p=(e,r)=>{for(var t in r||(r={}))u.call(r,t)&&d(e,t,r[t]);if(s)for(var t of s(r))c.call(r,t)&&d(e,t,r[t]);return e},f=(e,r)=>a(e,l(r));const b=n.default.div((()=>"\n  position: absolute;\n  z-index: 0;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  overflow: hidden;\n")),g=({styles:r,uniqId:o})=>{const{backgroundImage:n,bgImageWidth:i,backgroundPosition:a,defaultOverlay:l}=r,s={width:"100%",height:"100%"};if(!n)return null;const u=o?{"data-uniq-id":`background-${o}`}:{};return e.jsx(b,f(p({},u),{children:e.jsx(t.ImageBase,{src:n,googleImageParams:{width:i},isPreview:!1,isLinkConfig:!1,imageWrapperStyle:s,fetchPriority:"high",commonStyle:f(p({},s),{objectPosition:a,defaultOverlay:l})})}))};exports.BackgroundImage=g,exports["default"]=g;


/***/ }),

/***/ 825926:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),i=__webpack_require__(85097),r=__webpack_require__(877084),l=__webpack_require__(586753),o=__webpack_require__(840424);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=n(t),c=n(r),d=Object.defineProperty,s=Object.defineProperties,p=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,f=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,y=(e,t,i)=>t in e?d(e,t,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[t]=i,x=(e,t)=>{for(var i in t||(t={}))f.call(t,i)&&y(e,i,t[i]);if(u)for(var i of u(t))m.call(t,i)&&y(e,i,t[i]);return e},b=(e,t)=>s(e,p(t)),v=(e,t)=>{var i={};for(var r in e)f.call(e,r)&&t.indexOf(r)<0&&(i[r]=e[r]);if(null!=e&&u)for(var r of u(e))t.indexOf(r)<0&&m.call(e,r)&&(i[r]=e[r]);return i};const h=a.default.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: transparent;
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  ${e=>i.getStyle(e.cardStyle)}
`,g=a.default.div`
  position: relative;
  flex: 1 0 auto;

  &.allow-click {
    &:hover {
      cursor: pointer;
    }
  }
`,j=a.default.div`
  position: relative;
  margin-bottom: 4px;
`,w=a.default(l.Image)`
  display: inline-block;
  overflow: hidden;
  position: absolute;
  height: 100%;
  inset: 0;
`,S=a.default.div`
  &.detail-card.left {
    text-align: left;
  }
  &.detail-card.center {
    text-align: center;
  }
  &.detail-card.right {
    text-align: right;
  }
  ${e=>i.getStyle(null==e?void 0:e.commonStyle)}
`,k=a.default(o.Paragraph)`
  font-size: 14px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: #000000;
  font-weight: 700;
  ${e=>i.getStyle(null==e?void 0:e.commonStyle)}
`;exports.CardDetail=t=>{var r=t,{onClick:l,isEditingMode:o,isVisualCard:n,extraElement:a,contentStyle:d}=r,s=v(r,["onClick","isEditingMode","isVisualCard","extraElement","contentStyle"]);const{imageStyle:p,image:u,link:f,alignment:m,nameStyle:y,name:O,cardStyle:P}=s,q=p||{},{aspectRatio:C="1 / 1",objectFit:E="cover"}=q,N=v(q,["aspectRatio","objectFit"]),T="function"==typeof l,_=e.jsx(j,{children:e.jsx("div",{style:{position:"relative",aspectRatio:C},children:e.jsx(w,x({commonStyle:x({objectFit:E,height:"100%",width:"100%"},N),autoOptimize:!0},u))})}),F=()=>e.jsxs(g,{className:c.default({"allow-click":T}),children:[n?_:e.jsx(i.Link,b(x({},{eventType:"link",link:{openNewTab:!0,nofollow:!0,href:f}}),{children:_})),e.jsxs(S,{commonStyle:d,className:c.default("detail-card",m),children:[e.jsx(k,{className:"detail-card__name",text:O,commonStyle:y}),a]})]});return n?e.jsx(h,{cardStyle:P,children:F()}):T?e.jsx(h,{cardStyle:P,onClick:()=>{T&&l(s)},children:F()}):e.jsx(i.Link,b(x({},{eventType:"link",link:{openNewTab:!0,nofollow:!0,href:f}}),{children:e.jsx(h,{cardStyle:P,children:F()})}))};


/***/ }),

/***/ 234388:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=(e=>(e.All="ALL",e.Pagination="PAGINATION",e))(e||{});exports.DisplayModeType=e;


/***/ }),

/***/ 335417:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var e=__webpack_require__(561261),t=__webpack_require__(891987),i=__webpack_require__(200448),a=__webpack_require__(836544),s=__webpack_require__(574511),n=__webpack_require__(40314),r=__webpack_require__(567966),l=__webpack_require__(539789),o=__webpack_require__(699799),p=__webpack_require__(212951);function d(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}function c(e){if(e&&e.__esModule)return e;var t=Object.create(null);return e&&Object.keys(e).forEach((function(i){if("default"!==i){var a=Object.getOwnPropertyDescriptor(e,i);Object.defineProperty(t,i,a.get?a:{enumerable:!0,get:function(){return e[i]}})}})),t.default=e,Object.freeze(t)}var u=c(t),h=d(i),m=d(a),f=d(s),g=d(n),b=d(p),v=Object.defineProperty,y=Object.defineProperties,C=Object.getOwnPropertyDescriptors,N=Object.getOwnPropertySymbols,k=Object.prototype.hasOwnProperty,P=Object.prototype.propertyIsEnumerable,w=(e,t,i)=>t in e?v(e,t,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[t]=i,x=(e,t)=>{for(var i in t||(t={}))k.call(t,i)&&w(e,i,t[i]);if(N)for(var i of N(t))P.call(t,i)&&w(e,i,t[i]);return e},V=(e,t)=>y(e,C(t));class O extends u.Component{constructor(e){super(e),this.setPopupVisible=e=>{const{value:t}=this.state;"popupVisible"in this.props||this.setState({popupVisible:e}),e&&!this.state.popupVisible&&this.setState({activeValue:t}),this.props.onPopupVisibleChange(e)},this.handleChange=(e,{visible:t},i)=>{"keydown"===i.type&&i.keyCode!==f.default.ENTER||(this.props.onChange(e.map((e=>e[this.getFieldName("value")])),e),this.setPopupVisible(t))},this.handlePopupVisibleChange=e=>{this.setPopupVisible(e)},this.handleMenuSelect=(e,t,i)=>{const a=this.trigger.getRootDomNode();a&&a.focus&&a.focus();const{changeOnSelect:s,loadData:n,expandTrigger:r}=this.props;if(!e||e.disabled)return;let{activeValue:l}=this.state;l=l.slice(0,t+1),l[t]=e[this.getFieldName("value")];const o=this.getActiveOptions(l);if(!1===e.isLeaf&&!e[this.getFieldName("children")]&&n)return s&&this.handleChange(o,{visible:!0},i),this.setState({activeValue:l}),void n(o);const p={};e[this.getFieldName("children")]&&e[this.getFieldName("children")].length?!s||"click"!==i.type&&"keydown"!==i.type||("hover"===r?this.handleChange(o,{visible:!1},i):this.handleChange(o,{visible:!0},i),p.value=l):(this.handleChange(o,{visible:!1},i),p.value=l),p.activeValue=l,("value"in this.props||"keydown"===i.type&&i.keyCode!==f.default.ENTER)&&delete p.value,this.setState(p)},this.handleItemDoubleClick=()=>{const{changeOnSelect:e}=this.props;e&&this.setPopupVisible(!1)},this.handleKeyDown=e=>{const{children:t}=this.props;if(t&&t.props.onKeyDown)return void t.props.onKeyDown(e);const i=[...this.state.activeValue],a=i.length-1<0?0:i.length-1,s=this.getCurrentLevelOptions(),n=s.map((e=>e[this.getFieldName("value")])).indexOf(i[a]);if(e.keyCode!==f.default.DOWN&&e.keyCode!==f.default.UP&&e.keyCode!==f.default.LEFT&&e.keyCode!==f.default.RIGHT&&e.keyCode!==f.default.ENTER&&e.keyCode!==f.default.SPACE&&e.keyCode!==f.default.BACKSPACE&&e.keyCode!==f.default.ESC&&e.keyCode!==f.default.TAB)return;if(!this.state.popupVisible&&e.keyCode!==f.default.BACKSPACE&&e.keyCode!==f.default.LEFT&&e.keyCode!==f.default.RIGHT&&e.keyCode!==f.default.ESC&&e.keyCode!==f.default.TAB)return this.setPopupVisible(!0),void(this.props.onKeyDown&&this.props.onKeyDown(e));if(e.keyCode===f.default.DOWN||e.keyCode===f.default.UP){e.preventDefault();let t=n;-1!==t?e.keyCode===f.default.DOWN?(t+=1,t=t>=s.length?0:t):(t-=1,t=t<0?s.length-1:t):t=0,i[a]=s[t][this.getFieldName("value")]}else if(e.keyCode===f.default.LEFT||e.keyCode===f.default.BACKSPACE)e.preventDefault(),i.splice(i.length-1,1);else if(e.keyCode===f.default.RIGHT)e.preventDefault(),s[n]&&s[n][this.getFieldName("children")]&&i.push(s[n][this.getFieldName("children")][0][this.getFieldName("value")]);else if(e.keyCode===f.default.ESC||e.keyCode===f.default.TAB)return this.setPopupVisible(!1),void(this.props.onKeyDown&&this.props.onKeyDown(e));i&&0!==i.length||this.setPopupVisible(!1);const r=this.getActiveOptions(i),l=r[r.length-1];this.handleMenuSelect(l,r.length-1,e),this.props.onKeyDown&&this.props.onKeyDown(e)},this.saveTrigger=e=>{this.trigger=e};let t=[];"value"in e?t=e.value||[]:"defaultValue"in e&&(t=e.defaultValue||[]),m.default(!("filedNames"in e),"`filedNames` of Cascader is a typo usage and deprecated, please use `fieldNames` instead."),this.state={popupVisible:e.popupVisible,activeValue:t,value:t,prevProps:e},this.defaultFieldNames={label:"label",value:"value",children:"children"}}static getDerivedStateFromProps(e,t){const{prevProps:i={}}=t,a={prevProps:e};return"value"in e&&!r.isEqualArrays(i.value,e.value)&&(a.value=e.value||[],"loadData"in e||(a.activeValue=e.value||[])),"popupVisible"in e&&(a.popupVisible=e.popupVisible),a}getPopupDOMNode(){return this.trigger.getPopupDomNode()}getFieldName(e){const{defaultFieldNames:t}=this,{fieldNames:i,filedNames:a}=this.props;return"filedNames"in this.props?a[e]||t[e]:i[e]||t[e]}getFieldNames(){const{fieldNames:e,filedNames:t}=this.props;return"filedNames"in this.props?t:e}getCurrentLevelOptions(){const{options:e=[]}=this.props,{activeValue:t=[]}=this.state,i=g.default(e,((e,i)=>e[this.getFieldName("value")]===t[i]),{childrenKeyName:this.getFieldName("children")});return i[i.length-2]?i[i.length-2][this.getFieldName("children")]:[...e].filter((e=>!e.disabled))}getActiveOptions(e){return g.default(this.props.options||[],((t,i)=>t[this.getFieldName("value")]===e[i]),{childrenKeyName:this.getFieldName("children")})}render(){const t=this.props,{prefixCls:i,transitionName:a,popupClassName:s,options:n=[],disabled:r,builtinPlacements:l,popupPlacement:o,children:p,dropdownRender:d}=t,c=((e,t)=>{var i={};for(var a in e)k.call(e,a)&&t.indexOf(a)<0&&(i[a]=e[a]);if(null!=e&&N)for(var a of N(e))t.indexOf(a)<0&&P.call(e,a)&&(i[a]=e[a]);return i})(t,["prefixCls","transitionName","popupClassName","options","disabled","builtinPlacements","popupPlacement","children","dropdownRender"]);let m=e.jsx("div",{}),f="";n&&n.length>0?m=e.jsx(S,V(x({},this.props),{fieldNames:this.getFieldNames(),defaultFieldNames:this.defaultFieldNames,activeValue:this.state.activeValue,onSelect:this.handleMenuSelect,onItemDoubleClick:this.handleItemDoubleClick,visible:this.state.popupVisible})):f=` ${i}-menus-empty`;let g=m;return d&&(g=d(m)),e.jsx(h.default,V(x({ref:this.saveTrigger},c),{popupPlacement:o,builtinPlacements:l,popupTransitionName:a,action:r?[]:["click"],popupVisible:!r&&this.state.popupVisible,onPopupVisibleChange:this.handlePopupVisibleChange,prefixCls:`${i}-menus`,popupClassName:s+f,popup:g,children:u.cloneElement(p,{onKeyDown:this.handleKeyDown,tabIndex:r?void 0:0})}))}}O.defaultProps={onChange:()=>{},onPopupVisibleChange:()=>{},disabled:!1,transitionName:"",prefixCls:"rc-cascader",popupClassName:"",popupPlacement:"bottomLeft",builtinPlacements:o,expandTrigger:"click",fieldNames:{label:"label",value:"value",children:"children"},expandIcon:">"};var D=O;const S=b.default(l)`
  .rc-cascader {
    font-size: 12px;
  }
  .rc-cascader-menus {
    font-size: 12px;
    overflow: hidden;
    background: #fff;
    position: absolute;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.17);
    white-space: nowrap;
  }
  .rc-cascader-menus-hidden {
    display: none;
  }
  .rc-cascader-menus.slide-up-enter,
  .rc-cascader-menus.slide-up-appear {
    animation-duration: 0.3s;
    animation-fill-mode: both;
    transform-origin: 0 0;
    opacity: 0;
    animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
    animation-play-state: paused;
  }
  .rc-cascader-menus.slide-up-leave {
    animation-duration: 0.3s;
    animation-fill-mode: both;
    transform-origin: 0 0;
    opacity: 1;
    animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
    animation-play-state: paused;
  }
  .rc-cascader-menus.slide-up-enter.slide-up-enter-active.rc-cascader-menus-placement-bottomLeft,
  .rc-cascader-menus.slide-up-appear.slide-up-appear-active.rc-cascader-menus-placement-bottomLeft {
    animation-name: SlideUpIn;
    animation-play-state: running;
  }
  .rc-cascader-menus.slide-up-enter.slide-up-enter-active.rc-cascader-menus-placement-topLeft,
  .rc-cascader-menus.slide-up-appear.slide-up-appear-active.rc-cascader-menus-placement-topLeft {
    animation-name: SlideDownIn;
    animation-play-state: running;
  }
  .rc-cascader-menus.slide-up-leave.slide-up-leave-active.rc-cascader-menus-placement-bottomLeft {
    animation-name: SlideUpOut;
    animation-play-state: running;
  }
  .rc-cascader-menus.slide-up-leave.slide-up-leave-active.rc-cascader-menus-placement-topLeft {
    animation-name: SlideDownOut;
    animation-play-state: running;
  }
  .rc-cascader-menu {
    display: inline-block;
    width: 100px;
    height: 192px;
    list-style: none;
    margin: 0;
    padding: 0;
    border-right: 1px solid #e9e9e9;
    overflow: auto;
  }
  .rc-cascader-menu:last-child {
    border-right: 0;
  }
  .rc-cascader-menu-item {
    height: 32px;
    line-height: 32px;
    padding: 0 16px;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: all 0.3s ease;
    position: relative;
  }
  .rc-cascader-menu-item:hover {
    background: tint(#2db7f5, 90%);
  }
  .rc-cascader-menu-item-disabled {
    cursor: not-allowed;
    color: #ccc;
  }
  .rc-cascader-menu-item-disabled:hover {
    background: transparent;
  }
  .rc-cascader-menu-item-loading:after {
    position: absolute;
    right: 12px;
    content: 'loading';
    color: #aaa;
    font-style: italic;
  }
  .rc-cascader-menu-item-active {
    background: tint(#2db7f5, 80%);
  }
  .rc-cascader-menu-item-active:hover {
    background: tint(#2db7f5, 80%);
  }
  .rc-cascader-menu-item-expand {
    position: relative;
  }
  .rc-cascader-menu-item-expand-icon {
    font-size: 12px;
    color: #999;
    position: absolute;
    right: 16px;
    line-height: 32px;
  }
  @keyframes SlideUpIn {
    0% {
      opacity: 0;
      transform-origin: 0% 0%;
      transform: scaleY(0.8);
    }
    100% {
      opacity: 1;
      transform-origin: 0% 0%;
      transform: scaleY(1);
    }
  }
  @keyframes SlideUpOut {
    0% {
      opacity: 1;
      transform-origin: 0% 0%;
      transform: scaleY(1);
    }
    100% {
      opacity: 0;
      transform-origin: 0% 0%;
      transform: scaleY(0.8);
    }
  }
  @keyframes SlideDownIn {
    0% {
      opacity: 0;
      transform-origin: 0% 100%;
      transform: scaleY(0.8);
    }
    100% {
      opacity: 1;
      transform-origin: 0% 100%;
      transform: scaleY(1);
    }
  }
  @keyframes SlideDownOut {
    0% {
      opacity: 1;
      transform-origin: 0% 100%;
      transform: scaleY(1);
    }
    100% {
      opacity: 0;
      transform-origin: 0% 100%;
      transform: scaleY(0.8);
    }
  }
`;module.exports=D;


/***/ }),

/***/ 539789:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var e=__webpack_require__(561261),t=__webpack_require__(891987),i=__webpack_require__(40314);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}function s(e){if(e&&e.__esModule)return e;var t=Object.create(null);return e&&Object.keys(e).forEach((function(i){if("default"!==i){var n=Object.getOwnPropertyDescriptor(e,i);Object.defineProperty(t,i,n.get?n:{enumerable:!0,get:function(){return e[i]}})}})),t.default=e,Object.freeze(t)}var l=s(t),r=n(i),o=Object.defineProperty,a=Object.defineProperties,c=Object.getOwnPropertyDescriptors,u=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,d=Object.prototype.propertyIsEnumerable,m=(e,t,i)=>t in e?o(e,t,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[t]=i;class h extends l.Component{constructor(){super(...arguments),this.menuItems={},this.saveMenuItem=e=>t=>{this.menuItems[e]=t}}componentDidMount(){this.scrollActiveItemToView()}componentDidUpdate(e){!e.visible&&this.props.visible&&this.scrollActiveItemToView()}getFieldName(e){const{fieldNames:t,defaultFieldNames:i}=this.props;return t[e]||i[e]}getOption(t,i){const{prefixCls:n,expandTrigger:s,expandIcon:l,loadingIcon:r}=this.props,o=this.props.onSelect.bind(this,t,i);let h={onClick:o,onDoubleClick:this.props.onItemDoubleClick.bind(this,t,i)},f=`${n}-menu-item`,g=null;const v=t[this.getFieldName("children")]&&t[this.getFieldName("children")].length>0;(v||!1===t.isLeaf)&&(f+=` ${n}-menu-item-expand`,t.loading||(g=e.jsx("span",{className:`${n}-menu-item-expand-icon`,children:l}))),"hover"!==s||!v&&!1!==t.isLeaf||(h={onMouseEnter:this.delayOnSelect.bind(this,o),onMouseLeave:this.delayOnSelect.bind(this),onClick:o}),this.isActiveOption(t,i)&&(f+=` ${n}-menu-item-active`,h.ref=this.saveMenuItem(i)),t.disabled&&(f+=` ${n}-menu-item-disabled`);let b=null;t.loading&&(f+=` ${n}-menu-item-loading`,b=r||null);let O="";return"title"in t?O=t.title:"string"==typeof t[this.getFieldName("label")]&&(O=t[this.getFieldName("label")]),e.jsxs("li",(y=((e,t)=>{for(var i in t||(t={}))p.call(t,i)&&m(e,i,t[i]);if(u)for(var i of u(t))d.call(t,i)&&m(e,i,t[i]);return e})({className:f,title:O},h),j={role:"menuitem",onMouseDown:e=>e.preventDefault(),children:[t[this.getFieldName("label")],g,b]},a(y,c(j))),t[this.getFieldName("value")]);var y,j}getActiveOptions(e){const{options:t}=this.props,i=e||this.props.activeValue;return r.default(t,((e,t)=>e[this.getFieldName("value")]===i[t]),{childrenKeyName:this.getFieldName("children")})}getShowOptions(){const{options:e}=this.props,t=this.getActiveOptions().map((e=>e[this.getFieldName("children")])).filter((e=>!!e));return t.unshift(e),t}delayOnSelect(e,...t){this.delayTimer&&(clearTimeout(this.delayTimer),this.delayTimer=null),"function"==typeof e&&(this.delayTimer=window.setTimeout((()=>{e(t),this.delayTimer=null}),150))}scrollActiveItemToView(){const e=this.getShowOptions().length;for(let t=0;t<e;t++){const e=this.menuItems[t];e&&e.parentElement&&(e.parentElement.scrollTop=e.offsetTop)}}isActiveOption(e,t){const{activeValue:i=[]}=this.props;return i[t]===e[this.getFieldName("value")]}render(){const{prefixCls:t,dropdownMenuColumnStyle:i}=this.props;return e.jsx("div",{children:this.getShowOptions().map(((n,s)=>e.jsx("ul",{className:`${t}-menu`,style:i,children:n.map((e=>this.getOption(e,s)))},s)))})}}h.defaultProps={options:[],value:[],activeValue:[],onSelect(){},prefixCls:"rc-cascader-menus",visible:!1,expandTrigger:"click"};var f=h;module.exports=f;


/***/ }),

/***/ 699799:
/***/ (function(module) {

module.exports={bottomLeft:{points:["tl","bl"],offset:[0,4],overflow:{adjustX:1,adjustY:1}},topLeft:{points:["bl","tl"],offset:[0,-4],overflow:{adjustX:1,adjustY:1}},bottomRight:{points:["tr","br"],offset:[0,4],overflow:{adjustX:1,adjustY:1}},topRight:{points:["br","tr"],offset:[0,-4],overflow:{adjustX:1,adjustY:1}}};


/***/ }),

/***/ 567966:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.isEqualArrays=function(e,r){if(e===r)return!0;if(!e||!r)return!1;const t=e.length;if(r.length!==t)return!1;for(let n=0;n<t;n++)if(e[n]!==r[n])return!1;return!0};


/***/ }),

/***/ 672158:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(891987),t=__webpack_require__(85097),i=__webpack_require__(212951),a=__webpack_require__(879774);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var o=n(r),l=n(i),d=Object.defineProperty,u=Object.defineProperties,c=Object.getOwnPropertyDescriptors,f=Object.getOwnPropertySymbols,s=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,m=(e,r,t)=>r in e?d(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;const b=l.default.div`
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  position: relative;
  @media (min-width: ${a.BREAK_POINTS.xl}) {
    max-width: ${e=>e.fluid?"100%":t.unitParse(e.maxWidth)};
  }
`,O=o.default.forwardRef(((r,t)=>{const i=r,{children:a,fluid:n=!1,maxWidth:o=1232}=i,l=((e,r)=>{var t={};for(var i in e)s.call(e,i)&&r.indexOf(i)<0&&(t[i]=e[i]);if(null!=e&&f)for(var i of f(e))r.indexOf(i)<0&&p.call(e,i)&&(t[i]=e[i]);return t})(i,["children","fluid","maxWidth"]);return e.jsx(b,(d=((e,r)=>{for(var t in r||(r={}))s.call(r,t)&&m(e,t,r[t]);if(f)for(var t of f(r))p.call(r,t)&&m(e,t,r[t]);return e})({"data-selector-name":"section-container",maxWidth:o,fluid:n,ref:t},l),u(d,c({children:a}))));var d}));O.displayName="Container",exports.Container=O;


/***/ }),

/***/ 282004:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(85097),i=__webpack_require__(212951),n=__webpack_require__(282384);function t(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=t(i),a=Object.defineProperty,o=Object.defineProperties,l=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,g=Object.prototype.hasOwnProperty,v=Object.prototype.propertyIsEnumerable,p=(e,r,i)=>r in e?a(e,r,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[r]=i;const s=r=>{var i,t=r,{width:d="100%",height:a="1px",color:s="black",dividerStyle:f=n.DividerStyleEnum.solid,align:y,gap:w,alignContent:m,spacingContent:x,children:$}=t,j=((e,r)=>{var i={};for(var n in e)g.call(e,n)&&r.indexOf(n)<0&&(i[n]=e[n]);if(null!=e&&c)for(var n of c(e))r.indexOf(n)<0&&v.call(e,n)&&(i[n]=e[n]);return i})(t,["width","height","color","dividerStyle","align","gap","alignContent","spacingContent","children"]);return e.jsx(u,(i=((e,r)=>{for(var i in r||(r={}))g.call(r,i)&&p(e,i,r[i]);if(c)for(var i of c(r))v.call(r,i)&&p(e,i,r[i]);return e})({},j),o(i,l({gap:w,children:$?e.jsx(b,{width:d,weight:a,dividerStyle:f,color:s,align:y,alignContent:m,spacingContent:x,children:e.jsx("span",{children:$})}):e.jsx(h,{width:d,weight:a,dividerStyle:f,color:s,align:y})}))))},u=d.default.div((({gap:e})=>`\n  --divider-gap: ${r.unitParse(e)||"12px"};\n  display: flex;\n  padding-top: var(--divider-gap);\n  padding-bottom: var(--divider-gap);\n`)),f=e=>{switch(e){case r.Alignment.center:return"margin: 0 auto;";case r.Alignment.right:return"\n        margin: 0 auto;\n        margin-right: 0;\n      ";default:return""}},h=d.default.div((({width:e,weight:r,dividerStyle:i,color:n,align:t})=>`\n  --divider-border-style: ${i};\n  --divider-color: ${n||"#000000"};\n  --divider-border-width: ${r||"1px"};\n  display: flex;\n  width: ${e||"100%"};\n  border-top: var(--divider-border-width) var(--divider-border-style) var(--divider-color);\n  ${f(t)}\n`)),b=d.default.div((({width:e,weight:i,dividerStyle:n,color:t="black",align:d,alignContent:a,spacingContent:o})=>`\n  --divider-border-style: ${n};\n  --divider-color: ${t};\n  --divider-border-width: ${i||"1px"};\n  --divider-content-spacing: ${o||"10px"};\n  display: flex;\n  align-items: center;\n  width: ${e||"100%"};\n  ${f(d)}\n  ${(e=>{const i='{\n    display: block;\n    content: "";\n    border-bottom: 0;\n    flex-grow: 1;\n    border-top: var(--divider-border-width) var(--divider-border-style) var(--divider-color);\n  }';switch(e){case r.Alignment.left:return`\n          &:after ${i}\n        `;case r.Alignment.right:return`\n          &:before ${i}\n        `;default:return`\n          &:after, &:before ${i}\n        `}})(a)}\n\n  > span {\n    margin: 0 var(--divider-content-spacing);\n    margin-left: ${"left"===a?"0":"var(--divider-content-spacing)"};\n    margin-right: ${"right"===a?"0":"var(--divider-content-spacing)"};\n  }\n`));s.displayName="Divider",exports.Divider=s;


/***/ }),

/***/ 115741:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),n=__webpack_require__(212951),i=__webpack_require__(85097),t=__webpack_require__(891987),r=__webpack_require__(406968),o=__webpack_require__(844221),a=__webpack_require__(726438);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=l(n),p=l(a),u=Object.defineProperty,d=Object.defineProperties,c=Object.getOwnPropertyDescriptors,g=Object.getOwnPropertySymbols,w=Object.prototype.hasOwnProperty,h=Object.prototype.propertyIsEnumerable,m=(e,n,i)=>n in e?u(e,n,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[n]=i,b=(e,n)=>{for(var i in n||(n={}))w.call(n,i)&&m(e,i,n[i]);if(g)for(var i of g(n))h.call(n,i)&&m(e,i,n[i]);return e};p.default.use([a.Navigation,a.Pagination,a.Thumbs,a.Autoplay,a.Virtual]);const f=s.default.div((({isMultipleRows:e,paginationStyle:n,paginationColor:t,paginationPosition:r,paginationDeactiveColor:a,navigationStyle:l,navigationColor:s,commonStyle:p,slidesPerView:u=1,slidesPerColumn:d=1,itemsCount:c,spaceBetween:g=10})=>{var w;const h="undefined"==typeof window;let m,b,f;return h&&(m=Math.ceil(c/d),b=m/u*100+"%",f=`calc(100% / ${m} - ${g*(m-1)/m}px)`),`\n    .swiper-container {\n      margin-left: auto;\n      margin-right: auto;\n      position: relative;\n      overflow: hidden;\n      list-style: none;\n      padding: 0;\n      ${n&&"outside"===r?"padding-bottom: 3em;":""}\n    }\n    .swiper-wrapper {\n      position: relative;\n      height: 100%;\n      display: flex;\n      transition-property: transform;\n      box-sizing: content-box;\n      flex-wrap: ${e?"wrap":"nowrap"};\n      // Chỉ có tác dụng ở SSR, khi về CSR thư viện swiper sẽ tự động override css này bằng pixel\n      ${h?`width: ${b}`:""}\n    }\n    .swiper-slide {\n      flex-shrink: 0;\n      position: relative;\n      border-radius: ${i.unitParse(null!=(w=null==p?void 0:p.borderRadius)?w:0,i.UnitEnum.percent)};\n      overflow: hidden;\n      transition-property: transform;\n      ${e?"margin-top: 0px !important":""};\n      // Chỉ có tác dụng ở SSR, khi về CSR thư viện swiper sẽ tự động override css này bằng pixel\n      ${h?`width: ${f};\n            margin-right: ${g}px;`:""}\n    }\n    &:hover {\n      .swiper-button-next,\n      .swiper-button-prev {\n        opacity: 1;\n        &.swiper-button-disabled {\n          opacity: 0.35;\n        }\n      }\n    }\n    .swiper-pagination {\n      position: absolute;\n      text-align: center;\n      transform: translate3d(0, 0, 0);\n      z-index: 10;\n    }\n    .swiper-pagination-fraction {\n      bottom: 0;\n      left: 0;\n      width: 100%;\n    }\n    .swiper-pagination-bullets {\n      bottom: 10px;\n      left: 0;\n      width: 100%;\n    }\n    ${n?o.renderPaginationStyle(n,t,a):""}\n    .swiper-button-prev,\n    .swiper-button-next {\n      position: absolute;\n      top: 50%;\n      z-index: 10;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 44px;\n      height: 44px;\n      margin-top: -22px;\n      opacity: 0;\n      &.swiper-button-disabled {\n        opacity: 0;\n        cursor: auto;\n        pointer-events: auto;\n      }\n    }\n    .swiper-thumbnail {\n      padding-top: 10px;\n\n      &.swiper-thumbnail__left {\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n      }\n\n      &.swiper-thumbnail__center {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n\n      &.swiper-thumbnail__right {\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n      }\n\n      .swiper-slide {\n        width: 80px !important;\n        height: 80px;\n        cursor: pointer;\n\n        img {\n          width: 80px;\n          height: 80px;\n        }\n\n        &.swiper-slide-thumb-active::after {\n          background: transparent;\n        }\n\n        &::after {\n          content: "";\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 100%;\n          height: 100%;\n          background: rgba(0,0,0,.5);\n        }\n      }\n    }\n    ${i.getStyle(p)}\n    ${l?o.renderSwipeButton(l,s):""}\n`}));exports.DSSlider=n=>{var i=n,{className:o,children:a,paginationStyle:l,navigationStyle:s,speed:p=3e3,pauseOnMouseEnter:u=!0,paginationColor:m,virtual:v,paginationPosition:y="inside",paginationDeactiveColor:x,commonStyle:S,slidesPerViewMobile:P,navigationColor:C}=i,j=((e,n)=>{var i={};for(var t in e)w.call(e,t)&&n.indexOf(t)<0&&(i[t]=e[t]);if(null!=e&&g)for(var t of g(e))n.indexOf(t)<0&&h.call(e,t)&&(i[t]=e[t]);return i})(i,["className","children","paginationStyle","navigationStyle","speed","pauseOnMouseEnter","paginationColor","virtual","paginationPosition","paginationDeactiveColor","commonStyle","slidesPerViewMobile","navigationColor"]);const{slidesPerView:$,slidesPerColumn:O,pagination:M,autoplay:T,loop:_,showThumbnail:k,alignThumbnail:V}=j,[R,q]=t.useState(0);let B;const[D,E]=t.useState(null),I=t.useRef(null),N=O&&O>1;M&&(j.pagination={clickable:!0}),N&&(j.loop=!1),T&&(j.autoplay={delay:p,disableOnInteraction:!1,pauseOnMouseEnter:u}),P&&(B={320:{slidesPerView:P,slidesPerGroup:Math.floor(P)},640:{slidesPerView:$,slidesPerGroup:Math.floor($)}}),t.useEffect((()=>{q((e=>e+1))}),[k,T,_,p,u,v,O]);return e.jsxs(f,{className:o,paginationStyle:l,navigationStyle:s,isMultipleRows:N,paginationColor:m,paginationDeactiveColor:x,navigationColor:C,paginationPosition:y,commonStyle:S,slidesPerView:$,slidesPerColumn:O,itemsCount:t.Children.toArray(a).length,spaceBetween:null==j?void 0:j.spaceBetween,children:[e.jsx(r.Swiper,(z=b({onInit:e=>{I.current=e.el},breakpoints:B,slidesPerGroup:Math.floor($)},j),A={thumbs:{swiper:D&&!D.destroyed?D:null,multipleActiveThumbs:!1},virtual:!(!v||!$)&&{addSlidesBefore:2},resizeObserver:!0,slidesPerColumnFill:"row",onActiveIndexChange:({activeIndex:e})=>{setTimeout((()=>{null==D||D.slideTo(e)}),0)},children:t.Children.map(a,((n,i)=>e.jsx(r.SwiperSlide,{virtualIndex:i,children:n},`slide-${i}`)))},d(z,c(A))),`swiper-${R}`),k&&e.jsx(r.Swiper,{className:"swiper-thumbnail "+(V?`swiper-thumbnail__${V}`:""),onSwiper:E,spaceBetween:10,slidesPerView:"auto",watchSlidesProgress:!0,slideToClickedSlide:!0,simulateTouch:!1,virtual:!1,children:t.Children.map(a,((n,i)=>e.jsx(r.SwiperSlide,{onClick:()=>{(e=>{var n,i;null==(i=null==(n=I.current)?void 0:n.swiper)||i.slideTo(e)})(_?i+1:i),null==D||D.slideTo(i)},children:n},`thumb-${i}`)))})]});var z,A};


/***/ }),

/***/ 844221:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.renderPaginationStyle=(n,i,a)=>n>0?[`.swiper-pagination-bullet {\n      width: 8px;\n      height: 8px;\n      display: inline-block;\n      border-radius: 100%;\n      background: ${a};\n      margin: 0 4px;\n      cursor: pointer;\n    }\n    .swiper-pagination-bullet-active {\n      background: ${i};\n      border-radius: 0.75rem;\n    }`,`.swiper-pagination-bullet {\n      width: 8px;\n      height: 8px;\n      display: inline-block;\n      border-radius: 100%;\n      background:${a};\n      margin: 0 4px;\n      cursor: pointer;\n    }\n    .swiper-pagination-bullet-active {\n      background: ${i};\n      border-radius: 0.75rem;\n      width: 24px;\n    }`,`.swiper-pagination-bullet {\n      width: 8px;\n      height: 8px;\n      display: inline-block;\n      background:${a};\n      cursor: pointer;\n      &:first-of-type {\n        border-radius: 999px 0 0 999px;\n      };\n      &:last-of-type {\n        border-radius: 0 999px 999px 0;\n      }\n    }\n    .swiper-pagination-bullet-active {\n      width: 24px;\n      position: relative;\n      &:after {\n        content: "";\n        border-radius: 999px;\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background-color: ${i};\n      }\n    }`,`.swiper-pagination-bullet {\n      width: 8px;\n      height: 8px;\n      display: inline-block;\n      border-radius: 100%;\n      background: ${a};\n      margin: 0 4px;\n      cursor: pointer;\n    }\n    .swiper-pagination-bullet-active {\n      background: ${i};\n      border-radius: 0.75rem;\n      width: 12px;\n      height: 12px;\n      border-radius: 50%;\n      transform: translateY(2px);\n    }`][n-1]:null,exports.renderSwipeButton=(n,i)=>n>0?[`.swiper-button-next {\n      right: 0;\n      left: auto;\n      border-top-left-radius: 100px;\n      border-bottom-left-radius: 100px;\n      background-color: rgba(168, 168, 168, 0.46);\n      &:after {\n        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');\n        content: ' ';\n        height: 30px;\n        width: 30px;\n        mask-size: contain;\n        display: inline-block;\n        background: ${i||"#333"};\n      }\n    }\n    .swiper-button-prev {\n      left: 0;\n      right: auto;\n      border-top-right-radius: 100px;\n      border-bottom-right-radius: 100px;\n      background-color: rgba(168, 168, 168, 0.46);\n      &:after {\n        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');\n        content: ' ';\n        height: 30px;\n        width: 30px;\n        mask-size: contain;\n        display: inline-block;\n        background: ${i||"#333"};\n      }\n    }`,`.swiper-button-next {\n      right: 0;\n      left: auto;\n      border-radius: 50%;\n      background-color: rgba(168, 168, 168, 0.46);\n      margin-right: 0.5rem;\n      &:after {\n        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');\n        content: ' ';\n        height: 30px;\n        width: 30px;\n        mask-size: contain;\n        display: inline-block;\n        background: ${i||"#333"};\n      }\n    }\n    .swiper-button-prev {\n      left: 0;\n      right: auto;\n      border-radius: 50%;\n      background-color: rgba(168, 168, 168, 0.46);\n      margin-left: 1rem;\n      &:after {\n        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');\n        content: ' ';\n        height: 30px;\n        width: 30px;\n        mask-size: contain;\n        display: inline-block;\n        background: ${i||"#333"};\n      }\n    }`,`.swiper-button-next {\n      right: 0;\n      left: auto;\n      background-color: transparent;\n      &:after {\n        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');\n        content: ' ';\n        height: 30px;\n        width: 30px;\n        mask-size: contain;\n        display: inline-block;\n        background: ${i||"#333"};\n      }\n    }\n    .swiper-button-prev {\n      left: 0;\n      right: auto;\n      background-color: transparent;\n      &:after {\n        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');\n        content: ' ';\n        height: 30px;\n        width: 30px;\n        mask-size: contain;\n        display: inline-block;\n        background: ${i||"#333"};\n      }\n    }`][n-1]:null;


/***/ }),

/***/ 568646:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),n=__webpack_require__(85097),r=__webpack_require__(112373);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const d=i(t).default.div((({commonStyle:e})=>`\n  width: 100%;\n  height: 100px;\n  background: #ddd;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ${n.getStyle(e)};\n`));exports.Empty=({children:t=e.jsx(r.PlusOutlined,{}),style:n})=>e.jsx(d,{commonStyle:n,children:t});


/***/ }),

/***/ 669117:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(891987),n=__webpack_require__(877084),o=__webpack_require__(130383),r=__webpack_require__(75537),l=__webpack_require__(212951),s=__webpack_require__(879774);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=i(t),f=i(n),u=i(l),p=Object.defineProperty,$=Object.defineProperties,c=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,x=Object.prototype.hasOwnProperty,m=Object.prototype.propertyIsEnumerable,h=(e,t,n)=>t in e?p(e,t,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[t]=n,y=(e,t)=>{for(var n in t||(t={}))x.call(t,n)&&h(e,n,t[n]);if(d)for(var n of d(t))m.call(t,n)&&h(e,n,t[n]);return e},O=(e,t)=>$(e,c(t));function b(e){return"number"==typeof e?`${e} ${e} auto`:/^\d+(\.\d+)?(px|em|rem|%)$/.test(e)?`0 0 ${e}`:e}const g=["xs","sm","md","lg","xl","xxl"],v=a.default.forwardRef(((t,n)=>{const{gutter:r,wrap:l}=a.default.useContext(o),s=t,{span:i,order:u,offset:p,push:$,pull:c,className:h,children:v,flex:j,style:k}=s,w=((e,t)=>{var n={};for(var o in e)x.call(e,o)&&t.indexOf(o)<0&&(n[o]=e[o]);if(null!=e&&d)for(var o of d(e))t.indexOf(o)<0&&m.call(e,o)&&(n[o]=e[o]);return n})(s,["span","order","offset","push","pull","className","children","flex","style"]),N="teko-col";let P={};g.forEach((e=>{let n={};const o=t[e];"number"==typeof o?n.span=o:"object"==typeof o&&(n=o||{}),P=O(y({},P),{[`${N}-${e}-${n.span}`]:void 0!==n.span,[`${N}-${e}-order-${n.order}`]:n.order||0===n.order,[`${N}-${e}-offset-${n.offset}`]:n.offset||0===n.offset,[`${N}-${e}-push-${n.push}`]:n.push||0===n.push,[`${N}-${e}-pull-${n.pull}`]:n.pull||0===n.pull})}));const _=f.default(N,{[`${N}-${i}`]:void 0!==i,[`${N}-order-${u}`]:u,[`${N}-offset-${p}`]:p,[`${N}-push-${$}`]:$,[`${N}-pull-${c}`]:c},h,P);let I=y({},k);return r&&(I=y(y({},r[0]&&r[0]>0?{paddingLeft:r[0]/2,paddingRight:r[0]/2}:{}),I)),j&&(I.flex=b(j),"auto"!==j||!1!==l||I.minWidth||(I.minWidth=0)),e.jsx(R,O(y({},w),{style:I,className:_,ref:n,children:v}))}));v.displayName="Col";const j=e=>Math.floor(100*e)/100,k=(e,t)=>j(e/t*100)+"%",w=(e="")=>{let t=`\n    &.teko-col${e}-0 {\n      display: none;\n    }\n    &.teko-col-push-0 {\n      left: auto;\n    }\n    &.teko-col-pull-0 {\n      right: auto;\n    }\n    &.teko-col${e}-push-0 {\n      left: auto;\n    }\n    &.teko-col${e}-pull-0 {\n      right: auto;\n    }\n    &.teko-col${e}-offset-0 {\n      margin-left: 0;\n    }\n    &.teko-col${e}-order-0 {\n      order: 0;\n    }\n  `;for(let n=1;n<=24;n++)t+=`\n      &.teko-col${e}-${n} {\n        display: block;\n        flex: 0 0 ${k(n,s.GRID_COLUMNS)};\n        max-width: ${"-lg"===e?"84px":["-xl","-xxl"].includes(e)?"104px":k(n,s.GRID_COLUMNS)};\n      }\n      &.teko-col${e}-push-${n} {\n        left: ${k(n,s.GRID_COLUMNS)};\n      }\n      &.teko-col${e}-pull-${n} {\n        right: ${k(n,s.GRID_COLUMNS)};\n      }\n      &.teko-col${e}-offset-${n} {\n        margin-left: ${k(n,s.GRID_COLUMNS)};\n      }\n      &.teko-col${e}-order-${n} {\n        order: ${n};\n      }\n    `;return t},N=r.css`
  ${w()}
  ${w("-xs")}
  ${Object.keys(s.BREAK_POINTS).map((e=>"xs"!==e?`\n    @media (min-width: ${s.BREAK_POINTS[e]}) {\n      ${w(`-${e}`)}\n    }\n  `:"")).join("")}
`,P=e=>{if(e)return`\n    flex: ${b(e)};\n    ${"string"==typeof e?`max-width: ${e};`:""}\n  `},R=u.default.div("\n  &.teko-col {\n    position: relative;\n    // Prevent columns from collapsing when empty\n    min-height: 1px;\n  }",N,(e=>{var t;return r.css`
    ${"object"==typeof e.xs&&void 0!==(null==(t=e.xs)?void 0:t.flex)?P(e.xs.flex):"max-width: 100%;"}
    ${Object.keys(s.BREAK_POINTS).map((t=>{var n,o;return(null==(n=e[t])?void 0:n.flex)&&"xs"!==t?`\n      @media (min-width: ${s.BREAK_POINTS[t]}) {\n        ${P(null==(o=e[t])?void 0:o.flex)||"max-width: 100%"};\n      }\n    `:""})).join("")}
  `}));exports.Col=v,exports.floorPercentage=j,exports.percentage=k;


/***/ }),

/***/ 930907:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(891987),t=__webpack_require__(877084),o=__webpack_require__(130383),a=__webpack_require__(839613),n=__webpack_require__(212951),s=__webpack_require__(879774);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=i(r),f=i(t),c=i(n),u=Object.defineProperty,p=Object.defineProperties,d=Object.getOwnPropertyDescriptors,w=Object.getOwnPropertySymbols,y=Object.prototype.hasOwnProperty,b=Object.prototype.propertyIsEnumerable,j=(e,r,t)=>r in e?u(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,x=(e,r)=>{for(var t in r||(r={}))y.call(r,t)&&j(e,t,r[t]);if(w)for(var t of w(r))b.call(r,t)&&j(e,t,r[t]);return e};const m=l.default.forwardRef(((r,t)=>{const n=r,{justify:s,align:i,className:c,style:u,children:j,gutter:m=0,wrap:v}=n,k=((e,r)=>{var t={};for(var o in e)y.call(e,o)&&r.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&w)for(var o of w(e))r.indexOf(o)<0&&b.call(e,o)&&(t[o]=e[o]);return t})(n,["justify","align","className","style","children","gutter","wrap"]),[O,h]=l.default.useState({xs:!0,sm:!0,md:!0,lg:!0,xl:!0,xxl:!0}),A=l.default.useRef(m);l.default.useEffect((()=>{const e=a.default.subscribe((e=>{const r=A.current||0;(!Array.isArray(r)&&"object"==typeof r||Array.isArray(r)&&("object"==typeof r[0]||"object"==typeof r[1]))&&h(e)}));return()=>a.default.unsubscribe(e)}),[]);const P="teko-row",q=(()=>{const e=[0,0];return(Array.isArray(m)?m:[m,0]).forEach(((r,t)=>{if("object"==typeof r&&null!==r)for(let o=0;o<a.responsiveArray.length;o++){const n=a.responsiveArray[o];if(O[n]&&void 0!==r[n]){e[t]=r[n];break}}else e[t]=r||0})),e})(),R=f.default(P,{[`${P}-no-wrap`]:!1===v,[`${P}-${s}`]:s,[`${P}-${i}`]:i},c),N=x(x(x({},q[0]&&q[0]>0?{marginLeft:q[0]/-2,marginRight:q[0]/-2}:{}),q[1]&&m[1]>0?{rowGap:q[1]}:{}),u);return e.jsx(o.Provider,{value:{gutter:q,wrap:v},children:e.jsx(g,($=x({},k),E={className:R,style:N,ref:t,children:j},p($,d(E))))});var $,E}));m.displayName="Row";const g=c.default.div`
  &.teko-row {
    display: flex;
    flex-flow: row wrap;
  }
  @media (min-width: ${s.BREAK_POINTS.lg}) {
    &.teko-row {
      justify-content: center;
    }
  }
  &.teko-row:before,
  &.teko-row:after {
    display: flex;
  }

  // No wrap of flex
  &.teko-row-no-wrap {
    flex-wrap: nowrap;
  }

  &.teko-row-start {
    justify-content: flex-start;
  }

  &.teko-row-center {
    justify-content: center;
  }

  &.teko-row-end {
    justify-content: flex-end;
  }

  &.teko-row-space-between {
    justify-content: space-between;
  }

  &.teko-row-space-around {
    justify-content: space-around;
  }

  &.teko-row-top {
    align-items: flex-start;
  }

  &.teko-row-middle {
    align-items: center;
  }

  &.teko-row-bottom {
    align-items: flex-end;
  }
`;exports.Row=m;


/***/ }),

/***/ 130383:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var e=(__webpack_require__(891987).createContext)({});module.exports=e;


/***/ }),

/***/ 839613:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=Object.defineProperty,t=Object.defineProperties,r=Object.getOwnPropertyDescriptors,s=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,n=Object.prototype.propertyIsEnumerable,a=(t,r,s)=>r in t?e(t,r,{enumerable:!0,configurable:!0,writable:!0,value:s}):t[r]=s;const l={xs:"(max-width: 575px)",sm:"(min-width: 576px)",md:"(min-width: 768px)",lg:"(min-width: 1024px)",xl:"(min-width: 1440px)",xxl:"(min-width: 1600px)"},o=new Map;let c=-1,p={};var d={matchHandlers:{},dispatch:e=>(p=e,o.forEach((e=>e(p))),o.size>=1),subscribe(e){return o.size||this.register(),c+=1,o.set(c,e),e(p),c},unsubscribe(e){o.delete(e),o.size||this.unregister()},unregister(){Object.keys(l).forEach((e=>{const t=l[e],r=this.matchHandlers[t];null==r||r.mql.removeListener(null==r?void 0:r.listener)})),o.clear()},register(){Object.keys(l).forEach((e=>{const o=l[e],c=({matches:l})=>{var o;this.dispatch((o=((e,t)=>{for(var r in t||(t={}))i.call(t,r)&&a(e,r,t[r]);if(s)for(var r of s(t))n.call(t,r)&&a(e,r,t[r]);return e})({},p),t(o,r({[e]:l}))))},d=window.matchMedia(o);d.addListener(c),this.matchHandlers[o]={mql:d,listener:c},c(d)}))}};exports["default"]=d,exports.responsiveArray=["xxl","xl","lg","md","sm","xs"],exports.responsiveMap=l;


/***/ }),

/***/ 124946:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(891987);function r(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var n=r(t);exports.LazyComponent=({children:r,debounce:c=0})=>{const s=n.default.useRef(null),[i,u]=t.useState(!1);return n.default.useEffect((()=>{if(!s.current)return;const e=new IntersectionObserver(((e,t)=>{for(const r of e)if(r.isIntersecting)return u(!0),void t.disconnect()}));return e.observe(s.current),c>0&&requestIdleCallback((function t(r){r.timeRemaining()>c?(u(!0),e.disconnect()):requestIdleCallback(t)})),()=>e.disconnect()}),[c]),e.jsx("div",{ref:s,className:"lazy-component",children:i?r:e.jsx("div",{className:"fake-body",style:{width:"100%",height:200}})})};


/***/ }),

/***/ 563003:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(891987);const o=(e,t)=>"email"===t?`mailto:${e}`:"phone"===t?`tel:${e}`:"internal"===t?`/${e}`:e;exports.LinkV1=({href:n,target:r,linkType:c,children:i,className:l,sectionMarginTop:s=0})=>{const a=t.useRef();return n?"inPage"===c?e.jsx("div",{ref:a,style:{cursor:"pointer"},onClick:()=>(e=>{var t;const o=a.current.ownerDocument!==document;let n=window;if(o){const e=window.document.getElementsByTagName("iframe");for(const t of e)if(t.contentDocument===a.current.ownerDocument){n=t.contentWindow;break}}const r=a.current.ownerDocument.querySelectorAll(`[data-id="${e}"]`);for(const e of r)if("none"!==(null==(t=null==n?void 0:n.getComputedStyle(e))?void 0:t.display)){const t=e.getBoundingClientRect().top+n.pageYOffset-s;n.scrollTo({top:t,behavior:"smooth"})}})(n),children:i}):e.jsx("a",{style:{textDecoration:"none",color:"unset",cursor:"pointer"},href:o(n,c),target:"_blank"===r?"_blank":"_self"===r?"_top":void 0,className:l,rel:"noopener noreferrer",children:i}):i};


/***/ }),

/***/ 725042:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(891987),n=__webpack_require__(85097),t=__webpack_require__(503915),l=__webpack_require__(832027),r=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable;exports.LinkV2=s=>{var c,d,u,p,v,f,m,g,h,w,b,x,y,k,C,P,T,W,j,O,N=s,{eventType:q,children:D,className:_,sectionMarginTop:A=0,trackingEventName:E,conversionGGAdsId:$,conversionGGAdsLabel:S,scriptCustom:L}=N,G=((e,o)=>{var n={};for(var t in e)i.call(e,t)&&o.indexOf(t)<0&&(n[t]=e[t]);if(null!=e&&r)for(var t of r(e))o.indexOf(t)<0&&a.call(e,t)&&(n[t]=e[t]);return n})(N,["eventType","children","className","sectionMarginTop","trackingEventName","conversionGGAdsId","conversionGGAdsLabel","scriptCustom"]);const{globalData:I}=n.useStore(),{addToast:M,ToastComponent:R}=t.useToast(),B=(null==I?void 0:I.prefixLangUrl)||"",U=o.useRef(),F=()=>{var e,o,n,t;E&&(null==(e=null==window?void 0:window.gtag)||e.call(window,"event",E),null==(o=null==window?void 0:window.fbq)||o.call(window,"trackCustom",E),null==(n=null==window?void 0:window.track)||n.call(window,"customEvent",E)),$&&S&&(null==(t=null==window?void 0:window.gtag)||t.call(window,"event","conversion",{send_to:`AW-${$}/${S}`})),V(L)},V=e=>{if(null==e?void 0:e.trim())try{new Function(n.unescapeString(e))()}catch(e){console.error(e)}};if("openPageOfWebsite"===q&&((null==(c=G.openPageOfWebsite)?void 0:c.href)||(null==(d=G.openPageOfWebsite)?void 0:d.pageId))){let o=(null==(u=G.openPageOfWebsite)?void 0:u.href)||"";const n=null==(p=G.openPageOfWebsite)?void 0:p.pageId;let t;if(n&&(t=null==(m=null==(f=null==(v=null==I?void 0:I.menu)?void 0:v.find((e=>{var o;return"PAGE"===(null==e?void 0:e.linkType)&&(null==e?void 0:e.linkPageId)===(null==(o=G.openPageOfWebsite)?void 0:o.pageId)})))?void 0:f.page)?void 0:m.slug,o="/"+(t||"")),!n||t)return e.jsx("a",{style:{textDecoration:"none",color:"unset",cursor:"pointer",maxWidth:"100%"},href:`${B}${o}`,onClick:F,target:(null==(g=G[q])?void 0:g.openNewTab)?"_blank":"_self",className:_,rel:(null==(h=G[q])?void 0:h.nofollow)?"nofollow":"noopener noreferrer",children:D})}if("openArticleOfWebsite"===q&&(null==(w=G.openArticleOfWebsite)?void 0:w.pageId)){let o="";const n=null==(b=G.openArticleOfWebsite)?void 0:b.pageId;let t;if(n&&(t=null==(y=null==(x=null==I?void 0:I.referencedArticles)?void 0:x.find((e=>(null==e?void 0:e.id)===n)))?void 0:y.slug,o="/"+(t||"")),t)return e.jsx("a",{style:{textDecoration:"none",color:"unset",cursor:"pointer",maxWidth:"100%"},href:`${B}${o}`,onClick:F,target:(null==(k=G[q])?void 0:k.openNewTab)?"_blank":"_self",className:_,children:D})}return"link"===q&&(null==(C=G.link)?void 0:C.href)?e.jsx("a",{style:{textDecoration:"none",color:"unset",cursor:"pointer",maxWidth:"100%"},href:G.link.href,onClick:F,target:(null==(P=G[q])?void 0:P.openNewTab)?"_blank":"_top",className:_,rel:(null==(T=G[q])?void 0:T.nofollow)?"nofollow":"noopener noreferrer",children:D}):"inPage"===q&&G.inPage?e.jsx("div",{style:{cursor:"pointer",maxWidth:"100%"},onClick:()=>{(e=>{var o;const n=U.current.ownerDocument!==document;let t=window;if(n){const e=window.document.getElementsByTagName("iframe");for(const o of e)if(o.contentDocument===U.current.ownerDocument){t=o.contentWindow;break}}const l=U.current.ownerDocument.querySelectorAll(`[data-id="${e}"]`);for(const e of l)if("none"!==(null==(o=null==t?void 0:t.getComputedStyle(e))?void 0:o.display)){const o=e.getBoundingClientRect().top+t.pageYOffset-A;t.scrollTo({top:o,behavior:"smooth"})}})(G.inPage),F()},ref:U,children:D}):"internal"===q&&(null==(W=G.internal)?void 0:W.href)?e.jsx("a",{style:{textDecoration:"none",color:"unset",cursor:"pointer",maxWidth:"100%"},href:`${B}/${G.internal.href}`,onClick:F,target:(null==(j=G.internal)?void 0:j.openNewTab)?"_blank":"_top",className:_,rel:"noopener noreferrer",children:D}):"email"===q&&G.email?e.jsx("a",{style:{textDecoration:"none",color:"unset",cursor:"pointer",maxWidth:"100%"},href:`mailto:${G.email}`,onClick:F,className:_,rel:"noopener noreferrer",target:"_top",children:D}):"phone"===q&&G.phone?e.jsx("a",{style:{textDecoration:"none",color:"unset",cursor:"pointer",maxWidth:"100%"},href:`tel:${G.phone}`,onClick:F,className:_,rel:"noopener noreferrer",target:"_top",children:D}):"openPopup"===q&&G.togglePopup?e.jsx("div",{ref:U,onClick:()=>{var e,o;e=G.togglePopup,null==(o=U.current.ownerDocument.querySelector(`[data-uniq-id="${e}"]`))||o.click(),F()},style:{maxWidth:"100%"},children:D}):"closePopupList"===q&&(null==(O=G.togglePopupList)?void 0:O.length)?e.jsx("div",{ref:U,onClick:()=>{(e=>{const o=U.current.ownerDocument.querySelectorAll("[data-uniq-id]"),n=[];o.forEach((o=>{e.includes(o.getAttribute("data-uniq-id"))&&n.push(o)})),n.forEach((e=>{const o=null==e?void 0:e.parentElement;o.classList.remove("show"),o.classList.add("hide-from-btn"),null==e||e.click()}))})(G.togglePopupList),F()},style:{maxWidth:"100%"},children:D}):"closePopup"===q&&G.togglePopup?e.jsx("div",{ref:U,onClick:()=>{(e=>{const o=U.current.ownerDocument.querySelector(`[data-uniq-id="${e}"]`),n=null==o?void 0:o.parentElement;n.classList.remove("show"),n.classList.add("hide-from-btn"),null==o||o.click()})(G.togglePopup),F()},style:{maxWidth:"100%"},children:D}):"copyToClipboard"===q&&G.copyToClipboard?e.jsxs("div",{ref:U,onClick:()=>{var e,o;navigator.clipboard.writeText(null==(e=G.copyToClipboard)?void 0:e.textCopy),M({message:null==(o=G.copyToClipboard)?void 0:o.notificationMessage,duration:2500,position:l.ToastPosition.TOP_CENTER,type:l.ToastType.SUCCESS,commonStyle:{backgroundColor:"rgba(0, 0, 0, 0.8)",color:"white"}}),F()},style:{maxWidth:"100%"},children:[D,R]}):e.jsx("div",{onClick:F,style:{maxWidth:"100%"},children:D})};


/***/ }),

/***/ 319891:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(563003),t=__webpack_require__(725042),i=Object.defineProperty,n=Object.getOwnPropertySymbols,o=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable,p=(e,r,t)=>r in e?i(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,s=(e,r)=>{for(var t in r||(r={}))o.call(r,t)&&p(e,t,r[t]);if(n)for(var t of n(r))a.call(r,t)&&p(e,t,r[t]);return e};exports.Link=i=>i.eventType?e.jsx(t.LinkV2,s({},i)):e.jsx(r.LinkV1,s({},i));


/***/ }),

/***/ 832864:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=s(__webpack_require__(212951));const i=t.default.div`
  height: 400px;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 14px;
`,l=t.default.div`
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .spinner-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    flex-direction: column;
    opacity: 0.9;
  }
  .loading-text {
    font-size: 16px;
    letter-spacing: 2px;
    color: #7367f0;
    margin-bottom: 8px;
  }
  .pulse-container {
    width: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .pulse-bubble {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: linear-gradient(to right, #7367f0, #a29af6);
  }

  .pulse-bubble-1 {
    animation: pulse 1s ease 0s infinite alternate;
  }
  .pulse-bubble-2 {
    animation: pulse 1s ease 0.2s infinite alternate;
  }
  .pulse-bubble-3 {
    animation: pulse 1s ease 0.4s infinite alternate;
  }
  .pulse-bubble-4 {
    animation: pulse 1s ease 0.6s infinite alternate;
  }
  .pulse-bubble-5 {
    animation: pulse 1s ease 0.8s infinite alternate;
  }

  @keyframes pulse {
    from {
      opacity: 1;
      transform: scale(1);
    }
    to {
      opacity: 0.25;
      transform: scale(0.75);
    }
  }
`;exports.Loading=()=>e.jsx(i,{children:e.jsx(l,{children:e.jsx("div",{className:"spinner-box",children:e.jsxs("div",{className:"pulse-container",children:[e.jsx("div",{className:"pulse-bubble pulse-bubble-1"}),e.jsx("div",{className:"pulse-bubble pulse-bubble-2"}),e.jsx("div",{className:"pulse-bubble pulse-bubble-3"}),e.jsx("div",{className:"pulse-bubble pulse-bubble-4"}),e.jsx("div",{className:"pulse-bubble pulse-bubble-5"})]})})})});


/***/ }),

/***/ 20975:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261);exports.NextIcon=({color:C="#7367f0"})=>e.jsx("svg",{width:"9",viewBox:"0 0 7 12",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:e.jsx("path",{d:"M6.39777 5.66233L0.360269 0.9467C0.344493 0.93428 0.325533 0.926562 0.305568 0.924431C0.285603 0.9223 0.265441 0.925844 0.247399 0.934655C0.229357 0.943466 0.214166 0.957188 0.203571 0.974243C0.192976 0.991299 0.187406 1.011 0.187501 1.03108V2.06634C0.187501 2.13197 0.218305 2.19491 0.269198 2.23509L5.09063 5.99983L0.269198 9.76456C0.216966 9.80474 0.187501 9.86768 0.187501 9.93331V10.9686C0.187501 11.0583 0.290626 11.1079 0.360269 11.053L6.39777 6.33733C6.44908 6.2973 6.4906 6.2461 6.51915 6.18761C6.5477 6.12913 6.56254 6.06491 6.56254 5.99983C6.56254 5.93475 6.5477 5.87052 6.51915 5.81204C6.4906 5.75356 6.44908 5.70235 6.39777 5.66233Z",fill:C})}),exports.PrevIcon=({color:C="#7367f0"})=>e.jsx("svg",{width:"9",viewBox:"0 0 7 12",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:e.jsx("path",{d:"M6.83962 2.06646V1.03119C6.83962 0.941456 6.7365 0.891902 6.66685 0.946813L0.629351 5.66244C0.578054 5.70233 0.536546 5.75341 0.507994 5.81179C0.479442 5.87016 0.4646 5.93429 0.4646 5.99927C0.4646 6.06425 0.479442 6.12838 0.507994 6.18675C0.536546 6.24512 0.578054 6.29621 0.629351 6.3361L6.66685 11.0517C6.73783 11.1066 6.83962 11.0571 6.83962 10.9673V9.93208C6.83962 9.86646 6.80882 9.80351 6.75792 9.76333L1.93649 5.99994L6.75792 2.23521C6.80882 2.19503 6.83962 2.13208 6.83962 2.06646Z",fill:C})});


/***/ }),

/***/ 541076:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),o=__webpack_require__(212951),t=__webpack_require__(986383),i=__webpack_require__(20975),r=__webpack_require__(414746);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=n(o),l=n(t),s=Object.defineProperty,d=Object.getOwnPropertySymbols,p=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,c=(e,o,t)=>o in e?s(e,o,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[o]=t,g=(e,o)=>{for(var t in o||(o={}))p.call(o,t)&&c(e,t,o[t]);if(d)for(var t of d(o))u.call(o,t)&&c(e,t,o[t]);return e};const f=a.default.div`
  ${e=>e.$isEditingMode?"pointer-events: none;":""}
  width: 100%;
  display: flex;
  justify-content: ${e=>e.$position};

  /* Reset default list styles */
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  /* Pagination styles */
  ul[role='navigation'] {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1em 0;
  }

  ul[role='navigation'] li {
    margin: 0 5px;
  }

  ul[role='navigation'] a {
    display: block;
    padding: 0.25em 0.75em;
    text-decoration: none;
    color: ${e=>e.$textColor};

    border-radius: 4px;
    cursor: pointer;
  }

  ul[role='navigation'] .selected a {
    color: ${e=>e.$paginationColor};
    background-color: transparent;
    border: 1px solid ${e=>e.$paginationColor};
  }

  ul[role='navigation'] .disabled a {
    pointer-events: none;
    color: #d9d9d9;
  }

  /* Arrow styles */
  ul[role='navigation'] a[aria-label='Previous page'],
  ul[role='navigation'] a[aria-label='Next page'] {
    font-weight: bold;
  }

  /* Hover effect */
  ul[role='navigation'] a:hover:not(.disabled) {
    background-color: #ddd;
  }

  a {
    pointer-events: unset;
  }

  li.disabled {
    filter: grayscale(1);
    opacity: 0.5;
  }
`;exports.Pagination=o=>{const t=o,{paginationColor:n="#7367f0",textColor:a="#000000",position:s=r.PositionPaginationType.Center,isEditingMode:c=!1}=t,b=((e,o)=>{var t={};for(var i in e)p.call(e,i)&&o.indexOf(i)<0&&(t[i]=e[i]);if(null!=e&&d)for(var i of d(e))o.indexOf(i)<0&&u.call(e,i)&&(t[i]=e[i]);return t})(t,["paginationColor","textColor","position","isEditingMode"]);return e.jsx(f,{$paginationColor:n,$textColor:a,$position:s,$isEditingMode:c,children:e.jsx(l.default,g({breakLabel:"...",nextLabel:e.jsx(i.NextIcon,{color:n}),pageRangeDisplayed:1,previousLabel:e.jsx(i.PrevIcon,{color:n}),renderOnZeroPageCount:null},b))})};


/***/ }),

/***/ 414746:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=(e=>(e.Center="center",e.Start="start",e.End="end",e))(e||{});exports.PositionPaginationType=e;


/***/ }),

/***/ 134166:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(561261),e=__webpack_require__(212951),r=__webpack_require__(834584);function a(t){return t&&"object"==typeof t&&"default"in t?t:{default:t}}var i=a(e),o=a(r),l=Object.defineProperty,s=Object.getOwnPropertySymbols,n=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,f=(t,e,r)=>e in t?l(t,e,{enumerable:!0,configurable:!0,writable:!0,value:r}):t[e]=r;const m=i.default(o.default)`
  &.tempi-rate {
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 18px;
    display: inline-block;
    vertical-align: middle;
    font-weight: normal;
    font-style: normal;
    outline: none;
  }

  &.tempi-rate-rtl {
    direction: rtl;
    .tempi-rate-star {
      margin-right: 0;
      margin-left: 2px;
      float: right;
    }
    .tempi-rate-star-first {
      right: 0;
      left: auto;
    }
  }

  &.tempi-rate-disabled {
    .tempi-rate-star {
      cursor: default;
    }
    .tempi-rate-star:before,
    .tempi-rate-star-content:before {
      cursor: default;
    }
    .tempi-rate-star:hover {
      transform: scale(1);
    }
  }

  .tempi-rate-star {
    margin: 0;
    padding: 0;
    display: inline-block;
    margin-right: 2px;
    position: relative;
    transition: all 0.3s;
    color: #e9e9e9;
    cursor: pointer;
    line-height: 1.5;
    &:last-child {
      margin-right: 0;
    }
  }

  .tempi-rate-star-first,
  .tempi-rate-star-second {
    transition: all 0.3s;
  }
  .tempi-rate-star-focused,
  .tempi-rate-star:hover {
    transform: scale(1.1);
  }
  .tempi-rate-star-first {
    position: absolute;
    left: 0;
    top: 0;
    width: 50%;
    height: 100%;
    overflow: hidden;
    opacity: 0;
  }

  .tempi-rate-star-half .tempi-rate-star-first,
  .tempi-rate-star-half .tempi-rate-star-second {
    opacity: 1;
  }
  .tempi-rate-star-half .tempi-rate-star-first,
  .tempi-rate-star-full .tempi-rate-star-second {
    color: #fadb14;
  }
`;exports.Rating=e=>t.jsx(m,((t,e)=>{for(var r in e||(e={}))n.call(e,r)&&f(t,r,e[r]);if(s)for(var r of s(e))p.call(e,r)&&f(t,r,e[r]);return t})({prefixCls:"tempi-rate",allowHalf:!0},e));


/***/ }),

/***/ 144497:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),o=__webpack_require__(891987);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const r=i(t).default.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  z-index: 0;
  border-radius: inherit;
  span {
    transform: scale(0);
    border-radius: 100%;
    position: absolute;
    opacity: 0.75;
    background-color: rgba(255, 255, 255, 0.6);
    animation: ripple;
    animation-duration: 696ms;
  }
  @keyframes ripple {
    to {
      opacity: 0;
      transform: scale(2);
    }
  }
`;exports.Ripple=({duration:t=600,color:i="rgba(255,255,255,0.6)"})=>{const[n,a]=o.useState([]);return((e,t,i)=>{("undefined"!=typeof window?o.useLayoutEffect:o.useEffect)((()=>{let o=null;return e>0&&(clearTimeout(o),o=setTimeout((()=>{i(),clearTimeout(o)}),4*t)),()=>clearTimeout(o)}),[e,t,i])})(n.length,t,(()=>{a([])})),e.jsx(r,{onMouseDown:e=>{const t=e.currentTarget.getBoundingClientRect(),o=t.width>t.height?t.width:t.height,i={x:e.clientX-t.x-o/2,y:e.clientY-t.y-o/2,size:o};a([...n,i])},children:n.map(((o,r)=>e.jsx("span",{style:{top:o.y,left:o.x,width:o.size,height:o.size,backgroundColor:i,animationDuration:`${t}ms`}},"span"+r)))})};


/***/ }),

/***/ 465112:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),t=__webpack_require__(212951),n=__webpack_require__(998621);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var r=i(t);const l=r.default.div`
  position: relative;
`,s=r.default.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4;
  display: block;
  width: 100%;
  height: 100%;
  max-height: 400px;
  top: 40px;
  left: calc(50% - 40px);
`,o=r.default.div`
  clear: both;
  opacity: 0.5;
  user-select: none;
  pointer-events: none;
`;exports.Spin=({spinning:t=!0,children:i,style:r})=>t?e.jsxs(e.Fragment,{children:[e.jsx(l,{children:e.jsx(s,{children:e.jsx(n.StyledSpinningInner,{})})}),e.jsx(o,{style:r,children:i})]}):e.jsx(e.Fragment,{children:i});


/***/ }),

/***/ 998621:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

function n(n){return n&&"object"==typeof n&&"default"in n?n:{default:n}}Object.defineProperty(exports, "__esModule", ({value:!0}));const e=n(__webpack_require__(212951)).default.div((({size:n,transform:e,time:t,color:r="#3f747e"})=>`\n  @keyframes ldio-1ga5p6b2g17 {\n    0% {\n      transform: rotate(0deg);\n    }\n    50% {\n      transform: rotate(180deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  width: ${n||80}px;\n  height: ${n||80}px;\n  box-shadow: 0 1.9px 0 0 ${r};\n  transform-origin: ${e||40}px ${e||40}px;\n  animation: ldio-1ga5p6b2g17 ${t||1.27}s linear infinite;\n  border-radius: 50%;\n`));exports.StyledSpinningInner=e;


/***/ }),

/***/ 740295:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261);function t(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var r=t(__webpack_require__(787045));exports.TipTapTextDisplay=({text:t})=>e.jsx("span",{dangerouslySetInnerHTML:{__html:r.default.sanitize(t)}});


/***/ }),

/***/ 585514:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097),t=__webpack_require__(891987);const n=[e.TOP_BANNER,e.HEADER];exports.useIgnoreElementTotalHeight=({ignoreHeightElements:r=n,height:o})=>{const[i,l]=t.useState(0);return t.useEffect((()=>{const t=()=>{var t;const n=null==r?void 0:r.map((e=>`[data-uniq-id="${e}"]`));if(!(null==n?void 0:n.length)&&!i)return;let o=0;if(null==n?void 0:n.length){const r=((null==(t=null==document?void 0:document.querySelector(`#${e.TEMPI_MAIN_IFRAME}`))?void 0:t.contentDocument)||document).querySelectorAll(n.join(","));null==r||r.forEach((e=>{o+=e.getBoundingClientRect().height}))}l(o)},n=e.debounce((()=>t()),200);return t(),window.addEventListener("resize",n),()=>{window.removeEventListener("resize",n)}}),[r]),{totalIgnoreHeight:i,calculatedHeight:"100vh"===o?`calc(100vh  - ${i}px)`:o}};


/***/ }),

/***/ 800656:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(396556),t=__webpack_require__(618996);function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}function r(e){return Object.freeze({__proto__:null,default:e})}var o=n(e),a=Object.defineProperty,i=Object.defineProperties,s=Object.getOwnPropertyDescriptors,c=Object.getOwnPropertySymbols,l=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,u=(e,t,n)=>t in e?a(e,t,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[t]=n,f=(e,t)=>{for(var n in t||(t={}))l.call(t,n)&&u(e,n,t[n]);if(c)for(var n of c(t))p.call(t,n)&&u(e,n,t[n]);return e},m=(e,t)=>i(e,s(t));const b=["en","vi"],d=o.default.createInstance(),y=e=>"en"===e?Promise.resolve().then((function(){return r(__webpack_require__(331198))})):Promise.resolve().then((function(){return r(__webpack_require__(987198))})),O=async()=>{const e=await Promise.all(b.map((async e=>({[e]:{components:(await y(e)).default}}))));return Object.assign({},...e)};exports.SUPPORTED_LANGUAGES=b,exports.getComponentsTranslationResources=O,exports.getOptionsI18n=(e,t,n)=>{const r="string"==typeof n?[n]:n;return t.map((t=>f(f({},t),r.reduce(((n,r)=>(n[r]=e(t[r]),n)),{}))))},exports.importTranslationResources=y,exports.initComponentsI18n=async e=>{await d.use(t.initReactI18next).init({resources:await O(),lng:e,fallbackLng:"vi",ns:["components"],defaultNS:"components",initImmediate:!1,interpolation:{escapeValue:!1}})},exports.t=(e,t)=>o.default.t(e,m(f({},t),{interpolation:{escapeValue:!1}}))||e,exports.translate=(e,t)=>(d.isInitialized?d:o.default).t(e,m(f({},t),{interpolation:{escapeValue:!1}}))||e;


/***/ }),

/***/ 331198:
/***/ (function(module) {

module.exports={"website-header.cart.total-price":"Total price","order_popup.payment_method.cash":"Cash","order_popup.payment_method.cod":"Cash on delivery (COD)","order_popup.payment_method.bank_transfer":"Bank transfer","order_popup.payment_method.vnpay":"Payment via VNPAY","common.quantity":"Quantity","product_list.sold":"Sold","product_list.add_to_cart":"Product has been added to cart"};


/***/ }),

/***/ 987198:
/***/ (function(module) {

module.exports={"website-header.cart.total-price":"Tổng thanh toán","order_popup.payment_method.cash":"Tiền mặt","order_popup.payment_method.cod":"Thanh toán khi nhận hàng (COD)","order_popup.payment_method.bank_transfer":"Chuyển khoản qua ngân hàng","order_popup.payment_method.vnpay":"Thanh toán qua VNPAY","common.quantity":"Số lượng","product_list.sold":"Đã bán","product_list.add_to_cart":"Sản phẩm đã được thêm vào giỏ hàng"};


/***/ }),

/***/ 537753:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
__webpack_unused_export__ = ({value:!0});var e=__webpack_require__(561261),o=__webpack_require__(611489),r=__webpack_require__(145567),n=__webpack_require__(559701),t=__webpack_require__(799407),i=__webpack_require__(752928),u=__webpack_require__(618137),s=__webpack_require__(334489),c=__webpack_require__(581345),p=__webpack_require__(275814),a=__webpack_require__(514411),m=__webpack_require__(953264),d=__webpack_require__(16394),l=__webpack_require__(503446),j=__webpack_require__(147302),q=__webpack_require__(972076),b=__webpack_require__(921265),P=__webpack_require__(570953),C=__webpack_require__(336684),S=__webpack_require__(378800),I=__webpack_require__(865338),g=__webpack_require__(159800),T=__webpack_require__(797214),L=__webpack_require__(171860),V=__webpack_require__(940315),v=__webpack_require__(88146),h=__webpack_require__(945675),k=__webpack_require__(270992),A=__webpack_require__(707777),F=__webpack_require__(494252),f=__webpack_require__(229441),x=__webpack_require__(147428),y=__webpack_require__(602700),M=__webpack_require__(655368),B=__webpack_require__(543729),O=__webpack_require__(694195),w=__webpack_require__(330094),H=__webpack_require__(135104),E=__webpack_require__(314413),D=__webpack_require__(390181),G=__webpack_require__(70456),R=__webpack_require__(871847),W=__webpack_require__(926930),N=__webpack_require__(326485),Q=__webpack_require__(163962),Y=__webpack_require__(892195),_=__webpack_require__(841849),z=__webpack_require__(893462),J=__webpack_require__(319058),K=__webpack_require__(772162),U=__webpack_require__(134496),X=__webpack_require__(533657),Z=__webpack_require__(961804),$=__webpack_require__(127575),ee=__webpack_require__(479287),oe=__webpack_require__(13674),re=__webpack_require__(457336),ne=__webpack_require__(704150),te=__webpack_require__(927322),ie=__webpack_require__(243898),ue=__webpack_require__(728379),se=__webpack_require__(510690),ce=__webpack_require__(228740),pe=__webpack_require__(750911),ae=__webpack_require__(840424),me=__webpack_require__(484435),de=__webpack_require__(586753),le=__webpack_require__(643452),je=__webpack_require__(174958),qe=__webpack_require__(331615),be=__webpack_require__(179244),Pe=__webpack_require__(569208),Ce=__webpack_require__(680284),Se=__webpack_require__(142848),Ie=__webpack_require__(647950),ge=__webpack_require__(984175),Te=__webpack_require__(845589),Le=__webpack_require__(705478),Ve=__webpack_require__(799434),ve=__webpack_require__(872278),he=__webpack_require__(22530),ke=__webpack_require__(679566),Ae=__webpack_require__(855277),Fe=__webpack_require__(22177),fe=__webpack_require__(998089),xe=__webpack_require__(963766),ye=__webpack_require__(690131),Me=__webpack_require__(553884),Be=__webpack_require__(155502),Oe=__webpack_require__(242605),we=__webpack_require__(61444),He=__webpack_require__(71880),Ee=__webpack_require__(823413),De=__webpack_require__(292221),Ge=__webpack_require__(471908),Re=__webpack_require__(734645),We=Object.defineProperty,Ne=Object.getOwnPropertySymbols,Qe=Object.prototype.hasOwnProperty,Ye=Object.prototype.propertyIsEnumerable,_e=(e,o,r)=>o in e?We(e,o,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[o]=r;const ze=o=>e.jsx(Te.FormV4,((e,o)=>{for(var r in o||(o={}))Qe.call(o,r)&&_e(e,r,o[r]);if(Ne)for(var r of Ne(o))Ye.call(o,r)&&_e(e,r,o[r]);return e})({},o));ze.displayName="SubscriptionFormV2";const Je={Root:n.Root,PbIcon:te.PbIcon,Section:ie.PbSection,Container:ue.PbContainer,Row:se.PbRow,Col:ce.PbCol,ButtonV2:pe.ButtonV2,Paragraph:ae.Paragraph,Heading:me.Heading,Divider:t.PbDivider,Spacer:i.Spacer,Youtube:u.Youtube,Countdown:s.Countdown,Map:c.Map,Image:de.Image,Gallery:p.Gallery,HtmlCode:a.HtmlCode,PageFlip:m.PageFlip,NumberCounter:d.NumberCounter,SocialIcon:l.SocialIcon,SocialMedia:j.SocialMedia,StoreList:q.StoreList,Slider:b.Slider,AdvancedSlider:le.AdvancedSlider,Table:P.Table,Accordion:je.Accordion,AccordionContent:qe.AccordionContent,AccordionItem:be.AccordionItem,Audio:C.Audio,ExpandableContent:Pe.ExpandableContent,ExpandableContentBlock:Ce.ExpandableContentBlock,ListItemV2:Se.ListItemV2,ListItemContentV2:Ie.ListItemContentV2,ListItemIconV2:ge.ListItemIconV2,FormV4:Te.FormV4,SubscriptionFormV2:ze,PopupV1:Le.PopupV1,Header:Ve.Header,Menu:ve.Menu,MenuItem:he.MenuItem,Logo:ke.Logo,MenuCol:Ae.MenuCol,LuckyDrawV2:S.LuckyDrawV2,Tab:Fe.Tab,TabItem:fe.TabItem,TestimonialCarousel:I.TestimonialCarousel,TestimonialV2:xe.TestimonialV2,TestimonialV2Item:ye.TestimonialV2Item,ContentSlider:Me.ContentSlider,ContentSliderItem:Be.ContentSliderItem,ProductList:Oe.ProductList,ProductListContent:we.ProductListContent,WebsiteFooter:g.WebsiteFooter,GlobalBlock:T.GlobalBlock,WebsiteHeader:L.WebsiteHeader,PopupRoot:V.PopupRoot,ContactBubble:v.ContactBubble,Page404:h.Page404,TempiProductList:k.TempiProductList,QRCode:A.QRCode,ExamScore:F.ExamScore,ExamScoreSales:f.ExamScoreSales,Video:x.Video,ArticleList:y.ArticleList,ArticleHeader:M.ArticleHeader,SampleComponent:B.SampleComponent,LeadForm:O.LeadForm,InlineBanner:w.InlineBanner,TreasureHunting:He.TreasureHunting,PopupGame:Ee.PopupGame,OrderPopup:H.OrderPopup,OrderFailPopup:o.OrderFailPopup,OrderSuccessPopup:r.OrderSuccessPopup,ProductDetailPopup:E.ProductDetailPopup,CheckoutForm:D.CheckoutForm,LuckyMoney:G.LuckyMoney,PotSmashing:R.PotSmashing,TempiProductListV2:W.TempiProductListV2,TempiProductListV3:N.TempiProductListV3,OrderButton:Q.OrderButton,TopBanner:Y.TopBanner,ListFilter:_.ListFilter,OrderPopupV2:z.OrderPopupV2,DocumentViewer:J.DocumentViewer,Timeline:De.Timeline,TimelineItem:Ge.TimelineItem,GroupButton:K.GroupButton,AdvancedSliderItem:Re.AdvancedSliderItem,Search:U.Search,FacebookComment:X.FacebookComment,FacebookShare:Z.FacebookShare,TextMask:$.TextMask,CartButton:ee.CartButton,Space:oe.Space,PageEffect:re.PageEffect,HeroBannerTempi:ne.HeroBannerTempi};exports.w=Je;


/***/ }),

/***/ 512005:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(969597),e=__webpack_require__(358326),r=__webpack_require__(895325);const o=t.create()(e.devtools(e.persist(((t,e)=>({isOpenCart:!1,orderInfo:null,cart:[],buyNowItem:void 0,isShowSuccessPopup:!1,isShowErrorPopup:!1,isShowCheckoutPopup:!1,errorMessage:null,setOpenCart:e=>t({isOpenCart:e}),addToCart:r.addToCart(t),updateQuantity:r.updateQuantity(t),removeFromCart:r.removeFromCart(t),clearCart:r.clearCart(t),getCartTotal:r.getCartTotal(e),getCartQuantity:r.getCartQuantity(e),getProductTotal:r.getProductTotal(e),buyNow:r.buyNow(t),clearBuyNow:r.clearBuyNow(t),updateBuyNowItemQuantity:r.updateBuyNowItemQuantity(t),getBuyNowTotal:r.getBuyNowTotal(e),setShowSuccessPopup:e=>t({isShowSuccessPopup:e}),setShowErrorPopup:(e,r)=>t({isShowErrorPopup:e,errorMessage:r||null}),setShowCheckoutPopup:e=>t({isShowCheckoutPopup:e}),setOrderInfo:e=>t({orderInfo:e})})),{name:"cart-storage",partialize:t=>({cart:t.cart})})));exports.useCartStore=o;


/***/ }),

/***/ 760339:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(969597),r=__webpack_require__(358326);const p=e.create()(r.devtools((e=>({productsByPopupMap:new Map,updateProductForPopup:(r,p)=>e((e=>{const t=new Map(e.productsByPopupMap);return t.set(r,p),{productsByPopupMap:t}})),currencyConfigMap:new Map,updateCurrencyConfig:(r,p)=>e((e=>{const t=new Map(e.currencyConfigMap);return t.set(r,p),{currencyConfigMap:t}}))}))));exports.useProductListStore=p;


/***/ }),

/***/ 84140:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(969597),r=__webpack_require__(358326);const t=e.create()(r.devtools(r.persist((e=>({activeIndex:0,totalSlide:0,swiperCurrent:null,slidePerView:0,updateSwiperCurrent:r=>{e((()=>({swiperCurrent:r})))},updateActiveIndex:r=>{e((()=>({activeIndex:r})))},updateTotalSlide:r=>{e((()=>({totalSlide:r})))},updateSlidePerView:r=>{e((()=>({slidePerView:r})))}})),{name:"swiper-storage",partialize:()=>({})})));exports.useSwiperStore=t;


/***/ }),

/***/ 954591:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=(e=>(e.auto="auto",e.full="full",e.fixed="fixed",e))(e||{}),t=(e=>(e.default="default",e.fixed="fixed",e.fullHeight="fullHeight",e))(t||{}),o=(e=>(e.front="front",e.behind="behind",e))(o||{}),i=(e=>(e.HOUR="hour",e.DAY="day",e.WEEK="week",e.MONTH="month",e))(i||{});exports.HeightTypeEnum=t,exports.Position=o,exports.QuotaPeriodType=i,exports.WidthTypeEnum=e;


/***/ }),

/***/ 154815:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=(e=>(e.Cash="CASH",e.BankTransfer="BANK_TRANSFER",e.VNPayGateway="VNPAY_GATEWAY",e.Cod="COD",e))(e||{}),t=(e=>(e.Paid="PAID",e.Unpaid="UNPAID",e))(t||{}),a=(e=>(e.Processing="PROCESSING",e.Confirmed="CONFIRMED",e.Completed="COMPLETED",e.Canceled="CANCELED",e))(a||{});exports.OrderStatus=a,exports.PaymentMethod=e,exports.PaymentStatus=t;


/***/ }),

/***/ 327844:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.addPaddingNumber=e=>isNaN(e)?"":null==e?void 0:e.toString().padStart(2,"0");


/***/ }),

/***/ 16793:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.capitalize=e=>e[0].toUpperCase()+e.substr(1,e.length);


/***/ }),

/***/ 895325:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=Object.defineProperty,e=Object.defineProperties,r=Object.getOwnPropertyDescriptors,a=Object.getOwnPropertySymbols,o=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,n=(e,r,a)=>r in e?t(e,r,{enumerable:!0,configurable:!0,writable:!0,value:a}):e[r]=a,i=(t,e)=>{for(var r in e||(e={}))o.call(e,r)&&n(t,r,e[r]);if(a)for(var r of a(e))u.call(e,r)&&n(t,r,e[r]);return t},c=(t,a)=>e(t,r(a));const s=t=>{if(!Number.isInteger(t))throw new Error("Quantity must be an integer")};exports.addToCart=t=>(e,r=1)=>{t((t=>{if(!(r<=0))return s(r),t.cart.find((t=>t.sku===e.sku))?{cart:t.cart.map((t=>t.sku===e.sku?c(i({},t),{quantity:t.quantity+r}):t))}:{cart:[...t.cart,c(i({},e),{quantity:r})]}}))},exports.buyNow=t=>e=>{t((()=>({buyNowItem:c(i({},e),{quantity:1}),isShowCheckoutPopup:!0})))},exports.clearBuyNow=t=>()=>{t((()=>({buyNowItem:void 0})))},exports.clearCart=t=>()=>{t((()=>({cart:[]})))},exports.formatOrderPayload=(t,e)=>[{name:"Chi tiết đơn hàng",type:"string",value:null==t?void 0:t.reduce(((t,e,r)=>t+`${r+1}. ${e.name}: ${e.price||0} x ${e.quantity}\n`),"Chi tiết đơn:\n")},{name:"Tổng thanh toán",type:"number",value:(null==t?void 0:t.reduce(((t,e)=>t+e.quantity*(e.price||0)),0)).toString()},{name:"Phương thức thanh toán",type:"string",value:e}],exports.getBuyNowTotal=t=>()=>{const e=t().buyNowItem;return e?e.price*e.quantity:0},exports.getCartQuantity=t=>()=>t().cart.reduce(((t,e)=>t+e.quantity),0),exports.getCartTotal=t=>()=>t().cart.reduce(((t,e)=>t+e.price*e.quantity),0),exports.getProductTotal=t=>e=>{const r=t().cart.find((t=>t.sku===e.sku));return r?r.price*r.quantity:0},exports.removeFromCart=t=>e=>{t((t=>({cart:t.cart.filter((t=>t.sku!==e.sku))})))},exports.updateBuyNowItemQuantity=t=>e=>{t((t=>(s(e),e<=0?{buyNowItem:void 0,isShowCheckoutPopup:!1}:{buyNowItem:c(i({},t.buyNowItem),{quantity:e})})))},exports.updateQuantity=t=>(e,r)=>{t((t=>(s(r),r<=0?{cart:t.cart.filter((t=>t.sku!==e.sku))}:{cart:t.cart.map((t=>t.sku===e.sku?c(i({},e),{quantity:r}):t))})))},exports.validateQuantity=s;


/***/ }),

/***/ 795625:
/***/ (function(module) {

var e=new class{constructor(){this.events={}}addListener(e,s){this.events[e]||(this.events[e]=[]),this.events[e].push(s)}removeListener(e,s){this.events[e]&&(this.events[e]=this.events[e].filter((e=>e!==s)))}removeAllListeners(e){e?this.events[e]=[]:this.events={}}emit(e,...s){this.events[e]&&this.events[e].forEach((e=>e(...s)))}};module.exports=e;


/***/ }),

/***/ 655268:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097),r=__webpack_require__(262560),t=__webpack_require__(324259),o=Object.defineProperty,a=Object.defineProperties,n=Object.getOwnPropertyDescriptors,i=Object.getOwnPropertySymbols,s=Object.prototype.hasOwnProperty,l=Object.prototype.propertyIsEnumerable,c=(e,r,t)=>r in e?o(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,u=(e,r)=>{for(var t in r||(r={}))s.call(r,t)&&c(e,t,r[t]);if(i)for(var t of i(r))l.call(r,t)&&c(e,t,r[t]);return e};class d{constructor(){this.insertDataToGoogleSheetV2=async(e,r,t)=>{try{return this.api.post(t,{merchantId:null==e?void 0:e.merchantId,formAccountId:null==e?void 0:e.formAccountId,spreadSheetId:null==e?void 0:e.spreadSheetId,sheetId:null==e?void 0:e.sheetId,formData:r})}catch(e){return console.error(e),Promise.reject(e)}},this.submitFormData=async(e,r,t)=>{try{return this.api.post(t,{formId:e,formData:r})}catch(e){return console.error(e),Promise.reject(e)}},this.api=new e.Api("")}}const m=new d;exports.FormUtil=d,exports.formUtils=m,exports.handleStorageData=async(o,i,s,l=[])=>{var c;if(!i||!(null==o?void 0:o.formConfigId))return;const d=new Date,{year:p,month:f,day:h,hour:y,minute:b,second:v}=r.getPartialDateTimeTimeZone7(d),g=`${p}-${f}-${h} ${y}:${b}:${v}`;let j=(w=u({},i),a(w,n({created_at:g})));var w;(null==o?void 0:o.autoPassParams)&&(j=u(u({},t.queryStringToObject(window.location.search)),j));const O=[...Object.entries(j).map((([e,r])=>({name:e,type:"string",value:r}))),{name:"url_page",type:"string",value:null==(c=null==window?void 0:window.location)?void 0:c.href},...l];await m.submitFormData(null==o?void 0:o.formConfigId,O,`${e.publicBffUrl[s]}/v1/submit-form`)};


/***/ }),

/***/ 292471:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(387064),l=__webpack_require__(368380);exports.getEditorAttributeValue=(e,i,u)=>{var o,r,n,d,s,v,a,E,g,c;const p=u?l.getResponsiveAttrKey(i,u):i;return(null==(r=null==(o=null==e?void 0:e.getAttributes)?void 0:o.call(e,t.NODE_TYPES.textStyle))?void 0:r[p])||(null==(d=null==(n=null==e?void 0:e.getAttributes)?void 0:n.call(e,t.NODE_TYPES.paragraph))?void 0:d[p])||(null==(v=null==(s=null==e?void 0:e.getAttributes)?void 0:s.call(e,t.NODE_TYPES.heading))?void 0:v[p])||(null==(E=null==(a=null==e?void 0:e.getAttributes)?void 0:a.call(e,t.NODE_TYPES.bulletList))?void 0:E[p])||(null==(c=null==(g=null==e?void 0:e.getAttributes)?void 0:g.call(e,t.NODE_TYPES.orderedList))?void 0:c[p])};


/***/ }),

/***/ 570267:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(561261),r=__webpack_require__(85097),o=__webpack_require__(143599),t=__webpack_require__(628912),n=Object.defineProperty,i=Object.getOwnPropertySymbols,l=Object.prototype.hasOwnProperty,c=Object.prototype.propertyIsEnumerable,u=(e,r,o)=>r in e?n(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,s=(e,r)=>{for(var o in r||(r={}))l.call(r,o)&&u(e,o,r[o]);if(i)for(var o of i(r))c.call(r,o)&&u(e,o,r[o]);return e};exports.getIconComponent=n=>{if(!(null==n?void 0:n.name))return null;const{device:i}=r.useStore(),{size:l}=r.getPropsByDevice(n,i);return e.jsx(o.Icon,s({},s({name:null==n?void 0:n.name},t.getPropsIcon({color:null==n?void 0:n.color,size:l}))))};


/***/ }),

/***/ 262560:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.getPartialDateTimeTimeZone7=e=>({year:new Intl.DateTimeFormat("en-GB",{timeZone:"Asia/Jakarta",year:"numeric"}).format(e),month:new Intl.DateTimeFormat("en-GB",{timeZone:"Asia/Jakarta",month:"2-digit"}).format(e),day:new Intl.DateTimeFormat("en-GB",{timeZone:"Asia/Jakarta",day:"2-digit"}).format(e),hour:new Intl.DateTimeFormat("en-GB",{timeZone:"Asia/Jakarta",hour:"2-digit",hour12:!1}).format(e),minute:new Intl.DateTimeFormat("en-GB",{timeZone:"Asia/Jakarta",minute:"2-digit"}).format(e),second:new Intl.DateTimeFormat("en-GB",{timeZone:"Asia/Jakarta",second:"2-digit"}).format(e)});


/***/ }),

/***/ 628912:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.getPropsIcon=e=>{const o={};return(null==e?void 0:e.color)&&(o.color=e.color),(null==e?void 0:e.size)&&(o.fontSize=e.size),{style:o}};


/***/ }),

/***/ 368380:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.getResponsiveAttrKey=(e,t)=>e+t.charAt(0).toUpperCase()+t.slice(1);


/***/ }),

/***/ 41259:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097);exports.getSizeWithUnit=i=>{if("number"==typeof(null==i?void 0:i.size))return`${null==i?void 0:i.size}${(null==i?void 0:i.unit)||e.UnitEnum.pixel}`};


/***/ }),

/***/ 409245:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097);const n="https://connect.facebook.net/vi_VN/sdk.js#xfbml=1&version=v22.0";exports.initFacebookEmbed=()=>{var l,o,i,r;const t=(null==(l=null==document?void 0:document.querySelector(`#${e.TEMPI_MAIN_IFRAME}`))?void 0:l.contentWindow)||window;if(null==t?void 0:t.document)if(t&&(null==(i=null==(o=null==t?void 0:t.FB)?void 0:o.XFBML)?void 0:i.parse))t.FB.XFBML.parse();else if(!t.document.querySelector(`script[src="${n}"]`)){t.fbAsyncInit=function(){var e,n,l,o;null==(n=null==(e=t.FB)?void 0:e.init)||n.call(e,{xfbml:!0,version:"v22.0"}),null==(o=null==(l=t.FB.XFBML)?void 0:l.parse)||o.call(l)};const e=t.document.createElement("script");e.src=n,e.async=!0,e.defer=!0,e.crossOrigin="anonymous",e.onload=function(){var e,n,l;null==(l=null==(n=null==(e=t.FB)?void 0:e.XFBML)?void 0:n.parse)||l.call(n)},null==(r=t.document.body)||r.appendChild(e)}};


/***/ }),

/***/ 266666:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(85097);exports.initInstagramEmbed=()=>{var t;const n=null==document?void 0:document.querySelector(`#${e.TEMPI_MAIN_IFRAME}`),s=null==(t=(null==n?void 0:n.contentWindow)||window)?void 0:t.document;if(s)if(s.querySelector('script[src*="instagram.com/embed.js"]')){const e=n.contentWindow;e.instgrm&&e.instgrm.Embeds&&e.instgrm.Embeds.process()}else{const e=s.createElement("script");e.async=!0,e.src="https://www.instagram.com/embed.js",s.head.appendChild(e),e.onload=()=>{const e=n.contentWindow;e.instgrm&&e.instgrm.Embeds&&e.instgrm.Embeds.process()}}};


/***/ }),

/***/ 196170:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.isUrlValid=e=>!!e.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);


/***/ }),

/***/ 138989:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=Object.defineProperty,r=Object.defineProperties,t=Object.getOwnPropertyDescriptors,l=Object.getOwnPropertySymbols,n=Object.prototype.hasOwnProperty,o=Object.prototype.propertyIsEnumerable,p=(r,t,l)=>t in r?e(r,t,{enumerable:!0,configurable:!0,writable:!0,value:l}):r[t]=l,i=(e,r)=>{for(var t in r||(r={}))n.call(r,t)&&p(e,t,r[t]);if(l)for(var t of l(r))o.call(r,t)&&p(e,t,r[t]);return e},a=(e,l)=>r(e,t(l));exports.flattenToTree=e=>{const r=(e,t)=>e.filter((e=>e.parentId===t)).map((t=>{const l=r(e,t.id);return a(i({},t),{children:l})}));return e.filter((e=>!e.parentId)).map((t=>a(i({},t),{children:r(e,t.id)})))},exports.getTargetUrl=e=>"BLANK"===e?"_blank":"_self",exports.getUrlOfMenuItem=(e,r=!1,t="")=>{var l,n;return r?null:"LINK"===(null==e?void 0:e.linkType)?e.href:(null==(l=null==e?void 0:e.page)?void 0:l.isHomepage)?`${t||"/"}`:t+"/"+(null==(n=null==e?void 0:e.page)?void 0:n.slug)};


/***/ }),

/***/ 681084:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(85097),e=__webpack_require__(800656);const r=t=>t?`in_cart_product_list_${t}`:"in_cart_product_list",n=()=>{const t=new Date,e=t.getDate(),r=t.getMonth()+1;return`${t.getFullYear().toString().slice(-2)}${r<10?`0${r}`:`${r}`}${e<10?`0${e}`:`${e}`}`};exports.clearProductInCart=t=>{localStorage.removeItem(r(t))},exports.customExtraFieldProductSubmit=t=>{var e,r,n;return[{name:"Tên sản phẩm",type:"string",value:null==(e=null==t?void 0:t[0])?void 0:e.name},{name:"Giá bán",type:"number",value:null==(n=null==(r=null==t?void 0:t[0])?void 0:r.price)?void 0:n.toString()}]},exports.customExtraFieldProductsSubmit=t=>{const e=null==t?void 0:t.reduce(((t,e,r)=>t+`${r+1}. ${e.name}: ${e.price} x ${e.quantity}\n`),"Chi tiết đơn:\n"),r=null==t?void 0:t.reduce(((t,e)=>t+(e.quantity||1)*(e.price||0)),0);return[{name:"Chi tiết đơn hàng",type:"string",value:e},{name:"Tổng thanh toán",type:"number",value:null==r?void 0:r.toString()}]},exports.generateCode=(t=8,e="1234567890ABCDYFGHIGKLMNOPQRSTUVWXYZ")=>{let r="",o=0|t;for(;o--;)r+=e[Math.random()*e.length|0];return`${n()}${r}`},exports.generateSku=()=>{const t=new Date,e=Math.floor((60*t.getHours()*60+60*t.getMinutes()+t.getSeconds())*Math.random()).toString().padStart(5,"0");return`${n()}${e}`},exports.getPrefixCode=n,exports.getPriceText=(r,n="đ",o="right")=>{const a=t.formatCurrencyVND(r,!1),i=n||e.t("đ");return"left"===o?`${i}${a}`:`${a} ${i}`},exports.getProductsInLocalCart=t=>JSON.parse(localStorage.getItem(r(t)))||[],exports.setProductsToLocalCart=(t,e)=>{const n=JSON.stringify(e);localStorage.setItem(r(t),n)};


/***/ }),

/***/ 324259:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.queryStringToObject=(e,t=[])=>{const r=new URLSearchParams(e),s={};for(const[e,o]of r)"string"==typeof o?t.includes(e)?s[e]=o.split(","):s[e]=o.trim():s[e]=o;return s};


/***/ }),

/***/ 426839:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports.getAttrTracking=t=>{if(!t)return{};const{regionName:e,contentName:n,target:o,payload:r}=t;return{"data-track-content":!0,"data-content-region-name":e,"data-content-name":n,"data-content-target":o,"data-content-payload":r}},exports.objectToAttrString=t=>{if(!t||0===Object.keys(t).length)return"";const e=[];for(const[n,o]of Object.entries(t))"boolean"==typeof o?e.push(`${n}=${o.toString().toLowerCase()}`):void 0!==o&&e.push(`${n}="${o}"`);return e.join(" ")};


/***/ }),

/***/ 80667:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(262560);exports.transformValuesGGSheet=(t,a)=>{const n=[];return a.forEach((a=>{let r=t[a.name];if("date"===a.type&&t[a.name]){const{year:n,month:m,day:o}=e.getPartialDateTimeTimeZone7(new Date(t[a.name]));r=`${o}-${m}-${n}`}if("datetime-local"===a.type&&t[a.name]){const{year:n,month:m,day:o,hour:i,minute:s,second:l}=e.getPartialDateTimeTimeZone7(new Date(t[a.name]));r=`${o}-${m}-${n} ${parseInt(i)>23?"00":i}:${s}:${l}`}("checkbox-group"===a.type&&!1===r||null==r)&&(r=""),n.push({name:a.name,value:"object"==typeof r?JSON.stringify(r):r,type:"number"===a.type?"number":"string"}),delete t[a.name]})),Object.keys(t).forEach((e=>{null!=t[e]&&null!=t[e]&&n.push({name:e,value:t[e],type:"string"})})),n};


/***/ }),

/***/ 361713:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0}));const e=(t,o=[null,void 0])=>{if("object"!=typeof t)return t;const r={};for(const s in t){const c=t[s];o.some((e=>c===e))||(r[s]=e(c))}return r};exports.clearObject=e;


/***/ }),

/***/ 268751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ s; }
/* harmony export */ });
/* harmony import */ var _hooks_useGetVisible_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(860426);
const s=({children:s,timeVisibility:e={},isEditingMode:t})=>{const{isVisible:o}=(0,_hooks_useGetVisible_es_js__WEBPACK_IMPORTED_MODULE_0__/* .useGetVisible */ .m)(e);return o||t?s:null};


/***/ }),

/***/ 12913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ n; }
/* harmony export */ });
const n="\n    .animation-hidden {\n        visibility: hidden!important;\n        opacity: 0!important;\n    }\n\n    @keyframes bg-marquee-horizontal {\n        0% {\n          background-position-x: 0;\n        }\n      \n        100% {\n          background-position-x: -99999px;\n        }\n      }\n  \n      @keyframes bg-marquee-vertical {\n        0% {\n          background-position-y: 0;\n        }\n      \n        100% {\n          background-position-y: -99999px;\n        }\n    }\n";


/***/ }),

/***/ 791790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dy": function() { return /* binding */ d; },
/* harmony export */   "EB": function() { return /* binding */ u; },
/* harmony export */   "UI": function() { return /* binding */ n; },
/* harmony export */   "a$": function() { return /* binding */ o; },
/* harmony export */   "aE": function() { return /* binding */ S; },
/* harmony export */   "em": function() { return /* binding */ t; },
/* harmony export */   "kC": function() { return /* binding */ i; },
/* harmony export */   "tC": function() { return /* binding */ e; },
/* harmony export */   "wc": function() { return /* binding */ l; },
/* harmony export */   "wp": function() { return /* binding */ r; }
/* harmony export */ });
/* harmony import */ var _types_common_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(883786);
const e=["Alfa Slab One","Anton","Arima Madurai","Arimo","Athiti","Bahianita","Baloo Bhaina","Barlow","Barlow Condensed","Bungee","Bungee Inline","Bungee Outline","Bungee Shade","Cabin","Chonburi","Cormorant Upright","Crimson Pro","Dancing Script","Dosis","EB Garamond","Exo","Epilogue","Fira Sans","Hepta Slab","Inconsolata","Inter","Itim","Josefin Sans","Judson","Jura","Kanit","K2D","Lexend","Literata","Lobster","Lora","Manrope","Maven Pro","Merriweather","Montserrat","Mulish","Niramit","Noto Serif","Open Sans","Oswald","Pattaya","Paytone One","Philosopher","Play","Playfair Display","Poppins","Prata","Quicksand","Raleway","Roboto","Roboto Slab","Rokkitt","Source Sans Pro","Space Grotesk","Sriracha","Taviraj","Thasadith","Tinos","Trirong","VT323","Work Sans","Yeseva One"],n=e.map((e=>({source:_types_common_es_js__WEBPACK_IMPORTED_MODULE_0__/* .FontSource.GOOGLE */ .gY.GOOGLE,name:e}))),i="https://storage.googleapis.com/teko-landing-builder-cdn/tempi-editor-v2/font-static-file/fontPreviewSvg.json",o={"100 (Thin)":100,"200 (Extra Light)":200,"300 (Light)":300,"400 (Regular)":400,"500 (Medium)":500,"600 (Semi Bold)":600,"700 (Bold)":700,"800 (Extra Bold)":800,"900 (Black)":900},r=Object.values(o).join(";"),l=e.map((a=>`family=${encodeURIComponent(a)}:wght@${r}`)).join("&"),t="Roboto",s=["ABeeZee","Abel","Abhaya Libre","Abril Fatface","Abyssinica SIL","Aclonica","Acme","Actor","Adamina","Advent Pro","Aguafina Script","Akaya Kanadaka","Akaya Telivigala","Akronim","Akshar","Aladin","Alata","Alatsi","Aldrich","Alef","Alegreya","Alegreya Sans","Alegreya Sans SC","Alegreya SC","Aleo","Alex Brush","Alfa Slab One","Alice","Alike","Alike Angular","Allan","Allerta","Allerta Stencil","Allison","Allura","Almarai","Almendra","Almendra Display","Almendra SC","Alumni Sans","Alumni Sans Collegiate One","Alumni Sans Inline One","Amarante","Amaranth","Amatic SC","Amatica SC","Amethysta","Amiko","Amiri","Amita","Anaheim","Andada Pro","Andika","Andika New Basic","Anek Bangla","Anek Devanagari","Anek Gujarati","Anek Gurmukhi","Anek Kannada","Anek Latin","Anek Malayalam","Anek Odia","Anek Tamil","Anek Telugu","Angkor","Annie Use Your Telescope","Anonymous Pro","Antic","Antic Didone","Antic Slab","Anton","Antonio","Anybody","Aoboshi One","Arapey","Arbutus","Arbutus Slab","Architects Daughter","Archivo","Archivo Black","Archivo Narrow","Are You Serious","Aref Ruqaa","Aref Ruqaa Ink","Arima Madurai","Arimo","Arizonia","Armata","Arsenal","Artifika","Arvo","Arya","Asap","Asap Condensed","Asar","Asset","Assistant","Astloch","Asul","Athiti","Atkinson Hyperlegible","Atma","Atomic Age","Aubrey","Audiowide","Autour One","Average","Average Sans","Averia Gruesa Libre","Averia Libre","Averia Sans Libre","Averia Serif Libre","Azeret Mono","B612","B612 Mono","Babylonica","Bad Script","Bahiana","Bahianita","Bai Jamjuree","Bakbak One","Ballet","Baloo","'Baloo 2'","Baloo Bhai","Baloo Bhai 2","Baloo Bhaijaan","Baloo Bhaijaan 2","Baloo Bhaina","Baloo Bhaina 2","Baloo Chettan","Baloo Chettan 2","Baloo Da","Baloo Da 2","Baloo Paaji","Baloo Paaji 2","Baloo Tamma","Baloo Tamma 2","Baloo Tammudu","Baloo Tammudu 2","Baloo Thambi","Baloo Thambi 2","Balsamiq Sans","Balthazar","Bangers","Barlow","Barlow Condensed","Barlow Semi Condensed","Barriecito","Barrio","Basic","Baskervville","Battambang","Baumans","Bayon","Be Vietnam","Be Vietnam Pro","Beau Rivage","Bebas Neue","Belgrano","Bellefair","Belleza","Bellota","Bellota Text","BenchNine","Benne","Bentham","Berkshire Swash","Besley","Beth Ellen","Bevan","BhuTuka Expanded One","Big Shoulders Display","Big Shoulders Inline Display","Big Shoulders Inline Text","Big Shoulders Stencil Display","Big Shoulders Stencil Text","Big Shoulders Text","Bigelow Rules","Bigshot One","Bilbo","Bilbo Swash Caps","BioRhyme","BioRhyme Expanded","Birthstone","Birthstone Bounce","Biryani","Bitter","BIZ UDGothic","BIZ UDMincho","BIZ UDPGothic","BIZ UDPMincho","Black And White Picture","Black Han Sans","Black Ops One","Blaka Ink","Blinker","Bodoni Moda","Bokor","Bona Nova","Bonbon","Bonheur Royale","Boogaloo","Bowlby One","Bowlby One SC","Brawler","Bree Serif","Bruno Ace","Bruno Ace SC","'Brygada 1918'","Bubblegum Sans","Bubbler One","Buenard","Bungee","Bungee Hairline","Bungee Inline","Bungee Outline","Bungee Shade","Butcherman","Butcherman Caps","Butterfly Kids","Cabin","Cabin Condensed","Cabin Sketch","Caesar Dressing","Cagliostro","Cairo","Caladea","Calistoga","Calligraffitti","Cambay","Cambo","Candal","Cantarell","Cantata One","Cantora One","Capriola","Caramel","Carattere","Cardo","Carme","Carrois Gothic","Carrois Gothic SC","Carter One","Castoro","Catamaran","Caudex","Caveat","Caveat Brush","Cedarville Cursive","Ceviche One","Chakra Petch","Changa","Changa One","Chango","Charm","Charmonman","Chathura","Chau Philomene One","Chela One","Chelsea Market","Cherish","Cherry Bomb","Cherry Bomb One","Cherry Cream Soda","Cherry Swash","Chewy","Chicle","Chilanka","Chivo","Chokokutai","Chonburi","Cinzel","Cinzel Decorative","Clicker Script","Coda","Codystar","Coiny","Combo","Comfortaa","Comforter","Comforter Brush","Comic Neue","Coming Soon","Commissioner","Concert One","Condiment","Contrail One","Convergence","Cookie","Copse","Corben","Corinthia","Cormorant","Cormorant Garamond","Cormorant Infant","Cormorant SC","Cormorant Unicase","Cormorant Upright","Courgette","Courier Prime","Cousine","Coustard","Covered By Your Grace","Crafty Girls","Creepster","Creepster Caps","Crete Round","Crimson Pro","Crimson Text","Croissant One","Crushed","Cuprum","Cute Font","Cutive","Cutive Mono","Damion","Dancing Script","Dangrek","Darker Grotesque","Darumadrop One","David Libre","Dawning of a New Day","Days One","Dekko","Dela Gothic One","Delius","Delius Swash Caps","Delius Unicase","Della Respira","Denk One","Devonshire","Dhurjati","Dhyana","Didact Gothic","Diplomata","Diplomata SC","DM Mono","DM Sans","DM Serif Display","DM Serif Text","Dokdo","Domine","Donegal One","Dongle","Doppio One","Dorsa","Dosis","DotGothic16","Dr Sugiyama","Droid Sans","Duru Sans","Dynalight","Eagle Lake","East Sea Dokdo","Eater","EB Garamond","Economica","Eczar","Ek Mukta","El Messiri","Electrolize","Elsie","Elsie Swash Caps","Emblema One","Emilys Candy","Encode Sans","Encode Sans Condensed","Encode Sans Expanded","Encode Sans SC","Encode Sans Semi Condensed","Encode Sans Semi Expanded","Engagement","Englebert","Enriqueta","Ephesis","Epilogue","Erica One","Esteban","Estonia","Euphoria Script","Ewert","Exo","Exo 2","Expletus Sans","Explora","Fahkwang","Familjen Grotesk","Fanwood Text","Farro","Farsan","Fascinate","Fascinate Inline","Faster One","Fasthand","Fauna One","Faustina","Federant","Federo","Felipa","Fenix","Festive","Finger Paint","Fira Code","Fira Mono","Fira Sans","Fira Sans Condensed","Fira Sans Extra Condensed","Fjalla One","Fjord One","Flamenco","Flavors","Fleur De Leah","Flow Block","Flow Circular","Flow Rounded","Fondamento","Fontdiner Swanky","Forum","Francois One","Frank Ruhl Libre","Fraunces","Freckle Face","Fredericka the Great","Fredoka","Fredoka One","Freehand","Fresca","Frijole","Fruktur","Fugaz One","Fuggles","Fuzzy Bubbles","Gabriela","Gaegu","Gafata","Galada","Galdeano","Galindo","Gamja Flower","Gayathri","Gelasio","Gemunu Libre","Genos","Gentium Basic","Gentium Book Basic","Geo","Georama","Geostar","Geostar Fill","Germania One","GFS Didot","GFS Neohellenic","Gideon Roman","Gidugu","Gilda Display","Girassol","Give You Glory","Glass Antiqua","Glegoo","Gloria Hallelujah","Glory","Gluten","Goblin One","Gochi Hand","Goldman","Gorditas","Gothic A1","Gotu","'Goudy Bookletter 1911'","Gowun Batang","Gowun Dodum","Graduate","Grand Hotel","Grandstander","Grape Nuts","Gravitas One","Great Vibes","Grechen Fuemen","Grenze","Grenze Gotisch","Grey Qo","Griffy","Gruppo","Gudea","Gugi","Gupter","Gurajada","Gwendolyn","Habibi","Hachi Maru Pop","Hahmlet","Halant","Hammersmith One","Hanalei","Hanalei Fill","Handjet","Handlee","Hanuman","Happy Monkey","Harmattan","Headland One","Heebo","Henny Penny","Hepta Slab","Herr Von Muellerhoff","Hi Melody","Hina Mincho","Hind","Hind Guntur","Hind Madurai","Hind Siliguri","Hind Vadodara","Holtwood One SC","Homemade Apple","Homenaje","Hubballi","Hurricane","Ibarra Real Nova","IBM Plex Mono","IBM Plex Sans","IBM Plex Sans Condensed","IBM Plex Sans Devanagari","IBM Plex Sans Hebrew","IBM Plex Sans KR","IBM Plex Sans Thai","IBM Plex Sans Thai Looped","IBM Plex Serif","Iceberg","Iceland","IM Fell Double Pica","IM Fell Double Pica SC","IM Fell DW Pica","IM Fell DW Pica SC","IM Fell English","IM Fell English SC","IM Fell French Canon","IM Fell French Canon SC","IM Fell Great Primer","IM Fell Great Primer SC","Imbue","Imperial Script","Imprima","Inconsolata","Inder","Indie Flower","Ingrid Darling","Inika","Inknut Antiqua","Inria Sans","Inria Serif","Inspiration","Inter","Irish Grover","Island Moments","Istok Web","Italiana","Italianno","Itim","Jacques Francois","Jacques Francois Shadow","Jaldi","JetBrains Mono","Jim Nightshade","Jockey One","Jolly Lodger","Jomhuria","Jomolhari","Josefin Sans","Josefin Slab","Jost","Joti One","Jua","Judson","Julee","Julius Sans One","Junge","Jura","Just Another Hand","Just Me Again Down Here","K2D","Kadwa","Kaisei Decol","Kaisei HarunoUmi","Kaisei Opti","Kaisei Tokumin","Kalam","Kameron","Kanit","Karantina","Karla","Karma","Katibeh","Kaushan Script","Kavivanar","Kavoon","Keania One","Kelly Slab","Kenia","Khand","Khula","Kings","Kite One","Kiwi Maru","Klee One","Knewave","Kodchasan","Koh Santepheap","KoHo","Kolker Brush","Kosugi","Kosugi Maru","Kotta One","Koulen","Kranky","Kreon","Kristi","Krona One","Krub","Kufam","Kulim Park","Kumar One","Kumbh Sans","Kurale","La Belle Aurore","Lacquer","Laila","Lakki Reddy","Lalezar","Lancelot","Langar","Lateef","Lato","Lavishly Yours","League Gothic","League Script","League Spartan","Leckerli One","Ledger","Lekton","Lemon","Lemonada","Lexend","Lexend Deca","Lexend Exa","Lexend Giga","Lexend Mega","Lexend Peta","Lexend Tera","Lexend Zetta","Libre Barcode 128","Libre Barcode 128 Text","Libre Barcode 39","Libre Barcode 39 Extended","Libre Barcode 39 Extended Text","Libre Barcode 39 Text","Libre Barcode EAN13 Text","Libre Baskerville","Libre Bodoni","Libre Caslon Display","Libre Caslon Text","Libre Franklin","Licorice","Life Savers","Lilita One","Lily Script One","Limelight","Linden Hill","Literata","Liu Jian Mao Cao","Livvic","Lobster","Lobster Two","Londrina Outline","Londrina Shadow","Londrina Sketch","Londrina Solid","Long Cang","Lora","Love Light","Love Ya Like A Sister","Loved by the King","Lovers Quarrel","Luckiest Guy","Lusitana","Lustria","Luxurious Roman","Luxurious Script","'M PLUS 1'","'M PLUS 1 Code'","'M PLUS 2'","M PLUS Code Latin","Ma Shan Zheng","Macondo","Macondo Swash Caps","Mada","Magra","Maiden Orange","Maitree","Major Mono Display","Mako","Mali","Mallanna","Mandali","Manjari","Manrope","Mansalva","Manuale","Marcellus","Marcellus SC","Marck Script","Margarine","Markazi Text","Marko One","Marmelad","Martel","Martel Sans","Marvel","Mate","Mate SC","Maven Pro","McLaren","Mea Culpa","Meddon","MedievalSharp","Medula One","Meera Inimai","Megrim","Meie Script","Meow Script","Merienda","Merienda One","Merriweather","Merriweather Sans","Metal","Metal Mania","Metamorphous","Metrophobic","Michroma","Milonga","Miltonian","Miltonian Tattoo","Mina","Miniver","Miriam Libre","Mirza","Miss Fajardose","Mitr","Mochiy Pop One","Mochiy Pop P One","Modak","Modern Antiqua","Mogra","Mohave","Molengo","Molle","Monda","Monofett","Monomaniac One","Monoton","Monsieur La Doulaise","Montaga","Montagu Slab","MonteCarlo","Montez","Montserrat","Montserrat Alternates","Montserrat Subrayada","Moo Lah Lah","Moon Dance","Moul","Moulpali","Mountains of Christmas","Mouse Memoirs","Mr Bedfort","Mr Dafoe","Mr De Haviland","Mrs Saint Delafield","Mrs Sheppards","Ms Madi","Mukta","Mukta Mahee","Mukta Malar","Mukta Vaani","Mulish","Murecho","MuseoModerno","My Soul","Mystery Quest","Nanum Brush Script","Nanum Gothic","Nanum Gothic Coding","Nanum Myeongjo","Neonderthaw","Nerko One","Neucha","Neuton","New Rocker","New Tegomin","News Cycle","Newsreader","Niconne","Niramit","Nixie One","Nobile","Nokora","Norican","Nosifer","Nosifer Caps","Notable","Nothing You Could Do","Noto Traditional Nushu","Nova Cut","Nova Flat","Nova Oval","Nova Round","Nova Script","Nova Slim","Nova Square","Nova Mono","NTR","Numans","Nunito","Nunito Sans","Odibee Sans","Odor Mean Chey","Offside","OFL Sorts Mill Goudy TT","Oi","Old Standard TT","Oldenburg","Ole","Oleo Script","Oleo Script Swash Caps","Oooh Baby","Open Sans","Oranienbaum","Orbitron","Oregano","Orelega One","Orienta","Original Surfer","Oswald","Otomanopee One","Outfit","Over the Rainbow","Overlock","Overlock SC","Overpass","Overpass Mono","Ovo","Oxanium","Oxygen","Oxygen Mono","Pacifico","Padauk","Palanquin","Palanquin Dark","Palette Mosaic","Pangolin","Paprika","Parisienne","Passero One","Passion One","Passions Conflict","Pathway Gothic One","Patrick Hand","Patrick Hand SC","Pattaya","Patua One","Pavanam","Paytone One","Peddana","Peralta","Permanent Marker","Petemoss","Petit Formal Script","Petrona","Philosopher","Piazzolla","Piedra","Pinyon Script","Pirata One","Plaster","Play","Playball","Playfair Display","Playfair Display SC","Plus Jakarta Sans","Podkova","Poetsen One","Poiret One","Poller One","Poly","Pompiere","Pontano Sans","Poor Story","Poppins","Port Lligat Sans","Port Lligat Slab","Potta One","Pragati Narrow","Praise","Prata","Preahvihear","Press Start 2P","Pridi","Princess Sofia","Prociono","Prompt","Prosto One","Proza Libre","PT Mono","PT Sans","PT Sans Caption","PT Sans Narrow","PT Serif","PT Serif Caption","Public Sans","Puppies Play","Puritan","Purple Purse","Qahiri","Quando","Quantico","Quattrocento","Quattrocento Sans","Questrial","Quicksand","Quintessential","Qwigley","Qwitcher Grypen","Racing Sans One","Radio Canada","Radley","Rajdhani","Rakkas","Raleway","Raleway Dots","Ramabhadra","Ramaraja","Rambla","Rammetto One","Rampart One","Ranchers","Rancho","Ranga","Rasa","Rationale","Ravi Prakash","Readex Pro","Recursive","Red Hat Display","Red Hat Mono","Red Hat Text","Red Rose","Redacted","Redacted Script","Redressed","Reem Kufi","Reem Kufi Fun","Reem Kufi Ink","Reenie Beanie","Reggae One","Revalia","Rhodium Libre","Ribeye","Ribeye Marrow","Righteous","Risque","Road Rage","Roboto","Roboto Condensed","Roboto Flex","Roboto Mono","Roboto Serif","Roboto Slab","Rochester","Rock 3D","Rock Salt","RocknRoll One","Rokkitt","Romanesco","Ropa Sans","Rosario","Rosarivo","Rouge Script","Rowdies","Rozha One","Rubik","Rubik Beastly","Rubik Bubbles","Rubik Glitch","Rubik Microbe","Rubik Mono One","Rubik Moonrocks","Rubik One","Rubik Puddles","Rubik Wet Paint","Ruda","Rufina","Ruge Boogie","Ruluko","Rum Raisin","Ruslan Display","Russo One","Ruthie","Rye","Sacramento","Sahitya","Sail","Saira","Saira Condensed","Saira Stencil One","Salsa","Sanchez","Sancreek","Sansita","Sansita One","Sansita Swashed","Sarabun","Sarala","Sarina","Sarpanch","Sassy Frass","Satisfy","Sawarabi Gothic","Sawarabi Mincho","Scada","Scheherazade","Scheherazade New","Schoolbell","Scope One","Seaweed Script","Secular One","Sedan","Sedan SC","Sedgwick Ave","Sedgwick Ave Display","Sen","Send Flowers","Sevillana","Seymour One","Shadows Into Light","Shadows Into Light Two","Shalimar","Shanti","Share","Share Tech","Share Tech Mono","Shippori Antique","Shippori Antique B1","Shippori Mincho","Shippori Mincho B1","Shizuru","Shojumaru","Short Stack","Shrikhand","Sigmar One","Signika","Signika Negative","Simonetta","Single Day","Sintony","Sirin Stencil","Six Caps","Skranji","Slabo 13px","Slabo 27px","Slackey","Slackside One","Smokum","Smooch","Smooch Sans","Smythe","Sniglet","Snippet","Snowburst One","Sofadi One","Sofia","Sofia Sans","Solway","Sometype Mono","Song Myung","Sonsie One","Sora","Sorts Mill Goudy","Source Code Pro","Source Sans 3","Source Sans Pro","Source Serif 4","Source Serif Pro","Space Grotesk","Space Mono","Spartan","Special Elite","Spectral","Spectral SC","Spicy Rice","Spinnaker","Spirax","Spline Sans","Spline Sans Mono","Squada One","Square Peg","Sree Krushnadevaraya","Sriracha","Srisakdi","Staatliches","Stalemate","Stalinist One","Stardos Stencil","Stick","Stick No Bills","Stint Ultra Condensed","Stint Ultra Expanded","STIX Two Math","STIX Two Text","Stoke","Strait","Style Script","Stylish","Sue Ellen Francisco","Suez One","Sulphur Point","Sumana","Sunflower","Sunshiney","Sura","Suranna","Suravaram","Suwannaphum","Swanky and Moo Moo","Syncopate","Syne","Syne Mono","Syne Tactile","Tajawal","Tangerine","Tapestry","Taprom","Tauri","Taviraj","Teko","Telex","Tenali Ramakrishna","Tenor Sans","Text Me One","Texturina","Thabit","Thasadith","The Girl Next Door","The Nautigal","Tienne","Tillana","Timmana","Tinos","Tiro Bangla","Tiro Devanagari Hindi","Tiro Devanagari Marathi","Tiro Devanagari Sanskrit","Tiro Gurmukhi","Tiro Kannada","Tiro Tamil","Tiro Telugu","Titan One","Titillium Web","Tomorrow","Tourney","Trade Winds","Train One","Trirong","Trispace","Trocchi","Trochut","Truculenta","Trykker","Tsukimi Rounded","Tulpen One","Turret Road","Twinkle Star","Ubuntu","Ubuntu Condensed","Ubuntu Mono","Uchen","Ultra","Uncial Antiqua","Underdog","Unica One","UnifrakturCook","UnifrakturMaguntia","Unkempt","Unlock","Unna","Updock","Urbanist","Vampiro One","Varela","Varela Round","Varta","Vast Shadow","Vazirmatn","Vesper Libre","Viaoda Libre","Vibes","Vibur","Vidaloka","Viga","Voces","Volkhov","Vollkorn","Vollkorn SC","Voltaire","VT323","Vujahday Script","Waiting for the Sunrise","Wallpoet","Walter Turncoat","Warnes","Water Brush","Waterfall","Wellfleet","Wendy One","Whisper","WindSong","Wire One","Work Sans","Xanh Mono","Yaldevi","Yanone Kaffeesatz","Yantramanav","Yatra One","Yellowtail","Yeseva One","Yesteryear","Yomogi","Yrsa","Yuji Boku","Yuji Hentaigana Akari","Yuji Hentaigana Akebono","Yuji Mai","Yuji Syuku","Yusei Magic","ZCOOL KuaiLe","ZCOOL QingKe HuangYou","ZCOOL XiaoWei","Zen Antique","Zen Antique Soft","Zen Dots","Zen Kaku Gothic Antique","Zen Kaku Gothic New","Zen Kurenaido","Zen Loop","Zen Maru Gothic","Zen Old Mincho","Zen Tokyo Zoo","Zeyada","Zhi Mang Xing","Zilla Slab","Zilla Slab Highlight"],u=new Set(s),d=["FH Cordelia","SVN Hottroof Semhesta","Delta Jaeger Bold Italic","Delta Jaeger Bold","Delta Jaeger Book Italic","Delta Jaeger Book","Delta Jaeger Light Italic","Delta Jaeger Light","Delta Jaeger Medium Italic","Delta Jaeger Medium","Maiden Crimes","Ganh Regular","Ganh Regular Italic","Ganh Thin","Ganh Thin Italic","Times New Roman","UTM Avo","UTM Avo Bold","UTM Avo Bold Italic","UTM Avo Italic","Maison Neue Extended Bold","Maison Neue Extended Book","Maison Neue Extended Demi","Maison Neue Extended Medium","Myriadpro Regular","SVN-Gilroy Black","SVN-Gilroy Bold Italic","SVN-Gilroy Bold","SVN-Gilroy Heavy Italic","SVN-Gilroy Heavy","SVN-Gilroy Italic","SVN-Gilroy Light","SVN-Gilroy Medium Italic","SVN-Gilroy Medium","SVN-Gilroy Regular","SVN-Gilroy SemiBold Italic","SVN-Gilroy SemiBold","SVN-Gilroy Thin Italic","SVN-Gilroy Thin","SVN-Gilroy XBold Italic","SVN-Gilroy XBold","SVN-Gilroy Xlight Italic","SVN-Gilroy Xlight","SVN-Gilroy Black Italic","DC Monument Extended Ultrabold","Noto Serif JP","GT-Walsheim-Black-Oblique","GT-Walsheim-Black","GT-Walsheim-Bold-Oblique","GT-Walsheim-Bold","GT-Walsheim-Condensed-Black-Oblique","GT-Walsheim-Condensed-Black","GT-Walsheim-Condensed-Bold-Oblique","GT-Walsheim-Condensed-Bold","GT-Walsheim-Condensed-Light-Oblique","GT-Walsheim-Condensed-Light","GT-Walsheim-Condensed-Medium-Oblique","GT-Walsheim-Condensed-Medium","GT-Walsheim-Condensed-Regular-Oblique","GT-Walsheim-Condensed-Regular","GT-Walsheim-Condensed-Thin-Oblique","GT-Walsheim-Condensed-Thin","GT-Walsheim-Condensed-Ultra-Bold-Oblique","GT-Walsheim-Condensed-Ultra-Bold","GT-Walsheim-Condensed-Ultra-Light-Oblique","GT-Walsheim-Condensed-Ultra-Light","GT-Walsheim-Light-Oblique","GT-Walsheim-Light","GT-Walsheim-Medium-Oblique","GT-Walsheim-Medium","GT-Walsheim-Regular-Oblique","GT-Walsheim-Regular","GT-Walsheim-Thin-Oblique","GT-Walsheim-Thin","GT-Walsheim-Ultra-Bold-Oblique","GT-Walsheim-Ultra-Bold","GT-Walsheim-Ultra-Light-Oblique","GT-Walsheim-Ultra-Light","Georgia"],S=new Set([...s,...d]);


/***/ }),

/***/ 474402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B4": function() { return /* binding */ u; },
/* harmony export */   "Fd": function() { return /* binding */ g; },
/* harmony export */   "GJ": function() { return /* binding */ d; },
/* harmony export */   "Yn": function() { return /* binding */ b; },
/* harmony export */   "Zq": function() { return /* binding */ f; },
/* harmony export */   "d1": function() { return /* binding */ h; },
/* harmony export */   "jS": function() { return /* binding */ m; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _fonts_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(791790);
/* harmony import */ var react_helmet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(616357);
var a=Object.defineProperty,p=Object.defineProperties,r=Object.getOwnPropertyDescriptors,n=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,c=Object.prototype.propertyIsEnumerable,l=(t,e,s)=>e in t?a(t,e,{enumerable:!0,configurable:!0,writable:!0,value:s}):t[e]=s;const f=[{rel:"preconnect",href:"https://fonts.googleapis.com"},{rel:"preconnect",href:"https://fonts.gstatic.com",crossOrigin:"anonymous"},{rel:"preLoad stylesheet",href:`https://fonts.googleapis.com/css2?${_fonts_es_js__WEBPACK_IMPORTED_MODULE_3__/* .fontQueryParams */ .wc}&display=swap`,as:"style",type:"text/css"},{rel:"preLoad stylesheet",href:"https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css",as:"style",type:"text/css"}],m=[{rel:"preconnect",href:"https://fonts.googleapis.com"},{rel:"preconnect",href:"https://fonts.gstatic.com",crossOrigin:"anonymous"},{rel:"preLoad stylesheet",href:"https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css",as:"style",type:"text/css"},{rel:"preLoad stylesheet",href:"https://storage.googleapis.com/teko-landing-builder-cdn/tempi-editor-v2/font-static-file/tempi-font-face.css",as:"style",type:"text/css"}],h=()=>(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_helmet__WEBPACK_IMPORTED_MODULE_2__/* .Helmet */ .q,{children:f.map(((t,s)=>{return (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)("link",(o=((t,e)=>{for(var s in e||(e={}))i.call(e,s)&&l(t,s,e[s]);if(n)for(var s of n(e))c.call(e,s)&&l(t,s,e[s]);return t})({},t),p(o,r({key:s}))));var o}))}),g={local:"http://localhost:8081",dev:"https://public-builder-bff.dev.tekoapis.net",stag:"https://public-builder-bff.stag.tekoapis.net",production:"https://public.tempi.vn","test-1":"https://public-builder-bff.test-1.tekoapis.net",internal:"http://public-bff-api.page-management"},b={local:"http://localhost:8081",dev:"https://pinpos-retail-bff.dev.tekoapis.net",stag:"https://pinpos-retail-bff.stag.tekoapis.net",production:"https://pinpos-retail-bff.tekoapis.com"},d={local:"https://consumer-bff.dev.tekoapis.net",dev:"https://consumer-bff.dev.tekoapis.net",stag:"https://consumer-bff.stag.tekoapis.net",production:"https://consumer-bff.tekoapis.com"},u={local:"https://mkt-gateway.dev.tekoapis.net",dev:"https://mkt-gateway.dev.tekoapis.net",stag:"https://mkt-gateway.stag.tekoapis.net",production:"https://mkt-gateway.tekoapis.com"};


/***/ }),

/***/ 49563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ n; }
/* harmony export */ });
const n="\n.rc-cascader {\n  font-size: 12px;\n}\n.rc-cascader-menus {\n  font-size: 12px;\n  overflow: hidden;\n  background: #fff;\n  position: absolute;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  box-shadow: 0 0 4px rgba(0,0,0,0.17);\n  white-space: nowrap;\n}\n.rc-cascader-menus-hidden {\n  display: none;\n}\n.rc-cascader-menus.slide-up-enter, .rc-cascader-menus.slide-up-appear {\n  animation-duration: .3s;\n  animation-fill-mode: both;\n  transform-origin: 0 0;\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08,0.82,0.17,1);\n  animation-play-state: paused;\n}\n.rc-cascader-menus.slide-up-leave {\n  animation-duration: .3s;\n  animation-fill-mode: both;\n  transform-origin: 0 0;\n  opacity: 1;\n  animation-timing-function: cubic-bezier(0.6,0.04,0.98,0.34);\n  animation-play-state: paused;\n}\n.rc-cascader-menus.slide-up-enter.slide-up-enter-active.rc-cascader-menus-placement-bottomLeft, .rc-cascader-menus.slide-up-appear.slide-up-appear-active.rc-cascader-menus-placement-bottomLeft {\n  animation-name: SlideUpIn;\n  animation-play-state: running;\n}\n.rc-cascader-menus.slide-up-enter.slide-up-enter-active.rc-cascader-menus-placement-topLeft, .rc-cascader-menus.slide-up-appear.slide-up-appear-active.rc-cascader-menus-placement-topLeft {\n  animation-name: SlideDownIn;\n  animation-play-state: running;\n}\n.rc-cascader-menus.slide-up-leave.slide-up-leave-active.rc-cascader-menus-placement-bottomLeft {\n  animation-name: SlideUpOut;\n  animation-play-state: running;\n}\n.rc-cascader-menus.slide-up-leave.slide-up-leave-active.rc-cascader-menus-placement-topLeft {\n  animation-name: SlideDownOut;\n  animation-play-state: running;\n}\n.rc-cascader-menu {\n  display: inline-block;\n  height: 192px;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  padding-right:1em\n  border-right: 1px solid #e9e9e9;\n  overflow: auto;\n}\n.rc-cascader-menu:last-child {\n  border-right: 0;\n}\n.rc-cascader-menu-item {\n  height: 32px;\n  line-height: 32px;\n  padding: 0 16px;\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: all 0.3s ease;\n  position: relative;\n}\n.rc-cascader-menu-item:hover {\n  background: #2db6f5e7;\n}\n.rc-cascader-menu-item-disabled {\n  cursor: not-allowed;\n  color: #ccc;\n}\n.rc-cascader-menu-item-disabled:hover {\n  background: transparent;\n}\n.rc-cascader-menu-item-loading:after {\n  position: absolute;\n  right: 12px;\n  content: 'loading';\n  color: #aaa;\n  font-style: italic;\n}\n.rc-cascader-menu-item-active {\n  background:  #2db6f5dd;\n}\n.rc-cascader-menu-item-active:hover {\n  background:  #2db6f5e7;\n}\n.rc-cascader-menu-item-expand {\n  position: relative;\n}\n.rc-cascader-menu-item-expand-icon {\n  font-size: 12px;\n  color: #999;\n  position: absolute;\n  right: 16px;\n  line-height: 32px;\n}\n@keyframes SlideUpIn {\n  0% {\n    opacity: 0;\n    transform-origin: 0% 0%;\n    transform: scaleY(.8);\n }\n  100% {\n    opacity: 1;\n    transform-origin: 0% 0%;\n    transform: scaleY(1);\n }\n}\n@keyframes SlideUpOut {\n  0% {\n    opacity: 1;\n    transform-origin: 0% 0%;\n    transform: scaleY(1);\n }\n  100% {\n    opacity: 0;\n    transform-origin: 0% 0%;\n    transform: scaleY(0.8);\n }\n}\n@keyframes SlideDownIn {\n  0% {\n    opacity: 0;\n    transform-origin: 0% 100%;\n    transform: scaleY(0.8);\n }\n  100% {\n    opacity: 1;\n    transform-origin: 0% 100%;\n    transform: scaleY(1);\n }\n}\n@keyframes SlideDownOut {\n  0% {\n    opacity: 1;\n    transform-origin: 0% 100%;\n    transform: scaleY(1);\n }\n  100% {\n    opacity: 0;\n    transform-origin: 0% 100%;\n    transform: scaleY(0.8);\n }\n}\n\n";


/***/ }),

/***/ 577995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ n; }
/* harmony export */ });
const n="\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n  }\n\n  html {\n    scroll-behavior: smooth;\n  }\n  \n  [tabindex='-1']:focus:not(:focus-visible) {\n    outline: 0 !important;\n  }\n\n  hr {\n    margin: 1rem 0;\n    color: inherit;\n    background-color: currentColor;\n    border: 0;\n    opacity: 0.25;\n  }\n\n  hr:not([size]) {\n    height: 1px;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    margin-top: 0;\n    margin-bottom: 0.5rem;\n    font-weight: 500;\n    line-height: 1.3;\n    color: unset;\n  }\n\n  h1 {\n    font-size: calc(1.375rem + 1.5vw);\n  }\n\n  @media (min-width: 1200px) {\n    h1 {\n      font-size: 2.5rem;\n    }\n  }\n\n  h2 {\n    font-size: calc(1.325rem + 0.9vw);\n  }\n\n  @media (min-width: 1200px) {\n    h2 {\n      font-size: 2rem;\n    }\n  }\n\n  h3 {\n    font-size: calc(1.3rem + 0.6vw);\n  }\n\n  @media (min-width: 1200px) {\n    h3 {\n      font-size: 1.75rem;\n    }\n  }\n\n  h4 {\n    font-size: calc(1.275rem + 0.3vw);\n  }\n\n  @media (min-width: 1200px) {\n    h4 {\n      font-size: 1.5rem;\n    }\n  }\n\n  h5 {\n    font-size: 1.25rem;\n  }\n\n  h6 {\n    font-size: 1rem;\n  }\n\n  p {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  abbr[title],\n  abbr[data-original-title] {\n    text-decoration: underline;\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n    cursor: help;\n    -webkit-text-decoration-skip-ink: none;\n    text-decoration-skip-ink: none;\n  }\n\n  address {\n    margin-bottom: 1rem;\n    font-style: normal;\n    line-height: inherit;\n  }\n\n  ol,\n  ul {\n    padding-left: 2rem;\n  }\n\n  ol,\n  ul,\n  dl {\n    margin-top: 0;\n    margin-bottom: 1rem;\n  }\n\n  ol ol,\n  ul ul,\n  ol ul,\n  ul ol {\n    margin-bottom: 0;\n  }\n\n  dt {\n    font-weight: 700;\n  }\n\n  dd {\n    margin-bottom: 0.5rem;\n    margin-left: 0;\n  }\n\n  blockquote {\n    margin: 0 0 1rem;\n  }\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  small {\n    font-size: 0.875em;\n  }\n\n  mark {\n    padding: 0.2em;\n    background-color: #fcf8e3;\n  }\n\n  sub,\n  sup {\n    position: relative;\n    font-size: 0.75em;\n    line-height: 0;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  a {\n    color: #0d6efd;\n    text-decoration: none;\n  }\n\n  a:hover {\n    color: #024dbc;\n  }\n\n  a:not([href]),\n  a:not([href]):hover {\n    text-decoration: none;\n  }\n\n  pre,\n  code,\n  kbd,\n  samp {\n    font-family: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',\n      'Courier New', monospace;\n    font-size: 1em;\n  }\n\n  pre {\n    display: block;\n    margin-top: 0;\n    margin-bottom: 1rem;\n    overflow: auto;\n    font-size: 0.875em;\n  }\n\n  pre code {\n    font-size: inherit;\n    color: inherit;\n    word-break: normal;\n  }\n\n  code {\n    font-size: 0.875em;\n    color: #d63384;\n    word-wrap: break-word;\n  }\n\n  a > code {\n    color: inherit;\n  }\n\n  kbd {\n    padding: 0.2rem 0.4rem;\n    font-size: 0.875em;\n    color: #fff;\n    background-color: #212529;\n    border-radius: 0.2rem;\n  }\n\n  kbd kbd {\n    padding: 0;\n    font-size: 1em;\n    font-weight: 700;\n  }\n\n  figure {\n    margin: 0 0 1rem;\n  }\n\n  img,\n  svg {\n    vertical-align: middle;\n  }\n\n  table {\n    caption-side: bottom;\n    border-collapse: collapse;\n  }\n\n  caption {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n    color: #6c757d;\n    text-align: left;\n  }\n\n  th {\n    text-align: inherit;\n    text-align: -webkit-match-parent;\n  }\n\n  label {\n    display: inline-block;\n    margin-bottom: 0.5rem;\n  }\n\n  button {\n    border-radius: 0;\n  }\n\n  button:focus {\n    outline: none;\n  }\n\n  input,\n  button,\n  select,\n  optgroup,\n  textarea {\n    margin: 0;\n    font-family: inherit;\n    font-size: inherit;\n    line-height: inherit;\n  }\n\n  button,\n  input {\n    overflow: visible;\n  }\n\n  button,\n  select {\n    text-transform: none;\n  }\n\n  select {\n    word-wrap: normal;\n  }\n\n  [list]::-webkit-calendar-picker-indicator {\n    display: none;\n  }\n\n  button,\n  [type='button'],\n  [type='reset'],\n  [type='submit'] {\n    -webkit-appearance: button;\n  }\n\n  button:not(:disabled),\n  [type='button']:not(:disabled),\n  [type='reset']:not(:disabled),\n  [type='submit']:not(:disabled) {\n    cursor: pointer;\n  }\n\n  ::-moz-focus-inner {\n    padding: 0;\n    border-style: none;\n  }\n\n  input[type='date'],\n  input[type='time'],\n  input[type='datetime-local'],\n  input[type='month'] {\n    -webkit-appearance: textfield;\n  }\n\n  textarea {\n    resize: vertical;\n  }\n\n  fieldset {\n    min-width: 0;\n    padding: 0;\n    margin: 0;\n    border: 0;\n  }\n\n  legend {\n    float: left;\n    width: 100%;\n    padding: 0;\n    margin-bottom: 0.5rem;\n    font-size: calc(1.275rem + 0.3vw);\n    line-height: inherit;\n    white-space: normal;\n  }\n\n  @media (min-width: 1200px) {\n    legend {\n      font-size: 1.5rem;\n    }\n  }\n\n  legend + * {\n    clear: left;\n  }\n\n  ::-webkit-datetime-edit-fields-wrapper,\n  ::-webkit-datetime-edit-text,\n  ::-webkit-datetime-edit-minute,\n  ::-webkit-datetime-edit-hour-field,\n  ::-webkit-datetime-edit-day-field,\n  ::-webkit-datetime-edit-month-field,\n  ::-webkit-datetime-edit-year-field {\n    padding: 0;\n  }\n\n  ::-webkit-inner-spin-button {\n    height: auto;\n  }\n\n  [type='search'] {\n    outline-offset: -2px;\n    -webkit-appearance: textfield;\n  }\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  ::-webkit-color-swatch-wrapper {\n    padding: 0;\n  }\n\n  ::-webkit-file-upload-button {\n    font: inherit;\n    -webkit-appearance: button;\n  }\n\n  output {\n    display: inline-block;\n  }\n\n  summary {\n    display: list-item;\n    cursor: pointer;\n  }\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  [hidden] {\n    display: none !important;\n  }\n\n  html,\n  body,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  a,\n  p,\n  span,\n  em,\n  small,\n  strong,\n  sub,\n  sup,\n  mark,\n  del,\n  ins,\n  strike,\n  abbr,\n  dfn,\n  blockquote,\n  q,\n  cite,\n  code,\n  pre,\n  ol,\n  ul,\n  li,\n  dl,\n  dt,\n  dd,\n  div,\n  section,\n  article,\n  main,\n  aside,\n  nav,\n  header,\n  hgroup,\n  footer,\n  img,\n  figure,\n  figcaption,\n  address,\n  time,\n  audio,\n  video,\n  canvas,\n  iframe,\n  details,\n  summary,\n  fieldset,\n  form,\n  label,\n  legend,\n  table,\n  caption,\n  tbody,\n  tfoot,\n  thead,\n  tr,\n  th,\n  td {\n    margin: 0;\n    padding: 0;\n    border: 0;\n  }\n  button,\n  input,\n  optgroup,\n  select,\n  textarea {\n    margin: 0px;\n    color: inherit;\n    font-size: inherit;\n    font-family: inherit;\n    line-height: inherit;\n  }\n\n  @media (max-width: 767px) {\n    .hidden-xs {\n      display: none !important;\n    }\n  }\n\n  @media (min-width: 768px) {\n    .hidden-md {\n      display: none !important;\n    }\n  }\n";


/***/ }),

/***/ 86258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$d": function() { return /* binding */ e; },
/* harmony export */   "Dh": function() { return /* binding */ P; },
/* harmony export */   "Dx": function() { return /* binding */ E; },
/* harmony export */   "H2": function() { return /* binding */ r; },
/* harmony export */   "Hx": function() { return /* binding */ B; },
/* harmony export */   "XA": function() { return /* binding */ t; },
/* harmony export */   "f_": function() { return /* binding */ A; },
/* harmony export */   "gH": function() { return /* binding */ p; },
/* harmony export */   "hM": function() { return /* binding */ T; },
/* harmony export */   "jh": function() { return /* binding */ O; },
/* harmony export */   "lW": function() { return /* binding */ R; },
/* harmony export */   "yP": function() { return /* binding */ i; },
/* harmony export */   "yf": function() { return /* binding */ o; }
/* harmony export */ });
const E="ROOT",O="RootEditor",o="HEADER",R="FOOTER",t="BUBBLE",P="TOP_BANNER",B="ARTICLE_HEADER",T="ORDER_POPUP",e=768,i=5,p="PAGE_EFFECT",r={ROOT:"root",SECTION:"section",ROW:"row",POPUP:"popupv1",BUBBLE:"contactbubble"},A="tempi-main-iframe";


/***/ }),

/***/ 116108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ d; },
/* harmony export */   "o": function() { return /* binding */ p; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
var o=Object.defineProperty,i=Object.getOwnPropertySymbols,a=Object.prototype.hasOwnProperty,l=Object.prototype.propertyIsEnumerable,u=(e,r,t)=>r in e?o(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,c=(e,r)=>{for(var t in r||(r={}))a.call(r,t)&&u(e,t,r[t]);if(i)for(var t of i(r))l.call(r,t)&&u(e,t,r[t]);return e};const f=react__WEBPACK_IMPORTED_MODULE_1__.createContext({}),d=r=>{var n,o,u=r,{children:d,device:p="desktop"}=u,v=((e,r)=>{var t={};for(var n in e)a.call(e,n)&&r.indexOf(n)<0&&(t[n]=e[n]);if(null!=e&&i)for(var n of i(e))r.indexOf(n)<0&&l.call(e,n)&&(t[n]=e[n]);return t})(u,["children","device"]);const s=null==(n=v.globalData)?void 0:n.menu,b=(null==(o=v.globalData)?void 0:o.prefixLangUrl)||"",m=(0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)((()=>null==s?void 0:s.reduce(((e,r)=>(e[null==r?void 0:r.id]=(e=>{if(!e)return;if("LINK"===e.linkType)return e.href;const{slug:r,isHomepage:t}=e.page||{};return r||t?b+"/"+(r||""):void 0})(r),e)),{})),[JSON.stringify(s)]);return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(f.Provider,{value:c({device:p,mappingWebsiteMenuHref:m},v),children:d})};function p(){const e=(0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(f);if(!e)throw new Error("useStore must be inside a StoreStateContext with a state value");return e}


/***/ }),

/***/ 860426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ r; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _utils_date_time_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(385190);
const r=({startTime:r,endTime:o,ruleRepeat:a,date:s,duration:m})=>{const d=()=>(0,_utils_date_time_es_js__WEBPACK_IMPORTED_MODULE_1__/* .validateIsVisibleComponent */ .U0)({startTime:r,endTime:o,ruleRepeat:a,date:s,duration:m}),[c,u]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((()=>d()));return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((()=>{const{visibleEndTime:e,visibleStartTime:t}=(0,_utils_date_time_es_js__WEBPACK_IMPORTED_MODULE_1__/* .getNearestAvailableRangeTime */ .So)({startTime:r,endTime:o,ruleRepeat:a,date:s,duration:m});if(!e&&!t)return;const n=e=>e?new Date(e).getTime()-Date.now():null;let l;const T=()=>{clearTimeout(l);const i=Math.min(...[n(e),n(t)].filter(Boolean));i>0&&(l=setTimeout((()=>{const e=d();e!==c&&u(e)}),i))};T();const v=()=>{if(!document.hidden){const e=d();e!==c&&u(e),T()}};return document.addEventListener("visibilitychange",v),()=>{clearTimeout(l),document.removeEventListener("visibilitychange",v)}}),[c,r,o,a,s,m]),{isVisible:c}};


/***/ }),

/***/ 85097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ARTICLE_HEADER": function() { return /* reexport */ root_es/* ARTICLE_HEADER */.Hx; },
  "Alignment": function() { return /* reexport */ style_es_a; },
  "Api": function() { return /* reexport */ index_es_u; },
  "ApiError": function() { return /* reexport */ error_es_s; },
  "AssignmentStatusEnum": function() { return /* reexport */ common_es/* AssignmentStatusEnum */.PO; },
  "BG_LAZY_CLASS_NAME": function() { return /* reexport */ common_es_l; },
  "BG_VISIBLE_LAZY_CLASS_NAME": function() { return /* reexport */ common_es_b; },
  "BUBBLE": function() { return /* reexport */ root_es/* BUBBLE */.XA; },
  "BackgroundType": function() { return /* reexport */ style_es_i; },
  "BackgroundVideo": function() { return /* reexport */ BackgroundVideo_es_j; },
  "BackgroundVideoPlatform": function() { return /* reexport */ style_es_t; },
  "BreakpointWidthProvider": function() { return /* reexport */ BreakpointWidthContext_es_s; },
  "BuilderComponent": function() { return /* reexport */ render_es/* BuilderComponent */.V; },
  "COMPONENT_TAG": function() { return /* reexport */ root_es/* COMPONENT_TAG */.H2; },
  "ColorType": function() { return /* reexport */ style_es_l; },
  "DOCUMENT_TYPE": function() { return /* reexport */ common_es/* DOCUMENT_TYPE */.tE; },
  "FOOTER": function() { return /* reexport */ root_es/* FOOTER */.lW; },
  "FontSource": function() { return /* reexport */ common_es/* FontSource */.gY; },
  "GradientType": function() { return /* reexport */ style_es_n; },
  "HEADER": function() { return /* reexport */ root_es/* HEADER */.yf; },
  "IMAGE_WRAPPER_CLASS_NAME": function() { return /* reexport */ Image_es_L; },
  "ImageBase": function() { return /* reexport */ Image_es_T; },
  "ImageObjectFit": function() { return /* reexport */ style_es_d; },
  "ImageOptimize": function() { return /* reexport */ ImageOptimize_es_p; },
  "LandingLinks": function() { return /* reexport */ index_es/* LandingLinks */.d1; },
  "LazyComponent": function() { return /* reexport */ LazyComponent_es_s; },
  "Link": function() { return /* reexport */ Link_es_u; },
  "MAPPING_EXTENSION_MIME_TYPE": function() { return /* reexport */ common_es/* MAPPING_EXTENSION_MIME_TYPE */.h5; },
  "MAX_DPR": function() { return /* reexport */ root_es/* MAX_DPR */.yP; },
  "MINESTONE_M_WIDTH": function() { return /* reexport */ root_es/* MINESTONE_M_WIDTH */.$d; },
  "MinMaxUnitEnum": function() { return /* reexport */ style_es_o; },
  "NodeElement": function() { return /* reexport */ NodeElements_es_m; },
  "ORDER_POPUP": function() { return /* reexport */ root_es/* ORDER_POPUP */.hM; },
  "OverlayType": function() { return /* reexport */ style_es_r; },
  "PAGE_EFFECT": function() { return /* reexport */ root_es/* PAGE_EFFECT */.gH; },
  "PATTERN_VALIDATION": function() { return /* reexport */ regex_es_s; },
  "PageDataProvider": function() { return /* reexport */ PageDataContext_es_u; },
  "PreviewGroupProvider": function() { return /* reexport */ PreviewGroupContext_es_f; },
  "ROOT": function() { return /* reexport */ root_es/* ROOT */.Dx; },
  "ROOT_SELECTOR_NAME": function() { return /* reexport */ root_es/* ROOT_SELECTOR_NAME */.jh; },
  "ReactLazyComponent": function() { return /* reexport */ ReactLazyComponent_es_b; },
  "RenderPage": function() { return /* reexport */ P; },
  "RepeatTypeEnum": function() { return /* reexport */ common_es/* RepeatTypeEnum */.gj; },
  "RuleRepeatEnum": function() { return /* reexport */ common_es/* RuleRepeatEnum */.Ew; },
  "StoreProvider": function() { return /* reexport */ StoreContext_es/* StoreProvider */.g; },
  "TEMPI_MAIN_IFRAME": function() { return /* reexport */ root_es/* TEMPI_MAIN_IFRAME */.f_; },
  "TOP_BANNER": function() { return /* reexport */ root_es/* TOP_BANNER */.Dh; },
  "TimeVisibilityWrapper": function() { return /* reexport */ TimeVisibilityWrapper_es/* TimeVisibilityWrapper */.y; },
  "UnitEnum": function() { return /* reexport */ style_es_e; },
  "UnitRepeatEnum": function() { return /* reexport */ common_es/* UnitRepeatEnum */.Ql; },
  "VerticalAlignment": function() { return /* reexport */ style_es_c; },
  "animationCss": function() { return /* reexport */ animation_es/* animationCss */.W; },
  "buildComponentDict": function() { return /* reexport */ utils_render_es/* buildComponentDict */.Oq; },
  "buildSizes": function() { return /* reexport */ buildSizes_es_e; },
  "buildSrcset": function() { return /* reexport */ buildSrcset_es_m; },
  "buildSrcsetDPR": function() { return /* reexport */ buildSrcsetDPR_es_r; },
  "builder": function() { return /* reexport */ u; },
  "calculateTimeDelta": function() { return /* reexport */ date_time_es/* calculateTimeDelta */.mE; },
  "computeStringHandleBarsExpression": function() { return /* reexport */ computeStringHandleBarsExpression_es_r; },
  "constructGoogleImageParams": function() { return /* reexport */ image_es_u; },
  "consumerBffUrl": function() { return /* reexport */ index_es/* consumerBffUrl */.GJ; },
  "debounce": function() { return /* reexport */ S; },
  "defaultFontFamily": function() { return /* reexport */ fonts_es/* defaultFontFamily */.em; },
  "defaultGoogleFont": function() { return /* reexport */ fonts_es/* defaultGoogleFont */.UI; },
  "escapeString": function() { return /* reexport */ transform_es_L; },
  "fontPreviewJsonLink": function() { return /* reexport */ fonts_es/* fontPreviewJsonLink */.kC; },
  "fontQueryParams": function() { return /* reexport */ fonts_es/* fontQueryParams */.wc; },
  "fontSetV2": function() { return /* reexport */ fonts_es/* fontSetV2 */.aE; },
  "fontWeightQueryParams": function() { return /* reexport */ fonts_es/* fontWeightQueryParams */.wp; },
  "formatCurrencyVND": function() { return /* reexport */ W; },
  "formatImageUrlQuality": function() { return /* reexport */ image_es_d; },
  "generate": function() { return /* reexport */ generate_es_r; },
  "generateColorVariable": function() { return /* reexport */ theme_es_o; },
  "generateGlobalCSS": function() { return /* reexport */ theme_es_l; },
  "generateRandomId": function() { return /* reexport */ V; },
  "generateTypographyVariable": function() { return /* reexport */ theme_es_i; },
  "getAllHandleBarsVariables": function() { return /* reexport */ computeStringHandleBarsExpression_es_l; },
  "getAnimation": function() { return /* reexport */ transform_es_w; },
  "getAttrTracking": function() { return /* reexport */ track_es_t; },
  "getBackgroundImageMarquee": function() { return /* reexport */ transform_es_y; },
  "getBackgroundOverlay": function() { return /* reexport */ transform_es_v; },
  "getBoxShadow": function() { return /* reexport */ transform_es_h; },
  "getBreakpointWidthFromStyle": function() { return /* reexport */ getBreakpointWidthFromStyle_es_t; },
  "getCommonCss": function() { return /* reexport */ transform_es_$; },
  "getComponentProps": function() { return /* reexport */ getComponentProps_es_p; },
  "getDropShadowFilter": function() { return /* reexport */ transform_es_x; },
  "getGoogleFontQuery": function() { return /* reexport */ getGoogleFontQuery_es_n; },
  "getImageUrlFromGoogleUserContent": function() { return /* reexport */ image_es_a; },
  "getNearestAvailableRangeTime": function() { return /* reexport */ date_time_es/* getNearestAvailableRangeTime */.So; },
  "getOffset": function() { return /* reexport */ getOffset_es_e; },
  "getPlaceholderColor": function() { return /* reexport */ T; },
  "getPropsByDevice": function() { return /* reexport */ utils_render_es/* getPropsByDevice */.vv; },
  "getRgbaFromHex": function() { return /* reexport */ util_es_e; },
  "getScrollbarWidth": function() { return /* reexport */ I; },
  "getSrcSetImageWidth": function() { return /* reexport */ getSrcSetImageWidth_es_n; },
  "getStyle": function() { return /* reexport */ transform_es_O; },
  "getTargetOfTrackingFromEvent": function() { return /* reexport */ utils_render_es/* getTargetOfTrackingFromEvent */.d0; },
  "getTextShadow": function() { return /* reexport */ transform_es_k; },
  "getThemeAttribute": function() { return /* reexport */ theme_es_m; },
  "getTrackingData": function() { return /* reexport */ utils_render_es/* getTrackingData */.O5; },
  "googleFontSetV2": function() { return /* reexport */ fonts_es/* googleFontSetV2 */.EB; },
  "isAbsoluteWidth": function() { return /* reexport */ isAbsoluteWidth_es_t; },
  "isGCSUrl": function() { return /* reexport */ isGCSUrl_es_t; },
  "isHandleBarsVariable": function() { return /* reexport */ computeStringHandleBarsExpression_es_t; },
  "isHeadingFontStyle": function() { return /* reexport */ theme_es_a; },
  "isParagraphFontStyle": function() { return /* reexport */ theme_es_r; },
  "landingLinks": function() { return /* reexport */ index_es/* landingLinks */.Zq; },
  "landingLinksWithoutFontQuery": function() { return /* reexport */ index_es/* landingLinksWithoutFontQuery */.jS; },
  "loadGGFontFromQuery": function() { return /* reexport */ getFontFamily_es_n; },
  "loadNewGGFont": function() { return /* reexport */ getFontFamily_es_o; },
  "mappingAssets": function() { return /* reexport */ mapping_assets_es_t; },
  "mergeArrayPropSeparateDevice": function() { return /* reexport */ utils_render_es/* mergeArrayPropSeparateDevice */.aX; },
  "mktGatewayUrl": function() { return /* reexport */ index_es/* mktGatewayUrl */.B4; },
  "parseColor": function() { return /* reexport */ N; },
  "parseRuleRepeat": function() { return /* reexport */ date_time_es/* parseRuleRepeat */.gV; },
  "pbFontFamily": function() { return /* reexport */ fonts_es/* pbFontFamily */.tC; },
  "pbFontWeight": function() { return /* reexport */ fonts_es/* pbFontWeight */.a$; },
  "pinposBffUrl": function() { return /* reexport */ index_es/* pinposBffUrl */.Yn; },
  "pixelParse": function() { return /* reexport */ z; },
  "preProcesssorGoogleImageParams": function() { return /* reexport */ image_es_p; },
  "publicBffUrl": function() { return /* reexport */ index_es/* publicBffUrl */.Fd; },
  "rcCascaderCss": function() { return /* reexport */ rc_cascader_es/* rcCascaderCss */.J; },
  "reset": function() { return /* reexport */ reset_es/* reset */.m; },
  "stringifyColor": function() { return /* reexport */ transform_es_j; },
  "tempiFontList": function() { return /* reexport */ fonts_es/* tempiFontList */.Dy; },
  "tiktokParser": function() { return /* reexport */ tiktokParser_es_o; },
  "unescapeString": function() { return /* reexport */ transform_es_B; },
  "unitParse": function() { return /* reexport */ transform_es_C; },
  "upsertStyleById": function() { return /* reexport */ theme_es_n; },
  "useAnimation": function() { return /* reexport */ useAnimation_es_a; },
  "useBreakpointWidth": function() { return /* reexport */ BreakpointWidthContext_es_h; },
  "useEndpointHandler": function() { return /* reexport */ useEndpointHandler_es_p; },
  "useEndpointHandlerV2": function() { return /* reexport */ useEndpointHandlerV2_es_h; },
  "useGetComponentProps": function() { return /* reexport */ useGetComponentProps_es_p; },
  "useGetDynamicValue": function() { return /* reexport */ useGetDynamicValue_es_o; },
  "useGetVisible": function() { return /* reexport */ useGetVisible_es/* useGetVisible */.m; },
  "useInitValue": function() { return /* reexport */ useInitValue_es_a; },
  "useInjectDynamicLinks": function() { return /* reexport */ useInjectDynamicLinks_es_t; },
  "useInjectLinksToHTML": function() { return /* reexport */ useInjectLinksToHTML_es_p; },
  "useIntersectionObserver": function() { return /* reexport */ useIntersectionObserver_es_n; },
  "useLocationChange": function() { return /* reexport */ useLocationChange_es_e; },
  "usePageData": function() { return /* reexport */ PageDataContext_es_p; },
  "usePreviewGroup": function() { return /* reexport */ v; },
  "useStore": function() { return /* reexport */ StoreContext_es/* useStore */.o; },
  "useTimeVisibility": function() { return /* reexport */ useTimeVisibility_es_e; },
  "useTimer": function() { return /* reexport */ useTimer_es_n; },
  "validateIsVisibleComponent": function() { return /* reexport */ date_time_es/* validateIsVisibleComponent */.U0; },
  "youtubeParser": function() { return /* reexport */ youtubeParser_es_t; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/constants/index.es.js
var index_es = __webpack_require__(474402);
// EXTERNAL MODULE: ../../.yarn/cache/opentracing-npm-0.14.7-a8451c5ee8-5f7e444390.zip/node_modules/opentracing/lib/index.js
var lib = __webpack_require__(83492);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/api/error.es.js
class error_es_s{constructor(s,e,t){this.message=s,this.response=t,this.code=e}get reason(){return this.response}}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/api/index.es.js
var s=Object.defineProperty,a=Object.defineProperties,n=Object.getOwnPropertyDescriptors,o=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,c=Object.prototype.propertyIsEnumerable,p=(t,e,r)=>e in t?s(t,e,{enumerable:!0,configurable:!0,writable:!0,value:r}):t[e]=r,h=(t,e)=>{for(var r in e||(e={}))i.call(e,r)&&p(t,r,e[r]);if(o)for(var r of o(e))c.call(e,r)&&p(t,r,e[r]);return t};const l=(t="",e)=>`${t.endsWith("/")?t.slice(0,t.length-1):t}/${e.startsWith("/")?e.slice(1):e}`;class index_es_u{constructor(t,e,r={}){this.baseURL=t,this.interceptors=[],this.getError=e,this.defaultConfig=r}_parseJson(t){return t.text().then((t=>t?JSON.parse(t):null))}addInterceptor(t){this.interceptors.push(t)}appendParamsToURL(t,e={}){if(e){const r=[];for(const t of Object.keys(e))null!==e[t]&&void 0!==e[t]&&r.push(`${t}=${encodeURIComponent(e[t])}`);r.length>0&&(t=`${t}?${r.join("&")}`)}return t}async request(s,o,i,c={}){var p;const{params:u}=c;let f=c.headers||{};const d=this.appendParamsToURL(s,u||{});let g=null;const y=o&&"string"!=typeof o&&"append"in o;o&&"string"!=typeof o&&(y?g=new URLSearchParams(o).toString():(g=JSON.stringify(o),f=h({"Content-Type":"application/json"},f)));let b=null;u&&(b=JSON.stringify(u));const m=(0,lib.globalTracer)(),w=`[${i}] ${l(this.baseURL,s)}`,O=m.startSpan(w);m.inject(O,lib.FORMAT_HTTP_HEADERS,f),O.setTag("http.method",i),O.setTag("http.baseurl",this.baseURL),O.log({body:g,params:b});const j=(P=h({},this.defaultConfig),T={method:i,headers:new Headers(f),body:y?o:g},a(P,n(T)));var P,T;this.interceptors.forEach((t=>t(j)));const E=await fetch(d.startsWith("http")?d:l(this.baseURL,d),j);if(E.status>=400){const t=await E.json(),e=(null==(p=this.getError)?void 0:p.call(this,t))||new error_es_s("Đã có lỗi xảy ra, vui lòng thử lại sau!",-1,t);return O.setTag("status","error"),O.log({error:JSON.stringify(e)}),O.finish(),Promise.reject(e)}const v={};E.headers.forEach(((t,e)=>v[e]=t));const S=await this._parseJson(E);return O.setTag("status","success"),O.finish(),{code:E.status,data:S,headers:v}}async get(t,e={}){return await this.request(t,null,"GET",e)}async post(t,e,r={}){return await this.request(t,e,"POST",r)}async patch(t,e,r={}){return await this.request(t,e,"PATCH",r)}async put(t,e,r={}){return await this.request(t,e,"PUT",r)}async delete(t,e={},r={}){return await this.request(t,e,"DELETE",r)}}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/builder.es.js
var t=Object.defineProperty,builder_es_n=Object.defineProperties,builder_es_i=Object.getOwnPropertyDescriptors,r=Object.getOwnPropertySymbols,builder_es_o=Object.prototype.hasOwnProperty,builder_es_l=Object.prototype.propertyIsEnumerable,builder_es_s=(e,a,n)=>a in e?t(e,a,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[a]=n,d=(e,a)=>{for(var t in a||(a={}))builder_es_o.call(a,t)&&builder_es_s(e,t,a[t]);if(r)for(var t of r(a))builder_es_l.call(a,t)&&builder_es_s(e,t,a[t]);return e},g=(e,a)=>builder_es_n(e,builder_es_i(a));class builder_es_p{init(t,n){this.domain=t,n.env||(n.env="production"),this.pageManagementClient=new index_es_u(index_es/* publicBffUrl */.Fd[n.env]),this.internalClient=new index_es_u(index_es/* publicBffUrl.internal */.Fd.internal)}async getPublicPage(e,a=!1){const t=a?this.internalClient:this.pageManagementClient,{data:n}=await t.get("/v1/page",{params:g(d({},e),{domain:this.domain})});return null==n?void 0:n.data}async getPublicPageV2(e,a=!1){var t,n,i;const s=a?this.internalClient:this.pageManagementClient,p=e,{languageCode:u,slug:c,password:v}=p,m=((e,a)=>{var t={};for(var n in e)builder_es_o.call(e,n)&&a.indexOf(n)<0&&(t[n]=e[n]);if(null!=e&&r)for(var n of r(e))a.indexOf(n)<0&&builder_es_l.call(e,n)&&(t[n]=e[n]);return t})(p,["languageCode","slug","password"]),{data:f}=await s.get("/v1/page",{params:g(d({},m),{slug:c,domain:this.domain}),headers:{"Accept-Language":u||"*","x-password":v}});return g(d({},null==(t=null==f?void 0:f.data)?void 0:t.page),{pbConfig:null==(i=null==(n=null==f?void 0:f.data)?void 0:n.page)?void 0:i.content})}async getPrivatePageV2(e,a){var t,n,i;const r=this.pageManagementClient,{data:o}=await r.get("/v1/page",{params:g(d({},e),{domain:this.domain}),headers:a});return g(d({},null==(t=null==o?void 0:o.data)?void 0:t.page),{pbConfig:null==(i=null==(n=null==o?void 0:o.data)?void 0:n.page)?void 0:i.content})}getSSRInputs(e,a){const{device:t="desktop",ssrComponentTags:n,getSlotDataFunc:i}=a;return Object.keys(e).filter((a=>n.includes(e[a].tag))).map((a=>({key:a,data:i(e[a],t)}))).reduce(((e,a)=>g(d({},e),{[a.key]:a.data})),{})}}builder_es_p.ITEMS_PER_PAGE=18;const u=new builder_es_p;

// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/render.es.js
var render_es = __webpack_require__(241464);
// EXTERNAL MODULE: ../../.yarn/cache/color-name-npm-1.1.4-025792b0ea-b044585952.zip/node_modules/color-name/index.js
var color_name = __webpack_require__(335410);
var color_name_default = /*#__PURE__*/__webpack_require__.n(color_name);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/colors/core/parse-css-color/regexes/index.es.js
const index_es_n="-?\\d*(?:\\.\\d+)",index_es_s=`(${index_es_n}?)`,$=`(${index_es_n}?%)`,e=`(${index_es_n}?%?)`,index_es_g=new RegExp(/^#([a-f0-9]{3,4}|[a-f0-9]{4}(?:[a-f0-9]{2}){1,2})\b$/,"i"),index_es_a=`^\n  hsla?\\(\n    \\s*(-?\\d*(?:\\.\\d+)?(?:deg|rad|turn)?)\\s*,\n    \\s*${$}\\s*,\n    \\s*${$}\\s*\n    (?:,\\s*${e}\\s*)?\n  \\)\n  $\n`.replace(/\n|\s/g,""),index_es_r=new RegExp(index_es_a),index_es_p=`^\n  hsla?\\(\n    \\s*(-?\\d*(?:\\.\\d+)?(?:deg|rad|turn)?)\\s*\n    \\s+${$}\n    \\s+${$}\n    \\s*(?:\\s*\\/\\s*${e}\\s*)?\n  \\)\n  $\n`.replace(/\n|\s/g,""),index_es_d=new RegExp(index_es_p),x=`^\n  rgba?\\(\n    \\s*${index_es_s}\\s*,\n    \\s*${index_es_s}\\s*,\n    \\s*${index_es_s}\\s*\n    (?:,\\s*${e}\\s*)?\n  \\)\n  $\n`.replace(/\n|\s/g,""),index_es_l=new RegExp(x),w=`^\n  rgba?\\(\n    \\s*${$}\\s*,\n    \\s*${$}\\s*,\n    \\s*${$}\\s*\n    (?:,\\s*${e}\\s*)?\n  \\)\n  $\n`.replace(/\n|\s/g,""),E=new RegExp(w),R=`^\n  rgba?\\(\n    \\s*${index_es_s}\n    \\s+${index_es_s}\n    \\s+${index_es_s}\n    \\s*(?:\\s*\\/\\s*${e}\\s*)?\n  \\)\n$\n`.replace(/\n|\s/g,""),index_es_c=new RegExp(R),index_es_t=`^\n  rgba?\\(\n    \\s*${$}\n    \\s+${$}\n    \\s+${$}\n    \\s*(?:\\s*\\/\\s*${e}\\s*)?\n  \\)\n$\n`.replace(/\n|\s/g,""),b=new RegExp(index_es_t),f=new RegExp(/^transparent$/,"i");

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/colors/core/parse-css-color/utils/hex-rgb.es.js
const hex_rgb_es_e="a-f\\d",hex_rgb_es_r=`#?[${hex_rgb_es_e}]{3}[${hex_rgb_es_e}]?`,hex_rgb_es_t=`#?[${hex_rgb_es_e}]{6}([${hex_rgb_es_e}]{2})?`,hex_rgb_es_a=new RegExp(`[^#${hex_rgb_es_e}]`,"gi"),hex_rgb_es_n=new RegExp(`^${hex_rgb_es_r}$|^${hex_rgb_es_t}$`,"i");function hex_rgb_es_o(e,r={format:void 0}){if("string"!=typeof e||hex_rgb_es_a.test(e)||!hex_rgb_es_n.test(e))throw new TypeError("Expected a valid hex string");let t=1;8===(e=e.replace(/^#/,"")).length&&(t=Math.floor(Number.parseInt(e.slice(6,8),16)/255*100)/100,e=e.slice(0,6)),4===e.length&&(t=Math.floor(Number.parseInt(e.slice(3,4).repeat(2),16)/255*100)/100,e=e.slice(0,3)),3===e.length&&(e=e[0]+e[0]+e[1]+e[1]+e[2]+e[2]);const o=Number.parseInt(e,16),s=o>>16,l=o>>8&255,$=255&o;return"array"===r.format?[s,l,$,t]:"css"===r.format?`rgb(${s} ${l} ${$}${1===t?"":` / ${Number((100*t).toFixed(2))}%`})`:{red:s,green:l,blue:$,alpha:t}}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/colors/core/parse-css-color/utils/index.es.js
const utils_index_es_a=(t,a,r)=>Math.min(Math.max(a,t),r),utils_index_es_r=t=>{let r=t;return"number"!=typeof r&&(r=r.endsWith("%")?255*parseFloat(r)/100:parseFloat(r)),utils_index_es_a(Math.round(r),0,255)},index_es_e=t=>utils_index_es_a(parseFloat(t),0,100);function utils_index_es_n(t){let r=t;return"number"!=typeof r&&(r=r.endsWith("%")?parseFloat(r)/100:parseFloat(r)),utils_index_es_a(r,0,1)}function utils_index_es_l(a){const[r,e,n,l]=hex_rgb_es_o(a,{format:"array"});return utils_index_es_s([null,r,e,n,l])}function index_es_o([,t,a,r,l=1]){let o=t;return o=o.endsWith("turn")?360*parseFloat(o)/1:o.endsWith("rad")?Math.round(180*parseFloat(o)/Math.PI):parseFloat(o),{type:"hsl",values:[o,index_es_e(a),index_es_e(r)],alpha:utils_index_es_n(null===l?1:l)}}function utils_index_es_s([,t,a,e,l=1]){return{type:"rgb",values:[t,a,e].map(utils_index_es_r),alpha:utils_index_es_n(null===l?1:l)}}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/colors/core/parse-css-color/index.es.js
var m=m=>{if("string"!=typeof m)return null;const a=index_es_g.exec(m);if(a)return utils_index_es_l(a[0]);const p=index_es_d.exec(m)||index_es_r.exec(m);if(p)return index_es_o(p);const d=index_es_c.exec(m)||b.exec(m)||index_es_l.exec(m)||E.exec(m);if(d)return utils_index_es_s(d);if(f.exec(m))return utils_index_es_s([null,0,0,0,0]);const g=(color_name_default())[m.toLowerCase()];return g?utils_index_es_s([null,g[0],g[1],g[2],1]):null};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/colors/core/pure-color/index.es.js
function pure_color_index_es_t(t){const n=t[0]/360,r=t[1]/100,o=t[2]/100;let e,c,u;if(0==r)return u=255*o,[u,u,u];e=o<.5?o*(1+r):o+r-o*r;const a=2*o-e,i=[0,0,0];for(let t=0;t<3;t++)c=n+1/3*-(t-1),c<0&&c++,c>1&&c--,u=6*c<1?a+6*(e-a)*c:2*c<1?e:3*c<2?a+(e-a)*(2/3-c)*6:a,i[t]=255*u;return i}function pure_color_index_es_n(t){var n;const r=Math.round((n=t,Math.min(Math.max(n,0),255))).toString(16);return 1==r.length?"0"+r:r}function pure_color_index_es_r(t){const r=4===t.length?pure_color_index_es_n(255*t[3]):"";return"#"+pure_color_index_es_n(t[0])+pure_color_index_es_n(t[1])+pure_color_index_es_n(t[2])+r}function pure_color_index_es_o(t){const n=t[0]/255,r=t[1]/255,o=t[2]/255,e=Math.min(n,r,o),c=Math.max(n,r,o),u=c-e;let a,i;c==e?a=0:n==c?a=(r-o)/u:r==c?a=2+(o-n)/u:o==c&&(a=4+(n-r)/u),a=Math.min(60*a,360),a<0&&(a+=360);const h=(e+c)/2;return i=c==e?0:h<=.5?u/(c+e):u/(2-c-e),[a,100*i,100*h]}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/colors/core/mix-css-color/index.es.js
function mix_css_color_index_es_s(e){const l=m(e);return null===l?null:("hsl"===l.type&&(l.values=pure_color_index_es_t(l.values)),l)}function mix_css_color_index_es_t(a,r,t=50){const n=mix_css_color_index_es_s(a),o=mix_css_color_index_es_s(r);if(!n||!o)return null;const u=Math.min(Math.max(0,t),100)/100,p=2*u-1,h=n.alpha-o.alpha,i=((p*h==-1?p:(p+h)/(1+p*h))+1)/2,c=1-i,[m,x,d]=n.values.map(((a,e)=>Math.round(n.values[e]*i+o.values[e]*c))),f=parseFloat((n.alpha*u+o.alpha*(1-u)).toFixed(8));return{hex:pure_color_index_es_r([m,x,d]),hexa:pure_color_index_es_r([m,x,d,f]),rgba:[m,x,d,f],hsla:[...pure_color_index_es_o([m,x,d]).map(Math.round),f]}}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/colors/core/index.es.js
const index_es_i=(t,r)=>null===t||isNaN(t)||"string"==typeof t?r:t;class index_es_h{constructor(r="#000",s="base",e=0){[this.rgb,this.alpha,this.type,this.weight]=[[0,0,0],1,s,e];const i=null===r?"#000":r;if("string"!=typeof i)throw new TypeError(`Input should be a string: ${i}`);const h=m(i);if(!h)throw new Error(`Unable to parse color from string: ${i}`);return this[`_setFrom${h.type.toUpperCase()}`]([...h.values,h.alpha])}get hex(){return this.hexString().replace(/^#/,"")}setColor(r){const s=m(r);return s?this[`_setFrom${s.type.toUpperCase()}`]([...s.values,s.alpha]):null}tint(t,s=index_es_i(t,50)){return new index_es_h(`rgb(${mix_css_color_index_es_t("#fff",this.rgbString(),s).rgba})`,"tint",s)}shade(t,s=index_es_i(t,50)){return new index_es_h(`rgb(${mix_css_color_index_es_t("#000",this.rgbString(),s).rgba})`,"shade",s)}tints(t,r=index_es_i(t,10)){return Array.from({length:100/r},((t,s)=>this.tint((s+1)*r)))}shades(t,r=index_es_i(t,10)){return Array.from({length:100/r},((t,s)=>this.shade((s+1)*r)))}all(t=10){return[...this.tints(t).reverse(),Object.assign(this),...this.shades(t)]}hexString(){return pure_color_index_es_r(this.alpha>=1?this.rgb:[...this.rgb,this.alpha])}rgbString(){const t=(this.alpha>=1?this.rgb:[...this.rgb,this.alpha]).join(", ");return`${this.alpha>=1?"rgb":"rgba"}(${t})`}getBrightness(){return Math.round(this.rgb.reduce(((t,r)=>t+r))/765*100)}_setFromRGB([t,r,s,e]){return[this.rgb,this.alpha]=[[t,r,s],e],this}_setFromHSL([t,r,s,i]){return[this.rgb,this.alpha]=[pure_color_index_es_t([t,r,s]).map(Math.round),i],this}}

// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/constants/root.es.js
var root_es = __webpack_require__(86258);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/colors/generate.es.js
const generate_es_o={50:1,100:2,200:4,500:20,600:22,700:24},generate_es_n=/^var\(*.+\)$/;function generate_es_r(r,l=""){var c;let u=r;const d=(null==(c=null==document?void 0:document.getElementById(root_es/* TEMPI_MAIN_IFRAME */.f_))?void 0:c.contentDocument)||document,m=(null==d?void 0:d.defaultView)||window;generate_es_n.test(r)&&(u=m.getComputedStyle(d.documentElement).getPropertyValue(r.replace(/var\(*|\)/g,"").trim())||r);const s={},a=new index_es_h(u).all(5);return Object.keys(generate_es_o).forEach((e=>{s[`${l}${e}`]=a[generate_es_o[e]].hexString()})),s}

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/hooks/useIntersectionObserver.es.js
const useIntersectionObserver_es_n=(n,{threshold:t=0,root:o=null,rootMargin:s="0%",freezeOnceVisible:i=!1})=>{const[c,l]=(0,react.useState)(!1),u=c&&i;return (0,react.useEffect)((()=>{const r=null==n?void 0:n.current;if(!window.IntersectionObserver||u||!r)return;const e=new IntersectionObserver((([r])=>{l(r.isIntersecting)}),{threshold:t,root:o,rootMargin:s});return e.observe(r),()=>e.disconnect()}),[null==n?void 0:n.current,t,o,s,u]),c};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/hooks/useAnimation.es.js
const useAnimation_es_a=(a,t)=>{var l;const o=useIntersectionObserver_es_n((null==a?void 0:a.name)?t:null,{freezeOnceVisible:!0}),[r,m]=(0,react.useState)(!0),[u,s]=(0,react.useState)("animation-hidden");return (0,react.useEffect)((()=>{if((null==a?void 0:a.name)&&r&&(null==t?void 0:t.current)&&o&&r){const n=setTimeout((()=>{s(""),m(!1)}),1e3*((null==a?void 0:a.delay)||0)+20);return()=>clearTimeout(n)}}),[o,a,r,t]),(null==a?void 0:a.name)?o&&r||!r?{style:{animationName:null==a?void 0:a.name,animationDelay:`${(null==a?void 0:a.delay)||0}s`,animationDuration:`${(null==a?void 0:a.duration)||0}s`,animationIterationCount:"infinite"===(null==a?void 0:a.repeatType)?"infinite":(null==(l=null==a?void 0:a.repeatNumber)?void 0:l.toString())||"1"},animationClassName:u}:{style:{},animationClassName:u}:{style:{},animationClassName:""}};

// EXTERNAL MODULE: ../../.yarn/__virtual__/react-dom-virtual-d2a5f90a4a/0/cache/react-dom-npm-18.2.0-dd675bca1c-7d323310be.zip/node_modules/react-dom/index.js
var react_dom = __webpack_require__(926759);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@react-spring-web-virtual-ec5a21a431/0/cache/@react-spring-web-npm-9.7.3-95390d075a-7f5cd05b23.zip/node_modules/@react-spring/web/dist/react-spring_web.modern.mjs + 3 modules
var react_spring_web_modern = __webpack_require__(267447);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/image.es.js
var image_es_e=Object.defineProperty,image_es_r=Object.defineProperties,image_es_t=Object.getOwnPropertyDescriptors,image_es_o=Object.getOwnPropertySymbols,image_es_n=Object.prototype.hasOwnProperty,image_es_i=Object.prototype.propertyIsEnumerable,image_es_s=(r,t,o)=>t in r?image_es_e(r,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):r[t]=o,image_es_c=(e,r)=>{for(var t in r||(r={}))image_es_n.call(r,t)&&image_es_s(e,t,r[t]);if(image_es_o)for(var t of image_es_o(r))image_es_i.call(r,t)&&image_es_s(e,t,r[t]);return e};const image_es_l={width:"w",height:"h",webp:"rw",png:"rp",jpg:"rj",stretch:"s",crop:"c",compressLevel:"v"},image_es_p=(e,o)=>{return n=image_es_c(image_es_c({},o),e),i={width:(null==e?void 0:e.percent)?Math.round((null==e?void 0:e.width)*(null==e?void 0:e.percent)/100):null==e?void 0:e.width},image_es_r(n,image_es_t(i));var n,i},image_es_u=(e,r)=>{const t=e.indexOf("=")>=0?e.substring(0,e.indexOf("=")):e,o=[],n=(e=>{const r=image_es_c({},e),{width:t,percent:o}=r||{};return t&&o&&(r.width=Math.round(t*o/100)),r})(r);return Object.entries(n).forEach((([e,r])=>{if(0===r||r){switch(e){case"format":return void o.push(image_es_l[r]);case"size":if(r)return void o.push(`${image_es_l[e]}0`);break;case"compressLevel":return}if(image_es_l[e]){if("boolean"==typeof r)return r?void o.push(`${image_es_l[e]}`):void 0;o.push(`${image_es_l[e]}${r}`)}}})),o.length>0?`${t}=${o.join("-")}`:e},image_es_a=(e,r)=>e&&e.includes("googleusercontent.com")&&!e.includes("=")?image_es_u(e,r):e,image_es_d=(e,r=800)=>{if(!(null==e?void 0:e.startsWith("https://lh3.googleusercontent.com/")))return e;const t=/([=-])w\d+(-|$)/;return t.test(e)?e.replace(t,`$1w${r}$2`):/[=-]rw($|-)/.test(e)?e.replace(/=rw($|-)/,`=rw$1w${r}$1`):e+`=w${r}`};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/contexts/PreviewGroupContext.es.js
var PreviewGroupContext_es_i=Object.defineProperty,PreviewGroupContext_es_s=Object.defineProperties,PreviewGroupContext_es_c=Object.getOwnPropertyDescriptors,PreviewGroupContext_es_p=Object.getOwnPropertySymbols,PreviewGroupContext_es_m=Object.prototype.hasOwnProperty,PreviewGroupContext_es_u=Object.prototype.propertyIsEnumerable,PreviewGroupContext_es_l=(e,r,t)=>r in e?PreviewGroupContext_es_i(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;const PreviewGroupContext_es_b=react.createContext({}),PreviewGroupContext_es_f=({children:r,images:o})=>{const[i,f]=(0,react.useState)(),v=o.map((e=>{const{src:r,googleImageParams:t}=e,o=image_es_a(r,image_es_p(t,{format:"webp",compressLevel:1})),i=image_es_a(r,image_es_p(t,{format:"png"}));return b=((e,r)=>{for(var t in r||(r={}))PreviewGroupContext_es_m.call(r,t)&&PreviewGroupContext_es_l(e,t,r[t]);if(PreviewGroupContext_es_p)for(var t of PreviewGroupContext_es_p(r))PreviewGroupContext_es_u.call(r,t)&&PreviewGroupContext_es_l(e,t,r[t]);return e})({},e),PreviewGroupContext_es_s(b,PreviewGroupContext_es_c({src:o||i||r}));var b}));return (0,jsx_runtime.jsx)(PreviewGroupContext_es_b.Provider,{value:{images:v,currentIndex:i,setCurrentIndex:f},children:r})},v=()=>{const e=(0,react.useContext)(PreviewGroupContext_es_b);if(!e)throw new Error("usePreviewGroup must be inside a PreviewGroupContext with a state value");return e};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/getOffset.es.js
const getOffset_es_e=e=>{const t=e&&e.ownerDocument.defaultView||window,o=e&&e.ownerDocument||document,n=e.getBoundingClientRect(),c=o.documentElement;return{left:n.left+(t.pageXOffset||c.scrollLeft)-(c.clientLeft||document.body.clientLeft||0),top:n.top+(t.pageYOffset||c.scrollTop)-(c.clientTop||document.body.clientTop||0)}};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/components/Image/Preview.es.js
var Preview_es_u=Object.defineProperty,Preview_es_v=Object.defineProperties,Preview_es_f=Object.getOwnPropertyDescriptors,Preview_es_h=Object.getOwnPropertySymbols,Preview_es_w=Object.prototype.hasOwnProperty,Preview_es_m=Object.prototype.propertyIsEnumerable,Preview_es_b=(e,t,o)=>t in e?Preview_es_u(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o,Preview_es_g=(e,t)=>{for(var o in t||(t={}))Preview_es_w.call(t,o)&&Preview_es_b(e,o,t[o]);if(Preview_es_h)for(var o of Preview_es_h(t))Preview_es_m.call(t,o)&&Preview_es_b(e,o,t[o]);return e};const Preview_es_x=({open:n,onClose:a,mousePosition:u,allowDownload:h,src:w})=>{const m=(0,react.useRef)(),[b,x]=(0,react.useState)(n),[k,P]=(0,react.useState)(w),[z,$]=(0,react.useState)(n),[D,M]=(0,react.useState)(n),[V,I]=(0,react.useState)(),[Z,B]=(0,react.useState)({}),{images:R,currentIndex:T,setCurrentIndex:W}=v();(0,react.useEffect)((()=>{if(R)if(n){const e=R.findIndex((e=>w.includes(e.src)))||0;T!==e&&W(e)}else k!==w&&P(w)}),[n]);const[G,S]=(0,react_spring_web_modern/* useSpring */.q_)((()=>({from:{opacity:n?0:1},to:{opacity:n?1:0},config:{duration:100},onResolve:()=>{n||$(!1)}})),[n]),[q,A]=(0,react_spring_web_modern/* useSpring */.q_)((()=>{const e="number"==typeof(null==V?void 0:V.width)?u.width/(null==V?void 0:V.width):1,t="number"==typeof(null==V?void 0:V.left)?u.left-(null==V?void 0:V.left):0,o="number"==typeof(null==V?void 0:V.top)?u.top-(null==V?void 0:V.top):0;return{from:{transform:n?`translate(${t}px, ${o}px)`:"translate(0px, 0px)",scale:n?e:1},to:{transform:n?"translate(0px, 0px)":`translate(${t}px, ${o}px)`,scale:n?1:e},config:{duration:100},onResolve:()=>{n||M(!1)}}}),[n,V]),F=()=>{var e,t;return(null==(t=null==(e=m.current)?void 0:e.ownerDocument)?void 0:t.defaultView)||window},H=()=>{var e;return(null==(e=m.current)?void 0:e.ownerDocument)||document},J=()=>{null==a||a()};(0,react.useEffect)((()=>{S.start(),A.start()}),[n]),(0,react.useEffect)((()=>{n&&($(!0),M(!0))}),[n]),(0,react.useEffect)((()=>{n&&!b&&x(!0)}),[n,b]),(0,react.useEffect)((()=>{const e=e=>{"Escape"!==e.key&&27!==e.keyCode||(e.preventDefault(),e.stopPropagation(),J())};return n&&b?((()=>{B({overflow:H().body.style.overflow,width:H().body.style.width});const e=H().body.clientWidth;H().body.style.overflow="hidden",H().body.style.width=`${e}px`})(),F().addEventListener("wheel",J),H().addEventListener("keydown",e,!1)):(H().body.style.width=Z.width,H().body.style.overflow=Z.overflow,B({}),F().removeEventListener("wheel",J),F().removeEventListener("touchstart",J),H().removeEventListener("keydown",e,!1)),()=>{F().removeEventListener("wheel",J),F().removeEventListener("touchstart",J),H().removeEventListener("keydown",e,!1)}}),[n,b]);const K=T<(null==R?void 0:R.length)-1&&(0,jsx_runtime.jsx)(j,{onClick:e=>{var t;e.stopPropagation(),T<(null==R?void 0:R.length)-1&&(P(null==(t=R[T+1])?void 0:t.src),W((e=>e+1)))},children:(0,jsx_runtime.jsx)("svg",{width:"36",height:"36",viewBox:"0 0 36 36",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:(0,jsx_runtime.jsx)("path",{d:"M28.1933 16.9884L10.0808 2.84154C10.0335 2.80427 9.9766 2.78112 9.9167 2.77473C9.85681 2.76833 9.79632 2.77897 9.7422 2.8054C9.68807 2.83183 9.6425 2.873 9.61071 2.92416C9.57893 2.97533 9.56222 3.03443 9.5625 3.09466V6.20046C9.5625 6.39734 9.65491 6.58618 9.80759 6.70671L24.2719 18.0009L9.80759 29.2951C9.6509 29.4156 9.5625 29.6045 9.5625 29.8014V32.9072C9.5625 33.1764 9.87188 33.325 10.0808 33.1603L28.1933 19.0134C28.3473 18.8933 28.4718 18.7397 28.5574 18.5643C28.6431 18.3888 28.6876 18.1962 28.6876 18.0009C28.6876 17.8057 28.6431 17.613 28.5574 17.4376C28.4718 17.2621 28.3473 17.1085 28.1933 16.9884Z",fill:"black"})})}),N=T>0&&(0,jsx_runtime.jsx)(O,{onClick:e=>{var t;e.stopPropagation(),T>0&&(P(null==(t=R[T-1])?void 0:t.src),W((e=>e-1)))},children:(0,jsx_runtime.jsx)("svg",{width:"36",height:"36",viewBox:"0 0 36 36",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:(0,jsx_runtime.jsx)("path",{d:"M26.5188 6.19866V3.09286C26.5188 2.82366 26.2095 2.675 26.0005 2.83974L7.88802 16.9866C7.73413 17.1063 7.60961 17.2595 7.52395 17.4347C7.4383 17.6098 7.39377 17.8022 7.39377 17.9971C7.39377 18.1921 7.4383 18.3844 7.52395 18.5595C7.60961 18.7347 7.73413 18.8879 7.88802 19.0076L26.0005 33.1545C26.2135 33.3192 26.5188 33.1705 26.5188 32.9013V29.7955C26.5188 29.5987 26.4264 29.4098 26.2737 29.2893L11.8095 17.9991L26.2737 6.70491C26.4264 6.58438 26.5188 6.39554 26.5188 6.19866Z",fill:"black"})})}),Q=(0,jsx_runtime.jsx)(jsx_runtime.Fragment,{children:(0,jsx_runtime.jsx)(Preview_es_E,{type:"button",children:(0,jsx_runtime.jsx)("svg",{"aria-hidden":"true","data-rmiz-btn-unzoom-icon":!0,fill:"currentColor",focusable:"false",viewBox:"0 0 16 16",xmlns:"http://www.w3.org/2000/svg",children:(0,jsx_runtime.jsx)("path",{d:"M 14.144531 1.148438 L 9 6.292969 L 9 3 L 8 3 L 8 8 L 13 8 L 13 7 L 9.707031 7 L 14.855469 1.851563 Z M 8 8 L 3 8 L 3 9 L 6.292969 9 L 1.148438 14.144531 L 1.851563 14.855469 L 7 9.707031 L 7 13 L 8 13 Z"})})})}),U=R?[N,K,Q]:[Q];return b?(0,jsx_runtime.jsxs)(jsx_runtime.Fragment,{children:[(0,jsx_runtime.jsx)("div",{ref:m,style:{display:"none"}}),(0,react_dom.createPortal)((0,jsx_runtime.jsxs)("div",{children:[z&&(0,jsx_runtime.jsx)(y,{style:G}),(0,jsx_runtime.jsxs)(L,{onClick:a,style:D?{}:{display:"none"},children:[U,(0,jsx_runtime.jsx)(C,{style:(X=Preview_es_g({},q),Y={transformOrigin:"top left"},Preview_es_v(X,Preview_es_f(Y))),src:k,onContextMenu:e=>{h||e.preventDefault()},onLoad:e=>{V||I(Preview_es_g({width:e.currentTarget.offsetWidth},getOffset_es_e(e.currentTarget)))}})]})]}),H().body)]}):null;var X,Y},y=(0,react_spring_web_modern/* animated */.q)(emotion_styled_browser_esm["default"].div`
  position: fixed;
  inset: 0;
  z-index: 10000;
  height: 100%;
  background-color: rgba(255, 255, 255, 1);
  pointer-events: none;
`),L=emotion_styled_browser_esm["default"].div`
  position: fixed;
  inset: 0;
  z-index: 10001;
  overflow: auto;
  outline: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`,C=(0,react_spring_web_modern/* animated */.q)(emotion_styled_browser_esm["default"].img`
  max-width: 100vw;
  max-height: 100vh;
  cursor: zoom-out;
  user-select: none;
`),k="\nposition: absolute;\ncursor: pointer;\nz-index: 1;\nborder-radius: 50%;\nbackground-color: transparent;\nborder: none;\n\n&:hover{\n  background-color: rgba(0, 0, 0, 0.25);\n}\ntop: 0;\nbottom: 0;\nmargin: auto 0;\npadding: 0;\ntouch-action: manipulation;\nheight: 72px;\nwidth: 72px;",O=emotion_styled_browser_esm["default"].button`
  ${k}
  inset: 20px 20px
`,j=emotion_styled_browser_esm["default"].button`
  ${k}
  right: 20px;
`,Preview_es_E=emotion_styled_browser_esm["default"].button`
  position: absolute;
  cursor: pointer;
  inset: 20px 20px auto auto;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 50%;
  border: none;
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  color: #fff;
  height: 40px;
  margin: 0;
  outline-offset: 2px;
  padding: 9px;
  touch-action: manipulation;
  width: 40px;
`;

// EXTERNAL MODULE: ../../.yarn/cache/clsx-npm-1.1.1-362bec0598-ff05265032.zip/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(877084);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/types/style.es.js
var style_es_e=(e=>(e.percent="%",e.pixel="px",e))(style_es_e||{}),style_es_o=(e=>(e.auto="Auto",e.pixel="px",e))(style_es_o||{}),style_es_t=(e=>(e.YouTube="YouTube",e.Upload="Upload",e))(style_es_t||{}),style_es_i=(e=>(e.COLOR="color",e.IMAGE="image",e.VIDEO="video",e))(style_es_i||{}),style_es_r=(e=>(e.color="color",e.gradient="gradient",e))(style_es_r||{}),style_es_l=(e=>(e.solid="solid",e.gradient="gradient",e.theme="theme",e))(style_es_l||{}),style_es_n=(e=>(e.linear="linear",e.radial="radial",e))(style_es_n||{}),style_es_a=(e=>(e.left="left",e.center="center",e.right="right",e.justify="justify",e))(style_es_a||{}),style_es_c=(e=>(e.top="top",e.center="center",e.bottom="bottom",e.justify="justify",e))(style_es_c||{}),style_es_d=(e=>(e.None="none",e.Fill="fill",e.Contain="contain",e.Cover="cover",e.ScaleDown="scale-down",e))(style_es_d||{});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/constants/common.es.js
const common_es_b="bg-visible-lazy",common_es_l="bg-lazy";

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/colors/util.es.js
function util_es_e(e,l=1){var o;const n=hex_rgb_es_o(e);return n?`rgba(${n.red},${n.green},${n.blue},${null!=(o=null==n?void 0:n.alpha)?o:l})`:null}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/transform.es.js
var transform_es_d=Object.defineProperty,transform_es_u=Object.getOwnPropertySymbols,transform_es_c=Object.prototype.hasOwnProperty,transform_es_s=Object.prototype.propertyIsEnumerable,transform_es_b=(o,r,n)=>r in o?transform_es_d(o,r,{enumerable:!0,configurable:!0,writable:!0,value:n}):o[r]=n,transform_es_p=(o,r)=>{for(var n in r||(r={}))transform_es_c.call(r,n)&&transform_es_b(o,n,r[n]);if(transform_es_u)for(var n of transform_es_u(r))transform_es_s.call(r,n)&&transform_es_b(o,n,r[n]);return o},transform_es_g=(o,r)=>{var n={};for(var e in o)transform_es_c.call(o,e)&&r.indexOf(e)<0&&(n[e]=o[e]);if(null!=o&&transform_es_u)for(var e of transform_es_u(o))r.indexOf(e)<0&&transform_es_s.call(o,e)&&(n[e]=o[e]);return n};const transform_es_m=o=>"number"==typeof o||"string"==typeof o&&!isNaN(o)&&!isNaN(parseFloat(o)),transform_es_f=o=>o.replace(/[A-Z]/g,(o=>`-${o.toLowerCase()}`)),transform_es_$=o=>o&&Object.entries(o).reduce(((r,n)=>{const[e,t]=n;return[null,void 0,!1].some((o=>o===t))||/Unit$/.test(e)?r:`${r}\n${transform_es_f(e)}: ${transform_es_C(t,o[`${e}Unit`])};`}),""),transform_es_v=(o,n)=>o===style_es_r.color&&n?`\n      & {\n        position: relative;\n\n        &:before {\n          position: absolute;\n          top: 0;\n          bottom: 0;\n          left: 0;\n          right: 0;\n          content: '';\n          background: ${n};\n          border-radius: inherit;\n          z-index: -1;\n        }\n      }\n    `:"",transform_es_y=(o,r)=>o?`\n    & {\n      background-repeat: ${"horizontal"===o?"repeat-x":"repeat-y"} !important;\n      animation: ${"horizontal"===o?"bg-marquee-horizontal":"bg-marquee-vertical"} ${99999/(r||30)}s linear infinite;\n    }\n  `:"",transform_es_h=o=>{let r="";return(null==o?void 0:o.color)&&(r="box-shadow: ",r+=(null==o?void 0:o.x)?`${o.x}px `:"0 ",r+=(null==o?void 0:o.y)?`${o.y}px `:"0 ",r+=(null==o?void 0:o.blur)?`${o.blur}px `:"0 ",r+=(null==o?void 0:o.spread)?`${o.spread}px `:"0 ",r+=`${o.color};`),(null==o?void 0:o.on)&&(r="box-shadow: ",r+=(null==o?void 0:o.x)?`${o.x}px `:"0 ",r+=(null==o?void 0:o.y)?`${o.y}px `:"0 ",r+=(null==o?void 0:o.blur)?`${o.blur}px `:"0 ",r+=(null==o?void 0:o.spread)?`${o.spread}px `:"0 ",r+=`rgba(0,0,0,${null==o?void 0:o.opacity});`),r},transform_es_k=o=>{let r="";return(null==o?void 0:o.color)&&(r="text-shadow: ",r+=(null==o?void 0:o.x)?`${o.x}px `:"0 ",r+=(null==o?void 0:o.y)?`${o.y}px `:"0 ",r+=(null==o?void 0:o.blur)?`${o.blur}px `:"0 ",r+=`${o.color};`),r},transform_es_x=o=>{if(!(null==o?void 0:o.on))return"";const{x:r=0,y:n=0,blur:e=0,color:t="rgba(0,0,0,1)"}=o;return`filter: drop-shadow(${r}px ${n}px ${e}px ${t});`},transform_es_w=o=>`\n    ${(null==o?void 0:o.name)?`animation-name: ${o.name};`:""}\n    ${transform_es_m(null==o?void 0:o.delay)?`animation-delay: ${o.delay}s;`:""}\n    ${transform_es_m(null==o?void 0:o.duration)?`animation-duration: ${o.duration}s;`:""}\n    ${"infinite"===(null==o?void 0:o.repeatType)?"animation-iteration-count: infinite;":transform_es_m(null==o?void 0:o.repeatNumber)?`animation-iteration-count: ${o.repeatNumber};`:""}\n    `,transform_es_R=(r,n,e)=>!/^url\((.*)\)$/.test(r)&&r?`url(${image_es_a(r,{width:n,percent:e,format:"webp",compressLevel:1})})`:r,transform_es_O=(o,r={lazyBgImage:!1})=>{const{lazyBgImage:t}=r;if(!o)return"";const i=o,{margin:a={},padding:d={},border:u={},shadow:c,textShadow:s,backgroundType:b,backgroundVideo:x,backgroundOverlay:w,backgroundOverlayType:O,bgImageWidth:I,bgImagePercent:z,backgroundImage:C,hover:S={},animation:j,defaultOverlay:N,background:V,backgroundBlur:L,backgroundColor:B,backgroundPosition:W,backgroundRepeat:q,backgroundSize:P,backgroundMarqueeDirection:E,backgroundMarqueeSpeed:M,borderRadius:D,borderBottomLeftRadius:H,borderBottomRightRadius:F,borderTopLeftRadius:A,borderTopRightRadius:U,cornerType:G,placeholderColor:Z}=i,J=transform_es_g(i,["margin","padding","border","shadow","textShadow","backgroundType","backgroundVideo","backgroundOverlay","backgroundOverlayType","bgImageWidth","bgImagePercent","backgroundImage","hover","animation","defaultOverlay","background","backgroundBlur","backgroundColor","backgroundPosition","backgroundRepeat","backgroundSize","backgroundMarqueeDirection","backgroundMarqueeSpeed","borderRadius","borderBottomLeftRadius","borderBottomRightRadius","borderTopLeftRadius","borderTopRightRadius","cornerType","placeholderColor"]),{borderStyle:K,borderWidth:Q}=o||{},X="detail"===G?{borderBottomLeftRadius:H,borderBottomRightRadius:F,borderTopLeftRadius:A,borderTopRightRadius:U}:{borderRadius:D};let Y="";if(!b&&!(null==x?void 0:x.src)&&!(null==x?void 0:x.uploadSrc)||b&&b!==style_es_i.VIDEO){if(Y+=`${transform_es_$({background:V,backgroundColor:B})}`,C&&(!b||b===style_es_i.IMAGE)){const o=transform_es_R(C,I,z),r=(o=>transform_es_R(o,200,100))(C);Y+=o!==r&&t?`\n        background-image: ${r};\n        &.${common_es_b} {\n          background-image: ${o};\n        }\n      `:`\n        background-image: ${o};\n      `,Y+=transform_es_y(E,M)}Y+=`\n      ${transform_es_v(O,w)}\n      ${transform_es_$({backgroundPosition:W,backgroundRepeat:q,backgroundSize:P})}\n    `}else Y+="\n      position: relative;\n    ";return`\n    & {\n      ${transform_es_h(c)}\n      ${transform_es_k(s)}\n      ${transform_es_$(transform_es_p(transform_es_p(transform_es_p({},X),u),J))}\n      ${Y}\n      ${(o=>{const r=["top","right","bottom","left"],n=["topLeft","topRight","bottomRight","bottomLeft"];return Object.entries(o).reduce(((o,t)=>{const[i,l={}]=t,a=l,{unit:d=style_es_e.pixel}=a,u=transform_es_g(a,["unit"]);return o+"\n"+Object.keys(u).filter((o=>(r.includes(o)||n.includes(o))&&null!==l[o]&&void 0!==l[o])).map((o=>{let r;return r=transform_es_m(l[o])?l[o]+d:l[o],`${transform_es_f(`${i}-${o}`)}: ${r};`})).join("\n")}),"")})({margin:a,padding:d})}\n      ${((o,r)=>`\n    &:hover {\n      ${transform_es_$(transform_es_p(transform_es_p(transform_es_p(transform_es_p({},(null==o?void 0:o.color)&&{color:o.color}),(null==o?void 0:o.backgroundColor)&&{backgroundColor:o.backgroundColor}),(null==o?void 0:o.background)&&{background:o.background}),(null==o?void 0:o.borderColor)&&{borderColor:o.borderColor,borderWidth:(null==r?void 0:r.borderWidth)||1,borderStyle:(null==r?void 0:r.borderStyle)||"solid"}))}\n      ${(null==o?void 0:o.zIndex)?`z-index: ${o.zIndex};`:""}\n      ${(null==o?void 0:o.transparent)?`opacity: ${o.transparent/100};`:""}\n      ${(null==o?void 0:o.zoom)?`transform: scale(${o.zoom/100})`:""}\n    }\n    `)(S,{borderWidth:Q,borderStyle:K})}\n      ${b===style_es_i.COLOR?"":(_=b===style_es_i.VIDEO?null==x?void 0:x.defaultOverlay:N,_?`\n      & {\n        position: relative;\n        z-index: 0;\n\n        &:before {\n          position: absolute;\n          top: 0;\n          bottom: 0;\n          left: 0;\n          right: 0;\n          content: '';\n          background: rgba(0, 0, 0, ${_});\n          border-radius: inherit;\n          z-index: -1;\n        }\n      }`:"")}\n      ${(o=>{if(o>0)return`\n      position: relative;\n      z-index: 0;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        backdrop-filter: blur(${o}px);\n        pointer-events: none;\n        z-index: -1;\n      }`})(L)}\n    }\n      ${T(Z)}\n    `;var _},T=o=>`\n    &::placeholder {\n      color: ${o||"#999"};\n    }\n  `,I=()=>{let o=0;if("undefined"!=typeof window){if(document.body.scrollHeight<=window.innerHeight)return 0;if(window.scrollbarWidth&&document.body.scrollHeight>window.innerHeight)return window.scrollbarWidth;const r=document.createElement("div");r.style.visibility="hidden",r.style.overflow="scroll",document.body.appendChild(r);const n=document.createElement("div");r.appendChild(n),o=r.offsetWidth-n.offsetWidth,r.parentNode.removeChild(r)}return o},z=o=>"number"==typeof o?`${o}px`:o,transform_es_C=(o,r=style_es_e.pixel)=>"number"==typeof o?`${o}${r}`:o,S=(o,r=200)=>{let n;return function(...e){n&&clearTimeout(n),n=setTimeout((()=>{o(...e),n=null}),r)}},transform_es_j=o=>{if(o.colorType===style_es_l.solid)return o.colorValue;const r=o.colorValue;if(!r)return"";const n=[...r.colors];return`${r.gradientType}-gradient(${r.gradientType===style_es_n.radial?"circle":`${r.radius}deg`}, ${n.sort(((o,r)=>o.stop-r.stop)).map((o=>`${o.color} ${o.stop}%`)).join(",")})`},N=o=>{if(!o||"string"!=typeof o)return;if(o.includes("var(--tempi-global-color"))return{colorType:style_es_l.theme,colorValue:o};if(!o.includes("-gradient"))return{colorType:style_es_l.solid,colorValue:o.includes("#")?util_es_e(o):o};const r=o.slice(0,o.indexOf("-gradient")),n=o.substring(o.indexOf("(")+1,o.lastIndexOf(")")).split(/,(?![^(]*\))(?![^"']*["'](?:[^"']*["'][^"']*["'])*[^"']*$)/),e=n.shift(),l=n.map((o=>{const r=o.trim().split(" ");return{color:r[0],stop:parseInt(r[1])}}));return{colorType:style_es_l.gradient,colorValue:{colors:[...l],radius:parseInt(e)||void 0,gradientType:r===style_es_n.linear?style_es_n.linear:style_es_n.radial}}},V=(o=7)=>Math.random().toString(36).substring(1,o),transform_es_L=o=>{if(!o)return"";const r={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#039;"};return o.replace(/[&<>"']/g,(function(o){return r[o]}))},transform_es_B=o=>{if(!o)return"";const r={"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#039;":"'"};return o.replace(/&amp;|&lt;|&gt;|&quot;|&#039;/g,(function(o){return r[o]}))},W=(o,r=!0)=>{if("number"!=typeof o)return null;let n;return n=r?new Intl.NumberFormat("vi-VN",{style:"currency",currency:"VND"}):new Intl.NumberFormat("vi-VN"),n.format(o)};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/render.es.js
var utils_render_es = __webpack_require__(88908);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/isAbsoluteWidth.es.js
const isAbsoluteWidth_es_t=t=>"px"===t.unit;

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/contexts/BreakpointWidthContext.es.js
const BreakpointWidthContext_es_u=(0,react.createContext)({sWidth:{value:100,unit:"%"},mWidth:{value:100,unit:"%"}}),BreakpointWidthContext_es_d=(t,i)=>isAbsoluteWidth_es_t(t)?t:{value:i.value*t.value/100,unit:isAbsoluteWidth_es_t(i)?"px":"%"},BreakpointWidthContext_es_s=({children:i,sWidth:e,mWidth:r})=>{const{sWidth:s,mWidth:m}=BreakpointWidthContext_es_h();return (0,jsx_runtime.jsx)(BreakpointWidthContext_es_u.Provider,{value:{sWidth:BreakpointWidthContext_es_d(e,s),mWidth:BreakpointWidthContext_es_d(r,m)},children:i})},BreakpointWidthContext_es_h=()=>(0,react.useContext)(BreakpointWidthContext_es_u);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/getSrcSetImageWidth.es.js
const getSrcSetImageWidth_es_e=(t,o)=>{const s=[];let e=1;for(;t*e<o;){if(e>100)return s;s.push(t*e),e++}return s.push(o),s},getSrcSetImageWidth_es_n=(n,r)=>{const i=r.sWidth;let h,l;if(isAbsoluteWidth_es_t(i)){const t=i.value,s=Math.min(n,t*root_es/* MAX_DPR */.yP);h=getSrcSetImageWidth_es_e(t,s)}else{const s=Math.floor(i.value*root_es/* MINESTONE_M_WIDTH */.$d/100),r=Math.min(n,s*root_es/* MAX_DPR */.yP);h=getSrcSetImageWidth_es_e(s,r)}const a=r.mWidth;if(isAbsoluteWidth_es_t(a)){const t=a.value,s=Math.min(n,t*root_es/* MAX_DPR */.yP);l=getSrcSetImageWidth_es_e(t,s)}else{const o=Math.floor(a.value*root_es/* MINESTONE_M_WIDTH */.$d/100);l=getSrcSetImageWidth_es_e(o,n)}return{sWidth:h,mWidth:l}};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/buildSrcset.es.js
const buildSrcset_es_m=(m,e)=>e.map((e=>`${image_es_d(m,e)} ${e}w`)).join(",");

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/buildSizes.es.js
const buildSizes_es_e=e=>isAbsoluteWidth_es_t(e)?`${e.value}${e.unit}`:`${e.value}vw`;

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/components/ImageOptimize/ImageOptimize.es.js
const ImageOptimize_es_p=({src:p,googleImageParams:d})=>{const a=BreakpointWidthContext_es_h(),{sWidth:n,mWidth:u}=getSrcSetImageWidth_es_n(d.width,a);return p?(0,jsx_runtime.jsxs)(jsx_runtime.Fragment,{children:[(0,jsx_runtime.jsx)("source",{media:`(max-width: ${root_es/* MINESTONE_M_WIDTH */.$d}px)`,srcSet:buildSrcset_es_m(p,n),sizes:buildSizes_es_e(a.sWidth),type:"image/webp"}),(0,jsx_runtime.jsx)("source",{srcSet:buildSrcset_es_m(p,u),sizes:buildSizes_es_e(a.mWidth),type:"image/webp"})]}):null};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/getBreakpointWidthFromStyle.es.js
const getBreakpointWidthFromStyle_es_t=t=>{const n={value:100,unit:"%"},u=null==t?void 0:t.width,i=null==t?void 0:t.widthUnit;return i?isNaN(+u)?n:{value:+u,unit:i}:"number"==typeof u?{value:u,unit:"px"}:n};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/contexts/StoreContext.es.js
var StoreContext_es = __webpack_require__(116108);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/components/Link/Link.es.js
var Link_es_t=Object.defineProperty,Link_es_r=Object.getOwnPropertySymbols,Link_es_i=Object.prototype.hasOwnProperty,Link_es_c=Object.prototype.propertyIsEnumerable,Link_es_a=(e,n,o)=>n in e?Link_es_t(e,n,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[n]=o,Link_es_s=(e,n)=>{for(var o in n||(n={}))Link_es_i.call(n,o)&&Link_es_a(e,o,n[o]);if(Link_es_r)for(var o of Link_es_r(n))Link_es_c.call(n,o)&&Link_es_a(e,o,n[o]);return e};const Link_es_u=t=>{var a,u,d,p,f,v,g,m,w,h,b,y,k,P,O,C,N,D,x,A=t,{eventType:$,children:T,className:W,sectionMarginTop:_=0,trackingEventName:E,conversionGGAdsId:L,conversionGGAdsLabel:q,scriptCustom:G,style:I}=A,j=((e,n)=>{var o={};for(var l in e)Link_es_i.call(e,l)&&n.indexOf(l)<0&&(o[l]=e[l]);if(null!=e&&Link_es_r)for(var l of Link_es_r(e))n.indexOf(l)<0&&Link_es_c.call(e,l)&&(o[l]=e[l]);return o})(A,["eventType","children","className","sectionMarginTop","trackingEventName","conversionGGAdsId","conversionGGAdsLabel","scriptCustom","style"]);const{globalData:S}=(0,StoreContext_es/* useStore */.o)(),B=(null==S?void 0:S.prefixLangUrl)||"",M=(0,react.useRef)(),F=()=>{var e,n,o,l;E&&(null==(e=null==window?void 0:window.gtag)||e.call(window,"event",E),null==(n=null==window?void 0:window.fbq)||n.call(window,"trackCustom",E),null==(o=null==window?void 0:window.track)||o.call(window,"customEvent",E)),L&&q&&(null==(l=null==window?void 0:window.gtag)||l.call(window,"event","conversion",{send_to:`AW-${L}/${q}`})),R(G)},R=e=>{if(null==e?void 0:e.trim())try{new Function(transform_es_B(e))()}catch(e){console.error(e)}};if("openPageOfWebsite"===$&&((null==(a=j.openPageOfWebsite)?void 0:a.href)||(null==(u=j.openPageOfWebsite)?void 0:u.pageId))){let n=(null==(d=j.openPageOfWebsite)?void 0:d.href)||"";const o=null==(p=j.openPageOfWebsite)?void 0:p.pageId;let l;if(o&&(l=null==(g=null==(v=null==(f=null==S?void 0:S.menu)?void 0:f.find((e=>{var n;return"PAGE"===(null==e?void 0:e.linkType)&&(null==e?void 0:e.linkPageId)===(null==(n=j.openPageOfWebsite)?void 0:n.pageId)})))?void 0:v.page)?void 0:g.slug,n="/"+(l||"")),!o||l)return (0,jsx_runtime.jsx)("a",{style:Link_es_s({textDecoration:"none",color:"unset",cursor:"pointer"},I),href:`${B}${n}`,onClick:F,target:(null==(m=j[$])?void 0:m.openNewTab)?"_blank":"_top",className:W,children:T})}if("openArticleOfWebsite"===$&&(null==(w=j.openArticleOfWebsite)?void 0:w.pageId)){let n="";const o=null==(h=j.openArticleOfWebsite)?void 0:h.pageId;let l;if(o&&(l=null==(y=null==(b=null==S?void 0:S.referencedArticles)?void 0:b.find((e=>(null==e?void 0:e.id)===o)))?void 0:y.slug,n="/"+(l||"")),l)return (0,jsx_runtime.jsx)("a",{style:{textDecoration:"none",color:"unset",cursor:"pointer"},href:`${B}${n}`,onClick:F,target:(null==(k=j[$])?void 0:k.openNewTab)?"_blank":"_self",className:W,children:T})}return"link"===$&&(null==(P=j.link)?void 0:P.href)?(0,jsx_runtime.jsx)("a",{style:Link_es_s({textDecoration:"none",color:"unset",cursor:"pointer"},I),href:j.link.href,onClick:F,target:(null==(O=j[$])?void 0:O.openNewTab)?"_blank":"_top",className:W,rel:(null==(C=j[$])?void 0:C.nofollow)?"nofollow":"noopener noreferrer",children:T}):"inPage"===$&&j.inPage?(0,jsx_runtime.jsx)("div",{style:Link_es_s({cursor:"pointer"},I),onClick:()=>{(e=>{var n;const o=M.current.ownerDocument!==document;let l=window;if(o){const e=window.document.getElementsByTagName("iframe");for(const n of e)if(n.contentDocument===M.current.ownerDocument){l=n.contentWindow;break}}const t=M.current.ownerDocument.querySelectorAll(`[data-id="${e}"]`);for(const e of t)if("none"!==(null==(n=null==l?void 0:l.getComputedStyle(e))?void 0:n.display)){const n=e.getBoundingClientRect().top+l.pageYOffset-_;l.scrollTo({top:n,behavior:"smooth"})}})(j.inPage),F()},ref:M,children:T}):"internal"===$&&(null==(N=j.internal)?void 0:N.href)?(0,jsx_runtime.jsx)("a",{style:Link_es_s({textDecoration:"none",color:"unset",cursor:"pointer"},I),href:`${B}/${j.internal.href}`,onClick:F,target:(null==(D=j.internal)?void 0:D.openNewTab)?"_blank":"_top",className:W,rel:"noopener noreferrer",children:T}):"email"===$&&j.email?(0,jsx_runtime.jsx)("a",{style:Link_es_s({textDecoration:"none",color:"unset",cursor:"pointer"},I),href:`mailto:${j.email}`,onClick:F,className:W,rel:"noopener noreferrer",target:"_top",children:T}):"phone"===$&&j.phone?(0,jsx_runtime.jsx)("a",{style:Link_es_s({textDecoration:"none",color:"unset",cursor:"pointer"},I),href:`tel:${j.phone}`,onClick:F,className:W,rel:"noopener noreferrer",target:"_top",children:T}):"openPopup"===$&&j.togglePopup?(0,jsx_runtime.jsx)("div",{ref:M,style:I,onClick:()=>{var e,n;e=j.togglePopup,null==(n=M.current.ownerDocument.querySelector(`[data-uniq-id="${e}"]`))||n.click(),F()},children:T}):"closePopupList"===$&&(null==(x=j.togglePopupList)?void 0:x.length)?(0,jsx_runtime.jsx)("div",{ref:M,style:I,onClick:()=>{(e=>{const n=M.current.ownerDocument.querySelectorAll("[data-uniq-id]"),o=[];n.forEach((n=>{e.includes(n.getAttribute("data-uniq-id"))&&o.push(n)})),o.forEach((e=>{const n=null==e?void 0:e.parentElement;n.classList.remove("show"),n.classList.add("hide-from-btn"),null==e||e.click()}))})(j.togglePopupList),F()},children:T}):"closePopup"===$&&j.togglePopup?(0,jsx_runtime.jsx)("div",{ref:M,style:I,onClick:()=>{(e=>{const n=M.current.ownerDocument.querySelector(`[data-uniq-id="${e}"]`),o=null==n?void 0:n.parentElement;o.classList.remove("show"),o.classList.add("hide-from-btn"),null==n||n.click()})(j.togglePopup),F()},children:T}):(0,jsx_runtime.jsx)("div",{style:I,onClick:F,children:T})};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/constants/mapping-assets.es.js
const mapping_assets_es_t={cardDefaultImage:"https://lh3.googleusercontent.com/XkvvC_Xpbpatsq8nf_NUjQgAdyB2wD7qbBQO1omzrUoa3eAV7WZuKGkBHHQzDP134RfgK5TFH1tiszH11ptSXQUr5RuvkGgw",defaultImage:"https://lh3.googleusercontent.com/Av6FDtBu9SniovENlthB014sqhpxhMSolIBzF9NCXcs1Ky1zelW1DlQ6UHaNxDRJRoJdY-AxjQJAbnKug8WKdHhpCqGu1iJabA",defaultImageSvg:"https://landingbuilder-cdn.tekoapis.com/static-assets/images/default_image.svg",rouletteImage:"https://lh3.googleusercontent.com/E66gFfiSLjcORXrWIS91o5DKUEPVKqjYN4cc2gn-ORBa12J-2B64bYQ-y938L_ggJbxnUkfkchtlfbFxUd5fT2im6F6ONGm4tw",spinTriggerImage:"https://lh3.googleusercontent.com/1ZxAxoPeshezR3ZevusxeAtmn8PHtf-yK4_SMMYUsvpTdz1l0M_LWWtIo9eDNMxy3Vdssy_QLSwUSK-KpyGUlF32h7eutKA",checkedInputGroupImageBkg:"https://lh3.googleusercontent.com/gb3xmoWfyljDOoCzs17NowaMtKFZllc4UHeBRtAuJWxinFDRJtfmzWnZUd1Sih83LKlP1lPNFdusQVOGyn2iEs13Vra5S74",noProductFoundImage:"https://lh3.googleusercontent.com/aCaLPZj5x231b37or78je16Gtd7e1mOvkpPkFH_pCvr6byaFgc9rw8lOfrClBFH6RRFHP2aZTpT9eN9RuVV743YtQgKV8jG4",VN:"https://landingbuilder-cdn.tekoapis.com/static-assets/json/VN.json"};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/track.es.js
const track_es_t=t=>{if(!t)return{};const{regionName:a,contentName:n,target:e,payload:o}=t;return{"data-track-content":!0,"data-content-region-name":a,"data-content-name":n,"data-content-target":e,"data-content-payload":o}};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/components/Image/Image.es.js
var Image_es_O=Object.defineProperty,Image_es_x=Object.defineProperties,Image_es_z=Object.getOwnPropertyDescriptors,Image_es_C=Object.getOwnPropertySymbols,Image_es_W=Object.prototype.hasOwnProperty,Image_es_I=Object.prototype.propertyIsEnumerable,Image_es_$=(e,t,o)=>t in e?Image_es_O(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o,Image_es_E=(e,t)=>{for(var o in t||(t={}))Image_es_W.call(t,o)&&Image_es_$(e,o,t[o]);if(Image_es_C)for(var o of Image_es_C(t))Image_es_I.call(t,o)&&Image_es_$(e,o,t[o]);return e},F=(e,t)=>Image_es_x(e,Image_es_z(t));const Image_es_L="image-wrapper-rte324",{defaultImage:D}=mapping_assets_es_t,Image_es_R=emotion_styled_browser_esm["default"].div((({alignment:e,customStyle:t})=>`\n    text-align: ${e};\n    ${transform_es_O(t)}\n  `)),Image_es_N=({commonStyle:e,objectFit:t})=>`\n    max-width: 100%;\n    vertical-align: top;\n    display: inline-block;\n    transition: transform 0.3s;\n    overflow: hidden;\n    position: relative;\n    object-fit: ${t||"cover"};\n    object-position: inherit;\n    ${transform_es_O(e)}\n    &:before {\n      z-index: 1;\n    }\n  `,M=emotion_styled_browser_esm["default"].div(Image_es_N),B=emotion_styled_browser_esm["default"].picture(Image_es_N),H=emotion_styled_browser_esm["default"].img((({ratioWidth:e,ratioHeight:t,src:o,aspectRatio:i})=>`\n  width: 100%;\n  height: 100%;\n  border-radius: inherit;\n  object-fit: inherit;\n  &.preview {\n    cursor: zoom-in;\n  }\n  aspect-ratio: ${i||(o?`auto ${e} / ${t}`:"unset")};\n`)),A=emotion_styled_browser_esm["default"].img`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  object-fit: inherit;
  object-position: inherit;
`,Image_es_T=react.forwardRef(((i,r)=>{var p;const b=i,{src:O,alt:x="",commonStyle:z,alignment:$="center",event:N,googleImageParams:T,isEditingMode:q=!1,zoomPreview:G=!1,fetchPriority:J="auto",showPlaceholder:K=!0,autoOptimize:Q=!0,linkStyle:U,imageWrapperStyle:V,isPreview:X=!0,isLinkConfig:Y=!0,width:Z,height:_,name:ee,allowDownload:te,desktop:oe,mobile:ie,aspectRatio:re,objectFit:ne=style_es_d.Cover}=b,le=((e,t)=>{var o={};for(var i in e)Image_es_W.call(e,i)&&t.indexOf(i)<0&&(o[i]=e[i]);if(null!=e&&Image_es_C)for(var i of Image_es_C(e))t.indexOf(i)<0&&Image_es_I.call(e,i)&&(o[i]=e[i]);return o})(b,["src","alt","commonStyle","alignment","event","googleImageParams","isEditingMode","zoomPreview","fetchPriority","showPlaceholder","autoOptimize","linkStyle","imageWrapperStyle","isPreview","isLinkConfig","width","height","name","allowDownload","desktop","mobile","aspectRatio","objectFit"]),{device:ae}=(0,StoreContext_es/* useStore */.o)(),{commonStyle:se}=(0,utils_render_es/* getPropsByDevice */.vv)({commonStyle:z,desktop:oe,mobile:ie},ae),{tekoTrackingEvent:me}=N||{},ce=(0,react.useRef)(null),[pe,de]=(0,react.useState)(!1),[fe,ge]=(0,react.useState)(),he=(0,react.useRef)(null),ue=r||he,{style:ve,animationClassName:ye}=useAnimation_es_a(null==se?void 0:se.animation,ue),[je,we]=(0,react.useState)(!1),be=image_es_a(O,image_es_p(T,{format:"webp",compressLevel:1})),Pe=image_es_a(O,image_es_p(T,{format:"png"})),Se=e=>{e.target.src=D},ke=K?image_es_d(be,200):"",Oe=Q&&(null==T?void 0:T.width),xe=K&&!je&&ke!==be,ze=Z||(null==T?void 0:T.width),Ce=_||(null==T?void 0:T.height),We=(0,jsx_runtime.jsx)(H,{ref:ce,src:be,alt:x,ratioWidth:null!=ze?ze:16,ratioHeight:null!=Ce?Ce:9,aspectRatio:re,onError:Se,decoding:"async",className:(0,clsx_m["default"])("lazyload",{preview:G}),loading:"high"===J?"eager":"lazy",fetchpriority:J,onLoad:()=>{we(!0)},onClick:e=>{if(!G)return;const{left:t,top:o}=getOffset_es_e(e.target);ge({left:t,top:o,width:e.target.clientWidth}),de(!0)}}),Ie=Oe&&O?(0,jsx_runtime.jsxs)(B,{ref:ue,commonStyle:se,objectFit:ne,style:ve,className:(0,clsx_m["default"])(ye,Image_es_L),children:[(0,jsx_runtime.jsx)(ImageOptimize_es_p,{src:be,googleImageParams:T}),Pe&&(0,jsx_runtime.jsx)("source",{srcSet:Pe,type:"image/png"}),We]}):(0,jsx_runtime.jsxs)(M,{ref:ue,commonStyle:se,objectFit:ne,style:ve,className:(0,clsx_m["default"])(ye,Image_es_L),children:[We,xe&&(0,jsx_runtime.jsx)(A,{src:ke,alt:x,onError:Se,fetchpriority:"high"})]});return (0,react.useEffect)((()=>{void 0!==(null==ce?void 0:ce.current)&&ce.current.complete!==je&&we(ce.current.complete)}),[null==(p=null==ce?void 0:ce.current)?void 0:p.complete,je]),(0,jsx_runtime.jsx)(BreakpointWidthContext_es_s,{sWidth:getBreakpointWidthFromStyle_es_t(se),mWidth:getBreakpointWidthFromStyle_es_t(se),children:q?Ie:(()=>{var i;const r=(0,jsx_runtime.jsx)(Image_es_R,F(Image_es_E(Image_es_E({customStyle:V,alignment:$,onContextMenu:e=>{te||e.preventDefault()}},me||{}),le),{"data-image-name":ee,children:Ie}));return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment,{children:[Y?(0,jsx_runtime.jsx)("div",F(Image_es_E({},track_es_t(me)),{children:(0,jsx_runtime.jsx)(Link_es_u,F(Image_es_E({style:U},N),{children:r}))})):r,X?(0,jsx_runtime.jsx)(Preview_es_x,{src:be||Pe||(null==(i=ce.current)?void 0:i.currentSrc),open:pe,allowDownload:te,onClose:()=>{de(!1)},mousePosition:fe}):null]})})()})}));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/components/LazyComponent/LazyComponent.es.js
const LazyComponent_es_s=({children:s})=>{const c=(0,react.useRef)(null),[m,l]=(0,react.useState)(!1),a=useIntersectionObserver_es_n(c,{freezeOnceVisible:!0,rootMargin:"30% 0px"});return (0,react.useEffect)((()=>{a&&l(!0)}),[a]),m?(0,jsx_runtime.jsx)(jsx_runtime.Fragment,{children:s}):(0,jsx_runtime.jsx)("div",{ref:c,className:"lazy-component",style:{width:"100%",height:100}})};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/components/LazyComponent/ReactLazyComponent.es.js
var ReactLazyComponent_es_o=Object.defineProperty,ReactLazyComponent_es_a=Object.getOwnPropertySymbols,ReactLazyComponent_es_c=Object.prototype.hasOwnProperty,ReactLazyComponent_es_s=Object.prototype.propertyIsEnumerable,ReactLazyComponent_es_l=(e,r,n)=>r in e?ReactLazyComponent_es_o(e,r,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[r]=n,ReactLazyComponent_es_u=(e,r)=>{for(var n in r||(r={}))ReactLazyComponent_es_c.call(r,n)&&ReactLazyComponent_es_l(e,n,r[n]);if(ReactLazyComponent_es_a)for(var n of ReactLazyComponent_es_a(r))ReactLazyComponent_es_s.call(r,n)&&ReactLazyComponent_es_l(e,n,r[n]);return e};const ReactLazyComponent_es_d={once:!0,capture:!0,passive:!0},ReactLazyComponent_es_p={rootMargin:"30% 0px"},ReactLazyComponent_es_b=({on:o=[],whenInputPending:a=!1,children:c,forceHydration:s=!1})=>{const l=(0,react.useRef)(null),b=(0,react.useRef)([]),[v,f]=(0,react.useState)(a&&!(null==(m=null==(h=null==navigator?void 0:navigator.scheduling)?void 0:h.isInputPending)?void 0:m.call(h))||s);var h,m;return (0,react.useEffect)((()=>{const e=()=>{b.current.forEach((e=>e())),b.current=[]},r=async()=>{e(),v||f(!0)},n=(e,n)=>{switch(e){case"delay":((e=2e3)=>{if(e<=0)return;const n=setTimeout(r,e);b.current.push((()=>clearTimeout(n)))})(n);break;case"visible":(e=>{if(!("IntersectionObserver"in window))return void r();const n=ReactLazyComponent_es_u(ReactLazyComponent_es_u({},ReactLazyComponent_es_p),e),t=new IntersectionObserver((([e])=>{e.isIntersecting&&e.intersectionRatio>0&&r()}),n);b.current.push((()=>{t&&t.disconnect()})),t.observe(l.current)})(n);break;case"idle":((e=1e3)=>{if(!("requestIdleCallback"in window))return void r();const n=requestIdleCallback((()=>requestAnimationFrame((()=>r()))),{timeout:e});"cancelIdleCallback"in window&&b.current.push((()=>{cancelIdleCallback(n)}))})(n);break;default:((e,n=()=>l.current)=>{const t=n();t.addEventListener(e,r,ReactLazyComponent_es_d),b.current.push((()=>{t&&t.removeEventListener(e,r,ReactLazyComponent_es_d)}))})(e,n)}};if(!v)return o.forEach((e=>Array.isArray(e)?n(...e):n(e))),e}),[]),v?(0,jsx_runtime.jsx)(jsx_runtime.Fragment,{children:c}):(0,jsx_runtime.jsx)("section",{ref:l,dangerouslySetInnerHTML:{__html:""},style:{width:"100%",height:100},suppressHydrationWarning:!0})};

// EXTERNAL MODULE: ../../.yarn/__virtual__/react-youtube-virtual-f153a8b3de/0/cache/react-youtube-npm-10.1.0-57507894ba-514678c2a2.zip/node_modules/react-youtube/dist/YouTube.esm.js
var YouTube_esm = __webpack_require__(499985);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/isGCSUrl.es.js
const isGCSUrl_es_t=t=>!(!t||!new RegExp(/^(?:https?:\/\/)?(?:www\.)?storage\.googleapis\.com/i).test(t));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/youtubeParser.es.js
const youtubeParser_es_t=t=>{var d;const e=null==t?void 0:t.trim();if(!e)return{videoId:"",playlistId:""};const l=new RegExp("^(https?:\\/\\/)?(www\\.)?(youtu\\.be\\/|youtube\\.com\\/(shorts\\/|embed\\/|v\\/|watch\\?(.+&)*v=))(?<videoId>[\\w-]+)(?:.*?[?&]list=(?<playlistId>[\\w-]+))?"),{videoId:o,playlistId:i}=(null==(d=l.exec(e))?void 0:d.groups)||{};return{videoId:11===(null==o?void 0:o.length)?o:"",playlistId:i||""}};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/components/BackgroundVideo/BackgroundVideo.es.js
var BackgroundVideo_es_m=Object.defineProperty,BackgroundVideo_es_p=Object.defineProperties,BackgroundVideo_es_d=Object.getOwnPropertyDescriptors,BackgroundVideo_es_f=Object.getOwnPropertySymbols,BackgroundVideo_es_y=Object.prototype.hasOwnProperty,BackgroundVideo_es_b=Object.prototype.propertyIsEnumerable,BackgroundVideo_es_v=(e,t,r)=>t in e?BackgroundVideo_es_m(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,BackgroundVideo_es_h=(e,t)=>{for(var r in t||(t={}))BackgroundVideo_es_y.call(t,r)&&BackgroundVideo_es_v(e,r,t[r]);if(BackgroundVideo_es_f)for(var r of BackgroundVideo_es_f(t))BackgroundVideo_es_b.call(t,r)&&BackgroundVideo_es_v(e,r,t[r]);return e},BackgroundVideo_es_g=(e,t)=>BackgroundVideo_es_p(e,BackgroundVideo_es_d(t));const BackgroundVideo_es_j=({platform:t,src:i,uploadSrc:c,defaultOverlay:m,backgroundBlur:p,background:d,objectFit:f,style:y})=>{const b=(0,react.useRef)(),v=(0,react.useRef)(),[j,z]=(0,react.useState)();(0,react.useEffect)((()=>()=>clearTimeout(v.current)),[]),(0,react.useEffect)((()=>{const e=()=>{const e=(()=>{if(!(null==b?void 0:b.current))return;let{clientWidth:e,clientHeight:t}=b.current;const r=16/9,o=e/t;return o<r?e=t*r:o>r&&(t=e/r),{width:e,height:t}})();e&&z(e)};return e(),window.addEventListener("resize",e),()=>{window.removeEventListener("resize",e)}}),[null==b?void 0:b.current]);const I=useIntersectionObserver_es_n(b,{freezeOnceVisible:!0});return i||c||m?t===style_es_t.Upload&&!c||t===style_es_t.YouTube&&!i?null:(0,jsx_runtime.jsx)(BackgroundVideo_es_w,{ref:b,commonStyle:BackgroundVideo_es_h({defaultOverlay:m,backgroundBlur:p,background:d},y),children:(()=>{if(!I||!b.current)return null;if(t===style_es_t.Upload||!t&&isGCSUrl_es_t(c))return (0,jsx_runtime.jsx)("video",BackgroundVideo_es_g(BackgroundVideo_es_h({},j),{style:BackgroundVideo_es_g(BackgroundVideo_es_h({},BackgroundVideo_es_T),{objectFit:f||"cover",width:"100%",height:"100%"}),playsInline:!0,loop:!0,autoPlay:!0,muted:!0,src:c,crossOrigin:"anonymous"}));const{videoId:r}=youtubeParser_es_t(i);if(!r)return null;let o,n;function a(){let e=o.getCurrentTime();if(e*=1e3,e>=n)o.seekTo(0),v.current=setTimeout(a,n);else{const t=n-e-10;v.current=setTimeout(a,t)}}return (0,jsx_runtime.jsx)(BackgroundVideo_es_O,{videoId:r,opts:BackgroundVideo_es_g(BackgroundVideo_es_h({},j),{playerVars:{playlist:r,playsInLine:1,mute:1,controls:0,allowFullScreen:1,autoplay:1}}),onReady:e=>{o=e.target,n=1e3*o.getDuration()-1e3,v.current=setTimeout(a,n)},onEnd:()=>{clearTimeout(v.current)}})})()}):null},BackgroundVideo_es_w=emotion_styled_browser_esm["default"].div((({commonStyle:e})=>`\n  ${transform_es_O(e)}\n\n  position: absolute !important;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  overflow: hidden;\n  z-index: 0;\n`)),BackgroundVideo_es_O=(0,emotion_styled_browser_esm["default"])(YouTube_esm["default"])`
  iframe {
    min-width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: -2; // z-index of overlay: -1
  }
`,BackgroundVideo_es_T={position:"absolute",top:"50%",left:"50%",transform:"translate(-50%, -50%)",zIndex:"-2"};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/date-time.es.js
var date_time_es = __webpack_require__(385190);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/getComponentProps.es.js
var getComponentProps_es_r=Object.defineProperty,getComponentProps_es_i=Object.defineProperties,getComponentProps_es_o=Object.getOwnPropertyDescriptors,getComponentProps_es_a=Object.getOwnPropertySymbols,getComponentProps_es_d=Object.prototype.hasOwnProperty,getComponentProps_es_n=Object.prototype.propertyIsEnumerable,getComponentProps_es_s=(e,t,i)=>t in e?getComponentProps_es_r(e,t,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[t]=i,getComponentProps_es_l=(e,t)=>{for(var r in t||(t={}))getComponentProps_es_d.call(t,r)&&getComponentProps_es_s(e,r,t[r]);if(getComponentProps_es_a)for(var r of getComponentProps_es_a(t))getComponentProps_es_n.call(t,r)&&getComponentProps_es_s(e,r,t[r]);return e};const getComponentProps_es_p=(r,a,d)=>{var n,s;const{customAttributes:p,style:m,elementId:c,id:u,startTime:b,endTime:y,ruleRepeat:v,date:f,duration:O,tag:j,children:h}=r||{},P=getComponentProps_es_l((g=getComponentProps_es_l({},p[j]||{}),getComponentProps_es_i(g,getComponentProps_es_o({commonStyle:m||{},id:c,"data-id":c,"data-uniq-id":u,dataUniqId:u}))),a);var g;return{key:u,props:P,className:(0,clsx_m["default"])({"hidden-xs":null==(n=P.responsive)?void 0:n.hiddenXs,"hidden-md":null==(s=P.responsive)?void 0:s.hiddenMd}),ssrData:d,isVisible:(0,date_time_es/* validateIsVisibleComponent */.U0)({startTime:b,endTime:y,ruleRepeat:v,date:f,duration:O}),nodes:h||[]}};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/components/NodeElement/NodeElements.es.js
var NodeElements_es_r=Object.defineProperty,NodeElements_es_i=Object.getOwnPropertySymbols,NodeElements_es_l=Object.prototype.hasOwnProperty,NodeElements_es_a=Object.prototype.propertyIsEnumerable,NodeElements_es_s=(e,t,n)=>t in e?NodeElements_es_r(e,t,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[t]=n,NodeElements_es_c=(e,t)=>{for(var n in t||(t={}))NodeElements_es_l.call(t,n)&&NodeElements_es_s(e,n,t[n]);if(NodeElements_es_i)for(var n of NodeElements_es_i(t))NodeElements_es_a.call(t,n)&&NodeElements_es_s(e,n,t[n]);return e},NodeElements_es_p=(e,t)=>{var n={};for(var o in e)NodeElements_es_l.call(e,o)&&t.indexOf(o)<0&&(n[o]=e[o]);if(null!=e&&NodeElements_es_i)for(var o of NodeElements_es_i(e))t.indexOf(o)<0&&NodeElements_es_a.call(e,o)&&(n[o]=e[o]);return n};const NodeElements_es_m=r=>{var i,l,a,s,d=r,{id:u}=d,f=NodeElements_es_p(d,["id"]);const v=(0,StoreContext_es/* useStore */.o)(),{content:b,ssrData:g,componentDict:y,mappingDynamicSlots:O}=v,j=NodeElements_es_p(v,["content","ssrData","componentDict","mappingDynamicSlots"]),D=b[u];if(!D||!y[D.tag])return console.warn("Cannot found component: "+(null==(i=null==D?void 0:D.tag)?void 0:i.toString())),null;const{className:h,props:x,isVisible:S}=getComponentProps_es_p(D,j,g[u]);if(!S||(null==(l=x.responsive)?void 0:l.hiddenXs)&&"mobile"===j.device||(null==(a=x.responsive)?void 0:a.hiddenMd)&&"desktop"===j.device)return null;let w;return(null==(s=null==D?void 0:D.children)?void 0:s.length)&&(w=D.children.map((t=>(0,jsx_runtime.jsx)(NodeElements_es_m,{id:t},t)))),react.createElement(y[D.tag],NodeElements_es_c(NodeElements_es_c({key:u,ssrData:g[u],className:h},x),f),w)};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/components/TimeVisibilityWrapper/TimeVisibilityWrapper.es.js
var TimeVisibilityWrapper_es = __webpack_require__(268751);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/constants/reset.es.js
var reset_es = __webpack_require__(577995);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/constants/fonts.es.js
var fonts_es = __webpack_require__(791790);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/constants/regex.es.js
const regex_es_s={email:/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,phone:/^(0|84|\+84)[1-9]([0-9]{8,9})$/};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/constants/rc-cascader.es.js
var rc_cascader_es = __webpack_require__(49563);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/constants/animation.es.js
var animation_es = __webpack_require__(12913);
// EXTERNAL MODULE: ../../.yarn/cache/lodash.set-npm-4.3.2-7586c942c2-a9122f49ee.zip/node_modules/lodash.set/index.js
var lodash_set = __webpack_require__(407229);
var lodash_set_default = /*#__PURE__*/__webpack_require__.n(lodash_set);
// EXTERNAL MODULE: ../../.yarn/cache/lodash.get-npm-4.4.2-7bda64ed87-e403047ddb.zip/node_modules/lodash.get/index.js
var lodash_get = __webpack_require__(47248);
var lodash_get_default = /*#__PURE__*/__webpack_require__.n(lodash_get);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/hooks/useLocationChange.es.js
const useLocationChange_es_e=(e,n=!1)=>{(0,react.useEffect)((()=>{n&&e();const t=window.history.pushState,o=window.history.replaceState,i=()=>{window.dispatchEvent(new Event("locationchange"))};return window.history.pushState=function(...e){const n=t.apply(this,e);return i(),n},window.history.replaceState=function(...t){const e=o.apply(this,t);return i(),e},window.addEventListener("popstate",i,!1),window.addEventListener("locationchange",e,!1),()=>{window.removeEventListener("locationchange",e,!1),window.history.pushState=t,window.history.replaceState=o,window.removeEventListener("popstate",i,!1)}}),[])};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/computeStringHandleBarsExpression.es.js
const computeStringHandleBarsExpression_es_r=(r,l)=>r.replaceAll(/"{{([\w,.]*)}}"/g,(r=>{const t=lodash_get_default()(l,r.replace(/"{{/,"").replace(/}}"/,""));return JSON.stringify(t)})).replaceAll(/{{([\w,.]*)}}/g,(r=>{var t;const a=lodash_get_default()(l,r.replace(/{{/,"").replace(/}}/,""));return"string"==typeof a||"number"==typeof a?null==(t=null==a?void 0:a.toString)?void 0:t.call(a):r})),computeStringHandleBarsExpression_es_l=e=>(e.match(/{{([\w,.]*)}}/g)||[]).map((e=>e.replace(/{{/,"").replace(/}}/,""))),computeStringHandleBarsExpression_es_t=e=>!!e&&/{{([\w,.]*)}}/g.test(e);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/contexts/PageDataContext.es.js
const PageDataContext_es_c=react.createContext({}),PageDataContext_es_u=({children:o,user:n})=>{const[u,p]=(0,react.useState)(),[h,l]=(0,react.useState)();return useLocationChange_es_e((()=>{const e=window.location.search;p(Object.fromEntries(new URLSearchParams(e)))}),!0),(0,jsx_runtime.jsx)(PageDataContext_es_c.Provider,{value:{setComponentValueByPath:(e,r)=>{const o=Object.assign({},h);lodash_set_default()(o,e,r),l(o)},getValueByPath:e=>computeStringHandleBarsExpression_es_t(e)?computeStringHandleBarsExpression_es_r(e,{components:h,user:n,queryParams:u}):lodash_get_default()({components:h,user:n,queryParams:u},e),storeData:{components:h,queryParams:u,user:n}},children:o})};function PageDataContext_es_p(){const e=(0,react.useContext)(PageDataContext_es_c);if(!e)throw new Error("use must be inside a ComponentStateContext with a state value");return e}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/contexts/useInitValue.es.js
const useInitValue_es_a=({settingValue:a})=>{const{storeData:o,getValueByPath:n}=PageDataContext_es_p();return{initValue:(0,react.useMemo)((()=>{const{valueType:t,contextPath:e,staticValue:o}=a||{};let r;return"STATIC"===t&&(r=o),"CONTEXT_PATH"===t&&(r=n(e)),r}),[a,null==o?void 0:o.components])}};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/hooks/useInjectLinksToHTML.es.js
var useInjectLinksToHTML_es_r=Object.defineProperty,useInjectLinksToHTML_es_t=Object.defineProperties,useInjectLinksToHTML_es_o=Object.getOwnPropertyDescriptors,useInjectLinksToHTML_es_n=Object.getOwnPropertySymbols,useInjectLinksToHTML_es_l=Object.prototype.hasOwnProperty,useInjectLinksToHTML_es_a=Object.prototype.propertyIsEnumerable,useInjectLinksToHTML_es_c=(e,t,o)=>t in e?useInjectLinksToHTML_es_r(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o;const useInjectLinksToHTML_es_p=(r,p)=>{(0,react.useEffect)((()=>{if(!(null==r?void 0:r.length))return;const e=p||document,i=[...e.getElementsByTagName("link")].reduce(((e,r)=>{return p=((e,r)=>{for(var t in r||(r={}))useInjectLinksToHTML_es_l.call(r,t)&&useInjectLinksToHTML_es_c(e,t,r[t]);if(useInjectLinksToHTML_es_n)for(var t of useInjectLinksToHTML_es_n(r))useInjectLinksToHTML_es_a.call(r,t)&&useInjectLinksToHTML_es_c(e,t,r[t]);return e})({},e),i={[r.href]:!0},useInjectLinksToHTML_es_t(p,useInjectLinksToHTML_es_o(i));var p,i}),{});r.forEach((({type:r,rel:t,href:o})=>{if(!i[o]){const n=e.createElement("link");r&&(n.type=r),t&&(n.rel=t),n.href=o,e.head.appendChild(n),i[o]=!0}}))}),[p])};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/hooks/useTimer.es.js
const useTimer_es_n=n=>{const[o,a]=(0,react.useState)((()=>n?(0,date_time_es/* calculateTimeDelta */.mE)(new Date,n):null));return (0,react.useEffect)((()=>{const t=setInterval((()=>a((0,date_time_es/* calculateTimeDelta */.mE)(new Date,n))),1e3);return()=>{clearInterval(t)}}),[n]),o};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/hooks/useTimeVisibility.es.js
const useTimeVisibility_es_e=(e,l=!1)=>({displayItems:(0,react.useMemo)((()=>null==e?void 0:e.filter((i=>!!l||(0,date_time_es/* validateIsVisibleComponent */.U0)((null==i?void 0:i.timeVisibility)||{})))),[l,e])});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/hooks/useInjectDynamicLinks.es.js
const useInjectDynamicLinks_es_t=(t,a)=>{const{mappingWebsiteMenuHref:n,globalData:r}=(0,StoreContext_es/* useStore */.o)();return{text:(()=>{let e=t;return t&&a&&(e=t.replace(/<a(.*?)<\/a>/g,`<span ${a}><a$1</a></span>`)),t?(n&&(e=e.replace(new RegExp('(?<start><a[^>]+)(?<attrName>data-(?:page|article)-id)="(?<pageId>[a-zA-Z0-9]+)"(?<end>[^>]*>)',"g"),((e,t,a,o,l)=>{var p,c;let i;if("data-article-id"===a){const e=null==(c=null==(p=null==r?void 0:r.referencedArticles)?void 0:p.find((e=>{var t;return(null==(t=null==e?void 0:e.id)?void 0:t.toString())===o})))?void 0:c.slug;e&&(i=(null==r?void 0:r.prefixLangUrl)+"/"+(e||""))}else i=n[o];return i?`${t}${a}="${o}" href="${i}"${l}`:e}))),e=e.replace(new RegExp('(?<start><a[^>]+)data-link-href="(?<href>[^"]+)"(?<end>[^>]*>)',"g"),((e,t,a,n)=>`${t}href="${a}"${n}`)),e=e.replace(new RegExp('(?<start><a[^>]+)data-email="(?<email>[^"]+)"(?<end>[^>]*>)',"g"),((e,t,a,n)=>`${t}href="mailto:${a}"${n}`)),e=e.replace(new RegExp('(?<start><a[^>]+)data-phone="(?<phone>[^"]+)"(?<end>[^>]*>)',"g"),((e,t,a,n)=>`${t}href="tel:${a}"${n}`)),e=e.replace(/<a([^>]+)data-inpage-id="([^"]+)"([^>]*)>/g,((e,t,a,n)=>{const r=n.match(/data-section-margin-top="([^"]+)"/),o=r?r[1]:null,l=n.replace(/data-inpage-id="[^"]*"/g,"").replace(/data-section-margin-top="[^"]*"/g,"").trim();if(o){const e=parseInt(o,10);return`<a${t}href="#${a}" onclick="event.preventDefault(); const element=document.querySelector('[data-id=\\'${a}\\']');if(element){const top=element.getBoundingClientRect().top+window.pageYOffset${e>=0?`-${e}`:`+${Math.abs(e)}`};window.scrollTo({top,behavior:'smooth'});}"${l?" "+l:""}>`}return`<a${t}href="#${a}" onclick="document.querySelector('[data-id=\\'${a}\\']')?.scrollIntoView({behavior: 'smooth'}); return false;"${l?" "+l:""}>`})),e=e.replace(new RegExp('(?<start><a[^>]+)data-open-popup-id="(?<openPopupId>[^"]+)"(?<end>[^>]*>)',"g"),((e,t,a,n)=>`${t}href="#" onclick="document.querySelector('[data-uniq-id=\\'${a}\\']')?.click(); return false;"${n}`)),e=e.replace(new RegExp('(?<start><a[^>]+)data-close-popup-id="(?<closePopupId>[^"]+)"(?<end>[^>]*>)',"g"),((e,t,a,n)=>`${t}href="#" onclick="(function(){const currentDoc=this.ownerDocument||document;const getAllElement=currentDoc.querySelectorAll('[data-uniq-id]');const popupList=[];getAllElement.forEach((el)=>{if(el.getAttribute('data-uniq-id')==='${a}'){popupList.push(el);}});popupList.forEach((popup)=>{const maskPopup=popup.parentElement;maskPopup.classList.remove('show');maskPopup.classList.add('hide-from-btn');maskPopup.click();});})(); return false;"${n}`)),e=e.replace(/<a([^>]+)data-copy-text="([^"]+)"([^>]*)>/g,((e,t,a,n)=>{const r=(t+" "+n).match(/data-notification-message="([^"]+)"/),o=r?r[1]:"Copy thành công!",l=t.replace(/data-copy-text="[^"]*"/g,"").trim(),p=n.replace(/data-copy-text="[^"]*"/g,"").replace(/data-notification-message="[^"]*"/g,"").trim();return`<a${l}href="#" style="cursor: pointer;" onclick="navigator.clipboard.writeText('${a}').then(()=>alert('${o}')); return false;"${p?" "+p:""}>`})),e=e.replace(new RegExp('(?<start><a[^>]+)data-open-new-tab="(?<openNewTab>[^"]+)"(?<end>[^>]*>)',"g"),((e,t,a,n)=>{const r="true"===a?"noopener noreferrer":"";return`${t}target="${"true"===a?"_blank":"_self"}"${r?` rel="${r}"`:""}${n}`})),e=e.replace(new RegExp('(?<start><a[^>]+)data-nofollow="(?<nofollow>[^"]+)"(?<end>[^>]*>)',"g"),((e,t,a,n)=>"true"===a?`${t}rel="nofollow"${n}`:e)),e):e})()}};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/hooks/useEndpointHandler.es.js
var useEndpointHandler_es_c=Object.defineProperty,useEndpointHandler_es_l=Object.getOwnPropertySymbols,useEndpointHandler_es_u=Object.prototype.hasOwnProperty,useEndpointHandler_es_d=Object.prototype.propertyIsEnumerable,useEndpointHandler_es_m=(e,r,t)=>r in e?useEndpointHandler_es_c(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,useEndpointHandler_es_y=(e,r)=>{for(var t in r||(r={}))useEndpointHandler_es_u.call(r,t)&&useEndpointHandler_es_m(e,t,r[t]);if(useEndpointHandler_es_l)for(var t of useEndpointHandler_es_l(r))useEndpointHandler_es_d.call(r,t)&&useEndpointHandler_es_m(e,t,r[t]);return e};const useEndpointHandler_es_p=c=>{const[l,u]=(0,react.useState)(),[d,m]=(0,react.useState)(!1),[p,f]=(0,react.useState)(),[b,h]=(0,react.useState)(),{auth:{getAccessToken:v,user:g={}}={},globalData:{endpoints:O=[]}={}}=(0,StoreContext_es/* useStore */.o)(),j=async()=>{const e=O.find((e=>e.id===c));if(!e||!(e=>[...computeStringHandleBarsExpression_es_l(e.url||""),...computeStringHandleBarsExpression_es_l(e.body||""),...computeStringHandleBarsExpression_es_l(e.headers||"")].every((e=>void 0!==lodash_get_default()({queryParams:l,user:g},e))))(e)||!l)return;const r=new index_es_u(""),o=computeStringHandleBarsExpression_es_r(e.url,{queryParams:l,user:g});let a,u={};if("GET"!==e.method&&e.body)try{a=JSON.parse(computeStringHandleBarsExpression_es_r(e.body,{queryParams:l,user:g}))}catch(e){console.error(e),a={}}if(e.headers)try{u=JSON.parse(computeStringHandleBarsExpression_es_r(e.headers,{queryParams:l,user:g}))}catch(e){console.error(e),u={}}const d=null==v?void 0:v(),p=null==g?void 0:g.tenant_id;try{m(!0);const t=await r.request(o,a,e.method,{headers:useEndpointHandler_es_y(useEndpointHandler_es_y(useEndpointHandler_es_y({},u),d?{Authorization:`Bearer ${d}`}:{}),p?{"X-Tenant-Id":p}:{})});h(void 0),f(t.data)}catch(e){h(e),console.error(e)}finally{m(!1)}};return useLocationChange_es_e((()=>{const e=window.location.search;u(Object.fromEntries(new URLSearchParams(e)))}),!0),(0,react.useEffect)((()=>{const e=()=>{"visible"===document.visibilityState&&j()};return j(),document.addEventListener("visibilitychange",e),()=>{document.removeEventListener("visibilitychange",e)}}),[c,JSON.stringify(O),JSON.stringify(l)]),{result:p,loading:null==p&&d,error:b,queryParams:l}};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/hooks/useEndpointHandlerV2.es.js
var useEndpointHandlerV2_es_i=Object.defineProperty,useEndpointHandlerV2_es_c=Object.defineProperties,useEndpointHandlerV2_es_p=Object.getOwnPropertyDescriptors,useEndpointHandlerV2_es_l=Object.getOwnPropertySymbols,useEndpointHandlerV2_es_m=Object.prototype.hasOwnProperty,useEndpointHandlerV2_es_d=Object.prototype.propertyIsEnumerable,useEndpointHandlerV2_es_u=(e,r,t)=>r in e?useEndpointHandlerV2_es_i(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,useEndpointHandlerV2_es_f=(e,r)=>{for(var t in r||(r={}))useEndpointHandlerV2_es_m.call(r,t)&&useEndpointHandlerV2_es_u(e,t,r[t]);if(useEndpointHandlerV2_es_l)for(var t of useEndpointHandlerV2_es_l(r))useEndpointHandlerV2_es_d.call(r,t)&&useEndpointHandlerV2_es_u(e,t,r[t]);return e},useEndpointHandlerV2_es_y=(e,r)=>useEndpointHandlerV2_es_c(e,useEndpointHandlerV2_es_p(r));const useEndpointHandlerV2_es_h=()=>{const[i,c]=(0,react.useState)(!1),{auth:{getAccessToken:p}={},globalData:{endpoints:l=[]}={}}=(0,StoreContext_es/* useStore */.o)(),{getValueByPath:m,storeData:d}=PageDataContext_es_p(),u=(e,r,t=!1)=>{if(!e)return;const a=(r||[]).reduce(((e,r)=>(e[r.name]=r,e)),{});return e.reduce(((e,r)=>{if(t&&!r.isRequired)return e;const o=a[r.paramName].valueType,n=a[r.paramName].staticValue,s=a[r.paramName].contextPath;return"CONTEXT_PATH"===o&&s&&(e[r.paramName]=m(s)),"STATIC"===o&&n&&(e[r.paramName]=n),e}),{})};return{fetchData:async({endpointId:e,mappingParams:t})=>{var a,i;const m=l.find((r=>r.id===e));if(!m||!((e,t)=>{const a=u(e.params,t,!0)||{},o=useEndpointHandlerV2_es_y(useEndpointHandlerV2_es_f({},d),{params:a});return[...computeStringHandleBarsExpression_es_l(e.url||""),...computeStringHandleBarsExpression_es_l(e.body||""),...computeStringHandleBarsExpression_es_l(e.headers||"")].every((e=>void 0!==lodash_get_default()(o,e)))})(m,t))return;const h=u(m.params,t)||{},b=useEndpointHandlerV2_es_y(useEndpointHandlerV2_es_f({},d),{params:h}),v=new index_es_u(""),O=computeStringHandleBarsExpression_es_r(m.url,b);let g,j={};if("GET"!==m.method&&m.body)try{g=JSON.parse(computeStringHandleBarsExpression_es_r(m.body,b))}catch(e){console.error(e),g={}}if(m.headers)try{j=JSON.parse(computeStringHandleBarsExpression_es_r(m.headers,b))}catch(e){console.error(e),j={}}const P=null==p?void 0:p(),T=null==(a=null==d?void 0:d.user)?void 0:a.tenant_id;try{c(!0);const e=await v.request(O,g,m.method,{headers:useEndpointHandlerV2_es_f(useEndpointHandlerV2_es_f(useEndpointHandlerV2_es_f({},j),P?{Authorization:`Bearer ${P}`}:{}),T?{"X-Tenant-Id":T}:{})});return null==(i=null==e?void 0:e.data)?void 0:i.data}catch(e){throw new Error(e)}finally{c(!1)}},loading:i}};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/hooks/useGetDynamicValue.es.js
const useGetDynamicValue_es_o=()=>{const{getValueByPath:o}=PageDataContext_es_p();return{getValue:(e,a)=>{const{valueType:r,contextPath:n,staticValue:s}=e||{};return"STATIC"===r&&s?s:"CONTEXT_PATH"===r&&n?lodash_get_default()(a,n)||o(n):void 0}}};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/hooks/useGetVisible.es.js
var useGetVisible_es = __webpack_require__(860426);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/hooks/useGetComponentProps.es.js
var useGetComponentProps_es_r=Object.defineProperty,useGetComponentProps_es_i=Object.defineProperties,useGetComponentProps_es_o=Object.getOwnPropertyDescriptors,useGetComponentProps_es_s=Object.getOwnPropertySymbols,useGetComponentProps_es_n=Object.prototype.hasOwnProperty,useGetComponentProps_es_a=Object.prototype.propertyIsEnumerable,useGetComponentProps_es_d=(e,t,i)=>t in e?useGetComponentProps_es_r(e,t,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[t]=i,useGetComponentProps_es_l=(e,t)=>{for(var r in t||(t={}))useGetComponentProps_es_n.call(t,r)&&useGetComponentProps_es_d(e,r,t[r]);if(useGetComponentProps_es_s)for(var r of useGetComponentProps_es_s(t))useGetComponentProps_es_a.call(t,r)&&useGetComponentProps_es_d(e,r,t[r]);return e};const useGetComponentProps_es_p=(r,s,n)=>{var a,d;const{customAttributes:p,style:c,elementId:m,id:u,startTime:b,endTime:y,ruleRepeat:v,date:f,duration:O,tag:j,children:h}=r||{},P=useGetComponentProps_es_l((g=useGetComponentProps_es_l({},p[j]||{}),useGetComponentProps_es_i(g,useGetComponentProps_es_o({commonStyle:c||{},id:m,"data-id":m,"data-uniq-id":u,dataUniqId:u}))),s);var g;const w=(0,clsx_m["default"])({"hidden-xs":null==(a=P.responsive)?void 0:a.hiddenXs,"hidden-md":null==(d=P.responsive)?void 0:d.hiddenMd}),{isVisible:T}=(0,useGetVisible_es/* useGetVisible */.m)({startTime:b,endTime:y,ruleRepeat:v,date:f,duration:O});return{key:u,props:P,className:w,ssrData:n,isVisible:T,nodes:h||[]}};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/types/common.es.js
var common_es = __webpack_require__(883786);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/buildSrcsetDPR.es.js
const buildSrcsetDPR_es_r=(r,e)=>{if(!r)return"";if(!r.startsWith("https://lh3.googleusercontent.com/"))return r;const{width:s,height:i}=e;return Array.from({length:root_es/* MAX_DPR */.yP},((t,o)=>o+1)).map((o=>`${image_es_u(r,{width:null!=s?s*o:void 0,height:null!=i?i*o:void 0,format:"webp",compressLevel:1})} ${o}x`)).join(", ")};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/getGoogleFontQuery.es.js
const getGoogleFontQuery_es_n=n=>n?(null==n?void 0:n.length)?`https://fonts.googleapis.com/css2?${n.filter((o=>o.source===common_es/* FontSource.GOOGLE */.gY.GOOGLE)).flatMap((l=>{var n,t;return null==(t=null==(n=l.name)?void 0:n.split(","))?void 0:t.map((l=>{var n;return`family=${encodeURIComponent(null==(n=null==l?void 0:l.trim())?void 0:n.replace(/['\-]/g,""))}:wght@${fonts_es/* fontWeightQueryParams */.wp}`}))})).join("&")}&display=swap`:"":null;

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/tiktokParser.es.js
const tiktokParser_es_o=o=>{var e;const t=null==o?void 0:o.trim();if(!t)return"";const d=new RegExp("tiktok\\.com\\/@[\\w.-]+\\/video\\/(?<videoId>\\d+)"),{videoId:i}=(null==(e=d.exec(t))?void 0:e.groups)||{};return i||""};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/getFontFamily.es.js
const getFontFamily_es_n=(e,t)=>{var n;const o=null==(n=document.getElementById("tempi-main-iframe"))?void 0:n.contentDocument;(null==t?void 0:t.length)||(t=[o||document]),t.forEach((t=>{if(t){const n=`https://fonts.googleapis.com/css2?display=swap&${e}`,o=t.querySelectorAll(`link[href='${n}']`);if(!(null==o?void 0:o.length)){const e=t.createElement("link");e.rel="preLoad stylesheet",e.as="style",e.type="text/css",e.href=n,t.head.appendChild(e)}}}))},getFontFamily_es_o=(o,l)=>{if(!fonts_es/* googleFontSetV2.has */.EB.has(o))return!1;const s=`family=${encodeURIComponent(o.replaceAll("'",""))}:wght@${fonts_es/* fontWeightQueryParams */.wp}`;return getFontFamily_es_n(s,l),!0};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/utils/theme.es.js
const theme_es_o=t=>t.length?`:root{${t.map((t=>`--tempi-global-${t.id}:${t.color}`)).join(";")};}`:"",theme_es_i=t=>t.length?`:root{${t.map((t=>{const e=t.id.toLowerCase(),o=t=>`"wght" ${t}, "wdth" 100, "SOFT" 0`;return[`--tempi-global-${e}fontfamily:'${t.fontFamily}'`,`--tempi-global-${e}fontsize:${t.fontSize}${t.fontSizeUnit||"px"}`,`--tempi-global-${e}fontweight:${t.fontWeight}`,`--tempi-global-${e}letterspacing:${t.letterSpacing?`${t.letterSpacing}px`:"unset"}`,`--tempi-global-${e}lineheight:${t.lineHeight?`${t.lineHeight}px`:"unset"}`,`--tempi-global-${e}fontvariation:${o(t.fontWeight)}`,`--tempi-global-${e}mobilefontsize:${t.mobileFontSize||t.fontSize}${t.mobileFontSizeUnit||t.fontSizeUnit||"px"}`,`--tempi-global-${e}mobilefontweight:${t.mobileFontWeight||t.fontWeight}`,`--tempi-global-${e}mobileletterspacing:${t.mobileLetterSpacing||t.letterSpacing?`${t.mobileLetterSpacing||t.letterSpacing}px`:"unset"}`,`--tempi-global-${e}mobilelineheight:${t.mobileLineHeight||t.lineHeight?`${t.mobileLineHeight||t.lineHeight}px`:"unset"}`,`--tempi-global-${e}mobilefontvariation:${o(t.mobileFontWeight||t.fontWeight)}`,`--tempi-global-${e}storyfontsize:${(t.fontSize/16*3.68).toFixed(2)}%`,`--tempi-global-${e}bold:${t.bold?"bold":"inherit"}`,`--tempi-global-${e}italic:${t.italic?"italic":"inherit"}`,`--tempi-global-${e}textdecoration:${(()=>{const e=[];return t.underline&&e.push("underline"),t.strikeThrough&&e.push("line-through"),e.length>0?e.join(" "):"inherit"})()}`,`--tempi-global-${e}texttransform:inherit`].join(";")})).join(";")};}`:"",theme_es_n=(t,e,o)=>{var i;const n=o||(null==(i=document.getElementById("tempi-main-iframe"))?void 0:i.contentDocument)||document,{content:l,attributes:a={}}=e;if(!t)throw new Error("Style ID is required");if(!l)throw new Error("Style content is required");if(!n)throw new Error("Missing context");let r=n.getElementById(t),m=!1;r||(r=n.createElement("style"),r.id=t,m=!0),r.innerHTML=l,Object.entries(a).forEach((([t,e])=>{r.setAttribute(t,e)})),m&&n.head.appendChild(r)},theme_es_l=t=>{if(null==t?void 0:t.colorPalette){const e=theme_es_o(t.colorPalette);theme_es_n("tempi-color-variable",{content:e}),theme_es_n("tempi-color-variable-for-floating-setting",{content:e},document)}if(null==t?void 0:t.fontStyles){const e=theme_es_i(t.fontStyles);theme_es_n("tempi-typography-variable",{content:e})}},theme_es_a=t=>null==t?void 0:t.startsWith("heading"),theme_es_r=t=>null==t?void 0:t.startsWith("paragraph"),theme_es_m=({theme:n,fonts:l})=>{const m=((null==n?void 0:n.fontStyles)||[]).reduce(((t,e)=>(theme_es_a(e.id)&&(t.fontFamilyHeading=e.fontFamily,t.fontFamilyHeadingSource=e.fontSource),theme_es_r(e.id)&&(t.fontFamilyParagraph=e.fontFamily,t.fontFamilyParagraphSource=e.fontSource),t)),{fontFamilyHeading:"",fontFamilyParagraph:"",fontFamilyHeadingSource:common_es/* FontSource.GOOGLE */.gY.GOOGLE,fontFamilyParagraphSource:common_es/* FontSource.GOOGLE */.gY.GOOGLE});return{fontQuery:getGoogleFontQuery_es_n([...l||[],{name:m.fontFamilyHeading||"Roboto",source:m.fontFamilyHeadingSource||common_es/* FontSource.GOOGLE */.gY.GOOGLE},{name:m.fontFamilyParagraph||"Roboto",source:m.fontFamilyParagraphSource||common_es/* FontSource.GOOGLE */.gY.GOOGLE}]),colorVariable:(null==n?void 0:n.colorPalette)?theme_es_o(n.colorPalette):null,typographyVariable:(null==n?void 0:n.fontStyles)?theme_es_i(n.fontStyles):null}};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-react-virtual-fce7dbd44e/0/cache/@emotion-react-npm-11.5.0-7e3b735976-4188b664cc.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(75537);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/renderPage/RenderPage.es.js
var RenderPage_es_y=Object.defineProperty,RenderPage_es_f=Object.defineProperties,RenderPage_es_v=Object.getOwnPropertyDescriptors,RenderPage_es_g=Object.getOwnPropertySymbols,RenderPage_es_j=Object.prototype.hasOwnProperty,RenderPage_es_N=Object.prototype.propertyIsEnumerable,RenderPage_es_b=(e,o,t)=>o in e?RenderPage_es_y(e,o,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[o]=t,RenderPage_es_h=(e,o)=>{for(var t in o||(o={}))RenderPage_es_j.call(o,t)&&RenderPage_es_b(e,t,o[t]);if(RenderPage_es_g)for(var t of RenderPage_es_g(o))RenderPage_es_N.call(o,t)&&RenderPage_es_b(e,t,o[t]);return e},RenderPage_es_O=(e,o)=>RenderPage_es_f(e,RenderPage_es_v(o));const P=({content:y={},configs:f,ssrData:v={},mappingDynamicSlots:g,rootId:j="ROOT",addGlobalStyle:N=!0,numOfHydratedBlocks:b,addLandingLinks:P=!0,componentDict:B})=>{const D=(0,react.useMemo)((()=>{var e,o,t;const r=null==(t=null==(o=null==(e=y[j])?void 0:e.tag)?void 0:o.toString())?void 0:t.toLowerCase();return r?B[r]:null}),[y,j,B]),S=void 0===b,w=(0,react.useMemo)((()=>y[j]?getComponentProps_es_p(y[j],f,v[j]):null),[y,j,f,v]),{initialNodes:L=[],idleNodes:x=[],delayNodes:C=[],overlayNodes:E=[]}=(0,react.useMemo)((()=>{var e;if(!(null==(e=null==w?void 0:w.nodes)?void 0:e.length))return{};const o=w.nodes;if(S)return{initialNodes:o,idleNodes:[],delayNodes:[],overlayNodes:[]};const t=new Set([root_es/* COMPONENT_TAG.BUBBLE */.H2.BUBBLE,root_es/* COMPONENT_TAG.POPUP */.H2.POPUP]),{regular:r,overlay:s}=o.reduce(((e,o)=>{var r,s;const n=null==(s=null==(r=y[o])?void 0:r.tag)?void 0:s.toString();return t.has(n)?e.overlay.push(o):e.regular.push(o),e}),{regular:[],overlay:[]}),n=Math.min(r.length,b||r.length),i=r.slice(n),l=Math.floor(i.length/2);return{overlayNodes:s,initialNodes:r.slice(0,n),idleNodes:i.slice(0,l),delayNodes:i.slice(l)}}),[w.nodes,S,b,y]);return D&&w&&w.isVisible?(0,jsx_runtime.jsxs)(StoreContext_es/* StoreProvider */.g,RenderPage_es_O(RenderPage_es_h({ssrData:v,content:y,mappingDynamicSlots:g,componentDict:B},f),{children:[N&&(0,jsx_runtime.jsxs)(jsx_runtime.Fragment,{children:[(0,jsx_runtime.jsx)(emotion_react_browser_esm.Global,{styles:reset_es/* reset */.m}),(0,jsx_runtime.jsx)(emotion_react_browser_esm.Global,{styles:rc_cascader_es/* rcCascaderCss */.J}),(0,jsx_runtime.jsx)(emotion_react_browser_esm.Global,{styles:animation_es/* animationCss */.W})]}),P&&(0,jsx_runtime.jsx)(index_es/* LandingLinks */.d1,{}),(0,jsx_runtime.jsxs)(D,RenderPage_es_O(RenderPage_es_h({className:w.className,ssrData:v[j]},w.props),{children:[L.map((e=>(0,jsx_runtime.jsx)(NodeElements_es_m,{isBot:S,id:e},e))),E.map((e=>(0,jsx_runtime.jsx)(NodeElements_es_m,{isBot:S,id:e},e))),x.map((e=>(0,jsx_runtime.jsx)(ReactLazyComponent_es_b,{on:["visible",["idle",500]],children:(0,jsx_runtime.jsx)(NodeElements_es_m,{isBot:S,id:e})},e))),C.map((e=>(0,jsx_runtime.jsx)(ReactLazyComponent_es_b,{on:["visible",["idle",1e3],["delay",1e3]],children:(0,jsx_runtime.jsx)(NodeElements_es_m,{isBot:S,id:e})},e)))]}),w.key)]})):null};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-34d9805ad2/0/cache/@tempi-core-renderer-npm-1.0.81-1714e78765-0458e2aa11.zip/node_modules/@tempi/core-renderer/dist/index.es.js



/***/ }),

/***/ 241464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ D; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(877084);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(474402);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75537);
/* harmony import */ var _contexts_StoreContext_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(116108);
/* harmony import */ var _constants_rc_cascader_es_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(49563);
/* harmony import */ var _constants_animation_es_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12913);
/* harmony import */ var _constants_root_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86258);
/* harmony import */ var _components_TimeVisibilityWrapper_TimeVisibilityWrapper_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(268751);
/* harmony import */ var _constants_reset_es_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(577995);
/* harmony import */ var _utils_date_time_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(385190);
var j=Object.defineProperty,g=Object.defineProperties,O=Object.getOwnPropertyDescriptors,h=Object.getOwnPropertySymbols,T=Object.prototype.hasOwnProperty,x=Object.prototype.propertyIsEnumerable,P=(e,t,i)=>t in e?j(e,t,{enumerable:!0,configurable:!0,writable:!0,value:i}):e[t]=i,S=(e,t)=>{for(var i in t||(t={}))T.call(t,i)&&P(e,i,t[i]);if(h)for(var i of h(t))x.call(t,i)&&P(e,i,t[i]);return e},V=(e,t)=>g(e,O(t));const D=j=>{const{content:g,configs:O,ssrData:h={},mappingDynamicSlots:T,rootId:x="ROOT",componentDict:P,addGlobalStyle:D=!0,numOfHydratedBlocks:w,addLandingLinks:N=!0,prefixCss:I,isAutoVisible:k=!0}=j,[B,E]=(0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(!1);(0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)((()=>{E(!0)}),[]);const R=(0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)((()=>Object.entries(g).reduce(((e,[t,i])=>{var n,r;const{startTime:o,endTime:l,ruleRepeat:a,date:d,duration:m}=i,u=S(V(S({},i.customAttributes[i.tag]||{}),{commonStyle:i.style||{},id:i.elementId,"data-id":i.elementId,"data-uniq-id":i.id,dataUniqId:i.id,timeVisibility:{startTime:o,endTime:l,ruleRepeat:a,date:d,duration:m}}),O),c=(0,clsx__WEBPACK_IMPORTED_MODULE_2__["default"])({"hidden-xs":null==(n=null==u?void 0:u.responsive)?void 0:n.hiddenXs,"hidden-md":null==(r=null==u?void 0:u.responsive)?void 0:r.hiddenMd}),p=(0,_utils_date_time_es_js__WEBPACK_IMPORTED_MODULE_3__/* .validateIsVisibleComponent */ .U0)({startTime:o,endTime:l,ruleRepeat:a,date:d,duration:m});return e[t]=V(S({},i),{props:u,clsName:c,isVisible:p}),e}),{})),[JSON.stringify(g)]),C=t=>{var i,r,o,l,s,a,d,m,u,c,y,b,j;const g=P[null==(i=null==R?void 0:R[t])?void 0:i.tag];let O;if(!P[null==(r=null==R?void 0:R[t])?void 0:r.tag])return console.warn("Cannot found component: "+(null==(l=null==(o=null==R?void 0:R[t])?void 0:o.tag)?void 0:l.toString())),null;if(!(null==(s=null==R?void 0:R[t])?void 0:s.isVisible)&&!k)return null;if(null==(d=null==(a=null==R?void 0:R[t])?void 0:a.children)?void 0:d.length){let e=0;O=react__WEBPACK_IMPORTED_MODULE_1__.createElement(g,S({key:t,ssrData:h[t],className:null==(m=R[t])?void 0:m.clsName},null==(u=R[t])?void 0:u.props),R[t].children.map((i=>{var n;if(t===_constants_root_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ROOT */ .Dx){if(void 0===w)return C(i);const t=[_constants_root_es_js__WEBPACK_IMPORTED_MODULE_4__/* .COMPONENT_TAG.BUBBLE */ .H2.BUBBLE,_constants_root_es_js__WEBPACK_IMPORTED_MODULE_4__/* .COMPONENT_TAG.POPUP */ .H2.POPUP].includes(null==(n=R[i])?void 0:n.tag);return e<w||t?(e++,C(i)):B?C(i):null}return C(i)})))}else O=react__WEBPACK_IMPORTED_MODULE_1__.createElement(g,S({key:t,ssrData:h[t],className:null==(c=R[t])?void 0:c.clsName},null==(y=R[t])?void 0:y.props));return k?(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TimeVisibilityWrapper_TimeVisibilityWrapper_es_js__WEBPACK_IMPORTED_MODULE_5__/* .TimeVisibilityWrapper */ .y,{timeVisibility:null==(j=null==(b=null==R?void 0:R[t])?void 0:b.props)?void 0:j.timeVisibility,children:O}):O};return(null==g?void 0:g[x])?(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_StoreContext_es_js__WEBPACK_IMPORTED_MODULE_6__/* .StoreProvider */ .g,V(S({mappingDynamicSlots:T},O),{children:(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment,{children:[D&&(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment,{children:[(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_emotion_react__WEBPACK_IMPORTED_MODULE_7__.Global,{styles:(L=_constants_reset_es_js__WEBPACK_IMPORTED_MODULE_8__/* .reset */ .m,U=I,U?`\n    :where(${U}) {\n      ${L}\n    }\n  `:L)}),(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_emotion_react__WEBPACK_IMPORTED_MODULE_7__.Global,{styles:_constants_rc_cascader_es_js__WEBPACK_IMPORTED_MODULE_9__/* .rcCascaderCss */ .J}),(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_emotion_react__WEBPACK_IMPORTED_MODULE_7__.Global,{styles:_constants_animation_es_js__WEBPACK_IMPORTED_MODULE_10__/* .animationCss */ .W})]}),N&&(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_constants_index_es_js__WEBPACK_IMPORTED_MODULE_11__/* .LandingLinks */ .d1,{}),C(x)]})})):null;var L,U};


/***/ }),

/***/ 883786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ew": function() { return /* binding */ c; },
/* harmony export */   "PO": function() { return /* binding */ E; },
/* harmony export */   "Ql": function() { return /* binding */ p; },
/* harmony export */   "gY": function() { return /* binding */ e; },
/* harmony export */   "gj": function() { return /* binding */ o; },
/* harmony export */   "h5": function() { return /* binding */ s; },
/* harmony export */   "tE": function() { return /* binding */ i; }
/* harmony export */ });
var o=(o=>(o.DAILY="DAILY",o.DAY_IN_WEEK="DAY_IN_WEEK",o.CUSTOM="CUSTOM",o.NO_REPEAT="NO_REPEAT",o))(o||{}),p=(o=>(o.DAY="DAILY",o.WEEK="WEEKLY",o.MONTH="MONTH",o.YEAR="YEAR",o.DURATION="DURATION",o))(p||{}),c=(o=>(o.FREQ="FREQ",o.INTERVAL="INTERVAL",o.BYDAY="BYDAY",o.UNTIL="UNTIL",o))(c||{}),e=(o=>(o.GOOGLE="google",o.TEMPI="tempi",o))(e||{}),i=(o=>(o.Pdf="pdf",o.Doc="doc",o.Docx="docx",o.Xlsx="xlsx",o.Zip="zip",o))(i||{});const s={pdf:"application/pdf",doc:"application/msword",docx:"application/vnd.openxmlformats-officedocument.wordprocessingml.document",xlsx:"application/vnd.ms-excel",xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",zip:"application/zip"};var E=(o=>(o.success="success",o.failed="failed",o))(E||{});


/***/ }),

/***/ 385190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "So": function() { return /* binding */ u; },
/* harmony export */   "U0": function() { return /* binding */ l; },
/* harmony export */   "gV": function() { return /* binding */ r; },
/* harmony export */   "mE": function() { return /* binding */ o; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(287268);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _types_common_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(883786);
const i=t=>{if(t)return new Date(t).toISOString()},r=(t,e)=>{var n;const i=new RegExp(`(${t}:)[^;]+(?=;)`,"g"),r=e.match(i);return(null==r?void 0:r.length)>0?null==(n=r[0])?void 0:n.replaceAll(`${t}:`,""):void 0},l=({startTime:l,endTime:o,ruleRepeat:u,date:a,duration:d})=>{var s,m;const T=(new Date).toISOString(),c=i(l),f=i(o);if(c&&T<c)return!1;if(f&&T>=f)return!1;if(u){const l=r(_types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .RuleRepeatEnum.INTERVAL */ .Ew.INTERVAL,u)?parseInt(r(_types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .RuleRepeatEnum.INTERVAL */ .Ew.INTERVAL,u)):1,o=r(_types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .RuleRepeatEnum.FREQ */ .Ew.FREQ,u),c=r(_types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .RuleRepeatEnum.UNTIL */ .Ew.UNTIL,u),f=r(_types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .RuleRepeatEnum.BYDAY */ .Ew.BYDAY,u);if(a&&T<dayjs__WEBPACK_IMPORTED_MODULE_0___default()(a).hour(0).minute(0).second(0).toISOString())return!1;if(c&&T>i(null==(s=dayjs__WEBPACK_IMPORTED_MODULE_0___default()(c).endOf("day"))?void 0:s.toISOString()))return!1;let S=!0;const v=e=>{if(1===l&&("day"===e||"week"===e))return!0;const n=a?dayjs__WEBPACK_IMPORTED_MODULE_0___default()(T).diff(a,e):-1;return n>=0&&n%l==0};switch(o){case _types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .UnitRepeatEnum.DAY */ .Ql.DAY:S=v("day");break;case _types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .UnitRepeatEnum.WEEK */ .Ql.WEEK:S=v("week")&&(null==(m=null==f?void 0:f.split(","))?void 0:m.includes(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(T).day().toString()));break;case _types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .UnitRepeatEnum.MONTH */ .Ql.MONTH:S=v("month")&&dayjs__WEBPACK_IMPORTED_MODULE_0___default()(T).get("date")===dayjs__WEBPACK_IMPORTED_MODULE_0___default()(a).get("date");break;case _types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .UnitRepeatEnum.YEAR */ .Ql.YEAR:S=v("year")&&dayjs__WEBPACK_IMPORTED_MODULE_0___default()(T).get("date")===dayjs__WEBPACK_IMPORTED_MODULE_0___default()(a).get("date")&&dayjs__WEBPACK_IMPORTED_MODULE_0___default()(T).get("month")===dayjs__WEBPACK_IMPORTED_MODULE_0___default()(a).get("month")}if(!S)return!1;if(d&&(d[0]&&60*dayjs__WEBPACK_IMPORTED_MODULE_0___default()(T).hour()+dayjs__WEBPACK_IMPORTED_MODULE_0___default()(T).minute()<d[0]||d[1]&&60*dayjs__WEBPACK_IMPORTED_MODULE_0___default()(T).hour()+dayjs__WEBPACK_IMPORTED_MODULE_0___default()(T).minute()>=d[1]))return!1}return!0},o=(t,e)=>{const n=t.getTime(),i=e.getTime(),r=Math.max(0,Math.round((i-n)/1e3));return{durationInSecond:r,days:Math.floor(r/86400),hours:Math.floor(r/3600%24),minutes:Math.floor(r/60%60),seconds:Math.floor(r%60)}},u=({startTime:l,endTime:o,ruleRepeat:u,date:a,duration:d})=>{if(!l&&!o&&!u)return{visibleStartTime:null,visibleEndTime:null};const s=(new Date).toISOString();let m=null,T=null;const c=u?r(_types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .RuleRepeatEnum.FREQ */ .Ew.FREQ,u):_types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .UnitRepeatEnum.DURATION */ .Ql.DURATION;if(c===_types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .UnitRepeatEnum.DURATION */ .Ql.DURATION){const t=i(l),e=i(o);return t&&s<t&&(m=l),e&&s<e&&(T=o),{visibleStartTime:m,visibleEndTime:T}}if((r(_types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .RuleRepeatEnum.INTERVAL */ .Ew.INTERVAL,u)?parseInt(r(_types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .RuleRepeatEnum.INTERVAL */ .Ew.INTERVAL,u)):1)>1)return{visibleStartTime:null,visibleEndTime:null};const f=r(_types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .RuleRepeatEnum.UNTIL */ .Ew.UNTIL,u),S=(e,n)=>dayjs__WEBPACK_IMPORTED_MODULE_0___default()(e).startOf("day").add(n,"minutes").toISOString(),v=a?S(a,(null==d?void 0:d[0])||0):null,g=f?S(f,(null==d?void 0:d[1])||1440):null;if(c===_types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .UnitRepeatEnum.DAY */ .Ql.DAY){const e=S(s,(null==d?void 0:d[0])||0),n=S(s,(null==d?void 0:d[1])||1440);return m=v?s<v?v:s<e?e:dayjs__WEBPACK_IMPORTED_MODULE_0___default()(e).add(1,"day").toISOString():null,m>=g&&(m=null),T=!g||s>g?null:s<n?n:dayjs__WEBPACK_IMPORTED_MODULE_0___default()(n).add(1,"day").toISOString(),(T<v||T>g)&&(T=null),{visibleStartTime:m,visibleEndTime:T}}return{visibleStartTime:null,visibleEndTime:null}};


/***/ }),

/***/ 88908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O5": function() { return /* binding */ i; },
/* harmony export */   "Oq": function() { return /* binding */ d; },
/* harmony export */   "aX": function() { return /* binding */ m; },
/* harmony export */   "d0": function() { return /* binding */ p; },
/* harmony export */   "vv": function() { return /* binding */ s; }
/* harmony export */ });
/* harmony import */ var deepmerge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(745025);
/* harmony import */ var deepmerge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(deepmerge__WEBPACK_IMPORTED_MODULE_0__);
var t=Object.defineProperty,o=Object.getOwnPropertySymbols,n=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable,r=(e,o,n)=>o in e?t(e,o,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[o]=n,l=(e,t)=>{for(var l in t||(t={}))n.call(t,l)&&r(e,l,t[l]);if(o)for(var l of o(t))a.call(t,l)&&r(e,l,t[l]);return e},c=(e,t)=>{var r={};for(var l in e)n.call(e,l)&&t.indexOf(l)<0&&(r[l]=e[l]);if(null!=e&&o)for(var l of o(e))t.indexOf(l)<0&&a.call(e,l)&&(r[l]=e[l]);return r};const i=({isTrackContent:e,contentName:t,index:o,regionName:n,target:a,payload:r})=>l(l(l(l(l(l({},n&&{"data-content-region-name":n}),e&&{"data-track-content":!0}),t&&{"data-content-name":t}),(o||0===o)&&{"data-content-index":o}),a&&{"data-content-target":a}),r&&{"data-content-payload":r}),s=(t,o="desktop")=>{const n=t,{syncDeviceStyle:a,desktop:r,mobile:l,commonStyle:i}=n,s=c(n,["syncDeviceStyle","desktop","mobile","commonStyle"]),p=i||{},{desktop:d,mobile:m}=p,u=c(p,["desktop","mobile"]);if(!(r||l||d||m))return t;if("mobile"===o){const t=void 0===a,o=deepmerge__WEBPACK_IMPORTED_MODULE_0___default().all([u,t&&d?d:{},m||{}]);return deepmerge__WEBPACK_IMPORTED_MODULE_0___default().all([{commonStyle:o},s,t&&r?r:{},l||{}])}const y=deepmerge__WEBPACK_IMPORTED_MODULE_0___default()(u,d||{});return deepmerge__WEBPACK_IMPORTED_MODULE_0___default().all([{commonStyle:y},s,r||{}])},p=e=>{var t;const o=null==e?void 0:e.eventType;switch(o){case"openPageOfWebsite":case"link":case"internal":return null==(t=e[o])?void 0:t.href;case"email":case"phone":case"inPage":return e[o];case"openPopup":case"closePopup":return e.togglePopup;default:return}},d=e=>Object.values(e).reduce(((e,t)=>(e[(t.displayName||t.name).toLowerCase()]=t,e)),{}),m=(t,o,n,a)=>t&&Array.isArray(t)?o||n?t.map(((t,r)=>{let c=l({},t);if("mobile"===a){const t=null==o?void 0:o[r],a=null==n?void 0:n[r];t&&(c=deepmerge__WEBPACK_IMPORTED_MODULE_0___default()(c,t)),a&&(c=deepmerge__WEBPACK_IMPORTED_MODULE_0___default()(c,a))}else{const t=null==o?void 0:o[r];t&&(c=deepmerge__WEBPACK_IMPORTED_MODULE_0___default()(c,t))}return c})):t:[];


/***/ }),

/***/ 127689:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var constants = __webpack_require__(157397);
var utils = __webpack_require__(792028);
var image = __webpack_require__(478130);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const imageDefault = image.generatePlaceholderImage({ width: 300, height: 400 });
const ArticleItem = (props) => {
  var _a, _b;
  const { device, globalData } = coreRenderer.useStore();
  const isPreviewMode = globalData == null ? void 0 : globalData.isPreviewMode;
  const {
    title,
    category,
    src: imageUrl,
    googleImageParams,
    itemStyle,
    description,
    displayConfig,
    event,
    isEditingMode
  } = props;
  const {
    showCategory = true,
    showTitle = true,
    showDescription = true
  } = displayConfig || {};
  const isMobile = device === "mobile";
  const linkArticle = (_a = event == null ? void 0 : event.link) == null ? void 0 : _a.href;
  const {
    borderRadius = 0,
    descriptionColor,
    titleColor,
    categoryColor
  } = __spreadValues(__spreadValues({}, constants.ARTICLE_ITEM_STYLE), utils.cleanObj(itemStyle));
  const totalContentRow = (_b = [showCategory, showTitle, showDescription].filter(
    Boolean
  )) == null ? void 0 : _b.length;
  const handleClickUrl = (url, target = "_blank") => {
    if (!url || isEditingMode || isPreviewMode)
      return;
    window.open(url, target);
  };
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
    rel: "noreferrer",
    totalShowRows: totalContentRow + 1,
    isMobile,
    isEditingMode,
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
        commonStyle: {
          width: isMobile ? 150 : 300,
          objectFit: "fill",
          marginLeft: "auto",
          marginRight: "auto",
          height: isMobile ? 200 : 400,
          borderRadius
        },
        src: imageUrl || imageDefault,
        googleImageParams,
        event
      }),
      /* @__PURE__ */ jsxRuntime.jsxs(ContentWrapper, {
        gridRow: totalContentRow,
        children: [
          showCategory && category && /* @__PURE__ */ jsxRuntime.jsx(CategoryWrapper, {
            children: /* @__PURE__ */ jsxRuntime.jsx(Category, {
              color: categoryColor,
              children: category
            })
          }),
          showTitle && /* @__PURE__ */ jsxRuntime.jsx(Title, {
            onClick: () => handleClickUrl(linkArticle),
            style: { color: titleColor },
            children: title
          }),
          showDescription && /* @__PURE__ */ jsxRuntime.jsx(Description, {
            style: { color: descriptionColor },
            children: description
          })
        ]
      })
    ]
  });
};
const Wrapper = styled__default["default"].div(
  ({ totalShowRows, rowGap, commonStyle, isEditingMode }) => `
    display: grid;
    width: fit-content;
    grid-template-rows: subgrid;
    grid-row: span ${totalShowRows};
    grid-row-gap: ${rowGap}px;
    ${isEditingMode ? `
      a {
        pointer-events: none;
      }
    ` : ""}
    ${coreRenderer.getStyle(commonStyle)}
    `
);
const ContentWrapper = styled__default["default"].div(
  ({ gridRow }) => `
    margin-top: 4px;
    width: 100%;
    display: grid;
    grid-template-rows: subgrid;
    grid-row: span ${gridRow};
`
);
const Title = styled__default["default"].p`
  font-weight: 600;
  line-height: 22px;
  font-size: 14px;
  cursor: pointer;
  ${utils.getClampedTextStyle(3)}
`;
const Description = styled__default["default"].p`
  font-weight: 400;
  line-height: 20px;
  font-size: 12px;
  ${utils.getClampedTextStyle(3)}
`;
const Category = styled__default["default"].div(
  ({ color, commonStyle }) => `
   color: ${color};
  background-color: ${coreRenderer.generate(color)["50"]};
  border: ${coreRenderer.generate(color)["200"]} 1px solid;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 400;
  line-height: 20px;
  font-size: 12px;
  width: fit-content;
  ${coreRenderer.getStyle(commonStyle)}
`
);
const CategoryWrapper = styled__default["default"].div`
  display: flex;
  gap: 8px;
  flex-direction: column;
`;

exports.ArticleItem = ArticleItem;


/***/ }),

/***/ 157397:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var style = __webpack_require__(667925);
var image = __webpack_require__(478130);
var grid = __webpack_require__(860046);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const BASE_ARTICLE_LIST_DATA = {
  title: "C\u1EA9m nang mua s\u1EAFm",
  titleColor: "#000000",
  viewMoreStyle: {
    color: "#000000"
  },
  items: [
    {
      src: "https://lh3.googleusercontent.com/HeYzLy2ooplcdEqDCWeT7jm-UO3woKaqOMxxa2rBmvt-jxapAf9Scx5kmnagEoXYAj84y6PBm2bxXEwxyHGmvpXOZaAjFjdm",
      googleImageParams: {
        width: 300
      },
      event: {
        eventType: "link",
        link: {
          href: "https://cooponline.vn/"
        }
      },
      title: "C\u1EA9m nang mua s\u1EAFm Co.op Online",
      category: "Co.opmart - TP.HCM",
      description: "28/05/2025 - 11/06/2025"
    },
    {
      src: "https://lh3.googleusercontent.com/BU0Bc9XOkQC1RM65KwO6cTX0EEihRzDq1JhrWuawgX3o8xNHdOu7hZpjHZ2l0tQIW_H8CVhjvQpF_0WZVBVQ1xonpJZmb3zN",
      googleImageParams: {
        width: 300
      },
      event: {
        eventType: "link",
        link: {
          href: "https://cooponline.vn/"
        }
      },
      title: "C\u1EA9m nang mua s\u1EAFm Co.op Online",
      category: "Co.opmart - TP.HCM",
      description: "28/05/2025 - 11/06/2025"
    },
    {
      src: image.generatePlaceholderImage({ width: 300, height: 400 }),
      googleImageParams: {
        width: 300
      },
      event: {
        eventType: "link",
        link: {
          href: "https://cooponline.vn/"
        }
      },
      title: "C\u1EA9m nang mua s\u1EAFm Co.op Online",
      category: "Co.opmart - TP.HCM",
      description: "28/05/2025 - 11/06/2025"
    }
  ],
  displayConfig: {
    showCategory: true,
    showTitle: true,
    showDescription: true
  },
  maxWidth: grid.DEFAULT_MAX_WIDTH
};
const ARTICLE_ITEM_STYLE = {
  titleColor: "#000000",
  categoryColor: "#1677FF",
  descriptionColor: "#000000A6",
  borderRadius: 8
};
const DEFAULT_ARTICLE_LIST = __spreadProps(__spreadValues({}, BASE_ARTICLE_LIST_DATA), {
  itemStyle: ARTICLE_ITEM_STYLE,
  desktop: {
    commonStyle: __spreadValues({}, style.DESKTOP_COMMON_STYLE)
  },
  mobile: {
    commonStyle: __spreadProps(__spreadValues({}, style.MOBILE_COMMON_STYLE), {
      padding: {
        left: 0,
        right: 0
      }
    })
  }
});

exports.ARTICLE_ITEM_STYLE = ARTICLE_ITEM_STYLE;
exports.DEFAULT_ARTICLE_LIST = DEFAULT_ARTICLE_LIST;


/***/ }),

/***/ 104164:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var icons = __webpack_require__(143599);
var ArticleItem = __webpack_require__(127689);
var constants = __webpack_require__(157397);
var utils = __webpack_require__(792028);
var Container = __webpack_require__(341018);
var Slider = __webpack_require__(183594);
var grid = __webpack_require__(860046);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const OmniArticleList = (props) => {
  const { device, globalData } = coreRenderer.useStore();
  const isPreviewMode = globalData == null ? void 0 : globalData.isPreviewMode;
  const isMobile = device === "mobile";
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);
  const [showNavBtns, setShowNavBtns] = React.useState(false);
  const _a = props, {
    isEditingMode,
    title,
    viewMoreUrl,
    items = [],
    itemStyle,
    viewMoreStyle,
    titleColor = constants.DEFAULT_ARTICLE_LIST.titleColor,
    displayConfig
  } = _a, restProps = __objRest(_a, [
    "isEditingMode",
    "title",
    "viewMoreUrl",
    "items",
    "itemStyle",
    "viewMoreStyle",
    "titleColor",
    "displayConfig"
  ]);
  const _b = coreRenderer.getPropsByDevice(restProps, device), {
    commonStyle,
    maxWidth = grid.DEFAULT_MAX_WIDTH
  } = _b, rest = __objRest(_b, [
    "commonStyle",
    "maxWidth"
  ]);
  const _c = commonStyle || {}, { padding, margin } = _c, restStyle = __objRest(_c, ["padding", "margin"]);
  const { displayItems } = coreRenderer.useTimeVisibility(items, isEditingMode);
  const handleClickUrl = (url, target = "_blank") => {
    if (!url || isEditingMode || isPreviewMode)
      return;
    window.open(url, target);
  };
  if (!(displayItems == null ? void 0 : displayItems.length) && !isEditingMode)
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: { maxWidth, padding, margin },
    maxWidth
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      commonStyle: __spreadValues({ backgroundSize: "cover" }, restStyle),
      style: { padding: "8px 16px", borderRadius: 8 },
      children: [
        /* @__PURE__ */ jsxRuntime.jsxs(TitleWrapper, {
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(TitleStyled, {
              style: { color: titleColor },
              children: title
            }),
            viewMoreUrl && /* @__PURE__ */ jsxRuntime.jsxs(ViewAll, {
              style: {
                color: (viewMoreStyle == null ? void 0 : viewMoreStyle.color) || constants.DEFAULT_ARTICLE_LIST.viewMoreStyle.color
              },
              onClick: () => handleClickUrl(viewMoreUrl),
              children: [
                "Xem t\u1EA5t c\u1EA3 ",
                /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
                  style: { fontSize: 16 },
                  name: "RightOutlined"
                })
              ]
            })
          ]
        }),
        isMobile ? /* @__PURE__ */ jsxRuntime.jsx(ArticleListWrapper, {
          isEditingMode,
          children: displayItems.map((item, index) => /* @__PURE__ */ React.createElement(ArticleItem.ArticleItem, __spreadProps(__spreadValues({}, item), {
            key: index,
            itemStyle,
            isEditingMode,
            displayConfig
          })))
        }) : /* @__PURE__ */ jsxRuntime.jsxs("div", {
          onMouseEnter: () => setShowNavBtns(true),
          onMouseLeave: () => setShowNavBtns(false),
          style: { position: "relative" },
          children: [
            (displayItems == null ? void 0 : displayItems.length) > 1 && /* @__PURE__ */ jsxRuntime.jsx(NavigationButtonStyled, {
              className: "left-nav",
              style: { opacity: showNavBtns ? 1 : 0 },
              ref: navigationPrevRef
            }),
            /* @__PURE__ */ jsxRuntime.jsx(SliderWrapper, {
              navigation: {
                prevEl: navigationPrevRef.current,
                nextEl: navigationNextRef.current
              },
              slidesPerView: "auto",
              navigationStyle: 1,
              paginationColor: "#ffffff",
              allowTouchMove: !isEditingMode,
              onBeforeInit: (swiper) => {
                swiper.params.navigation.prevEl = navigationPrevRef.current;
                swiper.params.navigation.nextEl = navigationNextRef.current;
              },
              spaceBetween: 16,
              children: displayItems.map((item, index) => /* @__PURE__ */ React.createElement(ArticleItem.ArticleItem, __spreadProps(__spreadValues({}, item), {
                key: index,
                itemStyle,
                isEditingMode,
                displayConfig
              })))
            }),
            (displayItems == null ? void 0 : displayItems.length) > 1 && /* @__PURE__ */ jsxRuntime.jsx(NavigationButtonStyled, {
              className: "right-nav",
              style: { opacity: showNavBtns ? 1 : 0 },
              ref: navigationNextRef
            })
          ]
        })
      ]
    })
  }));
};
OmniArticleList.displayName = "Omni_ArticleList";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)}
`
);
const TitleStyled = styled__default["default"].div`
  ${utils.getClampedTextStyle(1)}
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  margin: 0 16px 0 0;
`;
const ArticleListWrapper = styled__default["default"].div(
  ({ isEditingMode }) => `
  display: grid;
  grid-auto-flow: column;
  width: fit-content;
  width: 100%;
  row-gap: 4px;
  column-gap: 12px;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    height: 8px;
    ${!isEditingMode ? "display: none;" : ""}
  }

  &::-webkit-scrollbar-track {
    border-radius: 12px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
  }
`
);
const NavigationButtonStyled = styled__default["default"].div`
  top: 200px;
  position: absolute;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 100px;
  background-color: white;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2);
  &:after {
    content: ' ';
    height: 30px;
    width: 30px;
    display: inline-block;
    background: #333;
  }

  &.left-nav {
    transform: translateY(-50%) translateX(-50%);
    left: 0px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
      mask-size: contain;
    }
  }

  &.right-nav {
    transform: translateY(-50%) translateX(50%);
    right: 0px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
      mask-size: contain;
    }
  }

  &.swiper-button-disabled {
    display: none;
  }
`;
const TitleWrapper = styled__default["default"].div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;
const ViewAll = styled__default["default"].div`
  white-space: nowrap;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
`;
const SliderWrapper = styled__default["default"](Slider.Slider)`
  .swiper-wrapper {
    display: grid;
    grid-auto-flow: column;
    width: fit-content;
    row-gap: 4px;
  }

  .swiper-slide {
    display: grid;
    grid-template-rows: subgrid;
    grid-row: span 4;
  }
`;

exports.OmniArticleList = OmniArticleList;


/***/ }),

/***/ 792028:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const cleanObj = (obj) => Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== void 0));
const getClampedTextStyle = (lines) => `
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: ${lines};
  line-clamp: ${lines};
  -webkit-box-orient: vertical;
  line-height: 1.5;
`;

exports.cleanObj = cleanObj;
exports.getClampedTextStyle = getClampedTextStyle;


/***/ }),

/***/ 14869:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var icons = __webpack_require__(143599);
var coreRenderer = __webpack_require__(85097);
var Container = __webpack_require__(341018);
var renderDynamicSlot = __webpack_require__(958220);
var EmptyProduct = __webpack_require__(907438);
var grid = __webpack_require__(860046);
var getStyles = __webpack_require__(934512);
var BlockHeader = __webpack_require__(951297);
var renderLink = __webpack_require__(284727);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CarouselSkuList = (_a) => {
  var _b = _a, {
    isEditingMode = false,
    ssrData
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "ssrData"
  ]);
  const { device, mappingDynamicSlots } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    collectionSlug,
    viewMoreUrl,
    title,
    commonStyle,
    titleStyle,
    viewMoreStyle,
    maxWidth
  } = _a2, rest = __objRest(_a2, [
    "collectionSlug",
    "viewMoreUrl",
    "title",
    "commonStyle",
    "titleStyle",
    "viewMoreStyle",
    "maxWidth"
  ]);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  const renderViewAllLink = () => {
    if (!viewMoreUrl)
      return null;
    const content = /* @__PURE__ */ jsxRuntime.jsxs(ViewMore, {
      commonStyle: viewMoreStyle,
      children: [
        "Xem t\u1EA5t c\u1EA3 ",
        /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
          name: "RightOutlined"
        })
      ]
    });
    return renderLink.renderLink(viewMoreUrl, content, isEditingMode);
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: { maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH, padding, margin }
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, __spreadProps(__spreadValues({
      commonStyle: __spreadValues({ backgroundSize: "cover" }, restStyle)
    }, !isEditingMode && coreRenderer.getTrackingData({
      isTrackContent: true,
      regionName: `${title}HorizontalBlock`
    })), {
      children: [
        !!title && /* @__PURE__ */ jsxRuntime.jsxs(Header, {
          device,
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(Label, {
              commonStyle: titleStyle,
              children: title
            }),
            renderViewAllLink()
          ]
        }),
        /* @__PURE__ */ jsxRuntime.jsx(ProductListWrapper, {
          children: collectionSlug || isEditingMode ? renderDynamicSlot.renderDynamicSlot(
            `product_carousel_${device}`,
            mappingDynamicSlots,
            ssrData,
            {
              collectionSlug
            }
          ) : /* @__PURE__ */ jsxRuntime.jsx(EmptyProduct.EmptyProduct, {})
        })
      ]
    }))
  }));
};
CarouselSkuList.displayName = "Omni_ProductSlider";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${getStyles.getStyle(commonStyle)}
`
);
const Header = styled__default["default"](BlockHeader.BlockHeader)(
  `
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  color: #ffffff;
`
);
const Label = styled__default["default"].div(
  ({ commonStyle }) => `
    flex: 1;
    margin-right: 8px;
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;

    ${getStyles.getStyle(commonStyle)}
  `
);
const ViewMore = styled__default["default"].span(
  ({ commonStyle }) => `
    display: flex;
    align-items: center;
    ${getStyles.getStyle(commonStyle)}
  `
);
const ProductListWrapper = styled__default["default"].div`
  padding: 1rem;
`;

exports.CarouselSkuList = CarouselSkuList;


/***/ }),

/***/ 366440:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var MenuItems = __webpack_require__(309991);
var Container = __webpack_require__(341018);
var grid = __webpack_require__(860046);
var BlockHeader = __webpack_require__(951297);
var getStyles = __webpack_require__(934512);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAX_ITEMS_PER_VIEW = 6;
const CategoryMenu2Lines = (_a) => {
  var _b = _a, {
    isEditingMode,
    maxWidth,
    radius
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "maxWidth",
    "radius"
  ]);
  const { device } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), { commonStyle, title, titleStyle, altStyle, items } = _a2, rest = __objRest(_a2, ["commonStyle", "title", "titleStyle", "altStyle", "items"]);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  const numberOfItems = items == null ? void 0 : items.length;
  const getSlidesPerView = () => {
    return numberOfItems <= MAX_ITEMS_PER_VIEW ? numberOfItems : MAX_ITEMS_PER_VIEW;
  };
  const getMenuItemsStyle = () => {
    return __spreadValues({
      slidesPerView: getSlidesPerView(),
      slidesPerGroup: 1,
      slidesPerColumn: 2,
      categoryMenuItems: items,
      imageSize: { height: 80, width: 80 },
      isEditingMode,
      altStyle,
      style: {
        padding: "24px 0 8px 0",
        margin: "0 16px"
      }
    }, numberOfItems > MAX_ITEMS_PER_VIEW * 2 ? { navigation: true, navigationStyle: 1 } : {});
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: {
      maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH_1600,
      padding,
      margin
    }
  }, rest), {
    maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH_1600,
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      commonStyle: __spreadProps(__spreadValues({}, restStyle), { borderRadius: Number(radius) }),
      children: [
        !!title && /* @__PURE__ */ jsxRuntime.jsx(BlockHeader.BlockHeader, {
          device,
          children: /* @__PURE__ */ jsxRuntime.jsx(StyledTitle, {
            commonStyle: titleStyle,
            children: title
          })
        }),
        /* @__PURE__ */ jsxRuntime.jsx(MenuItems.MenuItems, __spreadValues({}, getMenuItemsStyle()))
      ]
    })
  }));
};
CategoryMenu2Lines.displayName = "Omni_BlockMenu2Lines";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${getStyles.getStyle(commonStyle)}
`
);
const StyledTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 700;
  font-size: 20px;
  ${getStyles.getStyle(commonStyle)}; 
`
);

exports.CategoryMenu2Lines = CategoryMenu2Lines;


/***/ }),

/***/ 309991:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var Slider = __webpack_require__(183594);
var renderLink = __webpack_require__(284727);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const { cardDefaultImage: defaultImage } = coreRenderer.mappingAssets;
const MenuItems = (_a) => {
  var _b = _a, {
    categoryMenuItems = [],
    imageSize,
    isEditingMode = false,
    altStyle
  } = _b, sliderProps = __objRest(_b, [
    "categoryMenuItems",
    "imageSize",
    "isEditingMode",
    "altStyle"
  ]);
  const { displayItems } = coreRenderer.useTimeVisibility(categoryMenuItems, isEditingMode);
  const renderMenuItem = (item) => {
    const { src, alt, googleImageParams, event } = item;
    const content = /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
          commonStyle: {
            height: imageSize.height,
            width: imageSize.width,
            objectFit: "cover",
            marginLeft: "auto",
            marginRight: "auto"
          },
          src: src || defaultImage,
          alt,
          googleImageParams
        }),
        /* @__PURE__ */ jsxRuntime.jsx(StyledSubTitle, {
          commonStyle: altStyle,
          children: alt
        })
      ]
    });
    return renderLink.renderLink(event, content, isEditingMode);
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Slider.Slider, __spreadProps(__spreadValues({
    allowTouchMove: !isEditingMode
  }, sliderProps), {
    children: displayItems == null ? void 0 : displayItems.map((item, index) => /* @__PURE__ */ jsxRuntime.jsx("div", __spreadProps(__spreadValues({}, !isEditingMode && coreRenderer.getTrackingData({
      isTrackContent: true,
      regionName: "categoryList",
      contentName: item.alt,
      target: coreRenderer.getTargetOfTrackingFromEvent(item == null ? void 0 : item.event),
      index
    })), {
      children: renderMenuItem(item)
    }), index))
  }));
};
const StyledSubTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  font-size: 14px;
  line-height: 20px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-align: center;
  word-wrap: break-word;
  padding-bottom: 16px;
  /* Mobile */
  @media only screen and (max-width: 460px) {
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 4px;
  }

  ${coreRenderer.getStyle(commonStyle)}
`
);

exports.MenuItems = MenuItems;


/***/ }),

/***/ 157671:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var style = __webpack_require__(667925);
var image = __webpack_require__(478130);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MAX_CATEGORIES_PER_ROW = 3;
const BASE_CATEGORY_MENU_V2_DATA = {
  title: "Danh m\u1EE5c s\u1EA3n ph\u1EA9m",
  categories: {
    items: [...Array(MAX_CATEGORIES_PER_ROW * 2).keys()].map((item) => {
      return {
        alt: `menu_${item + 1}`,
        icon: image.generatePlaceholderImage({ width: 60, height: 60 }),
        subCategories: {
          items: [...Array(6).keys()].map((subItem) => {
            return { title: `category level 2_${item + 1}_${subItem + 1}` };
          })
        }
      };
    })
  }
};
const BASE_CATEGORY_STYLE = {
  titleStyle: {
    color: "#333333"
  },
  altStyle: {
    color: "#333333"
  },
  commonStyle: {
    background: "#ffffff",
    borderRadius: 8,
    padding: {
      left: 8,
      right: 8
    },
    margin: {
      bottom: 24
    }
  },
  categories: {
    titleStyle: {
      color: "#333333"
    },
    commonStyle: {
      background: "#f9f9f9"
    }
  }
};
const DEFAULT_CATEGORY_MENU_V2 = __spreadProps(__spreadValues(__spreadValues({}, BASE_CATEGORY_STYLE), BASE_CATEGORY_MENU_V2_DATA), {
  categories: __spreadValues(__spreadValues({}, BASE_CATEGORY_STYLE.categories), BASE_CATEGORY_MENU_V2_DATA.categories),
  commonStyle: __spreadValues(__spreadValues({}, style.MOBILE_COMMON_STYLE), BASE_CATEGORY_STYLE.commonStyle)
});

exports.DEFAULT_CATEGORY_MENU_V2 = DEFAULT_CATEGORY_MENU_V2;
exports.MAX_CATEGORIES_PER_ROW = MAX_CATEGORIES_PER_ROW;


/***/ }),

/***/ 976103:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var React = __webpack_require__(891987);
var constants = __webpack_require__(157671);
var Container = __webpack_require__(341018);
var BlockHeader = __webpack_require__(951297);
var renderLink = __webpack_require__(284727);
var getStyles = __webpack_require__(934512);
var grid = __webpack_require__(860046);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const DISPLAY_NAME = "Omni_BlockCategory";
const { cardDefaultImage: defaultImage } = coreRenderer.mappingAssets;
const CategoryMenuV2 = (_a) => {
  var _b = _a, {
    isEditingMode
  } = _b, restProps = __objRest(_b, [
    "isEditingMode"
  ]);
  const { device } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    commonStyle,
    title,
    titleStyle,
    altStyle,
    categories,
    dataUniqId
  } = _a2, rest = __objRest(_a2, [
    "commonStyle",
    "title",
    "titleStyle",
    "altStyle",
    "categories",
    "dataUniqId"
  ]);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  const CATEGORY_MENU_V2_SS_KEY = `${DISPLAY_NAME}_${dataUniqId}`;
  const SSData = sessionStorage.getItem(CATEGORY_MENU_V2_SS_KEY);
  const parsedSSData = !!SSData ? JSON.parse(SSData) : {};
  const [activeCategoryIndex, setActiveCategoryIndex] = React.useState(parsedSSData.activeCategoryIndex);
  const numberOfColumns = Math.ceil(
    categories.items.length / constants.MAX_CATEGORIES_PER_ROW
  );
  const displayItems = [...Array(numberOfColumns).keys()].map((key) => {
    const startIndex = constants.MAX_CATEGORIES_PER_ROW * key;
    const endIndex = constants.MAX_CATEGORIES_PER_ROW * key + constants.MAX_CATEGORIES_PER_ROW;
    return categories.items.slice(startIndex, endIndex);
  });
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: {
      maxWidth: grid.DEFAULT_MAX_WIDTH,
      padding,
      margin
    }
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      commonStyle: restStyle,
      children: [
        !!title && /* @__PURE__ */ jsxRuntime.jsx(BlockHeader.BlockHeader, {
          device,
          children: /* @__PURE__ */ jsxRuntime.jsx(StyledTitle, {
            commonStyle: titleStyle,
            children: title
          })
        }),
        displayItems.map((items, rowIndex) => {
          var _a3, _b3;
          return /* @__PURE__ */ jsxRuntime.jsxs("div", {
            style: { marginBottom: "8px" },
            children: [
              /* @__PURE__ */ jsxRuntime.jsx(CategoryWrapper, {
                children: items == null ? void 0 : items.map((categoryItem, colIndex) => {
                  var _a4;
                  const { icon, alt } = categoryItem;
                  return /* @__PURE__ */ jsxRuntime.jsxs("div", {
                    onClick: () => {
                      if ((activeCategoryIndex == null ? void 0 : activeCategoryIndex.row) !== rowIndex || (activeCategoryIndex == null ? void 0 : activeCategoryIndex.col) !== colIndex) {
                        setActiveCategoryIndex({
                          row: rowIndex,
                          col: colIndex
                        });
                        sessionStorage.setItem(
                          CATEGORY_MENU_V2_SS_KEY,
                          JSON.stringify({
                            activeCategoryIndex: {
                              row: rowIndex,
                              col: colIndex
                            }
                          })
                        );
                      } else {
                        setActiveCategoryIndex(void 0);
                        sessionStorage.setItem(
                          CATEGORY_MENU_V2_SS_KEY,
                          JSON.stringify({
                            activeCategoryIndex: void 0
                          })
                        );
                      }
                    },
                    children: [
                      /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
                        commonStyle: {
                          height: 60,
                          width: 60,
                          objectFit: "cover",
                          marginLeft: "auto",
                          marginRight: "auto"
                        },
                        src: icon || defaultImage,
                        alt: alt || "Category_Image"
                      }),
                      /* @__PURE__ */ jsxRuntime.jsx(StyledSubTitle, {
                        commonStyle: altStyle,
                        children: alt
                      }),
                      !!activeCategoryIndex && (activeCategoryIndex == null ? void 0 : activeCategoryIndex.row) === rowIndex && (activeCategoryIndex == null ? void 0 : activeCategoryIndex.col) === colIndex && /* @__PURE__ */ jsxRuntime.jsx(TopArrow, {
                        commonStyle: {
                          background: (_a4 = categories == null ? void 0 : categories.commonStyle) == null ? void 0 : _a4.background
                        }
                      })
                    ]
                  }, colIndex);
                })
              }),
              !!activeCategoryIndex && (activeCategoryIndex == null ? void 0 : activeCategoryIndex.row) === rowIndex && /* @__PURE__ */ jsxRuntime.jsx(Container.Container, {
                commonStyle: __spreadValues({
                  padding: { top: 8, right: 16, bottom: 8, left: 40 },
                  borderRadius: 6,
                  margin: { bottom: 8 }
                }, !!(categories == null ? void 0 : categories.commonStyle) ? categories == null ? void 0 : categories.commonStyle : {}),
                children: (_b3 = (_a3 = items == null ? void 0 : items[activeCategoryIndex.col]) == null ? void 0 : _a3.subCategories) == null ? void 0 : _b3.items.map(
                  (subCategoryItem, index) => {
                    const { title: title2, event } = subCategoryItem;
                    const content = /* @__PURE__ */ jsxRuntime.jsx(StyledSubCategoryTitle, __spreadProps(__spreadValues({
                      commonStyle: categories == null ? void 0 : categories.titleStyle
                    }, event), {
                      children: title2
                    }));
                    return /* @__PURE__ */ jsxRuntime.jsx("div", __spreadProps(__spreadValues({
                      style: index !== 0 ? { marginTop: 8 } : void 0
                    }, !isEditingMode && coreRenderer.getTrackingData({
                      isTrackContent: true,
                      regionName: "categoryMenuV2",
                      contentName: title2,
                      target: coreRenderer.getTargetOfTrackingFromEvent(event),
                      index
                    })), {
                      children: renderLink.renderLink(event, content, isEditingMode, index)
                    }), index);
                  }
                )
              })
            ]
          }, rowIndex);
        })
      ]
    })
  }));
};
CategoryMenuV2.displayName = DISPLAY_NAME;
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${getStyles.getStyle(commonStyle)}
`
);
const StyledTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 700;
  font-size: 20px;
  margin-bottom: 10px;
  ${getStyles.getStyle(commonStyle)}; 
`
);
const StyledSubTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  font-size: 14px;
  line-height: 22px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  text-align: center;
  word-wrap: break-word;
  margin-bottom: 4px;
  ${getStyles.getStyle(commonStyle)}
`
);
const CategoryWrapper = styled__default["default"].div`
  display: grid;
  grid-template-columns: repeat(${constants.MAX_CATEGORIES_PER_ROW}, 1fr);
  grid-column-gap: 12px;
`;
const StyledSubCategoryTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  font-size: 14px;
  line-height: 22px;
  word-wrap: break-word;
  ${getStyles.getStyle(commonStyle)}
`
);
const TopArrow = styled__default["default"].div(
  ({ commonStyle }) => `
  width: 0; 
  height: 0; 
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid ${commonStyle.background || "#f9f9f9"};
  margin: 0 auto;
`
);

exports.CategoryMenuV2 = CategoryMenuV2;


/***/ }),

/***/ 15105:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var MenuItems = __webpack_require__(130471);
var Container = __webpack_require__(341018);
var BlockHeader = __webpack_require__(951297);
var grid = __webpack_require__(860046);
var getStyles = __webpack_require__(934512);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAX_ITEMS_PER_VIEW = {
  DESKTOP: 10,
  MOBILE: 5
};
const CategoryMenu = (_a) => {
  var _b = _a, {
    isEditingMode,
    maxWidth
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "maxWidth"
  ]);
  const { device } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), { commonStyle, title, titleStyle, altStyle, items } = _a2, rest = __objRest(_a2, ["commonStyle", "title", "titleStyle", "altStyle", "items"]);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  const isDesktop = device === "desktop";
  const numberOfItems = items == null ? void 0 : items.length;
  const getSlidesPerView = () => {
    if (isDesktop) {
      return numberOfItems <= MAX_ITEMS_PER_VIEW.DESKTOP ? numberOfItems : 9.5;
    }
    if (numberOfItems <= MAX_ITEMS_PER_VIEW.MOBILE)
      return numberOfItems;
    return numberOfItems <= MAX_ITEMS_PER_VIEW.DESKTOP ? 5 : 4.5;
  };
  const getMenuItemsStyle = () => {
    if (isDesktop) {
      return __spreadValues({
        slidesPerView: getSlidesPerView(),
        slidesPerGroup: 1,
        categoryMenuItems: items,
        imageSize: { height: 56, width: 56 },
        isEditingMode,
        altStyle,
        style: {
          padding: "24px 0",
          margin: "0 16px"
        }
      }, numberOfItems > MAX_ITEMS_PER_VIEW.DESKTOP ? { navigation: true, navigationStyle: 1 } : {});
    }
    return {
      slidesPerView: getSlidesPerView(),
      slidesPerGroup: 1,
      slidesPerColumn: (items == null ? void 0 : items.length) <= 5 ? 1 : 2,
      categoryMenuItems: items,
      imageSize: { height: 42, width: 42 },
      isEditingMode,
      altStyle,
      style: {
        padding: "12px 0 0 0",
        margin: "0 16px"
      }
    };
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: {
      maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH,
      padding,
      margin
    }
  }, rest), {
    maxWidth,
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      commonStyle: restStyle,
      children: [
        !!title && /* @__PURE__ */ jsxRuntime.jsx(BlockHeader.BlockHeader, {
          device,
          children: /* @__PURE__ */ jsxRuntime.jsx(StyledTitle, {
            commonStyle: titleStyle,
            children: title
          })
        }),
        /* @__PURE__ */ jsxRuntime.jsx(MenuItems.MenuItems, __spreadValues({}, getMenuItemsStyle()))
      ]
    })
  }));
};
CategoryMenu.displayName = "Omni_BlockMenu";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${getStyles.getStyle(commonStyle)}
`
);
const StyledTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 700;
  font-size: 20px;
  ${getStyles.getStyle(commonStyle)}; 
`
);

exports.CategoryMenu = CategoryMenu;


/***/ }),

/***/ 130471:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var Slider = __webpack_require__(183594);
var renderLink = __webpack_require__(284727);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const { cardDefaultImage: defaultImage } = coreRenderer.mappingAssets;
const MenuItems = (_a) => {
  var _b = _a, {
    categoryMenuItems = [],
    imageSize,
    isEditingMode = false,
    altStyle
  } = _b, sliderProps = __objRest(_b, [
    "categoryMenuItems",
    "imageSize",
    "isEditingMode",
    "altStyle"
  ]);
  const { device } = coreRenderer.useStore();
  const { displayItems } = coreRenderer.useTimeVisibility(categoryMenuItems, isEditingMode);
  const renderMenuItem = (item) => {
    const { src, alt, googleImageParams, event } = item;
    const content = /* @__PURE__ */ jsxRuntime.jsxs("div", {
      style: { paddingBottom: device === "desktop" ? "0px" : "16px" },
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
          commonStyle: {
            height: imageSize.height,
            width: imageSize.width,
            objectFit: "cover",
            marginLeft: "auto",
            marginRight: "auto"
          },
          src: src || defaultImage,
          alt,
          googleImageParams
        }),
        /* @__PURE__ */ jsxRuntime.jsx(StyledSubTitle, {
          commonStyle: altStyle,
          children: alt
        })
      ]
    });
    return renderLink.renderLink(event, content, isEditingMode);
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Slider.Slider, __spreadProps(__spreadValues({
    allowTouchMove: !isEditingMode
  }, sliderProps), {
    children: displayItems == null ? void 0 : displayItems.map((item, index) => /* @__PURE__ */ jsxRuntime.jsx("div", __spreadProps(__spreadValues({}, !isEditingMode && coreRenderer.getTrackingData({
      isTrackContent: true,
      regionName: "categoryList",
      contentName: item.alt,
      target: coreRenderer.getTargetOfTrackingFromEvent(item == null ? void 0 : item.event),
      index
    })), {
      children: renderMenuItem(item)
    }), index))
  }));
};
const StyledSubTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  font-size: 14px;
  line-height: 20px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-align: center;
  word-wrap: break-word;
  /* Mobile */
  @media only screen and (max-width: 460px) {
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 4px;
  }
  margin-top: 8px;

  ${coreRenderer.getStyle(commonStyle)}
`
);

exports.MenuItems = MenuItems;


/***/ }),

/***/ 398661:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const bannerTemplate = [
  {
    bannerPerView: 1,
    width: 1200,
    height: 108,
    label: "M\xF4\u0323t banner (1200x108)"
  },
  {
    bannerPerView: 2,
    width: 594,
    height: 108,
    label: "Hai banner (594x108)"
  },
  {
    bannerPerView: 3,
    width: 392,
    height: 108,
    label: "Ba banner (392x108)"
  }
];

exports.bannerTemplate = bannerTemplate;


/***/ }),

/***/ 848110:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var uuid = __webpack_require__(596839);
var style = __webpack_require__(667925);
var image = __webpack_require__(478130);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const DEFAULT_COUNTDOWN_SKU_ITEMS_DATA = {
  tabs: [
    {
      title: "TAB 1",
      description: "\u0110ang di\u1EC5n ra",
      id: uuid.v4(),
      banners: {
        bannerPerView: 2,
        desktop: [
          { src: image.generatePlaceholderImage({ width: 594, height: 108 }) },
          { src: image.generatePlaceholderImage({ width: 594, height: 108 }) }
        ],
        mobile: [
          { src: image.generatePlaceholderImage({ width: 359, height: 108 }) }
        ]
      }
    },
    {
      title: "TAB 2",
      description: "S\u1EAFp t\u1EDBi",
      id: uuid.v4(),
      banners: {
        bannerPerView: 1,
        desktop: [
          { src: image.generatePlaceholderImage({ width: 1200, height: 108 }) }
        ],
        mobile: [
          { src: image.generatePlaceholderImage({ width: 359, height: 108 }) }
        ]
      }
    },
    {
      title: "TAB 3",
      description: "S\u1EAFp t\u1EDBi",
      id: uuid.v4(),
      banners: {
        bannerPerView: 3,
        desktop: [
          { src: image.generatePlaceholderImage({ width: 392, height: 108 }) },
          { src: image.generatePlaceholderImage({ width: 392, height: 108 }) },
          { src: image.generatePlaceholderImage({ width: 392, height: 108 }) }
        ],
        mobile: [
          { src: image.generatePlaceholderImage({ width: 359, height: 108 }) }
        ]
      }
    },
    {
      title: "TAB 4",
      description: "S\u1EAFp t\u1EDBi",
      id: uuid.v4()
    }
  ]
};
const DEFAULT_COUNTDOWN_SKU_ITEMS_STYLE = {
  commonStyle: {
    backgroundColor: "#1230B0"
  },
  titleStyle: {
    color: "#848788"
  },
  viewMoreStyle: {
    color: "#ffffff"
  },
  activeTabStyle: {
    backgroundColor: "#1230B0"
  }
};
const DEFAULT_COUNTDOWN_SKU_LIST = __spreadProps(__spreadValues({
  syncDeviceStyle: true
}, DEFAULT_COUNTDOWN_SKU_ITEMS_DATA), {
  desktop: __spreadProps(__spreadValues({}, DEFAULT_COUNTDOWN_SKU_ITEMS_STYLE), {
    commonStyle: __spreadValues(__spreadValues({}, DEFAULT_COUNTDOWN_SKU_ITEMS_STYLE.commonStyle), style.DESKTOP_COMMON_STYLE)
  }),
  mobile: __spreadProps(__spreadValues({}, DEFAULT_COUNTDOWN_SKU_ITEMS_STYLE), {
    commonStyle: __spreadValues(__spreadValues({}, DEFAULT_COUNTDOWN_SKU_ITEMS_STYLE.commonStyle), style.MOBILE_COMMON_STYLE)
  })
});
const DEFAULT_COUNTDOWN_BLOCK_VISIBILITY = true;

exports.DEFAULT_COUNTDOWN_BLOCK_VISIBILITY = DEFAULT_COUNTDOWN_BLOCK_VISIBILITY;
exports.DEFAULT_COUNTDOWN_SKU_LIST = DEFAULT_COUNTDOWN_SKU_LIST;


/***/ }),

/***/ 781516:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var addPaddingNumber = __webpack_require__(996887);
var Countdown = __webpack_require__(283980);
var Row = __webpack_require__(346761);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const BlockCountdown = ({ endTime, isMobile }) => {
  const timer = coreRenderer.useTimer(new Date(endTime || ""));
  if (!endTime) {
    return null;
  }
  const digitStyle = {
    width: isMobile ? "1.5rem" : "2.2rem",
    height: isMobile ? "1.5rem" : "2.2rem",
    fontSize: isMobile ? "12px" : "1rem",
    fontWeight: "bold",
    textAlign: "center",
    alignItems: "center",
    lineHeight: isMobile ? "1.5rem" : "2.2rem",
    color: "white",
    background: "linear-gradient(rgb(74, 74, 74),rgb(35, 34, 34))",
    borderRadius: 5
  };
  return /* @__PURE__ */ jsxRuntime.jsx(CountdownWrapper, {
    isMobile,
    children: !!(timer == null ? void 0 : timer.days) ? /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [
        "K\u1EBFt th\xFAc sau",
        /* @__PURE__ */ jsxRuntime.jsx(RemainingDay, {
          style: digitStyle,
          children: addPaddingNumber.addPaddingNumber(timer.days)
        }),
        " ",
        "Nga\u0300y"
      ]
    }) : /* @__PURE__ */ jsxRuntime.jsx(Countdown.Countdown, {
      due: endTime,
      showDays: false,
      showLabel: false,
      showHours: true,
      showMinutes: true,
      showSeconds: true,
      countdownType: "due",
      splitTimeUnit: /* @__PURE__ */ jsxRuntime.jsx(Row.Row, {
        align: "middle",
        children: ":"
      }),
      countdownStyle: {
        elementGap: 4,
        align: coreRenderer.Alignment.center,
        digitStyle
      }
    })
  });
};
const CountdownWrapper = styled__default["default"].div`
  display: flex;
  align-items: center;
  color: white;
  column-gap: 0.5rem;
  font-size: ${({ isMobile }) => isMobile ? "13px" : "18px"};
  font-weight: 500;
`;
const RemainingDay = styled__default["default"].div`
  font-size: 1rem;
  color: white;
  text-align: center;
`;

exports.BlockCountdown = BlockCountdown;


/***/ }),

/***/ 9215:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var icons = __webpack_require__(143599);
var React = __webpack_require__(891987);
var Countdown = __webpack_require__(781516);
var useTabs = __webpack_require__(850255);
var mock = __webpack_require__(848110);
var banner = __webpack_require__(398661);
var renderLink = __webpack_require__(284727);
var renderDynamicSlot = __webpack_require__(958220);
var EmptyProduct = __webpack_require__(907438);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CountdownSkuListDesktop = (_a) => {
  var _b = _a, {
    tabs,
    commonStyle,
    isEditingMode,
    activeTabStyle,
    ssrData,
    viewMoreStyle,
    titleStyle
  } = _b, props = __objRest(_b, [
    "tabs",
    "commonStyle",
    "isEditingMode",
    "activeTabStyle",
    "ssrData",
    "viewMoreStyle",
    "titleStyle"
  ]);
  var _a2, _b2, _c, _d;
  const { displayItem, validItems, setActiveTab, activeTab } = useTabs.useTabs(
    tabs,
    isEditingMode
  );
  const { mappingDynamicSlots, globalData } = coreRenderer.useStore();
  const { id, viewMoreUrl, timeVisibility, collectionSlug, banners } = displayItem || {};
  const blockCountDownStartTime = timeVisibility == null ? void 0 : timeVisibility.startTime;
  const blockCountdownEndTime = timeVisibility == null ? void 0 : timeVisibility.endTime;
  const activeTabIndex = tabs.findIndex((tab) => tab.id === activeTab) || 0;
  const blockCountdownVisibility = (_b2 = (_a2 = tabs == null ? void 0 : tabs[activeTabIndex]) == null ? void 0 : _a2.isDisplayCountdown) != null ? _b2 : mock.DEFAULT_COUNTDOWN_BLOCK_VISIBILITY;
  const viewMoreContent = /* @__PURE__ */ jsxRuntime.jsxs(ViewMore, {
    viewMoreStyle,
    children: [
      "Xem t\u1EA5t c\u1EA3 ",
      /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
        name: "RightOutlined",
        style: { fontSize: 18 }
      })
    ]
  });
  const showCountdownBlock = React.useMemo(() => {
    const currentTime = new Date();
    return !!blockCountdownVisibility && !!blockCountDownStartTime && !!blockCountdownEndTime && currentTime >= new Date(blockCountDownStartTime) && currentTime <= new Date(blockCountdownEndTime);
  }, [
    blockCountdownVisibility,
    blockCountDownStartTime,
    blockCountdownEndTime
  ]);
  if (validItems.length === 0)
    return;
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, __spreadProps(__spreadValues({}, props), {
    style: { maxWidth: coreRenderer.unitParse(commonStyle.maxWidth) },
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(TabHeaderWapper, {
        children: validItems.slice(0, 6).map((tab, index) => {
          return /* @__PURE__ */ jsxRuntime.jsxs(TabItem, __spreadProps(__spreadValues({
            active: tab.id === activeTab,
            commonStyle,
            activeTabStyle,
            titleStyle,
            onClick: () => setActiveTab(tab.id)
          }, !isEditingMode && !(globalData == null ? void 0 : globalData.isPreviewMode) && coreRenderer.getTrackingData({
            isTrackContent: true,
            regionName: `countDownTab${props.id}`,
            contentName: tab.title,
            index: index + 1
          })), {
            children: [
              /* @__PURE__ */ jsxRuntime.jsx("div", {
                className: "tab-title inline",
                children: tab.title
              }),
              /* @__PURE__ */ jsxRuntime.jsxs("div", {
                className: "tab-description inline",
                children: [
                  " ",
                  tab.description
                ]
              })
            ]
          }), index);
        })
      }),
      /* @__PURE__ */ jsxRuntime.jsxs(TabContentWrapper, {
        commonStyle,
        children: [
          (commonStyle == null ? void 0 : commonStyle.backgroundImage) && /* @__PURE__ */ jsxRuntime.jsx(BackgroundImage, {
            src: commonStyle.backgroundImage
          }),
          /* @__PURE__ */ jsxRuntime.jsxs(TabContent, {
            children: [
              !!((_c = banners == null ? void 0 : banners.desktop) == null ? void 0 : _c.length) && !!(banners == null ? void 0 : banners.bannerPerView) && /* @__PURE__ */ jsxRuntime.jsx(TabBanner, {
                children: (_d = [...Array(banners == null ? void 0 : banners.bannerPerView).fill(null)]) == null ? void 0 : _d.map(
                  (_, index) => {
                    var _a3;
                    const banner$1 = (_a3 = banners == null ? void 0 : banners.desktop) == null ? void 0 : _a3[index];
                    const template = banner.bannerTemplate.find(
                      (tem) => tem.bannerPerView === ((banners == null ? void 0 : banners.bannerPerView) || 1)
                    );
                    return (banner$1 == null ? void 0 : banner$1.src) ? /* @__PURE__ */ jsxRuntime.jsx(Banner, {
                      src: banner$1.src,
                      ratio: `${template.width}/${template.height}`
                    }, index) : /* @__PURE__ */ jsxRuntime.jsx("div", {
                      style: { flex: 1 }
                    }, index);
                  }
                )
              }),
              (!!viewMoreUrl || !!showCountdownBlock) && /* @__PURE__ */ jsxRuntime.jsxs(StyledRow, {
                justify: !!showCountdownBlock ? "space-between" : "flex-end",
                children: [
                  !!showCountdownBlock && /* @__PURE__ */ jsxRuntime.jsx(Countdown.BlockCountdown, {
                    endTime: blockCountdownEndTime
                  }),
                  !!viewMoreUrl ? /* @__PURE__ */ jsxRuntime.jsx("div", __spreadProps(__spreadValues({}, !isEditingMode && !(globalData == null ? void 0 : globalData.isPreviewMode) && coreRenderer.getTrackingData({
                    isTrackContent: true,
                    regionName: "countDownTab",
                    contentName: "viewAllButton",
                    target: viewMoreUrl
                  })), {
                    children: renderLink.renderLink(viewMoreUrl, viewMoreContent, isEditingMode)
                  })) : null
                ]
              }),
              /* @__PURE__ */ jsxRuntime.jsx("div", {
                style: { minHeight: 300 },
                children: collectionSlug || isEditingMode ? renderDynamicSlot.renderDynamicSlot(
                  "product_carousel_desktop",
                  mappingDynamicSlots,
                  validItems.findIndex((el) => el.id === activeTab) === 0 ? ssrData : void 0,
                  {
                    collectionSlug,
                    config: {
                      regionName: "countDownTab"
                    }
                  }
                ) : /* @__PURE__ */ jsxRuntime.jsx(EmptyProduct.EmptyProduct, {})
              }, activeTab)
            ]
          }, id)
        ]
      })
    ]
  }));
};
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)}
  position: relative;
  overflow: hidden;
  width: 100%;
  border-radius: 8px;
`
);
const TabHeaderWapper = styled__default["default"].div`
  display: flex;
  wrap: no-wrap;
  background-color: #fff;
  padding: 0.5rem 0 0 0;
`;
const TabContent = styled__default["default"].div`
  padding: 1rem;
  position: relative;
`;
const TabItem = styled__default["default"].div`
  /* title max length =  */
  color: ${({ commonStyle, active, titleStyle }) => active ? "#fff" : (titleStyle == null ? void 0 : titleStyle.color) || (commonStyle == null ? void 0 : commonStyle.color) || "gray"};
  background-color: ${({ active, commonStyle, activeTabStyle }) => active ? (activeTabStyle == null ? void 0 : activeTabStyle.backgroundColor) || (commonStyle == null ? void 0 : commonStyle.backgroundColor) || "gray" : "#fff"};
  flex: 1 1 0%;
  text-align: center;
  padding: 0.5rem 0.5rem 0.75rem 0.5rem;
  border-radius: 8px 8px 0 0;
  cursor: pointer;
  .inline {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    max-width: 100%;
  }
  .tab-title {
    font-size: 20px;
    font-weight: 550;
    line-height: 28px;
    margin-bottom: 2px;
  }
  .tab-description {
    font-size: 13px;
    line-height: 24px;
    color: ${({ commonStyle, active }) => active ? "#fff" : (commonStyle == null ? void 0 : commonStyle.color) || "gray"};
  }
`;
const ViewMore = styled__default["default"].a(
  ({ viewMoreStyle }) => `
  color: ${(viewMoreStyle == null ? void 0 : viewMoreStyle.color) || "#fff"}!important;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  :hover {
    color: #fff;
  }
  text-decoration: none;
`
);
const StyledRow = styled__default["default"].div`
  display: flex;
  justify-content: ${({ justify }) => justify || "flex-end"};
  align-items: center;
  padding: 0 !important;
  margin: 0 0 0.5rem !important;
  flex-wrap: nowrap;
`;
const TabBanner = styled__default["default"].div`
  display: flex;
  column-gap: 1rem;
  flex-wrap: nowrap;
  margin-bottom: 0.5rem;
  min-height: 108px;
`;
const Banner = styled__default["default"].img`
  border-radius: 4px;
  flex: 1 1 0%;
  overflow: hidden;
  object-fit: cover;
  width: 100%;
  object-position: top;
  aspect-ratio: ${({ ratio }) => ratio};
`;
const BackgroundImage = styled__default["default"].img`
  position: absolute;
  width: 100%;
  object-fit: cover;
`;
const TabContentWrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)}
  background-color: ${({ commonStyle: commonStyle2 }) => (commonStyle2 == null ? void 0 : commonStyle2.backgroundColor) || "gray"};
  position: relative;
`
);

exports.CountdownSkuListDesktop = CountdownSkuListDesktop;


/***/ }),

/***/ 169281:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var icons = __webpack_require__(143599);
var React = __webpack_require__(891987);
var useTabs = __webpack_require__(850255);
var Countdown = __webpack_require__(781516);
var mock = __webpack_require__(848110);
var Slider = __webpack_require__(183594);
var renderDynamicSlot = __webpack_require__(958220);
var EmptyProduct = __webpack_require__(907438);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CountdownSkuListMobile = (_a) => {
  var _b = _a, {
    tabs,
    isEditingMode,
    commonStyle,
    activeTabStyle,
    viewMoreStyle,
    ssrData,
    titleStyle
  } = _b, props = __objRest(_b, [
    "tabs",
    "isEditingMode",
    "commonStyle",
    "activeTabStyle",
    "viewMoreStyle",
    "ssrData",
    "titleStyle"
  ]);
  var _a2, _b2, _c, _d;
  const { validItems, activeTab, setActiveTab, displayItem } = useTabs.useTabs(
    tabs || [],
    isEditingMode
  );
  const { timeVisibility, banners, collectionSlug, viewMoreUrl } = displayItem || {};
  const { mappingDynamicSlots } = coreRenderer.useStore();
  const blockCountDownStartTime = timeVisibility == null ? void 0 : timeVisibility.startTime;
  const blockCountdownEndTime = timeVisibility == null ? void 0 : timeVisibility.endTime;
  const activeTabIndex = tabs.findIndex((tab) => tab.id === activeTab);
  const blockCountdownVisibility = (_b2 = (_a2 = tabs == null ? void 0 : tabs[activeTabIndex]) == null ? void 0 : _a2.isDisplayCountdown) != null ? _b2 : mock.DEFAULT_COUNTDOWN_BLOCK_VISIBILITY;
  const onClickTabId = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center"
      });
    }
    setActiveTab(id);
  };
  const showCountdownBlock = React.useMemo(() => {
    const currentTime = new Date();
    return !!blockCountdownVisibility && !!blockCountDownStartTime && !!blockCountdownEndTime && currentTime >= new Date(blockCountDownStartTime) && currentTime <= new Date(blockCountdownEndTime);
  }, [
    blockCountdownVisibility,
    blockCountDownStartTime,
    blockCountdownEndTime
  ]);
  if (validItems.length === 0)
    return;
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, __spreadProps(__spreadValues({}, props), {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(BlockHeader, {
        children: /* @__PURE__ */ jsxRuntime.jsx(TabHeaderWapper, {
          children: validItems.map((tab) => {
            return /* @__PURE__ */ jsxRuntime.jsxs(TabItem, {
              id: tab.id,
              active: tab.id === activeTab,
              commonStyle,
              activeTabStyle,
              titleStyle,
              onClick: () => onClickTabId(tab.id),
              children: [
                /* @__PURE__ */ jsxRuntime.jsx("div", {
                  className: "tab-title-wrapper",
                  children: /* @__PURE__ */ jsxRuntime.jsx("div", {
                    className: "tab-title inline",
                    children: tab.title
                  })
                }),
                /* @__PURE__ */ jsxRuntime.jsxs("div", {
                  className: "tab-description inline",
                  children: [
                    " ",
                    tab.description
                  ]
                })
              ]
            }, tab.id);
          })
        })
      }),
      /* @__PURE__ */ jsxRuntime.jsxs(BlockContainer, {
        commonStyle,
        children: [
          !!((_c = banners == null ? void 0 : banners.mobile) == null ? void 0 : _c.length) && /* @__PURE__ */ jsxRuntime.jsx(SliderWrapper, {
            children: ((_d = banners == null ? void 0 : banners.mobile) == null ? void 0 : _d.length) === 1 ? /* @__PURE__ */ jsxRuntime.jsx(Banner, {
              src: banners == null ? void 0 : banners.mobile[0].src,
              ratio: `359/108`
            }) : /* @__PURE__ */ jsxRuntime.jsx(Slider.Slider, {
              spaceBetween: 8,
              loop: true,
              allowTouchMove: !isEditingMode,
              autoplay: true,
              children: banners == null ? void 0 : banners.mobile.map((banner, index) => /* @__PURE__ */ jsxRuntime.jsx(Banner, {
                src: banner.src,
                ratio: `359/108`
              }, index))
            })
          }),
          (!!viewMoreUrl || !!showCountdownBlock) && /* @__PURE__ */ jsxRuntime.jsxs(StyledRow, {
            justify: !!showCountdownBlock ? "space-between" : "end",
            children: [
              !!showCountdownBlock && /* @__PURE__ */ jsxRuntime.jsx(Countdown.BlockCountdown, {
                isMobile: true,
                endTime: blockCountdownEndTime
              }),
              !!viewMoreUrl && /* @__PURE__ */ jsxRuntime.jsxs(ViewMore, {
                href: viewMoreUrl,
                target: "_self",
                viewMoreStyle,
                children: [
                  "Xem t\xE2\u0301t ca\u0309",
                  /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
                    name: "RightOutlined",
                    style: { fontSize: 18 }
                  })
                ]
              })
            ]
          }),
          /* @__PURE__ */ jsxRuntime.jsx("div", {
            style: { minHeight: 250 },
            children: collectionSlug || isEditingMode ? renderDynamicSlot.renderDynamicSlot(
              "product_carousel_mobile",
              mappingDynamicSlots,
              validItems.findIndex((el) => el.id === activeTab) === 0 ? ssrData : void 0,
              {
                collectionSlug,
                config: {
                  regionName: "countDownTab"
                }
              }
            ) : /* @__PURE__ */ jsxRuntime.jsx(EmptyProduct.EmptyProduct, {})
          }, activeTab)
        ]
      }, activeTab)
    ]
  }));
};
const Wrapper = styled__default["default"].div`
  position: relative;
  width: 100%;
  padding-top: 40px;
`;
const TabHeaderWapper = styled__default["default"].div`
  display: flex;
  wrap: nowrap;
  padding: 0 0.5rem;
  column-gap: 6px;
  user-select: none;
`;
const TabItem = styled__default["default"].div`
  cursor: pointer;
  color: ${({ commonStyle, active, titleStyle }) => active ? "#fff" : (titleStyle == null ? void 0 : titleStyle.color) || (commonStyle == null ? void 0 : commonStyle.color) || "gray"};
  background-color: ${({ active, commonStyle, activeTabStyle }) => active ? (activeTabStyle == null ? void 0 : activeTabStyle.backgroundColor) || (commonStyle == null ? void 0 : commonStyle.backgroundColor) || "gray" : "#fff"};
  padding: 0.5rem;
  justify-content: center;
  height: 80px;
  min-width: 96px;
  max-width: 110px;
  flex: 1;
  border-radius: 8px;
  border: 1px solid ${({ active }) => active ? "#fff" : "#E4E5F0"};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .inline {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    max-width: 100%;
  }
  .tab-title {
    font-size: 13px;
    font-weight: 550;
    line-height: 20px;
    margin-bottom: 2px;
    -webkit-line-clamp: 2;
    text-align: center;
  }
  .tab-description {
    font-size: 10px;
    -webkit-line-clamp: 1;
    text-align: center;
  }
  .tab-title-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
  }
`;
const BlockHeader = styled__default["default"].div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  overflow-x: auto;
  margin-bottom: 0.25rem;
  /* hide scrollbar*/
  ::-webkit-scrollbar {
    display: none;
  }
`;
const BlockContainer = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)}
  padding: 1rem 0.5rem;
  padding-top: 48px;
`
);
const StyledRow = styled__default["default"].div`
  display: flex;
  justify-content: ${({ justify }) => justify || "flex-end"};
  align-items: center;
  padding: 0 !important;
  margin: 0 0 0.5rem !important;
  flex-wrap: nowrap !important;
`;
const ViewMore = styled__default["default"].a(
  ({ viewMoreStyle }) => `
  color: ${(viewMoreStyle == null ? void 0 : viewMoreStyle.color) || "#fff"}!important;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  :hover {
    color: #fff;
  }
  text-decoration: none;
`
);
const Banner = styled__default["default"].img`
  border-radius: 4px;
  flex: 1 1 0%;
  overflow: hidden;
  object-fit: cover;
  object-position: top;
  width: 100%;
  aspect-ratio: ${({ ratio }) => ratio};
`;
const SliderWrapper = styled__default["default"].div`
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 0.5rem;
`;

exports.CountdownSkuListMobile = CountdownSkuListMobile;


/***/ }),

/***/ 743994:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var coreRenderer = __webpack_require__(85097);
var CountdownSkuListDesktop = __webpack_require__(9215);
var CountdownSkuListMobile = __webpack_require__(169281);
var grid = __webpack_require__(860046);
var Container = __webpack_require__(341018);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CountdownSkuListV2 = (_a) => {
  var _b = _a, {
    isEditingMode,
    ssrData
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "ssrData"
  ]);
  const { device } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(
    restProps,
    device
  ), { tabs, commonStyle, maxWidth } = _a2, restStyle = __objRest(_a2, ["tabs", "commonStyle", "maxWidth"]);
  const _b2 = commonStyle || {}, { padding, margin, borderRadius } = _b2, restCommonStyle = __objRest(_b2, ["padding", "margin", "borderRadius"]);
  const ContainerStyle = {
    padding,
    margin,
    borderRadius,
    maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH
  };
  if (!(tabs == null ? void 0 : tabs.length))
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, {
    commonStyle: ContainerStyle,
    children: device === "desktop" ? /* @__PURE__ */ jsxRuntime.jsx(CountdownSkuListDesktop.CountdownSkuListDesktop, __spreadValues({
      tabs: (tabs || []).map((el) => __spreadProps(__spreadValues({}, el), {
        id: el.id || coreRenderer.generateRandomId()
      })),
      ssrData,
      commonStyle: restCommonStyle,
      isEditingMode
    }, restStyle)) : /* @__PURE__ */ jsxRuntime.jsx(CountdownSkuListMobile.CountdownSkuListMobile, __spreadValues({
      tabs: (tabs || []).map((el) => __spreadProps(__spreadValues({}, el), {
        id: el.id || coreRenderer.generateRandomId()
      })),
      ssrData,
      commonStyle: restCommonStyle,
      isEditingMode
    }, restStyle))
  });
};
CountdownSkuListV2.displayName = "Omni_CountdownSkuList_v2";

exports.CountdownSkuListV2 = CountdownSkuListV2;


/***/ }),

/***/ 850255:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(85097);
var React = __webpack_require__(891987);

const useTabs = (items, isEditingMode = false) => {
  var _a;
  const { displayItems: validItems } = coreRenderer.useTimeVisibility(items, isEditingMode);
  const [activeTab, setActiveTab] = React.useState((_a = validItems == null ? void 0 : validItems[0]) == null ? void 0 : _a.id);
  const displayItem = React.useMemo(() => {
    return validItems == null ? void 0 : validItems.find((el) => el.id === activeTab);
  }, [validItems, activeTab]);
  React.useEffect(() => {
    var _a2;
    if (isEditingMode) {
      setActiveTab((_a2 = validItems == null ? void 0 : validItems[0]) == null ? void 0 : _a2.id);
    }
  }, [items == null ? void 0 : items.length, isEditingMode]);
  return {
    activeTab,
    setActiveTab,
    validItems,
    displayItem
  };
};

exports.useTabs = useTabs;


/***/ }),

/***/ 667664:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var uuid = __webpack_require__(596839);
var style = __webpack_require__(667925);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const DEFAULT_RADIUS = 16;
const PRODUCT_WRAPPER_PADDING = 8;
const DEFAULT_COUNTDOWN_SKU_ITEMS_DATA = {
  items: [
    {
      title: "T\xCAN CH\u01AF\u01A0NG TR\xCCNH",
      description: "M\xF4 t\u1EA3/Th\u1EDDi gian di\u1EC5n ra",
      id: uuid.v4()
    },
    {
      title: "T\xCAN CH\u01AF\u01A0NG TR\xCCNH",
      description: "M\xF4 t\u1EA3/Th\u1EDDi gian di\u1EC5n ra",
      id: uuid.v4()
    },
    {
      title: "T\xCAN CH\u01AF\u01A0NG TR\xCCNH",
      description: "M\xF4 t\u1EA3/Th\u1EDDi gian di\u1EC5n ra",
      id: uuid.v4()
    },
    {
      title: "T\xCAN CH\u01AF\u01A0NG TR\xCCNH",
      description: "M\xF4 t\u1EA3/Th\u1EDDi gian di\u1EC5n ra",
      id: uuid.v4()
    }
  ]
};
const DEFAULT_COUNTDOWN_SKU_ITEMS_STYLE = {
  commonStyle: {
    borderRadius: 8,
    bgImageWidth: 1600,
    bgImagePercent: 100,
    backgroundImage: "https://lh3.googleusercontent.com/n8WdU2aITBBDNRpw1OIBNADR2b_EsATsFkU42S-Kfftu8UictI8JsyKwOBjRkPT7u_BO1ILqcwRXn8xZG8TCP2jCLqwTSWQR"
  },
  titleStyle: {
    color: "#848788"
  },
  activeTabStyle: {
    backgroundColor: "#f2f2fb",
    tabBarColor: "#0200BC",
    activeColor: "#0200BC"
  },
  viewMoreStyle: {
    color: "#fff"
  },
  maxWidth: 1600
};
const DEFAULT_COUNTDOWN_SKU_LIST = __spreadProps(__spreadValues({
  syncDeviceStyle: true
}, DEFAULT_COUNTDOWN_SKU_ITEMS_DATA), {
  desktop: __spreadProps(__spreadValues({}, DEFAULT_COUNTDOWN_SKU_ITEMS_STYLE), {
    commonStyle: __spreadValues(__spreadValues({}, DEFAULT_COUNTDOWN_SKU_ITEMS_STYLE.commonStyle), style.DESKTOP_COMMON_STYLE)
  }),
  mobile: __spreadProps(__spreadValues({}, DEFAULT_COUNTDOWN_SKU_ITEMS_STYLE), {
    commonStyle: __spreadValues(__spreadValues({}, DEFAULT_COUNTDOWN_SKU_ITEMS_STYLE.commonStyle), style.MOBILE_COMMON_STYLE)
  }),
  radius: DEFAULT_RADIUS
});
const DEFAULT_COUNTDOWN_BLOCK_VISIBILITY = true;

exports.DEFAULT_COUNTDOWN_BLOCK_VISIBILITY = DEFAULT_COUNTDOWN_BLOCK_VISIBILITY;
exports.DEFAULT_COUNTDOWN_SKU_LIST = DEFAULT_COUNTDOWN_SKU_LIST;
exports.DEFAULT_RADIUS = DEFAULT_RADIUS;
exports.PRODUCT_WRAPPER_PADDING = PRODUCT_WRAPPER_PADDING;


/***/ }),

/***/ 731824:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var addPaddingNumber = __webpack_require__(996887);
var Countdown = __webpack_require__(283980);
var Row = __webpack_require__(346761);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const BlockCountdown = ({ endTime, isMobile, countDownStyle }) => {
  const timer = coreRenderer.useTimer(new Date(endTime || ""));
  if (!endTime) {
    return null;
  }
  const digitStyle = {
    width: isMobile ? "1.5rem" : "2.2rem",
    height: isMobile ? "1.5rem" : "2.2rem",
    fontSize: isMobile ? "12px" : "1rem",
    fontWeight: "bold",
    textAlign: "center",
    alignItems: "center",
    lineHeight: isMobile ? "1.5rem" : "2.2rem",
    color: (countDownStyle == null ? void 0 : countDownStyle.color) || "black",
    background: "linear-gradient(rgb(74, 74, 74),rgb(35, 34, 34))",
    borderRadius: 5
  };
  return /* @__PURE__ */ jsxRuntime.jsx(CountdownWrapper, {
    isMobile,
    color: countDownStyle == null ? void 0 : countDownStyle.color,
    children: !!(timer == null ? void 0 : timer.days) ? /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [
        "K\u1EBFt th\xFAc sau",
        /* @__PURE__ */ jsxRuntime.jsx(RemainingDay, {
          style: digitStyle,
          children: addPaddingNumber.addPaddingNumber(timer.days)
        }),
        " ",
        "Nga\u0300y"
      ]
    }) : /* @__PURE__ */ jsxRuntime.jsx(Countdown.Countdown, {
      due: endTime,
      showDays: false,
      showLabel: false,
      showHours: true,
      showMinutes: true,
      showSeconds: true,
      countdownType: "due",
      splitTimeUnit: /* @__PURE__ */ jsxRuntime.jsx(Row.Row, {
        align: "middle",
        children: ":"
      }),
      countdownStyle: {
        elementGap: 4,
        align: coreRenderer.Alignment.center,
        digitStyle
      }
    })
  });
};
const CountdownWrapper = styled__default["default"].div`
  display: flex;
  align-items: center;
  color: ${({ color }) => color || "black"};
  column-gap: 0.5rem;
  font-size: ${({ isMobile }) => isMobile ? "13px" : "18px"};
  font-weight: 500;
  margin-left: ${({ isMobile }) => isMobile ? "0" : "1rem"};
  margin-top: 4px;
`;
const RemainingDay = styled__default["default"].div`
  font-size: 1rem;
  color: white;
  text-align: center;
`;

exports.BlockCountdown = BlockCountdown;


/***/ }),

/***/ 545222:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var coreRenderer = __webpack_require__(85097);
var CountdownSkuListWithBannerDesktop = __webpack_require__(62928);
var grid = __webpack_require__(860046);
var Container = __webpack_require__(341018);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CountdownSkuListWithBanner = (_a) => {
  var _b = _a, { isEditingMode, ssrData, maxWidth } = _b, restProps = __objRest(_b, ["isEditingMode", "ssrData", "maxWidth"]);
  const { device } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(
    restProps,
    device
  ), { items, commonStyle } = _a2, restStyle = __objRest(_a2, ["items", "commonStyle"]);
  const _b2 = commonStyle, { padding, margin, borderRadius } = _b2, restCommonStyle = __objRest(_b2, ["padding", "margin", "borderRadius"]);
  const ContainerStyle = {
    padding,
    margin,
    borderRadius,
    maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH_1600
  };
  if (!isEditingMode && !(items == null ? void 0 : items.length))
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: ContainerStyle
  }, restStyle), {
    maxWidth: ContainerStyle.maxWidth,
    children: /* @__PURE__ */ jsxRuntime.jsx(CountdownSkuListWithBannerDesktop.CountdownSkuListWithBannerDesktop, __spreadValues({
      items: (items || []).map((el) => __spreadProps(__spreadValues({}, el), {
        id: el.id || coreRenderer.generateRandomId()
      })),
      ssrData,
      commonStyle: restCommonStyle,
      isEditingMode,
      maxWidth: ContainerStyle.maxWidth
    }, restStyle))
  }));
};
CountdownSkuListWithBanner.displayName = "Omni_CountdownSkuListWithBanner";

exports.CountdownSkuListWithBanner = CountdownSkuListWithBanner;


/***/ }),

/***/ 62928:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var styled = __webpack_require__(212951);
var icons = __webpack_require__(143599);
var coreRenderer = __webpack_require__(85097);
var hooks = __webpack_require__(644344);
var useMediaQuery = __webpack_require__(548834);
var constants = __webpack_require__(667664);
var Countdown = __webpack_require__(731824);
var renderDynamicSlot = __webpack_require__(958220);
var getStyles = __webpack_require__(934512);
var renderLink = __webpack_require__(284727);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CountdownSkuListWithBannerDesktop = (_a) => {
  var _b = _a, {
    items,
    ssrData,
    isEditingMode,
    commonStyle,
    titleStyle,
    viewMoreStyle,
    activeTabStyle,
    banners,
    radius = constants.DEFAULT_RADIUS,
    countDownStyle,
    maxWidth
  } = _b, restProps = __objRest(_b, [
    "items",
    "ssrData",
    "isEditingMode",
    "commonStyle",
    "titleStyle",
    "viewMoreStyle",
    "activeTabStyle",
    "banners",
    "radius",
    "countDownStyle",
    "maxWidth"
  ]);
  var _b2, _c, _d;
  const _a2 = commonStyle, { background, backgroundImage } = _a2, restCommonStyle = __objRest(_a2, ["background", "backgroundImage"]);
  const { activeTab, setActiveTab, validItems, displayItem } = hooks.useCountdownSkuList(items, isEditingMode);
  const { viewMoreUrl, timeVisibility } = displayItem || {};
  const isMobile = useMediaQuery.useMediaQuery("(max-width: 768px)");
  const activeTabIndex = items.findIndex((tab) => tab.id === activeTab) || 0;
  const renderViewAllLink = () => {
    const content = /* @__PURE__ */ jsxRuntime.jsxs(ViewMore, {
      commonStyle: viewMoreStyle,
      children: [
        "Xem t\u1EA5t c\u1EA3 ",
        /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
          name: "RightOutlined"
        })
      ]
    });
    return renderLink.renderLink(displayItem == null ? void 0 : displayItem.collectionSlug, content, isEditingMode);
  };
  const { mappingDynamicSlots, device } = coreRenderer.useStore();
  const blockCountdownVisibility = (_c = (_b2 = items == null ? void 0 : items[activeTabIndex]) == null ? void 0 : _b2.isDisplayCountdown) != null ? _c : constants.DEFAULT_COUNTDOWN_BLOCK_VISIBILITY;
  const blockCountDownStartTime = timeVisibility == null ? void 0 : timeVisibility.startTime;
  const blockCountdownEndTime = timeVisibility == null ? void 0 : timeVisibility.endTime;
  const showCountdownBlock = React.useMemo(() => {
    const currentTime = new Date();
    return !!blockCountdownVisibility && !!blockCountDownStartTime && !!blockCountdownEndTime && currentTime >= new Date(blockCountDownStartTime) && currentTime <= new Date(blockCountdownEndTime);
  }, [
    blockCountdownVisibility,
    blockCountDownStartTime,
    blockCountdownEndTime
  ]);
  if (!isEditingMode && !(validItems == null ? void 0 : validItems.length))
    return null;
  const hasBanner = banners && banners.length > 0;
  const innerProductWrapperRadius = radius - constants.PRODUCT_WRAPPER_PADDING;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    radius,
    children: /* @__PURE__ */ jsxRuntime.jsxs(Container, __spreadProps(__spreadValues({}, restProps), {
      children: [
        (isEditingMode || !isEditingMode && hasBanner) && /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
          isEditingMode,
          src: hasBanner ? (_d = banners[0]) == null ? void 0 : _d.src : "https://lh3.googleusercontent.com/5j_eWpVbAWOPHpd5RCylcaFR6cg0bFFDjFqYnh0ASIsEJScCiLfafyAI6lkToXn-ihjJEQCkWSX-pW2C-7ZW6qxwJhsGcY8",
          alt: "Image",
          commonStyle: { objectFit: "contain", width: "100%" }
        }),
        /* @__PURE__ */ jsxRuntime.jsxs("div", {
          style: {
            backgroundColor: typeof background === "string" ? background : "#010076",
            backgroundImage,
            padding: constants.PRODUCT_WRAPPER_PADDING,
            borderRadius: hasBanner ? 0 : `${radius}px ${radius}px 0 0`
          },
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(HeaderWrapper, {
              radius: innerProductWrapperRadius >= 0 ? innerProductWrapperRadius : 0,
              children: validItems.map((tab, index) => {
                return /* @__PURE__ */ jsxRuntime.jsxs(TabHeader, __spreadProps(__spreadValues({
                  onClick: () => setActiveTab(tab.id),
                  className: `${activeTab === tab.id ? "active " : ""}`
                }, coreRenderer.getTrackingData({
                  isTrackContent: true,
                  regionName: "countdownSkuListWithBanner",
                  contentName: tab.title
                })), {
                  commonStyle: __spreadValues(__spreadValues({}, activeTabStyle), titleStyle),
                  isMobile: device === "mobile" || isMobile,
                  numberOfItems: validItems.length,
                  children: [
                    /* @__PURE__ */ jsxRuntime.jsx(TabTitle, {
                      children: tab.title
                    }),
                    /* @__PURE__ */ jsxRuntime.jsx(TabDescription, {
                      children: tab.description
                    })
                  ]
                }), index);
              })
            }),
            /* @__PURE__ */ jsxRuntime.jsxs(TabContainer, {
              commonStyle: __spreadProps(__spreadValues({}, restCommonStyle), { backgroundColor: "white" }),
              radius: innerProductWrapperRadius >= 0 ? innerProductWrapperRadius : 0,
              children: [
                (!!viewMoreUrl || !!showCountdownBlock) && /* @__PURE__ */ jsxRuntime.jsxs(StyledRow, {
                  justify: !!showCountdownBlock ? "space-between" : "flex-end",
                  children: [
                    !!showCountdownBlock && /* @__PURE__ */ jsxRuntime.jsx(Countdown.BlockCountdown, {
                      endTime: blockCountdownEndTime,
                      isMobile,
                      countDownStyle
                    }),
                    !!viewMoreUrl ? /* @__PURE__ */ jsxRuntime.jsx(ViewAllLinkWrapper, {
                      hasPaddingTop: !showCountdownBlock,
                      children: renderViewAllLink()
                    }) : null
                  ]
                }),
                /* @__PURE__ */ jsxRuntime.jsx(TabContent, {
                  children: /* @__PURE__ */ jsxRuntime.jsx(ProductWrapper, {
                    style: { minHeight: 300 },
                    children: renderDynamicSlot.renderDynamicSlot(
                      `new_layout_product_carousel_${device}`,
                      mappingDynamicSlots,
                      validItems.findIndex((el) => el.id === activeTab) === 0 ? ssrData : void 0,
                      {
                        collectionSlug: displayItem == null ? void 0 : displayItem.collectionSlug,
                        config: { maxWidth }
                      }
                    )
                  }, activeTab)
                })
              ]
            })
          ]
        })
      ]
    }))
  });
};
const Wrapper = styled__default["default"].div(
  ({ radius }) => `
  position: relative;
  overflow: hidden;
  border-radius: ${radius}px;
`
);
const Container = styled__default["default"].div`
  z-index: 1;
  background: none;
  position: relative;
`;
const HeaderWrapper = styled__default["default"].div(
  ({ radius }) => `
  display: flex;
  flex-direction: row;
  flex-wrap: no-wrap;
  border-radius: ${radius}px ${radius}px 0 0;
  background: white;
  border-bottom: 2px solid #e8e8e8;
  overflow-x: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  -webkit-overflow-scrolling: touch;
`
);
const TabHeader = styled__default["default"].div(
  ({
    commonStyle,
    isMobile,
    numberOfItems
  }) => `
color: ${(commonStyle == null ? void 0 : commonStyle.color) || "#000"};
flex: ${isMobile ? "0 0 calc(95% / 2.5)" : numberOfItems <= 7 ? "0 0 calc(95% / 7.2)" : "1 1 0%"};
padding: 12px 4px;
position: relative;
overflow: hidden;
background: white;
text-align: center;
align-content: center;
&:hover {
  cursor: pointer;
}
&.active {
  color: ${commonStyle == null ? void 0 : commonStyle.activeColor};
  background: ${commonStyle == null ? void 0 : commonStyle.backgroundColor};
  border-bottom: 2px solid ${commonStyle == null ? void 0 : commonStyle.activeColor};
}
`
);
const TabTitle = styled__default["default"].div(
  () => `
  white-space: pre-line;
  color: inherit;
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
  text-transform: uppercase;
  &:hover {
    cursor: pointer;
  }
`
);
const TabDescription = styled__default["default"].div(
  () => `
  color: inherit;
  font-weight: 500;
  text-decoration: unset;
  font-size: 10px;
  line-height: 16px;
  &:hover {
    cursor: pointer;
  }
`
);
const TabContainer = styled__default["default"].div(
  ({ commonStyle, radius }) => `
position: relative;
border-radius: 0 0 ${radius}px ${radius}px;
${getStyles.getStyle(commonStyle)}
`
);
const TabContent = styled__default["default"].div(
  ({ commonStyle }) => `
display: flex;
flex: row nowrap;
${getStyles.getStyle(commonStyle)}
`
);
const ProductWrapper = styled__default["default"].div`
  flex: 100%;
  max-width: 100%;
  padding: 0px 8px;
`;
const ViewAllLinkWrapper = styled__default["default"].div(
  ({ hasPaddingTop }) => `
  color: white;
  padding: ${hasPaddingTop ? "1rem" : "0"} 1rem 0 0;
`
);
const ViewMore = styled__default["default"].span(
  ({ commonStyle }) => `
  display: flex;
  align-items: center;
  ${getStyles.getStyle(commonStyle)}
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
`
);
const StyledRow = styled__default["default"].div`
  display: flex;
  justify-content: ${({ justify }) => justify || "flex-end"};
  align-items: center;
  padding: 0 !important;
  margin: 0 !important;
  flex-wrap: nowrap;
`;

exports.CountdownSkuListWithBannerDesktop = CountdownSkuListWithBannerDesktop;


/***/ }),

/***/ 644344:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(85097);
var React = __webpack_require__(891987);

const useCountdownSkuList = (items, isEditingMode = false) => {
  var _a;
  const { displayItems: validItems } = coreRenderer.useTimeVisibility(items, isEditingMode);
  const [activeTab, setActiveTab] = React.useState((_a = validItems == null ? void 0 : validItems[0]) == null ? void 0 : _a.id);
  const displayItem = React.useMemo(() => {
    return validItems == null ? void 0 : validItems.find((el) => el.id === activeTab);
  }, [validItems, activeTab]);
  React.useEffect(() => {
    var _a2;
    if (isEditingMode) {
      setActiveTab((_a2 = validItems == null ? void 0 : validItems[0]) == null ? void 0 : _a2.id);
    }
  }, [items == null ? void 0 : items.length, isEditingMode]);
  return {
    activeTab,
    setActiveTab,
    validItems,
    displayItem
  };
};

exports.useCountdownSkuList = useCountdownSkuList;


/***/ }),

/***/ 649336:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var getISODateBackward = __webpack_require__(177725);
var Countdown = __webpack_require__(283980);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const CountdownDesktop = ({
  endTime
}) => {
  const finalDue = getISODateBackward.getISODateBackward(endTime);
  const timer = coreRenderer.useTimer(new Date(finalDue));
  return /* @__PURE__ */ jsxRuntime.jsxs(CountdownWrapper, {
    children: [
      !!(timer == null ? void 0 : timer.days) && /* @__PURE__ */ jsxRuntime.jsxs(RemainingDay, {
        children: [
          "K\u1EBFt th\xFAc sau",
          " ",
          /* @__PURE__ */ jsxRuntime.jsx("span", {
            style: { fontSize: "1.3rem", fontWeight: "600" },
            children: timer.days
          }),
          " ",
          "ng\xE0y"
        ]
      }),
      /* @__PURE__ */ jsxRuntime.jsx(Countdown.Countdown, {
        due: endTime,
        showDays: false,
        showLabel: false,
        showHours: true,
        showMinutes: true,
        showSeconds: true,
        countdownType: "due",
        countdownStyle: {
          elementGap: 16,
          align: coreRenderer.Alignment.center,
          digitStyle: {
            width: 45,
            height: 45,
            fontSize: "20px",
            fontWeight: "bold",
            textAlign: "center",
            alignItems: "center",
            lineHeight: 45,
            color: "white",
            background: "linear-gradient(rgb(74, 74, 74),rgb(35, 34, 34))",
            borderRadius: 5
          }
        }
      })
    ]
  });
};
const CountdownWrapper = styled__default["default"].div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  flex: 16.66%;
`;
const RemainingDay = styled__default["default"].p`
  font-size: 1rem;
  color: white;
  text-align: center;
`;

exports.CountdownDesktop = CountdownDesktop;


/***/ }),

/***/ 367395:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var getISODateBackward = __webpack_require__(177725);
var Countdown = __webpack_require__(283980);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const CountdownMobile = ({
  endTime
}) => {
  const finalDue = getISODateBackward.getISODateBackward(endTime);
  const timer = coreRenderer.useTimer(new Date(finalDue));
  return /* @__PURE__ */ jsxRuntime.jsx(CountdownWrapper, {
    children: !!timer && /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
      children: (timer == null ? void 0 : timer.days) > 1 ? /* @__PURE__ */ jsxRuntime.jsxs(StyledText, {
        children: [
          "C\xF2n ",
          timer.days,
          " ng\xE0y"
        ]
      }) : /* @__PURE__ */ jsxRuntime.jsx(Countdown.Countdown, {
        due: endTime,
        showDays: false,
        showLabel: false,
        showHours: true,
        showMinutes: true,
        showSeconds: true,
        countdownType: "due",
        countdownStyle: {
          elementGap: 3,
          align: coreRenderer.Alignment.center,
          timeUnitStyle: { fontSize: "10px" }
        },
        splitTimeUnit: /* @__PURE__ */ jsxRuntime.jsx("span", {
          style: { fontSize: "10px" },
          children: " : "
        }),
        commonStyle: {
          backgroundColor: "white",
          color: "rgb(20, 115, 204)",
          borderRadius: "4px",
          padding: {
            top: 2,
            bottom: 2,
            left: 8,
            right: 8,
            unit: coreRenderer.UnitEnum.pixel
          }
        }
      })
    })
  });
};
const CountdownWrapper = styled__default["default"].div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
`;
const StyledText = styled__default["default"].div`
  color: rgb(20, 115, 204);
  background-color: white;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 10px;
`;

exports.CountdownMobile = CountdownMobile;


/***/ }),

/***/ 271193:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var coreRenderer = __webpack_require__(85097);
var CountdownSkuListDesktop = __webpack_require__(549467);
var CountdownSkuListMobile = __webpack_require__(320261);
var grid = __webpack_require__(860046);
var Container = __webpack_require__(341018);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CountdownSkuList = (_a) => {
  var _b = _a, {
    isEditingMode,
    ssrData
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "ssrData"
  ]);
  const { device } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(
    restProps,
    device
  ), { items, commonStyle } = _a2, restStyle = __objRest(_a2, ["items", "commonStyle"]);
  const _b2 = commonStyle, { padding, margin, borderRadius } = _b2, restCommonStyle = __objRest(_b2, ["padding", "margin", "borderRadius"]);
  const ContainerStyle = {
    padding,
    margin,
    borderRadius,
    maxWidth: grid.DEFAULT_MAX_WIDTH
  };
  if (!isEditingMode && !(items == null ? void 0 : items.length))
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, {
    commonStyle: ContainerStyle,
    children: device === "desktop" ? /* @__PURE__ */ jsxRuntime.jsx(CountdownSkuListDesktop.CountdownSkuListDesktop, __spreadValues({
      items: (items || []).map((el) => __spreadProps(__spreadValues({}, el), {
        id: el.id || coreRenderer.generateRandomId()
      })),
      ssrData,
      commonStyle: restCommonStyle,
      isEditingMode
    }, restStyle)) : /* @__PURE__ */ jsxRuntime.jsx(CountdownSkuListMobile.CountdownSkuListMobile, __spreadValues({
      items: (items || []).map((el) => __spreadProps(__spreadValues({}, el), {
        id: el.id || coreRenderer.generateRandomId()
      })),
      ssrData,
      isEditingMode,
      commonStyle
    }, restStyle))
  });
};
CountdownSkuList.displayName = "Omni_CountdownSkuList";

exports.CountdownSkuList = CountdownSkuList;


/***/ }),

/***/ 549467:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var icons = __webpack_require__(143599);
var coreRenderer = __webpack_require__(85097);
var helper = __webpack_require__(945660);
var hooks = __webpack_require__(798910);
var CountdownDesktop = __webpack_require__(649336);
var renderDynamicSlot = __webpack_require__(958220);
var getStyles = __webpack_require__(934512);
var renderLink = __webpack_require__(284727);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const CountdownSkuListDesktop = ({
  items,
  ssrData,
  isEditingMode,
  commonStyle,
  titleStyle,
  viewMoreStyle,
  activeTabStyle
}) => {
  const { activeTab, setActiveTab, validItems, displayItem } = hooks.useCountdownSkuList(items, isEditingMode);
  const renderViewAllLink = () => {
    const content = /* @__PURE__ */ jsxRuntime.jsxs(ViewMore, {
      commonStyle: viewMoreStyle,
      children: [
        "Xem t\u1EA5t c\u1EA3 ",
        /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
          name: "RightOutlined"
        })
      ]
    });
    return renderLink.renderLink(displayItem == null ? void 0 : displayItem.collectionSlug, content, isEditingMode);
  };
  const { mappingDynamicSlots } = coreRenderer.useStore();
  if (!isEditingMode && !(validItems == null ? void 0 : validItems.length))
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Container, {
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(HeaderWrapper, {
          children: validItems.map((tab, index) => {
            return /* @__PURE__ */ jsxRuntime.jsxs(TabHeader, __spreadProps(__spreadValues({
              onClick: () => setActiveTab(tab.id),
              className: `${activeTab === tab.id ? "active " : ""}`
            }, coreRenderer.getTrackingData({
              isTrackContent: true,
              regionName: "hotDealTab",
              contentName: tab.title
            })), {
              commonStyle: __spreadValues(__spreadValues({}, activeTabStyle), titleStyle),
              children: [
                /* @__PURE__ */ jsxRuntime.jsx(TabTitle, {
                  children: tab.title
                }),
                /* @__PURE__ */ jsxRuntime.jsx(TabDescription, {
                  children: tab.description
                })
              ]
            }), index);
          })
        }),
        /* @__PURE__ */ jsxRuntime.jsxs(TabContainer, {
          commonStyle: __spreadProps(__spreadValues({}, commonStyle), { backgroundColor: "#cecece" }),
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(ViewAllLinkWrapper, {
              children: renderViewAllLink()
            }),
            /* @__PURE__ */ jsxRuntime.jsxs(TabContent, {
              children: [
                /* @__PURE__ */ jsxRuntime.jsx(CountdownDesktop.CountdownDesktop, {
                  endTime: helper.getEndTimeByTimeVisibility(displayItem == null ? void 0 : displayItem.timeVisibility)
                }),
                /* @__PURE__ */ jsxRuntime.jsx(ProductWrapper, {
                  style: { minHeight: 300 },
                  children: renderDynamicSlot.renderDynamicSlot(
                    "product_carousel_desktop",
                    mappingDynamicSlots,
                    validItems.findIndex((el) => el.id === activeTab) === 0 ? ssrData : void 0,
                    {
                      collectionSlug: displayItem == null ? void 0 : displayItem.collectionSlug,
                      config: {
                        regionName: "hotDeal"
                      }
                    }
                  )
                }, activeTab)
              ]
            })
          ]
        })
      ]
    })
  });
};
const Wrapper = styled__default["default"].div`
  position: relative;
  overflow: hidden;
  border-radius: 8px;
`;
const Container = styled__default["default"].div`
  z-index: 1;
  background: none;
  position: relative;
`;
const HeaderWrapper = styled__default["default"].div`
  display: flex;
  flex-direction: row;
  flex-wrap: no-wrap;
  border-radius: 8px 8px 0 0;
`;
const TabHeader = styled__default["default"].div(
  ({ commonStyle }) => `
color: ${commonStyle == null ? void 0 : commonStyle.color};
flex: 1 1 0%;
padding: 0.25rem 0;
position: relative;
overflow: hidden;
background: white;
text-align: center;
&:hover {
  cursor: pointer;
}
&.active {
  color: #fff;
  background: ${commonStyle == null ? void 0 : commonStyle.backgroundColor};
  &:before {
    content: '';
    width: 0px;
    height: 0px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid white;
    position: absolute;
    left: -5px;
    top: 0px;
  }
  &:after {
    content: '';
    width: 0px;
    height: 0px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid white;
    position: absolute;
    right: -5px;
    top: 0px;
    z-index: 0;
  }
}
`
);
const TabTitle = styled__default["default"].div`
  color: inherit;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  text-transform: uppercase;
  &:hover {
    cursor: pointer;
  }
`;
const TabDescription = styled__default["default"].div`
  color: inherit;
  font-weight: 500;
  text-decoration: unset;
  font-size: 13px;
  line-height: 24px;
  &:hover {
    cursor: pointer;
  }
`;
const TabContainer = styled__default["default"].div(
  ({ commonStyle }) => `
position: relative;
${getStyles.getStyle(commonStyle)}
`
);
const TabContent = styled__default["default"].div(
  ({ commonStyle }) => `
display: flex;
flex: row nowrap;
${getStyles.getStyle(commonStyle)}
`
);
const ProductWrapper = styled__default["default"].div`
  flex: 83.33%;
  max-width: 83.33%;
  padding: 16px 8px;
`;
const ViewAllLinkWrapper = styled__default["default"].div`
  color: white;
  display: flex;
  justify-content: flex-end;
  padding: 1rem 1rem 0 0;
`;
const ViewMore = styled__default["default"].span(
  ({ commonStyle }) => `
  display: flex;
  align-items: center;
  ${getStyles.getStyle(commonStyle)}
`
);

exports.CountdownSkuListDesktop = CountdownSkuListDesktop;


/***/ }),

/***/ 320261:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var icons = __webpack_require__(143599);
var coreRenderer = __webpack_require__(85097);
var helper = __webpack_require__(945660);
var hooks = __webpack_require__(798910);
var CountdownMobile = __webpack_require__(367395);
var renderDynamicSlot = __webpack_require__(958220);
var getStyles = __webpack_require__(934512);
var renderLink = __webpack_require__(284727);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const CountdownSkuListMobile = ({
  items,
  ssrData,
  isEditingMode,
  commonStyle,
  titleStyle,
  viewMoreStyle,
  activeTabStyle
}) => {
  const { activeTab, setActiveTab, validItems, displayItem } = hooks.useCountdownSkuList(items, isEditingMode);
  const { mappingDynamicSlots } = coreRenderer.useStore();
  const renderViewAllLink = () => {
    const content = /* @__PURE__ */ jsxRuntime.jsxs(ViewMore, {
      commonStyle: viewMoreStyle,
      children: [
        "Xem t\u1EA5t c\u1EA3 ",
        /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
          name: "RightOutlined"
        })
      ]
    });
    return renderLink.renderLink(displayItem == null ? void 0 : displayItem.collectionSlug, content, isEditingMode);
  };
  if (!isEditingMode && !(validItems == null ? void 0 : validItems.length))
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Container, {
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(HeaderWrapper, {
          children: validItems.map((tab, index) => {
            const isActive = activeTab === tab.id;
            return /* @__PURE__ */ jsxRuntime.jsxs(TabHeader, __spreadProps(__spreadValues({
              onClick: () => setActiveTab(tab.id),
              className: `${isActive ? "active" : ""}`
            }, coreRenderer.getTrackingData({
              isTrackContent: true,
              regionName: "hotDealTab",
              contentName: tab.title
            })), {
              commonStyle: __spreadValues(__spreadValues({}, activeTabStyle), titleStyle),
              children: [
                /* @__PURE__ */ jsxRuntime.jsx(TabTitle, {
                  className: `${isActive ? "active" : ""}`,
                  children: tab.title
                }),
                /* @__PURE__ */ jsxRuntime.jsx(TabDescription, {
                  className: `${isActive ? "active" : ""}`,
                  children: tab.description
                }),
                isActive && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
                  children: [
                    /* @__PURE__ */ jsxRuntime.jsx(CountdownMobile.CountdownMobile, {
                      endTime: helper.getEndTimeByTimeVisibility(
                        displayItem == null ? void 0 : displayItem.timeVisibility
                      )
                    }),
                    /* @__PURE__ */ jsxRuntime.jsx(ActiveArrow, {
                      commonStyle: activeTabStyle
                    })
                  ]
                })
              ]
            }), index);
          })
        }),
        /* @__PURE__ */ jsxRuntime.jsxs(TabContent, {
          commonStyle,
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(ViewAllLinkWrapper, {
              children: renderViewAllLink()
            }),
            /* @__PURE__ */ jsxRuntime.jsx(ProductWrapper, {
              children: renderDynamicSlot.renderDynamicSlot(
                "product_carousel_mobile",
                mappingDynamicSlots,
                validItems.findIndex((el) => el.id === activeTab) === 0 ? ssrData : void 0,
                {
                  collectionSlug: displayItem == null ? void 0 : displayItem.collectionSlug,
                  config: {
                    regionName: "hotDeal"
                  }
                }
              )
            }, activeTab)
          ]
        })
      ]
    })
  });
};
const Wrapper = styled__default["default"].div`
  position: relative;
  margin-bottom: 0.5rem;
`;
const Container = styled__default["default"].div(
  ({ commonStyle }) => `
  position: relative;
  ${getStyles.getStyle(commonStyle)}
`
);
const HeaderWrapper = styled__default["default"].div`
  display: flex;
  flex-direction: row;
  flex-wrap: no-wrap;
  justify-content: flex-start;
  column-gap: 0.5rem;
  height: 96px;
  position: relative;
  z-index: 2;
  margin-left: 1rem;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
`;
const TabHeader = styled__default["default"].div(
  ({ commonStyle }) => `
  color: ${commonStyle == null ? void 0 : commonStyle.color};
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 84px;
  min-width: 84px;
  padding: 0.25rem;
  position: relative;
  background: white;
  text-align: center;
  border-radius: 8px;
  border: 1px solid rgb(228, 229, 240);
  &:hover {
    cursor: pointer;
  }
  &.active {
    color: #fff;
    background: ${commonStyle == null ? void 0 : commonStyle.backgroundColor};
    color: white;
    transition: all 0.2s ease-in-out 0s;
    border-style: none;
  }
`
);
const TabTitle = styled__default["default"].div`
  color: inherit;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  &:hover {
    cursor: pointer;
  }
  &.active {
    transition: color 0.3s ease 0s;
  }
`;
const TabDescription = styled__default["default"].div`
  color: inherit;
  text-decoration: unset;
  font-size: 10px;
  line-height: 16px;
  margin-bottom: 0.25rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;

  &:hover {
    cursor: pointer;
  }
  &.active {
    transition: color 0.3s ease 0s;
  }
`;
const TabContent = styled__default["default"].div(
  ({ commonStyle }) => `
  margin-top: -36px;
  margin-bottom: 8px;
  padding: 16px 8px;
  position: relative;
  background-color: #cecece;
  ${getStyles.getStyle(commonStyle)}
`
);
const ProductWrapper = styled__default["default"].div`
  flex-grow: 1;
  width: 100%;
`;
const ViewAllLinkWrapper = styled__default["default"].div`
  color: white;
  display: flex;
  justify-content: flex-end;
  padding: 32px 16px;
`;
const ActiveArrow = styled__default["default"].div(
  ({ commonStyle }) => `
  width: 10px;
  height: 10px;
  transform: rotate(45deg);
  position: absolute;
  bottom: -5px;
  background: ${commonStyle == null ? void 0 : commonStyle.backgroundColor};
  transition: all 0.2s ease-in-out 0s;
`
);
const ViewMore = styled__default["default"].span(
  ({ commonStyle }) => `
  display: flex;
  align-items: center;
  ${getStyles.getStyle(commonStyle)}
`
);

exports.ActiveArrow = ActiveArrow;
exports.Container = Container;
exports.CountdownSkuListMobile = CountdownSkuListMobile;
exports.HeaderWrapper = HeaderWrapper;
exports.ProductWrapper = ProductWrapper;
exports.TabContent = TabContent;
exports.TabDescription = TabDescription;
exports.TabHeader = TabHeader;
exports.TabTitle = TabTitle;
exports.ViewAllLinkWrapper = ViewAllLinkWrapper;
exports.ViewMore = ViewMore;
exports.Wrapper = Wrapper;


/***/ }),

/***/ 945660:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(85097);

const getEndTimeByTimeVisibility = (timeVisibility) => {
  var _a, _b;
  if (!timeVisibility)
    return "";
  const { endTime, ruleRepeat, duration } = timeVisibility;
  if (!ruleRepeat)
    return "";
  try {
    const frequently = coreRenderer.parseRuleRepeat(coreRenderer.RuleRepeatEnum.FREQ, ruleRepeat);
    const currentDate = new Date();
    if (frequently === coreRenderer.UnitRepeatEnum.DURATION)
      return endTime;
    const [, endMinute] = duration;
    const hour = Math.floor(endMinute / 60);
    const minute = endMinute % 60;
    if (frequently === coreRenderer.UnitRepeatEnum.DAY) {
      currentDate.setHours(hour);
      currentDate.setMinutes(minute);
      return currentDate.toISOString();
    }
    if (frequently === coreRenderer.UnitRepeatEnum.WEEK) {
      const availableDays = (_b = (_a = coreRenderer.parseRuleRepeat(coreRenderer.RuleRepeatEnum.BYDAY, ruleRepeat)) == null ? void 0 : _a.split) == null ? void 0 : _b.call(_a, ",").map((i) => parseInt(i));
      const nextWeekAvailableDays = availableDays.map((i) => i + 7);
      const checkArr = [...availableDays, ...nextWeekAvailableDays].sort(
        (a, b) => a - b
      );
      const dayOfWeek = currentDate.getDay();
      const day = checkArr.find((d) => d >= dayOfWeek);
      const interval = day - dayOfWeek;
      const newDate = new Date();
      newDate.setDate(currentDate.getDate() + interval);
      newDate.setHours(hour);
      newDate.setMinutes(minute);
      return newDate.toISOString();
    }
  } catch (e) {
    return "";
  }
};

exports.getEndTimeByTimeVisibility = getEndTimeByTimeVisibility;


/***/ }),

/***/ 798910:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(85097);
var React = __webpack_require__(891987);

const useCountdownSkuList = (items, isEditingMode = false) => {
  var _a;
  const { displayItems: validItems } = coreRenderer.useTimeVisibility(items, isEditingMode);
  const [activeTab, setActiveTab] = React.useState((_a = validItems == null ? void 0 : validItems[0]) == null ? void 0 : _a.id);
  const displayItem = React.useMemo(() => {
    return validItems == null ? void 0 : validItems.find((el) => el.id === activeTab);
  }, [validItems, activeTab]);
  React.useEffect(() => {
    var _a2;
    if (isEditingMode) {
      setActiveTab((_a2 = validItems == null ? void 0 : validItems[0]) == null ? void 0 : _a2.id);
    }
  }, [items == null ? void 0 : items.length, isEditingMode]);
  return {
    activeTab,
    setActiveTab,
    validItems,
    displayItem
  };
};

exports.useCountdownSkuList = useCountdownSkuList;


/***/ }),

/***/ 165092:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var uuid = __webpack_require__(596839);
var style = __webpack_require__(667925);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const DEFAULT_RADIUS = 16;
const PRODUCT_WRAPPER_PADDING = 8;
const DEFAULT_HAMPER_ITEMS_DATA = {
  items: [
    {
      title: "T\xCAN CH\u01AF\u01A0NG TR\xCCNH",
      description: "M\xF4 t\u1EA3/Th\u1EDDi gian di\u1EC5n ra",
      id: uuid.v4()
    },
    {
      title: "T\xCAN CH\u01AF\u01A0NG TR\xCCNH",
      description: "M\xF4 t\u1EA3/Th\u1EDDi gian di\u1EC5n ra",
      id: uuid.v4()
    },
    {
      title: "T\xCAN CH\u01AF\u01A0NG TR\xCCNH",
      description: "M\xF4 t\u1EA3/Th\u1EDDi gian di\u1EC5n ra",
      id: uuid.v4()
    },
    {
      title: "T\xCAN CH\u01AF\u01A0NG TR\xCCNH",
      description: "M\xF4 t\u1EA3/Th\u1EDDi gian di\u1EC5n ra",
      id: uuid.v4()
    }
  ]
};
const DEFAULT_HAMPER_ITEMS_STYLE = {
  commonStyle: {
    borderRadius: 8,
    bgImageWidth: 1600,
    bgImagePercent: 100,
    backgroundImage: "https://lh3.googleusercontent.com/n8WdU2aITBBDNRpw1OIBNADR2b_EsATsFkU42S-Kfftu8UictI8JsyKwOBjRkPT7u_BO1ILqcwRXn8xZG8TCP2jCLqwTSWQR"
  },
  titleStyle: {
    color: "#848788"
  },
  activeTabStyle: {
    backgroundColor: "#f2f2fb",
    tabBarColor: "#0200BC",
    activeColor: "#0200BC"
  },
  viewMoreStyle: {
    color: "#fff"
  },
  maxWidth: 1600
};
const DEFAULT_HAMPER_LIST = __spreadProps(__spreadValues({
  syncDeviceStyle: true
}, DEFAULT_HAMPER_ITEMS_DATA), {
  desktop: __spreadProps(__spreadValues({}, DEFAULT_HAMPER_ITEMS_STYLE), {
    commonStyle: __spreadValues(__spreadValues({}, DEFAULT_HAMPER_ITEMS_STYLE.commonStyle), style.DESKTOP_COMMON_STYLE)
  }),
  mobile: __spreadProps(__spreadValues({}, DEFAULT_HAMPER_ITEMS_STYLE), {
    commonStyle: __spreadValues(__spreadValues({}, DEFAULT_HAMPER_ITEMS_STYLE.commonStyle), style.MOBILE_COMMON_STYLE)
  }),
  radius: DEFAULT_RADIUS
});
const DEFAULT_COUNTDOWN_BLOCK_VISIBILITY = true;

exports.DEFAULT_COUNTDOWN_BLOCK_VISIBILITY = DEFAULT_COUNTDOWN_BLOCK_VISIBILITY;
exports.DEFAULT_HAMPER_LIST = DEFAULT_HAMPER_LIST;
exports.DEFAULT_RADIUS = DEFAULT_RADIUS;
exports.PRODUCT_WRAPPER_PADDING = PRODUCT_WRAPPER_PADDING;


/***/ }),

/***/ 135841:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var addPaddingNumber = __webpack_require__(996887);
var Countdown = __webpack_require__(283980);
var Row = __webpack_require__(346761);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const BlockCountdown = ({ endTime, isMobile, countDownStyle }) => {
  const timer = coreRenderer.useTimer(new Date(endTime || ""));
  if (!endTime) {
    return null;
  }
  const digitStyle = {
    width: isMobile ? "1.5rem" : "2.2rem",
    height: isMobile ? "1.5rem" : "2.2rem",
    fontSize: isMobile ? "12px" : "1rem",
    fontWeight: "bold",
    textAlign: "center",
    alignItems: "center",
    lineHeight: isMobile ? "1.5rem" : "2.2rem",
    color: (countDownStyle == null ? void 0 : countDownStyle.color) || "black",
    background: "linear-gradient(rgb(74, 74, 74),rgb(35, 34, 34))",
    borderRadius: 5
  };
  return /* @__PURE__ */ jsxRuntime.jsx(CountdownWrapper, {
    isMobile,
    color: countDownStyle == null ? void 0 : countDownStyle.color,
    children: !!(timer == null ? void 0 : timer.days) ? /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [
        "K\u1EBFt th\xFAc sau",
        /* @__PURE__ */ jsxRuntime.jsx(RemainingDay, {
          style: digitStyle,
          children: addPaddingNumber.addPaddingNumber(timer.days)
        }),
        " ",
        "Nga\u0300y"
      ]
    }) : /* @__PURE__ */ jsxRuntime.jsx(Countdown.Countdown, {
      due: endTime,
      showDays: false,
      showLabel: false,
      showHours: true,
      showMinutes: true,
      showSeconds: true,
      countdownType: "due",
      splitTimeUnit: /* @__PURE__ */ jsxRuntime.jsx(Row.Row, {
        align: "middle",
        children: ":"
      }),
      countdownStyle: {
        elementGap: 4,
        align: coreRenderer.Alignment.center,
        digitStyle
      }
    })
  });
};
const CountdownWrapper = styled__default["default"].div`
  display: flex;
  align-items: center;
  color: ${({ color }) => color || "black"};
  column-gap: 0.5rem;
  font-size: ${({ isMobile }) => isMobile ? "13px" : "18px"};
  font-weight: 500;
  margin-left: ${({ isMobile }) => isMobile ? "0" : "1rem"};
  margin-top: 4px;
`;
const RemainingDay = styled__default["default"].div`
  font-size: 1rem;
  color: white;
  text-align: center;
`;

exports.BlockCountdown = BlockCountdown;


/***/ }),

/***/ 388019:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var coreRenderer = __webpack_require__(85097);
var HamperListContent = __webpack_require__(774247);
var grid = __webpack_require__(860046);
var Container = __webpack_require__(341018);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const HamperList = (_a) => {
  var _b = _a, {
    isEditingMode,
    ssrData,
    maxWidth
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "ssrData",
    "maxWidth"
  ]);
  const { device } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(
    restProps,
    device
  ), { items, commonStyle } = _a2, restStyle = __objRest(_a2, ["items", "commonStyle"]);
  const _b2 = commonStyle, { padding, margin, borderRadius } = _b2, restCommonStyle = __objRest(_b2, ["padding", "margin", "borderRadius"]);
  const ContainerStyle = {
    padding,
    margin,
    borderRadius,
    maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH_1600
  };
  if (!isEditingMode && !(items == null ? void 0 : items.length))
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: ContainerStyle
  }, restStyle), {
    maxWidth: ContainerStyle.maxWidth,
    children: /* @__PURE__ */ jsxRuntime.jsx(HamperListContent.HamperListContent, __spreadValues({
      items: (items || []).map((el) => __spreadProps(__spreadValues({}, el), {
        id: el.id || coreRenderer.generateRandomId()
      })),
      ssrData,
      commonStyle: restCommonStyle,
      isEditingMode,
      maxWidth: ContainerStyle.maxWidth
    }, restStyle))
  }));
};
HamperList.displayName = "Omni_HamperList";

exports.HamperList = HamperList;


/***/ }),

/***/ 774247:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var styled = __webpack_require__(212951);
var icons = __webpack_require__(143599);
var coreRenderer = __webpack_require__(85097);
var hooks = __webpack_require__(807169);
var useMediaQuery = __webpack_require__(548834);
var constants = __webpack_require__(165092);
var Countdown = __webpack_require__(135841);
var renderDynamicSlot = __webpack_require__(958220);
var getStyles = __webpack_require__(934512);
var renderLink = __webpack_require__(284727);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const HamperListContent = (_a) => {
  var _b = _a, {
    items,
    ssrData,
    isEditingMode,
    commonStyle,
    titleStyle,
    viewMoreStyle,
    activeTabStyle,
    banners,
    radius = constants.DEFAULT_RADIUS,
    countDownStyle,
    maxWidth
  } = _b, restProps = __objRest(_b, [
    "items",
    "ssrData",
    "isEditingMode",
    "commonStyle",
    "titleStyle",
    "viewMoreStyle",
    "activeTabStyle",
    "banners",
    "radius",
    "countDownStyle",
    "maxWidth"
  ]);
  var _b2, _c, _d;
  const _a2 = commonStyle, { background, backgroundImage } = _a2, restCommonStyle = __objRest(_a2, ["background", "backgroundImage"]);
  const { activeTab, setActiveTab, validItems, displayItem } = hooks.useCountdownSkuList(items, isEditingMode);
  const { viewMoreUrl, timeVisibility } = displayItem || {};
  const isMobile = useMediaQuery.useMediaQuery("(max-width: 768px)");
  const activeTabIndex = items.findIndex((tab) => tab.id === activeTab) || 0;
  const renderViewAllLink = () => {
    const content = /* @__PURE__ */ jsxRuntime.jsxs(ViewMore, {
      commonStyle: viewMoreStyle,
      children: [
        "Xem t\u1EA5t c\u1EA3 ",
        /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
          name: "RightOutlined"
        })
      ]
    });
    return renderLink.renderLink(displayItem == null ? void 0 : displayItem.collectionSlug, content, isEditingMode);
  };
  const { mappingDynamicSlots, device } = coreRenderer.useStore();
  const blockCountdownVisibility = (_c = (_b2 = items == null ? void 0 : items[activeTabIndex]) == null ? void 0 : _b2.isDisplayCountdown) != null ? _c : constants.DEFAULT_COUNTDOWN_BLOCK_VISIBILITY;
  const blockCountDownStartTime = timeVisibility == null ? void 0 : timeVisibility.startTime;
  const blockCountdownEndTime = timeVisibility == null ? void 0 : timeVisibility.endTime;
  const showCountdownBlock = React.useMemo(() => {
    const currentTime = new Date();
    return !!blockCountdownVisibility && !!blockCountDownStartTime && !!blockCountdownEndTime && currentTime >= new Date(blockCountDownStartTime) && currentTime <= new Date(blockCountdownEndTime);
  }, [
    blockCountdownVisibility,
    blockCountDownStartTime,
    blockCountdownEndTime
  ]);
  if (!isEditingMode && !(validItems == null ? void 0 : validItems.length))
    return null;
  const hasBanner = banners && banners.length > 0;
  const innerProductWrapperRadius = radius - constants.PRODUCT_WRAPPER_PADDING;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    radius,
    children: /* @__PURE__ */ jsxRuntime.jsxs(Container, __spreadProps(__spreadValues({}, restProps), {
      children: [
        (isEditingMode || !isEditingMode && hasBanner) && /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
          isEditingMode,
          src: hasBanner ? (_d = banners[0]) == null ? void 0 : _d.src : "https://lh3.googleusercontent.com/5j_eWpVbAWOPHpd5RCylcaFR6cg0bFFDjFqYnh0ASIsEJScCiLfafyAI6lkToXn-ihjJEQCkWSX-pW2C-7ZW6qxwJhsGcY8",
          alt: "Image",
          commonStyle: { objectFit: "contain", width: "100%" }
        }),
        /* @__PURE__ */ jsxRuntime.jsxs("div", {
          style: {
            backgroundColor: typeof background === "string" ? background : "#010076",
            backgroundImage,
            padding: constants.PRODUCT_WRAPPER_PADDING,
            borderRadius: hasBanner ? 0 : `${radius}px ${radius}px 0 0`
          },
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(HeaderWrapper, {
              radius: innerProductWrapperRadius >= 0 ? innerProductWrapperRadius : 0,
              children: validItems.map((tab, index) => {
                return /* @__PURE__ */ jsxRuntime.jsxs(TabHeader, __spreadProps(__spreadValues({
                  onClick: () => setActiveTab(tab.id),
                  className: `${activeTab === tab.id ? "active " : ""}`
                }, coreRenderer.getTrackingData({
                  isTrackContent: true,
                  regionName: "countdownSkuListWithBanner",
                  contentName: tab.title
                })), {
                  commonStyle: __spreadValues(__spreadValues({}, activeTabStyle), titleStyle),
                  isMobile: device === "mobile" || isMobile,
                  numberOfItems: validItems.length,
                  children: [
                    /* @__PURE__ */ jsxRuntime.jsx(TabTitle, {
                      children: tab.title
                    }),
                    /* @__PURE__ */ jsxRuntime.jsx(TabDescription, {
                      children: tab.description
                    })
                  ]
                }), index);
              })
            }),
            /* @__PURE__ */ jsxRuntime.jsxs(TabContainer, {
              commonStyle: __spreadProps(__spreadValues({}, restCommonStyle), { backgroundColor: "white" }),
              radius: innerProductWrapperRadius >= 0 ? innerProductWrapperRadius : 0,
              children: [
                (!!viewMoreUrl || !!showCountdownBlock) && /* @__PURE__ */ jsxRuntime.jsxs(StyledRow, {
                  justify: !!showCountdownBlock ? "space-between" : "flex-end",
                  children: [
                    !!showCountdownBlock && /* @__PURE__ */ jsxRuntime.jsx(Countdown.BlockCountdown, {
                      endTime: blockCountdownEndTime,
                      isMobile,
                      countDownStyle
                    }),
                    !!viewMoreUrl ? /* @__PURE__ */ jsxRuntime.jsx(ViewAllLinkWrapper, {
                      hasPaddingTop: !showCountdownBlock,
                      children: renderViewAllLink()
                    }) : null
                  ]
                }),
                /* @__PURE__ */ jsxRuntime.jsx(TabContent, {
                  children: /* @__PURE__ */ jsxRuntime.jsx(ProductWrapper, {
                    style: { minHeight: 300 },
                    children: renderDynamicSlot.renderDynamicSlot(
                      `hamper_carousel_${device}`,
                      mappingDynamicSlots,
                      validItems.findIndex((el) => el.id === activeTab) === 0 ? ssrData : void 0,
                      {
                        collectionSlug: displayItem == null ? void 0 : displayItem.collectionSlug,
                        config: { maxWidth },
                        byPassCheckStock: true
                      }
                    )
                  }, activeTab)
                })
              ]
            })
          ]
        })
      ]
    }))
  });
};
const Wrapper = styled__default["default"].div(
  ({ radius }) => `
  position: relative;
  overflow: hidden;
  border-radius: ${radius}px;
`
);
const Container = styled__default["default"].div`
  z-index: 1;
  background: none;
  position: relative;
`;
const HeaderWrapper = styled__default["default"].div(
  ({ radius }) => `
  display: flex;
  flex-direction: row;
  flex-wrap: no-wrap;
  border-radius: ${radius}px ${radius}px 0 0;
  background: white;
  border-bottom: 2px solid #e8e8e8;
  overflow-x: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  -webkit-overflow-scrolling: touch;
`
);
const TabHeader = styled__default["default"].div(
  ({
    commonStyle,
    isMobile,
    numberOfItems
  }) => `
color: ${(commonStyle == null ? void 0 : commonStyle.color) || "#000"};
flex: ${isMobile ? "0 0 calc(95% / 2.5)" : numberOfItems <= 7 ? "0 0 calc(95% / 7.2)" : "1 1 0%"};
padding: 12px 4px;
position: relative;
overflow: hidden;
background: white;
text-align: center;
align-content: center;
&:hover {
  cursor: pointer;
}
&.active {
  color: ${commonStyle == null ? void 0 : commonStyle.activeColor};
  background: ${commonStyle == null ? void 0 : commonStyle.backgroundColor};
  border-bottom: 2px solid ${commonStyle == null ? void 0 : commonStyle.activeColor};
}
`
);
const TabTitle = styled__default["default"].div(
  () => `
  white-space: pre-line;
  color: inherit;
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
  text-transform: uppercase;
  &:hover {
    cursor: pointer;
  }
`
);
const TabDescription = styled__default["default"].div(
  () => `
  color: inherit;
  font-weight: 500;
  text-decoration: unset;
  font-size: 10px;
  line-height: 16px;
  &:hover {
    cursor: pointer;
  }
`
);
const TabContainer = styled__default["default"].div(
  ({ commonStyle, radius }) => `
position: relative;
border-radius: 0 0 ${radius}px ${radius}px;
${getStyles.getStyle(commonStyle)}
`
);
const TabContent = styled__default["default"].div(
  ({ commonStyle }) => `
display: flex;
flex: row nowrap;
${getStyles.getStyle(commonStyle)}
`
);
const ProductWrapper = styled__default["default"].div`
  flex: 100%;
  max-width: 100%;
  padding: 0px 8px;
`;
const ViewAllLinkWrapper = styled__default["default"].div(
  ({ hasPaddingTop }) => `
  color: white;
  padding: ${hasPaddingTop ? "1rem" : "0"} 1rem 0 0;
`
);
const ViewMore = styled__default["default"].span(
  ({ commonStyle }) => `
  display: flex;
  align-items: center;
  ${getStyles.getStyle(commonStyle)}
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
`
);
const StyledRow = styled__default["default"].div`
  display: flex;
  justify-content: ${({ justify }) => justify || "flex-end"};
  align-items: center;
  padding: 0 !important;
  margin: 0 !important;
  flex-wrap: nowrap;
`;

exports.HamperListContent = HamperListContent;


/***/ }),

/***/ 807169:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(85097);
var React = __webpack_require__(891987);

const useCountdownSkuList = (items, isEditingMode = false) => {
  var _a;
  const { displayItems: validItems } = coreRenderer.useTimeVisibility(items, isEditingMode);
  const [activeTab, setActiveTab] = React.useState((_a = validItems == null ? void 0 : validItems[0]) == null ? void 0 : _a.id);
  const displayItem = React.useMemo(() => {
    return validItems == null ? void 0 : validItems.find((el) => el.id === activeTab);
  }, [validItems, activeTab]);
  React.useEffect(() => {
    var _a2;
    if (isEditingMode) {
      setActiveTab((_a2 = validItems == null ? void 0 : validItems[0]) == null ? void 0 : _a2.id);
    }
  }, [items == null ? void 0 : items.length, isEditingMode]);
  return {
    activeTab,
    setActiveTab,
    validItems,
    displayItem
  };
};

exports.useCountdownSkuList = useCountdownSkuList;


/***/ }),

/***/ 583676:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var React = __webpack_require__(891987);
var ui = __webpack_require__(923049);
var Container = __webpack_require__(341018);
var Slider = __webpack_require__(183594);
var grid = __webpack_require__(860046);
var renderLink = __webpack_require__(284727);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const { cardDefaultImage: defaultImage } = coreRenderer.mappingAssets;
const HeroBanner2Web = (_a) => {
  var _b = _a, {
    isEditingMode,
    ssrData,
    menu: menuProps,
    maxWidth = grid.DEFAULT_MAX_WIDTH_1600
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "ssrData",
    "menu",
    "maxWidth"
  ]);
  var _b2;
  const { device } = coreRenderer.useStore();
  const isDesktop = device === "desktop";
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    autoSwipeTimeMilliseconds = 3e3,
    items = [],
    commonStyle,
    subBanners = [],
    isDisplaySubBanners
  } = _a2, rest = __objRest(_a2, [
    "autoSwipeTimeMilliseconds",
    "items",
    "commonStyle",
    "subBanners",
    "isDisplaySubBanners"
  ]);
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);
  const [showNavBtns, setShowNavBtns] = React.useState(false);
  const { displayItems: validItems } = coreRenderer.useTimeVisibility(items, isEditingMode);
  const { displayItems: displaySubBanners } = coreRenderer.useTimeVisibility(
    subBanners,
    isEditingMode
  );
  const subBannerContainerWidth = maxWidth < window.innerWidth ? maxWidth : window.innerWidth - 64;
  const mobileViewportWidth = Math.min(window.innerWidth, 768);
  const subBannerMobileContainerWidth = mobileViewportWidth - 16;
  const renderValidItem = (item, index) => {
    return /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
      isEditingMode,
      event: item.event,
      googleImageParams: item.googleImageParams,
      src: item.src || defaultImage,
      alt: item.alt || "Image",
      commonStyle: {
        objectFit: "fill",
        width: "100%",
        maxWidth: "100%",
        height: isDesktop ? window.innerWidth / 4 : mobileViewportWidth / 1.95
      }
    }, index);
  };
  const renderSubBannersItem = (item, index) => {
    const { event, googleImageParams, src, alt } = item;
    const content = /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
      googleImageParams,
      src: src || defaultImage,
      alt: alt || "Brand",
      isEditingMode,
      commonStyle: {
        width: "100%",
        borderRadius: 8,
        objectFit: "fill",
        height: isDesktop ? (subBannerContainerWidth - 8) / 7 : (subBannerMobileContainerWidth - 8) / 3.75
      }
    });
    return renderLink.renderLink(event, content, isEditingMode, index);
  };
  return /* @__PURE__ */ jsxRuntime.jsx(ui.StyledHeroBanner, {
    commonStyle,
    onMouseEnter: () => setShowNavBtns(true),
    onMouseLeave: () => setShowNavBtns(false),
    children: /* @__PURE__ */ jsxRuntime.jsxs(Container.Container, __spreadProps(__spreadValues({
      commonStyle: {
        position: "relative",
        width: "100%",
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        height: isDesktop ? window.innerWidth / 4 + (subBannerContainerWidth - 8) / 7 - window.innerWidth / 24 + 20 : mobileViewportWidth / 1.95 + (subBannerMobileContainerWidth - 8) / 3.75 - mobileViewportWidth / 19.5 + 8
      }
    }, rest), {
      maxWidth: "100%",
      children: [
        (validItems == null ? void 0 : validItems.length) > 1 && /* @__PURE__ */ jsxRuntime.jsx(StyledLeftNav, {
          style: { opacity: showNavBtns ? 1 : 0 },
          ref: navigationPrevRef,
          maxWidth: subBannerContainerWidth,
          isDesktop
        }),
        /* @__PURE__ */ jsxRuntime.jsx("div", {
          style: {
            maxWidth: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          children: /* @__PURE__ */ jsxRuntime.jsx(StyledFullWidthSlider, {
            children: validItems.length !== 1 ? /* @__PURE__ */ jsxRuntime.jsx(Slider.Slider, {
              navigation: {
                prevEl: navigationPrevRef.current,
                nextEl: navigationNextRef.current
              },
              navigationStyle: 1,
              virtual: true,
              paginationColor: "#ffffff",
              loop: true,
              speed: autoSwipeTimeMilliseconds,
              allowTouchMove: !isEditingMode,
              onBeforeInit: (swiper) => {
                swiper.params.navigation.prevEl = navigationPrevRef.current;
                swiper.params.navigation.nextEl = navigationNextRef.current;
              },
              children: validItems.map((item, index) => renderValidItem(item, index))
            }) : renderValidItem(validItems[0], 0)
          })
        }),
        (validItems == null ? void 0 : validItems.length) > 1 && /* @__PURE__ */ jsxRuntime.jsx(StyledRightNav, {
          style: { opacity: showNavBtns ? 1 : 0 },
          ref: navigationNextRef,
          maxWidth: subBannerContainerWidth,
          isDesktop
        }),
        isDisplaySubBanners && /* @__PURE__ */ jsxRuntime.jsx(RecommendBrandWrapper, {
          style: {
            width: isDesktop ? subBannerContainerWidth : "100%",
            position: "absolute",
            top: isDesktop ? window.innerWidth / 4 - window.innerWidth / 24 : mobileViewportWidth / 1.95 - mobileViewportWidth / 19.5 - 12,
            maxWidth: isDesktop ? subBannerContainerWidth : "100%",
            height: isDesktop ? (subBannerContainerWidth - 8) / 7 : (subBannerMobileContainerWidth - 8) / 3.75
          },
          isDesktop,
          children: displaySubBanners.length !== 1 ? /* @__PURE__ */ jsxRuntime.jsx(Slider.Slider, {
            allowTouchMove: !isEditingMode,
            slidesPerView: 2,
            autoplay: !!autoSwipeTimeMilliseconds,
            speed: autoSwipeTimeMilliseconds,
            pagination: true,
            paginationStyle: 2,
            paginationColor: "#ffffff",
            loop: true,
            spaceBetween: 8,
            children: (_b2 = displaySubBanners == null ? void 0 : displaySubBanners.map) == null ? void 0 : _b2.call(
              displaySubBanners,
              (item, index) => renderSubBannersItem(item, index)
            )
          }) : renderSubBannersItem(displaySubBanners[0], 0)
        })
      ]
    }))
  });
};
HeroBanner2Web.displayName = "omni_herobanner2_desktop";
const StyledFullWidthSlider = styled__default["default"].div`
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  z-index: 0;

  .swiper-pagination {
    bottom: 1rem !important;
  }
`;
const StyledLeftNav = styled__default["default"].div(
  ({ maxWidth, isDesktop }) => `
  top: 39.5%;
  left: ${isDesktop ? (window.innerWidth - maxWidth - 30) / 2 : 8}px;

  position: absolute;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${isDesktop ? 44 : 28}px;
  height: ${isDesktop ? 44 : 28}px;

  border-radius: 100px;
  background-color: white;

  &:after {
    mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
    content: ' ';
    height: ${isDesktop ? 24 : 12}px;
    width: ${isDesktop ? 24 : 12}px;
    mask-size: contain;
    display: inline-block;
    background: #333;
  }
`
);
const StyledRightNav = styled__default["default"].div(
  ({ maxWidth, isDesktop }) => `
  top: 39.5%;
  right: ${isDesktop ? (window.innerWidth - maxWidth - 30) / 2 : 8}px;

  position: absolute;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${isDesktop ? 44 : 28}px;
  height: ${isDesktop ? 44 : 28}px;

  border-radius: 100px;
  background-color: white;

  &:after {
    mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
    content: ' ';
    height: ${isDesktop ? 24 : 12}px;
    width: ${isDesktop ? 24 : 12}px;
    mask-size: contain;
    display: inline-block;
    background: #333;
  }
`
);
const RecommendBrandWrapper = styled__default["default"].div(
  ({ isDesktop }) => `
  padding: ${isDesktop ? "12px 16px" : "12px 8px"};
  @media (max-width: 1600px) {
    padding: ${isDesktop ? "12px 0" : "12px 8px"};
  }
`
);

exports.HeroBanner2Web = HeroBanner2Web;
exports.StyledFullWidthSlider = StyledFullWidthSlider;
exports.StyledLeftNav = StyledLeftNav;
exports.StyledRightNav = StyledRightNav;


/***/ }),

/***/ 923049:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var React = __webpack_require__(891987);
var Section = __webpack_require__(843633);
var Col = __webpack_require__(481851);
var MegaMenu = __webpack_require__(279111);
var grid = __webpack_require__(860046);
var Slider = __webpack_require__(183594);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const { cardDefaultImage: defaultImage } = coreRenderer.mappingAssets;
const HeroBanner = (_a) => {
  var _b = _a, {
    isEditingMode,
    ssrData,
    menu: menuProps
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "ssrData",
    "menu"
  ]);
  var _b2;
  const { device, globalData } = coreRenderer.useStore();
  const menu = isEditingMode ? menuProps : globalData.menu || [];
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    autoSwipeTimeMilliseconds = 3e3,
    items = [],
    rightItems = [],
    showMegaMenu,
    menuZone,
    commonStyle,
    primaryColor,
    maxWidth
  } = _a2, rest = __objRest(_a2, [
    "autoSwipeTimeMilliseconds",
    "items",
    "rightItems",
    "showMegaMenu",
    "menuZone",
    "commonStyle",
    "primaryColor",
    "maxWidth"
  ]);
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);
  const [showNavBtns, setShowNavBtns] = React.useState(false);
  const { displayItems: validItems } = coreRenderer.useTimeVisibility(items, isEditingMode);
  const { displayItems: validRightItems } = coreRenderer.useTimeVisibility(
    rightItems,
    isEditingMode
  );
  if (!isEditingMode && !(items == null ? void 0 : items.length))
    return null;
  const renderValidItem = (item, index) => {
    return /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadValues({
      isEditingMode,
      event: item.event,
      googleImageParams: item.googleImageParams || { width: 1920 },
      src: item.src || defaultImage,
      alt: item.alt || "Image",
      commonStyle: {
        objectFit: "cover",
        width: "100%",
        height: 566
      }
    }, !isEditingMode && coreRenderer.getTrackingData({
      isTrackContent: true,
      regionName: "topSliderBannerHomepage",
      contentName: "heroBannerSlide",
      target: coreRenderer.getTargetOfTrackingFromEvent(item.event),
      index
    })), index);
  };
  return /* @__PURE__ */ jsxRuntime.jsx(StyledHeroBanner, __spreadProps(__spreadValues({
    commonStyle,
    onMouseEnter: () => setShowNavBtns(true),
    onMouseLeave: () => setShowNavBtns(false)
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Section.Section, {
      commonStyle: {
        maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH,
        padding: { left: 16, right: 16 }
      },
      row: {
        commonStyle: {
          height: 556,
          alignItems: "stretch"
        }
      },
      children: [
        /* @__PURE__ */ jsxRuntime.jsxs(Col.Col, {
          span: 2,
          style: { paddingTop: "1rem", zIndex: 980 },
          children: [
            /* @__PURE__ */ jsxRuntime.jsx("div", {
              style: { position: "relative" },
              children: /* @__PURE__ */ jsxRuntime.jsx(MegaMenu.MegaMenu, {
                menu,
                isEditingMode,
                primaryColor
              })
            }),
            (validItems == null ? void 0 : validItems.length) > 1 && /* @__PURE__ */ jsxRuntime.jsx(StyledLeftNav, {
              style: { opacity: showNavBtns ? 1 : 0 },
              ref: navigationPrevRef
            })
          ]
        }),
        /* @__PURE__ */ jsxRuntime.jsx("div", {
          style: { flex: "1 1 0%" },
          children: /* @__PURE__ */ jsxRuntime.jsx(StyledFullWidthSlider, {
            children: validItems.length !== 1 ? /* @__PURE__ */ jsxRuntime.jsx(Slider.Slider, {
              pagination: true,
              paginationStyle: 1,
              navigation: {
                prevEl: navigationPrevRef.current,
                nextEl: navigationNextRef.current
              },
              navigationStyle: 1,
              virtual: true,
              paginationColor: "#ffffff",
              loop: true,
              autoplay: !!autoSwipeTimeMilliseconds,
              speed: autoSwipeTimeMilliseconds,
              allowTouchMove: !isEditingMode,
              onBeforeInit: (swiper) => {
                swiper.params.navigation.prevEl = navigationPrevRef.current;
                swiper.params.navigation.nextEl = navigationNextRef.current;
              },
              children: validItems.map((item, index) => renderValidItem(item, index))
            }) : renderValidItem(validItems[0], 0)
          })
        }),
        /* @__PURE__ */ jsxRuntime.jsxs(Col.Col, {
          span: 2,
          style: { paddingTop: "1rem" },
          children: [
            (validItems == null ? void 0 : validItems.length) > 1 && /* @__PURE__ */ jsxRuntime.jsx(StyledRightNav, {
              style: { opacity: showNavBtns ? 1 : 0 },
              ref: navigationNextRef
            }),
            !!(validRightItems == null ? void 0 : validRightItems.length) && /* @__PURE__ */ jsxRuntime.jsx(StyledRightBanner, {
              children: (_b2 = validRightItems == null ? void 0 : validRightItems.slice) == null ? void 0 : _b2.call(validRightItems, 0, 2).map((item, index) => /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadValues({
                isEditingMode,
                event: item.event,
                googleImageParams: item.googleImageParams || { width: 300 },
                src: item.src || defaultImage,
                alt: item.alt || "Image",
                commonStyle: {
                  objectFit: "cover",
                  width: "100%",
                  height: 220,
                  borderRadius: 8,
                  hover: {
                    zoom: 105
                  }
                }
              }, !isEditingMode && coreRenderer.getTrackingData({
                isTrackContent: true,
                regionName: "topRightBannerHomepage",
                contentName: "heroBannerRight",
                index,
                target: coreRenderer.getTargetOfTrackingFromEvent(item.event)
              })), index))
            })
          ]
        })
      ]
    })
  }));
};
const StyledHeroBanner = styled__default["default"].div(
  ({ commonStyle }) => `
  position: relative;
  content-visibility: auto;
  ${coreRenderer.getStyle(commonStyle)}
`
);
const StyledFullWidthSlider = styled__default["default"].div`
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  z-index: 0;

  .swiper-pagination {
    bottom: 7rem !important;
  }
`;
const StyledRightBanner = styled__default["default"].div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const StyledLeftNav = styled__default["default"].div`
  top: 39.5%;
  right: -46px;

  position: absolute;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;

  border-top-right-radius: 100px;
  border-bottom-right-radius: 100px;
  background-color: rgba(168, 168, 168, 0.46);

  &:after {
    mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
    content: ' ';
    height: 30px;
    width: 30px;
    mask-size: contain;
    display: inline-block;
    background: #333;
  }
`;
const StyledRightNav = styled__default["default"].div`
  top: 39.5%;
  left: -48px;

  position: absolute;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;

  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  background-color: rgba(168, 168, 168, 0.46);

  &:after {
    mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
    content: ' ';
    height: 30px;
    width: 30px;
    mask-size: contain;
    display: inline-block;
    background: #333;
  }
`;
HeroBanner.displayName = "Omni_HeroBanner";

exports.HeroBanner = HeroBanner;
exports.StyledFullWidthSlider = StyledFullWidthSlider;
exports.StyledHeroBanner = StyledHeroBanner;
exports.StyledLeftNav = StyledLeftNav;
exports.StyledRightNav = StyledRightNav;


/***/ }),

/***/ 273039:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var style = __webpack_require__(667925);
var image = __webpack_require__(478130);
var grid = __webpack_require__(860046);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const IMAGE_BANNER_DEFAULT_SRC = image.generatePlaceholderImage({
  width: 374,
  height: 374
});
const BASE_IMAGE_LIST_DATA = {
  isMultipleBanner: false,
  items: [
    {
      src: IMAGE_BANNER_DEFAULT_SRC,
      event: {
        eventType: "link",
        link: {
          href: "https://cooponline.vn/"
        }
      }
    },
    {
      src: IMAGE_BANNER_DEFAULT_SRC,
      googleImageParams: {
        width: 300
      },
      event: {
        eventType: "link",
        link: {
          href: "https://cooponline.vn/"
        }
      }
    },
    {
      src: IMAGE_BANNER_DEFAULT_SRC,
      event: {
        eventType: "link",
        link: {
          href: "https://cooponline.vn/"
        }
      }
    },
    {
      src: IMAGE_BANNER_DEFAULT_SRC,
      event: {
        eventType: "link",
        link: {
          href: "https://cooponline.vn/"
        }
      }
    }
  ],
  maxWidth: grid.DEFAULT_MAX_WIDTH
};
const DEFAULT_IMAGE_LIST = __spreadProps(__spreadValues({}, BASE_IMAGE_LIST_DATA), {
  itemStyle: {
    borderRadius: 12
  },
  desktop: {
    commonStyle: __spreadValues({}, style.DESKTOP_COMMON_STYLE)
  },
  mobile: {
    commonStyle: __spreadProps(__spreadValues({}, style.MOBILE_COMMON_STYLE), {
      padding: {
        left: 0,
        right: 0
      }
    })
  }
});

exports.DEFAULT_IMAGE_LIST = DEFAULT_IMAGE_LIST;
exports.IMAGE_BANNER_DEFAULT_SRC = IMAGE_BANNER_DEFAULT_SRC;


/***/ }),

/***/ 112750:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var React = __webpack_require__(891987);
var constants = __webpack_require__(273039);
var Container = __webpack_require__(341018);
var grid = __webpack_require__(860046);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ImageListOmni = (props) => {
  const { device } = coreRenderer.useStore();
  const _a = props, {
    isMultipleBanner,
    items = [],
    itemStyle,
    isEditingMode
  } = _a, restProps = __objRest(_a, [
    "isMultipleBanner",
    "items",
    "itemStyle",
    "isEditingMode"
  ]);
  const _b = coreRenderer.getPropsByDevice(restProps, device), {
    commonStyle,
    maxWidth = grid.DEFAULT_MAX_WIDTH
  } = _b, rest = __objRest(_b, [
    "commonStyle",
    "maxWidth"
  ]);
  const _c = commonStyle || {}, { padding, margin } = _c, restStyle = __objRest(_c, ["padding", "margin"]);
  const { displayItems } = coreRenderer.useTimeVisibility(items, isEditingMode);
  const banners = React.useMemo(() => {
    const banners2 = displayItems == null ? void 0 : displayItems.slice(0, 4);
    if (banners2.length < 4) {
      for (let i = banners2.length; i < 4; i++) {
        banners2.push({
          src: constants.IMAGE_BANNER_DEFAULT_SRC
        });
      }
    }
    return banners2;
  }, [displayItems]);
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: { maxWidth, padding, margin },
    maxWidth
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
      commonStyle: __spreadValues({ backgroundSize: "cover" }, restStyle),
      style: { padding: "8px 16px", borderRadius: 8 },
      children: isMultipleBanner ? /* @__PURE__ */ jsxRuntime.jsx(MultipleImageWrapper, {
        children: banners == null ? void 0 : banners.map((item, index) => /* @__PURE__ */ jsxRuntime.jsx(ImageStyled, {
          itemStyle,
          alt: "banner",
          src: item == null ? void 0 : item.src
        }, index))
      }) : /* @__PURE__ */ jsxRuntime.jsx(SingleImageWrapper, {
        children: /* @__PURE__ */ jsxRuntime.jsx(ImageStyled, {
          itemStyle,
          alt: "banner",
          src: (items == null ? void 0 : items[0].src) || constants.IMAGE_BANNER_DEFAULT_SRC
        })
      })
    })
  }));
};
ImageListOmni.displayName = "Omni_ImageList";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)}
`
);
const MultipleImageWrapper = styled__default["default"].div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
`;
const SingleImageWrapper = styled__default["default"].div`
  overflow: hidden;
`;
const ImageStyled = styled__default["default"].img(
  ({ itemStyle }) => `
  border-radius: ${(itemStyle == null ? void 0 : itemStyle.borderRadius) || 0}px;
  object-fit: cover;
  aspect-ratio: 1 / 1;
  width: 100%;
  `
);

exports.ImageListOmni = ImageListOmni;


/***/ }),

/***/ 80039:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var icons = __webpack_require__(143599);
var coreRenderer = __webpack_require__(85097);
var Container = __webpack_require__(341018);
var renderDynamicSlot = __webpack_require__(958220);
var EmptyProduct = __webpack_require__(907438);
var grid = __webpack_require__(860046);
var getStyles = __webpack_require__(934512);
var BlockHeader = __webpack_require__(951297);
var renderLink = __webpack_require__(284727);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const LeftBannerProduct = (_a) => {
  var _b = _a, {
    isEditingMode = false,
    ssrData
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "ssrData"
  ]);
  const { device, mappingDynamicSlots } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    collectionSlug,
    viewMoreUrl,
    title,
    commonStyle,
    titleStyle,
    viewMoreStyle,
    showTwoProductRows,
    topBanner,
    bottomBanner
  } = _a2, rest = __objRest(_a2, [
    "collectionSlug",
    "viewMoreUrl",
    "title",
    "commonStyle",
    "titleStyle",
    "viewMoreStyle",
    "showTwoProductRows",
    "topBanner",
    "bottomBanner"
  ]);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  const renderViewAllLink = () => {
    if (!viewMoreUrl)
      return null;
    const content = /* @__PURE__ */ jsxRuntime.jsxs(ViewMore, {
      commonStyle: viewMoreStyle,
      children: [
        "Xem t\u1EA5t c\u1EA3 ",
        /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
          name: "RightOutlined"
        })
      ]
    });
    return renderLink.renderLink(viewMoreUrl, content, isEditingMode);
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: { maxWidth: grid.DEFAULT_MAX_WIDTH, padding, margin }
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, __spreadProps(__spreadValues({
      commonStyle: __spreadValues({ backgroundSize: "cover" }, restStyle)
    }, !isEditingMode && coreRenderer.getTrackingData({
      isTrackContent: true,
      regionName: `${title}HorizontalBlock`
    })), {
      children: [
        !!title && /* @__PURE__ */ jsxRuntime.jsxs(Header, {
          device,
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(Label, {
              commonStyle: titleStyle,
              children: title
            }),
            renderViewAllLink()
          ]
        }),
        /* @__PURE__ */ jsxRuntime.jsx(ProductListWrapper, {
          children: collectionSlug || isEditingMode ? renderDynamicSlot.renderDynamicSlot(
            `left_banner_product_${device}`,
            mappingDynamicSlots,
            ssrData,
            {
              collectionSlug,
              showTwoProductRows,
              topBanner,
              bottomBanner
            }
          ) : /* @__PURE__ */ jsxRuntime.jsx(EmptyProduct.EmptyProduct, {})
        })
      ]
    }))
  }));
};
LeftBannerProduct.displayName = "Omni_LeftBannerProduct";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${getStyles.getStyle(commonStyle)}
`
);
const Header = styled__default["default"](BlockHeader.BlockHeader)(
  `
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  color: #ffffff;
`
);
const Label = styled__default["default"].div(
  ({ commonStyle }) => `
    flex: 1;
    margin-right: 8px;
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;

    ${getStyles.getStyle(commonStyle)}
  `
);
const ViewMore = styled__default["default"].span(
  ({ commonStyle }) => `
    display: flex;
    align-items: center;
    ${getStyles.getStyle(commonStyle)}
  `
);
const ProductListWrapper = styled__default["default"].div`
  padding: 1rem;
`;

exports.LeftBannerProduct = LeftBannerProduct;


/***/ }),

/***/ 160325:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var React = __webpack_require__(891987);
var Container = __webpack_require__(341018);
var BlockHeader = __webpack_require__(951297);
var renderDynamicSlot = __webpack_require__(958220);
var EmptyProduct = __webpack_require__(907438);
var grid = __webpack_require__(860046);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ListingTab = (_a) => {
  var _b = _a, {
    isEditingMode = false,
    ssrData,
    maxWidth
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "ssrData",
    "maxWidth"
  ]);
  var _c, _d;
  const [activeTab, setActiveTab] = React.useState(0);
  const { device, mappingDynamicSlots } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    items = [],
    commonStyle,
    title,
    activeTabStyle
  } = _a2, rest = __objRest(_a2, [
    "items",
    "commonStyle",
    "title",
    "activeTabStyle"
  ]);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  const tabHeadRef = React.useRef();
  const tabHead = tabHeadRef == null ? void 0 : tabHeadRef.current;
  const isDesktop = device === "desktop";
  React.useEffect(() => {
    if (tabHead && tabHead.scroll) {
      const activeDom = tabHead.childNodes[activeTab];
      tabHead.scroll({
        left: activeDom.offsetLeft - (tabHead.offsetWidth - activeDom.offsetWidth) / 2,
        behavior: "smooth"
      });
    }
  }, [activeTab, tabHead]);
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: { maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH, padding, margin }
  }, rest), {
    maxWidth,
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      commonStyle: restStyle,
      children: [
        !!title && /* @__PURE__ */ jsxRuntime.jsx(BlockHeader.BlockHeader, {
          device,
          children: /* @__PURE__ */ jsxRuntime.jsx(Title, {
            children: title
          })
        }),
        !!(items == null ? void 0 : items.length) && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(HeaderWrapper, {
              ref: tabHeadRef,
              children: items.map(({ src, title: title2 }, index) => /* @__PURE__ */ jsxRuntime.jsxs(TabItem, __spreadProps(__spreadValues({
                className: activeTab === index ? "active" : "",
                onClick: () => setActiveTab(index)
              }, !isEditingMode && coreRenderer.getTrackingData({
                isTrackContent: true,
                regionName: "forYouTabCategory",
                contentName: title2,
                index
              })), {
                isDesktop,
                hasImage: !!src,
                activeTabStyle,
                children: [
                  !!src && /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
                    src,
                    alt: title2 || "Image",
                    commonStyle: {
                      objectFit: "cover",
                      position: "relative",
                      display: "inline-block",
                      margin: {
                        bottom: 4
                      },
                      height: 44,
                      width: 44
                    }
                  }),
                  /* @__PURE__ */ jsxRuntime.jsx(TabTitle, {
                    isDesktop,
                    children: title2
                  })
                ]
              }), index))
            }),
            /* @__PURE__ */ jsxRuntime.jsx("div", {
              children: ((_c = items == null ? void 0 : items[activeTab]) == null ? void 0 : _c.collectionSlug) || isEditingMode ? renderDynamicSlot.renderDynamicSlot(
                `product_grid_${device}`,
                mappingDynamicSlots,
                activeTab === 0 ? ssrData : void 0,
                {
                  collectionSlug: (_d = items == null ? void 0 : items[activeTab]) == null ? void 0 : _d.collectionSlug,
                  config: { regionName: "productCard" }
                }
              ) : /* @__PURE__ */ jsxRuntime.jsx(EmptyProduct.EmptyProduct, {})
            })
          ]
        })
      ]
    })
  }));
};
ListingTab.displayName = "Omni_ListingTab";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  border-radius: 8px;
  overflow: hidden;
  ${coreRenderer.getStyle(commonStyle)}
  `
);
const Title = styled__default["default"].div`
  color: rgb(51, 51, 51);
  font-weight: 700;
  font-size: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.5;
  background-color: #ffffff;
`;
const HeaderWrapper = styled__default["default"].div`
  overflow-x: scroll;
  position: sticky;
  width: 100%;
  &::-webkit-scrollbar {
    display: none;
  }
  scroll-snap-type: x mandatory;
  display: flex;
  align-items: stretch;
  background-color: #ffffff;
`;
const TabItem = styled__default["default"].div(
  ({ isDesktop, hasImage, activeTabStyle }) => `
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  flex-direction: column;
  position: relative;
  background: rgb(255, 255, 255);
  display: inline-flex;
  scroll-snap-align: start;
  justify-content: ${hasImage ? `flex-start` : `center`};
  height: auto;
  ${isDesktop ? `min-width: 120px; width: 120px; padding: 12px 0;` : `min-width: 90px; width: 90px; padding: 8px 0;`}
  &.active {
    color: rgb(51, 51, 51);
    ${coreRenderer.getStyle(activeTabStyle)}
  }
  &:hover {
    cursor: pointer;
  }
`
);
const TabTitle = styled__default["default"].span(
  ({ isDesktop }) => `
  color: rgb(51, 51, 51);
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: normal;
  text-align: center;
  
  ${isDesktop ? `font-size: 14px; padding: 0 12px;` : `font-size: 12px; padding: 0 8px;`}
`
);

exports.ListingTab = ListingTab;


/***/ }),

/***/ 279111:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var styled = __webpack_require__(212951);
var clsx = __webpack_require__(981892);
var MegaMenuContent = __webpack_require__(561099);
var coreRenderer = __webpack_require__(85097);
var menu = __webpack_require__(921977);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MegaMenu = ({ menu: menu$1 = [], primaryColor, isEditingMode }) => {
  const { globalData } = coreRenderer.useStore();
  const isPreviewMode = globalData == null ? void 0 : globalData.isPreviewMode;
  const [activeMenu, setActiveMenu] = React.useState();
  const MAX_LENGTH_MENU = 14;
  const tree = menu.flattenToTree((menu$1 || []).filter((el) => !el.isHidden)).slice(
    0,
    MAX_LENGTH_MENU
  );
  return /* @__PURE__ */ jsxRuntime.jsxs("div", {
    onMouseLeave: () => setActiveMenu(null),
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
        className: clsx__default["default"]((activeMenu == null ? void 0 : activeMenu.children.length) > 0 ? ["active"] : null),
        children: tree == null ? void 0 : tree.map((item, index) => /* @__PURE__ */ jsxRuntime.jsx("div", __spreadProps(__spreadValues({}, !isEditingMode && !isPreviewMode && coreRenderer.getTrackingData({
          isTrackContent: true,
          contentName: item == null ? void 0 : item.name,
          regionName: "megaMenuText"
        })), {
          children: /* @__PURE__ */ jsxRuntime.jsxs(MenuItemWrapper, {
            href: menu.getUrlOfMenuItem(item, isEditingMode),
            primaryColor,
            onMouseEnter: () => {
              setActiveMenu(item);
            },
            children: [
              (item == null ? void 0 : item.iconUrl) && /* @__PURE__ */ jsxRuntime.jsx(IconImg, {
                src: item == null ? void 0 : item.iconUrl,
                alt: item == null ? void 0 : item.name
              }),
              /* @__PURE__ */ jsxRuntime.jsx(Caption, {
                children: item == null ? void 0 : item.name
              })
            ]
          }, index)
        })))
      }),
      /* @__PURE__ */ jsxRuntime.jsx(VerticalMenuPanel, {
        className: clsx__default["default"]((activeMenu == null ? void 0 : activeMenu.children.length) > 0 ? ["active"] : null),
        children: activeMenu && /* @__PURE__ */ jsxRuntime.jsx(MegaMenuContent.MegaMenuContent, {
          menu: activeMenu,
          primaryColor,
          isEditingMode,
          type: "vertical"
        })
      })
    ]
  });
};
const verticalMenuWidth = "12.375rem";
const megaMenuHeight = "28.5rem";
const Wrapper = styled__default["default"].div`
  border-radius: 0.5rem;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
  z-index: 980;
  height: ${megaMenuHeight};
  width: ${verticalMenuWidth};

  &.active {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`;
const MenuItemWrapper = styled__default["default"].a(
  ({ primaryColor = "#1435c3" }) => `
  cursor: pointer;
  color: black;
  text-decoration: none;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 0.5rem;
  padding: 0 0.5rem;
  border-radius: 0.5rem;
  overflow: hidden;

  &:hover {
    background-color: #ababab20;
    color: ${primaryColor} !important;
  }
`
);
const Caption = styled__default["default"].div`
  flex: 1 1 0%;
  margin: 0px;
  padding: 0px;
  border-style: none;
  border-width: 1px;
  border-color: unset;
  opacity: 1;
  color: inherit;
  font-weight: 500;
  text-decoration: unset;
  font-size: 12px;
  line-height: 16px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  max-width: unset;
  min-width: unset;
  transition: color 0.3s ease 0s;
`;
const VerticalMenuPanel = styled__default["default"].div`
  position: absolute;
  top: 0;
  width: calc(75rem - 12.375rem);
  left: 12.375rem;
  min-height: 100%;
  z-index: 980;
  overflow: hidden;
  transition: all 0.1s;
  visibility: hidden;
  opacity: 0;
  border-radius: 0.5rem;
  &.active {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    visibility: visible;
    opacity: 1;
  }
`;
const IconImg = styled__default["default"].img`
  width: 22px;
  height: 22px;
`;

exports.MegaMenu = MegaMenu;


/***/ }),

/***/ 561099:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var utils = __webpack_require__(786978);
var coreRenderer = __webpack_require__(85097);
var menu = __webpack_require__(921977);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MegaMenuContent = ({
  menu: menu$1,
  primaryColor = "#434657",
  isEditingMode = false,
  type = "vertical"
}) => {
  const getMenuColumns = () => {
    let totalCols = 6;
    if (type === "vertical")
      totalCols--;
    return totalCols;
  };
  const { globalData } = coreRenderer.useStore();
  const isPreviewMode = globalData == null ? void 0 : globalData.isPreviewMode;
  const newMenu = utils.convertMegaMenu(menu$1, getMenuColumns());
  return /* @__PURE__ */ jsxRuntime.jsx(StyledContentPanel, {
    children: newMenu == null ? void 0 : newMenu.map((col) => /* @__PURE__ */ jsxRuntime.jsx(MegaMenuColumn, {
      children: col.items.map((item, index) => {
        var _a;
        return /* @__PURE__ */ jsxRuntime.jsxs(MegaMenuSubColumn, {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem",
            marginBottom: "1.5rem"
          },
          children: [
            /* @__PURE__ */ jsxRuntime.jsx("div", __spreadProps(__spreadValues({}, !isEditingMode && !isPreviewMode && coreRenderer.getTrackingData({
              isTrackContent: true,
              contentName: `${menu$1.name} > ${item.name}`,
              regionName: "megaMenuText"
            })), {
              children: /* @__PURE__ */ jsxRuntime.jsx(StyledLink, {
                href: menu.getUrlOfMenuItem(item, isEditingMode),
                primaryColor,
                children: item == null ? void 0 : item.name
              })
            })),
            (_a = item == null ? void 0 : item.children) == null ? void 0 : _a.map((child) => /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
              children: (child == null ? void 0 : child.name) && /* @__PURE__ */ jsxRuntime.jsx("div", __spreadProps(__spreadValues({}, !isEditingMode && !isPreviewMode && coreRenderer.getTrackingData({
                isTrackContent: true,
                contentName: `${menu$1.name} > ${item.name} > ${child.name}`,
                regionName: "megaMenuText"
              })), {
                children: /* @__PURE__ */ jsxRuntime.jsx(StyledChildLink, {
                  href: menu.getUrlOfMenuItem(child, isEditingMode),
                  primaryColor,
                  children: child.name
                })
              }))
            }))
          ]
        }, index);
      })
    }))
  });
};
const StyledContentPanel = styled__default["default"].div`
  background-color: #ffffff;
  display: flex;
  flex: 1 1 0%;
  min-height: 28.5rem;
  padding: 0.75rem;
`;
const StyledLink = styled__default["default"].a(
  ({ primaryColor }) => `
color: ${primaryColor};
text-decoration: none;
font-size: 14px;
font-weight: bold;

&:hover {
  color: ${primaryColor};
}
`
);
const StyledChildLink = styled__default["default"].a(
  ({ primaryColor }) => `
  color: rgb(67, 70, 87);
  text-decoration: none;
  font-size: 14px;

  &:hover {
    color: ${primaryColor ? primaryColor : `rgb(20, 53, 195)`};
  }
`
);
const MegaMenuColumn = styled__default["default"].div`
  width: 25%;
  padding: 0px 8px;
  font-size: 20;
`;
const MegaMenuSubColumn = styled__default["default"].div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
`;

exports.MegaMenuContent = MegaMenuContent;


/***/ }),

/***/ 786978:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const convertMegaMenu = (menu, numberCol) => {
  if (numberCol < 1)
    return [];
  const newArr = menu.children.map((m) => {
    return {
      len: m.children.length + 1,
      items: [__spreadValues({}, m)]
    };
  });
  if (newArr.length <= numberCol)
    return newArr;
  newArr.sort((a, b) => b.len - a.len);
  const result = [...newArr.slice(0, numberCol)];
  let min;
  let k;
  for (let i = numberCol; i < newArr.length; i++) {
    min = result[0].len;
    k = 0;
    for (let j = 0; j < numberCol; j++) {
      if (min > result[j].len) {
        min = result[j].len;
        k = j;
      }
    }
    result[k] = {
      len: result[k].len + newArr[i].len,
      items: [...result[k].items, ...newArr[i].items]
    };
  }
  return result;
};

exports.convertMegaMenu = convertMegaMenu;


/***/ }),

/***/ 116600:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var coreRenderer = __webpack_require__(85097);
var MixBannerSide = __webpack_require__(169758);
var Container = __webpack_require__(341018);
var grid = __webpack_require__(860046);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MixBanner = (_a) => {
  var _b = _a, {
    isEditingMode,
    maxWidth
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "maxWidth"
  ]);
  const { device } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), { left, right, commonStyle, titleStyle, viewMoreStyle } = _a2, rest = __objRest(_a2, ["left", "right", "commonStyle", "titleStyle", "viewMoreStyle"]);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  return /* @__PURE__ */ jsxRuntime.jsxs(Container.Container, __spreadProps(__spreadValues({
    commonStyle: {
      maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH,
      padding,
      margin,
      display: "flex",
      gap: 16
    }
  }, rest), {
    maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH,
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(MixBannerSide.MixBannerSide, __spreadProps(__spreadValues({}, left), {
        commonStyle: __spreadValues(__spreadValues({}, restStyle), left == null ? void 0 : left.commonStyle),
        isEditingMode,
        titleStyle,
        viewMoreStyle
      })),
      /* @__PURE__ */ jsxRuntime.jsx(MixBannerSide.MixBannerSide, __spreadProps(__spreadValues({}, right), {
        commonStyle: __spreadValues(__spreadValues({}, restStyle), right == null ? void 0 : right.commonStyle),
        isEditingMode,
        titleStyle,
        viewMoreStyle
      }))
    ]
  }));
};
MixBanner.displayName = "Omni_MixBanner";

exports.MixBanner = MixBanner;


/***/ }),

/***/ 169758:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var icons = __webpack_require__(143599);
var coreRenderer = __webpack_require__(85097);
var Row = __webpack_require__(346761);
var Col = __webpack_require__(481851);
var renderLink = __webpack_require__(284727);
var BlockHeader = __webpack_require__(951297);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const { cardDefaultImage: defaultImage } = coreRenderer.mappingAssets;
const MixBannerSide = ({
  isEditingMode,
  title,
  redirectUrl,
  mainBanner,
  rightBanners,
  bottomBanners,
  commonStyle,
  titleStyle,
  viewMoreStyle
}) => {
  var _a, _b, _c;
  const { device } = coreRenderer.useStore();
  const { displayItems: displayRightBanners } = coreRenderer.useTimeVisibility(
    rightBanners,
    isEditingMode
  );
  const { displayItems: displayBottomBanners } = coreRenderer.useTimeVisibility(
    bottomBanners,
    isEditingMode
  );
  const renderViewAllLink = () => {
    const content = /* @__PURE__ */ jsxRuntime.jsxs(ViewMore, {
      commonStyle: viewMoreStyle,
      children: [
        "Xem t\u1EA5t c\u1EA3 ",
        /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
          name: "RightOutlined"
        })
      ]
    });
    return renderLink.renderLink(redirectUrl, content, isEditingMode);
  };
  const renderMainBanner = () => {
    if (!mainBanner)
      return null;
    const { googleImageParams, src, alt, event } = mainBanner;
    const content = /* @__PURE__ */ jsxRuntime.jsx(StyleMainBanner, __spreadValues({
      googleImageParams: googleImageParams || {
        width: 400
      },
      src: src || defaultImage,
      alt: alt || "Image",
      commonStyle: {
        hover: { zoom: 105 },
        objectFit: "cover",
        width: "100%",
        height: "100%"
      }
    }, !isEditingMode && coreRenderer.getTrackingData({
      isTrackContent: true,
      regionName: "categoriesBlockBrand",
      contentName: title,
      target: coreRenderer.getTargetOfTrackingFromEvent(event)
    })));
    return /* @__PURE__ */ jsxRuntime.jsx(ImageWrapper, {
      children: renderLink.renderLink(event, content, isEditingMode)
    });
  };
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
    commonStyle,
    children: [
      /* @__PURE__ */ jsxRuntime.jsxs(Header, {
        device,
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(Label, {
            commonStyle: titleStyle,
            children: title
          }),
          !!redirectUrl && renderViewAllLink()
        ]
      }),
      /* @__PURE__ */ jsxRuntime.jsxs(Row.Row, {
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(Col.Col, {
            span: 4,
            children: renderMainBanner()
          }),
          /* @__PURE__ */ jsxRuntime.jsx(Col.Col, {
            span: 8,
            children: /* @__PURE__ */ jsxRuntime.jsx(ContentItemsWrapper, {
              children: (_c = (_a = displayRightBanners == null ? void 0 : displayRightBanners.slice) == null ? void 0 : (_b = _a.call(displayRightBanners, 0, 4)).map) == null ? void 0 : _c.call(_b, (banner, index) => {
                const content = /* @__PURE__ */ jsxRuntime.jsxs(ContentItem, {
                  children: [
                    /* @__PURE__ */ jsxRuntime.jsx(StyledRightTitle, {
                      children: banner == null ? void 0 : banner.alt
                    }),
                    /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
                      googleImageParams: banner.googleImageParams || { width: 300 },
                      src: banner.src || defaultImage,
                      alt: banner.alt || banner.title || "Image",
                      commonStyle: {
                        hover: { zoom: 105 },
                        objectFit: "contain",
                        height: 120
                      }
                    })
                  ]
                });
                return renderLink.renderLink(banner == null ? void 0 : banner.event, content, isEditingMode, index);
              })
            })
          })
        ]
      }),
      !!(displayBottomBanners == null ? void 0 : displayBottomBanners.length) && /* @__PURE__ */ jsxRuntime.jsx(Footer, {
        children: displayBottomBanners.map((banner, index) => {
          const content = /* @__PURE__ */ jsxRuntime.jsx(StyledBottomImage, __spreadValues({
            googleImageParams: banner.googleImageParams || { width: 200 },
            src: banner.src || defaultImage,
            alt: banner.alt || "Image",
            commonStyle: {
              hover: { zoom: 105 },
              objectFit: "contain",
              height: 68
            }
          }, !isEditingMode && coreRenderer.getTrackingData({
            isTrackContent: true,
            regionName: "categoriesBlockBrand",
            contentName: "bottomCategoriesBlockBrand",
            index,
            target: coreRenderer.getTargetOfTrackingFromEvent(banner.event)
          })));
          return renderLink.renderLink(banner.event, content, isEditingMode, index);
        })
      })
    ]
  });
};
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  overflow: hidden;
  flex: 50%;
  ${coreRenderer.getStyle(commonStyle)}
  `
);
const Header = styled__default["default"](BlockHeader.BlockHeader)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const Label = styled__default["default"].div(
  ({ commonStyle }) => `
  flex: 1;
  margin-right: 8px;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  ${coreRenderer.getStyle(commonStyle)}
`
);
const ImageWrapper = styled__default["default"].div`
  height: 356px;
  div {
    height: 100%;
  }
`;
const StyleMainBanner = styled__default["default"](coreRenderer.ImageBase)`
  display: inline-block;
  overflow: hidden;
  height: 100%;
  width: 100%;
  transition: transform 0.3s ease 0s;
`;
const ContentItemsWrapper = styled__default["default"].div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0;

  & > :nth-child(odd) {
    border-right: 1px solid rgb(224, 224, 224);
  }
  & > :nth-child(-n + 2) {
    border-bottom: 1px solid rgb(224, 224, 224);
  }
`;
const ContentItem = styled__default["default"].div`
  text-align: center;
  padding: 1rem;
  height: 100%;
`;
const StyledRightTitle = styled__default["default"].div`
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`;
const Footer = styled__default["default"].div`
  display: flex;
  justify-content: space-between;

  & > * {
    flex: 1;
  }
`;
const StyledBottomImage = styled__default["default"](coreRenderer.ImageBase)`
  width: 100%;
`;
const ViewMore = styled__default["default"].span(
  ({ commonStyle }) => `
    display: flex;
    align-items: center;
    ${coreRenderer.getStyle(commonStyle)}
  `
);

exports.MixBannerSide = MixBannerSide;


/***/ }),

/***/ 728759:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var Container = __webpack_require__(341018);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const OmniFooter = (_a) => {
  var _b = _a, {
    children,
    commonStyle
  } = _b, other = __objRest(_b, [
    "children",
    "commonStyle"
  ]);
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    fluid: true,
    commonStyle
  }, other), {
    children
  }));
};
OmniFooter.displayName = "Omni_Footer";

exports.OmniFooter = OmniFooter;


/***/ }),

/***/ 87013:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const DEFAULT_CATEGORY_BLOCK_RADIUS = 4;
const DEFAULT_MAX_WIDTH = 1232;
const DEFAULT_ECOMMERCE_HEADER_PROPS = {
  syncDeviceStyle: true,
  categoryBlockRadius: DEFAULT_CATEGORY_BLOCK_RADIUS,
  desktop: {
    primaryColor: "#7367F0"
  },
  mobile: {
    primaryColor: "#7367F0"
  },
  layout: "horizontal",
  maxWidth: DEFAULT_MAX_WIDTH,
  logoDesktop: {
    src: "https://lh3.googleusercontent.com/bhg6FoxZPA5S6q50_Gmu6YgMt2GcKxpjsbnaRvvHUwSV9JSnAj83TpbJEHIJjgKnbNoZmM7Mnx0pBlUau5CG2yIOG5v7rGc",
    commonStyle: {
      width: 128
    }
  },
  logoMobile: {
    src: "https://lh3.googleusercontent.com/QQLcWuF3LeVbgQdHjwDNnEUWoobbmTHRBuDIMoaYiADyIDZymjn1IbtEisUXCcgAycD0yNhuQ4aRF1WAaKSL9HHUr7bvfwA",
    commonStyle: {
      width: 128,
      marginRight: 16
    }
  },
  topBanner: {
    src: "https://lh3.googleusercontent.com/TpMhcfQsg7n_tCOYvj8mssYVWIg-TWaVhMOT_Lua0YvyIqOVBVCaQ1tboj_IyTf_KfLrgA2mhUloN9T2ekgyHP0ZQrYCRYg=rw-w1920",
    alt: "topBanner",
    commonStyle: {
      height: 56
    }
  },
  topBarMenu: [
    {
      title: "Khuy\u1EBFn m\u1EA1i",
      icon: {
        src: "https://lh3.googleusercontent.com/Bs986m6Kux0Lc47JKef2wzI2B2-kWgqt-7Vc3fAbCPAQ6q-5qXt4advONbDMlLqTR02KmHVeE8DwHYpQ7rkTHzv-X10hTj99=rw-w512"
      }
    },
    {
      title: "H\u1EC7 th\u1ED1ng Showroom",
      icon: {
        src: "https://lh3.googleusercontent.com/KJweUKGVn27k3y-SzqPOoxnxND8eyApxXJSEtev3dUljWKm3kyAxgXwzeFqsVvY5TFXSOD4vmoPwTPt2lKAJScsLX0_jXqxX6g=rw-w512"
      }
    },
    {
      title: "T\u01B0 v\u1EA5n mua h\xE0ng",
      icon: {
        src: "https://lh3.googleusercontent.com/IbF2IPMW_0QRtyuE2Qwqzu3rjSVrbRUQnQGSFXGBOkwqAwB-768TIybtM88idvlHFb4DHT-ybEhdnAX2PS_5rlKvCfCu_tJq=rw-w512"
      }
    },
    {
      title: "Tin c\xF4ng ngh\u1EC7",
      icon: {
        src: "https://lh3.googleusercontent.com/OYvO0n57IbvxtIDCkjM75Yz2r0rvfC9fD5f5YGhrGOBpjwEtN0DKdeQDijSEN95tOdU7-dr9G72kjpn_D8Vuelp-5Ev8C3jA=rw-w512"
      }
    },
    {
      title: "X\xE2y d\u1EF1ng c\u1EA5u h\xECnh",
      icon: {
        src: "https://lh3.googleusercontent.com/IHjqUa3vlKyhiixaFB4HnFBP1shDS8h2O1_qo6ylgcW5UFaymUF3imy9YTsBZn7l7Zi1u6sKe8ZcJSKLc994rEye_mEAD969=rw-w512"
      }
    }
  ]
};
const DEFAULT_TOP_BAR_MENU_ITEM = {
  title: "Lorem Ipsum"
};

exports.DEFAULT_CATEGORY_BLOCK_RADIUS = DEFAULT_CATEGORY_BLOCK_RADIUS;
exports.DEFAULT_ECOMMERCE_HEADER_PROPS = DEFAULT_ECOMMERCE_HEADER_PROPS;
exports.DEFAULT_MAX_WIDTH = DEFAULT_MAX_WIDTH;
exports.DEFAULT_TOP_BAR_MENU_ITEM = DEFAULT_TOP_BAR_MENU_ITEM;


/***/ }),

/***/ 707998:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var React = __webpack_require__(891987);

const OmniHeaderContext = React.createContext({});
const OmniHeaderProvider = OmniHeaderContext.Provider;
const useOmniHeader = () => React.useContext(OmniHeaderContext);

exports.OmniHeaderContext = OmniHeaderContext;
exports.OmniHeaderProvider = OmniHeaderProvider;
exports.useOmniHeader = useOmniHeader;


/***/ }),

/***/ 730285:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var HorizontalCategories = __webpack_require__(658535);
var VerticalCategories = __webpack_require__(414027);
var context = __webpack_require__(707998);
var constants = __webpack_require__(87013);
var coreRenderer = __webpack_require__(85097);
var Row = __webpack_require__(346761);
var Col = __webpack_require__(481851);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MainNavigationBar = ({
  logo,
  searchSlot,
  rightItemsSlot,
  layout,
  showMenu,
  setShowMenu,
  primaryColor,
  border,
  maxWidth = constants.DEFAULT_MAX_WIDTH
}) => {
  const isVertical = layout === "vertical";
  const isHorizontal = layout === "horizontal";
  const { isEditingMode = false } = context.useOmniHeader();
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(Content, {
        maxWidth,
        children: /* @__PURE__ */ jsxRuntime.jsxs(StyledRow, {
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(StyledCol, {
              children: /* @__PURE__ */ jsxRuntime.jsxs(LogoWrapper, {
                children: [
                  /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadProps(__spreadValues({}, logo), {
                    event: {
                      eventType: "link",
                      link: { href: isEditingMode ? null : "/" }
                    }
                  })),
                  isVertical && /* @__PURE__ */ jsxRuntime.jsx(VerticalCategories.VerticalCategories, {
                    showMenu,
                    setShowMenu,
                    primaryColor,
                    border
                  })
                ]
              })
            }),
            /* @__PURE__ */ jsxRuntime.jsx(StyledCol, {
              style: {
                flex: "1 1 auto"
              },
              children: searchSlot
            }),
            /* @__PURE__ */ jsxRuntime.jsx(StyledCol, {
              children: rightItemsSlot
            })
          ]
        })
      }),
      isHorizontal && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(Divider, {}),
          /* @__PURE__ */ jsxRuntime.jsx(Content, {
            maxWidth,
            children: /* @__PURE__ */ jsxRuntime.jsx(Row.Row, {
              children: /* @__PURE__ */ jsxRuntime.jsx(Col.Col, {
                span: 12,
                children: /* @__PURE__ */ jsxRuntime.jsx(HorizontalCategories.HorizontalCategories, {
                  primaryColor
                })
              })
            })
          })
        ]
      })
    ]
  });
};
const Wrapper = styled__default["default"].nav`
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);
`;
const Content = styled__default["default"].div(
  ({ maxWidth = constants.DEFAULT_MAX_WIDTH }) => `
   max-width: ${maxWidth}px;
  margin: 0 auto;
  padding-right: 16px;
  padding-left: 16px;
  width: 100%;
`
);
const StyledRow = styled__default["default"](Row.Row)`
  margin-left: -8px;
  margin-right: -8px;
  row-gap: 16px;
  min-height: 88px;
  align-items: center;

  @media (min-width: 1024px) {
    justify-content: center;
  }
`;
const StyledCol = styled__default["default"](Col.Col)`
  padding-left: 8px;
  padding-right: 8px;
`;
const Divider = styled__default["default"].div`
  display: flex;
  width: 100%;
  border-top: 1px solid #e4e5f0;
`;
const LogoWrapper = styled__default["default"].div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

exports.MainNavigationBar = MainNavigationBar;


/***/ }),

/***/ 206573:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var TopBarMenu = __webpack_require__(108610);
var MainNavigationBar = __webpack_require__(730285);
var TopBanner = __webpack_require__(367746);
var context = __webpack_require__(707998);
var renderDynamicSlot = __webpack_require__(958220);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const OmniDesktopHeader = (_a) => {
  var _b = _a, {
    ssrData
  } = _b, rest = __objRest(_b, [
    "ssrData"
  ]);
  const { isEditingMode = false } = context.useOmniHeader();
  const {
    topBarMenu = [],
    logoDesktop,
    topBanner,
    layout,
    maxWidth,
    categoryBlockRadius
  } = rest || {};
  const _a2 = coreRenderer.getPropsByDevice(
    rest,
    "desktop"
  ), { primaryColor, commonStyle } = _a2, others = __objRest(_a2, ["primaryColor", "commonStyle"]);
  const { mappingDynamicSlots, globalData } = coreRenderer.useStore();
  const isPreviewMode = globalData == null ? void 0 : globalData.isPreviewMode;
  const [showMenu, setShowMenu] = React__default["default"].useState(false);
  const searchSlot = renderDynamicSlot.renderDynamicSlot(
    `header_search_desktop`,
    mappingDynamicSlots,
    ssrData,
    {
      primaryColor
    }
  );
  const rightItemsSlot = renderDynamicSlot.renderDynamicSlot(
    `header_right_items_desktop`,
    mappingDynamicSlots,
    ssrData
  );
  const isShowTopBanner = isEditingMode || coreRenderer.validateIsVisibleComponent((topBanner == null ? void 0 : topBanner.timeVisibility) || {});
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      showMenu && /* @__PURE__ */ jsxRuntime.jsx(Backdrop, {
        onClick: () => setShowMenu(false)
      }),
      isShowTopBanner && /* @__PURE__ */ jsxRuntime.jsxs("div", __spreadProps(__spreadValues({}, !isEditingMode && !isPreviewMode && coreRenderer.getTrackingData({ isTrackContent: true, regionName: "topBanner" })), {
        children: [
          " ",
          /* @__PURE__ */ jsxRuntime.jsx(TopBanner.TopBanner, __spreadValues(__spreadValues({}, topBanner), others))
        ]
      })),
      /* @__PURE__ */ jsxRuntime.jsx(TopBarMenu.TopBarMenu, __spreadValues({
        items: topBarMenu,
        backgroundColor: primaryColor,
        isEditingMode
      }, others)),
      /* @__PURE__ */ jsxRuntime.jsx(Header, __spreadProps(__spreadValues({
        commonStyle,
        isEditingMode
      }, others), {
        children: /* @__PURE__ */ jsxRuntime.jsx(MainNavigationBar.MainNavigationBar, {
          logo: logoDesktop,
          layout,
          searchSlot,
          rightItemsSlot,
          showMenu,
          setShowMenu,
          primaryColor,
          border: categoryBlockRadius,
          maxWidth
        })
      }))
    ]
  });
};
const Header = styled__default["default"].header(
  ({ commonStyle, isEditingMode }) => `
    background-color: #fff;
    position: sticky;
    top: 0;
    z-index: ${isEditingMode ? "550" : "1040"};
    margin-bottom: 24px;
    ${coreRenderer.getStyle(commonStyle)}
    `
);
const Backdrop = styled__default["default"].div`
  position: fixed;
  inset: 0px;
  background: rgba(0, 0, 0, 0.5);
  transition-delay: 0.1s;
  z-index: 550;
`;

exports.OmniDesktopHeader = OmniDesktopHeader;


/***/ }),

/***/ 367746:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const TopBanner = (_a) => {
  var _b = _a, {
    timeVisibility,
    commonStyle
  } = _b, props = __objRest(_b, [
    "timeVisibility",
    "commonStyle"
  ]);
  if (!props.src)
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    children: /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadProps(__spreadValues({}, props), {
      commonStyle: __spreadProps(__spreadValues({}, commonStyle), { display: "block" })
    }))
  });
};
const Wrapper = styled__default["default"].div`
  position: relative;
  z-index: 550;
`;

exports.TopBanner = TopBanner;


/***/ }),

/***/ 108610:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var Link = __webpack_require__(20384);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const TopBarMenu = (_a) => {
  var _b = _a, { items, backgroundColor, isEditingMode } = _b, rest = __objRest(_b, ["items", "backgroundColor", "isEditingMode"]);
  const { globalData } = coreRenderer.useStore();
  const isPreviewMode = globalData == null ? void 0 : globalData.isPreviewMode;
  if (!(items == null ? void 0 : items.length))
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, __spreadProps(__spreadValues({
    backgroundColor
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsx(ContentWrapper, {
      maxWidth: rest.maxWidth,
      children: /* @__PURE__ */ jsxRuntime.jsx(Content, {
        children: items == null ? void 0 : items.map(({ event, icon, title }, index) => {
          var _a2;
          return /* @__PURE__ */ jsxRuntime.jsx("div", __spreadProps(__spreadValues({}, !isEditingMode && !isPreviewMode && coreRenderer.getTrackingData({
            isTrackContent: true,
            contentName: title,
            regionName: "topBarMenu",
            target: (_a2 = event == null ? void 0 : event.link) == null ? void 0 : _a2.href
          })), {
            children: /* @__PURE__ */ React.createElement(Link.Link, __spreadProps(__spreadValues({}, event), {
              key: index
            }), /* @__PURE__ */ jsxRuntime.jsxs(MenuItem, {
              children: [
                (icon == null ? void 0 : icon.src) && /* @__PURE__ */ jsxRuntime.jsx("img", {
                  src: icon.src,
                  style: {
                    width: 18,
                    height: 18
                  },
                  alt: title
                }),
                title
              ]
            }))
          }), index);
        })
      })
    })
  }));
};
const Wrapper = styled__default["default"].nav(
  ({ backgroundColor }) => `
  position: relative;
  min-height: 42px;
  ${backgroundColor && `background-color: ${backgroundColor};`}
  z-index: 550;
`
);
const ContentWrapper = styled__default["default"].div(
  ({ maxWidth }) => `
  max-width: ${maxWidth || "1232"}px;
  margin: 0 auto;
  text-align: right;
`
);
const Content = styled__default["default"].div`
  display: inline-flex;
  color: white;
  white-space: pre;
  max-width: 100%;
  overflow: hidden;
`;
const MenuItem = styled__default["default"].div`
  display: flex;
  align-items: center;
  padding: 0 1.25rem;
  cursor: pointer;
  height: 42px;
  gap: 0.5rem;
`;

exports.TopBarMenu = TopBarMenu;


/***/ }),

/***/ 658535:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var React = __webpack_require__(891987);
var clsx = __webpack_require__(981892);
var context = __webpack_require__(707998);
var MegaMenuContent = __webpack_require__(561099);
var menu = __webpack_require__(921977);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

const HorizontalCategories = ({ primaryColor }) => {
  const { isEditingMode = false, menu: menu$1 = [] } = context.useOmniHeader();
  const [activeMenu, setActiveMenu] = React.useState();
  if (!(menu$1 == null ? void 0 : menu$1.length))
    return null;
  const tree = menu.flattenToTree(menu$1.filter((el) => !el.isHidden));
  return /* @__PURE__ */ jsxRuntime.jsxs("div", {
    onMouseLeave: () => setActiveMenu(null),
    style: { position: "relative" },
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
        children: tree == null ? void 0 : tree.map((item, index) => /* @__PURE__ */ jsxRuntime.jsxs(CategoryItem, {
          href: menu.getUrlOfMenuItem(item, isEditingMode),
          primaryColor,
          onMouseEnter: () => {
            setActiveMenu(item);
          },
          children: [
            (item == null ? void 0 : item.iconUrl) && /* @__PURE__ */ jsxRuntime.jsx(StyledImage, {
              src: item == null ? void 0 : item.iconUrl,
              alt: item == null ? void 0 : item.name
            }),
            item == null ? void 0 : item.name
          ]
        }, index))
      }),
      activeMenu && /* @__PURE__ */ jsxRuntime.jsx(HorizontalMenuPanel, {
        className: clsx__default["default"]((activeMenu == null ? void 0 : activeMenu.children.length) > 0 ? ["active"] : null),
        children: /* @__PURE__ */ jsxRuntime.jsx(MegaMenuContent.MegaMenuContent, {
          menu: activeMenu,
          primaryColor,
          isEditingMode,
          type: "horizontal"
        })
      })
    ]
  });
};
const Wrapper = styled__default["default"].div`
  position: relative;
  height: 3rem;
  background-color: #ffffff;
  width: 100%;
  overflow: hidden;
`;
const HorizontalMenuPanel = styled__default["default"].div`
  background-color: rgb(255, 255, 255);
  display: flex;
  position: absolute;
  left: 0px;
  right: 0px;
  top: 3rem;
  z-index: 980;
  overflow: hidden;
  visibility: hidden;
  opacity: 0;
  transition: all 0.2s ease 0s;
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;

  &.active {
    visibility: visible;
    opacity: 1;
    filter: drop-shadow(rgba(0, 0, 0, 0.05) 0px 2px 4px);
  }
`;
const CategoryItem = styled__default["default"].a(
  ({ primaryColor }) => `
  cursor: pointer;
  padding: 0 0.75rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  float: left;
  position: relative;
  transition: all 0.3s ease;
  color: #434657;
  font-weight: 500;
  text-decoration: unset;
  font-size: 13px;
  line-height: 20px;
  
  &:hover {
    color: ${primaryColor};
  }

  &:hover::after {
    opacity: 1;
  }

  &::after {
    content: '';
    height: 2px;
    background-color: ${primaryColor};
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
}
`
);
const StyledImage = styled__default["default"].img`
  width: 22px;
  height: 22px;
  margin-right: 0.5rem;
`;

exports.HorizontalCategories = HorizontalCategories;


/***/ }),

/***/ 414027:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var ListIcon = __webpack_require__(206318);
var context = __webpack_require__(707998);
var constants = __webpack_require__(87013);
var MegaMenu = __webpack_require__(279111);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const VerticalCategories = ({ showMenu = false, setShowMenu, primaryColor, border }) => {
  const { isEditingMode = false, menu = [] } = context.useOmniHeader();
  if (!(menu == null ? void 0 : menu.length))
    return null;
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
        border,
        onClick: () => setShowMenu(!showMenu),
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(ListIcon.ListIcon, {}),
          /* @__PURE__ */ jsxRuntime.jsx("span", {
            style: { marginLeft: "0.5rem" },
            children: "Danh m\u1EE5c s\u1EA3n ph\u1EA9m"
          })
        ]
      }),
      showMenu && /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
        children: /* @__PURE__ */ jsxRuntime.jsx(MenuWrapper, {
          children: /* @__PURE__ */ jsxRuntime.jsx(MegaMenu.MegaMenu, {
            menu,
            primaryColor,
            isEditingMode
          })
        })
      })
    ]
  });
};
const Wrapper = styled__default["default"].div(
  ({ border = constants.DEFAULT_CATEGORY_BLOCK_RADIUS }) => `
  border: 1px solid rgb(224, 224, 224);
  cursor: pointer;
  border-radius: ${border}px;
  line-height: 1rem;
  padding: 0.4rem 0.75rem;
  text-align: center;
  color: rgb(130, 134, 158);
  margin: 0 0.5rem;
  user-select: none;
`
);
const MenuWrapper = styled__default["default"].div`
  position: absolute;
  inset: 0px auto auto 0px;
  visibility: visible;
  z-index: 999;
  transform: translate(16px, 72px) !important;
`;

exports.VerticalCategories = VerticalCategories;


/***/ }),

/***/ 43285:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);

const CloseIcon = () => {
  return /* @__PURE__ */ jsxRuntime.jsx("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntime.jsx("path", {
      d: "m4.21 4.387.083-.094a1 1 0 0 1 1.32-.083l.094.083L12 10.585l6.293-6.292a1 1 0 1 1 1.414 1.414L13.415 12l6.292 6.293a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.32.083l-.094-.083L12 13.415l-6.293 6.292a1 1 0 0 1-1.414-1.414L10.585 12 4.293 5.707a1 1 0 0 1-.083-1.32l.083-.094-.083.094Z",
      fill: "currentColor"
    })
  });
};

exports.CloseIcon = CloseIcon;


/***/ }),

/***/ 522129:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);

const DownIcon = () => {
  return /* @__PURE__ */ jsxRuntime.jsx("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntime.jsx("path", {
      d: "M4.293 8.293a1 1 0 0 1 1.414 0L12 14.586l6.293-6.293a1 1 0 1 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 0-1.414Z",
      fill: "#212121"
    })
  });
};

exports.DownIcon = DownIcon;


/***/ }),

/***/ 206318:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);

const ListIcon = () => {
  return /* @__PURE__ */ jsxRuntime.jsx("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntime.jsx("path", {
      d: "M3 17h18a1 1 0 0 1 .117 1.993L21 19H3a1 1 0 0 1-.117-1.993L3 17h18H3Zm0-6 18-.002a1 1 0 0 1 .117 1.993l-.117.007L3 13a1 1 0 0 1-.117-1.993L3 11l18-.002L3 11Zm0-6h18a1 1 0 0 1 .117 1.993L21 7H3a1 1 0 0 1-.117-1.993L3 5h18H3Z",
      fill: "currentColor"
    })
  });
};

exports.ListIcon = ListIcon;


/***/ }),

/***/ 47069:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);

const UpIcon = () => {
  return /* @__PURE__ */ jsxRuntime.jsx("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntime.jsx("path", {
      d: "M4.293 15.707a1 1 0 0 0 1.414 0L12 9.414l6.293 6.293a1 1 0 0 0 1.414-1.414l-7-7a1 1 0 0 0-1.414 0l-7 7a1 1 0 0 0 0 1.414Z",
      fill: "#212121"
    })
  });
};

exports.UpIcon = UpIcon;


/***/ }),

/***/ 670295:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var React = __webpack_require__(891987);
var context = __webpack_require__(707998);
var UpIcon = __webpack_require__(47069);
var DownIcon = __webpack_require__(522129);
var menu = __webpack_require__(921977);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const MenuItemTile = ({ item }) => {
  var _a, _b;
  const { isEditingMode = false } = context.useOmniHeader();
  const [open, setOpen] = React.useState(false);
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsxs(MenuItemWrapper, {
        onClick: () => setOpen(!open),
        children: [
          /* @__PURE__ */ jsxRuntime.jsxs(TitleWrapper, {
            href: menu.getUrlOfMenuItem(item, isEditingMode),
            children: [
              (item == null ? void 0 : item.iconUrl) && /* @__PURE__ */ jsxRuntime.jsx("img", {
                src: item == null ? void 0 : item.iconUrl,
                width: 18,
                height: 18,
                alt: item == null ? void 0 : item.name
              }),
              item == null ? void 0 : item.name
            ]
          }),
          ((_a = item == null ? void 0 : item.children) == null ? void 0 : _a.length) > 0 && /* @__PURE__ */ jsxRuntime.jsx("div", {
            children: open ? /* @__PURE__ */ jsxRuntime.jsx(UpIcon.UpIcon, {}) : /* @__PURE__ */ jsxRuntime.jsx(DownIcon.DownIcon, {})
          })
        ]
      }),
      open && /* @__PURE__ */ jsxRuntime.jsx("div", {
        style: { paddingLeft: "2em" },
        children: (_b = item == null ? void 0 : item.children) == null ? void 0 : _b.map((item2) => /* @__PURE__ */ jsxRuntime.jsx(MenuItemTile, {
          item: item2
        }))
      })
    ]
  });
};
const MenuItemWrapper = styled__default["default"].div`
  cursor: pointer;
  color: black;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0 0.5rem;
  overflow: hidden;
  padding: 10px 16px;
  border-top: 1px solid #eeeeee;

  a {
    color: black;
  }
`;
const TitleWrapper = styled__default["default"].a`
  display: flex;
  align-items: center;
  gap: 0.5em;
`;

exports.MenuItemTile = MenuItemTile;
exports.MenuItemWrapper = MenuItemWrapper;


/***/ }),

/***/ 545761:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var styled = __webpack_require__(212951);
var context = __webpack_require__(707998);
var CloseIcon = __webpack_require__(43285);
var MenuItemTile = __webpack_require__(670295);
var menu = __webpack_require__(921977);
var coreRenderer = __webpack_require__(85097);
var Link = __webpack_require__(20384);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MobileDrawer = ({ setMenuOpen, topBarMenu = [] }) => {
  const { menu: menu$1 = [] } = context.useOmniHeader();
  const tree = menu.flattenToTree((menu$1 || []).filter((el) => !el.isHidden));
  return /* @__PURE__ */ jsxRuntime.jsxs(Drawer, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsxs(Menu, {
        children: [
          /* @__PURE__ */ jsxRuntime.jsx("div", {
            style: {
              display: "flex",
              padding: "1em"
            },
            children: /* @__PURE__ */ jsxRuntime.jsx(CloseDrawer, {
              onClick: () => setMenuOpen(false),
              children: /* @__PURE__ */ jsxRuntime.jsx(CloseIcon.CloseIcon, {})
            })
          }),
          tree == null ? void 0 : tree.map((item, index) => /* @__PURE__ */ jsxRuntime.jsx(MenuItemTile.MenuItemTile, {
            item
          }, index))
        ]
      }),
      /* @__PURE__ */ jsxRuntime.jsx(TopBarMenu, {
        children: topBarMenu == null ? void 0 : topBarMenu.map(({ event, icon, title }, index) => /* @__PURE__ */ React.createElement(StyledLink, __spreadProps(__spreadValues({}, event), {
          key: index
        }), /* @__PURE__ */ jsxRuntime.jsxs(TopBarItem, {
          children: [
            (icon == null ? void 0 : icon.src) && /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadProps(__spreadValues({}, icon), {
              commonStyle: {
                width: 18,
                height: 18
              }
            })),
            title
          ]
        })))
      })
    ]
  });
};
const Menu = styled__default["default"].div`
  background-color: white;
`;
const TopBarMenu = styled__default["default"].div`
  background-color: white;
  margin-top: 1em;
`;
const Drawer = styled__default["default"].div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #f8f8fc;
  z-index: 1060;
`;
const CloseDrawer = styled__default["default"].div`
  display: inline-block;
  cursor: pointer;
  margin-left: auto;
`;
const StyledLink = styled__default["default"](Link.Link)`
  display: flex;
`;
const TopBarItem = styled__default["default"].div`
  cursor: pointer;
  color: black;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.5rem;
  overflow: hidden;
  padding: 10px 16px;
  border-top: 1px solid #eeeeee;

  a {
    color: black;
  }
`;

exports.MobileDrawer = MobileDrawer;


/***/ }),

/***/ 288727:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const MobileSearchBar = ({
  searchSlot,
  rightItemsSlot,
  isRightItemsVisible,
  backButtonHeaderMobile
}) => {
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
    children: [
      !!backButtonHeaderMobile && backButtonHeaderMobile,
      searchSlot,
      isRightItemsVisible && rightItemsSlot
    ]
  });
};
const Wrapper = styled__default["default"].div`
  margin: 0 1rem;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  & > *:not(:first-child) {
    margin-left: 1rem;
  }
`;

exports.MobileSearchBar = MobileSearchBar;


/***/ }),

/***/ 69076:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var React = __webpack_require__(891987);
var useIntersectionObserver = __webpack_require__(90304);
var coreRenderer = __webpack_require__(85097);
var context = __webpack_require__(707998);
var MobileDrawer = __webpack_require__(545761);
var MobileSearchBar = __webpack_require__(288727);
var renderDynamicSlot = __webpack_require__(958220);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const OmniMobileHeader = (_a) => {
  var _b = _a, {
    ssrData
  } = _b, rest = __objRest(_b, [
    "ssrData"
  ]);
  const { isEditingMode = false } = context.useOmniHeader();
  const { topBarMenu = [], logoMobile } = rest || {};
  const { mappingDynamicSlots } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(
    rest,
    "mobile"
  ), { primaryColor, commonStyle } = _a2, others = __objRest(_a2, ["primaryColor", "commonStyle"]);
  const [isMenuOpen, setMenuOpen] = React__default["default"].useState(false);
  const headerRef = React.useRef(null);
  const [isVisible] = useIntersectionObserver.useIntersectionObserver({
    elementRef: headerRef,
    threshold: 0
  });
  const searchSlot = renderDynamicSlot.renderDynamicSlot(
    `header_search_mobile`,
    mappingDynamicSlots,
    ssrData
  );
  const searchBarRightItemsSlot = renderDynamicSlot.renderDynamicSlot(
    `search_bar_right_items_mobile`,
    mappingDynamicSlots,
    ssrData
  );
  const backButtonHeaderMobile = renderDynamicSlot.renderDynamicSlot(
    `back_button_header_mobile`,
    mappingDynamicSlots,
    ssrData
  );
  const headerRightItemsSlot = renderDynamicSlot.renderDynamicSlot(
    `header_right_items_mobile`,
    mappingDynamicSlots,
    ssrData
  );
  const locationPickerHeaderMobile = renderDynamicSlot.renderDynamicSlot(
    `location_picker_header_mobile`,
    mappingDynamicSlots,
    ssrData
  );
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      isMenuOpen && /* @__PURE__ */ jsxRuntime.jsx(MobileDrawer.MobileDrawer, {
        setMenuOpen,
        topBarMenu
      }),
      !backButtonHeaderMobile && /* @__PURE__ */ jsxRuntime.jsx(Wrapper, __spreadProps(__spreadValues({
        ref: headerRef,
        primaryColor,
        commonStyle
      }, others), {
        children: /* @__PURE__ */ jsxRuntime.jsxs(NavigationBar, {
          children: [
            /* @__PURE__ */ jsxRuntime.jsxs(LogoWrapper, {
              children: [
                false,
                (logoMobile == null ? void 0 : logoMobile.src) && /* @__PURE__ */ jsxRuntime.jsx(Logo, {
                  href: isEditingMode ? null : "/",
                  children: /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadProps(__spreadValues({}, logoMobile), {
                    alt: "logo"
                  }))
                })
              ]
            }),
            headerRightItemsSlot
          ]
        })
      })),
      /* @__PURE__ */ jsxRuntime.jsx(SearchBarWrapper, __spreadProps(__spreadValues({
        primaryColor,
        isEditingMode
      }, others), {
        children: /* @__PURE__ */ jsxRuntime.jsx(MobileSearchBar.MobileSearchBar, {
          searchSlot,
          rightItemsSlot: searchBarRightItemsSlot,
          isRightItemsVisible: !isVisible,
          backButtonHeaderMobile
        })
      })),
      locationPickerHeaderMobile
    ]
  });
};
const Wrapper = styled__default["default"].header(
  ({ commonStyle, primaryColor }) => `
  position: relative; 
  background-color: ${primaryColor};
  ${coreRenderer.getStyle(commonStyle)}
        `
);
const NavigationBar = styled__default["default"].nav`
  display: flex;
  padding: 8px 16px 0 16px;
  color: white;
  justify-content: space-between;
  align-items: center;
`;
const SearchBarWrapper = styled__default["default"].div(
  ({ primaryColor, isEditingMode }) => `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3.5rem;
  background: ${primaryColor};
  position: sticky;
  top: 0;
  margin-bottom: 8px;
  ${isEditingMode ? "" : "z-index: 1040;"}
`
);
styled__default["default"].div`
  margin-right: 0.5em;
  cursor: pointer;
`;
const Logo = styled__default["default"].a`
  user-select: none;
`;
const LogoWrapper = styled__default["default"].div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
`;

exports.OmniMobileHeader = OmniMobileHeader;


/***/ }),

/***/ 669484:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var coreRenderer = __webpack_require__(85097);
var useMediaQuery = __webpack_require__(548834);
var context = __webpack_require__(707998);
var OmniMobileHeader = __webpack_require__(69076);
var OmniDesktopHeader = __webpack_require__(206573);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const OmniHeader = (props) => {
  const { isEditingMode } = props;
  const { device, globalData } = coreRenderer.useStore();
  const menu = isEditingMode ? props == null ? void 0 : props.menu : (globalData == null ? void 0 : globalData.menu) || [];
  const isMobile = useMediaQuery.useMediaQuery("(max-width: 768px)");
  const renderByDevice = () => {
    if (device === "mobile" || isMobile)
      return /* @__PURE__ */ jsxRuntime.jsx(OmniMobileHeader.OmniMobileHeader, __spreadProps(__spreadValues({}, props), {
        menu
      }));
    return /* @__PURE__ */ jsxRuntime.jsx(OmniDesktopHeader.OmniDesktopHeader, __spreadProps(__spreadValues({}, props), {
      menu
    }));
  };
  return /* @__PURE__ */ jsxRuntime.jsx(context.OmniHeaderProvider, {
    value: { menu, isEditingMode },
    children: renderByDevice()
  });
};
OmniHeader.displayName = "Omni_Header";

exports.OmniHeader = OmniHeader;


/***/ }),

/***/ 941322:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var icons = __webpack_require__(143599);
var coreRenderer = __webpack_require__(85097);
var Container = __webpack_require__(341018);
var renderDynamicSlot = __webpack_require__(958220);
var grid = __webpack_require__(860046);
var BlockHeader = __webpack_require__(951297);
var renderLink = __webpack_require__(284727);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const OmniProductList = (_a) => {
  var _b = _a, {
    ssrData,
    isEditingMode
  } = _b, restProps = __objRest(_b, [
    "ssrData",
    "isEditingMode"
  ]);
  const { device, mappingDynamicSlots } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    collectionSlug,
    commonStyle,
    title,
    titleStyle,
    viewMoreUrl,
    viewMoreStyle
  } = _a2, rest = __objRest(_a2, [
    "collectionSlug",
    "commonStyle",
    "title",
    "titleStyle",
    "viewMoreUrl",
    "viewMoreStyle"
  ]);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  const renderViewAllLink = () => {
    if (!viewMoreUrl)
      return null;
    const content = /* @__PURE__ */ jsxRuntime.jsxs(ViewAll, {
      commonStyle: viewMoreStyle,
      children: [
        "Xem t\u1EA5t c\u1EA3 ",
        /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
          name: "RightOutlined"
        })
      ]
    });
    return renderLink.renderLink(viewMoreUrl, content, isEditingMode);
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: { maxWidth: grid.DEFAULT_MAX_WIDTH, padding, margin }
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      commonStyle: restStyle,
      children: [
        !!title && /* @__PURE__ */ jsxRuntime.jsxs(Header, {
          device,
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(StyledTitle, {
              commonStyle: titleStyle,
              children: title
            }),
            renderViewAllLink()
          ]
        }),
        renderDynamicSlot.renderDynamicSlot(
          `product_grid_${device}`,
          mappingDynamicSlots,
          ssrData,
          {
            collectionSlug,
            config: {
              regionName: "forYouListProduct"
            }
          }
        )
      ]
    })
  }));
};
OmniProductList.displayName = "Omni_ProductList";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  border-radius: 0.5rem;
  background: #ffffff;
  overflow: hidden;
  ${coreRenderer.getStyle(commonStyle)}
`
);
const Header = styled__default["default"](BlockHeader.BlockHeader)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const StyledTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  flex: 1;
  margin-right: 8px;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  ${coreRenderer.getStyle(commonStyle)}
`
);
const ViewAll = styled__default["default"].div(
  ({ commonStyle }) => `
  display: flex;
  align-items: center;
  ${coreRenderer.getStyle(commonStyle)}
`
);

exports.OmniProductList = OmniProductList;


/***/ }),

/***/ 553347:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const DEFAULT_RADIUS = 16;
const PRODUCT_WRAPPER_PADDING = 8;
const DEFAULT_PRODUCT_SLIDER_WITH_BANNER_WEB = {
  syncDeviceStyle: true,
  responsive: { hiddenMd: true },
  mobile: {
    titleStyle: { color: "#ffffff", background: "#0200BC" },
    viewMoreStyle: { color: "#ffffff" },
    blockStyle: { background: "#0200BC" }
  },
  desktop: {
    titleStyle: { color: "#ffffff", background: "#0200BC" },
    viewMoreStyle: { color: "#ffffff" },
    blockStyle: { background: "#0200BC" }
  },
  title: "Product Slider Title",
  maxWidth: 1600,
  radius: DEFAULT_RADIUS
};

exports.DEFAULT_PRODUCT_SLIDER_WITH_BANNER_WEB = DEFAULT_PRODUCT_SLIDER_WITH_BANNER_WEB;
exports.DEFAULT_RADIUS = DEFAULT_RADIUS;
exports.PRODUCT_WRAPPER_PADDING = PRODUCT_WRAPPER_PADDING;


/***/ }),

/***/ 912260:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var icons = __webpack_require__(143599);
var coreRenderer = __webpack_require__(85097);
var constants = __webpack_require__(553347);
var Container = __webpack_require__(341018);
var grid = __webpack_require__(860046);
var BlockHeader = __webpack_require__(951297);
var Row = __webpack_require__(346761);
var renderLink = __webpack_require__(284727);
var renderDynamicSlot = __webpack_require__(958220);
var getStyles = __webpack_require__(934512);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductSliderWithBannerWeb = (_a) => {
  var _b = _a, {
    isEditingMode = false,
    banners = [],
    title,
    ssrData,
    viewMoreUrl
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "banners",
    "title",
    "ssrData",
    "viewMoreUrl"
  ]);
  var _b2;
  const { device, mappingDynamicSlots } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    commonStyle,
    titleStyle,
    viewMoreStyle,
    maxWidth,
    radius = constants.DEFAULT_RADIUS,
    blockStyle,
    collectionSlug
  } = _a2, rest = __objRest(_a2, [
    "commonStyle",
    "titleStyle",
    "viewMoreStyle",
    "maxWidth",
    "radius",
    "blockStyle",
    "collectionSlug"
  ]);
  const viewMoreContent = /* @__PURE__ */ jsxRuntime.jsxs(StyledViewAll, {
    color: viewMoreStyle == null ? void 0 : viewMoreStyle.color,
    children: [
      "Xem t\u1EA5t c\u1EA3",
      " ",
      /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
        name: "RightOutlined",
        color: viewMoreStyle == null ? void 0 : viewMoreStyle.color,
        style: {
          fontSize: 20
        }
      })
    ]
  });
  const hasBanner = banners && banners.length > 0;
  const innerBorderRadius = radius - constants.PRODUCT_WRAPPER_PADDING;
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: __spreadValues({
      maxWidth
    }, commonStyle)
  }, rest), {
    maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH_1600,
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      radius,
      children: [
        (isEditingMode || !isEditingMode && hasBanner) && /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
          isEditingMode,
          src: hasBanner ? (_b2 = banners[0]) == null ? void 0 : _b2.src : "https://lh3.googleusercontent.com/5j_eWpVbAWOPHpd5RCylcaFR6cg0bFFDjFqYnh0ASIsEJScCiLfafyAI6lkToXn-ihjJEQCkWSX-pW2C-7ZW6qxwJhsGcY8",
          alt: "Image",
          commonStyle: { objectFit: "contain", width: "100%" }
        }),
        /* @__PURE__ */ jsxRuntime.jsx(HeaderWrapper, {
          commonStyle: __spreadValues(__spreadValues({}, titleStyle), hasBanner ? { borderRadius: 0 } : {
            borderRadius: `${radius}px ${radius}px 0 0`
          }),
          children: /* @__PURE__ */ jsxRuntime.jsx(BlockHeader.BlockHeader, {
            device,
            children: /* @__PURE__ */ jsxRuntime.jsxs(Row.Row, {
              justify: "space-between",
              children: [
                /* @__PURE__ */ jsxRuntime.jsx(StyledTitle, {
                  color: titleStyle == null ? void 0 : titleStyle.color,
                  children: title
                }),
                !!viewMoreUrl && /* @__PURE__ */ jsxRuntime.jsx("div", {
                  children: renderLink.renderLink(viewMoreUrl, viewMoreContent, isEditingMode)
                })
              ]
            })
          })
        }),
        /* @__PURE__ */ jsxRuntime.jsx(ProductWrapper, {
          commonStyle: blockStyle,
          radius,
          children: /* @__PURE__ */ jsxRuntime.jsx("div", {
            style: {
              flexGrow: 1,
              width: "100%",
              backgroundColor: "#fff",
              borderRadius: `${innerBorderRadius >= 0 ? innerBorderRadius : 0}px`,
              padding: 8
            },
            children: renderDynamicSlot.renderDynamicSlot(
              `new_layout_product_carousel_${device}`,
              mappingDynamicSlots,
              ssrData,
              { collectionSlug, config: { maxWidth } }
            )
          })
        })
      ]
    })
  }));
};
const Wrapper = styled__default["default"].div(
  ({ radius }) => `
  position: relative;
  overflow: hidden;
  border-radius: ${radius}px;
`
);
const HeaderWrapper = styled__default["default"].div(
  ({ commonStyle }) => getStyles.getStyle(commonStyle)
);
const StyledTitle = styled__default["default"].div(
  ({ color }) => `
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  transition: color 0.3s ease 0s;
  color: ${color}
`
);
const StyledViewAll = styled__default["default"].div(
  ({ color }) => `
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  transition: color 0.3s ease 0s;
  color: ${color}
`
);
const ProductWrapper = styled__default["default"].div(
  ({ radius, commonStyle }) => `
  flex-grow: 1;
  width: 100%;
  border-radius: 0 0 ${radius}px ${radius}px;
  padding: ${constants.PRODUCT_WRAPPER_PADDING}px;
  color: unset !important;
  ${getStyles.getStyle(commonStyle)},
`
);
ProductSliderWithBannerWeb.displayName = "omni_productsliderwithbanner_web";

exports.ProductSliderWithBannerWeb = ProductSliderWithBannerWeb;


/***/ }),

/***/ 871164:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var icons = __webpack_require__(143599);
var grid = __webpack_require__(860046);
var Container = __webpack_require__(341018);
var Slider = __webpack_require__(183594);
var getStyles = __webpack_require__(934512);
var BlockHeader = __webpack_require__(951297);
var renderLink = __webpack_require__(284727);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const { cardDefaultImage: defaultImage } = coreRenderer.mappingAssets;
const RecommendBrand = (_a) => {
  var _b = _a, {
    isEditingMode
  } = _b, restProps = __objRest(_b, [
    "isEditingMode"
  ]);
  var _c;
  const { device } = coreRenderer.useStore();
  const isDesktop = device === "desktop";
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    commonStyle,
    title,
    titleStyle,
    altStyle,
    showAlt = true,
    items,
    autoSwipeTimeMilliseconds,
    viewMoreUrl,
    showDescription,
    descriptionStyle,
    viewMoreStyle,
    maxWidth = grid.DEFAULT_MAX_WIDTH
  } = _a2, rest = __objRest(_a2, [
    "commonStyle",
    "title",
    "titleStyle",
    "altStyle",
    "showAlt",
    "items",
    "autoSwipeTimeMilliseconds",
    "viewMoreUrl",
    "showDescription",
    "descriptionStyle",
    "viewMoreStyle",
    "maxWidth"
  ]);
  const { displayItems } = coreRenderer.useTimeVisibility(items, isEditingMode);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  const renderBrandItem = (item, index) => {
    const { event, googleImageParams, src, alt, description } = item;
    const content = /* @__PURE__ */ jsxRuntime.jsxs(BrandItem, {
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(ImageWrapper, {
          children: /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadValues({
            googleImageParams,
            src: src || defaultImage,
            alt: alt || "Brand",
            isEditingMode,
            commonStyle: __spreadValues({
              width: "100%",
              borderRadius: 8,
              objectFit: "cover"
            }, isDesktop ? {
              height: "140px",
              hover: { zoom: 103 }
            } : {
              height: "120px"
            })
          }, !isEditingMode && coreRenderer.getTrackingData({
            isTrackContent: true,
            regionName: "topBrands",
            contentName: alt,
            index,
            target: coreRenderer.getTargetOfTrackingFromEvent(event)
          })))
        }),
        showDescription && !!description && /* @__PURE__ */ jsxRuntime.jsx(BrandDescription, {
          commonStyle: descriptionStyle,
          children: description
        }),
        showAlt && /* @__PURE__ */ jsxRuntime.jsx(BrandTitle, {
          commonStyle: altStyle,
          children: alt
        })
      ]
    });
    return renderLink.renderLink(event, content, isEditingMode, index);
  };
  const renderViewAllLink = () => {
    if (!viewMoreUrl)
      return null;
    const content = /* @__PURE__ */ jsxRuntime.jsxs(ViewAll, {
      commonStyle: viewMoreStyle,
      children: [
        "Xem t\u1EA5t c\u1EA3 ",
        /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
          name: "RightOutlined"
        })
      ]
    });
    return renderLink.renderLink(viewMoreUrl, content, isEditingMode);
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: { maxWidth, padding, margin }
  }, rest), {
    maxWidth,
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      commonStyle: restStyle,
      children: [
        /* @__PURE__ */ jsxRuntime.jsxs(Header, {
          device,
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(StyledTitle, {
              commonStyle: titleStyle,
              children: title
            }),
            !!viewMoreUrl && renderViewAllLink()
          ]
        }),
        /* @__PURE__ */ jsxRuntime.jsx(RecommendBrandWrapper, {
          children: /* @__PURE__ */ jsxRuntime.jsx(Slider.Slider, __spreadProps(__spreadValues({
            allowTouchMove: !isEditingMode
          }, isDesktop ? { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 8 } : { slidesPerView: 1.5, spaceBetween: 16 }), {
            autoplay: !!autoSwipeTimeMilliseconds,
            speed: autoSwipeTimeMilliseconds,
            children: (_c = displayItems == null ? void 0 : displayItems.map) == null ? void 0 : _c.call(displayItems, (item, index) => renderBrandItem(item, index))
          }))
        })
      ]
    })
  }));
};
RecommendBrand.displayName = "Omni_BannerSlider_2";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => getStyles.getStyle(commonStyle)
);
const StyledTitle = styled__default["default"].div(
  ({ commonStyle }) => `
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    ${getStyles.getStyle(commonStyle)}
  `
);
const RecommendBrandWrapper = styled__default["default"].div`
  width: 100%;
  padding: 12px 16px;
`;
const ImageWrapper = styled__default["default"].div`
  width: 100%;
  height: 100%;
`;
const BrandItem = styled__default["default"].div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
`;
const BrandDescription = styled__default["default"].div(
  ({ commonStyle }) => `
  margin-top: 0.5rem;
  font-size: 15px;
  line-height: 20px;
  font-weight: 500;
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  ${getStyles.getStyle(commonStyle)}
`
);
const BrandTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  margin-top: 0.5rem;
  font-size: 15px;
  line-height: 20px;
  font-weight: 500;
  ${getStyles.getStyle(commonStyle)}
`
);
const Header = styled__default["default"](BlockHeader.BlockHeader)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const ViewAll = styled__default["default"].span(
  ({ commonStyle }) => `
    display: flex;
    align-items: center;
    ${getStyles.getStyle(commonStyle)}
  `
);

exports.RecommendBrand = RecommendBrand;


/***/ }),

/***/ 955080:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var Container = __webpack_require__(341018);
var BlockHeader = __webpack_require__(951297);
var Slider = __webpack_require__(183594);
var renderLink = __webpack_require__(284727);
var grid = __webpack_require__(860046);
var getStyles = __webpack_require__(934512);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const { cardDefaultImage: defaultImage } = coreRenderer.mappingAssets;
const RecommendCategory = (_a) => {
  var _b = _a, {
    isEditingMode = false,
    maxWidth
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "maxWidth"
  ]);
  const { device } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    title,
    items,
    commonStyle,
    altStyle,
    titleStyle,
    autoSwipeTimeMilliseconds
  } = _a2, rest = __objRest(_a2, [
    "title",
    "items",
    "commonStyle",
    "altStyle",
    "titleStyle",
    "autoSwipeTimeMilliseconds"
  ]);
  const { displayItems } = coreRenderer.useTimeVisibility(items, isEditingMode);
  if (!(displayItems == null ? void 0 : displayItems.length) && !isEditingMode)
    return null;
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: { maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH, padding, margin }
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      commonStyle: restStyle,
      children: [
        !!title && /* @__PURE__ */ jsxRuntime.jsx(BlockHeader.BlockHeader, {
          device,
          children: /* @__PURE__ */ jsxRuntime.jsx(StyledTitle, {
            commonStyle: titleStyle,
            children: title
          })
        }),
        /* @__PURE__ */ jsxRuntime.jsx(CategoryWrapper, {
          children: /* @__PURE__ */ jsxRuntime.jsx(Slider.Slider, __spreadProps(__spreadValues({
            allowTouchMove: !isEditingMode
          }, device === "desktop" ? { slidesPerView: 6, slidesPerGroup: 6, spaceBetween: 24 } : {
            slidesPerView: 2.5,
            slidesPerColumn: 2,
            spaceBetween: 16,
            isMultipleRows: true
          }), {
            autoplay: !!autoSwipeTimeMilliseconds,
            speed: autoSwipeTimeMilliseconds,
            children: displayItems == null ? void 0 : displayItems.map(({ src, event, alt }, index) => {
              const content = /* @__PURE__ */ jsxRuntime.jsxs(CategoryItem, __spreadProps(__spreadValues({}, !isEditingMode && coreRenderer.getTrackingData({
                isTrackContent: true,
                regionName: "topCategories",
                contentName: title,
                target: coreRenderer.getTargetOfTrackingFromEvent(event),
                index
              })), {
                children: [
                  /* @__PURE__ */ jsxRuntime.jsx(StyledImage, {
                    src: src || defaultImage,
                    alt: alt || "Image",
                    commonStyle: {
                      borderRadius: 12,
                      objectFit: "contain",
                      width: "100%"
                    }
                  }),
                  !!alt && /* @__PURE__ */ jsxRuntime.jsx(CategoryTitle, {
                    commonStyle: altStyle,
                    children: alt
                  })
                ]
              }), index);
              return renderLink.renderLink(event, content, isEditingMode, index);
            })
          }))
        })
      ]
    })
  }));
};
RecommendCategory.displayName = "Omni_RecommendCategory";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => getStyles.getStyle(commonStyle)
);
const StyledTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  transition: color 0.3s ease 0s;
  ${getStyles.getStyle(commonStyle)}
`
);
const CategoryWrapper = styled__default["default"].div`
  padding: 12px 16px;
`;
const CategoryItem = styled__default["default"].div`
  flex-direction: column;
  position: relative;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
`;
const StyledImage = styled__default["default"](coreRenderer.ImageBase)`
  border-radius: 12px;
  box-shadow: rgb(217 217 217) 0px 4px 8px 0px;
`;
const CategoryTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  font-size: 13px;
  line-height: 20px;
  overflow: hidden;
  -webkit-box-orient: vertical;
  transition: color 0.3s ease 0s;
  z-index: 1;
  background-color: white;
  padding: 3px 10px;
  border-radius: 12px;
  max-width: 90%;
  box-shadow: rgb(217 217 217) 0px 4px 8px 0px;
  position: absolute;
  bottom: 0;
  transform: translateY(50%);
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  font-weight: 400;
  ${getStyles.getStyle(commonStyle)}
`
);

exports.RecommendCategory = RecommendCategory;


/***/ }),

/***/ 909534:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var antd = __webpack_require__(610314);
var image = __webpack_require__(478130);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const RecommendProductItem = (props) => {
  const { src: imageUrl, buttonTitle, onClick, title } = props;
  const { device } = coreRenderer.useStore();
  const isMobile = device === "mobile";
  const imageDefault = image.generatePlaceholderImage({
    width: isMobile ? 140 : 224,
    height: isMobile ? 180 : 290
  });
  const width = isMobile ? 140 : 224;
  const imageHeight = isMobile ? 180 : 290;
  const fontSizeLabel = isMobile ? 12 : 13;
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
    width,
    children: [
      /* @__PURE__ */ jsxRuntime.jsxs(ImageWrapper, {
        height: imageHeight,
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
            commonStyle: {
              width: "100%",
              objectFit: "cover",
              marginLeft: "auto",
              marginRight: "auto",
              height: isMobile ? "180px" : "290px"
            },
            src: imageUrl || imageDefault
          }),
          !!title && /* @__PURE__ */ jsxRuntime.jsx(LabelWrapper, {
            children: /* @__PURE__ */ jsxRuntime.jsx(Label, {
              fontSize: fontSizeLabel,
              ellipsis: true,
              children: title
            })
          })
        ]
      }),
      /* @__PURE__ */ jsxRuntime.jsx(WrapperButton, {
        children: /* @__PURE__ */ jsxRuntime.jsx(StyledButton, {
          onClick,
          children: /* @__PURE__ */ jsxRuntime.jsx(ClampText, {
            children: buttonTitle
          })
        })
      })
    ]
  });
};
const ImageWrapper = styled__default["default"].div(
  ({ height }) => `
  width: 100%;
  position: relative;
  height: ${height}px;
`
);
const Label = styled__default["default"](antd.Typography.Text)(
  ({ fontSize }) => `
  font-size: ${fontSize}px;
  color: white;
  font-weight: 400;
  padding-left: 4px;
  white-space: nowrap;
`
);
const LabelWrapper = styled__default["default"].div`
  background: #000000b2;
  position: absolute;
  bottom: 4px;
  height: 28px !important;
  width: calc(100% - 12px);
  margin-left: 8px;
  margin-right: 8px;
  border-radius: 8px;
  line-height: 28px;
  display: flex;
  align-items: center;
`;
const Wrapper = styled__default["default"].div(
  ({ width }) => `
  position: relative;
  overflow: clip;
  width: ${width}px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;
`
);
const WrapperButton = styled__default["default"].div`
  padding: 8px;
  width: 100%;
`;
const StyledButton = styled__default["default"].div`
  font-size: 13px;
  font-weight: '400';
  width: 100%;
  cursor: pointer;
  background: #0200bc;
  color: #ffffff;
  border-radius: 9999px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  word-wrap: break-word;
  padding: 8px;
  text-align: center;
  white-space: break-spaces;
`;
const ClampText = styled__default["default"].p`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

exports.RecommendProductItem = RecommendProductItem;


/***/ }),

/***/ 780528:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const RecommendProductTabs = (props) => {
  const { items, activeItem, onChange, activeTabColor } = props;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    children: /* @__PURE__ */ jsxRuntime.jsx(TabList, {
      children: items == null ? void 0 : items.map((item) => {
        return /* @__PURE__ */ jsxRuntime.jsx(WrapperItem, {
          onClick: () => onChange(item.id),
          children: /* @__PURE__ */ jsxRuntime.jsx(StyledTabbar, {
            activeTabColor,
            isActive: item.id === activeItem.id,
            children: item.title
          }, item.id)
        });
      })
    })
  });
};
const Wrapper = styled__default["default"].div`
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
  overflow-x: auto;
  white-space: nowrap;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  margin-bottom: 16px;
`;
const TabList = styled__default["default"].div`
  display: flex;
`;
const StyledTabbar = styled__default["default"].div(
  ({ isActive, activeTabColor }) => `
  padding-top: 12px;
  padding-bottom: 12px;
  ${isActive ? `border-bottom: 2px solid ${activeTabColor};` : ""}
  ${isActive ? `color: ${activeTabColor};` : ""}
  font-weight: 400;
  font-size: 14px;
`
);
const WrapperItem = styled__default["default"].div`
  padding-right: 32px;
  cursor: pointer;
`;

exports.RecommendProductTabs = RecommendProductTabs;


/***/ }),

/***/ 19514:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var uuid = __webpack_require__(596839);
var style = __webpack_require__(667925);
var grid = __webpack_require__(860046);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const defaultProductGroupItem = {
  title: "Nguy\xEAn li\u1EC7u ch\xEDnh",
  productSkus: ""
};
const defaultGroup = [
  {
    imageUrl: "https://lh3.googleusercontent.com/KlpDRUo6wrfd2zgWBfyLdA8dyWpUkMdYxZYUtMuMihjkVoAOhS5KYhVWLj80BoKaFBBCEPiRIR8HTOQE2tAjXP9zNuULoMvU",
    productGroups: [defaultProductGroupItem, defaultProductGroupItem]
  },
  {
    imageUrl: "https://lh3.googleusercontent.com/mrJaG0cJe9Yt_MgEZKs5hXJvaJvgchGFXN2PN0DU4oMqCywFfXBeIPRdt7CQF9Kl3X2khbh6KZwx6qvmHTIRu5eaDmKFizY0",
    productGroups: [defaultProductGroupItem, defaultProductGroupItem]
  },
  {
    imageUrl: "https://lh3.googleusercontent.com/qUXZ145LXwYy320wuf8wEKsrEOIZgZjGmu4dQmKqhd9wVckhCdHMhyQICNNYRG7j26juXgrWQprkYsYqKpB5PZ849dA7fw8V",
    productGroups: [defaultProductGroupItem, defaultProductGroupItem]
  },
  {
    imageUrl: "https://lh3.googleusercontent.com/TSevtOCIrghz0P7UnRBco_3uxMvapwhzp56_SzTl808vAOrNCiB6fJKdOhoi1h4gcePtThnLP3upG6U4RGOSQLY95iMp6xNr",
    productGroups: [defaultProductGroupItem, defaultProductGroupItem]
  },
  {
    imageUrl: "https://lh3.googleusercontent.com/KlpDRUo6wrfd2zgWBfyLdA8dyWpUkMdYxZYUtMuMihjkVoAOhS5KYhVWLj80BoKaFBBCEPiRIR8HTOQE2tAjXP9zNuULoMvU",
    productGroups: [defaultProductGroupItem, defaultProductGroupItem]
  }
];
const DEFAULT_RECOMMEND_PRODUCT_ITEMS_DATA = {
  items: [
    {
      id: uuid.v4(),
      title: "M\xF3n chi\xEAn-x\xE0o",
      groups: defaultGroup
    },
    {
      id: uuid.v4(),
      title: "M\xF3n h\u1EA5p",
      groups: defaultGroup
    },
    {
      id: uuid.v4(),
      title: "M\xF3n lu\u1ED9c",
      groups: defaultGroup
    },
    {
      id: uuid.v4(),
      title: "M\xF3n n\u01B0\u1EDBng",
      groups: defaultGroup
    },
    {
      id: uuid.v4(),
      title: "T\u1ED1i \u1EA5m c\xFAng",
      groups: defaultGroup
    },
    {
      id: uuid.v4(),
      title: "S\xE1ng t\u1EC9nh t\xE1o",
      groups: defaultGroup
    }
  ]
};
const DEFAULT_RECOMMEND_PRODUCT = __spreadProps(__spreadValues({
  syncDeviceStyle: true,
  title: "KH\xC1M PH\xC1 M\xD3N NGON",
  buttonTitle: "Mua nguy\xEAn li\u1EC7u",
  radius: "16",
  maxWidth: grid.DEFAULT_MAX_WIDTH
}, DEFAULT_RECOMMEND_PRODUCT_ITEMS_DATA), {
  desktop: {
    commonStyle: __spreadProps(__spreadValues({}, style.DESKTOP_COMMON_STYLE), {
      padding: {
        left: 16,
        right: 16,
        top: 16,
        bottom: 16
      }
    }),
    titleStyle: {
      color: "#000000"
    },
    tabStyle: {
      activeTabStyle: "#1677FF"
    },
    backgroundColor: "#ffffff"
  },
  mobile: {
    commonStyle: __spreadProps(__spreadValues({}, style.MOBILE_COMMON_STYLE), {
      padding: {
        left: 16,
        right: 16
      }
    }),
    titleStyle: {
      color: "#000000"
    },
    tabStyle: {
      activeTabStyle: "#1677FF",
      backgroundColor: "#ffffff"
    }
  }
});
const RECOMMEND_PRODUCT_DEFAULT_SPACING_DESKTOP = 16;
const RECOMMEND_PRODUCT_DEFAULT_SPACING_MOBILE = 8;
const WIDTH_OF_MODAL_SELECT_PRODUCT = 1020;

exports.DEFAULT_RECOMMEND_PRODUCT = DEFAULT_RECOMMEND_PRODUCT;
exports.RECOMMEND_PRODUCT_DEFAULT_SPACING_DESKTOP = RECOMMEND_PRODUCT_DEFAULT_SPACING_DESKTOP;
exports.RECOMMEND_PRODUCT_DEFAULT_SPACING_MOBILE = RECOMMEND_PRODUCT_DEFAULT_SPACING_MOBILE;
exports.WIDTH_OF_MODAL_SELECT_PRODUCT = WIDTH_OF_MODAL_SELECT_PRODUCT;


/***/ }),

/***/ 280503:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var antd = __webpack_require__(610314);
var React = __webpack_require__(891987);
var constants = __webpack_require__(19514);
var RecommendProductTabs = __webpack_require__(780528);
var RecommendProductItem = __webpack_require__(909534);
var Container = __webpack_require__(341018);
var grid = __webpack_require__(860046);
var renderDynamicSlot = __webpack_require__(958220);
var Slider = __webpack_require__(183594);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const RecommendProduct = (props) => {
  var _b, _c, _d, _e;
  const _a = props, {
    title,
    buttonTitle,
    items,
    isEditingMode,
    maxWidth = grid.DEFAULT_MAX_WIDTH,
    radius
  } = _a, restProps = __objRest(_a, [
    "title",
    "buttonTitle",
    "items",
    "isEditingMode",
    "maxWidth",
    "radius"
  ]);
  const { device, mappingDynamicSlots } = coreRenderer.useStore();
  const isMobile = device === "mobile";
  const { commonStyle, backgroundColor, titleStyle, tabStyle } = coreRenderer.getPropsByDevice(restProps, device);
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);
  const [isShowModalSelectProduct, setIsShowModalSelectProduct] = React.useState(false);
  const [isShowModalSelectProductMobile, setIsShowModalSelectProductMobile] = React.useState(false);
  const { padding, margin } = commonStyle || {};
  const [showNavBtns, setShowNavBtns] = React.useState(false);
  const [activeItem, setActiveItem] = React.useState(
    {}
  );
  const [activeGroup, setActiveGroup] = React.useState({});
  const onChange = (key) => {
    const newActiveItem = (items == null ? void 0 : items.find((item) => item.id === key)) || {};
    setActiveItem(newActiveItem);
  };
  React.useEffect(() => {
    if (!!items && Array.isArray(items)) {
      setActiveItem(items == null ? void 0 : items[0]);
    }
  }, [items]);
  const showModal = () => {
    isMobile ? setIsShowModalSelectProductMobile(true) : setIsShowModalSelectProduct(true);
  };
  const handleCancelModal = () => {
    isMobile ? setIsShowModalSelectProductMobile(false) : setIsShowModalSelectProduct(false);
  };
  return /* @__PURE__ */ jsxRuntime.jsxs(Container.Container, {
    commonStyle: {
      borderRadius: Number(radius),
      backgroundColor,
      padding,
      margin,
      maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH
    },
    maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH,
    children: [
      title ? /* @__PURE__ */ jsxRuntime.jsx(TitleWrapper, {
        children: /* @__PURE__ */ jsxRuntime.jsx(TitleStyled, {
          fontWeight: isMobile ? 500 : 700,
          fontSize: isMobile ? 16 : 20,
          style: { color: titleStyle.color },
          children: title
        })
      }) : null,
      /* @__PURE__ */ jsxRuntime.jsx(RecommendProductTabs.RecommendProductTabs, {
        onChange,
        items,
        activeItem,
        activeTabColor: tabStyle.activeTabStyle
      }),
      (activeItem == null ? void 0 : activeItem.groups) && /* @__PURE__ */ jsxRuntime.jsx(SliderWrapper, {
        style: { alignItems: (_b = grid.MAPPING_ALIGNMENT_FLEX) == null ? void 0 : _b["center"] },
        children: /* @__PURE__ */ jsxRuntime.jsxs("div", {
          onMouseEnter: () => setShowNavBtns(true),
          onMouseLeave: () => setShowNavBtns(false),
          style: {
            position: "relative",
            width: "100%"
          },
          children: [
            ((_c = activeItem == null ? void 0 : activeItem.groups) == null ? void 0 : _c.length) > 1 && /* @__PURE__ */ jsxRuntime.jsx(NavigationButtonStyled, {
              className: "left-nav",
              style: { opacity: showNavBtns ? 1 : 0 },
              ref: navigationPrevRef
            }),
            /* @__PURE__ */ jsxRuntime.jsx(SliderStyled, {
              navigation: {
                prevEl: navigationPrevRef.current,
                nextEl: navigationNextRef.current
              },
              slidesPerView: "auto",
              navigationStyle: 1,
              paginationColor: "#ffffff",
              allowTouchMove: !isEditingMode,
              onBeforeInit: (swiper) => {
                swiper.params.navigation.prevEl = navigationPrevRef.current;
                swiper.params.navigation.nextEl = navigationNextRef.current;
              },
              spaceBetween: isMobile ? constants.RECOMMEND_PRODUCT_DEFAULT_SPACING_MOBILE : constants.RECOMMEND_PRODUCT_DEFAULT_SPACING_DESKTOP,
              children: (_d = activeItem == null ? void 0 : activeItem.groups) == null ? void 0 : _d.map((item, index) => /* @__PURE__ */ jsxRuntime.jsx(RecommendProductItem.RecommendProductItem, {
                src: item.imageUrl,
                buttonTitle,
                onClick: () => {
                  showModal();
                  setActiveGroup(item);
                },
                title: item.title
              }, `${index}`))
            }),
            ((_e = activeItem == null ? void 0 : activeItem.groups) == null ? void 0 : _e.length) > 1 && /* @__PURE__ */ jsxRuntime.jsx(NavigationButtonStyled, {
              className: "right-nav",
              style: { opacity: showNavBtns ? 1 : 0 },
              ref: navigationNextRef
            })
          ]
        })
      }),
      isMobile ? /* @__PURE__ */ jsxRuntime.jsx(antd.Drawer, {
        placement: "bottom",
        closable: false,
        open: isShowModalSelectProductMobile,
        onClose: handleCancelModal,
        size: "large",
        style: { borderTopLeftRadius: "8px", borderTopRightRadius: "8px" },
        bodyStyle: {
          padding: 0
        },
        children: renderDynamicSlot.renderDynamicSlot(
          `modal_recommend_product`,
          mappingDynamicSlots,
          void 0,
          {
            activeGroup,
            config: { maxWidth },
            onCloseModal: () => setIsShowModalSelectProductMobile(false)
          }
        )
      }) : /* @__PURE__ */ jsxRuntime.jsx(antd.Modal, {
        open: isShowModalSelectProduct,
        onCancel: handleCancelModal,
        width: constants.WIDTH_OF_MODAL_SELECT_PRODUCT,
        footer: [],
        closable: false,
        centered: true,
        zIndex: 1050,
        children: renderDynamicSlot.renderDynamicSlot(
          `modal_recommend_product`,
          mappingDynamicSlots,
          void 0,
          {
            activeGroup,
            config: { maxWidth },
            onCloseModal: () => setIsShowModalSelectProduct(false)
          }
        )
      })
    ]
  });
};
RecommendProduct.displayName = "Omni_RecommendProduct";
const TitleWrapper = styled__default["default"].div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  @media (max-width: 460px) {
    margin-bottom: 12px;
  }
`;
const TitleStyled = styled__default["default"].div(
  ({ fontSize, fontWeight }) => `
  font-size: ${fontSize}px;
  font-weight: ${fontWeight};
  line-height: 28px;
  margin: 0 16px 0 0;
`
);
const SliderWrapper = styled__default["default"].div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const NavigationButtonStyled = styled__default["default"].div`
  top: 50%;
  position: absolute;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 100px;
  background-color: white;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2);
  &:after {
    content: ' ';
    height: 30px;
    width: 30px;
    display: inline-block;
    background: #333;
  }

  &.left-nav {
    transform: translateY(-50%) translateX(-50%);
    left: 0px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
      mask-size: contain;
    }
  }

  &.right-nav {
    transform: translateY(-50%) translateX(50%);
    right: 0px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
      mask-size: contain;
    }
  }

  &.swiper-button-disabled {
    display: none;
  }
`;
const SliderStyled = styled__default["default"](Slider.Slider)(
  () => `
   .swiper-wrapper {
    display: grid;
    grid-auto-flow: column;
    width: fit-content;
    row-gap: 4px;
  }

  .swiper-slide {
    display: grid;
    grid-template-rows: subgrid;
  }

`
);

exports.RecommendProduct = RecommendProduct;


/***/ }),

/***/ 536210:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var coreRenderer = __webpack_require__(85097);
var Container = __webpack_require__(341018);
var Slider = __webpack_require__(183594);
var grid = __webpack_require__(860046);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const { cardDefaultImage: defaultImage } = coreRenderer.mappingAssets;
const SlideBanner = (_a) => {
  var _b = _a, {
    isEditingMode = false
  } = _b, restProps = __objRest(_b, [
    "isEditingMode"
  ]);
  const { device } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    commonStyle,
    autoSwipeTimeMilliseconds,
    items = []
  } = _a2, rest = __objRest(_a2, [
    "commonStyle",
    "autoSwipeTimeMilliseconds",
    "items"
  ]);
  const { displayItems } = coreRenderer.useTimeVisibility(items, isEditingMode);
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: __spreadValues({ maxWidth: grid.DEFAULT_MAX_WIDTH }, commonStyle)
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsx(Slider.Slider, {
      pagination: true,
      paginationStyle: 1,
      virtual: true,
      paginationColor: "#ffffff",
      loop: true,
      allowTouchMove: !isEditingMode,
      autoplay: !!autoSwipeTimeMilliseconds,
      speed: autoSwipeTimeMilliseconds,
      children: displayItems.map((el, index) => {
        return /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadValues({
          event: el.event,
          isEditingMode,
          googleImageParams: el.googleImageParams || { width: 1e3 },
          src: el.src || defaultImage,
          alt: el.alt || "Image",
          commonStyle: {
            objectFit: "cover",
            width: "100%",
            borderRadius: 10
          }
        }, !isEditingMode && coreRenderer.getTrackingData({
          isTrackContent: true,
          regionName: "topBannerHomepage",
          contentName: "slideBanner",
          target: coreRenderer.getTargetOfTrackingFromEvent(el.event),
          index
        })), index);
      })
    })
  }));
};
SlideBanner.displayName = "Omni_BannerSlider";

exports.SlideBanner = SlideBanner;


/***/ }),

/***/ 584827:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreEditor = __webpack_require__(443410);
var coreRenderer = __webpack_require__(85097);
var image = __webpack_require__(478130);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const PROP_KEY = __spreadProps(__spreadValues({}, coreEditor.PROP_KEY), {
  DisplayOnScrollToPosition: "displayOnScrollToPosition",
  DisplayOnScrollToElement: "displayOnScrollToElement",
  DisplayOnScrollTo: "displayOnScrollTo",
  LeftImageProps: "leftImageProps",
  RightImageProps: "rightImageProps"
});
const DEFAULT_STICKY_BANNER = {
  leftImageProps: {
    commonStyle: {
      width: 159,
      height: 349,
      widthUnit: coreRenderer.UnitEnum.pixel,
      heightUnit: coreRenderer.UnitEnum.pixel
    },
    src: image.generatePlaceholderImage({ width: 159, height: 349 })
  },
  rightImageProps: {
    commonStyle: {
      width: 159,
      height: 349,
      widthUnit: coreRenderer.UnitEnum.pixel,
      heightUnit: coreRenderer.UnitEnum.pixel
    },
    src: image.generatePlaceholderImage({ width: 159, height: 349 })
  }
};

exports.DEFAULT_STICKY_BANNER = DEFAULT_STICKY_BANNER;
exports.PROP_KEY = PROP_KEY;


/***/ }),

/***/ 699486:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var React = __webpack_require__(891987);
var constants = __webpack_require__(584827);
var render = __webpack_require__(591599);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const StickyBanner = (props) => {
  const {
    enable,
    isEditorMode,
    globalData,
    leftImageProps,
    rightImageProps,
    displayOnScrollTo,
    displayOnScrollToElement,
    displayOnScrollToPosition
  } = props;
  const isPreviewMode = globalData == null ? void 0 : globalData.isPreviewMode;
  const [showBanner, setShowBanner] = React.useState(false);
  const handleScroll = React.useCallback(() => {
    var _a;
    if (displayOnScrollTo === constants.PROP_KEY.DisplayOnScrollToPosition) {
      if (isEditorMode || isPreviewMode) {
        setShowBanner(
          ((_a = document.querySelector("iframe").contentWindow.window) == null ? void 0 : _a.scrollY) >= displayOnScrollToPosition
        );
      } else {
        setShowBanner((window == null ? void 0 : window.scrollY) >= displayOnScrollToPosition);
      }
    } else if (displayOnScrollTo === constants.PROP_KEY.DisplayOnScrollToElement) {
      const element = isEditorMode ? document.querySelector("iframe").contentWindow.document.getElementById(displayOnScrollToElement) : document.getElementById(displayOnScrollToElement);
      if (element) {
        if (element.getBoundingClientRect().bottom <= 0) {
          setShowBanner(true);
        } else {
          setShowBanner(false);
        }
      } else {
        setShowBanner(false);
      }
    } else {
      setShowBanner(false);
    }
  }, [displayOnScrollTo, displayOnScrollToElement, displayOnScrollToPosition]);
  React.useEffect(() => {
    var _a, _b;
    window == null ? void 0 : window.addEventListener("scroll", handleScroll);
    if (isEditorMode || isPreviewMode) {
      (_b = (_a = document.querySelector("iframe")) == null ? void 0 : _a.contentWindow.window) == null ? void 0 : _b.addEventListener("scroll", handleScroll);
    }
    return () => {
      var _a2, _b2;
      window == null ? void 0 : window.removeEventListener("scroll", handleScroll);
      if (isEditorMode || isPreviewMode) {
        (_b2 = (_a2 = document.querySelector("iframe")) == null ? void 0 : _a2.contentWindow.window) == null ? void 0 : _b2.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll, isEditorMode, isPreviewMode]);
  if (!enable)
    return null;
  const getPropsLink = (href, openNewTab) => {
    if (!href)
      return;
    return {
      href,
      target: openNewTab ? "_blank" : "_self"
    };
  };
  return showBanner && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx("a", __spreadProps(__spreadValues({}, getPropsLink(leftImageProps.href, leftImageProps.openNewTab)), {
        rel: "noreferrer",
        children: /* @__PURE__ */ jsxRuntime.jsx(LeftBannerWrapper, {
          children: /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadValues(__spreadValues({}, leftImageProps), render.getAttrTracking({
            trackingData: {
              regionName: "leftStickBanner",
              contentName: leftImageProps.alt,
              target: leftImageProps.href
            },
            isEditorMode,
            isPreviewMode
          })))
        })
      })),
      /* @__PURE__ */ jsxRuntime.jsx("a", __spreadProps(__spreadValues({}, getPropsLink(rightImageProps.href, rightImageProps.openNewTab)), {
        rel: "noreferrer",
        children: /* @__PURE__ */ jsxRuntime.jsx(RightBannerWrapper, {
          children: /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadValues(__spreadValues({}, rightImageProps), render.getAttrTracking({
            trackingData: {
              regionName: "rightStickBanner",
              contentName: rightImageProps.alt,
              target: rightImageProps.href
            },
            isEditorMode,
            isPreviewMode
          })))
        })
      }))
    ]
  });
};
const LeftBannerWrapper = styled__default["default"].div`
  position: fixed;
  left: calc((100% - 1232px) / 2 - 159px - 16px);
  top: 45%;
  transform: translateY(-50%);
  z-index: 999;
  display: none;

  @media (min-width: 1200px) {
    display: block;
  }
`;
const RightBannerWrapper = styled__default["default"].div`
  position: fixed;
  right: calc((100% - 1232px) / 2 - 159px - 16px);
  top: 45%;
  transform: translateY(-50%);
  z-index: 999;
  display: none;

  @media (min-width: 1200px) {
    display: block;
  }
`;
StickyBanner.displayName = "Omni_StickyBanner";

exports.StickyBanner = StickyBanner;


/***/ }),

/***/ 882756:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);

const CardIcon = () => /* @__PURE__ */ jsxRuntime.jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    /* @__PURE__ */ jsxRuntime.jsxs("g", {
      clipPath: "url(#clip0_5461_4)",
      children: [
        /* @__PURE__ */ jsxRuntime.jsx("path", {
          d: "M4.66658 16.0004C5.40296 16.0004 5.99991 15.4035 5.99991 14.6671C5.99991 13.9307 5.40296 13.3338 4.66658 13.3338C3.9302 13.3338 3.33325 13.9307 3.33325 14.6671C3.33325 15.4035 3.9302 16.0004 4.66658 16.0004Z",
          fill: "#212533"
        }),
        /* @__PURE__ */ jsxRuntime.jsx("path", {
          d: "M11.3333 16.0004C12.0697 16.0004 12.6667 15.4035 12.6667 14.6671C12.6667 13.9307 12.0697 13.3338 11.3333 13.3338C10.597 13.3338 10 13.9307 10 14.6671C10 15.4035 10.597 16.0004 11.3333 16.0004Z",
          fill: "#43464C"
        }),
        /* @__PURE__ */ jsxRuntime.jsx("path", {
          d: "M15.3334 2H14.0001V0.666667C14.0001 0.489856 13.9298 0.320286 13.8048 0.195262C13.6798 0.0702379 13.5102 0 13.3334 0C13.1566 0 12.987 0.0702379 12.862 0.195262C12.737 0.320286 12.6667 0.489856 12.6667 0.666667V2H11.3334C11.1566 2 10.987 2.07024 10.862 2.19526C10.737 2.32029 10.6667 2.48986 10.6667 2.66667C10.6667 2.84348 10.737 3.01305 10.862 3.13807C10.987 3.2631 11.1566 3.33333 11.3334 3.33333H12.6667V4.66667C12.6667 4.84348 12.737 5.01305 12.862 5.13807C12.987 5.2631 13.1566 5.33333 13.3334 5.33333C13.5102 5.33333 13.6798 5.2631 13.8048 5.13807C13.9298 5.01305 14.0001 4.84348 14.0001 4.66667V3.33333H15.3334C15.5102 3.33333 15.6798 3.2631 15.8048 3.13807C15.9298 3.01305 16.0001 2.84348 16.0001 2.66667C16.0001 2.48986 15.9298 2.32029 15.8048 2.19526C15.6798 2.07024 15.5102 2 15.3334 2Z",
          fill: "#43464C"
        }),
        /* @__PURE__ */ jsxRuntime.jsx("path", {
          d: "M14.514 6.484C14.4278 6.46787 14.3393 6.46901 14.2535 6.48735C14.1678 6.5057 14.0865 6.54088 14.0144 6.59086C13.9424 6.64084 13.881 6.70463 13.8337 6.77852C13.7865 6.85242 13.7544 6.93495 13.7393 7.02133C13.6562 7.48277 13.4136 7.90033 13.0539 8.20106C12.6941 8.5018 12.2402 8.6666 11.7713 8.66667H3.612L2.98533 3.33333H8.66667C8.84348 3.33333 9.01305 3.2631 9.13807 3.13807C9.2631 3.01305 9.33333 2.84348 9.33333 2.66667C9.33333 2.48986 9.2631 2.32029 9.13807 2.19526C9.01305 2.07024 8.84348 2 8.66667 2H2.828L2.8 1.76533C2.74255 1.27907 2.50871 0.830769 2.14279 0.505403C1.77688 0.180036 1.30432 0.000208558 0.814667 0L0.666667 0C0.489856 0 0.320286 0.0702379 0.195262 0.195262C0.0702379 0.320286 0 0.489856 0 0.666667C0 0.843478 0.0702379 1.01305 0.195262 1.13807C0.320286 1.2631 0.489856 1.33333 0.666667 1.33333H0.814667C0.977956 1.33335 1.13556 1.3933 1.25758 1.50181C1.3796 1.61032 1.45756 1.75983 1.47667 1.922L2.394 9.722C2.48923 10.5332 2.87899 11.2812 3.48927 11.824C4.09956 12.3668 4.8879 12.6667 5.70467 12.6667H12.6667C12.8435 12.6667 13.013 12.5964 13.1381 12.4714C13.2631 12.3464 13.3333 12.1768 13.3333 12C13.3333 11.8232 13.2631 11.6536 13.1381 11.5286C13.013 11.4036 12.8435 11.3333 12.6667 11.3333H5.70467C5.29101 11.3334 4.88751 11.2052 4.54974 10.9664C4.21197 10.7276 3.95655 10.39 3.81867 10H11.7713C12.5528 10.0001 13.3094 9.72561 13.909 9.22455C14.5087 8.72348 14.9132 8.02768 15.052 7.25867C15.0676 7.17247 15.066 7.08405 15.0474 6.99847C15.0288 6.91288 14.9935 6.83179 14.9435 6.75985C14.8936 6.68791 14.8299 6.62652 14.7562 6.57919C14.6825 6.53185 14.6002 6.49951 14.514 6.484Z",
          fill: "#43464C"
        })
      ]
    }),
    /* @__PURE__ */ jsxRuntime.jsx("defs", {
      children: /* @__PURE__ */ jsxRuntime.jsx("clipPath", {
        id: "clip0_5461_4",
        children: /* @__PURE__ */ jsxRuntime.jsx("rect", {
          width: "16",
          height: "16",
          fill: "white"
        })
      })
    })
  ]
});
const ProductPreviewIcon = () => /* @__PURE__ */ jsxRuntime.jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    /* @__PURE__ */ jsxRuntime.jsx("rect", {
      width: "24",
      height: "24",
      rx: "12",
      fill: "#00973C"
    }),
    /* @__PURE__ */ jsxRuntime.jsx("g", {
      clipPath: "url(#clip0_7480_8601)",
      children: /* @__PURE__ */ jsxRuntime.jsx("path", {
        d: "M19.5315 10.0227C19.1515 9.58467 18.6008 9.33333 18.0201 9.33333H17.9628C17.6301 6.33733 15.0835 4 12.0001 4C8.91681 4 6.37015 6.33733 6.03748 9.33333H6.00015C5.42015 9.33333 4.87015 9.58467 4.48948 10.0227C4.10881 10.4607 3.93815 11.0413 4.02015 11.6167L4.72748 16.566C5.00748 18.524 6.71015 20 8.68748 20H15.3335C17.3108 20 19.0135 18.5233 19.2935 16.566L20.0008 11.6167C20.0828 11.042 19.9115 10.4613 19.5315 10.0227ZM12.0001 5.33333C14.3468 5.33333 16.2941 7.07533 16.6188 9.33333H7.38148C7.70615 7.07533 9.65348 5.33333 12.0001 5.33333ZM9.33348 16.6667C9.33348 17.0353 9.03548 17.3333 8.66681 17.3333C8.29815 17.3333 8.00015 17.0353 8.00015 16.6667V12.6667C8.00015 12.298 8.29815 12 8.66681 12C9.03548 12 9.33348 12.298 9.33348 12.6667V16.6667ZM12.6668 16.6667C12.6668 17.0353 12.3688 17.3333 12.0001 17.3333C11.6315 17.3333 11.3335 17.0353 11.3335 16.6667V12.6667C11.3335 12.298 11.6315 12 12.0001 12C12.3688 12 12.6668 12.298 12.6668 12.6667V16.6667ZM16.0001 16.6667C16.0001 17.0353 15.7021 17.3333 15.3335 17.3333C14.9648 17.3333 14.6668 17.0353 14.6668 16.6667V12.6667C14.6668 12.298 14.9648 12 15.3335 12C15.7021 12 16.0001 12.298 16.0001 12.6667V16.6667Z",
        fill: "white"
      })
    }),
    /* @__PURE__ */ jsxRuntime.jsx("defs", {
      children: /* @__PURE__ */ jsxRuntime.jsx("clipPath", {
        id: "clip0_7480_8601",
        children: /* @__PURE__ */ jsxRuntime.jsx("rect", {
          width: "16",
          height: "16",
          fill: "white",
          transform: "translate(4 4)"
        })
      })
    })
  ]
});

exports.CardIcon = CardIcon;
exports.ProductPreviewIcon = ProductPreviewIcon;


/***/ }),

/***/ 779209:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PauseIcon = () => /* @__PURE__ */ jsxRuntime.jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    /* @__PURE__ */ jsxRuntime.jsx("path", {
      d: "M5.41667 0C4.64312 0 3.90125 0.307291 3.35427 0.854272C2.80729 1.40125 2.5 2.14312 2.5 2.91667V17.0833C2.5 17.8569 2.80729 18.5987 3.35427 19.1457C3.90125 19.6927 4.64312 20 5.41667 20C6.19022 20 6.93208 19.6927 7.47906 19.1457C8.02604 18.5987 8.33333 17.8569 8.33333 17.0833V2.91667C8.33333 2.14312 8.02604 1.40125 7.47906 0.854272C6.93208 0.307291 6.19022 0 5.41667 0Z",
      fill: "white"
    }),
    /* @__PURE__ */ jsxRuntime.jsx("path", {
      d: "M14.5834 0C13.8099 0 13.068 0.307291 12.521 0.854272C11.974 1.40125 11.6667 2.14312 11.6667 2.91667V17.0833C11.6667 17.8569 11.974 18.5987 12.521 19.1457C13.068 19.6927 13.8099 20 14.5834 20C15.357 20 16.0988 19.6927 16.6458 19.1457C17.1928 18.5987 17.5001 17.8569 17.5001 17.0833V2.91667C17.5001 2.14312 17.1928 1.40125 16.6458 0.854272C16.0988 0.307291 15.357 0 14.5834 0Z",
      fill: "white"
    })
  ]
});
const PlayIcon = () => /* @__PURE__ */ jsxRuntime.jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    /* @__PURE__ */ jsxRuntime.jsx("g", {
      clipPath: "url(#clip0_4715_71904)",
      children: /* @__PURE__ */ jsxRuntime.jsx("path", {
        d: "M17.0767 6.6412L9.12834 0.812862C8.50753 0.358266 7.77296 0.0844559 7.00606 0.0217814C6.23916 -0.0408932 5.46988 0.110016 4.78349 0.457782C4.09711 0.805548 3.52043 1.33659 3.11737 1.99203C2.71432 2.64748 2.50063 3.40174 2.50001 4.1712V15.8337C2.49881 16.6039 2.71138 17.3593 3.11405 18.0159C3.51672 18.6725 4.09369 19.2044 4.78075 19.5525C5.46781 19.9006 6.23799 20.0512 7.00557 19.9876C7.77314 19.924 8.508 19.6485 9.12834 19.192L17.0767 13.3637C17.6041 12.9767 18.0329 12.4709 18.3285 11.8873C18.6241 11.3037 18.7782 10.6587 18.7782 10.0045C18.7782 9.35035 18.6241 8.70536 18.3285 8.12178C18.0329 7.53819 17.6041 7.0324 17.0767 6.64536V6.6412Z",
        fill: "white"
      })
    }),
    /* @__PURE__ */ jsxRuntime.jsx("defs", {
      children: /* @__PURE__ */ jsxRuntime.jsx("clipPath", {
        id: "clip0_4715_71904",
        children: /* @__PURE__ */ jsxRuntime.jsx("rect", {
          width: "20",
          height: "20",
          fill: "white"
        })
      })
    })
  ]
});
const VolumeOnIcon = () => /* @__PURE__ */ jsxRuntime.jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    /* @__PURE__ */ jsxRuntime.jsxs("g", {
      clipPath: "url(#clip0_4715_71920)",
      children: [
        /* @__PURE__ */ jsxRuntime.jsx("path", {
          d: "M17.3332 3.5773C17.1743 3.4356 16.9671 3.36013 16.7542 3.36639C16.5414 3.37264 16.339 3.46015 16.1886 3.61094C16.0383 3.76173 15.9513 3.96436 15.9457 4.17724C15.94 4.39011 16.0161 4.59707 16.1582 4.75563C17.5467 6.1477 18.3265 8.03362 18.3265 9.9998C18.3265 11.966 17.5467 13.8519 16.1582 15.244C16.0736 15.3194 16.0053 15.4113 15.9574 15.514C15.9095 15.6168 15.8831 15.7282 15.8798 15.8415C15.8764 15.9549 15.8962 16.0677 15.938 16.173C15.9798 16.2784 16.0426 16.3742 16.1226 16.4544C16.2027 16.5347 16.2983 16.5978 16.4035 16.6399C16.5088 16.6819 16.6215 16.7021 16.7349 16.6991C16.8482 16.6961 16.9597 16.67 17.0626 16.6224C17.1655 16.5748 17.2575 16.5067 17.3332 16.4223C19.0342 14.7177 19.9895 12.4079 19.9895 9.9998C19.9895 7.59168 19.0342 5.28191 17.3332 3.5773Z",
          fill: "white"
        }),
        /* @__PURE__ */ jsxRuntime.jsx("path", {
          d: "M15.0775 6.0782C15.0006 5.99861 14.9087 5.93512 14.807 5.89145C14.7054 5.84777 14.596 5.82478 14.4854 5.82382C14.3747 5.82286 14.265 5.84395 14.1626 5.88585C14.0601 5.92775 13.9671 5.98962 13.8889 6.06787C13.8106 6.14611 13.7487 6.23916 13.7068 6.34157C13.6649 6.44398 13.6438 6.55372 13.6448 6.66436C13.6458 6.77501 13.6688 6.88436 13.7124 6.98603C13.7561 7.0877 13.8196 7.17966 13.8992 7.25653C14.6256 7.98508 15.0335 8.9719 15.0335 10.0007C15.0335 11.0295 14.6256 12.0163 13.8992 12.7449C13.8196 12.8217 13.7561 12.9137 13.7124 13.0154C13.6688 13.117 13.6458 13.2264 13.6448 13.337C13.6438 13.4477 13.6649 13.5574 13.7068 13.6598C13.7487 13.7622 13.8106 13.8553 13.8889 13.9335C13.9671 14.0118 14.0601 14.0736 14.1626 14.1155C14.265 14.1574 14.3747 14.1785 14.4854 14.1776C14.596 14.1766 14.7054 14.1536 14.807 14.1099C14.9087 14.0663 15.0006 14.0028 15.0775 13.9232C16.1161 12.882 16.6994 11.4714 16.6994 10.0007C16.6994 8.53003 16.1161 7.1194 15.0775 6.0782Z",
          fill: "white"
        }),
        /* @__PURE__ */ jsxRuntime.jsx("path", {
          d: "M11.5158 0.171845C8.98377 0.647116 6.73108 2.07701 5.22333 4.16601H4.16667C3.062 4.16734 2.00296 4.60675 1.22185 5.38786C0.440735 6.16898 0.00132321 7.22802 0 8.33268L0 11.666C0.00132321 12.7707 0.440735 13.8297 1.22185 14.6108C2.00296 15.3919 3.062 15.8314 4.16667 15.8327H5.22417C6.73148 17.9218 8.98395 19.3517 11.5158 19.8268C11.636 19.849 11.7595 19.8444 11.8777 19.8134C11.9959 19.7825 12.1059 19.7259 12.1998 19.6478C12.2937 19.5696 12.3693 19.4718 12.4211 19.3611C12.473 19.2505 12.4999 19.1299 12.5 19.0077V0.991012C12.4999 0.868834 12.473 0.748164 12.4211 0.637549C12.3693 0.526934 12.2937 0.42908 12.1998 0.350919C12.1059 0.272758 11.9959 0.216201 11.8777 0.185255C11.7595 0.154309 11.636 0.149731 11.5158 0.171845Z",
          fill: "white"
        })
      ]
    }),
    /* @__PURE__ */ jsxRuntime.jsx("defs", {
      children: /* @__PURE__ */ jsxRuntime.jsx("clipPath", {
        id: "clip0_4715_71920",
        children: /* @__PURE__ */ jsxRuntime.jsx("rect", {
          width: "20",
          height: "20",
          fill: "white"
        })
      })
    })
  ]
});
const VolumeOffIcon = () => /* @__PURE__ */ jsxRuntime.jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    /* @__PURE__ */ jsxRuntime.jsx("g", {
      clipPath: "url(#clip0_4715_71922)",
      children: /* @__PURE__ */ jsxRuntime.jsx("path", {
        d: "M11.37 0.348342C11.18 0.190009 10.9291 0.125009 10.6858 0.169175C8.18496 0.631675 5.89079 2.08751 4.39079 4.16418H4.16496C1.86746 4.16501 -0.00170898 6.03418 -0.00170898 8.33168V11.6692C-0.00170898 13.9667 1.86746 15.8358 4.16496 15.8358H4.39079C5.89246 17.915 8.18662 19.3717 10.6858 19.8308C10.7358 19.84 10.7866 19.845 10.8366 19.845C11.03 19.845 11.2191 19.7775 11.37 19.6525C11.56 19.4942 11.67 19.2592 11.67 19.0117V0.989175C11.67 0.741675 11.5608 0.506675 11.37 0.348342ZM19.7775 11.9108C20.1033 12.2367 20.1033 12.7633 19.7775 13.0892C19.615 13.2517 19.4016 13.3333 19.1883 13.3333C18.975 13.3333 18.7616 13.2517 18.5991 13.0892L16.6883 11.1783L14.7775 13.0892C14.615 13.2517 14.4016 13.3333 14.1883 13.3333C13.975 13.3333 13.7616 13.2517 13.5991 13.0892C13.2733 12.7633 13.2733 12.2367 13.5991 11.9108L15.51 10L13.5991 8.08918C13.2733 7.76334 13.2733 7.23668 13.5991 6.91084C13.925 6.58501 14.4516 6.58501 14.7775 6.91084L16.6883 8.82168L18.5991 6.91084C18.925 6.58501 19.4516 6.58501 19.7775 6.91084C20.1033 7.23668 20.1033 7.76334 19.7775 8.08918L17.8666 10L19.7775 11.9108Z",
        fill: "white"
      })
    }),
    /* @__PURE__ */ jsxRuntime.jsx("defs", {
      children: /* @__PURE__ */ jsxRuntime.jsx("clipPath", {
        id: "clip0_4715_71922",
        children: /* @__PURE__ */ jsxRuntime.jsx("rect", {
          width: "20",
          height: "20",
          fill: "white"
        })
      })
    })
  ]
});
const FullScreenIcon = () => /* @__PURE__ */ jsxRuntime.jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    /* @__PURE__ */ jsxRuntime.jsxs("g", {
      clipPath: "url(#clip0_4715_71941)",
      children: [
        /* @__PURE__ */ jsxRuntime.jsx("path", {
          d: "M19.1668 13.3332C18.9458 13.3332 18.7338 13.421 18.5776 13.5773C18.4213 13.7335 18.3335 13.9455 18.3335 14.1665V15.8332C18.3335 16.4962 18.0701 17.1321 17.6013 17.6009C17.1324 18.0698 16.4965 18.3332 15.8335 18.3332H14.1668C13.9458 18.3332 13.7339 18.421 13.5776 18.5773C13.4213 18.7335 13.3335 18.9455 13.3335 19.1665C13.3335 19.3875 13.4213 19.5995 13.5776 19.7558C13.7339 19.912 13.9458 19.9998 14.1668 19.9998H15.8335C16.9382 19.9985 17.9972 19.5591 18.7783 18.778C19.5594 17.9969 19.9988 16.9378 20.0002 15.8332V14.1665C20.0002 13.9455 19.9124 13.7335 19.7561 13.5773C19.5998 13.421 19.3878 13.3332 19.1668 13.3332Z",
          fill: "white"
        }),
        /* @__PURE__ */ jsxRuntime.jsx("path", {
          d: "M5.83333 0H4.16667C3.062 0.00132321 2.00296 0.440735 1.22185 1.22185C0.440735 2.00296 0.00132321 3.062 0 4.16667L0 5.83333C0 6.05435 0.0877974 6.26631 0.244078 6.42259C0.400358 6.57887 0.61232 6.66667 0.833333 6.66667C1.05435 6.66667 1.26631 6.57887 1.42259 6.42259C1.57887 6.26631 1.66667 6.05435 1.66667 5.83333V4.16667C1.66667 3.50363 1.93006 2.86774 2.3989 2.3989C2.86774 1.93006 3.50363 1.66667 4.16667 1.66667H5.83333C6.05435 1.66667 6.26631 1.57887 6.42259 1.42259C6.57887 1.26631 6.66667 1.05435 6.66667 0.833333C6.66667 0.61232 6.57887 0.400358 6.42259 0.244078C6.26631 0.0877974 6.05435 0 5.83333 0V0Z",
          fill: "white"
        }),
        /* @__PURE__ */ jsxRuntime.jsx("path", {
          d: "M5.83333 18.3332H4.16667C3.50363 18.3332 2.86774 18.0698 2.3989 17.6009C1.93006 17.1321 1.66667 16.4962 1.66667 15.8332V14.1665C1.66667 13.9455 1.57887 13.7335 1.42259 13.5773C1.26631 13.421 1.05435 13.3332 0.833333 13.3332C0.61232 13.3332 0.400358 13.421 0.244078 13.5773C0.0877974 13.7335 0 13.9455 0 14.1665L0 15.8332C0.00132321 16.9378 0.440735 17.9969 1.22185 18.778C2.00296 19.5591 3.062 19.9985 4.16667 19.9998H5.83333C6.05435 19.9998 6.26631 19.912 6.42259 19.7558C6.57887 19.5995 6.66667 19.3875 6.66667 19.1665C6.66667 18.9455 6.57887 18.7335 6.42259 18.5773C6.26631 18.421 6.05435 18.3332 5.83333 18.3332Z",
          fill: "white"
        }),
        /* @__PURE__ */ jsxRuntime.jsx("path", {
          d: "M15.8335 0H14.1668C13.9458 0 13.7339 0.0877974 13.5776 0.244078C13.4213 0.400358 13.3335 0.61232 13.3335 0.833333C13.3335 1.05435 13.4213 1.26631 13.5776 1.42259C13.7339 1.57887 13.9458 1.66667 14.1668 1.66667H15.8335C16.4965 1.66667 17.1324 1.93006 17.6013 2.3989C18.0701 2.86774 18.3335 3.50363 18.3335 4.16667V5.83333C18.3335 6.05435 18.4213 6.26631 18.5776 6.42259C18.7338 6.57887 18.9458 6.66667 19.1668 6.66667C19.3878 6.66667 19.5998 6.57887 19.7561 6.42259C19.9124 6.26631 20.0002 6.05435 20.0002 5.83333V4.16667C19.9988 3.062 19.5594 2.00296 18.7783 1.22185C17.9972 0.440735 16.9382 0.00132321 15.8335 0V0Z",
          fill: "white"
        })
      ]
    }),
    /* @__PURE__ */ jsxRuntime.jsx("defs", {
      children: /* @__PURE__ */ jsxRuntime.jsx("clipPath", {
        id: "clip0_4715_71941",
        children: /* @__PURE__ */ jsxRuntime.jsx("rect", {
          width: "20",
          height: "20",
          fill: "white"
        })
      })
    })
  ]
});
const IconWrapper = (_a) => {
  var _b = _a, {
    size,
    onClick,
    children,
    isStopPropagation = true
  } = _b, rest = __objRest(_b, [
    "size",
    "onClick",
    "children",
    "isStopPropagation"
  ]);
  const handleClick = (e) => {
    if (isStopPropagation)
      e.stopPropagation();
    onClick == null ? void 0 : onClick();
  };
  return /* @__PURE__ */ jsxRuntime.jsx(WrapperIconStyled, __spreadProps(__spreadValues({
    size,
    onClick: handleClick
  }, rest), {
    children
  }));
};
const WrapperIconStyled = styled__default["default"].div(
  ({ size }) => `
  position: absolute;
  border-radius: 100%;
  padding: 8px;
  background-color: #0000000f;
  transform: translateY(-50%) translateX(-50%);
  cursor: pointer;
  line-height: 0;
  z-index: 2;

  ${size ? `
    svg {
        width: ${size}px;
        height: ${size}px;
    }` : ""}
`
);

exports.FullScreenIcon = FullScreenIcon;
exports.IconWrapper = IconWrapper;
exports.PauseIcon = PauseIcon;
exports.PlayIcon = PlayIcon;
exports.VolumeOffIcon = VolumeOffIcon;
exports.VolumeOnIcon = VolumeOnIcon;


/***/ }),

/***/ 554748:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var icons = __webpack_require__(143599);
var constants = __webpack_require__(177718);
var VideoProductCard = __webpack_require__(370149);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const ListProductPreview = ({
  productReviews,
  onClose,
  isMobile,
  isHorizontal,
  hideBuyNowButton
}) => {
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      isMobile && /* @__PURE__ */ jsxRuntime.jsx(DimBackground, {
        onClick: (e) => {
          e.stopPropagation();
          onClose == null ? void 0 : onClose();
        }
      }),
      /* @__PURE__ */ jsxRuntime.jsxs(ListProductPreviewWrapper, {
        onClick: (e) => e.stopPropagation(),
        isHorizontal,
        isMobile,
        children: [
          /* @__PURE__ */ jsxRuntime.jsxs(HeaderStyled, {
            children: [
              /* @__PURE__ */ jsxRuntime.jsx(Title, {
                children: "S\u1EA3n ph\u1EA9m review"
              }),
              /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
                onClick: () => onClose == null ? void 0 : onClose(),
                name: "CloseOutlined",
                style: {
                  fontSize: 28,
                  color: "#00000073",
                  cursor: "pointer"
                }
              })
            ]
          }),
          /* @__PURE__ */ jsxRuntime.jsx(ListProductWrapper, {
            className: "list-product-preview-wrapper",
            children: (productReviews || []).map((item, index) => /* @__PURE__ */ jsxRuntime.jsx(VideoProductCard.VideoProductCard, {
              productCurrent: item,
              style: { width: "100%", borderRadius: 16 },
              isShowButtonViewMoreProduct: false,
              layout: constants.VideoPreviewLayout.Vertical,
              hiddenButtonBuyNow: hideBuyNowButton
            }, index))
          })
        ]
      })
    ]
  });
};
const ListProductPreviewWrapper = styled__default["default"].div(
  ({ isHorizontal, isMobile }) => `
  
    @keyframes slideUpForHorizontal {
      from {
        transform: translateX(100%) translateY(100%);
        opacity: 0;
      }
      to {
        transform: translateX(100%) translateY(0);
        opacity: 1;
      }
    }

    @keyframes slideUp {
      from {
        transform: translateX(-50%) translateY(100%);
        opacity: 0;
      }
      to {
        transform: translateX(-50%) translateY(0);
        opacity: 1;
      }
    }
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 16px;
    z-index: 1;
    background: #ffffff;
    border-radius: 12px;
    
    ${isHorizontal ? `
      right: -16px;
      transform: translateX(100%);
      animation: slideUpForHorizontal 0.3s ease-out;
      ` : `
      left: 50%;
      transform: translateX(-50%);
      animation: slideUp 0.3s ease-out;
      `}

     ${isMobile ? `
          width: 100vw;
          position: fixed;
          border-radius: 12px 12px 0px 0px;
      ` : ``}
`
);
const Title = styled__default["default"].p`
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  padding-bottom: 16px;
`;
const ListProductWrapper = styled__default["default"].div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 75dvh;
  min-height: 75dvh;
  overflow: auto;
  padding-right: 4px;
`;
const DimBackground = styled__default["default"].div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  overflow: hidden;
  outline: 0;
  height: 100dvh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.8);
`;
const HeaderStyled = styled__default["default"].div`
  display: flex;
  justify-content: space-between;
`;

exports.ListProductPreview = ListProductPreview;


/***/ }),

/***/ 819418:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var icons = __webpack_require__(143599);
var React = __webpack_require__(891987);
var constants = __webpack_require__(177718);
var ListProductPreview = __webpack_require__(554748);
var VideoPreviewItem = __webpack_require__(389302);
var detectUserAgent = __webpack_require__(579589);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MIN_WIDTH_VIDEO = 355;
const MAX_WIDTH_VIDEO = 480;
const HEIGHT_PRODUCT_CART = 116;
const RATIO_HEIGHT_CONTENT = 0.95;
const HEIGHT_ICON_CLOSE = 36;
const ModalPreviewVideo = ({
  videoPreview,
  show,
  cancel,
  closeOnOverlayClick = true,
  itemStyle,
  isEditingMode,
  layout,
  displayType,
  showListProductPreview,
  cancelShowListProductPreview,
  hideBuyNowButton
}) => {
  var _a;
  const { device } = coreRenderer.useStore();
  const isMobile = device === "mobile";
  const isZaloIOSWebView = detectUserAgent.checkZaloIOSWebView();
  const autoPlay = !isZaloIOSWebView;
  const [isMuted, setIsMuted] = React.useState(showListProductPreview);
  const layoutPreview = displayType === constants.VideoPreviewDisplayType.ShortDescription ? constants.VideoPreviewLayout.Vertical : layout;
  const { width, isConvertToOverlay, isHorizontalProductPreview } = React.useMemo(() => {
    var _a2;
    const pageContainer = ((_a2 = document == null ? void 0 : document.querySelector(`#${coreRenderer.TEMPI_MAIN_IFRAME}`)) == null ? void 0 : _a2.contentWindow) || window;
    const getVideoWidth = (layout2) => {
      const vh = pageContainer.innerHeight;
      const vw = pageContainer.innerWidth;
      const heightProductCard = layout2 === constants.VideoPreviewLayout.Overlay ? 0 : HEIGHT_PRODUCT_CART;
      const widthCompByRatio = (vh * RATIO_HEIGHT_CONTENT - heightProductCard - HEIGHT_ICON_CLOSE) * 9 / 16;
      if (widthCompByRatio >= vw)
        return "100vw";
      else if (widthCompByRatio < MIN_WIDTH_VIDEO)
        return MIN_WIDTH_VIDEO;
      else if (widthCompByRatio > MAX_WIDTH_VIDEO)
        return MAX_WIDTH_VIDEO;
      return widthCompByRatio;
    };
    let width2 = getVideoWidth(layoutPreview);
    const isConvertToOverlay2 = isMobile && layoutPreview === constants.VideoPreviewLayout.Vertical && width2 !== "100vw";
    if (isConvertToOverlay2)
      width2 = getVideoWidth(constants.VideoPreviewLayout.Overlay);
    let isHorizontalProductPreview2 = false;
    if (!isMobile && typeof width2 === "number" && width2 < pageContainer.innerWidth / 3 - 50)
      isHorizontalProductPreview2 = true;
    return { isConvertToOverlay: isConvertToOverlay2, width: width2, isHorizontalProductPreview: isHorizontalProductPreview2 };
  }, [isMobile, show, layoutPreview]);
  React.useEffect(() => {
    var _a2;
    if (!show)
      return;
    const pageContainer = ((_a2 = document == null ? void 0 : document.querySelector(`#${coreRenderer.TEMPI_MAIN_IFRAME}`)) == null ? void 0 : _a2.contentWindow) || window;
    const original = pageContainer.document.body.style.overflow || "unset";
    pageContainer.document.body.style.overflow = "hidden";
    return () => {
      pageContainer.document.body.style.overflow = original;
    };
  }, [show]);
  const ModalProductPreview = showListProductPreview && ((_a = videoPreview == null ? void 0 : videoPreview.productReviews) == null ? void 0 : _a.length) > 1 ? /* @__PURE__ */ jsxRuntime.jsx(ListProductPreview.ListProductPreview, {
    onClose: cancelShowListProductPreview,
    productReviews: videoPreview == null ? void 0 : videoPreview.productReviews,
    isHorizontal: isHorizontalProductPreview,
    isMobile,
    hideBuyNowButton
  }) : null;
  const isShowProductPreviewOverlay = showListProductPreview && !isHorizontalProductPreview;
  React.useEffect(() => {
    if (isShowProductPreviewOverlay && !isMuted)
      setIsMuted(true);
  }, [isShowProductPreviewOverlay, isMuted]);
  return /* @__PURE__ */ jsxRuntime.jsxs(MyModalNotification, {
    className: `${show ? "show" : "off"} `,
    onClick: () => {
      if (closeOnOverlayClick && cancel)
        cancel();
    },
    style: {
      backgroundColor: isMobile ? "rgba(0, 0, 0, 0.9)" : "rgba(0, 0, 0, 0.5)"
    },
    children: [
      isMobile && ModalProductPreview,
      /* @__PURE__ */ jsxRuntime.jsx(MyModalDialog, {
        commonStyle: { width },
        children: /* @__PURE__ */ jsxRuntime.jsxs(ModalBody, {
          children: [
            !isMobile && ModalProductPreview,
            /* @__PURE__ */ jsxRuntime.jsx(IconWrapper, {
              onClick: cancel,
              children: /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
                name: "CloseOutlined",
                style: {
                  fontSize: 28,
                  color: "#fff",
                  cursor: "pointer"
                }
              })
            }),
            /* @__PURE__ */ jsxRuntime.jsx(Content, {
              onClick: (e) => e.stopPropagation(),
              children: /* @__PURE__ */ jsxRuntime.jsx(VideoPreviewItem.VideoPreviewItem, __spreadProps(__spreadValues({}, videoPreview), {
                itemStyle,
                isEditingMode,
                layout: isConvertToOverlay ? constants.VideoPreviewLayout.Overlay : layoutPreview,
                displayType: constants.VideoPreviewDisplayType.ProductCard,
                isFocusMode: true,
                videoProps: {
                  autoPlay: autoPlay && !isShowProductPreviewOverlay,
                  muted: isMuted ? false : isShowProductPreviewOverlay
                },
                hideBuyNowButton
              }))
            })
          ]
        })
      })
    ]
  });
};
const MyModalNotification = styled__default["default"].div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100000;
  overflow: hidden;
  outline: 0;
  height: 100dvh;
  &.off {
    opacity: 0;
    visibility: hidden;
    filter: blur(8px);
    transform: scale(0.33);
    box-shadow: 1rem 0 0 rgba(black, 0.2);
  }
  &.show {
    box-shadow: -2rem 2rem 2rem rgba(0, 0, 0, 0.2);
    filter: blur(0);
    transform: scale(1);
    opacity: 1;
    visibility: visible;
  }

  .video-preview-item-wrapper {
    width: 100%;
  }
`;
const MyModalDialog = styled__default["default"].div(
  ({ commonStyle }) => `
    transform: translate(0, 0);
    transition: -webkit-transform 0.3s ease-out;
    transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out;
    position: relative;
    width: 100%;
    height: 100%;
    width: 380px;
    max-width: 100vw;
    margin: 0 auto;
    ${coreRenderer.getStyle(commonStyle)}
`
);
const Content = styled__default["default"].div`
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-clip: padding-box;
  outline: 0;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.08);
  flex-grow: 1;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #b3b2b3;
    border-radius: 999px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f5f5f5;
  }
`;
const ModalBody = styled__default["default"].div`
  position: absolute;
  top: calc(50% - ${HEIGHT_ICON_CLOSE / 2}px);
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-height: 95dvh;
  display: flex;
  flex-direction: column;
`;
const IconWrapper = styled__default["default"].div`
  width: 100%;
  display: flex;
  justify-content: end;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-right: 8px;
  font-weight: bold;
`;

exports.ModalPreviewVideo = ModalPreviewVideo;


/***/ }),

/***/ 713299:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var React = __webpack_require__(891987);
var constants = __webpack_require__(177718);
var context = __webpack_require__(203231);
var ProductIcon = __webpack_require__(882756);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const ProductReviewButton = ({
  productReviews,
  layout
}) => {
  const { handleShowListProductReview } = React.useContext(context.VideoPreviewListContext);
  const handleClick = () => {
    handleShowListProductReview();
  };
  return /* @__PURE__ */ jsxRuntime.jsxs(ProductReviewButtonStyled, {
    layout,
    onClick: handleClick,
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(ProductIcon.ProductPreviewIcon, {}),
      /* @__PURE__ */ jsxRuntime.jsxs(Title, {
        children: [
          "S\u1EA3n ph\u1EA9m review (",
          productReviews == null ? void 0 : productReviews.length,
          ")"
        ]
      })
    ]
  });
};
const ProductReviewButtonStyled = styled__default["default"].div(
  ({ layout }) => `
    position: absolute;
    ${layout === constants.VideoPreviewLayout.Vertical ? `
       left: 8px;
      ` : `
       left: 0px;
      `}
    top: -8px;
    transform: translateY(-100%);
    display: flex;
    gap: 8px;
    padding: 2px 6px 2px 2px;
    background-color: #00000033;
    align-items: center;
    border-radius: 16px;
    cursor: pointer;
  `
);
const Title = styled__default["default"].p`
  color: #ffffff;
  align-items: center;
  border-radius: 16px;
  font-weight: 500;
  font-size: 13px;
`;

exports.ProductReviewButton = ProductReviewButton;


/***/ }),

/***/ 491589:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var coreRenderer = __webpack_require__(85097);
var styled = __webpack_require__(212951);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const FB_VIDEO_NOT_AVAILABLE_LINK = `https://www.facebook.com/plugins/video.php?href=https://fb.watch`;
const FB_SDK_URL = "https://connect.facebook.net/vi_VN/sdk.js#xfbml=1&version=v22.0";
const initFacebookSdk = () => {
  var _a, _b, _c, _d;
  const pageContainer = ((_a = document == null ? void 0 : document.querySelector(`#${coreRenderer.TEMPI_MAIN_IFRAME}`)) == null ? void 0 : _a.contentWindow) || window;
  const pageDocument = pageContainer == null ? void 0 : pageContainer.document;
  if (!pageDocument)
    return;
  if ((_c = (_b = pageContainer == null ? void 0 : pageContainer.FB) == null ? void 0 : _b.XFBML) == null ? void 0 : _c.parse) {
    pageContainer.FB.XFBML.parse();
    return;
  }
  const existingScript = pageContainer.document.querySelector(
    `script[src="${FB_SDK_URL}"]`
  );
  if (!existingScript) {
    pageContainer.fbAsyncInit = function() {
      var _a2, _b2, _c2, _d2, _e;
      (_b2 = (_a2 = pageContainer.FB) == null ? void 0 : _a2.init) == null ? void 0 : _b2.call(_a2, {
        xfbml: true,
        version: "v22.0"
      });
      (_e = (_d2 = (_c2 = pageContainer.FB) == null ? void 0 : _c2.XFBML) == null ? void 0 : _d2.parse) == null ? void 0 : _e.call(_d2);
    };
    const script = pageContainer.document.createElement("script");
    script.src = FB_SDK_URL;
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    script.onload = function() {
      var _a2, _b2, _c2;
      (_c2 = (_b2 = (_a2 = pageContainer.FB) == null ? void 0 : _a2.XFBML) == null ? void 0 : _b2.parse) == null ? void 0 : _c2.call(_b2);
    };
    (_d = pageDocument.body) == null ? void 0 : _d.appendChild(script);
  }
};
const FacebookVideoEmbed = ({
  isEditorMode,
  src,
  fullscreen,
  borderRadius,
  isBorderRadiusFull
}) => {
  React.useEffect(() => {
    initFacebookSdk();
  }, [src]);
  return /* @__PURE__ */ jsxRuntime.jsx(FacebookVideoWrapper, {
    isEditorMode,
    borderRadius,
    isBorderRadiusFull,
    children: /* @__PURE__ */ jsxRuntime.jsx("div", {
      className: "fb-video",
      "data-href": src || FB_VIDEO_NOT_AVAILABLE_LINK,
      "data-allowfullscreen": fullscreen ? "true" : "false"
    })
  });
};
const FacebookVideoWrapper = styled__default["default"].div(
  ({ isBorderRadiusFull, borderRadius = 16, isEditorMode }) => `
  ${isEditorMode ? `pointer-events: none;` : ``}
  overflow: hidden;
  border-radius: ${isBorderRadiusFull ? `${borderRadius}px;` : `${borderRadius}px ${borderRadius}px 0px 0px;`};
`
);

exports.FacebookVideoEmbed = FacebookVideoEmbed;


/***/ }),

/***/ 301638:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const TikTokVideoEmbed = ({
  isEditorMode,
  src,
  autoplay,
  loop,
  controls,
  description,
  musicDescription,
  isBorderRadiusFull,
  borderRadius
}) => {
  return /* @__PURE__ */ jsxRuntime.jsx(TiktokWrapper, {
    src: `https://www.tiktok.com/player/v1/${src ? coreRenderer.tiktokParser(src) : void 0}?autoplay=${isEditorMode ? 0 : autoplay ? 1 : 0}&loop=${loop ? 1 : 0}&controls=${controls ? 1 : 0}&description=${description ? 1 : 0}&music_info=${musicDescription ? 1 : 0}`,
    isEditorMode,
    isBorderRadiusFull,
    borderRadius
  });
};
const TiktokWrapper = styled__default["default"].iframe(
  ({ isBorderRadiusFull, borderRadius = 16, isEditorMode }) => `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
   ${isEditorMode ? `pointer-events: none;` : ``}
  border-radius: ${isBorderRadiusFull ? `${borderRadius}px;` : `${borderRadius}px ${borderRadius}px 0px 0px;`};
`
);

exports.TikTokVideoEmbed = TikTokVideoEmbed;


/***/ }),

/***/ 530812:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var React = __webpack_require__(891987);
var VideoIcon = __webpack_require__(779209);
var useVideoController = __webpack_require__(948821);
var detectUserAgent = __webpack_require__(579589);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const IS_FORCE_LOAD_THUBNAIL = true;
const VideoPlayerCore = (_a) => {
  var _b = _a, {
    videoUrl,
    imageSrcFallback,
    isBorderRadiusFull,
    borderRadius,
    togglePlayWhenFocus = true,
    iconSize = 20,
    allowClickPlayButton = true,
    hiddenPlayButton,
    thumbnailUrl
  } = _b, rest = __objRest(_b, [
    "videoUrl",
    "imageSrcFallback",
    "isBorderRadiusFull",
    "borderRadius",
    "togglePlayWhenFocus",
    "iconSize",
    "allowClickPlayButton",
    "hiddenPlayButton",
    "thumbnailUrl"
  ]);
  var _a2;
  const videoRef = React.useRef(null);
  const videoWrapperRef = React.useRef(null);
  const [isIOS, setIsIOS] = React.useState(false);
  const {
    isPlaying,
    muted,
    play,
    mute,
    unmute,
    pause,
    seekTo,
    enterFullscreen,
    currentTime
  } = useVideoController.useVideoController(videoRef, {
    autoPlay: (rest == null ? void 0 : rest.autoPlay) || false,
    initialMuted: (_a2 = rest == null ? void 0 : rest.muted) != null ? _a2 : true
  });
  const iconWidth = iconSize + 8 * 2;
  const isShowThumbnail = thumbnailUrl && !isPlaying && currentTime < 0.1;
  const srcMerged = videoUrl && (isIOS || IS_FORCE_LOAD_THUBNAIL) ? `${videoUrl}#t=0.001` : videoUrl;
  React.useEffect(() => {
    const wrapperREl = videoWrapperRef.current;
    if (!wrapperREl || !togglePlayWhenFocus)
      return;
    let hasMouseEntered = false;
    let mouseEnterTimer;
    const onMouseEnter = (e) => {
      mouseEnterTimer = setTimeout(() => {
        var _a3;
        const from = e.relatedTarget || null;
        if (((_a3 = videoWrapperRef.current) == null ? void 0 : _a3.contains(from)) || hasMouseEntered)
          return;
        hasMouseEntered = true;
        play();
      }, 700);
    };
    const onMouseLeave = (e) => {
      var _a3;
      clearTimeout(mouseEnterTimer);
      const from = e.relatedTarget || null;
      if ((_a3 = videoWrapperRef.current) == null ? void 0 : _a3.contains(from))
        return;
      hasMouseEntered = false;
      pause();
      seekTo(0);
    };
    wrapperREl.addEventListener("mouseenter", onMouseEnter);
    wrapperREl.addEventListener("mouseleave", onMouseLeave);
    return () => {
      wrapperREl.removeEventListener("mouseenter", onMouseEnter);
      wrapperREl.removeEventListener("mouseleave", onMouseLeave);
    };
  }, [videoWrapperRef, videoRef]);
  React.useEffect(() => {
    try {
      const isiOS = detectUserAgent.checkIOS();
      setIsIOS(isiOS);
    } catch (error) {
      console.error(error);
    }
  }, []);
  return /* @__PURE__ */ jsxRuntime.jsxs(VideoWrapper, {
    ref: videoWrapperRef,
    children: [
      isShowThumbnail && /* @__PURE__ */ jsxRuntime.jsx(ThumbnailVideo, {
        thumbnailUrl,
        borderRadius,
        isBorderRadiusFull
      }),
      /* @__PURE__ */ jsxRuntime.jsx(StyledVideo, __spreadValues({
        ref: videoRef,
        muted: true,
        playsInline: true,
        preload: thumbnailUrl ? "none" : "metadata",
        crossOrigin: "anonymous",
        isBorderRadiusFull,
        borderRadius,
        src: srcMerged,
        onContextMenu: (e) => e.preventDefault(),
        controlsList: "nodownload"
      }, rest)),
      isPlaying && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(VideoIcon.IconWrapper, {
            size: iconSize,
            onClick: pause,
            style: {
              top: 24,
              left: 10 + iconWidth / 2
            },
            children: /* @__PURE__ */ jsxRuntime.jsx(VideoIcon.PauseIcon, {})
          }),
          /* @__PURE__ */ jsxRuntime.jsx(VideoIcon.IconWrapper, {
            size: iconSize,
            onClick: muted ? unmute : mute,
            style: {
              top: 24,
              left: 20 + iconWidth * 3 / 2
            },
            children: muted ? /* @__PURE__ */ jsxRuntime.jsx(VideoIcon.VolumeOffIcon, {}) : /* @__PURE__ */ jsxRuntime.jsx(VideoIcon.VolumeOnIcon, {})
          }),
          /* @__PURE__ */ jsxRuntime.jsx(VideoIcon.IconWrapper, {
            size: iconSize,
            onClick: enterFullscreen,
            style: {
              top: 24,
              right: 10 - iconWidth / 2
            },
            children: /* @__PURE__ */ jsxRuntime.jsx(VideoIcon.FullScreenIcon, {})
          })
        ]
      }),
      !hiddenPlayButton && !isPlaying && /* @__PURE__ */ jsxRuntime.jsx(VideoIcon.IconWrapper, {
        className: "video-play-icon",
        isStopPropagation: false,
        onClick: () => {
          if (!allowClickPlayButton)
            return;
          play();
          unmute();
        },
        style: {
          top: "50%",
          left: "50%",
          backgroundColor: "#FFFFFF80",
          border: "1px solid #ffffff",
          padding: 16
        },
        size: iconSize + 12,
        children: /* @__PURE__ */ jsxRuntime.jsx(VideoIcon.PlayIcon, {})
      })
    ]
  });
};
const VideoWrapper = styled__default["default"].div`
  position: relative;
  width: 100%;
  height: 100%;
  container-type: inline-size;
  @container (max-width: 150px) {
    .video-play-icon {
      display: none;
    }
  }
`;
const StyledVideo = styled__default["default"].video(
  ({ isBorderRadiusFull, borderRadius = 16 }) => `
  object-fit: cover;
  outline: none;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &.editor-mode {
    pointer-events: none;
  }
  border-radius: ${isBorderRadiusFull ? `${borderRadius}px;` : `${borderRadius}px ${borderRadius}px 0px 0px;`};

  background: #000000;

  &.video-loadedmetadata {
    background: none;
  }

  &:fullscreen {
    object-fit: contain;
    border-radius: 0;
  }

  &:-webkit-full-screen {
    object-fit: contain;
  }
`
);
const ThumbnailVideo = styled__default["default"].video(
  ({ thumbnailUrl, isBorderRadiusFull, borderRadius }) => `
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0;
    background: url('${thumbnailUrl}') center/cover no-repeat;
    pointer-events: none;
    z-index: 0;
    border-radius: ${isBorderRadiusFull ? `${borderRadius}px;` : `${borderRadius}px ${borderRadius}px 0px 0px;`};
`
);

exports.VideoPlayerCore = VideoPlayerCore;


/***/ }),

/***/ 446419:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var Ytb = __webpack_require__(499985);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var Ytb__default = /*#__PURE__*/_interopDefaultLegacy(Ytb);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const YouTubeVideoEmbed = ({
  src,
  isEditorMode,
  autoplay,
  loop,
  showController,
  isBorderRadiusFull,
  borderRadius
}) => {
  const { videoId, playlistId } = coreRenderer.youtubeParser(src);
  return /* @__PURE__ */ jsxRuntime.jsx(YouTubeFrame, {
    iframeClassName: "youtube-video-frame",
    isEditorMode,
    borderRadius,
    isBorderRadiusFull,
    videoId,
    loading: "lazy",
    opts: !isEditorMode ? {
      playerVars: __spreadProps(__spreadValues({}, playlistId ? { listType: "playlist", list: playlistId } : { playlist: videoId }), {
        autoplay: autoplay ? 1 : 0,
        mute: autoplay ? 1 : 0,
        loop: loop ? 1 : 0,
        controls: showController ? 1 : 0
      }),
      width: "100%",
      height: "100%"
    } : {
      width: "100%",
      height: "100%"
    }
  });
};
const YouTubeFrame = styled__default["default"](Ytb__default["default"])(
  ({ isBorderRadiusFull, borderRadius = 16, isEditorMode }) => `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  ${isEditorMode ? `pointer-events: none;` : ``}
  .youtube-video-frame {
    border-radius: ${isBorderRadiusFull ? `${borderRadius}px;` : `${borderRadius}px ${borderRadius}px 0px 0px;`};
  }
`
);

exports.YouTubeVideoEmbed = YouTubeVideoEmbed;


/***/ }),

/***/ 948821:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var React = __webpack_require__(891987);

const useVideoController = (videoRef, {
  autoPlay = false,
  initialMuted = false,
  initialVolume = 0.8
} = {}) => {
  const [isPlaying, setPlaying] = React.useState(false);
  const [muted, setMuted] = React.useState(initialMuted);
  const [volume, setVolume] = React.useState(initialVolume);
  const [duration, setDuration] = React.useState(0);
  const currentTime = React.useRef(null);
  React.useEffect(() => {
    const v = videoRef.current;
    if (!v)
      return;
    v.muted = muted;
    v.volume = volume;
  }, [muted, volume, videoRef]);
  React.useEffect(() => {
    const v = videoRef.current;
    if (!v)
      return;
    const onLoaded = () => {
      setDuration(v.duration || 0);
      v.classList.add("video-loadedmetadata");
    };
    const onTime = () => {
      currentTime.current = v.currentTime || 0;
    };
    const onPlay = () => setPlaying(true);
    const onPause = () => setPlaying(false);
    const onVolumeChange = () => {
      setMuted(v.muted);
      setVolume(v.volume);
    };
    const onEnded = () => {
      v.currentTime = 0;
      v.pause();
      setPlaying(false);
    };
    v.addEventListener("loadedmetadata", onLoaded);
    v.addEventListener("timeupdate", onTime);
    v.addEventListener("play", onPlay);
    v.addEventListener("pause", onPause);
    v.addEventListener("volumechange", onVolumeChange);
    v.addEventListener("ended", onEnded);
    if (autoPlay)
      v.play().catch(() => {
      });
    return () => {
      v.removeEventListener("loadedmetadata", onLoaded);
      v.removeEventListener("timeupdate", onTime);
      v.removeEventListener("play", onPlay);
      v.removeEventListener("pause", onPause);
      v.removeEventListener("volumechange", onVolumeChange);
      v.removeEventListener("ended", onEnded);
    };
  }, [videoRef, autoPlay]);
  const play = React.useCallback(() => {
    var _a;
    return (_a = videoRef.current) == null ? void 0 : _a.play();
  }, [videoRef]);
  const pause = React.useCallback(() => {
    var _a;
    return (_a = videoRef.current) == null ? void 0 : _a.pause();
  }, [videoRef]);
  const mute = React.useCallback(() => {
    const v = videoRef.current;
    if (!v)
      return;
    v.muted = true;
  }, [videoRef]);
  const unmute = React.useCallback(() => {
    const v = videoRef.current;
    if (!v)
      return;
    v.muted = false;
  }, [videoRef]);
  const togglePlay = React.useCallback(() => {
    const v = videoRef.current;
    if (!v)
      return;
    v.paused ? v.play() : v.pause();
  }, [videoRef]);
  const toggleMute = React.useCallback(() => setMuted((m) => !m), []);
  const setVolumeClamped = React.useCallback((val) => {
    const v = Math.min(1, Math.max(0, val));
    setVolume(v);
    if (v === 0)
      setMuted(true);
    else
      setMuted(false);
  }, []);
  const seekRatio = React.useCallback(
    (ratio) => {
      const v = videoRef.current;
      if (!v || !Number.isFinite(v.duration))
        return;
      const r = Math.min(1, Math.max(0, ratio));
      v.currentTime = r * v.duration;
    },
    [videoRef]
  );
  const seekTo = React.useCallback(
    (timeSec) => {
      const v = videoRef.current;
      if (!v || !Number.isFinite(v.duration))
        return;
      v.currentTime = Math.min(v.duration, Math.max(0, timeSec));
    },
    [videoRef]
  );
  const enterFullscreen = React.useCallback(
    async (container) => {
      const el = container != null ? container : videoRef.current;
      if (!el)
        return;
      if (el.requestFullscreen) {
        el.requestFullscreen();
      } else if (el.webkitRequestFullscreen) {
        el.webkitRequestFullscreen();
      } else if (el.webkitEnterFullScreen) {
        el.webkitEnterFullScreen();
      }
    },
    [videoRef]
  );
  const exitFullscreen = React.useCallback(async () => {
    if (document.fullscreenElement)
      await document.exitFullscreen();
  }, []);
  const toggleFullscreen = React.useCallback(
    async (container) => {
      if (document.fullscreenElement)
        return exitFullscreen();
      return enterFullscreen(container);
    },
    [enterFullscreen, exitFullscreen]
  );
  return {
    isPlaying,
    muted,
    volume,
    duration,
    currentTime: currentTime.current,
    play,
    pause,
    mute,
    unmute,
    togglePlay,
    toggleMute,
    setVolume: setVolumeClamped,
    seekRatio,
    seekTo,
    enterFullscreen,
    exitFullscreen,
    toggleFullscreen
  };
};

exports.useVideoController = useVideoController;


/***/ }),

/***/ 389302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var constants = __webpack_require__(177718);
var VideoPlayerCore = __webpack_require__(530812);
var VideoProductCard = __webpack_require__(370149);
var VideoShortDescription = __webpack_require__(656872);
var FacebookVideo = __webpack_require__(491589);
var TiktokVideo = __webpack_require__(301638);
var YouTubeVideo = __webpack_require__(446419);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const VideoPreviewItem = (props) => {
  const { device, globalData } = coreRenderer.useStore();
  const isPreviewMode = globalData == null ? void 0 : globalData.isPreviewMode;
  const _a = props, {
    isEditingMode,
    videoUrl,
    videoPlatform = constants.VideoPlatform.Upload,
    facebook,
    tiktok,
    youtube,
    layout,
    itemStyle,
    isFocusMode = false,
    productReviews,
    videoProps,
    displayType,
    productSkus,
    description,
    hiddenPlayButton = false,
    thumbnailUrl,
    hideBuyNowButton
  } = _a, rest = __objRest(_a, [
    "isEditingMode",
    "videoUrl",
    "videoPlatform",
    "facebook",
    "tiktok",
    "youtube",
    "layout",
    "itemStyle",
    "isFocusMode",
    "productReviews",
    "videoProps",
    "displayType",
    "productSkus",
    "description",
    "hiddenPlayButton",
    "thumbnailUrl",
    "hideBuyNowButton"
  ]);
  const { borderRadius } = itemStyle || {};
  const isMobile = device === "mobile";
  const isShowProductCard = displayType === constants.VideoPreviewDisplayType.ProductCard && (isEditingMode || isPreviewMode || (productReviews == null ? void 0 : productReviews.length));
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, __spreadProps(__spreadValues({
    className: "video-preview-item-wrapper",
    isMobile,
    isEditingMode
  }, rest), {
    title: "",
    children: /* @__PURE__ */ jsxRuntime.jsxs(ContentWrapper, {
      children: [
        /* @__PURE__ */ jsxRuntime.jsxs(VideoWrapper, {
          aspectRatio: videoProps == null ? void 0 : videoProps.aspectRatio,
          children: [
            videoPlatform === constants.VideoPlatform.Facebook && /* @__PURE__ */ jsxRuntime.jsx(FacebookVideo.FacebookVideoEmbed, {
              src: facebook == null ? void 0 : facebook.videoUrl,
              fullscreen: true,
              isEditorMode: isEditingMode,
              borderRadius,
              isBorderRadiusFull: !isShowProductCard || layout === constants.VideoPreviewLayout.Overlay
            }),
            videoPlatform === constants.VideoPlatform.TikTok && /* @__PURE__ */ jsxRuntime.jsx(TiktokVideo.TikTokVideoEmbed, {
              src: tiktok == null ? void 0 : tiktok.videoUrl,
              isEditorMode: isEditingMode,
              borderRadius,
              isBorderRadiusFull: !isShowProductCard || layout === constants.VideoPreviewLayout.Overlay,
              controls: !isEditingMode
            }),
            videoPlatform === constants.VideoPlatform.YouTube && /* @__PURE__ */ jsxRuntime.jsx(YouTubeVideo.YouTubeVideoEmbed, {
              src: youtube == null ? void 0 : youtube.videoUrl,
              isEditorMode: isEditingMode,
              borderRadius,
              isBorderRadiusFull: !isShowProductCard || layout === constants.VideoPreviewLayout.Overlay,
              showController: true
            }),
            videoPlatform === constants.VideoPlatform.Upload && /* @__PURE__ */ jsxRuntime.jsx(VideoPlayerCore.VideoPlayerCore, __spreadValues({
              muted: true,
              playsInline: true,
              borderRadius,
              togglePlayWhenFocus: !isFocusMode,
              iconSize: !isFocusMode && isMobile ? 12 : 20,
              videoUrl,
              allowClickPlayButton: !isMobile || isFocusMode,
              isBorderRadiusFull: !isShowProductCard || layout === constants.VideoPreviewLayout.Overlay,
              hiddenPlayButton,
              thumbnailUrl
            }, videoProps))
          ]
        }),
        isShowProductCard ? /* @__PURE__ */ jsxRuntime.jsx(VideoProductCard.VideoProductCard, {
          layout,
          itemStyle,
          productReviews,
          productCurrent: productReviews == null ? void 0 : productReviews[0],
          hiddenButtonBuyNow: hideBuyNowButton || !isFocusMode && layout === constants.VideoPreviewLayout.Overlay
        }) : null,
        displayType === constants.VideoPreviewDisplayType.ShortDescription ? /* @__PURE__ */ jsxRuntime.jsx(VideoShortDescription.VideoShortDescription, {
          description,
          borderRadius
        }) : null
      ]
    })
  }));
};
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
    position: relative;
    overflow: clip;
    width: ${constants.VIDEO_PREVIEW_ITEM_WIDTH_DEFAULT_DESKTOP}px;
    ${coreRenderer.getStyle(commonStyle)}
    `
);
const ContentWrapper = styled__default["default"].div`
  display: flex;
  flex-direction: column;
`;
const VideoWrapper = styled__default["default"].div(
  ({ aspectRatio }) => `
    position: relative;
    aspect-ratio: ${aspectRatio || "9 / 16"};
`
);

exports.VideoPreviewItem = VideoPreviewItem;


/***/ }),

/***/ 370149:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var React = __webpack_require__(891987);
var constants = __webpack_require__(177718);
var context = __webpack_require__(203231);
var utils = __webpack_require__(175321);
var ProductIcon = __webpack_require__(882756);
var ProductReviewButton = __webpack_require__(713299);
var formatCurrency = __webpack_require__(173685);
var coreRenderer = __webpack_require__(85097);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const VideoProductCard = (_a) => {
  var _b = _a, {
    layout,
    itemStyle,
    productReviews,
    hiddenButtonBuyNow,
    isShowButtonViewMoreProduct = true,
    productCurrent
  } = _b, rest = __objRest(_b, [
    "layout",
    "itemStyle",
    "productReviews",
    "hiddenButtonBuyNow",
    "isShowButtonViewMoreProduct",
    "productCurrent"
  ]);
  var _a2;
  const { borderRadius } = itemStyle || {};
  const [loadingAddToCart, setLoadingAddToCart] = React.useState(false);
  const [loadingBuyNow, setLoadingBuyNow] = React.useState(false);
  const pinProduct = productCurrent || constants.PRODUCT_REVIEW_EXAMPLE;
  const { imageUrl, name, price, showContact } = pinProduct || {};
  const { latestPrice, supplierRetailPrice, discountPercent } = price || {};
  const { addToCart, buyNow } = React.useContext(context.VideoPreviewListContext);
  const handleAddToCart = async (e) => {
    e.stopPropagation();
    if (!productCurrent)
      return;
    setLoadingAddToCart(true);
    try {
      await (addToCart == null ? void 0 : addToCart(productCurrent));
      await new Promise((resolve) => setTimeout(resolve, 500, null));
    } finally {
      setLoadingAddToCart(false);
    }
  };
  const handleBuyNow = async (e) => {
    e.stopPropagation();
    if (!productCurrent)
      return;
    setLoadingBuyNow(true);
    try {
      await (buyNow == null ? void 0 : buyNow(productCurrent));
    } finally {
      setLoadingBuyNow(false);
    }
  };
  const isOutOfStock = showContact && latestPrice;
  return /* @__PURE__ */ jsxRuntime.jsxs(VideoProductCardWrapper, __spreadProps(__spreadValues({
    layout,
    borderRadius
  }, rest), {
    children: [
      isShowButtonViewMoreProduct && (productReviews == null ? void 0 : productReviews.length) > 1 && /* @__PURE__ */ jsxRuntime.jsx(ProductReviewButton.ProductReviewButton, {
        productReviews,
        layout
      }),
      /* @__PURE__ */ jsxRuntime.jsx(ImageWrapper, {
        children: /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
          commonStyle: {
            width: "100%",
            objectFit: "contain",
            marginLeft: "auto",
            marginRight: "auto",
            height: "100%",
            borderRadius: 8,
            maxHeight: layout === ((_a2 = constants.VideoPreviewLayout) == null ? void 0 : _a2.Vertical) ? 96 : 66
          },
          src: imageUrl
        })
      }),
      /* @__PURE__ */ jsxRuntime.jsxs(ProductCardBody, {
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(ProductTitle, {
            title: name,
            children: name
          }),
          /* @__PURE__ */ jsxRuntime.jsxs(ProductCardBottom, {
            layout,
            children: [
              /* @__PURE__ */ jsxRuntime.jsxs(ProductPrice, {
                children: [
                  /* @__PURE__ */ jsxRuntime.jsx("p", {
                    className: "price--current",
                    style: { minHeight: 22 },
                    children: formatCurrency.formatCurrency(latestPrice)
                  }),
                  /* @__PURE__ */ jsxRuntime.jsx("div", {
                    style: { display: "flex", gap: 6, minHeight: 16 },
                    children: latestPrice !== supplierRetailPrice && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
                      children: [
                        /* @__PURE__ */ jsxRuntime.jsx("span", {
                          className: "price--old",
                          children: formatCurrency.formatCurrency(supplierRetailPrice)
                        }),
                        /* @__PURE__ */ jsxRuntime.jsx("span", {
                          className: "price--off",
                          children: discountPercent
                        })
                      ]
                    })
                  })
                ]
              }),
              /* @__PURE__ */ jsxRuntime.jsx(ProductCardActions, {
                children: isOutOfStock ? /* @__PURE__ */ jsxRuntime.jsx(OutStockLabel, {
                  children: "H\u1EBFt h\xE0ng"
                }) : /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
                  children: [
                    /* @__PURE__ */ jsxRuntime.jsx(ButtonCard, {
                      className: "btn btn--icon",
                      "aria-label": "Th\xEAm gi\u1ECF",
                      onClick: handleAddToCart,
                      disabled: loadingAddToCart,
                      children: loadingAddToCart ? /* @__PURE__ */ jsxRuntime.jsx("div", {
                        className: "spinner"
                      }) : /* @__PURE__ */ jsxRuntime.jsx(ProductIcon.CardIcon, {})
                    }),
                    !hiddenButtonBuyNow && /* @__PURE__ */ jsxRuntime.jsx(ButtonBuyNow, {
                      className: "btn btn--icon",
                      "aria-label": "Th\xEAm gi\u1ECF",
                      onClick: handleBuyNow,
                      disabled: loadingBuyNow,
                      children: loadingBuyNow ? /* @__PURE__ */ jsxRuntime.jsx("div", {
                        className: "spinner"
                      }) : "Mua ngay"
                    })
                  ]
                })
              })
            ]
          })
        ]
      })
    ]
  }));
};
const VideoProductCardWrapper = styled__default["default"].div(
  ({ layout, borderRadius = 16 }) => `
  position: relative;
  justify-self: center;
  background-color: #ffffff;
  padding: 8px;
  display: grid;
  gap: 8px;
  grid-template-columns: min(30%, 80px) 1fr;
  border: 1px solid #00000026;

  ${layout === constants.VideoPreviewLayout.Overlay ? `
      position: absolute;
      bottom: 10px;
      width: calc(100% - 16px);
      left: 50%;
      transform: translateX(-50%);
      border-radius: ${borderRadius - 4}px;
      grid-template-columns: min(30%, 68px) 1fr;
    ` : `
        border-radius: 0px 0px ${borderRadius}px ${borderRadius}px;
      `}

    .spinner {
      width: 16px;
      height: 16px;
      border: 2px solid rgba(255, 255, 255, 0.6);
      border-top: 2px solid #fff;
      border-radius: 50%;
      animation: spread-animation 0.8s linear infinite;
  }
`
);
const ImageWrapper = styled__default["default"].div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;

  div {
    width: 100%;
    height: 100%;
  }
`;
const ProductCardBody = styled__default["default"].div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
const ProductTitle = styled__default["default"].p`
  ${utils.getClampedTextStyle(1)}
  font-size: 13px;
  line-height: 20px;
`;
const ProductPrice = styled__default["default"].div`
  display: flex;
  flex-direction: column;
  gap: 0px;

  .price--current {
    font-weight: 500;
    font-size: 15px;
    line-height: 22px;
  }

  .price--old {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #00000073;
    text-decoration: line-through;
  }

  .price--off {
    font-size: 12px;
    line-height: 16px;
    color: #f5222d;
  }
`;
const ProductCardActions = styled__default["default"].div`
  display: flex;
  gap: 8px;
`;
const ProductCardBottom = styled__default["default"].div(
  ({ layout }) => `
  display: flex;
  gap: 4px;

  ${layout === constants.VideoPreviewLayout.Overlay ? `
     flex-direction: row;
     justify-content: space-between;
     align-items: end;
    ` : `
  flex-direction: column;

      `}
`
);
const ButtonCard = styled__default["default"].button`
  padding: 4px 16px;
  border-radius: 9999px;
  border: 1px #00000026 solid;
  background: transparent;
  height: 32px;
  &:disabled {
    opacity: 0.6;
    cursor: auto;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  .spinner {
    border: 2px solid rgba(0, 0, 0, 0.4);
    border-top: 2px solid #000;
  }
`;
const ButtonBuyNow = styled__default["default"].button`
  padding: 4px 16px;
  height: 32px;
  white-space: nowrap;
  flex: 1;
  background: #0200bc;
  color: #ffffff;
  border-radius: 9999px;
  &:disabled {
    opacity: 0.6;
    cursor: auto;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
`;
const OutStockLabel = styled__default["default"].div`
  font-size: 14px;
  color: #faad14;
  display: flex;
  align-items: center;
  min-height: 32px;
  padding: 0 8px 0 0;
  text-align: center;
 }
`;

exports.VideoProductCard = VideoProductCard;


/***/ }),

/***/ 656872:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var utils = __webpack_require__(175321);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const VideoShortDescription = ({
  description,
  borderRadius
}) => {
  if (!description)
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    borderRadius,
    children: /* @__PURE__ */ jsxRuntime.jsx(Description, {
      title: description,
      children: description
    })
  });
};
const Wrapper = styled__default["default"].div(
  ({ borderRadius = 16 }) => `
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: linear-gradient(180deg, rgba(2, 0, 188, 0) 0%, #0200BC 100%);
    padding: 16px 8px;
    height: 72px;
    border-radius: 0px 0px ${borderRadius}px ${borderRadius}px;
    cursor: pointer;
    `
);
const Description = styled__default["default"].p`
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  color: #ffffff;
  letter-spacing: 0%;
  ${utils.getClampedTextStyle(2)};
  word-break: break-word;
`;

exports.VideoShortDescription = VideoShortDescription;


/***/ }),

/***/ 809420:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var React = __webpack_require__(891987);

const useModalPreviewVideo = ({
  isEditingMode
}) => {
  const [currentVideoFocus, setCurrentVideoFocus] = React.useState();
  const [showModalPreview, setShowModalPreview] = React.useState(false);
  const [showListProductPreview, setShowListProductPreview] = React.useState(false);
  const handleFocusVideo = (video) => {
    if (!(video == null ? void 0 : video.videoUrl) || isEditingMode)
      return;
    setCurrentVideoFocus(video);
    setShowModalPreview(true);
  };
  const handleShowListProductReview = (video) => {
    if (video)
      handleFocusVideo(video);
    setShowListProductPreview(true);
  };
  return {
    currentVideoFocus,
    setCurrentVideoFocus,
    showModalPreview,
    setShowModalPreview,
    showListProductPreview,
    setShowListProductPreview,
    handleFocusVideo,
    handleShowListProductReview
  };
};

exports.useModalPreviewVideo = useModalPreviewVideo;


/***/ }),

/***/ 177718:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var style = __webpack_require__(667925);
var grid = __webpack_require__(860046);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var VideoPreviewLayout = /* @__PURE__ */ ((VideoPreviewLayout2) => {
  VideoPreviewLayout2["Vertical"] = "vertical";
  VideoPreviewLayout2["Overlay"] = "overlay";
  return VideoPreviewLayout2;
})(VideoPreviewLayout || {});
var VideoPreviewDisplayType = /* @__PURE__ */ ((VideoPreviewDisplayType2) => {
  VideoPreviewDisplayType2["ProductCard"] = "product_card";
  VideoPreviewDisplayType2["ShortDescription"] = "short_description";
  return VideoPreviewDisplayType2;
})(VideoPreviewDisplayType || {});
var VideoPreviewWidthType = /* @__PURE__ */ ((VideoPreviewWidthType2) => {
  VideoPreviewWidthType2["FullWidth"] = "fullWidth";
  VideoPreviewWidthType2["HugContent"] = "hugContent";
  return VideoPreviewWidthType2;
})(VideoPreviewWidthType || {});
const BASE_VIDEO_PREVIEW_LIST_DATA = {
  widthType: "fullWidth" /* FullWidth */,
  layout: "vertical" /* Vertical */,
  displayType: "product_card" /* ProductCard */,
  titleColor: "#000000",
  viewMoreStyle: {
    color: "#000000"
  },
  items: [
    {
      videoUrl: "https://storage.googleapis.com/develop-teko-storage/media/video/2025/10/22/27291001-31aa-4136-b8e2-a9170bf51da5/video%20mp4.mp4",
      title: "video preview 1"
    },
    {
      videoUrl: "https://storage.googleapis.com/develop-teko-storage/media/video/2025/10/22/27291001-31aa-4136-b8e2-a9170bf51da5/video%20mp4.mp4",
      title: "video preview 2"
    }
  ],
  maxWidth: grid.DEFAULT_MAX_WIDTH
};
const VIDEO_PREVIEW_ITEM_STYLE = {
  borderRadius: 12
};
const DEFAULT_VIDEO_PREVIEW_LIST = __spreadProps(__spreadValues({}, BASE_VIDEO_PREVIEW_LIST_DATA), {
  itemStyle: VIDEO_PREVIEW_ITEM_STYLE,
  desktop: {
    commonStyle: __spreadValues({}, style.DESKTOP_COMMON_STYLE),
    itemPerView: 5
  },
  mobile: {
    commonStyle: __spreadProps(__spreadValues({}, style.MOBILE_COMMON_STYLE), {
      padding: {
        left: 0,
        right: 0
      }
    }),
    itemPerView: 1.5
  }
});
const VIDEO_PREVIEW_ITEM_WIDTH_DEFAULT_DESKTOP = 288;
const VIDEO_PREVIEW_DEFAULT_SPACING_DESKTOP = 24;
const VIDEO_PREVIEW_DEFAULT_SPACING_MOBILE = 8;
const MAX_VIDEO_ITEM_MOBILE = 3;
const PRODUCT_REVIEW_EXAMPLE = {
  sku: "1",
  sellerSku: "LINH004",
  name: "Tr\xE0 xanh C2 \u1ED5i h\u1ED3ng chanh d\xE2y 455ml",
  imageUrl: "https://lh3.googleusercontent.com/gtOHWQvi2DXbJg8oNW5-4kx0DMzU_JkVtqYOVcI3WNhI_euoaDDeOpKRMUo9GDl3KC8JbLQhClqYSIwY44_2-UArEvOFliU",
  price: {
    latestPrice: 121200,
    supplierRetailPrice: 15e4,
    discountAmount: 28755,
    discountPercent: "-19%"
  },
  stockQuantity: 1e3,
  selectPromotionId: 0,
  link: {
    as: {
      pathname: "/linhptn-tra-xanh-c2-oi-hong-chanh-day-455ml--s250301535",
      query: {}
    },
    href: { pathname: "/products/[sku]", query: { sku: "250301535" } },
    passHref: true
  },
  bestComboDiscount: "0",
  numberDisplayFormat: { thousandSeparator: ".", decimalSeparator: "," },
  precisionToDisplayDecimalQuantity: 0,
  showContact: false
};
const LIST_PRODUCT_REVIEW_EXAMPLE = [
  __spreadProps(__spreadValues({}, PRODUCT_REVIEW_EXAMPLE), {
    sku: "1",
    sellerSku: "LINH004",
    name: "Tr\xE0 xanh C2 \u1ED5i h\u1ED3ng chanh d\xE2y 455ml"
  }),
  __spreadProps(__spreadValues({}, PRODUCT_REVIEW_EXAMPLE), {
    sku: "2",
    sellerSku: "seller2",
    name: "\u0110\xE2y l\xE0 s\u1EA3n ph\u1EA9m preview 2"
  }),
  __spreadProps(__spreadValues({}, PRODUCT_REVIEW_EXAMPLE), {
    sku: "3",
    sellerSku: "seller3",
    name: "\u0110\xE2y l\xE0 s\u1EA3n ph\u1EA9m preview 3"
  }),
  __spreadProps(__spreadValues({}, PRODUCT_REVIEW_EXAMPLE), {
    sku: "4",
    sellerSku: "seller4",
    name: "\u0110\xE2y l\xE0 s\u1EA3n ph\u1EA9m preview 4"
  }),
  __spreadProps(__spreadValues({}, PRODUCT_REVIEW_EXAMPLE), {
    sku: "5",
    sellerSku: "seller5",
    name: "\u0110\xE2y l\xE0 s\u1EA3n ph\u1EA9m preview 5"
  }),
  __spreadProps(__spreadValues({}, PRODUCT_REVIEW_EXAMPLE), {
    sku: "6",
    sellerSku: "seller6",
    name: "\u0110\xE2y l\xE0 s\u1EA3n ph\u1EA9m preview 6"
  }),
  __spreadProps(__spreadValues({}, PRODUCT_REVIEW_EXAMPLE), {
    sku: "7",
    sellerSku: "seller7",
    name: "\u0110\xE2y l\xE0 s\u1EA3n ph\u1EA9m preview 7"
  }),
  __spreadProps(__spreadValues({}, PRODUCT_REVIEW_EXAMPLE), {
    sku: "8",
    sellerSku: "seller7",
    name: "\u0110\xE2y l\xE0 s\u1EA3n ph\u1EA9m preview 7"
  }),
  __spreadProps(__spreadValues({}, PRODUCT_REVIEW_EXAMPLE), {
    sku: "9",
    sellerSku: "seller7",
    name: "\u0110\xE2y l\xE0 s\u1EA3n ph\u1EA9m preview 7"
  }),
  __spreadProps(__spreadValues({}, PRODUCT_REVIEW_EXAMPLE), {
    sku: "10",
    sellerSku: "seller7",
    name: "\u0110\xE2y l\xE0 s\u1EA3n ph\u1EA9m preview 7"
  })
];
const PROPS_DEFAULT_LAYOUT_VIDEO_PREVIEW_TWO_COL = {
  ["row"]: {
    responsive: {
      hiddenXs: false,
      hiddenMd: false
    },
    gutter: [0, 0],
    widthType: "full",
    contentWidthType: "fixed",
    row: {
      commonStyle: {
        maxWidth: 1232
      }
    },
    desktop: {
      gutter: [0, 0],
      commonStyle: style.DESKTOP_COMMON_STYLE
    },
    mobile: {
      gutter: [0, 0],
      commonStyle: __spreadProps(__spreadValues({}, style.MOBILE_COMMON_STYLE), {
        padding: {
          left: 8,
          right: 8
        }
      })
    }
  },
  ["col_left"]: {
    responsive: {
      hiddenXs: false,
      hiddenMd: false
    },
    md: {
      flex: "50%"
    },
    xs: {
      flex: "50%"
    },
    desktop: {
      commonStyle: {
        padding: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          main: 0
        },
        margin: {
          top: 0,
          right: 4,
          bottom: 0,
          left: 0,
          main: 0
        }
      }
    },
    mobile: {
      commonStyle: {
        padding: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          main: 0
        },
        margin: {
          top: 0,
          right: 4,
          bottom: 0,
          left: 0,
          main: 0
        }
      }
    }
  },
  ["col_right"]: {
    responsive: {
      hiddenXs: false,
      hiddenMd: false
    },
    md: {
      flex: "50%"
    },
    xs: {
      flex: "50%"
    },
    desktop: {
      commonStyle: {
        padding: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          main: 0
        },
        margin: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 4,
          main: 0
        }
      }
    },
    mobile: {
      commonStyle: {
        padding: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          main: 0
        },
        margin: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 4,
          main: 0
        }
      }
    }
  },
  ["omni_videopreviewlist"]: {
    responsive: {
      hiddenXs: false,
      hiddenMd: false
    },
    widthType: "fullWidth",
    layout: "overlay",
    displayType: "short_description",
    titleColor: "#000000",
    viewMoreStyle: {
      color: "#000000"
    },
    items: [
      {
        videoUrl: "https://storage.googleapis.com/develop-teko-storage/media/video/2025/10/22/27291001-31aa-4136-b8e2-a9170bf51da5/video%20mp4.mp4",
        title: "video preview 1",
        description: "N\u1ED9i dung m\xF4 t\u1EA3 N\u1ED9i dung m\xF4 t\u1EA3\n"
      },
      {
        videoUrl: "https://storage.googleapis.com/develop-teko-storage/media/video/2025/10/22/27291001-31aa-4136-b8e2-a9170bf51da5/video%20mp4.mp4",
        title: "video preview 2",
        description: "N\u1ED9i dung m\xF4 t\u1EA3 N\u1ED9i dung m\xF4 t\u1EA3\n N\u1ED9i dung m\xF4 t\u1EA3 N\u1ED9i dung m\xF4 t\u1EA3\n"
      }
    ],
    maxWidth: 1232,
    itemStyle: {
      borderRadius: 12
    },
    desktop: {
      itemPerView: 5
    },
    mobile: {
      itemPerView: 2
    },
    title: "Video Preview",
    viewMoreUrl: "",
    commonStyle: {
      background: "rgba(255,255,255,1)"
    }
  }
};
var VideoPlatform = /* @__PURE__ */ ((VideoPlatform2) => {
  VideoPlatform2["YouTube"] = "YouTube";
  VideoPlatform2["Facebook"] = "Facebook";
  VideoPlatform2["TikTok"] = "TikTok";
  VideoPlatform2["Upload"] = "Upload";
  return VideoPlatform2;
})(VideoPlatform || {});
const VIDEO_PLATFORM = [
  "YouTube" /* YouTube */,
  "Facebook" /* Facebook */,
  "TikTok" /* TikTok */,
  "Upload" /* Upload */
];

exports.DEFAULT_VIDEO_PREVIEW_LIST = DEFAULT_VIDEO_PREVIEW_LIST;
exports.LIST_PRODUCT_REVIEW_EXAMPLE = LIST_PRODUCT_REVIEW_EXAMPLE;
exports.MAX_VIDEO_ITEM_MOBILE = MAX_VIDEO_ITEM_MOBILE;
exports.PRODUCT_REVIEW_EXAMPLE = PRODUCT_REVIEW_EXAMPLE;
exports.PROPS_DEFAULT_LAYOUT_VIDEO_PREVIEW_TWO_COL = PROPS_DEFAULT_LAYOUT_VIDEO_PREVIEW_TWO_COL;
exports.VIDEO_PLATFORM = VIDEO_PLATFORM;
exports.VIDEO_PREVIEW_DEFAULT_SPACING_DESKTOP = VIDEO_PREVIEW_DEFAULT_SPACING_DESKTOP;
exports.VIDEO_PREVIEW_DEFAULT_SPACING_MOBILE = VIDEO_PREVIEW_DEFAULT_SPACING_MOBILE;
exports.VIDEO_PREVIEW_ITEM_STYLE = VIDEO_PREVIEW_ITEM_STYLE;
exports.VIDEO_PREVIEW_ITEM_WIDTH_DEFAULT_DESKTOP = VIDEO_PREVIEW_ITEM_WIDTH_DEFAULT_DESKTOP;
exports.VideoPlatform = VideoPlatform;
exports.VideoPreviewDisplayType = VideoPreviewDisplayType;
exports.VideoPreviewLayout = VideoPreviewLayout;
exports.VideoPreviewWidthType = VideoPreviewWidthType;


/***/ }),

/***/ 203231:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const VideoPreviewListContext = React.createContext({});
const VideoPreviewListProvider = (_a) => {
  var _b = _a, {
    children
  } = _b, rest = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ jsxRuntime.jsx(VideoPreviewListContext.Provider, {
    value: __spreadValues({}, rest),
    children
  });
};

exports.VideoPreviewListContext = VideoPreviewListContext;
exports.VideoPreviewListProvider = VideoPreviewListProvider;


/***/ }),

/***/ 362074:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var icons = __webpack_require__(143599);
var useModalPreviewVideo = __webpack_require__(809420);
var ModalPreviewVideo = __webpack_require__(819418);
var VideoPreviewItem = __webpack_require__(389302);
var constants = __webpack_require__(177718);
var context = __webpack_require__(203231);
var utils = __webpack_require__(175321);
var grid = __webpack_require__(860046);
var Container = __webpack_require__(341018);
var Slider = __webpack_require__(183594);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const parseProductSkus = (skuString) => {
  if (!skuString)
    return [];
  return skuString.split(",").map((sku) => sku.trim()).filter((sku) => !!sku && typeof sku === "string");
};
const VideoPreviewList = (props) => {
  var _a;
  const skus = (_a = props == null ? void 0 : props.items) == null ? void 0 : _a.flatMap(
    (item) => parseProductSkus(item == null ? void 0 : item.productSkus)
  );
  const { mappingDynamicSlots } = coreRenderer.useStore();
  const VideoPreviewCompSlot = mappingDynamicSlots == null ? void 0 : mappingDynamicSlots["video_preview_carouse"];
  return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: VideoPreviewCompSlot ? /* @__PURE__ */ jsxRuntime.jsx(VideoPreviewCompSlot, {
      as: VideoPreviewListWithPropsOmni,
      asProps: props,
      skus
    }) : /* @__PURE__ */ jsxRuntime.jsx(VideoPreviewListWithPropsOmni, __spreadValues({}, props))
  });
};
const VideoPreviewListWithPropsOmni = (props) => {
  const { device } = coreRenderer.useStore();
  const _a = coreRenderer.getPropsByDevice(props, device), {
    itemPerView,
    commonStyle,
    maxWidth = grid.DEFAULT_MAX_WIDTH,
    isTwoColumnLayout
  } = _a, rest = __objRest(_a, [
    "itemPerView",
    "commonStyle",
    "maxWidth",
    "isTwoColumnLayout"
  ]);
  const { padding, margin } = commonStyle || {};
  const {
    title = "",
    viewMoreUrl = "",
    hideBuyNowButton = false,
    items = []
  } = (props == null ? void 0 : props.secondColumn) || {};
  const basePropsTwoColumn = __spreadProps(__spreadValues({}, props), {
    mobile: __spreadProps(__spreadValues({}, props.mobile), {
      itemPerView: 2
    })
  });
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: { maxWidth, padding, margin },
    maxWidth
  }, rest), {
    children: !isTwoColumnLayout ? /* @__PURE__ */ jsxRuntime.jsx(VideoPreviewListBase, __spreadValues({}, props)) : /* @__PURE__ */ jsxRuntime.jsxs(TwoColumnLayoutStyled, {
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(VideoPreviewListBase, __spreadValues(__spreadValues({}, props), basePropsTwoColumn)),
        /* @__PURE__ */ jsxRuntime.jsx(VideoPreviewListBase, __spreadValues(__spreadValues(__spreadValues({}, props), basePropsTwoColumn), { title, viewMoreUrl, hideBuyNowButton, items }))
      ]
    })
  }));
};
const VideoPreviewListBase = (props) => {
  var _c;
  const { device, globalData } = coreRenderer.useStore();
  const isPreviewMode = globalData == null ? void 0 : globalData.isPreviewMode;
  const isMobile = device === "mobile";
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);
  const [showNavBtns, setShowNavBtns] = React.useState(false);
  const wrapperMobileRef = React.useRef(null);
  const [widthWrapperMobile, setWidthWrapperMobile] = React.useState(null);
  const [isPaddingSmall, setIsPaddingSmall] = React.useState(false);
  const _a = props, {
    isEditingMode,
    title,
    viewMoreUrl,
    hideBuyNowButton = false,
    items = [],
    itemStyle,
    viewMoreStyle,
    titleColor = constants.DEFAULT_VIDEO_PREVIEW_LIST.titleColor,
    alignment = constants.VideoPreviewWidthType.FullWidth,
    layout = constants.VideoPreviewLayout.Vertical,
    displayType = constants.VideoPreviewDisplayType.ProductCard,
    widthType,
    products = [],
    buyNow,
    addToCart,
    isTwoColumnLayout
  } = _a, restProps = __objRest(_a, [
    "isEditingMode",
    "title",
    "viewMoreUrl",
    "hideBuyNowButton",
    "items",
    "itemStyle",
    "viewMoreStyle",
    "titleColor",
    "alignment",
    "layout",
    "displayType",
    "widthType",
    "products",
    "buyNow",
    "addToCart",
    "isTwoColumnLayout"
  ]);
  const {
    currentVideoFocus,
    showModalPreview,
    setShowModalPreview,
    showListProductPreview,
    setShowListProductPreview,
    handleFocusVideo,
    handleShowListProductReview
  } = useModalPreviewVideo.useModalPreviewVideo({ isEditingMode });
  const spacingItem = isMobile ? constants.VIDEO_PREVIEW_DEFAULT_SPACING_MOBILE : constants.VIDEO_PREVIEW_DEFAULT_SPACING_DESKTOP;
  const productMap = React.useMemo(() => {
    const result = {};
    products == null ? void 0 : products.forEach((product) => {
      const { sku } = product || {};
      if (sku)
        result[sku] = product;
    });
    return result;
  }, [JSON.stringify(products)]);
  const videosFormatted = React.useMemo(() => {
    const getProductReviews = (skus) => {
      var _a2, _b2, _c2;
      if (isEditingMode || isPreviewMode)
        return constants.LIST_PRODUCT_REVIEW_EXAMPLE.slice(
          0,
          ((_a2 = skus == null ? void 0 : skus.split(",")) == null ? void 0 : _a2.length) || 1
        );
      return ((_c2 = (_b2 = skus == null ? void 0 : skus.split(",")) == null ? void 0 : _b2.map(
        (sku) => {
          var _a3;
          return productMap == null ? void 0 : productMap[(_a3 = sku == null ? void 0 : sku.toString()) == null ? void 0 : _a3.trim()];
        }
      )) == null ? void 0 : _c2.filter(Boolean)) || [];
    };
    const isHiddenWhenNotFoundProduct = !isEditingMode && !isPreviewMode;
    return items == null ? void 0 : items.map((item) => __spreadProps(__spreadValues({}, item), {
      productReviews: getProductReviews(item == null ? void 0 : item.productSkus)
    })).filter((item) => {
      var _a2, _b2;
      if (isHiddenWhenNotFoundProduct)
        return (((_a2 = item == null ? void 0 : item.productReviews) == null ? void 0 : _a2.length) || !((_b2 = item == null ? void 0 : item.productSkus) == null ? void 0 : _b2.length)) && item.videoUrl;
      return true;
    });
  }, [JSON.stringify(products), JSON.stringify(items), isEditingMode]);
  const { itemPerView, commonStyle } = coreRenderer.getPropsByDevice(restProps, device);
  const hiddenPlayButton = isMobile && itemPerView >= 3;
  const widthSlideWrapper = React.useMemo(() => {
    if (widthType === constants.VideoPreviewWidthType.FullWidth)
      return "100%";
    if (itemPerView)
      return itemPerView * constants.VIDEO_PREVIEW_ITEM_WIDTH_DEFAULT_DESKTOP + spacingItem * Math.ceil(itemPerView - 1);
  }, [itemPerView, widthType, spacingItem]);
  const _b = commonStyle || {}, restStyle = __objRest(_b, ["padding", "margin"]);
  const handleClickUrl = (url, target = "_blank") => {
    if (!url || isEditingMode || isPreviewMode)
      return;
    window.open(url, target);
  };
  const widthVideoItemMobile = React.useMemo(() => {
    const isClient = typeof window !== "undefined";
    if (!isClient)
      return 250;
    const itemPerViewComputed = Math.min(itemPerView, constants.MAX_VIDEO_ITEM_MOBILE);
    const widthItem = (widthWrapperMobile - (Math.ceil(itemPerViewComputed) - 1) * constants.VIDEO_PREVIEW_DEFAULT_SPACING_MOBILE) / itemPerViewComputed;
    if (displayType === constants.VideoPreviewDisplayType.ShortDescription)
      return widthItem;
    return Math.max(widthItem, 250) || 250;
  }, [itemPerView, widthWrapperMobile, displayType, isMobile]);
  const isShowListVideoItem = displayType === constants.VideoPreviewDisplayType.ProductCard || widthWrapperMobile;
  React.useEffect(() => {
    if (!wrapperMobileRef.current)
      return;
    const el = wrapperMobileRef.current;
    const updateWidth = () => {
      var _a2;
      const width = (_a2 = el == null ? void 0 : el.getBoundingClientRect()) == null ? void 0 : _a2.width;
      if (width)
        setWidthWrapperMobile(Math.round(width));
    };
    const debouncedUpdateWidth = isEditingMode ? coreRenderer.debounce(updateWidth, 200) : updateWidth;
    const observer = new ResizeObserver(() => {
      debouncedUpdateWidth();
    });
    requestAnimationFrame(() => {
      debouncedUpdateWidth();
    });
    observer.observe(el);
    return () => {
      observer.disconnect();
    };
  }, [isMobile, isEditingMode, wrapperMobileRef.current]);
  React.useEffect(() => {
    const isPaddingSmall2 = isTwoColumnLayout || widthWrapperMobile < 250;
    if (isPaddingSmall2)
      setIsPaddingSmall(true);
  }, [isPaddingSmall, widthWrapperMobile]);
  const isHiddenBlock = !(videosFormatted == null ? void 0 : videosFormatted.length) && !isEditingMode;
  return /* @__PURE__ */ jsxRuntime.jsxs(context.VideoPreviewListProvider, {
    buyNow,
    addToCart,
    handleShowListProductReview,
    children: [
      /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
        commonStyle: __spreadProps(__spreadValues({
          backgroundSize: "cover"
        }, restStyle), {
          background: isHiddenBlock ? "transparent" : restStyle == null ? void 0 : restStyle.background
        }),
        style: {
          padding: isPaddingSmall ? "8px 8px" : "8px 16px",
          borderRadius: 8
        },
        children: [
          (title || viewMoreUrl) && !isHiddenBlock ? /* @__PURE__ */ jsxRuntime.jsxs(TitleWrapper, {
            children: [
              /* @__PURE__ */ jsxRuntime.jsx(TitleStyled, {
                style: { color: titleColor },
                children: title
              }),
              viewMoreUrl && /* @__PURE__ */ jsxRuntime.jsxs(ViewAll, {
                style: {
                  color: (viewMoreStyle == null ? void 0 : viewMoreStyle.color) || constants.DEFAULT_VIDEO_PREVIEW_LIST.viewMoreStyle.color
                },
                onClick: () => handleClickUrl(viewMoreUrl),
                children: [
                  isTwoColumnLayout || isMobile ? null : "Xem t\u1EA5t c\u1EA3",
                  /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
                    style: { fontSize: 16 },
                    name: "RightOutlined"
                  })
                ]
              })
            ]
          }) : null,
          isMobile ? /* @__PURE__ */ jsxRuntime.jsx(VideoListWrapper, {
            isEditingMode,
            widthVideoItemMobile,
            ref: wrapperMobileRef,
            children: isShowListVideoItem ? videosFormatted == null ? void 0 : videosFormatted.map((item, index) => /* @__PURE__ */ React.createElement(VideoPreviewItem.VideoPreviewItem, __spreadProps(__spreadValues({}, item), {
              key: index,
              itemStyle,
              isEditingMode,
              layout,
              displayType,
              onClick: () => handleFocusVideo(item),
              hiddenPlayButton,
              hideBuyNowButton
            }))) : /* @__PURE__ */ jsxRuntime.jsx("div", {
              style: { width: "100%" }
            })
          }) : /* @__PURE__ */ jsxRuntime.jsx(SliderWrapper, {
            style: { alignItems: (_c = grid.MAPPING_ALIGNMENT_FLEX) == null ? void 0 : _c[alignment] },
            children: /* @__PURE__ */ jsxRuntime.jsxs("div", {
              onMouseEnter: () => setShowNavBtns(true),
              onMouseLeave: () => setShowNavBtns(false),
              style: {
                position: "relative",
                width: typeof widthSlideWrapper === "number" ? `min(${widthSlideWrapper}px, 100%)` : widthSlideWrapper
              },
              children: [
                (videosFormatted == null ? void 0 : videosFormatted.length) > 1 && /* @__PURE__ */ jsxRuntime.jsx(NavigationButtonStyled, {
                  className: "left-nav",
                  style: { opacity: showNavBtns ? 1 : 0 },
                  ref: navigationPrevRef
                }),
                /* @__PURE__ */ jsxRuntime.jsx(SliderStyled, {
                  navigation: {
                    prevEl: navigationPrevRef.current,
                    nextEl: navigationNextRef.current
                  },
                  slidesPerView: "auto",
                  navigationStyle: 1,
                  paginationColor: "#ffffff",
                  allowTouchMove: !isEditingMode,
                  onBeforeInit: (swiper) => {
                    swiper.params.navigation.prevEl = navigationPrevRef.current;
                    swiper.params.navigation.nextEl = navigationNextRef.current;
                  },
                  spaceBetween: spacingItem,
                  children: videosFormatted == null ? void 0 : videosFormatted.map((item, index) => /* @__PURE__ */ React.createElement(VideoPreviewItem.VideoPreviewItem, __spreadProps(__spreadValues({}, item), {
                    key: index,
                    itemStyle,
                    isEditingMode,
                    layout,
                    displayType,
                    onClick: () => handleFocusVideo(item),
                    hiddenPlayButton,
                    hideBuyNowButton
                  })))
                }),
                (videosFormatted == null ? void 0 : videosFormatted.length) > 1 && /* @__PURE__ */ jsxRuntime.jsx(NavigationButtonStyled, {
                  className: "right-nav",
                  style: { opacity: showNavBtns ? 1 : 0 },
                  ref: navigationNextRef
                })
              ]
            })
          })
        ]
      }),
      showModalPreview && /* @__PURE__ */ jsxRuntime.jsx(ModalPreviewVideo.ModalPreviewVideo, {
        videoPreview: currentVideoFocus,
        show: showModalPreview,
        cancel: () => {
          setShowModalPreview(false);
          setShowListProductPreview(false);
        },
        itemStyle,
        isEditingMode,
        layout,
        displayType,
        showListProductPreview,
        cancelShowListProductPreview: () => {
          setShowListProductPreview(false);
        },
        hideBuyNowButton
      })
    ]
  });
};
VideoPreviewList.displayName = "Omni_VideoPreviewList";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)}
`
);
const SliderWrapper = styled__default["default"].div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const TitleStyled = styled__default["default"].div`
  ${utils.getClampedTextStyle(1)}
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  margin: 0 16px 0 0;
`;
const VideoListWrapper = styled__default["default"].div(
  ({ isEditingMode, widthVideoItemMobile }) => `
  display: grid;
  width: 100%;
  column-gap: ${constants.VIDEO_PREVIEW_DEFAULT_SPACING_MOBILE}px;
  overflow-x: scroll;
  overflow-y: hidden;
  grid-auto-flow: column;
  grid-auto-columns: ${widthVideoItemMobile}px;
  & > div {
    width: unset !important;
  }


  &::-webkit-scrollbar {
    height: 8px;
    ${!isEditingMode ? "display: none;" : ""}
  }

  &::-webkit-scrollbar-track {
    border-radius: 12px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
  }
`
);
const NavigationButtonStyled = styled__default["default"].div`
  top: 50%;
  position: absolute;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 100px;
  background-color: white;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2);
  &:after {
    content: ' ';
    height: 30px;
    width: 30px;
    display: inline-block;
    background: #333;
  }

  &.left-nav {
    transform: translateY(-50%) translateX(-50%);
    left: 0px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
      mask-size: contain;
    }
  }

  &.right-nav {
    transform: translateY(-50%) translateX(50%);
    right: 0px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
      mask-size: contain;
    }
  }

  &.swiper-button-disabled {
    display: none;
  }
`;
const TitleWrapper = styled__default["default"].div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  @media (max-width: 460px) {
    margin-bottom: 12px;
  }
`;
const ViewAll = styled__default["default"].div`
  white-space: nowrap;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
`;
const SliderStyled = styled__default["default"](Slider.Slider)(
  () => `
   .swiper-wrapper {
    display: grid;
    grid-auto-flow: column;
    width: fit-content;
    row-gap: 4px;
  }

  .swiper-slide {
    display: grid;
    grid-template-rows: subgrid;
  }

`
);
const TwoColumnLayoutStyled = styled__default["default"].div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;

  > * {
    min-width: 0;
  }
`;

exports.VideoPreviewList = VideoPreviewList;
exports.parseProductSkus = parseProductSkus;


/***/ }),

/***/ 175321:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const getClampedTextStyle = (lines) => `
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: ${lines};
  line-clamp: ${lines};
  -webkit-box-orient: vertical;
  line-height: 1.5;
  word-break: break-all;
`;
const getFirstFrameBlob = async (videoUrl) => {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    video.crossOrigin = "anonymous";
    video.src = `${videoUrl}#t=0.001`;
    video.muted = true;
    video.playsInline = true;
    const getFrame = () => {
      try {
        const width = Math.max(video.videoWidth, 500);
        const height = width * 16 / 9;
        if (!width || !height) {
          return reject(new Error("Kh\xF4ng l\u1EA5y \u0111\u01B0\u1EE3c k\xEDch th\u01B0\u1EDBc video"));
        }
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, width, height);
        canvas.toBlob(
          (blob) => {
            if (!blob) {
              return reject(new Error("Kh\xF4ng t\u1EA1o \u0111\u01B0\u1EE3c blob t\u1EEB canvas"));
            }
            const file = new File([blob], "thumbnail.jpg", {
              type: "image/jpeg"
            });
            resolve(file);
          },
          "image/jpeg",
          0.9
        );
      } catch (err) {
        reject(err);
      }
    };
    video.addEventListener("canplay", () => setTimeout(getFrame, 500));
    video.addEventListener("error", () => {
      reject(new Error("error load video"));
    });
  });
};

exports.getClampedTextStyle = getClampedTextStyle;
exports.getFirstFrameBlob = getFirstFrameBlob;


/***/ }),

/***/ 531137:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var visualizeBlock = __webpack_require__(447692);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const BuildPC = React__default["default"].forwardRef(
  (props, ref) => {
    return /* @__PURE__ */ jsxRuntime.jsx(visualizeBlock.VisualizeBlock, __spreadValues({
      type: "build_pc",
      ref
    }, props));
  }
);
BuildPC.displayName = "Omni_BuildPC";

exports.BuildPC = BuildPC;


/***/ }),

/***/ 447692:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var coreRenderer = __webpack_require__(85097);
var React = __webpack_require__(891987);
var Container = __webpack_require__(341018);
var renderDynamicSlot = __webpack_require__(958220);
var grid = __webpack_require__(860046);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const VisualizeBlock = React__default["default"].forwardRef((props, ref) => {
  const { mappingDynamicSlots } = coreRenderer.useStore();
  const _a = props, { commonStyle, isEditingMode, type, maxWidth } = _a, rest = __objRest(_a, ["commonStyle", "isEditingMode", "type", "maxWidth"]);
  if (!(mappingDynamicSlots == null ? void 0 : mappingDynamicSlots[type]))
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    ref,
    commonStyle: __spreadProps(__spreadValues({}, commonStyle), { maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH })
  }, rest), {
    maxWidth,
    children: renderDynamicSlot.renderDynamicSlot(type, mappingDynamicSlots)
  }));
});

exports.VisualizeBlock = VisualizeBlock;


/***/ }),

/***/ 886018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var visualizeBlock = __webpack_require__(447692);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const CustomHamper = React__default["default"].forwardRef(
  (props, ref) => {
    return /* @__PURE__ */ jsxRuntime.jsx(visualizeBlock.VisualizeBlock, __spreadValues({
      type: "custom_hamper",
      ref
    }, props));
  }
);
CustomHamper.displayName = "Omni_CustomHamper";

exports.CustomHamper = CustomHamper;


/***/ }),

/***/ 876884:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var visualizeBlock = __webpack_require__(447692);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const PendingPayment = React__default["default"].forwardRef((props, ref) => {
  return /* @__PURE__ */ jsxRuntime.jsx(visualizeBlock.VisualizeBlock, __spreadValues({
    type: "pending_payment",
    ref
  }, props));
});
PendingPayment.displayName = "Omni_PendingPayment";

exports.PendingPayment = PendingPayment;


/***/ }),

/***/ 496791:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var visualizeBlock = __webpack_require__(447692);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const RecentProduct = React__default["default"].forwardRef((props, ref) => {
  return /* @__PURE__ */ jsxRuntime.jsx(visualizeBlock.VisualizeBlock, __spreadValues({
    type: "recent_product",
    ref
  }, props));
});
RecentProduct.displayName = "Omni_RecentProduct";

exports.RecentProduct = RecentProduct;


/***/ }),

/***/ 227526:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var visualizeBlock = __webpack_require__(447692);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const RecentSearch = React__default["default"].forwardRef(
  (props, ref) => {
    return /* @__PURE__ */ jsxRuntime.jsx(visualizeBlock.VisualizeBlock, __spreadValues({
      type: "recent_search",
      ref
    }, props));
  }
);
RecentSearch.displayName = "Omni_RecentSearch";

exports.RecentSearch = RecentSearch;


/***/ }),

/***/ 907579:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var React = __webpack_require__(891987);
var constants = __webpack_require__(277939);
var contex = __webpack_require__(783135);
var addPaddingNumber = __webpack_require__(996887);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ButtonSave = (_a) => {
  var _b = _a, {
    handleSubmit,
    loading,
    layout,
    isMobile,
    timeVisibility = {},
    isHidden,
    extraInfo
  } = _b, rest = __objRest(_b, [
    "handleSubmit",
    "loading",
    "layout",
    "isMobile",
    "timeVisibility",
    "isHidden",
    "extraInfo"
  ]);
  const { startTime, endTime } = timeVisibility;
  const { triggerFilterItems } = contex.useVoucherList();
  const { status, remainingAssignments } = extraInfo || {};
  const timerEnd = coreRenderer.useTimer(new Date(endTime));
  const timerStart = coreRenderer.useTimer(new Date(startTime));
  const isAvailable = new Date() >= new Date(startTime) && new Date() <= new Date(endTime);
  const renderCountdown = (timer) => {
    const { days, hours, minutes, seconds } = timer;
    const totalHours = days * 24 + hours;
    return [totalHours, minutes, seconds].map((time) => addPaddingNumber.addPaddingNumber(time)).join(" : ");
  };
  const { disableButton, label } = React.useMemo(() => {
    const disableButton2 = status === constants.VoucherStatus.ASSIGNED || remainingAssignments === 0;
    let label2;
    if (status === constants.VoucherStatus.ASSIGNED)
      label2 = "\u0110\xE3 l\u01B0u";
    else if (remainingAssignments === 0)
      label2 = "\u0110\xE3 h\u1EBFt m\xE3";
    return { disableButton: disableButton2, label: label2 };
  }, [status, remainingAssignments]);
  React.useEffect(() => {
    if (isAvailable)
      triggerFilterItems();
  }, [isAvailable]);
  if (disableButton)
    return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
      isMobile,
      layout,
      children: /* @__PURE__ */ jsxRuntime.jsx(ButtonStyled, {
        style: { width: "100%" },
        disabled: true,
        children: label
      })
    });
  if (isAvailable)
    return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      isMobile,
      layout,
      children: [
        /* @__PURE__ */ jsxRuntime.jsxs(CountdownEnd, {
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(IconFlash, {}),
            /* @__PURE__ */ jsxRuntime.jsx(ValueCountdown, {
              children: renderCountdown(timerEnd)
            })
          ]
        }),
        /* @__PURE__ */ jsxRuntime.jsx(ButtonStyled, __spreadProps(__spreadValues({
          onClick: handleSubmit,
          disabled: loading
        }, rest), {
          children: loading ? /* @__PURE__ */ jsxRuntime.jsx("div", {
            className: "spinner"
          }) : "L\u01B0u"
        }))
      ]
    });
  if (!isHidden)
    return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
      isMobile,
      layout,
      children: /* @__PURE__ */ jsxRuntime.jsxs(CountdownStart, {
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(BackgroundButtonCountdown, {
            src: "https://lh3.googleusercontent.com/rsM-Hp0L2WDgJivyNHyRqiI37ZPOZUoqglBXPyF09d-3cRYhUQ6rmWd_Fx3f3ceenTnJaAPfHDELw-1CEV4jwumvVE3Gs9-o"
          }),
          /* @__PURE__ */ jsxRuntime.jsx(LabelCountdown, {
            style: { zIndex: 1 },
            children: "L\u1EA5y m\xE3 sau"
          }),
          /* @__PURE__ */ jsxRuntime.jsx(ValueCountdown, {
            children: renderCountdown(timerStart)
          })
        ]
      })
    });
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    isMobile,
    layout,
    children: /* @__PURE__ */ jsxRuntime.jsx(ButtonStyled, {
      onClick: handleSubmit,
      disabled: true,
      style: { filter: "grayscale(1)" },
      children: "L\u01B0u"
    })
  });
};
const IconFlash = () => /* @__PURE__ */ jsxRuntime.jsx("svg", {
  width: "10",
  height: "16",
  viewBox: "0 0 10 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsxRuntime.jsx("path", {
    d: "M7.04488 0.283326L0.889974 7.63868L4.45665 8.55154L2.18403 15.5453L9.40393 6.7738L5.46696 6.65744L7.04488 0.283326Z",
    fill: "#FADB14"
  })
});
const Wrapper = styled__default["default"].div(
  ({ isMobile, layout }) => `
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  order: 2;
  gap: 4px;
  background: transparent;
${isMobile && layout === "carousel" ? `
    order: 0;
    width: 100%;
    ` : ``}
`
);
const ButtonStyled = styled__default["default"].button(
  ({ disabled }) => `
    background: #003eb3;
    padding: 2px 8px;
    display: block;
    color: #ffffff;
    width: auto;
    border-radius: 4px;
    order: 2;
    min-width: 40px;
    min-height: 25px;
    border: none;
    &:disabled {
      opacity: 0.6;
      cursor: auto;
    }
    display: flex;
    justify-content: center;
    align-items: center;

    ${disabled ? `
        border: 1px solid #00000026;
        background:#0000000A;
        color: #00000060;
        pointer-events: none;
      ` : ""}
`
);
const CountdownStart = styled__default["default"].div`
  position: relative;
  order: 2;
  min-width: 120px;
  min-height: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const BackgroundButtonCountdown = styled__default["default"].img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;
const LabelCountdown = styled__default["default"].p`
  padding: 0 4px;
  font-weight: 900;
  font-size: 8px;
  line-height: 10px;
  color: #fff;
`;
const ValueCountdown = styled__default["default"].p`
  min-width: 52%;
  text-align: center;
  font-weight: 900;
  font-size: 10px;
  line-height: 10px;
  font-style: italic;
  white-space: nowrap;
`;
const CountdownEnd = styled__default["default"].div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding-right: 4px;
  padding-left: 2px;
  height: 100%;
  background-color: #fff7e6;
  min-height: 25px;
  border-radius: 4px;
`;

exports.ButtonSave = ButtonSave;


/***/ }),

/***/ 606697:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var React = __webpack_require__(891987);
var constants = __webpack_require__(277939);
var contex = __webpack_require__(783135);
var useSaveVoucher = __webpack_require__(689870);
var utils = __webpack_require__(324591);
var ButtonSave = __webpack_require__(907579);
var image = __webpack_require__(478130);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const imageDefault = image.generatePlaceholderImage({ width: 100, height: 110 });
const VoucherItem = (props) => {
  const {
    title,
    imageUrl,
    description,
    descriptionExtra,
    textLinkTitle,
    textLinkUrl,
    productListPath,
    googleImageParams,
    isEditingMode,
    itemStyle,
    configStorage,
    handleShowNotification,
    layout,
    timeVisibility = {},
    isShowButtonSave = true,
    extraInfo,
    endpointConfig,
    campaignId
  } = props;
  const { device, globalData } = coreRenderer.useStore();
  const isPreviewMode = globalData == null ? void 0 : globalData.isPreviewMode;
  const { isVisible } = coreRenderer.useGetVisible(timeVisibility);
  const { triggerFilterItems, triggerUpdateStatus } = contex.useVoucherList();
  const isMobile = device === "mobile";
  const { handleSaveVoucher, loading } = useSaveVoucher.useSaveVoucher({
    handleShowNotification,
    onSuccess: triggerUpdateStatus
  });
  const {
    buttonColor,
    buttonTextColor,
    commonStyle,
    descriptionColor,
    descriptionExtraColor,
    textLinkColor,
    titleColor
  } = __spreadValues(__spreadValues({}, constants.VOUCHER_ITEM_STYLE), itemStyle);
  const handleClickUrl = (url, target = "_blank") => {
    if (!url || isEditingMode || isPreviewMode)
      return;
    window.open(url, target);
  };
  const handleSubmit = () => {
    const isOldFollow = !endpointConfig && (configStorage == null ? void 0 : configStorage.formConfigId);
    const endpointConfigId = isOldFollow ? configStorage == null ? void 0 : configStorage.formConfigId : endpointConfig == null ? void 0 : endpointConfig.saveVoucherConfigId;
    if (isEditingMode || isPreviewMode || !endpointConfigId || !campaignId)
      return;
    handleSaveVoucher(endpointConfigId, [
      {
        type: "number",
        name: "campaignId",
        value: campaignId
      }
    ]);
  };
  const isHidden = !utils.validateShowVoucher(timeVisibility, isShowButtonSave);
  React.useEffect(() => {
    if (!isVisible)
      triggerFilterItems();
  }, [isVisible]);
  if (!isVisible && !isEditingMode && !isShowButtonSave)
    return null;
  return /* @__PURE__ */ jsxRuntime.jsxs(VoucherItemStyled, {
    commonStyle,
    isMobile,
    layout,
    isHidden,
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(WrapperImage, {
        children: /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
          onClick: () => handleClickUrl(productListPath),
          commonStyle: {
            width: isMobile ? 100 : 91,
            objectFit: "fill",
            marginLeft: "auto",
            marginRight: "auto",
            height: isMobile ? 110 : 100,
            borderRadius: 8
          },
          src: imageUrl || imageDefault,
          googleImageParams
        })
      }),
      /* @__PURE__ */ jsxRuntime.jsxs(VoucherContent, {
        isMobile,
        layout,
        children: [
          /* @__PURE__ */ jsxRuntime.jsxs("div", {
            children: [
              /* @__PURE__ */ jsxRuntime.jsx("p", {
                style: { color: titleColor },
                className: "voucher-content_title text-1-lines",
                children: title
              }),
              /* @__PURE__ */ jsxRuntime.jsx("p", {
                style: { color: descriptionColor },
                className: "voucher-content_description text-2-lines",
                children: description
              })
            ]
          }),
          /* @__PURE__ */ jsxRuntime.jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 2
            },
            children: [
              /* @__PURE__ */ jsxRuntime.jsx("p", {
                className: "voucher-content_description text-1-lines",
                style: { color: descriptionExtraColor },
                children: descriptionExtra
              }),
              /* @__PURE__ */ jsxRuntime.jsxs("div", {
                className: "voucher-content-wrap-button",
                children: [
                  isShowButtonSave ? /* @__PURE__ */ jsxRuntime.jsx(ButtonSave.ButtonSave, {
                    loading,
                    timeVisibility,
                    isMobile,
                    layout,
                    onClick: handleSubmit,
                    style: { color: buttonTextColor, background: buttonColor },
                    className: "voucher-content_button",
                    isHidden,
                    extraInfo
                  }) : null,
                  /* @__PURE__ */ jsxRuntime.jsx("a", {
                    href: textLinkUrl,
                    style: {
                      pointerEvents: isEditingMode || isPreviewMode ? "none" : "auto",
                      color: textLinkColor
                    },
                    className: "voucher-content_text-link",
                    children: textLinkTitle
                  })
                ]
              })
            ]
          })
        ]
      })
    ]
  });
};
const VoucherItemStyled = styled__default["default"].div(
  ({ commonStyle, isMobile, layout, isHidden }) => `
  position: relative;
  display: flex;
  border: 1px solid #0000000f;
  flex-shrink: 0;
  flex-grow: 1;
  padding: 4px;
  border-radius: ${constants.VOUCHER_ITEM_STYLE.commonStyle.borderRadius}px;

  img {
    cursor: pointer
  }
  ${coreRenderer.getStyle(commonStyle)}

  ${layout === "carousel" ? `
  min-width: ${isMobile ? "240" : "320"}px;
  max-width: ${isMobile ? "240" : "320"}px;
  ` : ""}

     ${isHidden ? `
    &:after {
      pointer-events: none;
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: repeating-linear-gradient(125deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 1px, transparent 2px, transparent 9px);
    }` : ""}
}
`
);
const WrapperImage = styled__default["default"].div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const VoucherContent = styled__default["default"].div(
  ({ isMobile, layout }) => `
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  flex-direction: column;
  padding: 0 8px;
  gap: 2px;


  .voucher-content_title {
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;
  }

  .voucher-content_description {
    font-size: 10px;
    line-height: 16px;
  }

  .voucher-content-wrap-button {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }


  .voucher-content_text-link {
    font-size: 10px;
    line-height: 16px;
  }

  .text-2-lines,
  .text-1-lines {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .text-2-lines {
    -webkit-line-clamp: 2;
  }

  .text-1-lines {
    -webkit-line-clamp: 1;
  }

  @keyframes spread-animation {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .spinner {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.6);
    border-top: 2px solid #fff;
    border-radius: 50%;
    animation: spread-animation 0.8s linear infinite;
  }

  ${isMobile && layout === "carousel" ? `
  .voucher-content-wrap-button {
    flex-direction: column;
    justify-content: start;
    align-items: start;
    gap: 2px;
  }
    ` : ``}
`
);

exports.VoucherItem = VoucherItem;


/***/ }),

/***/ 931273:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var React = __webpack_require__(891987);
var Slider = __webpack_require__(183594);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const VoucherLayout = ({
  layout,
  isEditingMode,
  children,
  itemLength,
  gridConfig
}) => {
  const { device } = coreRenderer.useStore();
  const isMobile = device === "mobile";
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);
  const [showNavBtns, setShowNavBtns] = React.useState(false);
  if (layout === "grid")
    return /* @__PURE__ */ jsxRuntime.jsx(GridWrapper, __spreadProps(__spreadValues(__spreadValues({}, gridConfig), isMobile ? { column: 1 } : {}), {
      children
    }));
  if (!layout || layout === "carousel")
    return isMobile ? /* @__PURE__ */ jsxRuntime.jsx(VoucherListCarouselWrapperMobile, {
      isEditingMode,
      children
    }) : /* @__PURE__ */ jsxRuntime.jsxs("div", {
      onMouseEnter: () => setShowNavBtns(true),
      onMouseLeave: () => setShowNavBtns(false),
      style: { position: "relative" },
      children: [
        itemLength > 1 && /* @__PURE__ */ jsxRuntime.jsx(NavigationButtonStyled, {
          className: "left-nav",
          style: { opacity: showNavBtns ? 1 : 0 },
          ref: navigationPrevRef
        }),
        /* @__PURE__ */ jsxRuntime.jsx(Slider.Slider, {
          navigation: {
            prevEl: navigationPrevRef.current,
            nextEl: navigationNextRef.current
          },
          slidesPerView: "auto",
          navigationStyle: 1,
          paginationColor: "#ffffff",
          allowTouchMove: !isEditingMode,
          onBeforeInit: (swiper) => {
            swiper.params.navigation.prevEl = navigationPrevRef.current;
            swiper.params.navigation.nextEl = navigationNextRef.current;
          },
          spaceBetween: 16,
          children
        }),
        itemLength > 1 && /* @__PURE__ */ jsxRuntime.jsx(NavigationButtonStyled, {
          className: "right-nav",
          style: { opacity: showNavBtns ? 1 : 0 },
          ref: navigationNextRef
        })
      ]
    });
};
const GridWrapper = styled__default["default"].div(
  ({ column = 4, gutter = 16 }) => `
    display: grid;
    grid-template-columns: repeat(${column}, minmax(0,1fr));
    grid-gap: ${gutter}px;

    & > div {
      min-width: 280px;
    }

    @media (max-width: 870px) {
      grid-template-columns: repeat(${Math.min(column, 2)}, 1fr);
    }

    @media (max-width: 1170px) {
      grid-template-columns: repeat(${Math.min(column, 3)}, 1fr);
    }


`
);
const VoucherListCarouselWrapperMobile = styled__default["default"].div(
  ({ isEditingMode }) => `
  display: flex;
  width: 100%;
  overflow-y: auto;
  gap: 12px;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    height: 8px;
    ${!isEditingMode ? "display: none;" : ""}
  }

  &::-webkit-scrollbar-track {
    border-radius: 12px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
  }
`
);
const NavigationButtonStyled = styled__default["default"].div`
  top: 50%;
  position: absolute;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 100px;
  background-color: white;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2);
  &:after {
    content: ' ';
    height: 30px;
    width: 30px;
    display: inline-block;
    background: #333;
  }

  &.left-nav {
    transform: translateY(-50%) translateX(-50%);
    left: 0px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
      mask-size: contain;
    }
  }

  &.right-nav {
    transform: translateY(-50%) translateX(50%);
    right: 0px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
      mask-size: contain;
    }
  }

  &.swiper-button-disabled {
    display: none;
  }
`;

exports.VoucherLayout = VoucherLayout;


/***/ }),

/***/ 277939:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var style = __webpack_require__(667925);
var image = __webpack_require__(478130);
var grid = __webpack_require__(860046);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const BASE_VOUCHER_LIST_DATA = {
  layout: "carousel",
  title: "VOUCHER KHUY\u1EBEN M\xC3I",
  titleColor: "#000000",
  viewMoreStyle: {
    color: "#000000"
  },
  items: [
    {
      title: "Gi\u1EA3m 30.000\u0111",
      imageUrl: "https://lh3.googleusercontent.com/iqoMUFLdOcVCsZnhmrYN-syq2O7qSwtN3hm-BHrh_M8mMtnOiDZEqdOnCm5sKgqIdNhJAWroq0WufB4iX7eb2gf-BAZrjM9aPQ",
      description: "\u0110\u01A1n t\u1ED1i thi\u1EC3u 300k",
      descriptionExtra: "HSD: 20/06/2025",
      textLinkTitle: "\u0110i\u1EC1u ki\u1EC7n \xE1p d\u1EE5ng",
      textLinkUrl: "https://cooponline.vn",
      productListPath: "/c/khuyen-mai-hot",
      isShowButtonSave: true
    },
    {
      title: "Voucher title",
      imageUrl: image.generatePlaceholderImage({ width: 100, height: 110 }),
      description: "M\xF4 t\u1EA3 1",
      descriptionExtra: "M\xF4 t\u1EA3 2",
      textLinkTitle: "\u0110i\u1EC1u ki\u1EC7n \xE1p d\u1EE5ng",
      textLinkUrl: "https://cooponline.vn",
      productListPath: "/c/khuyen-mai-hot",
      isShowButtonSave: true
    }
  ],
  maxWidth: grid.DEFAULT_MAX_WIDTH
};
const VOUCHER_ITEM_STYLE = {
  titleColor: "#000000",
  descriptionColor: "#000000",
  descriptionExtraColor: "#00000073",
  buttonColor: "#003EB3",
  buttonTextColor: "#ffffff",
  textLinkColor: "#1677FF",
  commonStyle: {
    borderRadius: 12
  }
};
const DEFAULT_VOUCHER_LIST = __spreadProps(__spreadValues({}, BASE_VOUCHER_LIST_DATA), {
  itemStyle: VOUCHER_ITEM_STYLE,
  desktop: {
    commonStyle: __spreadValues({}, style.DESKTOP_COMMON_STYLE),
    gridConfig: {
      column: 4,
      gutter: 16
    }
  },
  mobile: {
    commonStyle: __spreadProps(__spreadValues({}, style.MOBILE_COMMON_STYLE), {
      padding: {
        left: 0,
        right: 0
      }
    }),
    gridConfig: {
      column: 1,
      gutter: 16
    }
  }
});
const getApiConfigSaveVoucher = (domain) => ({
  endpoint: `${domain}/v1/campaigns/assign-customer`,
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "X-API-KEY": "<PLEASE_INPUT_YOUR_API_KEY>"
  },
  body: {
    campaignId: "{{campaignId}}",
    phoneNumber: "{{phoneNumber}}",
    distributionPartnerUserId: 1
  },
  type: "API",
  isMainConfig: true
});
const getApiConfigGetStatusVoucher = (domain) => ({
  endpoint: `${domain}/v1/campaigns/check-assign`,
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "X-API-KEY": "<PLEASE_INPUT_YOUR_API_KEY>"
  },
  body: {
    campaignIds: "{{campaignIds}}",
    phoneNumber: "{{phoneNumber}}"
  },
  type: "API",
  isMainConfig: true
});
const DOMAIN_MARKETING_GATEWAY_MAP = {
  dev: "https://mkt-gateway.dev.tekoapis.net",
  stag: "https://mkt-gateway.stag.tekoapis.net",
  production: "https://mkt-gateway.tekoapis.com"
};
var VoucherStatus = /* @__PURE__ */ ((VoucherStatus2) => {
  VoucherStatus2["ASSIGNED"] = "ASSIGNED";
  VoucherStatus2["NotAssigned"] = "NOT_ASSIGNED";
  return VoucherStatus2;
})(VoucherStatus || {});

exports.DEFAULT_VOUCHER_LIST = DEFAULT_VOUCHER_LIST;
exports.DOMAIN_MARKETING_GATEWAY_MAP = DOMAIN_MARKETING_GATEWAY_MAP;
exports.VOUCHER_ITEM_STYLE = VOUCHER_ITEM_STYLE;
exports.VoucherStatus = VoucherStatus;
exports.getApiConfigGetStatusVoucher = getApiConfigGetStatusVoucher;
exports.getApiConfigSaveVoucher = getApiConfigSaveVoucher;


/***/ }),

/***/ 783135:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var React = __webpack_require__(891987);

const VoucherListContext = React.createContext(
  {}
);
const VoucherListProvider = VoucherListContext.Provider;
const useVoucherList = () => React.useContext(VoucherListContext);

exports.VoucherListContext = VoucherListContext;
exports.VoucherListProvider = VoucherListProvider;
exports.useVoucherList = useVoucherList;


/***/ }),

/***/ 507790:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(85097);
var React = __webpack_require__(891987);
var utils = __webpack_require__(324591);

const useGetListVoucher = (props) => {
  const { items, isEditingMode } = props;
  const [displayItems, setDisplayItems] = React.useState([]);
  const triggerFilterItems = () => {
    const itemsHasTimeVisibility = (items == null ? void 0 : items.filter((item) => {
      const { timeVisibility, isShowButtonSave = true } = item || {};
      return isEditingMode || utils.validateShowVoucher(timeVisibility, isShowButtonSave);
    })) || [];
    setDisplayItems(itemsHasTimeVisibility);
  };
  const getDelayNearest = () => {
    var _a;
    const getDelay = (date) => {
      if (!date)
        return null;
      const endTime = new Date(date).getTime();
      const now = Date.now();
      const diffMs = endTime - now;
      return diffMs;
    };
    const listDelay = ((_a = items == null ? void 0 : items.map((item) => {
      const { startTime, endTime } = (item == null ? void 0 : item.timeVisibility) || {};
      const { visibleStartTime } = coreRenderer.getNearestAvailableRangeTime({
        startTime,
        endTime
      });
      const delay = getDelay(visibleStartTime);
      return delay;
    })) == null ? void 0 : _a.filter((delay) => delay && delay > 0)) || [];
    return listDelay.length ? Math.min(...listDelay) : 0;
  };
  React.useEffect(() => {
    triggerFilterItems();
    if (isEditingMode)
      return;
    let timer;
    const initTimeout = () => {
      clearTimeout(timer);
      const delay = getDelayNearest();
      if (delay > 0)
        timer = setTimeout(() => {
          triggerFilterItems();
        }, delay);
    };
    initTimeout();
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        triggerFilterItems();
        initTimeout();
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      clearTimeout(timer);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [isEditingMode, JSON.stringify(displayItems), items]);
  return { triggerFilterItems, displayItems };
};

exports.useGetListVoucher = useGetListVoucher;


/***/ }),

/***/ 46842:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(85097);
var React = __webpack_require__(891987);
var form = __webpack_require__(78616);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const useGetStatusVoucher = (props) => {
  const { getStatusVoucherConfigId, isEditingMode, items } = props;
  const { globalData } = coreRenderer.useStore();
  const [listExtraInfoMap, setListExtraInfoMap] = React.useState({});
  const { userPhoneNumber, isPreviewMode } = globalData || {};
  const { env } = coreRenderer.useStore();
  const triggerUpdateStatus = async () => {
    var _a, _b;
    const campaignIds = (_a = items == null ? void 0 : items.map((item) => item == null ? void 0 : item.campaignId)) == null ? void 0 : _a.filter(Boolean);
    const valuesSubmit = [
      {
        name: "phoneNumber",
        value: userPhoneNumber,
        type: "string"
      },
      {
        name: "campaignIds",
        value: campaignIds,
        type: "object"
      }
    ];
    if (!userPhoneNumber || !(campaignIds == null ? void 0 : campaignIds.length))
      return;
    try {
      const result = await form.formUtils.submitFormData(
        getStatusVoucherConfigId,
        valuesSubmit,
        `${coreRenderer.publicBffUrl[env]}/v1/submit-form`
      );
      const listVoucherExtraInfo = ((_b = result == null ? void 0 : result.data) == null ? void 0 : _b.data) || [];
      if (listVoucherExtraInfo == null ? void 0 : listVoucherExtraInfo.length) {
        const listExtraInfoMap2 = listVoucherExtraInfo == null ? void 0 : listVoucherExtraInfo.reduce((acc, item) => {
          const { campaignId } = item;
          if (campaignId)
            acc[campaignId] = item;
          return acc;
        }, {});
        setListExtraInfoMap(listExtraInfoMap2);
      }
    } catch (error) {
      console.error("error", error);
    }
  };
  React.useEffect(() => {
    if (isEditingMode || isPreviewMode || !getStatusVoucherConfigId)
      return;
    triggerUpdateStatus();
  }, [isEditingMode, isPreviewMode, getStatusVoucherConfigId, userPhoneNumber]);
  const itemsWithExtraInfo = React.useMemo(() => {
    return items == null ? void 0 : items.map((item) => {
      const extraInfo = listExtraInfoMap[item == null ? void 0 : item.campaignId];
      if (listExtraInfoMap)
        return __spreadProps(__spreadValues({}, item), {
          extraInfo
        });
    });
  }, [listExtraInfoMap, items]);
  return { itemsWithExtraInfo, triggerUpdateStatus };
};

exports.useGetStatusVoucher = useGetStatusVoucher;


/***/ }),

/***/ 689870:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var React = __webpack_require__(891987);
var coreRenderer = __webpack_require__(85097);
var TerraKit = __webpack_require__(175915);
var ModalNotification = __webpack_require__(721498);
var form = __webpack_require__(78616);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var TerraKit__default = /*#__PURE__*/_interopDefaultLegacy(TerraKit);

const useSaveVoucher = ({
  handleShowNotification,
  onSuccess
}) => {
  const { globalData } = coreRenderer.useStore();
  const { userPhoneNumber } = globalData || {};
  const [loading, setLoading] = React.useState(false);
  const { env } = coreRenderer.useStore();
  const handleSaveVoucher = async (endpointConfigId, values = []) => {
    var _a, _b, _c, _d, _e, _f;
    try {
      setLoading(true);
      const isLoggedWeb = (_b = (_a = window == null ? void 0 : window.TekoID) == null ? void 0 : _a.user) == null ? void 0 : _b.getUserInfo();
      const isLoggedApp = (_d = (_c = TerraKit__default["default"]) == null ? void 0 : _c.auth()) == null ? void 0 : _d.isLoggedIn();
      if (!isLoggedWeb && !isLoggedApp) {
        handleShowNotification(
          "Vui l\xF2ng \u0111\u0103ng nh\u1EADp t\xE0i kho\u1EA3n \u0111\u1EC3 nh\u1EADn m\xE3",
          ModalNotification.NotificationType.Error
        );
        return;
      }
      if (!userPhoneNumber) {
        handleShowNotification(
          "T\xE0i kho\u1EA3n c\u1EE7a b\u1EA1n kh\xF4ng c\xF3 s\u1ED1 \u0111i\u1EC7n tho\u1EA1i, vui l\xF2ng v\xE0o Th\xF4ng tin t\xE0i kho\u1EA3n v\xE0 c\u1EADp nh\u1EADt s\u1ED1 \u0111i\u1EC7n tho\u1EA1i",
          ModalNotification.NotificationType.Error
        );
        return;
      }
      const valuesSubmit = [
        ...values,
        {
          name: "phoneNumber",
          value: userPhoneNumber,
          type: "string"
        }
      ];
      let result;
      try {
        result = await form.formUtils.submitFormData(
          endpointConfigId,
          valuesSubmit,
          `${coreRenderer.publicBffUrl[env]}/v1/submit-form`
        );
      } catch (error) {
        console.error("error", error);
        result = { data: error == null ? void 0 : error.response };
      }
      const responseCode = (_e = result == null ? void 0 : result.data) == null ? void 0 : _e.code;
      switch (responseCode) {
        case 200:
          handleShowNotification(
            "L\u01B0u th\xE0nh c\xF4ng. B\u1EA1n c\xF3 th\u1EC3 xem v\xE0 s\u1EED d\u1EE5ng m\xE3 gi\u1EA3m gi\xE1 \u1EDF trang Gi\u1ECF h\xE0ng",
            ModalNotification.NotificationType.Success
          );
          if (onSuccess)
            await (onSuccess == null ? void 0 : onSuccess());
          break;
        case 460:
          handleShowNotification(
            "B\u1EA1n \u0111\xE3 h\u1EBFt l\u01B0\u1EE3t thu th\u1EADp m\xE3 voucher n\xE0y",
            ModalNotification.NotificationType.Error
          );
          break;
        case 459:
          handleShowNotification(
            "R\u1EA5t ti\u1EBFc, voucher n\xE0y \u0111\xE3 \u0111\u01B0\u1EE3c thu th\u1EADp h\u1EBFt",
            ModalNotification.NotificationType.Error
          );
          if (onSuccess)
            await (onSuccess == null ? void 0 : onSuccess());
          break;
        default:
          handleShowNotification(
            ((_f = result == null ? void 0 : result.data) == null ? void 0 : _f.message) || "C\xF3 l\u1ED7i x\u1EA3y ra, vui l\xF2ng th\u1EED l\u1EA1i",
            ModalNotification.NotificationType.Error
          );
          break;
      }
    } finally {
      setLoading(false);
    }
  };
  return {
    handleSaveVoucher,
    loading
  };
};

exports.useSaveVoucher = useSaveVoucher;


/***/ }),

/***/ 42601:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var icons = __webpack_require__(143599);
var VoucherItem = __webpack_require__(606697);
var VoucherLayout = __webpack_require__(931273);
var constants = __webpack_require__(277939);
var contex = __webpack_require__(783135);
var useNotification = __webpack_require__(53093);
var useGetStatusVoucher = __webpack_require__(46842);
var useGetListVoucher = __webpack_require__(507790);
var Container = __webpack_require__(341018);
var grid = __webpack_require__(860046);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const VoucherList = (props) => {
  const { device, globalData } = coreRenderer.useStore();
  const isPreviewMode = globalData == null ? void 0 : globalData.isPreviewMode;
  const { handleShowNotification, ToastComponent } = useNotification.useNotification();
  const _a = props, {
    isEditingMode,
    title,
    viewMoreUrl,
    items = [],
    itemStyle,
    viewMoreStyle,
    titleColor = constants.DEFAULT_VOUCHER_LIST.titleColor,
    layout = "carousel",
    endpointConfig
  } = _a, restProps = __objRest(_a, [
    "isEditingMode",
    "title",
    "viewMoreUrl",
    "items",
    "itemStyle",
    "viewMoreStyle",
    "titleColor",
    "layout",
    "endpointConfig"
  ]);
  const _b = coreRenderer.getPropsByDevice(restProps, device), {
    commonStyle,
    maxWidth = grid.DEFAULT_MAX_WIDTH,
    gridConfig
  } = _b, rest = __objRest(_b, [
    "commonStyle",
    "maxWidth",
    "gridConfig"
  ]);
  const _c = commonStyle || {}, { padding, margin } = _c, restStyle = __objRest(_c, ["padding", "margin"]);
  const { itemsWithExtraInfo, triggerUpdateStatus } = useGetStatusVoucher.useGetStatusVoucher({
    items,
    isEditingMode,
    getStatusVoucherConfigId: endpointConfig == null ? void 0 : endpointConfig.getStatusVoucherConfigId
  });
  const { displayItems, triggerFilterItems } = useGetListVoucher.useGetListVoucher({
    isEditingMode,
    items: itemsWithExtraInfo
  });
  const handleClickUrl = (url, target = "_blank") => {
    if (!url || isEditingMode || isPreviewMode)
      return;
    window.open(url, target);
  };
  if (!(displayItems == null ? void 0 : displayItems.length) && !isEditingMode)
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(contex.VoucherListProvider, {
    value: {
      triggerFilterItems,
      triggerUpdateStatus
    },
    children: /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
      commonStyle: {
        position: "relative",
        maxWidth,
        padding,
        margin
      },
      maxWidth
    }, rest), {
      children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
        commonStyle: __spreadValues({ backgroundSize: "cover" }, restStyle),
        style: {
          padding: "8px 16px",
          borderRadius: 8,
          backgroundColor: "#fff"
        },
        children: [
          /* @__PURE__ */ jsxRuntime.jsxs(TitleWrapper, {
            children: [
              /* @__PURE__ */ jsxRuntime.jsx(TitleStyled, {
                style: { color: titleColor },
                children: title
              }),
              viewMoreUrl && /* @__PURE__ */ jsxRuntime.jsxs(ViewAll, {
                style: {
                  color: (viewMoreStyle == null ? void 0 : viewMoreStyle.color) || constants.DEFAULT_VOUCHER_LIST.viewMoreStyle.color
                },
                onClick: () => handleClickUrl(viewMoreUrl),
                children: [
                  "Xem t\u1EA5t c\u1EA3",
                  " ",
                  /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
                    style: { fontSize: 20 },
                    name: "RightOutlined"
                  })
                ]
              })
            ]
          }),
          /* @__PURE__ */ jsxRuntime.jsx(VoucherLayout.VoucherLayout, {
            itemLength: displayItems == null ? void 0 : displayItems.length,
            layout,
            isEditingMode,
            gridConfig,
            children: displayItems.map((item, index) => /* @__PURE__ */ React.createElement(VoucherItem.VoucherItem, __spreadProps(__spreadValues({}, item), {
              key: `${index} ${item == null ? void 0 : item.title} ${item == null ? void 0 : item.description} ${JSON.stringify(item == null ? void 0 : item.timeVisibility)}`,
              itemStyle,
              isEditingMode,
              handleShowNotification,
              layout,
              endpointConfig
            })))
          }),
          ToastComponent
        ]
      })
    }))
  });
};
VoucherList.displayName = "Omni_VoucherList";
const TitleStyled = styled__default["default"].div`
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
`;
const TitleWrapper = styled__default["default"].div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;
const ViewAll = styled__default["default"].div`
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
`;
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)}
`
);

exports.VoucherList = VoucherList;


/***/ }),

/***/ 324591:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(85097);

const validateShowVoucher = (timeVisibility, isShowCountdownBefore) => {
  try {
    if (!isShowCountdownBefore)
      return coreRenderer.validateIsVisibleComponent(timeVisibility);
    const now = new Date();
    const { endTime, startTime } = timeVisibility || {};
    const hasConfigTime = endTime && startTime;
    const isOverTime = endTime && now > new Date(endTime);
    return hasConfigTime && !isOverTime;
  } catch (error) {
    console.error(error);
    return false;
  }
};

exports.validateShowVoucher = validateShowVoucher;


/***/ }),

/***/ 892980:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var ui$4 = __webpack_require__(14869);
var ui = __webpack_require__(227526);
var ui$1 = __webpack_require__(496791);
var ui$2 = __webpack_require__(876884);
var ui$3 = __webpack_require__(941322);
var index = __webpack_require__(743994);
var ui$5 = __webpack_require__(160325);
var ui$6 = __webpack_require__(955080);
var ui$7 = __webpack_require__(871164);
var ui$8 = __webpack_require__(923049);
var ui$9 = __webpack_require__(536210);
var ui$a = __webpack_require__(531137);
var ui$b = __webpack_require__(886018);
var ui$c = __webpack_require__(80039);
var ui$d = __webpack_require__(912260);
var CountdownSkuList = __webpack_require__(271193);
var CountdownSkuListWithBanner = __webpack_require__(545222);
var HamperList = __webpack_require__(388019);
var CategoryMenu = __webpack_require__(15105);
var MixBanner = __webpack_require__(116600);

const ECOMERCE_COMPONENT_TAG = {
  RECENT_SEARCH: ui.RecentSearch.displayName.toLowerCase(),
  RECENT_PRODUCT: ui$1.RecentProduct.displayName.toLowerCase(),
  PENDING_PAYMENT: ui$2.PendingPayment.displayName.toLowerCase(),
  PRODUCT_LIST: ui$3.OmniProductList.displayName.toLowerCase(),
  COUNT_DOWN_SKU_LIST: CountdownSkuList.CountdownSkuList.displayName.toLowerCase(),
  COUNT_DOWN_SKU_LIST_V2: index.CountdownSkuListV2.displayName.toLowerCase(),
  COUNT_DOWN_SKU_LIST_WITH_BANNER: CountdownSkuListWithBanner.CountdownSkuListWithBanner.displayName.toLowerCase(),
  HAMPER_LIST: HamperList.HamperList.displayName.toLowerCase(),
  CAROUSEL_SKU_LIST: ui$4.CarouselSkuList.displayName.toLowerCase(),
  LISTING_TAB: ui$5.ListingTab.displayName.toLowerCase(),
  PROMOTE_CATEGORY_MENU: CategoryMenu.CategoryMenu.displayName.toLowerCase(),
  RECOMMENDED_CATEGORY: ui$6.RecommendCategory.displayName.toLowerCase(),
  RECOMMENDED_BRAND: ui$7.RecommendBrand.displayName.toLowerCase(),
  HERO_BANNER: ui$8.HeroBanner.displayName.toLowerCase(),
  MIX_BANNER: MixBanner.MixBanner.displayName.toLowerCase(),
  SLIDE_BANNER: ui$9.SlideBanner.displayName.toLowerCase(),
  BUILD_PC: ui$a.BuildPC.displayName.toLowerCase(),
  CUSTOM_HAMPER: ui$b.CustomHamper.displayName.toLowerCase(),
  LEFT_BANNER_PRODUCT: ui$c.LeftBannerProduct.displayName.toLowerCase(),
  PRODUCT_SLIDER_WITH_BANNER: ui$d.ProductSliderWithBannerWeb.displayName.toLowerCase()
};
const SSR_COMPONENT_TAGS = [
  ECOMERCE_COMPONENT_TAG.PRODUCT_LIST,
  ECOMERCE_COMPONENT_TAG.COUNT_DOWN_SKU_LIST,
  ECOMERCE_COMPONENT_TAG.COUNT_DOWN_SKU_LIST_WITH_BANNER,
  ECOMERCE_COMPONENT_TAG.CAROUSEL_SKU_LIST,
  ECOMERCE_COMPONENT_TAG.LISTING_TAB,
  ECOMERCE_COMPONENT_TAG.HERO_BANNER,
  ECOMERCE_COMPONENT_TAG.COUNT_DOWN_SKU_LIST_V2,
  ECOMERCE_COMPONENT_TAG.LEFT_BANNER_PRODUCT
];

exports.ECOMERCE_COMPONENT_TAG = ECOMERCE_COMPONENT_TAG;
exports.SSR_COMPONENT_TAGS = SSR_COMPONENT_TAGS;


/***/ }),

/***/ 860046:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(85097);
var grid = __webpack_require__(620553);

const DEFAULT_MAX_WIDTH = 1232;
const DEFAULT_MAX_WIDTH_1600 = 1600;
const BREAK_POINTS = {
  xs: "480px",
  sm: "576px",
  md: "768px",
  lg: "1024px",
  xl: "1440px",
  xxl: "1600px"
};
const GRID_COLUMNS = 12;
({
  [coreRenderer.VerticalAlignment.top]: "flex-start",
  [coreRenderer.VerticalAlignment.center]: "center",
  [coreRenderer.VerticalAlignment.bottom]: "flex-end"
});
const MAPPING_ALIGNMENT_FLEX = {
  [coreRenderer.Alignment.center]: "center",
  [coreRenderer.Alignment.left]: "flex-start",
  [coreRenderer.Alignment.right]: "flex-end",
  [coreRenderer.Alignment.justify]: "space-between"
};
const DEFAULT_GUTTER = [0, 0];
const DEFAULT_WIDTH = 1232;
const DEFAULT_HEIGHT = 400;
const WIDTH_TYPE_OPTIONS = [
  { label: "To\xE0n b\u1ED9 chi\u1EC1u r\u1ED9ng", value: grid.WidthTypeEnum.full },
  { label: "T\xF9y ch\u1EC9nh", value: grid.WidthTypeEnum.fixed }
];

exports.BREAK_POINTS = BREAK_POINTS;
exports.DEFAULT_GUTTER = DEFAULT_GUTTER;
exports.DEFAULT_HEIGHT = DEFAULT_HEIGHT;
exports.DEFAULT_MAX_WIDTH = DEFAULT_MAX_WIDTH;
exports.DEFAULT_MAX_WIDTH_1600 = DEFAULT_MAX_WIDTH_1600;
exports.DEFAULT_WIDTH = DEFAULT_WIDTH;
exports.GRID_COLUMNS = GRID_COLUMNS;
exports.MAPPING_ALIGNMENT_FLEX = MAPPING_ALIGNMENT_FLEX;
exports.WIDTH_TYPE_OPTIONS = WIDTH_TYPE_OPTIONS;


/***/ }),

/***/ 667925:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const DESKTOP_COMMON_STYLE = {
  padding: {
    left: 16,
    right: 16
  },
  margin: {
    bottom: 24
  }
};
const MOBILE_COMMON_STYLE = {
  margin: {
    bottom: 8
  }
};
const DEFAULT_COMMON_STYLE = {
  backgroundPosition: "center",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat"
};

exports.DEFAULT_COMMON_STYLE = DEFAULT_COMMON_STYLE;
exports.DESKTOP_COMMON_STYLE = DESKTOP_COMMON_STYLE;
exports.MOBILE_COMMON_STYLE = MOBILE_COMMON_STYLE;


/***/ }),

/***/ 951297:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var styled = __webpack_require__(212951);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const BlockHeader = styled__default["default"].div(
  ({ device }) => `
    padding: ${device === "desktop" ? "1rem" : "0.5rem"} 1rem;
  `
);

exports.BlockHeader = BlockHeader;


/***/ }),

/***/ 341018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var grid = __webpack_require__(860046);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Container = React__default["default"].forwardRef(
  (props, ref) => {
    const _a = props, { children, fluid = false, maxWidth = 1232 } = _a, others = __objRest(_a, ["children", "fluid", "maxWidth"]);
    return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, __spreadProps(__spreadValues({
      ref,
      fluid,
      maxWidth
    }, others), {
      children
    }));
  }
);
const Wrapper = styled__default["default"].div(
  ({ fluid, maxWidth, commonStyle }) => `
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    ${coreRenderer.getStyle(commonStyle)}
    
    @media (min-width: ${grid.BREAK_POINTS.xl}) {
      max-width: ${fluid ? "100%" : coreRenderer.unitParse(maxWidth)};
    }
  `
);

exports.Container = Container;


/***/ }),

/***/ 283980:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var React = __webpack_require__(891987);
var grid = __webpack_require__(860046);
var getISODateBackward = __webpack_require__(177725);
var addPaddingNumber = __webpack_require__(996887);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const Countdown = ({
  countdownType: _countdownType = "due",
  due,
  showDays = true,
  showHours = true,
  showMinutes = true,
  showSeconds = true,
  showLabel = false,
  labelDays,
  labelHours,
  labelMinutes,
  labelSeconds,
  countdownStyle,
  commonStyle,
  splitTimeUnit
}) => {
  const {
    elementGap,
    labelGap,
    digitStyle,
    labelStyle,
    timeUnitStyle,
    layout,
    labelPosition,
    align
  } = countdownStyle || {};
  const finalDue = getISODateBackward.getISODateBackward(due);
  const dueDate = new Date(finalDue);
  const [duration, setDuration] = React.useState(
    coreRenderer.calculateTimeDelta(new Date(), dueDate)
  );
  React.useEffect(() => {
    const intervalId = setInterval(() => {
      setDuration(coreRenderer.calculateTimeDelta(new Date(), dueDate));
    }, 1e3);
    return () => {
      clearInterval(intervalId);
    };
  }, [finalDue]);
  if (dueDate.toString() === "Invalid Date")
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    align,
    children: /* @__PURE__ */ jsxRuntime.jsxs(TimeWrapper, {
      commonStyle: __spreadProps(__spreadValues({}, commonStyle), { gap: elementGap }),
      children: [
        showDays && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [
            /* @__PURE__ */ jsxRuntime.jsxs(TimeUnit, {
              layout,
              labelPosition,
              labelGap,
              timeUnitStyle,
              children: [
                /* @__PURE__ */ jsxRuntime.jsx(Digit, {
                  digitStyle,
                  children: addPaddingNumber.addPaddingNumber(duration.days)
                }),
                showLabel && /* @__PURE__ */ jsxRuntime.jsx(Label, {
                  labelStyle,
                  children: labelDays
                })
              ]
            }),
            !!splitTimeUnit && splitTimeUnit
          ]
        }),
        showHours && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [
            /* @__PURE__ */ jsxRuntime.jsxs(TimeUnit, {
              layout,
              labelPosition,
              labelGap,
              timeUnitStyle,
              children: [
                /* @__PURE__ */ jsxRuntime.jsx(Digit, {
                  digitStyle,
                  children: addPaddingNumber.addPaddingNumber(duration.hours)
                }),
                showLabel && /* @__PURE__ */ jsxRuntime.jsx(Label, {
                  labelStyle,
                  children: labelHours
                })
              ]
            }),
            !!splitTimeUnit && splitTimeUnit
          ]
        }),
        showMinutes && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [
            /* @__PURE__ */ jsxRuntime.jsxs(TimeUnit, {
              layout,
              labelPosition,
              labelGap,
              timeUnitStyle,
              children: [
                /* @__PURE__ */ jsxRuntime.jsx(Digit, {
                  digitStyle,
                  children: addPaddingNumber.addPaddingNumber(duration.minutes)
                }),
                showLabel && /* @__PURE__ */ jsxRuntime.jsx(Label, {
                  labelStyle,
                  children: labelMinutes
                })
              ]
            }),
            !!splitTimeUnit && splitTimeUnit
          ]
        }),
        showSeconds && /* @__PURE__ */ jsxRuntime.jsxs(TimeUnit, {
          layout,
          labelPosition,
          labelGap,
          timeUnitStyle,
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(Digit, {
              digitStyle,
              children: addPaddingNumber.addPaddingNumber(duration.seconds)
            }),
            showLabel && /* @__PURE__ */ jsxRuntime.jsx(Label, {
              labelStyle,
              children: labelSeconds
            })
          ]
        })
      ]
    })
  });
};
const Wrapper = styled__default["default"].div(
  ({ align }) => `
  display: flex;
  justify-content: ${grid.MAPPING_ALIGNMENT_FLEX[align]};
`
);
const TimeWrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)};
  display: flex;
`
);
const Digit = styled__default["default"].div(
  ({ digitStyle }) => `
  ${coreRenderer.getStyle(digitStyle)}
  @media only screen and (max-width: 480px){
    font-size: min(${digitStyle == null ? void 0 : digitStyle.fontSize}px, 30px);
  }
`
);
const Label = styled__default["default"].div(
  ({ labelStyle }) => `
  ${coreRenderer.getStyle(labelStyle)}
  @media only screen and (max-width: 480px){
    font-size: min(${labelStyle == null ? void 0 : labelStyle.fontSize}px, 30px);
  }
`
);
const TimeUnit = styled__default["default"].div(
  ({ layout, labelPosition, labelGap, timeUnitStyle }) => `
  ${coreRenderer.getStyle(timeUnitStyle)}
  display: flex;
  ${labelGap ? `gap: ${labelGap}px;` : ""}
  ${layout === "horizontal" ? `align-items: ${labelPosition};` : `flex-direction: column;`};
`
);
Countdown.displayName = "Countdown";

exports.Countdown = Countdown;


/***/ }),

/***/ 907438:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const EmptyProduct = () => {
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    children: "Danh s\xE1ch s\u1EA3n ph\u1EA9m tr\u1ED1ng"
  });
};
const Wrapper = styled__default["default"].div`
  height: 200px;
  line-height: 200px;
  text-align: center;
`;

exports.EmptyProduct = EmptyProduct;


/***/ }),

/***/ 481851:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var react = __webpack_require__(75537);
var styled = __webpack_require__(212951);
var clsx = __webpack_require__(981892);
var React = __webpack_require__(891987);
var RowContext = __webpack_require__(787749);
var grid = __webpack_require__(860046);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function parseFlex(flex) {
  if (typeof flex === "number") {
    return `${flex} ${flex} auto`;
  }
  if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) {
    return `0 0 ${flex}`;
  }
  return flex;
}
const sizes = ["xs", "sm", "md", "lg", "xl", "xxl"];
const Col = React__default["default"].forwardRef(
  (props, ref) => {
    const { gutter, wrap } = React__default["default"].useContext(RowContext);
    const _a = props, {
      span,
      order,
      offset,
      push,
      pull,
      className,
      children,
      flex,
      style
    } = _a, others = __objRest(_a, [
      "span",
      "order",
      "offset",
      "push",
      "pull",
      "className",
      "children",
      "flex",
      "style"
    ]);
    const prefixCls = "teko-col";
    let sizeClassObj = {};
    sizes.forEach((size) => {
      let sizeProps = {};
      const propSize = props[size];
      if (typeof propSize === "number") {
        sizeProps.span = propSize;
      } else if (typeof propSize === "object") {
        sizeProps = propSize || {};
      }
      sizeClassObj = __spreadProps(__spreadValues({}, sizeClassObj), {
        [`${prefixCls}-${size}-${sizeProps.span}`]: sizeProps.span !== void 0,
        [`${prefixCls}-${size}-order-${sizeProps.order}`]: sizeProps.order || sizeProps.order === 0,
        [`${prefixCls}-${size}-offset-${sizeProps.offset}`]: sizeProps.offset || sizeProps.offset === 0,
        [`${prefixCls}-${size}-push-${sizeProps.push}`]: sizeProps.push || sizeProps.push === 0,
        [`${prefixCls}-${size}-pull-${sizeProps.pull}`]: sizeProps.pull || sizeProps.pull === 0
      });
    });
    const classes = clsx__default["default"](
      prefixCls,
      {
        [`${prefixCls}-${span}`]: span !== void 0,
        [`${prefixCls}-order-${order}`]: order,
        [`${prefixCls}-offset-${offset}`]: offset,
        [`${prefixCls}-push-${push}`]: push,
        [`${prefixCls}-pull-${pull}`]: pull
      },
      className,
      sizeClassObj
    );
    let mergedStyle = __spreadValues({}, style);
    if (gutter) {
      mergedStyle = __spreadValues(__spreadValues({}, gutter[0] && gutter[0] > 0 ? {
        paddingLeft: gutter[0] / 2,
        paddingRight: gutter[0] / 2
      } : {}), mergedStyle);
    }
    if (flex) {
      mergedStyle.flex = parseFlex(flex);
      if (flex === "auto" && wrap === false && !mergedStyle.minWidth) {
        mergedStyle.minWidth = 0;
      }
    }
    return /* @__PURE__ */ jsxRuntime.jsx(StyledCol, __spreadProps(__spreadValues({}, others), {
      style: mergedStyle,
      className: classes,
      ref,
      children
    }));
  }
);
const floorPercentage = (percent) => {
  return Math.floor(percent * 100) / 100;
};
const percentage = (x, y) => {
  return floorPercentage(x / y * 100) + "%";
};
const loopGridColumn = (_class = "") => {
  let _css = `
    &.teko-col${_class}-0 {
      display: none;
    }
    &.teko-col-push-0 {
      left: auto;
    }
    &.teko-col-pull-0 {
      right: auto;
    }
    &.teko-col${_class}-push-0 {
      left: auto;
    }
    &.teko-col${_class}-pull-0 {
      right: auto;
    }
    &.teko-col${_class}-offset-0 {
      margin-left: 0;
    }
    &.teko-col${_class}-order-0 {
      order: 0;
    }
  `;
  for (let i = 1; i <= 24; i++) {
    _css += `
      &.teko-col${_class}-${i} {
        display: block;
        flex: 0 0 ${percentage(i, grid.GRID_COLUMNS)};
        max-width: ${_class === "-lg" ? "84px" : ["-xl", "-xxl"].includes(_class) ? "104px" : percentage(i, grid.GRID_COLUMNS)};
      }
      &.teko-col${_class}-push-${i} {
        left: ${percentage(i, grid.GRID_COLUMNS)};
      }
      &.teko-col${_class}-pull-${i} {
        right: ${percentage(i, grid.GRID_COLUMNS)};
      }
      &.teko-col${_class}-offset-${i} {
        margin-left: ${percentage(i, grid.GRID_COLUMNS)};
      }
      &.teko-col${_class}-order-${i} {
        order: ${i};
      }
    `;
  }
  return _css;
};
const makeGrid = react.css`
  ${loopGridColumn()}
  ${loopGridColumn("-xs")}
  ${Object.keys(grid.BREAK_POINTS).map(
  (label) => label !== "xs" ? `
    @media (min-width: ${grid.BREAK_POINTS[label]}) {
      ${loopGridColumn(`-${label}`)}
    }
  ` : ""
).join("")}
`;
const flexStyle = (flex) => {
  if (!flex)
    return;
  return `
    flex: ${parseFlex(flex)};
    ${typeof flex === "string" ? `max-width: ${flex} !important;` : ""}
  `;
};
const makeFlexStyles = (props) => {
  var _a;
  return react.css`
    ${typeof props.xs === "object" && ((_a = props.xs) == null ? void 0 : _a.flex) !== void 0 ? flexStyle(props.xs.flex) : ""}
    ${Object.keys(grid.BREAK_POINTS).map(
    (label) => {
      var _a2, _b;
      return ((_a2 = props[label]) == null ? void 0 : _a2.flex) && label !== "xs" ? `
      @media (min-width: ${grid.BREAK_POINTS[label]}) {
        ${flexStyle((_b = props[label]) == null ? void 0 : _b.flex)};
      }
    ` : "";
    }
  ).join("")}
  `;
};
const StyledCol = styled__default["default"].div(
  `
  &.teko-col {
    position: relative;
    max-width: 100%;
    // Prevent columns from collapsing when empty
    min-height: 1px;
  }`,
  makeGrid,
  makeFlexStyles
);

exports.Col = Col;
exports.floorPercentage = floorPercentage;
exports.percentage = percentage;


/***/ }),

/***/ 346761:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var clsx = __webpack_require__(981892);
var React = __webpack_require__(891987);
var RowContext = __webpack_require__(787749);
var util = __webpack_require__(298257);
var grid = __webpack_require__(860046);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Row = React__default["default"].forwardRef((props, ref) => {
  const _a = props, {
    justify,
    align,
    className,
    style,
    children,
    gutter = 0,
    wrap
  } = _a, others = __objRest(_a, [
    "justify",
    "align",
    "className",
    "style",
    "children",
    "gutter",
    "wrap"
  ]);
  const [screens, setScreens] = React__default["default"].useState({
    xs: true,
    sm: true,
    md: true,
    lg: true,
    xl: true,
    xxl: true
  });
  const gutterRef = React__default["default"].useRef(gutter);
  React__default["default"].useEffect(() => {
    const token = util["default"].subscribe((screen) => {
      const currentGutter = gutterRef.current || 0;
      if (!Array.isArray(currentGutter) && typeof currentGutter === "object" || Array.isArray(currentGutter) && (typeof currentGutter[0] === "object" || typeof currentGutter[1] === "object")) {
        setScreens(screen);
      }
    });
    return () => util["default"].unsubscribe(token);
  }, []);
  const getGutter = () => {
    const results = [0, 0];
    const normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, 0];
    normalizedGutter.forEach((g, index) => {
      if (typeof g === "object") {
        for (let i = 0; i < util.responsiveArray.length; i++) {
          const breakpoint = util.responsiveArray[i];
          if (screens[breakpoint] && g[breakpoint] !== void 0) {
            results[index] = g[breakpoint];
            break;
          }
        }
      } else {
        results[index] = g || 0;
      }
    });
    return results;
  };
  const prefixCls = "teko-row";
  const gutters = getGutter();
  const classes = clsx__default["default"](
    prefixCls,
    {
      [`${prefixCls}-no-wrap`]: wrap === false,
      [`${prefixCls}-${justify}`]: justify,
      [`${prefixCls}-${align}`]: align
    },
    className
  );
  const rowStyle = __spreadValues(__spreadValues(__spreadValues({}, gutters[0] && gutters[0] > 0 ? {
    marginLeft: gutters[0] / -2,
    marginRight: gutters[0] / -2
  } : {}), gutters[1] && gutter[1] > 0 ? {
    rowGap: gutters[1]
  } : {}), style);
  return /* @__PURE__ */ jsxRuntime.jsx(RowContext.Provider, {
    value: { gutter: gutters, wrap },
    children: /* @__PURE__ */ jsxRuntime.jsx(StyledRow, __spreadProps(__spreadValues({}, others), {
      className: classes,
      commonStyle: rowStyle,
      ref,
      children
    }))
  });
});
const StyledRow = styled__default["default"].div(
  `
    &.teko-row {
      display: flex;
      flex-flow: row wrap;
    }
    @media (min-width: ${grid.BREAK_POINTS.lg}) {
      &.teko-row {
        justify-content: center;
      }
    }
    &.teko-row:before,
    &.teko-row:after {
      display: flex;
    }

    // No wrap of flex
    &.teko-row-no-wrap {
      flex-wrap: nowrap;
    }

    &.teko-row-start {
      justify-content: flex-start;
    }

    &.teko-row-center {
      justify-content: center;
    }

    &.teko-row-end {
      justify-content: flex-end;
    }

    &.teko-row-space-between {
      justify-content: space-between;
    }

    &.teko-row-space-around {
      justify-content: space-around;
    }

    &.teko-row-top {
      align-items: flex-start;
    }

    &.teko-row-middle {
      align-items: center;
    }

    &.teko-row-bottom {
      align-items: flex-end;
    }
  `,
  ({ commonStyle }) => coreRenderer.getStyle(commonStyle)
);

exports.Row = Row;


/***/ }),

/***/ 787749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {



var React = __webpack_require__(891987);

const RowContext = React.createContext({});
var RowContext$1 = RowContext;

module.exports = RowContext$1;


/***/ }),

/***/ 843633:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var Row = __webpack_require__(346761);
var Container = __webpack_require__(341018);
var grid = __webpack_require__(620553);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Section = React__default["default"].forwardRef(
  (props, ref) => {
    const _a = props, { children, commonStyle, widthType, row } = _a, other = __objRest(_a, ["children", "commonStyle", "widthType", "row"]);
    const { maxWidth } = commonStyle;
    let rowStyle = row == null ? void 0 : row.style;
    rowStyle = __spreadValues({ minHeight: "inherit", height: "100%" }, rowStyle);
    if (rowStyle == null ? void 0 : rowStyle.maxWidth) {
      rowStyle = __spreadValues({
        marginLeft: "auto !important",
        marginRight: "auto !important"
      }, rowStyle);
    }
    return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
      maxWidth,
      fluid: widthType === grid.WidthTypeEnum.full,
      ref,
      commonStyle
    }, other), {
      children: /* @__PURE__ */ jsxRuntime.jsx(Row.Row, __spreadProps(__spreadValues({}, row), {
        style: rowStyle,
        children
      }))
    }));
  }
);

exports.Section = Section;


/***/ }),

/***/ 298257:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const responsiveArray = [
  "xxl",
  "xl",
  "lg",
  "md",
  "sm",
  "xs"
];
const responsiveMap = {
  xs: "(max-width: 575px)",
  sm: "(min-width: 576px)",
  md: "(min-width: 768px)",
  lg: "(min-width: 1024px)",
  xl: "(min-width: 1440px)",
  xxl: "(min-width: 1600px)"
};
const subscribers = /* @__PURE__ */ new Map();
let subUid = -1;
let screens = {};
const responsiveObserve = {
  matchHandlers: {},
  dispatch(pointMap) {
    screens = pointMap;
    subscribers.forEach((func) => func(screens));
    return subscribers.size >= 1;
  },
  subscribe(func) {
    if (!subscribers.size)
      this.register();
    subUid += 1;
    subscribers.set(subUid, func);
    func(screens);
    return subUid;
  },
  unsubscribe(token) {
    subscribers.delete(token);
    if (!subscribers.size)
      this.unregister();
  },
  unregister() {
    Object.keys(responsiveMap).forEach((screen) => {
      const matchMediaQuery = responsiveMap[screen];
      const handler = this.matchHandlers[matchMediaQuery];
      handler == null ? void 0 : handler.mql.removeListener(handler == null ? void 0 : handler.listener);
    });
    subscribers.clear();
  },
  register() {
    Object.keys(responsiveMap).forEach((screen) => {
      const matchMediaQuery = responsiveMap[screen];
      const listener = ({ matches }) => {
        this.dispatch(__spreadProps(__spreadValues({}, screens), {
          [screen]: matches
        }));
      };
      const mql = window.matchMedia(matchMediaQuery);
      mql.addListener(listener);
      this.matchHandlers[matchMediaQuery] = {
        mql,
        listener
      };
      listener(mql);
    });
  }
};
var ResponsiveObserve = responsiveObserve;

exports["default"] = ResponsiveObserve;
exports.responsiveArray = responsiveArray;
exports.responsiveMap = responsiveMap;


/***/ }),

/***/ 20384:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var coreRenderer = __webpack_require__(85097);

var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Link = (_a) => {
  var _b = _a, {
    eventType,
    children,
    className,
    sectionMarginTop = 0,
    trackingEventName,
    conversionGGAdsId,
    conversionGGAdsLabel,
    scriptCustom
  } = _b, rest = __objRest(_b, [
    "eventType",
    "children",
    "className",
    "sectionMarginTop",
    "trackingEventName",
    "conversionGGAdsId",
    "conversionGGAdsLabel",
    "scriptCustom"
  ]);
  var _a2, _b2, _c, _d, _e, _f, _g, _h;
  const ref = React.useRef();
  const openPopup = (popupId) => {
    var _a3;
    (_a3 = ref.current.ownerDocument.querySelector(
      `[data-uniq-id="${popupId}"]`
    )) == null ? void 0 : _a3.click();
  };
  const closePopup = (popupId) => {
    const popup = ref.current.ownerDocument.querySelector(
      `[data-uniq-id="${popupId}"]`
    );
    const maskPopup = popup == null ? void 0 : popup.parentElement;
    maskPopup.classList.remove("show");
    maskPopup.classList.add("hide-from-btn");
    popup == null ? void 0 : popup.click();
  };
  const closePopupList = (popupIds) => {
    const getAllElement = ref.current.ownerDocument.querySelectorAll(
      `[data-uniq-id]`
    );
    const popupList = [];
    getAllElement.forEach((el) => {
      if (popupIds.includes(el.getAttribute("data-uniq-id")))
        popupList.push(el);
    });
    popupList.forEach((popup) => {
      const maskPopup = popup == null ? void 0 : popup.parentElement;
      maskPopup.classList.remove("show");
      maskPopup.classList.add("hide-from-btn");
      popup == null ? void 0 : popup.click();
    });
  };
  const scrollToElement = (elementId) => {
    var _a3;
    const isInIframe = ref.current.ownerDocument !== document;
    let innerWindow = window;
    if (isInIframe) {
      const iframeElements = window.document.getElementsByTagName("iframe");
      for (const iframe of iframeElements) {
        if (iframe.contentDocument === ref.current.ownerDocument) {
          innerWindow = iframe.contentWindow;
          break;
        }
      }
    }
    const elements = ref.current.ownerDocument.querySelectorAll(
      `[data-id="${elementId}"]`
    );
    for (const element of elements) {
      if (((_a3 = innerWindow == null ? void 0 : innerWindow.getComputedStyle(element)) == null ? void 0 : _a3.display) !== "none") {
        const top = element.getBoundingClientRect().top + innerWindow.pageYOffset - sectionMarginTop;
        innerWindow.scrollTo({
          top,
          behavior: "smooth"
        });
      }
    }
  };
  const trackEventClick = () => {
    var _a3, _b3, _c2, _d2;
    if (trackingEventName) {
      (_a3 = window == null ? void 0 : window.gtag) == null ? void 0 : _a3.call(window, "event", trackingEventName);
      (_b3 = window == null ? void 0 : window.fbq) == null ? void 0 : _b3.call(window, "trackCustom", trackingEventName);
      (_c2 = window == null ? void 0 : window.track) == null ? void 0 : _c2.call(window, "customEvent", trackingEventName);
    }
    if (conversionGGAdsId && conversionGGAdsLabel) {
      (_d2 = window == null ? void 0 : window.gtag) == null ? void 0 : _d2.call(window, "event", "conversion", {
        send_to: `AW-${conversionGGAdsId}/${conversionGGAdsLabel}`
      });
    }
    runStringFunc(scriptCustom);
  };
  const runStringFunc = (script) => {
    if (script == null ? void 0 : script.trim()) {
      try {
        const excuteScript = new Function(coreRenderer.unescapeString(script));
        excuteScript();
      } catch (err) {
        console.error(err);
      }
    }
  };
  if (eventType === "openPageOfWebsite" && ((_a2 = rest["openPageOfWebsite"]) == null ? void 0 : _a2.href))
    return /* @__PURE__ */ jsxRuntime.jsx("a", {
      style: { textDecoration: "none", color: "unset", cursor: "pointer" },
      href: rest["openPageOfWebsite"].href,
      onClick: trackEventClick,
      target: ((_b2 = rest[eventType]) == null ? void 0 : _b2.openNewTab) ? "_blank" : "_top",
      className,
      children
    });
  if (eventType === "link" && ((_c = rest["link"]) == null ? void 0 : _c.href))
    return /* @__PURE__ */ jsxRuntime.jsx("a", {
      style: { textDecoration: "none", color: "unset", cursor: "pointer" },
      href: rest["link"].href,
      onClick: trackEventClick,
      target: ((_d = rest[eventType]) == null ? void 0 : _d.openNewTab) ? "_blank" : "_top",
      className,
      rel: ((_e = rest[eventType]) == null ? void 0 : _e.nofollow) ? "nofollow" : "noopener noreferrer",
      children
    });
  if (eventType === "inPage" && rest["inPage"])
    return /* @__PURE__ */ jsxRuntime.jsx("div", {
      style: { cursor: "pointer" },
      onClick: () => {
        scrollToElement(rest["inPage"]);
        trackEventClick();
      },
      ref,
      children
    });
  if (eventType === "internal" && ((_f = rest["internal"]) == null ? void 0 : _f.href))
    return /* @__PURE__ */ jsxRuntime.jsx("a", {
      style: { textDecoration: "none", color: "unset", cursor: "pointer" },
      href: `/${rest["internal"].href}`,
      onClick: trackEventClick,
      target: ((_g = rest["internal"]) == null ? void 0 : _g.openNewTab) ? "_blank" : "_top",
      className,
      rel: "noopener noreferrer",
      children
    });
  if (eventType === "email" && rest["email"])
    return /* @__PURE__ */ jsxRuntime.jsx("a", {
      style: { textDecoration: "none", color: "unset", cursor: "pointer" },
      href: `mailto:${rest["email"]}`,
      onClick: trackEventClick,
      className,
      rel: "noopener noreferrer",
      target: "_top",
      children
    });
  if (eventType === "phone" && rest["phone"])
    return /* @__PURE__ */ jsxRuntime.jsx("a", {
      style: { textDecoration: "none", color: "unset", cursor: "pointer" },
      href: `tel:${rest["phone"]}`,
      onClick: trackEventClick,
      className,
      rel: "noopener noreferrer",
      target: "_top",
      children
    });
  if (eventType === "openPopup" && rest["togglePopup"]) {
    return /* @__PURE__ */ jsxRuntime.jsx("div", {
      ref,
      onClick: () => {
        openPopup(rest["togglePopup"]);
        trackEventClick();
      },
      children
    });
  }
  if (eventType === "closePopupList" && ((_h = rest["togglePopupList"]) == null ? void 0 : _h.length)) {
    return /* @__PURE__ */ jsxRuntime.jsx("div", {
      ref,
      onClick: () => {
        closePopupList(rest["togglePopupList"]);
        trackEventClick();
      },
      children
    });
  }
  if (eventType === "closePopup" && rest["togglePopup"]) {
    return /* @__PURE__ */ jsxRuntime.jsx("div", {
      ref,
      onClick: () => {
        closePopup(rest["togglePopup"]);
        trackEventClick();
      },
      children
    });
  }
  return /* @__PURE__ */ jsxRuntime.jsx("div", {
    onClick: trackEventClick,
    children
  });
};

exports.Link = Link;


/***/ }),

/***/ 721498:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var NotificationType = /* @__PURE__ */ ((NotificationType2) => {
  NotificationType2["Success"] = "Success";
  NotificationType2["Error"] = "Error";
  return NotificationType2;
})(NotificationType || {});
const ModalNotification = (props) => {
  const {
    show,
    className,
    title,
    message,
    cancelText,
    okText,
    cancel,
    ok,
    hideOk,
    hideCancel,
    closeOnOverlayClick = true
  } = props;
  const MyModalNotification = styled__default["default"].div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100000;
    overflow: hidden;
    outline: 0;
    background-color: rgba(0, 0, 0, 0.5);
    height: 100vh;
    &.off {
      opacity: 0;
      visibility: hidden;
      filter: blur(8px);
      transform: scale(0.33);
      box-shadow: 1rem 0 0 rgba(black, 0.2);
    }
    &.show {
      box-shadow: -2rem 2rem 2rem rgba(0, 0, 0, 0.2);
      filter: blur(0);
      transform: scale(1);
      opacity: 1;
      visibility: visible;
    }
  `;
  const MyModalDialog = styled__default["default"].div`
    transform: translate(0, 0);
    transition: -webkit-transform 0.3s ease-out;
    transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out;
    position: relative;
    width: 100%;
    height: 100%;
    pointer-events: none;
    @media (min-width: 576px) {
      max-width: 500px;
      margin: 1.75rem auto;
    }
  `;
  const Content = styled__default["default"].div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    width: fit-content;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    outline: 0;
    box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    width: 80%;
  `;
  const Messages = styled__default["default"].div`
    padding: 22px;
  `;
  const Title = styled__default["default"].div`
    width: 100%;
    text-align: center;
    font-size: 17px;
    font-weight: 500;
  `;
  const Message = styled__default["default"].div`
    padding-top: 16px;
    width: 100%;
    text-align: center;
    font-size: 14px;
  `;
  const ButtonGroup = styled__default["default"].div`
    display: flex;
    justify-content: space-between;
    padding-right: 22px;
    padding-left: 22px;
    padding-bottom: 22px;
  `;
  const Button = styled__default["default"].button(
    ({ theme }) => {
      var _a, _b, _c;
      return `
      border-radius: 6px;
      font-size: 13px;
      padding: 8px 0;
      flex: 1 1;
      &.btn-cancel {
        border: 0.5px solid  ${((_a = theme == null ? void 0 : theme.brand) == null ? void 0 : _a.primary) || "#1435c3"};
        background: #fff;
        color:  ${((_b = theme == null ? void 0 : theme.brand) == null ? void 0 : _b.primary) || "#1435c3"};
      }
      &.btn-ok {
        background:  ${((_c = theme == null ? void 0 : theme.brand) == null ? void 0 : _c.primary) || "#1435c3"};
        color: #fff;
        border: none;
      }
  `;
    }
  );
  const Mr15 = styled__default["default"].div`
    margin-right: 15px;
  `;
  return show ? /* @__PURE__ */ jsxRuntime.jsx(MyModalNotification, {
    className: `${show ? "show" : "off"} ${className || ""}`,
    onClick: (e) => {
      if (closeOnOverlayClick && cancel)
        cancel(e);
    },
    children: /* @__PURE__ */ jsxRuntime.jsx(MyModalDialog, {
      children: /* @__PURE__ */ jsxRuntime.jsxs(Content, {
        onClick: (e) => e.stopPropagation(),
        children: [
          /* @__PURE__ */ jsxRuntime.jsxs(Messages, {
            children: [
              title && /* @__PURE__ */ jsxRuntime.jsx(Title, {
                children: title
              }),
              message && /* @__PURE__ */ jsxRuntime.jsx(Message, {
                children: message
              })
            ]
          }),
          /* @__PURE__ */ jsxRuntime.jsxs(ButtonGroup, {
            children: [
              !hideCancel && /* @__PURE__ */ jsxRuntime.jsx(Button, {
                className: "btn-cancel",
                onClick: cancel,
                children: cancelText || `H\u1EE7y`
              }),
              !hideCancel && !hideOk && /* @__PURE__ */ jsxRuntime.jsx(Mr15, {}),
              !hideOk && /* @__PURE__ */ jsxRuntime.jsx(Button, {
                className: "btn-ok",
                onClick: ok,
                children: okText || `X\xF3a`
              })
            ]
          })
        ]
      })
    })
  }) : null;
};

exports.ModalNotification = ModalNotification;
exports.NotificationType = NotificationType;


/***/ }),

/***/ 53093:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var ModalNotification = __webpack_require__(721498);

const useNotification = () => {
  const [showNotification, setShowNotification] = React.useState(false);
  const [notificationMessage, setNotificationMessage] = React.useState("");
  const [type, setType] = React.useState(ModalNotification.NotificationType.Success);
  const handleShowNotification = (message, type2) => {
    setNotificationMessage(message);
    setShowNotification(true);
    setType(type2 || ModalNotification.NotificationType.Success);
  };
  const ToastComponent = showNotification ? /* @__PURE__ */ jsxRuntime.jsx(ModalNotification.ModalNotification, {
    type,
    show: showNotification,
    message: notificationMessage,
    title: "Th\xF4ng b\xE1o",
    okText: "\u0110\xF3ng",
    ok: () => {
      setShowNotification(false);
    },
    cancel: () => {
      setShowNotification(false);
    },
    hideCancel: true
  }) : null;
  return {
    handleShowNotification,
    ToastComponent
  };
};

exports.useNotification = useNotification;


/***/ }),

/***/ 183594:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(85097);
var React = __webpack_require__(891987);
var SwiperCore = __webpack_require__(726438);
var react = __webpack_require__(406968);
var helper = __webpack_require__(892337);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var SwiperCore__default = /*#__PURE__*/_interopDefaultLegacy(SwiperCore);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
SwiperCore__default["default"].use([SwiperCore.Navigation, SwiperCore.Pagination, SwiperCore.Thumbs, SwiperCore.Autoplay, SwiperCore.Virtual]);
const Slider = (_a) => {
  var _b = _a, {
    className,
    children,
    paginationStyle,
    navigationStyle,
    speed = 3e3,
    pauseOnMouseEnter = true,
    paginationColor,
    virtual,
    paginationPosition = "inside",
    commonStyle,
    slidesPerViewMobile,
    navigationColor
  } = _b, swiperProps = __objRest(_b, [
    "className",
    "children",
    "paginationStyle",
    "navigationStyle",
    "speed",
    "pauseOnMouseEnter",
    "paginationColor",
    "virtual",
    "paginationPosition",
    "commonStyle",
    "slidesPerViewMobile",
    "navigationColor"
  ]);
  const {
    slidesPerView,
    slidesPerColumn,
    pagination,
    autoplay,
    loop,
    showThumbnail,
    alignThumbnail
  } = swiperProps;
  const [swiperKey, setSwiperKey] = React.useState(0);
  let breakpoints;
  const [thumbsSwiper, setThumbsSwiper] = React.useState(null);
  const isMultipleRows = slidesPerColumn && slidesPerColumn > 1;
  if (pagination) {
    swiperProps.pagination = {
      clickable: true
    };
  }
  if (isMultipleRows)
    swiperProps.loop = false;
  if (autoplay) {
    swiperProps.autoplay = {
      delay: speed,
      disableOnInteraction: false,
      pauseOnMouseEnter
    };
  }
  if (slidesPerViewMobile) {
    breakpoints = {
      320: { slidesPerView: slidesPerViewMobile },
      640: { slidesPerView }
    };
  }
  React.useEffect(() => {
    setSwiperKey((key) => key + 1);
  }, [
    showThumbnail,
    autoplay,
    loop,
    speed,
    pauseOnMouseEnter,
    virtual,
    slidesPerColumn
  ]);
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
    className,
    paginationStyle,
    navigationStyle,
    isMultipleRows,
    paginationColor,
    navigationColor,
    paginationPosition,
    commonStyle,
    slidesPerView,
    slidesPerColumn,
    itemsCount: React.Children.toArray(children).length,
    spaceBetween: swiperProps == null ? void 0 : swiperProps.spaceBetween,
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(react.Swiper, __spreadProps(__spreadValues({
        breakpoints
      }, swiperProps), {
        thumbs: {
          swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null
        },
        virtual: virtual && typeof slidesPerView === "number" ? {
          addSlidesBefore: slidesPerView
        } : false,
        resizeObserver: true,
        slidesPerColumnFill: "row",
        children: React.Children.map(children, (child, index) => /* @__PURE__ */ jsxRuntime.jsx(react.SwiperSlide, {
          virtualIndex: index,
          children: child
        }, `slide-${index}`))
      }), `swiper-${swiperKey}`),
      showThumbnail && /* @__PURE__ */ jsxRuntime.jsx(react.Swiper, {
        className: `swiper-thumbnail ${alignThumbnail ? `swiper-thumbnail__${alignThumbnail}` : ""}`,
        onSwiper: setThumbsSwiper,
        spaceBetween: 10,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        children: React.Children.map(children, (child, index) => /* @__PURE__ */ jsxRuntime.jsx(react.SwiperSlide, {
          virtualIndex: index,
          children: child
        }, `thumb-${index}`))
      })
    ]
  });
};
const Wrapper = styled__default["default"].div(
  ({
    isMultipleRows,
    paginationStyle,
    paginationColor,
    paginationPosition,
    navigationStyle,
    navigationColor,
    commonStyle,
    slidesPerView = 1,
    slidesPerColumn = 1,
    itemsCount,
    spaceBetween = 10
  }) => {
    const isServerless = typeof window === "undefined";
    let totalItemPerRow, serverWidthWrapper, serverWidthItem;
    if (isServerless) {
      totalItemPerRow = Math.ceil(itemsCount / slidesPerColumn);
      serverWidthWrapper = `${totalItemPerRow / (slidesPerView === "auto" ? 1 : slidesPerView) * 100}%`;
      serverWidthItem = `calc(100% / ${totalItemPerRow} - ${spaceBetween * (totalItemPerRow - 1) / totalItemPerRow}px)`;
    }
    return `
    .swiper-container {
      margin-left: auto;
      margin-right: auto;
      position: relative;
      overflow: hidden;
      list-style: none;
      padding: 0;
      ${paginationStyle && paginationPosition === "outside" ? "padding-bottom: 3em;" : ""}
    }
    .swiper-wrapper {
      position: relative;
      height: 100%;
      display: flex;
      transition-property: transform;
      box-sizing: content-box;
      flex-wrap: ${isMultipleRows ? "wrap" : "nowrap"};
      // Ch\u1EC9 c\xF3 t\xE1c d\u1EE5ng \u1EDF SSR, khi v\u1EC1 CSR th\u01B0 vi\u1EC7n swiper s\u1EBD t\u1EF1 \u0111\u1ED9ng override css n\xE0y b\u1EB1ng pixel
      ${isServerless ? `width: ${serverWidthWrapper};` : ""}
    }
    .swiper-slide {
      flex-shrink: 0;
      height: 100%;
      position: relative;
      transition-property: transform;
      ${isMultipleRows ? `margin-top: 0px !important` : ""};
      // Ch\u1EC9 c\xF3 t\xE1c d\u1EE5ng \u1EDF SSR, khi v\u1EC1 CSR th\u01B0 vi\u1EC7n swiper s\u1EBD t\u1EF1 \u0111\u1ED9ng override css n\xE0y b\u1EB1ng pixel
      ${isServerless ? `width: ${serverWidthItem};
            margin-right: ${spaceBetween}px;` : ""}
    }
    &:hover {
      .swiper-button-next,
      .swiper-button-prev {
        opacity: 1;
        &.swiper-button-disabled {
          opacity: 0.35;
        }
      }
    }
    .swiper-pagination {
      position: absolute;
      text-align: center;
      transform: translate3d(0, 0, 0);
      z-index: 10;
    }
    .swiper-pagination-fraction {
      bottom: 0;
      left: 0;
      width: 100%;
    }
    .swiper-pagination-bullets {
      bottom: 10px;
      left: 0;
      width: 100%;
    }
    ${paginationStyle ? helper.renderPaginationStyle(paginationStyle, paginationColor) : ""}
    .swiper-button-prev,
    .swiper-button-next {
      position: absolute;
      top: 50%;
      z-index: 10;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      margin-top: -22px;
      opacity: 0;
      &.swiper-button-disabled {
        opacity: 0;
        cursor: auto;
        pointer-events: auto;
      }
    }
    .swiper-thumbnail {
      padding-top: 10px;

      &.swiper-thumbnail__left {
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }

      &.swiper-thumbnail__center {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &.swiper-thumbnail__right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      .swiper-slide {
        width: 80px !important;
        height: 80px;
        cursor: pointer;

        img {
          width: 80px;
          height: 80px;
        }

        &.swiper-slide-thumb-active::after {
          background: transparent;
        }

        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,.5);
        }
      }
    }
    ${coreRenderer.getStyle(commonStyle)}
    ${navigationStyle ? helper.renderSwipeButton(navigationStyle, navigationColor) : ""}
`;
  }
);

exports.Slider = Slider;


/***/ }),

/***/ 892337:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const renderPaginationStyle = (index, paginationColor) => {
  const styleArr = [
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 100%;
      background: #ddd;
      margin: 0 4px;
      cursor: pointer;
    }
    .swiper-pagination-bullet-active {
      background: ${paginationColor};
      border-radius: 0.75rem;
    }`,
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 100%;
      background: #ddd;
      margin: 0 4px;
      cursor: pointer;
    }
    .swiper-pagination-bullet-active {
      background: ${paginationColor};
      border-radius: 0.75rem;
      width: 24px;
    }`,
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      background: #ddd;
      cursor: pointer;
      &:first-of-type {
        border-radius: 999px 0 0 999px;
      };
      &:last-of-type {
        border-radius: 0 999px 999px 0;
      }
    }
    .swiper-pagination-bullet-active {
      width: 24px;
      position: relative;
      &:after {
        content: "";
        border-radius: 999px;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: ${paginationColor};
      }
    }`,
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 100%;
      background: #ddd;
      margin: 0 4px;
      cursor: pointer;
    }
    .swiper-pagination-bullet-active {
      background: ${paginationColor};
      border-radius: 0.75rem;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      transform: translateY(2px);
    }`
  ];
  return index > 0 ? styleArr[index - 1] : null;
};
const renderSwipeButton = (index, color) => {
  const styleArr = [
    `.swiper-button-next {
      right: 0;
      left: auto;
      border-top-left-radius: 100px;
      border-bottom-left-radius: 100px;
      background-color: rgba(168, 168, 168, 0.46);
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: ${color || "#333"};
      }
    }
    .swiper-button-prev {
      left: 0;
      right: auto;
      border-top-right-radius: 100px;
      border-bottom-right-radius: 100px;
      background-color: rgba(168, 168, 168, 0.46);
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: ${color || "#333"};
      }
    }`,
    `.swiper-button-next {
      right: 0;
      left: auto;
      border-radius: 50%;
      background-color: rgba(168, 168, 168, 0.46);
      margin-right: 0.5rem;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: ${color || "#333"};
      }
    }
    .swiper-button-prev {
      left: 0;
      right: auto;
      border-radius: 50%;
      background-color: rgba(168, 168, 168, 0.46);
      margin-left: 1rem;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: ${color || "#333"};
      }
    }`,
    `.swiper-button-next {
      right: 0;
      left: auto;
      background-color: transparent;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: ${color || "#333"};
      }
    }
    .swiper-button-prev {
      left: 0;
      right: auto;
      background-color: transparent;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: ${color || "#333"};
      }
    }`
  ];
  return index > 0 ? styleArr[index - 1] : null;
};

exports.renderPaginationStyle = renderPaginationStyle;
exports.renderSwipeButton = renderSwipeButton;


/***/ }),

/***/ 90304:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var React = __webpack_require__(891987);

function useIntersectionObserver({
  elementRef,
  root = null,
  rootMargin = "0%",
  threshold,
  initialValue = true
}) {
  const [entry, setEntry] = React.useState();
  const observer = React.useRef(null);
  const IOCallback = ([entry2]) => {
    setEntry(entry2);
  };
  React.useEffect(() => {
    if (observer.current) {
      observer.current.disconnect();
    }
    observer.current = new IntersectionObserver(IOCallback, {
      root,
      rootMargin,
      threshold
    });
    const currentObserver = observer.current;
    const node = elementRef.current;
    if (node) {
      currentObserver.observe(node);
    }
    return () => {
      currentObserver.disconnect();
    };
  }, [elementRef, root, rootMargin, threshold]);
  return [entry ? entry.isIntersecting : initialValue, entry];
}

exports.useIntersectionObserver = useIntersectionObserver;


/***/ }),

/***/ 548834:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var React = __webpack_require__(891987);

function useMediaQuery(query) {
  const getMatches = (query2) => {
    if (typeof window !== "undefined") {
      return window.matchMedia(query2).matches;
    }
    return false;
  };
  const [matches, setMatches] = React.useState(getMatches(query));
  function handleChange() {
    setMatches(getMatches(query));
  }
  React.useEffect(() => {
    const matchMedia = window.matchMedia(query);
    handleChange();
    if (matchMedia.addListener) {
      matchMedia.addListener(handleChange);
    } else {
      matchMedia.addEventListener("change", handleChange);
    }
    return () => {
      if (matchMedia.removeListener) {
        matchMedia.removeListener(handleChange);
      } else {
        matchMedia.removeEventListener("change", handleChange);
      }
    };
  }, [query]);
  return matches;
}

exports.useMediaQuery = useMediaQuery;


/***/ }),

/***/ 279973:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var uiWeb = __webpack_require__(583676);
var ui = __webpack_require__(14869);
var ui$a = __webpack_require__(728759);
var ui$b = __webpack_require__(669484);
var ui$c = __webpack_require__(699486);
var ui$h = __webpack_require__(42601);
var ui$i = __webpack_require__(104164);
var ui$j = __webpack_require__(362074);
var ui$k = __webpack_require__(280503);
var ui$l = __webpack_require__(112750);
var CategoryMenu = __webpack_require__(15105);
var CategoryMenuV2 = __webpack_require__(976103);
var CategoryMenu2Lines = __webpack_require__(366440);
var ui$1 = __webpack_require__(923049);
var ui$2 = __webpack_require__(160325);
var MixBanner = __webpack_require__(116600);
var ui$3 = __webpack_require__(941322);
var ui$4 = __webpack_require__(871164);
var ui$5 = __webpack_require__(955080);
var ui$6 = __webpack_require__(536210);
var ui$7 = __webpack_require__(876884);
var ui$8 = __webpack_require__(496791);
var ui$9 = __webpack_require__(227526);
var CountdownSkuList = __webpack_require__(271193);
var index = __webpack_require__(743994);
var CountdownSkuListWithBanner = __webpack_require__(545222);
var HamperList = __webpack_require__(388019);
var ui$d = __webpack_require__(531137);
var ui$e = __webpack_require__(886018);
var ui$f = __webpack_require__(80039);
var ui$g = __webpack_require__(912260);

const components = {
  CarouselSkuList: ui.CarouselSkuList,
  CategoryMenu: CategoryMenu.CategoryMenu,
  CategoryMenuV2: CategoryMenuV2.CategoryMenuV2,
  CategoryMenu2Lines: CategoryMenu2Lines.CategoryMenu2Lines,
  HeroBanner: ui$1.HeroBanner,
  ListingTab: ui$2.ListingTab,
  MixBanner: MixBanner.MixBanner,
  OmniProductList: ui$3.OmniProductList,
  RecommendBrand: ui$4.RecommendBrand,
  RecommendCategory: ui$5.RecommendCategory,
  SlideBanner: ui$6.SlideBanner,
  PendingPayment: ui$7.PendingPayment,
  RecentProduct: ui$8.RecentProduct,
  RecentSearch: ui$9.RecentSearch,
  OmniFooter: ui$a.OmniFooter,
  OmniHeader: ui$b.OmniHeader,
  CountdownSkuList: CountdownSkuList.CountdownSkuList,
  CountdownSkuListV2: index.CountdownSkuListV2,
  CountdownSkuListWithBanner: CountdownSkuListWithBanner.CountdownSkuListWithBanner,
  HamperList: HamperList.HamperList,
  OmniStickyBanner: ui$c.StickyBanner,
  BuildPC: ui$d.BuildPC,
  CustomHamper: ui$e.CustomHamper,
  LeftBannerProduct: ui$f.LeftBannerProduct,
  HeroBanner2Web: uiWeb.HeroBanner2Web,
  ProductSliderWithBannerWeb: ui$g.ProductSliderWithBannerWeb,
  VoucherList: ui$h.VoucherList,
  OmniArticleList: ui$i.OmniArticleList,
  VideoPreviewList: ui$j.VideoPreviewList,
  RecommendProduct: ui$k.RecommendProduct,
  ImageListOmni: ui$l.ImageListOmni
};

exports.w = components;


/***/ }),

/***/ 620553:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var WidthTypeEnum = /* @__PURE__ */ ((WidthTypeEnum2) => {
  WidthTypeEnum2["auto"] = "auto";
  WidthTypeEnum2["full"] = "full";
  WidthTypeEnum2["fixed"] = "fixed";
  return WidthTypeEnum2;
})(WidthTypeEnum || {});
var HeightTypeEnum = /* @__PURE__ */ ((HeightTypeEnum2) => {
  HeightTypeEnum2["default"] = "default";
  HeightTypeEnum2["fixed"] = "fixed";
  return HeightTypeEnum2;
})(HeightTypeEnum || {});

exports.HeightTypeEnum = HeightTypeEnum;
exports.WidthTypeEnum = WidthTypeEnum;


/***/ }),

/***/ 996887:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const addPaddingNumber = (number) => {
  return isNaN(number) ? "" : number == null ? void 0 : number.toString().padStart(2, "0");
};

exports.addPaddingNumber = addPaddingNumber;


/***/ }),

/***/ 579589:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const checkZaloIOSWebView = () => {
  if (typeof navigator === "undefined")
    return false;
  const ua = navigator.userAgent || "";
  const isZalo = /Zalo/i.test(ua);
  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  return isZalo && isIOS;
};
const checkIOS = () => {
  if (typeof navigator === "undefined")
    return false;
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
};

exports.checkIOS = checkIOS;
exports.checkZaloIOSWebView = checkZaloIOSWebView;


/***/ }),

/***/ 78616:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(85097);

class FormUtil {
  constructor() {
    this.submitFormData = async (formId, formData, url) => {
      try {
        const res = this.api.post(url, {
          formId,
          formData
        });
        return res;
      } catch (error) {
        console.error(error);
        return Promise.reject(error);
      }
    };
    this.api = new coreRenderer.Api("");
  }
}
const formUtils = new FormUtil();

exports.FormUtil = FormUtil;
exports.formUtils = formUtils;


/***/ }),

/***/ 173685:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const formatCurrency = (value, numberDisplayFormat, includeUnit = true) => {
  if (typeof value !== "number")
    return "";
  let currencyFormat;
  if (includeUnit)
    currencyFormat = new Intl.NumberFormat("vi-VN", {
      style: "currency",
      currency: "VND"
    });
  else
    currencyFormat = new Intl.NumberFormat("vi-VN");
  const valueWithCurrency = currencyFormat.format(value);
  if (!!numberDisplayFormat) {
    return valueWithCurrency.replaceAll(
      ".",
      numberDisplayFormat.thousandSeparator
    );
  } else {
    return valueWithCurrency;
  }
};

exports.formatCurrency = formatCurrency;


/***/ }),

/***/ 177725:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const getISODateBackward = (dateString) => {
  if (/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}$/.test(dateString)) {
    const day = parseInt(dateString.substring(0, 2));
    const month = parseInt(dateString.substring(3, 5));
    const year = parseInt(dateString.substring(6, 10));
    const hour = parseInt(dateString.substring(11, 13));
    const minute = parseInt(dateString.substring(14, 16));
    return new Date(year, month - 1, day, hour, minute).toISOString();
  }
  return dateString;
};

exports.getISODateBackward = getISODateBackward;


/***/ }),

/***/ 611120:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var coreRenderer = __webpack_require__(85097);
var dynamicBlock = __webpack_require__(892980);

const getValidItemsByTimeVisibility = (items) => {
  var _a;
  return (_a = items == null ? void 0 : items.filter) == null ? void 0 : _a.call(
    items,
    (item) => coreRenderer.validateIsVisibleComponent((item == null ? void 0 : item.timeVisibility) || {})
  );
};
const getSlotData = (config, device) => {
  var _a, _b, _c, _d;
  const { tag } = config;
  const {
    omni_productlist: productlistecommerce,
    omni_productslider: carouselskulist,
    omni_herobanner: herobanner,
    omni_listingtab: listingtab,
    omni_countdownskulist: countdownskulist,
    omni_countdownskulist_v2: countdownskulistv2
  } = (config == null ? void 0 : config.customAttributes) || {};
  switch (tag) {
    case dynamicBlock.ECOMERCE_COMPONENT_TAG.PRODUCT_LIST:
      return [
        {
          slot: `product_grid_${device}`,
          collectionSlug: productlistecommerce == null ? void 0 : productlistecommerce.collectionSlug
        }
      ];
    case dynamicBlock.ECOMERCE_COMPONENT_TAG.COUNT_DOWN_SKU_LIST:
      const availableItems = getValidItemsByTimeVisibility(
        (countdownskulist == null ? void 0 : countdownskulist.items) || []
      );
      return [
        {
          slot: `product_carousel_${device}`,
          collectionSlug: (_a = availableItems == null ? void 0 : availableItems[0]) == null ? void 0 : _a.collectionSlug
        }
      ];
    case dynamicBlock.ECOMERCE_COMPONENT_TAG.COUNT_DOWN_SKU_LIST_V2:
      const availableTabs = getValidItemsByTimeVisibility(
        (countdownskulistv2 == null ? void 0 : countdownskulistv2.tabs) || []
      );
      return [
        {
          slot: `product_carousel_${device}`,
          collectionSlug: (_b = availableTabs == null ? void 0 : availableTabs[0]) == null ? void 0 : _b.collectionSlug
        }
      ];
    case dynamicBlock.ECOMERCE_COMPONENT_TAG.CAROUSEL_SKU_LIST:
      return [
        {
          slot: `product_carousel_${device}`,
          collectionSlug: carouselskulist == null ? void 0 : carouselskulist.collectionSlug
        }
      ];
    case dynamicBlock.ECOMERCE_COMPONENT_TAG.HERO_BANNER:
      return [
        {
          slot: "mega_menu",
          menuZone: (herobanner == null ? void 0 : herobanner.showMegaMenu) ? herobanner == null ? void 0 : herobanner.menuZone : null
        }
      ];
    case dynamicBlock.ECOMERCE_COMPONENT_TAG.LISTING_TAB:
      return [
        {
          slot: `product_grid_${device}`,
          collectionSlug: (_d = (_c = listingtab == null ? void 0 : listingtab.items) == null ? void 0 : _c[0]) == null ? void 0 : _d.collectionSlug
        }
      ];
    default:
      return [];
  }
};

exports.P = getSlotData;


/***/ }),

/***/ 934512:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(85097);

const getStyle = (style) => {
  return `
    ${coreRenderer.getStyle(style)}
    ${(style == null ? void 0 : style.backgroundImage) ? `
      background-image: url(${coreRenderer.getImageUrlFromGoogleUserContent(
    style.backgroundImage,
    { width: style.bgImageWidth, percent: style.bgImagePercent }
  )}) !important;
    ` : ""}
    `;
};

exports.getStyle = getStyle;


/***/ }),

/***/ 478130:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const generatePlaceholderImage = (args) => {
  const {
    width,
    height,
    backgroundColor = "ccc",
    foregroundColor = "000",
    format = "gif"
  } = args;
  return `https://dummyimage.com/${width}x${height}/${backgroundColor}/${foregroundColor}.${format}`;
};

exports.generatePlaceholderImage = generatePlaceholderImage;


/***/ }),

/***/ 921977:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const flattenToTree = (originMenu) => {
  const getChildren = (menu, parentId) => {
    const result = menu.filter((item) => item.parentId === parentId).map((item) => {
      const children = getChildren(menu, item.id);
      return __spreadProps(__spreadValues({}, item), {
        children
      });
    });
    return result;
  };
  const tree = originMenu.filter((item) => !item.parentId).map((item) => __spreadProps(__spreadValues({}, item), { children: getChildren(originMenu, item.id) }));
  return tree;
};
const getUrlOfMenuItem = (item, isEditingMode = false) => {
  var _a, _b;
  if (isEditingMode)
    return void 0;
  if ((item == null ? void 0 : item.linkType) === "LINK")
    return item.href;
  if ((_a = item == null ? void 0 : item.page) == null ? void 0 : _a.isHomepage)
    return "/";
  return "/" + ((_b = item == null ? void 0 : item.page) == null ? void 0 : _b.slug);
};

exports.flattenToTree = flattenToTree;
exports.getUrlOfMenuItem = getUrlOfMenuItem;


/***/ }),

/***/ 591599:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(85097);

const getAttrTracking = ({
  trackingData,
  isEditorMode,
  isPreviewMode
}) => {
  if (!isEditorMode && !isPreviewMode) {
    return coreRenderer.getTrackingData(trackingData);
  }
  return {};
};

exports.getAttrTracking = getAttrTracking;


/***/ }),

/***/ 958220:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var React = __webpack_require__(891987);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const renderDynamicSlot = (slot, mappingDynamicSlots, ssrData, restProps = {}, position = 0) => {
  const Comp = mappingDynamicSlots == null ? void 0 : mappingDynamicSlots[slot];
  if (!Comp)
    return null;
  const { serverData } = (ssrData == null ? void 0 : ssrData[position]) || {};
  return React.createElement(Comp, __spreadValues(__spreadValues({}, serverData ? { serverData } : {}), restProps));
};

exports.renderDynamicSlot = renderDynamicSlot;


/***/ }),

/***/ 284727:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var Link = __webpack_require__(20384);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const renderLink = (event, children, isEditingMode = false, key) => {
  if (isEditingMode)
    return children;
  const eventProps = typeof event === "string" ? { eventType: "link", link: { href: event } } : event;
  return /* @__PURE__ */ jsxRuntime.jsx(Link.Link, __spreadProps(__spreadValues(__spreadValues({}, eventProps), typeof key !== "undefined" ? { key } : {}), {
    children
  }));
};

exports.renderLink = renderLink;


/***/ }),

/***/ 981892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "clsx": function() { return /* binding */ clsx; }
/* harmony export */ });
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["default"] = (clsx);

/***/ }),

/***/ 596839:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "NIL", ({
  enumerable: true,
  get: function get() {
    return _nil.default;
  }
}));
Object.defineProperty(exports, "parse", ({
  enumerable: true,
  get: function get() {
    return _parse.default;
  }
}));
Object.defineProperty(exports, "stringify", ({
  enumerable: true,
  get: function get() {
    return _stringify.default;
  }
}));
Object.defineProperty(exports, "v1", ({
  enumerable: true,
  get: function get() {
    return _v.default;
  }
}));
Object.defineProperty(exports, "v3", ({
  enumerable: true,
  get: function get() {
    return _v2.default;
  }
}));
Object.defineProperty(exports, "v4", ({
  enumerable: true,
  get: function get() {
    return _v3.default;
  }
}));
Object.defineProperty(exports, "v5", ({
  enumerable: true,
  get: function get() {
    return _v4.default;
  }
}));
Object.defineProperty(exports, "validate", ({
  enumerable: true,
  get: function get() {
    return _validate.default;
  }
}));
Object.defineProperty(exports, "version", ({
  enumerable: true,
  get: function get() {
    return _version.default;
  }
}));

var _v = _interopRequireDefault(__webpack_require__(157712));

var _v2 = _interopRequireDefault(__webpack_require__(784920));

var _v3 = _interopRequireDefault(__webpack_require__(254069));

var _v4 = _interopRequireDefault(__webpack_require__(30839));

var _nil = _interopRequireDefault(__webpack_require__(586940));

var _version = _interopRequireDefault(__webpack_require__(554668));

var _validate = _interopRequireDefault(__webpack_require__(115839));

var _stringify = _interopRequireDefault(__webpack_require__(315711));

var _parse = _interopRequireDefault(__webpack_require__(972766));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 89691:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Uint8Array(msg.length);

    for (let i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */


function md5ToHexEncodedArray(input) {
  const output = [];
  const length32 = input.length * 32;
  const hexTab = '0123456789abcdef';

  for (let i = 0; i < length32; i += 8) {
    const x = input[i >> 5] >>> i % 32 & 0xff;
    const hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }

  return output;
}
/**
 * Calculate output length with padding and bit length
 */


function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */


function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[getOutputLength(len) - 1] = len;
  let a = 1732584193;
  let b = -271733879;
  let c = -1732584194;
  let d = 271733878;

  for (let i = 0; i < x.length; i += 16) {
    const olda = a;
    const oldb = b;
    const oldc = c;
    const oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */


function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }

  const length8 = input.length * 8;
  const output = new Uint32Array(getOutputLength(length8));

  for (let i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }

  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safeAdd(x, y) {
  const lsw = (x & 0xffff) + (y & 0xffff);
  const msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

var _default = md5;
exports["default"] = _default;

/***/ }),

/***/ 353395:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var _default = {
  randomUUID
};
exports["default"] = _default;

/***/ }),

/***/ 586940:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _default = '00000000-0000-0000-0000-000000000000';
exports["default"] = _default;

/***/ }),

/***/ 972766:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _validate = _interopRequireDefault(__webpack_require__(115839));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parse(uuid) {
  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Invalid UUID');
  }

  let v;
  const arr = new Uint8Array(16); // Parse ########-....-....-....-............

  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 0xff;
  arr[2] = v >>> 8 & 0xff;
  arr[3] = v & 0xff; // Parse ........-####-....-....-............

  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 0xff; // Parse ........-....-####-....-............

  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 0xff; // Parse ........-....-....-####-............

  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 0xff; // Parse ........-....-....-....-############
  // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)

  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
  arr[11] = v / 0x100000000 & 0xff;
  arr[12] = v >>> 24 & 0xff;
  arr[13] = v >>> 16 & 0xff;
  arr[14] = v >>> 8 & 0xff;
  arr[15] = v & 0xff;
  return arr;
}

var _default = parse;
exports["default"] = _default;

/***/ }),

/***/ 21610:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
exports["default"] = _default;

/***/ }),

/***/ 324667:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = rng;
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);

function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/***/ }),

/***/ 289015:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;

    case 1:
      return x ^ y ^ z;

    case 2:
      return x & y ^ x & z ^ y & z;

    case 3:
      return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}

function sha1(bytes) {
  const K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  const H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = [];

    for (let i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
  }

  bytes.push(0x80);
  const l = bytes.length / 4 + 2;
  const N = Math.ceil(l / 16);
  const M = new Array(N);

  for (let i = 0; i < N; ++i) {
    const arr = new Uint32Array(16);

    for (let j = 0; j < 16; ++j) {
      arr[j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
    }

    M[i] = arr;
  }

  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;

  for (let i = 0; i < N; ++i) {
    const W = new Uint32Array(80);

    for (let t = 0; t < 16; ++t) {
      W[t] = M[i][t];
    }

    for (let t = 16; t < 80; ++t) {
      W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
    }

    let a = H[0];
    let b = H[1];
    let c = H[2];
    let d = H[3];
    let e = H[4];

    for (let t = 0; t < 80; ++t) {
      const s = Math.floor(t / 20);
      const T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }

  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

var _default = sha1;
exports["default"] = _default;

/***/ }),

/***/ 315711:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
exports.unsafeStringify = unsafeStringify;

var _validate = _interopRequireDefault(__webpack_require__(115839));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

var _default = stringify;
exports["default"] = _default;

/***/ }),

/***/ 157712:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _rng = _interopRequireDefault(__webpack_require__(324667));

var _stringify = __webpack_require__(315711);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
let _nodeId;

let _clockseq; // Previous uuid creation time


let _lastMSecs = 0;
let _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details

function v1(options, buf, offset) {
  let i = buf && offset || 0;
  const b = buf || new Array(16);
  options = options || {};
  let node = options.node || _nodeId;
  let clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189

  if (node == null || clockseq == null) {
    const seedBytes = options.random || (options.rng || _rng.default)();

    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }

    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.


  let msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock

  let nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)

  const dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression

  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval


  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  } // Per 4.2.1.2 Throw error if too many uuids are requested


  if (nsecs >= 10000) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch

  msecs += 12219292800000; // `time_low`

  const tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff; // `time_mid`

  const tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff; // `time_high_and_version`

  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version

  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)

  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`

  b[i++] = clockseq & 0xff; // `node`

  for (let n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf || (0, _stringify.unsafeStringify)(b);
}

var _default = v1;
exports["default"] = _default;

/***/ }),

/***/ 784920:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _v = _interopRequireDefault(__webpack_require__(134218));

var _md = _interopRequireDefault(__webpack_require__(89691));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const v3 = (0, _v.default)('v3', 0x30, _md.default);
var _default = v3;
exports["default"] = _default;

/***/ }),

/***/ 134218:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.URL = exports.DNS = void 0;
exports["default"] = v35;

var _stringify = __webpack_require__(315711);

var _parse = _interopRequireDefault(__webpack_require__(972766));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  const bytes = [];

  for (let i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }

  return bytes;
}

const DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
exports.DNS = DNS;
const URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
exports.URL = URL;

function v35(name, version, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    var _namespace;

    if (typeof value === 'string') {
      value = stringToBytes(value);
    }

    if (typeof namespace === 'string') {
      namespace = (0, _parse.default)(namespace);
    }

    if (((_namespace = namespace) === null || _namespace === void 0 ? void 0 : _namespace.length) !== 16) {
      throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
    } // Compute hash of namespace and value, Per 4.3
    // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
    // hashfunc([...namespace, ... value])`


    let bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;

    if (buf) {
      offset = offset || 0;

      for (let i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }

      return buf;
    }

    return (0, _stringify.unsafeStringify)(bytes);
  } // Function#name is not settable on some platforms (#270)


  try {
    generateUUID.name = name; // eslint-disable-next-line no-empty
  } catch (err) {} // For CommonJS default export support


  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
}

/***/ }),

/***/ 254069:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _native = _interopRequireDefault(__webpack_require__(353395));

var _rng = _interopRequireDefault(__webpack_require__(324667));

var _stringify = __webpack_require__(315711);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function v4(options, buf, offset) {
  if (_native.default.randomUUID && !buf && !options) {
    return _native.default.randomUUID();
  }

  options = options || {};

  const rnds = options.random || (options.rng || _rng.default)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`


  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return (0, _stringify.unsafeStringify)(rnds);
}

var _default = v4;
exports["default"] = _default;

/***/ }),

/***/ 30839:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _v = _interopRequireDefault(__webpack_require__(134218));

var _sha = _interopRequireDefault(__webpack_require__(289015));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const v5 = (0, _v.default)('v5', 0x50, _sha.default);
var _default = v5;
exports["default"] = _default;

/***/ }),

/***/ 115839:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _regex = _interopRequireDefault(__webpack_require__(21610));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(uuid) {
  return typeof uuid === 'string' && _regex.default.test(uuid);
}

var _default = validate;
exports["default"] = _default;

/***/ }),

/***/ 554668:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _validate = _interopRequireDefault(__webpack_require__(115839));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function version(uuid) {
  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Invalid UUID');
  }

  return parseInt(uuid.slice(14, 15), 16);
}

var _default = version;
exports["default"] = _default;

/***/ })

}]);